/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 168);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
var toSubscriber_1 = __webpack_require__(183);
var observable_1 = __webpack_require__(30);
var pipe_1 = __webpack_require__(42);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(28);
var Subscription_1 = __webpack_require__(5);
var Observer_1 = __webpack_require__(65);
var rxSubscriber_1 = __webpack_require__(29);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
}
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
var isArrayLike_1 = __webpack_require__(67);
var isPromise_1 = __webpack_require__(68);
var isObject_1 = __webpack_require__(63);
var Observable_1 = __webpack_require__(0);
var iterator_1 = __webpack_require__(16);
var InnerSubscriber_1 = __webpack_require__(192);
var observable_1 = __webpack_require__(30);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncAction_1 = __webpack_require__(21);
var AsyncScheduler_1 = __webpack_require__(22);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(11);
var isObject_1 = __webpack_require__(63);
var isFunction_1 = __webpack_require__(28);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var UnsubscriptionError_1 = __webpack_require__(64);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var Subscriber_1 = __webpack_require__(1);
var Subscription_1 = __webpack_require__(5);
var ObjectUnsubscribedError_1 = __webpack_require__(31);
var SubjectSubscription_1 = __webpack_require__(66);
var rxSubscriber_1 = __webpack_require__(29);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(7);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var ScalarObservable_1 = __webpack_require__(44);
var EmptyObservable_1 = __webpack_require__(13);
var isScheduler_1 = __webpack_require__(10);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ConnectableObservable_1 = __webpack_require__(115);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
exports.multicast = multicast;
var MulticastOperator = (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());
exports.MulticastOperator = MulticastOperator;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__(10);
var of_1 = __webpack_require__(69);
var from_1 = __webpack_require__(70);
var concatAll_1 = __webpack_require__(45);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
        return from_1.from(observables[0]);
    }
    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
    };
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(11);
function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
exports.isNumeric = isNumeric;
;
//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(9);
var Action_1 = __webpack_require__(222);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__(223);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = (function (_super) {
    __extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error));
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var scan_1 = __webpack_require__(54);
var takeLast_1 = __webpack_require__(55);
var defaultIfEmpty_1 = __webpack_require__(49);
var pipe_1 = __webpack_require__(42);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), takeLast_1.takeLast(1))(source);
    };
}
exports.reduce = reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var Subscription_1 = __webpack_require__(5);
/**
 * @class AsyncSubject<T>
 */
var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject_1.Subject));
exports.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__(12);
var isArray_1 = __webpack_require__(11);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
var none = {};
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project)); };
}
exports.combineLatest = combineLatest;
var CombineLatestOperator = (function () {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}());
exports.CombineLatestOperator = CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CombineLatestSubscriber = (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) {
                this._tryProject(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function (values) {
        var result;
        try {
            result = this.project.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.CombineLatestSubscriber = CombineLatestSubscriber;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Notification_1 = __webpack_require__(18);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(19);
var identity_1 = __webpack_require__(73);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var ArrayObservable_1 = __webpack_require__(12);
var isScheduler_1 = __webpack_require__(10);
var mergeAll_1 = __webpack_require__(35);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__(12);
var isArray_1 = __webpack_require__(11);
var Subscriber_1 = __webpack_require__(1);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
var iterator_1 = __webpack_require__(16);
/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
    };
}
exports.zip = zip;
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */
function zipStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = observables[observables.length - 1];
    if (typeof project === 'function') {
        observables.pop();
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
}
exports.zipStatic = zipStatic;
var ZipOperator = (function () {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}());
exports.ZipOperator = ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipSubscriber = (function (_super) {
    __extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) { values = Object.create(null); }
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = (typeof project === 'function') ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray_1.isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator_1.iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                this.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--; // not an observable
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) {
            this._tryProject(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber_1.Subscriber));
exports.ZipSubscriber = ZipSubscriber;
var StaticIterator = (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipBufferIterator = (function (_super) {
    __extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=zip.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var queue_1 = __webpack_require__(76);
var Subscription_1 = __webpack_require__(5);
var observeOn_1 = __webpack_require__(34);
var ObjectUnsubscribedError_1 = __webpack_require__(31);
var SubjectSubscription_1 = __webpack_require__(66);
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = (function (_super) {
    __extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error));
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) { config = exports.defaultThrottleConfig; }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
exports.throttle = throttle;
var ThrottleOperator = (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */
var ThrottleSubscriber = (function (_super) {
    __extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        }
        else {
            var duration = this.tryDurationSelector(value);
            if (duration) {
                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
            }
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function () {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function () {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__(43);
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__(35);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return mergeAll_1.mergeAll(1);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(11);
var ArrayObservable_1 = __webpack_require__(12);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if (isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
}
exports.race = race;
var RaceOperator = (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
exports.RaceOperator = RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RaceSubscriber = (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.RaceSubscriber = RaceSubscriber;
//# sourceMappingURL=race.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var FromObservable_1 = __webpack_require__(71);
var isArray_1 = __webpack_require__(11);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
exports.onErrorResumeNext = onErrorResumeNext;
/* tslint:enable:max-line-length */
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
var OnErrorResumeNextOperator = (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = (function (_super) {
    __extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            this.add(subscribeToResult_1.subscribeToResult(this, next));
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(19);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return mergeMap_1.mergeMap(project, resultSelector, 1);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
exports.defaultIfEmpty = defaultIfEmpty;
var DefaultIfEmptyOperator = (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DefaultIfEmptySubscriber = (function (_super) {
    __extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
exports.filter = filter;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FilterSubscriber = (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=filter.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
exports.find = find;
var FindValueOperator = (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());
exports.FindValueOperator = FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FindValueSubscriber = (function (_super) {
    __extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber_1.Subscriber));
exports.FindValueSubscriber = FindValueSubscriber;
//# sourceMappingURL=find.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
exports.audit = audit;
var AuditOperator = (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditSubscriber = (function (_super) {
    __extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
            if (duration === errorObject_1.errorObject) {
                this.destination.error(errorObject_1.errorObject.e);
            }
            else {
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
                if (innerSubscription.closed) {
                    this.clearThrottle();
                }
                else {
                    this.add(this.throttled = innerSubscription);
                }
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=audit.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
exports.scan = scan;
var ScanOperator = (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ScanSubscriber = (function (_super) {
    __extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=scan.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var ArgumentOutOfRangeError_1 = __webpack_require__(24);
var EmptyObservable_1 = __webpack_require__(13);
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else {
            return source.lift(new TakeLastOperator(count));
        }
    };
}
exports.takeLast = takeLast;
var TakeLastOperator = (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeLastSubscriber = (function (_super) {
    __extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
exports.refCount = refCount;
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=refCount.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new SwitchMapOperator(project, resultSelector));
    };
}
exports.switchMap = switchMap;
var SwitchMapOperator = (function () {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapSubscriber = (function (_super) {
    __extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var map_1 = __webpack_require__(23);
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());
exports.Timestamp = Timestamp;
;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(486);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(171);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["purchaseCompleted"] = purchaseCompleted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_glamorous__ = __webpack_require__(493);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var setState=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(highest){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return timepass.syncState({highest:highest});case 2:case"end":return _context.stop();}}},_callee,this);}));return function setState(_x){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var game=new __WEBPACK_IMPORTED_MODULE_1__game__["a" /* default */]();var timepass=window.timepass;var reviveGrowthFactor=1;function syncScoreInTournament(){setTimeout(function(){timepass.logGameEvents("[TOURNAMENT MODE] Sync Score Called, With Score: "+game.score);timepass.syncScore(game.score);},timepass.getTournamentTime()*1000);setTimeout(function(){timepass.logGameEvents("[TOURNAMENT MODE] Game Over Called");timepass.gameOver();},timepass.getTournamentTime()*1000);}function syncScoreInChallenge(){setTimeout(function(){timepass.logGameEvents("[CHALLENGE MODE] Sync Score Called, With Score: "+game.score);timepass.syncScore(game.score);},timepass.getChallengeTime()*1000);setTimeout(function(){timepass.logGameEvents("[CHALLENGE MODE] Game Over Called");timepass.gameOver();},timepass.getChallengeTime()*1000);}// Start the game
game.start();timepass.logGameEvents("Game Started Called");timepass.gameStarted();var Button=__WEBPACK_IMPORTED_MODULE_5_glamorous__["b" /* default */].div({display:"flex",justifyContent:"center",alignItems:"center",cursor:"pointer",backgroundColor:"#fdfdfd",color:"#000",fontWeight:"bold",fontSize:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(54),lineHeight:"normal",height:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(156),width:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(512),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(50/2),margin:"0 auto",boxShadow:"10 "+Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(4)+" "+Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(12)+" "+Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(4)+" rgba(113, 113, 113, 0.4)"});var Wrapper=__WEBPACK_IMPORTED_MODULE_5_glamorous__["b" /* default */].div({width:"10rem",margin:"0 auto",position:"relative",minHeight:"100%"});var Landing=function(_React$Component){_inherits(Landing,_React$Component);function Landing(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Landing);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Landing.__proto__||Object.getPrototypeOf(Landing)).call.apply(_ref,[this].concat(args))),_this),_this.handleStartClick=function(e){_this.props.onStart();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Landing,[{key:"componentDidMount",value:function componentDidMount(){this.props.onStart();}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{position:"fixed",left:0,right:0,top:0,bottom:0,background:"rgba(0, 0, 0, 0.3)",color:"#ffffff"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{fontSize:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(148),fontWeight:"bold",textAlign:"center",paddingTop:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(340)},"Bottle Flip"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{position:"absolute",bottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(259),width:"100%"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{marginTop:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(128)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Button,{onClick:this.handleStartClick},"Start Game")))));}}]);return Landing;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);function syncScore(score){timepass.logGameEvents("Sync Score Called, With Score: "+score);timepass.updateCurrentStats(null,null,game.score);timepass.syncScore(score);}function showPurchaseOption(){//console.log(timepass.getshowPurchaseOptionFlag() + "show purchase flag");
// eslint-disable-next-line
if(timepass.getshowPurchaseOptionFlag()=="true"||timepass.getshowPurchaseOptionFlag()==""||timepass.getshowPurchaseOptionFlag()==null){timepass.showPurchaseOptions("8155b9a2-376b-414e-9bdc-cab842142d53",reviveGrowthFactor);}else{purchaseCompleted("8155b9a2-376b-414e-9bdc-cab842142d53","");}}function purchaseCompleted(productid,purchaseType){if(productid==="8155b9a2-376b-414e-9bdc-cab842142d53"){game.revive();console.log(game.score);if(purchaseType==="coin"){reviveGrowthFactor+=1;}// Expose a way to update the state of the app to STATE_GAME
if(typeof window.setAppState==="function"){window.setAppState(STATE_GAME);}}}var Game=function(_React$Component2){_inherits(Game,_React$Component2);function Game(){var _ref3,_this3=this;var _temp2,_this2,_ret2;_classCallCheck(this,Game);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref3=Game.__proto__||Object.getPrototypeOf(Game)).call.apply(_ref3,[this].concat(args))),_this2),_this2.container=null,_this2.state={started:false},_this2.onRef=function(ref){_this2.container=ref;},_this2.handleGameOver=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this2.props.onGameOver();case 1:case"end":return _context2.stop();}}},_callee2,_this3);})),_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(Game,[{key:"componentDidMount",value:function componentDidMount(){this.container.appendChild(game.renderer.domElement);game.addEventListener("gameover",this.handleGameOver);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.container.removeChild(game.renderer.domElement);game.removeEventListener("gameover",this.handleGameOver);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:this.onRef}));}}]);return Game;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);var Score=function(_React$Component3){_inherits(Score,_React$Component3);function Score(){var _ref5;var _temp3,_this4,_ret3;_classCallCheck(this,Score);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this4=_possibleConstructorReturn(this,(_ref5=Score.__proto__||Object.getPrototypeOf(Score)).call.apply(_ref5,[this].concat(args))),_this4),_this4.handleReviveClick=function(){// showPurchaseOption();
_this4.props.onRevive();// Call the onRevive prop to handle state change
},_temp3),_possibleConstructorReturn(_this4,_ret3);}_createClass(Score,[{key:"render",value:function render(){var showReviveButton=timepass.getChallengeMode()!=="true"&&timepass.getTournamentMode()!=="true"&&(timepass.getshowPurchaseOptionFlag()!=="false"||timepass.getshowPurchaseOptionFlag()===null||timepass.getshowPurchaseOptionFlag()==="");return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{position:"fixed",left:0,right:0,top:0,bottom:0,background:"rgba(0, 0, 0, 0.8)",color:"#ffffff"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{textAlign:"center",fontSize:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(34),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(200)},"Round Score"," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{role:"img","aria-label":"Trophy"},"\uD83C\uDFC6")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{textAlign:"center",fontSize:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(146),fontWeight:"bold",marginTop:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(20),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(40)},this.props.round),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{position:"absolute",bottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(140)// Adjusted bottom position to ensure proper spacing
,width:"100%"},showReviveButton&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{marginBottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(20)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Button,{onClick:this.handleReviveClick},"Revive"," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{role:"img","aria-label":"Heart"},"\u2764\uFE0F"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{marginBottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(20)}," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Button,{onClick:this.props.onRestart},"Try Again"," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{role:"img","aria-label":"Refresh"},"\uD83D\uDD01"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_glamorous__["a" /* Div */],{fontSize:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(36),textAlign:"center",position:"absolute",width:"100%",bottom:Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* rem */])(-40)}," ","Highest Score: ",this.props.highest))));}}]);return Score;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);var STATE_LANDING="landing";var STATE_GAME="game";var STATE_GAMEOVER="gameover";var App=function(_React$Component4){_inherits(App,_React$Component4);function App(){var _ref6;var _temp4,_this5,_ret4;_classCallCheck(this,App);for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return _ret4=(_temp4=(_this5=_possibleConstructorReturn(this,(_ref6=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref6,[this].concat(args))),_this5),_this5.state={state:STATE_LANDING,highest:parseInt(localStorage.getItem("highest")||"0",10),round:0,adFrequency:14,playedChances:1},_temp4),_possibleConstructorReturn(_this5,_ret4);}_createClass(App,[{key:"componentDidMount",value:function componentDidMount(){var _this6=this;var uid=timepass.getUserId();timepass.analytics.configureGameAnalyticsUserId(uid);timepass.analytics.initializeGameAnalytics("20446c7524c75f103f802504356e73c6","ca65180594f734889f5c3fdb14f85b328e71aeb7");timepass.pageReady();var isBusinessPlatform=timepass.getIsBusinessPlatform();console.log(isBusinessPlatform);if(isBusinessPlatform==="true"){timepass.analytics.getGameAnalyticsRemoteConfigs("b2b_ad_frequency","2").then(function(value){_this6.adFrequency=value,console.log("ad Frequency"+_this6.adFrequency);}).catch(function(error){console.error("Error:",error);});}if(isBusinessPlatform!=="true"){timepass.analytics.getGameAnalyticsRemoteConfigs("ad_frequency","5").then(function(value){_this6.adFrequency=value,console.log("ad Frequency"+_this6.adFrequency);}).catch(function(error){console.error("Error:",error);});}if(timepass.getTournamentMode()==="true"&&timepass.getTournamentType()==="time"){syncScoreInTournament();}if(timepass.getChallengeMode()==="true"&&timepass.getChallengeType()==="time"){syncScoreInChallenge();}// Expose a global function to set the app state
window.setAppState=function(newState){_this6.setState({state:newState});};}},{key:"renderUI",value:function renderUI(){var _this7=this;var getState=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var state;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return timepass.getState();case 3:state=_context3.sent;if(!!state.highest){localStorage.setItem("highest",state.highest);}return _context3.abrupt("return",state);case 8:_context3.prev=8;_context3.t0=_context3["catch"](0);console.error({error:_context3.t0});case 11:case"end":return _context3.stop();}}},_callee3,this,[[0,8]]);}));return function getState(){return _ref7.apply(this,arguments);};}();var handleGameStart=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var state;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(timepass.getStateSyncEnabled()==="true")){_context4.next=5;break;}_context4.next=3;return getState();case 3:state=_context4.sent;if(!!state.highest){_this7.setState({highest:state.highest});}case 5:game.restart();_this7.setState({state:STATE_GAME});case 7:case"end":return _context4.stop();}}},_callee4,_this7);}));return function handleGameStart(){return _ref8.apply(this,arguments);};}();var handleGameRestart=function handleGameRestart(){game.restart();_this7.setState({state:STATE_GAME});};var handleRevive=function handleRevive(){showPurchaseOption();_this7.setState(function(prevState){return{round:game.score,playedChances:prevState.playedChances+1};});};switch(this.state.state){case STATE_GAMEOVER:return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Score,{round:this.state.round,highest:this.state.highest,onRestart:handleGameRestart,onRevive:handleRevive});case STATE_LANDING:return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Landing,{onStart:handleGameStart});case STATE_GAME:default:return null;}}},{key:"render",value:function render(){var _this8=this;var handleChancesInChallenge=function handleChancesInChallenge(){if(timepass.getChallengeMode()==='true'&&timepass.getChallengeType()==='chance'){if(// eslint-disable-next-line
_this8.state.playedChances==timepass.getChallengeChances()){timepass.logGameEvents('[Challenge MODE] Game Over Called');timepass.gameOver();}else{timepass.logGameEvents('[Challenge MODE] Chance Left Called, With Chance: '+timepass.getChallengeChances()-_this8.state.playedChances);timepass.gameChanceLeft(timepass.getChallengeChances()-_this8.state.playedChances);}}};var handleChancesInTournament=function handleChancesInTournament(){if(// eslint-disable-next-line
timepass.getTournamentMode()=='true'&&timepass.getTournamentType()==='chance'){if(// eslint-disable-next-line
_this8.state.playedChances==timepass.getTournamentChances()){timepass.logGameEvents('[TOURNAMENT MODE] Game Over Called');timepass.gameOver();}else{timepass.logGameEvents('[TOURNAMENT MODE] Chance Left Called, With Chance: '+timepass.getTournamentChances()-_this8.state.playedChances);timepass.gameChanceLeft(timepass.getTournamentChances()-_this8.state.playedChances);}}};var handleGameOver=function handleGameOver(){handleChancesInChallenge();handleChancesInTournament();// Tournament
if(_this8.state.playedChances%Number(_this8.adFrequency)===0){timepass.showAds();}syncScore(game.score);var highest=_this8.state.highest;if(game.score>highest){highest=game.score;localStorage.setItem("highest",highest.toString());setState(game.score);}_this8.setState({highest:highest,round:game.score,state:STATE_GAMEOVER,playedChances:_this8.state.playedChances+1});timepass.analytics.sendGameAnalyticsProgressionEvent({progressEvent:"Complete",progressOne:"Score",score:game.score});};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Game,{onGameOver:handleGameOver}),this.renderUI());}}]);return App;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(App,null),document.getElementById("root"));

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(12);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__(71);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(11);
var isArrayLike_1 = __webpack_require__(67);
var isPromise_1 = __webpack_require__(68);
var PromiseObservable_1 = __webpack_require__(72);
var IteratorObservable_1 = __webpack_require__(194);
var ArrayObservable_1 = __webpack_require__(12);
var ArrayLikeObservable_1 = __webpack_require__(195);
var iterator_1 = __webpack_require__(16);
var Observable_1 = __webpack_require__(0);
var observeOn_1 = __webpack_require__(34);
var observable_1 = __webpack_require__(30);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(9);
var Observable_1 = __webpack_require__(0);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TimerObservable_1 = __webpack_require__(245);
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(9);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var Observable_1 = __webpack_require__(0);
var Subscriber_1 = __webpack_require__(1);
var map_1 = __webpack_require__(23);
function getCORSRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else if (!!root_1.root.XDomainRequest) {
        return new root_1.root.XDomainRequest();
    }
    else {
        throw new Error('CORS is not supported by your browser');
    }
}
function getXMLHttpRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else {
        var progId = void 0;
        try {
            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
            for (var i = 0; i < 3; i++) {
                try {
                    progId = progIds[i];
                    if (new root_1.root.ActiveXObject(progId)) {
                        break;
                    }
                }
                catch (e) {
                }
            }
            return new root_1.root.ActiveXObject(progId);
        }
        catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) { headers = null; }
    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
}
exports.ajaxGet = ajaxGet;
;
function ajaxPost(url, body, headers) {
    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
}
exports.ajaxPost = ajaxPost;
;
function ajaxDelete(url, headers) {
    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
}
exports.ajaxDelete = ajaxDelete;
;
function ajaxPut(url, body, headers) {
    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
}
exports.ajaxPut = ajaxPut;
;
function ajaxPatch(url, body, headers) {
    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
}
exports.ajaxPatch = ajaxPatch;
;
var mapResponse = map_1.map(function (x, index) { return x.response; });
function ajaxGetJSON(url, headers) {
    return mapResponse(new AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
exports.ajaxGetJSON = ajaxGetJSON;
;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var AjaxObservable = (function (_super) {
    __extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function () {
                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') {
            request.url = urlOrRequest;
        }
        else {
            for (var prop in urlOrRequest) {
                if (urlOrRequest.hasOwnProperty(prop)) {
                    request[prop] = urlOrRequest[prop];
                }
            }
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function (subscriber) {
        return new AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */
    AjaxObservable.create = (function () {
        var create = function (urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    })();
    return AjaxObservable;
}(Observable_1.Observable));
exports.AjaxObservable = AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AjaxSubscriber = (function (_super) {
    __extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        // ensure content type is set
        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function (e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function () {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
        if (xhr === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            }
            else {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
            }
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) {
                xhr.withCredentials = !!request.withCredentials;
            }
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
        if (!body || typeof body === 'string') {
            return body;
        }
        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
            return body;
        }
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) {
                contentType = contentType.substring(0, splitIndex);
            }
        }
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function (key) { return (encodeURIComponent(key) + "=" + encodeURIComponent(body[key])); }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    };
    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) {
                progressSubscriber.error(e);
            }
            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        ;
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function (e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if (root_1.root.XDomainRequest) {
                    xhr.onprogress = xhrProgress_1;
                }
                else {
                    xhr.upload.onprogress = xhrProgress_1;
                }
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function (e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) {
                    status_1 = response ? 200 : 0;
                }
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) {
                        progressSubscriber.complete();
                    }
                    subscriber.next(e);
                    subscriber.complete();
                }
                else {
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        ;
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function () {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
            xhr.abort();
        }
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}(Subscriber_1.Subscriber));
exports.AjaxSubscriber = AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */
var AjaxResponse = (function () {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}());
exports.AjaxResponse = AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */
var AjaxError = (function (_super) {
    __extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error));
exports.AjaxError = AjaxError;
function parseXhrResponse(responseType, xhr) {
    switch (responseType) {
        case 'json':
            if ('response' in xhr) {
                //IE does not support json as responseType, parse it internally
                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            }
            else {
                // HACK(benlesh): TypeScript shennanigans
                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
                return JSON.parse(xhr.responseText || 'null');
            }
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return ('response' in xhr) ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */
var AjaxTimeoutError = (function (_super) {
    __extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}(AjaxError));
exports.AjaxTimeoutError = AjaxTimeoutError;
//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueueAction_1 = __webpack_require__(253);
var QueueScheduler_1 = __webpack_require__(254);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSubscriber = (function (_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
exports.bufferCount = bufferCount;
var BufferCountOperator = (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferCountSubscriber = (function (_super) {
    __extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSkipCountSubscriber = (function (_super) {
    __extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(4);
var Subscriber_1 = __webpack_require__(1);
var isScheduler_1 = __webpack_require__(10);
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
exports.bufferTime = bufferTime;
var BufferTimeOperator = (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferTimeSubscriber = (function (_super) {
    __extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
exports.bufferToggle = bufferToggle;
var BufferToggleOperator = (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferToggleSubscriber = (function (_super) {
    __extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(subscribeToResult_1.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription_1.Subscription();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
exports.bufferWhen = bufferWhen;
var BufferWhenOperator = (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferWhenSubscriber = (function (_super) {
    __extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            closingSubscription = new Subscription_1.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
exports.catchError = catchError;
var CatchOperator = (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CatchSubscriber = (function (_super) {
    __extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=catchError.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__(33);
function combineAll(project) {
    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__(17);
var concat_2 = __webpack_require__(17);
exports.concatStatic = concat_2.concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(48);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
exports.count = count;
var CountOperator = (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CountSubscriber = (function (_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=count.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
exports.dematerialize = dematerialize;
var DeMaterializeOperator = (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DeMaterializeSubscriber = (function (_super) {
    __extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
exports.debounce = debounce;
var DebounceOperator = (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceSubscriber = (function (_super) {
    __extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = subscribeToResult_1.subscribeToResult(this, duration);
        if (!subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var async_1 = __webpack_require__(4);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(4);
var isDate_1 = __webpack_require__(37);
var Subscriber_1 = __webpack_require__(1);
var Notification_1 = __webpack_require__(18);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(0);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
exports.delayWhen = delayWhen;
var DelayWhenOperator = (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelayWhenSubscriber = (function (_super) {
    __extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelayObservable = (function (_super) {
    __extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable_1.Observable));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelaySubscriber = (function (_super) {
    __extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
var Set_1 = __webpack_require__(296);
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
exports.distinct = distinct;
var DistinctOperator = (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctSubscriber = (function (_super) {
    __extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new Set_1.Set();
        if (flushes) {
            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
        }
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.DistinctSubscriber = DistinctSubscriber;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__(50);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
exports.tap = tap;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=tap.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
exports.exhaust = exhaust;
var SwitchFirstOperator = (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstSubscriber = (function (_super) {
    __extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return function (source) { return source.lift(new SwitchFirstMapOperator(project, resultSelector)); };
}
exports.exhaustMap = exhaustMap;
var SwitchFirstMapOperator = (function () {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstMapSubscriber = (function (_super) {
    __extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
exports.expand = expand;
var ExpandOperator = (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());
exports.ExpandOperator = ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ExpandSubscriber = (function (_super) {
    __extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            this.buffer = [];
        }
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = tryCatch_1.tryCatch(this.project)(value, index);
            if (result === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.ExpandSubscriber = ExpandSubscriber;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var ArgumentOutOfRangeError_1 = __webpack_require__(24);
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return function (source) { return source.lift(new ElementAtOperator(index, defaultValue)); };
}
exports.elementAt = elementAt;
var ElementAtOperator = (function () {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    ElementAtOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ElementAtSubscriber = (function (_super) {
    __extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function (x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') {
                destination.next(this.defaultValue);
            }
            else {
                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
            }
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Subscription_1 = __webpack_require__(5);
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
exports.finalize = finalize;
var FinallyOperator = (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FinallySubscriber = (function (_super) {
    __extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new Subscription_1.Subscription(callback));
    }
    return FinallySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=finalize.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__(52);
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var EmptyError_1 = __webpack_require__(40);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return function (source) { return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source)); };
}
exports.first = first;
var FirstOperator = (function () {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FirstSubscriber = (function (_super) {
    __extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._emit = function (value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function (value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        }
        else if (!this.hasCompleted) {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return FirstSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=first.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Subscription_1 = __webpack_require__(5);
var Observable_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(6);
var Map_1 = __webpack_require__(323);
var FastMap_1 = __webpack_require__(325);
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
exports.groupBy = groupBy;
var GroupByOperator = (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupBySubscriber = (function (_super) {
    __extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupDurationSubscriber = (function (_super) {
    __extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(Subscriber_1.Subscriber));
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */
var GroupedObservable = (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription_1.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable_1.Observable));
exports.GroupedObservable = GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerRefCountSubscription = (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription_1.Subscription));
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var noop_1 = __webpack_require__(43);
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
exports.ignoreElements = ignoreElements;
var IgnoreElementsOperator = (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IgnoreElementsSubscriber = (function (_super) {
    __extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
        noop_1.noop();
    };
    return IgnoreElementsSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
exports.isEmpty = isEmpty;
var IsEmptyOperator = (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IsEmptySubscriber = (function (_super) {
    __extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var audit_1 = __webpack_require__(53);
var timer_1 = __webpack_require__(74);
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
}
exports.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var EmptyError_1 = __webpack_require__(40);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return function (source) { return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source)); };
}
exports.last = last;
var LastOperator = (function () {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function (observer, source) {
        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var LastSubscriber = (function (_super) {
    __extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return LastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=last.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
exports.every = every;
var EveryOperator = (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var EverySubscriber = (function (_super) {
    __extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=every.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
exports.mapTo = mapTo;
var MapToOperator = (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapToSubscriber = (function (_super) {
    __extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Notification_1 = __webpack_require__(18);
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
exports.materialize = materialize;
var MaterializeOperator = (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MaterializeSubscriber = (function (_super) {
    __extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification_1.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(25);
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return reduce_1.reduce(max);
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__(36);
var merge_2 = __webpack_require__(36);
exports.mergeStatic = merge_2.merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function (source) { return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent)); };
}
exports.mergeMapTo = mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var MergeMapToOperator = (function () {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}());
exports.MergeMapToOperator = MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapToSubscriber = (function (_super) {
    __extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapToSubscriber = MergeMapToSubscriber;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
exports.mergeScan = mergeScan;
var MergeScanOperator = (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());
exports.MergeScanOperator = MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeScanSubscriber = (function (_super) {
    __extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeScanSubscriber = MergeScanSubscriber;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(25);
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return reduce_1.reduce(min);
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var Observable_1 = __webpack_require__(0);
var Subscriber_1 = __webpack_require__(1);
var Subscription_1 = __webpack_require__(5);
var refCount_1 = __webpack_require__(56);
/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, 
        /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription_1.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount_1.refCount()(this);
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
var connectableProto = ConnectableObservable.prototype;
exports.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(Subject_1.SubjectSubscriber));
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
exports.pairwise = pairwise;
var PairwiseOperator = (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var PairwiseSubscriber = (function (_super) {
    __extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var not_1 = __webpack_require__(370);
var filter_1 = __webpack_require__(51);
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return function (source) { return [
        filter_1.filter(predicate, thisArg)(source),
        filter_1.filter(not_1.not(predicate, thisArg))(source)
    ]; };
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(23);
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return map_1.map(plucker(properties, length))(source); };
}
exports.pluck = pluck;
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subject_1 = __webpack_require__(6);
var multicast_1 = __webpack_require__(14);
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return selector ?
        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
        multicast_1.multicast(new Subject_1.Subject());
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BehaviorSubject_1 = __webpack_require__(121);
var multicast_1 = __webpack_require__(14);
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var ObjectUnsubscribedError_1 = __webpack_require__(31);
/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(39);
var multicast_1 = __webpack_require__(14);
/* tslint:enable:max-line-length */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncSubject_1 = __webpack_require__(32);
var multicast_1 = __webpack_require__(14);
function publishLast() {
    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(11);
var race_1 = __webpack_require__(46);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
    };
}
exports.race = race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var EmptyObservable_1 = __webpack_require__(13);
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    return function (source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
exports.repeat = repeat;
var RepeatOperator = (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatSubscriber = (function (_super) {
    __extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
exports.repeatWhen = repeatWhen;
var RepeatWhenOperator = (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatWhenSubscriber = (function (_super) {
    __extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject_1.Subject();
        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
        if (retries === errorObject_1.errorObject) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
exports.retry = retry;
var RetryOperator = (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetrySubscriber = (function (_super) {
    __extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=retry.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
exports.retryWhen = retryWhen;
var RetryWhenOperator = (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetryWhenSubscriber = (function (_super) {
    __extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new Subject_1.Subject();
                retries = tryCatch_1.tryCatch(this.notifier)(errors);
                if (retries === errorObject_1.errorObject) {
                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
                }
                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return function (source) { return source.lift(new SampleOperator(notifier)); };
}
exports.sample = sample;
var SampleOperator = (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleSubscriber = (function (_super) {
    __extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=sample.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var async_1 = __webpack_require__(4);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
exports.sampleTime = sampleTime;
var SampleTimeOperator = (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleTimeSubscriber = (function (_super) {
    __extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
}
exports.sequenceEqual = sequenceEqual;
var SequenceEqualOperator = (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());
exports.SequenceEqualOperator = SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SequenceEqualSubscriber = (function (_super) {
    __extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
                if (areEqual === errorObject_1.errorObject) {
                    this.destination.error(errorObject_1.errorObject.e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber_1.Subscriber));
exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
var SequenceEqualCompareToSubscriber = (function (_super) {
    __extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__(14);
var refCount_1 = __webpack_require__(56);
var Subject_1 = __webpack_require__(6);
function shareSubjectFactory() {
    return new Subject_1.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(39);
/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
}
exports.shareReplay = shareReplay;
function shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        return function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) {
                subscription.unsubscribe();
            }
        };
    };
}
;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var EmptyError_1 = __webpack_require__(40);
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
exports.single = single;
var SingleOperator = (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SingleSubscriber = (function (_super) {
    __extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return SingleSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=single.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
exports.skip = skip;
var SkipOperator = (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipSubscriber = (function (_super) {
    __extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skip.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var ArgumentOutOfRangeError_1 = __webpack_require__(24);
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return function (source) { return source.lift(new SkipLastOperator(count)); };
}
exports.skipLast = skipLast;
var SkipLastOperator = (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            // If we don't want to skip any values then just subscribe
            // to Subscriber without any further logic.
            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipLastSubscriber = (function (_super) {
    __extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
exports.skipUntil = skipUntil;
var SkipUntilOperator = (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipUntilSubscriber = (function (_super) {
    __extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype._complete = function () {
        if (this.isInnerStopped) {
            _super.prototype._complete.call(this);
        }
        else {
            this.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
        this.isInnerStopped = true;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    return SkipUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
exports.skipWhile = skipWhile;
var SkipWhileOperator = (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipWhileSubscriber = (function (_super) {
    __extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(12);
var ScalarObservable_1 = __webpack_require__(44);
var EmptyObservable_1 = __webpack_require__(13);
var concat_1 = __webpack_require__(17);
var isScheduler_1 = __webpack_require__(10);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    return function (source) {
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len === 1) {
            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
        }
        else if (len > 1) {
            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
        }
        else {
            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
        }
    };
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsapAction_1 = __webpack_require__(421);
var AsapScheduler_1 = __webpack_require__(424);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */
exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
//# sourceMappingURL=asap.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(423);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMap_1 = __webpack_require__(57);
var identity_1 = __webpack_require__(73);
function switchAll() {
    return switchMap_1.switchMap(identity_1.identity);
}
exports.switchAll = switchAll;
//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return function (source) { return source.lift(new SwitchMapToOperator(innerObservable, resultSelector)); };
}
exports.switchMapTo = switchMapTo;
var SwitchMapToOperator = (function () {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapToSubscriber = (function (_super) {
    __extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function (value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var ArgumentOutOfRangeError_1 = __webpack_require__(24);
var EmptyObservable_1 = __webpack_require__(13);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return function (source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else {
            return source.lift(new TakeOperator(count));
        }
    };
}
exports.take = take;
var TakeOperator = (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeSubscriber = (function (_super) {
    __extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=take.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
}
exports.takeWhile = takeWhile;
var TakeWhileOperator = (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeWhileSubscriber = (function (_super) {
    __extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var async_1 = __webpack_require__(4);
var throttle_1 = __webpack_require__(41);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
exports.throttleTime = throttleTime;
var ThrottleTimeOperator = (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ThrottleTimeSubscriber = (function (_super) {
    __extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var timeInterval_1 = __webpack_require__(149);
exports.TimeInterval = timeInterval_1.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeInterval_1.timeInterval(scheduler)(this);
}
exports.timeInterval = timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var async_1 = __webpack_require__(4);
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new TimeIntervalOperator(scheduler)); };
}
exports.timeInterval = timeInterval;
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
;
var TimeIntervalOperator = (function () {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeIntervalSubscriber = (function (_super) {
    __extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(4);
var isDate_1 = __webpack_require__(37);
var Subscriber_1 = __webpack_require__(1);
var TimeoutError_1 = __webpack_require__(151);
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return function (source) { return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError())); };
}
exports.timeout = timeout;
var TimeoutOperator = (function () {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutSubscriber = (function (_super) {
    __extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */
var TimeoutError = (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(4);
var isDate_1 = __webpack_require__(37);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) {
        var absoluteTimeout = isDate_1.isDate(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
exports.timeoutWith = timeoutWith;
var TimeoutWithOperator = (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutWithSubscriber = (function (_super) {
    __extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(25);
function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return reduce_1.reduce(toArrayReducer, []);
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new Subject_1.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject_1.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=window.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
var Subject_1 = __webpack_require__(6);
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
exports.windowCount = windowCount;
var WindowCountOperator = (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowCountSubscriber = (function (_super) {
    __extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [new Subject_1.Subject()];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject_1.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var async_1 = __webpack_require__(4);
var Subscriber_1 = __webpack_require__(1);
var isNumeric_1 = __webpack_require__(20);
var isScheduler_1 = __webpack_require__(10);
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
exports.windowTime = windowTime;
var WindowTimeOperator = (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = (function (_super) {
    __extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject_1.Subject));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowTimeSubscriber = (function (_super) {
    __extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var Subscription_1 = __webpack_require__(5);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
exports.windowToggle = windowToggle;
var WindowToggleOperator = (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowToggleSubscriber = (function (_super) {
    __extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === errorObject_1.errorObject) {
                return this.error(errorObject_1.errorObject.e);
            }
            else {
                var window_1 = new Subject_1.Subject();
                var subscription = new Subscription_1.Subscription();
                var context = { window: window_1, subscription: subscription };
                this.contexts.push(context);
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
exports.windowWhen = windowWhen;
var WindowOperator = (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) { innerSub = null; }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject_1.Subject();
        this.destination.next(window);
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            var err = errorObject_1.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(2);
var subscribeToResult_1 = __webpack_require__(3);
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
exports.withLatestFrom = withLatestFrom;
var WithLatestFromOperator = (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WithLatestFromSubscriber = (function (_super) {
    __extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(38);
function zipAll(project) {
    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog_1 = __webpack_require__(162);
var SubscriptionLoggable = (function () {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}());
exports.SubscriptionLoggable = SubscriptionLoggable;
//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog = (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
exports.SubscriptionLog = SubscriptionLog;
//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
exports.applyMixins = applyMixins;
//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(21);
var AsyncScheduler_1 = __webpack_require__(22);
var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
        _super.call(this, SchedulerAction, function () { return _this.frame; });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.VirtualTimeScheduler = VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = scheduler.index += 1; }
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction_1.AsyncAction));
exports.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(496);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(498);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(501);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(503);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(166);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(500);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169);
module.exports = __webpack_require__(61);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(170).enable();
  window.Promise = __webpack_require__(172);
}

// fetch() polyfill for making API calls.
__webpack_require__(173);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(15);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(60);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(60);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(176);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Game; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cannon__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cannon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cannon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mersenne_twister__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mersenne_twister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mersenne_twister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var timepass=window.timepass;window.purchaseCompleted=__WEBPACK_IMPORTED_MODULE_6__index__["purchaseCompleted"];var body=window.document.body,BODY_WIDTH=Math.min(body.offsetWidth,540),BODY_HEIGHT=body.offsetHeight,ASPECT=BODY_WIDTH/BODY_HEIGHT,SCREEN_HEIGHT=BODY_HEIGHT,SCREEN_WIDTH=SCREEN_HEIGHT*ASPECT,FRUSTUM_HEIGHT=6,FRUSTUM_WIDTH=FRUSTUM_HEIGHT*ASPECT,FRUSTUM_SCALE=FRUSTUM_HEIGHT/SCREEN_HEIGHT;var FLIP_DISTANCE_UNIT=2.5,FLIP_HEIGHT=1.5,FLIP_DURATION=500;var BOTTLE_PRESSED_H=1.2,BOTTLE_PRESSED_V=0.45,BLOCK_PRESSED_H=0.5,BLOCK_HEIGHT=1;var PRESS_DURATION=3000,BOUNCE_DURATION=500;var font=new __WEBPACK_IMPORTED_MODULE_1_three__["f" /* FontLoader */]().parse(__webpack_require__(478));var objectLoader=new __WEBPACK_IMPORTED_MODULE_1_three__["k" /* ObjectLoader */]();var cubes=[{model:objectLoader.parse(__webpack_require__(479)),stayScore:2,prob:2},{model:objectLoader.parse(__webpack_require__(480)),stayScore:0,prob:3},{model:objectLoader.parse(__webpack_require__(481)),stayScore:0,prob:3},{model:objectLoader.parse(__webpack_require__(482)),stayScore:8,prob:1},{model:objectLoader.parse(__webpack_require__(483)),stayScore:32,prob:1},{model:objectLoader.parse(__webpack_require__(484)),stayScore:16,prob:1}];var Text=(_temp=_class=function(){function Text(){var _this=this;var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var material=arguments.length>1&&arguments[1]!==undefined?arguments[1]:new __WEBPACK_IMPORTED_MODULE_1_three__["i" /* MeshBasicMaterial */]({color:0xffffff});_classCallCheck(this,Text);this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.material=null;this.fontSize=0.4;this.scale=this.fontSize/font.data.resolution;this.lineHeight=(font.data.boundingBox.yMax-font.data.boundingBox.yMin+font.data.underlineThickness)*this.scale;this._text='';if(Text.glyphs===null){Text.glyphs={};'+0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ '.split('').forEach(function(key){Text.glyphs[key]={geometry:new __WEBPACK_IMPORTED_MODULE_1_three__["s" /* TextGeometry */](key,{font:font,size:_this.fontSize,height:0.1}),width:font.data.glyphs[key].ha*_this.scale};});}this.material=material;this._text=text.toString();this.redraw();}_createClass(Text,[{key:'redraw',value:function redraw(){var _this2=this;this.mesh.children.length=0;var offset=0;this._text.toString().split('').map(function(key,index){var glyph=new __WEBPACK_IMPORTED_MODULE_1_three__["h" /* Mesh */](Text.glyphs[key].geometry,_this2.material);glyph.position.set(offset,0,0);offset+=Text.glyphs[key].width;return glyph;}).forEach(function(char){char.position.x-=offset/2;_this2.mesh.add(char);});}},{key:'text',get:function get(){return this._text;},set:function set(_text){this._text=_text.toString();this.redraw();}}]);return Text;}(),_class.glyphs=null,_temp);var ShadowText=function(){function ShadowText(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';_classCallCheck(this,ShadowText);this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.fill=new Text();this.shadow=new Text('',new __WEBPACK_IMPORTED_MODULE_1_three__["i" /* MeshBasicMaterial */]({transparent:true,opacity:0.3,color:0x000000}));this.lineHeight=this.fill.lineHeight;this._text='';this.text=text;this.shadow.mesh.position.set(0,-0.02,-0.1);this.mesh.add(this.fill.mesh,this.shadow.mesh);}_createClass(ShadowText,[{key:'onUpdate',value:function onUpdate(){}},{key:'text',get:function get(){return this._text;},set:function set(_text){this._text=_text;this.fill.text=_text;this.shadow.text=_text;this.onUpdate();}}]);return ShadowText;}();var ScoreText=function(_ShadowText){_inherits(ScoreText,_ShadowText);function ScoreText(){_classCallCheck(this,ScoreText);return _possibleConstructorReturn(this,(ScoreText.__proto__||Object.getPrototypeOf(ScoreText)).apply(this,arguments));}_createClass(ScoreText,[{key:'onUpdate',value:function onUpdate(){this.mesh.position.set(FRUSTUM_WIDTH/2,FRUSTUM_HEIGHT-this.lineHeight/2-40*FRUSTUM_SCALE,0);}}]);return ScoreText;}(ShadowText);var CenterText=function(_ShadowText2){_inherits(CenterText,_ShadowText2);function CenterText(text){_classCallCheck(this,CenterText);var _this4=_possibleConstructorReturn(this,(CenterText.__proto__||Object.getPrototypeOf(CenterText)).call(this,text));_this4.mesh.visible=false;_this4.mesh.scale.set(0.8,0.65,1);return _this4;}_createClass(CenterText,[{key:'onUpdate',value:function onUpdate(){this.mesh.position.set(FRUSTUM_WIDTH/2,FRUSTUM_HEIGHT/2,0);}}]);return CenterText;}(ShadowText);var AddScoreText=function AddScoreText(){_classCallCheck(this,AddScoreText);this.text=new ShadowText('0');this.mesh=this.text.mesh;this.mesh.scale.set(3,3,3);this.mesh.position.set(0,0,1);};var Waves=function(){function Waves(){_classCallCheck(this,Waves);this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.rings=[];this.count=5;this.duration=2000;this.interval=this.duration/10;for(var i=0;i<this.count;++i){var ring=new __WEBPACK_IMPORTED_MODULE_1_three__["h" /* Mesh */](new __WEBPACK_IMPORTED_MODULE_1_three__["o" /* RingGeometry */](0.3,0.4,50,50),new __WEBPACK_IMPORTED_MODULE_1_three__["i" /* MeshBasicMaterial */]({transparent:true,opacity:1,color:0xffffff}));ring.visible=false;ring.position.z=0.01;this.rings.push(ring);this.mesh.add(ring);}}_createClass(Waves,[{key:'wave',value:function wave(count){var _this5=this;this.rings.forEach(function(ring){ring.visible=false;});count=Math.min(this.count,count);var _loop=function _loop(i){var ring=_this5.rings[i];ring.scale.set(1,1,1);new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(ring.scale).delay(_this5.interval*i).to({x:4,y:4},_this5.duration).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onStart(function(){ring.visible=true;}).start();ring.material.opacity=0.8;new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(ring.material).delay(_this5.interval*i).to({opacity:0},_this5.duration).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out).start();};for(var i=0;i<count;++i){_loop(i);}}}]);return Waves;}();var SputteringParticles=function(){function SputteringParticles(){_classCallCheck(this,SputteringParticles);this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.texture=new __WEBPACK_IMPORTED_MODULE_1_three__["c" /* CanvasTexture */](this.generateSprite());this.material=new __WEBPACK_IMPORTED_MODULE_1_three__["r" /* SpriteMaterial */]({map:this.texture,color:0xffffff});this.count=15;this.duration=500;for(var i=0;i<this.count;++i){var particle=new __WEBPACK_IMPORTED_MODULE_1_three__["q" /* Sprite */](this.material);particle.visible=false;this.mesh.add(particle);}}_createClass(SputteringParticles,[{key:'generateSprite',value:function generateSprite(){var canvas=document.createElement('canvas');canvas.width=16;canvas.height=16;var context=canvas.getContext('2d');var gradient=context.createRadialGradient(canvas.width/2,canvas.height/2,0,canvas.width/2,canvas.height/2,canvas.width/2);gradient.addColorStop(0,'rgba(255,255,255,1)');gradient.addColorStop(1,'rgba(255,255,255,1)');context.fillStyle=gradient;context.fillRect(0,0,canvas.width,canvas.height);return canvas;}},{key:'emit',value:function emit(){var _this6=this;this.mesh.visible=true;var particles=this.mesh.children;particles.forEach(function(particle,i){particle.visible=true;var direction=new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](Math.cos(Math.random()*2*Math.PI),Math.sin(Math.random()*2*Math.PI),0);var start=direction.clone().multiplyScalar(0.15);var end=direction.clone().multiplyScalar(0.25);var height=0.3;particle.scale.set(0.02,0.02,0.02);particle.position.copy(start);var up=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(particle.position).to({z:height},_this6.duration/2);var down=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(particle.position).to({z:end.z},_this6.duration/2);var move=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(particle.position).to({x:end.x,y:end.y},_this6.duration).onComplete(function(){particle.visible=false;});up.chain(down).start();move.start();});}},{key:'stop',value:function stop(){this.mesh.visible=false;}}]);return SputteringParticles;}();var PolymericParticles=function(){function PolymericParticles(){_classCallCheck(this,PolymericParticles);this.particles=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.count=15;this.interval=15;this.texture=new __WEBPACK_IMPORTED_MODULE_1_three__["c" /* CanvasTexture */](this.generateSprite());this.whiteMaterial=new __WEBPACK_IMPORTED_MODULE_1_three__["r" /* SpriteMaterial */]({map:this.texture,color:0x00ff00// blending: THREE.AdditiveBlending
});this.greenMaterial=new __WEBPACK_IMPORTED_MODULE_1_three__["r" /* SpriteMaterial */]({map:this.texture,color:0xffffff});for(var i=0;i<this.count;i++){var particle=new __WEBPACK_IMPORTED_MODULE_1_three__["q" /* Sprite */](i%3?this.whiteMaterial:this.greenMaterial);this.step(particle,i*this.interval);this.particles.add(particle);}this.particles.visible=false;}_createClass(PolymericParticles,[{key:'step',value:function step(particle,delay){var _this7=this;var position=new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](Math.random()-0.5,Math.random()-0.5,Math.random()-0.5).normalize().multiplyScalar(Math.random()*0.2+0.4);particle.scale.set(0.03,0.03,0.03);particle.position.copy(position);particle.visible=false;new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(particle.position).delay(delay).to({x:0,y:0,z:0},this.count*this.interval).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.In).start().onStart(function(){particle.visible=true;}).onComplete(function(){_this7.step(particle,delay);});}},{key:'generateSprite',value:function generateSprite(){var canvas=document.createElement('canvas');canvas.width=16;canvas.height=16;var context=canvas.getContext('2d');var gradient=context.createRadialGradient(canvas.width/2,canvas.height/2,0,canvas.width/2,canvas.height/2,canvas.width/2);gradient.addColorStop(0,'rgba(255,255,255,1)');gradient.addColorStop(1,'rgba(255,255,255,1)');context.fillStyle=gradient;context.fillRect(0,0,canvas.width,canvas.height);return canvas;}}]);return PolymericParticles;}();var Block=function(){function Block(cube){var scale=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;_classCallCheck(this,Block);this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.body=new __WEBPACK_IMPORTED_MODULE_2_cannon__["Body"]({mass:0});this.stayScore=0;this.scale=1;this.scale=scale;this.stayScore=cube.stayScore;var model=cube.model.clone();model.position.z=0.5;model.castShadow=true;model.receiveShadow=true;this.mesh.add(model);this.mesh.scale.set(scale,scale,1);this.body.addShape(new __WEBPACK_IMPORTED_MODULE_2_cannon__["Box"](new __WEBPACK_IMPORTED_MODULE_2_cannon__["Vec3"](scale/2,scale/2,0.5)),new __WEBPACK_IMPORTED_MODULE_2_cannon__["Vec3"](0,0,0.5));}_createClass(Block,[{key:'update',value:function update(){}},{key:'press',value:function press(){this.mesh.scale.z=1;return[new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.scale).to({z:BLOCK_PRESSED_H},PRESS_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out)];}},{key:'bounce',value:function bounce(){return[new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.scale).to({z:1},BOUNCE_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Bounce.Out)];}},{key:'down',value:function down(){this.mesh.position.z=3;this.mesh.visible=true;return new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.position).to({z:0},800).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Bounce.Out).start();}},{key:'canHold',value:function canHold(position){var offset=position.clone().sub(this.mesh.position).setZ(0);return Math.abs(offset.x)<=this.scale/2&&Math.abs(offset.y)<this.scale/2;}},{key:'hitCenter',value:function hitCenter(position){var offset=position.clone().sub(this.mesh.position).setZ(0);return offset.length()<0.08*this.scale;}}]);return Block;}();var Bottle=function(){function Bottle(){_classCallCheck(this,Bottle);this.connected=false;this.boundingBox=new __WEBPACK_IMPORTED_MODULE_1_three__["b" /* Box3 */]();this.offset=null;this.mesh=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();this.bottle=new __WEBPACK_IMPORTED_MODULE_1_three__["k" /* ObjectLoader */]().parse(__webpack_require__(485));this.body=new __WEBPACK_IMPORTED_MODULE_2_cannon__["Body"]({mass:0.1});this.polymeric=new PolymericParticles();this.waves=new Waves();this.sputtering=new SputteringParticles();this.mesh.add(this.bottle);this.mesh.position.z=1;this.computeBoundingBox();var size=this.boundingBox.getSize();this.bottle.position.set(0,0,-this.boundingBox.min.z);this.offset=new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,0,-this.boundingBox.min.z);var _size=new __WEBPACK_IMPORTED_MODULE_2_cannon__["Vec3"]().copy(size.clone().multiplyScalar(0.5));this.body.addShape(new __WEBPACK_IMPORTED_MODULE_2_cannon__["Box"](_size));this.body.sleep();this.mesh.add(this.polymeric.particles);this.mesh.add(this.sputtering.mesh);this.mesh.add(this.waves.mesh);}_createClass(Bottle,[{key:'update',value:function update(){if(this.connected){this.mesh.position.copy(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */]().copy(this.body.position).sub(this.offset.clone().applyQuaternion(this.body.quaternion)));this.mesh.quaternion.copy(this.body.quaternion);}}},{key:'computeBoundingBox',value:function computeBoundingBox(){var boundingBox=function boundingBox(object){if(object instanceof __WEBPACK_IMPORTED_MODULE_1_three__["h" /* Mesh */]){var geometry=object.geometry;if(!geometry.boundingBox)geometry.computeBoundingBox();return geometry.boundingBox;}return new __WEBPACK_IMPORTED_MODULE_1_three__["b" /* Box3 */]();};var compute=function compute(object){var box=boundingBox(object);object.children.forEach(function(o){box.union(compute(o));});box.min.multiply(object.scale).applyEuler(object.rotation);box.max.multiply(object.scale).applyEuler(object.rotation);return box;};this.boundingBox=compute(this.mesh);return this.boundingBox;}},{key:'flip',value:function flip(distance,direction){var _this8=this;var displacement=direction.clone().multiplyScalar(distance);// 翻滚
var tumbleAxis=direction.clone().applyAxisAngle(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,0,1),Math.PI/2).normalize();// 移动
var _mesh$position$clone$=this.mesh.position.clone().add(displacement),x=_mesh$position$clone$.x,y=_mesh$position$clone$.y,move=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.position).to({x:x,y:y},FLIP_DURATION);var rotate=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween({angle:0,progress:0}).to({angle:Math.PI*2,progress:1},FLIP_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function(_ref){var angle=_ref.angle,progress=_ref.progress;var tumble=new __WEBPACK_IMPORTED_MODULE_1_three__["n" /* Quaternion */]().setFromAxisAngle(tumbleAxis,angle);_this8.bottle.quaternion.copy(tumble);}),up=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.position).to({z:1+FLIP_HEIGHT},FLIP_DURATION/2).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out),down=new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.position).to({z:1},FLIP_DURATION/2).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.In);up.chain(down);var audio=new Audio('jump.mp3');audio.play();return[move,up,rotate];}},{key:'fall',value:function fall(){this.body.position.copy(this.mesh.position.clone().setZ(BLOCK_HEIGHT+this.offset.z));this.body.quaternion.setFromAxisAngle(new __WEBPACK_IMPORTED_MODULE_2_cannon__["Vec3"](0,0,0),0);this.body.wakeUp();this.connected=true;var audio=new Audio('fall.mp3');audio.play();}},{key:'press',value:function press(){this.mesh.scale.set(1,1,1);this.mesh.position.z=1;return[new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.scale).to({x:BOTTLE_PRESSED_H,y:BOTTLE_PRESSED_H,z:BOTTLE_PRESSED_V},PRESS_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out),new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.position).to({z:BLOCK_PRESSED_H},PRESS_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out)];}},{key:'bounce',value:function bounce(){return[new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.mesh.scale).to({x:1,y:1,z:1},BOUNCE_DURATION).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Bounce.Out)];}}]);return Bottle;}();var Game=function(_THREE$EventDispatche){_inherits(Game,_THREE$EventDispatche);function Game(){_classCallCheck(this,Game);var _this9=_possibleConstructorReturn(this,(Game.__proto__||Object.getPrototypeOf(Game)).call(this));_this9.score=0;_this9.combo=0;_this9.isFirstTap=false;_this9.scroreText=new ScoreText(_this9.score);_this9.gameOverText=new CenterText('GAME OVER');_this9.addScoreText=new AddScoreText();_this9.gameOver=false;_this9.time=0;_this9.flipping=false;_this9.falling=false;_this9.pause=false;_this9.updates=[];_this9.world=new __WEBPACK_IMPORTED_MODULE_2_cannon__["World"]();_this9.renderer=new __WEBPACK_IMPORTED_MODULE_1_three__["u" /* WebGLRenderer */]({antialias:true,alpla:true});_this9.scene=new __WEBPACK_IMPORTED_MODULE_1_three__["p" /* Scene */]();_this9.camera=new __WEBPACK_IMPORTED_MODULE_1_three__["l" /* OrthographicCamera */](FRUSTUM_WIDTH/-2,FRUSTUM_WIDTH/2,FRUSTUM_HEIGHT/2,FRUSTUM_HEIGHT/-2,-40,1000);_this9.bottle=new Bottle();_this9.light=new __WEBPACK_IMPORTED_MODULE_1_three__["d" /* DirectionalLight */](0xffffff,0.28);_this9.blocks=[];_this9.steps=[];_this9.step=0;_this9.UI=new __WEBPACK_IMPORTED_MODULE_1_three__["g" /* Group */]();_this9.down$=__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.merge(__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.fromEvent(_this9.renderer.domElement,'mousedown'),__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.fromEvent(_this9.renderer.domElement,'touchstart')).do(function(e){e.preventDefault();if(!_this9.isFirstTap){timepass.userPlayStarted();_this9.isFirstTap=true;}});_this9.up$=__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.merge(__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.fromEvent(_this9.renderer.domElement,'mouseup'),__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.fromEvent(_this9.renderer.domElement,'touchend')).do(function(e){e.preventDefault();});_this9.update$=new __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Subject();_this9.update=function(time){if(_this9.pause)return;_this9.time=time;requestAnimationFrame(_this9.update);__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.update();_this9.world.step(1/60);_this9.bottle.update();_this9.update$.next();_this9.render();};_this9.resestRandom();//renderer
_this9.renderer.setSize(SCREEN_WIDTH,SCREEN_HEIGHT);// this.renderer.shadowMap.enabled = true;
// this.renderer.clearColor = 0xffffff;
// const canvas = this.renderer.domElement;
// canvas.style.height = '100%';
// canvas.style.width = '100%';
// body.appendChild(canvas);
//scene
_this9.scene.receiveShadow=true;//helper
// const gridHelper = new THREE.GridHelper(1000, 500);
// gridHelper.rotateX(Math.PI/-2)
// this.scene.add(gridHelper);
// this.scene.add(new THREE.AxisHelper(1000));
_this9.renderer.setPixelRatio(Math.min(2,window.devicePixelRatio));//lights
_this9.scene.add(new __WEBPACK_IMPORTED_MODULE_1_three__["a" /* AmbientLight */](0xffffff,0.8));_this9.light.position.set(2,-10,15);_this9.light.castShadow=true;// this.light.target = this.bottle.mesh;
_this9.scene.add(_this9.light);_this9.scene.add(_this9.light.target);var ground=new __WEBPACK_IMPORTED_MODULE_1_three__["h" /* Mesh */](new __WEBPACK_IMPORTED_MODULE_1_three__["m" /* PlaneGeometry */](FRUSTUM_WIDTH,FRUSTUM_HEIGHT),new __WEBPACK_IMPORTED_MODULE_1_three__["j" /* MeshLambertMaterial */]({color:0xfedcba}));ground.position.z=-20;_this9.camera.add(ground);_this9.camera.position.set(-5,-6,7);_this9.camera.castShadow=true;_this9.camera.receiveShadow=true;_this9.camera.up.set(0,0,1);_this9.camera.lookAt(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,0,0));_this9.UI.position.set(FRUSTUM_WIDTH/-2,FRUSTUM_HEIGHT/-2,0);_this9.camera.add(_this9.UI);_this9.UI.add(_this9.gameOverText.mesh);_this9.scroreText.mesh.visible=false;_this9.UI.add(_this9.scroreText.mesh);_this9.scene.add(_this9.camera);//graphics ground
//background
// const background = new THREE.Mesh(new THREE.IcosahedronGeometry(100), new THREE.MeshLambertMaterial({color: 0xeeeeee, side: THREE.BackSide}));
// this.scene.add(background);
_this9.world.gravity.set(0,0,-9.8);var _ground=new __WEBPACK_IMPORTED_MODULE_2_cannon__["Body"]({mass:0});_ground.addShape(new __WEBPACK_IMPORTED_MODULE_2_cannon__["Plane"](),new __WEBPACK_IMPORTED_MODULE_2_cannon__["Vec3"](0,0,0));_this9.world.addBody(_ground);_this9.add(_this9.bottle);_this9.restart(20);_this9.scroreText.mesh.visible=false;_this9.revive(20);var _flipped$=_this9.down$.filter(function(){return!_this9.falling&&!_this9.gameOver&&!_this9.flipping;}).map(function(){_this9.flipping=true;_this9.bottle.polymeric.particles.visible=true;_this9.bottle.sputtering.stop();return{time:_this9.time,tweens:[].concat(_toConsumableArray(_this9.currentBlock.press()),_toConsumableArray(_this9.bottle.press())).map(function(tween){return tween.start();})};}).debounce(function(){return _this9.up$;}).map(function(_ref2){var time=_ref2.time,tweens=_ref2.tweens;_this9.bottle.polymeric.particles.visible=false;tweens.forEach(function(tween){tween.stop();});var interval=Math.min(5000,_this9.time-time);_this9.steps.push([time,_this9.time]);[].concat(_toConsumableArray(_this9.currentBlock.bounce()),_toConsumableArray(_this9.bottle.bounce())).map(function(tween){return tween.start();});var direction=_this9.nextBlock.mesh.position.clone().sub(_this9.bottle.mesh.position.clone()).setZ(0).normalize();var distance=interval/1000*FLIP_DISTANCE_UNIT;var completes=_this9.bottle.flip(distance,direction).map(function(tween){return tween.start();}).map(function(tween){return __WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable.bindCallback(tween.onComplete.bind(tween))();});return completes;}).debounce(function(completes){var _Rx$Observable;return(_Rx$Observable=__WEBPACK_IMPORTED_MODULE_4_rxjs_Rx___default.a.Observable).merge.apply(_Rx$Observable,_toConsumableArray(completes)).last();}).do(function(){_this9.flipping=false;if(_this9.currentBlock.canHold(_this9.bottle.mesh.position)){_this9.combo=0;}else{if(!_this9.nextBlock.canHold(_this9.bottle.mesh.position)){//game over
_this9.bottle.fall();_this9.falling=true;//this.gameOverText.mesh.visible = true;
_this9.gameOver=true;setTimeout(function(){_this9.falling=false;_this9.scroreText.mesh.visible=false;_this9.dispatchEvent({type:'gameover'});},800);}else{if(_this9.nextBlock.hitCenter(_this9.bottle.mesh.position)){_this9.bottle.waves.wave(++_this9.combo);}else{_this9.combo=0;}_this9.scroreText.text=_this9.score+=1+Math.min(5,_this9.combo);_this9.bottle.sputtering.emit();_this9.createBlock();_this9.nextBlock.down();_this9.moveCamera();var len=_this9.steps.length;setTimeout(function(){if(_this9.steps.length===len&&!_this9.flipping&&!_this9.falling&&!_this9.gameOver){_this9.addScore(_this9.currentBlock.stayScore);}},2000);}}}).map(function(val,index){return index;});_flipped$.subscribe();return _this9;}_createClass(Game,[{key:'addScore',value:function addScore(score){if(score!==0){this.scroreText.text=this.score+=score;}}},{key:'createBlock',value:function createBlock(){var cube=this.randomCube();var scale=1-this.random()*this.difficulty*0.4;var block=new Block(cube,scale);if(this.blocks.length){var direction=this.random()>0.5?new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](1,0,0):new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,1,0);var last=this.blocks[this.blocks.length-1];var position=last.mesh.position.clone().add(direction.multiplyScalar(1.2+this.random()*(1.2+this.difficulty*1.2))).setZ(0);block.body.position.copy(position);block.mesh.position.copy(position);}else{block.body.position.set(0,0,0);block.mesh.position.set(0,0,0);}block.mesh.visible=false;this.blocks.push(block);this.add(block);return block;}},{key:'moveCamera',value:function moveCamera(){var animate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var position=this.blocks.length>=2?this.nextBlock.mesh.position.clone().setZ(0).add(this.currentBlock.mesh.position.clone().setZ(0)).divideScalar(2):new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */]();var cameraTarget=new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](-5,-6,8).add(position);if(animate){new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(this.camera.position).to(cameraTarget,500).easing(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Easing.Quadratic.Out).start();}else{this.camera.position.copy(cameraTarget);}this.addScoreText.mesh.lookAt(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](-5,-6,8));this.light.position.copy(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](2,-10,15).add(position));this.light.target.position.copy(position);}},{key:'add',value:function add(object){this.world.addBody(object.body);this.scene.add(object.mesh);}},{key:'remove',value:function remove(object){this.world.remove(object.body);this.scene.remove(object.mesh);}},{key:'start',value:function start(){this.pause=false;this.render();requestAnimationFrame(this.update);}},{key:'restart',value:function restart(){var _this10=this;var seed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Math.floor(Math.random()*0xffffff);this.resestRandom(seed);this.gameOver=false;this.scroreText.mesh.visible=true;this.gameOverText.mesh.visible=false;this.combo=0;this.score=0;this.scroreText.text=0;this.blocks.forEach(function(block){_this10.remove(block);});this.steps=[];this.blocks.length=0;this.createBlock().mesh.visible=true;this.createBlock().down();this.createBlock();this.bottle.mesh.position.set(0,0,1);this.bottle.mesh.quaternion.set(0,0,0,0);this.bottle.bottle.quaternion.setFromAxisAngle(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,0,1),new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](1,0,0).angleTo(this.nextBlock.mesh.position.clone().sub(this.currentBlock.mesh.position).setZ(0).normalize()));this.bottle.connected=false;this.moveCamera(false);this.isFirstTap=false;}},{key:'revive',value:function revive(){var _this11=this;var seed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Math.floor(Math.random()*0xffffff);this.resestRandom(seed);this.gameOver=false;this.scroreText.mesh.visible=true;this.gameOverText.mesh.visible=false;this.combo=0;this.blocks.forEach(function(block){_this11.remove(block);});this.steps=[];this.blocks.length=0;this.createBlock().mesh.visible=true;this.createBlock().down();this.createBlock();this.bottle.mesh.position.set(0,0,1);this.bottle.mesh.quaternion.set(0,0,0,0);this.bottle.bottle.quaternion.setFromAxisAngle(new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](0,0,1),new __WEBPACK_IMPORTED_MODULE_1_three__["t" /* Vector3 */](1,0,0).angleTo(this.nextBlock.mesh.position.clone().sub(this.currentBlock.mesh.position).setZ(0).normalize()));this.bottle.connected=false;this.moveCamera(false);this.isFirstTap=false;}},{key:'render',value:function render(){this.renderer.render(this.scene,this.camera);}},{key:'resestRandom',value:function resestRandom(seed){var twister=new __WEBPACK_IMPORTED_MODULE_5_mersenne_twister___default.a(seed);this.random=function(){var value=twister.random();return value;};}},{key:'randomCube',value:function randomCube(){var sum=0;cubes.forEach(function(i){sum+=i.prob;});var random=Math.floor(this.random()*(sum+1));var index=0;for(var i=0;i<cubes.length;++i){random-=cubes[i].prob;if(random<=0){index=i;break;}}return cubes[index];}},{key:'currentBlock',get:function get(){return this.blocks[this.blocks.length-3];}},{key:'nextBlock',get:function get(){return this.blocks[this.blocks.length-2];}},{key:'towardsBlock',get:function get(){return this.blocks[this.blocks.length-1];}},{key:'difficulty',get:function get(){var v=1-Math.pow(0.5,this.steps.length/28);return v;}}]);return Game;}(__WEBPACK_IMPORTED_MODULE_1_three__["e" /* EventDispatcher */]);

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WebGLRenderTargetCube */
/* unused harmony export WebGLRenderTarget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return WebGLRenderer; });
/* unused harmony export ShaderLib */
/* unused harmony export UniformsLib */
/* unused harmony export UniformsUtils */
/* unused harmony export ShaderChunk */
/* unused harmony export FogExp2 */
/* unused harmony export Fog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Scene; });
/* unused harmony export LensFlare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Sprite; });
/* unused harmony export LOD */
/* unused harmony export SkinnedMesh */
/* unused harmony export Skeleton */
/* unused harmony export Bone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Mesh; });
/* unused harmony export LineSegments */
/* unused harmony export LineLoop */
/* unused harmony export Line */
/* unused harmony export Points */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Group; });
/* unused harmony export VideoTexture */
/* unused harmony export DataTexture */
/* unused harmony export CompressedTexture */
/* unused harmony export CubeTexture */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CanvasTexture; });
/* unused harmony export DepthTexture */
/* unused harmony export Texture */
/* unused harmony export CompressedTextureLoader */
/* unused harmony export DataTextureLoader */
/* unused harmony export CubeTextureLoader */
/* unused harmony export TextureLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ObjectLoader; });
/* unused harmony export MaterialLoader */
/* unused harmony export BufferGeometryLoader */
/* unused harmony export DefaultLoadingManager */
/* unused harmony export LoadingManager */
/* unused harmony export JSONLoader */
/* unused harmony export ImageLoader */
/* unused harmony export ImageBitmapLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FontLoader; });
/* unused harmony export FileLoader */
/* unused harmony export Loader */
/* unused harmony export LoaderUtils */
/* unused harmony export Cache */
/* unused harmony export AudioLoader */
/* unused harmony export SpotLightShadow */
/* unused harmony export SpotLight */
/* unused harmony export PointLight */
/* unused harmony export RectAreaLight */
/* unused harmony export HemisphereLight */
/* unused harmony export DirectionalLightShadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DirectionalLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmbientLight; });
/* unused harmony export LightShadow */
/* unused harmony export Light */
/* unused harmony export StereoCamera */
/* unused harmony export PerspectiveCamera */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OrthographicCamera; });
/* unused harmony export CubeCamera */
/* unused harmony export ArrayCamera */
/* unused harmony export Camera */
/* unused harmony export AudioListener */
/* unused harmony export PositionalAudio */
/* unused harmony export AudioContext */
/* unused harmony export AudioAnalyser */
/* unused harmony export Audio */
/* unused harmony export VectorKeyframeTrack */
/* unused harmony export StringKeyframeTrack */
/* unused harmony export QuaternionKeyframeTrack */
/* unused harmony export NumberKeyframeTrack */
/* unused harmony export ColorKeyframeTrack */
/* unused harmony export BooleanKeyframeTrack */
/* unused harmony export PropertyMixer */
/* unused harmony export PropertyBinding */
/* unused harmony export KeyframeTrack */
/* unused harmony export AnimationUtils */
/* unused harmony export AnimationObjectGroup */
/* unused harmony export AnimationMixer */
/* unused harmony export AnimationClip */
/* unused harmony export Uniform */
/* unused harmony export InstancedBufferGeometry */
/* unused harmony export BufferGeometry */
/* unused harmony export Geometry */
/* unused harmony export InterleavedBufferAttribute */
/* unused harmony export InstancedInterleavedBuffer */
/* unused harmony export InterleavedBuffer */
/* unused harmony export InstancedBufferAttribute */
/* unused harmony export Face3 */
/* unused harmony export Object3D */
/* unused harmony export Raycaster */
/* unused harmony export Layers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EventDispatcher; });
/* unused harmony export Clock */
/* unused harmony export QuaternionLinearInterpolant */
/* unused harmony export LinearInterpolant */
/* unused harmony export DiscreteInterpolant */
/* unused harmony export CubicInterpolant */
/* unused harmony export Interpolant */
/* unused harmony export Triangle */
/* unused harmony export Math */
/* unused harmony export Spherical */
/* unused harmony export Cylindrical */
/* unused harmony export Plane */
/* unused harmony export Frustum */
/* unused harmony export Sphere */
/* unused harmony export Ray */
/* unused harmony export Matrix4 */
/* unused harmony export Matrix3 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Box3; });
/* unused harmony export Box2 */
/* unused harmony export Line3 */
/* unused harmony export Euler */
/* unused harmony export Vector4 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Vector3; });
/* unused harmony export Vector2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Quaternion; });
/* unused harmony export Color */
/* unused harmony export ImmediateRenderObject */
/* unused harmony export VertexNormalsHelper */
/* unused harmony export SpotLightHelper */
/* unused harmony export SkeletonHelper */
/* unused harmony export PointLightHelper */
/* unused harmony export RectAreaLightHelper */
/* unused harmony export HemisphereLightHelper */
/* unused harmony export GridHelper */
/* unused harmony export PolarGridHelper */
/* unused harmony export FaceNormalsHelper */
/* unused harmony export DirectionalLightHelper */
/* unused harmony export CameraHelper */
/* unused harmony export BoxHelper */
/* unused harmony export Box3Helper */
/* unused harmony export PlaneHelper */
/* unused harmony export ArrowHelper */
/* unused harmony export AxesHelper */
/* unused harmony export Shape */
/* unused harmony export Path */
/* unused harmony export ShapePath */
/* unused harmony export Font */
/* unused harmony export CurvePath */
/* unused harmony export Curve */
/* unused harmony export ShapeUtils */
/* unused harmony export SceneUtils */
/* unused harmony export WebGLUtils */
/* unused harmony export WireframeGeometry */
/* unused harmony export ParametricGeometry */
/* unused harmony export ParametricBufferGeometry */
/* unused harmony export TetrahedronGeometry */
/* unused harmony export TetrahedronBufferGeometry */
/* unused harmony export OctahedronGeometry */
/* unused harmony export OctahedronBufferGeometry */
/* unused harmony export IcosahedronGeometry */
/* unused harmony export IcosahedronBufferGeometry */
/* unused harmony export DodecahedronGeometry */
/* unused harmony export DodecahedronBufferGeometry */
/* unused harmony export PolyhedronGeometry */
/* unused harmony export PolyhedronBufferGeometry */
/* unused harmony export TubeGeometry */
/* unused harmony export TubeBufferGeometry */
/* unused harmony export TorusKnotGeometry */
/* unused harmony export TorusKnotBufferGeometry */
/* unused harmony export TorusGeometry */
/* unused harmony export TorusBufferGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TextGeometry; });
/* unused harmony export TextBufferGeometry */
/* unused harmony export SphereGeometry */
/* unused harmony export SphereBufferGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RingGeometry; });
/* unused harmony export RingBufferGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PlaneGeometry; });
/* unused harmony export PlaneBufferGeometry */
/* unused harmony export LatheGeometry */
/* unused harmony export LatheBufferGeometry */
/* unused harmony export ShapeGeometry */
/* unused harmony export ShapeBufferGeometry */
/* unused harmony export ExtrudeGeometry */
/* unused harmony export ExtrudeBufferGeometry */
/* unused harmony export EdgesGeometry */
/* unused harmony export ConeGeometry */
/* unused harmony export ConeBufferGeometry */
/* unused harmony export CylinderGeometry */
/* unused harmony export CylinderBufferGeometry */
/* unused harmony export CircleGeometry */
/* unused harmony export CircleBufferGeometry */
/* unused harmony export BoxGeometry */
/* unused harmony export BoxBufferGeometry */
/* unused harmony export ShadowMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SpriteMaterial; });
/* unused harmony export RawShaderMaterial */
/* unused harmony export ShaderMaterial */
/* unused harmony export PointsMaterial */
/* unused harmony export MeshPhysicalMaterial */
/* unused harmony export MeshStandardMaterial */
/* unused harmony export MeshPhongMaterial */
/* unused harmony export MeshToonMaterial */
/* unused harmony export MeshNormalMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MeshLambertMaterial; });
/* unused harmony export MeshDepthMaterial */
/* unused harmony export MeshDistanceMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MeshBasicMaterial; });
/* unused harmony export LineDashedMaterial */
/* unused harmony export LineBasicMaterial */
/* unused harmony export Material */
/* unused harmony export Float64BufferAttribute */
/* unused harmony export Float32BufferAttribute */
/* unused harmony export Uint32BufferAttribute */
/* unused harmony export Int32BufferAttribute */
/* unused harmony export Uint16BufferAttribute */
/* unused harmony export Int16BufferAttribute */
/* unused harmony export Uint8ClampedBufferAttribute */
/* unused harmony export Uint8BufferAttribute */
/* unused harmony export Int8BufferAttribute */
/* unused harmony export BufferAttribute */
/* unused harmony export ArcCurve */
/* unused harmony export CatmullRomCurve3 */
/* unused harmony export CubicBezierCurve */
/* unused harmony export CubicBezierCurve3 */
/* unused harmony export EllipseCurve */
/* unused harmony export LineCurve */
/* unused harmony export LineCurve3 */
/* unused harmony export QuadraticBezierCurve */
/* unused harmony export QuadraticBezierCurve3 */
/* unused harmony export SplineCurve */
/* unused harmony export REVISION */
/* unused harmony export MOUSE */
/* unused harmony export CullFaceNone */
/* unused harmony export CullFaceBack */
/* unused harmony export CullFaceFront */
/* unused harmony export CullFaceFrontBack */
/* unused harmony export FrontFaceDirectionCW */
/* unused harmony export FrontFaceDirectionCCW */
/* unused harmony export BasicShadowMap */
/* unused harmony export PCFShadowMap */
/* unused harmony export PCFSoftShadowMap */
/* unused harmony export FrontSide */
/* unused harmony export BackSide */
/* unused harmony export DoubleSide */
/* unused harmony export FlatShading */
/* unused harmony export SmoothShading */
/* unused harmony export NoColors */
/* unused harmony export FaceColors */
/* unused harmony export VertexColors */
/* unused harmony export NoBlending */
/* unused harmony export NormalBlending */
/* unused harmony export AdditiveBlending */
/* unused harmony export SubtractiveBlending */
/* unused harmony export MultiplyBlending */
/* unused harmony export CustomBlending */
/* unused harmony export AddEquation */
/* unused harmony export SubtractEquation */
/* unused harmony export ReverseSubtractEquation */
/* unused harmony export MinEquation */
/* unused harmony export MaxEquation */
/* unused harmony export ZeroFactor */
/* unused harmony export OneFactor */
/* unused harmony export SrcColorFactor */
/* unused harmony export OneMinusSrcColorFactor */
/* unused harmony export SrcAlphaFactor */
/* unused harmony export OneMinusSrcAlphaFactor */
/* unused harmony export DstAlphaFactor */
/* unused harmony export OneMinusDstAlphaFactor */
/* unused harmony export DstColorFactor */
/* unused harmony export OneMinusDstColorFactor */
/* unused harmony export SrcAlphaSaturateFactor */
/* unused harmony export NeverDepth */
/* unused harmony export AlwaysDepth */
/* unused harmony export LessDepth */
/* unused harmony export LessEqualDepth */
/* unused harmony export EqualDepth */
/* unused harmony export GreaterEqualDepth */
/* unused harmony export GreaterDepth */
/* unused harmony export NotEqualDepth */
/* unused harmony export MultiplyOperation */
/* unused harmony export MixOperation */
/* unused harmony export AddOperation */
/* unused harmony export NoToneMapping */
/* unused harmony export LinearToneMapping */
/* unused harmony export ReinhardToneMapping */
/* unused harmony export Uncharted2ToneMapping */
/* unused harmony export CineonToneMapping */
/* unused harmony export UVMapping */
/* unused harmony export CubeReflectionMapping */
/* unused harmony export CubeRefractionMapping */
/* unused harmony export EquirectangularReflectionMapping */
/* unused harmony export EquirectangularRefractionMapping */
/* unused harmony export SphericalReflectionMapping */
/* unused harmony export CubeUVReflectionMapping */
/* unused harmony export CubeUVRefractionMapping */
/* unused harmony export RepeatWrapping */
/* unused harmony export ClampToEdgeWrapping */
/* unused harmony export MirroredRepeatWrapping */
/* unused harmony export NearestFilter */
/* unused harmony export NearestMipMapNearestFilter */
/* unused harmony export NearestMipMapLinearFilter */
/* unused harmony export LinearFilter */
/* unused harmony export LinearMipMapNearestFilter */
/* unused harmony export LinearMipMapLinearFilter */
/* unused harmony export UnsignedByteType */
/* unused harmony export ByteType */
/* unused harmony export ShortType */
/* unused harmony export UnsignedShortType */
/* unused harmony export IntType */
/* unused harmony export UnsignedIntType */
/* unused harmony export FloatType */
/* unused harmony export HalfFloatType */
/* unused harmony export UnsignedShort4444Type */
/* unused harmony export UnsignedShort5551Type */
/* unused harmony export UnsignedShort565Type */
/* unused harmony export UnsignedInt248Type */
/* unused harmony export AlphaFormat */
/* unused harmony export RGBFormat */
/* unused harmony export RGBAFormat */
/* unused harmony export LuminanceFormat */
/* unused harmony export LuminanceAlphaFormat */
/* unused harmony export RGBEFormat */
/* unused harmony export DepthFormat */
/* unused harmony export DepthStencilFormat */
/* unused harmony export RGB_S3TC_DXT1_Format */
/* unused harmony export RGBA_S3TC_DXT1_Format */
/* unused harmony export RGBA_S3TC_DXT3_Format */
/* unused harmony export RGBA_S3TC_DXT5_Format */
/* unused harmony export RGB_PVRTC_4BPPV1_Format */
/* unused harmony export RGB_PVRTC_2BPPV1_Format */
/* unused harmony export RGBA_PVRTC_4BPPV1_Format */
/* unused harmony export RGBA_PVRTC_2BPPV1_Format */
/* unused harmony export RGB_ETC1_Format */
/* unused harmony export LoopOnce */
/* unused harmony export LoopRepeat */
/* unused harmony export LoopPingPong */
/* unused harmony export InterpolateDiscrete */
/* unused harmony export InterpolateLinear */
/* unused harmony export InterpolateSmooth */
/* unused harmony export ZeroCurvatureEnding */
/* unused harmony export ZeroSlopeEnding */
/* unused harmony export WrapAroundEnding */
/* unused harmony export TrianglesDrawMode */
/* unused harmony export TriangleStripDrawMode */
/* unused harmony export TriangleFanDrawMode */
/* unused harmony export LinearEncoding */
/* unused harmony export sRGBEncoding */
/* unused harmony export GammaEncoding */
/* unused harmony export RGBEEncoding */
/* unused harmony export LogLuvEncoding */
/* unused harmony export RGBM7Encoding */
/* unused harmony export RGBM16Encoding */
/* unused harmony export RGBDEncoding */
/* unused harmony export BasicDepthPacking */
/* unused harmony export RGBADepthPacking */
/* unused harmony export CubeGeometry */
/* unused harmony export Face4 */
/* unused harmony export LineStrip */
/* unused harmony export LinePieces */
/* unused harmony export MeshFaceMaterial */
/* unused harmony export MultiMaterial */
/* unused harmony export PointCloud */
/* unused harmony export Particle */
/* unused harmony export ParticleSystem */
/* unused harmony export PointCloudMaterial */
/* unused harmony export ParticleBasicMaterial */
/* unused harmony export ParticleSystemMaterial */
/* unused harmony export Vertex */
/* unused harmony export DynamicBufferAttribute */
/* unused harmony export Int8Attribute */
/* unused harmony export Uint8Attribute */
/* unused harmony export Uint8ClampedAttribute */
/* unused harmony export Int16Attribute */
/* unused harmony export Uint16Attribute */
/* unused harmony export Int32Attribute */
/* unused harmony export Uint32Attribute */
/* unused harmony export Float32Attribute */
/* unused harmony export Float64Attribute */
/* unused harmony export ClosedSplineCurve3 */
/* unused harmony export SplineCurve3 */
/* unused harmony export Spline */
/* unused harmony export AxisHelper */
/* unused harmony export BoundingBoxHelper */
/* unused harmony export EdgesHelper */
/* unused harmony export WireframeHelper */
/* unused harmony export XHRLoader */
/* unused harmony export BinaryTextureLoader */
/* unused harmony export GeometryUtils */
/* unused harmony export ImageUtils */
/* unused harmony export Projector */
/* unused harmony export CanvasRenderer */
// Polyfills

if ( Number.EPSILON === undefined ) {

	Number.EPSILON = Math.pow( 2, - 52 );

}

if ( Number.isInteger === undefined ) {

	// Missing in IE
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

	Number.isInteger = function ( value ) {

		return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;

	};

}

//

if ( Math.sign === undefined ) {

	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

	Math.sign = function ( x ) {

		return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;

	};

}

if ( 'name' in Function.prototype === false ) {

	// Missing in IE
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name

	Object.defineProperty( Function.prototype, 'name', {

		get: function () {

			return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];

		}

	} );

}

if ( Object.assign === undefined ) {

	// Missing in IE
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

	( function () {

		Object.assign = function ( target ) {

			if ( target === undefined || target === null ) {

				throw new TypeError( 'Cannot convert undefined or null to object' );

			}

			var output = Object( target );

			for ( var index = 1; index < arguments.length; index ++ ) {

				var source = arguments[ index ];

				if ( source !== undefined && source !== null ) {

					for ( var nextKey in source ) {

						if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {

							output[ nextKey ] = source[ nextKey ];

						}

					}

				}

			}

			return output;

		};

	} )();

}

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

function EventDispatcher() {}

Object.assign( EventDispatcher.prototype, {

	addEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		var listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	},

	hasEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) return false;

		var listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	},

	removeEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) return;

		var listeners = this._listeners;
		var listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			var index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	},

	dispatchEvent: function ( event ) {

		if ( this._listeners === undefined ) return;

		var listeners = this._listeners;
		var listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			var array = listenerArray.slice( 0 );

			for ( var i = 0, l = array.length; i < l; i ++ ) {

				array[ i ].call( this, event );

			}

		}

	}

} );

var REVISION = '89';
var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
var CullFaceNone = 0;
var CullFaceBack = 1;
var CullFaceFront = 2;
var CullFaceFrontBack = 3;
var FrontFaceDirectionCW = 0;
var FrontFaceDirectionCCW = 1;
var BasicShadowMap = 0;
var PCFShadowMap = 1;
var PCFSoftShadowMap = 2;
var FrontSide = 0;
var BackSide = 1;
var DoubleSide = 2;
var FlatShading = 1;
var SmoothShading = 2;
var NoColors = 0;
var FaceColors = 1;
var VertexColors = 2;
var NoBlending = 0;
var NormalBlending = 1;
var AdditiveBlending = 2;
var SubtractiveBlending = 3;
var MultiplyBlending = 4;
var CustomBlending = 5;
var AddEquation = 100;
var SubtractEquation = 101;
var ReverseSubtractEquation = 102;
var MinEquation = 103;
var MaxEquation = 104;
var ZeroFactor = 200;
var OneFactor = 201;
var SrcColorFactor = 202;
var OneMinusSrcColorFactor = 203;
var SrcAlphaFactor = 204;
var OneMinusSrcAlphaFactor = 205;
var DstAlphaFactor = 206;
var OneMinusDstAlphaFactor = 207;
var DstColorFactor = 208;
var OneMinusDstColorFactor = 209;
var SrcAlphaSaturateFactor = 210;
var NeverDepth = 0;
var AlwaysDepth = 1;
var LessDepth = 2;
var LessEqualDepth = 3;
var EqualDepth = 4;
var GreaterEqualDepth = 5;
var GreaterDepth = 6;
var NotEqualDepth = 7;
var MultiplyOperation = 0;
var MixOperation = 1;
var AddOperation = 2;
var NoToneMapping = 0;
var LinearToneMapping = 1;
var ReinhardToneMapping = 2;
var Uncharted2ToneMapping = 3;
var CineonToneMapping = 4;
var UVMapping = 300;
var CubeReflectionMapping = 301;
var CubeRefractionMapping = 302;
var EquirectangularReflectionMapping = 303;
var EquirectangularRefractionMapping = 304;
var SphericalReflectionMapping = 305;
var CubeUVReflectionMapping = 306;
var CubeUVRefractionMapping = 307;
var RepeatWrapping = 1000;
var ClampToEdgeWrapping = 1001;
var MirroredRepeatWrapping = 1002;
var NearestFilter = 1003;
var NearestMipMapNearestFilter = 1004;
var NearestMipMapLinearFilter = 1005;
var LinearFilter = 1006;
var LinearMipMapNearestFilter = 1007;
var LinearMipMapLinearFilter = 1008;
var UnsignedByteType = 1009;
var ByteType = 1010;
var ShortType = 1011;
var UnsignedShortType = 1012;
var IntType = 1013;
var UnsignedIntType = 1014;
var FloatType = 1015;
var HalfFloatType = 1016;
var UnsignedShort4444Type = 1017;
var UnsignedShort5551Type = 1018;
var UnsignedShort565Type = 1019;
var UnsignedInt248Type = 1020;
var AlphaFormat = 1021;
var RGBFormat = 1022;
var RGBAFormat = 1023;
var LuminanceFormat = 1024;
var LuminanceAlphaFormat = 1025;
var RGBEFormat = RGBAFormat;
var DepthFormat = 1026;
var DepthStencilFormat = 1027;
var RGB_S3TC_DXT1_Format = 2001;
var RGBA_S3TC_DXT1_Format = 2002;
var RGBA_S3TC_DXT3_Format = 2003;
var RGBA_S3TC_DXT5_Format = 2004;
var RGB_PVRTC_4BPPV1_Format = 2100;
var RGB_PVRTC_2BPPV1_Format = 2101;
var RGBA_PVRTC_4BPPV1_Format = 2102;
var RGBA_PVRTC_2BPPV1_Format = 2103;
var RGB_ETC1_Format = 2151;
var LoopOnce = 2200;
var LoopRepeat = 2201;
var LoopPingPong = 2202;
var InterpolateDiscrete = 2300;
var InterpolateLinear = 2301;
var InterpolateSmooth = 2302;
var ZeroCurvatureEnding = 2400;
var ZeroSlopeEnding = 2401;
var WrapAroundEnding = 2402;
var TrianglesDrawMode = 0;
var TriangleStripDrawMode = 1;
var TriangleFanDrawMode = 2;
var LinearEncoding = 3000;
var sRGBEncoding = 3001;
var GammaEncoding = 3007;
var RGBEEncoding = 3002;
var LogLuvEncoding = 3003;
var RGBM7Encoding = 3004;
var RGBM16Encoding = 3005;
var RGBDEncoding = 3006;
var BasicDepthPacking = 3200;
var RGBADepthPacking = 3201;

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

var _Math = {

	DEG2RAD: Math.PI / 180,
	RAD2DEG: 180 / Math.PI,

	generateUUID: ( function () {

		// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136

		var lut = [];

		for ( var i = 0; i < 256; i ++ ) {

			lut[ i ] = ( i < 16 ? '0' : '' ) + ( i ).toString( 16 ).toUpperCase();

		}

		return function () {

			var d0 = Math.random() * 0xffffffff | 0;
			var d1 = Math.random() * 0xffffffff | 0;
			var d2 = Math.random() * 0xffffffff | 0;
			var d3 = Math.random() * 0xffffffff | 0;
			return lut[ d0 & 0xff ] + lut[ d0 >> 8 & 0xff ] + lut[ d0 >> 16 & 0xff ] + lut[ d0 >> 24 & 0xff ] + '-' +
				lut[ d1 & 0xff ] + lut[ d1 >> 8 & 0xff ] + '-' + lut[ d1 >> 16 & 0x0f | 0x40 ] + lut[ d1 >> 24 & 0xff ] + '-' +
				lut[ d2 & 0x3f | 0x80 ] + lut[ d2 >> 8 & 0xff ] + '-' + lut[ d2 >> 16 & 0xff ] + lut[ d2 >> 24 & 0xff ] +
				lut[ d3 & 0xff ] + lut[ d3 >> 8 & 0xff ] + lut[ d3 >> 16 & 0xff ] + lut[ d3 >> 24 & 0xff ];

		};

	} )(),

	clamp: function ( value, min, max ) {

		return Math.max( min, Math.min( max, value ) );

	},

	// compute euclidian modulo of m % n
	// https://en.wikipedia.org/wiki/Modulo_operation

	euclideanModulo: function ( n, m ) {

		return ( ( n % m ) + m ) % m;

	},

	// Linear mapping from range <a1, a2> to range <b1, b2>

	mapLinear: function ( x, a1, a2, b1, b2 ) {

		return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

	},

	// https://en.wikipedia.org/wiki/Linear_interpolation

	lerp: function ( x, y, t ) {

		return ( 1 - t ) * x + t * y;

	},

	// http://en.wikipedia.org/wiki/Smoothstep

	smoothstep: function ( x, min, max ) {

		if ( x <= min ) return 0;
		if ( x >= max ) return 1;

		x = ( x - min ) / ( max - min );

		return x * x * ( 3 - 2 * x );

	},

	smootherstep: function ( x, min, max ) {

		if ( x <= min ) return 0;
		if ( x >= max ) return 1;

		x = ( x - min ) / ( max - min );

		return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

	},

	// Random integer from <low, high> interval

	randInt: function ( low, high ) {

		return low + Math.floor( Math.random() * ( high - low + 1 ) );

	},

	// Random float from <low, high> interval

	randFloat: function ( low, high ) {

		return low + Math.random() * ( high - low );

	},

	// Random float from <-range/2, range/2> interval

	randFloatSpread: function ( range ) {

		return range * ( 0.5 - Math.random() );

	},

	degToRad: function ( degrees ) {

		return degrees * _Math.DEG2RAD;

	},

	radToDeg: function ( radians ) {

		return radians * _Math.RAD2DEG;

	},

	isPowerOfTwo: function ( value ) {

		return ( value & ( value - 1 ) ) === 0 && value !== 0;

	},

	ceilPowerOfTwo: function ( value ) {

		return Math.pow( 2, Math.ceil( Math.log( value ) / Math.LN2 ) );

	},

	floorPowerOfTwo: function ( value ) {

		return Math.pow( 2, Math.floor( Math.log( value ) / Math.LN2 ) );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author philogb / http://blog.thejit.org/
 * @author egraether / http://egraether.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

function Vector2( x, y ) {

	this.x = x || 0;
	this.y = y || 0;

}

Object.defineProperties( Vector2.prototype, {

	"width": {

		get: function () {

			return this.x;

		},

		set: function ( value ) {

			this.x = value;

		}

	},

	"height": {

		get: function () {

			return this.y;

		},

		set: function ( value ) {

			this.y = value;

		}

	}

} );

Object.assign( Vector2.prototype, {

	isVector2: true,

	set: function ( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	},

	multiply: function ( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		this.x *= scalar;
		this.y *= scalar;

		return this;

	},

	divide: function ( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	applyMatrix3: function ( m ) {

		var x = this.x, y = this.y;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];

		return this;

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	},

	clamp: function ( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	},

	clampScalar: function () {

		var min = new Vector2();
		var max = new Vector2();

		return function clampScalar( minVal, maxVal ) {

			min.set( minVal, minVal );
			max.set( maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	clampLength: function ( min, max ) {

		var length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	},

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y;

	},

	lengthSq: function () {

		return this.x * this.x + this.y * this.y;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	},

	manhattanLength: function () {

		return Math.abs( this.x ) + Math.abs( this.y );

	},

	normalize: function () {

		return this.divideScalar( this.length() || 1 );

	},

	angle: function () {

		// computes the angle in radians with respect to the positive x-axis

		var angle = Math.atan2( this.y, this.x );

		if ( angle < 0 ) angle += 2 * Math.PI;

		return angle;

	},

	distanceTo: function ( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	},

	distanceToSquared: function ( v ) {

		var dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	},

	manhattanDistanceTo: function ( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	},

	setLength: function ( length ) {

		return this.normalize().multiplyScalar( length );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	},

	fromBufferAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector2: offset has been removed from .fromBufferAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	},

	rotateAround: function ( center, angle ) {

		var c = Math.cos( angle ), s = Math.sin( angle );

		var x = this.x - center.x;
		var y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author jordi_ros / http://plattsoft.com
 * @author D1plo1d / http://github.com/D1plo1d
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author timknip / http://www.floorplanner.com/
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 */

function Matrix4() {

	this.elements = [

		1, 0, 0, 0,
		0, 1, 0, 0,
		0, 0, 1, 0,
		0, 0, 0, 1

	];

	if ( arguments.length > 0 ) {

		console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );

	}

}

Object.assign( Matrix4.prototype, {

	isMatrix4: true,

	set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		var te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	},

	identity: function () {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	},

	clone: function () {

		return new Matrix4().fromArray( this.elements );

	},

	copy: function ( m ) {

		var te = this.elements;
		var me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
		te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
		te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
		te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

		return this;

	},

	copyPosition: function ( m ) {

		var te = this.elements, me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	},

	extractBasis: function ( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	},

	makeBasis: function ( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		return this;

	},

	extractRotation: function () {

		var v1 = new Vector3();

		return function extractRotation( m ) {

			var te = this.elements;
			var me = m.elements;

			var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
			var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
			var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();

			te[ 0 ] = me[ 0 ] * scaleX;
			te[ 1 ] = me[ 1 ] * scaleX;
			te[ 2 ] = me[ 2 ] * scaleX;

			te[ 4 ] = me[ 4 ] * scaleY;
			te[ 5 ] = me[ 5 ] * scaleY;
			te[ 6 ] = me[ 6 ] * scaleY;

			te[ 8 ] = me[ 8 ] * scaleZ;
			te[ 9 ] = me[ 9 ] * scaleZ;
			te[ 10 ] = me[ 10 ] * scaleZ;

			return this;

		};

	}(),

	makeRotationFromEuler: function ( euler ) {

		if ( ! ( euler && euler.isEuler ) ) {

			console.error( 'THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );

		}

		var te = this.elements;

		var x = euler.x, y = euler.y, z = euler.z;
		var a = Math.cos( x ), b = Math.sin( x );
		var c = Math.cos( y ), d = Math.sin( y );
		var e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			var ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			var ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			var ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			var ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// last column
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// bottom row
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	},

	makeRotationFromQuaternion: function ( q ) {

		var te = this.elements;

		var x = q._x, y = q._y, z = q._z, w = q._w;
		var x2 = x + x, y2 = y + y, z2 = z + z;
		var xx = x * x2, xy = x * y2, xz = x * z2;
		var yy = y * y2, yz = y * z2, zz = z * z2;
		var wx = w * x2, wy = w * y2, wz = w * z2;

		te[ 0 ] = 1 - ( yy + zz );
		te[ 4 ] = xy - wz;
		te[ 8 ] = xz + wy;

		te[ 1 ] = xy + wz;
		te[ 5 ] = 1 - ( xx + zz );
		te[ 9 ] = yz - wx;

		te[ 2 ] = xz - wy;
		te[ 6 ] = yz + wx;
		te[ 10 ] = 1 - ( xx + yy );

		// last column
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// bottom row
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	},

	lookAt: function () {

		var x = new Vector3();
		var y = new Vector3();
		var z = new Vector3();

		return function lookAt( eye, target, up ) {

			var te = this.elements;

			z.subVectors( eye, target );

			if ( z.lengthSq() === 0 ) {

				// eye and target are in the same position

				z.z = 1;

			}

			z.normalize();
			x.crossVectors( up, z );

			if ( x.lengthSq() === 0 ) {

				// up and z are parallel

				if ( Math.abs( up.z ) === 1 ) {

					z.x += 0.0001;

				} else {

					z.z += 0.0001;

				}

				z.normalize();
				x.crossVectors( up, z );

			}

			x.normalize();
			y.crossVectors( z, x );

			te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
			te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
			te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;

			return this;

		};

	}(),

	multiply: function ( m, n ) {

		if ( n !== undefined ) {

			console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
			return this.multiplyMatrices( m, n );

		}

		return this.multiplyMatrices( this, m );

	},

	premultiply: function ( m ) {

		return this.multiplyMatrices( m, this );

	},

	multiplyMatrices: function ( a, b ) {

		var ae = a.elements;
		var be = b.elements;
		var te = this.elements;

		var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	},

	multiplyScalar: function ( s ) {

		var te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	},

	applyToBufferAttribute: function () {

		var v1 = new Vector3();

		return function applyToBufferAttribute( attribute ) {

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				v1.x = attribute.getX( i );
				v1.y = attribute.getY( i );
				v1.z = attribute.getZ( i );

				v1.applyMatrix4( this );

				attribute.setXYZ( i, v1.x, v1.y, v1.z );

			}

			return attribute;

		};

	}(),

	determinant: function () {

		var te = this.elements;

		var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	},

	transpose: function () {

		var te = this.elements;
		var tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	},

	setPosition: function ( v ) {

		var te = this.elements;

		te[ 12 ] = v.x;
		te[ 13 ] = v.y;
		te[ 14 ] = v.z;

		return this;

	},

	getInverse: function ( m, throwOnDegenerate ) {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		var te = this.elements,
			me = m.elements,

			n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
			n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
			n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
			n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) {

			var msg = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";

			if ( throwOnDegenerate === true ) {

				throw new Error( msg );

			} else {

				console.warn( msg );

			}

			return this.identity();

		}

		var detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	},

	scale: function ( v ) {

		var te = this.elements;
		var x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	},

	getMaxScaleOnAxis: function () {

		var te = this.elements;

		var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	},

	makeTranslation: function ( x, y, z ) {

		this.set(

			1, 0, 0, x,
			0, 1, 0, y,
			0, 0, 1, z,
			0, 0, 0, 1

		);

		return this;

	},

	makeRotationX: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0, 0, 0,
			0, c, - s, 0,
			0, s, c, 0,
			0, 0, 0, 1

		);

		return this;

	},

	makeRotationY: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	},

	makeRotationZ: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s, c, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	},

	makeRotationAxis: function ( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		var c = Math.cos( angle );
		var s = Math.sin( angle );
		var t = 1 - c;
		var x = axis.x, y = axis.y, z = axis.z;
		var tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		 return this;

	},

	makeScale: function ( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	},

	makeShear: function ( x, y, z ) {

		this.set(

			1, y, z, 0,
			x, 1, z, 0,
			x, y, 1, 0,
			0, 0, 0, 1

		);

		return this;

	},

	compose: function ( position, quaternion, scale ) {

		this.makeRotationFromQuaternion( quaternion );
		this.scale( scale );
		this.setPosition( position );

		return this;

	},

	decompose: function () {

		var vector = new Vector3();
		var matrix = new Matrix4();

		return function decompose( position, quaternion, scale ) {

			var te = this.elements;

			var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
			var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
			var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

			// if determine is negative, we need to invert one scale
			var det = this.determinant();
			if ( det < 0 ) sx = - sx;

			position.x = te[ 12 ];
			position.y = te[ 13 ];
			position.z = te[ 14 ];

			// scale the rotation part
			matrix.copy( this );

			var invSX = 1 / sx;
			var invSY = 1 / sy;
			var invSZ = 1 / sz;

			matrix.elements[ 0 ] *= invSX;
			matrix.elements[ 1 ] *= invSX;
			matrix.elements[ 2 ] *= invSX;

			matrix.elements[ 4 ] *= invSY;
			matrix.elements[ 5 ] *= invSY;
			matrix.elements[ 6 ] *= invSY;

			matrix.elements[ 8 ] *= invSZ;
			matrix.elements[ 9 ] *= invSZ;
			matrix.elements[ 10 ] *= invSZ;

			quaternion.setFromRotationMatrix( matrix );

			scale.x = sx;
			scale.y = sy;
			scale.z = sz;

			return this;

		};

	}(),

	makePerspective: function ( left, right, top, bottom, near, far ) {

		if ( far === undefined ) {

			console.warn( 'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.' );

		}

		var te = this.elements;
		var x = 2 * near / ( right - left );
		var y = 2 * near / ( top - bottom );

		var a = ( right + left ) / ( right - left );
		var b = ( top + bottom ) / ( top - bottom );
		var c = - ( far + near ) / ( far - near );
		var d = - 2 * far * near / ( far - near );

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	},

	makeOrthographic: function ( left, right, top, bottom, near, far ) {

		var te = this.elements;
		var w = 1.0 / ( right - left );
		var h = 1.0 / ( top - bottom );
		var p = 1.0 / ( far - near );

		var x = ( right + left ) * w;
		var y = ( top + bottom ) * h;
		var z = ( far + near ) * p;

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
		te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;

		return this;

	},

	equals: function ( matrix ) {

		var te = this.elements;
		var me = matrix.elements;

		for ( var i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		for ( var i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		var te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ] = te[ 8 ];
		array[ offset + 9 ] = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */

function Quaternion( x, y, z, w ) {

	this._x = x || 0;
	this._y = y || 0;
	this._z = z || 0;
	this._w = ( w !== undefined ) ? w : 1;

}

Object.assign( Quaternion, {

	slerp: function ( qa, qb, qm, t ) {

		return qm.copy( qa ).slerp( qb, t );

	},

	slerpFlat: function ( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		var x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ],

			x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			var s = 1 - t,

				cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,

				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				var sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			var tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

} );

Object.defineProperties( Quaternion.prototype, {

	x: {

		get: function () {

			return this._x;

		},

		set: function ( value ) {

			this._x = value;
			this.onChangeCallback();

		}

	},

	y: {

		get: function () {

			return this._y;

		},

		set: function ( value ) {

			this._y = value;
			this.onChangeCallback();

		}

	},

	z: {

		get: function () {

			return this._z;

		},

		set: function ( value ) {

			this._z = value;
			this.onChangeCallback();

		}

	},

	w: {

		get: function () {

			return this._w;

		},

		set: function ( value ) {

			this._w = value;
			this.onChangeCallback();

		}

	}

} );

Object.assign( Quaternion.prototype, {

	set: function ( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this.onChangeCallback();

		return this;

	},

	clone: function () {

		return new this.constructor( this._x, this._y, this._z, this._w );

	},

	copy: function ( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this.onChangeCallback();

		return this;

	},

	setFromEuler: function ( euler, update ) {

		if ( ! ( euler && euler.isEuler ) ) {

			throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );

		}

		var x = euler._x, y = euler._y, z = euler._z, order = euler.order;

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		var cos = Math.cos;
		var sin = Math.sin;

		var c1 = cos( x / 2 );
		var c2 = cos( y / 2 );
		var c3 = cos( z / 2 );

		var s1 = sin( x / 2 );
		var s2 = sin( y / 2 );
		var s3 = sin( z / 2 );

		if ( order === 'XYZ' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'YXZ' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if ( order === 'ZXY' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'ZYX' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if ( order === 'YZX' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'XZY' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		}

		if ( update !== false ) this.onChangeCallback();

		return this;

	},

	setFromAxisAngle: function ( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		var halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this.onChangeCallback();

		return this;

	},

	setFromRotationMatrix: function ( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33,
			s;

		if ( trace > 0 ) {

			s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this.onChangeCallback();

		return this;

	},

	setFromUnitVectors: function () {

		// assumes direction vectors vFrom and vTo are normalized

		var v1 = new Vector3();
		var r;

		var EPS = 0.000001;

		return function setFromUnitVectors( vFrom, vTo ) {

			if ( v1 === undefined ) v1 = new Vector3();

			r = vFrom.dot( vTo ) + 1;

			if ( r < EPS ) {

				r = 0;

				if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

					v1.set( - vFrom.y, vFrom.x, 0 );

				} else {

					v1.set( 0, - vFrom.z, vFrom.y );

				}

			} else {

				v1.crossVectors( vFrom, vTo );

			}

			this._x = v1.x;
			this._y = v1.y;
			this._z = v1.z;
			this._w = r;

			return this.normalize();

		};

	}(),

	inverse: function () {

		return this.conjugate().normalize();

	},

	conjugate: function () {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this.onChangeCallback();

		return this;

	},

	dot: function ( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	},

	lengthSq: function () {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	},

	length: function () {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	},

	normalize: function () {

		var l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this.onChangeCallback();

		return this;

	},

	multiply: function ( q, p ) {

		if ( p !== undefined ) {

			console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
			return this.multiplyQuaternions( q, p );

		}

		return this.multiplyQuaternions( this, q );

	},

	premultiply: function ( q ) {

		return this.multiplyQuaternions( q, this );

	},

	multiplyQuaternions: function ( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this.onChangeCallback();

		return this;

	},

	slerp: function ( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		var x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );

		if ( Math.abs( sinHalfTheta ) < 0.001 ) {

			this._w = 0.5 * ( w + this._w );
			this._x = 0.5 * ( x + this._x );
			this._y = 0.5 * ( y + this._y );
			this._z = 0.5 * ( z + this._z );

			return this;

		}

		var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this.onChangeCallback();

		return this;

	},

	equals: function ( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this.onChangeCallback();

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	},

	onChange: function ( callback ) {

		this.onChangeCallback = callback;

		return this;

	},

	onChangeCallback: function () {}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author kile / http://kile.stravaganza.org/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function Vector3( x, y, z ) {

	this.x = x || 0;
	this.y = y || 0;
	this.z = z || 0;

}

Object.assign( Vector3.prototype, {

	isVector3: true,

	set: function ( x, y, z ) {

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setZ: function ( z ) {

		this.z = z;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y, this.z );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	},

	multiply: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
			return this.multiplyVectors( v, w );

		}

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;

		return this;

	},

	multiplyVectors: function ( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	},

	applyEuler: function () {

		var quaternion = new Quaternion();

		return function applyEuler( euler ) {

			if ( ! ( euler && euler.isEuler ) ) {

				console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );

			}

			return this.applyQuaternion( quaternion.setFromEuler( euler ) );

		};

	}(),

	applyAxisAngle: function () {

		var quaternion = new Quaternion();

		return function applyAxisAngle( axis, angle ) {

			return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );

		};

	}(),

	applyMatrix3: function ( m ) {

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	},

	applyMatrix4: function ( m ) {

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		var w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

		return this;

	},

	applyQuaternion: function ( q ) {

		var x = this.x, y = this.y, z = this.z;
		var qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// calculate quat * vector

		var ix = qw * x + qy * z - qz * y;
		var iy = qw * y + qz * x - qx * z;
		var iz = qw * z + qx * y - qy * x;
		var iw = - qx * x - qy * y - qz * z;

		// calculate result * inverse quat

		this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
		this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
		this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;

		return this;

	},

	project: function () {

		var matrix = new Matrix4();

		return function project( camera ) {

			matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
			return this.applyMatrix4( matrix );

		};

	}(),

	unproject: function () {

		var matrix = new Matrix4();

		return function unproject( camera ) {

			matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
			return this.applyMatrix4( matrix );

		};

	}(),

	transformDirection: function ( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	},

	divide: function ( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	},

	clamp: function ( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	},

	clampScalar: function () {

		var min = new Vector3();
		var max = new Vector3();

		return function clampScalar( minVal, maxVal ) {

			min.set( minVal, minVal, minVal );
			max.set( maxVal, maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	clampLength: function ( min, max ) {

		var length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	},

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
		this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	},

	// TODO lengthSquared?

	lengthSq: function () {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	},

	manhattanLength: function () {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	},

	normalize: function () {

		return this.divideScalar( this.length() || 1 );

	},

	setLength: function ( length ) {

		return this.normalize().multiplyScalar( length );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	cross: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
			return this.crossVectors( v, w );

		}

		return this.crossVectors( this, v );

	},

	crossVectors: function ( a, b ) {

		var ax = a.x, ay = a.y, az = a.z;
		var bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	},

	projectOnVector: function ( vector ) {

		var scalar = vector.dot( this ) / vector.lengthSq();

		return this.copy( vector ).multiplyScalar( scalar );

	},

	projectOnPlane: function () {

		var v1 = new Vector3();

		return function projectOnPlane( planeNormal ) {

			v1.copy( this ).projectOnVector( planeNormal );

			return this.sub( v1 );

		};

	}(),

	reflect: function () {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		var v1 = new Vector3();

		return function reflect( normal ) {

			return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

		};

	}(),

	angleTo: function ( v ) {

		var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );

		// clamp, to handle numerical problems

		return Math.acos( _Math.clamp( theta, - 1, 1 ) );

	},

	distanceTo: function ( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	},

	distanceToSquared: function ( v ) {

		var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	},

	manhattanDistanceTo: function ( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	},

	setFromSpherical: function ( s ) {

		var sinPhiRadius = Math.sin( s.phi ) * s.radius;

		this.x = sinPhiRadius * Math.sin( s.theta );
		this.y = Math.cos( s.phi ) * s.radius;
		this.z = sinPhiRadius * Math.cos( s.theta );

		return this;

	},

	setFromCylindrical: function ( c ) {

		this.x = c.radius * Math.sin( c.theta );
		this.y = c.y;
		this.z = c.radius * Math.cos( c.theta );

		return this;

	},

	setFromMatrixPosition: function ( m ) {

		var e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];

		return this;

	},

	setFromMatrixScale: function ( m ) {

		var sx = this.setFromMatrixColumn( m, 0 ).length();
		var sy = this.setFromMatrixColumn( m, 1 ).length();
		var sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	},

	setFromMatrixColumn: function ( m, index ) {

		return this.fromArray( m.elements, index * 4 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	},

	fromBufferAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector3: offset has been removed from .fromBufferAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 * @author tschw
 */

function Matrix3() {

	this.elements = [

		1, 0, 0,
		0, 1, 0,
		0, 0, 1

	];

	if ( arguments.length > 0 ) {

		console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );

	}

}

Object.assign( Matrix3.prototype, {

	isMatrix3: true,

	set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		var te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	},

	identity: function () {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	},

	clone: function () {

		return new this.constructor().fromArray( this.elements );

	},

	copy: function ( m ) {

		var te = this.elements;
		var me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
		te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
		te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

		return this;

	},

	setFromMatrix4: function ( m ) {

		var me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[ 8 ],
			me[ 1 ], me[ 5 ], me[ 9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	},

	applyToBufferAttribute: function () {

		var v1 = new Vector3();

		return function applyToBufferAttribute( attribute ) {

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				v1.x = attribute.getX( i );
				v1.y = attribute.getY( i );
				v1.z = attribute.getZ( i );

				v1.applyMatrix3( this );

				attribute.setXYZ( i, v1.x, v1.y, v1.z );

			}

			return attribute;

		};

	}(),

	multiply: function ( m ) {

		return this.multiplyMatrices( this, m );

	},

	premultiply: function ( m ) {

		return this.multiplyMatrices( m, this );

	},

	multiplyMatrices: function ( a, b ) {

		var ae = a.elements;
		var be = b.elements;
		var te = this.elements;

		var a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
		var a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
		var a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

		var b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
		var b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
		var b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
		te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
		te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
		te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
		te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
		te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
		te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

		return this;

	},

	multiplyScalar: function ( s ) {

		var te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	},

	determinant: function () {

		var te = this.elements;

		var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	},

	getInverse: function ( matrix, throwOnDegenerate ) {

		if ( matrix && matrix.isMatrix4 ) {

			console.error( "THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument." );

		}

		var me = matrix.elements,
			te = this.elements,

			n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
			n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
			n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) {

			var msg = "THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0";

			if ( throwOnDegenerate === true ) {

				throw new Error( msg );

			} else {

				console.warn( msg );

			}

			return this.identity();

		}

		var detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	},

	transpose: function () {

		var tmp, m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	},

	getNormalMatrix: function ( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();

	},

	transposeIntoArray: function ( r ) {

		var m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	},

	setUvTransform: function ( tx, ty, sx, sy, rotation, cx, cy ) {

		var c = Math.cos( rotation );
		var s = Math.sin( rotation );

		this.set(
			sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
			- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
			0, 0, 1
		);

	},

	scale: function ( sx, sy ) {

		var te = this.elements;

		te[ 0 ] *= sx; te[ 3 ] *= sx; te[ 6 ] *= sx;
		te[ 1 ] *= sy; te[ 4 ] *= sy; te[ 7 ] *= sy;

		return this;

	},

	rotate: function ( theta ) {

		var c = Math.cos( theta );
		var s = Math.sin( theta );

		var te = this.elements;

		var a11 = te[ 0 ], a12 = te[ 3 ], a13 = te[ 6 ];
		var a21 = te[ 1 ], a22 = te[ 4 ], a23 = te[ 7 ];

		te[ 0 ] = c * a11 + s * a21;
		te[ 3 ] = c * a12 + s * a22;
		te[ 6 ] = c * a13 + s * a23;

		te[ 1 ] = - s * a11 + c * a21;
		te[ 4 ] = - s * a12 + c * a22;
		te[ 7 ] = - s * a13 + c * a23;

		return this;

	},

	translate: function ( tx, ty ) {

		var te = this.elements;

		te[ 0 ] += tx * te[ 2 ]; te[ 3 ] += tx * te[ 5 ]; te[ 6 ] += tx * te[ 8 ];
		te[ 1 ] += ty * te[ 2 ]; te[ 4 ] += ty * te[ 5 ]; te[ 7 ] += ty * te[ 8 ];

		return this;

	},

	equals: function ( matrix ) {

		var te = this.elements;
		var me = matrix.elements;

		for ( var i = 0; i < 9; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		for ( var i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		var te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ] = te[ 8 ];

		return array;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author szimek / https://github.com/szimek/
 */

var textureId = 0;

function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

	Object.defineProperty( this, 'id', { value: textureId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';

	this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
	this.mipmaps = [];

	this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;

	this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
	this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;

	this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
	this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;

	this.anisotropy = anisotropy !== undefined ? anisotropy : 1;

	this.format = format !== undefined ? format : RGBAFormat;
	this.type = type !== undefined ? type : UnsignedByteType;

	this.offset = new Vector2( 0, 0 );
	this.repeat = new Vector2( 1, 1 );
	this.center = new Vector2( 0, 0 );
	this.rotation = 0;

	this.matrixAutoUpdate = true;
	this.matrix = new Matrix3();

	this.generateMipmaps = true;
	this.premultiplyAlpha = false;
	this.flipY = true;
	this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

	// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
	//
	// Also changing the encoding after already used by a Material will not automatically make the Material
	// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
	this.encoding = encoding !== undefined ? encoding : LinearEncoding;

	this.version = 0;
	this.onUpdate = null;

}

Texture.DEFAULT_IMAGE = undefined;
Texture.DEFAULT_MAPPING = UVMapping;

Texture.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: Texture,

	isTexture: true,

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.name = source.name;

		this.image = source.image;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );
		this.center.copy( source.center );
		this.rotation = source.rotation;

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrix.copy( source.matrix );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.encoding = source.encoding;

		return this;

	},

	toJSON: function ( meta ) {

		var isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		function getDataURL( image ) {

			var canvas;

			if ( image instanceof HTMLCanvasElement ) {

				canvas = image;

			} else {

				canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = image.width;
				canvas.height = image.height;

				var context = canvas.getContext( '2d' );

				if ( image instanceof ImageData ) {

					context.putImageData( image, 0, 0 );

				} else {

					context.drawImage( image, 0, 0, image.width, image.height );

				}

			}

			if ( canvas.width > 2048 || canvas.height > 2048 ) {

				return canvas.toDataURL( 'image/jpeg', 0.6 );

			} else {

				return canvas.toDataURL( 'image/png' );

			}

		}

		var output = {
			metadata: {
				version: 4.5,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			mapping: this.mapping,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			center: [ this.center.x, this.center.y ],
			rotation: this.rotation,

			wrap: [ this.wrapS, this.wrapT ],

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY
		};

		if ( this.image !== undefined ) {

			// TODO: Move to THREE.Image

			var image = this.image;

			if ( image.uuid === undefined ) {

				image.uuid = _Math.generateUUID(); // UGH

			}

			if ( ! isRootObject && meta.images[ image.uuid ] === undefined ) {

				meta.images[ image.uuid ] = {
					uuid: image.uuid,
					url: getDataURL( image )
				};

			}

			output.image = image.uuid;

		}

		if ( ! isRootObject ) {

			meta.textures[ this.uuid ] = output;

		}

		return output;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	},

	transformUv: function ( uv ) {

		if ( this.mapping !== UVMapping ) return;

		uv.applyMatrix3( this.matrix );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}
					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}
					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

	}

} );

Object.defineProperty( Texture.prototype, "needsUpdate", {

	set: function ( value ) {

		if ( value === true ) this.version ++;

	}

} );

/**
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function Vector4( x, y, z, w ) {

	this.x = x || 0;
	this.y = y || 0;
	this.z = z || 0;
	this.w = ( w !== undefined ) ? w : 1;

}

Object.assign( Vector4.prototype, {

	isVector4: true,

	set: function ( x, y, z, w ) {

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;
		this.w = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setZ: function ( z ) {

		this.z = z;

		return this;

	},

	setW: function ( w ) {

		this.w = w;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			case 3: this.w = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y, this.z, this.w );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;
		this.w = ( v.w !== undefined ) ? v.w : 1;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;
		this.w += v.w;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;
		this.z += s;
		this.w += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;
		this.w = a.w + b.w;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;
		this.w += v.w * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;
		this.w -= v.w;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;
		this.w -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;
		this.w = a.w - b.w;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		this.w *= scalar;

		return this;

	},

	applyMatrix4: function ( m ) {

		var x = this.x, y = this.y, z = this.z, w = this.w;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
		this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	setAxisAngleFromQuaternion: function ( q ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

		// q is assumed to be normalized

		this.w = 2 * Math.acos( q.w );

		var s = Math.sqrt( 1 - q.w * q.w );

		if ( s < 0.0001 ) {

			this.x = 1;
			this.y = 0;
			this.z = 0;

		} else {

			this.x = q.x / s;
			this.y = q.y / s;
			this.z = q.z / s;

		}

		return this;

	},

	setAxisAngleFromRotationMatrix: function ( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var angle, x, y, z,		// variables for result
			epsilon = 0.01,		// margin to allow for rounding errors
			epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

			te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
		     ( Math.abs( m13 - m31 ) < epsilon ) &&
		     ( Math.abs( m23 - m32 ) < epsilon ) ) {

			// singularity found
			// first check for identity matrix which must have +1 for all terms
			// in leading diagonal and zero in other terms

			if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
			     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
			     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
			     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

				// this singularity is identity matrix so angle = 0

				this.set( 1, 0, 0, 0 );

				return this; // zero angle, arbitrary axis

			}

			// otherwise this singularity is angle = 180

			angle = Math.PI;

			var xx = ( m11 + 1 ) / 2;
			var yy = ( m22 + 1 ) / 2;
			var zz = ( m33 + 1 ) / 2;
			var xy = ( m12 + m21 ) / 4;
			var xz = ( m13 + m31 ) / 4;
			var yz = ( m23 + m32 ) / 4;

			if ( ( xx > yy ) && ( xx > zz ) ) {

				// m11 is the largest diagonal term

				if ( xx < epsilon ) {

					x = 0;
					y = 0.707106781;
					z = 0.707106781;

				} else {

					x = Math.sqrt( xx );
					y = xy / x;
					z = xz / x;

				}

			} else if ( yy > zz ) {

				// m22 is the largest diagonal term

				if ( yy < epsilon ) {

					x = 0.707106781;
					y = 0;
					z = 0.707106781;

				} else {

					y = Math.sqrt( yy );
					x = xy / y;
					z = yz / y;

				}

			} else {

				// m33 is the largest diagonal term so base result on this

				if ( zz < epsilon ) {

					x = 0.707106781;
					y = 0.707106781;
					z = 0;

				} else {

					z = Math.sqrt( zz );
					x = xz / z;
					y = yz / z;

				}

			}

			this.set( x, y, z, angle );

			return this; // return 180 deg rotation

		}

		// as we have reached here there are no singularities so we can handle normally

		var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
		                   ( m13 - m31 ) * ( m13 - m31 ) +
		                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

		if ( Math.abs( s ) < 0.001 ) s = 1;

		// prevent divide by zero, should not happen if matrix is orthogonal and should be
		// caught by singularity test above, but I've left it in just in case

		this.x = ( m32 - m23 ) / s;
		this.y = ( m13 - m31 ) / s;
		this.z = ( m21 - m12 ) / s;
		this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

		return this;

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );
		this.w = Math.min( this.w, v.w );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );
		this.w = Math.max( this.w, v.w );

		return this;

	},

	clamp: function ( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );
		this.w = Math.max( min.w, Math.min( max.w, this.w ) );

		return this;

	},

	clampScalar: function () {

		var min, max;

		return function clampScalar( minVal, maxVal ) {

			if ( min === undefined ) {

				min = new Vector4();
				max = new Vector4();

			}

			min.set( minVal, minVal, minVal, minVal );
			max.set( maxVal, maxVal, maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	clampLength: function ( min, max ) {

		var length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	},

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );
		this.w = Math.floor( this.w );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );
		this.w = Math.ceil( this.w );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );
		this.w = Math.round( this.w );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
		this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
		this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;
		this.w = - this.w;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

	},

	lengthSq: function () {

		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

	},

	manhattanLength: function () {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

	},

	normalize: function () {

		return this.divideScalar( this.length() || 1 );

	},

	setLength: function ( length ) {

		return this.normalize().multiplyScalar( length );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;
		this.w += ( v.w - this.w ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];
		this.w = array[ offset + 3 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;
		array[ offset + 3 ] = this.w;

		return array;

	},

	fromBufferAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector4: offset has been removed from .fromBufferAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );
		this.w = attribute.getW( index );

		return this;

	}

} );

/**
 * @author szimek / https://github.com/szimek/
 * @author alteredq / http://alteredqualia.com/
 * @author Marius Kintel / https://github.com/kintel
 */

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/
function WebGLRenderTarget( width, height, options ) {

	this.uuid = _Math.generateUUID();

	this.width = width;
	this.height = height;

	this.scissor = new Vector4( 0, 0, width, height );
	this.scissorTest = false;

	this.viewport = new Vector4( 0, 0, width, height );

	options = options || {};

	if ( options.minFilter === undefined ) options.minFilter = LinearFilter;

	this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );

	this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
	this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
	this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;

}

WebGLRenderTarget.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: WebGLRenderTarget,

	isWebGLRenderTarget: true,

	setSize: function ( width, height ) {

		if ( this.width !== width || this.height !== height ) {

			this.width = width;
			this.height = height;

			this.dispose();

		}

		this.viewport.set( 0, 0, width, height );
		this.scissor.set( 0, 0, width, height );

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.width = source.width;
		this.height = source.height;

		this.viewport.copy( source.viewport );

		this.texture = source.texture.clone();

		this.depthBuffer = source.depthBuffer;
		this.stencilBuffer = source.stencilBuffer;
		this.depthTexture = source.depthTexture;

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

/**
 * @author alteredq / http://alteredqualia.com
 */

function WebGLRenderTargetCube( width, height, options ) {

	WebGLRenderTarget.call( this, width, height, options );

	this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
	this.activeMipMapLevel = 0;

}

WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;

WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;

/**
 * @author alteredq / http://alteredqualia.com/
 */

function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.image = { data: data, width: width, height: height };

	this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
	this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

	this.generateMipmaps = false;
	this.flipY = false;
	this.unpackAlignment = 1;

}

DataTexture.prototype = Object.create( Texture.prototype );
DataTexture.prototype.constructor = DataTexture;

DataTexture.prototype.isDataTexture = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

	images = images !== undefined ? images : [];
	mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

	Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.flipY = false;

}

CubeTexture.prototype = Object.create( Texture.prototype );
CubeTexture.prototype.constructor = CubeTexture;

CubeTexture.prototype.isCubeTexture = true;

Object.defineProperty( CubeTexture.prototype, 'images', {

	get: function () {

		return this.image;

	},

	set: function ( value ) {

		this.image = value;

	}

} );

/**
 * @author tschw
 *
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [renderer] )
 *
 * 		uploads a uniform value(s)
 *  	the 'renderer' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (renderer factorizations):
 *
 * .upload( gl, seq, values, renderer )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (renderer factorizations):
 *
 * .setValue( gl, name, value )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .set( gl, obj, prop )
 *
 * 		sets uniform from object and property with same name than uniform
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */

var emptyTexture = new Texture();
var emptyCubeTexture = new CubeTexture();

// --- Base for inner nodes (including the root) ---

function UniformContainer() {

	this.seq = [];
	this.map = {};

}

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

var arrayCacheF32 = [];
var arrayCacheI32 = [];

// Float32Array caches used for uploading Matrix uniforms

var mat4array = new Float32Array( 16 );
var mat3array = new Float32Array( 9 );

// Flattening for arrays of vectors and matrices

function flatten( array, nBlocks, blockSize ) {

	var firstElem = array[ 0 ];

	if ( firstElem <= 0 || firstElem > 0 ) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	var n = nBlocks * blockSize,
		r = arrayCacheF32[ n ];

	if ( r === undefined ) {

		r = new Float32Array( n );
		arrayCacheF32[ n ] = r;

	}

	if ( nBlocks !== 0 ) {

		firstElem.toArray( r, 0 );

		for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {

			offset += blockSize;
			array[ i ].toArray( r, offset );

		}

	}

	return r;

}

// Texture unit allocation

function allocTexUnits( renderer, n ) {

	var r = arrayCacheI32[ n ];

	if ( r === undefined ) {

		r = new Int32Array( n );
		arrayCacheI32[ n ] = r;

	}

	for ( var i = 0; i !== n; ++ i )
		r[ i ] = renderer.allocTextureUnit();

	return r;

}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValue1f( gl, v ) {

	gl.uniform1f( this.addr, v );

}

function setValue1i( gl, v ) {

	gl.uniform1i( this.addr, v );

}

// Single float vector (from flat array or THREE.VectorN)

function setValue2fv( gl, v ) {

	if ( v.x === undefined ) {

		gl.uniform2fv( this.addr, v );

	} else {

		gl.uniform2f( this.addr, v.x, v.y );

	}

}

function setValue3fv( gl, v ) {

	if ( v.x !== undefined ) {

		gl.uniform3f( this.addr, v.x, v.y, v.z );

	} else if ( v.r !== undefined ) {

		gl.uniform3f( this.addr, v.r, v.g, v.b );

	} else {

		gl.uniform3fv( this.addr, v );

	}

}

function setValue4fv( gl, v ) {

	if ( v.x === undefined ) {

		gl.uniform4fv( this.addr, v );

	} else {

		 gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

	}

}

// Single matrix (from flat array or MatrixN)

function setValue2fm( gl, v ) {

	gl.uniformMatrix2fv( this.addr, false, v.elements || v );

}

function setValue3fm( gl, v ) {

	if ( v.elements === undefined ) {

		gl.uniformMatrix3fv( this.addr, false, v );

	} else {

		mat3array.set( v.elements );
		gl.uniformMatrix3fv( this.addr, false, mat3array );

	}

}

function setValue4fm( gl, v ) {

	if ( v.elements === undefined ) {

		gl.uniformMatrix4fv( this.addr, false, v );

	} else {

		mat4array.set( v.elements );
		gl.uniformMatrix4fv( this.addr, false, mat4array );

	}

}

// Single texture (2D / Cube)

function setValueT1( gl, v, renderer ) {

	var unit = renderer.allocTextureUnit();
	gl.uniform1i( this.addr, unit );
	renderer.setTexture2D( v || emptyTexture, unit );

}

function setValueT6( gl, v, renderer ) {

	var unit = renderer.allocTextureUnit();
	gl.uniform1i( this.addr, unit );
	renderer.setTextureCube( v || emptyCubeTexture, unit );

}

// Integer / Boolean vectors or arrays thereof (always flat arrays)

function setValue2iv( gl, v ) {

	gl.uniform2iv( this.addr, v );

}

function setValue3iv( gl, v ) {

	gl.uniform3iv( this.addr, v );

}

function setValue4iv( gl, v ) {

	gl.uniform4iv( this.addr, v );

}

// Helper to pick the right setter for the singular case

function getSingularSetter( type ) {

	switch ( type ) {

		case 0x1406: return setValue1f; // FLOAT
		case 0x8b50: return setValue2fv; // _VEC2
		case 0x8b51: return setValue3fv; // _VEC3
		case 0x8b52: return setValue4fv; // _VEC4

		case 0x8b5a: return setValue2fm; // _MAT2
		case 0x8b5b: return setValue3fm; // _MAT3
		case 0x8b5c: return setValue4fm; // _MAT4

		case 0x8b5e: case 0x8d66: return setValueT1; // SAMPLER_2D, SAMPLER_EXTERNAL_OES
		case 0x8b60: return setValueT6; // SAMPLER_CUBE

		case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
		case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
		case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

	}

}

// Array of scalars

function setValue1fv( gl, v ) {

	gl.uniform1fv( this.addr, v );

}
function setValue1iv( gl, v ) {

	gl.uniform1iv( this.addr, v );

}

// Array of vectors (flat or from THREE classes)

function setValueV2a( gl, v ) {

	gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );

}

function setValueV3a( gl, v ) {

	gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );

}

function setValueV4a( gl, v ) {

	gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );

}

// Array of matrices (flat or from THREE clases)

function setValueM2a( gl, v ) {

	gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );

}

function setValueM3a( gl, v ) {

	gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );

}

function setValueM4a( gl, v ) {

	gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );

}

// Array of textures (2D / Cube)

function setValueT1a( gl, v, renderer ) {

	var n = v.length,
		units = allocTexUnits( renderer, n );

	gl.uniform1iv( this.addr, units );

	for ( var i = 0; i !== n; ++ i ) {

		renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

	}

}

function setValueT6a( gl, v, renderer ) {

	var n = v.length,
		units = allocTexUnits( renderer, n );

	gl.uniform1iv( this.addr, units );

	for ( var i = 0; i !== n; ++ i ) {

		renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

	}

}

// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter( type ) {

	switch ( type ) {

		case 0x1406: return setValue1fv; // FLOAT
		case 0x8b50: return setValueV2a; // _VEC2
		case 0x8b51: return setValueV3a; // _VEC3
		case 0x8b52: return setValueV4a; // _VEC4

		case 0x8b5a: return setValueM2a; // _MAT2
		case 0x8b5b: return setValueM3a; // _MAT3
		case 0x8b5c: return setValueM4a; // _MAT4

		case 0x8b5e: return setValueT1a; // SAMPLER_2D
		case 0x8b60: return setValueT6a; // SAMPLER_CUBE

		case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
		case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
		case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

	}

}

// --- Uniform Classes ---

function SingleUniform( id, activeInfo, addr ) {

	this.id = id;
	this.addr = addr;
	this.setValue = getSingularSetter( activeInfo.type );

	// this.path = activeInfo.name; // DEBUG

}

function PureArrayUniform( id, activeInfo, addr ) {

	this.id = id;
	this.addr = addr;
	this.size = activeInfo.size;
	this.setValue = getPureArraySetter( activeInfo.type );

	// this.path = activeInfo.name; // DEBUG

}

function StructuredUniform( id ) {

	this.id = id;

	UniformContainer.call( this ); // mix-in

}

StructuredUniform.prototype.setValue = function ( gl, value ) {

	// Note: Don't need an extra 'renderer' parameter, since samplers
	// are not allowed in structured uniforms.

	var seq = this.seq;

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ];
		u.setValue( gl, value[ u.id ] );

	}

};

// --- Top-level ---

// Parser - builds up the property tree from the path strings

var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform( container, uniformObject ) {

	container.seq.push( uniformObject );
	container.map[ uniformObject.id ] = uniformObject;

}

function parseUniform( activeInfo, addr, container ) {

	var path = activeInfo.name,
		pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	for ( ; ; ) {

		var match = RePathPart.exec( path ),
			matchEnd = RePathPart.lastIndex,

			id = match[ 1 ],
			idIsIndex = match[ 2 ] === ']',
			subscript = match[ 3 ];

		if ( idIsIndex ) id = id | 0; // convert to integer

		if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {

			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform( container, subscript === undefined ?
				new SingleUniform( id, activeInfo, addr ) :
				new PureArrayUniform( id, activeInfo, addr ) );

			break;

		} else {

			// step into inner node / create it in case it doesn't exist

			var map = container.map, next = map[ id ];

			if ( next === undefined ) {

				next = new StructuredUniform( id );
				addUniform( container, next );

			}

			container = next;

		}

	}

}

// Root Container

function WebGLUniforms( gl, program, renderer ) {

	UniformContainer.call( this );

	this.renderer = renderer;

	var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

	for ( var i = 0; i < n; ++ i ) {

		var info = gl.getActiveUniform( program, i ),
			path = info.name,
			addr = gl.getUniformLocation( program, path );

		parseUniform( info, addr, this );

	}

}

WebGLUniforms.prototype.setValue = function ( gl, name, value ) {

	var u = this.map[ name ];

	if ( u !== undefined ) u.setValue( gl, value, this.renderer );

};

WebGLUniforms.prototype.setOptional = function ( gl, object, name ) {

	var v = object[ name ];

	if ( v !== undefined ) this.setValue( gl, name, v );

};


// Static interface

WebGLUniforms.upload = function ( gl, seq, values, renderer ) {

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ],
			v = values[ u.id ];

		if ( v.needsUpdate !== false ) {

			// note: always updating when .needsUpdate is undefined
			u.setValue( gl, v.value, renderer );

		}

	}

};

WebGLUniforms.seqWithValue = function ( seq, values ) {

	var r = [];

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ];
		if ( u.id in values ) r.push( u );

	}

	return r;

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

function Color( r, g, b ) {

	if ( g === undefined && b === undefined ) {

		// r is THREE.Color, hex or string
		return this.set( r );

	}

	return this.setRGB( r, g, b );

}

Object.assign( Color.prototype, {

	isColor: true,

	r: 1, g: 1, b: 1,

	set: function ( value ) {

		if ( value && value.isColor ) {

			this.copy( value );

		} else if ( typeof value === 'number' ) {

			this.setHex( value );

		} else if ( typeof value === 'string' ) {

			this.setStyle( value );

		}

		return this;

	},

	setScalar: function ( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	},

	setHex: function ( hex ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		return this;

	},

	setRGB: function ( r, g, b ) {

		this.r = r;
		this.g = g;
		this.b = b;

		return this;

	},

	setHSL: function () {

		function hue2rgb( p, q, t ) {

			if ( t < 0 ) t += 1;
			if ( t > 1 ) t -= 1;
			if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
			if ( t < 1 / 2 ) return q;
			if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
			return p;

		}

		return function setHSL( h, s, l ) {

			// h,s,l ranges are in 0.0 - 1.0
			h = _Math.euclideanModulo( h, 1 );
			s = _Math.clamp( s, 0, 1 );
			l = _Math.clamp( l, 0, 1 );

			if ( s === 0 ) {

				this.r = this.g = this.b = l;

			} else {

				var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
				var q = ( 2 * l ) - p;

				this.r = hue2rgb( q, p, h + 1 / 3 );
				this.g = hue2rgb( q, p, h );
				this.b = hue2rgb( q, p, h - 1 / 3 );

			}

			return this;

		};

	}(),

	setStyle: function ( style ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		var m;

		if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			var color;
			var name = m[ 1 ];
			var components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)
						this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
						this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
						this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;

						handleAlpha( color[ 5 ] );

						return this;

					}

					if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
						this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
						this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
						this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;

						handleAlpha( color[ 5 ] );

						return this;

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
						var h = parseFloat( color[ 1 ] ) / 360;
						var s = parseInt( color[ 2 ], 10 ) / 100;
						var l = parseInt( color[ 3 ], 10 ) / 100;

						handleAlpha( color[ 5 ] );

						return this.setHSL( h, s, l );

					}

					break;

			}

		} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {

			// hex color

			var hex = m[ 1 ];
			var size = hex.length;

			if ( size === 3 ) {

				// #ff0
				this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
				this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
				this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;

				return this;

			} else if ( size === 6 ) {

				// #ff0000
				this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
				this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
				this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;

				return this;

			}

		}

		if ( style && style.length > 0 ) {

			// color keywords
			var hex = ColorKeywords[ style ];

			if ( hex !== undefined ) {

				// red
				this.setHex( hex );

			} else {

				// unknown color
				console.warn( 'THREE.Color: Unknown color ' + style );

			}

		}

		return this;

	},

	clone: function () {

		return new this.constructor( this.r, this.g, this.b );

	},

	copy: function ( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	},

	copyGammaToLinear: function ( color, gammaFactor ) {

		if ( gammaFactor === undefined ) gammaFactor = 2.0;

		this.r = Math.pow( color.r, gammaFactor );
		this.g = Math.pow( color.g, gammaFactor );
		this.b = Math.pow( color.b, gammaFactor );

		return this;

	},

	copyLinearToGamma: function ( color, gammaFactor ) {

		if ( gammaFactor === undefined ) gammaFactor = 2.0;

		var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;

		this.r = Math.pow( color.r, safeInverse );
		this.g = Math.pow( color.g, safeInverse );
		this.b = Math.pow( color.b, safeInverse );

		return this;

	},

	convertGammaToLinear: function () {

		var r = this.r, g = this.g, b = this.b;

		this.r = r * r;
		this.g = g * g;
		this.b = b * b;

		return this;

	},

	convertLinearToGamma: function () {

		this.r = Math.sqrt( this.r );
		this.g = Math.sqrt( this.g );
		this.b = Math.sqrt( this.b );

		return this;

	},

	getHex: function () {

		return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;

	},

	getHexString: function () {

		return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );

	},

	getHSL: function ( optionalTarget ) {

		// h,s,l ranges are in 0.0 - 1.0

		var hsl = optionalTarget || { h: 0, s: 0, l: 0 };

		var r = this.r, g = this.g, b = this.b;

		var max = Math.max( r, g, b );
		var min = Math.min( r, g, b );

		var hue, saturation;
		var lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			var delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		hsl.h = hue;
		hsl.s = saturation;
		hsl.l = lightness;

		return hsl;

	},

	getStyle: function () {

		return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';

	},

	offsetHSL: function ( h, s, l ) {

		var hsl = this.getHSL();

		hsl.h += h; hsl.s += s; hsl.l += l;

		this.setHSL( hsl.h, hsl.s, hsl.l );

		return this;

	},

	add: function ( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	},

	addColors: function ( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	},

	addScalar: function ( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	},

	sub: function ( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	},

	multiply: function ( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	},

	multiplyScalar: function ( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	},

	lerp: function ( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	},

	equals: function ( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	},

	toJSON: function () {

		return this.getHex();

	}

} );

/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib = {

	common: {

		diffuse: { value: new Color( 0xeeeeee ) },
		opacity: { value: 1.0 },

		map: { value: null },
		uvTransform: { value: new Matrix3() },

		alphaMap: { value: null },

	},

	specularmap: {

		specularMap: { value: null },

	},

	envmap: {

		envMap: { value: null },
		flipEnvMap: { value: - 1 },
		reflectivity: { value: 1.0 },
		refractionRatio: { value: 0.98 }

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 }

	},

	emissivemap: {

		emissiveMap: { value: null }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalScale: { value: new Vector2( 1, 1 ) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	roughnessmap: {

		roughnessMap: { value: null }

	},

	metalnessmap: {

		metalnessMap: { value: null }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: new Color( 0xffffff ) }

	},

	lights: {

		ambientLightColor: { value: [] },

		directionalLights: { value: [], properties: {
			direction: {},
			color: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
			color: {},
			position: {},
			direction: {},
			distance: {},
			coneCos: {},
			penumbraCos: {},
			decay: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		spotShadowMap: { value: [] },
		spotShadowMatrix: { value: [] },

		pointLights: { value: [], properties: {
			color: {},
			position: {},
			decay: {},
			distance: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {},
			shadowCameraNear: {},
			shadowCameraFar: {}
		} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
			direction: {},
			skyColor: {},
			groundColor: {}
		} },

		// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
		rectAreaLights: { value: [], properties: {
			color: {},
			position: {},
			width: {},
			height: {}
		} }

	},

	points: {

		diffuse: { value: new Color( 0xeeeeee ) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		uvTransform: { value: new Matrix3() }

	}

};

/**
 * Uniform Utilities
 */

var UniformsUtils = {

	merge: function ( uniforms ) {

		var merged = {};

		for ( var u = 0; u < uniforms.length; u ++ ) {

			var tmp = this.clone( uniforms[ u ] );

			for ( var p in tmp ) {

				merged[ p ] = tmp[ p ];

			}

		}

		return merged;

	},

	clone: function ( uniforms_src ) {

		var uniforms_dst = {};

		for ( var u in uniforms_src ) {

			uniforms_dst[ u ] = {};

			for ( var p in uniforms_src[ u ] ) {

				var parameter_src = uniforms_src[ u ][ p ];

				if ( parameter_src && ( parameter_src.isColor ||
					parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
					parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
					parameter_src.isTexture ) ) {

					uniforms_dst[ u ][ p ] = parameter_src.clone();

				} else if ( Array.isArray( parameter_src ) ) {

					uniforms_dst[ u ][ p ] = parameter_src.slice();

				} else {

					uniforms_dst[ u ][ p ] = parameter_src;

				}

			}

		}

		return uniforms_dst;

	}

};

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";

var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var begin_vertex = "\nvec3 transformed = vec3( position );\n";

var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";

var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";

var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";

var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";

var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\n";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";

var defaultnormal_vertex = "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";

var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";

var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";

var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";

var fog_vertex = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif";

var fog_pars_vertex = "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n";

var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";

var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";

var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";

var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";

var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\tgl_Position.z *= gl_Position.w;\n\t#endif\n#endif\n";

var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";

var map_particle_fragment = "#ifdef USE_MAP\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";

var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform mat3 uvTransform;\n\tuniform sampler2D map;\n#endif\n";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";

var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";

var project_vertex = "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n";

var dithering_fragment = "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n";

var dithering_pars_fragment = "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";

var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n";

var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";

var tonemapping_pars_fragment = "#ifndef saturate\n\t#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";

var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";

var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\n";

var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";

var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";

var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";

var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n";

var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";

var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}\n";

var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";

var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n";

var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n";

var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";

var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n";

var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n";

var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n";

var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";

var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <fog_fragment>\n}\n";

var shadow_vert = "#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

var ShaderChunk = {
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	encodings_fragment: encodings_fragment,
	encodings_pars_fragment: encodings_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_vertex: envmap_vertex,
	fog_vertex: fog_vertex,
	fog_pars_vertex: fog_pars_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_fragment: lightmap_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_vertex: lights_lambert_vertex,
	lights_pars: lights_pars,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_template: lights_template,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_fragment: normal_fragment,
	normalmap_pars_fragment: normalmap_pars_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	dithering_fragment: dithering_fragment,
	dithering_pars_fragment: dithering_pars_fragment,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	uv2_pars_fragment: uv2_pars_fragment,
	uv2_pars_vertex: uv2_pars_vertex,
	uv2_vertex: uv2_vertex,
	worldpos_vertex: worldpos_vertex,

	cube_frag: cube_frag,
	cube_vert: cube_vert,
	depth_frag: depth_frag,
	depth_vert: depth_vert,
	distanceRGBA_frag: distanceRGBA_frag,
	distanceRGBA_vert: distanceRGBA_vert,
	equirect_frag: equirect_frag,
	equirect_vert: equirect_vert,
	linedashed_frag: linedashed_frag,
	linedashed_vert: linedashed_vert,
	meshbasic_frag: meshbasic_frag,
	meshbasic_vert: meshbasic_vert,
	meshlambert_frag: meshlambert_frag,
	meshlambert_vert: meshlambert_vert,
	meshphong_frag: meshphong_frag,
	meshphong_vert: meshphong_vert,
	meshphysical_frag: meshphysical_frag,
	meshphysical_vert: meshphysical_vert,
	normal_frag: normal_frag,
	normal_vert: normal_vert,
	points_frag: points_frag,
	points_vert: points_vert,
	shadow_frag: shadow_frag,
	shadow_vert: shadow_vert
};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 */

var ShaderLib = {

	basic: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.gradientmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) },
				specular: { value: new Color( 0x111111 ) },
				shininess: { value: 30 }
			}
		] ),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.roughnessmap,
			UniformsLib.metalnessmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) },
				roughness: { value: 0.5 },
				metalness: { value: 0.5 },
				envMapIntensity: { value: 1 } // temporary
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	points: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.points,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		] ),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.displacementmap
		] ),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			{
				opacity: { value: 1.0 }
			}
		] ),

		vertexShader: ShaderChunk.normal_vert,
		fragmentShader: ShaderChunk.normal_frag

	},

	/* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: - 1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	equirect: {

		uniforms: {
			tEquirect: { value: null },
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.displacementmap,
			{
				referencePosition: { value: new Vector3() },
				nearDistance: { value: 1 },
				farDistance: { value: 1000 }
			}
		] ),

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	},

	shadow: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.lights,
			UniformsLib.fog,
			{
				color: { value: new Color( 0x00000 ) },
				opacity: { value: 1.0 }
			},
		] ),

		vertexShader: ShaderChunk.shadow_vert,
		fragmentShader: ShaderChunk.shadow_frag

	}

};

ShaderLib.physical = {

	uniforms: UniformsUtils.merge( [
		ShaderLib.standard.uniforms,
		{
			clearCoat: { value: 0 },
			clearCoatRoughness: { value: 0 }
		}
	] ),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

/**
 * @author bhouston / http://clara.io
 */

function Box2( min, max ) {

	this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
	this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );

}

Object.assign( Box2.prototype, {

	set: function ( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	},

	setFromPoints: function ( points ) {

		this.makeEmpty();

		for ( var i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	},

	setFromCenterAndSize: function () {

		var v1 = new Vector2();

		return function setFromCenterAndSize( center, size ) {

			var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
			this.min.copy( center ).sub( halfSize );
			this.max.copy( center ).add( halfSize );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	},

	makeEmpty: function () {

		this.min.x = this.min.y = + Infinity;
		this.max.x = this.max.y = - Infinity;

		return this;

	},

	isEmpty: function () {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	},

	getSize: function ( optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );

	},

	expandByPoint: function ( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	},

	expandByVector: function ( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	},

	expandByScalar: function ( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	},

	containsPoint: function ( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ? false : true;

	},

	containsBox: function ( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y;

	},

	getParameter: function ( point, optionalTarget ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		var result = optionalTarget || new Vector2();

		return result.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y )
		);

	},

	intersectsBox: function ( box ) {

		// using 4 splitting planes to rule out intersections

		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

	},

	clampPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return result.copy( point ).clamp( this.min, this.max );

	},

	distanceToPoint: function () {

		var v1 = new Vector2();

		return function distanceToPoint( point ) {

			var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
			return clampedPoint.sub( point ).length();

		};

	}(),

	intersect: function ( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		return this;

	},

	union: function ( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	},

	translate: function ( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	},

	equals: function ( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function WebGLFlareRenderer( renderer, gl, state, textures, capabilities ) {

	var vertexBuffer, elementBuffer;
	var shader, program, attributes, uniforms;

	var tempTexture, occlusionTexture;

	function init() {

		var vertices = new Float32Array( [
			- 1, - 1, 0, 0,
			  1, - 1, 1, 0,
			  1, 1, 1, 1,
			- 1, 1, 0, 1
		] );

		var faces = new Uint16Array( [
			0, 1, 2,
			0, 2, 3
		] );

		// buffers

		vertexBuffer = gl.createBuffer();
		elementBuffer = gl.createBuffer();

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
		gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

		// textures

		tempTexture = gl.createTexture();
		occlusionTexture = gl.createTexture();

		state.bindTexture( gl.TEXTURE_2D, tempTexture );
		gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

		state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
		gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

		shader = {

			vertexShader: [

				'uniform lowp int renderType;',

				'uniform vec3 screenPosition;',
				'uniform vec2 scale;',
				'uniform float rotation;',

				'uniform sampler2D occlusionMap;',

				'attribute vec2 position;',
				'attribute vec2 uv;',

				'varying vec2 vUV;',
				'varying float vVisibility;',

				'void main() {',

				'	vUV = uv;',

				'	vec2 pos = position;',

				'	if ( renderType == 2 ) {',

				'		vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );',
				'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );',

				'		vVisibility =        visibility.r / 9.0;',
				'		vVisibility *= 1.0 - visibility.g / 9.0;',
				'		vVisibility *=       visibility.b / 9.0;',
				'		vVisibility *= 1.0 - visibility.a / 9.0;',

				'		pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;',
				'		pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;',

				'	}',

				'	gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );',

				'}'

			].join( '\n' ),

			fragmentShader: [

				'uniform lowp int renderType;',

				'uniform sampler2D map;',
				'uniform float opacity;',
				'uniform vec3 color;',

				'varying vec2 vUV;',
				'varying float vVisibility;',

				'void main() {',

				// pink square

				'	if ( renderType == 0 ) {',

				'		gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );',

				// restore

				'	} else if ( renderType == 1 ) {',

				'		gl_FragColor = texture2D( map, vUV );',

				// flare

				'	} else {',

				'		vec4 texture = texture2D( map, vUV );',
				'		texture.a *= opacity * vVisibility;',
				'		gl_FragColor = texture;',
				'		gl_FragColor.rgb *= color;',

				'	}',

				'}'

			].join( '\n' )

		};

		program = createProgram( shader );

		attributes = {
			vertex: gl.getAttribLocation( program, 'position' ),
			uv: gl.getAttribLocation( program, 'uv' )
		};

		uniforms = {
			renderType: gl.getUniformLocation( program, 'renderType' ),
			map: gl.getUniformLocation( program, 'map' ),
			occlusionMap: gl.getUniformLocation( program, 'occlusionMap' ),
			opacity: gl.getUniformLocation( program, 'opacity' ),
			color: gl.getUniformLocation( program, 'color' ),
			scale: gl.getUniformLocation( program, 'scale' ),
			rotation: gl.getUniformLocation( program, 'rotation' ),
			screenPosition: gl.getUniformLocation( program, 'screenPosition' )
		};

	}

	/*
	 * Render lens flares
	 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
	 *         reads these back and calculates occlusion.
	 */

	this.render = function ( flares, scene, camera, viewport ) {

		if ( flares.length === 0 ) return;

		var tempPosition = new Vector3();

		var invAspect = viewport.w / viewport.z,
			halfViewportWidth = viewport.z * 0.5,
			halfViewportHeight = viewport.w * 0.5;

		var size = 16 / viewport.w,
			scale = new Vector2( size * invAspect, size );

		var screenPosition = new Vector3( 1, 1, 0 ),
			screenPositionPixels = new Vector2( 1, 1 );

		var validArea = new Box2();

		validArea.min.set( viewport.x, viewport.y );
		validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );

		if ( program === undefined ) {

			init();

		}

		state.useProgram( program );

		state.initAttributes();
		state.enableAttribute( attributes.vertex );
		state.enableAttribute( attributes.uv );
		state.disableUnusedAttributes();

		// loop through all lens flares to update their occlusion and positions
		// setup gl and common used attribs/uniforms

		gl.uniform1i( uniforms.occlusionMap, 0 );
		gl.uniform1i( uniforms.map, 1 );

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
		gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

		state.disable( gl.CULL_FACE );
		state.buffers.depth.setMask( false );

		for ( var i = 0, l = flares.length; i < l; i ++ ) {

			size = 16 / viewport.w;
			scale.set( size * invAspect, size );

			// calc object screen position

			var flare = flares[ i ];

			tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );

			tempPosition.applyMatrix4( camera.matrixWorldInverse );
			tempPosition.applyMatrix4( camera.projectionMatrix );

			// setup arrays for gl programs

			screenPosition.copy( tempPosition );

			// horizontal and vertical coordinate of the lower left corner of the pixels to copy

			screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
			screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;

			// screen cull

			if ( validArea.containsPoint( screenPositionPixels ) === true ) {

				// save current RGB to temp texture

				state.activeTexture( gl.TEXTURE0 );
				state.bindTexture( gl.TEXTURE_2D, null );
				state.activeTexture( gl.TEXTURE1 );
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


				// render pink quad

				gl.uniform1i( uniforms.renderType, 0 );
				gl.uniform2f( uniforms.scale, scale.x, scale.y );
				gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );

				state.disable( gl.BLEND );
				state.enable( gl.DEPTH_TEST );

				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


				// copy result to occlusionMap

				state.activeTexture( gl.TEXTURE0 );
				state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
				gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


				// restore graphics

				gl.uniform1i( uniforms.renderType, 1 );
				state.disable( gl.DEPTH_TEST );

				state.activeTexture( gl.TEXTURE1 );
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


				// update object positions

				flare.positionScreen.copy( screenPosition );

				if ( flare.customUpdateCallback ) {

					flare.customUpdateCallback( flare );

				} else {

					flare.updateLensFlares();

				}

				// render flares

				gl.uniform1i( uniforms.renderType, 2 );
				state.enable( gl.BLEND );

				for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {

					var sprite = flare.lensFlares[ j ];

					if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {

						screenPosition.x = sprite.x;
						screenPosition.y = sprite.y;
						screenPosition.z = sprite.z;

						size = sprite.size * sprite.scale / viewport.w;

						scale.x = size * invAspect;
						scale.y = size;

						gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
						gl.uniform2f( uniforms.scale, scale.x, scale.y );
						gl.uniform1f( uniforms.rotation, sprite.rotation );

						gl.uniform1f( uniforms.opacity, sprite.opacity );
						gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );

						state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );

						textures.setTexture2D( sprite.texture, 1 );

						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

					}

				}

			}

		}

		// restore gl

		state.enable( gl.CULL_FACE );
		state.enable( gl.DEPTH_TEST );
		state.buffers.depth.setMask( true );

		state.reset();

	};

	function createProgram( shader ) {

		var program = gl.createProgram();

		var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
		var vertexShader = gl.createShader( gl.VERTEX_SHADER );

		var prefix = 'precision ' + capabilities.precision + ' float;\n';

		gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
		gl.shaderSource( vertexShader, prefix + shader.vertexShader );

		gl.compileShader( fragmentShader );
		gl.compileShader( vertexShader );

		gl.attachShader( program, fragmentShader );
		gl.attachShader( program, vertexShader );

		gl.linkProgram( program );

		return program;

	}

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

	Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.needsUpdate = true;

}

CanvasTexture.prototype = Object.create( Texture.prototype );
CanvasTexture.prototype.constructor = CanvasTexture;

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function WebGLSpriteRenderer( renderer, gl, state, textures, capabilities ) {

	var vertexBuffer, elementBuffer;
	var program, attributes, uniforms;

	var texture;

	// decompose matrixWorld

	var spritePosition = new Vector3();
	var spriteRotation = new Quaternion();
	var spriteScale = new Vector3();

	function init() {

		var vertices = new Float32Array( [
			- 0.5, - 0.5, 0, 0,
			  0.5, - 0.5, 1, 0,
			  0.5, 0.5, 1, 1,
			- 0.5, 0.5, 0, 1
		] );

		var faces = new Uint16Array( [
			0, 1, 2,
			0, 2, 3
		] );

		vertexBuffer = gl.createBuffer();
		elementBuffer = gl.createBuffer();

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
		gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

		program = createProgram();

		attributes = {
			position: gl.getAttribLocation( program, 'position' ),
			uv: gl.getAttribLocation( program, 'uv' )
		};

		uniforms = {
			uvOffset: gl.getUniformLocation( program, 'uvOffset' ),
			uvScale: gl.getUniformLocation( program, 'uvScale' ),

			rotation: gl.getUniformLocation( program, 'rotation' ),
			scale: gl.getUniformLocation( program, 'scale' ),

			color: gl.getUniformLocation( program, 'color' ),
			map: gl.getUniformLocation( program, 'map' ),
			opacity: gl.getUniformLocation( program, 'opacity' ),

			modelViewMatrix: gl.getUniformLocation( program, 'modelViewMatrix' ),
			projectionMatrix: gl.getUniformLocation( program, 'projectionMatrix' ),

			fogType: gl.getUniformLocation( program, 'fogType' ),
			fogDensity: gl.getUniformLocation( program, 'fogDensity' ),
			fogNear: gl.getUniformLocation( program, 'fogNear' ),
			fogFar: gl.getUniformLocation( program, 'fogFar' ),
			fogColor: gl.getUniformLocation( program, 'fogColor' ),
			fogDepth: gl.getUniformLocation( program, 'fogDepth' ),

			alphaTest: gl.getUniformLocation( program, 'alphaTest' )
		};

		var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
		canvas.width = 8;
		canvas.height = 8;

		var context = canvas.getContext( '2d' );
		context.fillStyle = 'white';
		context.fillRect( 0, 0, 8, 8 );

		texture = new CanvasTexture( canvas );

	}

	this.render = function ( sprites, scene, camera ) {

		if ( sprites.length === 0 ) return;

		// setup gl

		if ( program === undefined ) {

			init();

		}

		state.useProgram( program );

		state.initAttributes();
		state.enableAttribute( attributes.position );
		state.enableAttribute( attributes.uv );
		state.disableUnusedAttributes();

		state.disable( gl.CULL_FACE );
		state.enable( gl.BLEND );

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
		gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

		gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );

		state.activeTexture( gl.TEXTURE0 );
		gl.uniform1i( uniforms.map, 0 );

		var oldFogType = 0;
		var sceneFogType = 0;
		var fog = scene.fog;

		if ( fog ) {

			gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );

			if ( fog.isFog ) {

				gl.uniform1f( uniforms.fogNear, fog.near );
				gl.uniform1f( uniforms.fogFar, fog.far );

				gl.uniform1i( uniforms.fogType, 1 );
				oldFogType = 1;
				sceneFogType = 1;

			} else if ( fog.isFogExp2 ) {

				gl.uniform1f( uniforms.fogDensity, fog.density );

				gl.uniform1i( uniforms.fogType, 2 );
				oldFogType = 2;
				sceneFogType = 2;

			}

		} else {

			gl.uniform1i( uniforms.fogType, 0 );
			oldFogType = 0;
			sceneFogType = 0;

		}


		// update positions and sort

		for ( var i = 0, l = sprites.length; i < l; i ++ ) {

			var sprite = sprites[ i ];

			sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
			sprite.z = - sprite.modelViewMatrix.elements[ 14 ];

		}

		sprites.sort( painterSortStable );

		// render all sprites

		var scale = [];

		for ( var i = 0, l = sprites.length; i < l; i ++ ) {

			var sprite = sprites[ i ];
			var material = sprite.material;

			if ( material.visible === false ) continue;

			sprite.onBeforeRender( renderer, scene, camera, undefined, material, undefined );

			gl.uniform1f( uniforms.alphaTest, material.alphaTest );
			gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );

			sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );

			scale[ 0 ] = spriteScale.x;
			scale[ 1 ] = spriteScale.y;

			var fogType = 0;

			if ( scene.fog && material.fog ) {

				fogType = sceneFogType;

			}

			if ( oldFogType !== fogType ) {

				gl.uniform1i( uniforms.fogType, fogType );
				oldFogType = fogType;

			}

			if ( material.map !== null ) {

				gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
				gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );

			} else {

				gl.uniform2f( uniforms.uvOffset, 0, 0 );
				gl.uniform2f( uniforms.uvScale, 1, 1 );

			}

			gl.uniform1f( uniforms.opacity, material.opacity );
			gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );

			gl.uniform1f( uniforms.rotation, material.rotation );
			gl.uniform2fv( uniforms.scale, scale );

			state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha );
			state.buffers.depth.setTest( material.depthTest );
			state.buffers.depth.setMask( material.depthWrite );
			state.buffers.color.setMask( material.colorWrite );

			textures.setTexture2D( material.map || texture, 0 );

			gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

			sprite.onAfterRender( renderer, scene, camera, undefined, material, undefined );

		}

		// restore gl

		state.enable( gl.CULL_FACE );

		state.reset();

	};

	function createProgram() {

		var program = gl.createProgram();

		var vertexShader = gl.createShader( gl.VERTEX_SHADER );
		var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

		gl.shaderSource( vertexShader, [

			'precision ' + capabilities.precision + ' float;',

			'#define SHADER_NAME ' + 'SpriteMaterial',

			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform float rotation;',
			'uniform vec2 scale;',
			'uniform vec2 uvOffset;',
			'uniform vec2 uvScale;',

			'attribute vec2 position;',
			'attribute vec2 uv;',

			'varying vec2 vUV;',
			'varying float fogDepth;',

			'void main() {',

			'	vUV = uvOffset + uv * uvScale;',

			'	vec2 alignedPosition = position * scale;',

			'	vec2 rotatedPosition;',
			'	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
			'	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',

			'	vec4 mvPosition;',

			'	mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
			'	mvPosition.xy += rotatedPosition;',

			'	gl_Position = projectionMatrix * mvPosition;',

			'	fogDepth = - mvPosition.z;',

			'}'

		].join( '\n' ) );

		gl.shaderSource( fragmentShader, [

			'precision ' + capabilities.precision + ' float;',

			'#define SHADER_NAME ' + 'SpriteMaterial',

			'uniform vec3 color;',
			'uniform sampler2D map;',
			'uniform float opacity;',

			'uniform int fogType;',
			'uniform vec3 fogColor;',
			'uniform float fogDensity;',
			'uniform float fogNear;',
			'uniform float fogFar;',
			'uniform float alphaTest;',

			'varying vec2 vUV;',
			'varying float fogDepth;',

			'void main() {',

			'	vec4 texture = texture2D( map, vUV );',

			'	gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',

			'	if ( gl_FragColor.a < alphaTest ) discard;',

			'	if ( fogType > 0 ) {',

			'		float fogFactor = 0.0;',

			'		if ( fogType == 1 ) {',

			'			fogFactor = smoothstep( fogNear, fogFar, fogDepth );',

			'		} else {',

			'			const float LOG2 = 1.442695;',
			'			fogFactor = exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 );',
			'			fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',

			'		}',

			'		gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );',

			'	}',

			'}'

		].join( '\n' ) );

		gl.compileShader( vertexShader );
		gl.compileShader( fragmentShader );

		gl.attachShader( program, vertexShader );
		gl.attachShader( program, fragmentShader );

		gl.linkProgram( program );

		return program;

	}

	function painterSortStable( a, b ) {

		if ( a.renderOrder !== b.renderOrder ) {

			return a.renderOrder - b.renderOrder;

		} else if ( a.z !== b.z ) {

			return b.z - a.z;

		} else {

			return b.id - a.id;

		}

	}

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

var materialId = 0;

function Material() {

	Object.defineProperty( this, 'id', { value: materialId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Material';

	this.fog = true;
	this.lights = true;

	this.blending = NormalBlending;
	this.side = FrontSide;
	this.flatShading = false;
	this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors

	this.opacity = 1;
	this.transparent = false;

	this.blendSrc = SrcAlphaFactor;
	this.blendDst = OneMinusSrcAlphaFactor;
	this.blendEquation = AddEquation;
	this.blendSrcAlpha = null;
	this.blendDstAlpha = null;
	this.blendEquationAlpha = null;

	this.depthFunc = LessEqualDepth;
	this.depthTest = true;
	this.depthWrite = true;

	this.clippingPlanes = null;
	this.clipIntersection = false;
	this.clipShadows = false;

	this.colorWrite = true;

	this.precision = null; // override the renderer's default precision for this material

	this.polygonOffset = false;
	this.polygonOffsetFactor = 0;
	this.polygonOffsetUnits = 0;

	this.dithering = false;

	this.alphaTest = 0;
	this.premultipliedAlpha = false;

	this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer

	this.visible = true;

	this.userData = {};

	this.needsUpdate = true;

}

Material.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: Material,

	isMaterial: true,

	onBeforeCompile: function () {},

	setValues: function ( values ) {

		if ( values === undefined ) return;

		for ( var key in values ) {

			var newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
				continue;

			}

			// for backward compatability if shading is set in the constructor
			if ( key === 'shading' ) {

				console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
				this.flatShading = ( newValue === FlatShading ) ? true : false;
				continue;

			}

			var currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

				currentValue.copy( newValue );

			} else if ( key === 'overdraw' ) {

				// ensure overdraw is backwards-compatible with legacy boolean type
				this[ key ] = Number( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	},

	toJSON: function ( meta ) {

		var isRoot = ( meta === undefined || typeof meta === 'string' );

		if ( isRoot ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		var data = {
			metadata: {
				version: 4.5,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;

		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
		if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
		if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}
		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalScale = this.normalScale.toArray();

		}
		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}
		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;
			data.reflectivity = this.reflectivity; // Scale behind envMap

		}

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending ) data.blending = this.blending;
		if ( this.flatShading === true ) data.flatShading = this.flatShading;
		if ( this.side !== FrontSide ) data.side = this.side;
		if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = this.transparent;

		data.depthFunc = this.depthFunc;
		data.depthTest = this.depthTest;
		data.depthWrite = this.depthWrite;

		// rotation (SpriteMaterial)
		if ( this.rotation !== 0 ) data.rotation = this.rotation;

		if ( this.linewidth !== 1 ) data.linewidth = this.linewidth;
		if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
		if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
		if ( this.scale !== undefined ) data.scale = this.scale;

		if ( this.dithering === true ) data.dithering = true;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;

		if ( this.wireframe === true ) data.wireframe = this.wireframe;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		if ( this.morphTargets === true ) data.morphTargets = true;
		if ( this.skinning === true ) data.skinning = true;

		if ( this.visible === false ) data.visible = false;
		if ( JSON.stringify( this.userData ) !== '{}' ) data.userData = this.userData;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			var values = [];

			for ( var key in cache ) {

				var data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRoot ) {

			var textures = extractFromCache( meta.textures );
			var images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.name = source.name;

		this.fog = source.fog;
		this.lights = source.lights;

		this.blending = source.blending;
		this.side = source.side;
		this.flatShading = source.flatShading;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.dithering = source.dithering;

		this.alphaTest = source.alphaTest;
		this.premultipliedAlpha = source.premultipliedAlpha;

		this.overdraw = source.overdraw;

		this.visible = source.visible;
		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		this.clipShadows = source.clipShadows;
		this.clipIntersection = source.clipIntersection;

		var srcPlanes = source.clippingPlanes,
			dstPlanes = null;

		if ( srcPlanes !== null ) {

			var n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( var i = 0; i !== n; ++ i )
				dstPlanes[ i ] = srcPlanes[ i ].clone();

		}

		this.clippingPlanes = dstPlanes;

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author bhouston / https://clara.io
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */

function MeshDepthMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshDepthMaterial';

	this.depthPacking = BasicDepthPacking;

	this.skinning = false;
	this.morphTargets = false;

	this.map = null;

	this.alphaMap = null;

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false;
	this.lights = false;

	this.setValues( parameters );

}

MeshDepthMaterial.prototype = Object.create( Material.prototype );
MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;

MeshDepthMaterial.prototype.isMeshDepthMaterial = true;

MeshDepthMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.depthPacking = source.depthPacking;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;

	this.map = source.map;

	this.alphaMap = source.alphaMap;

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	return this;

};

/**
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */

function MeshDistanceMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshDistanceMaterial';

	this.referencePosition = new Vector3();
	this.nearDistance = 1;
	this.farDistance = 1000;

	this.skinning = false;
	this.morphTargets = false;

	this.map = null;

	this.alphaMap = null;

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.fog = false;
	this.lights = false;

	this.setValues( parameters );

}

MeshDistanceMaterial.prototype = Object.create( Material.prototype );
MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;

MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;

MeshDistanceMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.referencePosition.copy( source.referencePosition );
	this.nearDistance = source.nearDistance;
	this.farDistance = source.farDistance;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;

	this.map = source.map;

	this.alphaMap = source.alphaMap;

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	return this;

};

/**
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 */

function Box3( min, max ) {

	this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
	this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );

}

Object.assign( Box3.prototype, {

	isBox3: true,

	set: function ( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	},

	setFromArray: function ( array ) {

		var minX = + Infinity;
		var minY = + Infinity;
		var minZ = + Infinity;

		var maxX = - Infinity;
		var maxY = - Infinity;
		var maxZ = - Infinity;

		for ( var i = 0, l = array.length; i < l; i += 3 ) {

			var x = array[ i ];
			var y = array[ i + 1 ];
			var z = array[ i + 2 ];

			if ( x < minX ) minX = x;
			if ( y < minY ) minY = y;
			if ( z < minZ ) minZ = z;

			if ( x > maxX ) maxX = x;
			if ( y > maxY ) maxY = y;
			if ( z > maxZ ) maxZ = z;

		}

		this.min.set( minX, minY, minZ );
		this.max.set( maxX, maxY, maxZ );

		return this;

	},

	setFromBufferAttribute: function ( attribute ) {

		var minX = + Infinity;
		var minY = + Infinity;
		var minZ = + Infinity;

		var maxX = - Infinity;
		var maxY = - Infinity;
		var maxZ = - Infinity;

		for ( var i = 0, l = attribute.count; i < l; i ++ ) {

			var x = attribute.getX( i );
			var y = attribute.getY( i );
			var z = attribute.getZ( i );

			if ( x < minX ) minX = x;
			if ( y < minY ) minY = y;
			if ( z < minZ ) minZ = z;

			if ( x > maxX ) maxX = x;
			if ( y > maxY ) maxY = y;
			if ( z > maxZ ) maxZ = z;

		}

		this.min.set( minX, minY, minZ );
		this.max.set( maxX, maxY, maxZ );

		return this;

	},

	setFromPoints: function ( points ) {

		this.makeEmpty();

		for ( var i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	},

	setFromCenterAndSize: function () {

		var v1 = new Vector3();

		return function setFromCenterAndSize( center, size ) {

			var halfSize = v1.copy( size ).multiplyScalar( 0.5 );

			this.min.copy( center ).sub( halfSize );
			this.max.copy( center ).add( halfSize );

			return this;

		};

	}(),

	setFromObject: function ( object ) {

		this.makeEmpty();

		return this.expandByObject( object );

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	},

	makeEmpty: function () {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	},

	isEmpty: function () {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	},

	getSize: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );

	},

	expandByPoint: function ( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	},

	expandByVector: function ( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	},

	expandByScalar: function ( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	},

	expandByObject: function () {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		var scope, i, l;

		var v1 = new Vector3();

		function traverse( node ) {

			var geometry = node.geometry;

			if ( geometry !== undefined ) {

				if ( geometry.isGeometry ) {

					var vertices = geometry.vertices;

					for ( i = 0, l = vertices.length; i < l; i ++ ) {

						v1.copy( vertices[ i ] );
						v1.applyMatrix4( node.matrixWorld );

						scope.expandByPoint( v1 );

					}

				} else if ( geometry.isBufferGeometry ) {

					var attribute = geometry.attributes.position;

					if ( attribute !== undefined ) {

						for ( i = 0, l = attribute.count; i < l; i ++ ) {

							v1.fromBufferAttribute( attribute, i ).applyMatrix4( node.matrixWorld );

							scope.expandByPoint( v1 );

						}

					}

				}

			}

		}

		return function expandByObject( object ) {

			scope = this;

			object.updateMatrixWorld( true );

			object.traverse( traverse );

			return this;

		};

	}(),

	containsPoint: function ( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	},

	containsBox: function ( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	},

	getParameter: function ( point, optionalTarget ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		var result = optionalTarget || new Vector3();

		return result.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	},

	intersectsBox: function ( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	},

	intersectsSphere: ( function () {

		var closestPoint = new Vector3();

		return function intersectsSphere( sphere ) {

			// Find the point on the AABB closest to the sphere center.
			this.clampPoint( sphere.center, closestPoint );

			// If that point is inside the sphere, the AABB and sphere intersect.
			return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

		};

	} )(),

	intersectsPlane: function ( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		var min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= plane.constant && max >= plane.constant );

	},

	clampPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.copy( point ).clamp( this.min, this.max );

	},

	distanceToPoint: function () {

		var v1 = new Vector3();

		return function distanceToPoint( point ) {

			var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
			return clampedPoint.sub( point ).length();

		};

	}(),

	getBoundingSphere: function () {

		var v1 = new Vector3();

		return function getBoundingSphere( optionalTarget ) {

			var result = optionalTarget || new Sphere();

			this.getCenter( result.center );

			result.radius = this.getSize( v1 ).length() * 0.5;

			return result;

		};

	}(),

	intersect: function ( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	},

	union: function ( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	},

	applyMatrix4: function () {

		var points = [
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3()
		];

		return function applyMatrix4( matrix ) {

			// transform of empty box is an empty box.
			if ( this.isEmpty() ) return this;

			// NOTE: I am using a binary pattern to specify all 2^3 combinations below
			points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
			points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
			points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
			points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
			points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
			points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
			points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
			points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111

			this.setFromPoints( points );

			return this;

		};

	}(),

	translate: function ( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	},

	equals: function ( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

} );

/**
 * @author bhouston / http://clara.io
 * @author mrdoob / http://mrdoob.com/
 */

function Sphere( center, radius ) {

	this.center = ( center !== undefined ) ? center : new Vector3();
	this.radius = ( radius !== undefined ) ? radius : 0;

}

Object.assign( Sphere.prototype, {

	set: function ( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	},

	setFromPoints: function () {

		var box = new Box3();

		return function setFromPoints( points, optionalCenter ) {

			var center = this.center;

			if ( optionalCenter !== undefined ) {

				center.copy( optionalCenter );

			} else {

				box.setFromPoints( points ).getCenter( center );

			}

			var maxRadiusSq = 0;

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

			}

			this.radius = Math.sqrt( maxRadiusSq );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	},

	empty: function () {

		return ( this.radius <= 0 );

	},

	containsPoint: function ( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	},

	distanceToPoint: function ( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	},

	intersectsSphere: function ( sphere ) {

		var radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	},

	intersectsBox: function ( box ) {

		return box.intersectsSphere( this );

	},

	intersectsPlane: function ( plane ) {

		return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

	},

	clampPoint: function ( point, optionalTarget ) {

		var deltaLengthSq = this.center.distanceToSquared( point );

		var result = optionalTarget || new Vector3();

		result.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			result.sub( this.center ).normalize();
			result.multiplyScalar( this.radius ).add( this.center );

		}

		return result;

	},

	getBoundingBox: function ( optionalTarget ) {

		var box = optionalTarget || new Box3();

		box.set( this.center, this.center );
		box.expandByScalar( this.radius );

		return box;

	},

	applyMatrix4: function ( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	},

	translate: function ( offset ) {

		this.center.add( offset );

		return this;

	},

	equals: function ( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

} );

/**
 * @author bhouston / http://clara.io
 */

function Plane( normal, constant ) {

	// normal is assumed to be normalized

	this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
	this.constant = ( constant !== undefined ) ? constant : 0;

}

Object.assign( Plane.prototype, {

	set: function ( normal, constant ) {

		this.normal.copy( normal );
		this.constant = constant;

		return this;

	},

	setComponents: function ( x, y, z, w ) {

		this.normal.set( x, y, z );
		this.constant = w;

		return this;

	},

	setFromNormalAndCoplanarPoint: function ( normal, point ) {

		this.normal.copy( normal );
		this.constant = - point.dot( this.normal );

		return this;

	},

	setFromCoplanarPoints: function () {

		var v1 = new Vector3();
		var v2 = new Vector3();

		return function setFromCoplanarPoints( a, b, c ) {

			var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();

			// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

			this.setFromNormalAndCoplanarPoint( normal, a );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( plane ) {

		this.normal.copy( plane.normal );
		this.constant = plane.constant;

		return this;

	},

	normalize: function () {

		// Note: will lead to a divide by zero if the plane is invalid.

		var inverseNormalLength = 1.0 / this.normal.length();
		this.normal.multiplyScalar( inverseNormalLength );
		this.constant *= inverseNormalLength;

		return this;

	},

	negate: function () {

		this.constant *= - 1;
		this.normal.negate();

		return this;

	},

	distanceToPoint: function ( point ) {

		return this.normal.dot( point ) + this.constant;

	},

	distanceToSphere: function ( sphere ) {

		return this.distanceToPoint( sphere.center ) - sphere.radius;

	},

	projectPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return result.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );

	},

	intersectLine: function () {

		var v1 = new Vector3();

		return function intersectLine( line, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			var direction = line.delta( v1 );

			var denominator = this.normal.dot( direction );

			if ( denominator === 0 ) {

				// line is coplanar, return origin
				if ( this.distanceToPoint( line.start ) === 0 ) {

					return result.copy( line.start );

				}

				// Unsure if this is the correct method to handle this case.
				return undefined;

			}

			var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

			if ( t < 0 || t > 1 ) {

				return undefined;

			}

			return result.copy( direction ).multiplyScalar( t ).add( line.start );

		};

	}(),

	intersectsLine: function ( line ) {

		// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

		var startSign = this.distanceToPoint( line.start );
		var endSign = this.distanceToPoint( line.end );

		return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

	},

	intersectsBox: function ( box ) {

		return box.intersectsPlane( this );

	},

	intersectsSphere: function ( sphere ) {

		return sphere.intersectsPlane( this );

	},

	coplanarPoint: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return result.copy( this.normal ).multiplyScalar( - this.constant );

	},

	applyMatrix4: function () {

		var v1 = new Vector3();
		var m1 = new Matrix3();

		return function applyMatrix4( matrix, optionalNormalMatrix ) {

			var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );

			var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );

			var normal = this.normal.applyMatrix3( normalMatrix ).normalize();

			this.constant = - referencePoint.dot( normal );

			return this;

		};

	}(),

	translate: function ( offset ) {

		this.constant -= offset.dot( this.normal );

		return this;

	},

	equals: function ( plane ) {

		return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author bhouston / http://clara.io
 */

function Frustum( p0, p1, p2, p3, p4, p5 ) {

	this.planes = [

		( p0 !== undefined ) ? p0 : new Plane(),
		( p1 !== undefined ) ? p1 : new Plane(),
		( p2 !== undefined ) ? p2 : new Plane(),
		( p3 !== undefined ) ? p3 : new Plane(),
		( p4 !== undefined ) ? p4 : new Plane(),
		( p5 !== undefined ) ? p5 : new Plane()

	];

}

Object.assign( Frustum.prototype, {

	set: function ( p0, p1, p2, p3, p4, p5 ) {

		var planes = this.planes;

		planes[ 0 ].copy( p0 );
		planes[ 1 ].copy( p1 );
		planes[ 2 ].copy( p2 );
		planes[ 3 ].copy( p3 );
		planes[ 4 ].copy( p4 );
		planes[ 5 ].copy( p5 );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( frustum ) {

		var planes = this.planes;

		for ( var i = 0; i < 6; i ++ ) {

			planes[ i ].copy( frustum.planes[ i ] );

		}

		return this;

	},

	setFromMatrix: function ( m ) {

		var planes = this.planes;
		var me = m.elements;
		var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
		var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
		var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
		var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

		planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
		planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
		planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
		planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
		planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
		planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

		return this;

	},

	intersectsObject: function () {

		var sphere = new Sphere();

		return function intersectsObject( object ) {

			var geometry = object.geometry;

			if ( geometry.boundingSphere === null )
				geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere )
				.applyMatrix4( object.matrixWorld );

			return this.intersectsSphere( sphere );

		};

	}(),

	intersectsSprite: function () {

		var sphere = new Sphere();

		return function intersectsSprite( sprite ) {

			sphere.center.set( 0, 0, 0 );
			sphere.radius = 0.7071067811865476;
			sphere.applyMatrix4( sprite.matrixWorld );

			return this.intersectsSphere( sphere );

		};

	}(),

	intersectsSphere: function ( sphere ) {

		var planes = this.planes;
		var center = sphere.center;
		var negRadius = - sphere.radius;

		for ( var i = 0; i < 6; i ++ ) {

			var distance = planes[ i ].distanceToPoint( center );

			if ( distance < negRadius ) {

				return false;

			}

		}

		return true;

	},

	intersectsBox: function () {

		var p1 = new Vector3(),
			p2 = new Vector3();

		return function intersectsBox( box ) {

			var planes = this.planes;

			for ( var i = 0; i < 6; i ++ ) {

				var plane = planes[ i ];

				p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
				p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
				p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
				p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
				p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
				p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;

				var d1 = plane.distanceToPoint( p1 );
				var d2 = plane.distanceToPoint( p2 );

				// if both outside plane, no intersection

				if ( d1 < 0 && d2 < 0 ) {

					return false;

				}

			}

			return true;

		};

	}(),

	containsPoint: function ( point ) {

		var planes = this.planes;

		for ( var i = 0; i < 6; i ++ ) {

			if ( planes[ i ].distanceToPoint( point ) < 0 ) {

				return false;

			}

		}

		return true;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLShadowMap( _renderer, _objects, maxTextureSize ) {

	var _frustum = new Frustum(),
		_projScreenMatrix = new Matrix4(),

		_shadowMapSize = new Vector2(),
		_maxShadowMapSize = new Vector2( maxTextureSize, maxTextureSize ),

		_lookTarget = new Vector3(),
		_lightPositionWorld = new Vector3(),

		_MorphingFlag = 1,
		_SkinningFlag = 2,

		_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,

		_depthMaterials = new Array( _NumberOfMaterialVariants ),
		_distanceMaterials = new Array( _NumberOfMaterialVariants ),

		_materialCache = {};

	var cubeDirections = [
		new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
		new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
	];

	var cubeUps = [
		new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
		new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
	];

	var cube2DViewPorts = [
		new Vector4(), new Vector4(), new Vector4(),
		new Vector4(), new Vector4(), new Vector4()
	];

	// init

	for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {

		var useMorphing = ( i & _MorphingFlag ) !== 0;
		var useSkinning = ( i & _SkinningFlag ) !== 0;

		var depthMaterial = new MeshDepthMaterial( {

			depthPacking: RGBADepthPacking,

			morphTargets: useMorphing,
			skinning: useSkinning

		} );

		_depthMaterials[ i ] = depthMaterial;

		//

		var distanceMaterial = new MeshDistanceMaterial( {

			morphTargets: useMorphing,
			skinning: useSkinning

		} );

		_distanceMaterials[ i ] = distanceMaterial;

	}

	//

	var scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;

	this.renderReverseSided = true;
	this.renderSingleSided = true;

	this.render = function ( lights, scene, camera ) {

		if ( scope.enabled === false ) return;
		if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

		if ( lights.length === 0 ) return;

		// TODO Clean up (needed in case of contextlost)
		var _gl = _renderer.context;
		var _state = _renderer.state;

		// Set GL state for depth map.
		_state.disable( _gl.BLEND );
		_state.buffers.color.setClear( 1, 1, 1, 1 );
		_state.buffers.depth.setTest( true );
		_state.setScissorTest( false );

		// render depth map

		var faceCount;

		for ( var i = 0, il = lights.length; i < il; i ++ ) {

			var light = lights[ i ];
			var shadow = light.shadow;
			var isPointLight = light && light.isPointLight;

			if ( shadow === undefined ) {

				console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
				continue;

			}

			var shadowCamera = shadow.camera;

			_shadowMapSize.copy( shadow.mapSize );
			_shadowMapSize.min( _maxShadowMapSize );

			if ( isPointLight ) {

				var vpWidth = _shadowMapSize.x;
				var vpHeight = _shadowMapSize.y;

				// These viewports map a cube-map onto a 2D texture with the
				// following orientation:
				//
				//  xzXZ
				//   y Y
				//
				// X - Positive x direction
				// x - Negative x direction
				// Y - Positive y direction
				// y - Negative y direction
				// Z - Positive z direction
				// z - Negative z direction

				// positive X
				cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
				// negative X
				cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
				// positive Z
				cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
				// negative Z
				cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
				// positive Y
				cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
				// negative Y
				cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );

				_shadowMapSize.x *= 4.0;
				_shadowMapSize.y *= 2.0;

			}

			if ( shadow.map === null ) {

				var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };

				shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
				shadow.map.texture.name = light.name + ".shadowMap";

				shadowCamera.updateProjectionMatrix();

			}

			if ( shadow.isSpotLightShadow ) {

				shadow.update( light );

			}

			var shadowMap = shadow.map;
			var shadowMatrix = shadow.matrix;

			_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
			shadowCamera.position.copy( _lightPositionWorld );

			if ( isPointLight ) {

				faceCount = 6;

				// for point lights we set the shadow matrix to be a translation-only matrix
				// equal to inverse of the light's position

				shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );

			} else {

				faceCount = 1;

				_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
				shadowCamera.lookAt( _lookTarget );
				shadowCamera.updateMatrixWorld();

				// compute shadow matrix

				shadowMatrix.set(
					0.5, 0.0, 0.0, 0.5,
					0.0, 0.5, 0.0, 0.5,
					0.0, 0.0, 0.5, 0.5,
					0.0, 0.0, 0.0, 1.0
				);

				shadowMatrix.multiply( shadowCamera.projectionMatrix );
				shadowMatrix.multiply( shadowCamera.matrixWorldInverse );

			}

			_renderer.setRenderTarget( shadowMap );
			_renderer.clear();

			// render shadow map for each cube face (if omni-directional) or
			// run a single pass if not

			for ( var face = 0; face < faceCount; face ++ ) {

				if ( isPointLight ) {

					_lookTarget.copy( shadowCamera.position );
					_lookTarget.add( cubeDirections[ face ] );
					shadowCamera.up.copy( cubeUps[ face ] );
					shadowCamera.lookAt( _lookTarget );
					shadowCamera.updateMatrixWorld();

					var vpDimensions = cube2DViewPorts[ face ];
					_state.viewport( vpDimensions );

				}

				// update camera matrices and frustum

				_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
				_frustum.setFromMatrix( _projScreenMatrix );

				// set object matrices & frustum culling

				renderObject( scene, camera, shadowCamera, isPointLight );

			}

		}

		scope.needsUpdate = false;

	};

	function getDepthMaterial( object, material, isPointLight, lightPositionWorld, shadowCameraNear, shadowCameraFar ) {

		var geometry = object.geometry;

		var result = null;

		var materialVariants = _depthMaterials;
		var customMaterial = object.customDepthMaterial;

		if ( isPointLight ) {

			materialVariants = _distanceMaterials;
			customMaterial = object.customDistanceMaterial;

		}

		if ( ! customMaterial ) {

			var useMorphing = false;

			if ( material.morphTargets ) {

				if ( geometry && geometry.isBufferGeometry ) {

					useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;

				} else if ( geometry && geometry.isGeometry ) {

					useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;

				}

			}

			if ( object.isSkinnedMesh && material.skinning === false ) {

				console.warn( 'THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object );

			}

			var useSkinning = object.isSkinnedMesh && material.skinning;

			var variantIndex = 0;

			if ( useMorphing ) variantIndex |= _MorphingFlag;
			if ( useSkinning ) variantIndex |= _SkinningFlag;

			result = materialVariants[ variantIndex ];

		} else {

			result = customMaterial;

		}

		if ( _renderer.localClippingEnabled &&
				material.clipShadows === true &&
				material.clippingPlanes.length !== 0 ) {

			// in this case we need a unique material instance reflecting the
			// appropriate state

			var keyA = result.uuid, keyB = material.uuid;

			var materialsForVariant = _materialCache[ keyA ];

			if ( materialsForVariant === undefined ) {

				materialsForVariant = {};
				_materialCache[ keyA ] = materialsForVariant;

			}

			var cachedMaterial = materialsForVariant[ keyB ];

			if ( cachedMaterial === undefined ) {

				cachedMaterial = result.clone();
				materialsForVariant[ keyB ] = cachedMaterial;

			}

			result = cachedMaterial;

		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		var side = material.side;

		if ( scope.renderSingleSided && side == DoubleSide ) {

			side = FrontSide;

		}

		if ( scope.renderReverseSided ) {

			if ( side === FrontSide ) side = BackSide;
			else if ( side === BackSide ) side = FrontSide;

		}

		result.side = side;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;
		result.clipIntersection = material.clipIntersection;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if ( isPointLight && result.isMeshDistanceMaterial ) {

			result.referencePosition.copy( lightPositionWorld );
			result.nearDistance = shadowCameraNear;
			result.farDistance = shadowCameraFar;

		}

		return result;

	}

	function renderObject( object, camera, shadowCamera, isPointLight ) {

		if ( object.visible === false ) return;

		var visible = object.layers.test( camera.layers );

		if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

			if ( object.castShadow && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {

				object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );

				var geometry = _objects.update( object );
				var material = object.material;

				if ( Array.isArray( material ) ) {

					var groups = geometry.groups;

					for ( var k = 0, kl = groups.length; k < kl; k ++ ) {

						var group = groups[ k ];
						var groupMaterial = material[ group.materialIndex ];

						if ( groupMaterial && groupMaterial.visible ) {

							var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

						}

					}

				} else if ( material.visible ) {

					var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
					_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

				}

			}

		}

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			renderObject( children[ i ], camera, shadowCamera, isPointLight );

		}

	}

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLAttributes( gl ) {

	var buffers = {};

	function createBuffer( attribute, bufferType ) {

		var array = attribute.array;
		var usage = attribute.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;

		var buffer = gl.createBuffer();

		gl.bindBuffer( bufferType, buffer );
		gl.bufferData( bufferType, array, usage );

		attribute.onUploadCallback();

		var type = gl.FLOAT;

		if ( array instanceof Float32Array ) {

			type = gl.FLOAT;

		} else if ( array instanceof Float64Array ) {

			console.warn( 'THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.' );

		} else if ( array instanceof Uint16Array ) {

			type = gl.UNSIGNED_SHORT;

		} else if ( array instanceof Int16Array ) {

			type = gl.SHORT;

		} else if ( array instanceof Uint32Array ) {

			type = gl.UNSIGNED_INT;

		} else if ( array instanceof Int32Array ) {

			type = gl.INT;

		} else if ( array instanceof Int8Array ) {

			type = gl.BYTE;

		} else if ( array instanceof Uint8Array ) {

			type = gl.UNSIGNED_BYTE;

		}

		return {
			buffer: buffer,
			type: type,
			bytesPerElement: array.BYTES_PER_ELEMENT,
			version: attribute.version
		};

	}

	function updateBuffer( buffer, attribute, bufferType ) {

		var array = attribute.array;
		var updateRange = attribute.updateRange;

		gl.bindBuffer( bufferType, buffer );

		if ( attribute.dynamic === false ) {

			gl.bufferData( bufferType, array, gl.STATIC_DRAW );

		} else if ( updateRange.count === - 1 ) {

			// Not using update ranges

			gl.bufferSubData( bufferType, 0, array );

		} else if ( updateRange.count === 0 ) {

			console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );

		} else {

			gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
				array.subarray( updateRange.offset, updateRange.offset + updateRange.count ) );

			updateRange.count = - 1; // reset range

		}

	}

	//

	function get( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		return buffers[ attribute.uuid ];

	}

	function remove( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		var data = buffers[ attribute.uuid ];

		if ( data ) {

			gl.deleteBuffer( data.buffer );

			delete buffers[ attribute.uuid ];

		}

	}

	function update( attribute, bufferType ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		var data = buffers[ attribute.uuid ];

		if ( data === undefined ) {

			buffers[ attribute.uuid ] = createBuffer( attribute, bufferType );

		} else if ( data.version < attribute.version ) {

			updateBuffer( data.buffer, attribute, bufferType );

			data.version = attribute.version;

		}

	}

	return {

		get: get,
		remove: remove,
		update: update

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */

function Euler( x, y, z, order ) {

	this._x = x || 0;
	this._y = y || 0;
	this._z = z || 0;
	this._order = order || Euler.DefaultOrder;

}

Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];

Euler.DefaultOrder = 'XYZ';

Object.defineProperties( Euler.prototype, {

	x: {

		get: function () {

			return this._x;

		},

		set: function ( value ) {

			this._x = value;
			this.onChangeCallback();

		}

	},

	y: {

		get: function () {

			return this._y;

		},

		set: function ( value ) {

			this._y = value;
			this.onChangeCallback();

		}

	},

	z: {

		get: function () {

			return this._z;

		},

		set: function ( value ) {

			this._z = value;
			this.onChangeCallback();

		}

	},

	order: {

		get: function () {

			return this._order;

		},

		set: function ( value ) {

			this._order = value;
			this.onChangeCallback();

		}

	}

} );

Object.assign( Euler.prototype, {

	isEuler: true,

	set: function ( x, y, z, order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order || this._order;

		this.onChangeCallback();

		return this;

	},

	clone: function () {

		return new this.constructor( this._x, this._y, this._z, this._order );

	},

	copy: function ( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this.onChangeCallback();

		return this;

	},

	setFromRotationMatrix: function ( m, order, update ) {

		var clamp = _Math.clamp;

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var te = m.elements;
		var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		order = order || this._order;

		if ( order === 'XYZ' ) {

			this._y = Math.asin( clamp( m13, - 1, 1 ) );

			if ( Math.abs( m13 ) < 0.99999 ) {

				this._x = Math.atan2( - m23, m33 );
				this._z = Math.atan2( - m12, m11 );

			} else {

				this._x = Math.atan2( m32, m22 );
				this._z = 0;

			}

		} else if ( order === 'YXZ' ) {

			this._x = Math.asin( - clamp( m23, - 1, 1 ) );

			if ( Math.abs( m23 ) < 0.99999 ) {

				this._y = Math.atan2( m13, m33 );
				this._z = Math.atan2( m21, m22 );

			} else {

				this._y = Math.atan2( - m31, m11 );
				this._z = 0;

			}

		} else if ( order === 'ZXY' ) {

			this._x = Math.asin( clamp( m32, - 1, 1 ) );

			if ( Math.abs( m32 ) < 0.99999 ) {

				this._y = Math.atan2( - m31, m33 );
				this._z = Math.atan2( - m12, m22 );

			} else {

				this._y = 0;
				this._z = Math.atan2( m21, m11 );

			}

		} else if ( order === 'ZYX' ) {

			this._y = Math.asin( - clamp( m31, - 1, 1 ) );

			if ( Math.abs( m31 ) < 0.99999 ) {

				this._x = Math.atan2( m32, m33 );
				this._z = Math.atan2( m21, m11 );

			} else {

				this._x = 0;
				this._z = Math.atan2( - m12, m22 );

			}

		} else if ( order === 'YZX' ) {

			this._z = Math.asin( clamp( m21, - 1, 1 ) );

			if ( Math.abs( m21 ) < 0.99999 ) {

				this._x = Math.atan2( - m23, m22 );
				this._y = Math.atan2( - m31, m11 );

			} else {

				this._x = 0;
				this._y = Math.atan2( m13, m33 );

			}

		} else if ( order === 'XZY' ) {

			this._z = Math.asin( - clamp( m12, - 1, 1 ) );

			if ( Math.abs( m12 ) < 0.99999 ) {

				this._x = Math.atan2( m32, m22 );
				this._y = Math.atan2( m13, m11 );

			} else {

				this._x = Math.atan2( - m23, m33 );
				this._y = 0;

			}

		} else {

			console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );

		}

		this._order = order;

		if ( update !== false ) this.onChangeCallback();

		return this;

	},

	setFromQuaternion: function () {

		var matrix = new Matrix4();

		return function setFromQuaternion( q, order, update ) {

			matrix.makeRotationFromQuaternion( q );

			return this.setFromRotationMatrix( matrix, order, update );

		};

	}(),

	setFromVector3: function ( v, order ) {

		return this.set( v.x, v.y, v.z, order || this._order );

	},

	reorder: function () {

		// WARNING: this discards revolution information -bhouston

		var q = new Quaternion();

		return function reorder( newOrder ) {

			q.setFromEuler( this );

			return this.setFromQuaternion( q, newOrder );

		};

	}(),

	equals: function ( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	},

	fromArray: function ( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this.onChangeCallback();

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	},

	toVector3: function ( optionalResult ) {

		if ( optionalResult ) {

			return optionalResult.set( this._x, this._y, this._z );

		} else {

			return new Vector3( this._x, this._y, this._z );

		}

	},

	onChange: function ( callback ) {

		this.onChangeCallback = callback;

		return this;

	},

	onChangeCallback: function () {}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Layers() {

	this.mask = 1 | 0;

}

Object.assign( Layers.prototype, {

	set: function ( channel ) {

		this.mask = 1 << channel | 0;

	},

	enable: function ( channel ) {

		this.mask |= 1 << channel | 0;

	},

	toggle: function ( channel ) {

		this.mask ^= 1 << channel | 0;

	},

	disable: function ( channel ) {

		this.mask &= ~ ( 1 << channel | 0 );

	},

	test: function ( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author elephantatwork / www.elephantatwork.ch
 */

var object3DId = 0;

function Object3D() {

	Object.defineProperty( this, 'id', { value: object3DId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Object3D';

	this.parent = null;
	this.children = [];

	this.up = Object3D.DefaultUp.clone();

	var position = new Vector3();
	var rotation = new Euler();
	var quaternion = new Quaternion();
	var scale = new Vector3( 1, 1, 1 );

	function onRotationChange() {

		quaternion.setFromEuler( rotation, false );

	}

	function onQuaternionChange() {

		rotation.setFromQuaternion( quaternion, undefined, false );

	}

	rotation.onChange( onRotationChange );
	quaternion.onChange( onQuaternionChange );

	Object.defineProperties( this, {
		position: {
			enumerable: true,
			value: position
		},
		rotation: {
			enumerable: true,
			value: rotation
		},
		quaternion: {
			enumerable: true,
			value: quaternion
		},
		scale: {
			enumerable: true,
			value: scale
		},
		modelViewMatrix: {
			value: new Matrix4()
		},
		normalMatrix: {
			value: new Matrix3()
		}
	} );

	this.matrix = new Matrix4();
	this.matrixWorld = new Matrix4();

	this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
	this.matrixWorldNeedsUpdate = false;

	this.layers = new Layers();
	this.visible = true;

	this.castShadow = false;
	this.receiveShadow = false;

	this.frustumCulled = true;
	this.renderOrder = 0;

	this.userData = {};

}

Object3D.DefaultUp = new Vector3( 0, 1, 0 );
Object3D.DefaultMatrixAutoUpdate = true;

Object3D.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: Object3D,

	isObject3D: true,

	onBeforeRender: function () {},
	onAfterRender: function () {},

	applyMatrix: function ( matrix ) {

		this.matrix.multiplyMatrices( matrix, this.matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	},

	applyQuaternion: function ( q ) {

		this.quaternion.premultiply( q );

		return this;

	},

	setRotationFromAxisAngle: function ( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	},

	setRotationFromEuler: function ( euler ) {

		this.quaternion.setFromEuler( euler, true );

	},

	setRotationFromMatrix: function ( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	},

	setRotationFromQuaternion: function ( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	},

	rotateOnAxis: function () {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		var q1 = new Quaternion();

		return function rotateOnAxis( axis, angle ) {

			q1.setFromAxisAngle( axis, angle );

			this.quaternion.multiply( q1 );

			return this;

		};

	}(),

	rotateOnWorldAxis: function () {

		// rotate object on axis in world space
		// axis is assumed to be normalized
		// method assumes no rotated parent

		var q1 = new Quaternion();

		return function rotateOnWorldAxis( axis, angle ) {

			q1.setFromAxisAngle( axis, angle );

			this.quaternion.premultiply( q1 );

			return this;

		};

	}(),

	rotateX: function () {

		var v1 = new Vector3( 1, 0, 0 );

		return function rotateX( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	rotateY: function () {

		var v1 = new Vector3( 0, 1, 0 );

		return function rotateY( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	rotateZ: function () {

		var v1 = new Vector3( 0, 0, 1 );

		return function rotateZ( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	translateOnAxis: function () {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		var v1 = new Vector3();

		return function translateOnAxis( axis, distance ) {

			v1.copy( axis ).applyQuaternion( this.quaternion );

			this.position.add( v1.multiplyScalar( distance ) );

			return this;

		};

	}(),

	translateX: function () {

		var v1 = new Vector3( 1, 0, 0 );

		return function translateX( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	translateY: function () {

		var v1 = new Vector3( 0, 1, 0 );

		return function translateY( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	translateZ: function () {

		var v1 = new Vector3( 0, 0, 1 );

		return function translateZ( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	localToWorld: function ( vector ) {

		return vector.applyMatrix4( this.matrixWorld );

	},

	worldToLocal: function () {

		var m1 = new Matrix4();

		return function worldToLocal( vector ) {

			return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );

		};

	}(),

	lookAt: function () {

		// This method does not support objects with rotated and/or translated parent(s)

		var m1 = new Matrix4();
		var vector = new Vector3();

		return function lookAt( x, y, z ) {

			if ( x.isVector3 ) {

				vector.copy( x );

			} else {

				vector.set( x, y, z );

			}

			if ( this.isCamera ) {

				m1.lookAt( this.position, vector, this.up );

			} else {

				m1.lookAt( vector, this.position, this.up );

			}

			this.quaternion.setFromRotationMatrix( m1 );

		};

	}(),

	add: function ( object ) {

		if ( arguments.length > 1 ) {

			for ( var i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
			return this;

		}

		if ( ( object && object.isObject3D ) ) {

			if ( object.parent !== null ) {

				object.parent.remove( object );

			}

			object.parent = this;
			object.dispatchEvent( { type: 'added' } );

			this.children.push( object );

		} else {

			console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );

		}

		return this;

	},

	remove: function ( object ) {

		if ( arguments.length > 1 ) {

			for ( var i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

			return this;

		}

		var index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;

			object.dispatchEvent( { type: 'removed' } );

			this.children.splice( index, 1 );

		}

		return this;

	},

	getObjectById: function ( id ) {

		return this.getObjectByProperty( 'id', id );

	},

	getObjectByName: function ( name ) {

		return this.getObjectByProperty( 'name', name );

	},

	getObjectByProperty: function ( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( var i = 0, l = this.children.length; i < l; i ++ ) {

			var child = this.children[ i ];
			var object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	},

	getWorldPosition: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();

		this.updateMatrixWorld( true );

		return result.setFromMatrixPosition( this.matrixWorld );

	},

	getWorldQuaternion: function () {

		var position = new Vector3();
		var scale = new Vector3();

		return function getWorldQuaternion( optionalTarget ) {

			var result = optionalTarget || new Quaternion();

			this.updateMatrixWorld( true );

			this.matrixWorld.decompose( position, result, scale );

			return result;

		};

	}(),

	getWorldRotation: function () {

		var quaternion = new Quaternion();

		return function getWorldRotation( optionalTarget ) {

			var result = optionalTarget || new Euler();

			this.getWorldQuaternion( quaternion );

			return result.setFromQuaternion( quaternion, this.rotation.order, false );

		};

	}(),

	getWorldScale: function () {

		var position = new Vector3();
		var quaternion = new Quaternion();

		return function getWorldScale( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.updateMatrixWorld( true );

			this.matrixWorld.decompose( position, quaternion, result );

			return result;

		};

	}(),

	getWorldDirection: function () {

		var quaternion = new Quaternion();

		return function getWorldDirection( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.getWorldQuaternion( quaternion );

			return result.set( 0, 0, 1 ).applyQuaternion( quaternion );

		};

	}(),

	raycast: function () {},

	traverse: function ( callback ) {

		callback( this );

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	},

	traverseVisible: function ( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	},

	traverseAncestors: function ( callback ) {

		var parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	},

	updateMatrix: function () {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	},

	updateMatrixWorld: function ( force ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate || force ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// update children

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].updateMatrixWorld( force );

		}

	},

	toJSON: function ( meta ) {

		// meta is a string when called from JSON.stringify
		var isRootObject = ( meta === undefined || typeof meta === 'string' );

		var output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {}
			};

			output.metadata = {
				version: 4.5,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		var object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;
		if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;

		object.matrix = this.matrix.toArray();

		//

		function serialize( library, element ) {

			if ( library[ element.uuid ] === undefined ) {

				library[ element.uuid ] = element.toJSON( meta );

			}

			return element.uuid;

		}

		if ( this.geometry !== undefined ) {

			object.geometry = serialize( meta.geometries, this.geometry );

			var parameters = this.geometry.parameters;

			if ( parameters !== undefined && parameters.shapes !== undefined ) {

				var shapes = parameters.shapes;

				if ( Array.isArray( shapes ) ) {

					for ( var i = 0, l = shapes.length; i < l; i ++ ) {

						var shape = shapes[ i ];

						serialize( meta.shapes, shape );

					}

				} else {

					serialize( meta.shapes, shapes );

				}

			}

		}

		if ( this.material !== undefined ) {

			if ( Array.isArray( this.material ) ) {

				var uuids = [];

				for ( var i = 0, l = this.material.length; i < l; i ++ ) {

					uuids.push( serialize( meta.materials, this.material[ i ] ) );

				}

				object.material = uuids;

			} else {

				object.material = serialize( meta.materials, this.material );

			}

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( var i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		if ( isRootObject ) {

			var geometries = extractFromCache( meta.geometries );
			var materials = extractFromCache( meta.materials );
			var textures = extractFromCache( meta.textures );
			var images = extractFromCache( meta.images );
			var shapes = extractFromCache( meta.shapes );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;
			if ( shapes.length > 0 ) output.shapes = shapes;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			var values = [];
			for ( var key in cache ) {

				var data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}
			return values;

		}

	},

	clone: function ( recursive ) {

		return new this.constructor().copy( this, recursive );

	},

	copy: function ( source, recursive ) {

		if ( recursive === undefined ) recursive = true;

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( var i = 0; i < source.children.length; i ++ ) {

				var child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author WestLangley / http://github.com/WestLangley
*/

function Camera() {

	Object3D.call( this );

	this.type = 'Camera';

	this.matrixWorldInverse = new Matrix4();
	this.projectionMatrix = new Matrix4();

}

Camera.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Camera,

	isCamera: true,

	copy: function ( source, recursive ) {

		Object3D.prototype.copy.call( this, source, recursive );

		this.matrixWorldInverse.copy( source.matrixWorldInverse );
		this.projectionMatrix.copy( source.projectionMatrix );

		return this;

	},

	getWorldDirection: function () {

		var quaternion = new Quaternion();

		return function getWorldDirection( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.getWorldQuaternion( quaternion );

			return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );

		};

	}(),

	updateMatrixWorld: function ( force ) {

		Object3D.prototype.updateMatrixWorld.call( this, force );

		this.matrixWorldInverse.getInverse( this.matrixWorld );

	},

	clone: function () {

		return new this.constructor().copy( this );

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author arose / http://github.com/arose
 */

function OrthographicCamera( left, right, top, bottom, near, far ) {

	Camera.call( this );

	this.type = 'OrthographicCamera';

	this.zoom = 1;
	this.view = null;

	this.left = left;
	this.right = right;
	this.top = top;
	this.bottom = bottom;

	this.near = ( near !== undefined ) ? near : 0.1;
	this.far = ( far !== undefined ) ? far : 2000;

	this.updateProjectionMatrix();

}

OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

	constructor: OrthographicCamera,

	isOrthographicCamera: true,

	copy: function ( source, recursive ) {

		Camera.prototype.copy.call( this, source, recursive );

		this.left = source.left;
		this.right = source.right;
		this.top = source.top;
		this.bottom = source.bottom;
		this.near = source.near;
		this.far = source.far;

		this.zoom = source.zoom;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		return this;

	},

	setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	},

	clearViewOffset: function () {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	},

	updateProjectionMatrix: function () {

		var dx = ( this.right - this.left ) / ( 2 * this.zoom );
		var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
		var cx = ( this.right + this.left ) / 2;
		var cy = ( this.top + this.bottom ) / 2;

		var left = cx - dx;
		var right = cx + dx;
		var top = cy + dy;
		var bottom = cy - dy;

		if ( this.view !== null && this.view.enabled ) {

			var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
			var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
			var scaleW = ( this.right - this.left ) / this.view.width;
			var scaleH = ( this.top - this.bottom ) / this.view.height;

			left += scaleW * ( this.view.offsetX / zoomW );
			right = left + scaleW * ( this.view.width / zoomW );
			top -= scaleH * ( this.view.offsetY / zoomH );
			bottom = top - scaleH * ( this.view.height / zoomH );

		}

		this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.zoom = this.zoom;
		data.object.left = this.left;
		data.object.right = this.right;
		data.object.top = this.top;
		data.object.bottom = this.bottom;
		data.object.near = this.near;
		data.object.far = this.far;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		return data;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Face3( a, b, c, normal, color, materialIndex ) {

	this.a = a;
	this.b = b;
	this.c = c;

	this.normal = ( normal && normal.isVector3 ) ? normal : new Vector3();
	this.vertexNormals = Array.isArray( normal ) ? normal : [];

	this.color = ( color && color.isColor ) ? color : new Color();
	this.vertexColors = Array.isArray( color ) ? color : [];

	this.materialIndex = materialIndex !== undefined ? materialIndex : 0;

}

Object.assign( Face3.prototype, {

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.a = source.a;
		this.b = source.b;
		this.c = source.c;

		this.normal.copy( source.normal );
		this.color.copy( source.color );

		this.materialIndex = source.materialIndex;

		for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {

			this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();

		}

		for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {

			this.vertexColors[ i ] = source.vertexColors[ i ].clone();

		}

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author kile / http://kile.stravaganza.org/
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author bhouston / http://clara.io
 */

var geometryId = 0; // Geometry uses even numbers as Id

function Geometry() {

	Object.defineProperty( this, 'id', { value: geometryId += 2 } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Geometry';

	this.vertices = [];
	this.colors = [];
	this.faces = [];
	this.faceVertexUvs = [[]];

	this.morphTargets = [];
	this.morphNormals = [];

	this.skinWeights = [];
	this.skinIndices = [];

	this.lineDistances = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	// update flags

	this.elementsNeedUpdate = false;
	this.verticesNeedUpdate = false;
	this.uvsNeedUpdate = false;
	this.normalsNeedUpdate = false;
	this.colorsNeedUpdate = false;
	this.lineDistancesNeedUpdate = false;
	this.groupsNeedUpdate = false;

}

Geometry.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: Geometry,

	isGeometry: true,

	applyMatrix: function ( matrix ) {

		var normalMatrix = new Matrix3().getNormalMatrix( matrix );

		for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {

			var vertex = this.vertices[ i ];
			vertex.applyMatrix4( matrix );

		}

		for ( var i = 0, il = this.faces.length; i < il; i ++ ) {

			var face = this.faces[ i ];
			face.normal.applyMatrix3( normalMatrix ).normalize();

			for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

				face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();

			}

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		this.verticesNeedUpdate = true;
		this.normalsNeedUpdate = true;

		return this;

	},

	rotateX: function () {

		// rotate geometry around world x-axis

		var m1 = new Matrix4();

		return function rotateX( angle ) {

			m1.makeRotationX( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateY: function () {

		// rotate geometry around world y-axis

		var m1 = new Matrix4();

		return function rotateY( angle ) {

			m1.makeRotationY( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateZ: function () {

		// rotate geometry around world z-axis

		var m1 = new Matrix4();

		return function rotateZ( angle ) {

			m1.makeRotationZ( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	translate: function () {

		// translate geometry

		var m1 = new Matrix4();

		return function translate( x, y, z ) {

			m1.makeTranslation( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	scale: function () {

		// scale geometry

		var m1 = new Matrix4();

		return function scale( x, y, z ) {

			m1.makeScale( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	lookAt: function () {

		var obj = new Object3D();

		return function lookAt( vector ) {

			obj.lookAt( vector );

			obj.updateMatrix();

			this.applyMatrix( obj.matrix );

		};

	}(),

	fromBufferGeometry: function ( geometry ) {

		var scope = this;

		var indices = geometry.index !== null ? geometry.index.array : undefined;
		var attributes = geometry.attributes;

		var positions = attributes.position.array;
		var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
		var colors = attributes.color !== undefined ? attributes.color.array : undefined;
		var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
		var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;

		if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];

		var tempNormals = [];
		var tempUVs = [];
		var tempUVs2 = [];

		for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {

			scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );

			if ( normals !== undefined ) {

				tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );

			}

			if ( colors !== undefined ) {

				scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );

			}

			if ( uvs !== undefined ) {

				tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );

			}

			if ( uvs2 !== undefined ) {

				tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );

			}

		}

		function addFace( a, b, c, materialIndex ) {

			var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
			var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];

			var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );

			scope.faces.push( face );

			if ( uvs !== undefined ) {

				scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );

			}

			if ( uvs2 !== undefined ) {

				scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );

			}

		}

		var groups = geometry.groups;

		if ( groups.length > 0 ) {

			for ( var i = 0; i < groups.length; i ++ ) {

				var group = groups[ i ];

				var start = group.start;
				var count = group.count;

				for ( var j = start, jl = start + count; j < jl; j += 3 ) {

					if ( indices !== undefined ) {

						addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex );

					} else {

						addFace( j, j + 1, j + 2, group.materialIndex );

					}

				}

			}

		} else {

			if ( indices !== undefined ) {

				for ( var i = 0; i < indices.length; i += 3 ) {

					addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

				}

			} else {

				for ( var i = 0; i < positions.length / 3; i += 3 ) {

					addFace( i, i + 1, i + 2 );

				}

			}

		}

		this.computeFaceNormals();

		if ( geometry.boundingBox !== null ) {

			this.boundingBox = geometry.boundingBox.clone();

		}

		if ( geometry.boundingSphere !== null ) {

			this.boundingSphere = geometry.boundingSphere.clone();

		}

		return this;

	},

	center: function () {

		this.computeBoundingBox();

		var offset = this.boundingBox.getCenter().negate();

		this.translate( offset.x, offset.y, offset.z );

		return offset;

	},

	normalize: function () {

		this.computeBoundingSphere();

		var center = this.boundingSphere.center;
		var radius = this.boundingSphere.radius;

		var s = radius === 0 ? 1 : 1.0 / radius;

		var matrix = new Matrix4();
		matrix.set(
			s, 0, 0, - s * center.x,
			0, s, 0, - s * center.y,
			0, 0, s, - s * center.z,
			0, 0, 0, 1
		);

		this.applyMatrix( matrix );

		return this;

	},

	computeFaceNormals: function () {

		var cb = new Vector3(), ab = new Vector3();

		for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {

			var face = this.faces[ f ];

			var vA = this.vertices[ face.a ];
			var vB = this.vertices[ face.b ];
			var vC = this.vertices[ face.c ];

			cb.subVectors( vC, vB );
			ab.subVectors( vA, vB );
			cb.cross( ab );

			cb.normalize();

			face.normal.copy( cb );

		}

	},

	computeVertexNormals: function ( areaWeighted ) {

		if ( areaWeighted === undefined ) areaWeighted = true;

		var v, vl, f, fl, face, vertices;

		vertices = new Array( this.vertices.length );

		for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

			vertices[ v ] = new Vector3();

		}

		if ( areaWeighted ) {

			// vertex normals weighted by triangle areas
			// http://www.iquilezles.org/www/articles/normals/normals.htm

			var vA, vB, vC;
			var cb = new Vector3(), ab = new Vector3();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				vA = this.vertices[ face.a ];
				vB = this.vertices[ face.b ];
				vC = this.vertices[ face.c ];

				cb.subVectors( vC, vB );
				ab.subVectors( vA, vB );
				cb.cross( ab );

				vertices[ face.a ].add( cb );
				vertices[ face.b ].add( cb );
				vertices[ face.c ].add( cb );

			}

		} else {

			this.computeFaceNormals();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				vertices[ face.a ].add( face.normal );
				vertices[ face.b ].add( face.normal );
				vertices[ face.c ].add( face.normal );

			}

		}

		for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

			vertices[ v ].normalize();

		}

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				vertexNormals[ 0 ].copy( vertices[ face.a ] );
				vertexNormals[ 1 ].copy( vertices[ face.b ] );
				vertexNormals[ 2 ].copy( vertices[ face.c ] );

			} else {

				vertexNormals[ 0 ] = vertices[ face.a ].clone();
				vertexNormals[ 1 ] = vertices[ face.b ].clone();
				vertexNormals[ 2 ] = vertices[ face.c ].clone();

			}

		}

		if ( this.faces.length > 0 ) {

			this.normalsNeedUpdate = true;

		}

	},

	computeFlatVertexNormals: function () {

		var f, fl, face;

		this.computeFaceNormals();

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				vertexNormals[ 0 ].copy( face.normal );
				vertexNormals[ 1 ].copy( face.normal );
				vertexNormals[ 2 ].copy( face.normal );

			} else {

				vertexNormals[ 0 ] = face.normal.clone();
				vertexNormals[ 1 ] = face.normal.clone();
				vertexNormals[ 2 ] = face.normal.clone();

			}

		}

		if ( this.faces.length > 0 ) {

			this.normalsNeedUpdate = true;

		}

	},

	computeMorphNormals: function () {

		var i, il, f, fl, face;

		// save original normals
		// - create temp variables on first access
		//   otherwise just copy (for faster repeated calls)

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			if ( ! face.__originalFaceNormal ) {

				face.__originalFaceNormal = face.normal.clone();

			} else {

				face.__originalFaceNormal.copy( face.normal );

			}

			if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];

			for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {

				if ( ! face.__originalVertexNormals[ i ] ) {

					face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();

				} else {

					face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );

				}

			}

		}

		// use temp geometry to compute face and vertex normals for each morph

		var tmpGeo = new Geometry();
		tmpGeo.faces = this.faces;

		for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {

			// create on first access

			if ( ! this.morphNormals[ i ] ) {

				this.morphNormals[ i ] = {};
				this.morphNormals[ i ].faceNormals = [];
				this.morphNormals[ i ].vertexNormals = [];

				var dstNormalsFace = this.morphNormals[ i ].faceNormals;
				var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;

				var faceNormal, vertexNormals;

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					faceNormal = new Vector3();
					vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };

					dstNormalsFace.push( faceNormal );
					dstNormalsVertex.push( vertexNormals );

				}

			}

			var morphNormals = this.morphNormals[ i ];

			// set vertices to morph target

			tmpGeo.vertices = this.morphTargets[ i ].vertices;

			// compute morph normals

			tmpGeo.computeFaceNormals();
			tmpGeo.computeVertexNormals();

			// store morph normals

			var faceNormal, vertexNormals;

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				faceNormal = morphNormals.faceNormals[ f ];
				vertexNormals = morphNormals.vertexNormals[ f ];

				faceNormal.copy( face.normal );

				vertexNormals.a.copy( face.vertexNormals[ 0 ] );
				vertexNormals.b.copy( face.vertexNormals[ 1 ] );
				vertexNormals.c.copy( face.vertexNormals[ 2 ] );

			}

		}

		// restore original normals

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			face.normal = face.__originalFaceNormal;
			face.vertexNormals = face.__originalVertexNormals;

		}

	},

	computeLineDistances: function () {

		var d = 0;
		var vertices = this.vertices;

		for ( var i = 0, il = vertices.length; i < il; i ++ ) {

			if ( i > 0 ) {

				d += vertices[ i ].distanceTo( vertices[ i - 1 ] );

			}

			this.lineDistances[ i ] = d;

		}

	},

	computeBoundingBox: function () {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		this.boundingBox.setFromPoints( this.vertices );

	},

	computeBoundingSphere: function () {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		this.boundingSphere.setFromPoints( this.vertices );

	},

	merge: function ( geometry, matrix, materialIndexOffset ) {

		if ( ! ( geometry && geometry.isGeometry ) ) {

			console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
			return;

		}

		var normalMatrix,
			vertexOffset = this.vertices.length,
			vertices1 = this.vertices,
			vertices2 = geometry.vertices,
			faces1 = this.faces,
			faces2 = geometry.faces,
			uvs1 = this.faceVertexUvs[ 0 ],
			uvs2 = geometry.faceVertexUvs[ 0 ],
			colors1 = this.colors,
			colors2 = geometry.colors;

		if ( materialIndexOffset === undefined ) materialIndexOffset = 0;

		if ( matrix !== undefined ) {

			normalMatrix = new Matrix3().getNormalMatrix( matrix );

		}

		// vertices

		for ( var i = 0, il = vertices2.length; i < il; i ++ ) {

			var vertex = vertices2[ i ];

			var vertexCopy = vertex.clone();

			if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );

			vertices1.push( vertexCopy );

		}

		// colors

		for ( var i = 0, il = colors2.length; i < il; i ++ ) {

			colors1.push( colors2[ i ].clone() );

		}

		// faces

		for ( i = 0, il = faces2.length; i < il; i ++ ) {

			var face = faces2[ i ], faceCopy, normal, color,
				faceVertexNormals = face.vertexNormals,
				faceVertexColors = face.vertexColors;

			faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
			faceCopy.normal.copy( face.normal );

			if ( normalMatrix !== undefined ) {

				faceCopy.normal.applyMatrix3( normalMatrix ).normalize();

			}

			for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {

				normal = faceVertexNormals[ j ].clone();

				if ( normalMatrix !== undefined ) {

					normal.applyMatrix3( normalMatrix ).normalize();

				}

				faceCopy.vertexNormals.push( normal );

			}

			faceCopy.color.copy( face.color );

			for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {

				color = faceVertexColors[ j ];
				faceCopy.vertexColors.push( color.clone() );

			}

			faceCopy.materialIndex = face.materialIndex + materialIndexOffset;

			faces1.push( faceCopy );

		}

		// uvs

		for ( i = 0, il = uvs2.length; i < il; i ++ ) {

			var uv = uvs2[ i ], uvCopy = [];

			if ( uv === undefined ) {

				continue;

			}

			for ( var j = 0, jl = uv.length; j < jl; j ++ ) {

				uvCopy.push( uv[ j ].clone() );

			}

			uvs1.push( uvCopy );

		}

	},

	mergeMesh: function ( mesh ) {

		if ( ! ( mesh && mesh.isMesh ) ) {

			console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
			return;

		}

		mesh.matrixAutoUpdate && mesh.updateMatrix();

		this.merge( mesh.geometry, mesh.matrix );

	},

	/*
	 * Checks for duplicate vertices with hashmap.
	 * Duplicated vertices are removed
	 * and faces' vertices are updated.
	 */

	mergeVertices: function () {

		var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
		var unique = [], changes = [];

		var v, key;
		var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
		var precision = Math.pow( 10, precisionPoints );
		var i, il, face;
		var indices, j, jl;

		for ( i = 0, il = this.vertices.length; i < il; i ++ ) {

			v = this.vertices[ i ];
			key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );

			if ( verticesMap[ key ] === undefined ) {

				verticesMap[ key ] = i;
				unique.push( this.vertices[ i ] );
				changes[ i ] = unique.length - 1;

			} else {

				//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
				changes[ i ] = changes[ verticesMap[ key ] ];

			}

		}


		// if faces are completely degenerate after merging vertices, we
		// have to remove them from the geometry.
		var faceIndicesToRemove = [];

		for ( i = 0, il = this.faces.length; i < il; i ++ ) {

			face = this.faces[ i ];

			face.a = changes[ face.a ];
			face.b = changes[ face.b ];
			face.c = changes[ face.c ];

			indices = [ face.a, face.b, face.c ];

			// if any duplicate vertices are found in a Face3
			// we have to remove the face as nothing can be saved
			for ( var n = 0; n < 3; n ++ ) {

				if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {

					faceIndicesToRemove.push( i );
					break;

				}

			}

		}

		for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {

			var idx = faceIndicesToRemove[ i ];

			this.faces.splice( idx, 1 );

			for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {

				this.faceVertexUvs[ j ].splice( idx, 1 );

			}

		}

		// Use unique set of vertices

		var diff = this.vertices.length - unique.length;
		this.vertices = unique;
		return diff;

	},

	setFromPoints: function ( points ) {

		this.vertices = [];

		for ( var i = 0, l = points.length; i < l; i ++ ) {

			var point = points[ i ];
			this.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );

		}

		return this;

	},

	sortFacesByMaterialIndex: function () {

		var faces = this.faces;
		var length = faces.length;

		// tag faces

		for ( var i = 0; i < length; i ++ ) {

			faces[ i ]._id = i;

		}

		// sort faces

		function materialIndexSort( a, b ) {

			return a.materialIndex - b.materialIndex;

		}

		faces.sort( materialIndexSort );

		// sort uvs

		var uvs1 = this.faceVertexUvs[ 0 ];
		var uvs2 = this.faceVertexUvs[ 1 ];

		var newUvs1, newUvs2;

		if ( uvs1 && uvs1.length === length ) newUvs1 = [];
		if ( uvs2 && uvs2.length === length ) newUvs2 = [];

		for ( var i = 0; i < length; i ++ ) {

			var id = faces[ i ]._id;

			if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
			if ( newUvs2 ) newUvs2.push( uvs2[ id ] );

		}

		if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
		if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;

	},

	toJSON: function () {

		var data = {
			metadata: {
				version: 4.5,
				type: 'Geometry',
				generator: 'Geometry.toJSON'
			}
		};

		// standard Geometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;

		if ( this.parameters !== undefined ) {

			var parameters = this.parameters;

			for ( var key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		var vertices = [];

		for ( var i = 0; i < this.vertices.length; i ++ ) {

			var vertex = this.vertices[ i ];
			vertices.push( vertex.x, vertex.y, vertex.z );

		}

		var faces = [];
		var normals = [];
		var normalsHash = {};
		var colors = [];
		var colorsHash = {};
		var uvs = [];
		var uvsHash = {};

		for ( var i = 0; i < this.faces.length; i ++ ) {

			var face = this.faces[ i ];

			var hasMaterial = true;
			var hasFaceUv = false; // deprecated
			var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
			var hasFaceNormal = face.normal.length() > 0;
			var hasFaceVertexNormal = face.vertexNormals.length > 0;
			var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
			var hasFaceVertexColor = face.vertexColors.length > 0;

			var faceType = 0;

			faceType = setBit( faceType, 0, 0 ); // isQuad
			faceType = setBit( faceType, 1, hasMaterial );
			faceType = setBit( faceType, 2, hasFaceUv );
			faceType = setBit( faceType, 3, hasFaceVertexUv );
			faceType = setBit( faceType, 4, hasFaceNormal );
			faceType = setBit( faceType, 5, hasFaceVertexNormal );
			faceType = setBit( faceType, 6, hasFaceColor );
			faceType = setBit( faceType, 7, hasFaceVertexColor );

			faces.push( faceType );
			faces.push( face.a, face.b, face.c );
			faces.push( face.materialIndex );

			if ( hasFaceVertexUv ) {

				var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];

				faces.push(
					getUvIndex( faceVertexUvs[ 0 ] ),
					getUvIndex( faceVertexUvs[ 1 ] ),
					getUvIndex( faceVertexUvs[ 2 ] )
				);

			}

			if ( hasFaceNormal ) {

				faces.push( getNormalIndex( face.normal ) );

			}

			if ( hasFaceVertexNormal ) {

				var vertexNormals = face.vertexNormals;

				faces.push(
					getNormalIndex( vertexNormals[ 0 ] ),
					getNormalIndex( vertexNormals[ 1 ] ),
					getNormalIndex( vertexNormals[ 2 ] )
				);

			}

			if ( hasFaceColor ) {

				faces.push( getColorIndex( face.color ) );

			}

			if ( hasFaceVertexColor ) {

				var vertexColors = face.vertexColors;

				faces.push(
					getColorIndex( vertexColors[ 0 ] ),
					getColorIndex( vertexColors[ 1 ] ),
					getColorIndex( vertexColors[ 2 ] )
				);

			}

		}

		function setBit( value, position, enabled ) {

			return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );

		}

		function getNormalIndex( normal ) {

			var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();

			if ( normalsHash[ hash ] !== undefined ) {

				return normalsHash[ hash ];

			}

			normalsHash[ hash ] = normals.length / 3;
			normals.push( normal.x, normal.y, normal.z );

			return normalsHash[ hash ];

		}

		function getColorIndex( color ) {

			var hash = color.r.toString() + color.g.toString() + color.b.toString();

			if ( colorsHash[ hash ] !== undefined ) {

				return colorsHash[ hash ];

			}

			colorsHash[ hash ] = colors.length;
			colors.push( color.getHex() );

			return colorsHash[ hash ];

		}

		function getUvIndex( uv ) {

			var hash = uv.x.toString() + uv.y.toString();

			if ( uvsHash[ hash ] !== undefined ) {

				return uvsHash[ hash ];

			}

			uvsHash[ hash ] = uvs.length / 2;
			uvs.push( uv.x, uv.y );

			return uvsHash[ hash ];

		}

		data.data = {};

		data.data.vertices = vertices;
		data.data.normals = normals;
		if ( colors.length > 0 ) data.data.colors = colors;
		if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
		data.data.faces = faces;

		return data;

	},

	clone: function () {

		/*
		 // Handle primitives

		 var parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 var values = [];

		 for ( var key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 var geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */

		return new Geometry().copy( this );

	},

	copy: function ( source ) {

		var i, il, j, jl, k, kl;

		// reset

		this.vertices = [];
		this.colors = [];
		this.faces = [];
		this.faceVertexUvs = [[]];
		this.morphTargets = [];
		this.morphNormals = [];
		this.skinWeights = [];
		this.skinIndices = [];
		this.lineDistances = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// name

		this.name = source.name;

		// vertices

		var vertices = source.vertices;

		for ( i = 0, il = vertices.length; i < il; i ++ ) {

			this.vertices.push( vertices[ i ].clone() );

		}

		// colors

		var colors = source.colors;

		for ( i = 0, il = colors.length; i < il; i ++ ) {

			this.colors.push( colors[ i ].clone() );

		}

		// faces

		var faces = source.faces;

		for ( i = 0, il = faces.length; i < il; i ++ ) {

			this.faces.push( faces[ i ].clone() );

		}

		// face vertex uvs

		for ( i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {

			var faceVertexUvs = source.faceVertexUvs[ i ];

			if ( this.faceVertexUvs[ i ] === undefined ) {

				this.faceVertexUvs[ i ] = [];

			}

			for ( j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {

				var uvs = faceVertexUvs[ j ], uvsCopy = [];

				for ( k = 0, kl = uvs.length; k < kl; k ++ ) {

					var uv = uvs[ k ];

					uvsCopy.push( uv.clone() );

				}

				this.faceVertexUvs[ i ].push( uvsCopy );

			}

		}

		// morph targets

		var morphTargets = source.morphTargets;

		for ( i = 0, il = morphTargets.length; i < il; i ++ ) {

			var morphTarget = {};
			morphTarget.name = morphTargets[ i ].name;

			// vertices

			if ( morphTargets[ i ].vertices !== undefined ) {

				morphTarget.vertices = [];

				for ( j = 0, jl = morphTargets[ i ].vertices.length; j < jl; j ++ ) {

					morphTarget.vertices.push( morphTargets[ i ].vertices[ j ].clone() );

				}

			}

			// normals

			if ( morphTargets[ i ].normals !== undefined ) {

				morphTarget.normals = [];

				for ( j = 0, jl = morphTargets[ i ].normals.length; j < jl; j ++ ) {

					morphTarget.normals.push( morphTargets[ i ].normals[ j ].clone() );

				}

			}

			this.morphTargets.push( morphTarget );

		}

		// morph normals

		var morphNormals = source.morphNormals;

		for ( i = 0, il = morphNormals.length; i < il; i ++ ) {

			var morphNormal = {};

			// vertex normals

			if ( morphNormals[ i ].vertexNormals !== undefined ) {

				morphNormal.vertexNormals = [];

				for ( j = 0, jl = morphNormals[ i ].vertexNormals.length; j < jl; j ++ ) {

					var srcVertexNormal = morphNormals[ i ].vertexNormals[ j ];
					var destVertexNormal = {};

					destVertexNormal.a = srcVertexNormal.a.clone();
					destVertexNormal.b = srcVertexNormal.b.clone();
					destVertexNormal.c = srcVertexNormal.c.clone();

					morphNormal.vertexNormals.push( destVertexNormal );

				}

			}

			// face normals

			if ( morphNormals[ i ].faceNormals !== undefined ) {

				morphNormal.faceNormals = [];

				for ( j = 0, jl = morphNormals[ i ].faceNormals.length; j < jl; j ++ ) {

					morphNormal.faceNormals.push( morphNormals[ i ].faceNormals[ j ].clone() );

				}

			}

			this.morphNormals.push( morphNormal );

		}

		// skin weights

		var skinWeights = source.skinWeights;

		for ( i = 0, il = skinWeights.length; i < il; i ++ ) {

			this.skinWeights.push( skinWeights[ i ].clone() );

		}

		// skin indices

		var skinIndices = source.skinIndices;

		for ( i = 0, il = skinIndices.length; i < il; i ++ ) {

			this.skinIndices.push( skinIndices[ i ].clone() );

		}

		// line distances

		var lineDistances = source.lineDistances;

		for ( i = 0, il = lineDistances.length; i < il; i ++ ) {

			this.lineDistances.push( lineDistances[ i ] );

		}

		// bounding box

		var boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		var boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// update flags

		this.elementsNeedUpdate = source.elementsNeedUpdate;
		this.verticesNeedUpdate = source.verticesNeedUpdate;
		this.uvsNeedUpdate = source.uvsNeedUpdate;
		this.normalsNeedUpdate = source.normalsNeedUpdate;
		this.colorsNeedUpdate = source.colorsNeedUpdate;
		this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
		this.groupsNeedUpdate = source.groupsNeedUpdate;

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function BufferAttribute( array, itemSize, normalized ) {

	if ( Array.isArray( array ) ) {

		throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

	}

	this.uuid = _Math.generateUUID();
	this.name = '';

	this.array = array;
	this.itemSize = itemSize;
	this.count = array !== undefined ? array.length / itemSize : 0;
	this.normalized = normalized === true;

	this.dynamic = false;
	this.updateRange = { offset: 0, count: - 1 };

	this.onUploadCallback = function () {};

	this.version = 0;

}

Object.defineProperty( BufferAttribute.prototype, 'needsUpdate', {

	set: function ( value ) {

		if ( value === true ) this.version ++;

	}

} );

Object.assign( BufferAttribute.prototype, {

	isBufferAttribute: true,

	setArray: function ( array ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.count = array !== undefined ? array.length / this.itemSize : 0;
		this.array = array;

	},

	setDynamic: function ( value ) {

		this.dynamic = value;

		return this;

	},

	copy: function ( source ) {

		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.dynamic = source.dynamic;

		return this;

	},

	copyAt: function ( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( var i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	},

	copyArray: function ( array ) {

		this.array.set( array );

		return this;

	},

	copyColorsArray: function ( colors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = colors.length; i < l; i ++ ) {

			var color = colors[ i ];

			if ( color === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
				color = new Color();

			}

			array[ offset ++ ] = color.r;
			array[ offset ++ ] = color.g;
			array[ offset ++ ] = color.b;

		}

		return this;

	},

	copyIndicesArray: function ( indices ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = indices.length; i < l; i ++ ) {

			var index = indices[ i ];

			array[ offset ++ ] = index.a;
			array[ offset ++ ] = index.b;
			array[ offset ++ ] = index.c;

		}

		return this;

	},

	copyVector2sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
				vector = new Vector2();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;

		}

		return this;

	},

	copyVector3sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
				vector = new Vector3();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;
			array[ offset ++ ] = vector.z;

		}

		return this;

	},

	copyVector4sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
				vector = new Vector4();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;
			array[ offset ++ ] = vector.z;
			array[ offset ++ ] = vector.w;

		}

		return this;

	},

	set: function ( value, offset ) {

		if ( offset === undefined ) offset = 0;

		this.array.set( value, offset );

		return this;

	},

	getX: function ( index ) {

		return this.array[ index * this.itemSize ];

	},

	setX: function ( index, x ) {

		this.array[ index * this.itemSize ] = x;

		return this;

	},

	getY: function ( index ) {

		return this.array[ index * this.itemSize + 1 ];

	},

	setY: function ( index, y ) {

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	},

	getZ: function ( index ) {

		return this.array[ index * this.itemSize + 2 ];

	},

	setZ: function ( index, z ) {

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	},

	getW: function ( index ) {

		return this.array[ index * this.itemSize + 3 ];

	},

	setW: function ( index, w ) {

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	},

	setXY: function ( index, x, y ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	},

	setXYZ: function ( index, x, y, z ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	},

	setXYZW: function ( index, x, y, z, w ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	},

	onUpload: function ( callback ) {

		this.onUploadCallback = callback;

		return this;

	},

	clone: function () {

		return new this.constructor( this.array, this.itemSize ).copy( this );

	}

} );

//

function Int8BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Int8Array( array ), itemSize, normalized );

}

Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;


function Uint8BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Uint8Array( array ), itemSize, normalized );

}

Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;


function Uint8ClampedBufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize, normalized );

}

Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;


function Int16BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Int16Array( array ), itemSize, normalized );

}

Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;


function Uint16BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Uint16Array( array ), itemSize, normalized );

}

Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;


function Int32BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Int32Array( array ), itemSize, normalized );

}

Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;


function Uint32BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Uint32Array( array ), itemSize, normalized );

}

Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;


function Float32BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Float32Array( array ), itemSize, normalized );

}

Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;


function Float64BufferAttribute( array, itemSize, normalized ) {

	BufferAttribute.call( this, new Float64Array( array ), itemSize, normalized );

}

Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function DirectGeometry() {

	this.indices = [];
	this.vertices = [];
	this.normals = [];
	this.colors = [];
	this.uvs = [];
	this.uvs2 = [];

	this.groups = [];

	this.morphTargets = {};

	this.skinWeights = [];
	this.skinIndices = [];

	// this.lineDistances = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	// update flags

	this.verticesNeedUpdate = false;
	this.normalsNeedUpdate = false;
	this.colorsNeedUpdate = false;
	this.uvsNeedUpdate = false;
	this.groupsNeedUpdate = false;

}

Object.assign( DirectGeometry.prototype, {

	computeGroups: function ( geometry ) {

		var group;
		var groups = [];
		var materialIndex = undefined;

		var faces = geometry.faces;

		for ( var i = 0; i < faces.length; i ++ ) {

			var face = faces[ i ];

			// materials

			if ( face.materialIndex !== materialIndex ) {

				materialIndex = face.materialIndex;

				if ( group !== undefined ) {

					group.count = ( i * 3 ) - group.start;
					groups.push( group );

				}

				group = {
					start: i * 3,
					materialIndex: materialIndex
				};

			}

		}

		if ( group !== undefined ) {

			group.count = ( i * 3 ) - group.start;
			groups.push( group );

		}

		this.groups = groups;

	},

	fromGeometry: function ( geometry ) {

		var faces = geometry.faces;
		var vertices = geometry.vertices;
		var faceVertexUvs = geometry.faceVertexUvs;

		var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
		var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;

		// morphs

		var morphTargets = geometry.morphTargets;
		var morphTargetsLength = morphTargets.length;

		var morphTargetsPosition;

		if ( morphTargetsLength > 0 ) {

			morphTargetsPosition = [];

			for ( var i = 0; i < morphTargetsLength; i ++ ) {

				morphTargetsPosition[ i ] = [];

			}

			this.morphTargets.position = morphTargetsPosition;

		}

		var morphNormals = geometry.morphNormals;
		var morphNormalsLength = morphNormals.length;

		var morphTargetsNormal;

		if ( morphNormalsLength > 0 ) {

			morphTargetsNormal = [];

			for ( var i = 0; i < morphNormalsLength; i ++ ) {

				morphTargetsNormal[ i ] = [];

			}

			this.morphTargets.normal = morphTargetsNormal;

		}

		// skins

		var skinIndices = geometry.skinIndices;
		var skinWeights = geometry.skinWeights;

		var hasSkinIndices = skinIndices.length === vertices.length;
		var hasSkinWeights = skinWeights.length === vertices.length;

		//

		for ( var i = 0; i < faces.length; i ++ ) {

			var face = faces[ i ];

			this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );

			} else {

				var normal = face.normal;

				this.normals.push( normal, normal, normal );

			}

			var vertexColors = face.vertexColors;

			if ( vertexColors.length === 3 ) {

				this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );

			} else {

				var color = face.color;

				this.colors.push( color, color, color );

			}

			if ( hasFaceVertexUv === true ) {

				var vertexUvs = faceVertexUvs[ 0 ][ i ];

				if ( vertexUvs !== undefined ) {

					this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

				} else {

					console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );

					this.uvs.push( new Vector2(), new Vector2(), new Vector2() );

				}

			}

			if ( hasFaceVertexUv2 === true ) {

				var vertexUvs = faceVertexUvs[ 1 ][ i ];

				if ( vertexUvs !== undefined ) {

					this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

				} else {

					console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );

					this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );

				}

			}

			// morphs

			for ( var j = 0; j < morphTargetsLength; j ++ ) {

				var morphTarget = morphTargets[ j ].vertices;

				morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );

			}

			for ( var j = 0; j < morphNormalsLength; j ++ ) {

				var morphNormal = morphNormals[ j ].vertexNormals[ i ];

				morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );

			}

			// skins

			if ( hasSkinIndices ) {

				this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );

			}

			if ( hasSkinWeights ) {

				this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );

			}

		}

		this.computeGroups( geometry );

		this.verticesNeedUpdate = geometry.verticesNeedUpdate;
		this.normalsNeedUpdate = geometry.normalsNeedUpdate;
		this.colorsNeedUpdate = geometry.colorsNeedUpdate;
		this.uvsNeedUpdate = geometry.uvsNeedUpdate;
		this.groupsNeedUpdate = geometry.groupsNeedUpdate;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function arrayMax( array ) {

	if ( array.length === 0 ) return - Infinity;

	var max = array[ 0 ];

	for ( var i = 1, l = array.length; i < l; ++ i ) {

		if ( array[ i ] > max ) max = array[ i ];

	}

	return max;

}

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

var bufferGeometryId = 1; // BufferGeometry uses odd numbers as Id

function BufferGeometry() {

	Object.defineProperty( this, 'id', { value: bufferGeometryId += 2 } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'BufferGeometry';

	this.index = null;
	this.attributes = {};

	this.morphAttributes = {};

	this.groups = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	this.drawRange = { start: 0, count: Infinity };

}

BufferGeometry.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: BufferGeometry,

	isBufferGeometry: true,

	getIndex: function () {

		return this.index;

	},

	setIndex: function ( index ) {

		if ( Array.isArray( index ) ) {

			this.index = new ( arrayMax( index ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );

		} else {

			this.index = index;

		}

	},

	addAttribute: function ( name, attribute ) {

		if ( ! ( attribute && attribute.isBufferAttribute ) && ! ( attribute && attribute.isInterleavedBufferAttribute ) ) {

			console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );

			this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );

			return;

		}

		if ( name === 'index' ) {

			console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
			this.setIndex( attribute );

			return;

		}

		this.attributes[ name ] = attribute;

		return this;

	},

	getAttribute: function ( name ) {

		return this.attributes[ name ];

	},

	removeAttribute: function ( name ) {

		delete this.attributes[ name ];

		return this;

	},

	addGroup: function ( start, count, materialIndex ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex !== undefined ? materialIndex : 0

		} );

	},

	clearGroups: function () {

		this.groups = [];

	},

	setDrawRange: function ( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	},

	applyMatrix: function ( matrix ) {

		var position = this.attributes.position;

		if ( position !== undefined ) {

			matrix.applyToBufferAttribute( position );
			position.needsUpdate = true;

		}

		var normal = this.attributes.normal;

		if ( normal !== undefined ) {

			var normalMatrix = new Matrix3().getNormalMatrix( matrix );

			normalMatrix.applyToBufferAttribute( normal );
			normal.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	},

	rotateX: function () {

		// rotate geometry around world x-axis

		var m1 = new Matrix4();

		return function rotateX( angle ) {

			m1.makeRotationX( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateY: function () {

		// rotate geometry around world y-axis

		var m1 = new Matrix4();

		return function rotateY( angle ) {

			m1.makeRotationY( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateZ: function () {

		// rotate geometry around world z-axis

		var m1 = new Matrix4();

		return function rotateZ( angle ) {

			m1.makeRotationZ( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	translate: function () {

		// translate geometry

		var m1 = new Matrix4();

		return function translate( x, y, z ) {

			m1.makeTranslation( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	scale: function () {

		// scale geometry

		var m1 = new Matrix4();

		return function scale( x, y, z ) {

			m1.makeScale( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	lookAt: function () {

		var obj = new Object3D();

		return function lookAt( vector ) {

			obj.lookAt( vector );

			obj.updateMatrix();

			this.applyMatrix( obj.matrix );

		};

	}(),

	center: function () {

		this.computeBoundingBox();

		var offset = this.boundingBox.getCenter().negate();

		this.translate( offset.x, offset.y, offset.z );

		return offset;

	},

	setFromObject: function ( object ) {

		// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );

		var geometry = object.geometry;

		if ( object.isPoints || object.isLine ) {

			var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
			var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );

			this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
			this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );

			if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {

				var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );

				this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );

			}

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

		} else if ( object.isMesh ) {

			if ( geometry && geometry.isGeometry ) {

				this.fromGeometry( geometry );

			}

		}

		return this;

	},

	setFromPoints: function ( points ) {

		var position = [];

		for ( var i = 0, l = points.length; i < l; i ++ ) {

			var point = points[ i ];
			position.push( point.x, point.y, point.z || 0 );

		}

		this.addAttribute( 'position', new Float32BufferAttribute( position, 3 ) );

		return this;

	},

	updateFromObject: function ( object ) {

		var geometry = object.geometry;

		if ( object.isMesh ) {

			var direct = geometry.__directGeometry;

			if ( geometry.elementsNeedUpdate === true ) {

				direct = undefined;
				geometry.elementsNeedUpdate = false;

			}

			if ( direct === undefined ) {

				return this.fromGeometry( geometry );

			}

			direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
			direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
			direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
			direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
			direct.groupsNeedUpdate = geometry.groupsNeedUpdate;

			geometry.verticesNeedUpdate = false;
			geometry.normalsNeedUpdate = false;
			geometry.colorsNeedUpdate = false;
			geometry.uvsNeedUpdate = false;
			geometry.groupsNeedUpdate = false;

			geometry = direct;

		}

		var attribute;

		if ( geometry.verticesNeedUpdate === true ) {

			attribute = this.attributes.position;

			if ( attribute !== undefined ) {

				attribute.copyVector3sArray( geometry.vertices );
				attribute.needsUpdate = true;

			}

			geometry.verticesNeedUpdate = false;

		}

		if ( geometry.normalsNeedUpdate === true ) {

			attribute = this.attributes.normal;

			if ( attribute !== undefined ) {

				attribute.copyVector3sArray( geometry.normals );
				attribute.needsUpdate = true;

			}

			geometry.normalsNeedUpdate = false;

		}

		if ( geometry.colorsNeedUpdate === true ) {

			attribute = this.attributes.color;

			if ( attribute !== undefined ) {

				attribute.copyColorsArray( geometry.colors );
				attribute.needsUpdate = true;

			}

			geometry.colorsNeedUpdate = false;

		}

		if ( geometry.uvsNeedUpdate ) {

			attribute = this.attributes.uv;

			if ( attribute !== undefined ) {

				attribute.copyVector2sArray( geometry.uvs );
				attribute.needsUpdate = true;

			}

			geometry.uvsNeedUpdate = false;

		}

		if ( geometry.lineDistancesNeedUpdate ) {

			attribute = this.attributes.lineDistance;

			if ( attribute !== undefined ) {

				attribute.copyArray( geometry.lineDistances );
				attribute.needsUpdate = true;

			}

			geometry.lineDistancesNeedUpdate = false;

		}

		if ( geometry.groupsNeedUpdate ) {

			geometry.computeGroups( object.geometry );
			this.groups = geometry.groups;

			geometry.groupsNeedUpdate = false;

		}

		return this;

	},

	fromGeometry: function ( geometry ) {

		geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );

		return this.fromDirectGeometry( geometry.__directGeometry );

	},

	fromDirectGeometry: function ( geometry ) {

		var positions = new Float32Array( geometry.vertices.length * 3 );
		this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );

		if ( geometry.normals.length > 0 ) {

			var normals = new Float32Array( geometry.normals.length * 3 );
			this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );

		}

		if ( geometry.colors.length > 0 ) {

			var colors = new Float32Array( geometry.colors.length * 3 );
			this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );

		}

		if ( geometry.uvs.length > 0 ) {

			var uvs = new Float32Array( geometry.uvs.length * 2 );
			this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );

		}

		if ( geometry.uvs2.length > 0 ) {

			var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
			this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );

		}

		if ( geometry.indices.length > 0 ) {

			var TypeArray = arrayMax( geometry.indices ) > 65535 ? Uint32Array : Uint16Array;
			var indices = new TypeArray( geometry.indices.length * 3 );
			this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );

		}

		// groups

		this.groups = geometry.groups;

		// morphs

		for ( var name in geometry.morphTargets ) {

			var array = [];
			var morphTargets = geometry.morphTargets[ name ];

			for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {

				var morphTarget = morphTargets[ i ];

				var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );

				array.push( attribute.copyVector3sArray( morphTarget ) );

			}

			this.morphAttributes[ name ] = array;

		}

		// skinning

		if ( geometry.skinIndices.length > 0 ) {

			var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
			this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );

		}

		if ( geometry.skinWeights.length > 0 ) {

			var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
			this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );

		}

		//

		if ( geometry.boundingSphere !== null ) {

			this.boundingSphere = geometry.boundingSphere.clone();

		}

		if ( geometry.boundingBox !== null ) {

			this.boundingBox = geometry.boundingBox.clone();

		}

		return this;

	},

	computeBoundingBox: function () {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		var position = this.attributes.position;

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	},

	computeBoundingSphere: function () {

		var box = new Box3();
		var vector = new Vector3();

		return function computeBoundingSphere() {

			if ( this.boundingSphere === null ) {

				this.boundingSphere = new Sphere();

			}

			var position = this.attributes.position;

			if ( position ) {

				var center = this.boundingSphere.center;

				box.setFromBufferAttribute( position );
				box.getCenter( center );

				// hoping to find a boundingSphere with a radius smaller than the
				// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

				var maxRadiusSq = 0;

				for ( var i = 0, il = position.count; i < il; i ++ ) {

					vector.x = position.getX( i );
					vector.y = position.getY( i );
					vector.z = position.getZ( i );
					maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );

				}

				this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

				if ( isNaN( this.boundingSphere.radius ) ) {

					console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

				}

			}

		};

	}(),

	computeFaceNormals: function () {

		// backwards compatibility

	},

	computeVertexNormals: function () {

		var index = this.index;
		var attributes = this.attributes;
		var groups = this.groups;

		if ( attributes.position ) {

			var positions = attributes.position.array;

			if ( attributes.normal === undefined ) {

				this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );

			} else {

				// reset existing normals to zero

				var array = attributes.normal.array;

				for ( var i = 0, il = array.length; i < il; i ++ ) {

					array[ i ] = 0;

				}

			}

			var normals = attributes.normal.array;

			var vA, vB, vC;
			var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
			var cb = new Vector3(), ab = new Vector3();

			// indexed elements

			if ( index ) {

				var indices = index.array;

				if ( groups.length === 0 ) {

					this.addGroup( 0, indices.length );

				}

				for ( var j = 0, jl = groups.length; j < jl; ++ j ) {

					var group = groups[ j ];

					var start = group.start;
					var count = group.count;

					for ( var i = start, il = start + count; i < il; i += 3 ) {

						vA = indices[ i + 0 ] * 3;
						vB = indices[ i + 1 ] * 3;
						vC = indices[ i + 2 ] * 3;

						pA.fromArray( positions, vA );
						pB.fromArray( positions, vB );
						pC.fromArray( positions, vC );

						cb.subVectors( pC, pB );
						ab.subVectors( pA, pB );
						cb.cross( ab );

						normals[ vA ] += cb.x;
						normals[ vA + 1 ] += cb.y;
						normals[ vA + 2 ] += cb.z;

						normals[ vB ] += cb.x;
						normals[ vB + 1 ] += cb.y;
						normals[ vB + 2 ] += cb.z;

						normals[ vC ] += cb.x;
						normals[ vC + 1 ] += cb.y;
						normals[ vC + 2 ] += cb.z;

					}

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( var i = 0, il = positions.length; i < il; i += 9 ) {

					pA.fromArray( positions, i );
					pB.fromArray( positions, i + 3 );
					pC.fromArray( positions, i + 6 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normals[ i ] = cb.x;
					normals[ i + 1 ] = cb.y;
					normals[ i + 2 ] = cb.z;

					normals[ i + 3 ] = cb.x;
					normals[ i + 4 ] = cb.y;
					normals[ i + 5 ] = cb.z;

					normals[ i + 6 ] = cb.x;
					normals[ i + 7 ] = cb.y;
					normals[ i + 8 ] = cb.z;

				}

			}

			this.normalizeNormals();

			attributes.normal.needsUpdate = true;

		}

	},

	merge: function ( geometry, offset ) {

		if ( ! ( geometry && geometry.isBufferGeometry ) ) {

			console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
			return;

		}

		if ( offset === undefined ) offset = 0;

		var attributes = this.attributes;

		for ( var key in attributes ) {

			if ( geometry.attributes[ key ] === undefined ) continue;

			var attribute1 = attributes[ key ];
			var attributeArray1 = attribute1.array;

			var attribute2 = geometry.attributes[ key ];
			var attributeArray2 = attribute2.array;

			var attributeSize = attribute2.itemSize;

			for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {

				attributeArray1[ j ] = attributeArray2[ i ];

			}

		}

		return this;

	},

	normalizeNormals: function () {

		var vector = new Vector3();

		return function normalizeNormals() {

			var normals = this.attributes.normal;

			for ( var i = 0, il = normals.count; i < il; i ++ ) {

				vector.x = normals.getX( i );
				vector.y = normals.getY( i );
				vector.z = normals.getZ( i );

				vector.normalize();

				normals.setXYZ( i, vector.x, vector.y, vector.z );

			}

		};

	}(),

	toNonIndexed: function () {

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
			return this;

		}

		var geometry2 = new BufferGeometry();

		var indices = this.index.array;
		var attributes = this.attributes;

		for ( var name in attributes ) {

			var attribute = attributes[ name ];

			var array = attribute.array;
			var itemSize = attribute.itemSize;

			var array2 = new array.constructor( indices.length * itemSize );

			var index = 0, index2 = 0;

			for ( var i = 0, l = indices.length; i < l; i ++ ) {

				index = indices[ i ] * itemSize;

				for ( var j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );

		}

		return geometry2;

	},

	toJSON: function () {

		var data = {
			metadata: {
				version: 4.5,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;

		if ( this.parameters !== undefined ) {

			var parameters = this.parameters;

			for ( var key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		data.data = { attributes: {} };

		var index = this.index;

		if ( index !== null ) {

			var array = Array.prototype.slice.call( index.array );

			data.data.index = {
				type: index.array.constructor.name,
				array: array
			};

		}

		var attributes = this.attributes;

		for ( var key in attributes ) {

			var attribute = attributes[ key ];

			var array = Array.prototype.slice.call( attribute.array );

			data.data.attributes[ key ] = {
				itemSize: attribute.itemSize,
				type: attribute.array.constructor.name,
				array: array,
				normalized: attribute.normalized
			};

		}

		var groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		var boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	},

	clone: function () {

		/*
		 // Handle primitives

		 var parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 var values = [];

		 for ( var key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 var geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */

		return new BufferGeometry().copy( this );

	},

	copy: function ( source ) {

		var name, i, l;

		// reset

		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// name

		this.name = source.name;

		// index

		var index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone() );

		}

		// attributes

		var attributes = source.attributes;

		for ( name in attributes ) {

			var attribute = attributes[ name ];
			this.addAttribute( name, attribute.clone() );

		}

		// morph attributes

		var morphAttributes = source.morphAttributes;

		for ( name in morphAttributes ) {

			var array = [];
			var morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( i = 0, l = morphAttribute.length; i < l; i ++ ) {

				array.push( morphAttribute[ i ].clone() );

			}

			this.morphAttributes[ name ] = array;

		}

		// groups

		var groups = source.groups;

		for ( i = 0, l = groups.length; i < l; i ++ ) {

			var group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		// bounding box

		var boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		var boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// draw range

		this.drawRange.start = source.drawRange.start;
		this.drawRange.count = source.drawRange.count;

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

// BoxGeometry

function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

	Geometry.call( this );

	this.type = 'BoxGeometry';

	this.parameters = {
		width: width,
		height: height,
		depth: depth,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		depthSegments: depthSegments
	};

	this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
	this.mergeVertices();

}

BoxGeometry.prototype = Object.create( Geometry.prototype );
BoxGeometry.prototype.constructor = BoxGeometry;

// BoxBufferGeometry

function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

	BufferGeometry.call( this );

	this.type = 'BoxBufferGeometry';

	this.parameters = {
		width: width,
		height: height,
		depth: depth,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		depthSegments: depthSegments
	};

	var scope = this;

	width = width || 1;
	height = height || 1;
	depth = depth || 1;

	// segments

	widthSegments = Math.floor( widthSegments ) || 1;
	heightSegments = Math.floor( heightSegments ) || 1;
	depthSegments = Math.floor( depthSegments ) || 1;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var numberOfVertices = 0;
	var groupStart = 0;

	// build each side of the box geometry

	buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height, width, depthSegments, heightSegments, 0 ); // px
	buildPlane( 'z', 'y', 'x', 1, - 1, depth, height, - width, depthSegments, heightSegments, 1 ); // nx
	buildPlane( 'x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2 ); // py
	buildPlane( 'x', 'z', 'y', 1, - 1, width, depth, - height, widthSegments, depthSegments, 3 ); // ny
	buildPlane( 'x', 'y', 'z', 1, - 1, width, height, depth, widthSegments, heightSegments, 4 ); // pz
	buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth, widthSegments, heightSegments, 5 ); // nz

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

		var segmentWidth = width / gridX;
		var segmentHeight = height / gridY;

		var widthHalf = width / 2;
		var heightHalf = height / 2;
		var depthHalf = depth / 2;

		var gridX1 = gridX + 1;
		var gridY1 = gridY + 1;

		var vertexCounter = 0;
		var groupCount = 0;

		var ix, iy;

		var vector = new Vector3();

		// generate vertices, normals and uvs

		for ( iy = 0; iy < gridY1; iy ++ ) {

			var y = iy * segmentHeight - heightHalf;

			for ( ix = 0; ix < gridX1; ix ++ ) {

				var x = ix * segmentWidth - widthHalf;

				// set values to correct vector component

				vector[ u ] = x * udir;
				vector[ v ] = y * vdir;
				vector[ w ] = depthHalf;

				// now apply vector to vertex buffer

				vertices.push( vector.x, vector.y, vector.z );

				// set values to correct vector component

				vector[ u ] = 0;
				vector[ v ] = 0;
				vector[ w ] = depth > 0 ? 1 : - 1;

				// now apply vector to normal buffer

				normals.push( vector.x, vector.y, vector.z );

				// uvs

				uvs.push( ix / gridX );
				uvs.push( 1 - ( iy / gridY ) );

				// counters

				vertexCounter += 1;

			}

		}

		// indices

		// 1. you need three indices to draw a single face
		// 2. a single segment consists of two faces
		// 3. so we need to generate six (2*3) indices per segment

		for ( iy = 0; iy < gridY; iy ++ ) {

			for ( ix = 0; ix < gridX; ix ++ ) {

				var a = numberOfVertices + ix + gridX1 * iy;
				var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
				var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
				var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

				// increase counter

				groupCount += 6;

			}

		}

		// add a group to the geometry. this will ensure multi material support

		scope.addGroup( groupStart, groupCount, materialIndex );

		// calculate new start value for groups

		groupStart += groupCount;

		// update total number of vertices

		numberOfVertices += vertexCounter;

	}

}

BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

// PlaneGeometry

function PlaneGeometry( width, height, widthSegments, heightSegments ) {

	Geometry.call( this );

	this.type = 'PlaneGeometry';

	this.parameters = {
		width: width,
		height: height,
		widthSegments: widthSegments,
		heightSegments: heightSegments
	};

	this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );
	this.mergeVertices();

}

PlaneGeometry.prototype = Object.create( Geometry.prototype );
PlaneGeometry.prototype.constructor = PlaneGeometry;

// PlaneBufferGeometry

function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {

	BufferGeometry.call( this );

	this.type = 'PlaneBufferGeometry';

	this.parameters = {
		width: width,
		height: height,
		widthSegments: widthSegments,
		heightSegments: heightSegments
	};

	width = width || 1;
	height = height || 1;

	var width_half = width / 2;
	var height_half = height / 2;

	var gridX = Math.floor( widthSegments ) || 1;
	var gridY = Math.floor( heightSegments ) || 1;

	var gridX1 = gridX + 1;
	var gridY1 = gridY + 1;

	var segment_width = width / gridX;
	var segment_height = height / gridY;

	var ix, iy;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// generate vertices, normals and uvs

	for ( iy = 0; iy < gridY1; iy ++ ) {

		var y = iy * segment_height - height_half;

		for ( ix = 0; ix < gridX1; ix ++ ) {

			var x = ix * segment_width - width_half;

			vertices.push( x, - y, 0 );

			normals.push( 0, 0, 1 );

			uvs.push( ix / gridX );
			uvs.push( 1 - ( iy / gridY ) );

		}

	}

	// indices

	for ( iy = 0; iy < gridY; iy ++ ) {

		for ( ix = 0; ix < gridX; ix ++ ) {

			var a = ix + gridX1 * iy;
			var b = ix + gridX1 * ( iy + 1 );
			var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
			var d = ( ix + 1 ) + gridX1 * iy;

			// faces

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>
 * }
 */

function MeshBasicMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshBasicMaterial';

	this.color = new Color( 0xffffff ); // emissive

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;

	this.lights = false;

	this.setValues( parameters );

}

MeshBasicMaterial.prototype = Object.create( Material.prototype );
MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;

MeshBasicMaterial.prototype.isMeshBasicMaterial = true;

MeshBasicMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;

	return this;

};

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function ShaderMaterial( parameters ) {

	Material.call( this );

	this.type = 'ShaderMaterial';

	this.defines = {};
	this.uniforms = {};

	this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
	this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';

	this.linewidth = 1;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false; // set to use scene fog
	this.lights = false; // set to use scene lights
	this.clipping = false; // set to use user-defined clipping planes

	this.skinning = false; // set to use skinning attribute streams
	this.morphTargets = false; // set to use morph targets
	this.morphNormals = false; // set to use morph normals

	this.extensions = {
		derivatives: false, // set to use derivatives
		fragDepth: false, // set to use fragment depth values
		drawBuffers: false, // set to use draw buffers
		shaderTextureLOD: false // set to use shader texture LOD
	};

	// When rendered geometry doesn't include these attributes but the material does,
	// use these default values in WebGL. This avoids errors when buffer data is missing.
	this.defaultAttributeValues = {
		'color': [ 1, 1, 1 ],
		'uv': [ 0, 0 ],
		'uv2': [ 0, 0 ]
	};

	this.index0AttributeName = undefined;

	if ( parameters !== undefined ) {

		if ( parameters.attributes !== undefined ) {

			console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );

		}

		this.setValues( parameters );

	}

}

ShaderMaterial.prototype = Object.create( Material.prototype );
ShaderMaterial.prototype.constructor = ShaderMaterial;

ShaderMaterial.prototype.isShaderMaterial = true;

ShaderMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.fragmentShader = source.fragmentShader;
	this.vertexShader = source.vertexShader;

	this.uniforms = UniformsUtils.clone( source.uniforms );

	this.defines = source.defines;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	this.lights = source.lights;
	this.clipping = source.clipping;

	this.skinning = source.skinning;

	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	this.extensions = source.extensions;

	return this;

};

ShaderMaterial.prototype.toJSON = function ( meta ) {

	var data = Material.prototype.toJSON.call( this, meta );

	data.uniforms = this.uniforms;
	data.vertexShader = this.vertexShader;
	data.fragmentShader = this.fragmentShader;

	return data;

};

/**
 * @author bhouston / http://clara.io
 */

function Ray( origin, direction ) {

	this.origin = ( origin !== undefined ) ? origin : new Vector3();
	this.direction = ( direction !== undefined ) ? direction : new Vector3();

}

Object.assign( Ray.prototype, {

	set: function ( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	},

	at: function ( t, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );

	},

	lookAt: function ( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	},

	recast: function () {

		var v1 = new Vector3();

		return function recast( t ) {

			this.origin.copy( this.at( t, v1 ) );

			return this;

		};

	}(),

	closestPointToPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector3();
		result.subVectors( point, this.origin );
		var directionDistance = result.dot( this.direction );

		if ( directionDistance < 0 ) {

			return result.copy( this.origin );

		}

		return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

	},

	distanceToPoint: function ( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	},

	distanceSqToPoint: function () {

		var v1 = new Vector3();

		return function distanceSqToPoint( point ) {

			var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );

			// point behind the ray

			if ( directionDistance < 0 ) {

				return this.origin.distanceToSquared( point );

			}

			v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

			return v1.distanceToSquared( point );

		};

	}(),

	distanceSqToSegment: function () {

		var segCenter = new Vector3();
		var segDir = new Vector3();
		var diff = new Vector3();

		return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

			// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
			// It returns the min distance between the ray and the segment
			// defined by v0 and v1
			// It can also set two optional targets :
			// - The closest point on the ray
			// - The closest point on the segment

			segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
			segDir.copy( v1 ).sub( v0 ).normalize();
			diff.copy( this.origin ).sub( segCenter );

			var segExtent = v0.distanceTo( v1 ) * 0.5;
			var a01 = - this.direction.dot( segDir );
			var b0 = diff.dot( this.direction );
			var b1 = - diff.dot( segDir );
			var c = diff.lengthSq();
			var det = Math.abs( 1 - a01 * a01 );
			var s0, s1, sqrDist, extDet;

			if ( det > 0 ) {

				// The ray and segment are not parallel.

				s0 = a01 * b1 - b0;
				s1 = a01 * b0 - b1;
				extDet = segExtent * det;

				if ( s0 >= 0 ) {

					if ( s1 >= - extDet ) {

						if ( s1 <= extDet ) {

							// region 0
							// Minimum at interior points of ray and segment.

							var invDet = 1 / det;
							s0 *= invDet;
							s1 *= invDet;
							sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

						} else {

							// region 1

							s1 = segExtent;
							s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					} else {

						// region 5

						s1 = - segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					if ( s1 <= - extDet ) {

						// region 4

						s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
						s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					} else if ( s1 <= extDet ) {

						// region 3

						s0 = 0;
						s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = s1 * ( s1 + 2 * b1 ) + c;

					} else {

						// region 2

						s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
						s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				}

			} else {

				// Ray and segment are parallel.

				s1 = ( a01 > 0 ) ? - segExtent : segExtent;
				s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
				sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

			}

			if ( optionalPointOnRay ) {

				optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );

			}

			if ( optionalPointOnSegment ) {

				optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );

			}

			return sqrDist;

		};

	}(),

	intersectSphere: function () {

		var v1 = new Vector3();

		return function intersectSphere( sphere, optionalTarget ) {

			v1.subVectors( sphere.center, this.origin );
			var tca = v1.dot( this.direction );
			var d2 = v1.dot( v1 ) - tca * tca;
			var radius2 = sphere.radius * sphere.radius;

			if ( d2 > radius2 ) return null;

			var thc = Math.sqrt( radius2 - d2 );

			// t0 = first intersect point - entrance on front of sphere
			var t0 = tca - thc;

			// t1 = second intersect point - exit point on back of sphere
			var t1 = tca + thc;

			// test to see if both t0 and t1 are behind the ray - if so, return null
			if ( t0 < 0 && t1 < 0 ) return null;

			// test to see if t0 is behind the ray:
			// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
			// in order to always return an intersect point that is in front of the ray.
			if ( t0 < 0 ) return this.at( t1, optionalTarget );

			// else t0 is in front of the ray, so return the first collision point scaled by t0
			return this.at( t0, optionalTarget );

		};

	}(),

	intersectsSphere: function ( sphere ) {

		return this.distanceToPoint( sphere.center ) <= sphere.radius;

	},

	distanceToPlane: function ( plane ) {

		var denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t : null;

	},

	intersectPlane: function ( plane, optionalTarget ) {

		var t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, optionalTarget );

	},

	intersectsPlane: function ( plane ) {

		// check if the ray lies on the plane first

		var distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		var denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	},

	intersectBox: function ( box, optionalTarget ) {

		var tmin, tmax, tymin, tymax, tzmin, tzmax;

		var invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		var origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		// These lines also handle the case where tmin or tmax is NaN
		// (result of 0 * Infinity). x !== x returns true if x is NaN

		if ( tymin > tmin || tmin !== tmin ) tmin = tymin;

		if ( tymax < tmax || tmax !== tmax ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );

	},

	intersectsBox: ( function () {

		var v = new Vector3();

		return function intersectsBox( box ) {

			return this.intersectBox( box, v ) !== null;

		};

	} )(),

	intersectTriangle: function () {

		// Compute the offset origin, edges, and normal.
		var diff = new Vector3();
		var edge1 = new Vector3();
		var edge2 = new Vector3();
		var normal = new Vector3();

		return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {

			// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

			edge1.subVectors( b, a );
			edge2.subVectors( c, a );
			normal.crossVectors( edge1, edge2 );

			// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
			// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
			//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
			//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
			//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
			var DdN = this.direction.dot( normal );
			var sign;

			if ( DdN > 0 ) {

				if ( backfaceCulling ) return null;
				sign = 1;

			} else if ( DdN < 0 ) {

				sign = - 1;
				DdN = - DdN;

			} else {

				return null;

			}

			diff.subVectors( this.origin, a );
			var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );

			// b1 < 0, no intersection
			if ( DdQxE2 < 0 ) {

				return null;

			}

			var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );

			// b2 < 0, no intersection
			if ( DdE1xQ < 0 ) {

				return null;

			}

			// b1+b2 > 1, no intersection
			if ( DdQxE2 + DdE1xQ > DdN ) {

				return null;

			}

			// Line intersects triangle, check if ray does.
			var QdN = - sign * diff.dot( normal );

			// t < 0, no intersection
			if ( QdN < 0 ) {

				return null;

			}

			// Ray intersects triangle.
			return this.at( QdN / DdN, optionalTarget );

		};

	}(),

	applyMatrix4: function ( matrix4 ) {

		this.origin.applyMatrix4( matrix4 );
		this.direction.transformDirection( matrix4 );

		return this;

	},

	equals: function ( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

} );

/**
 * @author bhouston / http://clara.io
 */

function Line3( start, end ) {

	this.start = ( start !== undefined ) ? start : new Vector3();
	this.end = ( end !== undefined ) ? end : new Vector3();

}

Object.assign( Line3.prototype, {

	set: function ( start, end ) {

		this.start.copy( start );
		this.end.copy( end );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( line ) {

		this.start.copy( line.start );
		this.end.copy( line.end );

		return this;

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

	},

	delta: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.subVectors( this.end, this.start );

	},

	distanceSq: function () {

		return this.start.distanceToSquared( this.end );

	},

	distance: function () {

		return this.start.distanceTo( this.end );

	},

	at: function ( t, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return this.delta( result ).multiplyScalar( t ).add( this.start );

	},

	closestPointToPointParameter: function () {

		var startP = new Vector3();
		var startEnd = new Vector3();

		return function closestPointToPointParameter( point, clampToLine ) {

			startP.subVectors( point, this.start );
			startEnd.subVectors( this.end, this.start );

			var startEnd2 = startEnd.dot( startEnd );
			var startEnd_startP = startEnd.dot( startP );

			var t = startEnd_startP / startEnd2;

			if ( clampToLine ) {

				t = _Math.clamp( t, 0, 1 );

			}

			return t;

		};

	}(),

	closestPointToPoint: function ( point, clampToLine, optionalTarget ) {

		var t = this.closestPointToPointParameter( point, clampToLine );

		var result = optionalTarget || new Vector3();

		return this.delta( result ).multiplyScalar( t ).add( this.start );

	},

	applyMatrix4: function ( matrix ) {

		this.start.applyMatrix4( matrix );
		this.end.applyMatrix4( matrix );

		return this;

	},

	equals: function ( line ) {

		return line.start.equals( this.start ) && line.end.equals( this.end );

	}

} );

/**
 * @author bhouston / http://clara.io
 * @author mrdoob / http://mrdoob.com/
 */

function Triangle( a, b, c ) {

	this.a = ( a !== undefined ) ? a : new Vector3();
	this.b = ( b !== undefined ) ? b : new Vector3();
	this.c = ( c !== undefined ) ? c : new Vector3();

}

Object.assign( Triangle, {

	normal: function () {

		var v0 = new Vector3();

		return function normal( a, b, c, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			result.subVectors( c, b );
			v0.subVectors( a, b );
			result.cross( v0 );

			var resultLengthSq = result.lengthSq();
			if ( resultLengthSq > 0 ) {

				return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );

			}

			return result.set( 0, 0, 0 );

		};

	}(),

	// static/instance method to calculate barycentric coordinates
	// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
	barycoordFromPoint: function () {

		var v0 = new Vector3();
		var v1 = new Vector3();
		var v2 = new Vector3();

		return function barycoordFromPoint( point, a, b, c, optionalTarget ) {

			v0.subVectors( c, a );
			v1.subVectors( b, a );
			v2.subVectors( point, a );

			var dot00 = v0.dot( v0 );
			var dot01 = v0.dot( v1 );
			var dot02 = v0.dot( v2 );
			var dot11 = v1.dot( v1 );
			var dot12 = v1.dot( v2 );

			var denom = ( dot00 * dot11 - dot01 * dot01 );

			var result = optionalTarget || new Vector3();

			// collinear or singular triangle
			if ( denom === 0 ) {

				// arbitrary location outside of triangle?
				// not sure if this is the best idea, maybe should be returning undefined
				return result.set( - 2, - 1, - 1 );

			}

			var invDenom = 1 / denom;
			var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
			var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

			// barycentric coordinates must always sum to 1
			return result.set( 1 - u - v, v, u );

		};

	}(),

	containsPoint: function () {

		var v1 = new Vector3();

		return function containsPoint( point, a, b, c ) {

			var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );

			return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );

		};

	}()

} );

Object.assign( Triangle.prototype, {

	set: function ( a, b, c ) {

		this.a.copy( a );
		this.b.copy( b );
		this.c.copy( c );

		return this;

	},

	setFromPointsAndIndices: function ( points, i0, i1, i2 ) {

		this.a.copy( points[ i0 ] );
		this.b.copy( points[ i1 ] );
		this.c.copy( points[ i2 ] );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( triangle ) {

		this.a.copy( triangle.a );
		this.b.copy( triangle.b );
		this.c.copy( triangle.c );

		return this;

	},

	area: function () {

		var v0 = new Vector3();
		var v1 = new Vector3();

		return function area() {

			v0.subVectors( this.c, this.b );
			v1.subVectors( this.a, this.b );

			return v0.cross( v1 ).length() * 0.5;

		};

	}(),

	midpoint: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

	},

	normal: function ( optionalTarget ) {

		return Triangle.normal( this.a, this.b, this.c, optionalTarget );

	},

	plane: function ( optionalTarget ) {

		var result = optionalTarget || new Plane();

		return result.setFromCoplanarPoints( this.a, this.b, this.c );

	},

	barycoordFromPoint: function ( point, optionalTarget ) {

		return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );

	},

	containsPoint: function ( point ) {

		return Triangle.containsPoint( point, this.a, this.b, this.c );

	},

	closestPointToPoint: function () {

		var plane = new Plane();
		var edgeList = [ new Line3(), new Line3(), new Line3() ];
		var projectedPoint = new Vector3();
		var closestPoint = new Vector3();

		return function closestPointToPoint( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();
			var minDistance = Infinity;

			// project the point onto the plane of the triangle

			plane.setFromCoplanarPoints( this.a, this.b, this.c );
			plane.projectPoint( point, projectedPoint );

			// check if the projection lies within the triangle

			if ( this.containsPoint( projectedPoint ) === true ) {

				// if so, this is the closest point

				result.copy( projectedPoint );

			} else {

				// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices

				edgeList[ 0 ].set( this.a, this.b );
				edgeList[ 1 ].set( this.b, this.c );
				edgeList[ 2 ].set( this.c, this.a );

				for ( var i = 0; i < edgeList.length; i ++ ) {

					edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );

					var distance = projectedPoint.distanceToSquared( closestPoint );

					if ( distance < minDistance ) {

						minDistance = distance;

						result.copy( closestPoint );

					}

				}

			}

			return result;

		};

	}(),

	equals: function ( triangle ) {

		return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author jonobr1 / http://jonobr1.com/
 */

function Mesh( geometry, material ) {

	Object3D.call( this );

	this.type = 'Mesh';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );

	this.drawMode = TrianglesDrawMode;

	this.updateMorphTargets();

}

Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Mesh,

	isMesh: true,

	setDrawMode: function ( value ) {

		this.drawMode = value;

	},

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.drawMode = source.drawMode;

		if ( source.morphTargetInfluences !== undefined ) {

			this.morphTargetInfluences = source.morphTargetInfluences.slice();

		}

		if ( source.morphTargetDictionary !== undefined ) {

			this.morphTargetDictionary = Object.assign( {}, source.morphTargetDictionary );

		}

		return this;

	},

	updateMorphTargets: function () {

		var geometry = this.geometry;
		var m, ml, name;

		if ( geometry.isBufferGeometry ) {

			var morphAttributes = geometry.morphAttributes;
			var keys = Object.keys( morphAttributes );

			if ( keys.length > 0 ) {

				var morphAttribute = morphAttributes[ keys[ 0 ] ];

				if ( morphAttribute !== undefined ) {

					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};

					for ( m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

						name = morphAttribute[ m ].name || String( m );

						this.morphTargetInfluences.push( 0 );
						this.morphTargetDictionary[ name ] = m;

					}

				}

			}

		} else {

			var morphTargets = geometry.morphTargets;

			if ( morphTargets !== undefined && morphTargets.length > 0 ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( m = 0, ml = morphTargets.length; m < ml; m ++ ) {

					name = morphTargets[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	},

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		var vA = new Vector3();
		var vB = new Vector3();
		var vC = new Vector3();

		var tempA = new Vector3();
		var tempB = new Vector3();
		var tempC = new Vector3();

		var uvA = new Vector2();
		var uvB = new Vector2();
		var uvC = new Vector2();

		var barycoord = new Vector3();

		var intersectionPoint = new Vector3();
		var intersectionPointWorld = new Vector3();

		function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {

			Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );

			uv1.multiplyScalar( barycoord.x );
			uv2.multiplyScalar( barycoord.y );
			uv3.multiplyScalar( barycoord.z );

			uv1.add( uv2 ).add( uv3 );

			return uv1.clone();

		}

		function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {

			var intersect;

			if ( material.side === BackSide ) {

				intersect = ray.intersectTriangle( pC, pB, pA, true, point );

			} else {

				intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );

			}

			if ( intersect === null ) return null;

			intersectionPointWorld.copy( point );
			intersectionPointWorld.applyMatrix4( object.matrixWorld );

			var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );

			if ( distance < raycaster.near || distance > raycaster.far ) return null;

			return {
				distance: distance,
				point: intersectionPointWorld.clone(),
				object: object
			};

		}

		function checkBufferGeometryIntersection( object, raycaster, ray, position, uv, a, b, c ) {

			vA.fromBufferAttribute( position, a );
			vB.fromBufferAttribute( position, b );
			vC.fromBufferAttribute( position, c );

			var intersection = checkIntersection( object, object.material, raycaster, ray, vA, vB, vC, intersectionPoint );

			if ( intersection ) {

				if ( uv ) {

					uvA.fromBufferAttribute( uv, a );
					uvB.fromBufferAttribute( uv, b );
					uvC.fromBufferAttribute( uv, c );

					intersection.uv = uvIntersection( intersectionPoint, vA, vB, vC, uvA, uvB, uvC );

				}

				intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
				intersection.faceIndex = a;

			}

			return intersection;

		}

		return function raycast( raycaster, intersects ) {

			var geometry = this.geometry;
			var material = this.material;
			var matrixWorld = this.matrixWorld;

			if ( material === undefined ) return;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			// Check boundingBox before continuing

			if ( geometry.boundingBox !== null ) {

				if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;

			}

			var intersection;

			if ( geometry.isBufferGeometry ) {

				var a, b, c;
				var index = geometry.index;
				var position = geometry.attributes.position;
				var uv = geometry.attributes.uv;
				var i, l;

				if ( index !== null ) {

					// indexed buffer geometry

					for ( i = 0, l = index.count; i < l; i += 3 ) {

						a = index.getX( i );
						b = index.getX( i + 1 );
						c = index.getX( i + 2 );

						intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
							intersects.push( intersection );

						}

					}

				} else if ( position !== undefined ) {

					// non-indexed buffer geometry

					for ( i = 0, l = position.count; i < l; i += 3 ) {

						a = i;
						b = i + 1;
						c = i + 2;

						intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );

						if ( intersection ) {

							intersection.index = a; // triangle number in positions buffer semantics
							intersects.push( intersection );

						}

					}

				}

			} else if ( geometry.isGeometry ) {

				var fvA, fvB, fvC;
				var isMultiMaterial = Array.isArray( material );

				var vertices = geometry.vertices;
				var faces = geometry.faces;
				var uvs;

				var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
				if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;

				for ( var f = 0, fl = faces.length; f < fl; f ++ ) {

					var face = faces[ f ];
					var faceMaterial = isMultiMaterial ? material[ face.materialIndex ] : material;

					if ( faceMaterial === undefined ) continue;

					fvA = vertices[ face.a ];
					fvB = vertices[ face.b ];
					fvC = vertices[ face.c ];

					if ( faceMaterial.morphTargets === true ) {

						var morphTargets = geometry.morphTargets;
						var morphInfluences = this.morphTargetInfluences;

						vA.set( 0, 0, 0 );
						vB.set( 0, 0, 0 );
						vC.set( 0, 0, 0 );

						for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

							var influence = morphInfluences[ t ];

							if ( influence === 0 ) continue;

							var targets = morphTargets[ t ].vertices;

							vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
							vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
							vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );

						}

						vA.add( fvA );
						vB.add( fvB );
						vC.add( fvC );

						fvA = vA;
						fvB = vB;
						fvC = vC;

					}

					intersection = checkIntersection( this, faceMaterial, raycaster, ray, fvA, fvB, fvC, intersectionPoint );

					if ( intersection ) {

						if ( uvs && uvs[ f ] ) {

							var uvs_f = uvs[ f ];
							uvA.copy( uvs_f[ 0 ] );
							uvB.copy( uvs_f[ 1 ] );
							uvC.copy( uvs_f[ 2 ] );

							intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );

						}

						intersection.face = face;
						intersection.faceIndex = f;
						intersects.push( intersection );

					}

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLBackground( renderer, state, geometries, premultipliedAlpha ) {

	var clearColor = new Color( 0x000000 );
	var clearAlpha = 0;

	var planeCamera, planeMesh;
	var boxMesh;

	function render( renderList, scene, camera, forceClear ) {

		var background = scene.background;

		if ( background === null ) {

			setClear( clearColor, clearAlpha );

		} else if ( background && background.isColor ) {

			setClear( background, 1 );
			forceClear = true;

		}

		if ( renderer.autoClear || forceClear ) {

			renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );

		}

		if ( background && background.isCubeTexture ) {

			if ( boxMesh === undefined ) {

				boxMesh = new Mesh(
					new BoxBufferGeometry( 1, 1, 1 ),
					new ShaderMaterial( {
						uniforms: ShaderLib.cube.uniforms,
						vertexShader: ShaderLib.cube.vertexShader,
						fragmentShader: ShaderLib.cube.fragmentShader,
						side: BackSide,
						depthTest: true,
						depthWrite: false,
						fog: false
					} )
				);

				boxMesh.geometry.removeAttribute( 'normal' );
				boxMesh.geometry.removeAttribute( 'uv' );

				boxMesh.onBeforeRender = function ( renderer, scene, camera ) {

					this.matrixWorld.copyPosition( camera.matrixWorld );

				};

				geometries.update( boxMesh.geometry );

			}

			boxMesh.material.uniforms.tCube.value = background;

			renderList.push( boxMesh, boxMesh.geometry, boxMesh.material, 0, null );

		} else if ( background && background.isTexture ) {

			if ( planeCamera === undefined ) {

				planeCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );

				planeMesh = new Mesh(
					new PlaneBufferGeometry( 2, 2 ),
					new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
				);

				geometries.update( planeMesh.geometry );

			}

			planeMesh.material.map = background;

			// TODO Push this to renderList

			renderer.renderBufferDirect( planeCamera, null, planeMesh.geometry, planeMesh.material, planeMesh, null );

		}

	}

	function setClear( color, alpha ) {

		state.buffers.color.setClear( color.r, color.g, color.b, alpha, premultipliedAlpha );

	}

	return {

		getClearColor: function () {

			return clearColor;

		},
		setClearColor: function ( color, alpha ) {

			clearColor.set( color );
			clearAlpha = alpha !== undefined ? alpha : 1;
			setClear( clearColor, clearAlpha );

		},
		getClearAlpha: function () {

			return clearAlpha;

		},
		setClearAlpha: function ( alpha ) {

			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		render: render

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function painterSortStable( a, b ) {

	if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.program && b.program && a.program !== b.program ) {

		return a.program.id - b.program.id;

	} else if ( a.material.id !== b.material.id ) {

		return a.material.id - b.material.id;

	} else if ( a.z !== b.z ) {

		return a.z - b.z;

	} else {

		return a.id - b.id;

	}

}

function reversePainterSortStable( a, b ) {

	if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} if ( a.z !== b.z ) {

		return b.z - a.z;

	} else {

		return a.id - b.id;

	}

}

function WebGLRenderList() {

	var renderItems = [];
	var renderItemsIndex = 0;

	var opaque = [];
	var transparent = [];

	function init() {

		renderItemsIndex = 0;

		opaque.length = 0;
		transparent.length = 0;

	}

	function push( object, geometry, material, z, group ) {

		var renderItem = renderItems[ renderItemsIndex ];

		if ( renderItem === undefined ) {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				program: material.program,
				renderOrder: object.renderOrder,
				z: z,
				group: group
			};

			renderItems[ renderItemsIndex ] = renderItem;

		} else {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.program = material.program;
			renderItem.renderOrder = object.renderOrder;
			renderItem.z = z;
			renderItem.group = group;

		}

		( material.transparent === true ? transparent : opaque ).push( renderItem );

		renderItemsIndex ++;

	}

	function sort() {

		if ( opaque.length > 1 ) opaque.sort( painterSortStable );
		if ( transparent.length > 1 ) transparent.sort( reversePainterSortStable );

	}

	return {
		opaque: opaque,
		transparent: transparent,

		init: init,
		push: push,

		sort: sort
	};

}

function WebGLRenderLists() {

	var lists = {};

	function get( scene, camera ) {

		var hash = scene.id + ',' + camera.id;
		var list = lists[ hash ];

		if ( list === undefined ) {

			// console.log( 'THREE.WebGLRenderLists:', hash );

			list = new WebGLRenderList();
			lists[ hash ] = list;

		}

		return list;

	}

	function dispose() {

		lists = {};

	}

	return {
		get: get,
		dispose: dispose
	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function absNumericalSort( a, b ) {

	return Math.abs( b[ 1 ] ) - Math.abs( a[ 1 ] );

}

function WebGLMorphtargets( gl ) {

	var influencesList = {};
	var morphInfluences = new Float32Array( 8 );

	function update( object, geometry, material, program ) {

		var objectInfluences = object.morphTargetInfluences;

		var length = objectInfluences.length;

		var influences = influencesList[ geometry.id ];

		if ( influences === undefined ) {

			// initialise list

			influences = [];

			for ( var i = 0; i < length; i ++ ) {

				influences[ i ] = [ i, 0 ];

			}

			influencesList[ geometry.id ] = influences;

		}

		var morphTargets = material.morphTargets && geometry.morphAttributes.position;
		var morphNormals = material.morphNormals && geometry.morphAttributes.normal;

		// Remove current morphAttributes

		for ( var i = 0; i < length; i ++ ) {

			var influence = influences[ i ];

			if ( influence[ 1 ] !== 0 ) {

				if ( morphTargets ) geometry.removeAttribute( 'morphTarget' + i );
				if ( morphNormals ) geometry.removeAttribute( 'morphNormal' + i );

			}

		}

		// Collect influences

		for ( var i = 0; i < length; i ++ ) {

			var influence = influences[ i ];

			influence[ 0 ] = i;
			influence[ 1 ] = objectInfluences[ i ];

		}

		influences.sort( absNumericalSort );

		// Add morphAttributes

		for ( var i = 0; i < 8; i ++ ) {

			var influence = influences[ i ];

			if ( influence ) {

				var index = influence[ 0 ];
				var value = influence[ 1 ];

				if ( value ) {

					if ( morphTargets ) geometry.addAttribute( 'morphTarget' + i, morphTargets[ index ] );
					if ( morphNormals ) geometry.addAttribute( 'morphNormal' + i, morphNormals[ index ] );

					morphInfluences[ i ] = value;
					continue;

				}

			}

			morphInfluences[ i ] = 0;

		}

		program.getUniforms().setValue( gl, 'morphTargetInfluences', morphInfluences );

	}

	return {

		update: update

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {

	var mode;

	function setMode( value ) {

		mode = value;

	}

	var type, bytesPerElement;

	function setIndex( value ) {

		type = value.type;
		bytesPerElement = value.bytesPerElement;

	}

	function render( start, count ) {

		gl.drawElements( mode, count, type, start * bytesPerElement );

		infoRender.calls ++;
		infoRender.vertices += count;

		if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
		else if ( mode === gl.POINTS ) infoRender.points += count;

	}

	function renderInstances( geometry, start, count ) {

		var extension = extensions.get( 'ANGLE_instanced_arrays' );

		if ( extension === null ) {

			console.error( 'THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
			return;

		}

		extension.drawElementsInstancedANGLE( mode, count, type, start * bytesPerElement, geometry.maxInstancedCount );

		infoRender.calls ++;
		infoRender.vertices += count * geometry.maxInstancedCount;

		if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
		else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;

	}

	//

	this.setMode = setMode;
	this.setIndex = setIndex;
	this.render = render;
	this.renderInstances = renderInstances;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLBufferRenderer( gl, extensions, infoRender ) {

	var mode;

	function setMode( value ) {

		mode = value;

	}

	function render( start, count ) {

		gl.drawArrays( mode, start, count );

		infoRender.calls ++;
		infoRender.vertices += count;

		if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
		else if ( mode === gl.POINTS ) infoRender.points += count;

	}

	function renderInstances( geometry, start, count ) {

		var extension = extensions.get( 'ANGLE_instanced_arrays' );

		if ( extension === null ) {

			console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
			return;

		}

		var position = geometry.attributes.position;

		if ( position.isInterleavedBufferAttribute ) {

			count = position.data.count;

			extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

		} else {

			extension.drawArraysInstancedANGLE( mode, start, count, geometry.maxInstancedCount );

		}

		infoRender.calls ++;
		infoRender.vertices += count * geometry.maxInstancedCount;

		if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
		else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;

	}

	//

	this.setMode = setMode;
	this.render = render;
	this.renderInstances = renderInstances;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLGeometries( gl, attributes, infoMemory ) {

	var geometries = {};
	var wireframeAttributes = {};

	function onGeometryDispose( event ) {

		var geometry = event.target;
		var buffergeometry = geometries[ geometry.id ];

		if ( buffergeometry.index !== null ) {

			attributes.remove( buffergeometry.index );

		}

		for ( var name in buffergeometry.attributes ) {

			attributes.remove( buffergeometry.attributes[ name ] );

		}

		geometry.removeEventListener( 'dispose', onGeometryDispose );

		delete geometries[ geometry.id ];

		// TODO Remove duplicate code

		var attribute = wireframeAttributes[ geometry.id ];

		if ( attribute ) {

			attributes.remove( attribute );
			delete wireframeAttributes[ geometry.id ];

		}

		attribute = wireframeAttributes[ buffergeometry.id ];

		if ( attribute ) {

			attributes.remove( attribute );
			delete wireframeAttributes[ buffergeometry.id ];

		}

		//

		infoMemory.geometries --;

	}

	function get( object, geometry ) {

		var buffergeometry = geometries[ geometry.id ];

		if ( buffergeometry ) return buffergeometry;

		geometry.addEventListener( 'dispose', onGeometryDispose );

		if ( geometry.isBufferGeometry ) {

			buffergeometry = geometry;

		} else if ( geometry.isGeometry ) {

			if ( geometry._bufferGeometry === undefined ) {

				geometry._bufferGeometry = new BufferGeometry().setFromObject( object );

			}

			buffergeometry = geometry._bufferGeometry;

		}

		geometries[ geometry.id ] = buffergeometry;

		infoMemory.geometries ++;

		return buffergeometry;

	}

	function update( geometry ) {

		var index = geometry.index;
		var geometryAttributes = geometry.attributes;

		if ( index !== null ) {

			attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );

		}

		for ( var name in geometryAttributes ) {

			attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );

		}

		// morph targets

		var morphAttributes = geometry.morphAttributes;

		for ( var name in morphAttributes ) {

			var array = morphAttributes[ name ];

			for ( var i = 0, l = array.length; i < l; i ++ ) {

				attributes.update( array[ i ], gl.ARRAY_BUFFER );

			}

		}

	}

	function getWireframeAttribute( geometry ) {

		var attribute = wireframeAttributes[ geometry.id ];

		if ( attribute ) return attribute;

		var indices = [];

		var geometryIndex = geometry.index;
		var geometryAttributes = geometry.attributes;

		// console.time( 'wireframe' );

		if ( geometryIndex !== null ) {

			var array = geometryIndex.array;

			for ( var i = 0, l = array.length; i < l; i += 3 ) {

				var a = array[ i + 0 ];
				var b = array[ i + 1 ];
				var c = array[ i + 2 ];

				indices.push( a, b, b, c, c, a );

			}

		} else {

			var array = geometryAttributes.position.array;

			for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

				var a = i + 0;
				var b = i + 1;
				var c = i + 2;

				indices.push( a, b, b, c, c, a );

			}

		}

		// console.timeEnd( 'wireframe' );

		attribute = new ( arrayMax( indices ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );

		attributes.update( attribute, gl.ELEMENT_ARRAY_BUFFER );

		wireframeAttributes[ geometry.id ] = attribute;

		return attribute;

	}

	return {

		get: get,
		update: update,

		getWireframeAttribute: getWireframeAttribute

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function UniformsCache() {

	var lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			var uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color(),

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0,

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0,

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2(),
						shadowCameraNear: 1,
						shadowCameraFar: 1000
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
						// TODO (abelnation): set RectAreaLight shadow uniforms
					};
					break;

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}

function WebGLLights() {

	var cache = new UniformsCache();

	var state = {

		hash: '',

		ambient: [ 0, 0, 0 ],
		directional: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotShadowMap: [],
		spotShadowMatrix: [],
		rectArea: [],
		point: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: []

	};

	var vector3 = new Vector3();
	var matrix4 = new Matrix4();
	var matrix42 = new Matrix4();

	function setup( lights, shadows, camera ) {

		var r = 0, g = 0, b = 0;

		var directionalLength = 0;
		var pointLength = 0;
		var spotLength = 0;
		var rectAreaLength = 0;
		var hemiLength = 0;

		var viewMatrix = camera.matrixWorldInverse;

		for ( var i = 0, l = lights.length; i < l; i ++ ) {

			var light = lights[ i ];

			var color = light.color;
			var intensity = light.intensity;
			var distance = light.distance;

			var shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

			if ( light.isAmbientLight ) {

				r += color.r * intensity;
				g += color.g * intensity;
				b += color.b * intensity;

			} else if ( light.isDirectionalLight ) {

				var uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					var shadow = light.shadow;

					uniforms.shadowBias = shadow.bias;
					uniforms.shadowRadius = shadow.radius;
					uniforms.shadowMapSize = shadow.mapSize;

				}

				state.directionalShadowMap[ directionalLength ] = shadowMap;
				state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
				state.directional[ directionalLength ] = uniforms;

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				var uniforms = cache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.color.copy( color ).multiplyScalar( intensity );
				uniforms.distance = distance;

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				uniforms.coneCos = Math.cos( light.angle );
				uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
				uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					var shadow = light.shadow;

					uniforms.shadowBias = shadow.bias;
					uniforms.shadowRadius = shadow.radius;
					uniforms.shadowMapSize = shadow.mapSize;

				}

				state.spotShadowMap[ spotLength ] = shadowMap;
				state.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
				state.spot[ spotLength ] = uniforms;

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				var uniforms = cache.get( light );

				// (a) intensity controls irradiance of entire light
				uniforms.color
					.copy( color )
					.multiplyScalar( intensity / ( light.width * light.height ) );

				// (b) intensity controls the radiance per light area
				// uniforms.color.copy( color ).multiplyScalar( intensity );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				// extract local rotation of light to derive width/height half vectors
				matrix42.identity();
				matrix4.copy( light.matrixWorld );
				matrix4.premultiply( viewMatrix );
				matrix42.extractRotation( matrix4 );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				uniforms.halfWidth.applyMatrix4( matrix42 );
				uniforms.halfHeight.applyMatrix4( matrix42 );

				// TODO (abelnation): RectAreaLight distance?
				// uniforms.distance = distance;

				state.rectArea[ rectAreaLength ] = uniforms;

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				var uniforms = cache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
				uniforms.distance = light.distance;
				uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					var shadow = light.shadow;

					uniforms.shadowBias = shadow.bias;
					uniforms.shadowRadius = shadow.radius;
					uniforms.shadowMapSize = shadow.mapSize;
					uniforms.shadowCameraNear = shadow.camera.near;
					uniforms.shadowCameraFar = shadow.camera.far;

				}

				state.pointShadowMap[ pointLength ] = shadowMap;
				state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;
				state.point[ pointLength ] = uniforms;

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				var uniforms = cache.get( light );

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				uniforms.direction.transformDirection( viewMatrix );
				uniforms.direction.normalize();

				uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
				uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );

				state.hemi[ hemiLength ] = uniforms;

				hemiLength ++;

			}

		}

		state.ambient[ 0 ] = r;
		state.ambient[ 1 ] = g;
		state.ambient[ 2 ] = b;

		state.directional.length = directionalLength;
		state.spot.length = spotLength;
		state.rectArea.length = rectAreaLength;
		state.point.length = pointLength;
		state.hemi.length = hemiLength;

		// TODO (sam-g-steel) why aren't we using join
		state.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + shadows.length;

	}

	return {
		setup: setup,
		state: state
	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLObjects( geometries, infoRender ) {

	var updateList = {};

	function update( object ) {

		var frame = infoRender.frame;

		var geometry = object.geometry;
		var buffergeometry = geometries.get( object, geometry );

		// Update once per frame

		if ( updateList[ buffergeometry.id ] !== frame ) {

			if ( geometry.isGeometry ) {

				buffergeometry.updateFromObject( object );

			}

			geometries.update( buffergeometry );

			updateList[ buffergeometry.id ] = frame;

		}

		return buffergeometry;

	}

	function clear() {

		updateList = {};

	}

	return {

		update: update,
		clear: clear

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function addLineNumbers( string ) {

	var lines = string.split( '\n' );

	for ( var i = 0; i < lines.length; i ++ ) {

		lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];

	}

	return lines.join( '\n' );

}

function WebGLShader( gl, type, string ) {

	var shader = gl.createShader( type );

	gl.shaderSource( shader, string );
	gl.compileShader( shader );

	if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {

		console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );

	}

	if ( gl.getShaderInfoLog( shader ) !== '' ) {

		console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );

	}

	// --enable-privileged-webgl-extension
	// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

	return shader;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

var programIdCount = 0;

function getEncodingComponents( encoding ) {

	switch ( encoding ) {

		case LinearEncoding:
			return [ 'Linear', '( value )' ];
		case sRGBEncoding:
			return [ 'sRGB', '( value )' ];
		case RGBEEncoding:
			return [ 'RGBE', '( value )' ];
		case RGBM7Encoding:
			return [ 'RGBM', '( value, 7.0 )' ];
		case RGBM16Encoding:
			return [ 'RGBM', '( value, 16.0 )' ];
		case RGBDEncoding:
			return [ 'RGBD', '( value, 256.0 )' ];
		case GammaEncoding:
			return [ 'Gamma', '( value, float( GAMMA_FACTOR ) )' ];
		default:
			throw new Error( 'unsupported encoding: ' + encoding );

	}

}

function getTexelDecodingFunction( functionName, encoding ) {

	var components = getEncodingComponents( encoding );
	return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[ 0 ] + 'ToLinear' + components[ 1 ] + '; }';

}

function getTexelEncodingFunction( functionName, encoding ) {

	var components = getEncodingComponents( encoding );
	return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[ 0 ] + components[ 1 ] + '; }';

}

function getToneMappingFunction( functionName, toneMapping ) {

	var toneMappingName;

	switch ( toneMapping ) {

		case LinearToneMapping:
			toneMappingName = 'Linear';
			break;

		case ReinhardToneMapping:
			toneMappingName = 'Reinhard';
			break;

		case Uncharted2ToneMapping:
			toneMappingName = 'Uncharted2';
			break;

		case CineonToneMapping:
			toneMappingName = 'OptimizedCineon';
			break;

		default:
			throw new Error( 'unsupported toneMapping: ' + toneMapping );

	}

	return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';

}

function generateExtensions( extensions, parameters, rendererExtensions ) {

	extensions = extensions || {};

	var chunks = [
		( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
		( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
		( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
		( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
	];

	return chunks.filter( filterEmptyLine ).join( '\n' );

}

function generateDefines( defines ) {

	var chunks = [];

	for ( var name in defines ) {

		var value = defines[ name ];

		if ( value === false ) continue;

		chunks.push( '#define ' + name + ' ' + value );

	}

	return chunks.join( '\n' );

}

function fetchAttributeLocations( gl, program ) {

	var attributes = {};

	var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

	for ( var i = 0; i < n; i ++ ) {

		var info = gl.getActiveAttrib( program, i );
		var name = info.name;

		// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

		attributes[ name ] = gl.getAttribLocation( program, name );

	}

	return attributes;

}

function filterEmptyLine( string ) {

	return string !== '';

}

function replaceLightNums( string, parameters ) {

	return string
		.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
		.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
		.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
		.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
		.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );

}

function parseIncludes( string ) {

	var pattern = /^[ \t]*#include +<([\w\d.]+)>/gm;

	function replace( match, include ) {

		var replace = ShaderChunk[ include ];

		if ( replace === undefined ) {

			throw new Error( 'Can not resolve #include <' + include + '>' );

		}

		return parseIncludes( replace );

	}

	return string.replace( pattern, replace );

}

function unrollLoops( string ) {

	var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;

	function replace( match, start, end, snippet ) {

		var unroll = '';

		for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {

			unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );

		}

		return unroll;

	}

	return string.replace( pattern, replace );

}

function WebGLProgram( renderer, extensions, code, material, shader, parameters ) {

	var gl = renderer.context;

	var defines = material.defines;

	var vertexShader = shader.vertexShader;
	var fragmentShader = shader.fragmentShader;

	var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if ( parameters.shadowMapType === PCFShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

	} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

	}

	var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
	var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
	var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';

	if ( parameters.envMap ) {

		switch ( material.envMap.mapping ) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
			case CubeUVRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

			case EquirectangularReflectionMapping:
			case EquirectangularRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
				break;

			case SphericalReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
				break;

		}

		switch ( material.envMap.mapping ) {

			case CubeRefractionMapping:
			case EquirectangularRefractionMapping:
				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}

		switch ( material.combine ) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}

	}

	var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;

	// console.log( 'building new program ' );

	//

	var customExtensions = generateExtensions( material.extensions, parameters, extensions );

	var customDefines = generateDefines( defines );

	//

	var program = gl.createProgram();

	var prefixVertex, prefixFragment;

	if ( material.isRawShaderMaterial ) {

		prefixVertex = [

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixVertex.length > 0 ) {

			prefixVertex += '\n';

		}

		prefixFragment = [

			customExtensions,
			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixFragment.length > 0 ) {

			prefixFragment += '\n';

		}

	} else {

		prefixVertex = [

			'precision ' + parameters.precision + ' float;',
			'precision ' + parameters.precision + ' int;',

			'#define SHADER_NAME ' + shader.name,

			customDefines,

			parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',

			'#define GAMMA_FACTOR ' + gammaFactorDefine,

			'#define MAX_BONES ' + parameters.maxBones,
			( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
			( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.skinning ? '#define USE_SKINNING' : '',
			parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',

			parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
			parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
			parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

			'uniform mat4 modelMatrix;',
			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform mat4 viewMatrix;',
			'uniform mat3 normalMatrix;',
			'uniform vec3 cameraPosition;',

			'attribute vec3 position;',
			'attribute vec3 normal;',
			'attribute vec2 uv;',

			'#ifdef USE_COLOR',

			'	attribute vec3 color;',

			'#endif',

			'#ifdef USE_MORPHTARGETS',

			'	attribute vec3 morphTarget0;',
			'	attribute vec3 morphTarget1;',
			'	attribute vec3 morphTarget2;',
			'	attribute vec3 morphTarget3;',

			'	#ifdef USE_MORPHNORMALS',

			'		attribute vec3 morphNormal0;',
			'		attribute vec3 morphNormal1;',
			'		attribute vec3 morphNormal2;',
			'		attribute vec3 morphNormal3;',

			'	#else',

			'		attribute vec3 morphTarget4;',
			'		attribute vec3 morphTarget5;',
			'		attribute vec3 morphTarget6;',
			'		attribute vec3 morphTarget7;',

			'	#endif',

			'#endif',

			'#ifdef USE_SKINNING',

			'	attribute vec4 skinIndex;',
			'	attribute vec4 skinWeight;',

			'#endif',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			customExtensions,

			'precision ' + parameters.precision + ' float;',
			'precision ' + parameters.precision + ' int;',

			'#define SHADER_NAME ' + shader.name,

			customDefines,

			parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',

			'#define GAMMA_FACTOR ' + gammaFactorDefine,

			( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
			( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapTypeDefine : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.envMap ? '#define ' + envMapBlendingDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',

			parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
			'#define UNION_CLIPPING_PLANES ' + ( parameters.numClippingPlanes - parameters.numClipIntersection ),

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',

			parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
			parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

			parameters.envMap && extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',

			'uniform mat4 viewMatrix;',
			'uniform vec3 cameraPosition;',

			( parameters.toneMapping !== NoToneMapping ) ? '#define TONE_MAPPING' : '',
			( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '', // this code is required here because it is used by the toneMapping() function defined below
			( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( 'toneMapping', parameters.toneMapping ) : '',

			parameters.dithering ? '#define DITHERING' : '',

			( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
			parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
			parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
			parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
			parameters.outputEncoding ? getTexelEncodingFunction( 'linearToOutputTexel', parameters.outputEncoding ) : '',

			parameters.depthPacking ? '#define DEPTH_PACKING ' + material.depthPacking : '',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	}

	vertexShader = parseIncludes( vertexShader );
	vertexShader = replaceLightNums( vertexShader, parameters );

	fragmentShader = parseIncludes( fragmentShader );
	fragmentShader = replaceLightNums( fragmentShader, parameters );

	if ( ! material.isShaderMaterial ) {

		vertexShader = unrollLoops( vertexShader );
		fragmentShader = unrollLoops( fragmentShader );

	}

	var vertexGlsl = prefixVertex + vertexShader;
	var fragmentGlsl = prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
	var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

	gl.attachShader( program, glVertexShader );
	gl.attachShader( program, glFragmentShader );

	// Force a particular attribute to index 0.

	if ( material.index0AttributeName !== undefined ) {

		gl.bindAttribLocation( program, 0, material.index0AttributeName );

	} else if ( parameters.morphTargets === true ) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation( program, 0, 'position' );

	}

	gl.linkProgram( program );

	var programLog = gl.getProgramInfoLog( program );
	var vertexLog = gl.getShaderInfoLog( glVertexShader );
	var fragmentLog = gl.getShaderInfoLog( glFragmentShader );

	var runnable = true;
	var haveDiagnostics = true;

	// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
	// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );

	if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

		runnable = false;

		console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );

	} else if ( programLog !== '' ) {

		console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );

	} else if ( vertexLog === '' || fragmentLog === '' ) {

		haveDiagnostics = false;

	}

	if ( haveDiagnostics ) {

		this.diagnostics = {

			runnable: runnable,
			material: material,

			programLog: programLog,

			vertexShader: {

				log: vertexLog,
				prefix: prefixVertex

			},

			fragmentShader: {

				log: fragmentLog,
				prefix: prefixFragment

			}

		};

	}

	// clean up

	gl.deleteShader( glVertexShader );
	gl.deleteShader( glFragmentShader );

	// set up caching for uniform locations

	var cachedUniforms;

	this.getUniforms = function () {

		if ( cachedUniforms === undefined ) {

			cachedUniforms = new WebGLUniforms( gl, program, renderer );

		}

		return cachedUniforms;

	};

	// set up caching for attribute locations

	var cachedAttributes;

	this.getAttributes = function () {

		if ( cachedAttributes === undefined ) {

			cachedAttributes = fetchAttributeLocations( gl, program );

		}

		return cachedAttributes;

	};

	// free resource

	this.destroy = function () {

		gl.deleteProgram( program );
		this.program = undefined;

	};

	// DEPRECATED

	Object.defineProperties( this, {

		uniforms: {
			get: function () {

				console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
				return this.getUniforms();

			}
		},

		attributes: {
			get: function () {

				console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
				return this.getAttributes();

			}
		}

	} );


	//

	this.id = programIdCount ++;
	this.code = code;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLPrograms( renderer, extensions, capabilities ) {

	var programs = [];

	var shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshDistanceMaterial: 'distanceRGBA',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'phong',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points',
		ShadowMaterial: 'shadow'
	};

	var parameterNames = [
		"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
		"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
		"roughnessMap", "metalnessMap", "gradientMap",
		"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
		"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
		"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
		"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
		"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
		"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
		"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"
	];


	function allocateBones( object ) {

		var skeleton = object.skeleton;
		var bones = skeleton.bones;

		if ( capabilities.floatVertexTextures ) {

			return 1024;

		} else {

			// default for when object is not specified
			// ( for example when prebuilding shader to be used with multiple objects )
			//
			//  - leave some extra space for other uniforms
			//  - limit here is ANGLE's 254 max uniform vectors
			//    (up to 54 should be safe)

			var nVertexUniforms = capabilities.maxVertexUniforms;
			var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );

			var maxBones = Math.min( nVertexMatrices, bones.length );

			if ( maxBones < bones.length ) {

				console.warn( 'THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.' );
				return 0;

			}

			return maxBones;

		}

	}

	function getTextureEncodingFromMap( map, gammaOverrideLinear ) {

		var encoding;

		if ( ! map ) {

			encoding = LinearEncoding;

		} else if ( map.isTexture ) {

			encoding = map.encoding;

		} else if ( map.isWebGLRenderTarget ) {

			console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
			encoding = map.texture.encoding;

		}

		// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
		if ( encoding === LinearEncoding && gammaOverrideLinear ) {

			encoding = GammaEncoding;

		}

		return encoding;

	}

	this.getParameters = function ( material, lights, shadows, fog, nClipPlanes, nClipIntersection, object ) {

		var shaderID = shaderIDs[ material.type ];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		var maxBones = object.isSkinnedMesh ? allocateBones( object ) : 0;
		var precision = capabilities.precision;

		if ( material.precision !== null ) {

			precision = capabilities.getMaxPrecision( material.precision );

			if ( precision !== material.precision ) {

				console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

			}

		}

		var currentRenderTarget = renderer.getRenderTarget();

		var parameters = {

			shaderID: shaderID,

			precision: precision,
			supportsVertexTextures: capabilities.vertexTextures,
			outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
			map: !! material.map,
			mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
			envMap: !! material.envMap,
			envMapMode: material.envMap && material.envMap.mapping,
			envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
			envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
			lightMap: !! material.lightMap,
			aoMap: !! material.aoMap,
			emissiveMap: !! material.emissiveMap,
			emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
			bumpMap: !! material.bumpMap,
			normalMap: !! material.normalMap,
			displacementMap: !! material.displacementMap,
			roughnessMap: !! material.roughnessMap,
			metalnessMap: !! material.metalnessMap,
			specularMap: !! material.specularMap,
			alphaMap: !! material.alphaMap,

			gradientMap: !! material.gradientMap,

			combine: material.combine,

			vertexColors: material.vertexColors,

			fog: !! fog,
			useFog: material.fog,
			fogExp: ( fog && fog.isFogExp2 ),

			flatShading: material.flatShading,

			sizeAttenuation: material.sizeAttenuation,
			logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,

			skinning: material.skinning && maxBones > 0,
			maxBones: maxBones,
			useVertexTexture: capabilities.floatVertexTextures,

			morphTargets: material.morphTargets,
			morphNormals: material.morphNormals,
			maxMorphTargets: renderer.maxMorphTargets,
			maxMorphNormals: renderer.maxMorphNormals,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numClippingPlanes: nClipPlanes,
			numClipIntersection: nClipIntersection,

			dithering: material.dithering,

			shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: renderer.toneMapping,
			physicallyCorrectLights: renderer.physicallyCorrectLights,

			premultipliedAlpha: material.premultipliedAlpha,

			alphaTest: material.alphaTest,
			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false

		};

		return parameters;

	};

	this.getProgramCode = function ( material, parameters ) {

		var array = [];

		if ( parameters.shaderID ) {

			array.push( parameters.shaderID );

		} else {

			array.push( material.fragmentShader );
			array.push( material.vertexShader );

		}

		if ( material.defines !== undefined ) {

			for ( var name in material.defines ) {

				array.push( name );
				array.push( material.defines[ name ] );

			}

		}

		for ( var i = 0; i < parameterNames.length; i ++ ) {

			array.push( parameters[ parameterNames[ i ] ] );

		}

		array.push( material.onBeforeCompile.toString() );

		array.push( renderer.gammaOutput );

		return array.join();

	};

	this.acquireProgram = function ( material, shader, parameters, code ) {

		var program;

		// Check if code has been already compiled
		for ( var p = 0, pl = programs.length; p < pl; p ++ ) {

			var programInfo = programs[ p ];

			if ( programInfo.code === code ) {

				program = programInfo;
				++ program.usedTimes;

				break;

			}

		}

		if ( program === undefined ) {

			program = new WebGLProgram( renderer, extensions, code, material, shader, parameters );
			programs.push( program );

		}

		return program;

	};

	this.releaseProgram = function ( program ) {

		if ( -- program.usedTimes === 0 ) {

			// Remove from unordered set
			var i = programs.indexOf( program );
			programs[ i ] = programs[ programs.length - 1 ];
			programs.pop();

			// Free WebGL resources
			program.destroy();

		}

	};

	// Exposed for resource monitoring & error feedback via renderer.info:
	this.programs = programs;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, infoMemory ) {

	var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof window.WebGL2RenderingContext );
	var _videoTextures = {};

	//

	function clampToMaxSize( image, maxSize ) {

		if ( image.width > maxSize || image.height > maxSize ) {

			// Warning: Scaling through the canvas will only work with images that use
			// premultiplied alpha.

			var scale = maxSize / Math.max( image.width, image.height );

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = Math.floor( image.width * scale );
			canvas.height = Math.floor( image.height * scale );

			var context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );

			console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

			return canvas;

		}

		return image;

	}

	function isPowerOfTwo( image ) {

		return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );

	}

	function makePowerOfTwo( image ) {

		if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof ImageBitmap ) {

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = _Math.floorPowerOfTwo( image.width );
			canvas.height = _Math.floorPowerOfTwo( image.height );

			var context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, canvas.width, canvas.height );

			console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

			return canvas;

		}

		return image;

	}

	function textureNeedsPowerOfTwo( texture ) {

		return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
			( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );

	}

	function textureNeedsGenerateMipmaps( texture, isPowerOfTwo ) {

		return texture.generateMipmaps && isPowerOfTwo &&
			texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;

	}

	// Fallback filters for non-power-of-2 textures

	function filterFallback( f ) {

		if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {

			return _gl.NEAREST;

		}

		return _gl.LINEAR;

	}

	//

	function onTextureDispose( event ) {

		var texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		deallocateTexture( texture );

		if ( texture.isVideoTexture ) {

			delete _videoTextures[ texture.id ];

		}

		infoMemory.textures --;

	}

	function onRenderTargetDispose( event ) {

		var renderTarget = event.target;

		renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

		deallocateRenderTarget( renderTarget );

		infoMemory.textures --;

	}

	//

	function deallocateTexture( texture ) {

		var textureProperties = properties.get( texture );

		if ( texture.image && textureProperties.__image__webglTextureCube ) {

			// cube texture

			_gl.deleteTexture( textureProperties.__image__webglTextureCube );

		} else {

			// 2D texture

			if ( textureProperties.__webglInit === undefined ) return;

			_gl.deleteTexture( textureProperties.__webglTexture );

		}

		// remove all webgl properties
		properties.remove( texture );

	}

	function deallocateRenderTarget( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );
		var textureProperties = properties.get( renderTarget.texture );

		if ( ! renderTarget ) return;

		if ( textureProperties.__webglTexture !== undefined ) {

			_gl.deleteTexture( textureProperties.__webglTexture );

		}

		if ( renderTarget.depthTexture ) {

			renderTarget.depthTexture.dispose();

		}

		if ( renderTarget.isWebGLRenderTargetCube ) {

			for ( var i = 0; i < 6; i ++ ) {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

			}

		} else {

			_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
			if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );

		}

		properties.remove( renderTarget.texture );
		properties.remove( renderTarget );

	}

	//



	function setTexture2D( texture, slot ) {

		var textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			var image = texture.image;

			if ( image === undefined ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );

			} else if ( image.complete === false ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );

			} else {

				uploadTexture( textureProperties, texture, slot );
				return;

			}

		}

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

	}

	function setTextureCube( texture, slot ) {

		var textureProperties = properties.get( texture );

		if ( texture.image.length === 6 ) {

			if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

				if ( ! textureProperties.__image__webglTextureCube ) {

					texture.addEventListener( 'dispose', onTextureDispose );

					textureProperties.__image__webglTextureCube = _gl.createTexture();

					infoMemory.textures ++;

				}

				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

				_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );

				var isCompressed = ( texture && texture.isCompressedTexture );
				var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

				var cubeImage = [];

				for ( var i = 0; i < 6; i ++ ) {

					if ( ! isCompressed && ! isDataTexture ) {

						cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );

					} else {

						cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

					}

				}

				var image = cubeImage[ 0 ],
					isPowerOfTwoImage = isPowerOfTwo( image ),
					glFormat = utils.convert( texture.format ),
					glType = utils.convert( texture.type );

				setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );

				for ( var i = 0; i < 6; i ++ ) {

					if ( ! isCompressed ) {

						if ( isDataTexture ) {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );

						}

					} else {

						var mipmap, mipmaps = cubeImage[ i ].mipmaps;

						for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {

							mipmap = mipmaps[ j ];

							if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

								if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

									state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								} else {

									console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

				if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) {

					_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );

				}

				textureProperties.__version = texture.version;

				if ( texture.onUpdate ) texture.onUpdate( texture );

			} else {

				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

			}

		}

	}

	function setTextureCubeDynamic( texture, slot ) {

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );

	}

	function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {

		var extension;

		if ( isPowerOfTwoImage ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, utils.convert( texture.wrapS ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, utils.convert( texture.wrapT ) );

			_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, utils.convert( texture.magFilter ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, utils.convert( texture.minFilter ) );

		} else {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );

			if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {

				console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );

			}

			_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );

			if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {

				console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );

			}

		}

		extension = extensions.get( 'EXT_texture_filter_anisotropic' );

		if ( extension ) {

			if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
			if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;

			if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

				_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
				properties.get( texture ).__currentAnisotropy = texture.anisotropy;

			}

		}

	}

	function uploadTexture( textureProperties, texture, slot ) {

		if ( textureProperties.__webglInit === undefined ) {

			textureProperties.__webglInit = true;

			texture.addEventListener( 'dispose', onTextureDispose );

			textureProperties.__webglTexture = _gl.createTexture();

			if ( texture.isVideoTexture ) {

				_videoTextures[ texture.id ] = texture;

			}

			infoMemory.textures ++;

		}

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

		_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
		_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
		_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );

		var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );

		if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {

			image = makePowerOfTwo( image );

		}

		var isPowerOfTwoImage = isPowerOfTwo( image ),
			glFormat = utils.convert( texture.format ),
			glType = utils.convert( texture.type );

		setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );

		var mipmap, mipmaps = texture.mipmaps;

		if ( texture.isDepthTexture ) {

			// populate depth texture with dummy data

			var internalFormat = _gl.DEPTH_COMPONENT;

			if ( texture.type === FloatType ) {

				if ( ! _isWebGL2 ) throw new Error( 'Float Depth Texture only supported in WebGL2.0' );
				internalFormat = _gl.DEPTH_COMPONENT32F;

			} else if ( _isWebGL2 ) {

				// WebGL 2.0 requires signed internalformat for glTexImage2D
				internalFormat = _gl.DEPTH_COMPONENT16;

			}

			if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {

				// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
				// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {

					console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );

					texture.type = UnsignedShortType;
					glType = utils.convert( texture.type );

				}

			}

			// Depth stencil textures need the DEPTH_STENCIL internal format
			// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
			if ( texture.format === DepthStencilFormat ) {

				internalFormat = _gl.DEPTH_STENCIL;

				// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
				// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.type !== UnsignedInt248Type ) {

					console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );

					texture.type = UnsignedInt248Type;
					glType = utils.convert( texture.type );

				}

			}

			state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );

		} else if ( texture.isDataTexture ) {

			// use manually created mipmaps if available
			// if there are no manual mipmaps
			// set 0 level mipmap and then use GL to generate other mipmap levels

			if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];
					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

				}

				texture.generateMipmaps = false;

			} else {

				state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );

			}

		} else if ( texture.isCompressedTexture ) {

			for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

				mipmap = mipmaps[ i ];

				if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

					if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

						state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

					} else {

						console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

					}

				} else {

					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

				}

			}

		} else {

			// regular Texture (image, video, canvas)

			// use manually created mipmaps if available
			// if there are no manual mipmaps
			// set 0 level mipmap and then use GL to generate other mipmap levels

			if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];
					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );

				}

				texture.generateMipmaps = false;

			} else {

				state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );

			}

		}

		if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) _gl.generateMipmap( _gl.TEXTURE_2D );

		textureProperties.__version = texture.version;

		if ( texture.onUpdate ) texture.onUpdate( texture );

	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {

		var glFormat = utils.convert( renderTarget.texture.format );
		var glType = utils.convert( renderTarget.texture.type );
		state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
		_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
		_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
		_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage( renderbuffer, renderTarget ) {

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

		if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else {

			// FIXME: We don't support !depth !stencil
			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );

		}

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture( framebuffer, renderTarget ) {

		var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
		if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );

		_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( ! ( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

			throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );

		}

		// upload an empty depth texture with framebuffer size
		if ( ! properties.get( renderTarget.depthTexture ).__webglTexture ||
				renderTarget.depthTexture.image.width !== renderTarget.width ||
				renderTarget.depthTexture.image.height !== renderTarget.height ) {

			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;

		}

		setTexture2D( renderTarget.depthTexture, 0 );

		var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;

		if ( renderTarget.depthTexture.format === DepthFormat ) {

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

		} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

		} else {

			throw new Error( 'Unknown depthTexture format' );

		}

	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );

		var isCube = ( renderTarget.isWebGLRenderTargetCube === true );

		if ( renderTarget.depthTexture ) {

			if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );

			setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

		} else {

			if ( isCube ) {

				renderTargetProperties.__webglDepthbuffer = [];

				for ( var i = 0; i < 6; i ++ ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
					renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );

				}

			} else {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );

			}

		}

		_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// Set up GL resources for the render target
	function setupRenderTarget( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );
		var textureProperties = properties.get( renderTarget.texture );

		renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

		textureProperties.__webglTexture = _gl.createTexture();

		infoMemory.textures ++;

		var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
		var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

		// Setup framebuffer

		if ( isCube ) {

			renderTargetProperties.__webglFramebuffer = [];

			for ( var i = 0; i < 6; i ++ ) {

				renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

			}

		} else {

			renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

		}

		// Setup color buffer

		if ( isCube ) {

			state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );

			for ( var i = 0; i < 6; i ++ ) {

				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );

			}

			if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
			state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );

		} else {

			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
			setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );

			if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
			state.bindTexture( _gl.TEXTURE_2D, null );

		}

		// Setup depth and stencil buffers

		if ( renderTarget.depthBuffer ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	function updateRenderTargetMipmap( renderTarget ) {

		var texture = renderTarget.texture;
		var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

		if ( textureNeedsGenerateMipmaps( texture, isTargetPowerOfTwo ) ) {

			var target = renderTarget.isWebGLRenderTargetCube ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
			var webglTexture = properties.get( texture ).__webglTexture;

			state.bindTexture( target, webglTexture );
			_gl.generateMipmap( target );
			state.bindTexture( target, null );

		}

	}

	function updateVideoTextures() {

		for ( var id in _videoTextures ) {

			_videoTextures[ id ].update();

		}

	}

	this.setTexture2D = setTexture2D;
	this.setTextureCube = setTextureCube;
	this.setTextureCubeDynamic = setTextureCubeDynamic;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	this.updateVideoTextures = updateVideoTextures;

}

/**
 * @author fordacious / fordacious.github.io
 */

function WebGLProperties() {

	var properties = {};

	function get( object ) {

		var uuid = object.uuid;
		var map = properties[ uuid ];

		if ( map === undefined ) {

			map = {};
			properties[ uuid ] = map;

		}

		return map;

	}

	function remove( object ) {

		delete properties[ object.uuid ];

	}

	function clear() {

		properties = {};

	}

	return {
		get: get,
		remove: remove,
		clear: clear
	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLState( gl, extensions, utils ) {

	function ColorBuffer() {

		var locked = false;

		var color = new Vector4();
		var currentColorMask = null;
		var currentColorClear = new Vector4( 0, 0, 0, 0 );

		return {

			setMask: function ( colorMask ) {

				if ( currentColorMask !== colorMask && ! locked ) {

					gl.colorMask( colorMask, colorMask, colorMask, colorMask );
					currentColorMask = colorMask;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( r, g, b, a, premultipliedAlpha ) {

				if ( premultipliedAlpha === true ) {

					r *= a; g *= a; b *= a;

				}

				color.set( r, g, b, a );

				if ( currentColorClear.equals( color ) === false ) {

					gl.clearColor( r, g, b, a );
					currentColorClear.copy( color );

				}

			},

			reset: function () {

				locked = false;

				currentColorMask = null;
				currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state

			}

		};

	}

	function DepthBuffer() {

		var locked = false;

		var currentDepthMask = null;
		var currentDepthFunc = null;
		var currentDepthClear = null;

		return {

			setTest: function ( depthTest ) {

				if ( depthTest ) {

					enable( gl.DEPTH_TEST );

				} else {

					disable( gl.DEPTH_TEST );

				}

			},

			setMask: function ( depthMask ) {

				if ( currentDepthMask !== depthMask && ! locked ) {

					gl.depthMask( depthMask );
					currentDepthMask = depthMask;

				}

			},

			setFunc: function ( depthFunc ) {

				if ( currentDepthFunc !== depthFunc ) {

					if ( depthFunc ) {

						switch ( depthFunc ) {

							case NeverDepth:

								gl.depthFunc( gl.NEVER );
								break;

							case AlwaysDepth:

								gl.depthFunc( gl.ALWAYS );
								break;

							case LessDepth:

								gl.depthFunc( gl.LESS );
								break;

							case LessEqualDepth:

								gl.depthFunc( gl.LEQUAL );
								break;

							case EqualDepth:

								gl.depthFunc( gl.EQUAL );
								break;

							case GreaterEqualDepth:

								gl.depthFunc( gl.GEQUAL );
								break;

							case GreaterDepth:

								gl.depthFunc( gl.GREATER );
								break;

							case NotEqualDepth:

								gl.depthFunc( gl.NOTEQUAL );
								break;

							default:

								gl.depthFunc( gl.LEQUAL );

						}

					} else {

						gl.depthFunc( gl.LEQUAL );

					}

					currentDepthFunc = depthFunc;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( depth ) {

				if ( currentDepthClear !== depth ) {

					gl.clearDepth( depth );
					currentDepthClear = depth;

				}

			},

			reset: function () {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;

			}

		};

	}

	function StencilBuffer() {

		var locked = false;

		var currentStencilMask = null;
		var currentStencilFunc = null;
		var currentStencilRef = null;
		var currentStencilFuncMask = null;
		var currentStencilFail = null;
		var currentStencilZFail = null;
		var currentStencilZPass = null;
		var currentStencilClear = null;

		return {

			setTest: function ( stencilTest ) {

				if ( stencilTest ) {

					enable( gl.STENCIL_TEST );

				} else {

					disable( gl.STENCIL_TEST );

				}

			},

			setMask: function ( stencilMask ) {

				if ( currentStencilMask !== stencilMask && ! locked ) {

					gl.stencilMask( stencilMask );
					currentStencilMask = stencilMask;

				}

			},

			setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

				if ( currentStencilFunc !== stencilFunc ||
				     currentStencilRef 	!== stencilRef 	||
				     currentStencilFuncMask !== stencilMask ) {

					gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;

				}

			},

			setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

				if ( currentStencilFail	 !== stencilFail 	||
				     currentStencilZFail !== stencilZFail ||
				     currentStencilZPass !== stencilZPass ) {

					gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( stencil ) {

				if ( currentStencilClear !== stencil ) {

					gl.clearStencil( stencil );
					currentStencilClear = stencil;

				}

			},

			reset: function () {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;

			}

		};

	}

	//

	var colorBuffer = new ColorBuffer();
	var depthBuffer = new DepthBuffer();
	var stencilBuffer = new StencilBuffer();

	var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	var newAttributes = new Uint8Array( maxVertexAttributes );
	var enabledAttributes = new Uint8Array( maxVertexAttributes );
	var attributeDivisors = new Uint8Array( maxVertexAttributes );

	var capabilities = {};

	var compressedTextureFormats = null;

	var currentProgram = null;

	var currentBlending = null;
	var currentBlendEquation = null;
	var currentBlendSrc = null;
	var currentBlendDst = null;
	var currentBlendEquationAlpha = null;
	var currentBlendSrcAlpha = null;
	var currentBlendDstAlpha = null;
	var currentPremultipledAlpha = false;

	var currentFlipSided = null;
	var currentCullFace = null;

	var currentLineWidth = null;

	var currentPolygonOffsetFactor = null;
	var currentPolygonOffsetUnits = null;

	var maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );

	var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
	var lineWidthAvailable = parseFloat( version ) >= 1.0;

	var currentTextureSlot = null;
	var currentBoundTextures = {};

	var currentScissor = new Vector4();
	var currentViewport = new Vector4();

	function createTexture( type, target, count ) {

		var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
		var texture = gl.createTexture();

		gl.bindTexture( type, texture );
		gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
		gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

		for ( var i = 0; i < count; i ++ ) {

			gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

		}

		return texture;

	}

	var emptyTextures = {};
	emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
	emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );

	// init

	colorBuffer.setClear( 0, 0, 0, 1 );
	depthBuffer.setClear( 1 );
	stencilBuffer.setClear( 0 );

	enable( gl.DEPTH_TEST );
	depthBuffer.setFunc( LessEqualDepth );

	setFlipSided( false );
	setCullFace( CullFaceBack );
	enable( gl.CULL_FACE );

	enable( gl.BLEND );
	setBlending( NormalBlending );

	//

	function initAttributes() {

		for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {

			newAttributes[ i ] = 0;

		}

	}

	function enableAttribute( attribute ) {

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== 0 ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			extension.vertexAttribDivisorANGLE( attribute, 0 );
			attributeDivisors[ attribute ] = 0;

		}

	}

	function enableAttributeAndDivisor( attribute, meshPerAttribute ) {

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
			attributeDivisors[ attribute ] = meshPerAttribute;

		}

	}

	function disableUnusedAttributes() {

		for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {

			if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

	}

	function enable( id ) {

		if ( capabilities[ id ] !== true ) {

			gl.enable( id );
			capabilities[ id ] = true;

		}

	}

	function disable( id ) {

		if ( capabilities[ id ] !== false ) {

			gl.disable( id );
			capabilities[ id ] = false;

		}

	}

	function getCompressedTextureFormats() {

		if ( compressedTextureFormats === null ) {

			compressedTextureFormats = [];

			if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
			     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
			     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {

				var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );

				for ( var i = 0; i < formats.length; i ++ ) {

					compressedTextureFormats.push( formats[ i ] );

				}

			}

		}

		return compressedTextureFormats;

	}

	function useProgram( program ) {

		if ( currentProgram !== program ) {

			gl.useProgram( program );

			currentProgram = program;

			return true;

		}

		return false;

	}

	function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {

		if ( blending !== NoBlending ) {

			enable( gl.BLEND );

		} else {

			disable( gl.BLEND );

		}

		if ( blending !== CustomBlending ) {

			if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

				switch ( blending ) {

					case AdditiveBlending:

						if ( premultipliedAlpha ) {

							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );

						} else {

							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.SRC_ALPHA, gl.ONE );

						}
						break;

					case SubtractiveBlending:

						if ( premultipliedAlpha ) {

							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );

						} else {

							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );

						}
						break;

					case MultiplyBlending:

						if ( premultipliedAlpha ) {

							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );

						} else {

							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.ZERO, gl.SRC_COLOR );

						}
						break;

					default:

						if ( premultipliedAlpha ) {

							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

						} else {

							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

						}

				}

			}

			currentBlendEquation = null;
			currentBlendSrc = null;
			currentBlendDst = null;
			currentBlendEquationAlpha = null;
			currentBlendSrcAlpha = null;
			currentBlendDstAlpha = null;

		} else {

			blendEquationAlpha = blendEquationAlpha || blendEquation;
			blendSrcAlpha = blendSrcAlpha || blendSrc;
			blendDstAlpha = blendDstAlpha || blendDst;

			if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

				gl.blendEquationSeparate( utils.convert( blendEquation ), utils.convert( blendEquationAlpha ) );

				currentBlendEquation = blendEquation;
				currentBlendEquationAlpha = blendEquationAlpha;

			}

			if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

				gl.blendFuncSeparate( utils.convert( blendSrc ), utils.convert( blendDst ), utils.convert( blendSrcAlpha ), utils.convert( blendDstAlpha ) );

				currentBlendSrc = blendSrc;
				currentBlendDst = blendDst;
				currentBlendSrcAlpha = blendSrcAlpha;
				currentBlendDstAlpha = blendDstAlpha;

			}

		}

		currentBlending = blending;
		currentPremultipledAlpha = premultipliedAlpha;

	}

	function setMaterial( material, frontFaceCW ) {

		material.side === DoubleSide
			? disable( gl.CULL_FACE )
			: enable( gl.CULL_FACE );

		var flipSided = ( material.side === BackSide );
		if ( frontFaceCW ) flipSided = ! flipSided;

		setFlipSided( flipSided );

		material.transparent === true
			? setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
			: setBlending( NoBlending );

		depthBuffer.setFunc( material.depthFunc );
		depthBuffer.setTest( material.depthTest );
		depthBuffer.setMask( material.depthWrite );
		colorBuffer.setMask( material.colorWrite );

		setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

	}

	//

	function setFlipSided( flipSided ) {

		if ( currentFlipSided !== flipSided ) {

			if ( flipSided ) {

				gl.frontFace( gl.CW );

			} else {

				gl.frontFace( gl.CCW );

			}

			currentFlipSided = flipSided;

		}

	}

	function setCullFace( cullFace ) {

		if ( cullFace !== CullFaceNone ) {

			enable( gl.CULL_FACE );

			if ( cullFace !== currentCullFace ) {

				if ( cullFace === CullFaceBack ) {

					gl.cullFace( gl.BACK );

				} else if ( cullFace === CullFaceFront ) {

					gl.cullFace( gl.FRONT );

				} else {

					gl.cullFace( gl.FRONT_AND_BACK );

				}

			}

		} else {

			disable( gl.CULL_FACE );

		}

		currentCullFace = cullFace;

	}

	function setLineWidth( width ) {

		if ( width !== currentLineWidth ) {

			if ( lineWidthAvailable ) gl.lineWidth( width );

			currentLineWidth = width;

		}

	}

	function setPolygonOffset( polygonOffset, factor, units ) {

		if ( polygonOffset ) {

			enable( gl.POLYGON_OFFSET_FILL );

			if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

				gl.polygonOffset( factor, units );

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;

			}

		} else {

			disable( gl.POLYGON_OFFSET_FILL );

		}

	}

	function setScissorTest( scissorTest ) {

		if ( scissorTest ) {

			enable( gl.SCISSOR_TEST );

		} else {

			disable( gl.SCISSOR_TEST );

		}

	}

	// texture

	function activeTexture( webglSlot ) {

		if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

		if ( currentTextureSlot !== webglSlot ) {

			gl.activeTexture( webglSlot );
			currentTextureSlot = webglSlot;

		}

	}

	function bindTexture( webglType, webglTexture ) {

		if ( currentTextureSlot === null ) {

			activeTexture();

		}

		var boundTexture = currentBoundTextures[ currentTextureSlot ];

		if ( boundTexture === undefined ) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[ currentTextureSlot ] = boundTexture;

		}

		if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

			gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;

		}

	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage2D() {

		try {

			gl.texImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	//

	function scissor( scissor ) {

		if ( currentScissor.equals( scissor ) === false ) {

			gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
			currentScissor.copy( scissor );

		}

	}

	function viewport( viewport ) {

		if ( currentViewport.equals( viewport ) === false ) {

			gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
			currentViewport.copy( viewport );

		}

	}

	//

	function reset() {

		for ( var i = 0; i < enabledAttributes.length; i ++ ) {

			if ( enabledAttributes[ i ] === 1 ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

		capabilities = {};

		compressedTextureFormats = null;

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentProgram = null;

		currentBlending = null;

		currentFlipSided = null;
		currentCullFace = null;

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();

	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		enableAttributeAndDivisor: enableAttributeAndDivisor,
		disableUnusedAttributes: disableUnusedAttributes,
		enable: enable,
		disable: disable,
		getCompressedTextureFormats: getCompressedTextureFormats,

		useProgram: useProgram,

		setBlending: setBlending,
		setMaterial: setMaterial,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		compressedTexImage2D: compressedTexImage2D,
		texImage2D: texImage2D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLCapabilities( gl, extensions, parameters ) {

	var maxAnisotropy;

	function getMaxAnisotropy() {

		if ( maxAnisotropy !== undefined ) return maxAnisotropy;

		var extension = extensions.get( 'EXT_texture_filter_anisotropic' );

		if ( extension !== null ) {

			maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

		} else {

			maxAnisotropy = 0;

		}

		return maxAnisotropy;

	}

	function getMaxPrecision( precision ) {

		if ( precision === 'highp' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
			     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

				return 'highp';

			}

			precision = 'mediump';

		}

		if ( precision === 'mediump' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
			     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

				return 'mediump';

			}

		}

		return 'lowp';

	}

	var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	var maxPrecision = getMaxPrecision( precision );

	if ( maxPrecision !== precision ) {

		console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
		precision = maxPrecision;

	}

	var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;

	var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
	var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
	var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

	var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
	var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
	var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

	var vertexTextures = maxVertexTextures > 0;
	var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
	var floatVertexTextures = vertexTextures && floatFragmentTextures;

	return {

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,
		floatFragmentTextures: floatFragmentTextures,
		floatVertexTextures: floatVertexTextures

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author greggman / http://games.greggman.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author tschw
 */

function PerspectiveCamera( fov, aspect, near, far ) {

	Camera.call( this );

	this.type = 'PerspectiveCamera';

	this.fov = fov !== undefined ? fov : 50;
	this.zoom = 1;

	this.near = near !== undefined ? near : 0.1;
	this.far = far !== undefined ? far : 2000;
	this.focus = 10;

	this.aspect = aspect !== undefined ? aspect : 1;
	this.view = null;

	this.filmGauge = 35;	// width of the film (default in millimeters)
	this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

	this.updateProjectionMatrix();

}

PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

	constructor: PerspectiveCamera,

	isPerspectiveCamera: true,

	copy: function ( source, recursive ) {

		Camera.prototype.copy.call( this, source, recursive );

		this.fov = source.fov;
		this.zoom = source.zoom;

		this.near = source.near;
		this.far = source.far;
		this.focus = source.focus;

		this.aspect = source.aspect;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		this.filmGauge = source.filmGauge;
		this.filmOffset = source.filmOffset;

		return this;

	},

	/**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */
	setFocalLength: function ( focalLength ) {

		// see http://www.bobatkins.com/photography/technical/field_of_view.html
		var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

		this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
		this.updateProjectionMatrix();

	},

	/**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */
	getFocalLength: function () {

		var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );

		return 0.5 * this.getFilmHeight() / vExtentSlope;

	},

	getEffectiveFOV: function () {

		return _Math.RAD2DEG * 2 * Math.atan(
			Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );

	},

	getFilmWidth: function () {

		// film not completely covered in portrait format (aspect < 1)
		return this.filmGauge * Math.min( this.aspect, 1 );

	},

	getFilmHeight: function () {

		// film not completely covered in landscape format (aspect > 1)
		return this.filmGauge / Math.max( this.aspect, 1 );

	},

	/**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   var w = 1920;
	 *   var h = 1080;
	 *   var fullWidth = w * 3;
	 *   var fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */
	setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {

		this.aspect = fullWidth / fullHeight;

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	},

	clearViewOffset: function () {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	},

	updateProjectionMatrix: function () {

		var near = this.near,
			top = near * Math.tan(
				_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
			height = 2 * top,
			width = this.aspect * height,
			left = - 0.5 * width,
			view = this.view;

		if ( this.view !== null && this.view.enabled ) {

			var fullWidth = view.fullWidth,
				fullHeight = view.fullHeight;

			left += view.offsetX * width / fullWidth;
			top -= view.offsetY * height / fullHeight;
			width *= view.width / fullWidth;
			height *= view.height / fullHeight;

		}

		var skew = this.filmOffset;
		if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

		this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far );

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.fov = this.fov;
		data.object.zoom = this.zoom;

		data.object.near = this.near;
		data.object.far = this.far;
		data.object.focus = this.focus;

		data.object.aspect = this.aspect;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		data.object.filmGauge = this.filmGauge;
		data.object.filmOffset = this.filmOffset;

		return data;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ArrayCamera( array ) {

	PerspectiveCamera.call( this );

	this.cameras = array || [];

}

ArrayCamera.prototype = Object.assign( Object.create( PerspectiveCamera.prototype ), {

	constructor: ArrayCamera,

	isArrayCamera: true

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebVRManager( renderer ) {

	var scope = this;

	var device = null;
	var frameData = null;

	var poseTarget = null;

	if ( typeof window !== 'undefined' && 'VRFrameData' in window ) {

		frameData = new window.VRFrameData();

	}

	var matrixWorldInverse = new Matrix4();

	var cameraL = new PerspectiveCamera();
	cameraL.bounds = new Vector4( 0.0, 0.0, 0.5, 1.0 );
	cameraL.layers.enable( 1 );

	var cameraR = new PerspectiveCamera();
	cameraR.bounds = new Vector4( 0.5, 0.0, 0.5, 1.0 );
	cameraR.layers.enable( 2 );

	var cameraVR = new ArrayCamera( [ cameraL, cameraR ] );
	cameraVR.layers.enable( 1 );
	cameraVR.layers.enable( 2 );

	//

	var currentSize, currentPixelRatio;

	function onVRDisplayPresentChange() {

		if ( device !== null && device.isPresenting ) {

			var eyeParameters = device.getEyeParameters( 'left' );
			var renderWidth = eyeParameters.renderWidth;
			var renderHeight = eyeParameters.renderHeight;

			currentPixelRatio = renderer.getPixelRatio();
			currentSize = renderer.getSize();

			renderer.setDrawingBufferSize( renderWidth * 2, renderHeight, 1 );

		} else if ( scope.enabled ) {

			renderer.setDrawingBufferSize( currentSize.width, currentSize.height, currentPixelRatio );

		}

	}

	if ( typeof window !== 'undefined' ) {

		window.addEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );

	}

	//

	this.enabled = false;

	this.getDevice = function () {

		return device;

	};

	this.setDevice = function ( value ) {

		if ( value !== undefined ) device = value;

	};

	this.setPoseTarget = function ( object ) {

		if ( object !== undefined ) poseTarget = object;

	};

	this.getCamera = function ( camera ) {

		if ( device === null ) return camera;

		device.depthNear = camera.near;
		device.depthFar = camera.far;

		device.getFrameData( frameData );

		//

		var pose = frameData.pose;
		var poseObject = poseTarget !== null ? poseTarget : camera;

		if ( pose.position !== null ) {

			poseObject.position.fromArray( pose.position );

		} else {

			poseObject.position.set( 0, 0, 0 );

		}

		if ( pose.orientation !== null ) {

			poseObject.quaternion.fromArray( pose.orientation );

		}

		poseObject.updateMatrixWorld();

		if ( device.isPresenting === false ) return camera;

		//

		cameraL.near = camera.near;
		cameraR.near = camera.near;

		cameraL.far = camera.far;
		cameraR.far = camera.far;

		cameraVR.matrixWorld.copy( camera.matrixWorld );
		cameraVR.matrixWorldInverse.copy( camera.matrixWorldInverse );

		cameraL.matrixWorldInverse.fromArray( frameData.leftViewMatrix );
		cameraR.matrixWorldInverse.fromArray( frameData.rightViewMatrix );

		var parent = poseObject.parent;

		if ( parent !== null ) {

			matrixWorldInverse.getInverse( parent.matrixWorld );

			cameraL.matrixWorldInverse.multiply( matrixWorldInverse );
			cameraR.matrixWorldInverse.multiply( matrixWorldInverse );

		}

		// envMap and Mirror needs camera.matrixWorld

		cameraL.matrixWorld.getInverse( cameraL.matrixWorldInverse );
		cameraR.matrixWorld.getInverse( cameraR.matrixWorldInverse );

		cameraL.projectionMatrix.fromArray( frameData.leftProjectionMatrix );
		cameraR.projectionMatrix.fromArray( frameData.rightProjectionMatrix );

		// HACK @mrdoob
		// https://github.com/w3c/webvr/issues/203

		cameraVR.projectionMatrix.copy( cameraL.projectionMatrix );

		//

		var layers = device.getLayers();

		if ( layers.length ) {

			var layer = layers[ 0 ];

			if ( layer.leftBounds !== null && layer.leftBounds.length === 4 ) {

				cameraL.bounds.fromArray( layer.leftBounds );

			}

			if ( layer.rightBounds !== null && layer.rightBounds.length === 4 ) {

				cameraR.bounds.fromArray( layer.rightBounds );

			}

		}

		return cameraVR;

	};

	this.submitFrame = function () {

		if ( device && device.isPresenting ) device.submitFrame();

	};

	this.dispose = function () {

		if ( typeof window !== 'undefined' ) {

			window.removeEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange );

		}

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLExtensions( gl ) {

	var extensions = {};

	return {

		get: function ( name ) {

			if ( extensions[ name ] !== undefined ) {

				return extensions[ name ];

			}

			var extension;

			switch ( name ) {

				case 'WEBGL_depth_texture':
					extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
					break;

				case 'EXT_texture_filter_anisotropic':
					extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
					break;

				case 'WEBGL_compressed_texture_s3tc':
					extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
					break;

				case 'WEBGL_compressed_texture_pvrtc':
					extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
					break;

				case 'WEBGL_compressed_texture_etc1':
					extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
					break;

				default:
					extension = gl.getExtension( name );

			}

			if ( extension === null ) {

				console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

			}

			extensions[ name ] = extension;

			return extension;

		}

	};

}

/**
 * @author tschw
 */

function WebGLClipping() {

	var scope = this,

		globalState = null,
		numGlobalPlanes = 0,
		localClippingEnabled = false,
		renderingShadows = false,

		plane = new Plane(),
		viewNormalMatrix = new Matrix3(),

		uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function ( planes, enableLocalClipping, camera ) {

		var enabled =
			planes.length !== 0 ||
			enableLocalClipping ||
			// enable state of previous frame - the clipping code has to
			// run another frame in order to reset the state:
			numGlobalPlanes !== 0 ||
			localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		globalState = projectPlanes( planes, camera, 0 );
		numGlobalPlanes = planes.length;

		return enabled;

	};

	this.beginShadows = function () {

		renderingShadows = true;
		projectPlanes( null );

	};

	this.endShadows = function () {

		renderingShadows = false;
		resetGlobalState();

	};

	this.setState = function ( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {

		if ( ! localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && ! clipShadows ) {

			// there's no local clipping

			if ( renderingShadows ) {

				// there's no global clipping

				projectPlanes( null );

			} else {

				resetGlobalState();

			}

		} else {

			var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
				lGlobal = nGlobal * 4,

				dstArray = cache.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes( planes, camera, lGlobal, fromCache );

			for ( var i = 0; i !== lGlobal; ++ i ) {

				dstArray[ i ] = globalState[ i ];

			}

			cache.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;

		}


	};

	function resetGlobalState() {

		if ( uniform.value !== globalState ) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;

		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;

	}

	function projectPlanes( planes, camera, dstOffset, skipTransform ) {

		var nPlanes = planes !== null ? planes.length : 0,
			dstArray = null;

		if ( nPlanes !== 0 ) {

			dstArray = uniform.value;

			if ( skipTransform !== true || dstArray === null ) {

				var flatSize = dstOffset + nPlanes * 4,
					viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix( viewMatrix );

				if ( dstArray === null || dstArray.length < flatSize ) {

					dstArray = new Float32Array( flatSize );

				}

				for ( var i = 0, i4 = dstOffset; i !== nPlanes; ++ i, i4 += 4 ) {

					plane.copy( planes[ i ] ).applyMatrix4( viewMatrix, viewNormalMatrix );

					plane.normal.toArray( dstArray, i4 );
					dstArray[ i4 + 3 ] = plane.constant;

				}

			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;

		}

		scope.numPlanes = nPlanes;

		return dstArray;

	}

}

/**
 * @author thespite / http://www.twitter.com/thespite
 */

function WebGLUtils( gl, extensions ) {

	function convert( p ) {

		var extension;

		if ( p === RepeatWrapping ) return gl.REPEAT;
		if ( p === ClampToEdgeWrapping ) return gl.CLAMP_TO_EDGE;
		if ( p === MirroredRepeatWrapping ) return gl.MIRRORED_REPEAT;

		if ( p === NearestFilter ) return gl.NEAREST;
		if ( p === NearestMipMapNearestFilter ) return gl.NEAREST_MIPMAP_NEAREST;
		if ( p === NearestMipMapLinearFilter ) return gl.NEAREST_MIPMAP_LINEAR;

		if ( p === LinearFilter ) return gl.LINEAR;
		if ( p === LinearMipMapNearestFilter ) return gl.LINEAR_MIPMAP_NEAREST;
		if ( p === LinearMipMapLinearFilter ) return gl.LINEAR_MIPMAP_LINEAR;

		if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
		if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
		if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
		if ( p === UnsignedShort565Type ) return gl.UNSIGNED_SHORT_5_6_5;

		if ( p === ByteType ) return gl.BYTE;
		if ( p === ShortType ) return gl.SHORT;
		if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
		if ( p === IntType ) return gl.INT;
		if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
		if ( p === FloatType ) return gl.FLOAT;

		if ( p === HalfFloatType ) {

			extension = extensions.get( 'OES_texture_half_float' );

			if ( extension !== null ) return extension.HALF_FLOAT_OES;

		}

		if ( p === AlphaFormat ) return gl.ALPHA;
		if ( p === RGBFormat ) return gl.RGB;
		if ( p === RGBAFormat ) return gl.RGBA;
		if ( p === LuminanceFormat ) return gl.LUMINANCE;
		if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
		if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
		if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;

		if ( p === AddEquation ) return gl.FUNC_ADD;
		if ( p === SubtractEquation ) return gl.FUNC_SUBTRACT;
		if ( p === ReverseSubtractEquation ) return gl.FUNC_REVERSE_SUBTRACT;

		if ( p === ZeroFactor ) return gl.ZERO;
		if ( p === OneFactor ) return gl.ONE;
		if ( p === SrcColorFactor ) return gl.SRC_COLOR;
		if ( p === OneMinusSrcColorFactor ) return gl.ONE_MINUS_SRC_COLOR;
		if ( p === SrcAlphaFactor ) return gl.SRC_ALPHA;
		if ( p === OneMinusSrcAlphaFactor ) return gl.ONE_MINUS_SRC_ALPHA;
		if ( p === DstAlphaFactor ) return gl.DST_ALPHA;
		if ( p === OneMinusDstAlphaFactor ) return gl.ONE_MINUS_DST_ALPHA;

		if ( p === DstColorFactor ) return gl.DST_COLOR;
		if ( p === OneMinusDstColorFactor ) return gl.ONE_MINUS_DST_COLOR;
		if ( p === SrcAlphaSaturateFactor ) return gl.SRC_ALPHA_SATURATE;

		if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
			p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

			if ( extension !== null ) {

				if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
				if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
				if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
				if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

			}

		}

		if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
			p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

			if ( extension !== null ) {

				if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

			}

		}

		if ( p === RGB_ETC1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

			if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;

		}

		if ( p === MinEquation || p === MaxEquation ) {

			extension = extensions.get( 'EXT_blend_minmax' );

			if ( extension !== null ) {

				if ( p === MinEquation ) return extension.MIN_EXT;
				if ( p === MaxEquation ) return extension.MAX_EXT;

			}

		}

		if ( p === UnsignedInt248Type ) {

			extension = extensions.get( 'WEBGL_depth_texture' );

			if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;

		}

		return 0;

	}

	return { convert: convert };

}

/**
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author szimek / https://github.com/szimek/
 * @author tschw
 */

function WebGLRenderer( parameters ) {

	console.log( 'THREE.WebGLRenderer', REVISION );

	parameters = parameters || {};

	var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
		_context = parameters.context !== undefined ? parameters.context : null,

		_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
		_depth = parameters.depth !== undefined ? parameters.depth : true,
		_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
		_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
		_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
		_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false,
		_powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default';

	var lightsArray = [];
	var shadowsArray = [];

	var currentRenderList = null;

	var spritesArray = [];
	var flaresArray = [];

	// public properties

	this.domElement = _canvas;
	this.context = null;

	// clearing

	this.autoClear = true;
	this.autoClearColor = true;
	this.autoClearDepth = true;
	this.autoClearStencil = true;

	// scene graph

	this.sortObjects = true;

	// user-defined clipping

	this.clippingPlanes = [];
	this.localClippingEnabled = false;

	// physically based shading

	this.gammaFactor = 2.0;	// for backwards compatibility
	this.gammaInput = false;
	this.gammaOutput = false;

	// physical lights

	this.physicallyCorrectLights = false;

	// tone mapping

	this.toneMapping = LinearToneMapping;
	this.toneMappingExposure = 1.0;
	this.toneMappingWhitePoint = 1.0;

	// morphs

	this.maxMorphTargets = 8;
	this.maxMorphNormals = 4;

	// internal properties

	var _this = this,

		_isContextLost = false,

		// internal state cache

		_currentRenderTarget = null,
		_currentFramebuffer = null,
		_currentMaterialId = - 1,
		_currentGeometryProgram = '',

		_currentCamera = null,
		_currentArrayCamera = null,

		_currentViewport = new Vector4(),
		_currentScissor = new Vector4(),
		_currentScissorTest = null,

		//

		_usedTextureUnits = 0,

		//

		_width = _canvas.width,
		_height = _canvas.height,

		_pixelRatio = 1,

		_viewport = new Vector4( 0, 0, _width, _height ),
		_scissor = new Vector4( 0, 0, _width, _height ),
		_scissorTest = false,

		// frustum

		_frustum = new Frustum(),

		// clipping

		_clipping = new WebGLClipping(),
		_clippingEnabled = false,
		_localClippingEnabled = false,

		// camera matrices cache

		_projScreenMatrix = new Matrix4(),

		_vector3 = new Vector3(),

		// info

		_infoMemory = {
			geometries: 0,
			textures: 0
		},

		_infoRender = {

			frame: 0,
			calls: 0,
			vertices: 0,
			faces: 0,
			points: 0

		};

	this.info = {

		render: _infoRender,
		memory: _infoMemory,
		programs: null

	};

	function getTargetPixelRatio() {

		return _currentRenderTarget === null ? _pixelRatio : 1;

	}

	// initialize

	var _gl;

	try {

		var contextAttributes = {
			alpha: _alpha,
			depth: _depth,
			stencil: _stencil,
			antialias: _antialias,
			premultipliedAlpha: _premultipliedAlpha,
			preserveDrawingBuffer: _preserveDrawingBuffer,
			powerPreference: _powerPreference
		};

		// event listeners must be registered before WebGL context is created, see #12753

		_canvas.addEventListener( 'webglcontextlost', onContextLost, false );
		_canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );

		_gl = _context || _canvas.getContext( 'webgl', contextAttributes ) || _canvas.getContext( 'experimental-webgl', contextAttributes );

		if ( _gl === null ) {

			if ( _canvas.getContext( 'webgl' ) !== null ) {

				throw new Error( 'Error creating WebGL context with your selected attributes.' );

			} else {

				throw new Error( 'Error creating WebGL context.' );

			}

		}

		// Some experimental-webgl implementations do not have getShaderPrecisionFormat

		if ( _gl.getShaderPrecisionFormat === undefined ) {

			_gl.getShaderPrecisionFormat = function () {

				return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };

			};

		}

	} catch ( error ) {

		console.error( 'THREE.WebGLRenderer: ' + error.message );

	}

	var extensions, capabilities, state;
	var properties, textures, attributes, geometries, objects, lights;
	var programCache, renderLists;

	var background, morphtargets, bufferRenderer, indexedBufferRenderer;
	var flareRenderer, spriteRenderer;

	var utils;

	function initGLContext() {

		extensions = new WebGLExtensions( _gl );
		extensions.get( 'WEBGL_depth_texture' );
		extensions.get( 'OES_texture_float' );
		extensions.get( 'OES_texture_float_linear' );
		extensions.get( 'OES_texture_half_float' );
		extensions.get( 'OES_texture_half_float_linear' );
		extensions.get( 'OES_standard_derivatives' );
		extensions.get( 'OES_element_index_uint' );
		extensions.get( 'ANGLE_instanced_arrays' );

		utils = new WebGLUtils( _gl, extensions );

		capabilities = new WebGLCapabilities( _gl, extensions, parameters );

		state = new WebGLState( _gl, extensions, utils );
		state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
		state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

		properties = new WebGLProperties();
		textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, _infoMemory );
		attributes = new WebGLAttributes( _gl );
		geometries = new WebGLGeometries( _gl, attributes, _infoMemory );
		objects = new WebGLObjects( geometries, _infoRender );
		morphtargets = new WebGLMorphtargets( _gl );
		programCache = new WebGLPrograms( _this, extensions, capabilities );
		lights = new WebGLLights();
		renderLists = new WebGLRenderLists();

		background = new WebGLBackground( _this, state, geometries, _premultipliedAlpha );

		bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
		indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );

		flareRenderer = new WebGLFlareRenderer( _this, _gl, state, textures, capabilities );
		spriteRenderer = new WebGLSpriteRenderer( _this, _gl, state, textures, capabilities );

		_this.info.programs = programCache.programs;

		_this.context = _gl;
		_this.capabilities = capabilities;
		_this.extensions = extensions;
		_this.properties = properties;
		_this.renderLists = renderLists;
		_this.state = state;

	}

	initGLContext();

	// vr

	var vr = new WebVRManager( _this );

	this.vr = vr;

	// shadow map

	var shadowMap = new WebGLShadowMap( _this, objects, capabilities.maxTextureSize );

	this.shadowMap = shadowMap;

	// API

	this.getContext = function () {

		return _gl;

	};

	this.getContextAttributes = function () {

		return _gl.getContextAttributes();

	};

	this.forceContextLoss = function () {

		var extension = extensions.get( 'WEBGL_lose_context' );
		if ( extension ) extension.loseContext();

	};

	this.forceContextRestore = function () {

		var extension = extensions.get( 'WEBGL_lose_context' );
		if ( extension ) extension.restoreContext();

	};

	this.getPixelRatio = function () {

		return _pixelRatio;

	};

	this.setPixelRatio = function ( value ) {

		if ( value === undefined ) return;

		_pixelRatio = value;

		this.setSize( _width, _height, false );

	};

	this.getSize = function () {

		return {
			width: _width,
			height: _height
		};

	};

	this.setSize = function ( width, height, updateStyle ) {

		var device = vr.getDevice();

		if ( device && device.isPresenting ) {

			console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
			return;

		}

		_width = width;
		_height = height;

		_canvas.width = width * _pixelRatio;
		_canvas.height = height * _pixelRatio;

		if ( updateStyle !== false ) {

			_canvas.style.width = width + 'px';
			_canvas.style.height = height + 'px';

		}

		this.setViewport( 0, 0, width, height );

	};

	this.getDrawingBufferSize = function () {

		return {
			width: _width * _pixelRatio,
			height: _height * _pixelRatio
		};

	};

	this.setDrawingBufferSize = function ( width, height, pixelRatio ) {

		_width = width;
		_height = height;

		_pixelRatio = pixelRatio;

		_canvas.width = width * pixelRatio;
		_canvas.height = height * pixelRatio;

		this.setViewport( 0, 0, width, height );

	};

	this.setViewport = function ( x, y, width, height ) {

		_viewport.set( x, _height - y - height, width, height );
		state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

	};

	this.setScissor = function ( x, y, width, height ) {

		_scissor.set( x, _height - y - height, width, height );
		state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );

	};

	this.setScissorTest = function ( boolean ) {

		state.setScissorTest( _scissorTest = boolean );

	};

	// Clearing

	this.getClearColor = function () {

		return background.getClearColor();

	};

	this.setClearColor = function () {

		background.setClearColor.apply( background, arguments );

	};

	this.getClearAlpha = function () {

		return background.getClearAlpha();

	};

	this.setClearAlpha = function () {

		background.setClearAlpha.apply( background, arguments );

	};

	this.clear = function ( color, depth, stencil ) {

		var bits = 0;

		if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
		if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
		if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;

		_gl.clear( bits );

	};

	this.clearColor = function () {

		this.clear( true, false, false );

	};

	this.clearDepth = function () {

		this.clear( false, true, false );

	};

	this.clearStencil = function () {

		this.clear( false, false, true );

	};

	this.clearTarget = function ( renderTarget, color, depth, stencil ) {

		this.setRenderTarget( renderTarget );
		this.clear( color, depth, stencil );

	};

	//

	this.dispose = function () {

		_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
		_canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );

		renderLists.dispose();

		vr.dispose();

	};

	// Events

	function onContextLost( event ) {

		event.preventDefault();

		console.log( 'THREE.WebGLRenderer: Context Lost.' );

		_isContextLost = true;

	}

	function onContextRestore( /* event */ ) {

		console.log( 'THREE.WebGLRenderer: Context Restored.' );

		_isContextLost = false;

		initGLContext();

	}

	function onMaterialDispose( event ) {

		var material = event.target;

		material.removeEventListener( 'dispose', onMaterialDispose );

		deallocateMaterial( material );

	}

	// Buffer deallocation

	function deallocateMaterial( material ) {

		releaseMaterialProgramReference( material );

		properties.remove( material );

	}


	function releaseMaterialProgramReference( material ) {

		var programInfo = properties.get( material ).program;

		material.program = undefined;

		if ( programInfo !== undefined ) {

			programCache.releaseProgram( programInfo );

		}

	}

	// Buffer rendering

	function renderObjectImmediate( object, program, material ) {

		object.render( function ( object ) {

			_this.renderBufferImmediate( object, program, material );

		} );

	}

	this.renderBufferImmediate = function ( object, program, material ) {

		state.initAttributes();

		var buffers = properties.get( object );

		if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
		if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
		if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
		if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();

		var programAttributes = program.getAttributes();

		if ( object.hasPositions ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( programAttributes.position );
			_gl.vertexAttribPointer( programAttributes.position, 3, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasNormals ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );

			if ( ! material.isMeshPhongMaterial &&
				! material.isMeshStandardMaterial &&
				! material.isMeshNormalMaterial &&
				material.flatShading === true ) {

				for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {

					var array = object.normalArray;

					var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
					var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
					var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;

					array[ i + 0 ] = nx;
					array[ i + 1 ] = ny;
					array[ i + 2 ] = nz;

					array[ i + 3 ] = nx;
					array[ i + 4 ] = ny;
					array[ i + 5 ] = nz;

					array[ i + 6 ] = nx;
					array[ i + 7 ] = ny;
					array[ i + 8 ] = nz;

				}

			}

			_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( programAttributes.normal );

			_gl.vertexAttribPointer( programAttributes.normal, 3, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasUvs && material.map ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( programAttributes.uv );

			_gl.vertexAttribPointer( programAttributes.uv, 2, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasColors && material.vertexColors !== NoColors ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( programAttributes.color );

			_gl.vertexAttribPointer( programAttributes.color, 3, _gl.FLOAT, false, 0, 0 );

		}

		state.disableUnusedAttributes();

		_gl.drawArrays( _gl.TRIANGLES, 0, object.count );

		object.count = 0;

	};

	this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {

		var frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );

		state.setMaterial( material, frontFaceCW );

		var program = setProgram( camera, fog, material, object );
		var geometryProgram = geometry.id + '_' + program.id + '_' + ( material.wireframe === true );

		var updateBuffers = false;

		if ( geometryProgram !== _currentGeometryProgram ) {

			_currentGeometryProgram = geometryProgram;
			updateBuffers = true;

		}

		if ( object.morphTargetInfluences ) {

			morphtargets.update( object, geometry, material, program );

			updateBuffers = true;

		}

		//

		var index = geometry.index;
		var position = geometry.attributes.position;
		var rangeFactor = 1;

		if ( material.wireframe === true ) {

			index = geometries.getWireframeAttribute( geometry );
			rangeFactor = 2;

		}

		var attribute;
		var renderer = bufferRenderer;

		if ( index !== null ) {

			attribute = attributes.get( index );

			renderer = indexedBufferRenderer;
			renderer.setIndex( attribute );

		}

		if ( updateBuffers ) {

			setupVertexAttributes( material, program, geometry );

			if ( index !== null ) {

				_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, attribute.buffer );

			}

		}

		//

		var dataCount = 0;

		if ( index !== null ) {

			dataCount = index.count;

		} else if ( position !== undefined ) {

			dataCount = position.count;

		}

		var rangeStart = geometry.drawRange.start * rangeFactor;
		var rangeCount = geometry.drawRange.count * rangeFactor;

		var groupStart = group !== null ? group.start * rangeFactor : 0;
		var groupCount = group !== null ? group.count * rangeFactor : Infinity;

		var drawStart = Math.max( rangeStart, groupStart );
		var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;

		var drawCount = Math.max( 0, drawEnd - drawStart + 1 );

		if ( drawCount === 0 ) return;

		//

		if ( object.isMesh ) {

			if ( material.wireframe === true ) {

				state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
				renderer.setMode( _gl.LINES );

			} else {

				switch ( object.drawMode ) {

					case TrianglesDrawMode:
						renderer.setMode( _gl.TRIANGLES );
						break;

					case TriangleStripDrawMode:
						renderer.setMode( _gl.TRIANGLE_STRIP );
						break;

					case TriangleFanDrawMode:
						renderer.setMode( _gl.TRIANGLE_FAN );
						break;

				}

			}


		} else if ( object.isLine ) {

			var lineWidth = material.linewidth;

			if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

			state.setLineWidth( lineWidth * getTargetPixelRatio() );

			if ( object.isLineSegments ) {

				renderer.setMode( _gl.LINES );

			} else if ( object.isLineLoop ) {

				renderer.setMode( _gl.LINE_LOOP );

			} else {

				renderer.setMode( _gl.LINE_STRIP );

			}

		} else if ( object.isPoints ) {

			renderer.setMode( _gl.POINTS );

		}

		if ( geometry && geometry.isInstancedBufferGeometry ) {

			if ( geometry.maxInstancedCount > 0 ) {

				renderer.renderInstances( geometry, drawStart, drawCount );

			}

		} else {

			renderer.render( drawStart, drawCount );

		}

	};

	function setupVertexAttributes( material, program, geometry, startIndex ) {

		if ( geometry && geometry.isInstancedBufferGeometry ) {

			if ( extensions.get( 'ANGLE_instanced_arrays' ) === null ) {

				console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

		}

		if ( startIndex === undefined ) startIndex = 0;

		state.initAttributes();

		var geometryAttributes = geometry.attributes;

		var programAttributes = program.getAttributes();

		var materialDefaultAttributeValues = material.defaultAttributeValues;

		for ( var name in programAttributes ) {

			var programAttribute = programAttributes[ name ];

			if ( programAttribute >= 0 ) {

				var geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute !== undefined ) {

					var normalized = geometryAttribute.normalized;
					var size = geometryAttribute.itemSize;

					var attribute = attributes.get( geometryAttribute );

					// TODO Attribute may not be available on context restore

					if ( attribute === undefined ) continue;

					var buffer = attribute.buffer;
					var type = attribute.type;
					var bytesPerElement = attribute.bytesPerElement;

					if ( geometryAttribute.isInterleavedBufferAttribute ) {

						var data = geometryAttribute.data;
						var stride = data.stride;
						var offset = geometryAttribute.offset;

						if ( data && data.isInstancedInterleavedBuffer ) {

							state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute );

							if ( geometry.maxInstancedCount === undefined ) {

								geometry.maxInstancedCount = data.meshPerAttribute * data.count;

							}

						} else {

							state.enableAttribute( programAttribute );

						}

						_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
						_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );

					} else {

						if ( geometryAttribute.isInstancedBufferAttribute ) {

							state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute );

							if ( geometry.maxInstancedCount === undefined ) {

								geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

							}

						} else {

							state.enableAttribute( programAttribute );

						}

						_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
						_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );

					}

				} else if ( materialDefaultAttributeValues !== undefined ) {

					var value = materialDefaultAttributeValues[ name ];

					if ( value !== undefined ) {

						switch ( value.length ) {

							case 2:
								_gl.vertexAttrib2fv( programAttribute, value );
								break;

							case 3:
								_gl.vertexAttrib3fv( programAttribute, value );
								break;

							case 4:
								_gl.vertexAttrib4fv( programAttribute, value );
								break;

							default:
								_gl.vertexAttrib1fv( programAttribute, value );

						}

					}

				}

			}

		}

		state.disableUnusedAttributes();

	}

	// Compile

	this.compile = function ( scene, camera ) {

		lightsArray.length = 0;
		shadowsArray.length = 0;

		scene.traverse( function ( object ) {

			if ( object.isLight ) {

				lightsArray.push( object );

				if ( object.castShadow ) {

					shadowsArray.push( object );

				}

			}

		} );

		lights.setup( lightsArray, shadowsArray, camera );

		scene.traverse( function ( object ) {

			if ( object.material ) {

				if ( Array.isArray( object.material ) ) {

					for ( var i = 0; i < object.material.length; i ++ ) {

						initMaterial( object.material[ i ], scene.fog, object );

					}

				} else {

					initMaterial( object.material, scene.fog, object );

				}

			}

		} );

	};

	// Animation Loop

	var isAnimating = false;
	var onAnimationFrame = null;

	function start() {

		if ( isAnimating ) return;

		var device = vr.getDevice();

		if ( device && device.isPresenting ) {

			device.requestAnimationFrame( loop );

		} else {

			window.requestAnimationFrame( loop );

		}

		isAnimating = true;

	}

	function loop( time ) {

		if ( onAnimationFrame !== null ) onAnimationFrame( time );

		var device = vr.getDevice();

		if ( device && device.isPresenting ) {

			device.requestAnimationFrame( loop );

		} else {

			window.requestAnimationFrame( loop );

		}

	}

	this.animate = function ( callback ) {

		onAnimationFrame = callback;
		start();

	};

	// Rendering

	this.render = function ( scene, camera, renderTarget, forceClear ) {

		if ( ! ( camera && camera.isCamera ) ) {

			console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
			return;

		}

		if ( _isContextLost ) return;

		// reset caching for this frame

		_currentGeometryProgram = '';
		_currentMaterialId = - 1;
		_currentCamera = null;

		// update scene graph

		if ( scene.autoUpdate === true ) scene.updateMatrixWorld();

		// update camera matrices and frustum

		if ( camera.parent === null ) camera.updateMatrixWorld();

		if ( vr.enabled ) {

			camera = vr.getCamera( camera );

		}

		_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
		_frustum.setFromMatrix( _projScreenMatrix );

		lightsArray.length = 0;
		shadowsArray.length = 0;

		spritesArray.length = 0;
		flaresArray.length = 0;

		_localClippingEnabled = this.localClippingEnabled;
		_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );

		currentRenderList = renderLists.get( scene, camera );
		currentRenderList.init();

		projectObject( scene, camera, _this.sortObjects );

		if ( _this.sortObjects === true ) {

			currentRenderList.sort();

		}

		//

		textures.updateVideoTextures();

		//

		if ( _clippingEnabled ) _clipping.beginShadows();

		shadowMap.render( shadowsArray, scene, camera );

		lights.setup( lightsArray, shadowsArray, camera );

		if ( _clippingEnabled ) _clipping.endShadows();

		//

		_infoRender.frame ++;
		_infoRender.calls = 0;
		_infoRender.vertices = 0;
		_infoRender.faces = 0;
		_infoRender.points = 0;

		if ( renderTarget === undefined ) {

			renderTarget = null;

		}

		this.setRenderTarget( renderTarget );

		//

		background.render( currentRenderList, scene, camera, forceClear );

		// render scene

		var opaqueObjects = currentRenderList.opaque;
		var transparentObjects = currentRenderList.transparent;

		if ( scene.overrideMaterial ) {

			var overrideMaterial = scene.overrideMaterial;

			if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera, overrideMaterial );
			if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera, overrideMaterial );

		} else {

			// opaque pass (front-to-back order)

			if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera );

			// transparent pass (back-to-front order)

			if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera );

		}

		// custom renderers

		spriteRenderer.render( spritesArray, scene, camera );
		flareRenderer.render( flaresArray, scene, camera, _currentViewport );

		// Generate mipmap if we're using any kind of mipmap filtering

		if ( renderTarget ) {

			textures.updateRenderTargetMipmap( renderTarget );

		}

		// Ensure depth buffer writing is enabled so it can be cleared on next render

		state.buffers.depth.setTest( true );
		state.buffers.depth.setMask( true );
		state.buffers.color.setMask( true );

		state.setPolygonOffset( false );

		if ( vr.enabled ) {

			vr.submitFrame();

		}

		// _gl.finish();

	};

	/*
	// TODO Duplicated code (Frustum)

	var _sphere = new Sphere();

	function isObjectViewable( object ) {

		var geometry = object.geometry;

		if ( geometry.boundingSphere === null )
			geometry.computeBoundingSphere();

		_sphere.copy( geometry.boundingSphere ).
		applyMatrix4( object.matrixWorld );

		return isSphereViewable( _sphere );

	}

	function isSpriteViewable( sprite ) {

		_sphere.center.set( 0, 0, 0 );
		_sphere.radius = 0.7071067811865476;
		_sphere.applyMatrix4( sprite.matrixWorld );

		return isSphereViewable( _sphere );

	}

	function isSphereViewable( sphere ) {

		if ( ! _frustum.intersectsSphere( sphere ) ) return false;

		var numPlanes = _clipping.numPlanes;

		if ( numPlanes === 0 ) return true;

		var planes = _this.clippingPlanes,

			center = sphere.center,
			negRad = - sphere.radius,
			i = 0;

		do {

			// out when deeper than radius in the negative halfspace
			if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;

		} while ( ++ i !== numPlanes );

		return true;

	}
	*/

	function projectObject( object, camera, sortObjects ) {

		if ( object.visible === false ) return;

		var visible = object.layers.test( camera.layers );

		if ( visible ) {

			if ( object.isLight ) {

				lightsArray.push( object );

				if ( object.castShadow ) {

					shadowsArray.push( object );

				}

			} else if ( object.isSprite ) {

				if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {

					spritesArray.push( object );

				}

			} else if ( object.isLensFlare ) {

				flaresArray.push( object );

			} else if ( object.isImmediateRenderObject ) {

				if ( sortObjects ) {

					_vector3.setFromMatrixPosition( object.matrixWorld )
						.applyMatrix4( _projScreenMatrix );

				}

				currentRenderList.push( object, null, object.material, _vector3.z, null );

			} else if ( object.isMesh || object.isLine || object.isPoints ) {

				if ( object.isSkinnedMesh ) {

					object.skeleton.update();

				}

				if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {

					if ( sortObjects ) {

						_vector3.setFromMatrixPosition( object.matrixWorld )
							.applyMatrix4( _projScreenMatrix );

					}

					var geometry = objects.update( object );
					var material = object.material;

					if ( Array.isArray( material ) ) {

						var groups = geometry.groups;

						for ( var i = 0, l = groups.length; i < l; i ++ ) {

							var group = groups[ i ];
							var groupMaterial = material[ group.materialIndex ];

							if ( groupMaterial && groupMaterial.visible ) {

								currentRenderList.push( object, geometry, groupMaterial, _vector3.z, group );

							}

						}

					} else if ( material.visible ) {

						currentRenderList.push( object, geometry, material, _vector3.z, null );

					}

				}

			}

		}

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			projectObject( children[ i ], camera, sortObjects );

		}

	}

	function renderObjects( renderList, scene, camera, overrideMaterial ) {

		for ( var i = 0, l = renderList.length; i < l; i ++ ) {

			var renderItem = renderList[ i ];

			var object = renderItem.object;
			var geometry = renderItem.geometry;
			var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
			var group = renderItem.group;

			if ( camera.isArrayCamera ) {

				_currentArrayCamera = camera;

				var cameras = camera.cameras;

				for ( var j = 0, jl = cameras.length; j < jl; j ++ ) {

					var camera2 = cameras[ j ];

					if ( object.layers.test( camera2.layers ) ) {

						var bounds = camera2.bounds;

						var x = bounds.x * _width;
						var y = bounds.y * _height;
						var width = bounds.z * _width;
						var height = bounds.w * _height;

						state.viewport( _currentViewport.set( x, y, width, height ).multiplyScalar( _pixelRatio ) );

						renderObject( object, scene, camera2, geometry, material, group );

					}

				}

			} else {

				_currentArrayCamera = null;

				renderObject( object, scene, camera, geometry, material, group );

			}

		}

	}

	function renderObject( object, scene, camera, geometry, material, group ) {

		object.onBeforeRender( _this, scene, camera, geometry, material, group );

		object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
		object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

		if ( object.isImmediateRenderObject ) {

			var frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );

			state.setMaterial( material, frontFaceCW );

			var program = setProgram( camera, scene.fog, material, object );

			_currentGeometryProgram = '';

			renderObjectImmediate( object, program, material );

		} else {

			_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );

		}

		object.onAfterRender( _this, scene, camera, geometry, material, group );

	}

	function initMaterial( material, fog, object ) {

		var materialProperties = properties.get( material );

		var parameters = programCache.getParameters(
			material, lights.state, shadowsArray, fog, _clipping.numPlanes, _clipping.numIntersection, object );

		var code = programCache.getProgramCode( material, parameters );

		var program = materialProperties.program;
		var programChange = true;

		if ( program === undefined ) {

			// new material
			material.addEventListener( 'dispose', onMaterialDispose );

		} else if ( program.code !== code ) {

			// changed glsl or parameters
			releaseMaterialProgramReference( material );

		} else if ( parameters.shaderID !== undefined ) {

			// same glsl and uniform list
			return;

		} else {

			// only rebuild uniform list
			programChange = false;

		}

		if ( programChange ) {

			if ( parameters.shaderID ) {

				var shader = ShaderLib[ parameters.shaderID ];

				materialProperties.shader = {
					name: material.type,
					uniforms: UniformsUtils.clone( shader.uniforms ),
					vertexShader: shader.vertexShader,
					fragmentShader: shader.fragmentShader
				};

			} else {

				materialProperties.shader = {
					name: material.type,
					uniforms: material.uniforms,
					vertexShader: material.vertexShader,
					fragmentShader: material.fragmentShader
				};

			}

			material.onBeforeCompile( materialProperties.shader );

			program = programCache.acquireProgram( material, materialProperties.shader, parameters, code );

			materialProperties.program = program;
			material.program = program;

		}

		var programAttributes = program.getAttributes();

		if ( material.morphTargets ) {

			material.numSupportedMorphTargets = 0;

			for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {

				if ( programAttributes[ 'morphTarget' + i ] >= 0 ) {

					material.numSupportedMorphTargets ++;

				}

			}

		}

		if ( material.morphNormals ) {

			material.numSupportedMorphNormals = 0;

			for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {

				if ( programAttributes[ 'morphNormal' + i ] >= 0 ) {

					material.numSupportedMorphNormals ++;

				}

			}

		}

		var uniforms = materialProperties.shader.uniforms;

		if ( ! material.isShaderMaterial &&
			! material.isRawShaderMaterial ||
			material.clipping === true ) {

			materialProperties.numClippingPlanes = _clipping.numPlanes;
			materialProperties.numIntersection = _clipping.numIntersection;
			uniforms.clippingPlanes = _clipping.uniform;

		}

		materialProperties.fog = fog;

		// store the light setup it was created for

		materialProperties.lightsHash = lights.state.hash;

		if ( material.lights ) {

			// wire up the material to this renderer's lighting state

			uniforms.ambientLightColor.value = lights.state.ambient;
			uniforms.directionalLights.value = lights.state.directional;
			uniforms.spotLights.value = lights.state.spot;
			uniforms.rectAreaLights.value = lights.state.rectArea;
			uniforms.pointLights.value = lights.state.point;
			uniforms.hemisphereLights.value = lights.state.hemi;

			uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
			uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
			uniforms.spotShadowMap.value = lights.state.spotShadowMap;
			uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
			uniforms.pointShadowMap.value = lights.state.pointShadowMap;
			uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
			// TODO (abelnation): add area lights shadow info to uniforms

		}

		var progUniforms = materialProperties.program.getUniforms(),
			uniformsList =
				WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );

		materialProperties.uniformsList = uniformsList;

	}

	function setProgram( camera, fog, material, object ) {

		_usedTextureUnits = 0;

		var materialProperties = properties.get( material );

		if ( _clippingEnabled ) {

			if ( _localClippingEnabled || camera !== _currentCamera ) {

				var useCache =
					camera === _currentCamera &&
					material.id === _currentMaterialId;

				// we might want to call this function with some ClippingGroup
				// object instead of the material, once it becomes feasible
				// (#8465, #8379)
				_clipping.setState(
					material.clippingPlanes, material.clipIntersection, material.clipShadows,
					camera, materialProperties, useCache );

			}

		}

		if ( material.needsUpdate === false ) {

			if ( materialProperties.program === undefined ) {

				material.needsUpdate = true;

			} else if ( material.fog && materialProperties.fog !== fog ) {

				material.needsUpdate = true;

			} else if ( material.lights && materialProperties.lightsHash !== lights.state.hash ) {

				material.needsUpdate = true;

			} else if ( materialProperties.numClippingPlanes !== undefined &&
				( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
				materialProperties.numIntersection !== _clipping.numIntersection ) ) {

				material.needsUpdate = true;

			}

		}

		if ( material.needsUpdate ) {

			initMaterial( material, fog, object );
			material.needsUpdate = false;

		}

		var refreshProgram = false;
		var refreshMaterial = false;
		var refreshLights = false;

		var program = materialProperties.program,
			p_uniforms = program.getUniforms(),
			m_uniforms = materialProperties.shader.uniforms;

		if ( state.useProgram( program.program ) ) {

			refreshProgram = true;
			refreshMaterial = true;
			refreshLights = true;

		}

		if ( material.id !== _currentMaterialId ) {

			_currentMaterialId = material.id;

			refreshMaterial = true;

		}

		if ( refreshProgram || camera !== _currentCamera ) {

			p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );

			if ( capabilities.logarithmicDepthBuffer ) {

				p_uniforms.setValue( _gl, 'logDepthBufFC',
					2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

			}

			// Avoid unneeded uniform updates per ArrayCamera's sub-camera

			if ( _currentCamera !== ( _currentArrayCamera || camera ) ) {

				_currentCamera = ( _currentArrayCamera || camera );

				// lighting uniforms depend on the camera so enforce an update
				// now, in case this material supports lights - or later, when
				// the next material that does gets activated:

				refreshMaterial = true;		// set to true on material change
				refreshLights = true;		// remains set until update done

			}

			// load material specific uniforms
			// (shader material also gets them for the sake of genericity)

			if ( material.isShaderMaterial ||
				material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial ||
				material.envMap ) {

				var uCamPos = p_uniforms.map.cameraPosition;

				if ( uCamPos !== undefined ) {

					uCamPos.setValue( _gl,
						_vector3.setFromMatrixPosition( camera.matrixWorld ) );

				}

			}

			if ( material.isMeshPhongMaterial ||
				material.isMeshLambertMaterial ||
				material.isMeshBasicMaterial ||
				material.isMeshStandardMaterial ||
				material.isShaderMaterial ||
				material.skinning ) {

				p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

			}

		}

		// skinning uniforms must be set even if material didn't change
		// auto-setting of texture unit for bone texture must go before other textures
		// not sure why, but otherwise weird things happen

		if ( material.skinning ) {

			p_uniforms.setOptional( _gl, object, 'bindMatrix' );
			p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

			var skeleton = object.skeleton;

			if ( skeleton ) {

				var bones = skeleton.bones;

				if ( capabilities.floatVertexTextures ) {

					if ( skeleton.boneTexture === undefined ) {

						// layout (1 matrix = 4 pixels)
						//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
						//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
						//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
						//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
						//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)


						var size = Math.sqrt( bones.length * 4 ); // 4 pixels needed for 1 matrix
						size = _Math.ceilPowerOfTwo( size );
						size = Math.max( size, 4 );

						var boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
						boneMatrices.set( skeleton.boneMatrices ); // copy current values

						var boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );

						skeleton.boneMatrices = boneMatrices;
						skeleton.boneTexture = boneTexture;
						skeleton.boneTextureSize = size;

					}

					p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture );
					p_uniforms.setValue( _gl, 'boneTextureSize', skeleton.boneTextureSize );

				} else {

					p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );

				}

			}

		}

		if ( refreshMaterial ) {

			p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );
			p_uniforms.setValue( _gl, 'toneMappingWhitePoint', _this.toneMappingWhitePoint );

			if ( material.lights ) {

				// the current material requires lighting info

				// note: all lighting uniforms are always set correctly
				// they simply reference the renderer's state for their
				// values
				//
				// use the current material's .needsUpdate flags to set
				// the GL state when required

				markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

			}

			// refresh uniforms common to several materials

			if ( fog && material.fog ) {

				refreshUniformsFog( m_uniforms, fog );

			}

			if ( material.isMeshBasicMaterial ) {

				refreshUniformsCommon( m_uniforms, material );

			} else if ( material.isMeshLambertMaterial ) {

				refreshUniformsCommon( m_uniforms, material );
				refreshUniformsLambert( m_uniforms, material );

			} else if ( material.isMeshPhongMaterial ) {

				refreshUniformsCommon( m_uniforms, material );

				if ( material.isMeshToonMaterial ) {

					refreshUniformsToon( m_uniforms, material );

				} else {

					refreshUniformsPhong( m_uniforms, material );

				}

			} else if ( material.isMeshStandardMaterial ) {

				refreshUniformsCommon( m_uniforms, material );

				if ( material.isMeshPhysicalMaterial ) {

					refreshUniformsPhysical( m_uniforms, material );

				} else {

					refreshUniformsStandard( m_uniforms, material );

				}

			} else if ( material.isMeshDepthMaterial ) {

				refreshUniformsCommon( m_uniforms, material );
				refreshUniformsDepth( m_uniforms, material );

			} else if ( material.isMeshDistanceMaterial ) {

				refreshUniformsCommon( m_uniforms, material );
				refreshUniformsDistance( m_uniforms, material );

			} else if ( material.isMeshNormalMaterial ) {

				refreshUniformsCommon( m_uniforms, material );
				refreshUniformsNormal( m_uniforms, material );

			} else if ( material.isLineBasicMaterial ) {

				refreshUniformsLine( m_uniforms, material );

				if ( material.isLineDashedMaterial ) {

					refreshUniformsDash( m_uniforms, material );

				}

			} else if ( material.isPointsMaterial ) {

				refreshUniformsPoints( m_uniforms, material );

			} else if ( material.isShadowMaterial ) {

				m_uniforms.color.value = material.color;
				m_uniforms.opacity.value = material.opacity;

			}

			// RectAreaLight Texture
			// TODO (mrdoob): Find a nicer implementation

			if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = UniformsLib.LTC_MAT_TEXTURE;
			if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = UniformsLib.LTC_MAG_TEXTURE;

			WebGLUniforms.upload(
				_gl, materialProperties.uniformsList, m_uniforms, _this );

		}


		// common matrices

		p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
		p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
		p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

		return program;

	}

	// Uniforms (refresh uniforms objects)

	function refreshUniformsCommon( uniforms, material ) {

		uniforms.opacity.value = material.opacity;

		if ( material.color ) {

			uniforms.diffuse.value = material.color;

		}

		if ( material.emissive ) {

			uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

		}

		if ( material.map ) {

			uniforms.map.value = material.map;

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

		}

		if ( material.specularMap ) {

			uniforms.specularMap.value = material.specularMap;

		}

		if ( material.envMap ) {

			uniforms.envMap.value = material.envMap;

			// don't flip CubeTexture envMaps, flip everything else:
			//  WebGLRenderTargetCube will be flipped for backwards compatibility
			//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
			// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
			uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.refractionRatio.value = material.refractionRatio;

		}

		if ( material.lightMap ) {

			uniforms.lightMap.value = material.lightMap;
			uniforms.lightMapIntensity.value = material.lightMapIntensity;

		}

		if ( material.aoMap ) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

		}

		// uv repeat and offset setting priorities
		// 1. color map
		// 2. specular map
		// 3. normal map
		// 4. bump map
		// 5. alpha map
		// 6. emissive map

		var uvScaleMap;

		if ( material.map ) {

			uvScaleMap = material.map;

		} else if ( material.specularMap ) {

			uvScaleMap = material.specularMap;

		} else if ( material.displacementMap ) {

			uvScaleMap = material.displacementMap;

		} else if ( material.normalMap ) {

			uvScaleMap = material.normalMap;

		} else if ( material.bumpMap ) {

			uvScaleMap = material.bumpMap;

		} else if ( material.roughnessMap ) {

			uvScaleMap = material.roughnessMap;

		} else if ( material.metalnessMap ) {

			uvScaleMap = material.metalnessMap;

		} else if ( material.alphaMap ) {

			uvScaleMap = material.alphaMap;

		} else if ( material.emissiveMap ) {

			uvScaleMap = material.emissiveMap;

		}

		if ( uvScaleMap !== undefined ) {

			// backwards compatibility
			if ( uvScaleMap.isWebGLRenderTarget ) {

				uvScaleMap = uvScaleMap.texture;

			}

			if ( uvScaleMap.matrixAutoUpdate === true ) {

				var offset = uvScaleMap.offset;
				var repeat = uvScaleMap.repeat;
				var rotation = uvScaleMap.rotation;
				var center = uvScaleMap.center;

				uvScaleMap.matrix.setUvTransform( offset.x, offset.y, repeat.x, repeat.y, rotation, center.x, center.y );

			}

			uniforms.uvTransform.value.copy( uvScaleMap.matrix );

		}

	}

	function refreshUniformsLine( uniforms, material ) {

		uniforms.diffuse.value = material.color;
		uniforms.opacity.value = material.opacity;

	}

	function refreshUniformsDash( uniforms, material ) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;

	}

	function refreshUniformsPoints( uniforms, material ) {

		uniforms.diffuse.value = material.color;
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * _pixelRatio;
		uniforms.scale.value = _height * 0.5;

		uniforms.map.value = material.map;

		if ( material.map !== null ) {

			if ( material.map.matrixAutoUpdate === true ) {

				var offset = material.map.offset;
				var repeat = material.map.repeat;
				var rotation = material.map.rotation;
				var center = material.map.center;

				material.map.matrix.setUvTransform( offset.x, offset.y, repeat.x, repeat.y, rotation, center.x, center.y );

			}

			uniforms.uvTransform.value.copy( material.map.matrix );

		}

	}

	function refreshUniformsFog( uniforms, fog ) {

		uniforms.fogColor.value = fog.color;

		if ( fog.isFog ) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;

		} else if ( fog.isFogExp2 ) {

			uniforms.fogDensity.value = fog.density;

		}

	}

	function refreshUniformsLambert( uniforms, material ) {

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

	}

	function refreshUniformsPhong( uniforms, material ) {

		uniforms.specular.value = material.specular;
		uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

	}

	function refreshUniformsToon( uniforms, material ) {

		refreshUniformsPhong( uniforms, material );

		if ( material.gradientMap ) {

			uniforms.gradientMap.value = material.gradientMap;

		}

	}

	function refreshUniformsStandard( uniforms, material ) {

		uniforms.roughness.value = material.roughness;
		uniforms.metalness.value = material.metalness;

		if ( material.roughnessMap ) {

			uniforms.roughnessMap.value = material.roughnessMap;

		}

		if ( material.metalnessMap ) {

			uniforms.metalnessMap.value = material.metalnessMap;

		}

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		if ( material.envMap ) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common
			uniforms.envMapIntensity.value = material.envMapIntensity;

		}

	}

	function refreshUniformsPhysical( uniforms, material ) {

		uniforms.clearCoat.value = material.clearCoat;
		uniforms.clearCoatRoughness.value = material.clearCoatRoughness;

		refreshUniformsStandard( uniforms, material );

	}

	function refreshUniformsDepth( uniforms, material ) {

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

	}

	function refreshUniformsDistance( uniforms, material ) {

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		uniforms.referencePosition.value.copy( material.referencePosition );
		uniforms.nearDistance.value = material.nearDistance;
		uniforms.farDistance.value = material.farDistance;

	}

	function refreshUniformsNormal( uniforms, material ) {

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

	}

	// If uniforms are marked as clean, they don't need to be loaded to the GPU.

	function markUniformsLightsNeedsUpdate( uniforms, value ) {

		uniforms.ambientLightColor.needsUpdate = value;

		uniforms.directionalLights.needsUpdate = value;
		uniforms.pointLights.needsUpdate = value;
		uniforms.spotLights.needsUpdate = value;
		uniforms.rectAreaLights.needsUpdate = value;
		uniforms.hemisphereLights.needsUpdate = value;

	}

	// GL state setting

	this.setFaceCulling = function ( cullFace, frontFaceDirection ) {

		state.setCullFace( cullFace );
		state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );

	};

	// Textures

	function allocTextureUnit() {

		var textureUnit = _usedTextureUnits;

		if ( textureUnit >= capabilities.maxTextures ) {

			console.warn( 'THREE.WebGLRenderer: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

		}

		_usedTextureUnits += 1;

		return textureUnit;

	}

	this.allocTextureUnit = allocTextureUnit;

	// this.setTexture2D = setTexture2D;
	this.setTexture2D = ( function () {

		var warned = false;

		// backwards compatibility: peel texture.texture
		return function setTexture2D( texture, slot ) {

			if ( texture && texture.isWebGLRenderTarget ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
					warned = true;

				}

				texture = texture.texture;

			}

			textures.setTexture2D( texture, slot );

		};

	}() );

	this.setTexture = ( function () {

		var warned = false;

		return function setTexture( texture, slot ) {

			if ( ! warned ) {

				console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
				warned = true;

			}

			textures.setTexture2D( texture, slot );

		};

	}() );

	this.setTextureCube = ( function () {

		var warned = false;

		return function setTextureCube( texture, slot ) {

			// backwards compatibility: peel texture.texture
			if ( texture && texture.isWebGLRenderTargetCube ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
					warned = true;

				}

				texture = texture.texture;

			}

			// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
			// TODO: unify these code paths
			if ( ( texture && texture.isCubeTexture ) ||
				( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {

				// CompressedTexture can have Array in image :/

				// this function alone should take care of cube textures
				textures.setTextureCube( texture, slot );

			} else {

				// assumed: texture property of THREE.WebGLRenderTargetCube

				textures.setTextureCubeDynamic( texture, slot );

			}

		};

	}() );

	this.getRenderTarget = function () {

		return _currentRenderTarget;

	};

	this.setRenderTarget = function ( renderTarget ) {

		_currentRenderTarget = renderTarget;

		if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {

			textures.setupRenderTarget( renderTarget );

		}

		var framebuffer = null;
		var isCube = false;

		if ( renderTarget ) {

			var __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( renderTarget.isWebGLRenderTargetCube ) {

				framebuffer = __webglFramebuffer[ renderTarget.activeCubeFace ];
				isCube = true;

			} else {

				framebuffer = __webglFramebuffer;

			}

			_currentViewport.copy( renderTarget.viewport );
			_currentScissor.copy( renderTarget.scissor );
			_currentScissorTest = renderTarget.scissorTest;

		} else {

			_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );
			_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
			_currentScissorTest = _scissorTest;

		}

		if ( _currentFramebuffer !== framebuffer ) {

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
			_currentFramebuffer = framebuffer;

		}

		state.viewport( _currentViewport );
		state.scissor( _currentScissor );
		state.setScissorTest( _currentScissorTest );

		if ( isCube ) {

			var textureProperties = properties.get( renderTarget.texture );
			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );

		}

	};

	this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {

		if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

			console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
			return;

		}

		var framebuffer = properties.get( renderTarget ).__webglFramebuffer;

		if ( framebuffer ) {

			var restore = false;

			if ( framebuffer !== _currentFramebuffer ) {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				restore = true;

			}

			try {

				var texture = renderTarget.texture;
				var textureFormat = texture.format;
				var textureType = texture.type;

				if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
					return;

				}

				if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
					! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
					! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
					return;

				}

				if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );

					}

				} else {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );

				}

			} finally {

				if ( restore ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );

				}

			}

		}

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function FogExp2( color, density ) {

	this.name = '';

	this.color = new Color( color );
	this.density = ( density !== undefined ) ? density : 0.00025;

}

FogExp2.prototype.isFogExp2 = true;

FogExp2.prototype.clone = function () {

	return new FogExp2( this.color.getHex(), this.density );

};

FogExp2.prototype.toJSON = function ( /* meta */ ) {

	return {
		type: 'FogExp2',
		color: this.color.getHex(),
		density: this.density
	};

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Fog( color, near, far ) {

	this.name = '';

	this.color = new Color( color );

	this.near = ( near !== undefined ) ? near : 1;
	this.far = ( far !== undefined ) ? far : 1000;

}

Fog.prototype.isFog = true;

Fog.prototype.clone = function () {

	return new Fog( this.color.getHex(), this.near, this.far );

};

Fog.prototype.toJSON = function ( /* meta */ ) {

	return {
		type: 'Fog',
		color: this.color.getHex(),
		near: this.near,
		far: this.far
	};

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Scene() {

	Object3D.call( this );

	this.type = 'Scene';

	this.background = null;
	this.fog = null;
	this.overrideMaterial = null;

	this.autoUpdate = true; // checked by the renderer

}

Scene.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Scene,

	copy: function ( source, recursive ) {

		Object3D.prototype.copy.call( this, source, recursive );

		if ( source.background !== null ) this.background = source.background.clone();
		if ( source.fog !== null ) this.fog = source.fog.clone();
		if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

		this.autoUpdate = source.autoUpdate;
		this.matrixAutoUpdate = source.matrixAutoUpdate;

		return this;

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
		if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

		return data;

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function LensFlare( texture, size, distance, blending, color ) {

	Object3D.call( this );

	this.lensFlares = [];

	this.positionScreen = new Vector3();
	this.customUpdateCallback = undefined;

	if ( texture !== undefined ) {

		this.add( texture, size, distance, blending, color );

	}

}

LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: LensFlare,

	isLensFlare: true,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.positionScreen.copy( source.positionScreen );
		this.customUpdateCallback = source.customUpdateCallback;

		for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {

			this.lensFlares.push( source.lensFlares[ i ] );

		}

		return this;

	},

	add: function ( texture, size, distance, blending, color, opacity ) {

		if ( size === undefined ) size = - 1;
		if ( distance === undefined ) distance = 0;
		if ( opacity === undefined ) opacity = 1;
		if ( color === undefined ) color = new Color( 0xffffff );
		if ( blending === undefined ) blending = NormalBlending;

		distance = Math.min( distance, Math.max( 0, distance ) );

		this.lensFlares.push( {
			texture: texture,	// THREE.Texture
			size: size, 		// size in pixels (-1 = use texture.width)
			distance: distance, 	// distance (0-1) from light source (0=at light source)
			x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
			scale: 1, 		// scale
			rotation: 0, 		// rotation
			opacity: opacity,	// opacity
			color: color,		// color
			blending: blending	// blending
		} );

	},

	/*
	 * Update lens flares update positions on all flares based on the screen position
	 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
	 */

	updateLensFlares: function () {

		var f, fl = this.lensFlares.length;
		var flare;
		var vecX = - this.positionScreen.x * 2;
		var vecY = - this.positionScreen.y * 2;

		for ( f = 0; f < fl; f ++ ) {

			flare = this.lensFlares[ f ];

			flare.x = this.positionScreen.x + vecX * flare.distance;
			flare.y = this.positionScreen.y + vecY * flare.distance;

			flare.wantedRotation = flare.x * Math.PI * 0.25;
			flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;

		}

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *	uvOffset: new THREE.Vector2(),
 *	uvScale: new THREE.Vector2()
 * }
 */

function SpriteMaterial( parameters ) {

	Material.call( this );

	this.type = 'SpriteMaterial';

	this.color = new Color( 0xffffff );
	this.map = null;

	this.rotation = 0;

	this.fog = false;
	this.lights = false;

	this.setValues( parameters );

}

SpriteMaterial.prototype = Object.create( Material.prototype );
SpriteMaterial.prototype.constructor = SpriteMaterial;
SpriteMaterial.prototype.isSpriteMaterial = true;

SpriteMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );
	this.map = source.map;

	this.rotation = source.rotation;

	return this;

};

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function Sprite( material ) {

	Object3D.call( this );

	this.type = 'Sprite';

	this.material = ( material !== undefined ) ? material : new SpriteMaterial();

}

Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Sprite,

	isSprite: true,

	raycast: ( function () {

		var intersectPoint = new Vector3();
		var worldPosition = new Vector3();
		var worldScale = new Vector3();

		return function raycast( raycaster, intersects ) {

			worldPosition.setFromMatrixPosition( this.matrixWorld );
			raycaster.ray.closestPointToPoint( worldPosition, intersectPoint );

			worldScale.setFromMatrixScale( this.matrixWorld );
			var guessSizeSq = worldScale.x * worldScale.y / 4;

			if ( worldPosition.distanceToSquared( intersectPoint ) > guessSizeSq ) return;

			var distance = raycaster.ray.origin.distanceTo( intersectPoint );

			if ( distance < raycaster.near || distance > raycaster.far ) return;

			intersects.push( {

				distance: distance,
				point: intersectPoint.clone(),
				face: null,
				object: this

			} );

		};

	}() ),

	clone: function () {

		return new this.constructor( this.material ).copy( this );

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function LOD() {

	Object3D.call( this );

	this.type = 'LOD';

	Object.defineProperties( this, {
		levels: {
			enumerable: true,
			value: []
		}
	} );

}

LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: LOD,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source, false );

		var levels = source.levels;

		for ( var i = 0, l = levels.length; i < l; i ++ ) {

			var level = levels[ i ];

			this.addLevel( level.object.clone(), level.distance );

		}

		return this;

	},

	addLevel: function ( object, distance ) {

		if ( distance === undefined ) distance = 0;

		distance = Math.abs( distance );

		var levels = this.levels;

		for ( var l = 0; l < levels.length; l ++ ) {

			if ( distance < levels[ l ].distance ) {

				break;

			}

		}

		levels.splice( l, 0, { distance: distance, object: object } );

		this.add( object );

	},

	getObjectForDistance: function ( distance ) {

		var levels = this.levels;

		for ( var i = 1, l = levels.length; i < l; i ++ ) {

			if ( distance < levels[ i ].distance ) {

				break;

			}

		}

		return levels[ i - 1 ].object;

	},

	raycast: ( function () {

		var matrixPosition = new Vector3();

		return function raycast( raycaster, intersects ) {

			matrixPosition.setFromMatrixPosition( this.matrixWorld );

			var distance = raycaster.ray.origin.distanceTo( matrixPosition );

			this.getObjectForDistance( distance ).raycast( raycaster, intersects );

		};

	}() ),

	update: function () {

		var v1 = new Vector3();
		var v2 = new Vector3();

		return function update( camera ) {

			var levels = this.levels;

			if ( levels.length > 1 ) {

				v1.setFromMatrixPosition( camera.matrixWorld );
				v2.setFromMatrixPosition( this.matrixWorld );

				var distance = v1.distanceTo( v2 );

				levels[ 0 ].object.visible = true;

				for ( var i = 1, l = levels.length; i < l; i ++ ) {

					if ( distance >= levels[ i ].distance ) {

						levels[ i - 1 ].object.visible = false;
						levels[ i ].object.visible = true;

					} else {

						break;

					}

				}

				for ( ; i < l; i ++ ) {

					levels[ i ].object.visible = false;

				}

			}

		};

	}(),

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.levels = [];

		var levels = this.levels;

		for ( var i = 0, l = levels.length; i < l; i ++ ) {

			var level = levels[ i ];

			data.object.levels.push( {
				object: level.object.uuid,
				distance: level.distance
			} );

		}

		return data;

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author michael guerrero / http://realitymeltdown.com
 * @author ikerr / http://verold.com
 */

function Skeleton( bones, boneInverses ) {

	// copy the bone array

	bones = bones || [];

	this.bones = bones.slice( 0 );
	this.boneMatrices = new Float32Array( this.bones.length * 16 );

	// use the supplied bone inverses or calculate the inverses

	if ( boneInverses === undefined ) {

		this.calculateInverses();

	} else {

		if ( this.bones.length === boneInverses.length ) {

			this.boneInverses = boneInverses.slice( 0 );

		} else {

			console.warn( 'THREE.Skeleton boneInverses is the wrong length.' );

			this.boneInverses = [];

			for ( var i = 0, il = this.bones.length; i < il; i ++ ) {

				this.boneInverses.push( new Matrix4() );

			}

		}

	}

}

Object.assign( Skeleton.prototype, {

	calculateInverses: function () {

		this.boneInverses = [];

		for ( var i = 0, il = this.bones.length; i < il; i ++ ) {

			var inverse = new Matrix4();

			if ( this.bones[ i ] ) {

				inverse.getInverse( this.bones[ i ].matrixWorld );

			}

			this.boneInverses.push( inverse );

		}

	},

	pose: function () {

		var bone, i, il;

		// recover the bind-time world matrices

		for ( i = 0, il = this.bones.length; i < il; i ++ ) {

			bone = this.bones[ i ];

			if ( bone ) {

				bone.matrixWorld.getInverse( this.boneInverses[ i ] );

			}

		}

		// compute the local matrices, positions, rotations and scales

		for ( i = 0, il = this.bones.length; i < il; i ++ ) {

			bone = this.bones[ i ];

			if ( bone ) {

				if ( bone.parent && bone.parent.isBone ) {

					bone.matrix.getInverse( bone.parent.matrixWorld );
					bone.matrix.multiply( bone.matrixWorld );

				} else {

					bone.matrix.copy( bone.matrixWorld );

				}

				bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

			}

		}

	},

	update: ( function () {

		var offsetMatrix = new Matrix4();
		var identityMatrix = new Matrix4();

		return function update() {

			var bones = this.bones;
			var boneInverses = this.boneInverses;
			var boneMatrices = this.boneMatrices;
			var boneTexture = this.boneTexture;

			// flatten bone matrices to array

			for ( var i = 0, il = bones.length; i < il; i ++ ) {

				// compute the offset between the current and the original transform

				var matrix = bones[ i ] ? bones[ i ].matrixWorld : identityMatrix;

				offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
				offsetMatrix.toArray( boneMatrices, i * 16 );

			}

			if ( boneTexture !== undefined ) {

				boneTexture.needsUpdate = true;

			}

		};

	} )(),

	clone: function () {

		return new Skeleton( this.bones, this.boneInverses );

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author ikerr / http://verold.com
 */

function Bone() {

	Object3D.call( this );

	this.type = 'Bone';

}

Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Bone,

	isBone: true

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author ikerr / http://verold.com
 */

function SkinnedMesh( geometry, material ) {

	Mesh.call( this, geometry, material );

	this.type = 'SkinnedMesh';

	this.bindMode = 'attached';
	this.bindMatrix = new Matrix4();
	this.bindMatrixInverse = new Matrix4();

	var bones = this.initBones();
	var skeleton = new Skeleton( bones );

	this.bind( skeleton, this.matrixWorld );

	this.normalizeSkinWeights();

}

SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {

	constructor: SkinnedMesh,

	isSkinnedMesh: true,

	initBones: function () {

		var bones = [], bone, gbone;
		var i, il;

		if ( this.geometry && this.geometry.bones !== undefined ) {

			// first, create array of 'Bone' objects from geometry data

			for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {

				gbone = this.geometry.bones[ i ];

				// create new 'Bone' object

				bone = new Bone();
				bones.push( bone );

				// apply values

				bone.name = gbone.name;
				bone.position.fromArray( gbone.pos );
				bone.quaternion.fromArray( gbone.rotq );
				if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );

			}

			// second, create bone hierarchy

			for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {

				gbone = this.geometry.bones[ i ];

				if ( ( gbone.parent !== - 1 ) && ( gbone.parent !== null ) && ( bones[ gbone.parent ] !== undefined ) ) {

					// subsequent bones in the hierarchy

					bones[ gbone.parent ].add( bones[ i ] );

				} else {

					// topmost bone, immediate child of the skinned mesh

					this.add( bones[ i ] );

				}

			}

		}

		// now the bones are part of the scene graph and children of the skinned mesh.
		// let's update the corresponding matrices

		this.updateMatrixWorld( true );

		return bones;

	},

	bind: function ( skeleton, bindMatrix ) {

		this.skeleton = skeleton;

		if ( bindMatrix === undefined ) {

			this.updateMatrixWorld( true );

			this.skeleton.calculateInverses();

			bindMatrix = this.matrixWorld;

		}

		this.bindMatrix.copy( bindMatrix );
		this.bindMatrixInverse.getInverse( bindMatrix );

	},

	pose: function () {

		this.skeleton.pose();

	},

	normalizeSkinWeights: function () {

		var scale, i;

		if ( this.geometry && this.geometry.isGeometry ) {

			for ( i = 0; i < this.geometry.skinWeights.length; i ++ ) {

				var sw = this.geometry.skinWeights[ i ];

				scale = 1.0 / sw.manhattanLength();

				if ( scale !== Infinity ) {

					sw.multiplyScalar( scale );

				} else {

					sw.set( 1, 0, 0, 0 ); // do something reasonable

				}

			}

		} else if ( this.geometry && this.geometry.isBufferGeometry ) {

			var vec = new Vector4();

			var skinWeight = this.geometry.attributes.skinWeight;

			for ( i = 0; i < skinWeight.count; i ++ ) {

				vec.x = skinWeight.getX( i );
				vec.y = skinWeight.getY( i );
				vec.z = skinWeight.getZ( i );
				vec.w = skinWeight.getW( i );

				scale = 1.0 / vec.manhattanLength();

				if ( scale !== Infinity ) {

					vec.multiplyScalar( scale );

				} else {

					vec.set( 1, 0, 0, 0 ); // do something reasonable

				}

				skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );

			}

		}

	},

	updateMatrixWorld: function ( force ) {

		Mesh.prototype.updateMatrixWorld.call( this, force );

		if ( this.bindMode === 'attached' ) {

			this.bindMatrixInverse.getInverse( this.matrixWorld );

		} else if ( this.bindMode === 'detached' ) {

			this.bindMatrixInverse.getInverse( this.bindMatrix );

		} else {

			console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );

		}

	},

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */

function LineBasicMaterial( parameters ) {

	Material.call( this );

	this.type = 'LineBasicMaterial';

	this.color = new Color( 0xffffff );

	this.linewidth = 1;
	this.linecap = 'round';
	this.linejoin = 'round';

	this.lights = false;

	this.setValues( parameters );

}

LineBasicMaterial.prototype = Object.create( Material.prototype );
LineBasicMaterial.prototype.constructor = LineBasicMaterial;

LineBasicMaterial.prototype.isLineBasicMaterial = true;

LineBasicMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.linewidth = source.linewidth;
	this.linecap = source.linecap;
	this.linejoin = source.linejoin;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Line( geometry, material, mode ) {

	if ( mode === 1 ) {

		console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
		return new LineSegments( geometry, material );

	}

	Object3D.call( this );

	this.type = 'Line';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );

}

Line.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Line,

	isLine: true,

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		return function raycast( raycaster, intersects ) {

			var precision = raycaster.linePrecision;
			var precisionSq = precision * precision;

			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			var vStart = new Vector3();
			var vEnd = new Vector3();
			var interSegment = new Vector3();
			var interRay = new Vector3();
			var step = ( this && this.isLineSegments ) ? 2 : 1;

			if ( geometry.isBufferGeometry ) {

				var index = geometry.index;
				var attributes = geometry.attributes;
				var positions = attributes.position.array;

				if ( index !== null ) {

					var indices = index.array;

					for ( var i = 0, l = indices.length - 1; i < l; i += step ) {

						var a = indices[ i ];
						var b = indices[ i + 1 ];

						vStart.fromArray( positions, a * 3 );
						vEnd.fromArray( positions, b * 3 );

						var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				} else {

					for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {

						vStart.fromArray( positions, 3 * i );
						vEnd.fromArray( positions, 3 * i + 3 );

						var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				}

			} else if ( geometry.isGeometry ) {

				var vertices = geometry.vertices;
				var nbVertices = vertices.length;

				for ( var i = 0; i < nbVertices - 1; i += step ) {

					var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );

					if ( distSq > precisionSq ) continue;

					interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

					var distance = raycaster.ray.origin.distanceTo( interRay );

					if ( distance < raycaster.near || distance > raycaster.far ) continue;

					intersects.push( {

						distance: distance,
						// What do we want? intersection point on the ray or on the segment??
						// point: raycaster.ray.at( distance ),
						point: interSegment.clone().applyMatrix4( this.matrixWorld ),
						index: i,
						face: null,
						faceIndex: null,
						object: this

					} );

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LineSegments( geometry, material ) {

	Line.call( this, geometry, material );

	this.type = 'LineSegments';

}

LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {

	constructor: LineSegments,

	isLineSegments: true

} );

/**
 * @author mgreter / http://github.com/mgreter
 */

function LineLoop( geometry, material ) {

	Line.call( this, geometry, material );

	this.type = 'LineLoop';

}

LineLoop.prototype = Object.assign( Object.create( Line.prototype ), {

	constructor: LineLoop,

	isLineLoop: true,

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 * }
 */

function PointsMaterial( parameters ) {

	Material.call( this );

	this.type = 'PointsMaterial';

	this.color = new Color( 0xffffff );

	this.map = null;

	this.size = 1;
	this.sizeAttenuation = true;

	this.lights = false;

	this.setValues( parameters );

}

PointsMaterial.prototype = Object.create( Material.prototype );
PointsMaterial.prototype.constructor = PointsMaterial;

PointsMaterial.prototype.isPointsMaterial = true;

PointsMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.size = source.size;
	this.sizeAttenuation = source.sizeAttenuation;

	return this;

};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Points( geometry, material ) {

	Object3D.call( this );

	this.type = 'Points';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );

}

Points.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Points,

	isPoints: true,

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		return function raycast( raycaster, intersects ) {

			var object = this;
			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;
			var threshold = raycaster.params.Points.threshold;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );
			sphere.radius += threshold;

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
			var localThresholdSq = localThreshold * localThreshold;
			var position = new Vector3();

			function testPoint( point, index ) {

				var rayPointDistanceSq = ray.distanceSqToPoint( point );

				if ( rayPointDistanceSq < localThresholdSq ) {

					var intersectPoint = ray.closestPointToPoint( point );
					intersectPoint.applyMatrix4( matrixWorld );

					var distance = raycaster.ray.origin.distanceTo( intersectPoint );

					if ( distance < raycaster.near || distance > raycaster.far ) return;

					intersects.push( {

						distance: distance,
						distanceToRay: Math.sqrt( rayPointDistanceSq ),
						point: intersectPoint.clone(),
						index: index,
						face: null,
						object: object

					} );

				}

			}

			if ( geometry.isBufferGeometry ) {

				var index = geometry.index;
				var attributes = geometry.attributes;
				var positions = attributes.position.array;

				if ( index !== null ) {

					var indices = index.array;

					for ( var i = 0, il = indices.length; i < il; i ++ ) {

						var a = indices[ i ];

						position.fromArray( positions, a * 3 );

						testPoint( position, a );

					}

				} else {

					for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {

						position.fromArray( positions, i * 3 );

						testPoint( position, i );

					}

				}

			} else {

				var vertices = geometry.vertices;

				for ( var i = 0, l = vertices.length; i < l; i ++ ) {

					testPoint( vertices[ i ], i );

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Group() {

	Object3D.call( this );

	this.type = 'Group';

}

Group.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Group,

	isGroup: true

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

	Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.generateMipmaps = false;

	// Set needsUpdate when first frame is ready

	var scope = this;

	function onLoaded() {

		video.removeEventListener( 'loadeddata', onLoaded, false );
		scope.needsUpdate = true;

	}

	video.addEventListener( 'loadeddata', onLoaded, false );

}

VideoTexture.prototype = Object.assign( Object.create( Texture.prototype ), {

	constructor: VideoTexture,

	isVideoTexture: true,

	update: function () {

		var video = this.image;

		if ( video.readyState >= video.HAVE_CURRENT_DATA ) {

			this.needsUpdate = true;

		}

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.image = { width: width, height: height };
	this.mipmaps = mipmaps;

	// no flipping for cube textures
	// (also flipping doesn't work for compressed textures )

	this.flipY = false;

	// can't generate mipmaps for compressed textures
	// mips must be embedded in DDS files

	this.generateMipmaps = false;

}

CompressedTexture.prototype = Object.create( Texture.prototype );
CompressedTexture.prototype.constructor = CompressedTexture;

CompressedTexture.prototype.isCompressedTexture = true;

/**
 * @author Matt DesLauriers / @mattdesl
 * @author atix / arthursilber.de
 */

function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

	format = format !== undefined ? format : DepthFormat;

	if ( format !== DepthFormat && format !== DepthStencilFormat ) {

		throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );

	}

	if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
	if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.image = { width: width, height: height };

	this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
	this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

	this.flipY = false;
	this.generateMipmaps	= false;

}

DepthTexture.prototype = Object.create( Texture.prototype );
DepthTexture.prototype.constructor = DepthTexture;
DepthTexture.prototype.isDepthTexture = true;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

function WireframeGeometry( geometry ) {

	BufferGeometry.call( this );

	this.type = 'WireframeGeometry';

	// buffer

	var vertices = [];

	// helper variables

	var i, j, l, o, ol;
	var edge = [ 0, 0 ], edges = {}, e, edge1, edge2;
	var key, keys = [ 'a', 'b', 'c' ];
	var vertex;

	// different logic for Geometry and BufferGeometry

	if ( geometry && geometry.isGeometry ) {

		// create a data structure that contains all edges without duplicates

		var faces = geometry.faces;

		for ( i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			for ( j = 0; j < 3; j ++ ) {

				edge1 = face[ keys[ j ] ];
				edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
				edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
				edge[ 1 ] = Math.max( edge1, edge2 );

				key = edge[ 0 ] + ',' + edge[ 1 ];

				if ( edges[ key ] === undefined ) {

					edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };

				}

			}

		}

		// generate vertices

		for ( key in edges ) {

			e = edges[ key ];

			vertex = geometry.vertices[ e.index1 ];
			vertices.push( vertex.x, vertex.y, vertex.z );

			vertex = geometry.vertices[ e.index2 ];
			vertices.push( vertex.x, vertex.y, vertex.z );

		}

	} else if ( geometry && geometry.isBufferGeometry ) {

		var position, indices, groups;
		var group, start, count;
		var index1, index2;

		vertex = new Vector3();

		if ( geometry.index !== null ) {

			// indexed BufferGeometry

			position = geometry.attributes.position;
			indices = geometry.index;
			groups = geometry.groups;

			if ( groups.length === 0 ) {

				groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];

			}

			// create a data structure that contains all eges without duplicates

			for ( o = 0, ol = groups.length; o < ol; ++ o ) {

				group = groups[ o ];

				start = group.start;
				count = group.count;

				for ( i = start, l = ( start + count ); i < l; i += 3 ) {

					for ( j = 0; j < 3; j ++ ) {

						edge1 = indices.getX( i + j );
						edge2 = indices.getX( i + ( j + 1 ) % 3 );
						edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
						edge[ 1 ] = Math.max( edge1, edge2 );

						key = edge[ 0 ] + ',' + edge[ 1 ];

						if ( edges[ key ] === undefined ) {

							edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };

						}

					}

				}

			}

			// generate vertices

			for ( key in edges ) {

				e = edges[ key ];

				vertex.fromBufferAttribute( position, e.index1 );
				vertices.push( vertex.x, vertex.y, vertex.z );

				vertex.fromBufferAttribute( position, e.index2 );
				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		} else {

			// non-indexed BufferGeometry

			position = geometry.attributes.position;

			for ( i = 0, l = ( position.count / 3 ); i < l; i ++ ) {

				for ( j = 0; j < 3; j ++ ) {

					// three edges per triangle, an edge is represented as (index1, index2)
					// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)

					index1 = 3 * i + j;
					vertex.fromBufferAttribute( position, index1 );
					vertices.push( vertex.x, vertex.y, vertex.z );

					index2 = 3 * i + ( ( j + 1 ) % 3 );
					vertex.fromBufferAttribute( position, index2 );
					vertices.push( vertex.x, vertex.y, vertex.z );

				}

			}

		}

	}

	// build geometry

	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

}

WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
WireframeGeometry.prototype.constructor = WireframeGeometry;

/**
 * @author zz85 / https://github.com/zz85
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
 */

// ParametricGeometry

function ParametricGeometry( func, slices, stacks ) {

	Geometry.call( this );

	this.type = 'ParametricGeometry';

	this.parameters = {
		func: func,
		slices: slices,
		stacks: stacks
	};

	this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
	this.mergeVertices();

}

ParametricGeometry.prototype = Object.create( Geometry.prototype );
ParametricGeometry.prototype.constructor = ParametricGeometry;

// ParametricBufferGeometry

function ParametricBufferGeometry( func, slices, stacks ) {

	BufferGeometry.call( this );

	this.type = 'ParametricBufferGeometry';

	this.parameters = {
		func: func,
		slices: slices,
		stacks: stacks
	};

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	var EPS = 0.00001;

	var normal = new Vector3();

	var p0 = new Vector3(), p1 = new Vector3();
	var pu = new Vector3(), pv = new Vector3();

	var i, j;

	// generate vertices, normals and uvs

	var sliceCount = slices + 1;

	for ( i = 0; i <= stacks; i ++ ) {

		var v = i / stacks;

		for ( j = 0; j <= slices; j ++ ) {

			var u = j / slices;

			// vertex

			p0 = func( u, v, p0 );
			vertices.push( p0.x, p0.y, p0.z );

			// normal

			// approximate tangent vectors via finite differences

			if ( u - EPS >= 0 ) {

				p1 = func( u - EPS, v, p1 );
				pu.subVectors( p0, p1 );

			} else {

				p1 = func( u + EPS, v, p1 );
				pu.subVectors( p1, p0 );

			}

			if ( v - EPS >= 0 ) {

				p1 = func( u, v - EPS, p1 );
				pv.subVectors( p0, p1 );

			} else {

				p1 = func( u, v + EPS, p1 );
				pv.subVectors( p1, p0 );

			}

			// cross product of tangent vectors returns surface normal

			normal.crossVectors( pu, pv ).normalize();
			normals.push( normal.x, normal.y, normal.z );

			// uv

			uvs.push( u, v );

		}

	}

	// generate indices

	for ( i = 0; i < stacks; i ++ ) {

		for ( j = 0; j < slices; j ++ ) {

			var a = i * sliceCount + j;
			var b = i * sliceCount + j + 1;
			var c = ( i + 1 ) * sliceCount + j + 1;
			var d = ( i + 1 ) * sliceCount + j;

			// faces one and two

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;

/**
 * @author clockworkgeek / https://github.com/clockworkgeek
 * @author timothypratley / https://github.com/timothypratley
 * @author WestLangley / http://github.com/WestLangley
 * @author Mugen87 / https://github.com/Mugen87
 */

// PolyhedronGeometry

function PolyhedronGeometry( vertices, indices, radius, detail ) {

	Geometry.call( this );

	this.type = 'PolyhedronGeometry';

	this.parameters = {
		vertices: vertices,
		indices: indices,
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
	this.mergeVertices();

}

PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;

// PolyhedronBufferGeometry

function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {

	BufferGeometry.call( this );

	this.type = 'PolyhedronBufferGeometry';

	this.parameters = {
		vertices: vertices,
		indices: indices,
		radius: radius,
		detail: detail
	};

	radius = radius || 1;
	detail = detail || 0;

	// default buffer data

	var vertexBuffer = [];
	var uvBuffer = [];

	// the subdivision creates the vertex buffer data

	subdivide( detail );

	// all vertices should lie on a conceptual sphere with a given radius

	appplyRadius( radius );

	// finally, create the uv data

	generateUVs();

	// build non-indexed geometry

	this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );

	if ( detail === 0 ) {

		this.computeVertexNormals(); // flat normals

	} else {

		this.normalizeNormals(); // smooth normals

	}

	// helper functions

	function subdivide( detail ) {

		var a = new Vector3();
		var b = new Vector3();
		var c = new Vector3();

		// iterate over all faces and apply a subdivison with the given detail value

		for ( var i = 0; i < indices.length; i += 3 ) {

			// get the vertices of the face

			getVertexByIndex( indices[ i + 0 ], a );
			getVertexByIndex( indices[ i + 1 ], b );
			getVertexByIndex( indices[ i + 2 ], c );

			// perform subdivision

			subdivideFace( a, b, c, detail );

		}

	}

	function subdivideFace( a, b, c, detail ) {

		var cols = Math.pow( 2, detail );

		// we use this multidimensional array as a data structure for creating the subdivision

		var v = [];

		var i, j;

		// construct all of the vertices for this subdivision

		for ( i = 0; i <= cols; i ++ ) {

			v[ i ] = [];

			var aj = a.clone().lerp( c, i / cols );
			var bj = b.clone().lerp( c, i / cols );

			var rows = cols - i;

			for ( j = 0; j <= rows; j ++ ) {

				if ( j === 0 && i === cols ) {

					v[ i ][ j ] = aj;

				} else {

					v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

				}

			}

		}

		// construct all of the faces

		for ( i = 0; i < cols; i ++ ) {

			for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

				var k = Math.floor( j / 2 );

				if ( j % 2 === 0 ) {

					pushVertex( v[ i ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k ] );
					pushVertex( v[ i ][ k ] );

				} else {

					pushVertex( v[ i ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k ] );

				}

			}

		}

	}

	function appplyRadius( radius ) {

		var vertex = new Vector3();

		// iterate over the entire buffer and apply the radius to each vertex

		for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

			vertex.x = vertexBuffer[ i + 0 ];
			vertex.y = vertexBuffer[ i + 1 ];
			vertex.z = vertexBuffer[ i + 2 ];

			vertex.normalize().multiplyScalar( radius );

			vertexBuffer[ i + 0 ] = vertex.x;
			vertexBuffer[ i + 1 ] = vertex.y;
			vertexBuffer[ i + 2 ] = vertex.z;

		}

	}

	function generateUVs() {

		var vertex = new Vector3();

		for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

			vertex.x = vertexBuffer[ i + 0 ];
			vertex.y = vertexBuffer[ i + 1 ];
			vertex.z = vertexBuffer[ i + 2 ];

			var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
			var v = inclination( vertex ) / Math.PI + 0.5;
			uvBuffer.push( u, 1 - v );

		}

		correctUVs();

		correctSeam();

	}

	function correctSeam() {

		// handle case when face straddles the seam, see #3269

		for ( var i = 0; i < uvBuffer.length; i += 6 ) {

			// uv data of a single face

			var x0 = uvBuffer[ i + 0 ];
			var x1 = uvBuffer[ i + 2 ];
			var x2 = uvBuffer[ i + 4 ];

			var max = Math.max( x0, x1, x2 );
			var min = Math.min( x0, x1, x2 );

			// 0.9 is somewhat arbitrary

			if ( max > 0.9 && min < 0.1 ) {

				if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
				if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
				if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

			}

		}

	}

	function pushVertex( vertex ) {

		vertexBuffer.push( vertex.x, vertex.y, vertex.z );

	}

	function getVertexByIndex( index, vertex ) {

		var stride = index * 3;

		vertex.x = vertices[ stride + 0 ];
		vertex.y = vertices[ stride + 1 ];
		vertex.z = vertices[ stride + 2 ];

	}

	function correctUVs() {

		var a = new Vector3();
		var b = new Vector3();
		var c = new Vector3();

		var centroid = new Vector3();

		var uvA = new Vector2();
		var uvB = new Vector2();
		var uvC = new Vector2();

		for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

			a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
			b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
			c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

			uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
			uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
			uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

			centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

			var azi = azimuth( centroid );

			correctUV( uvA, j + 0, a, azi );
			correctUV( uvB, j + 2, b, azi );
			correctUV( uvC, j + 4, c, azi );

		}

	}

	function correctUV( uv, stride, vector, azimuth ) {

		if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

			uvBuffer[ stride ] = uv.x - 1;

		}

		if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

			uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

		}

	}

	// Angle around the Y axis, counter-clockwise when looking from above.

	function azimuth( vector ) {

		return Math.atan2( vector.z, - vector.x );

	}


	// Angle above the XZ plane.

	function inclination( vector ) {

		return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

	}

}

PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 * @author Mugen87 / https://github.com/Mugen87
 */

// TetrahedronGeometry

function TetrahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'TetrahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;

// TetrahedronBufferGeometry

function TetrahedronBufferGeometry( radius, detail ) {

	var vertices = [
		1, 1, 1, 	- 1, - 1, 1, 	- 1, 1, - 1, 	1, - 1, - 1
	];

	var indices = [
		2, 1, 0, 	0, 3, 2,	1, 3, 0,	2, 3, 1
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'TetrahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 * @author Mugen87 / https://github.com/Mugen87
 */

// OctahedronGeometry

function OctahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'OctahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

OctahedronGeometry.prototype = Object.create( Geometry.prototype );
OctahedronGeometry.prototype.constructor = OctahedronGeometry;

// OctahedronBufferGeometry

function OctahedronBufferGeometry( radius, detail ) {

	var vertices = [
		1, 0, 0, 	- 1, 0, 0,	0, 1, 0,
		0, - 1, 0, 	0, 0, 1,	0, 0, - 1
	];

	var indices = [
		0, 2, 4,	0, 4, 3,	0, 3, 5,
		0, 5, 2,	1, 2, 5,	1, 5, 3,
		1, 3, 4,	1, 4, 2
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'OctahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 * @author Mugen87 / https://github.com/Mugen87
 */

// IcosahedronGeometry

function IcosahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'IcosahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;

// IcosahedronBufferGeometry

function IcosahedronBufferGeometry( radius, detail ) {

	var t = ( 1 + Math.sqrt( 5 ) ) / 2;

	var vertices = [
		- 1, t, 0, 	1, t, 0, 	- 1, - t, 0, 	1, - t, 0,
		 0, - 1, t, 	0, 1, t,	0, - 1, - t, 	0, 1, - t,
		 t, 0, - 1, 	t, 0, 1, 	- t, 0, - 1, 	- t, 0, 1
	];

	var indices = [
		 0, 11, 5, 	0, 5, 1, 	0, 1, 7, 	0, 7, 10, 	0, 10, 11,
		 1, 5, 9, 	5, 11, 4,	11, 10, 2,	10, 7, 6,	7, 1, 8,
		 3, 9, 4, 	3, 4, 2,	3, 2, 6,	3, 6, 8,	3, 8, 9,
		 4, 9, 5, 	2, 4, 11,	6, 2, 10,	8, 6, 7,	9, 8, 1
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'IcosahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;

/**
 * @author Abe Pazos / https://hamoid.com
 * @author Mugen87 / https://github.com/Mugen87
 */

// DodecahedronGeometry

function DodecahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'DodecahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;

// DodecahedronBufferGeometry

function DodecahedronBufferGeometry( radius, detail ) {

	var t = ( 1 + Math.sqrt( 5 ) ) / 2;
	var r = 1 / t;

	var vertices = [

		// (±1, ±1, ±1)
		- 1, - 1, - 1,	- 1, - 1, 1,
		- 1, 1, - 1, - 1, 1, 1,
		1, - 1, - 1, 1, - 1, 1,
		1, 1, - 1, 1, 1, 1,

		// (0, ±1/φ, ±φ)
		 0, - r, - t, 0, - r, t,
		 0, r, - t, 0, r, t,

		// (±1/φ, ±φ, 0)
		- r, - t, 0, - r, t, 0,
		 r, - t, 0, r, t, 0,

		// (±φ, 0, ±1/φ)
		- t, 0, - r, t, 0, - r,
		- t, 0, r, t, 0, r
	];

	var indices = [
		3, 11, 7, 	3, 7, 15, 	3, 15, 13,
		7, 19, 17, 	7, 17, 6, 	7, 6, 15,
		17, 4, 8, 	17, 8, 10, 	17, 10, 6,
		8, 0, 16, 	8, 16, 2, 	8, 2, 10,
		0, 12, 1, 	0, 1, 18, 	0, 18, 16,
		6, 10, 2, 	6, 2, 13, 	6, 13, 15,
		2, 16, 18, 	2, 18, 3, 	2, 3, 13,
		18, 1, 9, 	18, 9, 11, 	18, 11, 3,
		4, 14, 12, 	4, 12, 0, 	4, 0, 8,
		11, 9, 5, 	11, 5, 19, 	11, 19, 7,
		19, 5, 14, 	19, 14, 4, 	19, 4, 17,
		1, 12, 14, 	1, 14, 5, 	1, 5, 9
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'DodecahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;

/**
 * @author oosmoxiecode / https://github.com/oosmoxiecode
 * @author WestLangley / https://github.com/WestLangley
 * @author zz85 / https://github.com/zz85
 * @author miningold / https://github.com/miningold
 * @author jonobr1 / https://github.com/jonobr1
 * @author Mugen87 / https://github.com/Mugen87
 *
 */

// TubeGeometry

function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {

	Geometry.call( this );

	this.type = 'TubeGeometry';

	this.parameters = {
		path: path,
		tubularSegments: tubularSegments,
		radius: radius,
		radialSegments: radialSegments,
		closed: closed
	};

	if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );

	var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );

	// expose internals

	this.tangents = bufferGeometry.tangents;
	this.normals = bufferGeometry.normals;
	this.binormals = bufferGeometry.binormals;

	// create geometry

	this.fromBufferGeometry( bufferGeometry );
	this.mergeVertices();

}

TubeGeometry.prototype = Object.create( Geometry.prototype );
TubeGeometry.prototype.constructor = TubeGeometry;

// TubeBufferGeometry

function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {

	BufferGeometry.call( this );

	this.type = 'TubeBufferGeometry';

	this.parameters = {
		path: path,
		tubularSegments: tubularSegments,
		radius: radius,
		radialSegments: radialSegments,
		closed: closed
	};

	tubularSegments = tubularSegments || 64;
	radius = radius || 1;
	radialSegments = radialSegments || 8;
	closed = closed || false;

	var frames = path.computeFrenetFrames( tubularSegments, closed );

	// expose internals

	this.tangents = frames.tangents;
	this.normals = frames.normals;
	this.binormals = frames.binormals;

	// helper variables

	var vertex = new Vector3();
	var normal = new Vector3();
	var uv = new Vector2();
	var P = new Vector3();

	var i, j;

	// buffer

	var vertices = [];
	var normals = [];
	var uvs = [];
	var indices = [];

	// create buffer data

	generateBufferData();

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	// functions

	function generateBufferData() {

		for ( i = 0; i < tubularSegments; i ++ ) {

			generateSegment( i );

		}

		// if the geometry is not closed, generate the last row of vertices and normals
		// at the regular position on the given path
		//
		// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

		generateSegment( ( closed === false ) ? tubularSegments : 0 );

		// uvs are generated in a separate function.
		// this makes it easy compute correct values for closed geometries

		generateUVs();

		// finally create faces

		generateIndices();

	}

	function generateSegment( i ) {

		// we use getPointAt to sample evenly distributed points from the given path

		P = path.getPointAt( i / tubularSegments, P );

		// retrieve corresponding normal and binormal

		var N = frames.normals[ i ];
		var B = frames.binormals[ i ];

		// generate normals and vertices for the current segment

		for ( j = 0; j <= radialSegments; j ++ ) {

			var v = j / radialSegments * Math.PI * 2;

			var sin = Math.sin( v );
			var cos = - Math.cos( v );

			// normal

			normal.x = ( cos * N.x + sin * B.x );
			normal.y = ( cos * N.y + sin * B.y );
			normal.z = ( cos * N.z + sin * B.z );
			normal.normalize();

			normals.push( normal.x, normal.y, normal.z );

			// vertex

			vertex.x = P.x + radius * normal.x;
			vertex.y = P.y + radius * normal.y;
			vertex.z = P.z + radius * normal.z;

			vertices.push( vertex.x, vertex.y, vertex.z );

		}

	}

	function generateIndices() {

		for ( j = 1; j <= tubularSegments; j ++ ) {

			for ( i = 1; i <= radialSegments; i ++ ) {

				var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				var b = ( radialSegments + 1 ) * j + ( i - 1 );
				var c = ( radialSegments + 1 ) * j + i;
				var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

	}

	function generateUVs() {

		for ( i = 0; i <= tubularSegments; i ++ ) {

			for ( j = 0; j <= radialSegments; j ++ ) {

				uv.x = i / tubularSegments;
				uv.y = j / radialSegments;

				uvs.push( uv.x, uv.y );

			}

		}

	}

}

TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;

/**
 * @author oosmoxiecode
 * @author Mugen87 / https://github.com/Mugen87
 *
 * based on http://www.blackpawn.com/texts/pqtorus/
 */

// TorusKnotGeometry

function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {

	Geometry.call( this );

	this.type = 'TorusKnotGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		tubularSegments: tubularSegments,
		radialSegments: radialSegments,
		p: p,
		q: q
	};

	if ( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );

	this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
	this.mergeVertices();

}

TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;

// TorusKnotBufferGeometry

function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {

	BufferGeometry.call( this );

	this.type = 'TorusKnotBufferGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		tubularSegments: tubularSegments,
		radialSegments: radialSegments,
		p: p,
		q: q
	};

	radius = radius || 1;
	tube = tube || 0.4;
	tubularSegments = Math.floor( tubularSegments ) || 64;
	radialSegments = Math.floor( radialSegments ) || 8;
	p = p || 2;
	q = q || 3;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var i, j;

	var vertex = new Vector3();
	var normal = new Vector3();

	var P1 = new Vector3();
	var P2 = new Vector3();

	var B = new Vector3();
	var T = new Vector3();
	var N = new Vector3();

	// generate vertices, normals and uvs

	for ( i = 0; i <= tubularSegments; ++ i ) {

		// the radian "u" is used to calculate the position on the torus curve of the current tubular segement

		var u = i / tubularSegments * p * Math.PI * 2;

		// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
		// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

		calculatePositionOnCurve( u, p, q, radius, P1 );
		calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

		// calculate orthonormal basis

		T.subVectors( P2, P1 );
		N.addVectors( P2, P1 );
		B.crossVectors( T, N );
		N.crossVectors( B, T );

		// normalize B, N. T can be ignored, we don't use it

		B.normalize();
		N.normalize();

		for ( j = 0; j <= radialSegments; ++ j ) {

			// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
			// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

			var v = j / radialSegments * Math.PI * 2;
			var cx = - tube * Math.cos( v );
			var cy = tube * Math.sin( v );

			// now calculate the final vertex position.
			// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve

			vertex.x = P1.x + ( cx * N.x + cy * B.x );
			vertex.y = P1.y + ( cx * N.y + cy * B.y );
			vertex.z = P1.z + ( cx * N.z + cy * B.z );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)

			normal.subVectors( vertex, P1 ).normalize();

			normals.push( normal.x, normal.y, normal.z );

			// uv

			uvs.push( i / tubularSegments );
			uvs.push( j / radialSegments );

		}

	}

	// generate indices

	for ( j = 1; j <= tubularSegments; j ++ ) {

		for ( i = 1; i <= radialSegments; i ++ ) {

			// indices

			var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
			var b = ( radialSegments + 1 ) * j + ( i - 1 );
			var c = ( radialSegments + 1 ) * j + i;
			var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

			// faces

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	// this function calculates the current position on the torus curve

	function calculatePositionOnCurve( u, p, q, radius, position ) {

		var cu = Math.cos( u );
		var su = Math.sin( u );
		var quOverP = q / p * u;
		var cs = Math.cos( quOverP );

		position.x = radius * ( 2 + cs ) * 0.5 * cu;
		position.y = radius * ( 2 + cs ) * su * 0.5;
		position.z = radius * Math.sin( quOverP ) * 0.5;

	}

}

TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;

/**
 * @author oosmoxiecode
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

// TorusGeometry

function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

	Geometry.call( this );

	this.type = 'TorusGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		radialSegments: radialSegments,
		tubularSegments: tubularSegments,
		arc: arc
	};

	this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );
	this.mergeVertices();

}

TorusGeometry.prototype = Object.create( Geometry.prototype );
TorusGeometry.prototype.constructor = TorusGeometry;

// TorusBufferGeometry

function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

	BufferGeometry.call( this );

	this.type = 'TorusBufferGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		radialSegments: radialSegments,
		tubularSegments: tubularSegments,
		arc: arc
	};

	radius = radius || 1;
	tube = tube || 0.4;
	radialSegments = Math.floor( radialSegments ) || 8;
	tubularSegments = Math.floor( tubularSegments ) || 6;
	arc = arc || Math.PI * 2;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var center = new Vector3();
	var vertex = new Vector3();
	var normal = new Vector3();

	var j, i;

	// generate vertices, normals and uvs

	for ( j = 0; j <= radialSegments; j ++ ) {

		for ( i = 0; i <= tubularSegments; i ++ ) {

			var u = i / tubularSegments * arc;
			var v = j / radialSegments * Math.PI * 2;

			// vertex

			vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
			vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
			vertex.z = tube * Math.sin( v );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			center.x = radius * Math.cos( u );
			center.y = radius * Math.sin( u );
			normal.subVectors( vertex, center ).normalize();

			normals.push( normal.x, normal.y, normal.z );

			// uv

			uvs.push( i / tubularSegments );
			uvs.push( j / radialSegments );

		}

	}

	// generate indices

	for ( j = 1; j <= radialSegments; j ++ ) {

		for ( i = 1; i <= tubularSegments; i ++ ) {

			// indices

			var a = ( tubularSegments + 1 ) * j + i - 1;
			var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
			var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
			var d = ( tubularSegments + 1 ) * j + i;

			// faces

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 * Port from https://github.com/mapbox/earcut (v2.1.2)
 */

var Earcut = {

	triangulate: function ( data, holeIndices, dim ) {

		dim = dim || 2;

		var hasHoles = holeIndices && holeIndices.length,
			outerLen = hasHoles ? holeIndices[ 0 ] * dim : data.length,
			outerNode = linkedList( data, 0, outerLen, dim, true ),
			triangles = [];

		if ( ! outerNode ) return triangles;

		var minX, minY, maxX, maxY, x, y, invSize;

		if ( hasHoles ) outerNode = eliminateHoles( data, holeIndices, outerNode, dim );

		// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox

		if ( data.length > 80 * dim ) {

			minX = maxX = data[ 0 ];
			minY = maxY = data[ 1 ];

			for ( var i = dim; i < outerLen; i += dim ) {

				x = data[ i ];
				y = data[ i + 1 ];
				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;

			}

			// minX, minY and invSize are later used to transform coords into integers for z-order calculation

			invSize = Math.max( maxX - minX, maxY - minY );
			invSize = invSize !== 0 ? 1 / invSize : 0;

		}

		earcutLinked( outerNode, triangles, dim, minX, minY, invSize );

		return triangles;

	}

};

// create a circular doubly linked list from polygon points in the specified winding order

function linkedList( data, start, end, dim, clockwise ) {

	var i, last;

	if ( clockwise === ( signedArea( data, start, end, dim ) > 0 ) ) {

		for ( i = start; i < end; i += dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	} else {

		for ( i = end - dim; i >= start; i -= dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	}

	if ( last && equals( last, last.next ) ) {

		removeNode( last );
		last = last.next;

	}

	return last;

}

// eliminate colinear or duplicate points

function filterPoints( start, end ) {

	if ( ! start ) return start;
	if ( ! end ) end = start;

	var p = start, again;

	do {

		again = false;

		if ( ! p.steiner && ( equals( p, p.next ) || area( p.prev, p, p.next ) === 0 ) ) {

			removeNode( p );
			p = end = p.prev;
			if ( p === p.next ) break;
			again = true;

		} else {

			p = p.next;

		}

	} while ( again || p !== end );

	return end;

}

// main ear slicing loop which triangulates a polygon (given as a linked list)

function earcutLinked( ear, triangles, dim, minX, minY, invSize, pass ) {

	if ( ! ear ) return;

	// interlink polygon nodes in z-order

	if ( ! pass && invSize ) indexCurve( ear, minX, minY, invSize );

	var stop = ear, prev, next;

	// iterate through ears, slicing them one by one

	while ( ear.prev !== ear.next ) {

		prev = ear.prev;
		next = ear.next;

		if ( invSize ? isEarHashed( ear, minX, minY, invSize ) : isEar( ear ) ) {

			// cut off the triangle
			triangles.push( prev.i / dim );
			triangles.push( ear.i / dim );
			triangles.push( next.i / dim );

			removeNode( ear );

			// skipping the next vertice leads to less sliver triangles
			ear = next.next;
			stop = next.next;

			continue;

		}

		ear = next;

		// if we looped through the whole remaining polygon and can't find any more ears

		if ( ear === stop ) {

			// try filtering points and slicing again

			if ( ! pass ) {

				earcutLinked( filterPoints( ear ), triangles, dim, minX, minY, invSize, 1 );

				// if this didn't work, try curing all small self-intersections locally

			} else if ( pass === 1 ) {

				ear = cureLocalIntersections( ear, triangles, dim );
				earcutLinked( ear, triangles, dim, minX, minY, invSize, 2 );

			// as a last resort, try splitting the remaining polygon into two

			} else if ( pass === 2 ) {

				splitEarcut( ear, triangles, dim, minX, minY, invSize );

			}

			break;

		}

	}

}

// check whether a polygon node forms a valid ear with adjacent nodes

function isEar( ear ) {

	var a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	// now make sure we don't have other points inside the potential ear
	var p = ear.next.next;

	while ( p !== ear.prev ) {

		if ( pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) {

			return false;

		}

		p = p.next;

	}

	return true;

}

function isEarHashed( ear, minX, minY, invSize ) {

	var a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	// triangle bbox; min & max are calculated like this for speed

	var minTX = a.x < b.x ? ( a.x < c.x ? a.x : c.x ) : ( b.x < c.x ? b.x : c.x ),
		minTY = a.y < b.y ? ( a.y < c.y ? a.y : c.y ) : ( b.y < c.y ? b.y : c.y ),
		maxTX = a.x > b.x ? ( a.x > c.x ? a.x : c.x ) : ( b.x > c.x ? b.x : c.x ),
		maxTY = a.y > b.y ? ( a.y > c.y ? a.y : c.y ) : ( b.y > c.y ? b.y : c.y );

	// z-order range for the current triangle bbox;

	var minZ = zOrder( minTX, minTY, minX, minY, invSize ),
		maxZ = zOrder( maxTX, maxTY, minX, minY, invSize );

	// first look for points inside the triangle in increasing z-order

	var p = ear.nextZ;

	while ( p && p.z <= maxZ ) {

		if ( p !== ear.prev && p !== ear.next &&
				pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) &&
				area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.nextZ;

	}

	// then look for points in decreasing z-order

	p = ear.prevZ;

	while ( p && p.z >= minZ ) {

		if ( p !== ear.prev && p !== ear.next &&
				pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) &&
				area( p.prev, p, p.next ) >= 0 ) return false;

		p = p.prevZ;

	}

	return true;

}

// go through all polygon nodes and cure small local self-intersections

function cureLocalIntersections( start, triangles, dim ) {

	var p = start;

	do {

		var a = p.prev, b = p.next.next;

		if ( ! equals( a, b ) && intersects( a, p, p.next, b ) && locallyInside( a, b ) && locallyInside( b, a ) ) {

			triangles.push( a.i / dim );
			triangles.push( p.i / dim );
			triangles.push( b.i / dim );

			// remove two nodes involved

			removeNode( p );
			removeNode( p.next );

			p = start = b;

		}

		p = p.next;

	} while ( p !== start );

	return p;

}

// try splitting polygon into two and triangulate them independently

function splitEarcut( start, triangles, dim, minX, minY, invSize ) {

	// look for a valid diagonal that divides the polygon into two

	var a = start;

	do {

		var b = a.next.next;

		while ( b !== a.prev ) {

			if ( a.i !== b.i && isValidDiagonal( a, b ) ) {

				// split the polygon in two by the diagonal

				var c = splitPolygon( a, b );

				// filter colinear points around the cuts

				a = filterPoints( a, a.next );
				c = filterPoints( c, c.next );

				// run earcut on each half

				earcutLinked( a, triangles, dim, minX, minY, invSize );
				earcutLinked( c, triangles, dim, minX, minY, invSize );
				return;

			}

			b = b.next;

		}

		a = a.next;

	} while ( a !== start );

}

// link every hole into the outer loop, producing a single-ring polygon without holes

function eliminateHoles( data, holeIndices, outerNode, dim ) {

	var queue = [], i, len, start, end, list;

	for ( i = 0, len = holeIndices.length; i < len; i ++ ) {

		start = holeIndices[ i ] * dim;
		end = i < len - 1 ? holeIndices[ i + 1 ] * dim : data.length;
		list = linkedList( data, start, end, dim, false );
		if ( list === list.next ) list.steiner = true;
		queue.push( getLeftmost( list ) );

	}

	queue.sort( compareX );

	// process holes from left to right

	for ( i = 0; i < queue.length; i ++ ) {

		eliminateHole( queue[ i ], outerNode );
		outerNode = filterPoints( outerNode, outerNode.next );

	}

	return outerNode;

}

function compareX( a, b ) {

	return a.x - b.x;

}

// find a bridge between vertices that connects hole with an outer ring and and link it

function eliminateHole( hole, outerNode ) {

	outerNode = findHoleBridge( hole, outerNode );

	if ( outerNode ) {

		var b = splitPolygon( outerNode, hole );

		filterPoints( b, b.next );

	}

}

// David Eberly's algorithm for finding a bridge between hole and outer polygon

function findHoleBridge( hole, outerNode ) {

	var p = outerNode,
		hx = hole.x,
		hy = hole.y,
		qx = - Infinity,
		m;

	// find a segment intersected by a ray from the hole's leftmost point to the left;
	// segment's endpoint with lesser x will be potential connection point

	do {

		if ( hy <= p.y && hy >= p.next.y && p.next.y !== p.y ) {

			var x = p.x + ( hy - p.y ) * ( p.next.x - p.x ) / ( p.next.y - p.y );

			if ( x <= hx && x > qx ) {

				qx = x;

				if ( x === hx ) {

					if ( hy === p.y ) return p;
					if ( hy === p.next.y ) return p.next;

				}

				m = p.x < p.next.x ? p : p.next;

			}

		}

		p = p.next;

	} while ( p !== outerNode );

	if ( ! m ) return null;

	if ( hx === qx ) return m.prev; // hole touches outer segment; pick lower endpoint

	// look for points inside the triangle of hole point, segment intersection and endpoint;
	// if there are no points found, we have a valid connection;
	// otherwise choose the point of the minimum angle with the ray as connection point

	var stop = m,
		mx = m.x,
		my = m.y,
		tanMin = Infinity,
		tan;

	p = m.next;

	while ( p !== stop ) {

		if ( hx >= p.x && p.x >= mx && hx !== p.x &&
						pointInTriangle( hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y ) ) {

			tan = Math.abs( hy - p.y ) / ( hx - p.x ); // tangential

			if ( ( tan < tanMin || ( tan === tanMin && p.x > m.x ) ) && locallyInside( p, hole ) ) {

				m = p;
				tanMin = tan;

			}

		}

		p = p.next;

	}

	return m;

}

// interlink polygon nodes in z-order

function indexCurve( start, minX, minY, invSize ) {

	var p = start;

	do {

		if ( p.z === null ) p.z = zOrder( p.x, p.y, minX, minY, invSize );
		p.prevZ = p.prev;
		p.nextZ = p.next;
		p = p.next;

	} while ( p !== start );

	p.prevZ.nextZ = null;
	p.prevZ = null;

	sortLinked( p );

}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html

function sortLinked( list ) {

	var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;

	do {

		p = list;
		list = null;
		tail = null;
		numMerges = 0;

		while ( p ) {

			numMerges ++;
			q = p;
			pSize = 0;

			for ( i = 0; i < inSize; i ++ ) {

				pSize ++;
				q = q.nextZ;
				if ( ! q ) break;

			}

			qSize = inSize;

			while ( pSize > 0 || ( qSize > 0 && q ) ) {

				if ( pSize !== 0 && ( qSize === 0 || ! q || p.z <= q.z ) ) {

					e = p;
					p = p.nextZ;
					pSize --;

				} else {

					e = q;
					q = q.nextZ;
					qSize --;

				}

				if ( tail ) tail.nextZ = e;
				else list = e;

				e.prevZ = tail;
				tail = e;

			}

			p = q;

		}

		tail.nextZ = null;
		inSize *= 2;

	} while ( numMerges > 1 );

	return list;

}

// z-order of a point given coords and inverse of the longer side of data bbox

function zOrder( x, y, minX, minY, invSize ) {

	// coords are transformed into non-negative 15-bit integer range

	x = 32767 * ( x - minX ) * invSize;
	y = 32767 * ( y - minY ) * invSize;

	x = ( x | ( x << 8 ) ) & 0x00FF00FF;
	x = ( x | ( x << 4 ) ) & 0x0F0F0F0F;
	x = ( x | ( x << 2 ) ) & 0x33333333;
	x = ( x | ( x << 1 ) ) & 0x55555555;

	y = ( y | ( y << 8 ) ) & 0x00FF00FF;
	y = ( y | ( y << 4 ) ) & 0x0F0F0F0F;
	y = ( y | ( y << 2 ) ) & 0x33333333;
	y = ( y | ( y << 1 ) ) & 0x55555555;

	return x | ( y << 1 );

}

// find the leftmost node of a polygon ring

function getLeftmost( start ) {

	var p = start, leftmost = start;

	do {

		if ( p.x < leftmost.x ) leftmost = p;
		p = p.next;

	} while ( p !== start );

	return leftmost;

}

// check if a point lies within a convex triangle

function pointInTriangle( ax, ay, bx, by, cx, cy, px, py ) {

	return ( cx - px ) * ( ay - py ) - ( ax - px ) * ( cy - py ) >= 0 &&
	 ( ax - px ) * ( by - py ) - ( bx - px ) * ( ay - py ) >= 0 &&
	 ( bx - px ) * ( cy - py ) - ( cx - px ) * ( by - py ) >= 0;

}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)

function isValidDiagonal( a, b ) {

	return a.next.i !== b.i && a.prev.i !== b.i && ! intersectsPolygon( a, b ) &&
		locallyInside( a, b ) && locallyInside( b, a ) && middleInside( a, b );

}

// signed area of a triangle

function area( p, q, r ) {

	return ( q.y - p.y ) * ( r.x - q.x ) - ( q.x - p.x ) * ( r.y - q.y );

}

// check if two points are equal

function equals( p1, p2 ) {

	return p1.x === p2.x && p1.y === p2.y;

}

// check if two segments intersect

function intersects( p1, q1, p2, q2 ) {

	if ( ( equals( p1, q1 ) && equals( p2, q2 ) ) ||
			( equals( p1, q2 ) && equals( p2, q1 ) ) ) return true;

	return area( p1, q1, p2 ) > 0 !== area( p1, q1, q2 ) > 0 &&
				 area( p2, q2, p1 ) > 0 !== area( p2, q2, q1 ) > 0;

}

// check if a polygon diagonal intersects any polygon segments

function intersectsPolygon( a, b ) {

	var p = a;

	do {

		if ( p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
						intersects( p, p.next, a, b ) ) {

			return true;

		}

		p = p.next;

	} while ( p !== a );

	return false;

}

// check if a polygon diagonal is locally inside the polygon

function locallyInside( a, b ) {

	return area( a.prev, a, a.next ) < 0 ?
		area( a, b, a.next ) >= 0 && area( a, a.prev, b ) >= 0 :
		area( a, b, a.prev ) < 0 || area( a, a.next, b ) < 0;

}

// check if the middle point of a polygon diagonal is inside the polygon

function middleInside( a, b ) {

	var p = a,
		inside = false,
		px = ( a.x + b.x ) / 2,
		py = ( a.y + b.y ) / 2;

	do {

		if ( ( ( p.y > py ) !== ( p.next.y > py ) ) && p.next.y !== p.y &&
						( px < ( p.next.x - p.x ) * ( py - p.y ) / ( p.next.y - p.y ) + p.x ) ) {

			inside = ! inside;

		}

		p = p.next;

	} while ( p !== a );

	return inside;

}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring

function splitPolygon( a, b ) {

	var a2 = new Node( a.i, a.x, a.y ),
		b2 = new Node( b.i, b.x, b.y ),
		an = a.next,
		bp = b.prev;

	a.next = b;
	b.prev = a;

	a2.next = an;
	an.prev = a2;

	b2.next = a2;
	a2.prev = b2;

	bp.next = b2;
	b2.prev = bp;

	return b2;

}

// create a node and optionally link it with previous one (in a circular doubly linked list)

function insertNode( i, x, y, last ) {

	var p = new Node( i, x, y );

	if ( ! last ) {

		p.prev = p;
		p.next = p;

	} else {

		p.next = last.next;
		p.prev = last;
		last.next.prev = p;
		last.next = p;

	}

	return p;

}

function removeNode( p ) {

	p.next.prev = p.prev;
	p.prev.next = p.next;

	if ( p.prevZ ) p.prevZ.nextZ = p.nextZ;
	if ( p.nextZ ) p.nextZ.prevZ = p.prevZ;

}

function Node( i, x, y ) {

	// vertice index in coordinates array
	this.i = i;

	// vertex coordinates
	this.x = x;
	this.y = y;

	// previous and next vertice nodes in a polygon ring
	this.prev = null;
	this.next = null;

	// z-order curve value
	this.z = null;

	// previous and next nodes in z-order
	this.prevZ = null;
	this.nextZ = null;

	// indicates whether this is a steiner point
	this.steiner = false;

}

function signedArea( data, start, end, dim ) {

	var sum = 0;

	for ( var i = start, j = end - dim; i < end; i += dim ) {

		sum += ( data[ j ] - data[ i ] ) * ( data[ i + 1 ] + data[ j + 1 ] );
		j = i;

	}

	return sum;

}

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

var ShapeUtils = {

	// calculate area of the contour polygon

	area: function ( contour ) {

		var n = contour.length;
		var a = 0.0;

		for ( var p = n - 1, q = 0; q < n; p = q ++ ) {

			a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

		}

		return a * 0.5;

	},

	isClockWise: function ( pts ) {

		return ShapeUtils.area( pts ) < 0;

	},

	triangulateShape: function ( contour, holes ) {

		function removeDupEndPts( points ) {

			var l = points.length;

			if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

				points.pop();

			}

		}

		function addContour( vertices, contour ) {

			for ( var i = 0; i < contour.length; i ++ ) {

				vertices.push( contour[ i ].x );
				vertices.push( contour[ i ].y );

			}

		}

		var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
		var holeIndices = []; // array of hole indices
		var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]

		removeDupEndPts( contour );
		addContour( vertices, contour );

		//

		var holeIndex = contour.length;
		holes.forEach( removeDupEndPts );

		for ( i = 0; i < holes.length; i ++ ) {

			holeIndices.push( holeIndex );
			holeIndex += holes[ i ].length;
			addContour( vertices, holes[ i ] );

		}

		//

		var triangles = Earcut.triangulate( vertices, holeIndices );

		//

		for ( var i = 0; i < triangles.length; i += 3 ) {

			faces.push( triangles.slice( i, i + 3 ) );

		}

		return faces;

	}

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 *
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  amount: <int>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline is bevel
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *  frames: <Object> // containing arrays of tangents, normals, binormals
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */

// ExtrudeGeometry

function ExtrudeGeometry( shapes, options ) {

	Geometry.call( this );

	this.type = 'ExtrudeGeometry';

	this.parameters = {
		shapes: shapes,
		options: options
	};

	this.fromBufferGeometry( new ExtrudeBufferGeometry( shapes, options ) );
	this.mergeVertices();

}

ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;

// ExtrudeBufferGeometry

function ExtrudeBufferGeometry( shapes, options ) {

	if ( typeof ( shapes ) === "undefined" ) {

		return;

	}

	BufferGeometry.call( this );

	this.type = 'ExtrudeBufferGeometry';

	shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

	this.addShapeList( shapes, options );

	this.computeVertexNormals();

	// can't really use automatic vertex normals
	// as then front and back sides get smoothed too
	// should do separate smoothing just for sides

	//this.computeVertexNormals();

	//console.log( "took", ( Date.now() - startTime ) );

}

ExtrudeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
ExtrudeBufferGeometry.prototype.constructor = ExtrudeBufferGeometry;

ExtrudeBufferGeometry.prototype.getArrays = function () {

	var positionAttribute = this.getAttribute( "position" );
	var verticesArray = positionAttribute ? Array.prototype.slice.call( positionAttribute.array ) : [];

	var uvAttribute = this.getAttribute( "uv" );
	var uvArray = uvAttribute ? Array.prototype.slice.call( uvAttribute.array ) : [];

	var IndexAttribute = this.index;
	var indicesArray = IndexAttribute ? Array.prototype.slice.call( IndexAttribute.array ) : [];

	return {
		position: verticesArray,
		uv: uvArray,
		index: indicesArray
	};

};

ExtrudeBufferGeometry.prototype.addShapeList = function ( shapes, options ) {

	var sl = shapes.length;
	options.arrays = this.getArrays();

	for ( var s = 0; s < sl; s ++ ) {

		var shape = shapes[ s ];
		this.addShape( shape, options );

	}

	this.setIndex( options.arrays.index );
	this.addAttribute( 'position', new Float32BufferAttribute( options.arrays.position, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );

};

ExtrudeBufferGeometry.prototype.addShape = function ( shape, options ) {

	var arrays = options.arrays ? options.arrays : this.getArrays();
	var verticesArray = arrays.position;
	var indicesArray = arrays.index;
	var uvArray = arrays.uv;

	var placeholder = [];


	var amount = options.amount !== undefined ? options.amount : 100;

	var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
	var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
	var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

	var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false

	var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;

	var steps = options.steps !== undefined ? options.steps : 1;

	var extrudePath = options.extrudePath;
	var extrudePts, extrudeByPath = false;

	// Use default WorldUVGenerator if no UV generators are specified.
	var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;

	var splineTube, binormal, normal, position2;
	if ( extrudePath ) {

		extrudePts = extrudePath.getSpacedPoints( steps );

		extrudeByPath = true;
		bevelEnabled = false; // bevels not supported for path extrusion

		// SETUP TNB variables

		// TODO1 - have a .isClosed in spline?

		splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );

		// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

		binormal = new Vector3();
		normal = new Vector3();
		position2 = new Vector3();

	}

	// Safeguards if bevels are not enabled

	if ( ! bevelEnabled ) {

		bevelSegments = 0;
		bevelThickness = 0;
		bevelSize = 0;

	}

	// Variables initialization

	var ahole, h, hl; // looping of holes
	var scope = this;

	var shapePoints = shape.extractPoints( curveSegments );

	var vertices = shapePoints.shape;
	var holes = shapePoints.holes;

	var reverse = ! ShapeUtils.isClockWise( vertices );

	if ( reverse ) {

		vertices = vertices.reverse();

		// Maybe we should also check if holes are in the opposite direction, just to be safe ...

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			if ( ShapeUtils.isClockWise( ahole ) ) {

				holes[ h ] = ahole.reverse();

			}

		}

	}


	var faces = ShapeUtils.triangulateShape( vertices, holes );

	/* Vertices */

	var contour = vertices; // vertices has all points but contour has only points of circumference

	for ( h = 0, hl = holes.length; h < hl; h ++ ) {

		ahole = holes[ h ];

		vertices = vertices.concat( ahole );

	}


	function scalePt2( pt, vec, size ) {

		if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );

		return vec.clone().multiplyScalar( size ).add( pt );

	}

	var b, bs, t, z,
		vert, vlen = vertices.length,
		face, flen = faces.length;


	// Find directions for point movement


	function getBevelVec( inPt, inPrev, inNext ) {

		// computes for inPt the corresponding point inPt' on a new contour
		//   shifted by 1 unit (length of normalized vector) to the left
		// if we walk along contour clockwise, this new contour is outside the old one
		//
		// inPt' is the intersection of the two lines parallel to the two
		//  adjacent edges of inPt at a distance of 1 unit on the left side.

		var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt

		// good reading for geometry algorithms (here: line-line intersection)
		// http://geomalgorithms.com/a05-_intersect-1.html

		var v_prev_x = inPt.x - inPrev.x,
			v_prev_y = inPt.y - inPrev.y;
		var v_next_x = inNext.x - inPt.x,
			v_next_y = inNext.y - inPt.y;

		var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

		// check for collinear edges
		var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

		if ( Math.abs( collinear0 ) > Number.EPSILON ) {

			// not collinear

			// length of vectors for normalizing

			var v_prev_len = Math.sqrt( v_prev_lensq );
			var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

			// shift adjacent points by unit vectors to the left

			var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
			var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

			var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
			var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

			// scaling factor for v_prev to intersection point

			var sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
					( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
				( v_prev_x * v_next_y - v_prev_y * v_next_x );

			// vector from inPt to intersection point

			v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
			v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

			// Don't normalize!, otherwise sharp corners become ugly
			//  but prevent crazy spikes
			var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
			if ( v_trans_lensq <= 2 ) {

				return new Vector2( v_trans_x, v_trans_y );

			} else {

				shrink_by = Math.sqrt( v_trans_lensq / 2 );

			}

		} else {

			// handle special case of collinear edges

			var direction_eq = false; // assumes: opposite
			if ( v_prev_x > Number.EPSILON ) {

				if ( v_next_x > Number.EPSILON ) {

					direction_eq = true;

				}

			} else {

				if ( v_prev_x < - Number.EPSILON ) {

					if ( v_next_x < - Number.EPSILON ) {

						direction_eq = true;

					}

				} else {

					if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

						direction_eq = true;

					}

				}

			}

			if ( direction_eq ) {

				// console.log("Warning: lines are a straight sequence");
				v_trans_x = - v_prev_y;
				v_trans_y = v_prev_x;
				shrink_by = Math.sqrt( v_prev_lensq );

			} else {

				// console.log("Warning: lines are a straight spike");
				v_trans_x = v_prev_x;
				v_trans_y = v_prev_y;
				shrink_by = Math.sqrt( v_prev_lensq / 2 );

			}

		}

		return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

	}


	var contourMovements = [];

	for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

		if ( j === il ) j = 0;
		if ( k === il ) k = 0;

		//  (j)---(i)---(k)
		// console.log('i,j,k', i, j , k)

		contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

	}

	var holesMovements = [],
		oneHoleMovements, verticesMovements = contourMovements.concat();

	for ( h = 0, hl = holes.length; h < hl; h ++ ) {

		ahole = holes[ h ];

		oneHoleMovements = [];

		for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

			if ( j === il ) j = 0;
			if ( k === il ) k = 0;

			//  (j)---(i)---(k)
			oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

		}

		holesMovements.push( oneHoleMovements );
		verticesMovements = verticesMovements.concat( oneHoleMovements );

	}


	// Loop bevelSegments, 1 for the front, 1 for the back

	for ( b = 0; b < bevelSegments; b ++ ) {

		//for ( b = bevelSegments; b > 0; b -- ) {

		t = b / bevelSegments;
		z = bevelThickness * Math.cos( t * Math.PI / 2 );
		bs = bevelSize * Math.sin( t * Math.PI / 2 );

		// contract shape

		for ( i = 0, il = contour.length; i < il; i ++ ) {

			vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

			v( vert.x, vert.y, - z );

		}

		// expand holes

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			oneHoleMovements = holesMovements[ h ];

			for ( i = 0, il = ahole.length; i < il; i ++ ) {

				vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

				v( vert.x, vert.y, - z );

			}

		}

	}

	bs = bevelSize;

	// Back facing vertices

	for ( i = 0; i < vlen; i ++ ) {

		vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

		if ( ! extrudeByPath ) {

			v( vert.x, vert.y, 0 );

		} else {

			// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

			normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
			binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

			position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

			v( position2.x, position2.y, position2.z );

		}

	}

	// Add stepped vertices...
	// Including front facing vertices

	var s;

	for ( s = 1; s <= steps; s ++ ) {

		for ( i = 0; i < vlen; i ++ ) {

			vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

			if ( ! extrudeByPath ) {

				v( vert.x, vert.y, amount / steps * s );

			} else {

				// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

				normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
				binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

				position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

				v( position2.x, position2.y, position2.z );

			}

		}

	}


	// Add bevel segments planes

	//for ( b = 1; b <= bevelSegments; b ++ ) {
	for ( b = bevelSegments - 1; b >= 0; b -- ) {

		t = b / bevelSegments;
		z = bevelThickness * Math.cos( t * Math.PI / 2 );
		bs = bevelSize * Math.sin( t * Math.PI / 2 );

		// contract shape

		for ( i = 0, il = contour.length; i < il; i ++ ) {

			vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
			v( vert.x, vert.y, amount + z );

		}

		// expand holes

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			oneHoleMovements = holesMovements[ h ];

			for ( i = 0, il = ahole.length; i < il; i ++ ) {

				vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y, amount + z );

				} else {

					v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

				}

			}

		}

	}

	/* Faces */

	// Top and bottom faces

	buildLidFaces();

	// Sides faces

	buildSideFaces();


	/////  Internal functions

	function buildLidFaces() {

		var start = verticesArray.length / 3;

		if ( bevelEnabled ) {

			var layer = 0; // steps + 1
			var offset = vlen * layer;

			// Bottom faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

			}

			layer = steps + bevelSegments * 2;
			offset = vlen * layer;

			// Top faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

			}

		} else {

			// Bottom faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 2 ], face[ 1 ], face[ 0 ] );

			}

			// Top faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

			}

		}

		scope.addGroup( start, verticesArray.length / 3 - start, options.material !== undefined ? options.material : 0 );

	}

	// Create faces for the z-sides of the shape

	function buildSideFaces() {

		var start = verticesArray.length / 3;
		var layeroffset = 0;
		sidewalls( contour, layeroffset );
		layeroffset += contour.length;

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			sidewalls( ahole, layeroffset );

			//, true
			layeroffset += ahole.length;

		}


		scope.addGroup( start, verticesArray.length / 3 - start, options.extrudeMaterial !== undefined ? options.extrudeMaterial : 1 );


	}

	function sidewalls( contour, layeroffset ) {

		var j, k;
		i = contour.length;

		while ( -- i >= 0 ) {

			j = i;
			k = i - 1;
			if ( k < 0 ) k = contour.length - 1;

			//console.log('b', i,j, i-1, k,vertices.length);

			var s = 0,
				sl = steps + bevelSegments * 2;

			for ( s = 0; s < sl; s ++ ) {

				var slen1 = vlen * s;
				var slen2 = vlen * ( s + 1 );

				var a = layeroffset + j + slen1,
					b = layeroffset + k + slen1,
					c = layeroffset + k + slen2,
					d = layeroffset + j + slen2;

				f4( a, b, c, d );

			}

		}

	}

	function v( x, y, z ) {

		placeholder.push( x );
		placeholder.push( y );
		placeholder.push( z );

	}


	function f3( a, b, c ) {

		addVertex( a );
		addVertex( b );
		addVertex( c );

		var nextIndex = verticesArray.length / 3;
		var uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

		addUV( uvs[ 0 ] );
		addUV( uvs[ 1 ] );
		addUV( uvs[ 2 ] );

	}

	function f4( a, b, c, d ) {

		addVertex( a );
		addVertex( b );
		addVertex( d );

		addVertex( b );
		addVertex( c );
		addVertex( d );


		var nextIndex = verticesArray.length / 3;
		var uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

		addUV( uvs[ 0 ] );
		addUV( uvs[ 1 ] );
		addUV( uvs[ 3 ] );

		addUV( uvs[ 1 ] );
		addUV( uvs[ 2 ] );
		addUV( uvs[ 3 ] );

	}

	function addVertex( index ) {

		indicesArray.push( verticesArray.length / 3 );
		verticesArray.push( placeholder[ index * 3 + 0 ] );
		verticesArray.push( placeholder[ index * 3 + 1 ] );
		verticesArray.push( placeholder[ index * 3 + 2 ] );

	}


	function addUV( vector2 ) {

		uvArray.push( vector2.x );
		uvArray.push( vector2.y );

	}

	if ( ! options.arrays ) {

		this.setIndex( indicesArray );
		this.addAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvArray, 2 ) );

	}

};

ExtrudeGeometry.WorldUVGenerator = {

	generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {

		var a_x = vertices[ indexA * 3 ];
		var a_y = vertices[ indexA * 3 + 1 ];
		var b_x = vertices[ indexB * 3 ];
		var b_y = vertices[ indexB * 3 + 1 ];
		var c_x = vertices[ indexC * 3 ];
		var c_y = vertices[ indexC * 3 + 1 ];

		return [
			new Vector2( a_x, a_y ),
			new Vector2( b_x, b_y ),
			new Vector2( c_x, c_y )
		];

	},

	generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {

		var a_x = vertices[ indexA * 3 ];
		var a_y = vertices[ indexA * 3 + 1 ];
		var a_z = vertices[ indexA * 3 + 2 ];
		var b_x = vertices[ indexB * 3 ];
		var b_y = vertices[ indexB * 3 + 1 ];
		var b_z = vertices[ indexB * 3 + 2 ];
		var c_x = vertices[ indexC * 3 ];
		var c_y = vertices[ indexC * 3 + 1 ];
		var c_z = vertices[ indexC * 3 + 2 ];
		var d_x = vertices[ indexD * 3 ];
		var d_y = vertices[ indexD * 3 + 1 ];
		var d_z = vertices[ indexD * 3 + 2 ];

		if ( Math.abs( a_y - b_y ) < 0.01 ) {

			return [
				new Vector2( a_x, 1 - a_z ),
				new Vector2( b_x, 1 - b_z ),
				new Vector2( c_x, 1 - c_z ),
				new Vector2( d_x, 1 - d_z )
			];

		} else {

			return [
				new Vector2( a_y, 1 - a_z ),
				new Vector2( b_y, 1 - b_z ),
				new Vector2( c_y, 1 - c_z ),
				new Vector2( d_y, 1 - d_z )
			];

		}

	}
};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author alteredq / http://alteredqualia.com/
 *
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float> // how far from text outline is bevel
 * }
 */

// TextGeometry

function TextGeometry( text, parameters ) {

	Geometry.call( this );

	this.type = 'TextGeometry';

	this.parameters = {
		text: text,
		parameters: parameters
	};

	this.fromBufferGeometry( new TextBufferGeometry( text, parameters ) );
	this.mergeVertices();

}

TextGeometry.prototype = Object.create( Geometry.prototype );
TextGeometry.prototype.constructor = TextGeometry;

// TextBufferGeometry

function TextBufferGeometry( text, parameters ) {

	parameters = parameters || {};

	var font = parameters.font;

	if ( ! ( font && font.isFont ) ) {

		console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
		return new Geometry();

	}

	var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );

	// translate parameters to ExtrudeGeometry API

	parameters.amount = parameters.height !== undefined ? parameters.height : 50;

	// defaults

	if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
	if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
	if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;

	ExtrudeBufferGeometry.call( this, shapes, parameters );

	this.type = 'TextBufferGeometry';

}

TextBufferGeometry.prototype = Object.create( ExtrudeBufferGeometry.prototype );
TextBufferGeometry.prototype.constructor = TextBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author benaadams / https://twitter.com/ben_a_adams
 * @author Mugen87 / https://github.com/Mugen87
 */

// SphereGeometry

function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'SphereGeometry';

	this.parameters = {
		radius: radius,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		phiStart: phiStart,
		phiLength: phiLength,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );
	this.mergeVertices();

}

SphereGeometry.prototype = Object.create( Geometry.prototype );
SphereGeometry.prototype.constructor = SphereGeometry;

// SphereBufferGeometry

function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'SphereBufferGeometry';

	this.parameters = {
		radius: radius,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		phiStart: phiStart,
		phiLength: phiLength,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	radius = radius || 1;

	widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
	heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );

	phiStart = phiStart !== undefined ? phiStart : 0;
	phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

	var thetaEnd = thetaStart + thetaLength;

	var ix, iy;

	var index = 0;
	var grid = [];

	var vertex = new Vector3();
	var normal = new Vector3();

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// generate vertices, normals and uvs

	for ( iy = 0; iy <= heightSegments; iy ++ ) {

		var verticesRow = [];

		var v = iy / heightSegments;

		for ( ix = 0; ix <= widthSegments; ix ++ ) {

			var u = ix / widthSegments;

			// vertex

			vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
			vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
			vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normal.set( vertex.x, vertex.y, vertex.z ).normalize();
			normals.push( normal.x, normal.y, normal.z );

			// uv

			uvs.push( u, 1 - v );

			verticesRow.push( index ++ );

		}

		grid.push( verticesRow );

	}

	// indices

	for ( iy = 0; iy < heightSegments; iy ++ ) {

		for ( ix = 0; ix < widthSegments; ix ++ ) {

			var a = grid[ iy ][ ix + 1 ];
			var b = grid[ iy ][ ix ];
			var c = grid[ iy + 1 ][ ix ];
			var d = grid[ iy + 1 ][ ix + 1 ];

			if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
			if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;

/**
 * @author Kaleb Murphy
 * @author Mugen87 / https://github.com/Mugen87
 */

// RingGeometry

function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'RingGeometry';

	this.parameters = {
		innerRadius: innerRadius,
		outerRadius: outerRadius,
		thetaSegments: thetaSegments,
		phiSegments: phiSegments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );
	this.mergeVertices();

}

RingGeometry.prototype = Object.create( Geometry.prototype );
RingGeometry.prototype.constructor = RingGeometry;

// RingBufferGeometry

function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'RingBufferGeometry';

	this.parameters = {
		innerRadius: innerRadius,
		outerRadius: outerRadius,
		thetaSegments: thetaSegments,
		phiSegments: phiSegments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	innerRadius = innerRadius || 0.5;
	outerRadius = outerRadius || 1;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

	thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
	phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// some helper variables

	var segment;
	var radius = innerRadius;
	var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
	var vertex = new Vector3();
	var uv = new Vector2();
	var j, i;

	// generate vertices, normals and uvs

	for ( j = 0; j <= phiSegments; j ++ ) {

		for ( i = 0; i <= thetaSegments; i ++ ) {

			// values are generate from the inside of the ring to the outside

			segment = thetaStart + i / thetaSegments * thetaLength;

			// vertex

			vertex.x = radius * Math.cos( segment );
			vertex.y = radius * Math.sin( segment );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normals.push( 0, 0, 1 );

			// uv

			uv.x = ( vertex.x / outerRadius + 1 ) / 2;
			uv.y = ( vertex.y / outerRadius + 1 ) / 2;

			uvs.push( uv.x, uv.y );

		}

		// increase the radius for next row of vertices

		radius += radiusStep;

	}

	// indices

	for ( j = 0; j < phiSegments; j ++ ) {

		var thetaSegmentLevel = j * ( thetaSegments + 1 );

		for ( i = 0; i < thetaSegments; i ++ ) {

			segment = i + thetaSegmentLevel;

			var a = segment;
			var b = segment + thetaSegments + 1;
			var c = segment + thetaSegments + 2;
			var d = segment + 1;

			// faces

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
RingBufferGeometry.prototype.constructor = RingBufferGeometry;

/**
 * @author astrodud / http://astrodud.isgreat.org/
 * @author zz85 / https://github.com/zz85
 * @author bhouston / http://clara.io
 * @author Mugen87 / https://github.com/Mugen87
 */

// LatheGeometry

function LatheGeometry( points, segments, phiStart, phiLength ) {

	Geometry.call( this );

	this.type = 'LatheGeometry';

	this.parameters = {
		points: points,
		segments: segments,
		phiStart: phiStart,
		phiLength: phiLength
	};

	this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
	this.mergeVertices();

}

LatheGeometry.prototype = Object.create( Geometry.prototype );
LatheGeometry.prototype.constructor = LatheGeometry;

// LatheBufferGeometry

function LatheBufferGeometry( points, segments, phiStart, phiLength ) {

	BufferGeometry.call( this );

	this.type = 'LatheBufferGeometry';

	this.parameters = {
		points: points,
		segments: segments,
		phiStart: phiStart,
		phiLength: phiLength
	};

	segments = Math.floor( segments ) || 12;
	phiStart = phiStart || 0;
	phiLength = phiLength || Math.PI * 2;

	// clamp phiLength so it's in range of [ 0, 2PI ]

	phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );


	// buffers

	var indices = [];
	var vertices = [];
	var uvs = [];

	// helper variables

	var base;
	var inverseSegments = 1.0 / segments;
	var vertex = new Vector3();
	var uv = new Vector2();
	var i, j;

	// generate vertices and uvs

	for ( i = 0; i <= segments; i ++ ) {

		var phi = phiStart + i * inverseSegments * phiLength;

		var sin = Math.sin( phi );
		var cos = Math.cos( phi );

		for ( j = 0; j <= ( points.length - 1 ); j ++ ) {

			// vertex

			vertex.x = points[ j ].x * sin;
			vertex.y = points[ j ].y;
			vertex.z = points[ j ].x * cos;

			vertices.push( vertex.x, vertex.y, vertex.z );

			// uv

			uv.x = i / segments;
			uv.y = j / ( points.length - 1 );

			uvs.push( uv.x, uv.y );


		}

	}

	// indices

	for ( i = 0; i < segments; i ++ ) {

		for ( j = 0; j < ( points.length - 1 ); j ++ ) {

			base = j + i * points.length;

			var a = base;
			var b = base + points.length;
			var c = base + points.length + 1;
			var d = base + 1;

			// faces

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	// generate normals

	this.computeVertexNormals();

	// if the geometry is closed, we need to average the normals along the seam.
	// because the corresponding vertices are identical (but still have different UVs).

	if ( phiLength === Math.PI * 2 ) {

		var normals = this.attributes.normal.array;
		var n1 = new Vector3();
		var n2 = new Vector3();
		var n = new Vector3();

		// this is the buffer offset for the last line of vertices

		base = segments * points.length * 3;

		for ( i = 0, j = 0; i < points.length; i ++, j += 3 ) {

			// select the normal of the vertex in the first line

			n1.x = normals[ j + 0 ];
			n1.y = normals[ j + 1 ];
			n1.z = normals[ j + 2 ];

			// select the normal of the vertex in the last line

			n2.x = normals[ base + j + 0 ];
			n2.y = normals[ base + j + 1 ];
			n2.z = normals[ base + j + 2 ];

			// average normals

			n.addVectors( n1, n2 ).normalize();

			// assign the new values to both normals

			normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
			normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
			normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;

		}

	}

}

LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;

/**
 * @author jonobr1 / http://jonobr1.com
 * @author Mugen87 / https://github.com/Mugen87
 */

// ShapeGeometry

function ShapeGeometry( shapes, curveSegments ) {

	Geometry.call( this );

	this.type = 'ShapeGeometry';

	if ( typeof curveSegments === 'object' ) {

		console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );

		curveSegments = curveSegments.curveSegments;

	}

	this.parameters = {
		shapes: shapes,
		curveSegments: curveSegments
	};

	this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
	this.mergeVertices();

}

ShapeGeometry.prototype = Object.create( Geometry.prototype );
ShapeGeometry.prototype.constructor = ShapeGeometry;

ShapeGeometry.prototype.toJSON = function () {

	var data = Geometry.prototype.toJSON.call( this );

	var shapes = this.parameters.shapes;

	return toJSON( shapes, data );

};

// ShapeBufferGeometry

function ShapeBufferGeometry( shapes, curveSegments ) {

	BufferGeometry.call( this );

	this.type = 'ShapeBufferGeometry';

	this.parameters = {
		shapes: shapes,
		curveSegments: curveSegments
	};

	curveSegments = curveSegments || 12;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var groupStart = 0;
	var groupCount = 0;

	// allow single and array values for "shapes" parameter

	if ( Array.isArray( shapes ) === false ) {

		addShape( shapes );

	} else {

		for ( var i = 0; i < shapes.length; i ++ ) {

			addShape( shapes[ i ] );

			this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

			groupStart += groupCount;
			groupCount = 0;

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


	// helper functions

	function addShape( shape ) {

		var i, l, shapeHole;

		var indexOffset = vertices.length / 3;
		var points = shape.extractPoints( curveSegments );

		var shapeVertices = points.shape;
		var shapeHoles = points.holes;

		// check direction of vertices

		if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

			shapeVertices = shapeVertices.reverse();

			// also check if holes are in the opposite direction

			for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

				shapeHole = shapeHoles[ i ];

				if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

					shapeHoles[ i ] = shapeHole.reverse();

				}

			}

		}

		var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

		// join vertices of inner and outer paths to a single array

		for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

			shapeHole = shapeHoles[ i ];
			shapeVertices = shapeVertices.concat( shapeHole );

		}

		// vertices, normals, uvs

		for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {

			var vertex = shapeVertices[ i ];

			vertices.push( vertex.x, vertex.y, 0 );
			normals.push( 0, 0, 1 );
			uvs.push( vertex.x, vertex.y ); // world uvs

		}

		// incides

		for ( i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			var a = face[ 0 ] + indexOffset;
			var b = face[ 1 ] + indexOffset;
			var c = face[ 2 ] + indexOffset;

			indices.push( a, b, c );
			groupCount += 3;

		}

	}

}

ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;

ShapeBufferGeometry.prototype.toJSON = function () {

	var data = BufferGeometry.prototype.toJSON.call( this );

	var shapes = this.parameters.shapes;

	return toJSON( shapes, data );

};

//

function toJSON( shapes, data ) {

	data.shapes = [];

	if ( Array.isArray( shapes ) ) {

		for ( var i = 0, l = shapes.length; i < l; i ++ ) {

			var shape = shapes[ i ];

			data.shapes.push( shape.uuid );

		}

	} else {

		data.shapes.push( shapes.uuid );

	}

	return data;

}

/**
 * @author WestLangley / http://github.com/WestLangley
 * @author Mugen87 / https://github.com/Mugen87
 */

function EdgesGeometry( geometry, thresholdAngle ) {

	BufferGeometry.call( this );

	this.type = 'EdgesGeometry';

	this.parameters = {
		thresholdAngle: thresholdAngle
	};

	thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;

	// buffer

	var vertices = [];

	// helper variables

	var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );
	var edge = [ 0, 0 ], edges = {}, edge1, edge2;
	var key, keys = [ 'a', 'b', 'c' ];

	// prepare source geometry

	var geometry2;

	if ( geometry.isBufferGeometry ) {

		geometry2 = new Geometry();
		geometry2.fromBufferGeometry( geometry );

	} else {

		geometry2 = geometry.clone();

	}

	geometry2.mergeVertices();
	geometry2.computeFaceNormals();

	var sourceVertices = geometry2.vertices;
	var faces = geometry2.faces;

	// now create a data structure where each entry represents an edge with its adjoining faces

	for ( var i = 0, l = faces.length; i < l; i ++ ) {

		var face = faces[ i ];

		for ( var j = 0; j < 3; j ++ ) {

			edge1 = face[ keys[ j ] ];
			edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
			edge[ 0 ] = Math.min( edge1, edge2 );
			edge[ 1 ] = Math.max( edge1, edge2 );

			key = edge[ 0 ] + ',' + edge[ 1 ];

			if ( edges[ key ] === undefined ) {

				edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ], face1: i, face2: undefined };

			} else {

				edges[ key ].face2 = i;

			}

		}

	}

	// generate vertices

	for ( key in edges ) {

		var e = edges[ key ];

		// an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.

		if ( e.face2 === undefined || faces[ e.face1 ].normal.dot( faces[ e.face2 ].normal ) <= thresholdDot ) {

			var vertex = sourceVertices[ e.index1 ];
			vertices.push( vertex.x, vertex.y, vertex.z );

			vertex = sourceVertices[ e.index2 ];
			vertices.push( vertex.x, vertex.y, vertex.z );

		}

	}

	// build geometry

	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

}

EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
EdgesGeometry.prototype.constructor = EdgesGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

// CylinderGeometry

function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'CylinderGeometry';

	this.parameters = {
		radiusTop: radiusTop,
		radiusBottom: radiusBottom,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
	this.mergeVertices();

}

CylinderGeometry.prototype = Object.create( Geometry.prototype );
CylinderGeometry.prototype.constructor = CylinderGeometry;

// CylinderBufferGeometry

function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'CylinderBufferGeometry';

	this.parameters = {
		radiusTop: radiusTop,
		radiusBottom: radiusBottom,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	var scope = this;

	radiusTop = radiusTop !== undefined ? radiusTop : 1;
	radiusBottom = radiusBottom !== undefined ? radiusBottom : 1;
	height = height || 1;

	radialSegments = Math.floor( radialSegments ) || 8;
	heightSegments = Math.floor( heightSegments ) || 1;

	openEnded = openEnded !== undefined ? openEnded : false;
	thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var index = 0;
	var indexArray = [];
	var halfHeight = height / 2;
	var groupStart = 0;

	// generate geometry

	generateTorso();

	if ( openEnded === false ) {

		if ( radiusTop > 0 ) generateCap( true );
		if ( radiusBottom > 0 ) generateCap( false );

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	function generateTorso() {

		var x, y;
		var normal = new Vector3();
		var vertex = new Vector3();

		var groupCount = 0;

		// this will be used to calculate the normal
		var slope = ( radiusBottom - radiusTop ) / height;

		// generate vertices, normals and uvs

		for ( y = 0; y <= heightSegments; y ++ ) {

			var indexRow = [];

			var v = y / heightSegments;

			// calculate the radius of the current row

			var radius = v * ( radiusBottom - radiusTop ) + radiusTop;

			for ( x = 0; x <= radialSegments; x ++ ) {

				var u = x / radialSegments;

				var theta = u * thetaLength + thetaStart;

				var sinTheta = Math.sin( theta );
				var cosTheta = Math.cos( theta );

				// vertex

				vertex.x = radius * sinTheta;
				vertex.y = - v * height + halfHeight;
				vertex.z = radius * cosTheta;
				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normal.set( sinTheta, slope, cosTheta ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u, 1 - v );

				// save index of vertex in respective row

				indexRow.push( index ++ );

			}

			// now save vertices of the row in our index array

			indexArray.push( indexRow );

		}

		// generate indices

		for ( x = 0; x < radialSegments; x ++ ) {

			for ( y = 0; y < heightSegments; y ++ ) {

				// we use the index array to access the correct indices

				var a = indexArray[ y ][ x ];
				var b = indexArray[ y + 1 ][ x ];
				var c = indexArray[ y + 1 ][ x + 1 ];
				var d = indexArray[ y ][ x + 1 ];

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

				// update group counter

				groupCount += 6;

			}

		}

		// add a group to the geometry. this will ensure multi material support

		scope.addGroup( groupStart, groupCount, 0 );

		// calculate new start value for groups

		groupStart += groupCount;

	}

	function generateCap( top ) {

		var x, centerIndexStart, centerIndexEnd;

		var uv = new Vector2();
		var vertex = new Vector3();

		var groupCount = 0;

		var radius = ( top === true ) ? radiusTop : radiusBottom;
		var sign = ( top === true ) ? 1 : - 1;

		// save the index of the first center vertex
		centerIndexStart = index;

		// first we generate the center vertex data of the cap.
		// because the geometry needs one set of uvs per face,
		// we must generate a center vertex per face/segment

		for ( x = 1; x <= radialSegments; x ++ ) {

			// vertex

			vertices.push( 0, halfHeight * sign, 0 );

			// normal

			normals.push( 0, sign, 0 );

			// uv

			uvs.push( 0.5, 0.5 );

			// increase index

			index ++;

		}

		// save the index of the last center vertex

		centerIndexEnd = index;

		// now we generate the surrounding vertices, normals and uvs

		for ( x = 0; x <= radialSegments; x ++ ) {

			var u = x / radialSegments;
			var theta = u * thetaLength + thetaStart;

			var cosTheta = Math.cos( theta );
			var sinTheta = Math.sin( theta );

			// vertex

			vertex.x = radius * sinTheta;
			vertex.y = halfHeight * sign;
			vertex.z = radius * cosTheta;
			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normals.push( 0, sign, 0 );

			// uv

			uv.x = ( cosTheta * 0.5 ) + 0.5;
			uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
			uvs.push( uv.x, uv.y );

			// increase index

			index ++;

		}

		// generate indices

		for ( x = 0; x < radialSegments; x ++ ) {

			var c = centerIndexStart + x;
			var i = centerIndexEnd + x;

			if ( top === true ) {

				// face top

				indices.push( i, i + 1, c );

			} else {

				// face bottom

				indices.push( i + 1, i, c );

			}

			groupCount += 3;

		}

		// add a group to the geometry. this will ensure multi material support

		scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

		// calculate new start value for groups

		groupStart += groupCount;

	}

}

CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;

/**
 * @author abelnation / http://github.com/abelnation
 */

// ConeGeometry

function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

	this.type = 'ConeGeometry';

	this.parameters = {
		radius: radius,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

}

ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
ConeGeometry.prototype.constructor = ConeGeometry;

// ConeBufferGeometry

function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

	this.type = 'ConeBufferGeometry';

	this.parameters = {
		radius: radius,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

}

ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 * @author Mugen87 / https://github.com/Mugen87
 * @author hughes
 */

// CircleGeometry

function CircleGeometry( radius, segments, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'CircleGeometry';

	this.parameters = {
		radius: radius,
		segments: segments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );
	this.mergeVertices();

}

CircleGeometry.prototype = Object.create( Geometry.prototype );
CircleGeometry.prototype.constructor = CircleGeometry;

// CircleBufferGeometry

function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'CircleBufferGeometry';

	this.parameters = {
		radius: radius,
		segments: segments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	radius = radius || 1;
	segments = segments !== undefined ? Math.max( 3, segments ) : 8;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

	// buffers

	var indices = [];
	var vertices = [];
	var normals = [];
	var uvs = [];

	// helper variables

	var i, s;
	var vertex = new Vector3();
	var uv = new Vector2();

	// center point

	vertices.push( 0, 0, 0 );
	normals.push( 0, 0, 1 );
	uvs.push( 0.5, 0.5 );

	for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {

		var segment = thetaStart + s / segments * thetaLength;

		// vertex

		vertex.x = radius * Math.cos( segment );
		vertex.y = radius * Math.sin( segment );

		vertices.push( vertex.x, vertex.y, vertex.z );

		// normal

		normals.push( 0, 0, 1 );

		// uvs

		uv.x = ( vertices[ i ] / radius + 1 ) / 2;
		uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;

		uvs.push( uv.x, uv.y );

	}

	// indices

	for ( i = 1; i <= segments; i ++ ) {

		indices.push( i, i + 1, 0 );

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

}

CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;



var Geometries = Object.freeze({
	WireframeGeometry: WireframeGeometry,
	ParametricGeometry: ParametricGeometry,
	ParametricBufferGeometry: ParametricBufferGeometry,
	TetrahedronGeometry: TetrahedronGeometry,
	TetrahedronBufferGeometry: TetrahedronBufferGeometry,
	OctahedronGeometry: OctahedronGeometry,
	OctahedronBufferGeometry: OctahedronBufferGeometry,
	IcosahedronGeometry: IcosahedronGeometry,
	IcosahedronBufferGeometry: IcosahedronBufferGeometry,
	DodecahedronGeometry: DodecahedronGeometry,
	DodecahedronBufferGeometry: DodecahedronBufferGeometry,
	PolyhedronGeometry: PolyhedronGeometry,
	PolyhedronBufferGeometry: PolyhedronBufferGeometry,
	TubeGeometry: TubeGeometry,
	TubeBufferGeometry: TubeBufferGeometry,
	TorusKnotGeometry: TorusKnotGeometry,
	TorusKnotBufferGeometry: TorusKnotBufferGeometry,
	TorusGeometry: TorusGeometry,
	TorusBufferGeometry: TorusBufferGeometry,
	TextGeometry: TextGeometry,
	TextBufferGeometry: TextBufferGeometry,
	SphereGeometry: SphereGeometry,
	SphereBufferGeometry: SphereBufferGeometry,
	RingGeometry: RingGeometry,
	RingBufferGeometry: RingBufferGeometry,
	PlaneGeometry: PlaneGeometry,
	PlaneBufferGeometry: PlaneBufferGeometry,
	LatheGeometry: LatheGeometry,
	LatheBufferGeometry: LatheBufferGeometry,
	ShapeGeometry: ShapeGeometry,
	ShapeBufferGeometry: ShapeBufferGeometry,
	ExtrudeGeometry: ExtrudeGeometry,
	ExtrudeBufferGeometry: ExtrudeBufferGeometry,
	EdgesGeometry: EdgesGeometry,
	ConeGeometry: ConeGeometry,
	ConeBufferGeometry: ConeBufferGeometry,
	CylinderGeometry: CylinderGeometry,
	CylinderBufferGeometry: CylinderBufferGeometry,
	CircleGeometry: CircleGeometry,
	CircleBufferGeometry: CircleBufferGeometry,
	BoxGeometry: BoxGeometry,
	BoxBufferGeometry: BoxBufferGeometry
});

/**
 * @author mrdoob / http://mrdoob.com/
 *
 * parameters = {
 *  color: <THREE.Color>,
 *  opacity: <float>
 * }
 */

function ShadowMaterial( parameters ) {

	Material.call( this );

	this.type = 'ShadowMaterial';

	this.color = new Color( 0x000000 );
	this.opacity = 1.0;

	this.lights = true;
	this.transparent = true;

	this.setValues( parameters );

}

ShadowMaterial.prototype = Object.create( Material.prototype );
ShadowMaterial.prototype.constructor = ShadowMaterial;

ShadowMaterial.prototype.isShadowMaterial = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function RawShaderMaterial( parameters ) {

	ShaderMaterial.call( this, parameters );

	this.type = 'RawShaderMaterial';

}

RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
RawShaderMaterial.prototype.constructor = RawShaderMaterial;

RawShaderMaterial.prototype.isRawShaderMaterial = true;

/**
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshStandardMaterial( parameters ) {

	Material.call( this );

	this.defines = { 'STANDARD': '' };

	this.type = 'MeshStandardMaterial';

	this.color = new Color( 0xffffff ); // diffuse
	this.roughness = 0.5;
	this.metalness = 0.5;

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.roughnessMap = null;

	this.metalnessMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.envMapIntensity = 1.0;

	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshStandardMaterial.prototype = Object.create( Material.prototype );
MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;

MeshStandardMaterial.prototype.isMeshStandardMaterial = true;

MeshStandardMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.defines = { 'STANDARD': '' };

	this.color.copy( source.color );
	this.roughness = source.roughness;
	this.metalness = source.metalness;

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.roughnessMap = source.roughnessMap;

	this.metalnessMap = source.metalnessMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.envMapIntensity = source.envMapIntensity;

	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  reflectivity: <float>
 * }
 */

function MeshPhysicalMaterial( parameters ) {

	MeshStandardMaterial.call( this );

	this.defines = { 'PHYSICAL': '' };

	this.type = 'MeshPhysicalMaterial';

	this.reflectivity = 0.5; // maps to F0 = 0.04

	this.clearCoat = 0.0;
	this.clearCoatRoughness = 0.0;

	this.setValues( parameters );

}

MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;

MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;

MeshPhysicalMaterial.prototype.copy = function ( source ) {

	MeshStandardMaterial.prototype.copy.call( this, source );

	this.defines = { 'PHYSICAL': '' };

	this.reflectivity = source.reflectivity;

	this.clearCoat = source.clearCoat;
	this.clearCoatRoughness = source.clearCoatRoughness;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshPhongMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshPhongMaterial';

	this.color = new Color( 0xffffff ); // diffuse
	this.specular = new Color( 0x111111 );
	this.shininess = 30;

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshPhongMaterial.prototype = Object.create( Material.prototype );
MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;

MeshPhongMaterial.prototype.isMeshPhongMaterial = true;

MeshPhongMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );
	this.specular.copy( source.specular );
	this.shininess = source.shininess;

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author takahirox / http://github.com/takahirox
 *
 * parameters = {
 *  gradientMap: new THREE.Texture( <Image> )
 * }
 */

function MeshToonMaterial( parameters ) {

	MeshPhongMaterial.call( this );

	this.defines = { 'TOON': '' };

	this.type = 'MeshToonMaterial';

	this.gradientMap = null;

	this.setValues( parameters );

}

MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
MeshToonMaterial.prototype.constructor = MeshToonMaterial;

MeshToonMaterial.prototype.isMeshToonMaterial = true;

MeshToonMaterial.prototype.copy = function ( source ) {

	MeshPhongMaterial.prototype.copy.call( this, source );

	this.gradientMap = source.gradientMap;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshNormalMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshNormalMaterial';

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false;
	this.lights = false;

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshNormalMaterial.prototype = Object.create( Material.prototype );
MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;

MeshNormalMaterial.prototype.isMeshNormalMaterial = true;

MeshNormalMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshLambertMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshLambertMaterial';

	this.color = new Color( 0xffffff ); // diffuse

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshLambertMaterial.prototype = Object.create( Material.prototype );
MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;

MeshLambertMaterial.prototype.isMeshLambertMaterial = true;

MeshLambertMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */

function LineDashedMaterial( parameters ) {

	LineBasicMaterial.call( this );

	this.type = 'LineDashedMaterial';

	this.scale = 1;
	this.dashSize = 3;
	this.gapSize = 1;

	this.setValues( parameters );

}

LineDashedMaterial.prototype = Object.create( LineBasicMaterial.prototype );
LineDashedMaterial.prototype.constructor = LineDashedMaterial;

LineDashedMaterial.prototype.isLineDashedMaterial = true;

LineDashedMaterial.prototype.copy = function ( source ) {

	LineBasicMaterial.prototype.copy.call( this, source );

	this.scale = source.scale;
	this.dashSize = source.dashSize;
	this.gapSize = source.gapSize;

	return this;

};



var Materials = Object.freeze({
	ShadowMaterial: ShadowMaterial,
	SpriteMaterial: SpriteMaterial,
	RawShaderMaterial: RawShaderMaterial,
	ShaderMaterial: ShaderMaterial,
	PointsMaterial: PointsMaterial,
	MeshPhysicalMaterial: MeshPhysicalMaterial,
	MeshStandardMaterial: MeshStandardMaterial,
	MeshPhongMaterial: MeshPhongMaterial,
	MeshToonMaterial: MeshToonMaterial,
	MeshNormalMaterial: MeshNormalMaterial,
	MeshLambertMaterial: MeshLambertMaterial,
	MeshDepthMaterial: MeshDepthMaterial,
	MeshDistanceMaterial: MeshDistanceMaterial,
	MeshBasicMaterial: MeshBasicMaterial,
	LineDashedMaterial: LineDashedMaterial,
	LineBasicMaterial: LineBasicMaterial,
	Material: Material
});

/**
 * @author mrdoob / http://mrdoob.com/
 */

var Cache = {

	enabled: false,

	files: {},

	add: function ( key, file ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[ key ] = file;

	},

	get: function ( key ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[ key ];

	},

	remove: function ( key ) {

		delete this.files[ key ];

	},

	clear: function () {

		this.files = {};

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LoadingManager( onLoad, onProgress, onError ) {

	var scope = this;

	var isLoading = false;
	var itemsLoaded = 0;
	var itemsTotal = 0;
	var urlModifier = undefined;

	this.onStart = undefined;
	this.onLoad = onLoad;
	this.onProgress = onProgress;
	this.onError = onError;

	this.itemStart = function ( url ) {

		itemsTotal ++;

		if ( isLoading === false ) {

			if ( scope.onStart !== undefined ) {

				scope.onStart( url, itemsLoaded, itemsTotal );

			}

		}

		isLoading = true;

	};

	this.itemEnd = function ( url ) {

		itemsLoaded ++;

		if ( scope.onProgress !== undefined ) {

			scope.onProgress( url, itemsLoaded, itemsTotal );

		}

		if ( itemsLoaded === itemsTotal ) {

			isLoading = false;

			if ( scope.onLoad !== undefined ) {

				scope.onLoad();

			}

		}

	};

	this.itemError = function ( url ) {

		if ( scope.onError !== undefined ) {

			scope.onError( url );

		}

	};

	this.resolveURL = function ( url ) {

		if ( urlModifier ) {

			return urlModifier( url );

		}

		return url;

	};

	this.setURLModifier = function ( transform ) {

		urlModifier = transform;
		return this;

	};

}

var DefaultLoadingManager = new LoadingManager();

/**
 * @author mrdoob / http://mrdoob.com/
 */

var loading = {};

function FileLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( FileLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		var scope = this;

		var cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		// Check if request is duplicate

		if ( loading[ url ] !== undefined ) {

			loading[ url ].push( {

				onLoad: onLoad,
				onProgress: onProgress,
				onError: onError

			} );

			return;

		}

		// Check for data: URI
		var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
		var dataUriRegexResult = url.match( dataUriRegex );

		// Safari can not handle Data URIs through XMLHttpRequest so process manually
		if ( dataUriRegexResult ) {

			var mimeType = dataUriRegexResult[ 1 ];
			var isBase64 = !! dataUriRegexResult[ 2 ];
			var data = dataUriRegexResult[ 3 ];

			data = window.decodeURIComponent( data );

			if ( isBase64 ) data = window.atob( data );

			try {

				var response;
				var responseType = ( this.responseType || '' ).toLowerCase();

				switch ( responseType ) {

					case 'arraybuffer':
					case 'blob':

						var view = new Uint8Array( data.length );

						for ( var i = 0; i < data.length; i ++ ) {

							view[ i ] = data.charCodeAt( i );

						}

						if ( responseType === 'blob' ) {

							response = new Blob( [ view.buffer ], { type: mimeType } );

						} else {

							response = view.buffer;

						}

						break;

					case 'document':

						var parser = new DOMParser();
						response = parser.parseFromString( data, mimeType );

						break;

					case 'json':

						response = JSON.parse( data );

						break;

					default: // 'text' or other

						response = data;

						break;

				}

				// Wait for next browser tick like standard XMLHttpRequest event dispatching does
				window.setTimeout( function () {

					if ( onLoad ) onLoad( response );

					scope.manager.itemEnd( url );

				}, 0 );

			} catch ( error ) {

				// Wait for next browser tick like standard XMLHttpRequest event dispatching does
				window.setTimeout( function () {

					if ( onError ) onError( error );

					scope.manager.itemEnd( url );
					scope.manager.itemError( url );

				}, 0 );

			}

		} else {

			// Initialise array for duplicate requests

			loading[ url ] = [];

			loading[ url ].push( {

				onLoad: onLoad,
				onProgress: onProgress,
				onError: onError

			} );

			var request = new XMLHttpRequest();

			request.open( 'GET', url, true );

			request.addEventListener( 'load', function ( event ) {

				var response = this.response;

				Cache.add( url, response );

				var callbacks = loading[ url ];

				delete loading[ url ];

				if ( this.status === 200 ) {

					for ( var i = 0, il = callbacks.length; i < il; i ++ ) {

						var callback = callbacks[ i ];
						if ( callback.onLoad ) callback.onLoad( response );

					}

					scope.manager.itemEnd( url );

				} else if ( this.status === 0 ) {

					// Some browsers return HTTP Status 0 when using non-http protocol
					// e.g. 'file://' or 'data://'. Handle as success.

					console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

					for ( var i = 0, il = callbacks.length; i < il; i ++ ) {

						var callback = callbacks[ i ];
						if ( callback.onLoad ) callback.onLoad( response );

					}

					scope.manager.itemEnd( url );

				} else {

					for ( var i = 0, il = callbacks.length; i < il; i ++ ) {

						var callback = callbacks[ i ];
						if ( callback.onError ) callback.onError( event );

					}

					scope.manager.itemEnd( url );
					scope.manager.itemError( url );

				}

			}, false );

			request.addEventListener( 'progress', function ( event ) {

				var callbacks = loading[ url ];

				for ( var i = 0, il = callbacks.length; i < il; i ++ ) {

					var callback = callbacks[ i ];
					if ( callback.onProgress ) callback.onProgress( event );

				}

			}, false );

			request.addEventListener( 'error', function ( event ) {

				var callbacks = loading[ url ];

				delete loading[ url ];

				for ( var i = 0, il = callbacks.length; i < il; i ++ ) {

					var callback = callbacks[ i ];
					if ( callback.onError ) callback.onError( event );

				}

				scope.manager.itemEnd( url );
				scope.manager.itemError( url );

			}, false );

			if ( this.responseType !== undefined ) request.responseType = this.responseType;
			if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;

			if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );

			for ( var header in this.requestHeader ) {

				request.setRequestHeader( header, this.requestHeader[ header ] );

			}

			request.send( null );

		}

		scope.manager.itemStart( url );

		return request;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	},

	setResponseType: function ( value ) {

		this.responseType = value;
		return this;

	},

	setWithCredentials: function ( value ) {

		this.withCredentials = value;
		return this;

	},

	setMimeType: function ( value ) {

		this.mimeType = value;
		return this;

	},

	setRequestHeader: function ( value ) {

		this.requestHeader = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 *
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 */

function CompressedTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	// override in sub classes
	this._parser = null;

}

Object.assign( CompressedTextureLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var images = [];

		var texture = new CompressedTexture();
		texture.image = images;

		var loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );

		function loadTexture( i ) {

			loader.load( url[ i ], function ( buffer ) {

				var texDatas = scope._parser( buffer, true );

				images[ i ] = {
					width: texDatas.width,
					height: texDatas.height,
					format: texDatas.format,
					mipmaps: texDatas.mipmaps
				};

				loaded += 1;

				if ( loaded === 6 ) {

					if ( texDatas.mipmapCount === 1 )
						texture.minFilter = LinearFilter;

					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, onProgress, onError );

		}

		if ( Array.isArray( url ) ) {

			var loaded = 0;

			for ( var i = 0, il = url.length; i < il; ++ i ) {

				loadTexture( i );

			}

		} else {

			// compressed cubemap texture stored in a single DDS file

			loader.load( url, function ( buffer ) {

				var texDatas = scope._parser( buffer, true );

				if ( texDatas.isCubemap ) {

					var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

					for ( var f = 0; f < faces; f ++ ) {

						images[ f ] = { mipmaps: [] };

						for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {

							images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
							images[ f ].format = texDatas.format;
							images[ f ].width = texDatas.width;
							images[ f ].height = texDatas.height;

						}

					}

				} else {

					texture.image.width = texDatas.width;
					texture.image.height = texDatas.height;
					texture.mipmaps = texDatas.mipmaps;

				}

				if ( texDatas.mipmapCount === 1 ) {

					texture.minFilter = LinearFilter;

				}

				texture.format = texDatas.format;
				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture );

			}, onProgress, onError );

		}

		return texture;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author Nikos M. / https://github.com/foo123/
 *
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 */

function DataTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	// override in sub classes
	this._parser = null;

}

Object.assign( DataTextureLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var texture = new DataTexture();

		var loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );

		loader.load( url, function ( buffer ) {

			var texData = scope._parser( buffer );

			if ( ! texData ) return;

			if ( undefined !== texData.image ) {

				texture.image = texData.image;

			} else if ( undefined !== texData.data ) {

				texture.image.width = texData.width;
				texture.image.height = texData.height;
				texture.image.data = texData.data;

			}

			texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
			texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;

			texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
			texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;

			texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;

			if ( undefined !== texData.format ) {

				texture.format = texData.format;

			}
			if ( undefined !== texData.type ) {

				texture.type = texData.type;

			}

			if ( undefined !== texData.mipmaps ) {

				texture.mipmaps = texData.mipmaps;

			}

			if ( 1 === texData.mipmapCount ) {

				texture.minFilter = LinearFilter;

			}

			texture.needsUpdate = true;

			if ( onLoad ) onLoad( texture, texData );

		}, onProgress, onError );


		return texture;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ImageLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( ImageLoader.prototype, {

	crossOrigin: 'Anonymous',

	load: function ( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		var scope = this;

		var cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );

		image.addEventListener( 'load', function () {

			Cache.add( url, this );

			if ( onLoad ) onLoad( this );

			scope.manager.itemEnd( url );

		}, false );

		/*
		image.addEventListener( 'progress', function ( event ) {

			if ( onProgress ) onProgress( event );

		}, false );
		*/

		image.addEventListener( 'error', function ( event ) {

			if ( onError ) onError( event );

			scope.manager.itemEnd( url );
			scope.manager.itemError( url );

		}, false );

		if ( url.substr( 0, 5 ) !== 'data:' ) {

			if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;

		}

		scope.manager.itemStart( url );

		image.src = url;

		return image;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CubeTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( CubeTextureLoader.prototype, {

	crossOrigin: 'Anonymous',

	load: function ( urls, onLoad, onProgress, onError ) {

		var texture = new CubeTexture();

		var loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		var loaded = 0;

		function loadTexture( i ) {

			loader.load( urls[ i ], function ( image ) {

				texture.images[ i ] = image;

				loaded ++;

				if ( loaded === 6 ) {

					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, undefined, onError );

		}

		for ( var i = 0; i < urls.length; ++ i ) {

			loadTexture( i );

		}

		return texture;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function TextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( TextureLoader.prototype, {

	crossOrigin: 'Anonymous',

	load: function ( url, onLoad, onProgress, onError ) {

		var texture = new Texture();

		var loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		loader.load( url, function ( image ) {

			texture.image = image;

			// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
			var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

			texture.format = isJPEG ? RGBFormat : RGBAFormat;
			texture.needsUpdate = true;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Extensible curve object
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/

/**************************************************************
 *	Abstract Curve base class
 **************************************************************/

function Curve() {

	this.type = 'Curve';

	this.arcLengthDivisions = 200;

}

Object.assign( Curve.prototype, {

	// Virtual base class method to overwrite and implement in subclasses
	//	- t [0 .. 1]

	getPoint: function ( /* t, optionalTarget */ ) {

		console.warn( 'THREE.Curve: .getPoint() not implemented.' );
		return null;

	},

	// Get point at relative position in curve according to arc length
	// - u [0 .. 1]

	getPointAt: function ( u, optionalTarget ) {

		var t = this.getUtoTmapping( u );
		return this.getPoint( t, optionalTarget );

	},

	// Get sequence of points using getPoint( t )

	getPoints: function ( divisions ) {

		if ( divisions === undefined ) divisions = 5;

		var points = [];

		for ( var d = 0; d <= divisions; d ++ ) {

			points.push( this.getPoint( d / divisions ) );

		}

		return points;

	},

	// Get sequence of points using getPointAt( u )

	getSpacedPoints: function ( divisions ) {

		if ( divisions === undefined ) divisions = 5;

		var points = [];

		for ( var d = 0; d <= divisions; d ++ ) {

			points.push( this.getPointAt( d / divisions ) );

		}

		return points;

	},

	// Get total curve arc length

	getLength: function () {

		var lengths = this.getLengths();
		return lengths[ lengths.length - 1 ];

	},

	// Get list of cumulative segment lengths

	getLengths: function ( divisions ) {

		if ( divisions === undefined ) divisions = this.arcLengthDivisions;

		if ( this.cacheArcLengths &&
			( this.cacheArcLengths.length === divisions + 1 ) &&
			! this.needsUpdate ) {

			return this.cacheArcLengths;

		}

		this.needsUpdate = false;

		var cache = [];
		var current, last = this.getPoint( 0 );
		var p, sum = 0;

		cache.push( 0 );

		for ( p = 1; p <= divisions; p ++ ) {

			current = this.getPoint( p / divisions );
			sum += current.distanceTo( last );
			cache.push( sum );
			last = current;

		}

		this.cacheArcLengths = cache;

		return cache; // { sums: cache, sum: sum }; Sum is in the last element.

	},

	updateArcLengths: function () {

		this.needsUpdate = true;
		this.getLengths();

	},

	// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

	getUtoTmapping: function ( u, distance ) {

		var arcLengths = this.getLengths();

		var i = 0, il = arcLengths.length;

		var targetArcLength; // The targeted u distance value to get

		if ( distance ) {

			targetArcLength = distance;

		} else {

			targetArcLength = u * arcLengths[ il - 1 ];

		}

		// binary search for the index with largest value smaller than target u distance

		var low = 0, high = il - 1, comparison;

		while ( low <= high ) {

			i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

			comparison = arcLengths[ i ] - targetArcLength;

			if ( comparison < 0 ) {

				low = i + 1;

			} else if ( comparison > 0 ) {

				high = i - 1;

			} else {

				high = i;
				break;

				// DONE

			}

		}

		i = high;

		if ( arcLengths[ i ] === targetArcLength ) {

			return i / ( il - 1 );

		}

		// we could get finer grain at lengths, or use simple interpolation between two points

		var lengthBefore = arcLengths[ i ];
		var lengthAfter = arcLengths[ i + 1 ];

		var segmentLength = lengthAfter - lengthBefore;

		// determine where we are between the 'before' and 'after' points

		var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

		// add that fractional amount to t

		var t = ( i + segmentFraction ) / ( il - 1 );

		return t;

	},

	// Returns a unit vector tangent at t
	// In case any sub curve does not implement its tangent derivation,
	// 2 points a small delta apart will be used to find its gradient
	// which seems to give a reasonable approximation

	getTangent: function ( t ) {

		var delta = 0.0001;
		var t1 = t - delta;
		var t2 = t + delta;

		// Capping in case of danger

		if ( t1 < 0 ) t1 = 0;
		if ( t2 > 1 ) t2 = 1;

		var pt1 = this.getPoint( t1 );
		var pt2 = this.getPoint( t2 );

		var vec = pt2.clone().sub( pt1 );
		return vec.normalize();

	},

	getTangentAt: function ( u ) {

		var t = this.getUtoTmapping( u );
		return this.getTangent( t );

	},

	computeFrenetFrames: function ( segments, closed ) {

		// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

		var normal = new Vector3();

		var tangents = [];
		var normals = [];
		var binormals = [];

		var vec = new Vector3();
		var mat = new Matrix4();

		var i, u, theta;

		// compute the tangent vectors for each segment on the curve

		for ( i = 0; i <= segments; i ++ ) {

			u = i / segments;

			tangents[ i ] = this.getTangentAt( u );
			tangents[ i ].normalize();

		}

		// select an initial normal vector perpendicular to the first tangent vector,
		// and in the direction of the minimum tangent xyz component

		normals[ 0 ] = new Vector3();
		binormals[ 0 ] = new Vector3();
		var min = Number.MAX_VALUE;
		var tx = Math.abs( tangents[ 0 ].x );
		var ty = Math.abs( tangents[ 0 ].y );
		var tz = Math.abs( tangents[ 0 ].z );

		if ( tx <= min ) {

			min = tx;
			normal.set( 1, 0, 0 );

		}

		if ( ty <= min ) {

			min = ty;
			normal.set( 0, 1, 0 );

		}

		if ( tz <= min ) {

			normal.set( 0, 0, 1 );

		}

		vec.crossVectors( tangents[ 0 ], normal ).normalize();

		normals[ 0 ].crossVectors( tangents[ 0 ], vec );
		binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


		// compute the slowly-varying normal and binormal vectors for each segment on the curve

		for ( i = 1; i <= segments; i ++ ) {

			normals[ i ] = normals[ i - 1 ].clone();

			binormals[ i ] = binormals[ i - 1 ].clone();

			vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

			if ( vec.length() > Number.EPSILON ) {

				vec.normalize();

				theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

				normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

			}

			binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

		}

		// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

		if ( closed === true ) {

			theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
			theta /= segments;

			if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

				theta = - theta;

			}

			for ( i = 1; i <= segments; i ++ ) {

				// twist a little...
				normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

		}

		return {
			tangents: tangents,
			normals: normals,
			binormals: binormals
		};

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.arcLengthDivisions = source.arcLengthDivisions;

		return this;

	},

	toJSON: function () {

		var data = {
			metadata: {
				version: 4.5,
				type: 'Curve',
				generator: 'Curve.toJSON'
			}
		};

		data.arcLengthDivisions = this.arcLengthDivisions;
		data.type = this.type;

		return data;

	},

	fromJSON: function ( json ) {

		this.arcLengthDivisions = json.arcLengthDivisions;

		return this;

	}

} );

function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

	Curve.call( this );

	this.type = 'EllipseCurve';

	this.aX = aX || 0;
	this.aY = aY || 0;

	this.xRadius = xRadius || 1;
	this.yRadius = yRadius || 1;

	this.aStartAngle = aStartAngle || 0;
	this.aEndAngle = aEndAngle || 2 * Math.PI;

	this.aClockwise = aClockwise || false;

	this.aRotation = aRotation || 0;

}

EllipseCurve.prototype = Object.create( Curve.prototype );
EllipseCurve.prototype.constructor = EllipseCurve;

EllipseCurve.prototype.isEllipseCurve = true;

EllipseCurve.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector2();

	var twoPi = Math.PI * 2;
	var deltaAngle = this.aEndAngle - this.aStartAngle;
	var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

	// ensures that deltaAngle is 0 .. 2 PI
	while ( deltaAngle < 0 ) deltaAngle += twoPi;
	while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

	if ( deltaAngle < Number.EPSILON ) {

		if ( samePoints ) {

			deltaAngle = 0;

		} else {

			deltaAngle = twoPi;

		}

	}

	if ( this.aClockwise === true && ! samePoints ) {

		if ( deltaAngle === twoPi ) {

			deltaAngle = - twoPi;

		} else {

			deltaAngle = deltaAngle - twoPi;

		}

	}

	var angle = this.aStartAngle + t * deltaAngle;
	var x = this.aX + this.xRadius * Math.cos( angle );
	var y = this.aY + this.yRadius * Math.sin( angle );

	if ( this.aRotation !== 0 ) {

		var cos = Math.cos( this.aRotation );
		var sin = Math.sin( this.aRotation );

		var tx = x - this.aX;
		var ty = y - this.aY;

		// Rotate the point about the center of the ellipse.
		x = tx * cos - ty * sin + this.aX;
		y = tx * sin + ty * cos + this.aY;

	}

	return point.set( x, y );

};

EllipseCurve.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.aX = source.aX;
	this.aY = source.aY;

	this.xRadius = source.xRadius;
	this.yRadius = source.yRadius;

	this.aStartAngle = source.aStartAngle;
	this.aEndAngle = source.aEndAngle;

	this.aClockwise = source.aClockwise;

	this.aRotation = source.aRotation;

	return this;

};


EllipseCurve.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.aX = this.aX;
	data.aY = this.aY;

	data.xRadius = this.xRadius;
	data.yRadius = this.yRadius;

	data.aStartAngle = this.aStartAngle;
	data.aEndAngle = this.aEndAngle;

	data.aClockwise = this.aClockwise;

	data.aRotation = this.aRotation;

	return data;

};

EllipseCurve.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.aX = json.aX;
	this.aY = json.aY;

	this.xRadius = json.xRadius;
	this.yRadius = json.yRadius;

	this.aStartAngle = json.aStartAngle;
	this.aEndAngle = json.aEndAngle;

	this.aClockwise = json.aClockwise;

	this.aRotation = json.aRotation;

	return this;

};

function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

	EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

	this.type = 'ArcCurve';

}

ArcCurve.prototype = Object.create( EllipseCurve.prototype );
ArcCurve.prototype.constructor = ArcCurve;

ArcCurve.prototype.isArcCurve = true;

/**
 * @author zz85 https://github.com/zz85
 *
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */


/*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/

function CubicPoly() {

	var c0 = 0, c1 = 0, c2 = 0, c3 = 0;

	/*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */
	function init( x0, x1, t0, t1 ) {

		c0 = x0;
		c1 = t0;
		c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
		c3 = 2 * x0 - 2 * x1 + t0 + t1;

	}

	return {

		initCatmullRom: function ( x0, x1, x2, x3, tension ) {

			init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

		},

		initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {

			// compute tangents when parameterized in [t1,t2]
			var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
			var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

			// rescale tangents for parametrization in [0,1]
			t1 *= dt1;
			t2 *= dt1;

			init( x1, x2, t1, t2 );

		},

		calc: function ( t ) {

			var t2 = t * t;
			var t3 = t2 * t;
			return c0 + c1 * t + c2 * t2 + c3 * t3;

		}

	};

}

//

var tmp = new Vector3();
var px = new CubicPoly();
var py = new CubicPoly();
var pz = new CubicPoly();

function CatmullRomCurve3( points, closed, curveType, tension ) {

	Curve.call( this );

	this.type = 'CatmullRomCurve3';

	this.points = points || [];
	this.closed = closed || false;
	this.curveType = curveType || 'centripetal';
	this.tension = tension || 0.5;

}

CatmullRomCurve3.prototype = Object.create( Curve.prototype );
CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;

CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;

CatmullRomCurve3.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector3();

	var points = this.points;
	var l = points.length;

	var p = ( l - ( this.closed ? 0 : 1 ) ) * t;
	var intPoint = Math.floor( p );
	var weight = p - intPoint;

	if ( this.closed ) {

		intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;

	} else if ( weight === 0 && intPoint === l - 1 ) {

		intPoint = l - 2;
		weight = 1;

	}

	var p0, p1, p2, p3; // 4 points

	if ( this.closed || intPoint > 0 ) {

		p0 = points[ ( intPoint - 1 ) % l ];

	} else {

		// extrapolate first point
		tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
		p0 = tmp;

	}

	p1 = points[ intPoint % l ];
	p2 = points[ ( intPoint + 1 ) % l ];

	if ( this.closed || intPoint + 2 < l ) {

		p3 = points[ ( intPoint + 2 ) % l ];

	} else {

		// extrapolate last point
		tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
		p3 = tmp;

	}

	if ( this.curveType === 'centripetal' || this.curveType === 'chordal' ) {

		// init Centripetal / Chordal Catmull-Rom
		var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
		var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
		var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
		var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

		// safety check for repeated points
		if ( dt1 < 1e-4 ) dt1 = 1.0;
		if ( dt0 < 1e-4 ) dt0 = dt1;
		if ( dt2 < 1e-4 ) dt2 = dt1;

		px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
		py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
		pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

	} else if ( this.curveType === 'catmullrom' ) {

		px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, this.tension );
		py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, this.tension );
		pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, this.tension );

	}

	point.set(
		px.calc( weight ),
		py.calc( weight ),
		pz.calc( weight )
	);

	return point;

};

CatmullRomCurve3.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.points = [];

	for ( var i = 0, l = source.points.length; i < l; i ++ ) {

		var point = source.points[ i ];

		this.points.push( point.clone() );

	}

	this.closed = source.closed;
	this.curveType = source.curveType;
	this.tension = source.tension;

	return this;

};

CatmullRomCurve3.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.points = [];

	for ( var i = 0, l = this.points.length; i < l; i ++ ) {

		var point = this.points[ i ];
		data.points.push( point.toArray() );

	}

	data.closed = this.closed;
	data.curveType = this.curveType;
	data.tension = this.tension;

	return data;

};

CatmullRomCurve3.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.points = [];

	for ( var i = 0, l = json.points.length; i < l; i ++ ) {

		var point = json.points[ i ];
		this.points.push( new Vector3().fromArray( point ) );

	}

	this.closed = json.closed;
	this.curveType = json.curveType;
	this.tension = json.tension;

	return this;

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 *
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */

function CatmullRom( t, p0, p1, p2, p3 ) {

	var v0 = ( p2 - p0 ) * 0.5;
	var v1 = ( p3 - p1 ) * 0.5;
	var t2 = t * t;
	var t3 = t * t2;
	return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

}

//

function QuadraticBezierP0( t, p ) {

	var k = 1 - t;
	return k * k * p;

}

function QuadraticBezierP1( t, p ) {

	return 2 * ( 1 - t ) * t * p;

}

function QuadraticBezierP2( t, p ) {

	return t * t * p;

}

function QuadraticBezier( t, p0, p1, p2 ) {

	return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
		QuadraticBezierP2( t, p2 );

}

//

function CubicBezierP0( t, p ) {

	var k = 1 - t;
	return k * k * k * p;

}

function CubicBezierP1( t, p ) {

	var k = 1 - t;
	return 3 * k * k * t * p;

}

function CubicBezierP2( t, p ) {

	return 3 * ( 1 - t ) * t * t * p;

}

function CubicBezierP3( t, p ) {

	return t * t * t * p;

}

function CubicBezier( t, p0, p1, p2, p3 ) {

	return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
		CubicBezierP3( t, p3 );

}

function CubicBezierCurve( v0, v1, v2, v3 ) {

	Curve.call( this );

	this.type = 'CubicBezierCurve';

	this.v0 = v0 || new Vector2();
	this.v1 = v1 || new Vector2();
	this.v2 = v2 || new Vector2();
	this.v3 = v3 || new Vector2();

}

CubicBezierCurve.prototype = Object.create( Curve.prototype );
CubicBezierCurve.prototype.constructor = CubicBezierCurve;

CubicBezierCurve.prototype.isCubicBezierCurve = true;

CubicBezierCurve.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector2();

	var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

	point.set(
		CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
		CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
	);

	return point;

};

CubicBezierCurve.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v0.copy( source.v0 );
	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );
	this.v3.copy( source.v3 );

	return this;

};

CubicBezierCurve.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v0 = this.v0.toArray();
	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();
	data.v3 = this.v3.toArray();

	return data;

};

CubicBezierCurve.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v0.fromArray( json.v0 );
	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );
	this.v3.fromArray( json.v3 );

	return this;

};

function CubicBezierCurve3( v0, v1, v2, v3 ) {

	Curve.call( this );

	this.type = 'CubicBezierCurve3';

	this.v0 = v0 || new Vector3();
	this.v1 = v1 || new Vector3();
	this.v2 = v2 || new Vector3();
	this.v3 = v3 || new Vector3();

}

CubicBezierCurve3.prototype = Object.create( Curve.prototype );
CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;

CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;

CubicBezierCurve3.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector3();

	var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

	point.set(
		CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
		CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
		CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
	);

	return point;

};

CubicBezierCurve3.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v0.copy( source.v0 );
	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );
	this.v3.copy( source.v3 );

	return this;

};

CubicBezierCurve3.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v0 = this.v0.toArray();
	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();
	data.v3 = this.v3.toArray();

	return data;

};

CubicBezierCurve3.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v0.fromArray( json.v0 );
	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );
	this.v3.fromArray( json.v3 );

	return this;

};

function LineCurve( v1, v2 ) {

	Curve.call( this );

	this.type = 'LineCurve';

	this.v1 = v1 || new Vector2();
	this.v2 = v2 || new Vector2();

}

LineCurve.prototype = Object.create( Curve.prototype );
LineCurve.prototype.constructor = LineCurve;

LineCurve.prototype.isLineCurve = true;

LineCurve.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector2();

	if ( t === 1 ) {

		point.copy( this.v2 );

	} else {

		point.copy( this.v2 ).sub( this.v1 );
		point.multiplyScalar( t ).add( this.v1 );

	}

	return point;

};

// Line curve is linear, so we can overwrite default getPointAt

LineCurve.prototype.getPointAt = function ( u, optionalTarget ) {

	return this.getPoint( u, optionalTarget );

};

LineCurve.prototype.getTangent = function ( /* t */ ) {

	var tangent = this.v2.clone().sub( this.v1 );

	return tangent.normalize();

};

LineCurve.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );

	return this;

};

LineCurve.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();

	return data;

};

LineCurve.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );

	return this;

};

function LineCurve3( v1, v2 ) {

	Curve.call( this );

	this.type = 'LineCurve3';

	this.v1 = v1 || new Vector3();
	this.v2 = v2 || new Vector3();

}

LineCurve3.prototype = Object.create( Curve.prototype );
LineCurve3.prototype.constructor = LineCurve3;

LineCurve3.prototype.isLineCurve3 = true;

LineCurve3.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector3();

	if ( t === 1 ) {

		point.copy( this.v2 );

	} else {

		point.copy( this.v2 ).sub( this.v1 );
		point.multiplyScalar( t ).add( this.v1 );

	}

	return point;

};

// Line curve is linear, so we can overwrite default getPointAt

LineCurve3.prototype.getPointAt = function ( u, optionalTarget ) {

	return this.getPoint( u, optionalTarget );

};

LineCurve3.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );

	return this;

};

LineCurve3.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();

	return data;

};

LineCurve3.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );

	return this;

};

function QuadraticBezierCurve( v0, v1, v2 ) {

	Curve.call( this );

	this.type = 'QuadraticBezierCurve';

	this.v0 = v0 || new Vector2();
	this.v1 = v1 || new Vector2();
	this.v2 = v2 || new Vector2();

}

QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;

QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;

QuadraticBezierCurve.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector2();

	var v0 = this.v0, v1 = this.v1, v2 = this.v2;

	point.set(
		QuadraticBezier( t, v0.x, v1.x, v2.x ),
		QuadraticBezier( t, v0.y, v1.y, v2.y )
	);

	return point;

};

QuadraticBezierCurve.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v0.copy( source.v0 );
	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );

	return this;

};

QuadraticBezierCurve.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v0 = this.v0.toArray();
	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();

	return data;

};

QuadraticBezierCurve.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v0.fromArray( json.v0 );
	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );

	return this;

};

function QuadraticBezierCurve3( v0, v1, v2 ) {

	Curve.call( this );

	this.type = 'QuadraticBezierCurve3';

	this.v0 = v0 || new Vector3();
	this.v1 = v1 || new Vector3();
	this.v2 = v2 || new Vector3();

}

QuadraticBezierCurve3.prototype = Object.create( Curve.prototype );
QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;

QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;

QuadraticBezierCurve3.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector3();

	var v0 = this.v0, v1 = this.v1, v2 = this.v2;

	point.set(
		QuadraticBezier( t, v0.x, v1.x, v2.x ),
		QuadraticBezier( t, v0.y, v1.y, v2.y ),
		QuadraticBezier( t, v0.z, v1.z, v2.z )
	);

	return point;

};

QuadraticBezierCurve3.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.v0.copy( source.v0 );
	this.v1.copy( source.v1 );
	this.v2.copy( source.v2 );

	return this;

};

QuadraticBezierCurve3.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.v0 = this.v0.toArray();
	data.v1 = this.v1.toArray();
	data.v2 = this.v2.toArray();

	return data;

};

QuadraticBezierCurve3.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.v0.fromArray( json.v0 );
	this.v1.fromArray( json.v1 );
	this.v2.fromArray( json.v2 );

	return this;

};

function SplineCurve( points /* array of Vector2 */ ) {

	Curve.call( this );

	this.type = 'SplineCurve';

	this.points = points || [];

}

SplineCurve.prototype = Object.create( Curve.prototype );
SplineCurve.prototype.constructor = SplineCurve;

SplineCurve.prototype.isSplineCurve = true;

SplineCurve.prototype.getPoint = function ( t, optionalTarget ) {

	var point = optionalTarget || new Vector2();

	var points = this.points;
	var p = ( points.length - 1 ) * t;

	var intPoint = Math.floor( p );
	var weight = p - intPoint;

	var p0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
	var p1 = points[ intPoint ];
	var p2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
	var p3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

	point.set(
		CatmullRom( weight, p0.x, p1.x, p2.x, p3.x ),
		CatmullRom( weight, p0.y, p1.y, p2.y, p3.y )
	);

	return point;

};

SplineCurve.prototype.copy = function ( source ) {

	Curve.prototype.copy.call( this, source );

	this.points = [];

	for ( var i = 0, l = source.points.length; i < l; i ++ ) {

		var point = source.points[ i ];

		this.points.push( point.clone() );

	}

	return this;

};

SplineCurve.prototype.toJSON = function () {

	var data = Curve.prototype.toJSON.call( this );

	data.points = [];

	for ( var i = 0, l = this.points.length; i < l; i ++ ) {

		var point = this.points[ i ];
		data.points.push( point.toArray() );

	}

	return data;

};

SplineCurve.prototype.fromJSON = function ( json ) {

	Curve.prototype.fromJSON.call( this, json );

	this.points = [];

	for ( var i = 0, l = json.points.length; i < l; i ++ ) {

		var point = json.points[ i ];
		this.points.push( new Vector2().fromArray( point ) );

	}

	return this;

};



var Curves = Object.freeze({
	ArcCurve: ArcCurve,
	CatmullRomCurve3: CatmullRomCurve3,
	CubicBezierCurve: CubicBezierCurve,
	CubicBezierCurve3: CubicBezierCurve3,
	EllipseCurve: EllipseCurve,
	LineCurve: LineCurve,
	LineCurve3: LineCurve3,
	QuadraticBezierCurve: QuadraticBezierCurve,
	QuadraticBezierCurve3: QuadraticBezierCurve3,
	SplineCurve: SplineCurve
});

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 *
 **/

/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

function CurvePath() {

	Curve.call( this );

	this.type = 'CurvePath';

	this.curves = [];
	this.autoClose = false; // Automatically closes the path

}

CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {

	constructor: CurvePath,

	add: function ( curve ) {

		this.curves.push( curve );

	},

	closePath: function () {

		// Add a line curve if start and end of lines are not connected
		var startPoint = this.curves[ 0 ].getPoint( 0 );
		var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

		if ( ! startPoint.equals( endPoint ) ) {

			this.curves.push( new LineCurve( endPoint, startPoint ) );

		}

	},

	// To get accurate point with reference to
	// entire path distance at time t,
	// following has to be done:

	// 1. Length of each sub path have to be known
	// 2. Locate and identify type of curve
	// 3. Get t for the curve
	// 4. Return curve.getPointAt(t')

	getPoint: function ( t ) {

		var d = t * this.getLength();
		var curveLengths = this.getCurveLengths();
		var i = 0;

		// To think about boundaries points.

		while ( i < curveLengths.length ) {

			if ( curveLengths[ i ] >= d ) {

				var diff = curveLengths[ i ] - d;
				var curve = this.curves[ i ];

				var segmentLength = curve.getLength();
				var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

				return curve.getPointAt( u );

			}

			i ++;

		}

		return null;

		// loop where sum != 0, sum > d , sum+1 <d

	},

	// We cannot use the default THREE.Curve getPoint() with getLength() because in
	// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
	// getPoint() depends on getLength

	getLength: function () {

		var lens = this.getCurveLengths();
		return lens[ lens.length - 1 ];

	},

	// cacheLengths must be recalculated.
	updateArcLengths: function () {

		this.needsUpdate = true;
		this.cacheLengths = null;
		this.getCurveLengths();

	},

	// Compute lengths and cache them
	// We cannot overwrite getLengths() because UtoT mapping uses it.

	getCurveLengths: function () {

		// We use cache values if curves and cache array are same length

		if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

			return this.cacheLengths;

		}

		// Get length of sub-curve
		// Push sums into cached array

		var lengths = [], sums = 0;

		for ( var i = 0, l = this.curves.length; i < l; i ++ ) {

			sums += this.curves[ i ].getLength();
			lengths.push( sums );

		}

		this.cacheLengths = lengths;

		return lengths;

	},

	getSpacedPoints: function ( divisions ) {

		if ( divisions === undefined ) divisions = 40;

		var points = [];

		for ( var i = 0; i <= divisions; i ++ ) {

			points.push( this.getPoint( i / divisions ) );

		}

		if ( this.autoClose ) {

			points.push( points[ 0 ] );

		}

		return points;

	},

	getPoints: function ( divisions ) {

		divisions = divisions || 12;

		var points = [], last;

		for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {

			var curve = curves[ i ];
			var resolution = ( curve && curve.isEllipseCurve ) ? divisions * 2
				: ( curve && curve.isLineCurve ) ? 1
					: ( curve && curve.isSplineCurve ) ? divisions * curve.points.length
						: divisions;

			var pts = curve.getPoints( resolution );

			for ( var j = 0; j < pts.length; j ++ ) {

				var point = pts[ j ];

				if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

				points.push( point );
				last = point;

			}

		}

		if ( this.autoClose && points.length > 1 && ! points[ points.length - 1 ].equals( points[ 0 ] ) ) {

			points.push( points[ 0 ] );

		}

		return points;

	},

	copy: function ( source ) {

		Curve.prototype.copy.call( this, source );

		this.curves = [];

		for ( var i = 0, l = source.curves.length; i < l; i ++ ) {

			var curve = source.curves[ i ];

			this.curves.push( curve.clone() );

		}

		this.autoClose = source.autoClose;

		return this;

	},

	toJSON: function () {

		var data = Curve.prototype.toJSON.call( this );

		data.autoClose = this.autoClose;
		data.curves = [];

		for ( var i = 0, l = this.curves.length; i < l; i ++ ) {

			var curve = this.curves[ i ];
			data.curves.push( curve.toJSON() );

		}

		return data;

	},

	fromJSON: function ( json ) {

		Curve.prototype.fromJSON.call( this, json );

		this.autoClose = json.autoClose;
		this.curves = [];

		for ( var i = 0, l = json.curves.length; i < l; i ++ ) {

			var curve = json.curves[ i ];
			this.curves.push( new Curves[ curve.type ]().fromJSON( curve ) );

		}

		return this;

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Creates free form 2d path using series of points, lines or curves.
 **/

function Path( points ) {

	CurvePath.call( this );

	this.type = 'Path';

	this.currentPoint = new Vector2();

	if ( points ) {

		this.setFromPoints( points );

	}

}

Path.prototype = Object.assign( Object.create( CurvePath.prototype ), {

	constructor: Path,

	setFromPoints: function ( points ) {

		this.moveTo( points[ 0 ].x, points[ 0 ].y );

		for ( var i = 1, l = points.length; i < l; i ++ ) {

			this.lineTo( points[ i ].x, points[ i ].y );

		}

	},

	moveTo: function ( x, y ) {

		this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

	},

	lineTo: function ( x, y ) {

		var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
		this.curves.push( curve );

		this.currentPoint.set( x, y );

	},

	quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

		var curve = new QuadraticBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCPx, aCPy ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

	},

	bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		var curve = new CubicBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCP1x, aCP1y ),
			new Vector2( aCP2x, aCP2y ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

	},

	splineThru: function ( pts /*Array of Vector*/ ) {

		var npts = [ this.currentPoint.clone() ].concat( pts );

		var curve = new SplineCurve( npts );
		this.curves.push( curve );

		this.currentPoint.copy( pts[ pts.length - 1 ] );

	},

	arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		var x0 = this.currentPoint.x;
		var y0 = this.currentPoint.y;

		this.absarc( aX + x0, aY + y0, aRadius,
			aStartAngle, aEndAngle, aClockwise );

	},

	absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

	},

	ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		var x0 = this.currentPoint.x;
		var y0 = this.currentPoint.y;

		this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

	},

	absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		if ( this.curves.length > 0 ) {

			// if a previous curve is present, attempt to join
			var firstPoint = curve.getPoint( 0 );

			if ( ! firstPoint.equals( this.currentPoint ) ) {

				this.lineTo( firstPoint.x, firstPoint.y );

			}

		}

		this.curves.push( curve );

		var lastPoint = curve.getPoint( 1 );
		this.currentPoint.copy( lastPoint );

	},

	copy: function ( source ) {

		CurvePath.prototype.copy.call( this, source );

		this.currentPoint.copy( source.currentPoint );

		return this;

	},

	toJSON: function () {

		var data = CurvePath.prototype.toJSON.call( this );

		data.currentPoint = this.currentPoint.toArray();

		return data;

	},

	fromJSON: function ( json ) {

		CurvePath.prototype.fromJSON.call( this, json );

		this.currentPoint.fromArray( json.currentPoint );

		return this;

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Defines a 2d shape plane using paths.
 **/

// STEP 1 Create a path.
// STEP 2 Turn path into shape.
// STEP 3 ExtrudeGeometry takes in Shape/Shapes
// STEP 3a - Extract points from each shape, turn to vertices
// STEP 3b - Triangulate each shape, add faces.

function Shape( points ) {

	Path.call( this, points );

	this.uuid = _Math.generateUUID();

	this.type = 'Shape';

	this.holes = [];

}

Shape.prototype = Object.assign( Object.create( Path.prototype ), {

	constructor: Shape,

	getPointsHoles: function ( divisions ) {

		var holesPts = [];

		for ( var i = 0, l = this.holes.length; i < l; i ++ ) {

			holesPts[ i ] = this.holes[ i ].getPoints( divisions );

		}

		return holesPts;

	},

	// get points of shape and holes (keypoints based on segments parameter)

	extractPoints: function ( divisions ) {

		return {

			shape: this.getPoints( divisions ),
			holes: this.getPointsHoles( divisions )

		};

	},

	copy: function ( source ) {

		Path.prototype.copy.call( this, source );

		this.holes = [];

		for ( var i = 0, l = source.holes.length; i < l; i ++ ) {

			var hole = source.holes[ i ];

			this.holes.push( hole.clone() );

		}

		return this;

	},

	toJSON: function () {

		var data = Path.prototype.toJSON.call( this );

		data.uuid = this.uuid;
		data.holes = [];

		for ( var i = 0, l = this.holes.length; i < l; i ++ ) {

			var hole = this.holes[ i ];
			data.holes.push( hole.toJSON() );

		}

		return data;

	},

	fromJSON: function ( json ) {

		Path.prototype.fromJSON.call( this, json );

		this.uuid = json.uuid;
		this.holes = [];

		for ( var i = 0, l = json.holes.length; i < l; i ++ ) {

			var hole = json.holes[ i ];
			this.holes.push( new Path().fromJSON( hole ) );

		}

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Light( color, intensity ) {

	Object3D.call( this );

	this.type = 'Light';

	this.color = new Color( color );
	this.intensity = intensity !== undefined ? intensity : 1;

	this.receiveShadow = undefined;

}

Light.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Light,

	isLight: true,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.intensity = source.intensity;

		return this;

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.color = this.color.getHex();
		data.object.intensity = this.intensity;

		if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

		if ( this.distance !== undefined ) data.object.distance = this.distance;
		if ( this.angle !== undefined ) data.object.angle = this.angle;
		if ( this.decay !== undefined ) data.object.decay = this.decay;
		if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

		if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

		return data;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function HemisphereLight( skyColor, groundColor, intensity ) {

	Light.call( this, skyColor, intensity );

	this.type = 'HemisphereLight';

	this.castShadow = undefined;

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.groundColor = new Color( groundColor );

}

HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: HemisphereLight,

	isHemisphereLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.groundColor.copy( source.groundColor );

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LightShadow( camera ) {

	this.camera = camera;

	this.bias = 0;
	this.radius = 1;

	this.mapSize = new Vector2( 512, 512 );

	this.map = null;
	this.matrix = new Matrix4();

}

Object.assign( LightShadow.prototype, {

	copy: function ( source ) {

		this.camera = source.camera.clone();

		this.bias = source.bias;
		this.radius = source.radius;

		this.mapSize.copy( source.mapSize );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	toJSON: function () {

		var object = {};

		if ( this.bias !== 0 ) object.bias = this.bias;
		if ( this.radius !== 1 ) object.radius = this.radius;
		if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

		object.camera = this.camera.toJSON( false ).object;
		delete object.camera.matrix;

		return object;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function SpotLightShadow() {

	LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );

}

SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

	constructor: SpotLightShadow,

	isSpotLightShadow: true,

	update: function ( light ) {

		var camera = this.camera;

		var fov = _Math.RAD2DEG * 2 * light.angle;
		var aspect = this.mapSize.width / this.mapSize.height;
		var far = light.distance || camera.far;

		if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

			camera.fov = fov;
			camera.aspect = aspect;
			camera.far = far;
			camera.updateProjectionMatrix();

		}

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function SpotLight( color, intensity, distance, angle, penumbra, decay ) {

	Light.call( this, color, intensity );

	this.type = 'SpotLight';

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.target = new Object3D();

	Object.defineProperty( this, 'power', {
		get: function () {

			// intensity = power per solid angle.
			// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			return this.intensity * Math.PI;

		},
		set: function ( power ) {

			// intensity = power per solid angle.
			// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			this.intensity = power / Math.PI;

		}
	} );

	this.distance = ( distance !== undefined ) ? distance : 0;
	this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
	this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
	this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

	this.shadow = new SpotLightShadow();

}

SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: SpotLight,

	isSpotLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.distance = source.distance;
		this.angle = source.angle;
		this.penumbra = source.penumbra;
		this.decay = source.decay;

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */


function PointLight( color, intensity, distance, decay ) {

	Light.call( this, color, intensity );

	this.type = 'PointLight';

	Object.defineProperty( this, 'power', {
		get: function () {

			// intensity = power per solid angle.
			// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			return this.intensity * 4 * Math.PI;

		},
		set: function ( power ) {

			// intensity = power per solid angle.
			// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			this.intensity = power / ( 4 * Math.PI );

		}
	} );

	this.distance = ( distance !== undefined ) ? distance : 0;
	this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

	this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

}

PointLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: PointLight,

	isPointLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.distance = source.distance;
		this.decay = source.decay;

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function DirectionalLightShadow( ) {

	LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

}

DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

	constructor: DirectionalLightShadow

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function DirectionalLight( color, intensity ) {

	Light.call( this, color, intensity );

	this.type = 'DirectionalLight';

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.target = new Object3D();

	this.shadow = new DirectionalLightShadow();

}

DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: DirectionalLight,

	isDirectionalLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AmbientLight( color, intensity ) {

	Light.call( this, color, intensity );

	this.type = 'AmbientLight';

	this.castShadow = undefined;

}

AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: AmbientLight,

	isAmbientLight: true

} );

/**
 * @author abelnation / http://github.com/abelnation
 */

function RectAreaLight( color, intensity, width, height ) {

	Light.call( this, color, intensity );

	this.type = 'RectAreaLight';

	this.position.set( 0, 1, 0 );
	this.updateMatrix();

	this.width = ( width !== undefined ) ? width : 10;
	this.height = ( height !== undefined ) ? height : 10;

	// TODO (abelnation): distance/decay

	// TODO (abelnation): update method for RectAreaLight to update transform to lookat target

	// TODO (abelnation): shadows

}

// TODO (abelnation): RectAreaLight update when light shape is changed
RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: RectAreaLight,

	isRectAreaLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.width = source.width;
		this.height = source.height;

		return this;

	},

	toJSON: function ( meta ) {

		var data = Light.prototype.toJSON.call( this, meta );

		data.object.width = this.width;
		data.object.height = this.height;

		return data;

	}

} );

/**
 *
 * A Track that interpolates Strings
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function StringKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrack.call( this, name, times, values, interpolation );

}

StringKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: StringKeyframeTrack,

	ValueTypeName: 'string',
	ValueBufferType: Array,

	DefaultInterpolation: InterpolateDiscrete,

	InterpolantFactoryMethodLinear: undefined,

	InterpolantFactoryMethodSmooth: undefined

} );

/**
 *
 * A Track of Boolean keyframe values.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function BooleanKeyframeTrack( name, times, values ) {

	KeyframeTrack.call( this, name, times, values );

}

BooleanKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: BooleanKeyframeTrack,

	ValueTypeName: 'bool',
	ValueBufferType: Array,

	DefaultInterpolation: InterpolateDiscrete,

	InterpolantFactoryMethodLinear: undefined,
	InterpolantFactoryMethodSmooth: undefined

	// Note: Actually this track could have a optimized / compressed
	// representation of a single value and a custom interpolant that
	// computes "firstValue ^ isOdd( index )".

} );

/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 * @author tschw
 */

function Interpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	this.parameterPositions = parameterPositions;
	this._cachedIndex = 0;

	this.resultBuffer = resultBuffer !== undefined ?
		resultBuffer : new sampleValues.constructor( sampleSize );
	this.sampleValues = sampleValues;
	this.valueSize = sampleSize;

}

Object.assign( Interpolant.prototype, {

	evaluate: function ( t ) {

		var pp = this.parameterPositions,
			i1 = this._cachedIndex,

			t1 = pp[ i1 ],
			t0 = pp[ i1 - 1 ];

		validate_interval: {

			seek: {

				var right;

				linear_scan: {

					//- See http://jsperf.com/comparison-to-undefined/3
					//- slower code:
					//-
					//- 				if ( t >= t1 || t1 === undefined ) {
					forward_scan: if ( ! ( t < t1 ) ) {

						for ( var giveUpAt = i1 + 2; ; ) {

							if ( t1 === undefined ) {

								if ( t < t0 ) break forward_scan;

								// after end

								i1 = pp.length;
								this._cachedIndex = i1;
								return this.afterEnd_( i1 - 1, t, t0 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t0 = t1;
							t1 = pp[ ++ i1 ];

							if ( t < t1 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the right side of the index
						right = pp.length;
						break linear_scan;

					}

					//- slower code:
					//-					if ( t < t0 || t0 === undefined ) {
					if ( ! ( t >= t0 ) ) {

						// looping?

						var t1global = pp[ 1 ];

						if ( t < t1global ) {

							i1 = 2; // + 1, using the scan for the details
							t0 = t1global;

						}

						// linear reverse scan

						for ( var giveUpAt = i1 - 2; ; ) {

							if ( t0 === undefined ) {

								// before start

								this._cachedIndex = 0;
								return this.beforeStart_( 0, t, t1 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t1 = t0;
							t0 = pp[ -- i1 - 1 ];

							if ( t >= t0 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the left side of the index
						right = i1;
						i1 = 0;
						break linear_scan;

					}

					// the interval is valid

					break validate_interval;

				} // linear scan

				// binary search

				while ( i1 < right ) {

					var mid = ( i1 + right ) >>> 1;

					if ( t < pp[ mid ] ) {

						right = mid;

					} else {

						i1 = mid + 1;

					}

				}

				t1 = pp[ i1 ];
				t0 = pp[ i1 - 1 ];

				// check boundary cases, again

				if ( t0 === undefined ) {

					this._cachedIndex = 0;
					return this.beforeStart_( 0, t, t1 );

				}

				if ( t1 === undefined ) {

					i1 = pp.length;
					this._cachedIndex = i1;
					return this.afterEnd_( i1 - 1, t0, t );

				}

			} // seek

			this._cachedIndex = i1;

			this.intervalChanged_( i1, t0, t1 );

		} // validate_interval

		return this.interpolate_( i1, t0, t, t1 );

	},

	settings: null, // optional, subclass-specific settings structure
	// Note: The indirection allows central control of many interpolants.

	// --- Protected interface

	DefaultSettings_: {},

	getSettings_: function () {

		return this.settings || this.DefaultSettings_;

	},

	copySampleValue_: function ( index ) {

		// copies a sample value to the result buffer

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,
			offset = index * stride;

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	},

	// Template methods for derived classes:

	interpolate_: function ( /* i1, t0, t, t1 */ ) {

		throw new Error( 'call to abstract method' );
		// implementations shall return this.resultBuffer

	},

	intervalChanged_: function ( /* i1, t0, t1 */ ) {

		// empty

	}

} );

//!\ DECLARE ALIAS AFTER assign prototype !
Object.assign( Interpolant.prototype, {

	//( 0, t, t0 ), returns this.resultBuffer
	beforeStart_: Interpolant.prototype.copySampleValue_,

	//( N-1, tN-1, t ), returns this.resultBuffer
	afterEnd_: Interpolant.prototype.copySampleValue_,

} );

/**
 * Spherical linear unit quaternion interpolant.
 *
 * @author tschw
 */

function QuaternionLinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

QuaternionLinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

	constructor: QuaternionLinearInterpolant,

	interpolate_: function ( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset = i1 * stride,

			alpha = ( t - t0 ) / ( t1 - t0 );

		for ( var end = offset + stride; offset !== end; offset += 4 ) {

			Quaternion.slerpFlat( result, 0, values, offset - stride, values, offset, alpha );

		}

		return result;

	}

} );

/**
 *
 * A Track of quaternion keyframe values.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function QuaternionKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrack.call( this, name, times, values, interpolation );

}

QuaternionKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: QuaternionKeyframeTrack,

	ValueTypeName: 'quaternion',

	// ValueBufferType is inherited

	DefaultInterpolation: InterpolateLinear,

	InterpolantFactoryMethodLinear: function ( result ) {

		return new QuaternionLinearInterpolant( this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodSmooth: undefined // not yet implemented

} );

/**
 *
 * A Track of keyframe values that represent color.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function ColorKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrack.call( this, name, times, values, interpolation );

}

ColorKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: ColorKeyframeTrack,

	ValueTypeName: 'color'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited

	// Note: Very basic implementation and nothing special yet.
	// However, this is the place for color space parameterization.

} );

/**
 *
 * A Track of numeric keyframe values.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function NumberKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrack.call( this, name, times, values, interpolation );

}

NumberKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: NumberKeyframeTrack,

	ValueTypeName: 'number'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited

} );

/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @author tschw
 */

function CubicInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	this._weightPrev = - 0;
	this._offsetPrev = - 0;
	this._weightNext = - 0;
	this._offsetNext = - 0;

}

CubicInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

	constructor: CubicInterpolant,

	DefaultSettings_: {

		endingStart: ZeroCurvatureEnding,
		endingEnd: ZeroCurvatureEnding

	},

	intervalChanged_: function ( i1, t0, t1 ) {

		var pp = this.parameterPositions,
			iPrev = i1 - 2,
			iNext = i1 + 1,

			tPrev = pp[ iPrev ],
			tNext = pp[ iNext ];

		if ( tPrev === undefined ) {

			switch ( this.getSettings_().endingStart ) {

				case ZeroSlopeEnding:

					// f'(t0) = 0
					iPrev = i1;
					tPrev = 2 * t0 - t1;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iPrev = pp.length - 2;
					tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(t0) = 0 a.k.a. Natural Spline
					iPrev = i1;
					tPrev = t1;

			}

		}

		if ( tNext === undefined ) {

			switch ( this.getSettings_().endingEnd ) {

				case ZeroSlopeEnding:

					// f'(tN) = 0
					iNext = i1;
					tNext = 2 * t1 - t0;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iNext = 1;
					tNext = t1 + pp[ 1 ] - pp[ 0 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(tN) = 0, a.k.a. Natural Spline
					iNext = i1 - 1;
					tNext = t0;

			}

		}

		var halfDt = ( t1 - t0 ) * 0.5,
			stride = this.valueSize;

		this._weightPrev = halfDt / ( t0 - tPrev );
		this._weightNext = halfDt / ( tNext - t1 );
		this._offsetPrev = iPrev * stride;
		this._offsetNext = iNext * stride;

	},

	interpolate_: function ( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			o1 = i1 * stride,		o0 = o1 - stride,
			oP = this._offsetPrev, 	oN = this._offsetNext,
			wP = this._weightPrev,	wN = this._weightNext,

			p = ( t - t0 ) / ( t1 - t0 ),
			pp = p * p,
			ppp = pp * p;

		// evaluate polynomials

		var sP = - wP * ppp + 2 * wP * pp - wP * p;
		var s0 = ( 1 + wP ) * ppp + ( - 1.5 - 2 * wP ) * pp + ( - 0.5 + wP ) * p + 1;
		var s1 = ( - 1 - wN ) * ppp + ( 1.5 + wN ) * pp + 0.5 * p;
		var sN = wN * ppp - wN * pp;

		// combine data linearly

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] =
					sP * values[ oP + i ] +
					s0 * values[ o0 + i ] +
					s1 * values[ o1 + i ] +
					sN * values[ oN + i ];

		}

		return result;

	}

} );

/**
 * @author tschw
 */

function LinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

LinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

	constructor: LinearInterpolant,

	interpolate_: function ( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset1 = i1 * stride,
			offset0 = offset1 - stride,

			weight1 = ( t - t0 ) / ( t1 - t0 ),
			weight0 = 1 - weight1;

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] =
					values[ offset0 + i ] * weight0 +
					values[ offset1 + i ] * weight1;

		}

		return result;

	}

} );

/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 *
 * @author tschw
 */

function DiscreteInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

DiscreteInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

	constructor: DiscreteInterpolant,

	interpolate_: function ( i1 /*, t0, t, t1 */ ) {

		return this.copySampleValue_( i1 - 1 );

	}

} );

/**
 * @author tschw
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 */

var AnimationUtils = {

	// same as Array.prototype.slice, but also works on typed arrays
	arraySlice: function ( array, from, to ) {

		if ( AnimationUtils.isTypedArray( array ) ) {

			// in ios9 array.subarray(from, undefined) will return empty array
			// but array.subarray(from) or array.subarray(from, len) is correct
			return new array.constructor( array.subarray( from, to !== undefined ? to : array.length ) );

		}

		return array.slice( from, to );

	},

	// converts an array to a specific type
	convertArray: function ( array, type, forceClone ) {

		if ( ! array || // let 'undefined' and 'null' pass
				! forceClone && array.constructor === type ) return array;

		if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

			return new type( array ); // create typed array

		}

		return Array.prototype.slice.call( array ); // create Array

	},

	isTypedArray: function ( object ) {

		return ArrayBuffer.isView( object ) &&
				! ( object instanceof DataView );

	},

	// returns an array by which times and values can be sorted
	getKeyframeOrder: function ( times ) {

		function compareTime( i, j ) {

			return times[ i ] - times[ j ];

		}

		var n = times.length;
		var result = new Array( n );
		for ( var i = 0; i !== n; ++ i ) result[ i ] = i;

		result.sort( compareTime );

		return result;

	},

	// uses the array previously returned by 'getKeyframeOrder' to sort data
	sortedArray: function ( values, stride, order ) {

		var nValues = values.length;
		var result = new values.constructor( nValues );

		for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

			var srcOffset = order[ i ] * stride;

			for ( var j = 0; j !== stride; ++ j ) {

				result[ dstOffset ++ ] = values[ srcOffset + j ];

			}

		}

		return result;

	},

	// function for parsing AOS keyframe formats
	flattenJSON: function ( jsonKeys, times, values, valuePropertyName ) {

		var i = 1, key = jsonKeys[ 0 ];

		while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

			key = jsonKeys[ i ++ ];

		}

		if ( key === undefined ) return; // no data

		var value = key[ valuePropertyName ];
		if ( value === undefined ) return; // no data

		if ( Array.isArray( value ) ) {

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					values.push.apply( values, value ); // push all elements

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		} else if ( value.toArray !== undefined ) {

			// ...assume THREE.Math-ish

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					value.toArray( values, values.length );

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		} else {

			// otherwise push as-is

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					values.push( value );

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		}

	}

};

/**
 *
 * A timed sequence of keyframes for a specific property.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function KeyframeTrack( name, times, values, interpolation ) {

	if ( name === undefined ) throw new Error( 'THREE.KeyframeTrack: track name is undefined' );
	if ( times === undefined || times.length === 0 ) throw new Error( 'THREE.KeyframeTrack: no keyframes in track named ' + name );

	this.name = name;

	this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
	this.values = AnimationUtils.convertArray( values, this.ValueBufferType );

	this.setInterpolation( interpolation || this.DefaultInterpolation );

	this.validate();
	this.optimize();

}

// Static methods:

Object.assign( KeyframeTrack, {

	// Serialization (in static context, because of constructor invocation
	// and automatic invocation of .toJSON):

	parse: function ( json ) {

		if ( json.type === undefined ) {

			throw new Error( 'THREE.KeyframeTrack: track type undefined, can not parse' );

		}

		var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );

		if ( json.times === undefined ) {

			var times = [], values = [];

			AnimationUtils.flattenJSON( json.keys, times, values, 'value' );

			json.times = times;
			json.values = values;

		}

		// derived classes can define a static parse method
		if ( trackType.parse !== undefined ) {

			return trackType.parse( json );

		} else {

			// by default, we assume a constructor compatible with the base
			return new trackType( json.name, json.times, json.values, json.interpolation );

		}

	},

	toJSON: function ( track ) {

		var trackType = track.constructor;

		var json;

		// derived classes can define a static toJSON method
		if ( trackType.toJSON !== undefined ) {

			json = trackType.toJSON( track );

		} else {

			// by default, we assume the data can be serialized as-is
			json = {

				'name': track.name,
				'times': AnimationUtils.convertArray( track.times, Array ),
				'values': AnimationUtils.convertArray( track.values, Array )

			};

			var interpolation = track.getInterpolation();

			if ( interpolation !== track.DefaultInterpolation ) {

				json.interpolation = interpolation;

			}

		}

		json.type = track.ValueTypeName; // mandatory

		return json;

	},

	_getTrackTypeForValueTypeName: function ( typeName ) {

		switch ( typeName.toLowerCase() ) {

			case 'scalar':
			case 'double':
			case 'float':
			case 'number':
			case 'integer':

				return NumberKeyframeTrack;

			case 'vector':
			case 'vector2':
			case 'vector3':
			case 'vector4':

				return VectorKeyframeTrack;

			case 'color':

				return ColorKeyframeTrack;

			case 'quaternion':

				return QuaternionKeyframeTrack;

			case 'bool':
			case 'boolean':

				return BooleanKeyframeTrack;

			case 'string':

				return StringKeyframeTrack;

		}

		throw new Error( 'THREE.KeyframeTrack: Unsupported typeName: ' + typeName );

	}

} );

Object.assign( KeyframeTrack.prototype, {

	constructor: KeyframeTrack,

	TimeBufferType: Float32Array,

	ValueBufferType: Float32Array,

	DefaultInterpolation: InterpolateLinear,

	InterpolantFactoryMethodDiscrete: function ( result ) {

		return new DiscreteInterpolant( this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodLinear: function ( result ) {

		return new LinearInterpolant( this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodSmooth: function ( result ) {

		return new CubicInterpolant( this.times, this.values, this.getValueSize(), result );

	},

	setInterpolation: function ( interpolation ) {

		var factoryMethod;

		switch ( interpolation ) {

			case InterpolateDiscrete:

				factoryMethod = this.InterpolantFactoryMethodDiscrete;

				break;

			case InterpolateLinear:

				factoryMethod = this.InterpolantFactoryMethodLinear;

				break;

			case InterpolateSmooth:

				factoryMethod = this.InterpolantFactoryMethodSmooth;

				break;

		}

		if ( factoryMethod === undefined ) {

			var message = "unsupported interpolation for " +
				this.ValueTypeName + " keyframe track named " + this.name;

			if ( this.createInterpolant === undefined ) {

				// fall back to default, unless the default itself is messed up
				if ( interpolation !== this.DefaultInterpolation ) {

					this.setInterpolation( this.DefaultInterpolation );

				} else {

					throw new Error( message ); // fatal, in this case

				}

			}

			console.warn( 'THREE.KeyframeTrack:', message );
			return;

		}

		this.createInterpolant = factoryMethod;

	},

	getInterpolation: function () {

		switch ( this.createInterpolant ) {

			case this.InterpolantFactoryMethodDiscrete:

				return InterpolateDiscrete;

			case this.InterpolantFactoryMethodLinear:

				return InterpolateLinear;

			case this.InterpolantFactoryMethodSmooth:

				return InterpolateSmooth;

		}

	},

	getValueSize: function () {

		return this.values.length / this.times.length;

	},

	// move all keyframes either forwards or backwards in time
	shift: function ( timeOffset ) {

		if ( timeOffset !== 0.0 ) {

			var times = this.times;

			for ( var i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] += timeOffset;

			}

		}

		return this;

	},

	// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
	scale: function ( timeScale ) {

		if ( timeScale !== 1.0 ) {

			var times = this.times;

			for ( var i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] *= timeScale;

			}

		}

		return this;

	},

	// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
	// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
	trim: function ( startTime, endTime ) {

		var times = this.times,
			nKeys = times.length,
			from = 0,
			to = nKeys - 1;

		while ( from !== nKeys && times[ from ] < startTime ) {

			++ from;

		}

		while ( to !== - 1 && times[ to ] > endTime ) {

			-- to;

		}

		++ to; // inclusive -> exclusive bound

		if ( from !== 0 || to !== nKeys ) {

			// empty tracks are forbidden, so keep at least one keyframe
			if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;

			var stride = this.getValueSize();
			this.times = AnimationUtils.arraySlice( times, from, to );
			this.values = AnimationUtils.arraySlice( this.values, from * stride, to * stride );

		}

		return this;

	},

	// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
	validate: function () {

		var valid = true;

		var valueSize = this.getValueSize();
		if ( valueSize - Math.floor( valueSize ) !== 0 ) {

			console.error( 'THREE.KeyframeTrack: Invalid value size in track.', this );
			valid = false;

		}

		var times = this.times,
			values = this.values,

			nKeys = times.length;

		if ( nKeys === 0 ) {

			console.error( 'THREE.KeyframeTrack: Track is empty.', this );
			valid = false;

		}

		var prevTime = null;

		for ( var i = 0; i !== nKeys; i ++ ) {

			var currTime = times[ i ];

			if ( typeof currTime === 'number' && isNaN( currTime ) ) {

				console.error( 'THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime );
				valid = false;
				break;

			}

			if ( prevTime !== null && prevTime > currTime ) {

				console.error( 'THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime );
				valid = false;
				break;

			}

			prevTime = currTime;

		}

		if ( values !== undefined ) {

			if ( AnimationUtils.isTypedArray( values ) ) {

				for ( var i = 0, n = values.length; i !== n; ++ i ) {

					var value = values[ i ];

					if ( isNaN( value ) ) {

						console.error( 'THREE.KeyframeTrack: Value is not a valid number.', this, i, value );
						valid = false;
						break;

					}

				}

			}

		}

		return valid;

	},

	// removes equivalent sequential keys as common in morph target sequences
	// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
	optimize: function () {

		var times = this.times,
			values = this.values,
			stride = this.getValueSize(),

			smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

			writeIndex = 1,
			lastIndex = times.length - 1;

		for ( var i = 1; i < lastIndex; ++ i ) {

			var keep = false;

			var time = times[ i ];
			var timeNext = times[ i + 1 ];

			// remove adjacent keyframes scheduled at the same time

			if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {

				if ( ! smoothInterpolation ) {

					// remove unnecessary keyframes same as their neighbors

					var offset = i * stride,
						offsetP = offset - stride,
						offsetN = offset + stride;

					for ( var j = 0; j !== stride; ++ j ) {

						var value = values[ offset + j ];

						if ( value !== values[ offsetP + j ] ||
							value !== values[ offsetN + j ] ) {

							keep = true;
							break;

						}

					}

				} else {

					keep = true;

				}

			}

			// in-place compaction

			if ( keep ) {

				if ( i !== writeIndex ) {

					times[ writeIndex ] = times[ i ];

					var readOffset = i * stride,
						writeOffset = writeIndex * stride;

					for ( var j = 0; j !== stride; ++ j ) {

						values[ writeOffset + j ] = values[ readOffset + j ];

					}

				}

				++ writeIndex;

			}

		}

		// flush last keyframe (compaction looks ahead)

		if ( lastIndex > 0 ) {

			times[ writeIndex ] = times[ lastIndex ];

			for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j ) {

				values[ writeOffset + j ] = values[ readOffset + j ];

			}

			++ writeIndex;

		}

		if ( writeIndex !== times.length ) {

			this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
			this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );

		}

		return this;

	}

} );

/**
 *
 * A Track of vectored keyframe values.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function VectorKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrack.call( this, name, times, values, interpolation );

}

VectorKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {

	constructor: VectorKeyframeTrack,

	ValueTypeName: 'vector'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited

} );

/**
 *
 * Reusable set of Tracks that represent an animation.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 */

function AnimationClip( name, duration, tracks ) {

	this.name = name;
	this.tracks = tracks;
	this.duration = ( duration !== undefined ) ? duration : - 1;

	this.uuid = _Math.generateUUID();

	// this means it should figure out its duration by scanning the tracks
	if ( this.duration < 0 ) {

		this.resetDuration();

	}

	this.optimize();

}

Object.assign( AnimationClip, {

	parse: function ( json ) {

		var tracks = [],
			jsonTracks = json.tracks,
			frameTime = 1.0 / ( json.fps || 1.0 );

		for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );

		}

		return new AnimationClip( json.name, json.duration, tracks );

	},

	toJSON: function ( clip ) {

		var tracks = [],
			clipTracks = clip.tracks;

		var json = {

			'name': clip.name,
			'duration': clip.duration,
			'tracks': tracks

		};

		for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

		}

		return json;

	},

	CreateFromMorphTargetSequence: function ( name, morphTargetSequence, fps, noLoop ) {

		var numMorphTargets = morphTargetSequence.length;
		var tracks = [];

		for ( var i = 0; i < numMorphTargets; i ++ ) {

			var times = [];
			var values = [];

			times.push(
				( i + numMorphTargets - 1 ) % numMorphTargets,
				i,
				( i + 1 ) % numMorphTargets );

			values.push( 0, 1, 0 );

			var order = AnimationUtils.getKeyframeOrder( times );
			times = AnimationUtils.sortedArray( times, 1, order );
			values = AnimationUtils.sortedArray( values, 1, order );

			// if there is a key at the first frame, duplicate it as the
			// last frame as well for perfect loop.
			if ( ! noLoop && times[ 0 ] === 0 ) {

				times.push( numMorphTargets );
				values.push( values[ 0 ] );

			}

			tracks.push(
				new NumberKeyframeTrack(
					'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
					times, values
				).scale( 1.0 / fps ) );

		}

		return new AnimationClip( name, - 1, tracks );

	},

	findByName: function ( objectOrClipArray, name ) {

		var clipArray = objectOrClipArray;

		if ( ! Array.isArray( objectOrClipArray ) ) {

			var o = objectOrClipArray;
			clipArray = o.geometry && o.geometry.animations || o.animations;

		}

		for ( var i = 0; i < clipArray.length; i ++ ) {

			if ( clipArray[ i ].name === name ) {

				return clipArray[ i ];

			}

		}

		return null;

	},

	CreateClipsFromMorphTargetSequences: function ( morphTargets, fps, noLoop ) {

		var animationToMorphTargets = {};

		// tested with https://regex101.com/ on trick sequences
		// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
		var pattern = /^([\w-]*?)([\d]+)$/;

		// sort morph target names into animation groups based
		// patterns like Walk_001, Walk_002, Run_001, Run_002
		for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {

			var morphTarget = morphTargets[ i ];
			var parts = morphTarget.name.match( pattern );

			if ( parts && parts.length > 1 ) {

				var name = parts[ 1 ];

				var animationMorphTargets = animationToMorphTargets[ name ];
				if ( ! animationMorphTargets ) {

					animationToMorphTargets[ name ] = animationMorphTargets = [];

				}

				animationMorphTargets.push( morphTarget );

			}

		}

		var clips = [];

		for ( var name in animationToMorphTargets ) {

			clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

		}

		return clips;

	},

	// parse the animation.hierarchy format
	parseAnimation: function ( animation, bones ) {

		if ( ! animation ) {

			console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
			return null;

		}

		var addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {

			// only return track if there are actually keys.
			if ( animationKeys.length !== 0 ) {

				var times = [];
				var values = [];

				AnimationUtils.flattenJSON( animationKeys, times, values, propertyName );

				// empty keys are filtered out, so check again
				if ( times.length !== 0 ) {

					destTracks.push( new trackType( trackName, times, values ) );

				}

			}

		};

		var tracks = [];

		var clipName = animation.name || 'default';
		// automatic length determination in AnimationClip.
		var duration = animation.length || - 1;
		var fps = animation.fps || 30;

		var hierarchyTracks = animation.hierarchy || [];

		for ( var h = 0; h < hierarchyTracks.length; h ++ ) {

			var animationKeys = hierarchyTracks[ h ].keys;

			// skip empty tracks
			if ( ! animationKeys || animationKeys.length === 0 ) continue;

			// process morph targets
			if ( animationKeys[ 0 ].morphTargets ) {

				// figure out all morph targets used in this track
				var morphTargetNames = {};

				for ( var k = 0; k < animationKeys.length; k ++ ) {

					if ( animationKeys[ k ].morphTargets ) {

						for ( var m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {

							morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;

						}

					}

				}

				// create a track for each morph target with all zero
				// morphTargetInfluences except for the keys in which
				// the morphTarget is named.
				for ( var morphTargetName in morphTargetNames ) {

					var times = [];
					var values = [];

					for ( var m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {

						var animationKey = animationKeys[ k ];

						times.push( animationKey.time );
						values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

					}

					tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

				}

				duration = morphTargetNames.length * ( fps || 1.0 );

			} else {

				// ...assume skeletal animation

				var boneName = '.bones[' + bones[ h ].name + ']';

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.position',
					animationKeys, 'pos', tracks );

				addNonemptyTrack(
					QuaternionKeyframeTrack, boneName + '.quaternion',
					animationKeys, 'rot', tracks );

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.scale',
					animationKeys, 'scl', tracks );

			}

		}

		if ( tracks.length === 0 ) {

			return null;

		}

		var clip = new AnimationClip( clipName, duration, tracks );

		return clip;

	}

} );

Object.assign( AnimationClip.prototype, {

	resetDuration: function () {

		var tracks = this.tracks, duration = 0;

		for ( var i = 0, n = tracks.length; i !== n; ++ i ) {

			var track = this.tracks[ i ];

			duration = Math.max( duration, track.times[ track.times.length - 1 ] );

		}

		this.duration = duration;

	},

	trim: function () {

		for ( var i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].trim( 0, this.duration );

		}

		return this;

	},

	optimize: function () {

		for ( var i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].optimize();

		}

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function MaterialLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	this.textures = {};

}

Object.assign( MaterialLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( JSON.parse( text ) ) );

		}, onProgress, onError );

	},

	setTextures: function ( value ) {

		this.textures = value;

	},

	parse: function ( json ) {

		var textures = this.textures;

		function getTexture( name ) {

			if ( textures[ name ] === undefined ) {

				console.warn( 'THREE.MaterialLoader: Undefined texture', name );

			}

			return textures[ name ];

		}

		var material = new Materials[ json.type ]();

		if ( json.uuid !== undefined ) material.uuid = json.uuid;
		if ( json.name !== undefined ) material.name = json.name;
		if ( json.color !== undefined ) material.color.setHex( json.color );
		if ( json.roughness !== undefined ) material.roughness = json.roughness;
		if ( json.metalness !== undefined ) material.metalness = json.metalness;
		if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
		if ( json.specular !== undefined ) material.specular.setHex( json.specular );
		if ( json.shininess !== undefined ) material.shininess = json.shininess;
		if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
		if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
		if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
		if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
		if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
		if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
		if ( json.fog !== undefined ) material.fog = json.fog;
		if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
		if ( json.blending !== undefined ) material.blending = json.blending;
		if ( json.side !== undefined ) material.side = json.side;
		if ( json.opacity !== undefined ) material.opacity = json.opacity;
		if ( json.transparent !== undefined ) material.transparent = json.transparent;
		if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
		if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
		if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
		if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
		if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
		if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
		if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
		if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;

		if ( json.rotation !== undefined ) material.rotation = json.rotation;

		if ( json.linewidth !== 1 ) material.linewidth = json.linewidth;
		if ( json.dashSize !== undefined ) material.dashSize = json.dashSize;
		if ( json.gapSize !== undefined ) material.gapSize = json.gapSize;
		if ( json.scale !== undefined ) material.scale = json.scale;

		if ( json.skinning !== undefined ) material.skinning = json.skinning;
		if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;
		if ( json.dithering !== undefined ) material.dithering = json.dithering;

		if ( json.visible !== undefined ) material.visible = json.visible;
		if ( json.userData !== undefined ) material.userData = json.userData;

		// Deprecated

		if ( json.shading !== undefined ) material.flatShading = json.shading === 1; // THREE.FlatShading

		// for PointsMaterial

		if ( json.size !== undefined ) material.size = json.size;
		if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

		// maps

		if ( json.map !== undefined ) material.map = getTexture( json.map );

		if ( json.alphaMap !== undefined ) {

			material.alphaMap = getTexture( json.alphaMap );
			material.transparent = true;

		}

		if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
		if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

		if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
		if ( json.normalScale !== undefined ) {

			var normalScale = json.normalScale;

			if ( Array.isArray( normalScale ) === false ) {

				// Blender exporter used to export a scalar. See #7459

				normalScale = [ normalScale, normalScale ];

			}

			material.normalScale = new Vector2().fromArray( normalScale );

		}

		if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
		if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
		if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

		if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
		if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

		if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
		if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

		if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );

		if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );

		if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;

		if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
		if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

		if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
		if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

		if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

		return material;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function BufferGeometryLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( BufferGeometryLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( JSON.parse( text ) ) );

		}, onProgress, onError );

	},

	parse: function ( json ) {

		var geometry = new BufferGeometry();

		var index = json.data.index;

		if ( index !== undefined ) {

			var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
			geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

		}

		var attributes = json.data.attributes;

		for ( var key in attributes ) {

			var attribute = attributes[ key ];
			var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );

			geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );

		}

		var groups = json.data.groups || json.data.drawcalls || json.data.offsets;

		if ( groups !== undefined ) {

			for ( var i = 0, n = groups.length; i !== n; ++ i ) {

				var group = groups[ i ];

				geometry.addGroup( group.start, group.count, group.materialIndex );

			}

		}

		var boundingSphere = json.data.boundingSphere;

		if ( boundingSphere !== undefined ) {

			var center = new Vector3();

			if ( boundingSphere.center !== undefined ) {

				center.fromArray( boundingSphere.center );

			}

			geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

		}

		return geometry;

	}

} );

var TYPED_ARRAYS = {
	Int8Array: Int8Array,
	Uint8Array: Uint8Array,
	// Workaround for IE11 pre KB2929437. See #11440
	Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
	Int16Array: Int16Array,
	Uint16Array: Uint16Array,
	Int32Array: Int32Array,
	Uint32Array: Uint32Array,
	Float32Array: Float32Array,
	Float64Array: Float64Array
};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Loader() {

	this.onLoadStart = function () {};
	this.onLoadProgress = function () {};
	this.onLoadComplete = function () {};

}

Loader.Handlers = {

	handlers: [],

	add: function ( regex, loader ) {

		this.handlers.push( regex, loader );

	},

	get: function ( file ) {

		var handlers = this.handlers;

		for ( var i = 0, l = handlers.length; i < l; i += 2 ) {

			var regex = handlers[ i ];
			var loader = handlers[ i + 1 ];

			if ( regex.test( file ) ) {

				return loader;

			}

		}

		return null;

	}

};

Object.assign( Loader.prototype, {

	crossOrigin: undefined,

	initMaterials: function ( materials, texturePath, crossOrigin ) {

		var array = [];

		for ( var i = 0; i < materials.length; ++ i ) {

			array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );

		}

		return array;

	},

	createMaterial: ( function () {

		var BlendingMode = {
			NoBlending: NoBlending,
			NormalBlending: NormalBlending,
			AdditiveBlending: AdditiveBlending,
			SubtractiveBlending: SubtractiveBlending,
			MultiplyBlending: MultiplyBlending,
			CustomBlending: CustomBlending
		};

		var color = new Color();
		var textureLoader = new TextureLoader();
		var materialLoader = new MaterialLoader();

		return function createMaterial( m, texturePath, crossOrigin ) {

			// convert from old material format

			var textures = {};

			function loadTexture( path, repeat, offset, wrap, anisotropy ) {

				var fullPath = texturePath + path;
				var loader = Loader.Handlers.get( fullPath );

				var texture;

				if ( loader !== null ) {

					texture = loader.load( fullPath );

				} else {

					textureLoader.setCrossOrigin( crossOrigin );
					texture = textureLoader.load( fullPath );

				}

				if ( repeat !== undefined ) {

					texture.repeat.fromArray( repeat );

					if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
					if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;

				}

				if ( offset !== undefined ) {

					texture.offset.fromArray( offset );

				}

				if ( wrap !== undefined ) {

					if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
					if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;

					if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
					if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;

				}

				if ( anisotropy !== undefined ) {

					texture.anisotropy = anisotropy;

				}

				var uuid = _Math.generateUUID();

				textures[ uuid ] = texture;

				return uuid;

			}

			//

			var json = {
				uuid: _Math.generateUUID(),
				type: 'MeshLambertMaterial'
			};

			for ( var name in m ) {

				var value = m[ name ];

				switch ( name ) {

					case 'DbgColor':
					case 'DbgIndex':
					case 'opticalDensity':
					case 'illumination':
						break;
					case 'DbgName':
						json.name = value;
						break;
					case 'blending':
						json.blending = BlendingMode[ value ];
						break;
					case 'colorAmbient':
					case 'mapAmbient':
						console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
						break;
					case 'colorDiffuse':
						json.color = color.fromArray( value ).getHex();
						break;
					case 'colorSpecular':
						json.specular = color.fromArray( value ).getHex();
						break;
					case 'colorEmissive':
						json.emissive = color.fromArray( value ).getHex();
						break;
					case 'specularCoef':
						json.shininess = value;
						break;
					case 'shading':
						if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
						if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
						if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
						break;
					case 'mapDiffuse':
						json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
						break;
					case 'mapDiffuseRepeat':
					case 'mapDiffuseOffset':
					case 'mapDiffuseWrap':
					case 'mapDiffuseAnisotropy':
						break;
					case 'mapEmissive':
						json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
						break;
					case 'mapEmissiveRepeat':
					case 'mapEmissiveOffset':
					case 'mapEmissiveWrap':
					case 'mapEmissiveAnisotropy':
						break;
					case 'mapLight':
						json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
						break;
					case 'mapLightRepeat':
					case 'mapLightOffset':
					case 'mapLightWrap':
					case 'mapLightAnisotropy':
						break;
					case 'mapAO':
						json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
						break;
					case 'mapAORepeat':
					case 'mapAOOffset':
					case 'mapAOWrap':
					case 'mapAOAnisotropy':
						break;
					case 'mapBump':
						json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
						break;
					case 'mapBumpScale':
						json.bumpScale = value;
						break;
					case 'mapBumpRepeat':
					case 'mapBumpOffset':
					case 'mapBumpWrap':
					case 'mapBumpAnisotropy':
						break;
					case 'mapNormal':
						json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
						break;
					case 'mapNormalFactor':
						json.normalScale = [ value, value ];
						break;
					case 'mapNormalRepeat':
					case 'mapNormalOffset':
					case 'mapNormalWrap':
					case 'mapNormalAnisotropy':
						break;
					case 'mapSpecular':
						json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
						break;
					case 'mapSpecularRepeat':
					case 'mapSpecularOffset':
					case 'mapSpecularWrap':
					case 'mapSpecularAnisotropy':
						break;
					case 'mapMetalness':
						json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
						break;
					case 'mapMetalnessRepeat':
					case 'mapMetalnessOffset':
					case 'mapMetalnessWrap':
					case 'mapMetalnessAnisotropy':
						break;
					case 'mapRoughness':
						json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
						break;
					case 'mapRoughnessRepeat':
					case 'mapRoughnessOffset':
					case 'mapRoughnessWrap':
					case 'mapRoughnessAnisotropy':
						break;
					case 'mapAlpha':
						json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
						break;
					case 'mapAlphaRepeat':
					case 'mapAlphaOffset':
					case 'mapAlphaWrap':
					case 'mapAlphaAnisotropy':
						break;
					case 'flipSided':
						json.side = BackSide;
						break;
					case 'doubleSided':
						json.side = DoubleSide;
						break;
					case 'transparency':
						console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
						json.opacity = value;
						break;
					case 'depthTest':
					case 'depthWrite':
					case 'colorWrite':
					case 'opacity':
					case 'reflectivity':
					case 'transparent':
					case 'visible':
					case 'wireframe':
						json[ name ] = value;
						break;
					case 'vertexColors':
						if ( value === true ) json.vertexColors = VertexColors;
						if ( value === 'face' ) json.vertexColors = FaceColors;
						break;
					default:
						console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
						break;

				}

			}

			if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
			if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;

			if ( json.opacity < 1 ) json.transparent = true;

			materialLoader.setTextures( textures );

			return materialLoader.parse( json );

		};

	} )()

} );

/**
 * @author Don McCurdy / https://www.donmccurdy.com
 */

var LoaderUtils = {

	decodeText: function ( array ) {

		if ( typeof TextDecoder !== 'undefined' ) {

			return new TextDecoder().decode( array );

		}

		// Avoid the String.fromCharCode.apply(null, array) shortcut, which
		// throws a "maximum call stack size exceeded" error for large arrays.

		var s = '';

		for ( var i = 0, il = array.length; i < il; i ++ ) {

			// Implicitly assumes little-endian.
			s += String.fromCharCode( array[ i ] );

		}

		return s;

	},

	extractUrlBase: function ( url ) {

		var parts = url.split( '/' );

		if ( parts.length === 1 ) return './';

		parts.pop();

		return parts.join( '/' ) + '/';

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function JSONLoader( manager ) {

	if ( typeof manager === 'boolean' ) {

		console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
		manager = undefined;

	}

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	this.withCredentials = false;

}

Object.assign( JSONLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var texturePath = this.texturePath && ( typeof this.texturePath === 'string' ) ? this.texturePath : LoaderUtils.extractUrlBase( url );

		var loader = new FileLoader( this.manager );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			var json = JSON.parse( text );
			var metadata = json.metadata;

			if ( metadata !== undefined ) {

				var type = metadata.type;

				if ( type !== undefined ) {

					if ( type.toLowerCase() === 'object' ) {

						console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
						return;

					}

					if ( type.toLowerCase() === 'scene' ) {

						console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
						return;

					}

				}

			}

			var object = scope.parse( json, texturePath );
			onLoad( object.geometry, object.materials );

		}, onProgress, onError );

	},

	setTexturePath: function ( value ) {

		this.texturePath = value;

	},

	parse: ( function () {

		function parseModel( json, geometry ) {

			function isBitSet( value, position ) {

				return value & ( 1 << position );

			}

			var i, j, fi,

				offset, zLength,

				colorIndex, normalIndex, uvIndex, materialIndex,

				type,
				isQuad,
				hasMaterial,
				hasFaceVertexUv,
				hasFaceNormal, hasFaceVertexNormal,
				hasFaceColor, hasFaceVertexColor,

				vertex, face, faceA, faceB, hex, normal,

				uvLayer, uv, u, v,

				faces = json.faces,
				vertices = json.vertices,
				normals = json.normals,
				colors = json.colors,

				scale = json.scale,

				nUvLayers = 0;


			if ( json.uvs !== undefined ) {

				// disregard empty arrays

				for ( i = 0; i < json.uvs.length; i ++ ) {

					if ( json.uvs[ i ].length ) nUvLayers ++;

				}

				for ( i = 0; i < nUvLayers; i ++ ) {

					geometry.faceVertexUvs[ i ] = [];

				}

			}

			offset = 0;
			zLength = vertices.length;

			while ( offset < zLength ) {

				vertex = new Vector3();

				vertex.x = vertices[ offset ++ ] * scale;
				vertex.y = vertices[ offset ++ ] * scale;
				vertex.z = vertices[ offset ++ ] * scale;

				geometry.vertices.push( vertex );

			}

			offset = 0;
			zLength = faces.length;

			while ( offset < zLength ) {

				type = faces[ offset ++ ];

				isQuad = isBitSet( type, 0 );
				hasMaterial = isBitSet( type, 1 );
				hasFaceVertexUv = isBitSet( type, 3 );
				hasFaceNormal = isBitSet( type, 4 );
				hasFaceVertexNormal = isBitSet( type, 5 );
				hasFaceColor = isBitSet( type, 6 );
				hasFaceVertexColor = isBitSet( type, 7 );

				// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);

				if ( isQuad ) {

					faceA = new Face3();
					faceA.a = faces[ offset ];
					faceA.b = faces[ offset + 1 ];
					faceA.c = faces[ offset + 3 ];

					faceB = new Face3();
					faceB.a = faces[ offset + 1 ];
					faceB.b = faces[ offset + 2 ];
					faceB.c = faces[ offset + 3 ];

					offset += 4;

					if ( hasMaterial ) {

						materialIndex = faces[ offset ++ ];
						faceA.materialIndex = materialIndex;
						faceB.materialIndex = materialIndex;

					}

					// to get face <=> uv index correspondence

					fi = geometry.faces.length;

					if ( hasFaceVertexUv ) {

						for ( i = 0; i < nUvLayers; i ++ ) {

							uvLayer = json.uvs[ i ];

							geometry.faceVertexUvs[ i ][ fi ] = [];
							geometry.faceVertexUvs[ i ][ fi + 1 ] = [];

							for ( j = 0; j < 4; j ++ ) {

								uvIndex = faces[ offset ++ ];

								u = uvLayer[ uvIndex * 2 ];
								v = uvLayer[ uvIndex * 2 + 1 ];

								uv = new Vector2( u, v );

								if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
								if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );

							}

						}

					}

					if ( hasFaceNormal ) {

						normalIndex = faces[ offset ++ ] * 3;

						faceA.normal.set(
							normals[ normalIndex ++ ],
							normals[ normalIndex ++ ],
							normals[ normalIndex ]
						);

						faceB.normal.copy( faceA.normal );

					}

					if ( hasFaceVertexNormal ) {

						for ( i = 0; i < 4; i ++ ) {

							normalIndex = faces[ offset ++ ] * 3;

							normal = new Vector3(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);


							if ( i !== 2 ) faceA.vertexNormals.push( normal );
							if ( i !== 0 ) faceB.vertexNormals.push( normal );

						}

					}


					if ( hasFaceColor ) {

						colorIndex = faces[ offset ++ ];
						hex = colors[ colorIndex ];

						faceA.color.setHex( hex );
						faceB.color.setHex( hex );

					}


					if ( hasFaceVertexColor ) {

						for ( i = 0; i < 4; i ++ ) {

							colorIndex = faces[ offset ++ ];
							hex = colors[ colorIndex ];

							if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
							if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );

						}

					}

					geometry.faces.push( faceA );
					geometry.faces.push( faceB );

				} else {

					face = new Face3();
					face.a = faces[ offset ++ ];
					face.b = faces[ offset ++ ];
					face.c = faces[ offset ++ ];

					if ( hasMaterial ) {

						materialIndex = faces[ offset ++ ];
						face.materialIndex = materialIndex;

					}

					// to get face <=> uv index correspondence

					fi = geometry.faces.length;

					if ( hasFaceVertexUv ) {

						for ( i = 0; i < nUvLayers; i ++ ) {

							uvLayer = json.uvs[ i ];

							geometry.faceVertexUvs[ i ][ fi ] = [];

							for ( j = 0; j < 3; j ++ ) {

								uvIndex = faces[ offset ++ ];

								u = uvLayer[ uvIndex * 2 ];
								v = uvLayer[ uvIndex * 2 + 1 ];

								uv = new Vector2( u, v );

								geometry.faceVertexUvs[ i ][ fi ].push( uv );

							}

						}

					}

					if ( hasFaceNormal ) {

						normalIndex = faces[ offset ++ ] * 3;

						face.normal.set(
							normals[ normalIndex ++ ],
							normals[ normalIndex ++ ],
							normals[ normalIndex ]
						);

					}

					if ( hasFaceVertexNormal ) {

						for ( i = 0; i < 3; i ++ ) {

							normalIndex = faces[ offset ++ ] * 3;

							normal = new Vector3(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

							face.vertexNormals.push( normal );

						}

					}


					if ( hasFaceColor ) {

						colorIndex = faces[ offset ++ ];
						face.color.setHex( colors[ colorIndex ] );

					}


					if ( hasFaceVertexColor ) {

						for ( i = 0; i < 3; i ++ ) {

							colorIndex = faces[ offset ++ ];
							face.vertexColors.push( new Color( colors[ colorIndex ] ) );

						}

					}

					geometry.faces.push( face );

				}

			}

		}

		function parseSkin( json, geometry ) {

			var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;

			if ( json.skinWeights ) {

				for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {

					var x = json.skinWeights[ i ];
					var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
					var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
					var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;

					geometry.skinWeights.push( new Vector4( x, y, z, w ) );

				}

			}

			if ( json.skinIndices ) {

				for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {

					var a = json.skinIndices[ i ];
					var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
					var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
					var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;

					geometry.skinIndices.push( new Vector4( a, b, c, d ) );

				}

			}

			geometry.bones = json.bones;

			if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {

				console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
					geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );

			}

		}

		function parseMorphing( json, geometry ) {

			var scale = json.scale;

			if ( json.morphTargets !== undefined ) {

				for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {

					geometry.morphTargets[ i ] = {};
					geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
					geometry.morphTargets[ i ].vertices = [];

					var dstVertices = geometry.morphTargets[ i ].vertices;
					var srcVertices = json.morphTargets[ i ].vertices;

					for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {

						var vertex = new Vector3();
						vertex.x = srcVertices[ v ] * scale;
						vertex.y = srcVertices[ v + 1 ] * scale;
						vertex.z = srcVertices[ v + 2 ] * scale;

						dstVertices.push( vertex );

					}

				}

			}

			if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {

				console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );

				var faces = geometry.faces;
				var morphColors = json.morphColors[ 0 ].colors;

				for ( var i = 0, l = faces.length; i < l; i ++ ) {

					faces[ i ].color.fromArray( morphColors, i * 3 );

				}

			}

		}

		function parseAnimations( json, geometry ) {

			var outputAnimations = [];

			// parse old style Bone/Hierarchy animations
			var animations = [];

			if ( json.animation !== undefined ) {

				animations.push( json.animation );

			}

			if ( json.animations !== undefined ) {

				if ( json.animations.length ) {

					animations = animations.concat( json.animations );

				} else {

					animations.push( json.animations );

				}

			}

			for ( var i = 0; i < animations.length; i ++ ) {

				var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
				if ( clip ) outputAnimations.push( clip );

			}

			// parse implicit morph animations
			if ( geometry.morphTargets ) {

				// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
				var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
				outputAnimations = outputAnimations.concat( morphAnimationClips );

			}

			if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;

		}

		return function ( json, texturePath ) {

			if ( json.data !== undefined ) {

				// Geometry 4.0 spec
				json = json.data;

			}

			if ( json.scale !== undefined ) {

				json.scale = 1.0 / json.scale;

			} else {

				json.scale = 1.0;

			}

			var geometry = new Geometry();

			parseModel( json, geometry );
			parseSkin( json, geometry );
			parseMorphing( json, geometry );
			parseAnimations( json, geometry );

			geometry.computeFaceNormals();
			geometry.computeBoundingSphere();

			if ( json.materials === undefined || json.materials.length === 0 ) {

				return { geometry: geometry };

			} else {

				var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );

				return { geometry: geometry, materials: materials };

			}

		};

	} )()

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ObjectLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	this.texturePath = '';

}

Object.assign( ObjectLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		if ( this.texturePath === '' ) {

			this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );

		}

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			var json = null;

			try {

				json = JSON.parse( text );

			} catch ( error ) {

				if ( onError !== undefined ) onError( error );

				console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );

				return;

			}

			var metadata = json.metadata;

			if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

				console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
				return;

			}

			scope.parse( json, onLoad );

		}, onProgress, onError );

	},

	setTexturePath: function ( value ) {

		this.texturePath = value;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;

	},

	parse: function ( json, onLoad ) {

		var shapes = this.parseShape( json.shapes );
		var geometries = this.parseGeometries( json.geometries, shapes );

		var images = this.parseImages( json.images, function () {

			if ( onLoad !== undefined ) onLoad( object );

		} );

		var textures = this.parseTextures( json.textures, images );
		var materials = this.parseMaterials( json.materials, textures );

		var object = this.parseObject( json.object, geometries, materials );

		if ( json.animations ) {

			object.animations = this.parseAnimations( json.animations );

		}

		if ( json.images === undefined || json.images.length === 0 ) {

			if ( onLoad !== undefined ) onLoad( object );

		}

		return object;

	},

	parseShape: function ( json ) {

		var shapes = {};

		if ( json !== undefined ) {

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var shape = new Shape().fromJSON( json[ i ] );

				shapes[ shape.uuid ] = shape;

			}

		}

		return shapes;

	},

	parseGeometries: function ( json, shapes ) {

		var geometries = {};

		if ( json !== undefined ) {

			var geometryLoader = new JSONLoader();
			var bufferGeometryLoader = new BufferGeometryLoader();

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var geometry;
				var data = json[ i ];

				switch ( data.type ) {

					case 'PlaneGeometry':
					case 'PlaneBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.width,
							data.height,
							data.widthSegments,
							data.heightSegments
						);

						break;

					case 'BoxGeometry':
					case 'BoxBufferGeometry':
					case 'CubeGeometry': // backwards compatible

						geometry = new Geometries[ data.type ](
							data.width,
							data.height,
							data.depth,
							data.widthSegments,
							data.heightSegments,
							data.depthSegments
						);

						break;

					case 'CircleGeometry':
					case 'CircleBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.segments,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'CylinderGeometry':
					case 'CylinderBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radiusTop,
							data.radiusBottom,
							data.height,
							data.radialSegments,
							data.heightSegments,
							data.openEnded,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'ConeGeometry':
					case 'ConeBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.height,
							data.radialSegments,
							data.heightSegments,
							data.openEnded,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'SphereGeometry':
					case 'SphereBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.widthSegments,
							data.heightSegments,
							data.phiStart,
							data.phiLength,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'DodecahedronGeometry':
					case 'DodecahedronBufferGeometry':
					case 'IcosahedronGeometry':
					case 'IcosahedronBufferGeometry':
					case 'OctahedronGeometry':
					case 'OctahedronBufferGeometry':
					case 'TetrahedronGeometry':
					case 'TetrahedronBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.detail
						);

						break;

					case 'RingGeometry':
					case 'RingBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.innerRadius,
							data.outerRadius,
							data.thetaSegments,
							data.phiSegments,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'TorusGeometry':
					case 'TorusBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.tube,
							data.radialSegments,
							data.tubularSegments,
							data.arc
						);

						break;

					case 'TorusKnotGeometry':
					case 'TorusKnotBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.tube,
							data.tubularSegments,
							data.radialSegments,
							data.p,
							data.q
						);

						break;

					case 'LatheGeometry':
					case 'LatheBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.points,
							data.segments,
							data.phiStart,
							data.phiLength
						);

						break;

					case 'PolyhedronGeometry':
					case 'PolyhedronBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.vertices,
							data.indices,
							data.radius,
							data.details
						);

						break;

					case 'ShapeGeometry':
					case 'ShapeBufferGeometry':

						var geometryShapes = [];

						for ( var i = 0, l = data.shapes.length; i < l; i ++ ) {

							var shape = shapes[ data.shapes[ i ] ];

							geometryShapes.push( shape );

						}

						geometry = new Geometries[ data.type ](
							geometryShapes,
							data.curveSegments
						);

						break;

					case 'BufferGeometry':

						geometry = bufferGeometryLoader.parse( data );

						break;

					case 'Geometry':

						geometry = geometryLoader.parse( data, this.texturePath ).geometry;

						break;

					default:

						console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );

						continue;

				}

				geometry.uuid = data.uuid;

				if ( data.name !== undefined ) geometry.name = data.name;

				geometries[ data.uuid ] = geometry;

			}

		}

		return geometries;

	},

	parseMaterials: function ( json, textures ) {

		var materials = {};

		if ( json !== undefined ) {

			var loader = new MaterialLoader();
			loader.setTextures( textures );

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var data = json[ i ];

				if ( data.type === 'MultiMaterial' ) {

					// Deprecated

					var array = [];

					for ( var j = 0; j < data.materials.length; j ++ ) {

						array.push( loader.parse( data.materials[ j ] ) );

					}

					materials[ data.uuid ] = array;

				} else {

					materials[ data.uuid ] = loader.parse( data );

				}

			}

		}

		return materials;

	},

	parseAnimations: function ( json ) {

		var animations = [];

		for ( var i = 0; i < json.length; i ++ ) {

			var clip = AnimationClip.parse( json[ i ] );

			animations.push( clip );

		}

		return animations;

	},

	parseImages: function ( json, onLoad ) {

		var scope = this;
		var images = {};

		function loadImage( url ) {

			scope.manager.itemStart( url );

			return loader.load( url, function () {

				scope.manager.itemEnd( url );

			}, undefined, function () {

				scope.manager.itemEnd( url );
				scope.manager.itemError( url );

			} );

		}

		if ( json !== undefined && json.length > 0 ) {

			var manager = new LoadingManager( onLoad );

			var loader = new ImageLoader( manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var image = json[ i ];
				var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;

				images[ image.uuid ] = loadImage( path );

			}

		}

		return images;

	},

	parseTextures: function ( json, images ) {

		function parseConstant( value, type ) {

			if ( typeof value === 'number' ) return value;

			console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

			return type[ value ];

		}

		var textures = {};

		if ( json !== undefined ) {

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var data = json[ i ];

				if ( data.image === undefined ) {

					console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

				}

				if ( images[ data.image ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

				}

				var texture = new Texture( images[ data.image ] );
				texture.needsUpdate = true;

				texture.uuid = data.uuid;

				if ( data.name !== undefined ) texture.name = data.name;

				if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );

				if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
				if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
				if ( data.center !== undefined ) texture.center.fromArray( data.center );
				if ( data.rotation !== undefined ) texture.rotation = data.rotation;

				if ( data.wrap !== undefined ) {

					texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
					texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );

				}

				if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
				if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
				if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

				if ( data.flipY !== undefined ) texture.flipY = data.flipY;

				textures[ data.uuid ] = texture;

			}

		}

		return textures;

	},

	parseObject: function () {

		var matrix = new Matrix4();

		return function parseObject( data, geometries, materials ) {

			var object;

			function getGeometry( name ) {

				if ( geometries[ name ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

				}

				return geometries[ name ];

			}

			function getMaterial( name ) {

				if ( name === undefined ) return undefined;

				if ( Array.isArray( name ) ) {

					var array = [];

					for ( var i = 0, l = name.length; i < l; i ++ ) {

						var uuid = name[ i ];

						if ( materials[ uuid ] === undefined ) {

							console.warn( 'THREE.ObjectLoader: Undefined material', uuid );

						}

						array.push( materials[ uuid ] );

					}

					return array;

				}

				if ( materials[ name ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined material', name );

				}

				return materials[ name ];

			}

			switch ( data.type ) {

				case 'Scene':

					object = new Scene();

					if ( data.background !== undefined ) {

						if ( Number.isInteger( data.background ) ) {

							object.background = new Color( data.background );

						}

					}

					if ( data.fog !== undefined ) {

						if ( data.fog.type === 'Fog' ) {

							object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

						} else if ( data.fog.type === 'FogExp2' ) {

							object.fog = new FogExp2( data.fog.color, data.fog.density );

						}

					}

					break;

				case 'PerspectiveCamera':

					object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

					if ( data.focus !== undefined ) object.focus = data.focus;
					if ( data.zoom !== undefined ) object.zoom = data.zoom;
					if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
					if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
					if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

					break;

				case 'OrthographicCamera':

					object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

					break;

				case 'AmbientLight':

					object = new AmbientLight( data.color, data.intensity );

					break;

				case 'DirectionalLight':

					object = new DirectionalLight( data.color, data.intensity );

					break;

				case 'PointLight':

					object = new PointLight( data.color, data.intensity, data.distance, data.decay );

					break;

				case 'RectAreaLight':

					object = new RectAreaLight( data.color, data.intensity, data.width, data.height );

					break;

				case 'SpotLight':

					object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

					break;

				case 'HemisphereLight':

					object = new HemisphereLight( data.color, data.groundColor, data.intensity );

					break;

				case 'SkinnedMesh':

					console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.' );

				case 'Mesh':

					var geometry = getGeometry( data.geometry );
					var material = getMaterial( data.material );

					if ( geometry.bones && geometry.bones.length > 0 ) {

						object = new SkinnedMesh( geometry, material );

					} else {

						object = new Mesh( geometry, material );

					}

					break;

				case 'LOD':

					object = new LOD();

					break;

				case 'Line':

					object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );

					break;

				case 'LineLoop':

					object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );

					break;

				case 'LineSegments':

					object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

					break;

				case 'PointCloud':
				case 'Points':

					object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

					break;

				case 'Sprite':

					object = new Sprite( getMaterial( data.material ) );

					break;

				case 'Group':

					object = new Group();

					break;

				default:

					object = new Object3D();

			}

			object.uuid = data.uuid;

			if ( data.name !== undefined ) object.name = data.name;
			if ( data.matrix !== undefined ) {

				matrix.fromArray( data.matrix );
				matrix.decompose( object.position, object.quaternion, object.scale );

			} else {

				if ( data.position !== undefined ) object.position.fromArray( data.position );
				if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
				if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
				if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

			}

			if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
			if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

			if ( data.shadow ) {

				if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
				if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
				if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
				if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

			}

			if ( data.visible !== undefined ) object.visible = data.visible;
			if ( data.userData !== undefined ) object.userData = data.userData;

			if ( data.children !== undefined ) {

				var children = data.children;

				for ( var i = 0; i < children.length; i ++ ) {

					object.add( this.parseObject( children[ i ], geometries, materials ) );

				}

			}

			if ( data.type === 'LOD' ) {

				var levels = data.levels;

				for ( var l = 0; l < levels.length; l ++ ) {

					var level = levels[ l ];
					var child = object.getObjectByProperty( 'uuid', level.object );

					if ( child !== undefined ) {

						object.addLevel( child, level.distance );

					}

				}

			}

			return object;

		};

	}()

} );

var TEXTURE_MAPPING = {
	UVMapping: UVMapping,
	CubeReflectionMapping: CubeReflectionMapping,
	CubeRefractionMapping: CubeRefractionMapping,
	EquirectangularReflectionMapping: EquirectangularReflectionMapping,
	EquirectangularRefractionMapping: EquirectangularRefractionMapping,
	SphericalReflectionMapping: SphericalReflectionMapping,
	CubeUVReflectionMapping: CubeUVReflectionMapping,
	CubeUVRefractionMapping: CubeUVRefractionMapping
};

var TEXTURE_WRAPPING = {
	RepeatWrapping: RepeatWrapping,
	ClampToEdgeWrapping: ClampToEdgeWrapping,
	MirroredRepeatWrapping: MirroredRepeatWrapping
};

var TEXTURE_FILTER = {
	NearestFilter: NearestFilter,
	NearestMipMapNearestFilter: NearestMipMapNearestFilter,
	NearestMipMapLinearFilter: NearestMipMapLinearFilter,
	LinearFilter: LinearFilter,
	LinearMipMapNearestFilter: LinearMipMapNearestFilter,
	LinearMipMapLinearFilter: LinearMipMapLinearFilter
};

/**
 * @author thespite / http://clicktorelease.com/
 */

function ImageBitmapLoader( manager ) {

	if ( typeof createImageBitmap === 'undefined' ) {

		console.warn( 'THREE.ImageBitmapLoader: createImageBitmap() not supported.' );

	}

	if ( typeof fetch === 'undefined' ) {

		console.warn( 'THREE.ImageBitmapLoader: fetch() not supported.' );

	}

	this.manager = manager !== undefined ? manager : DefaultLoadingManager;
	this.options = undefined;

}

ImageBitmapLoader.prototype = {

	constructor: ImageBitmapLoader,

	setOptions: function setOptions( options ) {

		this.options = options;

		return this;

	},

	load: function load( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		var scope = this;

		var cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		fetch( url ).then( function ( res ) {

			return res.blob();

		} ).then( function ( blob ) {

			return createImageBitmap( blob, scope.options );

		} ).then( function ( imageBitmap ) {

			Cache.add( url, imageBitmap );

			if ( onLoad ) onLoad( imageBitmap );

			scope.manager.itemEnd( url );

		} ).catch( function ( e ) {

			if ( onError ) onError( e );

			scope.manager.itemEnd( url );
			scope.manager.itemError( url );

		} );

	},

	setCrossOrigin: function ( /* value */ ) {

		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
 **/

function ShapePath() {

	this.type = 'ShapePath';

	this.subPaths = [];
	this.currentPath = null;

}

Object.assign( ShapePath.prototype, {

	moveTo: function ( x, y ) {

		this.currentPath = new Path();
		this.subPaths.push( this.currentPath );
		this.currentPath.moveTo( x, y );

	},

	lineTo: function ( x, y ) {

		this.currentPath.lineTo( x, y );

	},

	quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

		this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );

	},

	bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );

	},

	splineThru: function ( pts ) {

		this.currentPath.splineThru( pts );

	},

	toShapes: function ( isCCW, noHoles ) {

		function toShapesNoHoles( inSubpaths ) {

			var shapes = [];

			for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {

				var tmpPath = inSubpaths[ i ];

				var tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;

				shapes.push( tmpShape );

			}

			return shapes;

		}

		function isPointInsidePolygon( inPt, inPolygon ) {

			var polyLen = inPolygon.length;

			// inPt on polygon contour => immediate success    or
			// toggling of inside/outside at every single! intersection point of an edge
			//  with the horizontal line through inPt, left of inPt
			//  not counting lowerY endpoints of edges and whole edges on that line
			var inside = false;
			for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

				var edgeLowPt = inPolygon[ p ];
				var edgeHighPt = inPolygon[ q ];

				var edgeDx = edgeHighPt.x - edgeLowPt.x;
				var edgeDy = edgeHighPt.y - edgeLowPt.y;

				if ( Math.abs( edgeDy ) > Number.EPSILON ) {

					// not parallel
					if ( edgeDy < 0 ) {

						edgeLowPt = inPolygon[ q ]; edgeDx = - edgeDx;
						edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

					}
					if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

					if ( inPt.y === edgeLowPt.y ) {

						if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
						// continue;				// no intersection or edgeLowPt => doesn't count !!!

					} else {

						var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
						if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
						if ( perpEdge < 0 ) 				continue;
						inside = ! inside;		// true intersection left of inPt

					}

				} else {

					// parallel or collinear
					if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
					// edge lies on the same horizontal line as inPt
					if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
						 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
					// continue;

				}

			}

			return	inside;

		}

		var isClockWise = ShapeUtils.isClockWise;

		var subPaths = this.subPaths;
		if ( subPaths.length === 0 ) return [];

		if ( noHoles === true )	return	toShapesNoHoles( subPaths );


		var solid, tmpPath, tmpShape, shapes = [];

		if ( subPaths.length === 1 ) {

			tmpPath = subPaths[ 0 ];
			tmpShape = new Shape();
			tmpShape.curves = tmpPath.curves;
			shapes.push( tmpShape );
			return shapes;

		}

		var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
		holesFirst = isCCW ? ! holesFirst : holesFirst;

		// console.log("Holes first", holesFirst);

		var betterShapeHoles = [];
		var newShapes = [];
		var newShapeHoles = [];
		var mainIdx = 0;
		var tmpPoints;

		newShapes[ mainIdx ] = undefined;
		newShapeHoles[ mainIdx ] = [];

		for ( var i = 0, l = subPaths.length; i < l; i ++ ) {

			tmpPath = subPaths[ i ];
			tmpPoints = tmpPath.getPoints();
			solid = isClockWise( tmpPoints );
			solid = isCCW ? ! solid : solid;

			if ( solid ) {

				if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

				newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
				newShapes[ mainIdx ].s.curves = tmpPath.curves;

				if ( holesFirst )	mainIdx ++;
				newShapeHoles[ mainIdx ] = [];

				//console.log('cw', i);

			} else {

				newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

				//console.log('ccw', i);

			}

		}

		// only Holes? -> probably all Shapes with wrong orientation
		if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


		if ( newShapes.length > 1 ) {

			var ambiguous = false;
			var toChange = [];

			for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				betterShapeHoles[ sIdx ] = [];

			}

			for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				var sho = newShapeHoles[ sIdx ];

				for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {

					var ho = sho[ hIdx ];
					var hole_unassigned = true;

					for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

						if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

							if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
							if ( hole_unassigned ) {

								hole_unassigned = false;
								betterShapeHoles[ s2Idx ].push( ho );

							} else {

								ambiguous = true;

							}

						}

					}
					if ( hole_unassigned ) {

						betterShapeHoles[ sIdx ].push( ho );

					}

				}

			}
			// console.log("ambiguous: ", ambiguous);
			if ( toChange.length > 0 ) {

				// console.log("to change: ", toChange);
				if ( ! ambiguous )	newShapeHoles = betterShapeHoles;

			}

		}

		var tmpHoles;

		for ( var i = 0, il = newShapes.length; i < il; i ++ ) {

			tmpShape = newShapes[ i ].s;
			shapes.push( tmpShape );
			tmpHoles = newShapeHoles[ i ];

			for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

				tmpShape.holes.push( tmpHoles[ j ].h );

			}

		}

		//console.log("shape", shapes);

		return shapes;

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author mrdoob / http://mrdoob.com/
 */

function Font( data ) {

	this.type = 'Font';

	this.data = data;

}

Object.assign( Font.prototype, {

	isFont: true,

	generateShapes: function ( text, size, divisions ) {

		function createPaths( text ) {

			var chars = String( text ).split( '' );
			var scale = size / data.resolution;
			var line_height = ( data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness ) * scale;

			var offsetX = 0, offsetY = 0;

			var paths = [];

			for ( var i = 0; i < chars.length; i ++ ) {

				var char = chars[ i ];

				if ( char === '\n' ) {

					offsetX = 0;
					offsetY -= line_height;

				} else {

					var ret = createPath( char, scale, offsetX, offsetY );
					offsetX += ret.offsetX;
					paths.push( ret.path );

				}

			}

			return paths;

		}

		function createPath( c, scale, offsetX, offsetY ) {

			var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];

			if ( ! glyph ) return;

			var path = new ShapePath();

			var pts = [];
			var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;

			if ( glyph.o ) {

				var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );

				for ( var i = 0, l = outline.length; i < l; ) {

					var action = outline[ i ++ ];

					switch ( action ) {

						case 'm': // moveTo

							x = outline[ i ++ ] * scale + offsetX;
							y = outline[ i ++ ] * scale + offsetY;

							path.moveTo( x, y );

							break;

						case 'l': // lineTo

							x = outline[ i ++ ] * scale + offsetX;
							y = outline[ i ++ ] * scale + offsetY;

							path.lineTo( x, y );

							break;

						case 'q': // quadraticCurveTo

							cpx = outline[ i ++ ] * scale + offsetX;
							cpy = outline[ i ++ ] * scale + offsetY;
							cpx1 = outline[ i ++ ] * scale + offsetX;
							cpy1 = outline[ i ++ ] * scale + offsetY;

							path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );

							laste = pts[ pts.length - 1 ];

							if ( laste ) {

								cpx0 = laste.x;
								cpy0 = laste.y;

								

							}

							break;

						case 'b': // bezierCurveTo

							cpx = outline[ i ++ ] * scale + offsetX;
							cpy = outline[ i ++ ] * scale + offsetY;
							cpx1 = outline[ i ++ ] * scale + offsetX;
							cpy1 = outline[ i ++ ] * scale + offsetY;
							cpx2 = outline[ i ++ ] * scale + offsetX;
							cpy2 = outline[ i ++ ] * scale + offsetY;

							path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );

							laste = pts[ pts.length - 1 ];

							if ( laste ) {

								cpx0 = laste.x;
								cpy0 = laste.y;

								

							}

							break;

					}

				}

			}

			return { offsetX: glyph.ha * scale, path: path };

		}

		//

		if ( size === undefined ) size = 100;
		if ( divisions === undefined ) divisions = 4;

		var data = this.data;

		var paths = createPaths( text );
		var shapes = [];

		for ( var p = 0, pl = paths.length; p < pl; p ++ ) {

			Array.prototype.push.apply( shapes, paths[ p ].toShapes() );

		}

		return shapes;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function FontLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( FontLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.load( url, function ( text ) {

			var json;

			try {

				json = JSON.parse( text );

			} catch ( e ) {

				console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
				json = JSON.parse( text.substring( 65, text.length - 2 ) );

			}

			var font = scope.parse( json );

			if ( onLoad ) onLoad( font );

		}, onProgress, onError );

	},

	parse: function ( json ) {

		return new Font( json );

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

var context;

var AudioContext = {

	getContext: function () {

		if ( context === undefined ) {

			context = new ( window.AudioContext || window.webkitAudioContext )();

		}

		return context;

	},

	setContext: function ( value ) {

		context = value;

	}

};

/**
 * @author Reece Aaron Lecrivain / http://reecenotes.com/
 */

function AudioLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( AudioLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.load( url, function ( buffer ) {

			var context = AudioContext.getContext();

			context.decodeAudioData( buffer, function ( audioBuffer ) {

				onLoad( audioBuffer );

			} );

		}, onProgress, onError );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function StereoCamera() {

	this.type = 'StereoCamera';

	this.aspect = 1;

	this.eyeSep = 0.064;

	this.cameraL = new PerspectiveCamera();
	this.cameraL.layers.enable( 1 );
	this.cameraL.matrixAutoUpdate = false;

	this.cameraR = new PerspectiveCamera();
	this.cameraR.layers.enable( 2 );
	this.cameraR.matrixAutoUpdate = false;

}

Object.assign( StereoCamera.prototype, {

	update: ( function () {

		var instance, focus, fov, aspect, near, far, zoom, eyeSep;

		var eyeRight = new Matrix4();
		var eyeLeft = new Matrix4();

		return function update( camera ) {

			var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
												aspect !== camera.aspect * this.aspect || near !== camera.near ||
												far !== camera.far || zoom !== camera.zoom || eyeSep !== this.eyeSep;

			if ( needsUpdate ) {

				instance = this;
				focus = camera.focus;
				fov = camera.fov;
				aspect = camera.aspect * this.aspect;
				near = camera.near;
				far = camera.far;
				zoom = camera.zoom;

				// Off-axis stereoscopic effect based on
				// http://paulbourke.net/stereographics/stereorender/

				var projectionMatrix = camera.projectionMatrix.clone();
				eyeSep = this.eyeSep / 2;
				var eyeSepOnProjection = eyeSep * near / focus;
				var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
				var xmin, xmax;

				// translate xOffset

				eyeLeft.elements[ 12 ] = - eyeSep;
				eyeRight.elements[ 12 ] = eyeSep;

				// for left eye

				xmin = - ymax * aspect + eyeSepOnProjection;
				xmax = ymax * aspect + eyeSepOnProjection;

				projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
				projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

				this.cameraL.projectionMatrix.copy( projectionMatrix );

				// for right eye

				xmin = - ymax * aspect - eyeSepOnProjection;
				xmax = ymax * aspect - eyeSepOnProjection;

				projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
				projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

				this.cameraR.projectionMatrix.copy( projectionMatrix );

			}

			this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
			this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );

		};

	} )()

} );

/**
 * Camera for rendering cube maps
 *	- renders scene into axis-aligned cube
 *
 * @author alteredq / http://alteredqualia.com/
 */

function CubeCamera( near, far, cubeResolution ) {

	Object3D.call( this );

	this.type = 'CubeCamera';

	var fov = 90, aspect = 1;

	var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
	cameraPX.up.set( 0, - 1, 0 );
	cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
	this.add( cameraPX );

	var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
	cameraNX.up.set( 0, - 1, 0 );
	cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
	this.add( cameraNX );

	var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
	cameraPY.up.set( 0, 0, 1 );
	cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
	this.add( cameraPY );

	var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
	cameraNY.up.set( 0, 0, - 1 );
	cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
	this.add( cameraNY );

	var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
	cameraPZ.up.set( 0, - 1, 0 );
	cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
	this.add( cameraPZ );

	var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
	cameraNZ.up.set( 0, - 1, 0 );
	cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
	this.add( cameraNZ );

	var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };

	this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );
	this.renderTarget.texture.name = "CubeCamera";

	this.update = function ( renderer, scene ) {

		if ( this.parent === null ) this.updateMatrixWorld();

		var renderTarget = this.renderTarget;
		var generateMipmaps = renderTarget.texture.generateMipmaps;

		renderTarget.texture.generateMipmaps = false;

		renderTarget.activeCubeFace = 0;
		renderer.render( scene, cameraPX, renderTarget );

		renderTarget.activeCubeFace = 1;
		renderer.render( scene, cameraNX, renderTarget );

		renderTarget.activeCubeFace = 2;
		renderer.render( scene, cameraPY, renderTarget );

		renderTarget.activeCubeFace = 3;
		renderer.render( scene, cameraNY, renderTarget );

		renderTarget.activeCubeFace = 4;
		renderer.render( scene, cameraPZ, renderTarget );

		renderTarget.texture.generateMipmaps = generateMipmaps;

		renderTarget.activeCubeFace = 5;
		renderer.render( scene, cameraNZ, renderTarget );

		renderer.setRenderTarget( null );

	};

	this.clear = function ( renderer, color, depth, stencil ) {

		var renderTarget = this.renderTarget;

		for ( var i = 0; i < 6; i ++ ) {

			renderTarget.activeCubeFace = i;
			renderer.setRenderTarget( renderTarget );

			renderer.clear( color, depth, stencil );

		}

		renderer.setRenderTarget( null );

	};

}

CubeCamera.prototype = Object.create( Object3D.prototype );
CubeCamera.prototype.constructor = CubeCamera;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AudioListener() {

	Object3D.call( this );

	this.type = 'AudioListener';

	this.context = AudioContext.getContext();

	this.gain = this.context.createGain();
	this.gain.connect( this.context.destination );

	this.filter = null;

}

AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: AudioListener,

	getInput: function () {

		return this.gain;

	},

	removeFilter: function ( ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );
			this.gain.connect( this.context.destination );
			this.filter = null;

		}

	},

	getFilter: function () {

		return this.filter;

	},

	setFilter: function ( value ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );

		} else {

			this.gain.disconnect( this.context.destination );

		}

		this.filter = value;
		this.gain.connect( this.filter );
		this.filter.connect( this.context.destination );

	},

	getMasterVolume: function () {

		return this.gain.gain.value;

	},

	setMasterVolume: function ( value ) {

		this.gain.gain.value = value;

	},

	updateMatrixWorld: ( function () {

		var position = new Vector3();
		var quaternion = new Quaternion();
		var scale = new Vector3();

		var orientation = new Vector3();

		return function updateMatrixWorld( force ) {

			Object3D.prototype.updateMatrixWorld.call( this, force );

			var listener = this.context.listener;
			var up = this.up;

			this.matrixWorld.decompose( position, quaternion, scale );

			orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );

			if ( listener.positionX ) {

				listener.positionX.setValueAtTime( position.x, this.context.currentTime );
				listener.positionY.setValueAtTime( position.y, this.context.currentTime );
				listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
				listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
				listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
				listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
				listener.upX.setValueAtTime( up.x, this.context.currentTime );
				listener.upY.setValueAtTime( up.y, this.context.currentTime );
				listener.upZ.setValueAtTime( up.z, this.context.currentTime );

			} else {

				listener.setPosition( position.x, position.y, position.z );
				listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );

			}

		};

	} )()

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Reece Aaron Lecrivain / http://reecenotes.com/
 */

function Audio( listener ) {

	Object3D.call( this );

	this.type = 'Audio';

	this.context = listener.context;

	this.gain = this.context.createGain();
	this.gain.connect( listener.getInput() );

	this.autoplay = false;

	this.buffer = null;
	this.loop = false;
	this.startTime = 0;
	this.offset = 0;
	this.playbackRate = 1;
	this.isPlaying = false;
	this.hasPlaybackControl = true;
	this.sourceType = 'empty';

	this.filters = [];

}

Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Audio,

	getOutput: function () {

		return this.gain;

	},

	setNodeSource: function ( audioNode ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'audioNode';
		this.source = audioNode;
		this.connect();

		return this;

	},

	setBuffer: function ( audioBuffer ) {

		this.buffer = audioBuffer;
		this.sourceType = 'buffer';

		if ( this.autoplay ) this.play();

		return this;

	},

	play: function () {

		if ( this.isPlaying === true ) {

			console.warn( 'THREE.Audio: Audio is already playing.' );
			return;

		}

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		var source = this.context.createBufferSource();

		source.buffer = this.buffer;
		source.loop = this.loop;
		source.onended = this.onEnded.bind( this );
		source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
		this.startTime = this.context.currentTime;
		source.start( this.startTime, this.offset );

		this.isPlaying = true;

		this.source = source;

		return this.connect();

	},

	pause: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		if ( this.isPlaying === true ) {

			this.source.stop();
			this.offset += ( this.context.currentTime - this.startTime ) * this.playbackRate;
			this.isPlaying = false;

		}

		return this;

	},

	stop: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.source.stop();
		this.offset = 0;
		this.isPlaying = false;

		return this;

	},

	connect: function () {

		if ( this.filters.length > 0 ) {

			this.source.connect( this.filters[ 0 ] );

			for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].connect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

		} else {

			this.source.connect( this.getOutput() );

		}

		return this;

	},

	disconnect: function () {

		if ( this.filters.length > 0 ) {

			this.source.disconnect( this.filters[ 0 ] );

			for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].disconnect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

		} else {

			this.source.disconnect( this.getOutput() );

		}

		return this;

	},

	getFilters: function () {

		return this.filters;

	},

	setFilters: function ( value ) {

		if ( ! value ) value = [];

		if ( this.isPlaying === true ) {

			this.disconnect();
			this.filters = value;
			this.connect();

		} else {

			this.filters = value;

		}

		return this;

	},

	getFilter: function () {

		return this.getFilters()[ 0 ];

	},

	setFilter: function ( filter ) {

		return this.setFilters( filter ? [ filter ] : [] );

	},

	setPlaybackRate: function ( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.playbackRate = value;

		if ( this.isPlaying === true ) {

			this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );

		}

		return this;

	},

	getPlaybackRate: function () {

		return this.playbackRate;

	},

	onEnded: function () {

		this.isPlaying = false;

	},

	getLoop: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return false;

		}

		return this.loop;

	},

	setLoop: function ( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.loop = value;

		if ( this.isPlaying === true ) {

			this.source.loop = this.loop;

		}

		return this;

	},

	getVolume: function () {

		return this.gain.gain.value;

	},

	setVolume: function ( value ) {

		this.gain.gain.value = value;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function PositionalAudio( listener ) {

	Audio.call( this, listener );

	this.panner = this.context.createPanner();
	this.panner.connect( this.gain );

}

PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {

	constructor: PositionalAudio,

	getOutput: function () {

		return this.panner;

	},

	getRefDistance: function () {

		return this.panner.refDistance;

	},

	setRefDistance: function ( value ) {

		this.panner.refDistance = value;

	},

	getRolloffFactor: function () {

		return this.panner.rolloffFactor;

	},

	setRolloffFactor: function ( value ) {

		this.panner.rolloffFactor = value;

	},

	getDistanceModel: function () {

		return this.panner.distanceModel;

	},

	setDistanceModel: function ( value ) {

		this.panner.distanceModel = value;

	},

	getMaxDistance: function () {

		return this.panner.maxDistance;

	},

	setMaxDistance: function ( value ) {

		this.panner.maxDistance = value;

	},

	updateMatrixWorld: ( function () {

		var position = new Vector3();

		return function updateMatrixWorld( force ) {

			Object3D.prototype.updateMatrixWorld.call( this, force );

			position.setFromMatrixPosition( this.matrixWorld );

			this.panner.setPosition( position.x, position.y, position.z );

		};

	} )()


} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AudioAnalyser( audio, fftSize ) {

	this.analyser = audio.context.createAnalyser();
	this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;

	this.data = new Uint8Array( this.analyser.frequencyBinCount );

	audio.getOutput().connect( this.analyser );

}

Object.assign( AudioAnalyser.prototype, {

	getFrequencyData: function () {

		this.analyser.getByteFrequencyData( this.data );

		return this.data;

	},

	getAverageFrequency: function () {

		var value = 0, data = this.getFrequencyData();

		for ( var i = 0; i < data.length; i ++ ) {

			value += data[ i ];

		}

		return value / data.length;

	}

} );

/**
 *
 * Buffered scene graph property that allows weighted accumulation.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function PropertyMixer( binding, typeName, valueSize ) {

	this.binding = binding;
	this.valueSize = valueSize;

	var bufferType = Float64Array,
		mixFunction;

	switch ( typeName ) {

		case 'quaternion':
			mixFunction = this._slerp;
			break;

		case 'string':
		case 'bool':
			bufferType = Array;
			mixFunction = this._select;
			break;

		default:
			mixFunction = this._lerp;

	}

	this.buffer = new bufferType( valueSize * 4 );
	// layout: [ incoming | accu0 | accu1 | orig ]
	//
	// interpolators can use .buffer as their .result
	// the data then goes to 'incoming'
	//
	// 'accu0' and 'accu1' are used frame-interleaved for
	// the cumulative result and are compared to detect
	// changes
	//
	// 'orig' stores the original state of the property

	this._mixBufferRegion = mixFunction;

	this.cumulativeWeight = 0;

	this.useCount = 0;
	this.referenceCount = 0;

}

Object.assign( PropertyMixer.prototype, {

	// accumulate data in the 'incoming' region into 'accu<i>'
	accumulate: function ( accuIndex, weight ) {

		// note: happily accumulating nothing when weight = 0, the caller knows
		// the weight and shouldn't have made the call in the first place

		var buffer = this.buffer,
			stride = this.valueSize,
			offset = accuIndex * stride + stride,

			currentWeight = this.cumulativeWeight;

		if ( currentWeight === 0 ) {

			// accuN := incoming * weight

			for ( var i = 0; i !== stride; ++ i ) {

				buffer[ offset + i ] = buffer[ i ];

			}

			currentWeight = weight;

		} else {

			// accuN := accuN + incoming * weight

			currentWeight += weight;
			var mix = weight / currentWeight;
			this._mixBufferRegion( buffer, offset, 0, mix, stride );

		}

		this.cumulativeWeight = currentWeight;

	},

	// apply the state of 'accu<i>' to the binding when accus differ
	apply: function ( accuIndex ) {

		var stride = this.valueSize,
			buffer = this.buffer,
			offset = accuIndex * stride + stride,

			weight = this.cumulativeWeight,

			binding = this.binding;

		this.cumulativeWeight = 0;

		if ( weight < 1 ) {

			// accuN := accuN + original * ( 1 - cumulativeWeight )

			var originalValueOffset = stride * 3;

			this._mixBufferRegion(
				buffer, offset, originalValueOffset, 1 - weight, stride );

		}

		for ( var i = stride, e = stride + stride; i !== e; ++ i ) {

			if ( buffer[ i ] !== buffer[ i + stride ] ) {

				// value has changed -> update scene graph

				binding.setValue( buffer, offset );
				break;

			}

		}

	},

	// remember the state of the bound property and copy it to both accus
	saveOriginalState: function () {

		var binding = this.binding;

		var buffer = this.buffer,
			stride = this.valueSize,

			originalValueOffset = stride * 3;

		binding.getValue( buffer, originalValueOffset );

		// accu[0..1] := orig -- initially detect changes against the original
		for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {

			buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

		}

		this.cumulativeWeight = 0;

	},

	// apply the state previously taken via 'saveOriginalState' to the binding
	restoreOriginalState: function () {

		var originalValueOffset = this.valueSize * 3;
		this.binding.setValue( this.buffer, originalValueOffset );

	},


	// mix functions

	_select: function ( buffer, dstOffset, srcOffset, t, stride ) {

		if ( t >= 0.5 ) {

			for ( var i = 0; i !== stride; ++ i ) {

				buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

			}

		}

	},

	_slerp: function ( buffer, dstOffset, srcOffset, t ) {

		Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );

	},

	_lerp: function ( buffer, dstOffset, srcOffset, t, stride ) {

		var s = 1 - t;

		for ( var i = 0; i !== stride; ++ i ) {

			var j = dstOffset + i;

			buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

		}

	}

} );

/**
 *
 * A reference to a real property in the scene graph.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function Composite( targetGroup, path, optionalParsedPath ) {

	var parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );

	this._targetGroup = targetGroup;
	this._bindings = targetGroup.subscribe_( path, parsedPath );

}

Object.assign( Composite.prototype, {

	getValue: function ( array, offset ) {

		this.bind(); // bind all binding

		var firstValidIndex = this._targetGroup.nCachedObjects_,
			binding = this._bindings[ firstValidIndex ];

		// and only call .getValue on the first
		if ( binding !== undefined ) binding.getValue( array, offset );

	},

	setValue: function ( array, offset ) {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				  n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].setValue( array, offset );

		}

	},

	bind: function () {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				  n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].bind();

		}

	},

	unbind: function () {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				  n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].unbind();

		}

	}

} );


function PropertyBinding( rootNode, path, parsedPath ) {

	this.path = path;
	this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );

	this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName ) || rootNode;

	this.rootNode = rootNode;

}

Object.assign( PropertyBinding, {

	Composite: Composite,

	create: function ( root, path, parsedPath ) {

		if ( ! ( root && root.isAnimationObjectGroup ) ) {

			return new PropertyBinding( root, path, parsedPath );

		} else {

			return new PropertyBinding.Composite( root, path, parsedPath );

		}

	},

	/**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param  {string} name Node name to be sanitized.
	 * @return {string}
	 */
	sanitizeNodeName: function ( name ) {

		return name.replace( /\s/g, '_' ).replace( /[^\w-]/g, '' );

	},

	parseTrackName: function () {

		// Parent directories, delimited by '/' or ':'. Currently unused, but must
		// be matched to parse the rest of the track name.
		var directoryRe = /((?:[\w-]+[\/:])*)/;

		// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
		var nodeRe = /([\w-\.]+)?/;

		// Object on target node, and accessor. Name may contain only word
		// characters. Accessor may contain any character except closing bracket.
		var objectRe = /(?:\.([\w-]+)(?:\[(.+)\])?)?/;

		// Property and accessor. May contain only word characters. Accessor may
		// contain any non-bracket characters.
		var propertyRe = /\.([\w-]+)(?:\[(.+)\])?/;

		var trackRe = new RegExp( ''
			+ '^'
			+ directoryRe.source
			+ nodeRe.source
			+ objectRe.source
			+ propertyRe.source
			+ '$'
		);

		var supportedObjectNames = [ 'material', 'materials', 'bones' ];

		return function ( trackName ) {

			var matches = trackRe.exec( trackName );

			if ( ! matches ) {

				throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );

			}

			var results = {
				// directoryName: matches[ 1 ], // (tschw) currently unused
				nodeName: matches[ 2 ],
				objectName: matches[ 3 ],
				objectIndex: matches[ 4 ],
				propertyName: matches[ 5 ], // required
				propertyIndex: matches[ 6 ]
			};

			var lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );

			if ( lastDot !== undefined && lastDot !== - 1 ) {

				var objectName = results.nodeName.substring( lastDot + 1 );

				// Object names must be checked against a whitelist. Otherwise, there
				// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
				// 'bar' could be the objectName, or part of a nodeName (which can
				// include '.' characters).
				if ( supportedObjectNames.indexOf( objectName ) !== - 1 ) {

					results.nodeName = results.nodeName.substring( 0, lastDot );
					results.objectName = objectName;

				}

			}

			if ( results.propertyName === null || results.propertyName.length === 0 ) {

				throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );

			}

			return results;

		};

	}(),

	findNode: function ( root, nodeName ) {

		if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {

			return root;

		}

		// search into skeleton bones.
		if ( root.skeleton ) {

			var searchSkeleton = function ( skeleton ) {

				for ( var i = 0; i < skeleton.bones.length; i ++ ) {

					var bone = skeleton.bones[ i ];

					if ( bone.name === nodeName ) {

						return bone;

					}

				}

				return null;

			};

			var bone = searchSkeleton( root.skeleton );

			if ( bone ) {

				return bone;

			}

		}

		// search into node subtree.
		if ( root.children ) {

			var searchNodeSubtree = function ( children ) {

				for ( var i = 0; i < children.length; i ++ ) {

					var childNode = children[ i ];

					if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

						return childNode;

					}

					var result = searchNodeSubtree( childNode.children );

					if ( result ) return result;

				}

				return null;

			};

			var subTreeNode = searchNodeSubtree( root.children );

			if ( subTreeNode ) {

				return subTreeNode;

			}

		}

		return null;

	}

} );

Object.assign( PropertyBinding.prototype, { // prototype, continued

	// these are used to "bind" a nonexistent property
	_getValue_unavailable: function () {},
	_setValue_unavailable: function () {},

	BindingType: {
		Direct: 0,
		EntireArray: 1,
		ArrayElement: 2,
		HasFromToArray: 3
	},

	Versioning: {
		None: 0,
		NeedsUpdate: 1,
		MatrixWorldNeedsUpdate: 2
	},

	GetterByBindingType: [

		function getValue_direct( buffer, offset ) {

			buffer[ offset ] = this.node[ this.propertyName ];

		},

		function getValue_array( buffer, offset ) {

			var source = this.resolvedProperty;

			for ( var i = 0, n = source.length; i !== n; ++ i ) {

				buffer[ offset ++ ] = source[ i ];

			}

		},

		function getValue_arrayElement( buffer, offset ) {

			buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

		},

		function getValue_toArray( buffer, offset ) {

			this.resolvedProperty.toArray( buffer, offset );

		}

	],

	SetterByBindingTypeAndVersioning: [

		[
			// Direct

			function setValue_direct( buffer, offset ) {

				this.targetObject[ this.propertyName ] = buffer[ offset ];

			},

			function setValue_direct_setNeedsUpdate( buffer, offset ) {

				this.targetObject[ this.propertyName ] = buffer[ offset ];
				this.targetObject.needsUpdate = true;

			},

			function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.targetObject[ this.propertyName ] = buffer[ offset ];
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// EntireArray

			function setValue_array( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

			},

			function setValue_array_setNeedsUpdate( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

				this.targetObject.needsUpdate = true;

			},

			function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// ArrayElement

			function setValue_arrayElement( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

			},

			function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
				this.targetObject.needsUpdate = true;

			},

			function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// HasToFromArray

			function setValue_fromArray( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );

			},

			function setValue_fromArray_setNeedsUpdate( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );
				this.targetObject.needsUpdate = true;

			},

			function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		]

	],

	getValue: function getValue_unbound( targetArray, offset ) {

		this.bind();
		this.getValue( targetArray, offset );

		// Note: This class uses a State pattern on a per-method basis:
		// 'bind' sets 'this.getValue' / 'setValue' and shadows the
		// prototype version of these methods with one that represents
		// the bound state. When the property is not found, the methods
		// become no-ops.

	},

	setValue: function getValue_unbound( sourceArray, offset ) {

		this.bind();
		this.setValue( sourceArray, offset );

	},

	// create getter / setter pair for a property in the scene graph
	bind: function () {

		var targetObject = this.node,
			parsedPath = this.parsedPath,

			objectName = parsedPath.objectName,
			propertyName = parsedPath.propertyName,
			propertyIndex = parsedPath.propertyIndex;

		if ( ! targetObject ) {

			targetObject = PropertyBinding.findNode( this.rootNode, parsedPath.nodeName ) || this.rootNode;

			this.node = targetObject;

		}

		// set fail state so we can just 'return' on error
		this.getValue = this._getValue_unavailable;
		this.setValue = this._setValue_unavailable;

		// ensure there is a value node
		if ( ! targetObject ) {

			console.error( 'THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.' );
			return;

		}

		if ( objectName ) {

			var objectIndex = parsedPath.objectIndex;

			// special cases were we need to reach deeper into the hierarchy to get the face materials....
			switch ( objectName ) {

				case 'materials':

					if ( ! targetObject.material ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
						return;

					}

					if ( ! targetObject.material.materials ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
						return;

					}

					targetObject = targetObject.material.materials;

					break;

				case 'bones':

					if ( ! targetObject.skeleton ) {

						console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
						return;

					}

					// potential future optimization: skip this if propertyIndex is already an integer
					// and convert the integer string to a true integer.

					targetObject = targetObject.skeleton.bones;

					// support resolving morphTarget names into indices.
					for ( var i = 0; i < targetObject.length; i ++ ) {

						if ( targetObject[ i ].name === objectIndex ) {

							objectIndex = i;
							break;

						}

					}

					break;

				default:

					if ( targetObject[ objectName ] === undefined ) {

						console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
						return;

					}

					targetObject = targetObject[ objectName ];

			}


			if ( objectIndex !== undefined ) {

				if ( targetObject[ objectIndex ] === undefined ) {

					console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
					return;

				}

				targetObject = targetObject[ objectIndex ];

			}

		}

		// resolve property
		var nodeProperty = targetObject[ propertyName ];

		if ( nodeProperty === undefined ) {

			var nodeName = parsedPath.nodeName;

			console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
				'.' + propertyName + ' but it wasn\'t found.', targetObject );
			return;

		}

		// determine versioning scheme
		var versioning = this.Versioning.None;

		if ( targetObject.needsUpdate !== undefined ) { // material

			versioning = this.Versioning.NeedsUpdate;
			this.targetObject = targetObject;

		} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

			versioning = this.Versioning.MatrixWorldNeedsUpdate;
			this.targetObject = targetObject;

		}

		// determine how the property gets bound
		var bindingType = this.BindingType.Direct;

		if ( propertyIndex !== undefined ) {

			// access a sub element of the property array (only primitives are supported right now)

			if ( propertyName === "morphTargetInfluences" ) {

				// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

				// support resolving morphTarget names into indices.
				if ( ! targetObject.geometry ) {

					console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
					return;

				}

				if ( targetObject.geometry.isBufferGeometry ) {

					if ( ! targetObject.geometry.morphAttributes ) {

						console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
						return;

					}

					for ( var i = 0; i < this.node.geometry.morphAttributes.position.length; i ++ ) {

						if ( targetObject.geometry.morphAttributes.position[ i ].name === propertyIndex ) {

							propertyIndex = i;
							break;

						}

					}


				} else {

					if ( ! targetObject.geometry.morphTargets ) {

						console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.', this );
						return;

					}

					for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {

						if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {

							propertyIndex = i;
							break;

						}

					}

				}

			}

			bindingType = this.BindingType.ArrayElement;

			this.resolvedProperty = nodeProperty;
			this.propertyIndex = propertyIndex;

		} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {

			// must use copy for Object3D.Euler/Quaternion

			bindingType = this.BindingType.HasFromToArray;

			this.resolvedProperty = nodeProperty;

		} else if ( Array.isArray( nodeProperty ) ) {

			bindingType = this.BindingType.EntireArray;

			this.resolvedProperty = nodeProperty;

		} else {

			this.propertyName = propertyName;

		}

		// select getter / setter
		this.getValue = this.GetterByBindingType[ bindingType ];
		this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

	},

	unbind: function () {

		this.node = null;

		// back to the prototype version of getValue / setValue
		// note: avoiding to mutate the shape of 'this' via 'delete'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}

} );

//!\ DECLARE ALIAS AFTER assign prototype !
Object.assign( PropertyBinding.prototype, {

	// initial state of these methods that calls 'bind'
	_getValue_unbound: PropertyBinding.prototype.getValue,
	_setValue_unbound: PropertyBinding.prototype.setValue,

} );

/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * 	-	Add objects you would otherwise pass as 'root' to the
 * 		constructor or the .clipAction method of AnimationMixer.
 *
 * 	-	Instead pass this object as 'root'.
 *
 * 	-	You can also add and remove objects later when the mixer
 * 		is running.
 *
 * Note:
 *
 *  	Objects of this class appear as one object to the mixer,
 *  	so cache control of the individual objects must be done
 *  	on the group.
 *
 * Limitation:
 *
 * 	- 	The animated properties must be compatible among the
 * 		all objects in the group.
 *
 *  -	A single property can either be controlled through a
 *  	target group or directly, but not both.
 *
 * @author tschw
 */

function AnimationObjectGroup() {

	this.uuid = _Math.generateUUID();

	// cached objects followed by the active ones
	this._objects = Array.prototype.slice.call( arguments );

	this.nCachedObjects_ = 0;			// threshold
	// note: read by PropertyBinding.Composite

	var indices = {};
	this._indicesByUUID = indices;		// for bookkeeping

	for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

		indices[ arguments[ i ].uuid ] = i;

	}

	this._paths = [];					// inside: string
	this._parsedPaths = [];				// inside: { we don't care, here }
	this._bindings = []; 				// inside: Array< PropertyBinding >
	this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays

	var scope = this;

	this.stats = {

		objects: {
			get total() {

				return scope._objects.length;

			},
			get inUse() {

				return this.total - scope.nCachedObjects_;

			}
		},
		get bindingsPerObject() {

			return scope._bindings.length;

		}

	};

}

Object.assign( AnimationObjectGroup.prototype, {

	isAnimationObjectGroup: true,

	add: function () {

		var objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			paths = this._paths,
			parsedPaths = this._parsedPaths,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ],
				knownObject = undefined;

			if ( index === undefined ) {

				// unknown object -> add it to the ACTIVE region

				index = nObjects ++;
				indicesByUUID[ uuid ] = index;
				objects.push( object );

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					bindings[ j ].push( new PropertyBinding( object, paths[ j ], parsedPaths[ j ] ) );

				}

			} else if ( index < nCachedObjects ) {

				knownObject = objects[ index ];

				// move existing object to the ACTIVE region

				var firstActiveIndex = -- nCachedObjects,
					lastCachedObject = objects[ firstActiveIndex ];

				indicesByUUID[ lastCachedObject.uuid ] = index;
				objects[ index ] = lastCachedObject;

				indicesByUUID[ uuid ] = firstActiveIndex;
				objects[ firstActiveIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					var bindingsForPath = bindings[ j ],
						lastCached = bindingsForPath[ firstActiveIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = lastCached;

					if ( binding === undefined ) {

						// since we do not bother to create new bindings
						// for objects that are cached, the binding may
						// or may not exist

						binding = new PropertyBinding( object, paths[ j ], parsedPaths[ j ] );

					}

					bindingsForPath[ firstActiveIndex ] = binding;

				}

			} else if ( objects[ index ] !== knownObject ) {

				console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
						'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );

			} // else the object is already where we want it to be

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	remove: function () {

		var objects = this._objects,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined && index >= nCachedObjects ) {

				// move existing object into the CACHED region

				var lastCachedIndex = nCachedObjects ++,
					firstActiveObject = objects[ lastCachedIndex ];

				indicesByUUID[ firstActiveObject.uuid ] = index;
				objects[ index ] = firstActiveObject;

				indicesByUUID[ uuid ] = lastCachedIndex;
				objects[ lastCachedIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					var bindingsForPath = bindings[ j ],
						firstActive = bindingsForPath[ lastCachedIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = firstActive;
					bindingsForPath[ lastCachedIndex ] = binding;

				}

			}

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	// remove & forget
	uncache: function () {

		var objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined ) {

				delete indicesByUUID[ uuid ];

				if ( index < nCachedObjects ) {

					// object is cached, shrink the CACHED region

					var firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ],
						lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					// last cached object takes this object's place
					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					// last object goes to the activated slot and pop
					indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							last = bindingsForPath[ lastIndex ];

						bindingsForPath[ index ] = lastCached;
						bindingsForPath[ firstActiveIndex ] = last;
						bindingsForPath.pop();

					}

				} else {

					// object is active, just swap with the last and pop

					var lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					indicesByUUID[ lastObject.uuid ] = index;
					objects[ index ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ];

						bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
						bindingsForPath.pop();

					}

				} // cached or active

			} // if object is known

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	// Internal interface used by befriended PropertyBinding.Composite:

	subscribe_: function ( path, parsedPath ) {

		// returns an array of bindings for the given path that is changed
		// according to the contained objects in the group

		var indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ],
			bindings = this._bindings;

		if ( index !== undefined ) return bindings[ index ];

		var paths = this._paths,
			parsedPaths = this._parsedPaths,
			objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			bindingsForPath = new Array( nObjects );

		index = bindings.length;

		indicesByPath[ path ] = index;

		paths.push( path );
		parsedPaths.push( parsedPath );
		bindings.push( bindingsForPath );

		for ( var i = nCachedObjects, n = objects.length; i !== n; ++ i ) {

			var object = objects[ i ];
			bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );

		}

		return bindingsForPath;

	},

	unsubscribe_: function ( path ) {

		// tells the group to forget about a property path and no longer
		// update the array previously obtained with 'subscribe_'

		var indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ];

		if ( index !== undefined ) {

			var paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				lastBindingsIndex = bindings.length - 1,
				lastBindings = bindings[ lastBindingsIndex ],
				lastBindingsPath = path[ lastBindingsIndex ];

			indicesByPath[ lastBindingsPath ] = index;

			bindings[ index ] = lastBindings;
			bindings.pop();

			parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
			parsedPaths.pop();

			paths[ index ] = paths[ lastBindingsIndex ];
			paths.pop();

		}

	}

} );

/**
 *
 * Action provided by AnimationMixer for scheduling clip playback on specific
 * objects.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 *
 */

function AnimationAction( mixer, clip, localRoot ) {

	this._mixer = mixer;
	this._clip = clip;
	this._localRoot = localRoot || null;

	var tracks = clip.tracks,
		nTracks = tracks.length,
		interpolants = new Array( nTracks );

	var interpolantSettings = {
		endingStart: ZeroCurvatureEnding,
		endingEnd: ZeroCurvatureEnding
	};

	for ( var i = 0; i !== nTracks; ++ i ) {

		var interpolant = tracks[ i ].createInterpolant( null );
		interpolants[ i ] = interpolant;
		interpolant.settings = interpolantSettings;

	}

	this._interpolantSettings = interpolantSettings;

	this._interpolants = interpolants;	// bound by the mixer

	// inside: PropertyMixer (managed by the mixer)
	this._propertyBindings = new Array( nTracks );

	this._cacheIndex = null;			// for the memory manager
	this._byClipCacheIndex = null;		// for the memory manager

	this._timeScaleInterpolant = null;
	this._weightInterpolant = null;

	this.loop = LoopRepeat;
	this._loopCount = - 1;

	// global mixer time when the action is to be started
	// it's set back to 'null' upon start of the action
	this._startTime = null;

	// scaled local time of the action
	// gets clamped or wrapped to 0..clip.duration according to loop
	this.time = 0;

	this.timeScale = 1;
	this._effectiveTimeScale = 1;

	this.weight = 1;
	this._effectiveWeight = 1;

	this.repetitions = Infinity; 		// no. of repetitions when looping

	this.paused = false;				// true -> zero effective time scale
	this.enabled = true;				// false -> zero effective weight

	this.clampWhenFinished 	= false;	// keep feeding the last frame?

	this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
	this.zeroSlopeAtEnd		= true;		// clips for start, loop and end

}

Object.assign( AnimationAction.prototype, {

	// State & Scheduling

	play: function () {

		this._mixer._activateAction( this );

		return this;

	},

	stop: function () {

		this._mixer._deactivateAction( this );

		return this.reset();

	},

	reset: function () {

		this.paused = false;
		this.enabled = true;

		this.time = 0;			// restart clip
		this._loopCount = - 1;	// forget previous loops
		this._startTime = null;	// forget scheduling

		return this.stopFading().stopWarping();

	},

	isRunning: function () {

		return this.enabled && ! this.paused && this.timeScale !== 0 &&
				this._startTime === null && this._mixer._isActiveAction( this );

	},

	// return true when play has been called
	isScheduled: function () {

		return this._mixer._isActiveAction( this );

	},

	startAt: function ( time ) {

		this._startTime = time;

		return this;

	},

	setLoop: function ( mode, repetitions ) {

		this.loop = mode;
		this.repetitions = repetitions;

		return this;

	},

	// Weight

	// set the weight stopping any scheduled fading
	// although .enabled = false yields an effective weight of zero, this
	// method does *not* change .enabled, because it would be confusing
	setEffectiveWeight: function ( weight ) {

		this.weight = weight;

		// note: same logic as when updated at runtime
		this._effectiveWeight = this.enabled ? weight : 0;

		return this.stopFading();

	},

	// return the weight considering fading and .enabled
	getEffectiveWeight: function () {

		return this._effectiveWeight;

	},

	fadeIn: function ( duration ) {

		return this._scheduleFading( duration, 0, 1 );

	},

	fadeOut: function ( duration ) {

		return this._scheduleFading( duration, 1, 0 );

	},

	crossFadeFrom: function ( fadeOutAction, duration, warp ) {

		fadeOutAction.fadeOut( duration );
		this.fadeIn( duration );

		if ( warp ) {

			var fadeInDuration = this._clip.duration,
				fadeOutDuration = fadeOutAction._clip.duration,

				startEndRatio = fadeOutDuration / fadeInDuration,
				endStartRatio = fadeInDuration / fadeOutDuration;

			fadeOutAction.warp( 1.0, startEndRatio, duration );
			this.warp( endStartRatio, 1.0, duration );

		}

		return this;

	},

	crossFadeTo: function ( fadeInAction, duration, warp ) {

		return fadeInAction.crossFadeFrom( this, duration, warp );

	},

	stopFading: function () {

		var weightInterpolant = this._weightInterpolant;

		if ( weightInterpolant !== null ) {

			this._weightInterpolant = null;
			this._mixer._takeBackControlInterpolant( weightInterpolant );

		}

		return this;

	},

	// Time Scale Control

	// set the time scale stopping any scheduled warping
	// although .paused = true yields an effective time scale of zero, this
	// method does *not* change .paused, because it would be confusing
	setEffectiveTimeScale: function ( timeScale ) {

		this.timeScale = timeScale;
		this._effectiveTimeScale = this.paused ? 0 : timeScale;

		return this.stopWarping();

	},

	// return the time scale considering warping and .paused
	getEffectiveTimeScale: function () {

		return this._effectiveTimeScale;

	},

	setDuration: function ( duration ) {

		this.timeScale = this._clip.duration / duration;

		return this.stopWarping();

	},

	syncWith: function ( action ) {

		this.time = action.time;
		this.timeScale = action.timeScale;

		return this.stopWarping();

	},

	halt: function ( duration ) {

		return this.warp( this._effectiveTimeScale, 0, duration );

	},

	warp: function ( startTimeScale, endTimeScale, duration ) {

		var mixer = this._mixer, now = mixer.time,
			interpolant = this._timeScaleInterpolant,

			timeScale = this.timeScale;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._timeScaleInterpolant = interpolant;

		}

		var times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		times[ 1 ] = now + duration;

		values[ 0 ] = startTimeScale / timeScale;
		values[ 1 ] = endTimeScale / timeScale;

		return this;

	},

	stopWarping: function () {

		var timeScaleInterpolant = this._timeScaleInterpolant;

		if ( timeScaleInterpolant !== null ) {

			this._timeScaleInterpolant = null;
			this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

		}

		return this;

	},

	// Object Accessors

	getMixer: function () {

		return this._mixer;

	},

	getClip: function () {

		return this._clip;

	},

	getRoot: function () {

		return this._localRoot || this._mixer._root;

	},

	// Interna

	_update: function ( time, deltaTime, timeDirection, accuIndex ) {

		// called by the mixer

		if ( ! this.enabled ) {

			// call ._updateWeight() to update ._effectiveWeight

			this._updateWeight( time );
			return;

		}

		var startTime = this._startTime;

		if ( startTime !== null ) {

			// check for scheduled start of action

			var timeRunning = ( time - startTime ) * timeDirection;
			if ( timeRunning < 0 || timeDirection === 0 ) {

				return; // yet to come / don't decide when delta = 0

			}

			// start

			this._startTime = null; // unschedule
			deltaTime = timeDirection * timeRunning;

		}

		// apply time scale and advance time

		deltaTime *= this._updateTimeScale( time );
		var clipTime = this._updateTime( deltaTime );

		// note: _updateTime may disable the action resulting in
		// an effective weight of 0

		var weight = this._updateWeight( time );

		if ( weight > 0 ) {

			var interpolants = this._interpolants;
			var propertyMixers = this._propertyBindings;

			for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {

				interpolants[ j ].evaluate( clipTime );
				propertyMixers[ j ].accumulate( accuIndex, weight );

			}

		}

	},

	_updateWeight: function ( time ) {

		var weight = 0;

		if ( this.enabled ) {

			weight = this.weight;
			var interpolant = this._weightInterpolant;

			if ( interpolant !== null ) {

				var interpolantValue = interpolant.evaluate( time )[ 0 ];

				weight *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopFading();

					if ( interpolantValue === 0 ) {

						// faded out, disable
						this.enabled = false;

					}

				}

			}

		}

		this._effectiveWeight = weight;
		return weight;

	},

	_updateTimeScale: function ( time ) {

		var timeScale = 0;

		if ( ! this.paused ) {

			timeScale = this.timeScale;

			var interpolant = this._timeScaleInterpolant;

			if ( interpolant !== null ) {

				var interpolantValue = interpolant.evaluate( time )[ 0 ];

				timeScale *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopWarping();

					if ( timeScale === 0 ) {

						// motion has halted, pause
						this.paused = true;

					} else {

						// warp done - apply final time scale
						this.timeScale = timeScale;

					}

				}

			}

		}

		this._effectiveTimeScale = timeScale;
		return timeScale;

	},

	_updateTime: function ( deltaTime ) {

		var time = this.time + deltaTime;

		if ( deltaTime === 0 ) return time;

		var duration = this._clip.duration,

			loop = this.loop,
			loopCount = this._loopCount;

		if ( loop === LoopOnce ) {

			if ( loopCount === - 1 ) {

				// just started

				this._loopCount = 0;
				this._setEndings( true, true, false );

			}

			handle_stop: {

				if ( time >= duration ) {

					time = duration;

				} else if ( time < 0 ) {

					time = 0;

				} else break handle_stop;

				if ( this.clampWhenFinished ) this.paused = true;
				else this.enabled = false;

				this._mixer.dispatchEvent( {
					type: 'finished', action: this,
					direction: deltaTime < 0 ? - 1 : 1
				} );

			}

		} else { // repetitive Repeat or PingPong

			var pingPong = ( loop === LoopPingPong );

			if ( loopCount === - 1 ) {

				// just started

				if ( deltaTime >= 0 ) {

					loopCount = 0;

					this._setEndings( true, this.repetitions === 0, pingPong );

				} else {

					// when looping in reverse direction, the initial
					// transition through zero counts as a repetition,
					// so leave loopCount at -1

					this._setEndings( this.repetitions === 0, true, pingPong );

				}

			}

			if ( time >= duration || time < 0 ) {

				// wrap around

				var loopDelta = Math.floor( time / duration ); // signed
				time -= duration * loopDelta;

				loopCount += Math.abs( loopDelta );

				var pending = this.repetitions - loopCount;

				if ( pending < 0 ) {

					// have to stop (switch state, clamp time, fire event)

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					time = deltaTime > 0 ? duration : 0;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime > 0 ? 1 : - 1
					} );

				} else {

					// keep running

					if ( pending === 0 ) {

						// entering the last round

						var atStart = deltaTime < 0;
						this._setEndings( atStart, ! atStart, pingPong );

					} else {

						this._setEndings( false, false, pingPong );

					}

					this._loopCount = loopCount;

					this._mixer.dispatchEvent( {
						type: 'loop', action: this, loopDelta: loopDelta
					} );

				}

			}

			if ( pingPong && ( loopCount & 1 ) === 1 ) {

				// invert time for the "pong round"

				this.time = time;
				return duration - time;

			}

		}

		this.time = time;
		return time;

	},

	_setEndings: function ( atStart, atEnd, pingPong ) {

		var settings = this._interpolantSettings;

		if ( pingPong ) {

			settings.endingStart 	= ZeroSlopeEnding;
			settings.endingEnd		= ZeroSlopeEnding;

		} else {

			// assuming for LoopOnce atStart == atEnd == true

			if ( atStart ) {

				settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingStart = WrapAroundEnding;

			}

			if ( atEnd ) {

				settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingEnd 	 = WrapAroundEnding;

			}

		}

	},

	_scheduleFading: function ( duration, weightNow, weightThen ) {

		var mixer = this._mixer, now = mixer.time,
			interpolant = this._weightInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._weightInterpolant = interpolant;

		}

		var times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now; 				values[ 0 ] = weightNow;
		times[ 1 ] = now + duration;	values[ 1 ] = weightThen;

		return this;

	}

} );

/**
 *
 * Player for AnimationClips.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function AnimationMixer( root ) {

	this._root = root;
	this._initMemoryManager();
	this._accuIndex = 0;

	this.time = 0;

	this.timeScale = 1.0;

}

AnimationMixer.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {

	constructor: AnimationMixer,

	_bindAction: function ( action, prototypeAction ) {

		var root = action._localRoot || this._root,
			tracks = action._clip.tracks,
			nTracks = tracks.length,
			bindings = action._propertyBindings,
			interpolants = action._interpolants,
			rootUuid = root.uuid,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingsByName = bindingsByRoot[ rootUuid ];

		if ( bindingsByName === undefined ) {

			bindingsByName = {};
			bindingsByRoot[ rootUuid ] = bindingsByName;

		}

		for ( var i = 0; i !== nTracks; ++ i ) {

			var track = tracks[ i ],
				trackName = track.name,
				binding = bindingsByName[ trackName ];

			if ( binding !== undefined ) {

				bindings[ i ] = binding;

			} else {

				binding = bindings[ i ];

				if ( binding !== undefined ) {

					// existing binding, make sure the cache knows

					if ( binding._cacheIndex === null ) {

						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );

					}

					continue;

				}

				var path = prototypeAction && prototypeAction.
					_propertyBindings[ i ].binding.parsedPath;

				binding = new PropertyMixer(
					PropertyBinding.create( root, trackName, path ),
					track.ValueTypeName, track.getValueSize() );

				++ binding.referenceCount;
				this._addInactiveBinding( binding, rootUuid, trackName );

				bindings[ i ] = binding;

			}

			interpolants[ i ].resultBuffer = binding.buffer;

		}

	},

	_activateAction: function ( action ) {

		if ( ! this._isActiveAction( action ) ) {

			if ( action._cacheIndex === null ) {

				// this action has been forgotten by the cache, but the user
				// appears to be still using it -> rebind

				var rootUuid = ( action._localRoot || this._root ).uuid,
					clipUuid = action._clip.uuid,
					actionsForClip = this._actionsByClip[ clipUuid ];

				this._bindAction( action,
					actionsForClip && actionsForClip.knownActions[ 0 ] );

				this._addInactiveAction( action, clipUuid, rootUuid );

			}

			var bindings = action._propertyBindings;

			// increment reference counts / sort out state
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( binding.useCount ++ === 0 ) {

					this._lendBinding( binding );
					binding.saveOriginalState();

				}

			}

			this._lendAction( action );

		}

	},

	_deactivateAction: function ( action ) {

		if ( this._isActiveAction( action ) ) {

			var bindings = action._propertyBindings;

			// decrement reference counts / sort out state
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( -- binding.useCount === 0 ) {

					binding.restoreOriginalState();
					this._takeBackBinding( binding );

				}

			}

			this._takeBackAction( action );

		}

	},

	// Memory manager

	_initMemoryManager: function () {

		this._actions = []; // 'nActiveActions' followed by inactive ones
		this._nActiveActions = 0;

		this._actionsByClip = {};
		// inside:
		// {
		// 		knownActions: Array< AnimationAction >	- used as prototypes
		// 		actionByRoot: AnimationAction			- lookup
		// }


		this._bindings = []; // 'nActiveBindings' followed by inactive ones
		this._nActiveBindings = 0;

		this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


		this._controlInterpolants = []; // same game as above
		this._nActiveControlInterpolants = 0;

		var scope = this;

		this.stats = {

			actions: {
				get total() {

					return scope._actions.length;

				},
				get inUse() {

					return scope._nActiveActions;

				}
			},
			bindings: {
				get total() {

					return scope._bindings.length;

				},
				get inUse() {

					return scope._nActiveBindings;

				}
			},
			controlInterpolants: {
				get total() {

					return scope._controlInterpolants.length;

				},
				get inUse() {

					return scope._nActiveControlInterpolants;

				}
			}

		};

	},

	// Memory management for AnimationAction objects

	_isActiveAction: function ( action ) {

		var index = action._cacheIndex;
		return index !== null && index < this._nActiveActions;

	},

	_addInactiveAction: function ( action, clipUuid, rootUuid ) {

		var actions = this._actions,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip === undefined ) {

			actionsForClip = {

				knownActions: [ action ],
				actionByRoot: {}

			};

			action._byClipCacheIndex = 0;

			actionsByClip[ clipUuid ] = actionsForClip;

		} else {

			var knownActions = actionsForClip.knownActions;

			action._byClipCacheIndex = knownActions.length;
			knownActions.push( action );

		}

		action._cacheIndex = actions.length;
		actions.push( action );

		actionsForClip.actionByRoot[ rootUuid ] = action;

	},

	_removeInactiveAction: function ( action ) {

		var actions = this._actions,
			lastInactiveAction = actions[ actions.length - 1 ],
			cacheIndex = action._cacheIndex;

		lastInactiveAction._cacheIndex = cacheIndex;
		actions[ cacheIndex ] = lastInactiveAction;
		actions.pop();

		action._cacheIndex = null;


		var clipUuid = action._clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ],
			knownActionsForClip = actionsForClip.knownActions,

			lastKnownAction =
				knownActionsForClip[ knownActionsForClip.length - 1 ],

			byClipCacheIndex = action._byClipCacheIndex;

		lastKnownAction._byClipCacheIndex = byClipCacheIndex;
		knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
		knownActionsForClip.pop();

		action._byClipCacheIndex = null;


		var actionByRoot = actionsForClip.actionByRoot,
			rootUuid = ( action._localRoot || this._root ).uuid;

		delete actionByRoot[ rootUuid ];

		if ( knownActionsForClip.length === 0 ) {

			delete actionsByClip[ clipUuid ];

		}

		this._removeInactiveBindingsForAction( action );

	},

	_removeInactiveBindingsForAction: function ( action ) {

		var bindings = action._propertyBindings;
		for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

			var binding = bindings[ i ];

			if ( -- binding.referenceCount === 0 ) {

				this._removeInactiveBinding( binding );

			}

		}

	},

	_lendAction: function ( action ) {

		// [ active actions |  inactive actions  ]
		// [  active actions >| inactive actions ]
		//                 s        a
		//                  <-swap->
		//                 a        s

		var actions = this._actions,
			prevIndex = action._cacheIndex,

			lastActiveIndex = this._nActiveActions ++,

			firstInactiveAction = actions[ lastActiveIndex ];

		action._cacheIndex = lastActiveIndex;
		actions[ lastActiveIndex ] = action;

		firstInactiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = firstInactiveAction;

	},

	_takeBackAction: function ( action ) {

		// [  active actions  | inactive actions ]
		// [ active actions |< inactive actions  ]
		//        a        s
		//         <-swap->
		//        s        a

		var actions = this._actions,
			prevIndex = action._cacheIndex,

			firstInactiveIndex = -- this._nActiveActions,

			lastActiveAction = actions[ firstInactiveIndex ];

		action._cacheIndex = firstInactiveIndex;
		actions[ firstInactiveIndex ] = action;

		lastActiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = lastActiveAction;

	},

	// Memory management for PropertyMixer objects

	_addInactiveBinding: function ( binding, rootUuid, trackName ) {

		var bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			bindings = this._bindings;

		if ( bindingByName === undefined ) {

			bindingByName = {};
			bindingsByRoot[ rootUuid ] = bindingByName;

		}

		bindingByName[ trackName ] = binding;

		binding._cacheIndex = bindings.length;
		bindings.push( binding );

	},

	_removeInactiveBinding: function ( binding ) {

		var bindings = this._bindings,
			propBinding = binding.binding,
			rootUuid = propBinding.rootNode.uuid,
			trackName = propBinding.path,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			lastInactiveBinding = bindings[ bindings.length - 1 ],
			cacheIndex = binding._cacheIndex;

		lastInactiveBinding._cacheIndex = cacheIndex;
		bindings[ cacheIndex ] = lastInactiveBinding;
		bindings.pop();

		delete bindingByName[ trackName ];

		remove_empty_map: {

			for ( var _ in bindingByName ) break remove_empty_map; // eslint-disable-line no-unused-vars

			delete bindingsByRoot[ rootUuid ];

		}

	},

	_lendBinding: function ( binding ) {

		var bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			lastActiveIndex = this._nActiveBindings ++,

			firstInactiveBinding = bindings[ lastActiveIndex ];

		binding._cacheIndex = lastActiveIndex;
		bindings[ lastActiveIndex ] = binding;

		firstInactiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = firstInactiveBinding;

	},

	_takeBackBinding: function ( binding ) {

		var bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			firstInactiveIndex = -- this._nActiveBindings,

			lastActiveBinding = bindings[ firstInactiveIndex ];

		binding._cacheIndex = firstInactiveIndex;
		bindings[ firstInactiveIndex ] = binding;

		lastActiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = lastActiveBinding;

	},


	// Memory management of Interpolants for weight and time scale

	_lendControlInterpolant: function () {

		var interpolants = this._controlInterpolants,
			lastActiveIndex = this._nActiveControlInterpolants ++,
			interpolant = interpolants[ lastActiveIndex ];

		if ( interpolant === undefined ) {

			interpolant = new LinearInterpolant(
				new Float32Array( 2 ), new Float32Array( 2 ),
				1, this._controlInterpolantsResultBuffer );

			interpolant.__cacheIndex = lastActiveIndex;
			interpolants[ lastActiveIndex ] = interpolant;

		}

		return interpolant;

	},

	_takeBackControlInterpolant: function ( interpolant ) {

		var interpolants = this._controlInterpolants,
			prevIndex = interpolant.__cacheIndex,

			firstInactiveIndex = -- this._nActiveControlInterpolants,

			lastActiveInterpolant = interpolants[ firstInactiveIndex ];

		interpolant.__cacheIndex = firstInactiveIndex;
		interpolants[ firstInactiveIndex ] = interpolant;

		lastActiveInterpolant.__cacheIndex = prevIndex;
		interpolants[ prevIndex ] = lastActiveInterpolant;

	},

	_controlInterpolantsResultBuffer: new Float32Array( 1 ),

	// return an action for a clip optionally using a custom root target
	// object (this method allocates a lot of dynamic memory in case a
	// previously unknown clip/root combination is specified)
	clipAction: function ( clip, optionalRoot ) {

		var root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
				AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject !== null ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ],
			prototypeAction = null;

		if ( actionsForClip !== undefined ) {

			var existingAction =
					actionsForClip.actionByRoot[ rootUuid ];

			if ( existingAction !== undefined ) {

				return existingAction;

			}

			// we know the clip, so we don't have to parse all
			// the bindings again but can just copy
			prototypeAction = actionsForClip.knownActions[ 0 ];

			// also, take the clip from the prototype action
			if ( clipObject === null )
				clipObject = prototypeAction._clip;

		}

		// clip must be known when specified via string
		if ( clipObject === null ) return null;

		// allocate all resources required to run it
		var newAction = new AnimationAction( this, clipObject, optionalRoot );

		this._bindAction( newAction, prototypeAction );

		// and make the action known to the memory manager
		this._addInactiveAction( newAction, clipUuid, rootUuid );

		return newAction;

	},

	// get an existing action
	existingAction: function ( clip, optionalRoot ) {

		var root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
				AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			return actionsForClip.actionByRoot[ rootUuid ] || null;

		}

		return null;

	},

	// deactivates all previously scheduled actions
	stopAllAction: function () {

		var actions = this._actions,
			nActions = this._nActiveActions,
			bindings = this._bindings,
			nBindings = this._nActiveBindings;

		this._nActiveActions = 0;
		this._nActiveBindings = 0;

		for ( var i = 0; i !== nActions; ++ i ) {

			actions[ i ].reset();

		}

		for ( var i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].useCount = 0;

		}

		return this;

	},

	// advance the time and update apply the animation
	update: function ( deltaTime ) {

		deltaTime *= this.timeScale;

		var actions = this._actions,
			nActions = this._nActiveActions,

			time = this.time += deltaTime,
			timeDirection = Math.sign( deltaTime ),

			accuIndex = this._accuIndex ^= 1;

		// run active actions

		for ( var i = 0; i !== nActions; ++ i ) {

			var action = actions[ i ];

			action._update( time, deltaTime, timeDirection, accuIndex );

		}

		// update scene graph

		var bindings = this._bindings,
			nBindings = this._nActiveBindings;

		for ( var i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].apply( accuIndex );

		}

		return this;

	},

	// return this mixer's root target object
	getRoot: function () {

		return this._root;

	},

	// free all resources specific to a particular clip
	uncacheClip: function ( clip ) {

		var actions = this._actions,
			clipUuid = clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			// note: just calling _removeInactiveAction would mess up the
			// iteration state and also require updating the state we can
			// just throw away

			var actionsToRemove = actionsForClip.knownActions;

			for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

				var action = actionsToRemove[ i ];

				this._deactivateAction( action );

				var cacheIndex = action._cacheIndex,
					lastInactiveAction = actions[ actions.length - 1 ];

				action._cacheIndex = null;
				action._byClipCacheIndex = null;

				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();

				this._removeInactiveBindingsForAction( action );

			}

			delete actionsByClip[ clipUuid ];

		}

	},

	// free all resources specific to a particular root target object
	uncacheRoot: function ( root ) {

		var rootUuid = root.uuid,
			actionsByClip = this._actionsByClip;

		for ( var clipUuid in actionsByClip ) {

			var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
				action = actionByRoot[ rootUuid ];

			if ( action !== undefined ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

		var bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName !== undefined ) {

			for ( var trackName in bindingByName ) {

				var binding = bindingByName[ trackName ];
				binding.restoreOriginalState();
				this._removeInactiveBinding( binding );

			}

		}

	},

	// remove a targeted clip from the cache
	uncacheAction: function ( clip, optionalRoot ) {

		var action = this.existingAction( clip, optionalRoot );

		if ( action !== null ) {

			this._deactivateAction( action );
			this._removeInactiveAction( action );

		}

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Uniform( value ) {

	if ( typeof value === 'string' ) {

		console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
		value = arguments[ 1 ];

	}

	this.value = value;

}

Uniform.prototype.clone = function () {

	return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedBufferGeometry() {

	BufferGeometry.call( this );

	this.type = 'InstancedBufferGeometry';
	this.maxInstancedCount = undefined;

}

InstancedBufferGeometry.prototype = Object.assign( Object.create( BufferGeometry.prototype ), {

	constructor: InstancedBufferGeometry,

	isInstancedBufferGeometry: true,

	copy: function ( source ) {

		BufferGeometry.prototype.copy.call( this, source );

		this.maxInstancedCount = source.maxInstancedCount;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	}

} );

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {

	this.uuid = _Math.generateUUID();

	this.data = interleavedBuffer;
	this.itemSize = itemSize;
	this.offset = offset;

	this.normalized = normalized === true;

}

Object.defineProperties( InterleavedBufferAttribute.prototype, {

	count: {

		get: function () {

			return this.data.count;

		}

	},

	array: {

		get: function () {

			return this.data.array;

		}

	}

} );

Object.assign( InterleavedBufferAttribute.prototype, {

	isInterleavedBufferAttribute: true,

	setX: function ( index, x ) {

		this.data.array[ index * this.data.stride + this.offset ] = x;

		return this;

	},

	setY: function ( index, y ) {

		this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

		return this;

	},

	setZ: function ( index, z ) {

		this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

		return this;

	},

	setW: function ( index, w ) {

		this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

		return this;

	},

	getX: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset ];

	},

	getY: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 1 ];

	},

	getZ: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 2 ];

	},

	getW: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 3 ];

	},

	setXY: function ( index, x, y ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;

		return this;

	},

	setXYZ: function ( index, x, y, z ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;

		return this;

	},

	setXYZW: function ( index, x, y, z, w ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;
		this.data.array[ index + 3 ] = w;

		return this;

	}

} );

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InterleavedBuffer( array, stride ) {

	this.uuid = _Math.generateUUID();

	this.array = array;
	this.stride = stride;
	this.count = array !== undefined ? array.length / stride : 0;

	this.dynamic = false;
	this.updateRange = { offset: 0, count: - 1 };

	this.onUploadCallback = function () {};

	this.version = 0;

}

Object.defineProperty( InterleavedBuffer.prototype, 'needsUpdate', {

	set: function ( value ) {

		if ( value === true ) this.version ++;

	}

} );

Object.assign( InterleavedBuffer.prototype, {

	isInterleavedBuffer: true,

	setArray: function ( array ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.count = array !== undefined ? array.length / this.stride : 0;
		this.array = array;

	},

	setDynamic: function ( value ) {

		this.dynamic = value;

		return this;

	},

	copy: function ( source ) {

		this.array = new source.array.constructor( source.array );
		this.count = source.count;
		this.stride = source.stride;
		this.dynamic = source.dynamic;

		return this;

	},

	copyAt: function ( index1, attribute, index2 ) {

		index1 *= this.stride;
		index2 *= attribute.stride;

		for ( var i = 0, l = this.stride; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	},

	set: function ( value, offset ) {

		if ( offset === undefined ) offset = 0;

		this.array.set( value, offset );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	onUpload: function ( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

} );

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {

	InterleavedBuffer.call( this, array, stride );

	this.meshPerAttribute = meshPerAttribute || 1;

}

InstancedInterleavedBuffer.prototype = Object.assign( Object.create( InterleavedBuffer.prototype ), {

	constructor: InstancedInterleavedBuffer,

	isInstancedInterleavedBuffer: true,

	copy: function ( source ) {

		InterleavedBuffer.prototype.copy.call( this, source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

} );

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {

	BufferAttribute.call( this, array, itemSize );

	this.meshPerAttribute = meshPerAttribute || 1;

}

InstancedBufferAttribute.prototype = Object.assign( Object.create( BufferAttribute.prototype ), {

	constructor: InstancedBufferAttribute,

	isInstancedBufferAttribute: true,

	copy: function ( source ) {

		BufferAttribute.prototype.copy.call( this, source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author bhouston / http://clara.io/
 * @author stephomi / http://stephaneginier.com/
 */

function Raycaster( origin, direction, near, far ) {

	this.ray = new Ray( origin, direction );
	// direction is assumed to be normalized (for accurate distance calculations)

	this.near = near || 0;
	this.far = far || Infinity;

	this.params = {
		Mesh: {},
		Line: {},
		LOD: {},
		Points: { threshold: 1 },
		Sprite: {}
	};

	Object.defineProperties( this.params, {
		PointCloud: {
			get: function () {

				console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
				return this.Points;

			}
		}
	} );

}

function ascSort( a, b ) {

	return a.distance - b.distance;

}

function intersectObject( object, raycaster, intersects, recursive ) {

	if ( object.visible === false ) return;

	object.raycast( raycaster, intersects );

	if ( recursive === true ) {

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			intersectObject( children[ i ], raycaster, intersects, true );

		}

	}

}

Object.assign( Raycaster.prototype, {

	linePrecision: 1,

	set: function ( origin, direction ) {

		// direction is assumed to be normalized (for accurate distance calculations)

		this.ray.set( origin, direction );

	},

	setFromCamera: function ( coords, camera ) {

		if ( ( camera && camera.isPerspectiveCamera ) ) {

			this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
			this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();

		} else if ( ( camera && camera.isOrthographicCamera ) ) {

			this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
			this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );

		} else {

			console.error( 'THREE.Raycaster: Unsupported camera type.' );

		}

	},

	intersectObject: function ( object, recursive ) {

		var intersects = [];

		intersectObject( object, this, intersects, recursive );

		intersects.sort( ascSort );

		return intersects;

	},

	intersectObjects: function ( objects, recursive ) {

		var intersects = [];

		if ( Array.isArray( objects ) === false ) {

			console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
			return intersects;

		}

		for ( var i = 0, l = objects.length; i < l; i ++ ) {

			intersectObject( objects[ i ], this, intersects, recursive );

		}

		intersects.sort( ascSort );

		return intersects;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Clock( autoStart ) {

	this.autoStart = ( autoStart !== undefined ) ? autoStart : true;

	this.startTime = 0;
	this.oldTime = 0;
	this.elapsedTime = 0;

	this.running = false;

}

Object.assign( Clock.prototype, {

	start: function () {

		this.startTime = ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732

		this.oldTime = this.startTime;
		this.elapsedTime = 0;
		this.running = true;

	},

	stop: function () {

		this.getElapsedTime();
		this.running = false;
		this.autoStart = false;

	},

	getElapsedTime: function () {

		this.getDelta();
		return this.elapsedTime;

	},

	getDelta: function () {

		var diff = 0;

		if ( this.autoStart && ! this.running ) {

			this.start();
			return 0;

		}

		if ( this.running ) {

			var newTime = ( typeof performance === 'undefined' ? Date : performance ).now();

			diff = ( newTime - this.oldTime ) / 1000;
			this.oldTime = newTime;

			this.elapsedTime += diff;

		}

		return diff;

	}

} );

/**
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 *
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The poles (phi) are at the positive and negative y axis.
 * The equator starts at positive z.
 */

function Spherical( radius, phi, theta ) {

	this.radius = ( radius !== undefined ) ? radius : 1.0;
	this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
	this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere

	return this;

}

Object.assign( Spherical.prototype, {

	set: function ( radius, phi, theta ) {

		this.radius = radius;
		this.phi = phi;
		this.theta = theta;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( other ) {

		this.radius = other.radius;
		this.phi = other.phi;
		this.theta = other.theta;

		return this;

	},

	// restrict phi to be betwee EPS and PI-EPS
	makeSafe: function () {

		var EPS = 0.000001;
		this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

		return this;

	},

	setFromVector3: function ( vec3 ) {

		this.radius = vec3.length();

		if ( this.radius === 0 ) {

			this.theta = 0;
			this.phi = 0;

		} else {

			this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
			this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle

		}

		return this;

	}

} );

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 *
 */

function Cylindrical( radius, theta, y ) {

	this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
	this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
	this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane

	return this;

}

Object.assign( Cylindrical.prototype, {

	set: function ( radius, theta, y ) {

		this.radius = radius;
		this.theta = theta;
		this.y = y;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( other ) {

		this.radius = other.radius;
		this.theta = other.theta;
		this.y = other.y;

		return this;

	},

	setFromVector3: function ( vec3 ) {

		this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
		this.theta = Math.atan2( vec3.x, vec3.z );
		this.y = vec3.y;

		return this;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function ImmediateRenderObject( material ) {

	Object3D.call( this );

	this.material = material;
	this.render = function ( /* renderCallback */ ) {};

}

ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;

ImmediateRenderObject.prototype.isImmediateRenderObject = true;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function VertexNormalsHelper( object, size, hex, linewidth ) {

	this.object = object;

	this.size = ( size !== undefined ) ? size : 1;

	var color = ( hex !== undefined ) ? hex : 0xff0000;

	var width = ( linewidth !== undefined ) ? linewidth : 1;

	//

	var nNormals = 0;

	var objGeometry = this.object.geometry;

	if ( objGeometry && objGeometry.isGeometry ) {

		nNormals = objGeometry.faces.length * 3;

	} else if ( objGeometry && objGeometry.isBufferGeometry ) {

		nNormals = objGeometry.attributes.normal.count;

	}

	//

	var geometry = new BufferGeometry();

	var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

	geometry.addAttribute( 'position', positions );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

	//

	this.matrixAutoUpdate = false;

	this.update();

}

VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;

VertexNormalsHelper.prototype.update = ( function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var normalMatrix = new Matrix3();

	return function update() {

		var keys = [ 'a', 'b', 'c' ];

		this.object.updateMatrixWorld( true );

		normalMatrix.getNormalMatrix( this.object.matrixWorld );

		var matrixWorld = this.object.matrixWorld;

		var position = this.geometry.attributes.position;

		//

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			var vertices = objGeometry.vertices;

			var faces = objGeometry.faces;

			var idx = 0;

			for ( var i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

					var vertex = vertices[ face[ keys[ j ] ] ];

					var normal = face.vertexNormals[ j ];

					v1.copy( vertex ).applyMatrix4( matrixWorld );

					v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

					position.setXYZ( idx, v1.x, v1.y, v1.z );

					idx = idx + 1;

					position.setXYZ( idx, v2.x, v2.y, v2.z );

					idx = idx + 1;

				}

			}

		} else if ( objGeometry && objGeometry.isBufferGeometry ) {

			var objPos = objGeometry.attributes.position;

			var objNorm = objGeometry.attributes.normal;

			var idx = 0;

			// for simplicity, ignore index and drawcalls, and render every normal

			for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {

				v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );

				v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );

				v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

				position.setXYZ( idx, v1.x, v1.y, v1.z );

				idx = idx + 1;

				position.setXYZ( idx, v2.x, v2.y, v2.z );

				idx = idx + 1;

			}

		}

		position.needsUpdate = true;

	};

}() );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function SpotLightHelper( light, color ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	this.color = color;

	var geometry = new BufferGeometry();

	var positions = [
		0, 0, 0, 	0, 0, 1,
		0, 0, 0, 	1, 0, 1,
		0, 0, 0,	- 1, 0, 1,
		0, 0, 0, 	0, 1, 1,
		0, 0, 0, 	0, - 1, 1
	];

	for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

		var p1 = ( i / l ) * Math.PI * 2;
		var p2 = ( j / l ) * Math.PI * 2;

		positions.push(
			Math.cos( p1 ), Math.sin( p1 ), 1,
			Math.cos( p2 ), Math.sin( p2 ), 1
		);

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

	var material = new LineBasicMaterial( { fog: false } );

	this.cone = new LineSegments( geometry, material );
	this.add( this.cone );

	this.update();

}

SpotLightHelper.prototype = Object.create( Object3D.prototype );
SpotLightHelper.prototype.constructor = SpotLightHelper;

SpotLightHelper.prototype.dispose = function () {

	this.cone.geometry.dispose();
	this.cone.material.dispose();

};

SpotLightHelper.prototype.update = function () {

	var vector = new Vector3();
	var vector2 = new Vector3();

	return function update() {

		this.light.updateMatrixWorld();

		var coneLength = this.light.distance ? this.light.distance : 1000;
		var coneWidth = coneLength * Math.tan( this.light.angle );

		this.cone.scale.set( coneWidth, coneWidth, coneLength );

		vector.setFromMatrixPosition( this.light.matrixWorld );
		vector2.setFromMatrixPosition( this.light.target.matrixWorld );

		this.cone.lookAt( vector2.sub( vector ) );

		if ( this.color !== undefined ) {

			this.cone.material.color.set( this.color );

		} else {

			this.cone.material.color.copy( this.light.color );

		}

	};

}();

/**
 * @author Sean Griffin / http://twitter.com/sgrif
 * @author Michael Guerrero / http://realitymeltdown.com
 * @author mrdoob / http://mrdoob.com/
 * @author ikerr / http://verold.com
 * @author Mugen87 / https://github.com/Mugen87
 */

function getBoneList( object ) {

	var boneList = [];

	if ( object && object.isBone ) {

		boneList.push( object );

	}

	for ( var i = 0; i < object.children.length; i ++ ) {

		boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );

	}

	return boneList;

}

function SkeletonHelper( object ) {

	var bones = getBoneList( object );

	var geometry = new BufferGeometry();

	var vertices = [];
	var colors = [];

	var color1 = new Color( 0, 0, 1 );
	var color2 = new Color( 0, 1, 0 );

	for ( var i = 0; i < bones.length; i ++ ) {

		var bone = bones[ i ];

		if ( bone.parent && bone.parent.isBone ) {

			vertices.push( 0, 0, 0 );
			vertices.push( 0, 0, 0 );
			colors.push( color1.r, color1.g, color1.b );
			colors.push( color2.r, color2.g, color2.b );

		}

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );

	LineSegments.call( this, geometry, material );

	this.root = object;
	this.bones = bones;

	this.matrix = object.matrixWorld;
	this.matrixAutoUpdate = false;

}

SkeletonHelper.prototype = Object.create( LineSegments.prototype );
SkeletonHelper.prototype.constructor = SkeletonHelper;

SkeletonHelper.prototype.updateMatrixWorld = function () {

	var vector = new Vector3();

	var boneMatrix = new Matrix4();
	var matrixWorldInv = new Matrix4();

	return function updateMatrixWorld( force ) {

		var bones = this.bones;

		var geometry = this.geometry;
		var position = geometry.getAttribute( 'position' );

		matrixWorldInv.getInverse( this.root.matrixWorld );

		for ( var i = 0, j = 0; i < bones.length; i ++ ) {

			var bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
				vector.setFromMatrixPosition( boneMatrix );
				position.setXYZ( j, vector.x, vector.y, vector.z );

				boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
				vector.setFromMatrixPosition( boneMatrix );
				position.setXYZ( j + 1, vector.x, vector.y, vector.z );

				j += 2;

			}

		}

		geometry.getAttribute( 'position' ).needsUpdate = true;

		Object3D.prototype.updateMatrixWorld.call( this, force );

	};

}();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function PointLightHelper( light, sphereSize, color ) {

	this.light = light;
	this.light.updateMatrixWorld();

	this.color = color;

	var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
	var material = new MeshBasicMaterial( { wireframe: true, fog: false } );

	Mesh.call( this, geometry, material );

	this.matrix = this.light.matrixWorld;
	this.matrixAutoUpdate = false;

	this.update();


	/*
	var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	var d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/

}

PointLightHelper.prototype = Object.create( Mesh.prototype );
PointLightHelper.prototype.constructor = PointLightHelper;

PointLightHelper.prototype.dispose = function () {

	this.geometry.dispose();
	this.material.dispose();

};

PointLightHelper.prototype.update = function () {

	if ( this.color !== undefined ) {

		this.material.color.set( this.color );

	} else {

		this.material.color.copy( this.light.color );

	}

	/*
	var d = this.light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.visible = true;
		this.lightDistance.scale.set( d, d, d );

	}
	*/

};

/**
 * @author abelnation / http://github.com/abelnation
 * @author Mugen87 / http://github.com/Mugen87
 * @author WestLangley / http://github.com/WestLangley
 */

function RectAreaLightHelper( light, color ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	this.color = color;

	var material = new LineBasicMaterial( { fog: false } );

	var geometry = new BufferGeometry();

	geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 5 * 3 ), 3 ) );

	this.line = new Line( geometry, material );
	this.add( this.line );


	this.update();

}

RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;

RectAreaLightHelper.prototype.dispose = function () {

	this.children[ 0 ].geometry.dispose();
	this.children[ 0 ].material.dispose();

};

RectAreaLightHelper.prototype.update = function () {

	// calculate new dimensions of the helper

	var hx = this.light.width * 0.5;
	var hy = this.light.height * 0.5;

	var position = this.line.geometry.attributes.position;
	var array = position.array;

	// update vertices

	array[ 0 ] = hx; array[ 1 ] = - hy; array[ 2 ] = 0;
	array[ 3 ] = hx; array[ 4 ] = hy; array[ 5 ] = 0;
	array[ 6 ] = - hx; array[ 7 ] = hy; array[ 8 ] = 0;
	array[ 9 ] = - hx; array[ 10 ] = - hy; array[ 11 ] = 0;
	array[ 12 ] = hx; array[ 13 ] = - hy; array[ 14 ] = 0;

	position.needsUpdate = true;

	if ( this.color !== undefined ) {

		this.line.material.color.set( this.color );

	} else {

		this.line.material.color.copy( this.light.color );

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

function HemisphereLightHelper( light, size, color ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	this.color = color;

	var geometry = new OctahedronBufferGeometry( size );
	geometry.rotateY( Math.PI * 0.5 );

	this.material = new MeshBasicMaterial( { wireframe: true, fog: false } );
	if ( this.color === undefined ) this.material.vertexColors = VertexColors;

	var position = geometry.getAttribute( 'position' );
	var colors = new Float32Array( position.count * 3 );

	geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );

	this.add( new Mesh( geometry, this.material ) );

	this.update();

}

HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;

HemisphereLightHelper.prototype.dispose = function () {

	this.children[ 0 ].geometry.dispose();
	this.children[ 0 ].material.dispose();

};

HemisphereLightHelper.prototype.update = function () {

	var vector = new Vector3();

	var color1 = new Color();
	var color2 = new Color();

	return function update() {

		var mesh = this.children[ 0 ];

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			var colors = mesh.geometry.getAttribute( 'color' );

			color1.copy( this.light.color );
			color2.copy( this.light.groundColor );

			for ( var i = 0, l = colors.count; i < l; i ++ ) {

				var color = ( i < ( l / 2 ) ) ? color1 : color2;

				colors.setXYZ( i, color.r, color.g, color.b );

			}

			colors.needsUpdate = true;

		}

		mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );

	};

}();

/**
 * @author mrdoob / http://mrdoob.com/
 */

function GridHelper( size, divisions, color1, color2 ) {

	size = size || 10;
	divisions = divisions || 10;
	color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
	color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

	var center = divisions / 2;
	var step = size / divisions;
	var halfSize = size / 2;

	var vertices = [], colors = [];

	for ( var i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {

		vertices.push( - halfSize, 0, k, halfSize, 0, k );
		vertices.push( k, 0, - halfSize, k, 0, halfSize );

		var color = i === center ? color1 : color2;

		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;

	}

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

GridHelper.prototype = Object.create( LineSegments.prototype );
GridHelper.prototype.constructor = GridHelper;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / http://github.com/Mugen87
 * @author Hectate / http://www.github.com/Hectate
 */

function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {

	radius = radius || 10;
	radials = radials || 16;
	circles = circles || 8;
	divisions = divisions || 64;
	color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
	color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

	var vertices = [];
	var colors = [];

	var x, z;
	var v, i, j, r, color;

	// create the radials

	for ( i = 0; i <= radials; i ++ ) {

		v = ( i / radials ) * ( Math.PI * 2 );

		x = Math.sin( v ) * radius;
		z = Math.cos( v ) * radius;

		vertices.push( 0, 0, 0 );
		vertices.push( x, 0, z );

		color = ( i & 1 ) ? color1 : color2;

		colors.push( color.r, color.g, color.b );
		colors.push( color.r, color.g, color.b );

	}

	// create the circles

	for ( i = 0; i <= circles; i ++ ) {

		color = ( i & 1 ) ? color1 : color2;

		r = radius - ( radius / circles * i );

		for ( j = 0; j < divisions; j ++ ) {

			// first vertex

			v = ( j / divisions ) * ( Math.PI * 2 );

			x = Math.sin( v ) * r;
			z = Math.cos( v ) * r;

			vertices.push( x, 0, z );
			colors.push( color.r, color.g, color.b );

			// second vertex

			v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

			x = Math.sin( v ) * r;
			z = Math.cos( v ) * r;

			vertices.push( x, 0, z );
			colors.push( color.r, color.g, color.b );

		}

	}

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

PolarGridHelper.prototype = Object.create( LineSegments.prototype );
PolarGridHelper.prototype.constructor = PolarGridHelper;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function FaceNormalsHelper( object, size, hex, linewidth ) {

	// FaceNormalsHelper only supports THREE.Geometry

	this.object = object;

	this.size = ( size !== undefined ) ? size : 1;

	var color = ( hex !== undefined ) ? hex : 0xffff00;

	var width = ( linewidth !== undefined ) ? linewidth : 1;

	//

	var nNormals = 0;

	var objGeometry = this.object.geometry;

	if ( objGeometry && objGeometry.isGeometry ) {

		nNormals = objGeometry.faces.length;

	} else {

		console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );

	}

	//

	var geometry = new BufferGeometry();

	var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

	geometry.addAttribute( 'position', positions );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

	//

	this.matrixAutoUpdate = false;
	this.update();

}

FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;

FaceNormalsHelper.prototype.update = ( function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var normalMatrix = new Matrix3();

	return function update() {

		this.object.updateMatrixWorld( true );

		normalMatrix.getNormalMatrix( this.object.matrixWorld );

		var matrixWorld = this.object.matrixWorld;

		var position = this.geometry.attributes.position;

		//

		var objGeometry = this.object.geometry;

		var vertices = objGeometry.vertices;

		var faces = objGeometry.faces;

		var idx = 0;

		for ( var i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			var normal = face.normal;

			v1.copy( vertices[ face.a ] )
				.add( vertices[ face.b ] )
				.add( vertices[ face.c ] )
				.divideScalar( 3 )
				.applyMatrix4( matrixWorld );

			v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

			position.setXYZ( idx, v1.x, v1.y, v1.z );

			idx = idx + 1;

			position.setXYZ( idx, v2.x, v2.y, v2.z );

			idx = idx + 1;

		}

		position.needsUpdate = true;

	};

}() );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function DirectionalLightHelper( light, size, color ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	this.color = color;

	if ( size === undefined ) size = 1;

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( [
		- size, size, 0,
		size, size, 0,
		size, - size, 0,
		- size, - size, 0,
		- size, size, 0
	], 3 ) );

	var material = new LineBasicMaterial( { fog: false } );

	this.lightPlane = new Line( geometry, material );
	this.add( this.lightPlane );

	geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

	this.targetLine = new Line( geometry, material );
	this.add( this.targetLine );

	this.update();

}

DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;

DirectionalLightHelper.prototype.dispose = function () {

	this.lightPlane.geometry.dispose();
	this.lightPlane.material.dispose();
	this.targetLine.geometry.dispose();
	this.targetLine.material.dispose();

};

DirectionalLightHelper.prototype.update = function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var v3 = new Vector3();

	return function update() {

		v1.setFromMatrixPosition( this.light.matrixWorld );
		v2.setFromMatrixPosition( this.light.target.matrixWorld );
		v3.subVectors( v2, v1 );

		this.lightPlane.lookAt( v3 );

		if ( this.color !== undefined ) {

			this.lightPlane.material.color.set( this.color );
			this.targetLine.material.color.set( this.color );

		} else {

			this.lightPlane.material.color.copy( this.light.color );
			this.targetLine.material.color.copy( this.light.color );

		}

		this.targetLine.lookAt( v3 );
		this.targetLine.scale.z = v3.length();

	};

}();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author Mugen87 / https://github.com/Mugen87
 *
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */

function CameraHelper( camera ) {

	var geometry = new BufferGeometry();
	var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );

	var vertices = [];
	var colors = [];

	var pointMap = {};

	// colors

	var colorFrustum = new Color( 0xffaa00 );
	var colorCone = new Color( 0xff0000 );
	var colorUp = new Color( 0x00aaff );
	var colorTarget = new Color( 0xffffff );
	var colorCross = new Color( 0x333333 );

	// near

	addLine( 'n1', 'n2', colorFrustum );
	addLine( 'n2', 'n4', colorFrustum );
	addLine( 'n4', 'n3', colorFrustum );
	addLine( 'n3', 'n1', colorFrustum );

	// far

	addLine( 'f1', 'f2', colorFrustum );
	addLine( 'f2', 'f4', colorFrustum );
	addLine( 'f4', 'f3', colorFrustum );
	addLine( 'f3', 'f1', colorFrustum );

	// sides

	addLine( 'n1', 'f1', colorFrustum );
	addLine( 'n2', 'f2', colorFrustum );
	addLine( 'n3', 'f3', colorFrustum );
	addLine( 'n4', 'f4', colorFrustum );

	// cone

	addLine( 'p', 'n1', colorCone );
	addLine( 'p', 'n2', colorCone );
	addLine( 'p', 'n3', colorCone );
	addLine( 'p', 'n4', colorCone );

	// up

	addLine( 'u1', 'u2', colorUp );
	addLine( 'u2', 'u3', colorUp );
	addLine( 'u3', 'u1', colorUp );

	// target

	addLine( 'c', 't', colorTarget );
	addLine( 'p', 'c', colorCross );

	// cross

	addLine( 'cn1', 'cn2', colorCross );
	addLine( 'cn3', 'cn4', colorCross );

	addLine( 'cf1', 'cf2', colorCross );
	addLine( 'cf3', 'cf4', colorCross );

	function addLine( a, b, color ) {

		addPoint( a, color );
		addPoint( b, color );

	}

	function addPoint( id, color ) {

		vertices.push( 0, 0, 0 );
		colors.push( color.r, color.g, color.b );

		if ( pointMap[ id ] === undefined ) {

			pointMap[ id ] = [];

		}

		pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	LineSegments.call( this, geometry, material );

	this.camera = camera;
	if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

	this.matrix = camera.matrixWorld;
	this.matrixAutoUpdate = false;

	this.pointMap = pointMap;

	this.update();

}

CameraHelper.prototype = Object.create( LineSegments.prototype );
CameraHelper.prototype.constructor = CameraHelper;

CameraHelper.prototype.update = function () {

	var geometry, pointMap;

	var vector = new Vector3();
	var camera = new Camera();

	function setPoint( point, x, y, z ) {

		vector.set( x, y, z ).unproject( camera );

		var points = pointMap[ point ];

		if ( points !== undefined ) {

			var position = geometry.getAttribute( 'position' );

			for ( var i = 0, l = points.length; i < l; i ++ ) {

				position.setXYZ( points[ i ], vector.x, vector.y, vector.z );

			}

		}

	}

	return function update() {

		geometry = this.geometry;
		pointMap = this.pointMap;

		var w = 1, h = 1;

		// we need just camera projection matrix
		// world matrix must be identity

		camera.projectionMatrix.copy( this.camera.projectionMatrix );

		// center / target

		setPoint( 'c', 0, 0, - 1 );
		setPoint( 't', 0, 0, 1 );

		// near

		setPoint( 'n1', - w, - h, - 1 );
		setPoint( 'n2', w, - h, - 1 );
		setPoint( 'n3', - w, h, - 1 );
		setPoint( 'n4', w, h, - 1 );

		// far

		setPoint( 'f1', - w, - h, 1 );
		setPoint( 'f2', w, - h, 1 );
		setPoint( 'f3', - w, h, 1 );
		setPoint( 'f4', w, h, 1 );

		// up

		setPoint( 'u1', w * 0.7, h * 1.1, - 1 );
		setPoint( 'u2', - w * 0.7, h * 1.1, - 1 );
		setPoint( 'u3', 0, h * 2, - 1 );

		// cross

		setPoint( 'cf1', - w, 0, 1 );
		setPoint( 'cf2', w, 0, 1 );
		setPoint( 'cf3', 0, - h, 1 );
		setPoint( 'cf4', 0, h, 1 );

		setPoint( 'cn1', - w, 0, - 1 );
		setPoint( 'cn2', w, 0, - 1 );
		setPoint( 'cn3', 0, - h, - 1 );
		setPoint( 'cn4', 0, h, - 1 );

		geometry.getAttribute( 'position' ).needsUpdate = true;

	};

}();

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / http://github.com/Mugen87
 */

function BoxHelper( object, color ) {

	this.object = object;

	if ( color === undefined ) color = 0xffff00;

	var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
	var positions = new Float32Array( 8 * 3 );

	var geometry = new BufferGeometry();
	geometry.setIndex( new BufferAttribute( indices, 1 ) );
	geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

	this.matrixAutoUpdate = false;

	this.update();

}

BoxHelper.prototype = Object.create( LineSegments.prototype );
BoxHelper.prototype.constructor = BoxHelper;

BoxHelper.prototype.update = ( function () {

	var box = new Box3();

	return function update( object ) {

		if ( object !== undefined ) {

			console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );

		}

		if ( this.object !== undefined ) {

			box.setFromObject( this.object );

		}

		if ( box.isEmpty() ) return;

		var min = box.min;
		var max = box.max;

		/*
		  5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/

		var position = this.geometry.attributes.position;
		var array = position.array;

		array[ 0 ] = max.x; array[ 1 ] = max.y; array[ 2 ] = max.z;
		array[ 3 ] = min.x; array[ 4 ] = max.y; array[ 5 ] = max.z;
		array[ 6 ] = min.x; array[ 7 ] = min.y; array[ 8 ] = max.z;
		array[ 9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
		array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
		array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
		array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
		array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

		position.needsUpdate = true;

		this.geometry.computeBoundingSphere();

	};

} )();

BoxHelper.prototype.setFromObject = function ( object ) {

	this.object = object;
	this.update();

	return this;

};

/**
 * @author WestLangley / http://github.com/WestLangley
 */

function Box3Helper( box, hex ) {

	this.type = 'Box3Helper';

	this.box = box;

	var color = ( hex !== undefined ) ? hex : 0xffff00;

	var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );

	var positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];

	var geometry = new BufferGeometry();

	geometry.setIndex( new BufferAttribute( indices, 1 ) );

	geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

	this.geometry.computeBoundingSphere();

}

Box3Helper.prototype = Object.create( LineSegments.prototype );
Box3Helper.prototype.constructor = Box3Helper;

Box3Helper.prototype.updateMatrixWorld = function ( force ) {

	var box = this.box;

	if ( box.isEmpty() ) return;

	box.getCenter( this.position );

	box.getSize( this.scale );

	this.scale.multiplyScalar( 0.5 );

	Object3D.prototype.updateMatrixWorld.call( this, force );

};

/**
 * @author WestLangley / http://github.com/WestLangley
 */

function PlaneHelper( plane, size, hex ) {

	this.type = 'PlaneHelper';

	this.plane = plane;

	this.size = ( size === undefined ) ? 1 : size;

	var color = ( hex !== undefined ) ? hex : 0xffff00;

	var positions = [ 1, - 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0 ];

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	geometry.computeBoundingSphere();

	Line.call( this, geometry, new LineBasicMaterial( { color: color } ) );

	//

	var positions2 = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, - 1, 1, 1, - 1, 1 ];

	var geometry2 = new BufferGeometry();
	geometry2.addAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
	geometry2.computeBoundingSphere();

	this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false } ) ) );

}

PlaneHelper.prototype = Object.create( Line.prototype );
PlaneHelper.prototype.constructor = PlaneHelper;

PlaneHelper.prototype.updateMatrixWorld = function ( force ) {

	var scale = - this.plane.constant;

	if ( Math.abs( scale ) < 1e-8 ) scale = 1e-8; // sign does not matter

	this.scale.set( 0.5 * this.size, 0.5 * this.size, scale );

	this.lookAt( this.plane.normal );

	Object3D.prototype.updateMatrixWorld.call( this, force );

};

/**
 * @author WestLangley / http://github.com/WestLangley
 * @author zz85 / http://github.com/zz85
 * @author bhouston / http://clara.io
 *
 * Creates an arrow for visualizing directions
 *
 * Parameters:
 *  dir - Vector3
 *  origin - Vector3
 *  length - Number
 *  color - color in hex value
 *  headLength - Number
 *  headWidth - Number
 */

var lineGeometry;
var coneGeometry;

function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {

	// dir is assumed to be normalized

	Object3D.call( this );

	if ( color === undefined ) color = 0xffff00;
	if ( length === undefined ) length = 1;
	if ( headLength === undefined ) headLength = 0.2 * length;
	if ( headWidth === undefined ) headWidth = 0.2 * headLength;

	if ( lineGeometry === undefined ) {

		lineGeometry = new BufferGeometry();
		lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

		coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
		coneGeometry.translate( 0, - 0.5, 0 );

	}

	this.position.copy( origin );

	this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
	this.line.matrixAutoUpdate = false;
	this.add( this.line );

	this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
	this.cone.matrixAutoUpdate = false;
	this.add( this.cone );

	this.setDirection( dir );
	this.setLength( length, headLength, headWidth );

}

ArrowHelper.prototype = Object.create( Object3D.prototype );
ArrowHelper.prototype.constructor = ArrowHelper;

ArrowHelper.prototype.setDirection = ( function () {

	var axis = new Vector3();
	var radians;

	return function setDirection( dir ) {

		// dir is assumed to be normalized

		if ( dir.y > 0.99999 ) {

			this.quaternion.set( 0, 0, 0, 1 );

		} else if ( dir.y < - 0.99999 ) {

			this.quaternion.set( 1, 0, 0, 0 );

		} else {

			axis.set( dir.z, 0, - dir.x ).normalize();

			radians = Math.acos( dir.y );

			this.quaternion.setFromAxisAngle( axis, radians );

		}

	};

}() );

ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {

	if ( headLength === undefined ) headLength = 0.2 * length;
	if ( headWidth === undefined ) headWidth = 0.2 * headLength;

	this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
	this.line.updateMatrix();

	this.cone.scale.set( headWidth, headLength, headWidth );
	this.cone.position.y = length;
	this.cone.updateMatrix();

};

ArrowHelper.prototype.setColor = function ( color ) {

	this.line.material.color.copy( color );
	this.cone.material.color.copy( color );

};

/**
 * @author sroucheray / http://sroucheray.org/
 * @author mrdoob / http://mrdoob.com/
 */

function AxesHelper( size ) {

	size = size || 1;

	var vertices = [
		0, 0, 0,	size, 0, 0,
		0, 0, 0,	0, size, 0,
		0, 0, 0,	0, 0, size
	];

	var colors = [
		1, 0, 0,	1, 0.6, 0,
		0, 1, 0,	0.6, 1, 0,
		0, 0, 1,	0, 0.6, 1
	];

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

AxesHelper.prototype = Object.create( LineSegments.prototype );
AxesHelper.prototype.constructor = AxesHelper;

/**
 * @author alteredq / http://alteredqualia.com/
 */

var SceneUtils = {

	createMultiMaterialObject: function ( geometry, materials ) {

		var group = new Group();

		for ( var i = 0, l = materials.length; i < l; i ++ ) {

			group.add( new Mesh( geometry, materials[ i ] ) );

		}

		return group;

	},

	detach: function ( child, parent, scene ) {

		child.applyMatrix( parent.matrixWorld );
		parent.remove( child );
		scene.add( child );

	},

	attach: function ( child, scene, parent ) {

		child.applyMatrix( new Matrix4().getInverse( parent.matrixWorld ) );

		scene.remove( child );
		parent.add( child );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Face4( a, b, c, d, normal, color, materialIndex ) {

	console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
	return new Face3( a, b, c, normal, color, materialIndex );

}

var LineStrip = 0;

var LinePieces = 1;

function MeshFaceMaterial( materials ) {

	console.warn( 'THREE.MeshFaceMaterial has been removed. Use an Array instead.' );
	return materials;

}

function MultiMaterial( materials ) {

	if ( materials === undefined ) materials = [];

	console.warn( 'THREE.MultiMaterial has been removed. Use an Array instead.' );
	materials.isMultiMaterial = true;
	materials.materials = materials;
	materials.clone = function () {

		return materials.slice();

	};
	return materials;

}

function PointCloud( geometry, material ) {

	console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
	return new Points( geometry, material );

}

function Particle( material ) {

	console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
	return new Sprite( material );

}

function ParticleSystem( geometry, material ) {

	console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
	return new Points( geometry, material );

}

function PointCloudMaterial( parameters ) {

	console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function ParticleBasicMaterial( parameters ) {

	console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function ParticleSystemMaterial( parameters ) {

	console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function Vertex( x, y, z ) {

	console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
	return new Vector3( x, y, z );

}

//

function DynamicBufferAttribute( array, itemSize ) {

	console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
	return new BufferAttribute( array, itemSize ).setDynamic( true );

}

function Int8Attribute( array, itemSize ) {

	console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
	return new Int8BufferAttribute( array, itemSize );

}

function Uint8Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
	return new Uint8BufferAttribute( array, itemSize );

}

function Uint8ClampedAttribute( array, itemSize ) {

	console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
	return new Uint8ClampedBufferAttribute( array, itemSize );

}

function Int16Attribute( array, itemSize ) {

	console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
	return new Int16BufferAttribute( array, itemSize );

}

function Uint16Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
	return new Uint16BufferAttribute( array, itemSize );

}

function Int32Attribute( array, itemSize ) {

	console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
	return new Int32BufferAttribute( array, itemSize );

}

function Uint32Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
	return new Uint32BufferAttribute( array, itemSize );

}

function Float32Attribute( array, itemSize ) {

	console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
	return new Float32BufferAttribute( array, itemSize );

}

function Float64Attribute( array, itemSize ) {

	console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
	return new Float64BufferAttribute( array, itemSize );

}

//

Curve.create = function ( construct, getPoint ) {

	console.log( 'THREE.Curve.create() has been deprecated' );

	construct.prototype = Object.create( Curve.prototype );
	construct.prototype.constructor = construct;
	construct.prototype.getPoint = getPoint;

	return construct;

};

//

Object.assign( CurvePath.prototype, {

	createPointsGeometry: function ( divisions ) {

		console.warn( 'THREE.CurvePath: .createPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );

		// generate geometry from path points (for Line or Points objects)

		var pts = this.getPoints( divisions );
		return this.createGeometry( pts );

	},

	createSpacedPointsGeometry: function ( divisions ) {

		console.warn( 'THREE.CurvePath: .createSpacedPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );

		// generate geometry from equidistant sampling along the path

		var pts = this.getSpacedPoints( divisions );
		return this.createGeometry( pts );

	},

	createGeometry: function ( points ) {

		console.warn( 'THREE.CurvePath: .createGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );

		var geometry = new Geometry();

		for ( var i = 0, l = points.length; i < l; i ++ ) {

			var point = points[ i ];
			geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );

		}

		return geometry;

	}

} );

//

Object.assign( Path.prototype, {

	fromPoints: function ( points ) {

		console.warn( 'THREE.Path: .fromPoints() has been renamed to .setFromPoints().' );
		this.setFromPoints( points );

	}

} );

//

function ClosedSplineCurve3( points ) {

	console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

	CatmullRomCurve3.call( this, points );
	this.type = 'catmullrom';
	this.closed = true;

}

ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );

//

function SplineCurve3( points ) {

	console.warn( 'THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

	CatmullRomCurve3.call( this, points );
	this.type = 'catmullrom';

}

SplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );

//

function Spline( points ) {

	console.warn( 'THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.' );

	CatmullRomCurve3.call( this, points );
	this.type = 'catmullrom';

}

Spline.prototype = Object.create( CatmullRomCurve3.prototype );

Object.assign( Spline.prototype, {

	initFromArray: function ( /* a */ ) {

		console.error( 'THREE.Spline: .initFromArray() has been removed.' );

	},
	getControlPointsArray: function ( /* optionalTarget */ ) {

		console.error( 'THREE.Spline: .getControlPointsArray() has been removed.' );

	},
	reparametrizeByArcLength: function ( /* samplingCoef */ ) {

		console.error( 'THREE.Spline: .reparametrizeByArcLength() has been removed.' );

	}

} );

//

function AxisHelper( size ) {

	console.warn( 'THREE.AxisHelper has been renamed to THREE.AxesHelper.' );
	return new AxesHelper( size );

}

function BoundingBoxHelper( object, color ) {

	console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
	return new BoxHelper( object, color );

}

function EdgesHelper( object, hex ) {

	console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
	return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

}

GridHelper.prototype.setColors = function () {

	console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );

};

SkeletonHelper.prototype.update = function () {

	console.error( 'THREE.SkeletonHelper: update() no longer needs to be called.' );

};

function WireframeHelper( object, hex ) {

	console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
	return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

}

//

Object.assign( Loader.prototype, {

	extractUrlBase: function ( url ) {

		console.warn( 'THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.' );
		return LoaderUtils.extractUrlBase( url );

	}

} );

function XHRLoader( manager ) {

	console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
	return new FileLoader( manager );

}

function BinaryTextureLoader( manager ) {

	console.warn( 'THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.' );
	return new DataTextureLoader( manager );

}

//

Object.assign( Box2.prototype, {

	center: function ( optionalTarget ) {

		console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	},
	empty: function () {

		console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
		return this.isEmpty();

	},
	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	size: function ( optionalTarget ) {

		console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
		return this.getSize( optionalTarget );

	}
} );

Object.assign( Box3.prototype, {

	center: function ( optionalTarget ) {

		console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	},
	empty: function () {

		console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
		return this.isEmpty();

	},
	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	isIntersectionSphere: function ( sphere ) {

		console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
		return this.intersectsSphere( sphere );

	},
	size: function ( optionalTarget ) {

		console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
		return this.getSize( optionalTarget );

	}
} );

Line3.prototype.center = function ( optionalTarget ) {

	console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
	return this.getCenter( optionalTarget );

};

Object.assign( _Math, {

	random16: function () {

		console.warn( 'THREE.Math: .random16() has been deprecated. Use Math.random() instead.' );
		return Math.random();

	},

	nearestPowerOfTwo: function ( value ) {

		console.warn( 'THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo().' );
		return _Math.floorPowerOfTwo( value );

	},

	nextPowerOfTwo: function ( value ) {

		console.warn( 'THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo().' );
		return _Math.ceilPowerOfTwo( value );

	}

} );

Object.assign( Matrix3.prototype, {

	flattenToArrayOffset: function ( array, offset ) {

		console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
		return this.toArray( array, offset );

	},
	multiplyVector3: function ( vector ) {

		console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
		return vector.applyMatrix3( this );

	},
	multiplyVector3Array: function ( /* a */ ) {

		console.error( 'THREE.Matrix3: .multiplyVector3Array() has been removed.' );

	},
	applyToBuffer: function ( buffer /*, offset, length */ ) {

		console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
		return this.applyToBufferAttribute( buffer );

	},
	applyToVector3Array: function ( /* array, offset, length */ ) {

		console.error( 'THREE.Matrix3: .applyToVector3Array() has been removed.' );

	}

} );

Object.assign( Matrix4.prototype, {

	extractPosition: function ( m ) {

		console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
		return this.copyPosition( m );

	},
	flattenToArrayOffset: function ( array, offset ) {

		console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
		return this.toArray( array, offset );

	},
	getPosition: function () {

		var v1;

		return function getPosition() {

			if ( v1 === undefined ) v1 = new Vector3();
			console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
			return v1.setFromMatrixColumn( this, 3 );

		};

	}(),
	setRotationFromQuaternion: function ( q ) {

		console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
		return this.makeRotationFromQuaternion( q );

	},
	multiplyToArray: function () {

		console.warn( 'THREE.Matrix4: .multiplyToArray() has been removed.' );

	},
	multiplyVector3: function ( vector ) {

		console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
		return vector.applyMatrix4( this );

	},
	multiplyVector4: function ( vector ) {

		console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
		return vector.applyMatrix4( this );

	},
	multiplyVector3Array: function ( /* a */ ) {

		console.error( 'THREE.Matrix4: .multiplyVector3Array() has been removed.' );

	},
	rotateAxis: function ( v ) {

		console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
		v.transformDirection( this );

	},
	crossVector: function ( vector ) {

		console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
		return vector.applyMatrix4( this );

	},
	translate: function () {

		console.error( 'THREE.Matrix4: .translate() has been removed.' );

	},
	rotateX: function () {

		console.error( 'THREE.Matrix4: .rotateX() has been removed.' );

	},
	rotateY: function () {

		console.error( 'THREE.Matrix4: .rotateY() has been removed.' );

	},
	rotateZ: function () {

		console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );

	},
	rotateByAxis: function () {

		console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );

	},
	applyToBuffer: function ( buffer /*, offset, length */ ) {

		console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
		return this.applyToBufferAttribute( buffer );

	},
	applyToVector3Array: function ( /* array, offset, length */ ) {

		console.error( 'THREE.Matrix4: .applyToVector3Array() has been removed.' );

	},
	makeFrustum: function ( left, right, bottom, top, near, far ) {

		console.warn( 'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.' );
		return this.makePerspective( left, right, top, bottom, near, far );

	}

} );

Plane.prototype.isIntersectionLine = function ( line ) {

	console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
	return this.intersectsLine( line );

};

Quaternion.prototype.multiplyVector3 = function ( vector ) {

	console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
	return vector.applyQuaternion( this );

};

Object.assign( Ray.prototype, {

	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	isIntersectionPlane: function ( plane ) {

		console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
		return this.intersectsPlane( plane );

	},
	isIntersectionSphere: function ( sphere ) {

		console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
		return this.intersectsSphere( sphere );

	}

} );

Object.assign( Shape.prototype, {

	extractAllPoints: function ( divisions ) {

		console.warn( 'THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.' );
		return this.extractPoints( divisions );

	},
	extrude: function ( options ) {

		console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
		return new ExtrudeGeometry( this, options );

	},
	makeGeometry: function ( options ) {

		console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
		return new ShapeGeometry( this, options );

	}

} );

Object.assign( Vector2.prototype, {

	fromAttribute: function ( attribute, index, offset ) {

		console.warn( 'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().' );
		return this.fromBufferAttribute( attribute, index, offset );

	},
	distanceToManhattan: function ( v ) {

		console.warn( 'THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().' );
		return this.manhattanDistanceTo( v );

	},
	lengthManhattan: function () {

		console.warn( 'THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().' );
		return this.manhattanLength();

	}

} );

Object.assign( Vector3.prototype, {

	setEulerFromRotationMatrix: function () {

		console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );

	},
	setEulerFromQuaternion: function () {

		console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );

	},
	getPositionFromMatrix: function ( m ) {

		console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
		return this.setFromMatrixPosition( m );

	},
	getScaleFromMatrix: function ( m ) {

		console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
		return this.setFromMatrixScale( m );

	},
	getColumnFromMatrix: function ( index, matrix ) {

		console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
		return this.setFromMatrixColumn( matrix, index );

	},
	applyProjection: function ( m ) {

		console.warn( 'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.' );
		return this.applyMatrix4( m );

	},
	fromAttribute: function ( attribute, index, offset ) {

		console.warn( 'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().' );
		return this.fromBufferAttribute( attribute, index, offset );

	},
	distanceToManhattan: function ( v ) {

		console.warn( 'THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().' );
		return this.manhattanDistanceTo( v );

	},
	lengthManhattan: function () {

		console.warn( 'THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().' );
		return this.manhattanLength();

	}

} );

Object.assign( Vector4.prototype, {

	fromAttribute: function ( attribute, index, offset ) {

		console.warn( 'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().' );
		return this.fromBufferAttribute( attribute, index, offset );

	},
	lengthManhattan: function () {

		console.warn( 'THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().' );
		return this.manhattanLength();

	}

} );

//

Geometry.prototype.computeTangents = function () {

	console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );

};

Object.assign( Object3D.prototype, {

	getChildByName: function ( name ) {

		console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
		return this.getObjectByName( name );

	},
	renderDepth: function () {

		console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );

	},
	translate: function ( distance, axis ) {

		console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
		return this.translateOnAxis( axis, distance );

	}

} );

Object.defineProperties( Object3D.prototype, {

	eulerOrder: {
		get: function () {

			console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
			return this.rotation.order;

		},
		set: function ( value ) {

			console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
			this.rotation.order = value;

		}
	},
	useQuaternion: {
		get: function () {

			console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

		},
		set: function () {

			console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

		}
	}

} );

Object.defineProperties( LOD.prototype, {

	objects: {
		get: function () {

			console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
			return this.levels;

		}
	}

} );

Object.defineProperty( Skeleton.prototype, 'useVertexTexture', {

	get: function () {

		console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );

	},
	set: function () {

		console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );

	}

} );

Object.defineProperty( Curve.prototype, '__arcLengthDivisions', {

	get: function () {

		console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
		return this.arcLengthDivisions;

	},
	set: function ( value ) {

		console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
		this.arcLengthDivisions = value;

	}

} );

//

PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {

	console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
			"Use .setFocalLength and .filmGauge for a photographic setup." );

	if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
	this.setFocalLength( focalLength );

};

//

Object.defineProperties( Light.prototype, {
	onlyShadow: {
		set: function () {

			console.warn( 'THREE.Light: .onlyShadow has been removed.' );

		}
	},
	shadowCameraFov: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
			this.shadow.camera.fov = value;

		}
	},
	shadowCameraLeft: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
			this.shadow.camera.left = value;

		}
	},
	shadowCameraRight: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
			this.shadow.camera.right = value;

		}
	},
	shadowCameraTop: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
			this.shadow.camera.top = value;

		}
	},
	shadowCameraBottom: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
			this.shadow.camera.bottom = value;

		}
	},
	shadowCameraNear: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
			this.shadow.camera.near = value;

		}
	},
	shadowCameraFar: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
			this.shadow.camera.far = value;

		}
	},
	shadowCameraVisible: {
		set: function () {

			console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );

		}
	},
	shadowBias: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
			this.shadow.bias = value;

		}
	},
	shadowDarkness: {
		set: function () {

			console.warn( 'THREE.Light: .shadowDarkness has been removed.' );

		}
	},
	shadowMapWidth: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
			this.shadow.mapSize.width = value;

		}
	},
	shadowMapHeight: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
			this.shadow.mapSize.height = value;

		}
	}
} );

//

Object.defineProperties( BufferAttribute.prototype, {

	length: {
		get: function () {

			console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
			return this.array.length;

		}
	}

} );

Object.assign( BufferGeometry.prototype, {

	addIndex: function ( index ) {

		console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
		this.setIndex( index );

	},
	addDrawCall: function ( start, count, indexOffset ) {

		if ( indexOffset !== undefined ) {

			console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );

		}
		console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
		this.addGroup( start, count );

	},
	clearDrawCalls: function () {

		console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
		this.clearGroups();

	},
	computeTangents: function () {

		console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );

	},
	computeOffsets: function () {

		console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );

	}

} );

Object.defineProperties( BufferGeometry.prototype, {

	drawcalls: {
		get: function () {

			console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
			return this.groups;

		}
	},
	offsets: {
		get: function () {

			console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
			return this.groups;

		}
	}

} );

//

Object.defineProperties( Uniform.prototype, {

	dynamic: {
		set: function () {

			console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );

		}
	},
	onUpdate: {
		value: function () {

			console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
			return this;

		}
	}

} );

//

Object.defineProperties( Material.prototype, {

	wrapAround: {
		get: function () {

			console.warn( 'THREE.Material: .wrapAround has been removed.' );

		},
		set: function () {

			console.warn( 'THREE.Material: .wrapAround has been removed.' );

		}
	},
	wrapRGB: {
		get: function () {

			console.warn( 'THREE.Material: .wrapRGB has been removed.' );
			return new Color();

		}
	},

	shading: {
		get: function () {

			console.error( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );

		},
		set: function ( value ) {

			console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
			this.flatShading = ( value === FlatShading );

		}
	}

} );

Object.defineProperties( MeshPhongMaterial.prototype, {

	metal: {
		get: function () {

			console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
			return false;

		},
		set: function () {

			console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );

		}
	}

} );

Object.defineProperties( ShaderMaterial.prototype, {

	derivatives: {
		get: function () {

			console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
			return this.extensions.derivatives;

		},
		set: function ( value ) {

			console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
			this.extensions.derivatives = value;

		}
	}

} );

//

Object.assign( WebGLRenderer.prototype, {

	getCurrentRenderTarget: function () {

		console.warn( 'THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().' );
		return this.getRenderTarget();

	},

	getMaxAnisotropy: function () {

		console.warn( 'THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().' );
		return this.capabilities.getMaxAnisotropy();

	},

	getPrecision: function () {

		console.warn( 'THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.' );
		return this.capabilities.precision;

	},

	resetGLState: function () {

		console.warn( 'THREE.WebGLRenderer: .resetGLState() is now .state.reset().' );
		return this.state.reset();

	},

	supportsFloatTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
		return this.extensions.get( 'OES_texture_float' );

	},
	supportsHalfFloatTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
		return this.extensions.get( 'OES_texture_half_float' );

	},
	supportsStandardDerivatives: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
		return this.extensions.get( 'OES_standard_derivatives' );

	},
	supportsCompressedTextureS3TC: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
		return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );

	},
	supportsCompressedTexturePVRTC: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
		return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );

	},
	supportsBlendMinMax: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
		return this.extensions.get( 'EXT_blend_minmax' );

	},
	supportsVertexTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
		return this.capabilities.vertexTextures;

	},
	supportsInstancedArrays: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
		return this.extensions.get( 'ANGLE_instanced_arrays' );

	},
	enableScissorTest: function ( boolean ) {

		console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
		this.setScissorTest( boolean );

	},
	initMaterial: function () {

		console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );

	},
	addPrePlugin: function () {

		console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );

	},
	addPostPlugin: function () {

		console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );

	},
	updateShadowMap: function () {

		console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );

	}

} );

Object.defineProperties( WebGLRenderer.prototype, {

	shadowMapEnabled: {
		get: function () {

			return this.shadowMap.enabled;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
			this.shadowMap.enabled = value;

		}
	},
	shadowMapType: {
		get: function () {

			return this.shadowMap.type;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
			this.shadowMap.type = value;

		}
	},
	shadowMapCullFace: {
		get: function () {

			return this.shadowMap.cullFace;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
			this.shadowMap.cullFace = value;

		}
	}
} );

Object.defineProperties( WebGLShadowMap.prototype, {

	cullFace: {
		get: function () {

			return this.renderReverseSided ? CullFaceFront : CullFaceBack;

		},
		set: function ( cullFace ) {

			var value = ( cullFace !== CullFaceBack );
			console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
			this.renderReverseSided = value;

		}
	}

} );

//

Object.defineProperties( WebGLRenderTarget.prototype, {

	wrapS: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
			return this.texture.wrapS;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
			this.texture.wrapS = value;

		}
	},
	wrapT: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
			return this.texture.wrapT;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
			this.texture.wrapT = value;

		}
	},
	magFilter: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
			return this.texture.magFilter;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
			this.texture.magFilter = value;

		}
	},
	minFilter: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
			return this.texture.minFilter;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
			this.texture.minFilter = value;

		}
	},
	anisotropy: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
			return this.texture.anisotropy;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
			this.texture.anisotropy = value;

		}
	},
	offset: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
			return this.texture.offset;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
			this.texture.offset = value;

		}
	},
	repeat: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
			return this.texture.repeat;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
			this.texture.repeat = value;

		}
	},
	format: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
			return this.texture.format;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
			this.texture.format = value;

		}
	},
	type: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
			return this.texture.type;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
			this.texture.type = value;

		}
	},
	generateMipmaps: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
			return this.texture.generateMipmaps;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
			this.texture.generateMipmaps = value;

		}
	}

} );

//

Object.assign( WebVRManager.prototype, {

	getStandingMatrix: function () {

		console.warn( 'THREE.WebVRManager: .getStandingMatrix() has been removed.' );

	}

} );

Object.defineProperties( WebVRManager.prototype, {

	standing: {
		set: function ( /* value */ ) {

			console.warn( 'THREE.WebVRManager: .standing has been removed.' );

		}
	}

} );

//

Audio.prototype.load = function ( file ) {

	console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
	var scope = this;
	var audioLoader = new AudioLoader();
	audioLoader.load( file, function ( buffer ) {

		scope.setBuffer( buffer );

	} );
	return this;

};

AudioAnalyser.prototype.getData = function () {

	console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
	return this.getFrequencyData();

};

//

CubeCamera.prototype.updateCubeMap = function ( renderer, scene ) {

	console.warn( 'THREE.CubeCamera: .updateCubeMap() is now .update().' );
	return this.update( renderer, scene );

};

//

var GeometryUtils = {

	merge: function ( geometry1, geometry2, materialIndexOffset ) {

		console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
		var matrix;

		if ( geometry2.isMesh ) {

			geometry2.matrixAutoUpdate && geometry2.updateMatrix();

			matrix = geometry2.matrix;
			geometry2 = geometry2.geometry;

		}

		geometry1.merge( geometry2, matrix, materialIndexOffset );

	},

	center: function ( geometry ) {

		console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
		return geometry.center();

	}

};

var ImageUtils = {

	crossOrigin: undefined,

	loadTexture: function ( url, mapping, onLoad, onError ) {

		console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );

		var loader = new TextureLoader();
		loader.setCrossOrigin( this.crossOrigin );

		var texture = loader.load( url, onLoad, undefined, onError );

		if ( mapping ) texture.mapping = mapping;

		return texture;

	},

	loadTextureCube: function ( urls, mapping, onLoad, onError ) {

		console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );

		var loader = new CubeTextureLoader();
		loader.setCrossOrigin( this.crossOrigin );

		var texture = loader.load( urls, onLoad, undefined, onError );

		if ( mapping ) texture.mapping = mapping;

		return texture;

	},

	loadCompressedTexture: function () {

		console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );

	},

	loadCompressedTextureCube: function () {

		console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );

	}

};

//

function Projector() {

	console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );

	this.projectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
		vector.project( camera );

	};

	this.unprojectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
		vector.unproject( camera );

	};

	this.pickingRay = function () {

		console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );

	};

}

//

function CanvasRenderer() {

	console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );

	this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
	this.clear = function () {};
	this.render = function () {};
	this.setClearColor = function () {};
	this.setSize = function () {};

}




/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*
 * Copyright (c) 2015 cannon.js Authors
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use, copy,
 * modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

!function(e){if(true)module.exports=e();else if("function"==typeof define&&false)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.CANNON=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports={
  "name": "cannon",
  "version": "0.6.2",
  "description": "A lightweight 3D physics engine written in JavaScript.",
  "homepage": "https://github.com/schteppe/cannon.js",
  "author": "Stefan Hedman <schteppe@gmail.com> (http://steffe.se)",
  "keywords": [
    "cannon.js",
    "cannon",
    "physics",
    "engine",
    "3d"
  ],
  "main": "./build/cannon.js",
  "engines": {
    "node": "*"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/schteppe/cannon.js.git"
  },
  "bugs": {
    "url": "https://github.com/schteppe/cannon.js/issues"
  },
  "licenses": [
    {
      "type": "MIT"
    }
  ],
  "devDependencies": {
    "jshint": "latest",
    "uglify-js": "latest",
    "nodeunit": "^0.9.0",
    "grunt": "~0.4.0",
    "grunt-contrib-jshint": "~0.1.1",
    "grunt-contrib-nodeunit": "^0.4.1",
    "grunt-contrib-concat": "~0.1.3",
    "grunt-contrib-uglify": "^0.5.1",
    "grunt-browserify": "^2.1.4",
    "grunt-contrib-yuidoc": "^0.5.2",
    "browserify": "*"
  },
  "dependencies": {}
}

},{}],2:[function(_dereq_,module,exports){
// Export classes
module.exports = {
    version :                       _dereq_('../package.json').version,

    AABB :                          _dereq_('./collision/AABB'),
    ArrayCollisionMatrix :          _dereq_('./collision/ArrayCollisionMatrix'),
    Body :                          _dereq_('./objects/Body'),
    Box :                           _dereq_('./shapes/Box'),
    Broadphase :                    _dereq_('./collision/Broadphase'),
    Constraint :                    _dereq_('./constraints/Constraint'),
    ContactEquation :               _dereq_('./equations/ContactEquation'),
    Narrowphase :                   _dereq_('./world/Narrowphase'),
    ConeTwistConstraint :           _dereq_('./constraints/ConeTwistConstraint'),
    ContactMaterial :               _dereq_('./material/ContactMaterial'),
    ConvexPolyhedron :              _dereq_('./shapes/ConvexPolyhedron'),
    Cylinder :                      _dereq_('./shapes/Cylinder'),
    DistanceConstraint :            _dereq_('./constraints/DistanceConstraint'),
    Equation :                      _dereq_('./equations/Equation'),
    EventTarget :                   _dereq_('./utils/EventTarget'),
    FrictionEquation :              _dereq_('./equations/FrictionEquation'),
    GSSolver :                      _dereq_('./solver/GSSolver'),
    GridBroadphase :                _dereq_('./collision/GridBroadphase'),
    Heightfield :                   _dereq_('./shapes/Heightfield'),
    HingeConstraint :               _dereq_('./constraints/HingeConstraint'),
    LockConstraint :                _dereq_('./constraints/LockConstraint'),
    Mat3 :                          _dereq_('./math/Mat3'),
    Material :                      _dereq_('./material/Material'),
    NaiveBroadphase :               _dereq_('./collision/NaiveBroadphase'),
    ObjectCollisionMatrix :         _dereq_('./collision/ObjectCollisionMatrix'),
    Pool :                          _dereq_('./utils/Pool'),
    Particle :                      _dereq_('./shapes/Particle'),
    Plane :                         _dereq_('./shapes/Plane'),
    PointToPointConstraint :        _dereq_('./constraints/PointToPointConstraint'),
    Quaternion :                    _dereq_('./math/Quaternion'),
    Ray :                           _dereq_('./collision/Ray'),
    RaycastVehicle :                _dereq_('./objects/RaycastVehicle'),
    RaycastResult :                 _dereq_('./collision/RaycastResult'),
    RigidVehicle :                  _dereq_('./objects/RigidVehicle'),
    RotationalEquation :            _dereq_('./equations/RotationalEquation'),
    RotationalMotorEquation :       _dereq_('./equations/RotationalMotorEquation'),
    SAPBroadphase :                 _dereq_('./collision/SAPBroadphase'),
    SPHSystem :                     _dereq_('./objects/SPHSystem'),
    Shape :                         _dereq_('./shapes/Shape'),
    Solver :                        _dereq_('./solver/Solver'),
    Sphere :                        _dereq_('./shapes/Sphere'),
    SplitSolver :                   _dereq_('./solver/SplitSolver'),
    Spring :                        _dereq_('./objects/Spring'),
    Trimesh :                       _dereq_('./shapes/Trimesh'),
    Vec3 :                          _dereq_('./math/Vec3'),
    Vec3Pool :                      _dereq_('./utils/Vec3Pool'),
    World :                         _dereq_('./world/World'),
};

},{"../package.json":1,"./collision/AABB":3,"./collision/ArrayCollisionMatrix":4,"./collision/Broadphase":5,"./collision/GridBroadphase":6,"./collision/NaiveBroadphase":7,"./collision/ObjectCollisionMatrix":8,"./collision/Ray":9,"./collision/RaycastResult":10,"./collision/SAPBroadphase":11,"./constraints/ConeTwistConstraint":12,"./constraints/Constraint":13,"./constraints/DistanceConstraint":14,"./constraints/HingeConstraint":15,"./constraints/LockConstraint":16,"./constraints/PointToPointConstraint":17,"./equations/ContactEquation":19,"./equations/Equation":20,"./equations/FrictionEquation":21,"./equations/RotationalEquation":22,"./equations/RotationalMotorEquation":23,"./material/ContactMaterial":24,"./material/Material":25,"./math/Mat3":27,"./math/Quaternion":28,"./math/Vec3":30,"./objects/Body":31,"./objects/RaycastVehicle":32,"./objects/RigidVehicle":33,"./objects/SPHSystem":34,"./objects/Spring":35,"./shapes/Box":37,"./shapes/ConvexPolyhedron":38,"./shapes/Cylinder":39,"./shapes/Heightfield":40,"./shapes/Particle":41,"./shapes/Plane":42,"./shapes/Shape":43,"./shapes/Sphere":44,"./shapes/Trimesh":45,"./solver/GSSolver":46,"./solver/Solver":47,"./solver/SplitSolver":48,"./utils/EventTarget":49,"./utils/Pool":51,"./utils/Vec3Pool":54,"./world/Narrowphase":55,"./world/World":56}],3:[function(_dereq_,module,exports){
var Vec3 = _dereq_('../math/Vec3');
var Utils = _dereq_('../utils/Utils');

module.exports = AABB;

/**
 * Axis aligned bounding box class.
 * @class AABB
 * @constructor
 * @param {Object} [options]
 * @param {Vec3}   [options.upperBound]
 * @param {Vec3}   [options.lowerBound]
 */
function AABB(options){
    options = options || {};

    /**
     * The lower bound of the bounding box.
     * @property lowerBound
     * @type {Vec3}
     */
    this.lowerBound = new Vec3();
    if(options.lowerBound){
        this.lowerBound.copy(options.lowerBound);
    }

    /**
     * The upper bound of the bounding box.
     * @property upperBound
     * @type {Vec3}
     */
    this.upperBound = new Vec3();
    if(options.upperBound){
        this.upperBound.copy(options.upperBound);
    }
}

var tmp = new Vec3();

/**
 * Set the AABB bounds from a set of points.
 * @method setFromPoints
 * @param {Array} points An array of Vec3's.
 * @param {Vec3} position
 * @param {Quaternion} quaternion
 * @param {number} skinSize
 * @return {AABB} The self object
 */
AABB.prototype.setFromPoints = function(points, position, quaternion, skinSize){
    var l = this.lowerBound,
        u = this.upperBound,
        q = quaternion;

    // Set to the first point
    l.copy(points[0]);
    if(q){
        q.vmult(l, l);
    }
    u.copy(l);

    for(var i = 1; i<points.length; i++){
        var p = points[i];

        if(q){
            q.vmult(p, tmp);
            p = tmp;
        }

        if(p.x > u.x){ u.x = p.x; }
        if(p.x < l.x){ l.x = p.x; }
        if(p.y > u.y){ u.y = p.y; }
        if(p.y < l.y){ l.y = p.y; }
        if(p.z > u.z){ u.z = p.z; }
        if(p.z < l.z){ l.z = p.z; }
    }

    // Add offset
    if (position) {
        position.vadd(l, l);
        position.vadd(u, u);
    }

    if(skinSize){
        l.x -= skinSize;
        l.y -= skinSize;
        l.z -= skinSize;
        u.x += skinSize;
        u.y += skinSize;
        u.z += skinSize;
    }

    return this;
};

/**
 * Copy bounds from an AABB to this AABB
 * @method copy
 * @param  {AABB} aabb Source to copy from
 * @return {AABB} The this object, for chainability
 */
AABB.prototype.copy = function(aabb){
    this.lowerBound.copy(aabb.lowerBound);
    this.upperBound.copy(aabb.upperBound);
    return this;
};

/**
 * Clone an AABB
 * @method clone
 */
AABB.prototype.clone = function(){
    return new AABB().copy(this);
};

/**
 * Extend this AABB so that it covers the given AABB too.
 * @method extend
 * @param  {AABB} aabb
 */
AABB.prototype.extend = function(aabb){
    // Extend lower bound
    var l = aabb.lowerBound.x;
    if(this.lowerBound.x > l){
        this.lowerBound.x = l;
    }

    // Upper
    var u = aabb.upperBound.x;
    if(this.upperBound.x < u){
        this.upperBound.x = u;
    }

    // Extend lower bound
    var l = aabb.lowerBound.y;
    if(this.lowerBound.y > l){
        this.lowerBound.y = l;
    }

    // Upper
    var u = aabb.upperBound.y;
    if(this.upperBound.y < u){
        this.upperBound.y = u;
    }

    // Extend lower bound
    var l = aabb.lowerBound.z;
    if(this.lowerBound.z > l){
        this.lowerBound.z = l;
    }

    // Upper
    var u = aabb.upperBound.z;
    if(this.upperBound.z < u){
        this.upperBound.z = u;
    }
};

/**
 * Returns true if the given AABB overlaps this AABB.
 * @method overlaps
 * @param  {AABB} aabb
 * @return {Boolean}
 */
AABB.prototype.overlaps = function(aabb){
    var l1 = this.lowerBound,
        u1 = this.upperBound,
        l2 = aabb.lowerBound,
        u2 = aabb.upperBound;

    //      l2        u2
    //      |---------|
    // |--------|
    // l1       u1

    return ((l2.x <= u1.x && u1.x <= u2.x) || (l1.x <= u2.x && u2.x <= u1.x)) &&
           ((l2.y <= u1.y && u1.y <= u2.y) || (l1.y <= u2.y && u2.y <= u1.y)) &&
           ((l2.z <= u1.z && u1.z <= u2.z) || (l1.z <= u2.z && u2.z <= u1.z));
};

/**
 * Returns true if the given AABB is fully contained in this AABB.
 * @method contains
 * @param {AABB} aabb
 * @return {Boolean}
 */
AABB.prototype.contains = function(aabb){
    var l1 = this.lowerBound,
        u1 = this.upperBound,
        l2 = aabb.lowerBound,
        u2 = aabb.upperBound;

    //      l2        u2
    //      |---------|
    // |---------------|
    // l1              u1

    return (
        (l1.x <= l2.x && u1.x >= u2.x) &&
        (l1.y <= l2.y && u1.y >= u2.y) &&
        (l1.z <= l2.z && u1.z >= u2.z)
    );
};

/**
 * @method getCorners
 * @param {Vec3} a
 * @param {Vec3} b
 * @param {Vec3} c
 * @param {Vec3} d
 * @param {Vec3} e
 * @param {Vec3} f
 * @param {Vec3} g
 * @param {Vec3} h
 */
AABB.prototype.getCorners = function(a, b, c, d, e, f, g, h){
    var l = this.lowerBound,
        u = this.upperBound;

    a.copy(l);
    b.set( u.x, l.y, l.z );
    c.set( u.x, u.y, l.z );
    d.set( l.x, u.y, u.z );
    e.set( u.x, l.y, l.z );
    f.set( l.x, u.y, l.z );
    g.set( l.x, l.y, u.z );
    h.copy(u);
};

var transformIntoFrame_corners = [
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3()
];

/**
 * Get the representation of an AABB in another frame.
 * @method toLocalFrame
 * @param  {Transform} frame
 * @param  {AABB} target
 * @return {AABB} The "target" AABB object.
 */
AABB.prototype.toLocalFrame = function(frame, target){

    var corners = transformIntoFrame_corners;
    var a = corners[0];
    var b = corners[1];
    var c = corners[2];
    var d = corners[3];
    var e = corners[4];
    var f = corners[5];
    var g = corners[6];
    var h = corners[7];

    // Get corners in current frame
    this.getCorners(a, b, c, d, e, f, g, h);

    // Transform them to new local frame
    for(var i=0; i !== 8; i++){
        var corner = corners[i];
        frame.pointToLocal(corner, corner);
    }

    return target.setFromPoints(corners);
};

/**
 * Get the representation of an AABB in the global frame.
 * @method toWorldFrame
 * @param  {Transform} frame
 * @param  {AABB} target
 * @return {AABB} The "target" AABB object.
 */
AABB.prototype.toWorldFrame = function(frame, target){

    var corners = transformIntoFrame_corners;
    var a = corners[0];
    var b = corners[1];
    var c = corners[2];
    var d = corners[3];
    var e = corners[4];
    var f = corners[5];
    var g = corners[6];
    var h = corners[7];

    // Get corners in current frame
    this.getCorners(a, b, c, d, e, f, g, h);

    // Transform them to new local frame
    for(var i=0; i !== 8; i++){
        var corner = corners[i];
        frame.pointToWorld(corner, corner);
    }

    return target.setFromPoints(corners);
};

},{"../math/Vec3":30,"../utils/Utils":53}],4:[function(_dereq_,module,exports){
module.exports = ArrayCollisionMatrix;

/**
 * Collision "matrix". It's actually a triangular-shaped array of whether two bodies are touching this step, for reference next step
 * @class ArrayCollisionMatrix
 * @constructor
 */
function ArrayCollisionMatrix() {

    /**
     * The matrix storage
     * @property matrix
     * @type {Array}
     */
	this.matrix = [];
}

/**
 * Get an element
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
ArrayCollisionMatrix.prototype.get = function(i, j) {
	i = i.index;
	j = j.index;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
	return this.matrix[(i*(i + 1)>>1) + j-1];
};

/**
 * Set an element
 * @method set
 * @param {Number} i
 * @param {Number} j
 * @param {Number} value
 */
ArrayCollisionMatrix.prototype.set = function(i, j, value) {
	i = i.index;
	j = j.index;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
	this.matrix[(i*(i + 1)>>1) + j-1] = value ? 1 : 0;
};

/**
 * Sets all elements to zero
 * @method reset
 */
ArrayCollisionMatrix.prototype.reset = function() {
	for (var i=0, l=this.matrix.length; i!==l; i++) {
		this.matrix[i]=0;
	}
};

/**
 * Sets the max number of objects
 * @method setNumObjects
 * @param {Number} n
 */
ArrayCollisionMatrix.prototype.setNumObjects = function(n) {
	this.matrix.length = n*(n-1)>>1;
};

},{}],5:[function(_dereq_,module,exports){
var Body = _dereq_('../objects/Body');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Shape = _dereq_('../shapes/Shape');
var Plane = _dereq_('../shapes/Plane');

module.exports = Broadphase;

/**
 * Base class for broadphase implementations
 * @class Broadphase
 * @constructor
 * @author schteppe
 */
function Broadphase(){
    /**
    * The world to search for collisions in.
    * @property world
    * @type {World}
    */
    this.world = null;

    /**
     * If set to true, the broadphase uses bounding boxes for intersection test, else it uses bounding spheres.
     * @property useBoundingBoxes
     * @type {Boolean}
     */
    this.useBoundingBoxes = false;

    /**
     * Set to true if the objects in the world moved.
     * @property {Boolean} dirty
     */
    this.dirty = true;
}

/**
 * Get the collision pairs from the world
 * @method collisionPairs
 * @param {World} world The world to search in
 * @param {Array} p1 Empty array to be filled with body objects
 * @param {Array} p2 Empty array to be filled with body objects
 */
Broadphase.prototype.collisionPairs = function(world,p1,p2){
    throw new Error("collisionPairs not implemented for this BroadPhase class!");
};

/**
 * Check if a body pair needs to be intersection tested at all.
 * @method needBroadphaseCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @return {bool}
 */
var Broadphase_needBroadphaseCollision_STATIC_OR_KINEMATIC = Body.STATIC | Body.KINEMATIC;
Broadphase.prototype.needBroadphaseCollision = function(bodyA,bodyB){

    // Check collision filter masks
    if( (bodyA.collisionFilterGroup & bodyB.collisionFilterMask)===0 || (bodyB.collisionFilterGroup & bodyA.collisionFilterMask)===0){
        return false;
    }

    // Check types
    if(((bodyA.type & Broadphase_needBroadphaseCollision_STATIC_OR_KINEMATIC)!==0 || bodyA.sleepState === Body.SLEEPING) &&
       ((bodyB.type & Broadphase_needBroadphaseCollision_STATIC_OR_KINEMATIC)!==0 || bodyB.sleepState === Body.SLEEPING)) {
        // Both bodies are static, kinematic or sleeping. Skip.
        return false;
    }

    return true;
};

/**
 * Check if the bounding volumes of two bodies intersect.
 * @method intersectionTest
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {array} pairs1
 * @param {array} pairs2
  */
Broadphase.prototype.intersectionTest = function(bodyA, bodyB, pairs1, pairs2){
    if(this.useBoundingBoxes){
        this.doBoundingBoxBroadphase(bodyA,bodyB,pairs1,pairs2);
    } else {
        this.doBoundingSphereBroadphase(bodyA,bodyB,pairs1,pairs2);
    }
};

/**
 * Check if the bounding spheres of two bodies are intersecting.
 * @method doBoundingSphereBroadphase
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Array} pairs1 bodyA is appended to this array if intersection
 * @param {Array} pairs2 bodyB is appended to this array if intersection
 */
var Broadphase_collisionPairs_r = new Vec3(), // Temp objects
    Broadphase_collisionPairs_normal =  new Vec3(),
    Broadphase_collisionPairs_quat =  new Quaternion(),
    Broadphase_collisionPairs_relpos  =  new Vec3();
Broadphase.prototype.doBoundingSphereBroadphase = function(bodyA,bodyB,pairs1,pairs2){
    var r = Broadphase_collisionPairs_r;
    bodyB.position.vsub(bodyA.position,r);
    var boundingRadiusSum2 = Math.pow(bodyA.boundingRadius + bodyB.boundingRadius, 2);
    var norm2 = r.norm2();
    if(norm2 < boundingRadiusSum2){
        pairs1.push(bodyA);
        pairs2.push(bodyB);
    }
};

/**
 * Check if the bounding boxes of two bodies are intersecting.
 * @method doBoundingBoxBroadphase
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
Broadphase.prototype.doBoundingBoxBroadphase = function(bodyA,bodyB,pairs1,pairs2){
    if(bodyA.aabbNeedsUpdate){
        bodyA.computeAABB();
    }
    if(bodyB.aabbNeedsUpdate){
        bodyB.computeAABB();
    }

    // Check AABB / AABB
    if(bodyA.aabb.overlaps(bodyB.aabb)){
        pairs1.push(bodyA);
        pairs2.push(bodyB);
    }
};

/**
 * Removes duplicate pairs from the pair arrays.
 * @method makePairsUnique
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
var Broadphase_makePairsUnique_temp = { keys:[] },
    Broadphase_makePairsUnique_p1 = [],
    Broadphase_makePairsUnique_p2 = [];
Broadphase.prototype.makePairsUnique = function(pairs1,pairs2){
    var t = Broadphase_makePairsUnique_temp,
        p1 = Broadphase_makePairsUnique_p1,
        p2 = Broadphase_makePairsUnique_p2,
        N = pairs1.length;

    for(var i=0; i!==N; i++){
        p1[i] = pairs1[i];
        p2[i] = pairs2[i];
    }

    pairs1.length = 0;
    pairs2.length = 0;

    for(var i=0; i!==N; i++){
        var id1 = p1[i].id,
            id2 = p2[i].id;
        var key = id1 < id2 ? id1+","+id2 :  id2+","+id1;
        t[key] = i;
        t.keys.push(key);
    }

    for(var i=0; i!==t.keys.length; i++){
        var key = t.keys.pop(),
            pairIndex = t[key];
        pairs1.push(p1[pairIndex]);
        pairs2.push(p2[pairIndex]);
        delete t[key];
    }
};

/**
 * To be implemented by subcasses
 * @method setWorld
 * @param {World} world
 */
Broadphase.prototype.setWorld = function(world){
};

/**
 * Check if the bounding spheres of two bodies overlap.
 * @method boundingSphereCheck
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @return {boolean}
 */
var bsc_dist = new Vec3();
Broadphase.boundingSphereCheck = function(bodyA,bodyB){
    var dist = bsc_dist;
    bodyA.position.vsub(bodyB.position,dist);
    return Math.pow(bodyA.shape.boundingSphereRadius + bodyB.shape.boundingSphereRadius,2) > dist.norm2();
};

/**
 * Returns all the bodies within the AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param  {array} result An array to store resulting bodies in.
 * @return {array}
 */
Broadphase.prototype.aabbQuery = function(world, aabb, result){
    console.warn('.aabbQuery is not implemented in this Broadphase subclass.');
    return [];
};
},{"../math/Quaternion":28,"../math/Vec3":30,"../objects/Body":31,"../shapes/Plane":42,"../shapes/Shape":43}],6:[function(_dereq_,module,exports){
module.exports = GridBroadphase;

var Broadphase = _dereq_('./Broadphase');
var Vec3 = _dereq_('../math/Vec3');
var Shape = _dereq_('../shapes/Shape');

/**
 * Axis aligned uniform grid broadphase.
 * @class GridBroadphase
 * @constructor
 * @extends Broadphase
 * @todo Needs support for more than just planes and spheres.
 * @param {Vec3} aabbMin
 * @param {Vec3} aabbMax
 * @param {Number} nx Number of boxes along x
 * @param {Number} ny Number of boxes along y
 * @param {Number} nz Number of boxes along z
 */
function GridBroadphase(aabbMin,aabbMax,nx,ny,nz){
    Broadphase.apply(this);
    this.nx = nx || 10;
    this.ny = ny || 10;
    this.nz = nz || 10;
    this.aabbMin = aabbMin || new Vec3(100,100,100);
    this.aabbMax = aabbMax || new Vec3(-100,-100,-100);
	var nbins = this.nx * this.ny * this.nz;
	if (nbins <= 0) {
		throw "GridBroadphase: Each dimension's n must be >0";
	}
    this.bins = [];
	this.binLengths = []; //Rather than continually resizing arrays (thrashing the memory), just record length and allow them to grow
	this.bins.length = nbins;
	this.binLengths.length = nbins;
	for (var i=0;i<nbins;i++) {
		this.bins[i]=[];
		this.binLengths[i]=0;
	}
}
GridBroadphase.prototype = new Broadphase();
GridBroadphase.prototype.constructor = GridBroadphase;

/**
 * Get all the collision pairs in the physics world
 * @method collisionPairs
 * @param {World} world
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
var GridBroadphase_collisionPairs_d = new Vec3();
var GridBroadphase_collisionPairs_binPos = new Vec3();
GridBroadphase.prototype.collisionPairs = function(world,pairs1,pairs2){
    var N = world.numObjects(),
        bodies = world.bodies;

    var max = this.aabbMax,
        min = this.aabbMin,
        nx = this.nx,
        ny = this.ny,
        nz = this.nz;

	var xstep = ny*nz;
	var ystep = nz;
	var zstep = 1;

    var xmax = max.x,
        ymax = max.y,
        zmax = max.z,
        xmin = min.x,
        ymin = min.y,
        zmin = min.z;

    var xmult = nx / (xmax-xmin),
        ymult = ny / (ymax-ymin),
        zmult = nz / (zmax-zmin);

    var binsizeX = (xmax - xmin) / nx,
        binsizeY = (ymax - ymin) / ny,
        binsizeZ = (zmax - zmin) / nz;

	var binRadius = Math.sqrt(binsizeX*binsizeX + binsizeY*binsizeY + binsizeZ*binsizeZ) * 0.5;

    var types = Shape.types;
    var SPHERE =            types.SPHERE,
        PLANE =             types.PLANE,
        BOX =               types.BOX,
        COMPOUND =          types.COMPOUND,
        CONVEXPOLYHEDRON =  types.CONVEXPOLYHEDRON;

    var bins=this.bins,
		binLengths=this.binLengths,
        Nbins=this.bins.length;

    // Reset bins
    for(var i=0; i!==Nbins; i++){
        binLengths[i] = 0;
    }

    var ceil = Math.ceil;
	var min = Math.min;
	var max = Math.max;

	function addBoxToBins(x0,y0,z0,x1,y1,z1,bi) {
		var xoff0 = ((x0 - xmin) * xmult)|0,
			yoff0 = ((y0 - ymin) * ymult)|0,
			zoff0 = ((z0 - zmin) * zmult)|0,
			xoff1 = ceil((x1 - xmin) * xmult),
			yoff1 = ceil((y1 - ymin) * ymult),
			zoff1 = ceil((z1 - zmin) * zmult);

		if (xoff0 < 0) { xoff0 = 0; } else if (xoff0 >= nx) { xoff0 = nx - 1; }
		if (yoff0 < 0) { yoff0 = 0; } else if (yoff0 >= ny) { yoff0 = ny - 1; }
		if (zoff0 < 0) { zoff0 = 0; } else if (zoff0 >= nz) { zoff0 = nz - 1; }
		if (xoff1 < 0) { xoff1 = 0; } else if (xoff1 >= nx) { xoff1 = nx - 1; }
		if (yoff1 < 0) { yoff1 = 0; } else if (yoff1 >= ny) { yoff1 = ny - 1; }
		if (zoff1 < 0) { zoff1 = 0; } else if (zoff1 >= nz) { zoff1 = nz - 1; }

		xoff0 *= xstep;
		yoff0 *= ystep;
		zoff0 *= zstep;
		xoff1 *= xstep;
		yoff1 *= ystep;
		zoff1 *= zstep;

		for (var xoff = xoff0; xoff <= xoff1; xoff += xstep) {
			for (var yoff = yoff0; yoff <= yoff1; yoff += ystep) {
				for (var zoff = zoff0; zoff <= zoff1; zoff += zstep) {
					var idx = xoff+yoff+zoff;
					bins[idx][binLengths[idx]++] = bi;
				}
			}
		}
	}

    // Put all bodies into the bins
    for(var i=0; i!==N; i++){
        var bi = bodies[i];
        var si = bi.shape;

        switch(si.type){
        case SPHERE:
            // Put in bin
            // check if overlap with other bins
            var x = bi.position.x,
                y = bi.position.y,
                z = bi.position.z;
            var r = si.radius;

			addBoxToBins(x-r, y-r, z-r, x+r, y+r, z+r, bi);
            break;

        case PLANE:
            if(si.worldNormalNeedsUpdate){
                si.computeWorldNormal(bi.quaternion);
            }
            var planeNormal = si.worldNormal;

			//Relative position from origin of plane object to the first bin
			//Incremented as we iterate through the bins
			var xreset = xmin + binsizeX*0.5 - bi.position.x,
				yreset = ymin + binsizeY*0.5 - bi.position.y,
				zreset = zmin + binsizeZ*0.5 - bi.position.z;

            var d = GridBroadphase_collisionPairs_d;
			d.set(xreset, yreset, zreset);

			for (var xi = 0, xoff = 0; xi !== nx; xi++, xoff += xstep, d.y = yreset, d.x += binsizeX) {
				for (var yi = 0, yoff = 0; yi !== ny; yi++, yoff += ystep, d.z = zreset, d.y += binsizeY) {
					for (var zi = 0, zoff = 0; zi !== nz; zi++, zoff += zstep, d.z += binsizeZ) {
						if (d.dot(planeNormal) < binRadius) {
							var idx = xoff + yoff + zoff;
							bins[idx][binLengths[idx]++] = bi;
						}
					}
				}
			}
            break;

        default:
			if (bi.aabbNeedsUpdate) {
				bi.computeAABB();
			}

			addBoxToBins(
				bi.aabb.lowerBound.x,
				bi.aabb.lowerBound.y,
				bi.aabb.lowerBound.z,
				bi.aabb.upperBound.x,
				bi.aabb.upperBound.y,
				bi.aabb.upperBound.z,
				bi);
            break;
        }
    }

    // Check each bin
    for(var i=0; i!==Nbins; i++){
		var binLength = binLengths[i];
		//Skip bins with no potential collisions
		if (binLength > 1) {
			var bin = bins[i];

			// Do N^2 broadphase inside
			for(var xi=0; xi!==binLength; xi++){
				var bi = bin[xi];
				for(var yi=0; yi!==xi; yi++){
					var bj = bin[yi];
					if(this.needBroadphaseCollision(bi,bj)){
						this.intersectionTest(bi,bj,pairs1,pairs2);
					}
				}
			}
		}
    }

//	for (var zi = 0, zoff=0; zi < nz; zi++, zoff+= zstep) {
//		console.log("layer "+zi);
//		for (var yi = 0, yoff=0; yi < ny; yi++, yoff += ystep) {
//			var row = '';
//			for (var xi = 0, xoff=0; xi < nx; xi++, xoff += xstep) {
//				var idx = xoff + yoff + zoff;
//				row += ' ' + binLengths[idx];
//			}
//			console.log(row);
//		}
//	}

    this.makePairsUnique(pairs1,pairs2);
};

},{"../math/Vec3":30,"../shapes/Shape":43,"./Broadphase":5}],7:[function(_dereq_,module,exports){
module.exports = NaiveBroadphase;

var Broadphase = _dereq_('./Broadphase');
var AABB = _dereq_('./AABB');

/**
 * Naive broadphase implementation, used in lack of better ones.
 * @class NaiveBroadphase
 * @constructor
 * @description The naive broadphase looks at all possible pairs without restriction, therefore it has complexity N^2 (which is bad)
 * @extends Broadphase
 */
function NaiveBroadphase(){
    Broadphase.apply(this);
}
NaiveBroadphase.prototype = new Broadphase();
NaiveBroadphase.prototype.constructor = NaiveBroadphase;

/**
 * Get all the collision pairs in the physics world
 * @method collisionPairs
 * @param {World} world
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
NaiveBroadphase.prototype.collisionPairs = function(world,pairs1,pairs2){
    var bodies = world.bodies,
        n = bodies.length,
        i,j,bi,bj;

    // Naive N^2 ftw!
    for(i=0; i!==n; i++){
        for(j=0; j!==i; j++){

            bi = bodies[i];
            bj = bodies[j];

            if(!this.needBroadphaseCollision(bi,bj)){
                continue;
            }

            this.intersectionTest(bi,bj,pairs1,pairs2);
        }
    }
};

var tmpAABB = new AABB();

/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */
NaiveBroadphase.prototype.aabbQuery = function(world, aabb, result){
    result = result || [];

    for(var i = 0; i < world.bodies.length; i++){
        var b = world.bodies[i];

        if(b.aabbNeedsUpdate){
            b.computeAABB();
        }

        // Ugly hack until Body gets aabb
        if(b.aabb.overlaps(aabb)){
            result.push(b);
        }
    }

    return result;
};
},{"./AABB":3,"./Broadphase":5}],8:[function(_dereq_,module,exports){
module.exports = ObjectCollisionMatrix;

/**
 * Records what objects are colliding with each other
 * @class ObjectCollisionMatrix
 * @constructor
 */
function ObjectCollisionMatrix() {

    /**
     * The matrix storage
     * @property matrix
     * @type {Object}
     */
	this.matrix = {};
}

/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
ObjectCollisionMatrix.prototype.get = function(i, j) {
	i = i.id;
	j = j.id;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
	return i+'-'+j in this.matrix;
};

/**
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */
ObjectCollisionMatrix.prototype.set = function(i, j, value) {
	i = i.id;
	j = j.id;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
	}
	if (value) {
		this.matrix[i+'-'+j] = true;
	}
	else {
		delete this.matrix[i+'-'+j];
	}
};

/**
 * Empty the matrix
 * @method reset
 */
ObjectCollisionMatrix.prototype.reset = function() {
	this.matrix = {};
};

/**
 * Set max number of objects
 * @method setNumObjects
 * @param {Number} n
 */
ObjectCollisionMatrix.prototype.setNumObjects = function(n) {
};

},{}],9:[function(_dereq_,module,exports){
module.exports = Ray;

var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Transform = _dereq_('../math/Transform');
var ConvexPolyhedron = _dereq_('../shapes/ConvexPolyhedron');
var Box = _dereq_('../shapes/Box');
var RaycastResult = _dereq_('../collision/RaycastResult');
var Shape = _dereq_('../shapes/Shape');
var AABB = _dereq_('../collision/AABB');

/**
 * A line in 3D space that intersects bodies and return points.
 * @class Ray
 * @constructor
 * @param {Vec3} from
 * @param {Vec3} to
 */
function Ray(from, to){
    /**
     * @property {Vec3} from
     */
    this.from = from ? from.clone() : new Vec3();

    /**
     * @property {Vec3} to
     */
    this.to = to ? to.clone() : new Vec3();

    /**
     * @private
     * @property {Vec3} _direction
     */
    this._direction = new Vec3();

    /**
     * The precision of the ray. Used when checking parallelity etc.
     * @property {Number} precision
     */
    this.precision = 0.0001;

    /**
     * Set to true if you want the Ray to take .collisionResponse flags into account on bodies and shapes.
     * @property {Boolean} checkCollisionResponse
     */
    this.checkCollisionResponse = true;

    /**
     * If set to true, the ray skips any hits with normal.dot(rayDirection) < 0.
     * @property {Boolean} skipBackfaces
     */
    this.skipBackfaces = false;

    /**
     * @property {number} collisionFilterMask
     * @default -1
     */
    this.collisionFilterMask = -1;

    /**
     * @property {number} collisionFilterGroup
     * @default -1
     */
    this.collisionFilterGroup = -1;

    /**
     * The intersection mode. Should be Ray.ANY, Ray.ALL or Ray.CLOSEST.
     * @property {number} mode
     */
    this.mode = Ray.ANY;

    /**
     * Current result object.
     * @property {RaycastResult} result
     */
    this.result = new RaycastResult();

    /**
     * Will be set to true during intersectWorld() if the ray hit anything.
     * @property {Boolean} hasHit
     */
    this.hasHit = false;

    /**
     * Current, user-provided result callback. Will be used if mode is Ray.ALL.
     * @property {Function} callback
     */
    this.callback = function(result){};
}
Ray.prototype.constructor = Ray;

Ray.CLOSEST = 1;
Ray.ANY = 2;
Ray.ALL = 4;

var tmpAABB = new AABB();
var tmpArray = [];

/**
 * Do itersection against all bodies in the given World.
 * @method intersectWorld
 * @param  {World} world
 * @param  {object} options
 * @return {Boolean} True if the ray hit anything, otherwise false.
 */
Ray.prototype.intersectWorld = function (world, options) {
    this.mode = options.mode || Ray.ANY;
    this.result = options.result || new RaycastResult();
    this.skipBackfaces = !!options.skipBackfaces;
    this.collisionFilterMask = typeof(options.collisionFilterMask) !== 'undefined' ? options.collisionFilterMask : -1;
    this.collisionFilterGroup = typeof(options.collisionFilterGroup) !== 'undefined' ? options.collisionFilterGroup : -1;
    if(options.from){
        this.from.copy(options.from);
    }
    if(options.to){
        this.to.copy(options.to);
    }
    this.callback = options.callback || function(){};
    this.hasHit = false;

    this.result.reset();
    this._updateDirection();

    this.getAABB(tmpAABB);
    tmpArray.length = 0;
    world.broadphase.aabbQuery(world, tmpAABB, tmpArray);
    this.intersectBodies(tmpArray);

    return this.hasHit;
};

var v1 = new Vec3(),
    v2 = new Vec3();

/*
 * As per "Barycentric Technique" as named here http://www.blackpawn.com/texts/pointinpoly/default.html But without the division
 */
Ray.pointInTriangle = pointInTriangle;
function pointInTriangle(p, a, b, c) {
    c.vsub(a,v0);
    b.vsub(a,v1);
    p.vsub(a,v2);

    var dot00 = v0.dot( v0 );
    var dot01 = v0.dot( v1 );
    var dot02 = v0.dot( v2 );
    var dot11 = v1.dot( v1 );
    var dot12 = v1.dot( v2 );

    var u,v;

    return  ( (u = dot11 * dot02 - dot01 * dot12) >= 0 ) &&
            ( (v = dot00 * dot12 - dot01 * dot02) >= 0 ) &&
            ( u + v < ( dot00 * dot11 - dot01 * dot01 ) );
}

/**
 * Shoot a ray at a body, get back information about the hit.
 * @method intersectBody
 * @private
 * @param {Body} body
 * @param {RaycastResult} [result] Deprecated - set the result property of the Ray instead.
 */
var intersectBody_xi = new Vec3();
var intersectBody_qi = new Quaternion();
Ray.prototype.intersectBody = function (body, result) {
    if(result){
        this.result = result;
        this._updateDirection();
    }
    var checkCollisionResponse = this.checkCollisionResponse;

    if(checkCollisionResponse && !body.collisionResponse){
        return;
    }

    if((this.collisionFilterGroup & body.collisionFilterMask)===0 || (body.collisionFilterGroup & this.collisionFilterMask)===0){
        return;
    }

    var xi = intersectBody_xi;
    var qi = intersectBody_qi;

    for (var i = 0, N = body.shapes.length; i < N; i++) {
        var shape = body.shapes[i];

        if(checkCollisionResponse && !shape.collisionResponse){
            continue; // Skip
        }

        body.quaternion.mult(body.shapeOrientations[i], qi);
        body.quaternion.vmult(body.shapeOffsets[i], xi);
        xi.vadd(body.position, xi);

        this.intersectShape(
            shape,
            qi,
            xi,
            body
        );

        if(this.result._shouldStop){
            break;
        }
    }
};

/**
 * @method intersectBodies
 * @param {Array} bodies An array of Body objects.
 * @param {RaycastResult} [result] Deprecated
 */
Ray.prototype.intersectBodies = function (bodies, result) {
    if(result){
        this.result = result;
        this._updateDirection();
    }

    for ( var i = 0, l = bodies.length; !this.result._shouldStop && i < l; i ++ ) {
        this.intersectBody(bodies[i]);
    }
};

/**
 * Updates the _direction vector.
 * @private
 * @method _updateDirection
 */
Ray.prototype._updateDirection = function(){
    this.to.vsub(this.from, this._direction);
    this._direction.normalize();
};

/**
 * @method intersectShape
 * @private
 * @param {Shape} shape
 * @param {Quaternion} quat
 * @param {Vec3} position
 * @param {Body} body
 */
Ray.prototype.intersectShape = function(shape, quat, position, body){
    var from = this.from;


    // Checking boundingSphere
    var distance = distanceFromIntersection(from, this._direction, position);
    if ( distance > shape.boundingSphereRadius ) {
        return;
    }

    var intersectMethod = this[shape.type];
    if(intersectMethod){
        intersectMethod.call(this, shape, quat, position, body);
    }
};

var vector = new Vec3();
var normal = new Vec3();
var intersectPoint = new Vec3();

var a = new Vec3();
var b = new Vec3();
var c = new Vec3();
var d = new Vec3();

var tmpRaycastResult = new RaycastResult();

/**
 * @method intersectBox
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectBox = function(shape, quat, position, body){
    return this.intersectConvex(shape.convexPolyhedronRepresentation, quat, position, body);
};
Ray.prototype[Shape.types.BOX] = Ray.prototype.intersectBox;

/**
 * @method intersectPlane
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectPlane = function(shape, quat, position, body){
    var from = this.from;
    var to = this.to;
    var direction = this._direction;

    // Get plane normal
    var worldNormal = new Vec3(0, 0, 1);
    quat.vmult(worldNormal, worldNormal);

    var len = new Vec3();
    from.vsub(position, len);
    var planeToFrom = len.dot(worldNormal);
    to.vsub(position, len);
    var planeToTo = len.dot(worldNormal);

    if(planeToFrom * planeToTo > 0){
        // "from" and "to" are on the same side of the plane... bail out
        return;
    }

    if(from.distanceTo(to) < planeToFrom){
        return;
    }

    var n_dot_dir = worldNormal.dot(direction);

    if (Math.abs(n_dot_dir) < this.precision) {
        // No intersection
        return;
    }

    var planePointToFrom = new Vec3();
    var dir_scaled_with_t = new Vec3();
    var hitPointWorld = new Vec3();

    from.vsub(position, planePointToFrom);
    var t = -worldNormal.dot(planePointToFrom) / n_dot_dir;
    direction.scale(t, dir_scaled_with_t);
    from.vadd(dir_scaled_with_t, hitPointWorld);

    this.reportIntersection(worldNormal, hitPointWorld, shape, body, -1);
};
Ray.prototype[Shape.types.PLANE] = Ray.prototype.intersectPlane;

/**
 * Get the world AABB of the ray.
 * @method getAABB
 * @param  {AABB} aabb
 */
Ray.prototype.getAABB = function(result){
    var to = this.to;
    var from = this.from;
    result.lowerBound.x = Math.min(to.x, from.x);
    result.lowerBound.y = Math.min(to.y, from.y);
    result.lowerBound.z = Math.min(to.z, from.z);
    result.upperBound.x = Math.max(to.x, from.x);
    result.upperBound.y = Math.max(to.y, from.y);
    result.upperBound.z = Math.max(to.z, from.z);
};

var intersectConvexOptions = {
    faceList: [0]
};

/**
 * @method intersectHeightfield
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectHeightfield = function(shape, quat, position, body){
    var data = shape.data,
        w = shape.elementSize,
        worldPillarOffset = new Vec3();

    // Convert the ray to local heightfield coordinates
    var localRay = new Ray(this.from, this.to);
    Transform.pointToLocalFrame(position, quat, localRay.from, localRay.from);
    Transform.pointToLocalFrame(position, quat, localRay.to, localRay.to);

    // Get the index of the data points to test against
    var index = [];
    var iMinX = null;
    var iMinY = null;
    var iMaxX = null;
    var iMaxY = null;

    var inside = shape.getIndexOfPosition(localRay.from.x, localRay.from.y, index, false);
    if(inside){
        iMinX = index[0];
        iMinY = index[1];
        iMaxX = index[0];
        iMaxY = index[1];
    }
    inside = shape.getIndexOfPosition(localRay.to.x, localRay.to.y, index, false);
    if(inside){
        if (iMinX === null || index[0] < iMinX) { iMinX = index[0]; }
        if (iMaxX === null || index[0] > iMaxX) { iMaxX = index[0]; }
        if (iMinY === null || index[1] < iMinY) { iMinY = index[1]; }
        if (iMaxY === null || index[1] > iMaxY) { iMaxY = index[1]; }
    }

    if(iMinX === null){
        return;
    }

    var minMax = [];
    shape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
    var min = minMax[0];
    var max = minMax[1];

    // // Bail out if the ray can't touch the bounding box
    // // TODO
    // var aabb = new AABB();
    // this.getAABB(aabb);
    // if(aabb.intersects()){
    //     return;
    // }

    for(var i = iMinX; i <= iMaxX; i++){
        for(var j = iMinY; j <= iMaxY; j++){

            if(this.result._shouldStop){
                return;
            }

            // Lower triangle
            shape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(position, quat, shape.pillarOffset, worldPillarOffset);
            this.intersectConvex(shape.pillarConvex, quat, worldPillarOffset, body, intersectConvexOptions);

            if(this.result._shouldStop){
                return;
            }

            // Upper triangle
            shape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(position, quat, shape.pillarOffset, worldPillarOffset);
            this.intersectConvex(shape.pillarConvex, quat, worldPillarOffset, body, intersectConvexOptions);
        }
    }
};
Ray.prototype[Shape.types.HEIGHTFIELD] = Ray.prototype.intersectHeightfield;

var Ray_intersectSphere_intersectionPoint = new Vec3();
var Ray_intersectSphere_normal = new Vec3();

/**
 * @method intersectSphere
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectSphere = function(shape, quat, position, body){
    var from = this.from,
        to = this.to,
        r = shape.radius;

    var a = Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + Math.pow(to.z - from.z, 2);
    var b = 2 * ((to.x - from.x) * (from.x - position.x) + (to.y - from.y) * (from.y - position.y) + (to.z - from.z) * (from.z - position.z));
    var c = Math.pow(from.x - position.x, 2) + Math.pow(from.y - position.y, 2) + Math.pow(from.z - position.z, 2) - Math.pow(r, 2);

    var delta = Math.pow(b, 2) - 4 * a * c;

    var intersectionPoint = Ray_intersectSphere_intersectionPoint;
    var normal = Ray_intersectSphere_normal;

    if(delta < 0){
        // No intersection
        return;

    } else if(delta === 0){
        // single intersection point
        from.lerp(to, delta, intersectionPoint);

        intersectionPoint.vsub(position, normal);
        normal.normalize();

        this.reportIntersection(normal, intersectionPoint, shape, body, -1);

    } else {
        var d1 = (- b - Math.sqrt(delta)) / (2 * a);
        var d2 = (- b + Math.sqrt(delta)) / (2 * a);

        if(d1 >= 0 && d1 <= 1){
            from.lerp(to, d1, intersectionPoint);
            intersectionPoint.vsub(position, normal);
            normal.normalize();
            this.reportIntersection(normal, intersectionPoint, shape, body, -1);
        }

        if(this.result._shouldStop){
            return;
        }

        if(d2 >= 0 && d2 <= 1){
            from.lerp(to, d2, intersectionPoint);
            intersectionPoint.vsub(position, normal);
            normal.normalize();
            this.reportIntersection(normal, intersectionPoint, shape, body, -1);
        }
    }
};
Ray.prototype[Shape.types.SPHERE] = Ray.prototype.intersectSphere;


var intersectConvex_normal = new Vec3();
var intersectConvex_minDistNormal = new Vec3();
var intersectConvex_minDistIntersect = new Vec3();
var intersectConvex_vector = new Vec3();

/**
 * @method intersectConvex
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 * @param {object} [options]
 * @param {array} [options.faceList]
 */
Ray.prototype.intersectConvex = function intersectConvex(
    shape,
    quat,
    position,
    body,
    options
){
    var minDistNormal = intersectConvex_minDistNormal;
    var normal = intersectConvex_normal;
    var vector = intersectConvex_vector;
    var minDistIntersect = intersectConvex_minDistIntersect;
    var faceList = (options && options.faceList) || null;

    // Checking faces
    var faces = shape.faces,
        vertices = shape.vertices,
        normals = shape.faceNormals;
    var direction = this._direction;

    var from = this.from;
    var to = this.to;
    var fromToDistance = from.distanceTo(to);

    var minDist = -1;
    var Nfaces = faceList ? faceList.length : faces.length;
    var result = this.result;

    for (var j = 0; !result._shouldStop && j < Nfaces; j++) {
        var fi = faceList ? faceList[j] : j;

        var face = faces[fi];
        var faceNormal = normals[fi];
        var q = quat;
        var x = position;

        // determine if ray intersects the plane of the face
        // note: this works regardless of the direction of the face normal

        // Get plane point in world coordinates...
        vector.copy(vertices[face[0]]);
        q.vmult(vector,vector);
        vector.vadd(x,vector);

        // ...but make it relative to the ray from. We'll fix this later.
        vector.vsub(from,vector);

        // Get plane normal
        q.vmult(faceNormal,normal);

        // If this dot product is negative, we have something interesting
        var dot = direction.dot(normal);

        // Bail out if ray and plane are parallel
        if ( Math.abs( dot ) < this.precision ){
            continue;
        }

        // calc distance to plane
        var scalar = normal.dot(vector) / dot;

        // if negative distance, then plane is behind ray
        if (scalar < 0){
            continue;
        }

        // if (dot < 0) {

        // Intersection point is from + direction * scalar
        direction.mult(scalar,intersectPoint);
        intersectPoint.vadd(from,intersectPoint);

        // a is the point we compare points b and c with.
        a.copy(vertices[face[0]]);
        q.vmult(a,a);
        x.vadd(a,a);

        for(var i = 1; !result._shouldStop && i < face.length - 1; i++){
            // Transform 3 vertices to world coords
            b.copy(vertices[face[i]]);
            c.copy(vertices[face[i+1]]);
            q.vmult(b,b);
            q.vmult(c,c);
            x.vadd(b,b);
            x.vadd(c,c);

            var distance = intersectPoint.distanceTo(from);

            if(!(pointInTriangle(intersectPoint, a, b, c) || pointInTriangle(intersectPoint, b, a, c)) || distance > fromToDistance){
                continue;
            }

            this.reportIntersection(normal, intersectPoint, shape, body, fi);
        }
        // }
    }
};
Ray.prototype[Shape.types.CONVEXPOLYHEDRON] = Ray.prototype.intersectConvex;

var intersectTrimesh_normal = new Vec3();
var intersectTrimesh_localDirection = new Vec3();
var intersectTrimesh_localFrom = new Vec3();
var intersectTrimesh_localTo = new Vec3();
var intersectTrimesh_worldNormal = new Vec3();
var intersectTrimesh_worldIntersectPoint = new Vec3();
var intersectTrimesh_localAABB = new AABB();
var intersectTrimesh_triangles = [];
var intersectTrimesh_treeTransform = new Transform();

/**
 * @method intersectTrimesh
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 * @param {object} [options]
 * @todo Optimize by transforming the world to local space first.
 * @todo Use Octree lookup
 */
Ray.prototype.intersectTrimesh = function intersectTrimesh(
    mesh,
    quat,
    position,
    body,
    options
){
    var normal = intersectTrimesh_normal;
    var triangles = intersectTrimesh_triangles;
    var treeTransform = intersectTrimesh_treeTransform;
    var minDistNormal = intersectConvex_minDistNormal;
    var vector = intersectConvex_vector;
    var minDistIntersect = intersectConvex_minDistIntersect;
    var localAABB = intersectTrimesh_localAABB;
    var localDirection = intersectTrimesh_localDirection;
    var localFrom = intersectTrimesh_localFrom;
    var localTo = intersectTrimesh_localTo;
    var worldIntersectPoint = intersectTrimesh_worldIntersectPoint;
    var worldNormal = intersectTrimesh_worldNormal;
    var faceList = (options && options.faceList) || null;

    // Checking faces
    var indices = mesh.indices,
        vertices = mesh.vertices,
        normals = mesh.faceNormals;

    var from = this.from;
    var to = this.to;
    var direction = this._direction;

    var minDist = -1;
    treeTransform.position.copy(position);
    treeTransform.quaternion.copy(quat);

    // Transform ray to local space!
    Transform.vectorToLocalFrame(position, quat, direction, localDirection);
    //body.vectorToLocalFrame(direction, localDirection);
    Transform.pointToLocalFrame(position, quat, from, localFrom);
    //body.pointToLocalFrame(from, localFrom);
    Transform.pointToLocalFrame(position, quat, to, localTo);
    //body.pointToLocalFrame(to, localTo);
    var fromToDistanceSquared = localFrom.distanceSquared(localTo);

    mesh.tree.rayQuery(this, treeTransform, triangles);

    for (var i = 0, N = triangles.length; !this.result._shouldStop && i !== N; i++) {
        var trianglesIndex = triangles[i];

        mesh.getNormal(trianglesIndex, normal);

        // determine if ray intersects the plane of the face
        // note: this works regardless of the direction of the face normal

        // Get plane point in world coordinates...
        mesh.getVertex(indices[trianglesIndex * 3], a);

        // ...but make it relative to the ray from. We'll fix this later.
        a.vsub(localFrom,vector);

        // Get plane normal
        // quat.vmult(normal, normal);

        // If this dot product is negative, we have something interesting
        var dot = localDirection.dot(normal);

        // Bail out if ray and plane are parallel
        // if (Math.abs( dot ) < this.precision){
        //     continue;
        // }

        // calc distance to plane
        var scalar = normal.dot(vector) / dot;

        // if negative distance, then plane is behind ray
        if (scalar < 0){
            continue;
        }

        // Intersection point is from + direction * scalar
        localDirection.scale(scalar,intersectPoint);
        intersectPoint.vadd(localFrom,intersectPoint);

        // Get triangle vertices
        mesh.getVertex(indices[trianglesIndex * 3 + 1], b);
        mesh.getVertex(indices[trianglesIndex * 3 + 2], c);

        var squaredDistance = intersectPoint.distanceSquared(localFrom);

        if(!(pointInTriangle(intersectPoint, b, a, c) || pointInTriangle(intersectPoint, a, b, c)) || squaredDistance > fromToDistanceSquared){
            continue;
        }

        // transform intersectpoint and normal to world
        Transform.vectorToWorldFrame(quat, normal, worldNormal);
        //body.vectorToWorldFrame(normal, worldNormal);
        Transform.pointToWorldFrame(position, quat, intersectPoint, worldIntersectPoint);
        //body.pointToWorldFrame(intersectPoint, worldIntersectPoint);
        this.reportIntersection(worldNormal, worldIntersectPoint, mesh, body, trianglesIndex);
    }
    triangles.length = 0;
};
Ray.prototype[Shape.types.TRIMESH] = Ray.prototype.intersectTrimesh;


/**
 * @method reportIntersection
 * @private
 * @param  {Vec3} normal
 * @param  {Vec3} hitPointWorld
 * @param  {Shape} shape
 * @param  {Body} body
 * @return {boolean} True if the intersections should continue
 */
Ray.prototype.reportIntersection = function(normal, hitPointWorld, shape, body, hitFaceIndex){
    var from = this.from;
    var to = this.to;
    var distance = from.distanceTo(hitPointWorld);
    var result = this.result;

    // Skip back faces?
    if(this.skipBackfaces && normal.dot(this._direction) > 0){
        return;
    }

    result.hitFaceIndex = typeof(hitFaceIndex) !== 'undefined' ? hitFaceIndex : -1;

    switch(this.mode){
    case Ray.ALL:
        this.hasHit = true;
        result.set(
            from,
            to,
            normal,
            hitPointWorld,
            shape,
            body,
            distance
        );
        result.hasHit = true;
        this.callback(result);
        break;

    case Ray.CLOSEST:

        // Store if closer than current closest
        if(distance < result.distance || !result.hasHit){
            this.hasHit = true;
            result.hasHit = true;
            result.set(
                from,
                to,
                normal,
                hitPointWorld,
                shape,
                body,
                distance
            );
        }
        break;

    case Ray.ANY:

        // Report and stop.
        this.hasHit = true;
        result.hasHit = true;
        result.set(
            from,
            to,
            normal,
            hitPointWorld,
            shape,
            body,
            distance
        );
        result._shouldStop = true;
        break;
    }
};

var v0 = new Vec3(),
    intersect = new Vec3();
function distanceFromIntersection(from, direction, position) {

    // v0 is vector from from to position
    position.vsub(from,v0);
    var dot = v0.dot(direction);

    // intersect = direction*dot + from
    direction.mult(dot,intersect);
    intersect.vadd(from,intersect);

    var distance = position.distanceTo(intersect);

    return distance;
}


},{"../collision/AABB":3,"../collision/RaycastResult":10,"../math/Quaternion":28,"../math/Transform":29,"../math/Vec3":30,"../shapes/Box":37,"../shapes/ConvexPolyhedron":38,"../shapes/Shape":43}],10:[function(_dereq_,module,exports){
var Vec3 = _dereq_('../math/Vec3');

module.exports = RaycastResult;

/**
 * Storage for Ray casting data.
 * @class RaycastResult
 * @constructor
 */
function RaycastResult(){

	/**
	 * @property {Vec3} rayFromWorld
	 */
	this.rayFromWorld = new Vec3();

	/**
	 * @property {Vec3} rayToWorld
	 */
	this.rayToWorld = new Vec3();

	/**
	 * @property {Vec3} hitNormalWorld
	 */
	this.hitNormalWorld = new Vec3();

	/**
	 * @property {Vec3} hitPointWorld
	 */
	this.hitPointWorld = new Vec3();

	/**
	 * @property {boolean} hasHit
	 */
	this.hasHit = false;

	/**
	 * The hit shape, or null.
	 * @property {Shape} shape
	 */
	this.shape = null;

	/**
	 * The hit body, or null.
	 * @property {Body} body
	 */
	this.body = null;

	/**
	 * The index of the hit triangle, if the hit shape was a trimesh.
	 * @property {number} hitFaceIndex
	 * @default -1
	 */
	this.hitFaceIndex = -1;

	/**
	 * Distance to the hit. Will be set to -1 if there was no hit.
	 * @property {number} distance
	 * @default -1
	 */
	this.distance = -1;

	/**
	 * If the ray should stop traversing the bodies.
	 * @private
	 * @property {Boolean} _shouldStop
	 * @default false
	 */
	this._shouldStop = false;
}

/**
 * Reset all result data.
 * @method reset
 */
RaycastResult.prototype.reset = function () {
	this.rayFromWorld.setZero();
	this.rayToWorld.setZero();
	this.hitNormalWorld.setZero();
	this.hitPointWorld.setZero();
	this.hasHit = false;
	this.shape = null;
	this.body = null;
	this.hitFaceIndex = -1;
	this.distance = -1;
	this._shouldStop = false;
};

/**
 * @method abort
 */
RaycastResult.prototype.abort = function(){
	this._shouldStop = true;
};

/**
 * @method set
 * @param {Vec3} rayFromWorld
 * @param {Vec3} rayToWorld
 * @param {Vec3} hitNormalWorld
 * @param {Vec3} hitPointWorld
 * @param {Shape} shape
 * @param {Body} body
 * @param {number} distance
 */
RaycastResult.prototype.set = function(
	rayFromWorld,
	rayToWorld,
	hitNormalWorld,
	hitPointWorld,
	shape,
	body,
	distance
){
	this.rayFromWorld.copy(rayFromWorld);
	this.rayToWorld.copy(rayToWorld);
	this.hitNormalWorld.copy(hitNormalWorld);
	this.hitPointWorld.copy(hitPointWorld);
	this.shape = shape;
	this.body = body;
	this.distance = distance;
};
},{"../math/Vec3":30}],11:[function(_dereq_,module,exports){
var Shape = _dereq_('../shapes/Shape');
var Broadphase = _dereq_('../collision/Broadphase');

module.exports = SAPBroadphase;

/**
 * Sweep and prune broadphase along one axis.
 *
 * @class SAPBroadphase
 * @constructor
 * @param {World} [world]
 * @extends Broadphase
 */
function SAPBroadphase(world){
    Broadphase.apply(this);

    /**
     * List of bodies currently in the broadphase.
     * @property axisList
     * @type {Array}
     */
    this.axisList = [];

    /**
     * The world to search in.
     * @property world
     * @type {World}
     */
    this.world = null;

    /**
     * Axis to sort the bodies along. Set to 0 for x axis, and 1 for y axis. For best performance, choose an axis that the bodies are spread out more on.
     * @property axisIndex
     * @type {Number}
     */
    this.axisIndex = 0;

    var axisList = this.axisList;

    this._addBodyHandler = function(e){
        axisList.push(e.body);
    };

    this._removeBodyHandler = function(e){
        var idx = axisList.indexOf(e.body);
        if(idx !== -1){
            axisList.splice(idx,1);
        }
    };

    if(world){
        this.setWorld(world);
    }
}
SAPBroadphase.prototype = new Broadphase();

/**
 * Change the world
 * @method setWorld
 * @param  {World} world
 */
SAPBroadphase.prototype.setWorld = function(world){
    // Clear the old axis array
    this.axisList.length = 0;

    // Add all bodies from the new world
    for(var i=0; i<world.bodies.length; i++){
        this.axisList.push(world.bodies[i]);
    }

    // Remove old handlers, if any
    world.removeEventListener("addBody", this._addBodyHandler);
    world.removeEventListener("removeBody", this._removeBodyHandler);

    // Add handlers to update the list of bodies.
    world.addEventListener("addBody", this._addBodyHandler);
    world.addEventListener("removeBody", this._removeBodyHandler);

    this.world = world;
    this.dirty = true;
};

/**
 * @static
 * @method insertionSortX
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortX = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.x <= v.aabb.lowerBound.x){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * @static
 * @method insertionSortY
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortY = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.y <= v.aabb.lowerBound.y){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * @static
 * @method insertionSortZ
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortZ = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.z <= v.aabb.lowerBound.z){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * Collect all collision pairs
 * @method collisionPairs
 * @param  {World} world
 * @param  {Array} p1
 * @param  {Array} p2
 */
SAPBroadphase.prototype.collisionPairs = function(world,p1,p2){
    var bodies = this.axisList,
        N = bodies.length,
        axisIndex = this.axisIndex,
        i, j;

    if(this.dirty){
        this.sortList();
        this.dirty = false;
    }

    // Look through the list
    for(i=0; i !== N; i++){
        var bi = bodies[i];

        for(j=i+1; j < N; j++){
            var bj = bodies[j];

            if(!this.needBroadphaseCollision(bi,bj)){
                continue;
            }

            if(!SAPBroadphase.checkBounds(bi,bj,axisIndex)){
                break;
            }

            this.intersectionTest(bi,bj,p1,p2);
        }
    }
};

SAPBroadphase.prototype.sortList = function(){
    var axisList = this.axisList;
    var axisIndex = this.axisIndex;
    var N = axisList.length;

    // Update AABBs
    for(var i = 0; i!==N; i++){
        var bi = axisList[i];
        if(bi.aabbNeedsUpdate){
            bi.computeAABB();
        }
    }

    // Sort the list
    if(axisIndex === 0){
        SAPBroadphase.insertionSortX(axisList);
    } else if(axisIndex === 1){
        SAPBroadphase.insertionSortY(axisList);
    } else if(axisIndex === 2){
        SAPBroadphase.insertionSortZ(axisList);
    }
};

/**
 * Check if the bounds of two bodies overlap, along the given SAP axis.
 * @static
 * @method checkBounds
 * @param  {Body} bi
 * @param  {Body} bj
 * @param  {Number} axisIndex
 * @return {Boolean}
 */
SAPBroadphase.checkBounds = function(bi, bj, axisIndex){
    var biPos;
    var bjPos;

    if(axisIndex === 0){
        biPos = bi.position.x;
        bjPos = bj.position.x;
    } else if(axisIndex === 1){
        biPos = bi.position.y;
        bjPos = bj.position.y;
    } else if(axisIndex === 2){
        biPos = bi.position.z;
        bjPos = bj.position.z;
    }

    var ri = bi.boundingRadius,
        rj = bj.boundingRadius,
        boundA1 = biPos - ri,
        boundA2 = biPos + ri,
        boundB1 = bjPos - rj,
        boundB2 = bjPos + rj;

    return boundB1 < boundA2;
};

/**
 * Computes the variance of the body positions and estimates the best
 * axis to use. Will automatically set property .axisIndex.
 * @method autoDetectAxis
 */
SAPBroadphase.prototype.autoDetectAxis = function(){
    var sumX=0,
        sumX2=0,
        sumY=0,
        sumY2=0,
        sumZ=0,
        sumZ2=0,
        bodies = this.axisList,
        N = bodies.length,
        invN=1/N;

    for(var i=0; i!==N; i++){
        var b = bodies[i];

        var centerX = b.position.x;
        sumX += centerX;
        sumX2 += centerX*centerX;

        var centerY = b.position.y;
        sumY += centerY;
        sumY2 += centerY*centerY;

        var centerZ = b.position.z;
        sumZ += centerZ;
        sumZ2 += centerZ*centerZ;
    }

    var varianceX = sumX2 - sumX*sumX*invN,
        varianceY = sumY2 - sumY*sumY*invN,
        varianceZ = sumZ2 - sumZ*sumZ*invN;

    if(varianceX > varianceY){
        if(varianceX > varianceZ){
            this.axisIndex = 0;
        } else{
            this.axisIndex = 2;
        }
    } else if(varianceY > varianceZ){
        this.axisIndex = 1;
    } else{
        this.axisIndex = 2;
    }
};

/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */
SAPBroadphase.prototype.aabbQuery = function(world, aabb, result){
    result = result || [];

    if(this.dirty){
        this.sortList();
        this.dirty = false;
    }

    var axisIndex = this.axisIndex, axis = 'x';
    if(axisIndex === 1){ axis = 'y'; }
    if(axisIndex === 2){ axis = 'z'; }

    var axisList = this.axisList;
    var lower = aabb.lowerBound[axis];
    var upper = aabb.upperBound[axis];
    for(var i = 0; i < axisList.length; i++){
        var b = axisList[i];

        if(b.aabbNeedsUpdate){
            b.computeAABB();
        }

        if(b.aabb.overlaps(aabb)){
            result.push(b);
        }
    }

    return result;
};
},{"../collision/Broadphase":5,"../shapes/Shape":43}],12:[function(_dereq_,module,exports){
module.exports = ConeTwistConstraint;

var Constraint = _dereq_('./Constraint');
var PointToPointConstraint = _dereq_('./PointToPointConstraint');
var ConeEquation = _dereq_('../equations/ConeEquation');
var RotationalEquation = _dereq_('../equations/RotationalEquation');
var ContactEquation = _dereq_('../equations/ContactEquation');
var Vec3 = _dereq_('../math/Vec3');

/**
 * @class ConeTwistConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Vec3} [options.pivotA]
 * @param {Vec3} [options.pivotB]
 * @param {Vec3} [options.axisA]
 * @param {Vec3} [options.axisB]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function ConeTwistConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    // Set pivot point in between
    var pivotA = options.pivotA ? options.pivotA.clone() : new Vec3();
    var pivotB = options.pivotB ? options.pivotB.clone() : new Vec3();
    this.axisA = options.axisA ? options.axisA.clone() : new Vec3();
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3();

    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    this.collideConnected = !!options.collideConnected;

    this.angle = typeof(options.angle) !== 'undefined' ? options.angle : 0;

    /**
     * @property {ConeEquation} coneEquation
     */
    var c = this.coneEquation = new ConeEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} twistEquation
     */
    var t = this.twistEquation = new RotationalEquation(bodyA,bodyB,options);
    this.twistAngle = typeof(options.twistAngle) !== 'undefined' ? options.twistAngle : 0;

    // Make the cone equation push the bodies toward the cone axis, not outward
    c.maxForce = 0;
    c.minForce = -maxForce;

    // Make the twist equation add torque toward the initial position
    t.maxForce = 0;
    t.minForce = -maxForce;

    this.equations.push(c, t);
}
ConeTwistConstraint.prototype = new PointToPointConstraint();
ConeTwistConstraint.constructor = ConeTwistConstraint;

var ConeTwistConstraint_update_tmpVec1 = new Vec3();
var ConeTwistConstraint_update_tmpVec2 = new Vec3();

ConeTwistConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        cone = this.coneEquation,
        twist = this.twistEquation;

    PointToPointConstraint.prototype.update.call(this);

    // Update the axes to the cone constraint
    bodyA.vectorToWorldFrame(this.axisA, cone.axisA);
    bodyB.vectorToWorldFrame(this.axisB, cone.axisB);

    // Update the world axes in the twist constraint
    this.axisA.tangents(twist.axisA, twist.axisA);
    bodyA.vectorToWorldFrame(twist.axisA, twist.axisA);

    this.axisB.tangents(twist.axisB, twist.axisB);
    bodyB.vectorToWorldFrame(twist.axisB, twist.axisB);

    cone.angle = this.angle;
    twist.maxAngle = this.twistAngle;
};


},{"../equations/ConeEquation":18,"../equations/ContactEquation":19,"../equations/RotationalEquation":22,"../math/Vec3":30,"./Constraint":13,"./PointToPointConstraint":17}],13:[function(_dereq_,module,exports){
module.exports = Constraint;

var Utils = _dereq_('../utils/Utils');

/**
 * Constraint base class
 * @class Constraint
 * @author schteppe
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {boolean} [options.collideConnected=true]
 * @param {boolean} [options.wakeUpBodies=true]
 */
function Constraint(bodyA, bodyB, options){
    options = Utils.defaults(options,{
        collideConnected : true,
        wakeUpBodies : true,
    });

    /**
     * Equations to be solved in this constraint
     * @property equations
     * @type {Array}
     */
    this.equations = [];

    /**
     * @property {Body} bodyA
     */
    this.bodyA = bodyA;

    /**
     * @property {Body} bodyB
     */
    this.bodyB = bodyB;

    /**
     * @property {Number} id
     */
    this.id = Constraint.idCounter++;

    /**
     * Set to true if you want the bodies to collide when they are connected.
     * @property collideConnected
     * @type {boolean}
     */
    this.collideConnected = options.collideConnected;

    if(options.wakeUpBodies){
        if(bodyA){
            bodyA.wakeUp();
        }
        if(bodyB){
            bodyB.wakeUp();
        }
    }
}

/**
 * Update all the equations with data.
 * @method update
 */
Constraint.prototype.update = function(){
    throw new Error("method update() not implmemented in this Constraint subclass!");
};

/**
 * Enables all equations in the constraint.
 * @method enable
 */
Constraint.prototype.enable = function(){
    var eqs = this.equations;
    for(var i=0; i<eqs.length; i++){
        eqs[i].enabled = true;
    }
};

/**
 * Disables all equations in the constraint.
 * @method disable
 */
Constraint.prototype.disable = function(){
    var eqs = this.equations;
    for(var i=0; i<eqs.length; i++){
        eqs[i].enabled = false;
    }
};

Constraint.idCounter = 0;

},{"../utils/Utils":53}],14:[function(_dereq_,module,exports){
module.exports = DistanceConstraint;

var Constraint = _dereq_('./Constraint');
var ContactEquation = _dereq_('../equations/ContactEquation');

/**
 * Constrains two bodies to be at a constant distance from each others center of mass.
 * @class DistanceConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} [distance] The distance to keep. If undefined, it will be set to the current distance between bodyA and bodyB
 * @param {Number} [maxForce=1e6]
 * @extends Constraint
 */
function DistanceConstraint(bodyA,bodyB,distance,maxForce){
    Constraint.call(this,bodyA,bodyB);

    if(typeof(distance)==="undefined") {
        distance = bodyA.position.distanceTo(bodyB.position);
    }

    if(typeof(maxForce)==="undefined") {
        maxForce = 1e6;
    }

    /**
     * @property {number} distance
     */
    this.distance = distance;

    /**
     * @property {ContactEquation} distanceEquation
     */
    var eq = this.distanceEquation = new ContactEquation(bodyA, bodyB);
    this.equations.push(eq);

    // Make it bidirectional
    eq.minForce = -maxForce;
    eq.maxForce =  maxForce;
}
DistanceConstraint.prototype = new Constraint();

DistanceConstraint.prototype.update = function(){
    var bodyA = this.bodyA;
    var bodyB = this.bodyB;
    var eq = this.distanceEquation;
    var halfDist = this.distance * 0.5;
    var normal = eq.ni;

    bodyB.position.vsub(bodyA.position, normal);
    normal.normalize();
    normal.mult(halfDist, eq.ri);
    normal.mult(-halfDist, eq.rj);
};
},{"../equations/ContactEquation":19,"./Constraint":13}],15:[function(_dereq_,module,exports){
module.exports = HingeConstraint;

var Constraint = _dereq_('./Constraint');
var PointToPointConstraint = _dereq_('./PointToPointConstraint');
var RotationalEquation = _dereq_('../equations/RotationalEquation');
var RotationalMotorEquation = _dereq_('../equations/RotationalMotorEquation');
var ContactEquation = _dereq_('../equations/ContactEquation');
var Vec3 = _dereq_('../math/Vec3');

/**
 * Hinge constraint. Think of it as a door hinge. It tries to keep the door in the correct place and with the correct orientation.
 * @class HingeConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Vec3} [options.pivotA] A point defined locally in bodyA. This defines the offset of axisA.
 * @param {Vec3} [options.axisA] An axis that bodyA can rotate around, defined locally in bodyA.
 * @param {Vec3} [options.pivotB]
 * @param {Vec3} [options.axisB]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function HingeConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;
    var pivotA = options.pivotA ? options.pivotA.clone() : new Vec3();
    var pivotB = options.pivotB ? options.pivotB.clone() : new Vec3();

    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    /**
     * Rotation axis, defined locally in bodyA.
     * @property {Vec3} axisA
     */
    var axisA = this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1,0,0);
    axisA.normalize();

    /**
     * Rotation axis, defined locally in bodyB.
     * @property {Vec3} axisB
     */
    var axisB = this.axisB = options.axisB ? options.axisB.clone() : new Vec3(1,0,0);
    axisB.normalize();

    /**
     * @property {RotationalEquation} rotationalEquation1
     */
    var r1 = this.rotationalEquation1 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation2
     */
    var r2 = this.rotationalEquation2 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalMotorEquation} motorEquation
     */
    var motor = this.motorEquation = new RotationalMotorEquation(bodyA,bodyB,maxForce);
    motor.enabled = false; // Not enabled by default

    // Equations to be fed to the solver
    this.equations.push(
        r1, // rotational1
        r2, // rotational2
        motor
    );
}
HingeConstraint.prototype = new PointToPointConstraint();
HingeConstraint.constructor = HingeConstraint;

/**
 * @method enableMotor
 */
HingeConstraint.prototype.enableMotor = function(){
    this.motorEquation.enabled = true;
};

/**
 * @method disableMotor
 */
HingeConstraint.prototype.disableMotor = function(){
    this.motorEquation.enabled = false;
};

/**
 * @method setMotorSpeed
 * @param {number} speed
 */
HingeConstraint.prototype.setMotorSpeed = function(speed){
    this.motorEquation.targetVelocity = speed;
};

/**
 * @method setMotorMaxForce
 * @param {number} maxForce
 */
HingeConstraint.prototype.setMotorMaxForce = function(maxForce){
    this.motorEquation.maxForce = maxForce;
    this.motorEquation.minForce = -maxForce;
};

var HingeConstraint_update_tmpVec1 = new Vec3();
var HingeConstraint_update_tmpVec2 = new Vec3();

HingeConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        motor = this.motorEquation,
        r1 = this.rotationalEquation1,
        r2 = this.rotationalEquation2,
        worldAxisA = HingeConstraint_update_tmpVec1,
        worldAxisB = HingeConstraint_update_tmpVec2;

    var axisA = this.axisA;
    var axisB = this.axisB;

    PointToPointConstraint.prototype.update.call(this);

    // Get world axes
    bodyA.quaternion.vmult(axisA, worldAxisA);
    bodyB.quaternion.vmult(axisB, worldAxisB);

    worldAxisA.tangents(r1.axisA, r2.axisA);
    r1.axisB.copy(worldAxisB);
    r2.axisB.copy(worldAxisB);

    if(this.motorEquation.enabled){
        bodyA.quaternion.vmult(this.axisA, motor.axisA);
        bodyB.quaternion.vmult(this.axisB, motor.axisB);
    }
};


},{"../equations/ContactEquation":19,"../equations/RotationalEquation":22,"../equations/RotationalMotorEquation":23,"../math/Vec3":30,"./Constraint":13,"./PointToPointConstraint":17}],16:[function(_dereq_,module,exports){
module.exports = LockConstraint;

var Constraint = _dereq_('./Constraint');
var PointToPointConstraint = _dereq_('./PointToPointConstraint');
var RotationalEquation = _dereq_('../equations/RotationalEquation');
var RotationalMotorEquation = _dereq_('../equations/RotationalMotorEquation');
var ContactEquation = _dereq_('../equations/ContactEquation');
var Vec3 = _dereq_('../math/Vec3');

/**
 * Lock constraint. Will remove all degrees of freedom between the bodies.
 * @class LockConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function LockConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    // Set pivot point in between
    var pivotA = new Vec3();
    var pivotB = new Vec3();
    var halfWay = new Vec3();
    bodyA.position.vadd(bodyB.position, halfWay);
    halfWay.scale(0.5, halfWay);
    bodyB.pointToLocalFrame(halfWay, pivotB);
    bodyA.pointToLocalFrame(halfWay, pivotA);
    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    /**
     * @property {RotationalEquation} rotationalEquation1
     */
    var r1 = this.rotationalEquation1 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation2
     */
    var r2 = this.rotationalEquation2 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation3
     */
    var r3 = this.rotationalEquation3 = new RotationalEquation(bodyA,bodyB,options);

    this.equations.push(r1, r2, r3);
}
LockConstraint.prototype = new PointToPointConstraint();
LockConstraint.constructor = LockConstraint;

var LockConstraint_update_tmpVec1 = new Vec3();
var LockConstraint_update_tmpVec2 = new Vec3();

LockConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        motor = this.motorEquation,
        r1 = this.rotationalEquation1,
        r2 = this.rotationalEquation2,
        r3 = this.rotationalEquation3,
        worldAxisA = LockConstraint_update_tmpVec1,
        worldAxisB = LockConstraint_update_tmpVec2;

    PointToPointConstraint.prototype.update.call(this);

    bodyA.vectorToWorldFrame(Vec3.UNIT_X, r1.axisA);
    bodyB.vectorToWorldFrame(Vec3.UNIT_Y, r1.axisB);

    bodyA.vectorToWorldFrame(Vec3.UNIT_Y, r2.axisA);
    bodyB.vectorToWorldFrame(Vec3.UNIT_Z, r2.axisB);

    bodyA.vectorToWorldFrame(Vec3.UNIT_Z, r3.axisA);
    bodyB.vectorToWorldFrame(Vec3.UNIT_X, r3.axisB);
};


},{"../equations/ContactEquation":19,"../equations/RotationalEquation":22,"../equations/RotationalMotorEquation":23,"../math/Vec3":30,"./Constraint":13,"./PointToPointConstraint":17}],17:[function(_dereq_,module,exports){
module.exports = PointToPointConstraint;

var Constraint = _dereq_('./Constraint');
var ContactEquation = _dereq_('../equations/ContactEquation');
var Vec3 = _dereq_('../math/Vec3');

/**
 * Connects two bodies at given offset points.
 * @class PointToPointConstraint
 * @extends Constraint
 * @constructor
 * @param {Body} bodyA
 * @param {Vec3} pivotA The point relative to the center of mass of bodyA which bodyA is constrained to.
 * @param {Body} bodyB Body that will be constrained in a similar way to the same point as bodyA. We will therefore get a link between bodyA and bodyB. If not specified, bodyA will be constrained to a static point.
 * @param {Vec3} pivotB See pivotA.
 * @param {Number} maxForce The maximum force that should be applied to constrain the bodies.
 *
 * @example
 *     var bodyA = new Body({ mass: 1 });
 *     var bodyB = new Body({ mass: 1 });
 *     bodyA.position.set(-1, 0, 0);
 *     bodyB.position.set(1, 0, 0);
 *     bodyA.addShape(shapeA);
 *     bodyB.addShape(shapeB);
 *     world.addBody(bodyA);
 *     world.addBody(bodyB);
 *     var localPivotA = new Vec3(1, 0, 0);
 *     var localPivotB = new Vec3(-1, 0, 0);
 *     var constraint = new PointToPointConstraint(bodyA, localPivotA, bodyB, localPivotB);
 *     world.addConstraint(constraint);
 */
function PointToPointConstraint(bodyA,pivotA,bodyB,pivotB,maxForce){
    Constraint.call(this,bodyA,bodyB);

    maxForce = typeof(maxForce) !== 'undefined' ? maxForce : 1e6;

    /**
     * Pivot, defined locally in bodyA.
     * @property {Vec3} pivotA
     */
    this.pivotA = pivotA ? pivotA.clone() : new Vec3();

    /**
     * Pivot, defined locally in bodyB.
     * @property {Vec3} pivotB
     */
    this.pivotB = pivotB ? pivotB.clone() : new Vec3();

    /**
     * @property {ContactEquation} equationX
     */
    var x = this.equationX = new ContactEquation(bodyA,bodyB);

    /**
     * @property {ContactEquation} equationY
     */
    var y = this.equationY = new ContactEquation(bodyA,bodyB);

    /**
     * @property {ContactEquation} equationZ
     */
    var z = this.equationZ = new ContactEquation(bodyA,bodyB);

    // Equations to be fed to the solver
    this.equations.push(x, y, z);

    // Make the equations bidirectional
    x.minForce = y.minForce = z.minForce = -maxForce;
    x.maxForce = y.maxForce = z.maxForce =  maxForce;

    x.ni.set(1, 0, 0);
    y.ni.set(0, 1, 0);
    z.ni.set(0, 0, 1);
}
PointToPointConstraint.prototype = new Constraint();

PointToPointConstraint.prototype.update = function(){
    var bodyA = this.bodyA;
    var bodyB = this.bodyB;
    var x = this.equationX;
    var y = this.equationY;
    var z = this.equationZ;

    // Rotate the pivots to world space
    bodyA.quaternion.vmult(this.pivotA,x.ri);
    bodyB.quaternion.vmult(this.pivotB,x.rj);

    y.ri.copy(x.ri);
    y.rj.copy(x.rj);
    z.ri.copy(x.ri);
    z.rj.copy(x.rj);
};
},{"../equations/ContactEquation":19,"../math/Vec3":30,"./Constraint":13}],18:[function(_dereq_,module,exports){
module.exports = ConeEquation;

var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');
var Equation = _dereq_('./Equation');

/**
 * Cone equation. Works to keep the given body world vectors aligned, or tilted within a given angle from each other.
 * @class ConeEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Vec3} [options.axisA] Local axis in A
 * @param {Vec3} [options.axisB] Local axis in B
 * @param {Vec3} [options.angle] The "cone angle" to keep
 * @param {number} [options.maxForce=1e6]
 * @extends Equation
 */
function ConeEquation(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    Equation.call(this,bodyA,bodyB,-maxForce, maxForce);

    this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1, 0, 0);
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3(0, 1, 0);

    /**
     * The cone angle to keep
     * @property {number} angle
     */
    this.angle = typeof(options.angle) !== 'undefined' ? options.angle : 0;
}

ConeEquation.prototype = new Equation();
ConeEquation.prototype.constructor = ConeEquation;

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();

ConeEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,

        ni = this.axisA,
        nj = this.axisB,

        nixnj = tmpVec1,
        njxni = tmpVec2,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // Caluclate cross products
    ni.cross(nj, nixnj);
    nj.cross(ni, njxni);

    // The angle between two vector is:
    // cos(theta) = a * b / (length(a) * length(b) = { len(a) = len(b) = 1 } = a * b

    // g = a * b
    // gdot = (b x a) * wi + (a x b) * wj
    // G = [0 bxa 0 axb]
    // W = [vi wi vj wj]
    GA.rotational.copy(njxni);
    GB.rotational.copy(nixnj);

    var g = Math.cos(this.angle) - ni.dot(nj),
        GW = this.computeGW(),
        GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h * GiMf;

    return B;
};


},{"../math/Mat3":27,"../math/Vec3":30,"./Equation":20}],19:[function(_dereq_,module,exports){
module.exports = ContactEquation;

var Equation = _dereq_('./Equation');
var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');

/**
 * Contact/non-penetration constraint equation
 * @class ContactEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @extends Equation
 */
function ContactEquation(bodyA, bodyB, maxForce){
    maxForce = typeof(maxForce) !== 'undefined' ? maxForce : 1e6;
    Equation.call(this, bodyA, bodyB, 0, maxForce);

    /**
     * @property restitution
     * @type {Number}
     */
    this.restitution = 0.0; // "bounciness": u1 = -e*u0

    /**
     * World-oriented vector that goes from the center of bi to the contact point.
     * @property {Vec3} ri
     */
    this.ri = new Vec3();

    /**
     * World-oriented vector that starts in body j position and goes to the contact point.
     * @property {Vec3} rj
     */
    this.rj = new Vec3();

    /**
     * Contact normal, pointing out of body i.
     * @property {Vec3} ni
     */
    this.ni = new Vec3();
}

ContactEquation.prototype = new Equation();
ContactEquation.prototype.constructor = ContactEquation;

var ContactEquation_computeB_temp1 = new Vec3(); // Temp vectors
var ContactEquation_computeB_temp2 = new Vec3();
var ContactEquation_computeB_temp3 = new Vec3();
ContactEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,
        ri = this.ri,
        rj = this.rj,
        rixn = ContactEquation_computeB_temp1,
        rjxn = ContactEquation_computeB_temp2,

        vi = bi.velocity,
        wi = bi.angularVelocity,
        fi = bi.force,
        taui = bi.torque,

        vj = bj.velocity,
        wj = bj.angularVelocity,
        fj = bj.force,
        tauj = bj.torque,

        penetrationVec = ContactEquation_computeB_temp3,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB,

        n = this.ni;

    // Caluclate cross products
    ri.cross(n,rixn);
    rj.cross(n,rjxn);

    // g = xj+rj -(xi+ri)
    // G = [ -ni  -rixn  ni  rjxn ]
    n.negate(GA.spatial);
    rixn.negate(GA.rotational);
    GB.spatial.copy(n);
    GB.rotational.copy(rjxn);

    // Calculate the penetration vector
    penetrationVec.copy(bj.position);
    penetrationVec.vadd(rj,penetrationVec);
    penetrationVec.vsub(bi.position,penetrationVec);
    penetrationVec.vsub(ri,penetrationVec);

    var g = n.dot(penetrationVec);

    // Compute iteration
    var ePlusOne = this.restitution + 1;
    var GW = ePlusOne * vj.dot(n) - ePlusOne * vi.dot(n) + wj.dot(rjxn) - wi.dot(rixn);
    var GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h*GiMf;

    return B;
};

var ContactEquation_getImpactVelocityAlongNormal_vi = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_vj = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_xi = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_xj = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_relVel = new Vec3();

/**
 * Get the current relative velocity in the contact point.
 * @method getImpactVelocityAlongNormal
 * @return {number}
 */
ContactEquation.prototype.getImpactVelocityAlongNormal = function(){
    var vi = ContactEquation_getImpactVelocityAlongNormal_vi;
    var vj = ContactEquation_getImpactVelocityAlongNormal_vj;
    var xi = ContactEquation_getImpactVelocityAlongNormal_xi;
    var xj = ContactEquation_getImpactVelocityAlongNormal_xj;
    var relVel = ContactEquation_getImpactVelocityAlongNormal_relVel;

    this.bi.position.vadd(this.ri, xi);
    this.bj.position.vadd(this.rj, xj);

    this.bi.getVelocityAtWorldPoint(xi, vi);
    this.bj.getVelocityAtWorldPoint(xj, vj);

    vi.vsub(vj, relVel);

    return this.ni.dot(relVel);
};


},{"../math/Mat3":27,"../math/Vec3":30,"./Equation":20}],20:[function(_dereq_,module,exports){
module.exports = Equation;

var JacobianElement = _dereq_('../math/JacobianElement'),
    Vec3 = _dereq_('../math/Vec3');

/**
 * Equation base class
 * @class Equation
 * @constructor
 * @author schteppe
 * @param {Body} bi
 * @param {Body} bj
 * @param {Number} minForce Minimum (read: negative max) force to be applied by the constraint.
 * @param {Number} maxForce Maximum (read: positive max) force to be applied by the constraint.
 */
function Equation(bi,bj,minForce,maxForce){
    this.id = Equation.id++;

    /**
     * @property {number} minForce
     */
    this.minForce = typeof(minForce)==="undefined" ? -1e6 : minForce;

    /**
     * @property {number} maxForce
     */
    this.maxForce = typeof(maxForce)==="undefined" ? 1e6 : maxForce;

    /**
     * @property bi
     * @type {Body}
     */
    this.bi = bi;

    /**
     * @property bj
     * @type {Body}
     */
    this.bj = bj;

    /**
     * SPOOK parameter
     * @property {number} a
     */
    this.a = 0.0;

    /**
     * SPOOK parameter
     * @property {number} b
     */
    this.b = 0.0;

    /**
     * SPOOK parameter
     * @property {number} eps
     */
    this.eps = 0.0;

    /**
     * @property {JacobianElement} jacobianElementA
     */
    this.jacobianElementA = new JacobianElement();

    /**
     * @property {JacobianElement} jacobianElementB
     */
    this.jacobianElementB = new JacobianElement();

    /**
     * @property {boolean} enabled
     * @default true
     */
    this.enabled = true;

    // Set typical spook params
    this.setSpookParams(1e7,4,1/60);
}
Equation.prototype.constructor = Equation;

Equation.id = 0;

/**
 * Recalculates a,b,eps.
 * @method setSpookParams
 */
Equation.prototype.setSpookParams = function(stiffness,relaxation,timeStep){
    var d = relaxation,
        k = stiffness,
        h = timeStep;
    this.a = 4.0 / (h * (1 + 4 * d));
    this.b = (4.0 * d) / (1 + 4 * d);
    this.eps = 4.0 / (h * h * k * (1 + 4 * d));
};

/**
 * Computes the RHS of the SPOOK equation
 * @method computeB
 * @return {Number}
 */
Equation.prototype.computeB = function(a,b,h){
    var GW = this.computeGW(),
        Gq = this.computeGq(),
        GiMf = this.computeGiMf();
    return - Gq * a - GW * b - GiMf*h;
};

/**
 * Computes G*q, where q are the generalized body coordinates
 * @method computeGq
 * @return {Number}
 */
Equation.prototype.computeGq = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        xi = bi.position,
        xj = bj.position;
    return GA.spatial.dot(xi) + GB.spatial.dot(xj);
};

var zero = new Vec3();

/**
 * Computes G*W, where W are the body velocities
 * @method computeGW
 * @return {Number}
 */
Equation.prototype.computeGW = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        vi = bi.velocity,
        vj = bj.velocity,
        wi = bi.angularVelocity || zero,
        wj = bj.angularVelocity || zero;
    return GA.multiplyVectors(vi,wi) + GB.multiplyVectors(vj,wj);
};


/**
 * Computes G*Wlambda, where W are the body velocities
 * @method computeGWlambda
 * @return {Number}
 */
Equation.prototype.computeGWlambda = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        vi = bi.vlambda,
        vj = bj.vlambda,
        wi = bi.wlambda || zero,
        wj = bj.wlambda || zero;
    return GA.multiplyVectors(vi,wi) + GB.multiplyVectors(vj,wj);
};

/**
 * Computes G*inv(M)*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
 * @method computeGiMf
 * @return {Number}
 */
var iMfi = new Vec3(),
    iMfj = new Vec3(),
    invIi_vmult_taui = new Vec3(),
    invIj_vmult_tauj = new Vec3();
Equation.prototype.computeGiMf = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        fi = bi.force,
        ti = bi.torque,
        fj = bj.force,
        tj = bj.torque,
        invMassi = bi.invMassSolve,
        invMassj = bj.invMassSolve;

    if(bi.invInertiaWorldSolve){ bi.invInertiaWorldSolve.vmult(ti,invIi_vmult_taui); }
    else { invIi_vmult_taui.set(0,0,0); }
    if(bj.invInertiaWorldSolve){ bj.invInertiaWorldSolve.vmult(tj,invIj_vmult_tauj); }
    else { invIj_vmult_tauj.set(0,0,0); }

    fi.mult(invMassi,iMfi);
    fj.mult(invMassj,iMfj);

    return GA.multiplyVectors(iMfi,invIi_vmult_taui) + GB.multiplyVectors(iMfj,invIj_vmult_tauj);
};

/**
 * Computes G*inv(M)*G'
 * @method computeGiMGt
 * @return {Number}
 */
var tmp = new Vec3();
Equation.prototype.computeGiMGt = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        invMassi = bi.invMassSolve,
        invMassj = bj.invMassSolve,
        invIi = bi.invInertiaWorldSolve,
        invIj = bj.invInertiaWorldSolve,
        result = invMassi + invMassj;

    if(invIi){
        invIi.vmult(GA.rotational,tmp);
        result += tmp.dot(GA.rotational);
    }

    if(invIj){
        invIj.vmult(GB.rotational,tmp);
        result += tmp.dot(GB.rotational);
    }

    return  result;
};

var addToWlambda_temp = new Vec3(),
    addToWlambda_Gi = new Vec3(),
    addToWlambda_Gj = new Vec3(),
    addToWlambda_ri = new Vec3(),
    addToWlambda_rj = new Vec3(),
    addToWlambda_Mdiag = new Vec3();

/**
 * Add constraint velocity to the bodies.
 * @method addToWlambda
 * @param {Number} deltalambda
 */
Equation.prototype.addToWlambda = function(deltalambda){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        temp = addToWlambda_temp;

    // Add to linear velocity
    // v_lambda += inv(M) * delta_lamba * G
    GA.spatial.mult(bi.invMassSolve * deltalambda,temp);
    bi.vlambda.vadd(temp, bi.vlambda);

    GB.spatial.mult(bj.invMassSolve * deltalambda,temp);
    bj.vlambda.vadd(temp, bj.vlambda);

    // Add to angular velocity
    if(bi.invInertiaWorldSolve){
        bi.invInertiaWorldSolve.vmult(GA.rotational,temp);
        temp.mult(deltalambda,temp);
        bi.wlambda.vadd(temp,bi.wlambda);
    }

    if(bj.invInertiaWorldSolve){
        bj.invInertiaWorldSolve.vmult(GB.rotational,temp);
        temp.mult(deltalambda,temp);
        bj.wlambda.vadd(temp,bj.wlambda);
    }
};

/**
 * Compute the denominator part of the SPOOK equation: C = G*inv(M)*G' + eps
 * @method computeInvC
 * @param  {Number} eps
 * @return {Number}
 */
Equation.prototype.computeC = function(){
    return this.computeGiMGt() + this.eps;
};

},{"../math/JacobianElement":26,"../math/Vec3":30}],21:[function(_dereq_,module,exports){
module.exports = FrictionEquation;

var Equation = _dereq_('./Equation');
var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');

/**
 * Constrains the slipping in a contact along a tangent
 * @class FrictionEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} slipForce should be +-F_friction = +-mu * F_normal = +-mu * m * g
 * @extends Equation
 */
function FrictionEquation(bodyA, bodyB, slipForce){
    Equation.call(this,bodyA, bodyB, -slipForce, slipForce);
    this.ri = new Vec3();
    this.rj = new Vec3();
    this.t = new Vec3(); // tangent
}

FrictionEquation.prototype = new Equation();
FrictionEquation.prototype.constructor = FrictionEquation;

var FrictionEquation_computeB_temp1 = new Vec3();
var FrictionEquation_computeB_temp2 = new Vec3();
FrictionEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,
        ri = this.ri,
        rj = this.rj,
        rixt = FrictionEquation_computeB_temp1,
        rjxt = FrictionEquation_computeB_temp2,
        t = this.t;

    // Caluclate cross products
    ri.cross(t,rixt);
    rj.cross(t,rjxt);

    // G = [-t -rixt t rjxt]
    // And remember, this is a pure velocity constraint, g is always zero!
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB;
    t.negate(GA.spatial);
    rixt.negate(GA.rotational);
    GB.spatial.copy(t);
    GB.rotational.copy(rjxt);

    var GW = this.computeGW();
    var GiMf = this.computeGiMf();

    var B = - GW * b - h * GiMf;

    return B;
};

},{"../math/Mat3":27,"../math/Vec3":30,"./Equation":20}],22:[function(_dereq_,module,exports){
module.exports = RotationalEquation;

var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');
var Equation = _dereq_('./Equation');

/**
 * Rotational constraint. Works to keep the local vectors orthogonal to each other in world space.
 * @class RotationalEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Vec3} [options.axisA]
 * @param {Vec3} [options.axisB]
 * @param {number} [options.maxForce]
 * @extends Equation
 */
function RotationalEquation(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    Equation.call(this,bodyA,bodyB,-maxForce, maxForce);

    this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1, 0, 0);
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3(0, 1, 0);

    this.maxAngle = Math.PI / 2;
}

RotationalEquation.prototype = new Equation();
RotationalEquation.prototype.constructor = RotationalEquation;

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();

RotationalEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,

        ni = this.axisA,
        nj = this.axisB,

        nixnj = tmpVec1,
        njxni = tmpVec2,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // Caluclate cross products
    ni.cross(nj, nixnj);
    nj.cross(ni, njxni);

    // g = ni * nj
    // gdot = (nj x ni) * wi + (ni x nj) * wj
    // G = [0 njxni 0 nixnj]
    // W = [vi wi vj wj]
    GA.rotational.copy(njxni);
    GB.rotational.copy(nixnj);

    var g = Math.cos(this.maxAngle) - ni.dot(nj),
        GW = this.computeGW(),
        GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h * GiMf;

    return B;
};


},{"../math/Mat3":27,"../math/Vec3":30,"./Equation":20}],23:[function(_dereq_,module,exports){
module.exports = RotationalMotorEquation;

var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');
var Equation = _dereq_('./Equation');

/**
 * Rotational motor constraint. Tries to keep the relative angular velocity of the bodies to a given value.
 * @class RotationalMotorEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} maxForce
 * @extends Equation
 */
function RotationalMotorEquation(bodyA, bodyB, maxForce){
    maxForce = typeof(maxForce)!=='undefined' ? maxForce : 1e6;
    Equation.call(this,bodyA,bodyB,-maxForce,maxForce);

    /**
     * World oriented rotational axis
     * @property {Vec3} axisA
     */
    this.axisA = new Vec3();

    /**
     * World oriented rotational axis
     * @property {Vec3} axisB
     */
    this.axisB = new Vec3(); // World oriented rotational axis

    /**
     * Motor velocity
     * @property {Number} targetVelocity
     */
    this.targetVelocity = 0;
}

RotationalMotorEquation.prototype = new Equation();
RotationalMotorEquation.prototype.constructor = RotationalMotorEquation;

RotationalMotorEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,

        axisA = this.axisA,
        axisB = this.axisB,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // g = 0
    // gdot = axisA * wi - axisB * wj
    // gdot = G * W = G * [vi wi vj wj]
    // =>
    // G = [0 axisA 0 -axisB]

    GA.rotational.copy(axisA);
    axisB.negate(GB.rotational);

    var GW = this.computeGW() - this.targetVelocity,
        GiMf = this.computeGiMf();

    var B = - GW * b - h * GiMf;

    return B;
};

},{"../math/Mat3":27,"../math/Vec3":30,"./Equation":20}],24:[function(_dereq_,module,exports){
var Utils = _dereq_('../utils/Utils');

module.exports = ContactMaterial;

/**
 * Defines what happens when two materials meet.
 * @class ContactMaterial
 * @constructor
 * @param {Material} m1
 * @param {Material} m2
 * @param {object} [options]
 * @param {Number} [options.friction=0.3]
 * @param {Number} [options.restitution=0.3]
 * @param {number} [options.contactEquationStiffness=1e7]
 * @param {number} [options.contactEquationRelaxation=3]
 * @param {number} [options.frictionEquationStiffness=1e7]
 * @param {Number} [options.frictionEquationRelaxation=3]
 */
function ContactMaterial(m1, m2, options){
    options = Utils.defaults(options, {
        friction: 0.3,
        restitution: 0.3,
        contactEquationStiffness: 1e7,
        contactEquationRelaxation: 3,
        frictionEquationStiffness: 1e7,
        frictionEquationRelaxation: 3
    });

    /**
     * Identifier of this material
     * @property {Number} id
     */
    this.id = ContactMaterial.idCounter++;

    /**
     * Participating materials
     * @property {Array} materials
     * @todo  Should be .materialA and .materialB instead
     */
    this.materials = [m1, m2];

    /**
     * Friction coefficient
     * @property {Number} friction
     */
    this.friction = options.friction;

    /**
     * Restitution coefficient
     * @property {Number} restitution
     */
    this.restitution = options.restitution;

    /**
     * Stiffness of the produced contact equations
     * @property {Number} contactEquationStiffness
     */
    this.contactEquationStiffness = options.contactEquationStiffness;

    /**
     * Relaxation time of the produced contact equations
     * @property {Number} contactEquationRelaxation
     */
    this.contactEquationRelaxation = options.contactEquationRelaxation;

    /**
     * Stiffness of the produced friction equations
     * @property {Number} frictionEquationStiffness
     */
    this.frictionEquationStiffness = options.frictionEquationStiffness;

    /**
     * Relaxation time of the produced friction equations
     * @property {Number} frictionEquationRelaxation
     */
    this.frictionEquationRelaxation = options.frictionEquationRelaxation;
}

ContactMaterial.idCounter = 0;

},{"../utils/Utils":53}],25:[function(_dereq_,module,exports){
module.exports = Material;

/**
 * Defines a physics material.
 * @class Material
 * @constructor
 * @param {object} [options]
 * @author schteppe
 */
function Material(options){
    var name = '';
    options = options || {};

    // Backwards compatibility fix
    if(typeof(options) === 'string'){
        name = options;
        options = {};
    } else if(typeof(options) === 'object') {
        name = '';
    }

    /**
     * @property name
     * @type {String}
     */
    this.name = name;

    /**
     * material id.
     * @property id
     * @type {number}
     */
    this.id = Material.idCounter++;

    /**
     * Friction for this material. If non-negative, it will be used instead of the friction given by ContactMaterials. If there's no matching ContactMaterial, the value from .defaultContactMaterial in the World will be used.
     * @property {number} friction
     */
    this.friction = typeof(options.friction) !== 'undefined' ? options.friction : -1;

    /**
     * Restitution for this material. If non-negative, it will be used instead of the restitution given by ContactMaterials. If there's no matching ContactMaterial, the value from .defaultContactMaterial in the World will be used.
     * @property {number} restitution
     */
    this.restitution = typeof(options.restitution) !== 'undefined' ? options.restitution : -1;
}

Material.idCounter = 0;

},{}],26:[function(_dereq_,module,exports){
module.exports = JacobianElement;

var Vec3 = _dereq_('./Vec3');

/**
 * An element containing 6 entries, 3 spatial and 3 rotational degrees of freedom.
 * @class JacobianElement
 * @constructor
 */
function JacobianElement(){

    /**
     * @property {Vec3} spatial
     */
    this.spatial = new Vec3();

    /**
     * @property {Vec3} rotational
     */
    this.rotational = new Vec3();
}

/**
 * Multiply with other JacobianElement
 * @method multiplyElement
 * @param  {JacobianElement} element
 * @return {Number}
 */
JacobianElement.prototype.multiplyElement = function(element){
    return element.spatial.dot(this.spatial) + element.rotational.dot(this.rotational);
};

/**
 * Multiply with two vectors
 * @method multiplyVectors
 * @param  {Vec3} spatial
 * @param  {Vec3} rotational
 * @return {Number}
 */
JacobianElement.prototype.multiplyVectors = function(spatial,rotational){
    return spatial.dot(this.spatial) + rotational.dot(this.rotational);
};

},{"./Vec3":30}],27:[function(_dereq_,module,exports){
module.exports = Mat3;

var Vec3 = _dereq_('./Vec3');

/**
 * A 3x3 matrix.
 * @class Mat3
 * @constructor
 * @param array elements Array of nine elements. Optional.
 * @author schteppe / http://github.com/schteppe
 */
function Mat3(elements){
    /**
     * A vector of length 9, containing all matrix elements
     * @property {Array} elements
     */
    if(elements){
        this.elements = elements;
    } else {
        this.elements = [0,0,0,0,0,0,0,0,0];
    }
}

/**
 * Sets the matrix to identity
 * @method identity
 * @todo Should perhaps be renamed to setIdentity() to be more clear.
 * @todo Create another function that immediately creates an identity matrix eg. eye()
 */
Mat3.prototype.identity = function(){
    var e = this.elements;
    e[0] = 1;
    e[1] = 0;
    e[2] = 0;

    e[3] = 0;
    e[4] = 1;
    e[5] = 0;

    e[6] = 0;
    e[7] = 0;
    e[8] = 1;
};

/**
 * Set all elements to zero
 * @method setZero
 */
Mat3.prototype.setZero = function(){
    var e = this.elements;
    e[0] = 0;
    e[1] = 0;
    e[2] = 0;
    e[3] = 0;
    e[4] = 0;
    e[5] = 0;
    e[6] = 0;
    e[7] = 0;
    e[8] = 0;
};

/**
 * Sets the matrix diagonal elements from a Vec3
 * @method setTrace
 * @param {Vec3} vec3
 */
Mat3.prototype.setTrace = function(vec3){
    var e = this.elements;
    e[0] = vec3.x;
    e[4] = vec3.y;
    e[8] = vec3.z;
};

/**
 * Gets the matrix diagonal elements
 * @method getTrace
 * @return {Vec3}
 */
Mat3.prototype.getTrace = function(target){
    var target = target || new Vec3();
    var e = this.elements;
    target.x = e[0];
    target.y = e[4];
    target.z = e[8];
};

/**
 * Matrix-Vector multiplication
 * @method vmult
 * @param {Vec3} v The vector to multiply with
 * @param {Vec3} target Optional, target to save the result in.
 */
Mat3.prototype.vmult = function(v,target){
    target = target || new Vec3();

    var e = this.elements,
        x = v.x,
        y = v.y,
        z = v.z;
    target.x = e[0]*x + e[1]*y + e[2]*z;
    target.y = e[3]*x + e[4]*y + e[5]*z;
    target.z = e[6]*x + e[7]*y + e[8]*z;

    return target;
};

/**
 * Matrix-scalar multiplication
 * @method smult
 * @param {Number} s
 */
Mat3.prototype.smult = function(s){
    for(var i=0; i<this.elements.length; i++){
        this.elements[i] *= s;
    }
};

/**
 * Matrix multiplication
 * @method mmult
 * @param {Mat3} m Matrix to multiply with from left side.
 * @return {Mat3} The result.
 */
Mat3.prototype.mmult = function(m,target){
    var r = target || new Mat3();
    for(var i=0; i<3; i++){
        for(var j=0; j<3; j++){
            var sum = 0.0;
            for(var k=0; k<3; k++){
                sum += m.elements[i+k*3] * this.elements[k+j*3];
            }
            r.elements[i+j*3] = sum;
        }
    }
    return r;
};

/**
 * Scale each column of the matrix
 * @method scale
 * @param {Vec3} v
 * @return {Mat3} The result.
 */
Mat3.prototype.scale = function(v,target){
    target = target || new Mat3();
    var e = this.elements,
        t = target.elements;
    for(var i=0; i!==3; i++){
        t[3*i + 0] = v.x * e[3*i + 0];
        t[3*i + 1] = v.y * e[3*i + 1];
        t[3*i + 2] = v.z * e[3*i + 2];
    }
    return target;
};

/**
 * Solve Ax=b
 * @method solve
 * @param {Vec3} b The right hand side
 * @param {Vec3} target Optional. Target vector to save in.
 * @return {Vec3} The solution x
 * @todo should reuse arrays
 */
Mat3.prototype.solve = function(b,target){
    target = target || new Vec3();

    // Construct equations
    var nr = 3; // num rows
    var nc = 4; // num cols
    var eqns = [];
    for(var i=0; i<nr*nc; i++){
        eqns.push(0);
    }
    var i,j;
    for(i=0; i<3; i++){
        for(j=0; j<3; j++){
            eqns[i+nc*j] = this.elements[i+3*j];
        }
    }
    eqns[3+4*0] = b.x;
    eqns[3+4*1] = b.y;
    eqns[3+4*2] = b.z;

    // Compute right upper triangular version of the matrix - Gauss elimination
    var n = 3, k = n, np;
    var kp = 4; // num rows
    var p, els;
    do {
        i = k - n;
        if (eqns[i+nc*i] === 0) {
            // the pivot is null, swap lines
            for (j = i + 1; j < k; j++) {
                if (eqns[i+nc*j] !== 0) {
                    np = kp;
                    do {  // do ligne( i ) = ligne( i ) + ligne( k )
                        p = kp - np;
                        eqns[p+nc*i] += eqns[p+nc*j];
                    } while (--np);
                    break;
                }
            }
        }
        if (eqns[i+nc*i] !== 0) {
            for (j = i + 1; j < k; j++) {
                var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
                np = kp;
                do {  // do ligne( k ) = ligne( k ) - multiplier * ligne( i )
                    p = kp - np;
                    eqns[p+nc*j] = p <= i ? 0 : eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
                } while (--np);
            }
        }
    } while (--n);

    // Get the solution
    target.z = eqns[2*nc+3] / eqns[2*nc+2];
    target.y = (eqns[1*nc+3] - eqns[1*nc+2]*target.z) / eqns[1*nc+1];
    target.x = (eqns[0*nc+3] - eqns[0*nc+2]*target.z - eqns[0*nc+1]*target.y) / eqns[0*nc+0];

    if(isNaN(target.x) || isNaN(target.y) || isNaN(target.z) || target.x===Infinity || target.y===Infinity || target.z===Infinity){
        throw "Could not solve equation! Got x=["+target.toString()+"], b=["+b.toString()+"], A=["+this.toString()+"]";
    }

    return target;
};

/**
 * Get an element in the matrix by index. Index starts at 0, not 1!!!
 * @method e
 * @param {Number} row
 * @param {Number} column
 * @param {Number} value Optional. If provided, the matrix element will be set to this value.
 * @return {Number}
 */
Mat3.prototype.e = function( row , column ,value){
    if(value===undefined){
        return this.elements[column+3*row];
    } else {
        // Set value
        this.elements[column+3*row] = value;
    }
};

/**
 * Copy another matrix into this matrix object.
 * @method copy
 * @param {Mat3} source
 * @return {Mat3} this
 */
Mat3.prototype.copy = function(source){
    for(var i=0; i < source.elements.length; i++){
        this.elements[i] = source.elements[i];
    }
    return this;
};

/**
 * Returns a string representation of the matrix.
 * @method toString
 * @return string
 */
Mat3.prototype.toString = function(){
    var r = "";
    var sep = ",";
    for(var i=0; i<9; i++){
        r += this.elements[i] + sep;
    }
    return r;
};

/**
 * reverse the matrix
 * @method reverse
 * @param {Mat3} target Optional. Target matrix to save in.
 * @return {Mat3} The solution x
 */
Mat3.prototype.reverse = function(target){

    target = target || new Mat3();

    // Construct equations
    var nr = 3; // num rows
    var nc = 6; // num cols
    var eqns = [];
    for(var i=0; i<nr*nc; i++){
        eqns.push(0);
    }
    var i,j;
    for(i=0; i<3; i++){
        for(j=0; j<3; j++){
            eqns[i+nc*j] = this.elements[i+3*j];
        }
    }
    eqns[3+6*0] = 1;
    eqns[3+6*1] = 0;
    eqns[3+6*2] = 0;
    eqns[4+6*0] = 0;
    eqns[4+6*1] = 1;
    eqns[4+6*2] = 0;
    eqns[5+6*0] = 0;
    eqns[5+6*1] = 0;
    eqns[5+6*2] = 1;

    // Compute right upper triangular version of the matrix - Gauss elimination
    var n = 3, k = n, np;
    var kp = nc; // num rows
    var p;
    do {
        i = k - n;
        if (eqns[i+nc*i] === 0) {
            // the pivot is null, swap lines
            for (j = i + 1; j < k; j++) {
                if (eqns[i+nc*j] !== 0) {
                    np = kp;
                    do { // do line( i ) = line( i ) + line( k )
                        p = kp - np;
                        eqns[p+nc*i] += eqns[p+nc*j];
                    } while (--np);
                    break;
                }
            }
        }
        if (eqns[i+nc*i] !== 0) {
            for (j = i + 1; j < k; j++) {
                var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
                np = kp;
                do { // do line( k ) = line( k ) - multiplier * line( i )
                    p = kp - np;
                    eqns[p+nc*j] = p <= i ? 0 : eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
                } while (--np);
            }
        }
    } while (--n);

    // eliminate the upper left triangle of the matrix
    i = 2;
    do {
        j = i-1;
        do {
            var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
            np = nc;
            do {
                p = nc - np;
                eqns[p+nc*j] =  eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
            } while (--np);
        } while (j--);
    } while (--i);

    // operations on the diagonal
    i = 2;
    do {
        var multiplier = 1 / eqns[i+nc*i];
        np = nc;
        do {
            p = nc - np;
            eqns[p+nc*i] = eqns[p+nc*i] * multiplier ;
        } while (--np);
    } while (i--);

    i = 2;
    do {
        j = 2;
        do {
            p = eqns[nr+j+nc*i];
            if( isNaN( p ) || p ===Infinity ){
                throw "Could not reverse! A=["+this.toString()+"]";
            }
            target.e( i , j , p );
        } while (j--);
    } while (i--);

    return target;
};

/**
 * Set the matrix from a quaterion
 * @method setRotationFromQuaternion
 * @param {Quaternion} q
 */
Mat3.prototype.setRotationFromQuaternion = function( q ) {
    var x = q.x, y = q.y, z = q.z, w = q.w,
        x2 = x + x, y2 = y + y, z2 = z + z,
        xx = x * x2, xy = x * y2, xz = x * z2,
        yy = y * y2, yz = y * z2, zz = z * z2,
        wx = w * x2, wy = w * y2, wz = w * z2,
        e = this.elements;

    e[3*0 + 0] = 1 - ( yy + zz );
    e[3*0 + 1] = xy - wz;
    e[3*0 + 2] = xz + wy;

    e[3*1 + 0] = xy + wz;
    e[3*1 + 1] = 1 - ( xx + zz );
    e[3*1 + 2] = yz - wx;

    e[3*2 + 0] = xz - wy;
    e[3*2 + 1] = yz + wx;
    e[3*2 + 2] = 1 - ( xx + yy );

    return this;
};

/**
 * Transpose the matrix
 * @method transpose
 * @param  {Mat3} target Where to store the result.
 * @return {Mat3} The target Mat3, or a new Mat3 if target was omitted.
 */
Mat3.prototype.transpose = function( target ) {
    target = target || new Mat3();

    var Mt = target.elements,
        M = this.elements;

    for(var i=0; i!==3; i++){
        for(var j=0; j!==3; j++){
            Mt[3*i + j] = M[3*j + i];
        }
    }

    return target;
};

},{"./Vec3":30}],28:[function(_dereq_,module,exports){
module.exports = Quaternion;

var Vec3 = _dereq_('./Vec3');

/**
 * A Quaternion describes a rotation in 3D space. The Quaternion is mathematically defined as Q = x*i + y*j + z*k + w, where (i,j,k) are imaginary basis vectors. (x,y,z) can be seen as a vector related to the axis of rotation, while the real multiplier, w, is related to the amount of rotation.
 * @class Quaternion
 * @constructor
 * @param {Number} x Multiplier of the imaginary basis vector i.
 * @param {Number} y Multiplier of the imaginary basis vector j.
 * @param {Number} z Multiplier of the imaginary basis vector k.
 * @param {Number} w Multiplier of the real part.
 * @see http://en.wikipedia.org/wiki/Quaternion
 */
function Quaternion(x,y,z,w){
    /**
     * @property {Number} x
     */
    this.x = x!==undefined ? x : 0;

    /**
     * @property {Number} y
     */
    this.y = y!==undefined ? y : 0;

    /**
     * @property {Number} z
     */
    this.z = z!==undefined ? z : 0;

    /**
     * The multiplier of the real quaternion basis vector.
     * @property {Number} w
     */
    this.w = w!==undefined ? w : 1;
}

/**
 * Set the value of the quaternion.
 * @method set
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @param {Number} w
 */
Quaternion.prototype.set = function(x,y,z,w){
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
};

/**
 * Convert to a readable format
 * @method toString
 * @return string
 */
Quaternion.prototype.toString = function(){
    return this.x+","+this.y+","+this.z+","+this.w;
};

/**
 * Convert to an Array
 * @method toArray
 * @return Array
 */
Quaternion.prototype.toArray = function(){
    return [this.x, this.y, this.z, this.w];
};

/**
 * Set the quaternion components given an axis and an angle.
 * @method setFromAxisAngle
 * @param {Vec3} axis
 * @param {Number} angle in radians
 */
Quaternion.prototype.setFromAxisAngle = function(axis,angle){
    var s = Math.sin(angle*0.5);
    this.x = axis.x * s;
    this.y = axis.y * s;
    this.z = axis.z * s;
    this.w = Math.cos(angle*0.5);
};

/**
 * Converts the quaternion to axis/angle representation.
 * @method toAxisAngle
 * @param {Vec3} targetAxis Optional. A vector object to reuse for storing the axis.
 * @return Array An array, first elemnt is the axis and the second is the angle in radians.
 */
Quaternion.prototype.toAxisAngle = function(targetAxis){
    targetAxis = targetAxis || new Vec3();
    this.normalize(); // if w>1 acos and sqrt will produce errors, this cant happen if quaternion is normalised
    var angle = 2 * Math.acos(this.w);
    var s = Math.sqrt(1-this.w*this.w); // assuming quaternion normalised then w is less than 1, so term always positive.
    if (s < 0.001) { // test to avoid divide by zero, s is always positive due to sqrt
        // if s close to zero then direction of axis not important
        targetAxis.x = this.x; // if it is important that axis is normalised then replace with x=1; y=z=0;
        targetAxis.y = this.y;
        targetAxis.z = this.z;
    } else {
        targetAxis.x = this.x / s; // normalise axis
        targetAxis.y = this.y / s;
        targetAxis.z = this.z / s;
    }
    return [targetAxis,angle];
};

var sfv_t1 = new Vec3(),
    sfv_t2 = new Vec3();

/**
 * Set the quaternion value given two vectors. The resulting rotation will be the needed rotation to rotate u to v.
 * @method setFromVectors
 * @param {Vec3} u
 * @param {Vec3} v
 */
Quaternion.prototype.setFromVectors = function(u,v){
    if(u.isAntiparallelTo(v)){
        var t1 = sfv_t1;
        var t2 = sfv_t2;

        u.tangents(t1,t2);
        this.setFromAxisAngle(t1,Math.PI);
    } else {
        var a = u.cross(v);
        this.x = a.x;
        this.y = a.y;
        this.z = a.z;
        this.w = Math.sqrt(Math.pow(u.norm(),2) * Math.pow(v.norm(),2)) + u.dot(v);
        this.normalize();
    }
};

/**
 * Quaternion multiplication
 * @method mult
 * @param {Quaternion} q
 * @param {Quaternion} target Optional.
 * @return {Quaternion}
 */
var Quaternion_mult_va = new Vec3();
var Quaternion_mult_vb = new Vec3();
var Quaternion_mult_vaxvb = new Vec3();
Quaternion.prototype.mult = function(q,target){
    target = target || new Quaternion();
    var w = this.w,
        va = Quaternion_mult_va,
        vb = Quaternion_mult_vb,
        vaxvb = Quaternion_mult_vaxvb;

    va.set(this.x,this.y,this.z);
    vb.set(q.x,q.y,q.z);
    target.w = w*q.w - va.dot(vb);
    va.cross(vb,vaxvb);

    target.x = w * vb.x + q.w*va.x + vaxvb.x;
    target.y = w * vb.y + q.w*va.y + vaxvb.y;
    target.z = w * vb.z + q.w*va.z + vaxvb.z;

    return target;
};

/**
 * Get the inverse quaternion rotation.
 * @method inverse
 * @param {Quaternion} target
 * @return {Quaternion}
 */
Quaternion.prototype.inverse = function(target){
    var x = this.x, y = this.y, z = this.z, w = this.w;
    target = target || new Quaternion();

    this.conjugate(target);
    var inorm2 = 1/(x*x + y*y + z*z + w*w);
    target.x *= inorm2;
    target.y *= inorm2;
    target.z *= inorm2;
    target.w *= inorm2;

    return target;
};

/**
 * Get the quaternion conjugate
 * @method conjugate
 * @param {Quaternion} target
 * @return {Quaternion}
 */
Quaternion.prototype.conjugate = function(target){
    target = target || new Quaternion();

    target.x = -this.x;
    target.y = -this.y;
    target.z = -this.z;
    target.w = this.w;

    return target;
};

/**
 * Normalize the quaternion. Note that this changes the values of the quaternion.
 * @method normalize
 */
Quaternion.prototype.normalize = function(){
    var l = Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w);
    if ( l === 0 ) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.w = 0;
    } else {
        l = 1 / l;
        this.x *= l;
        this.y *= l;
        this.z *= l;
        this.w *= l;
    }
};

/**
 * Approximation of quaternion normalization. Works best when quat is already almost-normalized.
 * @method normalizeFast
 * @see http://jsperf.com/fast-quaternion-normalization
 * @author unphased, https://github.com/unphased
 */
Quaternion.prototype.normalizeFast = function () {
    var f = (3.0-(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w))/2.0;
    if ( f === 0 ) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.w = 0;
    } else {
        this.x *= f;
        this.y *= f;
        this.z *= f;
        this.w *= f;
    }
};

/**
 * Multiply the quaternion by a vector
 * @method vmult
 * @param {Vec3} v
 * @param {Vec3} target Optional
 * @return {Vec3}
 */
Quaternion.prototype.vmult = function(v,target){
    target = target || new Vec3();

    var x = v.x,
        y = v.y,
        z = v.z;

    var qx = this.x,
        qy = this.y,
        qz = this.z,
        qw = this.w;

    // q*v
    var ix =  qw * x + qy * z - qz * y,
    iy =  qw * y + qz * x - qx * z,
    iz =  qw * z + qx * y - qy * x,
    iw = -qx * x - qy * y - qz * z;

    target.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    target.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    target.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

    return target;
};

/**
 * Copies value of source to this quaternion.
 * @method copy
 * @param {Quaternion} source
 * @return {Quaternion} this
 */
Quaternion.prototype.copy = function(source){
    this.x = source.x;
    this.y = source.y;
    this.z = source.z;
    this.w = source.w;
    return this;
};

/**
 * Convert the quaternion to euler angle representation. Order: YZX, as this page describes: http://www.euclideanspace.com/maths/standards/index.htm
 * @method toEuler
 * @param {Vec3} target
 * @param string order Three-character string e.g. "YZX", which also is default.
 */
Quaternion.prototype.toEuler = function(target,order){
    order = order || "YZX";

    var heading, attitude, bank;
    var x = this.x, y = this.y, z = this.z, w = this.w;

    switch(order){
    case "YZX":
        var test = x*y + z*w;
        if (test > 0.499) { // singularity at north pole
            heading = 2 * Math.atan2(x,w);
            attitude = Math.PI/2;
            bank = 0;
        }
        if (test < -0.499) { // singularity at south pole
            heading = -2 * Math.atan2(x,w);
            attitude = - Math.PI/2;
            bank = 0;
        }
        if(isNaN(heading)){
            var sqx = x*x;
            var sqy = y*y;
            var sqz = z*z;
            heading = Math.atan2(2*y*w - 2*x*z , 1 - 2*sqy - 2*sqz); // Heading
            attitude = Math.asin(2*test); // attitude
            bank = Math.atan2(2*x*w - 2*y*z , 1 - 2*sqx - 2*sqz); // bank
        }
        break;
    default:
        throw new Error("Euler order "+order+" not supported yet.");
    }

    target.y = heading;
    target.z = attitude;
    target.x = bank;
};

/**
 * See http://www.mathworks.com/matlabcentral/fileexchange/20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/content/SpinCalc.m
 * @method setFromEuler
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @param {String} order The order to apply angles: 'XYZ' or 'YXZ' or any other combination
 */
Quaternion.prototype.setFromEuler = function ( x, y, z, order ) {
    order = order || "XYZ";

    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );

    if ( order === 'XYZ' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'YXZ' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if ( order === 'ZXY' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'ZYX' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if ( order === 'YZX' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'XZY' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    }

    return this;

};

Quaternion.prototype.clone = function(){
    return new Quaternion(this.x, this.y, this.z, this.w);
};
},{"./Vec3":30}],29:[function(_dereq_,module,exports){
var Vec3 = _dereq_('./Vec3');
var Quaternion = _dereq_('./Quaternion');

module.exports = Transform;

/**
 * @class Transform
 * @constructor
 */
function Transform(options) {
    options = options || {};

	/**
	 * @property {Vec3} position
	 */
	this.position = new Vec3();
    if(options.position){
        this.position.copy(options.position);
    }

	/**
	 * @property {Quaternion} quaternion
	 */
	this.quaternion = new Quaternion();
    if(options.quaternion){
        this.quaternion.copy(options.quaternion);
    }
}

var tmpQuat = new Quaternion();

/**
 * @static
 * @method pointToLocaFrame
 * @param {Vec3} position
 * @param {Quaternion} quaternion
 * @param {Vec3} worldPoint
 * @param {Vec3} result
 */
Transform.pointToLocalFrame = function(position, quaternion, worldPoint, result){
    var result = result || new Vec3();
    worldPoint.vsub(position, result);
    quaternion.conjugate(tmpQuat);
    tmpQuat.vmult(result, result);
    return result;
};

/**
 * Get a global point in local transform coordinates.
 * @method pointToLocal
 * @param  {Vec3} point
 * @param  {Vec3} result
 * @return {Vec3} The "result" vector object
 */
Transform.prototype.pointToLocal = function(worldPoint, result){
    return Transform.pointToLocalFrame(this.position, this.quaternion, worldPoint, result);
};

/**
 * @static
 * @method pointToWorldFrame
 * @param {Vec3} position
 * @param {Vec3} quaternion
 * @param {Vec3} localPoint
 * @param {Vec3} result
 */
Transform.pointToWorldFrame = function(position, quaternion, localPoint, result){
    var result = result || new Vec3();
    quaternion.vmult(localPoint, result);
    result.vadd(position, result);
    return result;
};

/**
 * Get a local point in global transform coordinates.
 * @method pointToWorld
 * @param  {Vec3} point
 * @param  {Vec3} result
 * @return {Vec3} The "result" vector object
 */
Transform.prototype.pointToWorld = function(localPoint, result){
    return Transform.pointToWorldFrame(this.position, this.quaternion, localPoint, result);
};


Transform.prototype.vectorToWorldFrame = function(localVector, result){
    var result = result || new Vec3();
    this.quaternion.vmult(localVector, result);
    return result;
};

Transform.vectorToWorldFrame = function(quaternion, localVector, result){
    quaternion.vmult(localVector, result);
    return result;
};

Transform.vectorToLocalFrame = function(position, quaternion, worldVector, result){
    var result = result || new Vec3();
    quaternion.w *= -1;
    quaternion.vmult(worldVector, result);
    quaternion.w *= -1;
    return result;
};

},{"./Quaternion":28,"./Vec3":30}],30:[function(_dereq_,module,exports){
module.exports = Vec3;

var Mat3 = _dereq_('./Mat3');

/**
 * 3-dimensional vector
 * @class Vec3
 * @constructor
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @author schteppe
 * @example
 *     var v = new Vec3(1, 2, 3);
 *     console.log('x=' + v.x); // x=1
 */
function Vec3(x,y,z){
    /**
     * @property x
     * @type {Number}
     */
    this.x = x||0.0;

    /**
     * @property y
     * @type {Number}
     */
    this.y = y||0.0;

    /**
     * @property z
     * @type {Number}
     */
    this.z = z||0.0;
}

/**
 * @static
 * @property {Vec3} ZERO
 */
Vec3.ZERO = new Vec3(0, 0, 0);

/**
 * @static
 * @property {Vec3} UNIT_X
 */
Vec3.UNIT_X = new Vec3(1, 0, 0);

/**
 * @static
 * @property {Vec3} UNIT_Y
 */
Vec3.UNIT_Y = new Vec3(0, 1, 0);

/**
 * @static
 * @property {Vec3} UNIT_Z
 */
Vec3.UNIT_Z = new Vec3(0, 0, 1);

/**
 * Vector cross product
 * @method cross
 * @param {Vec3} v
 * @param {Vec3} target Optional. Target to save in.
 * @return {Vec3}
 */
Vec3.prototype.cross = function(v,target){
    var vx=v.x, vy=v.y, vz=v.z, x=this.x, y=this.y, z=this.z;
    target = target || new Vec3();

    target.x = (y * vz) - (z * vy);
    target.y = (z * vx) - (x * vz);
    target.z = (x * vy) - (y * vx);

    return target;
};

/**
 * Set the vectors' 3 elements
 * @method set
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @return Vec3
 */
Vec3.prototype.set = function(x,y,z){
    this.x = x;
    this.y = y;
    this.z = z;
    return this;
};

/**
 * Set all components of the vector to zero.
 * @method setZero
 */
Vec3.prototype.setZero = function(){
    this.x = this.y = this.z = 0;
};

/**
 * Vector addition
 * @method vadd
 * @param {Vec3} v
 * @param {Vec3} target Optional.
 * @return {Vec3}
 */
Vec3.prototype.vadd = function(v,target){
    if(target){
        target.x = v.x + this.x;
        target.y = v.y + this.y;
        target.z = v.z + this.z;
    } else {
        return new Vec3(this.x + v.x,
                               this.y + v.y,
                               this.z + v.z);
    }
};

/**
 * Vector subtraction
 * @method vsub
 * @param {Vec3} v
 * @param {Vec3} target Optional. Target to save in.
 * @return {Vec3}
 */
Vec3.prototype.vsub = function(v,target){
    if(target){
        target.x = this.x - v.x;
        target.y = this.y - v.y;
        target.z = this.z - v.z;
    } else {
        return new Vec3(this.x-v.x,
                               this.y-v.y,
                               this.z-v.z);
    }
};

/**
 * Get the cross product matrix a_cross from a vector, such that a x b = a_cross * b = c
 * @method crossmat
 * @see http://www8.cs.umu.se/kurser/TDBD24/VT06/lectures/Lecture6.pdf
 * @return {Mat3}
 */
Vec3.prototype.crossmat = function(){
    return new Mat3([     0,  -this.z,   this.y,
                            this.z,        0,  -this.x,
                           -this.y,   this.x,        0]);
};

/**
 * Normalize the vector. Note that this changes the values in the vector.
 * @method normalize
 * @return {Number} Returns the norm of the vector
 */
Vec3.prototype.normalize = function(){
    var x=this.x, y=this.y, z=this.z;
    var n = Math.sqrt(x*x + y*y + z*z);
    if(n>0.0){
        var invN = 1/n;
        this.x *= invN;
        this.y *= invN;
        this.z *= invN;
    } else {
        // Make something up
        this.x = 0;
        this.y = 0;
        this.z = 0;
    }
    return n;
};

/**
 * Get the version of this vector that is of length 1.
 * @method unit
 * @param {Vec3} target Optional target to save in
 * @return {Vec3} Returns the unit vector
 */
Vec3.prototype.unit = function(target){
    target = target || new Vec3();
    var x=this.x, y=this.y, z=this.z;
    var ninv = Math.sqrt(x*x + y*y + z*z);
    if(ninv>0.0){
        ninv = 1.0/ninv;
        target.x = x * ninv;
        target.y = y * ninv;
        target.z = z * ninv;
    } else {
        target.x = 1;
        target.y = 0;
        target.z = 0;
    }
    return target;
};

/**
 * Get the length of the vector
 * @method norm
 * @return {Number}
 * @deprecated Use .length() instead
 */
Vec3.prototype.norm = function(){
    var x=this.x, y=this.y, z=this.z;
    return Math.sqrt(x*x + y*y + z*z);
};

/**
 * Get the length of the vector
 * @method length
 * @return {Number}
 */
Vec3.prototype.length = Vec3.prototype.norm;

/**
 * Get the squared length of the vector
 * @method norm2
 * @return {Number}
 * @deprecated Use .lengthSquared() instead.
 */
Vec3.prototype.norm2 = function(){
    return this.dot(this);
};

/**
 * Get the squared length of the vector.
 * @method lengthSquared
 * @return {Number}
 */
Vec3.prototype.lengthSquared = Vec3.prototype.norm2;

/**
 * Get distance from this point to another point
 * @method distanceTo
 * @param  {Vec3} p
 * @return {Number}
 */
Vec3.prototype.distanceTo = function(p){
    var x=this.x, y=this.y, z=this.z;
    var px=p.x, py=p.y, pz=p.z;
    return Math.sqrt((px-x)*(px-x)+
                     (py-y)*(py-y)+
                     (pz-z)*(pz-z));
};

/**
 * Get squared distance from this point to another point
 * @method distanceSquared
 * @param  {Vec3} p
 * @return {Number}
 */
Vec3.prototype.distanceSquared = function(p){
    var x=this.x, y=this.y, z=this.z;
    var px=p.x, py=p.y, pz=p.z;
    return (px-x)*(px-x) + (py-y)*(py-y) + (pz-z)*(pz-z);
};

/**
 * Multiply all the components of the vector with a scalar.
 * @deprecated Use .scale instead
 * @method mult
 * @param {Number} scalar
 * @param {Vec3} target The vector to save the result in.
 * @return {Vec3}
 * @deprecated Use .scale() instead
 */
Vec3.prototype.mult = function(scalar,target){
    target = target || new Vec3();
    var x = this.x,
        y = this.y,
        z = this.z;
    target.x = scalar * x;
    target.y = scalar * y;
    target.z = scalar * z;
    return target;
};

/**
 * Multiply the vector with a scalar.
 * @method scale
 * @param {Number} scalar
 * @param {Vec3} target
 * @return {Vec3}
 */
Vec3.prototype.scale = Vec3.prototype.mult;

/**
 * Calculate dot product
 * @method dot
 * @param {Vec3} v
 * @return {Number}
 */
Vec3.prototype.dot = function(v){
    return this.x * v.x + this.y * v.y + this.z * v.z;
};

/**
 * @method isZero
 * @return bool
 */
Vec3.prototype.isZero = function(){
    return this.x===0 && this.y===0 && this.z===0;
};

/**
 * Make the vector point in the opposite direction.
 * @method negate
 * @param {Vec3} target Optional target to save in
 * @return {Vec3}
 */
Vec3.prototype.negate = function(target){
    target = target || new Vec3();
    target.x = -this.x;
    target.y = -this.y;
    target.z = -this.z;
    return target;
};

/**
 * Compute two artificial tangents to the vector
 * @method tangents
 * @param {Vec3} t1 Vector object to save the first tangent in
 * @param {Vec3} t2 Vector object to save the second tangent in
 */
var Vec3_tangents_n = new Vec3();
var Vec3_tangents_randVec = new Vec3();
Vec3.prototype.tangents = function(t1,t2){
    var norm = this.norm();
    if(norm>0.0){
        var n = Vec3_tangents_n;
        var inorm = 1/norm;
        n.set(this.x*inorm,this.y*inorm,this.z*inorm);
        var randVec = Vec3_tangents_randVec;
        if(Math.abs(n.x) < 0.9){
            randVec.set(1,0,0);
            n.cross(randVec,t1);
        } else {
            randVec.set(0,1,0);
            n.cross(randVec,t1);
        }
        n.cross(t1,t2);
    } else {
        // The normal length is zero, make something up
        t1.set(1, 0, 0);
        t2.set(0, 1, 0);
    }
};

/**
 * Converts to a more readable format
 * @method toString
 * @return string
 */
Vec3.prototype.toString = function(){
    return this.x+","+this.y+","+this.z;
};

/**
 * Converts to an array
 * @method toArray
 * @return Array
 */
Vec3.prototype.toArray = function(){
    return [this.x, this.y, this.z];
};

/**
 * Copies value of source to this vector.
 * @method copy
 * @param {Vec3} source
 * @return {Vec3} this
 */
Vec3.prototype.copy = function(source){
    this.x = source.x;
    this.y = source.y;
    this.z = source.z;
    return this;
};


/**
 * Do a linear interpolation between two vectors
 * @method lerp
 * @param {Vec3} v
 * @param {Number} t A number between 0 and 1. 0 will make this function return u, and 1 will make it return v. Numbers in between will generate a vector in between them.
 * @param {Vec3} target
 */
Vec3.prototype.lerp = function(v,t,target){
    var x=this.x, y=this.y, z=this.z;
    target.x = x + (v.x-x)*t;
    target.y = y + (v.y-y)*t;
    target.z = z + (v.z-z)*t;
};

/**
 * Check if a vector equals is almost equal to another one.
 * @method almostEquals
 * @param {Vec3} v
 * @param {Number} precision
 * @return bool
 */
Vec3.prototype.almostEquals = function(v,precision){
    if(precision===undefined){
        precision = 1e-6;
    }
    if( Math.abs(this.x-v.x)>precision ||
        Math.abs(this.y-v.y)>precision ||
        Math.abs(this.z-v.z)>precision){
        return false;
    }
    return true;
};

/**
 * Check if a vector is almost zero
 * @method almostZero
 * @param {Number} precision
 */
Vec3.prototype.almostZero = function(precision){
    if(precision===undefined){
        precision = 1e-6;
    }
    if( Math.abs(this.x)>precision ||
        Math.abs(this.y)>precision ||
        Math.abs(this.z)>precision){
        return false;
    }
    return true;
};

var antip_neg = new Vec3();

/**
 * Check if the vector is anti-parallel to another vector.
 * @method isAntiparallelTo
 * @param  {Vec3}  v
 * @param  {Number}  precision Set to zero for exact comparisons
 * @return {Boolean}
 */
Vec3.prototype.isAntiparallelTo = function(v,precision){
    this.negate(antip_neg);
    return antip_neg.almostEquals(v,precision);
};

/**
 * Clone the vector
 * @method clone
 * @return {Vec3}
 */
Vec3.prototype.clone = function(){
    return new Vec3(this.x, this.y, this.z);
};
},{"./Mat3":27}],31:[function(_dereq_,module,exports){
module.exports = Body;

var EventTarget = _dereq_('../utils/EventTarget');
var Shape = _dereq_('../shapes/Shape');
var Vec3 = _dereq_('../math/Vec3');
var Mat3 = _dereq_('../math/Mat3');
var Quaternion = _dereq_('../math/Quaternion');
var Material = _dereq_('../material/Material');
var AABB = _dereq_('../collision/AABB');
var Box = _dereq_('../shapes/Box');

/**
 * Base class for all body types.
 * @class Body
 * @constructor
 * @extends EventTarget
 * @param {object} [options]
 * @param {Vec3} [options.position]
 * @param {Vec3} [options.velocity]
 * @param {Vec3} [options.angularVelocity]
 * @param {Quaternion} [options.quaternion]
 * @param {number} [options.mass]
 * @param {Material} [options.material]
 * @param {number} [options.type]
 * @param {number} [options.linearDamping=0.01]
 * @param {number} [options.angularDamping=0.01]
 * @param {boolean} [options.allowSleep=true]
 * @param {number} [options.sleepSpeedLimit=0.1]
 * @param {number} [options.sleepTimeLimit=1]
 * @param {number} [options.collisionFilterGroup=1]
 * @param {number} [options.collisionFilterMask=1]
 * @param {boolean} [options.fixedRotation=false]
 * @param {Body} [options.shape]
 * @example
 *     var body = new Body({
 *         mass: 1
 *     });
 *     var shape = new Sphere(1);
 *     body.addShape(shape);
 *     world.add(body);
 */
function Body(options){
    options = options || {};

    EventTarget.apply(this);

    this.id = Body.idCounter++;

    /**
     * Reference to the world the body is living in
     * @property world
     * @type {World}
     */
    this.world = null;

    /**
     * Callback function that is used BEFORE stepping the system. Use it to apply forces, for example. Inside the function, "this" will refer to this Body object.
     * @property preStep
     * @type {Function}
     * @deprecated Use World events instead
     */
    this.preStep = null;

    /**
     * Callback function that is used AFTER stepping the system. Inside the function, "this" will refer to this Body object.
     * @property postStep
     * @type {Function}
     * @deprecated Use World events instead
     */
    this.postStep = null;

    this.vlambda = new Vec3();

    /**
     * @property {Number} collisionFilterGroup
     */
    this.collisionFilterGroup = typeof(options.collisionFilterGroup) === 'number' ? options.collisionFilterGroup : 1;

    /**
     * @property {Number} collisionFilterMask
     */
    this.collisionFilterMask = typeof(options.collisionFilterMask) === 'number' ? options.collisionFilterMask : 1;

    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled.
     * @property {Number} collisionResponse
     */
	this.collisionResponse = true;

    /**
     * @property position
     * @type {Vec3}
     */
    this.position = new Vec3();

    if(options.position){
        this.position.copy(options.position);
    }

    /**
     * @property {Vec3} previousPosition
     */
    this.previousPosition = new Vec3();

    /**
     * Initial position of the body
     * @property initPosition
     * @type {Vec3}
     */
    this.initPosition = new Vec3();

    /**
     * @property velocity
     * @type {Vec3}
     */
    this.velocity = new Vec3();

    if(options.velocity){
        this.velocity.copy(options.velocity);
    }

    /**
     * @property initVelocity
     * @type {Vec3}
     */
    this.initVelocity = new Vec3();

    /**
     * Linear force on the body
     * @property force
     * @type {Vec3}
     */
    this.force = new Vec3();

    var mass = typeof(options.mass) === 'number' ? options.mass : 0;

    /**
     * @property mass
     * @type {Number}
     * @default 0
     */
    this.mass = mass;

    /**
     * @property invMass
     * @type {Number}
     */
    this.invMass = mass > 0 ? 1.0 / mass : 0;

    /**
     * @property material
     * @type {Material}
     */
    this.material = options.material || null;

    /**
     * @property linearDamping
     * @type {Number}
     */
    this.linearDamping = typeof(options.linearDamping) === 'number' ? options.linearDamping : 0.01;

    /**
     * One of: Body.DYNAMIC, Body.STATIC and Body.KINEMATIC.
     * @property type
     * @type {Number}
     */
    this.type = (mass <= 0.0 ? Body.STATIC : Body.DYNAMIC);
    if(typeof(options.type) === typeof(Body.STATIC)){
        this.type = options.type;
    }

    /**
     * If true, the body will automatically fall to sleep.
     * @property allowSleep
     * @type {Boolean}
     * @default true
     */
    this.allowSleep = typeof(options.allowSleep) !== 'undefined' ? options.allowSleep : true;

    /**
     * Current sleep state.
     * @property sleepState
     * @type {Number}
     */
    this.sleepState = 0;

    /**
     * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
     * @property sleepSpeedLimit
     * @type {Number}
     * @default 0.1
     */
    this.sleepSpeedLimit = typeof(options.sleepSpeedLimit) !== 'undefined' ? options.sleepSpeedLimit : 0.1;

    /**
     * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
     * @property sleepTimeLimit
     * @type {Number}
     * @default 1
     */
    this.sleepTimeLimit = typeof(options.sleepTimeLimit) !== 'undefined' ? options.sleepTimeLimit : 1;

    this.timeLastSleepy = 0;

    this._wakeUpAfterNarrowphase = false;


    /**
     * Rotational force on the body, around center of mass
     * @property {Vec3} torque
     */
    this.torque = new Vec3();

    /**
     * Orientation of the body
     * @property quaternion
     * @type {Quaternion}
     */
    this.quaternion = new Quaternion();

    if(options.quaternion){
        this.quaternion.copy(options.quaternion);
    }

    /**
     * @property initQuaternion
     * @type {Quaternion}
     */
    this.initQuaternion = new Quaternion();

    /**
     * @property angularVelocity
     * @type {Vec3}
     */
    this.angularVelocity = new Vec3();

    if(options.angularVelocity){
        this.angularVelocity.copy(options.angularVelocity);
    }

    /**
     * @property initAngularVelocity
     * @type {Vec3}
     */
    this.initAngularVelocity = new Vec3();

    this.interpolatedPosition = new Vec3();
    this.interpolatedQuaternion = new Quaternion();

    /**
     * @property shapes
     * @type {array}
     */
    this.shapes = [];

    /**
     * @property shapeOffsets
     * @type {array}
     */
    this.shapeOffsets = [];

    /**
     * @property shapeOrientations
     * @type {array}
     */
    this.shapeOrientations = [];

    /**
     * @property inertia
     * @type {Vec3}
     */
    this.inertia = new Vec3();

    /**
     * @property {Vec3} invInertia
     */
    this.invInertia = new Vec3();

    /**
     * @property {Mat3} invInertiaWorld
     */
    this.invInertiaWorld = new Mat3();

    this.invMassSolve = 0;

    /**
     * @property {Vec3} invInertiaSolve
     */
    this.invInertiaSolve = new Vec3();

    /**
     * @property {Mat3} invInertiaWorldSolve
     */
    this.invInertiaWorldSolve = new Mat3();

    /**
     * Set to true if you don't want the body to rotate. Make sure to run .updateMassProperties() after changing this.
     * @property {Boolean} fixedRotation
     * @default false
     */
    this.fixedRotation = typeof(options.fixedRotation) !== "undefined" ? options.fixedRotation : false;

    /**
     * @property {Number} angularDamping
     */
    this.angularDamping = typeof(options.angularDamping) !== 'undefined' ? options.angularDamping : 0.01;

    /**
     * @property aabb
     * @type {AABB}
     */
    this.aabb = new AABB();

    /**
     * Indicates if the AABB needs to be updated before use.
     * @property aabbNeedsUpdate
     * @type {Boolean}
     */
    this.aabbNeedsUpdate = true;

    this.wlambda = new Vec3();

    if(options.shape){
        this.addShape(options.shape);
    }

    this.updateMassProperties();
}
Body.prototype = new EventTarget();
Body.prototype.constructor = Body;

/**
 * A dynamic body is fully simulated. Can be moved manually by the user, but normally they move according to forces. A dynamic body can collide with all body types. A dynamic body always has finite, non-zero mass.
 * @static
 * @property DYNAMIC
 * @type {Number}
 */
Body.DYNAMIC = 1;

/**
 * A static body does not move during simulation and behaves as if it has infinite mass. Static bodies can be moved manually by setting the position of the body. The velocity of a static body is always zero. Static bodies do not collide with other static or kinematic bodies.
 * @static
 * @property STATIC
 * @type {Number}
 */
Body.STATIC = 2;

/**
 * A kinematic body moves under simulation according to its velocity. They do not respond to forces. They can be moved manually, but normally a kinematic body is moved by setting its velocity. A kinematic body behaves as if it has infinite mass. Kinematic bodies do not collide with other static or kinematic bodies.
 * @static
 * @property KINEMATIC
 * @type {Number}
 */
Body.KINEMATIC = 4;



/**
 * @static
 * @property AWAKE
 * @type {number}
 */
Body.AWAKE = 0;

/**
 * @static
 * @property SLEEPY
 * @type {number}
 */
Body.SLEEPY = 1;

/**
 * @static
 * @property SLEEPING
 * @type {number}
 */
Body.SLEEPING = 2;

Body.idCounter = 0;

/**
 * Wake the body up.
 * @method wakeUp
 */
Body.prototype.wakeUp = function(){
    var s = this.sleepState;
    this.sleepState = 0;
    if(s === Body.SLEEPING){
        this.dispatchEvent({type:"wakeup"});
    }
};

/**
 * Force body sleep
 * @method sleep
 */
Body.prototype.sleep = function(){
    this.sleepState = Body.SLEEPING;
    this.velocity.set(0,0,0);
    this.angularVelocity.set(0,0,0);
};

Body.sleepyEvent = {
    type: "sleepy"
};

Body.sleepEvent = {
    type: "sleep"
};

/**
 * Called every timestep to update internal sleep timer and change sleep state if needed.
 * @method sleepTick
 * @param {Number} time The world time in seconds
 */
Body.prototype.sleepTick = function(time){
    if(this.allowSleep){
        var sleepState = this.sleepState;
        var speedSquared = this.velocity.norm2() + this.angularVelocity.norm2();
        var speedLimitSquared = Math.pow(this.sleepSpeedLimit,2);
        if(sleepState===Body.AWAKE && speedSquared < speedLimitSquared){
            this.sleepState = Body.SLEEPY; // Sleepy
            this.timeLastSleepy = time;
            this.dispatchEvent(Body.sleepyEvent);
        } else if(sleepState===Body.SLEEPY && speedSquared > speedLimitSquared){
            this.wakeUp(); // Wake up
        } else if(sleepState===Body.SLEEPY && (time - this.timeLastSleepy ) > this.sleepTimeLimit){
            this.sleep(); // Sleeping
            this.dispatchEvent(Body.sleepEvent);
        }
    }
};

/**
 * If the body is sleeping, it should be immovable / have infinite mass during solve. We solve it by having a separate "solve mass".
 * @method updateSolveMassProperties
 */
Body.prototype.updateSolveMassProperties = function(){
    if(this.sleepState === Body.SLEEPING || this.type === Body.KINEMATIC){
        this.invMassSolve = 0;
        this.invInertiaSolve.setZero();
        this.invInertiaWorldSolve.setZero();
    } else {
        this.invMassSolve = this.invMass;
        this.invInertiaSolve.copy(this.invInertia);
        this.invInertiaWorldSolve.copy(this.invInertiaWorld);
    }
};

/**
 * Convert a world point to local body frame.
 * @method pointToLocalFrame
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.pointToLocalFrame = function(worldPoint,result){
    var result = result || new Vec3();
    worldPoint.vsub(this.position,result);
    this.quaternion.conjugate().vmult(result,result);
    return result;
};

/**
 * Convert a world vector to local body frame.
 * @method vectorToLocalFrame
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.vectorToLocalFrame = function(worldVector, result){
    var result = result || new Vec3();
    this.quaternion.conjugate().vmult(worldVector,result);
    return result;
};

/**
 * Convert a local body point to world frame.
 * @method pointToWorldFrame
 * @param  {Vec3} localPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.pointToWorldFrame = function(localPoint,result){
    var result = result || new Vec3();
    this.quaternion.vmult(localPoint,result);
    result.vadd(this.position,result);
    return result;
};

/**
 * Convert a local body point to world frame.
 * @method vectorToWorldFrame
 * @param  {Vec3} localVector
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.vectorToWorldFrame = function(localVector, result){
    var result = result || new Vec3();
    this.quaternion.vmult(localVector, result);
    return result;
};

var tmpVec = new Vec3();
var tmpQuat = new Quaternion();

/**
 * Add a shape to the body with a local offset and orientation.
 * @method addShape
 * @param {Shape} shape
 * @param {Vec3} offset
 * @param {Quaternion} quaternion
 * @return {Body} The body object, for chainability.
 */
Body.prototype.addShape = function(shape, _offset, _orientation){
    var offset = new Vec3();
    var orientation = new Quaternion();

    if(_offset){
        offset.copy(_offset);
    }
    if(_orientation){
        orientation.copy(_orientation);
    }

    this.shapes.push(shape);
    this.shapeOffsets.push(offset);
    this.shapeOrientations.push(orientation);
    this.updateMassProperties();
    this.updateBoundingRadius();

    this.aabbNeedsUpdate = true;

    return this;
};

/**
 * Update the bounding radius of the body. Should be done if any of the shapes are changed.
 * @method updateBoundingRadius
 */
Body.prototype.updateBoundingRadius = function(){
    var shapes = this.shapes,
        shapeOffsets = this.shapeOffsets,
        N = shapes.length,
        radius = 0;

    for(var i=0; i!==N; i++){
        var shape = shapes[i];
        shape.updateBoundingSphereRadius();
        var offset = shapeOffsets[i].norm(),
            r = shape.boundingSphereRadius;
        if(offset + r > radius){
            radius = offset + r;
        }
    }

    this.boundingRadius = radius;
};

var computeAABB_shapeAABB = new AABB();

/**
 * Updates the .aabb
 * @method computeAABB
 * @todo rename to updateAABB()
 */
Body.prototype.computeAABB = function(){
    var shapes = this.shapes,
        shapeOffsets = this.shapeOffsets,
        shapeOrientations = this.shapeOrientations,
        N = shapes.length,
        offset = tmpVec,
        orientation = tmpQuat,
        bodyQuat = this.quaternion,
        aabb = this.aabb,
        shapeAABB = computeAABB_shapeAABB;

    for(var i=0; i!==N; i++){
        var shape = shapes[i];

        // Get shape world quaternion
        shapeOrientations[i].mult(bodyQuat, orientation);

        // Get shape world position
        orientation.vmult(shapeOffsets[i], offset);
        offset.vadd(this.position, offset);

        // vec2.rotate(offset, shapeOffsets[i], bodyAngle);
        // vec2.add(offset, offset, this.position);

        // Get shape AABB
        shape.calculateWorldAABB(offset, orientation, shapeAABB.lowerBound, shapeAABB.upperBound);

        if(i === 0){
            aabb.copy(shapeAABB);
        } else {
            aabb.extend(shapeAABB);
        }
    }

    this.aabbNeedsUpdate = false;
};

var uiw_m1 = new Mat3(),
    uiw_m2 = new Mat3(),
    uiw_m3 = new Mat3();

/**
 * Update .inertiaWorld and .invInertiaWorld
 * @method updateInertiaWorld
 */
Body.prototype.updateInertiaWorld = function(force){
    var I = this.invInertia;
    if (I.x === I.y && I.y === I.z && !force) {
        // If inertia M = s*I, where I is identity and s a scalar, then
        //    R*M*R' = R*(s*I)*R' = s*R*I*R' = s*R*R' = s*I = M
        // where R is the rotation matrix.
        // In other words, we don't have to transform the inertia if all
        // inertia diagonal entries are equal.
    } else {
        var m1 = uiw_m1,
            m2 = uiw_m2,
            m3 = uiw_m3;
        m1.setRotationFromQuaternion(this.quaternion);
        m1.transpose(m2);
        m1.scale(I,m1);
        m1.mmult(m2,this.invInertiaWorld);
        //m3.getTrace(this.invInertiaWorld);
    }

    /*
    this.quaternion.vmult(this.inertia,this.inertiaWorld);
    this.quaternion.vmult(this.invInertia,this.invInertiaWorld);
    */
};

/**
 * Apply force to a world point. This could for example be a point on the Body surface. Applying force this way will add to Body.force and Body.torque.
 * @method applyForce
 * @param  {Vec3} force The amount of force to add.
 * @param  {Vec3} worldPoint A world point to apply the force on.
 */
var Body_applyForce_r = new Vec3();
var Body_applyForce_rotForce = new Vec3();
Body.prototype.applyForce = function(force,worldPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    // Compute point position relative to the body center
    var r = Body_applyForce_r;
    worldPoint.vsub(this.position,r);

    // Compute produced rotational force
    var rotForce = Body_applyForce_rotForce;
    r.cross(force,rotForce);

    // Add linear force
    this.force.vadd(force,this.force);

    // Add rotational force
    this.torque.vadd(rotForce,this.torque);
};

/**
 * Apply force to a local point in the body.
 * @method applyLocalForce
 * @param  {Vec3} force The force vector to apply, defined locally in the body frame.
 * @param  {Vec3} localPoint A local point in the body to apply the force on.
 */
var Body_applyLocalForce_worldForce = new Vec3();
var Body_applyLocalForce_worldPoint = new Vec3();
Body.prototype.applyLocalForce = function(localForce, localPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    var worldForce = Body_applyLocalForce_worldForce;
    var worldPoint = Body_applyLocalForce_worldPoint;

    // Transform the force vector to world space
    this.vectorToWorldFrame(localForce, worldForce);
    this.pointToWorldFrame(localPoint, worldPoint);

    this.applyForce(worldForce, worldPoint);
};

/**
 * Apply impulse to a world point. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulse
 * @param  {Vec3} impulse The amount of impulse to add.
 * @param  {Vec3} worldPoint A world point to apply the force on.
 */
var Body_applyImpulse_r = new Vec3();
var Body_applyImpulse_velo = new Vec3();
var Body_applyImpulse_rotVelo = new Vec3();
Body.prototype.applyImpulse = function(impulse, worldPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    // Compute point position relative to the body center
    var r = Body_applyImpulse_r;
    worldPoint.vsub(this.position,r);

    // Compute produced central impulse velocity
    var velo = Body_applyImpulse_velo;
    velo.copy(impulse);
    velo.mult(this.invMass,velo);

    // Add linear impulse
    this.velocity.vadd(velo, this.velocity);

    // Compute produced rotational impulse velocity
    var rotVelo = Body_applyImpulse_rotVelo;
    r.cross(impulse,rotVelo);

    /*
    rotVelo.x *= this.invInertia.x;
    rotVelo.y *= this.invInertia.y;
    rotVelo.z *= this.invInertia.z;
    */
    this.invInertiaWorld.vmult(rotVelo,rotVelo);

    // Add rotational Impulse
    this.angularVelocity.vadd(rotVelo, this.angularVelocity);
};

/**
 * Apply locally-defined impulse to a local point in the body.
 * @method applyLocalImpulse
 * @param  {Vec3} force The force vector to apply, defined locally in the body frame.
 * @param  {Vec3} localPoint A local point in the body to apply the force on.
 */
var Body_applyLocalImpulse_worldImpulse = new Vec3();
var Body_applyLocalImpulse_worldPoint = new Vec3();
Body.prototype.applyLocalImpulse = function(localImpulse, localPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    var worldImpulse = Body_applyLocalImpulse_worldImpulse;
    var worldPoint = Body_applyLocalImpulse_worldPoint;

    // Transform the force vector to world space
    this.vectorToWorldFrame(localImpulse, worldImpulse);
    this.pointToWorldFrame(localPoint, worldPoint);

    this.applyImpulse(worldImpulse, worldPoint);
};

var Body_updateMassProperties_halfExtents = new Vec3();

/**
 * Should be called whenever you change the body shape or mass.
 * @method updateMassProperties
 */
Body.prototype.updateMassProperties = function(){
    var halfExtents = Body_updateMassProperties_halfExtents;

    this.invMass = this.mass > 0 ? 1.0 / this.mass : 0;
    var I = this.inertia;
    var fixed = this.fixedRotation;

    // Approximate with AABB box
    this.computeAABB();
    halfExtents.set(
        (this.aabb.upperBound.x-this.aabb.lowerBound.x) / 2,
        (this.aabb.upperBound.y-this.aabb.lowerBound.y) / 2,
        (this.aabb.upperBound.z-this.aabb.lowerBound.z) / 2
    );
    Box.calculateInertia(halfExtents, this.mass, I);

    this.invInertia.set(
        I.x > 0 && !fixed ? 1.0 / I.x : 0,
        I.y > 0 && !fixed ? 1.0 / I.y : 0,
        I.z > 0 && !fixed ? 1.0 / I.z : 0
    );
    this.updateInertiaWorld(true);
};

/**
 * Get world velocity of a point in the body.
 * @method getVelocityAtWorldPoint
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3} The result vector.
 */
Body.prototype.getVelocityAtWorldPoint = function(worldPoint, result){
    var r = new Vec3();
    worldPoint.vsub(this.position, r);
    this.angularVelocity.cross(r, result);
    this.velocity.vadd(result, result);
    return result;
};

},{"../collision/AABB":3,"../material/Material":25,"../math/Mat3":27,"../math/Quaternion":28,"../math/Vec3":30,"../shapes/Box":37,"../shapes/Shape":43,"../utils/EventTarget":49}],32:[function(_dereq_,module,exports){
var Body = _dereq_('./Body');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var RaycastResult = _dereq_('../collision/RaycastResult');
var Ray = _dereq_('../collision/Ray');
var WheelInfo = _dereq_('../objects/WheelInfo');

module.exports = RaycastVehicle;

/**
 * Vehicle helper class that casts rays from the wheel positions towards the ground and applies forces.
 * @class RaycastVehicle
 * @constructor
 * @param {object} [options]
 * @param {Body} [options.chassisBody] The car chassis body.
 * @param {integer} [options.indexRightAxis] Axis to use for right. x=0, y=1, z=2
 * @param {integer} [options.indexLeftAxis]
 * @param {integer} [options.indexUpAxis]
 */
function RaycastVehicle(options){

    /**
     * @property {Body} chassisBody
     */
    this.chassisBody = options.chassisBody;

    /**
     * An array of WheelInfo objects.
     * @property {array} wheelInfos
     */
    this.wheelInfos = [];

    /**
     * Will be set to true if the car is sliding.
     * @property {boolean} sliding
     */
    this.sliding = false;

    /**
     * @property {World} world
     */
    this.world = null;

    /**
     * Index of the right axis, 0=x, 1=y, 2=z
     * @property {integer} indexRightAxis
     * @default 1
     */
    this.indexRightAxis = typeof(options.indexRightAxis) !== 'undefined' ? options.indexRightAxis : 1;

    /**
     * Index of the forward axis, 0=x, 1=y, 2=z
     * @property {integer} indexForwardAxis
     * @default 0
     */
    this.indexForwardAxis = typeof(options.indexForwardAxis) !== 'undefined' ? options.indexForwardAxis : 0;

    /**
     * Index of the up axis, 0=x, 1=y, 2=z
     * @property {integer} indexUpAxis
     * @default 2
     */
    this.indexUpAxis = typeof(options.indexUpAxis) !== 'undefined' ? options.indexUpAxis : 2;
}

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();
var tmpVec3 = new Vec3();
var tmpVec4 = new Vec3();
var tmpVec5 = new Vec3();
var tmpVec6 = new Vec3();
var tmpRay = new Ray();

/**
 * Add a wheel. For information about the options, see WheelInfo.
 * @method addWheel
 * @param {object} [options]
 */
RaycastVehicle.prototype.addWheel = function(options){
    options = options || {};

    var info = new WheelInfo(options);
    var index = this.wheelInfos.length;
    this.wheelInfos.push(info);

    return index;
};

/**
 * Set the steering value of a wheel.
 * @method setSteeringValue
 * @param {number} value
 * @param {integer} wheelIndex
 */
RaycastVehicle.prototype.setSteeringValue = function(value, wheelIndex){
    var wheel = this.wheelInfos[wheelIndex];
    wheel.steering = value;
};

var torque = new Vec3();

/**
 * Set the wheel force to apply on one of the wheels each time step
 * @method applyEngineForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RaycastVehicle.prototype.applyEngineForce = function(value, wheelIndex){
    this.wheelInfos[wheelIndex].engineForce = value;
};

/**
 * Set the braking force of a wheel
 * @method setBrake
 * @param {number} brake
 * @param {integer} wheelIndex
 */
RaycastVehicle.prototype.setBrake = function(brake, wheelIndex){
    this.wheelInfos[wheelIndex].brake = brake;
};

/**
 * Add the vehicle including its constraints to the world.
 * @method addToWorld
 * @param {World} world
 */
RaycastVehicle.prototype.addToWorld = function(world){
    var constraints = this.constraints;
    world.add(this.chassisBody);
    var that = this;
    this.preStepCallback = function(){
        that.updateVehicle(world.dt);
    };
    world.addEventListener('preStep', this.preStepCallback);
    this.world = world;
};

/**
 * Get one of the wheel axles, world-oriented.
 * @private
 * @method getVehicleAxisWorld
 * @param  {integer} axisIndex
 * @param  {Vec3} result
 */
RaycastVehicle.prototype.getVehicleAxisWorld = function(axisIndex, result){
    result.set(
        axisIndex === 0 ? 1 : 0,
        axisIndex === 1 ? 1 : 0,
        axisIndex === 2 ? 1 : 0
    );
    this.chassisBody.vectorToWorldFrame(result, result);
};

RaycastVehicle.prototype.updateVehicle = function(timeStep){
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;
    var chassisBody = this.chassisBody;

    for (var i = 0; i < numWheels; i++) {
        this.updateWheelTransform(i);
    }

    this.currentVehicleSpeedKmHour = 3.6 * chassisBody.velocity.norm();

    var forwardWorld = new Vec3();
    this.getVehicleAxisWorld(this.indexForwardAxis, forwardWorld);

    if (forwardWorld.dot(chassisBody.velocity) < 0){
        this.currentVehicleSpeedKmHour *= -1;
    }

    // simulate suspension
    for (var i = 0; i < numWheels; i++) {
        this.castRay(wheelInfos[i]);
    }

    this.updateSuspension(timeStep);

    var impulse = new Vec3();
    var relpos = new Vec3();
    for (var i = 0; i < numWheels; i++) {
        //apply suspension force
        var wheel = wheelInfos[i];
        var suspensionForce = wheel.suspensionForce;
        if (suspensionForce > wheel.maxSuspensionForce) {
            suspensionForce = wheel.maxSuspensionForce;
        }
        wheel.raycastResult.hitNormalWorld.scale(suspensionForce * timeStep, impulse);

        wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, relpos);
        chassisBody.applyImpulse(impulse, wheel.raycastResult.hitPointWorld/*relpos*/);
    }

    this.updateFriction(timeStep);

    var hitNormalWorldScaledWithProj = new Vec3();
    var fwd  = new Vec3();
    var vel = new Vec3();
    for (i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];
        //var relpos = new Vec3();
        //wheel.chassisConnectionPointWorld.vsub(chassisBody.position, relpos);
        chassisBody.getVelocityAtWorldPoint(wheel.chassisConnectionPointWorld, vel);

        // Hack to get the rotation in the correct direction
        var m = 1;
        switch(this.indexUpAxis){
        case 1:
            m = -1;
            break;
        }

        if (wheel.isInContact) {

            this.getVehicleAxisWorld(this.indexForwardAxis, fwd);
            var proj = fwd.dot(wheel.raycastResult.hitNormalWorld);
            wheel.raycastResult.hitNormalWorld.scale(proj, hitNormalWorldScaledWithProj);

            fwd.vsub(hitNormalWorldScaledWithProj, fwd);

            var proj2 = fwd.dot(vel);
            wheel.deltaRotation = m * proj2 * timeStep / wheel.radius;
        }

        if((wheel.sliding || !wheel.isInContact) && wheel.engineForce !== 0 && wheel.useCustomSlidingRotationalSpeed){
            // Apply custom rotation when accelerating and sliding
            wheel.deltaRotation = (wheel.engineForce > 0 ? 1 : -1) * wheel.customSlidingRotationalSpeed * timeStep;
        }

        // Lock wheels
        if(Math.abs(wheel.brake) > Math.abs(wheel.engineForce)){
            wheel.deltaRotation = 0;
        }

        wheel.rotation += wheel.deltaRotation; // Use the old value
        wheel.deltaRotation *= 0.99; // damping of rotation when not in contact
    }
};

RaycastVehicle.prototype.updateSuspension = function(deltaTime) {
    var chassisBody = this.chassisBody;
    var chassisMass = chassisBody.mass;
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;

    for (var w_it = 0; w_it < numWheels; w_it++){
        var wheel = wheelInfos[w_it];

        if (wheel.isInContact){
            var force;

            // Spring
            var susp_length = wheel.suspensionRestLength;
            var current_length = wheel.suspensionLength;
            var length_diff = (susp_length - current_length);

            force = wheel.suspensionStiffness * length_diff * wheel.clippedInvContactDotSuspension;

            // Damper
            var projected_rel_vel = wheel.suspensionRelativeVelocity;
            var susp_damping;
            if (projected_rel_vel < 0) {
                susp_damping = wheel.dampingCompression;
            } else {
                susp_damping = wheel.dampingRelaxation;
            }
            force -= susp_damping * projected_rel_vel;

            wheel.suspensionForce = force * chassisMass;
            if (wheel.suspensionForce < 0) {
                wheel.suspensionForce = 0;
            }
        } else {
            wheel.suspensionForce = 0;
        }
    }
};

/**
 * Remove the vehicle including its constraints from the world.
 * @method removeFromWorld
 * @param {World} world
 */
RaycastVehicle.prototype.removeFromWorld = function(world){
    var constraints = this.constraints;
    world.remove(this.chassisBody);
    world.removeEventListener('preStep', this.preStepCallback);
    this.world = null;
};

var castRay_rayvector = new Vec3();
var castRay_target = new Vec3();
RaycastVehicle.prototype.castRay = function(wheel) {
    var rayvector = castRay_rayvector;
    var target = castRay_target;

    this.updateWheelTransformWorld(wheel);
    var chassisBody = this.chassisBody;

    var depth = -1;

    var raylen = wheel.suspensionRestLength + wheel.radius;

    wheel.directionWorld.scale(raylen, rayvector);
    var source = wheel.chassisConnectionPointWorld;
    source.vadd(rayvector, target);
    var raycastResult = wheel.raycastResult;

    var param = 0;

    raycastResult.reset();
    // Turn off ray collision with the chassis temporarily
    var oldState = chassisBody.collisionResponse;
    chassisBody.collisionResponse = false;

    // Cast ray against world
    this.world.rayTest(source, target, raycastResult);
    chassisBody.collisionResponse = oldState;

    var object = raycastResult.body;

    wheel.raycastResult.groundObject = 0;

    if (object) {
        depth = raycastResult.distance;
        wheel.raycastResult.hitNormalWorld  = raycastResult.hitNormalWorld;
        wheel.isInContact = true;

        var hitDistance = raycastResult.distance;
        wheel.suspensionLength = hitDistance - wheel.radius;

        // clamp on max suspension travel
        var minSuspensionLength = wheel.suspensionRestLength - wheel.maxSuspensionTravel;
        var maxSuspensionLength = wheel.suspensionRestLength + wheel.maxSuspensionTravel;
        if (wheel.suspensionLength < minSuspensionLength) {
            wheel.suspensionLength = minSuspensionLength;
        }
        if (wheel.suspensionLength > maxSuspensionLength) {
            wheel.suspensionLength = maxSuspensionLength;
            wheel.raycastResult.reset();
        }

        var denominator = wheel.raycastResult.hitNormalWorld.dot(wheel.directionWorld);

        var chassis_velocity_at_contactPoint = new Vec3();
        chassisBody.getVelocityAtWorldPoint(wheel.raycastResult.hitPointWorld, chassis_velocity_at_contactPoint);

        var projVel = wheel.raycastResult.hitNormalWorld.dot( chassis_velocity_at_contactPoint );

        if (denominator >= -0.1) {
            wheel.suspensionRelativeVelocity = 0;
            wheel.clippedInvContactDotSuspension = 1 / 0.1;
        } else {
            var inv = -1 / denominator;
            wheel.suspensionRelativeVelocity = projVel * inv;
            wheel.clippedInvContactDotSuspension = inv;
        }

    } else {

        //put wheel info as in rest position
        wheel.suspensionLength = wheel.suspensionRestLength + 0 * wheel.maxSuspensionTravel;
        wheel.suspensionRelativeVelocity = 0.0;
        wheel.directionWorld.scale(-1, wheel.raycastResult.hitNormalWorld);
        wheel.clippedInvContactDotSuspension = 1.0;
    }

    return depth;
};

RaycastVehicle.prototype.updateWheelTransformWorld = function(wheel){
    wheel.isInContact = false;
    var chassisBody = this.chassisBody;
    chassisBody.pointToWorldFrame(wheel.chassisConnectionPointLocal, wheel.chassisConnectionPointWorld);
    chassisBody.vectorToWorldFrame(wheel.directionLocal, wheel.directionWorld);
    chassisBody.vectorToWorldFrame(wheel.axleLocal, wheel.axleWorld);
};


/**
 * Update one of the wheel transform.
 * Note when rendering wheels: during each step, wheel transforms are updated BEFORE the chassis; ie. their position becomes invalid after the step. Thus when you render wheels, you must update wheel transforms before rendering them. See raycastVehicle demo for an example.
 * @method updateWheelTransform
 * @param {integer} wheelIndex The wheel index to update.
 */
RaycastVehicle.prototype.updateWheelTransform = function(wheelIndex){
    var up = tmpVec4;
    var right = tmpVec5;
    var fwd = tmpVec6;

    var wheel = this.wheelInfos[wheelIndex];
    this.updateWheelTransformWorld(wheel);

    wheel.directionLocal.scale(-1, up);
    right.copy(wheel.axleLocal);
    up.cross(right, fwd);
    fwd.normalize();
    right.normalize();

    // Rotate around steering over the wheelAxle
    var steering = wheel.steering;
    var steeringOrn = new Quaternion();
    steeringOrn.setFromAxisAngle(up, steering);

    var rotatingOrn = new Quaternion();
    rotatingOrn.setFromAxisAngle(right, wheel.rotation);

    // World rotation of the wheel
    var q = wheel.worldTransform.quaternion;
    this.chassisBody.quaternion.mult(steeringOrn, q);
    q.mult(rotatingOrn, q);

    q.normalize();

    // world position of the wheel
    var p = wheel.worldTransform.position;
    p.copy(wheel.directionWorld);
    p.scale(wheel.suspensionLength, p);
    p.vadd(wheel.chassisConnectionPointWorld, p);
};

var directions = [
    new Vec3(1, 0, 0),
    new Vec3(0, 1, 0),
    new Vec3(0, 0, 1)
];

/**
 * Get the world transform of one of the wheels
 * @method getWheelTransformWorld
 * @param  {integer} wheelIndex
 * @return {Transform}
 */
RaycastVehicle.prototype.getWheelTransformWorld = function(wheelIndex) {
    return this.wheelInfos[wheelIndex].worldTransform;
};


var updateFriction_surfNormalWS_scaled_proj = new Vec3();
var updateFriction_axle = [];
var updateFriction_forwardWS = [];
var sideFrictionStiffness2 = 1;
RaycastVehicle.prototype.updateFriction = function(timeStep) {
    var surfNormalWS_scaled_proj = updateFriction_surfNormalWS_scaled_proj;

    //calculate the impulse, so that the wheels don't move sidewards
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;
    var chassisBody = this.chassisBody;
    var forwardWS = updateFriction_forwardWS;
    var axle = updateFriction_axle;

    var numWheelsOnGround = 0;

    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];

        var groundObject = wheel.raycastResult.body;
        if (groundObject){
            numWheelsOnGround++;
        }

        wheel.sideImpulse = 0;
        wheel.forwardImpulse = 0;
        if(!forwardWS[i]){
            forwardWS[i] = new Vec3();
        }
        if(!axle[i]){
            axle[i] = new Vec3();
        }
    }

    for (var i = 0; i < numWheels; i++){
        var wheel = wheelInfos[i];

        var groundObject = wheel.raycastResult.body;

        if (groundObject) {
            var axlei = axle[i];
            var wheelTrans = this.getWheelTransformWorld(i);

            // Get world axle
            wheelTrans.vectorToWorldFrame(directions[this.indexRightAxis], axlei);

            var surfNormalWS = wheel.raycastResult.hitNormalWorld;
            var proj = axlei.dot(surfNormalWS);
            surfNormalWS.scale(proj, surfNormalWS_scaled_proj);
            axlei.vsub(surfNormalWS_scaled_proj, axlei);
            axlei.normalize();

            surfNormalWS.cross(axlei, forwardWS[i]);
            forwardWS[i].normalize();

            wheel.sideImpulse = resolveSingleBilateral(
                chassisBody,
                wheel.raycastResult.hitPointWorld,
                groundObject,
                wheel.raycastResult.hitPointWorld,
                axlei
            );

            wheel.sideImpulse *= sideFrictionStiffness2;
        }
    }

    var sideFactor = 1;
    var fwdFactor = 0.5;

    this.sliding = false;
    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];
        var groundObject = wheel.raycastResult.body;

        var rollingFriction = 0;

        wheel.slipInfo = 1;
        if (groundObject) {
            var defaultRollingFrictionImpulse = 0;
            var maxImpulse = wheel.brake ? wheel.brake : defaultRollingFrictionImpulse;

            // btWheelContactPoint contactPt(chassisBody,groundObject,wheelInfraycastInfo.hitPointWorld,forwardWS[wheel],maxImpulse);
            // rollingFriction = calcRollingFriction(contactPt);
            rollingFriction = calcRollingFriction(chassisBody, groundObject, wheel.raycastResult.hitPointWorld, forwardWS[i], maxImpulse);

            rollingFriction += wheel.engineForce * timeStep;

            // rollingFriction = 0;
            var factor = maxImpulse / rollingFriction;
            wheel.slipInfo *= factor;
        }

        //switch between active rolling (throttle), braking and non-active rolling friction (nthrottle/break)

        wheel.forwardImpulse = 0;
        wheel.skidInfo = 1;

        if (groundObject) {
            wheel.skidInfo = 1;

            var maximp = wheel.suspensionForce * timeStep * wheel.frictionSlip;
            var maximpSide = maximp;

            var maximpSquared = maximp * maximpSide;

            wheel.forwardImpulse = rollingFriction;//wheelInfo.engineForce* timeStep;

            var x = wheel.forwardImpulse * fwdFactor;
            var y = wheel.sideImpulse * sideFactor;

            var impulseSquared = x * x + y * y;

            wheel.sliding = false;
            if (impulseSquared > maximpSquared) {
                this.sliding = true;
                wheel.sliding = true;

                var factor = maximp / Math.sqrt(impulseSquared);

                wheel.skidInfo *= factor;
            }
        }
    }

    if (this.sliding) {
        for (var i = 0; i < numWheels; i++) {
            var wheel = wheelInfos[i];
            if (wheel.sideImpulse !== 0) {
                if (wheel.skidInfo < 1){
                    wheel.forwardImpulse *= wheel.skidInfo;
                    wheel.sideImpulse *= wheel.skidInfo;
                }
            }
        }
    }

    // apply the impulses
    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];

        var rel_pos = new Vec3();
        //wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, rel_pos);
        // cannons applyimpulse is using world coord for the position
        rel_pos.copy(wheel.raycastResult.hitPointWorld);

        if (wheel.forwardImpulse !== 0) {
            var impulse = new Vec3();
            forwardWS[i].scale(wheel.forwardImpulse, impulse);
            chassisBody.applyImpulse(impulse, rel_pos);
        }

        if (wheel.sideImpulse !== 0){
            var groundObject = wheel.raycastResult.body;

            var rel_pos2 = new Vec3();
            //wheel.raycastResult.hitPointWorld.vsub(groundObject.position, rel_pos2);
            rel_pos2.copy(wheel.raycastResult.hitPointWorld);
            var sideImp = new Vec3();
            axle[i].scale(wheel.sideImpulse, sideImp);

            // Scale the relative position in the up direction with rollInfluence.
            // If rollInfluence is 1, the impulse will be applied on the hitPoint (easy to roll over), if it is zero it will be applied in the same plane as the center of mass (not easy to roll over).
            chassisBody.pointToLocalFrame(rel_pos, rel_pos);
            rel_pos['xyz'[this.indexUpAxis]] *= wheel.rollInfluence;
            chassisBody.pointToWorldFrame(rel_pos, rel_pos);
            chassisBody.applyImpulse(sideImp, rel_pos);

            //apply friction impulse on the ground
            sideImp.scale(-1, sideImp);
            groundObject.applyImpulse(sideImp, rel_pos2);
        }
    }
};

var calcRollingFriction_vel1 = new Vec3();
var calcRollingFriction_vel2 = new Vec3();
var calcRollingFriction_vel = new Vec3();

function calcRollingFriction(body0, body1, frictionPosWorld, frictionDirectionWorld, maxImpulse) {
    var j1 = 0;
    var contactPosWorld = frictionPosWorld;

    // var rel_pos1 = new Vec3();
    // var rel_pos2 = new Vec3();
    var vel1 = calcRollingFriction_vel1;
    var vel2 = calcRollingFriction_vel2;
    var vel = calcRollingFriction_vel;
    // contactPosWorld.vsub(body0.position, rel_pos1);
    // contactPosWorld.vsub(body1.position, rel_pos2);

    body0.getVelocityAtWorldPoint(contactPosWorld, vel1);
    body1.getVelocityAtWorldPoint(contactPosWorld, vel2);
    vel1.vsub(vel2, vel);

    var vrel = frictionDirectionWorld.dot(vel);

    var denom0 = computeImpulseDenominator(body0, frictionPosWorld, frictionDirectionWorld);
    var denom1 = computeImpulseDenominator(body1, frictionPosWorld, frictionDirectionWorld);
    var relaxation = 1;
    var jacDiagABInv = relaxation / (denom0 + denom1);

    // calculate j that moves us to zero relative velocity
    j1 = -vrel * jacDiagABInv;

    if (maxImpulse < j1) {
        j1 = maxImpulse;
    }
    if (j1 < -maxImpulse) {
        j1 = -maxImpulse;
    }

    return j1;
}

var computeImpulseDenominator_r0 = new Vec3();
var computeImpulseDenominator_c0 = new Vec3();
var computeImpulseDenominator_vec = new Vec3();
var computeImpulseDenominator_m = new Vec3();
function computeImpulseDenominator(body, pos, normal) {
    var r0 = computeImpulseDenominator_r0;
    var c0 = computeImpulseDenominator_c0;
    var vec = computeImpulseDenominator_vec;
    var m = computeImpulseDenominator_m;

    pos.vsub(body.position, r0);
    r0.cross(normal, c0);
    body.invInertiaWorld.vmult(c0, m);
    m.cross(r0, vec);

    return body.invMass + normal.dot(vec);
}


var resolveSingleBilateral_vel1 = new Vec3();
var resolveSingleBilateral_vel2 = new Vec3();
var resolveSingleBilateral_vel = new Vec3();

//bilateral constraint between two dynamic objects
function resolveSingleBilateral(body1, pos1, body2, pos2, normal, impulse){
    var normalLenSqr = normal.norm2();
    if (normalLenSqr > 1.1){
        return 0; // no impulse
    }
    // var rel_pos1 = new Vec3();
    // var rel_pos2 = new Vec3();
    // pos1.vsub(body1.position, rel_pos1);
    // pos2.vsub(body2.position, rel_pos2);

    var vel1 = resolveSingleBilateral_vel1;
    var vel2 = resolveSingleBilateral_vel2;
    var vel = resolveSingleBilateral_vel;
    body1.getVelocityAtWorldPoint(pos1, vel1);
    body2.getVelocityAtWorldPoint(pos2, vel2);

    vel1.vsub(vel2, vel);

    var rel_vel = normal.dot(vel);

    var contactDamping = 0.2;
    var massTerm = 1 / (body1.invMass + body2.invMass);
    var impulse = - contactDamping * rel_vel * massTerm;

    return impulse;
}
},{"../collision/Ray":9,"../collision/RaycastResult":10,"../math/Quaternion":28,"../math/Vec3":30,"../objects/WheelInfo":36,"./Body":31}],33:[function(_dereq_,module,exports){
var Body = _dereq_('./Body');
var Sphere = _dereq_('../shapes/Sphere');
var Box = _dereq_('../shapes/Box');
var Vec3 = _dereq_('../math/Vec3');
var HingeConstraint = _dereq_('../constraints/HingeConstraint');

module.exports = RigidVehicle;

/**
 * Simple vehicle helper class with spherical rigid body wheels.
 * @class RigidVehicle
 * @constructor
 * @param {Body} [options.chassisBody]
 */
function RigidVehicle(options){
    this.wheelBodies = [];

    /**
     * @property coordinateSystem
     * @type {Vec3}
     */
    this.coordinateSystem = typeof(options.coordinateSystem)==='undefined' ? new Vec3(1, 2, 3) : options.coordinateSystem.clone();

    /**
     * @property {Body} chassisBody
     */
    this.chassisBody = options.chassisBody;

    if(!this.chassisBody){
        // No chassis body given. Create it!
        var chassisShape = new Box(new Vec3(5, 2, 0.5));
        this.chassisBody = new Body(1, chassisShape);
    }

    /**
     * @property constraints
     * @type {Array}
     */
    this.constraints = [];

    this.wheelAxes = [];
    this.wheelForces = [];
}

/**
 * Add a wheel
 * @method addWheel
 * @param {object} options
 * @param {boolean} [options.isFrontWheel]
 * @param {Vec3} [options.position] Position of the wheel, locally in the chassis body.
 * @param {Vec3} [options.direction] Slide direction of the wheel along the suspension.
 * @param {Vec3} [options.axis] Axis of rotation of the wheel, locally defined in the chassis.
 * @param {Body} [options.body] The wheel body.
 */
RigidVehicle.prototype.addWheel = function(options){
    options = options || {};
    var wheelBody = options.body;
    if(!wheelBody){
        wheelBody =  new Body(1, new Sphere(1.2));
    }
    this.wheelBodies.push(wheelBody);
    this.wheelForces.push(0);

    // Position constrain wheels
    var zero = new Vec3();
    var position = typeof(options.position) !== 'undefined' ? options.position.clone() : new Vec3();

    // Set position locally to the chassis
    var worldPosition = new Vec3();
    this.chassisBody.pointToWorldFrame(position, worldPosition);
    wheelBody.position.set(worldPosition.x, worldPosition.y, worldPosition.z);

    // Constrain wheel
    var axis = typeof(options.axis) !== 'undefined' ? options.axis.clone() : new Vec3(0, 1, 0);
    this.wheelAxes.push(axis);

    var hingeConstraint = new HingeConstraint(this.chassisBody, wheelBody, {
        pivotA: position,
        axisA: axis,
        pivotB: Vec3.ZERO,
        axisB: axis,
        collideConnected: false
    });
    this.constraints.push(hingeConstraint);

    return this.wheelBodies.length - 1;
};

/**
 * Set the steering value of a wheel.
 * @method setSteeringValue
 * @param {number} value
 * @param {integer} wheelIndex
 * @todo check coordinateSystem
 */
RigidVehicle.prototype.setSteeringValue = function(value, wheelIndex){
    // Set angle of the hinge axis
    var axis = this.wheelAxes[wheelIndex];

    var c = Math.cos(value),
        s = Math.sin(value),
        x = axis.x,
        y = axis.y;
    this.constraints[wheelIndex].axisA.set(
        c*x -s*y,
        s*x +c*y,
        0
    );
};

/**
 * Set the target rotational speed of the hinge constraint.
 * @method setMotorSpeed
 * @param {number} value
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.setMotorSpeed = function(value, wheelIndex){
    var hingeConstraint = this.constraints[wheelIndex];
    hingeConstraint.enableMotor();
    hingeConstraint.motorTargetVelocity = value;
};

/**
 * Set the target rotational speed of the hinge constraint.
 * @method disableMotor
 * @param {number} value
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.disableMotor = function(wheelIndex){
    var hingeConstraint = this.constraints[wheelIndex];
    hingeConstraint.disableMotor();
};

var torque = new Vec3();

/**
 * Set the wheel force to apply on one of the wheels each time step
 * @method setWheelForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RigidVehicle.prototype.setWheelForce = function(value, wheelIndex){
    this.wheelForces[wheelIndex] = value;
};

/**
 * Apply a torque on one of the wheels.
 * @method applyWheelForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RigidVehicle.prototype.applyWheelForce = function(value, wheelIndex){
    var axis = this.wheelAxes[wheelIndex];
    var wheelBody = this.wheelBodies[wheelIndex];
    var bodyTorque = wheelBody.torque;

    axis.scale(value, torque);
    wheelBody.vectorToWorldFrame(torque, torque);
    bodyTorque.vadd(torque, bodyTorque);
};

/**
 * Add the vehicle including its constraints to the world.
 * @method addToWorld
 * @param {World} world
 */
RigidVehicle.prototype.addToWorld = function(world){
    var constraints = this.constraints;
    var bodies = this.wheelBodies.concat([this.chassisBody]);

    for (var i = 0; i < bodies.length; i++) {
        world.add(bodies[i]);
    }

    for (var i = 0; i < constraints.length; i++) {
        world.addConstraint(constraints[i]);
    }

    world.addEventListener('preStep', this._update.bind(this));
};

RigidVehicle.prototype._update = function(){
    var wheelForces = this.wheelForces;
    for (var i = 0; i < wheelForces.length; i++) {
        this.applyWheelForce(wheelForces[i], i);
    }
};

/**
 * Remove the vehicle including its constraints from the world.
 * @method removeFromWorld
 * @param {World} world
 */
RigidVehicle.prototype.removeFromWorld = function(world){
    var constraints = this.constraints;
    var bodies = this.wheelBodies.concat([this.chassisBody]);

    for (var i = 0; i < bodies.length; i++) {
        world.remove(bodies[i]);
    }

    for (var i = 0; i < constraints.length; i++) {
        world.removeConstraint(constraints[i]);
    }
};

var worldAxis = new Vec3();

/**
 * Get current rotational velocity of a wheel
 * @method getWheelSpeed
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.getWheelSpeed = function(wheelIndex){
    var axis = this.wheelAxes[wheelIndex];
    var wheelBody = this.wheelBodies[wheelIndex];
    var w = wheelBody.angularVelocity;
    this.chassisBody.vectorToWorldFrame(axis, worldAxis);
    return w.dot(worldAxis);
};

},{"../constraints/HingeConstraint":15,"../math/Vec3":30,"../shapes/Box":37,"../shapes/Sphere":44,"./Body":31}],34:[function(_dereq_,module,exports){
module.exports = SPHSystem;

var Shape = _dereq_('../shapes/Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Particle = _dereq_('../shapes/Particle');
var Body = _dereq_('../objects/Body');
var Material = _dereq_('../material/Material');

/**
 * Smoothed-particle hydrodynamics system
 * @class SPHSystem
 * @constructor
 */
function SPHSystem(){
    this.particles = [];
	
    /**
     * Density of the system (kg/m3).
     * @property {number} density
     */
    this.density = 1;
	
    /**
     * Distance below which two particles are considered to be neighbors.
     * It should be adjusted so there are about 15-20 neighbor particles within this radius.
     * @property {number} smoothingRadius
     */
    this.smoothingRadius = 1;
    this.speedOfSound = 1;
	
    /**
     * Viscosity of the system.
     * @property {number} viscosity
     */
    this.viscosity = 0.01;
    this.eps = 0.000001;

    // Stuff Computed per particle
    this.pressures = [];
    this.densities = [];
    this.neighbors = [];
}

/**
 * Add a particle to the system.
 * @method add
 * @param {Body} particle
 */
SPHSystem.prototype.add = function(particle){
    this.particles.push(particle);
    if(this.neighbors.length < this.particles.length){
        this.neighbors.push([]);
    }
};

/**
 * Remove a particle from the system.
 * @method remove
 * @param {Body} particle
 */
SPHSystem.prototype.remove = function(particle){
    var idx = this.particles.indexOf(particle);
    if(idx !== -1){
        this.particles.splice(idx,1);
        if(this.neighbors.length > this.particles.length){
            this.neighbors.pop();
        }
    }
};

/**
 * Get neighbors within smoothing volume, save in the array neighbors
 * @method getNeighbors
 * @param {Body} particle
 * @param {Array} neighbors
 */
var SPHSystem_getNeighbors_dist = new Vec3();
SPHSystem.prototype.getNeighbors = function(particle,neighbors){
    var N = this.particles.length,
        id = particle.id,
        R2 = this.smoothingRadius * this.smoothingRadius,
        dist = SPHSystem_getNeighbors_dist;
    for(var i=0; i!==N; i++){
        var p = this.particles[i];
        p.position.vsub(particle.position,dist);
        if(id!==p.id && dist.norm2() < R2){
            neighbors.push(p);
        }
    }
};

// Temp vectors for calculation
var SPHSystem_update_dist = new Vec3(),
    SPHSystem_update_a_pressure = new Vec3(),
    SPHSystem_update_a_visc = new Vec3(),
    SPHSystem_update_gradW = new Vec3(),
    SPHSystem_update_r_vec = new Vec3(),
    SPHSystem_update_u = new Vec3(); // Relative velocity
SPHSystem.prototype.update = function(){
    var N = this.particles.length,
        dist = SPHSystem_update_dist,
        cs = this.speedOfSound,
        eps = this.eps;

    for(var i=0; i!==N; i++){
        var p = this.particles[i]; // Current particle
        var neighbors = this.neighbors[i];

        // Get neighbors
        neighbors.length = 0;
        this.getNeighbors(p,neighbors);
        neighbors.push(this.particles[i]); // Add current too
        var numNeighbors = neighbors.length;

        // Accumulate density for the particle
        var sum = 0.0;
        for(var j=0; j!==numNeighbors; j++){

            //printf("Current particle has position %f %f %f\n",objects[id].pos.x(),objects[id].pos.y(),objects[id].pos.z());
            p.position.vsub(neighbors[j].position, dist);
            var len = dist.norm();

            var weight = this.w(len);
            sum += neighbors[j].mass * weight;
        }

        // Save
        this.densities[i] = sum;
        this.pressures[i] = cs * cs * (this.densities[i] - this.density);
    }

    // Add forces

    // Sum to these accelerations
    var a_pressure= SPHSystem_update_a_pressure;
    var a_visc =    SPHSystem_update_a_visc;
    var gradW =     SPHSystem_update_gradW;
    var r_vec =     SPHSystem_update_r_vec;
    var u =         SPHSystem_update_u;

    for(var i=0; i!==N; i++){

        var particle = this.particles[i];

        a_pressure.set(0,0,0);
        a_visc.set(0,0,0);

        // Init vars
        var Pij;
        var nabla;
        var Vij;

        // Sum up for all other neighbors
        var neighbors = this.neighbors[i];
        var numNeighbors = neighbors.length;

        //printf("Neighbors: ");
        for(var j=0; j!==numNeighbors; j++){

            var neighbor = neighbors[j];
            //printf("%d ",nj);

            // Get r once for all..
            particle.position.vsub(neighbor.position,r_vec);
            var r = r_vec.norm();

            // Pressure contribution
            Pij = -neighbor.mass * (this.pressures[i] / (this.densities[i]*this.densities[i] + eps) + this.pressures[j] / (this.densities[j]*this.densities[j] + eps));
            this.gradw(r_vec, gradW);
            // Add to pressure acceleration
            gradW.mult(Pij , gradW);
            a_pressure.vadd(gradW, a_pressure);

            // Viscosity contribution
            neighbor.velocity.vsub(particle.velocity, u);
            u.mult( 1.0 / (0.0001+this.densities[i] * this.densities[j]) * this.viscosity * neighbor.mass , u );
            nabla = this.nablaw(r);
            u.mult(nabla,u);
            // Add to viscosity acceleration
            a_visc.vadd( u, a_visc );
        }

        // Calculate force
        a_visc.mult(particle.mass, a_visc);
        a_pressure.mult(particle.mass, a_pressure);

        // Add force to particles
        particle.force.vadd(a_visc, particle.force);
        particle.force.vadd(a_pressure, particle.force);
    }
};

// Calculate the weight using the W(r) weightfunction
SPHSystem.prototype.w = function(r){
    // 315
    var h = this.smoothingRadius;
    return 315.0/(64.0*Math.PI*Math.pow(h,9)) * Math.pow(h*h-r*r,3);
};

// calculate gradient of the weight function
SPHSystem.prototype.gradw = function(rVec,resultVec){
    var r = rVec.norm(),
        h = this.smoothingRadius;
    rVec.mult(945.0/(32.0*Math.PI*Math.pow(h,9)) * Math.pow((h*h-r*r),2) , resultVec);
};

// Calculate nabla(W)
SPHSystem.prototype.nablaw = function(r){
    var h = this.smoothingRadius;
    var nabla = 945.0/(32.0*Math.PI*Math.pow(h,9)) * (h*h-r*r)*(7*r*r - 3*h*h);
    return nabla;
};

},{"../material/Material":25,"../math/Quaternion":28,"../math/Vec3":30,"../objects/Body":31,"../shapes/Particle":41,"../shapes/Shape":43}],35:[function(_dereq_,module,exports){
var Vec3 = _dereq_('../math/Vec3');

module.exports = Spring;

/**
 * A spring, connecting two bodies.
 *
 * @class Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restLength]   A number > 0. Default: 1
 * @param {number} [options.stiffness]    A number >= 0. Default: 100
 * @param {number} [options.damping]      A number >= 0. Default: 1
 * @param {Vec3}  [options.worldAnchorA] Where to hook the spring to body A, in world coordinates.
 * @param {Vec3}  [options.worldAnchorB]
 * @param {Vec3}  [options.localAnchorA] Where to hook the spring to body A, in local body coordinates.
 * @param {Vec3}  [options.localAnchorB]
 */
function Spring(bodyA,bodyB,options){
    options = options || {};

    /**
     * Rest length of the spring.
     * @property restLength
     * @type {number}
     */
    this.restLength = typeof(options.restLength) === "number" ? options.restLength : 1;

    /**
     * Stiffness of the spring.
     * @property stiffness
     * @type {number}
     */
    this.stiffness = options.stiffness || 100;

    /**
     * Damping of the spring.
     * @property damping
     * @type {number}
     */
    this.damping = options.damping || 1;

    /**
     * First connected body.
     * @property bodyA
     * @type {Body}
     */
    this.bodyA = bodyA;

    /**
     * Second connected body.
     * @property bodyB
     * @type {Body}
     */
    this.bodyB = bodyB;

    /**
     * Anchor for bodyA in local bodyA coordinates.
     * @property localAnchorA
     * @type {Vec3}
     */
    this.localAnchorA = new Vec3();

    /**
     * Anchor for bodyB in local bodyB coordinates.
     * @property localAnchorB
     * @type {Vec3}
     */
    this.localAnchorB = new Vec3();

    if(options.localAnchorA){
        this.localAnchorA.copy(options.localAnchorA);
    }
    if(options.localAnchorB){
        this.localAnchorB.copy(options.localAnchorB);
    }
    if(options.worldAnchorA){
        this.setWorldAnchorA(options.worldAnchorA);
    }
    if(options.worldAnchorB){
        this.setWorldAnchorB(options.worldAnchorB);
    }
}

/**
 * Set the anchor point on body A, using world coordinates.
 * @method setWorldAnchorA
 * @param {Vec3} worldAnchorA
 */
Spring.prototype.setWorldAnchorA = function(worldAnchorA){
    this.bodyA.pointToLocalFrame(worldAnchorA,this.localAnchorA);
};

/**
 * Set the anchor point on body B, using world coordinates.
 * @method setWorldAnchorB
 * @param {Vec3} worldAnchorB
 */
Spring.prototype.setWorldAnchorB = function(worldAnchorB){
    this.bodyB.pointToLocalFrame(worldAnchorB,this.localAnchorB);
};

/**
 * Get the anchor point on body A, in world coordinates.
 * @method getWorldAnchorA
 * @param {Vec3} result The vector to store the result in.
 */
Spring.prototype.getWorldAnchorA = function(result){
    this.bodyA.pointToWorldFrame(this.localAnchorA,result);
};

/**
 * Get the anchor point on body B, in world coordinates.
 * @method getWorldAnchorB
 * @param {Vec3} result The vector to store the result in.
 */
Spring.prototype.getWorldAnchorB = function(result){
    this.bodyB.pointToWorldFrame(this.localAnchorB,result);
};

var applyForce_r =              new Vec3(),
    applyForce_r_unit =         new Vec3(),
    applyForce_u =              new Vec3(),
    applyForce_f =              new Vec3(),
    applyForce_worldAnchorA =   new Vec3(),
    applyForce_worldAnchorB =   new Vec3(),
    applyForce_ri =             new Vec3(),
    applyForce_rj =             new Vec3(),
    applyForce_ri_x_f =         new Vec3(),
    applyForce_rj_x_f =         new Vec3(),
    applyForce_tmp =            new Vec3();

/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */
Spring.prototype.applyForce = function(){
    var k = this.stiffness,
        d = this.damping,
        l = this.restLength,
        bodyA = this.bodyA,
        bodyB = this.bodyB,
        r = applyForce_r,
        r_unit = applyForce_r_unit,
        u = applyForce_u,
        f = applyForce_f,
        tmp = applyForce_tmp;

    var worldAnchorA = applyForce_worldAnchorA,
        worldAnchorB = applyForce_worldAnchorB,
        ri = applyForce_ri,
        rj = applyForce_rj,
        ri_x_f = applyForce_ri_x_f,
        rj_x_f = applyForce_rj_x_f;

    // Get world anchors
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);

    // Get offset points
    worldAnchorA.vsub(bodyA.position,ri);
    worldAnchorB.vsub(bodyB.position,rj);

    // Compute distance vector between world anchor points
    worldAnchorB.vsub(worldAnchorA,r);
    var rlen = r.norm();
    r_unit.copy(r);
    r_unit.normalize();

    // Compute relative velocity of the anchor points, u
    bodyB.velocity.vsub(bodyA.velocity,u);
    // Add rotational velocity

    bodyB.angularVelocity.cross(rj,tmp);
    u.vadd(tmp,u);
    bodyA.angularVelocity.cross(ri,tmp);
    u.vsub(tmp,u);

    // F = - k * ( x - L ) - D * ( u )
    r_unit.mult(-k*(rlen-l) - d*u.dot(r_unit), f);

    // Add forces to bodies
    bodyA.force.vsub(f,bodyA.force);
    bodyB.force.vadd(f,bodyB.force);

    // Angular force
    ri.cross(f,ri_x_f);
    rj.cross(f,rj_x_f);
    bodyA.torque.vsub(ri_x_f,bodyA.torque);
    bodyB.torque.vadd(rj_x_f,bodyB.torque);
};

},{"../math/Vec3":30}],36:[function(_dereq_,module,exports){
var Vec3 = _dereq_('../math/Vec3');
var Transform = _dereq_('../math/Transform');
var RaycastResult = _dereq_('../collision/RaycastResult');
var Utils = _dereq_('../utils/Utils');

module.exports = WheelInfo;

/**
 * @class WheelInfo
 * @constructor
 * @param {Object} [options]
 *
 * @param {Vec3} [options.chassisConnectionPointLocal]
 * @param {Vec3} [options.chassisConnectionPointWorld]
 * @param {Vec3} [options.directionLocal]
 * @param {Vec3} [options.directionWorld]
 * @param {Vec3} [options.axleLocal]
 * @param {Vec3} [options.axleWorld]
 * @param {number} [options.suspensionRestLength=1]
 * @param {number} [options.suspensionMaxLength=2]
 * @param {number} [options.radius=1]
 * @param {number} [options.suspensionStiffness=100]
 * @param {number} [options.dampingCompression=10]
 * @param {number} [options.dampingRelaxation=10]
 * @param {number} [options.frictionSlip=10000]
 * @param {number} [options.steering=0]
 * @param {number} [options.rotation=0]
 * @param {number} [options.deltaRotation=0]
 * @param {number} [options.rollInfluence=0.01]
 * @param {number} [options.maxSuspensionForce]
 * @param {boolean} [options.isFrontWheel=true]
 * @param {number} [options.clippedInvContactDotSuspension=1]
 * @param {number} [options.suspensionRelativeVelocity=0]
 * @param {number} [options.suspensionForce=0]
 * @param {number} [options.skidInfo=0]
 * @param {number} [options.suspensionLength=0]
 * @param {number} [options.maxSuspensionTravel=1]
 * @param {boolean} [options.useCustomSlidingRotationalSpeed=false]
 * @param {number} [options.customSlidingRotationalSpeed=-0.1]
 */
function WheelInfo(options){
    options = Utils.defaults(options, {
        chassisConnectionPointLocal: new Vec3(),
        chassisConnectionPointWorld: new Vec3(),
        directionLocal: new Vec3(),
        directionWorld: new Vec3(),
        axleLocal: new Vec3(),
        axleWorld: new Vec3(),
        suspensionRestLength: 1,
        suspensionMaxLength: 2,
        radius: 1,
        suspensionStiffness: 100,
        dampingCompression: 10,
        dampingRelaxation: 10,
        frictionSlip: 10000,
        steering: 0,
        rotation: 0,
        deltaRotation: 0,
        rollInfluence: 0.01,
        maxSuspensionForce: Number.MAX_VALUE,
        isFrontWheel: true,
        clippedInvContactDotSuspension: 1,
        suspensionRelativeVelocity: 0,
        suspensionForce: 0,
        skidInfo: 0,
        suspensionLength: 0,
        maxSuspensionTravel: 1,
        useCustomSlidingRotationalSpeed: false,
        customSlidingRotationalSpeed: -0.1
    });

    /**
     * Max travel distance of the suspension, in meters.
     * @property {number} maxSuspensionTravel
     */
    this.maxSuspensionTravel = options.maxSuspensionTravel;

    /**
     * Speed to apply to the wheel rotation when the wheel is sliding.
     * @property {number} customSlidingRotationalSpeed
     */
    this.customSlidingRotationalSpeed = options.customSlidingRotationalSpeed;

    /**
     * If the customSlidingRotationalSpeed should be used.
     * @property {Boolean} useCustomSlidingRotationalSpeed
     */
    this.useCustomSlidingRotationalSpeed = options.useCustomSlidingRotationalSpeed;

    /**
     * @property {Boolean} sliding
     */
    this.sliding = false;

    /**
     * Connection point, defined locally in the chassis body frame.
     * @property {Vec3} chassisConnectionPointLocal
     */
    this.chassisConnectionPointLocal = options.chassisConnectionPointLocal.clone();

    /**
     * @property {Vec3} chassisConnectionPointWorld
     */
    this.chassisConnectionPointWorld = options.chassisConnectionPointWorld.clone();

    /**
     * @property {Vec3} directionLocal
     */
    this.directionLocal = options.directionLocal.clone();

    /**
     * @property {Vec3} directionWorld
     */
    this.directionWorld = options.directionWorld.clone();

    /**
     * @property {Vec3} axleLocal
     */
    this.axleLocal = options.axleLocal.clone();

    /**
     * @property {Vec3} axleWorld
     */
    this.axleWorld = options.axleWorld.clone();

    /**
     * @property {number} suspensionRestLength
     */
    this.suspensionRestLength = options.suspensionRestLength;

    /**
     * @property {number} suspensionMaxLength
     */
    this.suspensionMaxLength = options.suspensionMaxLength;

    /**
     * @property {number} radius
     */
    this.radius = options.radius;

    /**
     * @property {number} suspensionStiffness
     */
    this.suspensionStiffness = options.suspensionStiffness;

    /**
     * @property {number} dampingCompression
     */
    this.dampingCompression = options.dampingCompression;

    /**
     * @property {number} dampingRelaxation
     */
    this.dampingRelaxation = options.dampingRelaxation;

    /**
     * @property {number} frictionSlip
     */
    this.frictionSlip = options.frictionSlip;

    /**
     * @property {number} steering
     */
    this.steering = 0;

    /**
     * Rotation value, in radians.
     * @property {number} rotation
     */
    this.rotation = 0;

    /**
     * @property {number} deltaRotation
     */
    this.deltaRotation = 0;

    /**
     * @property {number} rollInfluence
     */
    this.rollInfluence = options.rollInfluence;

    /**
     * @property {number} maxSuspensionForce
     */
    this.maxSuspensionForce = options.maxSuspensionForce;

    /**
     * @property {number} engineForce
     */
    this.engineForce = 0;

    /**
     * @property {number} brake
     */
    this.brake = 0;

    /**
     * @property {number} isFrontWheel
     */
    this.isFrontWheel = options.isFrontWheel;

    /**
     * @property {number} clippedInvContactDotSuspension
     */
    this.clippedInvContactDotSuspension = 1;

    /**
     * @property {number} suspensionRelativeVelocity
     */
    this.suspensionRelativeVelocity = 0;

    /**
     * @property {number} suspensionForce
     */
    this.suspensionForce = 0;

    /**
     * @property {number} skidInfo
     */
    this.skidInfo = 0;

    /**
     * @property {number} suspensionLength
     */
    this.suspensionLength = 0;

    /**
     * @property {number} sideImpulse
     */
    this.sideImpulse = 0;

    /**
     * @property {number} forwardImpulse
     */
    this.forwardImpulse = 0;

    /**
     * The result from raycasting
     * @property {RaycastResult} raycastResult
     */
    this.raycastResult = new RaycastResult();

    /**
     * Wheel world transform
     * @property {Transform} worldTransform
     */
    this.worldTransform = new Transform();

    /**
     * @property {boolean} isInContact
     */
    this.isInContact = false;
}

var chassis_velocity_at_contactPoint = new Vec3();
var relpos = new Vec3();
var chassis_velocity_at_contactPoint = new Vec3();
WheelInfo.prototype.updateWheel = function(chassis){
    var raycastResult = this.raycastResult;

    if (this.isInContact){
        var project= raycastResult.hitNormalWorld.dot(raycastResult.directionWorld);
        raycastResult.hitPointWorld.vsub(chassis.position, relpos);
        chassis.getVelocityAtWorldPoint(relpos, chassis_velocity_at_contactPoint);
        var projVel = raycastResult.hitNormalWorld.dot( chassis_velocity_at_contactPoint );
        if (project >= -0.1) {
            this.suspensionRelativeVelocity = 0.0;
            this.clippedInvContactDotSuspension = 1.0 / 0.1;
        } else {
            var inv = -1 / project;
            this.suspensionRelativeVelocity = projVel * inv;
            this.clippedInvContactDotSuspension = inv;
        }

    } else {
        // Not in contact : position wheel in a nice (rest length) position
        raycastResult.suspensionLength = this.suspensionRestLength;
        this.suspensionRelativeVelocity = 0.0;
        raycastResult.directionWorld.scale(-1, raycastResult.hitNormalWorld);
        this.clippedInvContactDotSuspension = 1.0;
    }
};
},{"../collision/RaycastResult":10,"../math/Transform":29,"../math/Vec3":30,"../utils/Utils":53}],37:[function(_dereq_,module,exports){
module.exports = Box;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');
var ConvexPolyhedron = _dereq_('./ConvexPolyhedron');

/**
 * A 3d box shape.
 * @class Box
 * @constructor
 * @param {Vec3} halfExtents
 * @author schteppe
 * @extends Shape
 */
function Box(halfExtents){
    Shape.call(this);

    this.type = Shape.types.BOX;

    /**
     * @property halfExtents
     * @type {Vec3}
     */
    this.halfExtents = halfExtents;

    /**
     * Used by the contact generator to make contacts with other convex polyhedra for example
     * @property convexPolyhedronRepresentation
     * @type {ConvexPolyhedron}
     */
    this.convexPolyhedronRepresentation = null;

    this.updateConvexPolyhedronRepresentation();
    this.updateBoundingSphereRadius();
}
Box.prototype = new Shape();
Box.prototype.constructor = Box;

/**
 * Updates the local convex polyhedron representation used for some collisions.
 * @method updateConvexPolyhedronRepresentation
 */
Box.prototype.updateConvexPolyhedronRepresentation = function(){
    var sx = this.halfExtents.x;
    var sy = this.halfExtents.y;
    var sz = this.halfExtents.z;
    var V = Vec3;

    var vertices = [
        new V(-sx,-sy,-sz),
        new V( sx,-sy,-sz),
        new V( sx, sy,-sz),
        new V(-sx, sy,-sz),
        new V(-sx,-sy, sz),
        new V( sx,-sy, sz),
        new V( sx, sy, sz),
        new V(-sx, sy, sz)
    ];

    var indices = [
        [3,2,1,0], // -z
        [4,5,6,7], // +z
        [5,4,0,1], // -y
        [2,3,7,6], // +y
        [0,4,7,3], // -x
        [1,2,6,5], // +x
    ];

    var axes = [
        new V(0, 0, 1),
        new V(0, 1, 0),
        new V(1, 0, 0)
    ];

    var h = new ConvexPolyhedron(vertices, indices);
    this.convexPolyhedronRepresentation = h;
    h.material = this.material;
};

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3}
 */
Box.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    Box.calculateInertia(this.halfExtents, mass, target);
    return target;
};

Box.calculateInertia = function(halfExtents,mass,target){
    var e = halfExtents;
    target.x = 1.0 / 12.0 * mass * (   2*e.y*2*e.y + 2*e.z*2*e.z );
    target.y = 1.0 / 12.0 * mass * (   2*e.x*2*e.x + 2*e.z*2*e.z );
    target.z = 1.0 / 12.0 * mass * (   2*e.y*2*e.y + 2*e.x*2*e.x );
};

/**
 * Get the box 6 side normals
 * @method getSideNormals
 * @param {array}      sixTargetVectors An array of 6 vectors, to store the resulting side normals in.
 * @param {Quaternion} quat             Orientation to apply to the normal vectors. If not provided, the vectors will be in respect to the local frame.
 * @return {array}
 */
Box.prototype.getSideNormals = function(sixTargetVectors,quat){
    var sides = sixTargetVectors;
    var ex = this.halfExtents;
    sides[0].set(  ex.x,     0,     0);
    sides[1].set(     0,  ex.y,     0);
    sides[2].set(     0,     0,  ex.z);
    sides[3].set( -ex.x,     0,     0);
    sides[4].set(     0, -ex.y,     0);
    sides[5].set(     0,     0, -ex.z);

    if(quat!==undefined){
        for(var i=0; i!==sides.length; i++){
            quat.vmult(sides[i],sides[i]);
        }
    }

    return sides;
};

Box.prototype.volume = function(){
    return 8.0 * this.halfExtents.x * this.halfExtents.y * this.halfExtents.z;
};

Box.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = this.halfExtents.norm();
};

var worldCornerTempPos = new Vec3();
var worldCornerTempNeg = new Vec3();
Box.prototype.forEachWorldCorner = function(pos,quat,callback){

    var e = this.halfExtents;
    var corners = [[  e.x,  e.y,  e.z],
                   [ -e.x,  e.y,  e.z],
                   [ -e.x, -e.y,  e.z],
                   [ -e.x, -e.y, -e.z],
                   [  e.x, -e.y, -e.z],
                   [  e.x,  e.y, -e.z],
                   [ -e.x,  e.y, -e.z],
                   [  e.x, -e.y,  e.z]];
    for(var i=0; i<corners.length; i++){
        worldCornerTempPos.set(corners[i][0],corners[i][1],corners[i][2]);
        quat.vmult(worldCornerTempPos,worldCornerTempPos);
        pos.vadd(worldCornerTempPos,worldCornerTempPos);
        callback(worldCornerTempPos.x,
                 worldCornerTempPos.y,
                 worldCornerTempPos.z);
    }
};

var worldCornersTemp = [
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3()
];
Box.prototype.calculateWorldAABB = function(pos,quat,min,max){

    var e = this.halfExtents;
    worldCornersTemp[0].set(e.x, e.y, e.z);
    worldCornersTemp[1].set(-e.x,  e.y, e.z);
    worldCornersTemp[2].set(-e.x, -e.y, e.z);
    worldCornersTemp[3].set(-e.x, -e.y, -e.z);
    worldCornersTemp[4].set(e.x, -e.y, -e.z);
    worldCornersTemp[5].set(e.x,  e.y, -e.z);
    worldCornersTemp[6].set(-e.x,  e.y, -e.z);
    worldCornersTemp[7].set(e.x, -e.y,  e.z);

    var wc = worldCornersTemp[0];
    quat.vmult(wc, wc);
    pos.vadd(wc, wc);
    max.copy(wc);
    min.copy(wc);
    for(var i=1; i<8; i++){
        var wc = worldCornersTemp[i];
        quat.vmult(wc, wc);
        pos.vadd(wc, wc);
        var x = wc.x;
        var y = wc.y;
        var z = wc.z;
        if(x > max.x){
            max.x = x;
        }
        if(y > max.y){
            max.y = y;
        }
        if(z > max.z){
            max.z = z;
        }

        if(x < min.x){
            min.x = x;
        }
        if(y < min.y){
            min.y = y;
        }
        if(z < min.z){
            min.z = z;
        }
    }

    // Get each axis max
    // min.set(Infinity,Infinity,Infinity);
    // max.set(-Infinity,-Infinity,-Infinity);
    // this.forEachWorldCorner(pos,quat,function(x,y,z){
    //     if(x > max.x){
    //         max.x = x;
    //     }
    //     if(y > max.y){
    //         max.y = y;
    //     }
    //     if(z > max.z){
    //         max.z = z;
    //     }

    //     if(x < min.x){
    //         min.x = x;
    //     }
    //     if(y < min.y){
    //         min.y = y;
    //     }
    //     if(z < min.z){
    //         min.z = z;
    //     }
    // });
};

},{"../math/Vec3":30,"./ConvexPolyhedron":38,"./Shape":43}],38:[function(_dereq_,module,exports){
module.exports = ConvexPolyhedron;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Transform = _dereq_('../math/Transform');

/**
 * A set of polygons describing a convex shape.
 * @class ConvexPolyhedron
 * @constructor
 * @extends Shape
 * @description The shape MUST be convex for the code to work properly. No polygons may be coplanar (contained
 * in the same 3D plane), instead these should be merged into one polygon.
 *
 * @param {array} points An array of Vec3's
 * @param {array} faces Array of integer arrays, describing which vertices that is included in each face.
 *
 * @author qiao / https://github.com/qiao (original author, see https://github.com/qiao/three.js/commit/85026f0c769e4000148a67d45a9e9b9c5108836f)
 * @author schteppe / https://github.com/schteppe
 * @see http://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/
 * @see http://bullet.googlecode.com/svn/trunk/src/BulletCollision/NarrowPhaseCollision/btPolyhedralContactClipping.cpp
 *
 * @todo Move the clipping functions to ContactGenerator?
 * @todo Automatically merge coplanar polygons in constructor.
 */
function ConvexPolyhedron(points, faces, uniqueAxes) {
    var that = this;
    Shape.call(this);
    this.type = Shape.types.CONVEXPOLYHEDRON;

    /**
     * Array of Vec3
     * @property vertices
     * @type {Array}
     */
    this.vertices = points||[];

    this.worldVertices = []; // World transformed version of .vertices
    this.worldVerticesNeedsUpdate = true;

    /**
     * Array of integer arrays, indicating which vertices each face consists of
     * @property faces
     * @type {Array}
     */
    this.faces = faces||[];

    /**
     * Array of Vec3
     * @property faceNormals
     * @type {Array}
     */
    this.faceNormals = [];
    this.computeNormals();

    this.worldFaceNormalsNeedsUpdate = true;
    this.worldFaceNormals = []; // World transformed version of .faceNormals

    /**
     * Array of Vec3
     * @property uniqueEdges
     * @type {Array}
     */
    this.uniqueEdges = [];

    /**
     * If given, these locally defined, normalized axes are the only ones being checked when doing separating axis check.
     * @property {Array} uniqueAxes
     */
    this.uniqueAxes = uniqueAxes ? uniqueAxes.slice() : null;

    this.computeEdges();
    this.updateBoundingSphereRadius();
}
ConvexPolyhedron.prototype = new Shape();
ConvexPolyhedron.prototype.constructor = ConvexPolyhedron;

var computeEdges_tmpEdge = new Vec3();
/**
 * Computes uniqueEdges
 * @method computeEdges
 */
ConvexPolyhedron.prototype.computeEdges = function(){
    var faces = this.faces;
    var vertices = this.vertices;
    var nv = vertices.length;
    var edges = this.uniqueEdges;

    edges.length = 0;

    var edge = computeEdges_tmpEdge;

    for(var i=0; i !== faces.length; i++){
        var face = faces[i];
        var numVertices = face.length;
        for(var j = 0; j !== numVertices; j++){
            var k = ( j+1 ) % numVertices;
            vertices[face[j]].vsub(vertices[face[k]], edge);
            edge.normalize();
            var found = false;
            for(var p=0; p !== edges.length; p++){
                if (edges[p].almostEquals(edge) || edges[p].almostEquals(edge)){
                    found = true;
                    break;
                }
            }

            if (!found){
                edges.push(edge.clone());
            }
        }
    }
};

/**
 * Compute the normals of the faces. Will reuse existing Vec3 objects in the .faceNormals array if they exist.
 * @method computeNormals
 */
ConvexPolyhedron.prototype.computeNormals = function(){
    this.faceNormals.length = this.faces.length;

    // Generate normals
    for(var i=0; i<this.faces.length; i++){

        // Check so all vertices exists for this face
        for(var j=0; j<this.faces[i].length; j++){
            if(!this.vertices[this.faces[i][j]]){
                throw new Error("Vertex "+this.faces[i][j]+" not found!");
            }
        }

        var n = this.faceNormals[i] || new Vec3();
        this.getFaceNormal(i,n);
        n.negate(n);
        this.faceNormals[i] = n;
        var vertex = this.vertices[this.faces[i][0]];
        if(n.dot(vertex) < 0){
            console.error(".faceNormals[" + i + "] = Vec3("+n.toString()+") looks like it points into the shape? The vertices follow. Make sure they are ordered CCW around the normal, using the right hand rule.");
            for(var j=0; j<this.faces[i].length; j++){
                console.warn(".vertices["+this.faces[i][j]+"] = Vec3("+this.vertices[this.faces[i][j]].toString()+")");
            }
        }
    }
};

/**
 * Get face normal given 3 vertices
 * @static
 * @method getFaceNormal
 * @param {Vec3} va
 * @param {Vec3} vb
 * @param {Vec3} vc
 * @param {Vec3} target
 */
var cb = new Vec3();
var ab = new Vec3();
ConvexPolyhedron.computeNormal = function ( va, vb, vc, target ) {
    vb.vsub(va,ab);
    vc.vsub(vb,cb);
    cb.cross(ab,target);
    if ( !target.isZero() ) {
        target.normalize();
    }
};

/**
 * Compute the normal of a face from its vertices
 * @method getFaceNormal
 * @param  {Number} i
 * @param  {Vec3} target
 */
ConvexPolyhedron.prototype.getFaceNormal = function(i,target){
    var f = this.faces[i];
    var va = this.vertices[f[0]];
    var vb = this.vertices[f[1]];
    var vc = this.vertices[f[2]];
    return ConvexPolyhedron.computeNormal(va,vb,vc,target);
};

/**
 * @method clipAgainstHull
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @param {Vec3} separatingNormal
 * @param {Number} minDist Clamp distance
 * @param {Number} maxDist
 * @param {array} result The an array of contact point objects, see clipFaceAgainstHull
 * @see http://bullet.googlecode.com/svn/trunk/src/BulletCollision/NarrowPhaseCollision/btPolyhedralContactClipping.cpp
 */
var cah_WorldNormal = new Vec3();
ConvexPolyhedron.prototype.clipAgainstHull = function(posA,quatA,hullB,posB,quatB,separatingNormal,minDist,maxDist,result){
    var WorldNormal = cah_WorldNormal;
    var hullA = this;
    var curMaxDist = maxDist;
    var closestFaceB = -1;
    var dmax = -Number.MAX_VALUE;
    for(var face=0; face < hullB.faces.length; face++){
        WorldNormal.copy(hullB.faceNormals[face]);
        quatB.vmult(WorldNormal,WorldNormal);
        //posB.vadd(WorldNormal,WorldNormal);
        var d = WorldNormal.dot(separatingNormal);
        if (d > dmax){
            dmax = d;
            closestFaceB = face;
        }
    }
    var worldVertsB1 = [];
    var polyB = hullB.faces[closestFaceB];
    var numVertices = polyB.length;
    for(var e0=0; e0<numVertices; e0++){
        var b = hullB.vertices[polyB[e0]];
        var worldb = new Vec3();
        worldb.copy(b);
        quatB.vmult(worldb,worldb);
        posB.vadd(worldb,worldb);
        worldVertsB1.push(worldb);
    }

    if (closestFaceB>=0){
        this.clipFaceAgainstHull(separatingNormal,
                                 posA,
                                 quatA,
                                 worldVertsB1,
                                 minDist,
                                 maxDist,
                                 result);
    }
};

/**
 * Find the separating axis between this hull and another
 * @method findSeparatingAxis
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @param {Vec3} target The target vector to save the axis in
 * @return {bool} Returns false if a separation is found, else true
 */
var fsa_faceANormalWS3 = new Vec3(),
    fsa_Worldnormal1 = new Vec3(),
    fsa_deltaC = new Vec3(),
    fsa_worldEdge0 = new Vec3(),
    fsa_worldEdge1 = new Vec3(),
    fsa_Cross = new Vec3();
ConvexPolyhedron.prototype.findSeparatingAxis = function(hullB,posA,quatA,posB,quatB,target, faceListA, faceListB){
    var faceANormalWS3 = fsa_faceANormalWS3,
        Worldnormal1 = fsa_Worldnormal1,
        deltaC = fsa_deltaC,
        worldEdge0 = fsa_worldEdge0,
        worldEdge1 = fsa_worldEdge1,
        Cross = fsa_Cross;

    var dmin = Number.MAX_VALUE;
    var hullA = this;
    var curPlaneTests=0;

    if(!hullA.uniqueAxes){

        var numFacesA = faceListA ? faceListA.length : hullA.faces.length;

        // Test face normals from hullA
        for(var i=0; i<numFacesA; i++){
            var fi = faceListA ? faceListA[i] : i;

            // Get world face normal
            faceANormalWS3.copy(hullA.faceNormals[fi]);
            quatA.vmult(faceANormalWS3,faceANormalWS3);

            var d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(faceANormalWS3);
            }
        }

    } else {

        // Test unique axes
        for(var i = 0; i !== hullA.uniqueAxes.length; i++){

            // Get world axis
            quatA.vmult(hullA.uniqueAxes[i],faceANormalWS3);

            var d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(faceANormalWS3);
            }
        }
    }

    if(!hullB.uniqueAxes){

        // Test face normals from hullB
        var numFacesB = faceListB ? faceListB.length : hullB.faces.length;
        for(var i=0;i<numFacesB;i++){

            var fi = faceListB ? faceListB[i] : i;

            Worldnormal1.copy(hullB.faceNormals[fi]);
            quatB.vmult(Worldnormal1,Worldnormal1);
            curPlaneTests++;
            var d = hullA.testSepAxis(Worldnormal1, hullB,posA,quatA,posB,quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(Worldnormal1);
            }
        }
    } else {

        // Test unique axes in B
        for(var i = 0; i !== hullB.uniqueAxes.length; i++){
            quatB.vmult(hullB.uniqueAxes[i],Worldnormal1);

            curPlaneTests++;
            var d = hullA.testSepAxis(Worldnormal1, hullB,posA,quatA,posB,quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(Worldnormal1);
            }
        }
    }

    // Test edges
    for(var e0=0; e0 !== hullA.uniqueEdges.length; e0++){

        // Get world edge
        quatA.vmult(hullA.uniqueEdges[e0],worldEdge0);

        for(var e1=0; e1 !== hullB.uniqueEdges.length; e1++){

            // Get world edge 2
            quatB.vmult(hullB.uniqueEdges[e1], worldEdge1);
            worldEdge0.cross(worldEdge1,Cross);

            if(!Cross.almostZero()){
                Cross.normalize();
                var dist = hullA.testSepAxis(Cross, hullB, posA, quatA, posB, quatB);
                if(dist === false){
                    return false;
                }
                if(dist < dmin){
                    dmin = dist;
                    target.copy(Cross);
                }
            }
        }
    }

    posB.vsub(posA,deltaC);
    if((deltaC.dot(target))>0.0){
        target.negate(target);
    }

    return true;
};

var maxminA=[], maxminB=[];

/**
 * Test separating axis against two hulls. Both hulls are projected onto the axis and the overlap size is returned if there is one.
 * @method testSepAxis
 * @param {Vec3} axis
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @return {number} The overlap depth, or FALSE if no penetration.
 */
ConvexPolyhedron.prototype.testSepAxis = function(axis, hullB, posA, quatA, posB, quatB){
    var hullA=this;
    ConvexPolyhedron.project(hullA, axis, posA, quatA, maxminA);
    ConvexPolyhedron.project(hullB, axis, posB, quatB, maxminB);
    var maxA = maxminA[0];
    var minA = maxminA[1];
    var maxB = maxminB[0];
    var minB = maxminB[1];
    if(maxA<minB || maxB<minA){
        return false; // Separated
    }
    var d0 = maxA - minB;
    var d1 = maxB - minA;
    var depth = d0<d1 ? d0:d1;
    return depth;
};

var cli_aabbmin = new Vec3(),
    cli_aabbmax = new Vec3();

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 */
ConvexPolyhedron.prototype.calculateLocalInertia = function(mass,target){
    // Approximate with box inertia
    // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
    this.computeLocalAABB(cli_aabbmin,cli_aabbmax);
    var x = cli_aabbmax.x - cli_aabbmin.x,
        y = cli_aabbmax.y - cli_aabbmin.y,
        z = cli_aabbmax.z - cli_aabbmin.z;
    target.x = 1.0 / 12.0 * mass * ( 2*y*2*y + 2*z*2*z );
    target.y = 1.0 / 12.0 * mass * ( 2*x*2*x + 2*z*2*z );
    target.z = 1.0 / 12.0 * mass * ( 2*y*2*y + 2*x*2*x );
};

/**
 * @method getPlaneConstantOfFace
 * @param  {Number} face_i Index of the face
 * @return {Number}
 */
ConvexPolyhedron.prototype.getPlaneConstantOfFace = function(face_i){
    var f = this.faces[face_i];
    var n = this.faceNormals[face_i];
    var v = this.vertices[f[0]];
    var c = -n.dot(v);
    return c;
};

/**
 * Clip a face against a hull.
 * @method clipFaceAgainstHull
 * @param {Vec3} separatingNormal
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Array} worldVertsB1 An array of Vec3 with vertices in the world frame.
 * @param {Number} minDist Distance clamping
 * @param {Number} maxDist
 * @param Array result Array to store resulting contact points in. Will be objects with properties: point, depth, normal. These are represented in world coordinates.
 */
var cfah_faceANormalWS = new Vec3(),
    cfah_edge0 = new Vec3(),
    cfah_WorldEdge0 = new Vec3(),
    cfah_worldPlaneAnormal1 = new Vec3(),
    cfah_planeNormalWS1 = new Vec3(),
    cfah_worldA1 = new Vec3(),
    cfah_localPlaneNormal = new Vec3(),
    cfah_planeNormalWS = new Vec3();
ConvexPolyhedron.prototype.clipFaceAgainstHull = function(separatingNormal, posA, quatA, worldVertsB1, minDist, maxDist,result){
    var faceANormalWS = cfah_faceANormalWS,
        edge0 = cfah_edge0,
        WorldEdge0 = cfah_WorldEdge0,
        worldPlaneAnormal1 = cfah_worldPlaneAnormal1,
        planeNormalWS1 = cfah_planeNormalWS1,
        worldA1 = cfah_worldA1,
        localPlaneNormal = cfah_localPlaneNormal,
        planeNormalWS = cfah_planeNormalWS;

    var hullA = this;
    var worldVertsB2 = [];
    var pVtxIn = worldVertsB1;
    var pVtxOut = worldVertsB2;
    // Find the face with normal closest to the separating axis
    var closestFaceA = -1;
    var dmin = Number.MAX_VALUE;
    for(var face=0; face<hullA.faces.length; face++){
        faceANormalWS.copy(hullA.faceNormals[face]);
        quatA.vmult(faceANormalWS,faceANormalWS);
        //posA.vadd(faceANormalWS,faceANormalWS);
        var d = faceANormalWS.dot(separatingNormal);
        if (d < dmin){
            dmin = d;
            closestFaceA = face;
        }
    }
    if (closestFaceA < 0){
        // console.log("--- did not find any closest face... ---");
        return;
    }
    //console.log("closest A: ",closestFaceA);
    // Get the face and construct connected faces
    var polyA = hullA.faces[closestFaceA];
    polyA.connectedFaces = [];
    for(var i=0; i<hullA.faces.length; i++){
        for(var j=0; j<hullA.faces[i].length; j++){
            if(polyA.indexOf(hullA.faces[i][j])!==-1 /* Sharing a vertex*/ && i!==closestFaceA /* Not the one we are looking for connections from */ && polyA.connectedFaces.indexOf(i)===-1 /* Not already added */ ){
                polyA.connectedFaces.push(i);
            }
        }
    }
    // Clip the polygon to the back of the planes of all faces of hull A, that are adjacent to the witness face
    var numContacts = pVtxIn.length;
    var numVerticesA = polyA.length;
    var res = [];
    for(var e0=0; e0<numVerticesA; e0++){
        var a = hullA.vertices[polyA[e0]];
        var b = hullA.vertices[polyA[(e0+1)%numVerticesA]];
        a.vsub(b,edge0);
        WorldEdge0.copy(edge0);
        quatA.vmult(WorldEdge0,WorldEdge0);
        posA.vadd(WorldEdge0,WorldEdge0);
        worldPlaneAnormal1.copy(this.faceNormals[closestFaceA]);//transA.getBasis()* btVector3(polyA.m_plane[0],polyA.m_plane[1],polyA.m_plane[2]);
        quatA.vmult(worldPlaneAnormal1,worldPlaneAnormal1);
        posA.vadd(worldPlaneAnormal1,worldPlaneAnormal1);
        WorldEdge0.cross(worldPlaneAnormal1,planeNormalWS1);
        planeNormalWS1.negate(planeNormalWS1);
        worldA1.copy(a);
        quatA.vmult(worldA1,worldA1);
        posA.vadd(worldA1,worldA1);
        var planeEqWS1 = -worldA1.dot(planeNormalWS1);
        var planeEqWS;
        if(true){
            var otherFace = polyA.connectedFaces[e0];
            localPlaneNormal.copy(this.faceNormals[otherFace]);
            var localPlaneEq = this.getPlaneConstantOfFace(otherFace);

            planeNormalWS.copy(localPlaneNormal);
            quatA.vmult(planeNormalWS,planeNormalWS);
            //posA.vadd(planeNormalWS,planeNormalWS);
            var planeEqWS = localPlaneEq - planeNormalWS.dot(posA);
        } else  {
            planeNormalWS.copy(planeNormalWS1);
            planeEqWS = planeEqWS1;
        }

        // Clip face against our constructed plane
        this.clipFaceAgainstPlane(pVtxIn, pVtxOut, planeNormalWS, planeEqWS);

        // Throw away all clipped points, but save the reamining until next clip
        while(pVtxIn.length){
            pVtxIn.shift();
        }
        while(pVtxOut.length){
            pVtxIn.push(pVtxOut.shift());
        }
    }

    //console.log("Resulting points after clip:",pVtxIn);

    // only keep contact points that are behind the witness face
    localPlaneNormal.copy(this.faceNormals[closestFaceA]);

    var localPlaneEq = this.getPlaneConstantOfFace(closestFaceA);
    planeNormalWS.copy(localPlaneNormal);
    quatA.vmult(planeNormalWS,planeNormalWS);

    var planeEqWS = localPlaneEq - planeNormalWS.dot(posA);
    for (var i=0; i<pVtxIn.length; i++){
        var depth = planeNormalWS.dot(pVtxIn[i]) + planeEqWS; //???
        /*console.log("depth calc from normal=",planeNormalWS.toString()," and constant "+planeEqWS+" and vertex ",pVtxIn[i].toString()," gives "+depth);*/
        if (depth <=minDist){
            console.log("clamped: depth="+depth+" to minDist="+(minDist+""));
            depth = minDist;
        }

        if (depth <=maxDist){
            var point = pVtxIn[i];
            if(depth<=0){
                /*console.log("Got contact point ",point.toString(),
                  ", depth=",depth,
                  "contact normal=",separatingNormal.toString(),
                  "plane",planeNormalWS.toString(),
                  "planeConstant",planeEqWS);*/
                var p = {
                    point:point,
                    normal:planeNormalWS,
                    depth: depth,
                };
                result.push(p);
            }
        }
    }
};

/**
 * Clip a face in a hull against the back of a plane.
 * @method clipFaceAgainstPlane
 * @param {Array} inVertices
 * @param {Array} outVertices
 * @param {Vec3} planeNormal
 * @param {Number} planeConstant The constant in the mathematical plane equation
 */
ConvexPolyhedron.prototype.clipFaceAgainstPlane = function(inVertices,outVertices, planeNormal, planeConstant){
    var n_dot_first, n_dot_last;
    var numVerts = inVertices.length;

    if(numVerts < 2){
        return outVertices;
    }

    var firstVertex = inVertices[inVertices.length-1],
        lastVertex =   inVertices[0];

    n_dot_first = planeNormal.dot(firstVertex) + planeConstant;

    for(var vi = 0; vi < numVerts; vi++){
        lastVertex = inVertices[vi];
        n_dot_last = planeNormal.dot(lastVertex) + planeConstant;
        if(n_dot_first < 0){
            if(n_dot_last < 0){
                // Start < 0, end < 0, so output lastVertex
                var newv = new Vec3();
                newv.copy(lastVertex);
                outVertices.push(newv);
            } else {
                // Start < 0, end >= 0, so output intersection
                var newv = new Vec3();
                firstVertex.lerp(lastVertex,
                                 n_dot_first / (n_dot_first - n_dot_last),
                                 newv);
                outVertices.push(newv);
            }
        } else {
            if(n_dot_last<0){
                // Start >= 0, end < 0 so output intersection and end
                var newv = new Vec3();
                firstVertex.lerp(lastVertex,
                                 n_dot_first / (n_dot_first - n_dot_last),
                                 newv);
                outVertices.push(newv);
                outVertices.push(lastVertex);
            }
        }
        firstVertex = lastVertex;
        n_dot_first = n_dot_last;
    }
    return outVertices;
};

// Updates .worldVertices and sets .worldVerticesNeedsUpdate to false.
ConvexPolyhedron.prototype.computeWorldVertices = function(position,quat){
    var N = this.vertices.length;
    while(this.worldVertices.length < N){
        this.worldVertices.push( new Vec3() );
    }

    var verts = this.vertices,
        worldVerts = this.worldVertices;
    for(var i=0; i!==N; i++){
        quat.vmult( verts[i] , worldVerts[i] );
        position.vadd( worldVerts[i] , worldVerts[i] );
    }

    this.worldVerticesNeedsUpdate = false;
};

var computeLocalAABB_worldVert = new Vec3();
ConvexPolyhedron.prototype.computeLocalAABB = function(aabbmin,aabbmax){
    var n = this.vertices.length,
        vertices = this.vertices,
        worldVert = computeLocalAABB_worldVert;

    aabbmin.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    aabbmax.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);

    for(var i=0; i<n; i++){
        var v = vertices[i];
        if     (v.x < aabbmin.x){
            aabbmin.x = v.x;
        } else if(v.x > aabbmax.x){
            aabbmax.x = v.x;
        }
        if     (v.y < aabbmin.y){
            aabbmin.y = v.y;
        } else if(v.y > aabbmax.y){
            aabbmax.y = v.y;
        }
        if     (v.z < aabbmin.z){
            aabbmin.z = v.z;
        } else if(v.z > aabbmax.z){
            aabbmax.z = v.z;
        }
    }
};

/**
 * Updates .worldVertices and sets .worldVerticesNeedsUpdate to false.
 * @method computeWorldFaceNormals
 * @param  {Quaternion} quat
 */
ConvexPolyhedron.prototype.computeWorldFaceNormals = function(quat){
    var N = this.faceNormals.length;
    while(this.worldFaceNormals.length < N){
        this.worldFaceNormals.push( new Vec3() );
    }

    var normals = this.faceNormals,
        worldNormals = this.worldFaceNormals;
    for(var i=0; i!==N; i++){
        quat.vmult( normals[i] , worldNormals[i] );
    }

    this.worldFaceNormalsNeedsUpdate = false;
};

/**
 * @method updateBoundingSphereRadius
 */
ConvexPolyhedron.prototype.updateBoundingSphereRadius = function(){
    // Assume points are distributed with local (0,0,0) as center
    var max2 = 0;
    var verts = this.vertices;
    for(var i=0, N=verts.length; i!==N; i++) {
        var norm2 = verts[i].norm2();
        if(norm2 > max2){
            max2 = norm2;
        }
    }
    this.boundingSphereRadius = Math.sqrt(max2);
};

var tempWorldVertex = new Vec3();

/**
 * @method calculateWorldAABB
 * @param {Vec3}        pos
 * @param {Quaternion}  quat
 * @param {Vec3}        min
 * @param {Vec3}        max
 */
ConvexPolyhedron.prototype.calculateWorldAABB = function(pos,quat,min,max){
    var n = this.vertices.length, verts = this.vertices;
    var minx,miny,minz,maxx,maxy,maxz;
    for(var i=0; i<n; i++){
        tempWorldVertex.copy(verts[i]);
        quat.vmult(tempWorldVertex,tempWorldVertex);
        pos.vadd(tempWorldVertex,tempWorldVertex);
        var v = tempWorldVertex;
        if     (v.x < minx || minx===undefined){
            minx = v.x;
        } else if(v.x > maxx || maxx===undefined){
            maxx = v.x;
        }

        if     (v.y < miny || miny===undefined){
            miny = v.y;
        } else if(v.y > maxy || maxy===undefined){
            maxy = v.y;
        }

        if     (v.z < minz || minz===undefined){
            minz = v.z;
        } else if(v.z > maxz || maxz===undefined){
            maxz = v.z;
        }
    }
    min.set(minx,miny,minz);
    max.set(maxx,maxy,maxz);
};

/**
 * Get approximate convex volume
 * @method volume
 * @return {Number}
 */
ConvexPolyhedron.prototype.volume = function(){
    return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
};

/**
 * Get an average of all the vertices positions
 * @method getAveragePointLocal
 * @param  {Vec3} target
 * @return {Vec3}
 */
ConvexPolyhedron.prototype.getAveragePointLocal = function(target){
    target = target || new Vec3();
    var n = this.vertices.length,
        verts = this.vertices;
    for(var i=0; i<n; i++){
        target.vadd(verts[i],target);
    }
    target.mult(1/n,target);
    return target;
};

/**
 * Transform all local points. Will change the .vertices
 * @method transformAllPoints
 * @param  {Vec3} offset
 * @param  {Quaternion} quat
 */
ConvexPolyhedron.prototype.transformAllPoints = function(offset,quat){
    var n = this.vertices.length,
        verts = this.vertices;

    // Apply rotation
    if(quat){
        // Rotate vertices
        for(var i=0; i<n; i++){
            var v = verts[i];
            quat.vmult(v,v);
        }
        // Rotate face normals
        for(var i=0; i<this.faceNormals.length; i++){
            var v = this.faceNormals[i];
            quat.vmult(v,v);
        }
        /*
        // Rotate edges
        for(var i=0; i<this.uniqueEdges.length; i++){
            var v = this.uniqueEdges[i];
            quat.vmult(v,v);
        }*/
    }

    // Apply offset
    if(offset){
        for(var i=0; i<n; i++){
            var v = verts[i];
            v.vadd(offset,v);
        }
    }
};

/**
 * Checks whether p is inside the polyhedra. Must be in local coords. The point lies outside of the convex hull of the other points if and only if the direction of all the vectors from it to those other points are on less than one half of a sphere around it.
 * @method pointIsInside
 * @param  {Vec3} p      A point given in local coordinates
 * @return {Boolean}
 */
var ConvexPolyhedron_pointIsInside = new Vec3();
var ConvexPolyhedron_vToP = new Vec3();
var ConvexPolyhedron_vToPointInside = new Vec3();
ConvexPolyhedron.prototype.pointIsInside = function(p){
    var n = this.vertices.length,
        verts = this.vertices,
        faces = this.faces,
        normals = this.faceNormals;
    var positiveResult = null;
    var N = this.faces.length;
    var pointInside = ConvexPolyhedron_pointIsInside;
    this.getAveragePointLocal(pointInside);
    for(var i=0; i<N; i++){
        var numVertices = this.faces[i].length;
        var n = normals[i];
        var v = verts[faces[i][0]]; // We only need one point in the face

        // This dot product determines which side of the edge the point is
        var vToP = ConvexPolyhedron_vToP;
        p.vsub(v,vToP);
        var r1 = n.dot(vToP);

        var vToPointInside = ConvexPolyhedron_vToPointInside;
        pointInside.vsub(v,vToPointInside);
        var r2 = n.dot(vToPointInside);

        if((r1<0 && r2>0) || (r1>0 && r2<0)){
            return false; // Encountered some other sign. Exit.
        } else {
        }
    }

    // If we got here, all dot products were of the same sign.
    return positiveResult ? 1 : -1;
};

/**
 * Get max and min dot product of a convex hull at position (pos,quat) projected onto an axis. Results are saved in the array maxmin.
 * @static
 * @method project
 * @param {ConvexPolyhedron} hull
 * @param {Vec3} axis
 * @param {Vec3} pos
 * @param {Quaternion} quat
 * @param {array} result result[0] and result[1] will be set to maximum and minimum, respectively.
 */
var project_worldVertex = new Vec3();
var project_localAxis = new Vec3();
var project_localOrigin = new Vec3();
ConvexPolyhedron.project = function(hull, axis, pos, quat, result){
    var n = hull.vertices.length,
        worldVertex = project_worldVertex,
        localAxis = project_localAxis,
        max = 0,
        min = 0,
        localOrigin = project_localOrigin,
        vs = hull.vertices;

    localOrigin.setZero();

    // Transform the axis to local
    Transform.vectorToLocalFrame(pos, quat, axis, localAxis);
    Transform.pointToLocalFrame(pos, quat, localOrigin, localOrigin);
    var add = localOrigin.dot(localAxis);

    min = max = vs[0].dot(localAxis);

    for(var i = 1; i < n; i++){
        var val = vs[i].dot(localAxis);

        if(val > max){
            max = val;
        }

        if(val < min){
            min = val;
        }
    }

    min -= add;
    max -= add;

    if(min > max){
        // Inconsistent - swap
        var temp = min;
        min = max;
        max = temp;
    }
    // Output
    result[0] = max;
    result[1] = min;
};

},{"../math/Quaternion":28,"../math/Transform":29,"../math/Vec3":30,"./Shape":43}],39:[function(_dereq_,module,exports){
module.exports = Cylinder;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var ConvexPolyhedron = _dereq_('./ConvexPolyhedron');

/**
 * @class Cylinder
 * @constructor
 * @extends ConvexPolyhedron
 * @author schteppe / https://github.com/schteppe
 * @param {Number} radiusTop
 * @param {Number} radiusBottom
 * @param {Number} height
 * @param {Number} numSegments The number of segments to build the cylinder out of
 */
function Cylinder( radiusTop, radiusBottom, height , numSegments ) {
    var N = numSegments,
        verts = [],
        axes = [],
        faces = [],
        bottomface = [],
        topface = [],
        cos = Math.cos,
        sin = Math.sin;

    // First bottom point
    verts.push(new Vec3(radiusBottom*cos(0),
                               radiusBottom*sin(0),
                               -height*0.5));
    bottomface.push(0);

    // First top point
    verts.push(new Vec3(radiusTop*cos(0),
                               radiusTop*sin(0),
                               height*0.5));
    topface.push(1);

    for(var i=0; i<N; i++){
        var theta = 2*Math.PI/N * (i+1);
        var thetaN = 2*Math.PI/N * (i+0.5);
        if(i<N-1){
            // Bottom
            verts.push(new Vec3(radiusBottom*cos(theta),
                                       radiusBottom*sin(theta),
                                       -height*0.5));
            bottomface.push(2*i+2);
            // Top
            verts.push(new Vec3(radiusTop*cos(theta),
                                       radiusTop*sin(theta),
                                       height*0.5));
            topface.push(2*i+3);

            // Face
            faces.push([2*i+2, 2*i+3, 2*i+1,2*i]);
        } else {
            faces.push([0,1, 2*i+1, 2*i]); // Connect
        }

        // Axis: we can cut off half of them if we have even number of segments
        if(N % 2 === 1 || i < N / 2){
            axes.push(new Vec3(cos(thetaN), sin(thetaN), 0));
        }
    }
    faces.push(topface);
    axes.push(new Vec3(0,0,1));

    // Reorder bottom face
    var temp = [];
    for(var i=0; i<bottomface.length; i++){
        temp.push(bottomface[bottomface.length - i - 1]);
    }
    faces.push(temp);

    this.type = Shape.types.CONVEXPOLYHEDRON;
    ConvexPolyhedron.call( this, verts, faces, axes );
}

Cylinder.prototype = new ConvexPolyhedron();

},{"../math/Quaternion":28,"../math/Vec3":30,"./ConvexPolyhedron":38,"./Shape":43}],40:[function(_dereq_,module,exports){
var Shape = _dereq_('./Shape');
var ConvexPolyhedron = _dereq_('./ConvexPolyhedron');
var Vec3 = _dereq_('../math/Vec3');
var Utils = _dereq_('../utils/Utils');

module.exports = Heightfield;

/**
 * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a given distance.
 * @class Heightfield
 * @extends Shape
 * @constructor
 * @param {Array} data An array of Y values that will be used to construct the terrain.
 * @param {object} options
 * @param {Number} [options.minValue] Minimum value of the data points in the data array. Will be computed automatically if not given.
 * @param {Number} [options.maxValue] Maximum value.
 * @param {Number} [options.elementSize=0.1] World spacing between the data points in X direction.
 * @todo Should be possible to use along all axes, not just y
 *
 * @example
 *     // Generate some height data (y-values).
 *     var data = [];
 *     for(var i = 0; i < 1000; i++){
 *         var y = 0.5 * Math.cos(0.2 * i);
 *         data.push(y);
 *     }
 *
 *     // Create the heightfield shape
 *     var heightfieldShape = new Heightfield(data, {
 *         elementSize: 1 // Distance between the data points in X and Y directions
 *     });
 *     var heightfieldBody = new Body();
 *     heightfieldBody.addShape(heightfieldShape);
 *     world.addBody(heightfieldBody);
 */
function Heightfield(data, options){
    options = Utils.defaults(options, {
        maxValue : null,
        minValue : null,
        elementSize : 1
    });

    /**
     * An array of numbers, or height values, that are spread out along the x axis.
     * @property {array} data
     */
    this.data = data;

    /**
     * Max value of the data
     * @property {number} maxValue
     */
    this.maxValue = options.maxValue;

    /**
     * Max value of the data
     * @property {number} minValue
     */
    this.minValue = options.minValue;

    /**
     * The width of each element
     * @property {number} elementSize
     * @todo elementSizeX and Y
     */
    this.elementSize = options.elementSize;

    if(options.minValue === null){
        this.updateMinValue();
    }
    if(options.maxValue === null){
        this.updateMaxValue();
    }

    this.cacheEnabled = true;

    Shape.call(this);

    this.pillarConvex = new ConvexPolyhedron();
    this.pillarOffset = new Vec3();

    this.type = Shape.types.HEIGHTFIELD;
    this.updateBoundingSphereRadius();

    // "i_j_isUpper" => { convex: ..., offset: ... }
    // for example:
    // _cachedPillars["0_2_1"]
    this._cachedPillars = {};
}
Heightfield.prototype = new Shape();

/**
 * Call whenever you change the data array.
 * @method update
 */
Heightfield.prototype.update = function(){
    this._cachedPillars = {};
};

/**
 * Update the .minValue property
 * @method updateMinValue
 */
Heightfield.prototype.updateMinValue = function(){
    var data = this.data;
    var minValue = data[0][0];
    for(var i=0; i !== data.length; i++){
        for(var j=0; j !== data[i].length; j++){
            var v = data[i][j];
            if(v < minValue){
                minValue = v;
            }
        }
    }
    this.minValue = minValue;
};

/**
 * Update the .maxValue property
 * @method updateMaxValue
 */
Heightfield.prototype.updateMaxValue = function(){
    var data = this.data;
    var maxValue = data[0][0];
    for(var i=0; i !== data.length; i++){
        for(var j=0; j !== data[i].length; j++){
            var v = data[i][j];
            if(v > maxValue){
                maxValue = v;
            }
        }
    }
    this.maxValue = maxValue;
};

/**
 * Set the height value at an index. Don't forget to update maxValue and minValue after you're done.
 * @method setHeightValueAtIndex
 * @param {integer} xi
 * @param {integer} yi
 * @param {number} value
 */
Heightfield.prototype.setHeightValueAtIndex = function(xi, yi, value){
    var data = this.data;
    data[xi][yi] = value;

    // Invalidate cache
    this.clearCachedConvexTrianglePillar(xi, yi, false);
    if(xi > 0){
        this.clearCachedConvexTrianglePillar(xi - 1, yi, true);
        this.clearCachedConvexTrianglePillar(xi - 1, yi, false);
    }
    if(yi > 0){
        this.clearCachedConvexTrianglePillar(xi, yi - 1, true);
        this.clearCachedConvexTrianglePillar(xi, yi - 1, false);
    }
    if(yi > 0 && xi > 0){
        this.clearCachedConvexTrianglePillar(xi - 1, yi - 1, true);
    }
};

/**
 * Get max/min in a rectangle in the matrix data
 * @method getRectMinMax
 * @param  {integer} iMinX
 * @param  {integer} iMinY
 * @param  {integer} iMaxX
 * @param  {integer} iMaxY
 * @param  {array} [result] An array to store the results in.
 * @return {array} The result array, if it was passed in. Minimum will be at position 0 and max at 1.
 */
Heightfield.prototype.getRectMinMax = function (iMinX, iMinY, iMaxX, iMaxY, result) {
    result = result || [];

    // Get max and min of the data
    var data = this.data,
        max = this.minValue; // Set first value
    for(var i = iMinX; i <= iMaxX; i++){
        for(var j = iMinY; j <= iMaxY; j++){
            var height = data[i][j];
            if(height > max){
                max = height;
            }
        }
    }

    result[0] = this.minValue;
    result[1] = max;
};

/**
 * Get the index of a local position on the heightfield. The indexes indicate the rectangles, so if your terrain is made of N x N height data points, you will have rectangle indexes ranging from 0 to N-1.
 * @method getIndexOfPosition
 * @param  {number} x
 * @param  {number} y
 * @param  {array} result Two-element array
 * @param  {boolean} clamp If the position should be clamped to the heightfield edge.
 * @return {boolean}
 */
Heightfield.prototype.getIndexOfPosition = function (x, y, result, clamp) {

    // Get the index of the data points to test against
    var w = this.elementSize;
    var data = this.data;
    var xi = Math.floor(x / w);
    var yi = Math.floor(y / w);

    result[0] = xi;
    result[1] = yi;

    if(clamp){
        // Clamp index to edges
        if(xi < 0){ xi = 0; }
        if(yi < 0){ yi = 0; }
        if(xi >= data.length - 1){ xi = data.length - 1; }
        if(yi >= data[0].length - 1){ yi = data[0].length - 1; }
    }

    // Bail out if we are out of the terrain
    if(xi < 0 || yi < 0 || xi >= data.length-1 || yi >= data[0].length-1){
        return false;
    }

    return true;
};

Heightfield.prototype.getHeightAt = function(x, y, edgeClamp){
    var idx = [];
    this.getIndexOfPosition(x, y, idx, edgeClamp);

    // TODO: get upper or lower triangle, then use barycentric interpolation to get the height in the triangle.
    var minmax = [];
    this.getRectMinMax(idx[0], idx[1] + 1, idx[0], idx[1] + 1, minmax);

    return (minmax[0] + minmax[1]) / 2; // average
};

Heightfield.prototype.getCacheConvexTrianglePillarKey = function(xi, yi, getUpperTriangle){
    return xi + '_' + yi + '_' + (getUpperTriangle ? 1 : 0);
};

Heightfield.prototype.getCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    return this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
};

Heightfield.prototype.setCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle, convex, offset){
    this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)] = {
        convex: convex,
        offset: offset
    };
};

Heightfield.prototype.clearCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    delete this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
};

/**
 * Get a triangle in the terrain in the form of a triangular convex shape.
 * @method getConvexTrianglePillar
 * @param  {integer} i
 * @param  {integer} j
 * @param  {boolean} getUpperTriangle
 */
Heightfield.prototype.getConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    var result = this.pillarConvex;
    var offsetResult = this.pillarOffset;

    if(this.cacheEnabled){
        var data = this.getCachedConvexTrianglePillar(xi, yi, getUpperTriangle);
        if(data){
            this.pillarConvex = data.convex;
            this.pillarOffset = data.offset;
            return;
        }

        result = new ConvexPolyhedron();
        offsetResult = new Vec3();

        this.pillarConvex = result;
        this.pillarOffset = offsetResult;
    }

    var data = this.data;
    var elementSize = this.elementSize;
    var faces = result.faces;

    // Reuse verts if possible
    result.vertices.length = 6;
    for (var i = 0; i < 6; i++) {
        if(!result.vertices[i]){
            result.vertices[i] = new Vec3();
        }
    }

    // Reuse faces if possible
    faces.length = 5;
    for (var i = 0; i < 5; i++) {
        if(!faces[i]){
            faces[i] = [];
        }
    }

    var verts = result.vertices;

    var h = (Math.min(
        data[xi][yi],
        data[xi+1][yi],
        data[xi][yi+1],
        data[xi+1][yi+1]
    ) - this.minValue ) / 2 + this.minValue;

    if (!getUpperTriangle) {

        // Center of the triangle pillar - all polygons are given relative to this one
        offsetResult.set(
            (xi + 0.25) * elementSize, // sort of center of a triangle
            (yi + 0.25) * elementSize,
            h // vertical center
        );

        // Top triangle verts
        verts[0].set(
            -0.25 * elementSize,
            -0.25 * elementSize,
            data[xi][yi] - h
        );
        verts[1].set(
            0.75 * elementSize,
            -0.25 * elementSize,
            data[xi + 1][yi] - h
        );
        verts[2].set(
            -0.25 * elementSize,
            0.75 * elementSize,
            data[xi][yi + 1] - h
        );

        // bottom triangle verts
        verts[3].set(
            -0.25 * elementSize,
            -0.25 * elementSize,
            -h-1
        );
        verts[4].set(
            0.75 * elementSize,
            -0.25 * elementSize,
            -h-1
        );
        verts[5].set(
            -0.25 * elementSize,
            0.75  * elementSize,
            -h-1
        );

        // top triangle
        faces[0][0] = 0;
        faces[0][1] = 1;
        faces[0][2] = 2;

        // bottom triangle
        faces[1][0] = 5;
        faces[1][1] = 4;
        faces[1][2] = 3;

        // -x facing quad
        faces[2][0] = 0;
        faces[2][1] = 2;
        faces[2][2] = 5;
        faces[2][3] = 3;

        // -y facing quad
        faces[3][0] = 1;
        faces[3][1] = 0;
        faces[3][2] = 3;
        faces[3][3] = 4;

        // +xy facing quad
        faces[4][0] = 4;
        faces[4][1] = 5;
        faces[4][2] = 2;
        faces[4][3] = 1;


    } else {

        // Center of the triangle pillar - all polygons are given relative to this one
        offsetResult.set(
            (xi + 0.75) * elementSize, // sort of center of a triangle
            (yi + 0.75) * elementSize,
            h // vertical center
        );

        // Top triangle verts
        verts[0].set(
            0.25 * elementSize,
            0.25 * elementSize,
            data[xi + 1][yi + 1] - h
        );
        verts[1].set(
            -0.75 * elementSize,
            0.25 * elementSize,
            data[xi][yi + 1] - h
        );
        verts[2].set(
            0.25 * elementSize,
            -0.75 * elementSize,
            data[xi + 1][yi] - h
        );

        // bottom triangle verts
        verts[3].set(
            0.25 * elementSize,
            0.25 * elementSize,
            - h-1
        );
        verts[4].set(
            -0.75 * elementSize,
            0.25 * elementSize,
            - h-1
        );
        verts[5].set(
            0.25 * elementSize,
            -0.75 * elementSize,
            - h-1
        );

        // Top triangle
        faces[0][0] = 0;
        faces[0][1] = 1;
        faces[0][2] = 2;

        // bottom triangle
        faces[1][0] = 5;
        faces[1][1] = 4;
        faces[1][2] = 3;

        // +x facing quad
        faces[2][0] = 2;
        faces[2][1] = 5;
        faces[2][2] = 3;
        faces[2][3] = 0;

        // +y facing quad
        faces[3][0] = 3;
        faces[3][1] = 4;
        faces[3][2] = 1;
        faces[3][3] = 0;

        // -xy facing quad
        faces[4][0] = 1;
        faces[4][1] = 4;
        faces[4][2] = 5;
        faces[4][3] = 2;
    }

    result.computeNormals();
    result.computeEdges();
    result.updateBoundingSphereRadius();

    this.setCachedConvexTrianglePillar(xi, yi, getUpperTriangle, result, offsetResult);
};

Heightfield.prototype.calculateLocalInertia = function(mass, target){
    target = target || new Vec3();
    target.set(0, 0, 0);
    return target;
};

Heightfield.prototype.volume = function(){
    return Number.MAX_VALUE; // The terrain is infinite
};

Heightfield.prototype.calculateWorldAABB = function(pos, quat, min, max){
    // TODO: do it properly
    min.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    max.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
};

Heightfield.prototype.updateBoundingSphereRadius = function(){
    // Use the bounding box of the min/max values
    var data = this.data,
        s = this.elementSize;
    this.boundingSphereRadius = new Vec3(data.length * s, data[0].length * s, Math.max(Math.abs(this.maxValue), Math.abs(this.minValue))).norm();
};

},{"../math/Vec3":30,"../utils/Utils":53,"./ConvexPolyhedron":38,"./Shape":43}],41:[function(_dereq_,module,exports){
module.exports = Particle;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');

/**
 * Particle shape.
 * @class Particle
 * @constructor
 * @author schteppe
 * @extends Shape
 */
function Particle(){
    Shape.call(this);

    this.type = Shape.types.PARTICLE;
}
Particle.prototype = new Shape();
Particle.prototype.constructor = Particle;

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3}
 */
Particle.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    target.set(0, 0, 0);
    return target;
};

Particle.prototype.volume = function(){
    return 0;
};

Particle.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = 0;
};

Particle.prototype.calculateWorldAABB = function(pos,quat,min,max){
    // Get each axis max
    min.copy(pos);
    max.copy(pos);
};

},{"../math/Vec3":30,"./Shape":43}],42:[function(_dereq_,module,exports){
module.exports = Plane;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');

/**
 * A plane, facing in the Z direction. The plane has its surface at z=0 and everything below z=0 is assumed to be solid plane. To make the plane face in some other direction than z, you must put it inside a RigidBody and rotate that body. See the demos.
 * @class Plane
 * @constructor
 * @extends Shape
 * @author schteppe
 */
function Plane(){
    Shape.call(this);
    this.type = Shape.types.PLANE;

    // World oriented normal
    this.worldNormal = new Vec3();
    this.worldNormalNeedsUpdate = true;

    this.boundingSphereRadius = Number.MAX_VALUE;
}
Plane.prototype = new Shape();
Plane.prototype.constructor = Plane;

Plane.prototype.computeWorldNormal = function(quat){
    var n = this.worldNormal;
    n.set(0,0,1);
    quat.vmult(n,n);
    this.worldNormalNeedsUpdate = false;
};

Plane.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    return target;
};

Plane.prototype.volume = function(){
    return Number.MAX_VALUE; // The plane is infinite...
};

var tempNormal = new Vec3();
Plane.prototype.calculateWorldAABB = function(pos, quat, min, max){
    // The plane AABB is infinite, except if the normal is pointing along any axis
    tempNormal.set(0,0,1); // Default plane normal is z
    quat.vmult(tempNormal,tempNormal);
    var maxVal = Number.MAX_VALUE;
    min.set(-maxVal, -maxVal, -maxVal);
    max.set(maxVal, maxVal, maxVal);

    if(tempNormal.x === 1){ max.x = pos.x; }
    if(tempNormal.y === 1){ max.y = pos.y; }
    if(tempNormal.z === 1){ max.z = pos.z; }

    if(tempNormal.x === -1){ min.x = pos.x; }
    if(tempNormal.y === -1){ min.y = pos.y; }
    if(tempNormal.z === -1){ min.z = pos.z; }
};

Plane.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = Number.MAX_VALUE;
};
},{"../math/Vec3":30,"./Shape":43}],43:[function(_dereq_,module,exports){
module.exports = Shape;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Material = _dereq_('../material/Material');

/**
 * Base class for shapes
 * @class Shape
 * @constructor
 * @author schteppe
 * @todo Should have a mechanism for caching bounding sphere radius instead of calculating it each time
 */
function Shape(){

    /**
     * Identifyer of the Shape.
     * @property {number} id
     */
    this.id = Shape.idCounter++;

    /**
     * The type of this shape. Must be set to an int > 0 by subclasses.
     * @property type
     * @type {Number}
     * @see Shape.types
     */
    this.type = 0;

    /**
     * The local bounding sphere radius of this shape.
     * @property {Number} boundingSphereRadius
     */
    this.boundingSphereRadius = 0;

    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled.
     * @property {boolean} collisionResponse
     */
    this.collisionResponse = true;

    /**
     * @property {Material} material
     */
    this.material = null;
}
Shape.prototype.constructor = Shape;

/**
 * Computes the bounding sphere radius. The result is stored in the property .boundingSphereRadius
 * @method updateBoundingSphereRadius
 * @return {Number}
 */
Shape.prototype.updateBoundingSphereRadius = function(){
    throw "computeBoundingSphereRadius() not implemented for shape type "+this.type;
};

/**
 * Get the volume of this shape
 * @method volume
 * @return {Number}
 */
Shape.prototype.volume = function(){
    throw "volume() not implemented for shape type "+this.type;
};

/**
 * Calculates the inertia in the local frame for this shape.
 * @method calculateLocalInertia
 * @return {Vec3}
 * @see http://en.wikipedia.org/wiki/List_of_moments_of_inertia
 */
Shape.prototype.calculateLocalInertia = function(mass,target){
    throw "calculateLocalInertia() not implemented for shape type "+this.type;
};

Shape.idCounter = 0;

/**
 * The available shape types.
 * @static
 * @property types
 * @type {Object}
 */
Shape.types = {
    SPHERE:1,
    PLANE:2,
    BOX:4,
    COMPOUND:8,
    CONVEXPOLYHEDRON:16,
    HEIGHTFIELD:32,
    PARTICLE:64,
    CYLINDER:128,
    TRIMESH:256
};


},{"../material/Material":25,"../math/Quaternion":28,"../math/Vec3":30,"./Shape":43}],44:[function(_dereq_,module,exports){
module.exports = Sphere;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');

/**
 * Spherical shape
 * @class Sphere
 * @constructor
 * @extends Shape
 * @param {Number} radius The radius of the sphere, a non-negative number.
 * @author schteppe / http://github.com/schteppe
 */
function Sphere(radius){
    Shape.call(this);

    /**
     * @property {Number} radius
     */
    this.radius = radius!==undefined ? Number(radius) : 1.0;
    this.type = Shape.types.SPHERE;

    if(this.radius < 0){
        throw new Error('The sphere radius cannot be negative.');
    }

    this.updateBoundingSphereRadius();
}
Sphere.prototype = new Shape();
Sphere.prototype.constructor = Sphere;

Sphere.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    var I = 2.0*mass*this.radius*this.radius/5.0;
    target.x = I;
    target.y = I;
    target.z = I;
    return target;
};

Sphere.prototype.volume = function(){
    return 4.0 * Math.PI * this.radius / 3.0;
};

Sphere.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = this.radius;
};

Sphere.prototype.calculateWorldAABB = function(pos,quat,min,max){
    var r = this.radius;
    var axes = ['x','y','z'];
    for(var i=0; i<axes.length; i++){
        var ax = axes[i];
        min[ax] = pos[ax] - r;
        max[ax] = pos[ax] + r;
    }
};

},{"../math/Vec3":30,"./Shape":43}],45:[function(_dereq_,module,exports){
module.exports = Trimesh;

var Shape = _dereq_('./Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Transform = _dereq_('../math/Transform');
var AABB = _dereq_('../collision/AABB');
var Octree = _dereq_('../utils/Octree');

/**
 * @class Trimesh
 * @constructor
 * @param {array} vertices
 * @param {array} indices
 * @extends Shape
 * @example
 *     // How to make a mesh with a single triangle
 *     var vertices = [
 *         0, 0, 0, // vertex 0
 *         1, 0, 0, // vertex 1
 *         0, 1, 0  // vertex 2
 *     ];
 *     var indices = [
 *         0, 1, 2  // triangle 0
 *     ];
 *     var trimeshShape = new Trimesh(vertices, indices);
 */
function Trimesh(vertices, indices) {
    Shape.call(this);
    this.type = Shape.types.TRIMESH;

    /**
     * @property vertices
     * @type {Array}
     */
    this.vertices = new Float32Array(vertices);

    /**
     * Array of integers, indicating which vertices each triangle consists of. The length of this array is thus 3 times the number of triangles.
     * @property indices
     * @type {Array}
     */
    this.indices = new Int16Array(indices);

    /**
     * The normals data.
     * @property normals
     * @type {Array}
     */
    this.normals = new Float32Array(indices.length);

    /**
     * The local AABB of the mesh.
     * @property aabb
     * @type {Array}
     */
    this.aabb = new AABB();

    /**
     * References to vertex pairs, making up all unique edges in the trimesh.
     * @property {array} edges
     */
    this.edges = null;

    /**
     * Local scaling of the mesh. Use .setScale() to set it.
     * @property {Vec3} scale
     */
    this.scale = new Vec3(1, 1, 1);

    /**
     * The indexed triangles. Use .updateTree() to update it.
     * @property {Octree} tree
     */
    this.tree = new Octree();

    this.updateEdges();
    this.updateNormals();
    this.updateAABB();
    this.updateBoundingSphereRadius();
    this.updateTree();
}
Trimesh.prototype = new Shape();
Trimesh.prototype.constructor = Trimesh;

var computeNormals_n = new Vec3();

/**
 * @method updateTree
 */
Trimesh.prototype.updateTree = function(){
    var tree = this.tree;

    tree.reset();
    tree.aabb.copy(this.aabb);
    var scale = this.scale; // The local mesh AABB is scaled, but the octree AABB should be unscaled
    tree.aabb.lowerBound.x *= 1 / scale.x;
    tree.aabb.lowerBound.y *= 1 / scale.y;
    tree.aabb.lowerBound.z *= 1 / scale.z;
    tree.aabb.upperBound.x *= 1 / scale.x;
    tree.aabb.upperBound.y *= 1 / scale.y;
    tree.aabb.upperBound.z *= 1 / scale.z;

    // Insert all triangles
    var triangleAABB = new AABB();
    var a = new Vec3();
    var b = new Vec3();
    var c = new Vec3();
    var points = [a, b, c];
    for (var i = 0; i < this.indices.length / 3; i++) {
        //this.getTriangleVertices(i, a, b, c);

        // Get unscaled triangle verts
        var i3 = i * 3;
        this._getUnscaledVertex(this.indices[i3], a);
        this._getUnscaledVertex(this.indices[i3 + 1], b);
        this._getUnscaledVertex(this.indices[i3 + 2], c);

        triangleAABB.setFromPoints(points);
        tree.insert(triangleAABB, i);
    }
    tree.removeEmptyNodes();
};

var unscaledAABB = new AABB();

/**
 * Get triangles in a local AABB from the trimesh.
 * @method getTrianglesInAABB
 * @param  {AABB} aabb
 * @param  {array} result An array of integers, referencing the queried triangles.
 */
Trimesh.prototype.getTrianglesInAABB = function(aabb, result){
    unscaledAABB.copy(aabb);

    // Scale it to local
    var scale = this.scale;
    var isx = scale.x;
    var isy = scale.y;
    var isz = scale.z;
    var l = unscaledAABB.lowerBound;
    var u = unscaledAABB.upperBound;
    l.x /= isx;
    l.y /= isy;
    l.z /= isz;
    u.x /= isx;
    u.y /= isy;
    u.z /= isz;

    return this.tree.aabbQuery(unscaledAABB, result);
};

/**
 * @method setScale
 * @param {Vec3} scale
 */
Trimesh.prototype.setScale = function(scale){
    var wasUniform = this.scale.x === this.scale.y === this.scale.z;
    var isUniform = scale.x === scale.y === scale.z;

    if(!(wasUniform && isUniform)){
        // Non-uniform scaling. Need to update normals.
        this.updateNormals();
    }
    this.scale.copy(scale);
    this.updateAABB();
    this.updateBoundingSphereRadius();
};

/**
 * Compute the normals of the faces. Will save in the .normals array.
 * @method updateNormals
 */
Trimesh.prototype.updateNormals = function(){
    var n = computeNormals_n;

    // Generate normals
    var normals = this.normals;
    for(var i=0; i < this.indices.length / 3; i++){
        var i3 = i * 3;

        var a = this.indices[i3],
            b = this.indices[i3 + 1],
            c = this.indices[i3 + 2];

        this.getVertex(a, va);
        this.getVertex(b, vb);
        this.getVertex(c, vc);

        Trimesh.computeNormal(vb, va, vc, n);

        normals[i3] = n.x;
        normals[i3 + 1] = n.y;
        normals[i3 + 2] = n.z;
    }
};

/**
 * Update the .edges property
 * @method updateEdges
 */
Trimesh.prototype.updateEdges = function(){
    var edges = {};
    var add = function(indexA, indexB){
        var key = a < b ? a + '_' + b : b + '_' + a;
        edges[key] = true;
    };
    for(var i=0; i < this.indices.length / 3; i++){
        var i3 = i * 3;
        var a = this.indices[i3],
            b = this.indices[i3 + 1],
            c = this.indices[i3 + 2];
        add(a,b);
        add(b,c);
        add(c,a);
    }
    var keys = Object.keys(edges);
    this.edges = new Int16Array(keys.length * 2);
    for (var i = 0; i < keys.length; i++) {
        var indices = keys[i].split('_');
        this.edges[2 * i] = parseInt(indices[0], 10);
        this.edges[2 * i + 1] = parseInt(indices[1], 10);
    }
};

/**
 * Get an edge vertex
 * @method getEdgeVertex
 * @param  {number} edgeIndex
 * @param  {number} firstOrSecond 0 or 1, depending on which one of the vertices you need.
 * @param  {Vec3} vertexStore Where to store the result
 */
Trimesh.prototype.getEdgeVertex = function(edgeIndex, firstOrSecond, vertexStore){
    var vertexIndex = this.edges[edgeIndex * 2 + (firstOrSecond ? 1 : 0)];
    this.getVertex(vertexIndex, vertexStore);
};

var getEdgeVector_va = new Vec3();
var getEdgeVector_vb = new Vec3();

/**
 * Get a vector along an edge.
 * @method getEdgeVector
 * @param  {number} edgeIndex
 * @param  {Vec3} vectorStore
 */
Trimesh.prototype.getEdgeVector = function(edgeIndex, vectorStore){
    var va = getEdgeVector_va;
    var vb = getEdgeVector_vb;
    this.getEdgeVertex(edgeIndex, 0, va);
    this.getEdgeVertex(edgeIndex, 1, vb);
    vb.vsub(va, vectorStore);
};

/**
 * Get face normal given 3 vertices
 * @static
 * @method computeNormal
 * @param {Vec3} va
 * @param {Vec3} vb
 * @param {Vec3} vc
 * @param {Vec3} target
 */
var cb = new Vec3();
var ab = new Vec3();
Trimesh.computeNormal = function ( va, vb, vc, target ) {
    vb.vsub(va,ab);
    vc.vsub(vb,cb);
    cb.cross(ab,target);
    if ( !target.isZero() ) {
        target.normalize();
    }
};

var va = new Vec3();
var vb = new Vec3();
var vc = new Vec3();

/**
 * Get vertex i.
 * @method getVertex
 * @param  {number} i
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype.getVertex = function(i, out){
    var scale = this.scale;
    this._getUnscaledVertex(i, out);
    out.x *= scale.x;
    out.y *= scale.y;
    out.z *= scale.z;
    return out;
};

/**
 * Get raw vertex i
 * @private
 * @method _getUnscaledVertex
 * @param  {number} i
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype._getUnscaledVertex = function(i, out){
    var i3 = i * 3;
    var vertices = this.vertices;
    return out.set(
        vertices[i3],
        vertices[i3 + 1],
        vertices[i3 + 2]
    );
};

/**
 * Get a vertex from the trimesh,transformed by the given position and quaternion.
 * @method getWorldVertex
 * @param  {number} i
 * @param  {Vec3} pos
 * @param  {Quaternion} quat
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype.getWorldVertex = function(i, pos, quat, out){
    this.getVertex(i, out);
    Transform.pointToWorldFrame(pos, quat, out, out);
    return out;
};

/**
 * Get the three vertices for triangle i.
 * @method getTriangleVertices
 * @param  {number} i
 * @param  {Vec3} a
 * @param  {Vec3} b
 * @param  {Vec3} c
 */
Trimesh.prototype.getTriangleVertices = function(i, a, b, c){
    var i3 = i * 3;
    this.getVertex(this.indices[i3], a);
    this.getVertex(this.indices[i3 + 1], b);
    this.getVertex(this.indices[i3 + 2], c);
};

/**
 * Compute the normal of triangle i.
 * @method getNormal
 * @param  {Number} i
 * @param  {Vec3} target
 * @return {Vec3} The "target" vector object
 */
Trimesh.prototype.getNormal = function(i, target){
    var i3 = i * 3;
    return target.set(
        this.normals[i3],
        this.normals[i3 + 1],
        this.normals[i3 + 2]
    );
};

var cli_aabb = new AABB();

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3} The "target" vector object
 */
Trimesh.prototype.calculateLocalInertia = function(mass,target){
    // Approximate with box inertia
    // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
    this.computeLocalAABB(cli_aabb);
    var x = cli_aabb.upperBound.x - cli_aabb.lowerBound.x,
        y = cli_aabb.upperBound.y - cli_aabb.lowerBound.y,
        z = cli_aabb.upperBound.z - cli_aabb.lowerBound.z;
    return target.set(
        1.0 / 12.0 * mass * ( 2*y*2*y + 2*z*2*z ),
        1.0 / 12.0 * mass * ( 2*x*2*x + 2*z*2*z ),
        1.0 / 12.0 * mass * ( 2*y*2*y + 2*x*2*x )
    );
};

var computeLocalAABB_worldVert = new Vec3();

/**
 * Compute the local AABB for the trimesh
 * @method computeLocalAABB
 * @param  {AABB} aabb
 */
Trimesh.prototype.computeLocalAABB = function(aabb){
    var l = aabb.lowerBound,
        u = aabb.upperBound,
        n = this.vertices.length,
        vertices = this.vertices,
        v = computeLocalAABB_worldVert;

    this.getVertex(0, v);
    l.copy(v);
    u.copy(v);

    for(var i=0; i !== n; i++){
        this.getVertex(i, v);

        if(v.x < l.x){
            l.x = v.x;
        } else if(v.x > u.x){
            u.x = v.x;
        }

        if(v.y < l.y){
            l.y = v.y;
        } else if(v.y > u.y){
            u.y = v.y;
        }

        if(v.z < l.z){
            l.z = v.z;
        } else if(v.z > u.z){
            u.z = v.z;
        }
    }
};


/**
 * Update the .aabb property
 * @method updateAABB
 */
Trimesh.prototype.updateAABB = function(){
    this.computeLocalAABB(this.aabb);
};

/**
 * Will update the .boundingSphereRadius property
 * @method updateBoundingSphereRadius
 */
Trimesh.prototype.updateBoundingSphereRadius = function(){
    // Assume points are distributed with local (0,0,0) as center
    var max2 = 0;
    var vertices = this.vertices;
    var v = new Vec3();
    for(var i=0, N=vertices.length / 3; i !== N; i++) {
        this.getVertex(i, v);
        var norm2 = v.norm2();
        if(norm2 > max2){
            max2 = norm2;
        }
    }
    this.boundingSphereRadius = Math.sqrt(max2);
};

var tempWorldVertex = new Vec3();
var calculateWorldAABB_frame = new Transform();
var calculateWorldAABB_aabb = new AABB();

/**
 * @method calculateWorldAABB
 * @param {Vec3}        pos
 * @param {Quaternion}  quat
 * @param {Vec3}        min
 * @param {Vec3}        max
 */
Trimesh.prototype.calculateWorldAABB = function(pos,quat,min,max){
    /*
    var n = this.vertices.length / 3,
        verts = this.vertices;
    var minx,miny,minz,maxx,maxy,maxz;

    var v = tempWorldVertex;
    for(var i=0; i<n; i++){
        this.getVertex(i, v);
        quat.vmult(v, v);
        pos.vadd(v, v);
        if (v.x < minx || minx===undefined){
            minx = v.x;
        } else if(v.x > maxx || maxx===undefined){
            maxx = v.x;
        }

        if (v.y < miny || miny===undefined){
            miny = v.y;
        } else if(v.y > maxy || maxy===undefined){
            maxy = v.y;
        }

        if (v.z < minz || minz===undefined){
            minz = v.z;
        } else if(v.z > maxz || maxz===undefined){
            maxz = v.z;
        }
    }
    min.set(minx,miny,minz);
    max.set(maxx,maxy,maxz);
    */

    // Faster approximation using local AABB
    var frame = calculateWorldAABB_frame;
    var result = calculateWorldAABB_aabb;
    frame.position = pos;
    frame.quaternion = quat;
    this.aabb.toWorldFrame(frame, result);
    min.copy(result.lowerBound);
    max.copy(result.upperBound);
};

/**
 * Get approximate volume
 * @method volume
 * @return {Number}
 */
Trimesh.prototype.volume = function(){
    return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
};

/**
 * Create a Trimesh instance, shaped as a torus.
 * @static
 * @method createTorus
 * @param  {number} [radius=1]
 * @param  {number} [tube=0.5]
 * @param  {number} [radialSegments=8]
 * @param  {number} [tubularSegments=6]
 * @param  {number} [arc=6.283185307179586]
 * @return {Trimesh} A torus
 */
Trimesh.createTorus = function (radius, tube, radialSegments, tubularSegments, arc) {
    radius = radius || 1;
    tube = tube || 0.5;
    radialSegments = radialSegments || 8;
    tubularSegments = tubularSegments || 6;
    arc = arc || Math.PI * 2;

    var vertices = [];
    var indices = [];

    for ( var j = 0; j <= radialSegments; j ++ ) {
        for ( var i = 0; i <= tubularSegments; i ++ ) {
            var u = i / tubularSegments * arc;
            var v = j / radialSegments * Math.PI * 2;

            var x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
            var y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
            var z = tube * Math.sin( v );

            vertices.push( x, y, z );
        }
    }

    for ( var j = 1; j <= radialSegments; j ++ ) {
        for ( var i = 1; i <= tubularSegments; i ++ ) {
            var a = ( tubularSegments + 1 ) * j + i - 1;
            var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
            var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
            var d = ( tubularSegments + 1 ) * j + i;

            indices.push(a, b, d);
            indices.push(b, c, d);
        }
    }

    return new Trimesh(vertices, indices);
};

},{"../collision/AABB":3,"../math/Quaternion":28,"../math/Transform":29,"../math/Vec3":30,"../utils/Octree":50,"./Shape":43}],46:[function(_dereq_,module,exports){
module.exports = GSSolver;

var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Solver = _dereq_('./Solver');

/**
 * Constraint equation Gauss-Seidel solver.
 * @class GSSolver
 * @constructor
 * @todo The spook parameters should be specified for each constraint, not globally.
 * @author schteppe / https://github.com/schteppe
 * @see https://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf
 * @extends Solver
 */
function GSSolver(){
    Solver.call(this);

    /**
     * The number of solver iterations determines quality of the constraints in the world. The more iterations, the more correct simulation. More iterations need more computations though. If you have a large gravity force in your world, you will need more iterations.
     * @property iterations
     * @type {Number}
     * @todo write more about solver and iterations in the wiki
     */
    this.iterations = 10;

    /**
     * When tolerance is reached, the system is assumed to be converged.
     * @property tolerance
     * @type {Number}
     */
    this.tolerance = 1e-7;
}
GSSolver.prototype = new Solver();

var GSSolver_solve_lambda = []; // Just temporary number holders that we want to reuse each solve.
var GSSolver_solve_invCs = [];
var GSSolver_solve_Bs = [];
GSSolver.prototype.solve = function(dt,world){
    var iter = 0,
        maxIter = this.iterations,
        tolSquared = this.tolerance*this.tolerance,
        equations = this.equations,
        Neq = equations.length,
        bodies = world.bodies,
        Nbodies = bodies.length,
        h = dt,
        q, B, invC, deltalambda, deltalambdaTot, GWlambda, lambdaj;

    // Update solve mass
    if(Neq !== 0){
        for(var i=0; i!==Nbodies; i++){
            bodies[i].updateSolveMassProperties();
        }
    }

    // Things that does not change during iteration can be computed once
    var invCs = GSSolver_solve_invCs,
        Bs = GSSolver_solve_Bs,
        lambda = GSSolver_solve_lambda;
    invCs.length = Neq;
    Bs.length = Neq;
    lambda.length = Neq;
    for(var i=0; i!==Neq; i++){
        var c = equations[i];
        lambda[i] = 0.0;
        Bs[i] = c.computeB(h);
        invCs[i] = 1.0 / c.computeC();
    }

    if(Neq !== 0){

        // Reset vlambda
        for(var i=0; i!==Nbodies; i++){
            var b=bodies[i],
                vlambda=b.vlambda,
                wlambda=b.wlambda;
            vlambda.set(0,0,0);
            if(wlambda){
                wlambda.set(0,0,0);
            }
        }

        // Iterate over equations
        for(iter=0; iter!==maxIter; iter++){

            // Accumulate the total error for each iteration.
            deltalambdaTot = 0.0;

            for(var j=0; j!==Neq; j++){

                var c = equations[j];

                // Compute iteration
                B = Bs[j];
                invC = invCs[j];
                lambdaj = lambda[j];
                GWlambda = c.computeGWlambda();
                deltalambda = invC * ( B - GWlambda - c.eps * lambdaj );

                // Clamp if we are not within the min/max interval
                if(lambdaj + deltalambda < c.minForce){
                    deltalambda = c.minForce - lambdaj;
                } else if(lambdaj + deltalambda > c.maxForce){
                    deltalambda = c.maxForce - lambdaj;
                }
                lambda[j] += deltalambda;

                deltalambdaTot += deltalambda > 0.0 ? deltalambda : -deltalambda; // abs(deltalambda)

                c.addToWlambda(deltalambda);
            }

            // If the total error is small enough - stop iterate
            if(deltalambdaTot*deltalambdaTot < tolSquared){
                break;
            }
        }

        // Add result to velocity
        for(var i=0; i!==Nbodies; i++){
            var b=bodies[i],
                v=b.velocity,
                w=b.angularVelocity;
            v.vadd(b.vlambda, v);
            if(w){
                w.vadd(b.wlambda, w);
            }
        }
    }

    return iter;
};

},{"../math/Quaternion":28,"../math/Vec3":30,"./Solver":47}],47:[function(_dereq_,module,exports){
module.exports = Solver;

/**
 * Constraint equation solver base class.
 * @class Solver
 * @constructor
 * @author schteppe / https://github.com/schteppe
 */
function Solver(){
    /**
     * All equations to be solved
     * @property {Array} equations
     */
    this.equations = [];
}

/**
 * Should be implemented in subclasses!
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */
Solver.prototype.solve = function(dt,world){
    // Should return the number of iterations done!
    return 0;
};

/**
 * Add an equation
 * @method addEquation
 * @param {Equation} eq
 */
Solver.prototype.addEquation = function(eq){
    if (eq.enabled) {
        this.equations.push(eq);
    }
};

/**
 * Remove an equation
 * @method removeEquation
 * @param {Equation} eq
 */
Solver.prototype.removeEquation = function(eq){
    var eqs = this.equations;
    var i = eqs.indexOf(eq);
    if(i !== -1){
        eqs.splice(i,1);
    }
};

/**
 * Add all equations
 * @method removeAllEquations
 */
Solver.prototype.removeAllEquations = function(){
    this.equations.length = 0;
};


},{}],48:[function(_dereq_,module,exports){
module.exports = SplitSolver;

var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var Solver = _dereq_('./Solver');
var Body = _dereq_('../objects/Body');

/**
 * Splits the equations into islands and solves them independently. Can improve performance.
 * @class SplitSolver
 * @constructor
 * @extends Solver
 * @param {Solver} subsolver
 */
function SplitSolver(subsolver){
    Solver.call(this);
    this.iterations = 10;
    this.tolerance = 1e-7;
    this.subsolver = subsolver;
    this.nodes = [];
    this.nodePool = [];

    // Create needed nodes, reuse if possible
    while(this.nodePool.length < 128){
        this.nodePool.push(this.createNode());
    }
}
SplitSolver.prototype = new Solver();

// Returns the number of subsystems
var SplitSolver_solve_nodes = []; // All allocated node objects
var SplitSolver_solve_nodePool = []; // All allocated node objects
var SplitSolver_solve_eqs = [];   // Temp array
var SplitSolver_solve_bds = [];   // Temp array
var SplitSolver_solve_dummyWorld = {bodies:[]}; // Temp object

var STATIC = Body.STATIC;
function getUnvisitedNode(nodes){
    var Nnodes = nodes.length;
    for(var i=0; i!==Nnodes; i++){
        var node = nodes[i];
        if(!node.visited && !(node.body.type & STATIC)){
            return node;
        }
    }
    return false;
}

var queue = [];
function bfs(root,visitFunc,bds,eqs){
    queue.push(root);
    root.visited = true;
    visitFunc(root,bds,eqs);
    while(queue.length) {
        var node = queue.pop();
        // Loop over unvisited child nodes
        var child;
        while((child = getUnvisitedNode(node.children))) {
            child.visited = true;
            visitFunc(child,bds,eqs);
            queue.push(child);
        }
    }
}

function visitFunc(node,bds,eqs){
    bds.push(node.body);
    var Neqs = node.eqs.length;
    for(var i=0; i!==Neqs; i++){
        var eq = node.eqs[i];
        if(eqs.indexOf(eq) === -1){
            eqs.push(eq);
        }
    }
}

SplitSolver.prototype.createNode = function(){
    return { body:null, children:[], eqs:[], visited:false };
};

/**
 * Solve the subsystems
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */
SplitSolver.prototype.solve = function(dt,world){
    var nodes=SplitSolver_solve_nodes,
        nodePool=this.nodePool,
        bodies=world.bodies,
        equations=this.equations,
        Neq=equations.length,
        Nbodies=bodies.length,
        subsolver=this.subsolver;

    // Create needed nodes, reuse if possible
    while(nodePool.length < Nbodies){
        nodePool.push(this.createNode());
    }
    nodes.length = Nbodies;
    for (var i = 0; i < Nbodies; i++) {
        nodes[i] = nodePool[i];
    }

    // Reset node values
    for(var i=0; i!==Nbodies; i++){
        var node = nodes[i];
        node.body = bodies[i];
        node.children.length = 0;
        node.eqs.length = 0;
        node.visited = false;
    }
    for(var k=0; k!==Neq; k++){
        var eq=equations[k],
            i=bodies.indexOf(eq.bi),
            j=bodies.indexOf(eq.bj),
            ni=nodes[i],
            nj=nodes[j];
        ni.children.push(nj);
        ni.eqs.push(eq);
        nj.children.push(ni);
        nj.eqs.push(eq);
    }

    var child, n=0, eqs=SplitSolver_solve_eqs;

    subsolver.tolerance = this.tolerance;
    subsolver.iterations = this.iterations;

    var dummyWorld = SplitSolver_solve_dummyWorld;
    while((child = getUnvisitedNode(nodes))){
        eqs.length = 0;
        dummyWorld.bodies.length = 0;
        bfs(child, visitFunc, dummyWorld.bodies, eqs);

        var Neqs = eqs.length;

        eqs = eqs.sort(sortById);

        for(var i=0; i!==Neqs; i++){
            subsolver.addEquation(eqs[i]);
        }

        var iter = subsolver.solve(dt,dummyWorld);
        subsolver.removeAllEquations();
        n++;
    }

    return n;
};

function sortById(a, b){
    return b.id - a.id;
}
},{"../math/Quaternion":28,"../math/Vec3":30,"../objects/Body":31,"./Solver":47}],49:[function(_dereq_,module,exports){
/**
 * Base class for objects that dispatches events.
 * @class EventTarget
 * @constructor
 */
var EventTarget = function () {

};

module.exports = EventTarget;

EventTarget.prototype = {
    constructor: EventTarget,

    /**
     * Add an event listener
     * @method addEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventTarget} The self object, for chainability.
     */
    addEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ this._listeners = {}; }
        var listeners = this._listeners;
        if ( listeners[ type ] === undefined ) {
            listeners[ type ] = [];
        }
        if ( listeners[ type ].indexOf( listener ) === - 1 ) {
            listeners[ type ].push( listener );
        }
        return this;
    },

    /**
     * Check if an event listener is added
     * @method hasEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {Boolean}
     */
    hasEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ return false; }
        var listeners = this._listeners;
        if ( listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1 ) {
            return true;
        }
        return false;
    },

    /**
     * Remove an event listener
     * @method removeEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventTarget} The self object, for chainability.
     */
    removeEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ return this; }
        var listeners = this._listeners;
        if ( listeners[type] === undefined ){ return this; }
        var index = listeners[ type ].indexOf( listener );
        if ( index !== - 1 ) {
            listeners[ type ].splice( index, 1 );
        }
        return this;
    },

    /**
     * Emit an event.
     * @method dispatchEvent
     * @param  {Object} event
     * @param  {String} event.type
     * @return {EventTarget} The self object, for chainability.
     */
    dispatchEvent: function ( event ) {
        if ( this._listeners === undefined ){ return this; }
        var listeners = this._listeners;
        var listenerArray = listeners[ event.type ];
        if ( listenerArray !== undefined ) {
            event.target = this;
            for ( var i = 0, l = listenerArray.length; i < l; i ++ ) {
                listenerArray[ i ].call( this, event );
            }
        }
        return this;
    }
};

},{}],50:[function(_dereq_,module,exports){
var AABB = _dereq_('../collision/AABB');
var Vec3 = _dereq_('../math/Vec3');

module.exports = Octree;

/**
 * @class OctreeNode
 * @param {object} [options]
 * @param {Octree} [options.root]
 * @param {AABB} [options.aabb]
 */
function OctreeNode(options){
    options = options || {};

    /**
     * The root node
     * @property {OctreeNode} root
     */
    this.root = options.root || null;

    /**
     * Boundary of this node
     * @property {AABB} aabb
     */
    this.aabb = options.aabb ? options.aabb.clone() : new AABB();

    /**
     * Contained data at the current node level.
     * @property {Array} data
     */
    this.data = [];

    /**
     * Children to this node
     * @property {Array} children
     */
    this.children = [];
}

/**
 * @class Octree
 * @param {AABB} aabb The total AABB of the tree
 * @param {object} [options]
 * @param {number} [options.maxDepth=8]
 * @extends OctreeNode
 */
function Octree(aabb, options){
    options = options || {};
    options.root = null;
    options.aabb = aabb;
    OctreeNode.call(this, options);

    /**
     * Maximum subdivision depth
     * @property {number} maxDepth
     */
    this.maxDepth = typeof(options.maxDepth) !== 'undefined' ? options.maxDepth : 8;
}
Octree.prototype = new OctreeNode();

OctreeNode.prototype.reset = function(aabb, options){
    this.children.length = this.data.length = 0;
};

/**
 * Insert data into this node
 * @method insert
 * @param  {AABB} aabb
 * @param  {object} elementData
 * @return {boolean} True if successful, otherwise false
 */
OctreeNode.prototype.insert = function(aabb, elementData, level){
    var nodeData = this.data;
    level = level || 0;

    // Ignore objects that do not belong in this node
    if (!this.aabb.contains(aabb)){
        return false; // object cannot be added
    }

    var children = this.children;

    if(level < (this.maxDepth || this.root.maxDepth)){
        // Subdivide if there are no children yet
        var subdivided = false;
        if (!children.length){
            this.subdivide();
            subdivided = true;
        }

        // add to whichever node will accept it
        for (var i = 0; i !== 8; i++) {
            if (children[i].insert(aabb, elementData, level + 1)){
                return true;
            }
        }

        if(subdivided){
            // No children accepted! Might as well just remove em since they contain none
            children.length = 0;
        }
    }

    // Too deep, or children didnt want it. add it in current node
    nodeData.push(elementData);

    return true;
};

var halfDiagonal = new Vec3();

/**
 * Create 8 equally sized children nodes and put them in the .children array.
 * @method subdivide
 */
OctreeNode.prototype.subdivide = function() {
    var aabb = this.aabb;
    var l = aabb.lowerBound;
    var u = aabb.upperBound;

    var children = this.children;

    children.push(
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,0,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,0,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,1,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,1,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,1,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,0,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,0,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,1,0) }) })
    );

    u.vsub(l, halfDiagonal);
    halfDiagonal.scale(0.5, halfDiagonal);

    var root = this.root || this;

    for (var i = 0; i !== 8; i++) {
        var child = children[i];

        // Set current node as root
        child.root = root;

        // Compute bounds
        var lowerBound = child.aabb.lowerBound;
        lowerBound.x *= halfDiagonal.x;
        lowerBound.y *= halfDiagonal.y;
        lowerBound.z *= halfDiagonal.z;

        lowerBound.vadd(l, lowerBound);

        // Upper bound is always lower bound + halfDiagonal
        lowerBound.vadd(halfDiagonal, child.aabb.upperBound);
    }
};

/**
 * Get all data, potentially within an AABB
 * @method aabbQuery
 * @param  {AABB} aabb
 * @param  {array} result
 * @return {array} The "result" object
 */
OctreeNode.prototype.aabbQuery = function(aabb, result) {

    var nodeData = this.data;

    // abort if the range does not intersect this node
    // if (!this.aabb.overlaps(aabb)){
    //     return result;
    // }

    // Add objects at this level
    // Array.prototype.push.apply(result, nodeData);

    // Add child data
    // @todo unwrap recursion into a queue / loop, that's faster in JS
    var children = this.children;


    // for (var i = 0, N = this.children.length; i !== N; i++) {
    //     children[i].aabbQuery(aabb, result);
    // }

    var queue = [this];
    while (queue.length) {
        var node = queue.pop();
        if (node.aabb.overlaps(aabb)){
            Array.prototype.push.apply(result, node.data);
        }
        Array.prototype.push.apply(queue, node.children);
    }

    return result;
};

var tmpAABB = new AABB();

/**
 * Get all data, potentially intersected by a ray.
 * @method rayQuery
 * @param  {Ray} ray
 * @param  {Transform} treeTransform
 * @param  {array} result
 * @return {array} The "result" object
 */
OctreeNode.prototype.rayQuery = function(ray, treeTransform, result) {

    // Use aabb query for now.
    // @todo implement real ray query which needs less lookups
    ray.getAABB(tmpAABB);
    tmpAABB.toLocalFrame(treeTransform, tmpAABB);
    this.aabbQuery(tmpAABB, result);

    return result;
};

/**
 * @method removeEmptyNodes
 */
OctreeNode.prototype.removeEmptyNodes = function() {
    var queue = [this];
    while (queue.length) {
        var node = queue.pop();
        for (var i = node.children.length - 1; i >= 0; i--) {
            if(!node.children[i].data.length){
                node.children.splice(i, 1);
            }
        }
        Array.prototype.push.apply(queue, node.children);
    }
};

},{"../collision/AABB":3,"../math/Vec3":30}],51:[function(_dereq_,module,exports){
module.exports = Pool;

/**
 * For pooling objects that can be reused.
 * @class Pool
 * @constructor
 */
function Pool(){
    /**
     * The pooled objects
     * @property {Array} objects
     */
    this.objects = [];

    /**
     * Constructor of the objects
     * @property {mixed} type
     */
    this.type = Object;
}

/**
 * Release an object after use
 * @method release
 * @param {Object} obj
 */
Pool.prototype.release = function(){
    var Nargs = arguments.length;
    for(var i=0; i!==Nargs; i++){
        this.objects.push(arguments[i]);
    }
};

/**
 * Get an object
 * @method get
 * @return {mixed}
 */
Pool.prototype.get = function(){
    if(this.objects.length===0){
        return this.constructObject();
    } else {
        return this.objects.pop();
    }
};

/**
 * Construct an object. Should be implmented in each subclass.
 * @method constructObject
 * @return {mixed}
 */
Pool.prototype.constructObject = function(){
    throw new Error("constructObject() not implemented in this Pool subclass yet!");
};

},{}],52:[function(_dereq_,module,exports){
module.exports = TupleDictionary;

/**
 * @class TupleDictionary
 * @constructor
 */
function TupleDictionary() {

    /**
     * The data storage
     * @property data
     * @type {Object}
     */
    this.data = { keys:[] };
}

/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
TupleDictionary.prototype.get = function(i, j) {
    if (i > j) {
        // swap
        var temp = j;
        j = i;
        i = temp;
    }
    return this.data[i+'-'+j];
};

/**
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */
TupleDictionary.prototype.set = function(i, j, value) {
    if (i > j) {
        var temp = j;
        j = i;
        i = temp;
    }
    var key = i+'-'+j;

    // Check if key already exists
    if(!this.get(i,j)){
        this.data.keys.push(key);
    }

    this.data[key] = value;
};

/**
 * @method reset
 */
TupleDictionary.prototype.reset = function() {
    var data = this.data,
        keys = data.keys;
    while(keys.length > 0){
        var key = keys.pop();
        delete data[key];
    }
};

},{}],53:[function(_dereq_,module,exports){
function Utils(){}

module.exports = Utils;

/**
 * Extend an options object with default values.
 * @static
 * @method defaults
 * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
 * @param  {object} defaults An object containing default values.
 * @return {object} The modified options object.
 */
Utils.defaults = function(options, defaults){
    options = options || {};

    for(var key in defaults){
        if(!(key in options)){
            options[key] = defaults[key];
        }
    }

    return options;
};

},{}],54:[function(_dereq_,module,exports){
module.exports = Vec3Pool;

var Vec3 = _dereq_('../math/Vec3');
var Pool = _dereq_('./Pool');

/**
 * @class Vec3Pool
 * @constructor
 * @extends Pool
 */
function Vec3Pool(){
    Pool.call(this);
    this.type = Vec3;
}
Vec3Pool.prototype = new Pool();

/**
 * Construct a vector
 * @method constructObject
 * @return {Vec3}
 */
Vec3Pool.prototype.constructObject = function(){
    return new Vec3();
};

},{"../math/Vec3":30,"./Pool":51}],55:[function(_dereq_,module,exports){
module.exports = Narrowphase;

var AABB = _dereq_('../collision/AABB');
var Shape = _dereq_('../shapes/Shape');
var Ray = _dereq_('../collision/Ray');
var Vec3 = _dereq_('../math/Vec3');
var Transform = _dereq_('../math/Transform');
var ConvexPolyhedron = _dereq_('../shapes/ConvexPolyhedron');
var Quaternion = _dereq_('../math/Quaternion');
var Solver = _dereq_('../solver/Solver');
var Vec3Pool = _dereq_('../utils/Vec3Pool');
var ContactEquation = _dereq_('../equations/ContactEquation');
var FrictionEquation = _dereq_('../equations/FrictionEquation');

/**
 * Helper class for the World. Generates ContactEquations.
 * @class Narrowphase
 * @constructor
 * @todo Sphere-ConvexPolyhedron contacts
 * @todo Contact reduction
 * @todo  should move methods to prototype
 */
function Narrowphase(world){

    /**
     * Internal storage of pooled contact points.
     * @property {Array} contactPointPool
     */
    this.contactPointPool = [];

    this.frictionEquationPool = [];

    this.result = [];
    this.frictionResult = [];

    /**
     * Pooled vectors.
     * @property {Vec3Pool} v3pool
     */
    this.v3pool = new Vec3Pool();

    this.world = world;
    this.currentContactMaterial = null;

    /**
     * @property {Boolean} enableFrictionReduction
     */
    this.enableFrictionReduction = false;
}

/**
 * Make a contact object, by using the internal pool or creating a new one.
 * @method createContactEquation
 * @return {ContactEquation}
 */
Narrowphase.prototype.createContactEquation = function(bi, bj, si, sj, rsi, rsj){
    var c;
    if(this.contactPointPool.length){
        c = this.contactPointPool.pop();
        c.bi = bi;
        c.bj = bj;
    } else {
        c = new ContactEquation(bi, bj);
    }

    c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;

    var cm = this.currentContactMaterial;

    c.restitution = cm.restitution;

    c.setSpookParams(
        cm.contactEquationStiffness,
        cm.contactEquationRelaxation,
        this.world.dt
    );

    var matA = si.material || bi.material;
    var matB = sj.material || bj.material;
    if(matA && matB && matA.restitution >= 0 && matB.restitution >= 0){
        c.restitution = matA.restitution * matB.restitution;
    }

    c.si = rsi || si;
    c.sj = rsj || sj;

    return c;
};

Narrowphase.prototype.createFrictionEquationsFromContact = function(contactEquation, outArray){
    var bodyA = contactEquation.bi;
    var bodyB = contactEquation.bj;
    var shapeA = contactEquation.si;
    var shapeB = contactEquation.sj;

    var world = this.world;
    var cm = this.currentContactMaterial;

    // If friction or restitution were specified in the material, use them
    var friction = cm.friction;
    var matA = shapeA.material || bodyA.material;
    var matB = shapeB.material || bodyB.material;
    if(matA && matB && matA.friction >= 0 && matB.friction >= 0){
        friction = matA.friction * matB.friction;
    }

    if(friction > 0){

        // Create 2 tangent equations
        var mug = friction * world.gravity.length();
        var reducedMass = (bodyA.invMass + bodyB.invMass);
        if(reducedMass > 0){
            reducedMass = 1/reducedMass;
        }
        var pool = this.frictionEquationPool;
        var c1 = pool.length ? pool.pop() : new FrictionEquation(bodyA,bodyB,mug*reducedMass);
        var c2 = pool.length ? pool.pop() : new FrictionEquation(bodyA,bodyB,mug*reducedMass);

        c1.bi = c2.bi = bodyA;
        c1.bj = c2.bj = bodyB;
        c1.minForce = c2.minForce = -mug*reducedMass;
        c1.maxForce = c2.maxForce = mug*reducedMass;

        // Copy over the relative vectors
        c1.ri.copy(contactEquation.ri);
        c1.rj.copy(contactEquation.rj);
        c2.ri.copy(contactEquation.ri);
        c2.rj.copy(contactEquation.rj);

        // Construct tangents
        contactEquation.ni.tangents(c1.t, c2.t);

        // Set spook params
        c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);
        c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);

        c1.enabled = c2.enabled = contactEquation.enabled;

        outArray.push(c1, c2);

        return true;
    }

    return false;
};

var averageNormal = new Vec3();
var averageContactPointA = new Vec3();
var averageContactPointB = new Vec3();

// Take the average N latest contact point on the plane.
Narrowphase.prototype.createFrictionFromAverage = function(numContacts){
    // The last contactEquation
    var c = this.result[this.result.length - 1];

    // Create the result: two "average" friction equations
    if (!this.createFrictionEquationsFromContact(c, this.frictionResult) || numContacts === 1) {
        return;
    }

    var f1 = this.frictionResult[this.frictionResult.length - 2];
    var f2 = this.frictionResult[this.frictionResult.length - 1];

    averageNormal.setZero();
    averageContactPointA.setZero();
    averageContactPointB.setZero();

    var bodyA = c.bi;
    var bodyB = c.bj;
    for(var i=0; i!==numContacts; i++){
        c = this.result[this.result.length - 1 - i];
        if(c.bodyA !== bodyA){
            averageNormal.vadd(c.ni, averageNormal); // vec2.add(eq.t, eq.t, c.normalA);
            averageContactPointA.vadd(c.ri, averageContactPointA); // vec2.add(eq.contactPointA, eq.contactPointA, c.contactPointA);
            averageContactPointB.vadd(c.rj, averageContactPointB);
        } else {
            averageNormal.vsub(c.ni, averageNormal); // vec2.sub(eq.t, eq.t, c.normalA);
            averageContactPointA.vadd(c.rj, averageContactPointA); // vec2.add(eq.contactPointA, eq.contactPointA, c.contactPointA);
            averageContactPointB.vadd(c.ri, averageContactPointB);
        }
    }

    var invNumContacts = 1 / numContacts;
    averageContactPointA.scale(invNumContacts, f1.ri); // vec2.scale(eq.contactPointA, eq.contactPointA, invNumContacts);
    averageContactPointB.scale(invNumContacts, f1.rj); // vec2.scale(eq.contactPointB, eq.contactPointB, invNumContacts);
    f2.ri.copy(f1.ri); // Should be the same
    f2.rj.copy(f1.rj);
    averageNormal.normalize();
    averageNormal.tangents(f1.t, f2.t);
    // return eq;
};


var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();
var tmpQuat1 = new Quaternion();
var tmpQuat2 = new Quaternion();

/**
 * Generate all contacts between a list of body pairs
 * @method getContacts
 * @param {array} p1 Array of body indices
 * @param {array} p2 Array of body indices
 * @param {World} world
 * @param {array} result Array to store generated contacts
 * @param {array} oldcontacts Optional. Array of reusable contact objects
 */
Narrowphase.prototype.getContacts = function(p1, p2, world, result, oldcontacts, frictionResult, frictionPool){
    // Save old contact objects
    this.contactPointPool = oldcontacts;
    this.frictionEquationPool = frictionPool;
    this.result = result;
    this.frictionResult = frictionResult;

    var qi = tmpQuat1;
    var qj = tmpQuat2;
    var xi = tmpVec1;
    var xj = tmpVec2;

    for(var k=0, N=p1.length; k!==N; k++){

        // Get current collision bodies
        var bi = p1[k],
            bj = p2[k];

        // Get contact material
        var bodyContactMaterial = null;
        if(bi.material && bj.material){
            bodyContactMaterial = world.getContactMaterial(bi.material,bj.material) || null;
        }

        for (var i = 0; i < bi.shapes.length; i++) {
            bi.quaternion.mult(bi.shapeOrientations[i], qi);
            bi.quaternion.vmult(bi.shapeOffsets[i], xi);
            xi.vadd(bi.position, xi);
            var si = bi.shapes[i];

            for (var j = 0; j < bj.shapes.length; j++) {

                // Compute world transform of shapes
                bj.quaternion.mult(bj.shapeOrientations[j], qj);
                bj.quaternion.vmult(bj.shapeOffsets[j], xj);
                xj.vadd(bj.position, xj);
                var sj = bj.shapes[j];

                if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
                    continue;
                }

                // Get collision material
                var shapeContactMaterial = null;
                if(si.material && sj.material){
                    shapeContactMaterial = world.getContactMaterial(si.material,sj.material) || null;
                }

                this.currentContactMaterial = shapeContactMaterial || bodyContactMaterial || world.defaultContactMaterial;

                // Get contacts
                var resolver = this[si.type | sj.type];
                if(resolver){
                    if (si.type < sj.type) {
                        resolver.call(this, si, sj, xi, xj, qi, qj, bi, bj, si, sj);
                    } else {
                        resolver.call(this, sj, si, xj, xi, qj, qi, bj, bi, si, sj);
                    }
                }
            }
        }
    }
};

var numWarnings = 0;
var maxWarnings = 10;

function warn(msg){
    if(numWarnings > maxWarnings){
        return;
    }

    numWarnings++;

    console.warn(msg);
}

Narrowphase.prototype[Shape.types.BOX | Shape.types.BOX] =
Narrowphase.prototype.boxBox = function(si,sj,xi,xj,qi,qj,bi,bj){
    si.convexPolyhedronRepresentation.material = si.material;
    sj.convexPolyhedronRepresentation.material = sj.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
    this.convexConvex(si.convexPolyhedronRepresentation,sj.convexPolyhedronRepresentation,xi,xj,qi,qj,bi,bj,si,sj);
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.boxConvex = function(si,sj,xi,xj,qi,qj,bi,bj){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    this.convexConvex(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj,si,sj);
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.PARTICLE] =
Narrowphase.prototype.boxParticle = function(si,sj,xi,xj,qi,qj,bi,bj){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    this.convexParticle(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj,si,sj);
};

/**
 * @method sphereSphere
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE] =
Narrowphase.prototype.sphereSphere = function(si,sj,xi,xj,qi,qj,bi,bj){
    // We will have only one contact in this case
    var r = this.createContactEquation(bi,bj,si,sj);

    // Contact normal
    xj.vsub(xi, r.ni);
    r.ni.normalize();

    // Contact point locations
    r.ri.copy(r.ni);
    r.rj.copy(r.ni);
    r.ri.mult(si.radius, r.ri);
    r.rj.mult(-sj.radius, r.rj);

    r.ri.vadd(xi, r.ri);
    r.ri.vsub(bi.position, r.ri);

    r.rj.vadd(xj, r.rj);
    r.rj.vsub(bj.position, r.rj);

    this.result.push(r);

    this.createFrictionEquationsFromContact(r, this.frictionResult);
};

/**
 * @method planeTrimesh
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
var planeTrimesh_normal = new Vec3();
var planeTrimesh_relpos = new Vec3();
var planeTrimesh_projected = new Vec3();
Narrowphase.prototype[Shape.types.PLANE | Shape.types.TRIMESH] =
Narrowphase.prototype.planeTrimesh = function(
    planeShape,
    trimeshShape,
    planePos,
    trimeshPos,
    planeQuat,
    trimeshQuat,
    planeBody,
    trimeshBody
){
    // Make contacts!
    var v = new Vec3();

    var normal = planeTrimesh_normal;
    normal.set(0,0,1);
    planeQuat.vmult(normal,normal); // Turn normal according to plane

    for(var i=0; i<trimeshShape.vertices.length / 3; i++){

        // Get world vertex from trimesh
        trimeshShape.getVertex(i, v);

        // Safe up
        var v2 = new Vec3();
        v2.copy(v);
        Transform.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v);

        // Check plane side
        var relpos = planeTrimesh_relpos;
        v.vsub(planePos, relpos);
        var dot = normal.dot(relpos);

        if(dot <= 0.0){
            var r = this.createContactEquation(planeBody,trimeshBody,planeShape,trimeshShape);

            r.ni.copy(normal); // Contact normal is the plane normal

            // Get vertex position projected on plane
            var projected = planeTrimesh_projected;
            normal.scale(relpos.dot(normal), projected);
            v.vsub(projected,projected);

            // ri is the projected world position minus plane position
            r.ri.copy(projected);
            r.ri.vsub(planeBody.position, r.ri);

            r.rj.copy(v);
            r.rj.vsub(trimeshBody.position, r.rj);

            // Store result
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }
};

/**
 * @method sphereTrimesh
 * @param  {Shape}      sphereShape
 * @param  {Shape}      trimeshShape
 * @param  {Vec3}       spherePos
 * @param  {Vec3}       trimeshPos
 * @param  {Quaternion} sphereQuat
 * @param  {Quaternion} trimeshQuat
 * @param  {Body}       sphereBody
 * @param  {Body}       trimeshBody
 */
var sphereTrimesh_normal = new Vec3();
var sphereTrimesh_relpos = new Vec3();
var sphereTrimesh_projected = new Vec3();
var sphereTrimesh_v = new Vec3();
var sphereTrimesh_v2 = new Vec3();
var sphereTrimesh_edgeVertexA = new Vec3();
var sphereTrimesh_edgeVertexB = new Vec3();
var sphereTrimesh_edgeVector = new Vec3();
var sphereTrimesh_edgeVectorUnit = new Vec3();
var sphereTrimesh_localSpherePos = new Vec3();
var sphereTrimesh_tmp = new Vec3();
var sphereTrimesh_va = new Vec3();
var sphereTrimesh_vb = new Vec3();
var sphereTrimesh_vc = new Vec3();
var sphereTrimesh_localSphereAABB = new AABB();
var sphereTrimesh_triangles = [];
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.TRIMESH] =
Narrowphase.prototype.sphereTrimesh = function (
    sphereShape,
    trimeshShape,
    spherePos,
    trimeshPos,
    sphereQuat,
    trimeshQuat,
    sphereBody,
    trimeshBody
) {

    var edgeVertexA = sphereTrimesh_edgeVertexA;
    var edgeVertexB = sphereTrimesh_edgeVertexB;
    var edgeVector = sphereTrimesh_edgeVector;
    var edgeVectorUnit = sphereTrimesh_edgeVectorUnit;
    var localSpherePos = sphereTrimesh_localSpherePos;
    var tmp = sphereTrimesh_tmp;
    var localSphereAABB = sphereTrimesh_localSphereAABB;
    var v2 = sphereTrimesh_v2;
    var relpos = sphereTrimesh_relpos;
    var triangles = sphereTrimesh_triangles;

    // Convert sphere position to local in the trimesh
    Transform.pointToLocalFrame(trimeshPos, trimeshQuat, spherePos, localSpherePos);

    // Get the aabb of the sphere locally in the trimesh
    var sphereRadius = sphereShape.radius;
    localSphereAABB.lowerBound.set(
        localSpherePos.x - sphereRadius,
        localSpherePos.y - sphereRadius,
        localSpherePos.z - sphereRadius
    );
    localSphereAABB.upperBound.set(
        localSpherePos.x + sphereRadius,
        localSpherePos.y + sphereRadius,
        localSpherePos.z + sphereRadius
    );

    trimeshShape.getTrianglesInAABB(localSphereAABB, triangles);
    //for (var i = 0; i < trimeshShape.indices.length / 3; i++) triangles.push(i); // All

    // Vertices
    var v = sphereTrimesh_v;
    var radiusSquared = sphereShape.radius * sphereShape.radius;
    for(var i=0; i<triangles.length; i++){
        for (var j = 0; j < 3; j++) {

            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], v);

            // Check vertex overlap in sphere
            v.vsub(localSpherePos, relpos);

            if(relpos.norm2() <= radiusSquared){

                // Safe up
                v2.copy(v);
                Transform.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v);

                v.vsub(spherePos, relpos);

                var r = this.createContactEquation(sphereBody,trimeshBody,sphereShape,trimeshShape);
                r.ni.copy(relpos);
                r.ni.normalize();

                // ri is the vector from sphere center to the sphere surface
                r.ri.copy(r.ni);
                r.ri.scale(sphereShape.radius, r.ri);
                r.ri.vadd(spherePos, r.ri);
                r.ri.vsub(sphereBody.position, r.ri);

                r.rj.copy(v);
                r.rj.vsub(trimeshBody.position, r.rj);

                // Store result
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
    }

    // Check all edges
    for(var i=0; i<triangles.length; i++){
        for (var j = 0; j < 3; j++) {

            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], edgeVertexA);
            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + ((j+1)%3)], edgeVertexB);
            edgeVertexB.vsub(edgeVertexA, edgeVector);

            // Project sphere position to the edge
            localSpherePos.vsub(edgeVertexB, tmp);
            var positionAlongEdgeB = tmp.dot(edgeVector);

            localSpherePos.vsub(edgeVertexA, tmp);
            var positionAlongEdgeA = tmp.dot(edgeVector);

            if(positionAlongEdgeA > 0 && positionAlongEdgeB < 0){

                // Now check the orthogonal distance from edge to sphere center
                localSpherePos.vsub(edgeVertexA, tmp);

                edgeVectorUnit.copy(edgeVector);
                edgeVectorUnit.normalize();
                positionAlongEdgeA = tmp.dot(edgeVectorUnit);

                edgeVectorUnit.scale(positionAlongEdgeA, tmp);
                tmp.vadd(edgeVertexA, tmp);

                // tmp is now the sphere center position projected to the edge, defined locally in the trimesh frame
                var dist = tmp.distanceTo(localSpherePos);
                if(dist < sphereShape.radius){
                    var r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape);

                    tmp.vsub(localSpherePos, r.ni);
                    r.ni.normalize();
                    r.ni.scale(sphereShape.radius, r.ri);

                    Transform.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
                    tmp.vsub(trimeshBody.position, r.rj);

                    Transform.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
                    Transform.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);

                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
    }

    // Triangle faces
    var va = sphereTrimesh_va;
    var vb = sphereTrimesh_vb;
    var vc = sphereTrimesh_vc;
    var normal = sphereTrimesh_normal;
    for(var i=0, N = triangles.length; i !== N; i++){
        trimeshShape.getTriangleVertices(triangles[i], va, vb, vc);
        trimeshShape.getNormal(triangles[i], normal);
        localSpherePos.vsub(va, tmp);
        var dist = tmp.dot(normal);
        normal.scale(dist, tmp);
        localSpherePos.vsub(tmp, tmp);

        // tmp is now the sphere position projected to the triangle plane
        dist = tmp.distanceTo(localSpherePos);
        if(Ray.pointInTriangle(tmp, va, vb, vc) && dist < sphereShape.radius){
            var r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape);

            tmp.vsub(localSpherePos, r.ni);
            r.ni.normalize();
            r.ni.scale(sphereShape.radius, r.ri);

            Transform.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
            tmp.vsub(trimeshBody.position, r.rj);

            Transform.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
            Transform.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }

    triangles.length = 0;
};

var point_on_plane_to_sphere = new Vec3();
var plane_to_sphere_ortho = new Vec3();

/**
 * @method spherePlane
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.PLANE] =
Narrowphase.prototype.spherePlane = function(si,sj,xi,xj,qi,qj,bi,bj){
    // We will have one contact in this case
    var r = this.createContactEquation(bi,bj,si,sj);

    // Contact normal
    r.ni.set(0,0,1);
    qj.vmult(r.ni, r.ni);
    r.ni.negate(r.ni); // body i is the sphere, flip normal
    r.ni.normalize(); // Needed?

    // Vector from sphere center to contact point
    r.ni.mult(si.radius, r.ri);

    // Project down sphere on plane
    xi.vsub(xj, point_on_plane_to_sphere);
    r.ni.mult(r.ni.dot(point_on_plane_to_sphere), plane_to_sphere_ortho);
    point_on_plane_to_sphere.vsub(plane_to_sphere_ortho,r.rj); // The sphere position projected to plane

    if(-point_on_plane_to_sphere.dot(r.ni) <= si.radius){

        // Make it relative to the body
        var ri = r.ri;
        var rj = r.rj;
        ri.vadd(xi, ri);
        ri.vsub(bi.position, ri);
        rj.vadd(xj, rj);
        rj.vsub(bj.position, rj);

        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

// See http://bulletphysics.com/Bullet/BulletFull/SphereTriangleDetector_8cpp_source.html
var pointInPolygon_edge = new Vec3();
var pointInPolygon_edge_x_normal = new Vec3();
var pointInPolygon_vtp = new Vec3();
function pointInPolygon(verts, normal, p){
    var positiveResult = null;
    var N = verts.length;
    for(var i=0; i!==N; i++){
        var v = verts[i];

        // Get edge to the next vertex
        var edge = pointInPolygon_edge;
        verts[(i+1) % (N)].vsub(v,edge);

        // Get cross product between polygon normal and the edge
        var edge_x_normal = pointInPolygon_edge_x_normal;
        //var edge_x_normal = new Vec3();
        edge.cross(normal,edge_x_normal);

        // Get vector between point and current vertex
        var vertex_to_p = pointInPolygon_vtp;
        p.vsub(v,vertex_to_p);

        // This dot product determines which side of the edge the point is
        var r = edge_x_normal.dot(vertex_to_p);

        // If all such dot products have same sign, we are inside the polygon.
        if(positiveResult===null || (r>0 && positiveResult===true) || (r<=0 && positiveResult===false)){
            if(positiveResult===null){
                positiveResult = r>0;
            }
            continue;
        } else {
            return false; // Encountered some other sign. Exit.
        }
    }

    // If we got here, all dot products were of the same sign.
    return true;
}

var box_to_sphere = new Vec3();
var sphereBox_ns = new Vec3();
var sphereBox_ns1 = new Vec3();
var sphereBox_ns2 = new Vec3();
var sphereBox_sides = [new Vec3(),new Vec3(),new Vec3(),new Vec3(),new Vec3(),new Vec3()];
var sphereBox_sphere_to_corner = new Vec3();
var sphereBox_side_ns = new Vec3();
var sphereBox_side_ns1 = new Vec3();
var sphereBox_side_ns2 = new Vec3();

/**
 * @method sphereBox
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.BOX] =
Narrowphase.prototype.sphereBox = function(si,sj,xi,xj,qi,qj,bi,bj){
    var v3pool = this.v3pool;

    // we refer to the box as body j
    var sides = sphereBox_sides;
    xi.vsub(xj,box_to_sphere);
    sj.getSideNormals(sides,qj);
    var R =     si.radius;
    var penetrating_sides = [];

    // Check side (plane) intersections
    var found = false;

    // Store the resulting side penetration info
    var side_ns = sphereBox_side_ns;
    var side_ns1 = sphereBox_side_ns1;
    var side_ns2 = sphereBox_side_ns2;
    var side_h = null;
    var side_penetrations = 0;
    var side_dot1 = 0;
    var side_dot2 = 0;
    var side_distance = null;
    for(var idx=0,nsides=sides.length; idx!==nsides && found===false; idx++){
        // Get the plane side normal (ns)
        var ns = sphereBox_ns;
        ns.copy(sides[idx]);

        var h = ns.norm();
        ns.normalize();

        // The normal/distance dot product tells which side of the plane we are
        var dot = box_to_sphere.dot(ns);

        if(dot<h+R && dot>0){
            // Intersects plane. Now check the other two dimensions
            var ns1 = sphereBox_ns1;
            var ns2 = sphereBox_ns2;
            ns1.copy(sides[(idx+1)%3]);
            ns2.copy(sides[(idx+2)%3]);
            var h1 = ns1.norm();
            var h2 = ns2.norm();
            ns1.normalize();
            ns2.normalize();
            var dot1 = box_to_sphere.dot(ns1);
            var dot2 = box_to_sphere.dot(ns2);
            if(dot1<h1 && dot1>-h1 && dot2<h2 && dot2>-h2){
                var dist = Math.abs(dot-h-R);
                if(side_distance===null || dist < side_distance){
                    side_distance = dist;
                    side_dot1 = dot1;
                    side_dot2 = dot2;
                    side_h = h;
                    side_ns.copy(ns);
                    side_ns1.copy(ns1);
                    side_ns2.copy(ns2);
                    side_penetrations++;
                }
            }
        }
    }
    if(side_penetrations){
        found = true;
        var r = this.createContactEquation(bi,bj,si,sj);
        side_ns.mult(-R,r.ri); // Sphere r
        r.ni.copy(side_ns);
        r.ni.negate(r.ni); // Normal should be out of sphere
        side_ns.mult(side_h,side_ns);
        side_ns1.mult(side_dot1,side_ns1);
        side_ns.vadd(side_ns1,side_ns);
        side_ns2.mult(side_dot2,side_ns2);
        side_ns.vadd(side_ns2,r.rj);

        // Make relative to bodies
        r.ri.vadd(xi, r.ri);
        r.ri.vsub(bi.position, r.ri);
        r.rj.vadd(xj, r.rj);
        r.rj.vsub(bj.position, r.rj);

        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }

    // Check corners
    var rj = v3pool.get();
    var sphere_to_corner = sphereBox_sphere_to_corner;
    for(var j=0; j!==2 && !found; j++){
        for(var k=0; k!==2 && !found; k++){
            for(var l=0; l!==2 && !found; l++){
                rj.set(0,0,0);
                if(j){
                    rj.vadd(sides[0],rj);
                } else {
                    rj.vsub(sides[0],rj);
                }
                if(k){
                    rj.vadd(sides[1],rj);
                } else {
                    rj.vsub(sides[1],rj);
                }
                if(l){
                    rj.vadd(sides[2],rj);
                } else {
                    rj.vsub(sides[2],rj);
                }

                // World position of corner
                xj.vadd(rj,sphere_to_corner);
                sphere_to_corner.vsub(xi,sphere_to_corner);

                if(sphere_to_corner.norm2() < R*R){
                    found = true;
                    var r = this.createContactEquation(bi,bj,si,sj);
                    r.ri.copy(sphere_to_corner);
                    r.ri.normalize();
                    r.ni.copy(r.ri);
                    r.ri.mult(R,r.ri);
                    r.rj.copy(rj);

                    // Make relative to bodies
                    r.ri.vadd(xi, r.ri);
                    r.ri.vsub(bi.position, r.ri);
                    r.rj.vadd(xj, r.rj);
                    r.rj.vsub(bj.position, r.rj);

                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
    }
    v3pool.release(rj);
    rj = null;

    // Check edges
    var edgeTangent = v3pool.get();
    var edgeCenter = v3pool.get();
    var r = v3pool.get(); // r = edge center to sphere center
    var orthogonal = v3pool.get();
    var dist = v3pool.get();
    var Nsides = sides.length;
    for(var j=0; j!==Nsides && !found; j++){
        for(var k=0; k!==Nsides && !found; k++){
            if(j%3 !== k%3){
                // Get edge tangent
                sides[k].cross(sides[j],edgeTangent);
                edgeTangent.normalize();
                sides[j].vadd(sides[k], edgeCenter);
                r.copy(xi);
                r.vsub(edgeCenter,r);
                r.vsub(xj,r);
                var orthonorm = r.dot(edgeTangent); // distance from edge center to sphere center in the tangent direction
                edgeTangent.mult(orthonorm,orthogonal); // Vector from edge center to sphere center in the tangent direction

                // Find the third side orthogonal to this one
                var l = 0;
                while(l===j%3 || l===k%3){
                    l++;
                }

                // vec from edge center to sphere projected to the plane orthogonal to the edge tangent
                dist.copy(xi);
                dist.vsub(orthogonal,dist);
                dist.vsub(edgeCenter,dist);
                dist.vsub(xj,dist);

                // Distances in tangent direction and distance in the plane orthogonal to it
                var tdist = Math.abs(orthonorm);
                var ndist = dist.norm();

                if(tdist < sides[l].norm() && ndist<R){
                    found = true;
                    var res = this.createContactEquation(bi,bj,si,sj);
                    edgeCenter.vadd(orthogonal,res.rj); // box rj
                    res.rj.copy(res.rj);
                    dist.negate(res.ni);
                    res.ni.normalize();

                    res.ri.copy(res.rj);
                    res.ri.vadd(xj,res.ri);
                    res.ri.vsub(xi,res.ri);
                    res.ri.normalize();
                    res.ri.mult(R,res.ri);

                    // Make relative to bodies
                    res.ri.vadd(xi, res.ri);
                    res.ri.vsub(bi.position, res.ri);
                    res.rj.vadd(xj, res.rj);
                    res.rj.vsub(bj.position, res.rj);

                    this.result.push(res);
                    this.createFrictionEquationsFromContact(res, this.frictionResult);
                }
            }
        }
    }
    v3pool.release(edgeTangent,edgeCenter,r,orthogonal,dist);
};

var convex_to_sphere = new Vec3();
var sphereConvex_edge = new Vec3();
var sphereConvex_edgeUnit = new Vec3();
var sphereConvex_sphereToCorner = new Vec3();
var sphereConvex_worldCorner = new Vec3();
var sphereConvex_worldNormal = new Vec3();
var sphereConvex_worldPoint = new Vec3();
var sphereConvex_worldSpherePointClosestToPlane = new Vec3();
var sphereConvex_penetrationVec = new Vec3();
var sphereConvex_sphereToWorldPoint = new Vec3();

/**
 * @method sphereConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.sphereConvex = function(si,sj,xi,xj,qi,qj,bi,bj){
    var v3pool = this.v3pool;
    xi.vsub(xj,convex_to_sphere);
    var normals = sj.faceNormals;
    var faces = sj.faces;
    var verts = sj.vertices;
    var R =     si.radius;
    var penetrating_sides = [];

    // if(convex_to_sphere.norm2() > si.boundingSphereRadius + sj.boundingSphereRadius){
    //     return;
    // }

    // Check corners
    for(var i=0; i!==verts.length; i++){
        var v = verts[i];

        // World position of corner
        var worldCorner = sphereConvex_worldCorner;
        qj.vmult(v,worldCorner);
        xj.vadd(worldCorner,worldCorner);
        var sphere_to_corner = sphereConvex_sphereToCorner;
        worldCorner.vsub(xi, sphere_to_corner);
        if(sphere_to_corner.norm2() < R * R){
            found = true;
            var r = this.createContactEquation(bi,bj,si,sj);
            r.ri.copy(sphere_to_corner);
            r.ri.normalize();
            r.ni.copy(r.ri);
            r.ri.mult(R,r.ri);
            worldCorner.vsub(xj,r.rj);

            // Should be relative to the body.
            r.ri.vadd(xi, r.ri);
            r.ri.vsub(bi.position, r.ri);

            // Should be relative to the body.
            r.rj.vadd(xj, r.rj);
            r.rj.vsub(bj.position, r.rj);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
            return;
        }
    }

    // Check side (plane) intersections
    var found = false;
    for(var i=0, nfaces=faces.length; i!==nfaces && found===false; i++){
        var normal = normals[i];
        var face = faces[i];

        // Get world-transformed normal of the face
        var worldNormal = sphereConvex_worldNormal;
        qj.vmult(normal,worldNormal);

        // Get a world vertex from the face
        var worldPoint = sphereConvex_worldPoint;
        qj.vmult(verts[face[0]],worldPoint);
        worldPoint.vadd(xj,worldPoint);

        // Get a point on the sphere, closest to the face normal
        var worldSpherePointClosestToPlane = sphereConvex_worldSpherePointClosestToPlane;
        worldNormal.mult(-R, worldSpherePointClosestToPlane);
        xi.vadd(worldSpherePointClosestToPlane, worldSpherePointClosestToPlane);

        // Vector from a face point to the closest point on the sphere
        var penetrationVec = sphereConvex_penetrationVec;
        worldSpherePointClosestToPlane.vsub(worldPoint,penetrationVec);

        // The penetration. Negative value means overlap.
        var penetration = penetrationVec.dot(worldNormal);

        var worldPointToSphere = sphereConvex_sphereToWorldPoint;
        xi.vsub(worldPoint, worldPointToSphere);

        if(penetration < 0 && worldPointToSphere.dot(worldNormal)>0){
            // Intersects plane. Now check if the sphere is inside the face polygon
            var faceVerts = []; // Face vertices, in world coords
            for(var j=0, Nverts=face.length; j!==Nverts; j++){
                var worldVertex = v3pool.get();
                qj.vmult(verts[face[j]], worldVertex);
                xj.vadd(worldVertex,worldVertex);
                faceVerts.push(worldVertex);
            }

            if(pointInPolygon(faceVerts,worldNormal,xi)){ // Is the sphere center in the face polygon?
                found = true;
                var r = this.createContactEquation(bi,bj,si,sj);

                worldNormal.mult(-R, r.ri); // Contact offset, from sphere center to contact
                worldNormal.negate(r.ni); // Normal pointing out of sphere

                var penetrationVec2 = v3pool.get();
                worldNormal.mult(-penetration, penetrationVec2);
                var penetrationSpherePoint = v3pool.get();
                worldNormal.mult(-R, penetrationSpherePoint);

                //xi.vsub(xj).vadd(penetrationSpherePoint).vadd(penetrationVec2 , r.rj);
                xi.vsub(xj,r.rj);
                r.rj.vadd(penetrationSpherePoint,r.rj);
                r.rj.vadd(penetrationVec2 , r.rj);

                // Should be relative to the body.
                r.rj.vadd(xj, r.rj);
                r.rj.vsub(bj.position, r.rj);

                // Should be relative to the body.
                r.ri.vadd(xi, r.ri);
                r.ri.vsub(bi.position, r.ri);

                v3pool.release(penetrationVec2);
                v3pool.release(penetrationSpherePoint);

                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);

                // Release world vertices
                for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                    v3pool.release(faceVerts[j]);
                }

                return; // We only expect *one* face contact
            } else {
                // Edge?
                for(var j=0; j!==face.length; j++){

                    // Get two world transformed vertices
                    var v1 = v3pool.get();
                    var v2 = v3pool.get();
                    qj.vmult(verts[face[(j+1)%face.length]], v1);
                    qj.vmult(verts[face[(j+2)%face.length]], v2);
                    xj.vadd(v1, v1);
                    xj.vadd(v2, v2);

                    // Construct edge vector
                    var edge = sphereConvex_edge;
                    v2.vsub(v1,edge);

                    // Construct the same vector, but normalized
                    var edgeUnit = sphereConvex_edgeUnit;
                    edge.unit(edgeUnit);

                    // p is xi projected onto the edge
                    var p = v3pool.get();
                    var v1_to_xi = v3pool.get();
                    xi.vsub(v1, v1_to_xi);
                    var dot = v1_to_xi.dot(edgeUnit);
                    edgeUnit.mult(dot, p);
                    p.vadd(v1, p);

                    // Compute a vector from p to the center of the sphere
                    var xi_to_p = v3pool.get();
                    p.vsub(xi, xi_to_p);

                    // Collision if the edge-sphere distance is less than the radius
                    // AND if p is in between v1 and v2
                    if(dot > 0 && dot*dot<edge.norm2() && xi_to_p.norm2() < R*R){ // Collision if the edge-sphere distance is less than the radius
                        // Edge contact!
                        var r = this.createContactEquation(bi,bj,si,sj);
                        p.vsub(xj,r.rj);

                        p.vsub(xi,r.ni);
                        r.ni.normalize();

                        r.ni.mult(R,r.ri);

                        // Should be relative to the body.
                        r.rj.vadd(xj, r.rj);
                        r.rj.vsub(bj.position, r.rj);

                        // Should be relative to the body.
                        r.ri.vadd(xi, r.ri);
                        r.ri.vsub(bi.position, r.ri);

                        this.result.push(r);
                        this.createFrictionEquationsFromContact(r, this.frictionResult);

                        // Release world vertices
                        for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                            v3pool.release(faceVerts[j]);
                        }

                        v3pool.release(v1);
                        v3pool.release(v2);
                        v3pool.release(p);
                        v3pool.release(xi_to_p);
                        v3pool.release(v1_to_xi);

                        return;
                    }

                    v3pool.release(v1);
                    v3pool.release(v2);
                    v3pool.release(p);
                    v3pool.release(xi_to_p);
                    v3pool.release(v1_to_xi);
                }
            }

            // Release world vertices
            for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                v3pool.release(faceVerts[j]);
            }
        }
    }
};

var planeBox_normal = new Vec3();
var plane_to_corner = new Vec3();

/**
 * @method planeBox
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.BOX] =
Narrowphase.prototype.planeBox = function(si,sj,xi,xj,qi,qj,bi,bj){
    sj.convexPolyhedronRepresentation.material = sj.material;
    sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
    this.planeConvex(si,sj.convexPolyhedronRepresentation,xi,xj,qi,qj,bi,bj);
};

var planeConvex_v = new Vec3();
var planeConvex_normal = new Vec3();
var planeConvex_relpos = new Vec3();
var planeConvex_projected = new Vec3();

/**
 * @method planeConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.planeConvex = function(
    planeShape,
    convexShape,
    planePosition,
    convexPosition,
    planeQuat,
    convexQuat,
    planeBody,
    convexBody
){
    // Simply return the points behind the plane.
    var worldVertex = planeConvex_v,
        worldNormal = planeConvex_normal;
    worldNormal.set(0,0,1);
    planeQuat.vmult(worldNormal,worldNormal); // Turn normal according to plane orientation

    var numContacts = 0;
    var relpos = planeConvex_relpos;
    for(var i = 0; i !== convexShape.vertices.length; i++){

        // Get world convex vertex
        worldVertex.copy(convexShape.vertices[i]);
        convexQuat.vmult(worldVertex, worldVertex);
        convexPosition.vadd(worldVertex, worldVertex);
        worldVertex.vsub(planePosition, relpos);

        var dot = worldNormal.dot(relpos);
        if(dot <= 0.0){

            var r = this.createContactEquation(planeBody, convexBody, planeShape, convexShape);

            // Get vertex position projected on plane
            var projected = planeConvex_projected;
            worldNormal.mult(worldNormal.dot(relpos),projected);
            worldVertex.vsub(projected, projected);
            projected.vsub(planePosition, r.ri); // From plane to vertex projected on plane

            r.ni.copy(worldNormal); // Contact normal is the plane normal out from plane

            // rj is now just the vector from the convex center to the vertex
            worldVertex.vsub(convexPosition, r.rj);

            // Make it relative to the body
            r.ri.vadd(planePosition, r.ri);
            r.ri.vsub(planeBody.position, r.ri);
            r.rj.vadd(convexPosition, r.rj);
            r.rj.vsub(convexBody.position, r.rj);

            this.result.push(r);
            numContacts++;
            if(!this.enableFrictionReduction){
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
    }

    if(this.enableFrictionReduction && numContacts){
        this.createFrictionFromAverage(numContacts);
    }
};

var convexConvex_sepAxis = new Vec3();
var convexConvex_q = new Vec3();

/**
 * @method convexConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.convexConvex = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,faceListA,faceListB){
    var sepAxis = convexConvex_sepAxis;

    if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
        return;
    }

    if(si.findSeparatingAxis(sj,xi,qi,xj,qj,sepAxis,faceListA,faceListB)){
        var res = [];
        var q = convexConvex_q;
        si.clipAgainstHull(xi,qi,sj,xj,qj,sepAxis,-100,100,res);
        var numContacts = 0;
        for(var j = 0; j !== res.length; j++){
            var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj),
                ri = r.ri,
                rj = r.rj;
            sepAxis.negate(r.ni);
            res[j].normal.negate(q);
            q.mult(res[j].depth, q);
            res[j].point.vadd(q, ri);
            rj.copy(res[j].point);

            // Contact points are in world coordinates. Transform back to relative
            ri.vsub(xi,ri);
            rj.vsub(xj,rj);

            // Make relative to bodies
            ri.vadd(xi, ri);
            ri.vsub(bi.position, ri);
            rj.vadd(xj, rj);
            rj.vsub(bj.position, rj);

            this.result.push(r);
            numContacts++;
            if(!this.enableFrictionReduction){
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
        if(this.enableFrictionReduction && numContacts){
            this.createFrictionFromAverage(numContacts);
        }
    }
};


/**
 * @method convexTrimesh
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
// Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON | Shape.types.TRIMESH] =
// Narrowphase.prototype.convexTrimesh = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,faceListA,faceListB){
//     var sepAxis = convexConvex_sepAxis;

//     if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
//         return;
//     }

//     // Construct a temp hull for each triangle
//     var hullB = new ConvexPolyhedron();

//     hullB.faces = [[0,1,2]];
//     var va = new Vec3();
//     var vb = new Vec3();
//     var vc = new Vec3();
//     hullB.vertices = [
//         va,
//         vb,
//         vc
//     ];

//     for (var i = 0; i < sj.indices.length / 3; i++) {

//         var triangleNormal = new Vec3();
//         sj.getNormal(i, triangleNormal);
//         hullB.faceNormals = [triangleNormal];

//         sj.getTriangleVertices(i, va, vb, vc);

//         var d = si.testSepAxis(triangleNormal, hullB, xi, qi, xj, qj);
//         if(!d){
//             triangleNormal.scale(-1, triangleNormal);
//             d = si.testSepAxis(triangleNormal, hullB, xi, qi, xj, qj);

//             if(!d){
//                 continue;
//             }
//         }

//         var res = [];
//         var q = convexConvex_q;
//         si.clipAgainstHull(xi,qi,hullB,xj,qj,triangleNormal,-100,100,res);
//         for(var j = 0; j !== res.length; j++){
//             var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj),
//                 ri = r.ri,
//                 rj = r.rj;
//             r.ni.copy(triangleNormal);
//             r.ni.negate(r.ni);
//             res[j].normal.negate(q);
//             q.mult(res[j].depth, q);
//             res[j].point.vadd(q, ri);
//             rj.copy(res[j].point);

//             // Contact points are in world coordinates. Transform back to relative
//             ri.vsub(xi,ri);
//             rj.vsub(xj,rj);

//             // Make relative to bodies
//             ri.vadd(xi, ri);
//             ri.vsub(bi.position, ri);
//             rj.vadd(xj, rj);
//             rj.vsub(bj.position, rj);

//             result.push(r);
//         }
//     }
// };

var particlePlane_normal = new Vec3();
var particlePlane_relpos = new Vec3();
var particlePlane_projected = new Vec3();

/**
 * @method particlePlane
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.PARTICLE] =
Narrowphase.prototype.planeParticle = function(sj,si,xj,xi,qj,qi,bj,bi){
    var normal = particlePlane_normal;
    normal.set(0,0,1);
    bj.quaternion.vmult(normal,normal); // Turn normal according to plane orientation
    var relpos = particlePlane_relpos;
    xi.vsub(bj.position,relpos);
    var dot = normal.dot(relpos);
    if(dot <= 0.0){
        var r = this.createContactEquation(bi,bj,si,sj);
        r.ni.copy(normal); // Contact normal is the plane normal
        r.ni.negate(r.ni);
        r.ri.set(0,0,0); // Center of particle

        // Get particle position projected on plane
        var projected = particlePlane_projected;
        normal.mult(normal.dot(xi),projected);
        xi.vsub(projected,projected);
        //projected.vadd(bj.position,projected);

        // rj is now the projected world position minus plane position
        r.rj.copy(projected);
        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

var particleSphere_normal = new Vec3();

/**
 * @method particleSphere
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PARTICLE | Shape.types.SPHERE] =
Narrowphase.prototype.sphereParticle = function(sj,si,xj,xi,qj,qi,bj,bi){
    // The normal is the unit vector from sphere center to particle center
    var normal = particleSphere_normal;
    normal.set(0,0,1);
    xi.vsub(xj,normal);
    var lengthSquared = normal.norm2();

    if(lengthSquared <= sj.radius * sj.radius){
        var r = this.createContactEquation(bi,bj,si,sj);
        normal.normalize();
        r.rj.copy(normal);
        r.rj.mult(sj.radius,r.rj);
        r.ni.copy(normal); // Contact normal
        r.ni.negate(r.ni);
        r.ri.set(0,0,0); // Center of particle
        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

// WIP
var cqj = new Quaternion();
var convexParticle_local = new Vec3();
var convexParticle_normal = new Vec3();
var convexParticle_penetratedFaceNormal = new Vec3();
var convexParticle_vertexToParticle = new Vec3();
var convexParticle_worldPenetrationVec = new Vec3();

/**
 * @method convexParticle
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PARTICLE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.convexParticle = function(sj,si,xj,xi,qj,qi,bj,bi){
    var penetratedFaceIndex = -1;
    var penetratedFaceNormal = convexParticle_penetratedFaceNormal;
    var worldPenetrationVec = convexParticle_worldPenetrationVec;
    var minPenetration = null;
    var numDetectedFaces = 0;

    // Convert particle position xi to local coords in the convex
    var local = convexParticle_local;
    local.copy(xi);
    local.vsub(xj,local); // Convert position to relative the convex origin
    qj.conjugate(cqj);
    cqj.vmult(local,local);

    if(sj.pointIsInside(local)){

        if(sj.worldVerticesNeedsUpdate){
            sj.computeWorldVertices(xj,qj);
        }
        if(sj.worldFaceNormalsNeedsUpdate){
            sj.computeWorldFaceNormals(qj);
        }

        // For each world polygon in the polyhedra
        for(var i=0,nfaces=sj.faces.length; i!==nfaces; i++){

            // Construct world face vertices
            var verts = [ sj.worldVertices[ sj.faces[i][0] ] ];
            var normal = sj.worldFaceNormals[i];

            // Check how much the particle penetrates the polygon plane.
            xi.vsub(verts[0],convexParticle_vertexToParticle);
            var penetration = -normal.dot(convexParticle_vertexToParticle);
            if(minPenetration===null || Math.abs(penetration)<Math.abs(minPenetration)){
                minPenetration = penetration;
                penetratedFaceIndex = i;
                penetratedFaceNormal.copy(normal);
                numDetectedFaces++;
            }
        }

        if(penetratedFaceIndex!==-1){
            // Setup contact
            var r = this.createContactEquation(bi,bj,si,sj);
            penetratedFaceNormal.mult(minPenetration, worldPenetrationVec);

            // rj is the particle position projected to the face
            worldPenetrationVec.vadd(xi,worldPenetrationVec);
            worldPenetrationVec.vsub(xj,worldPenetrationVec);
            r.rj.copy(worldPenetrationVec);
            //var projectedToFace = xi.vsub(xj).vadd(worldPenetrationVec);
            //projectedToFace.copy(r.rj);

            //qj.vmult(r.rj,r.rj);
            penetratedFaceNormal.negate( r.ni ); // Contact normal
            r.ri.set(0,0,0); // Center of particle

            var ri = r.ri,
                rj = r.rj;

            // Make relative to bodies
            ri.vadd(xi, ri);
            ri.vsub(bi.position, ri);
            rj.vadd(xj, rj);
            rj.vsub(bj.position, rj);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        } else {
            console.warn("Point found inside convex, but did not find penetrating face!");
        }
    }
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.boxHeightfield = function (si,sj,xi,xj,qi,qj,bi,bj){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    this.convexHeightfield(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj);
};

var convexHeightfield_tmp1 = new Vec3();
var convexHeightfield_tmp2 = new Vec3();
var convexHeightfield_faceList = [0];

/**
 * @method convexHeightfield
 */
Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.convexHeightfield = function (
    convexShape,
    hfShape,
    convexPos,
    hfPos,
    convexQuat,
    hfQuat,
    convexBody,
    hfBody
){
    var data = hfShape.data,
        w = hfShape.elementSize,
        radius = convexShape.boundingSphereRadius,
        worldPillarOffset = convexHeightfield_tmp2,
        faceList = convexHeightfield_faceList;

    // Get sphere position to heightfield local!
    var localConvexPos = convexHeightfield_tmp1;
    Transform.pointToLocalFrame(hfPos, hfQuat, convexPos, localConvexPos);

    // Get the index of the data points to test against
    var iMinX = Math.floor((localConvexPos.x - radius) / w) - 1,
        iMaxX = Math.ceil((localConvexPos.x + radius) / w) + 1,
        iMinY = Math.floor((localConvexPos.y - radius) / w) - 1,
        iMaxY = Math.ceil((localConvexPos.y + radius) / w) + 1;

    // Bail out if we are out of the terrain
    if(iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMinY > data[0].length){
        return;
    }

    // Clamp index to edges
    if(iMinX < 0){ iMinX = 0; }
    if(iMaxX < 0){ iMaxX = 0; }
    if(iMinY < 0){ iMinY = 0; }
    if(iMaxY < 0){ iMaxY = 0; }
    if(iMinX >= data.length){ iMinX = data.length - 1; }
    if(iMaxX >= data.length){ iMaxX = data.length - 1; }
    if(iMaxY >= data[0].length){ iMaxY = data[0].length - 1; }
    if(iMinY >= data[0].length){ iMinY = data[0].length - 1; }

    var minMax = [];
    hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
    var min = minMax[0];
    var max = minMax[1];

    // Bail out if we're cant touch the bounding height box
    if(localConvexPos.z - radius > max || localConvexPos.z + radius < min){
        return;
    }

    for(var i = iMinX; i < iMaxX; i++){
        for(var j = iMinY; j < iMaxY; j++){

            // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) {
                this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, faceList, null);
            }

            // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) {
                this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, faceList, null);
            }
        }
    }
};

var sphereHeightfield_tmp1 = new Vec3();
var sphereHeightfield_tmp2 = new Vec3();

/**
 * @method sphereHeightfield
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.sphereHeightfield = function (
    sphereShape,
    hfShape,
    spherePos,
    hfPos,
    sphereQuat,
    hfQuat,
    sphereBody,
    hfBody
){
    var data = hfShape.data,
        radius = sphereShape.radius,
        w = hfShape.elementSize,
        worldPillarOffset = sphereHeightfield_tmp2;

    // Get sphere position to heightfield local!
    var localSpherePos = sphereHeightfield_tmp1;
    Transform.pointToLocalFrame(hfPos, hfQuat, spherePos, localSpherePos);

    // Get the index of the data points to test against
    var iMinX = Math.floor((localSpherePos.x - radius) / w) - 1,
        iMaxX = Math.ceil((localSpherePos.x + radius) / w) + 1,
        iMinY = Math.floor((localSpherePos.y - radius) / w) - 1,
        iMaxY = Math.ceil((localSpherePos.y + radius) / w) + 1;

    // Bail out if we are out of the terrain
    if(iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMaxY > data[0].length){
        return;
    }

    // Clamp index to edges
    if(iMinX < 0){ iMinX = 0; }
    if(iMaxX < 0){ iMaxX = 0; }
    if(iMinY < 0){ iMinY = 0; }
    if(iMaxY < 0){ iMaxY = 0; }
    if(iMinX >= data.length){ iMinX = data.length - 1; }
    if(iMaxX >= data.length){ iMaxX = data.length - 1; }
    if(iMaxY >= data[0].length){ iMaxY = data[0].length - 1; }
    if(iMinY >= data[0].length){ iMinY = data[0].length - 1; }

    var minMax = [];
    hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
    var min = minMax[0];
    var max = minMax[1];

    // Bail out if we're cant touch the bounding height box
    if(localSpherePos.z - radius > max || localSpherePos.z + radius < min){
        return;
    }

    var result = this.result;
    for(var i = iMinX; i < iMaxX; i++){
        for(var j = iMinY; j < iMaxY; j++){

            var numContactsBefore = result.length;

            // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) {
                this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody);
            }

            // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) {
                this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody);
            }

            var numContacts = result.length - numContactsBefore;

            if(numContacts > 2){
                return;
            }
            /*
            // Skip all but 1
            for (var k = 0; k < numContacts - 1; k++) {
                result.pop();
            }
            */
        }
    }
};

},{"../collision/AABB":3,"../collision/Ray":9,"../equations/ContactEquation":19,"../equations/FrictionEquation":21,"../math/Quaternion":28,"../math/Transform":29,"../math/Vec3":30,"../shapes/ConvexPolyhedron":38,"../shapes/Shape":43,"../solver/Solver":47,"../utils/Vec3Pool":54}],56:[function(_dereq_,module,exports){
/* global performance */

module.exports = World;

var Shape = _dereq_('../shapes/Shape');
var Vec3 = _dereq_('../math/Vec3');
var Quaternion = _dereq_('../math/Quaternion');
var GSSolver = _dereq_('../solver/GSSolver');
var Vec3Pool = _dereq_('../utils/Vec3Pool');
var ContactEquation = _dereq_('../equations/ContactEquation');
var FrictionEquation = _dereq_('../equations/FrictionEquation');
var Narrowphase = _dereq_('./Narrowphase');
var EventTarget = _dereq_('../utils/EventTarget');
var ArrayCollisionMatrix = _dereq_('../collision/ArrayCollisionMatrix');
var Material = _dereq_('../material/Material');
var ContactMaterial = _dereq_('../material/ContactMaterial');
var Body = _dereq_('../objects/Body');
var TupleDictionary = _dereq_('../utils/TupleDictionary');
var RaycastResult = _dereq_('../collision/RaycastResult');
var AABB = _dereq_('../collision/AABB');
var Ray = _dereq_('../collision/Ray');
var NaiveBroadphase = _dereq_('../collision/NaiveBroadphase');

/**
 * The physics world
 * @class World
 * @constructor
 * @extends EventTarget
 */
function World(){
    EventTarget.apply(this);

    /**
     * Currently / last used timestep. Is set to -1 if not available. This value is updated before each internal step, which means that it is "fresh" inside event callbacks.
     * @property {Number} dt
     */
    this.dt = -1;

    /**
     * Makes bodies go to sleep when they've been inactive
     * @property allowSleep
     * @type {Boolean}
     */
    this.allowSleep = false;

    /**
     * All the current contacts (instances of ContactEquation) in the world.
     * @property contacts
     * @type {Array}
     */
    this.contacts = [];
    this.frictionEquations = [];

    /**
     * How often to normalize quaternions. Set to 0 for every step, 1 for every second etc.. A larger value increases performance. If bodies tend to explode, set to a smaller value (zero to be sure nothing can go wrong).
     * @property quatNormalizeSkip
     * @type {Number}
     */
    this.quatNormalizeSkip = 0;

    /**
     * Set to true to use fast quaternion normalization. It is often enough accurate to use. If bodies tend to explode, set to false.
     * @property quatNormalizeFast
     * @type {Boolean}
     * @see Quaternion.normalizeFast
     * @see Quaternion.normalize
     */
    this.quatNormalizeFast = false;

    /**
     * The wall-clock time since simulation start
     * @property time
     * @type {Number}
     */
    this.time = 0.0;

    /**
     * Number of timesteps taken since start
     * @property stepnumber
     * @type {Number}
     */
    this.stepnumber = 0;

    /// Default and last timestep sizes
    this.default_dt = 1/60;

    this.nextId = 0;
    /**
     * @property gravity
     * @type {Vec3}
     */
    this.gravity = new Vec3();

    /**
     * @property broadphase
     * @type {Broadphase}
     */
    this.broadphase = new NaiveBroadphase();

    /**
     * @property bodies
     * @type {Array}
     */
    this.bodies = [];

    /**
     * @property solver
     * @type {Solver}
     */
    this.solver = new GSSolver();

    /**
     * @property constraints
     * @type {Array}
     */
    this.constraints = [];

    /**
     * @property narrowphase
     * @type {Narrowphase}
     */
    this.narrowphase = new Narrowphase(this);

    /**
     * @property {ArrayCollisionMatrix} collisionMatrix
	 * @type {ArrayCollisionMatrix}
	 */
	this.collisionMatrix = new ArrayCollisionMatrix();

    /**
     * CollisionMatrix from the previous step.
     * @property {ArrayCollisionMatrix} collisionMatrixPrevious
	 * @type {ArrayCollisionMatrix}
	 */
	this.collisionMatrixPrevious = new ArrayCollisionMatrix();

    /**
     * All added materials
     * @property materials
     * @type {Array}
     */
    this.materials = [];

    /**
     * @property contactmaterials
     * @type {Array}
     */
    this.contactmaterials = [];

    /**
     * Used to look up a ContactMaterial given two instances of Material.
     * @property {TupleDictionary} contactMaterialTable
     */
    this.contactMaterialTable = new TupleDictionary();

    this.defaultMaterial = new Material("default");

    /**
     * This contact material is used if no suitable contactmaterial is found for a contact.
     * @property defaultContactMaterial
     * @type {ContactMaterial}
     */
    this.defaultContactMaterial = new ContactMaterial(this.defaultMaterial, this.defaultMaterial, { friction: 0.3, restitution: 0.0 });

    /**
     * @property doProfiling
     * @type {Boolean}
     */
    this.doProfiling = false;

    /**
     * @property profile
     * @type {Object}
     */
    this.profile = {
        solve:0,
        makeContactConstraints:0,
        broadphase:0,
        integrate:0,
        narrowphase:0,
    };

    /**
     * @property subsystems
     * @type {Array}
     */
    this.subsystems = [];

    this.addBodyEvent = {
        type:"addBody",
        body : null,
    };

    this.removeBodyEvent = {
        type:"removeBody",
        body : null,
    };
}
World.prototype = new EventTarget();

// Temp stuff
var tmpAABB1 = new AABB();
var tmpArray1 = [];
var tmpRay = new Ray();

/**
 * Get the contact material between materials m1 and m2
 * @method getContactMaterial
 * @param {Material} m1
 * @param {Material} m2
 * @return {ContactMaterial} The contact material if it was found.
 */
World.prototype.getContactMaterial = function(m1,m2){
    return this.contactMaterialTable.get(m1.id,m2.id); //this.contactmaterials[this.mats2cmat[i+j*this.materials.length]];
};

/**
 * Get number of objects in the world.
 * @method numObjects
 * @return {Number}
 * @deprecated
 */
World.prototype.numObjects = function(){
    return this.bodies.length;
};

/**
 * Store old collision state info
 * @method collisionMatrixTick
 */
World.prototype.collisionMatrixTick = function(){
	var temp = this.collisionMatrixPrevious;
	this.collisionMatrixPrevious = this.collisionMatrix;
	this.collisionMatrix = temp;
	this.collisionMatrix.reset();
};

/**
 * Add a rigid body to the simulation.
 * @method add
 * @param {Body} body
 * @todo If the simulation has not yet started, why recrete and copy arrays for each body? Accumulate in dynamic arrays in this case.
 * @todo Adding an array of bodies should be possible. This would save some loops too
 * @deprecated Use .addBody instead
 */
World.prototype.add = World.prototype.addBody = function(body){
    if(this.bodies.indexOf(body) !== -1){
        return;
    }
    body.index = this.bodies.length;
    this.bodies.push(body);
    body.world = this;
    body.initPosition.copy(body.position);
    body.initVelocity.copy(body.velocity);
    body.timeLastSleepy = this.time;
    if(body instanceof Body){
        body.initAngularVelocity.copy(body.angularVelocity);
        body.initQuaternion.copy(body.quaternion);
    }
	this.collisionMatrix.setNumObjects(this.bodies.length);
    this.addBodyEvent.body = body;
    this.dispatchEvent(this.addBodyEvent);
};

/**
 * Add a constraint to the simulation.
 * @method addConstraint
 * @param {Constraint} c
 */
World.prototype.addConstraint = function(c){
    this.constraints.push(c);
};

/**
 * Removes a constraint
 * @method removeConstraint
 * @param {Constraint} c
 */
World.prototype.removeConstraint = function(c){
    var idx = this.constraints.indexOf(c);
    if(idx!==-1){
        this.constraints.splice(idx,1);
    }
};

/**
 * Raycast test
 * @method rayTest
 * @param {Vec3} from
 * @param {Vec3} to
 * @param {Function|RaycastResult} result
 * @deprecated Use .raycastAll, .raycastClosest or .raycastAny instead.
 */
World.prototype.rayTest = function(from, to, result){
    if(result instanceof RaycastResult){
        // Do raycastclosest
        this.raycastClosest(from, to, {
            skipBackfaces: true
        }, result);
    } else {
        // Do raycastAll
        this.raycastAll(from, to, {
            skipBackfaces: true
        }, result);
    }
};

/**
 * Ray cast against all bodies. The provided callback will be executed for each hit with a RaycastResult as single argument.
 * @method raycastAll
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {Function} callback
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastAll = function(from, to, options, callback){
    options.mode = Ray.ALL;
    options.from = from;
    options.to = to;
    options.callback = callback;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Ray cast, and stop at the first result. Note that the order is random - but the method is fast.
 * @method raycastAny
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {RaycastResult} result
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastAny = function(from, to, options, result){
    options.mode = Ray.ANY;
    options.from = from;
    options.to = to;
    options.result = result;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Ray cast, and return information of the closest hit.
 * @method raycastClosest
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {RaycastResult} result
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastClosest = function(from, to, options, result){
    options.mode = Ray.CLOSEST;
    options.from = from;
    options.to = to;
    options.result = result;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Remove a rigid body from the simulation.
 * @method remove
 * @param {Body} body
 * @deprecated Use .removeBody instead
 */
World.prototype.remove = function(body){
    body.world = null;
    var n = this.bodies.length-1,
        bodies = this.bodies,
        idx = bodies.indexOf(body);
    if(idx !== -1){
        bodies.splice(idx, 1); // Todo: should use a garbage free method

        // Recompute index
        for(var i=0; i!==bodies.length; i++){
            bodies[i].index = i;
        }

        this.collisionMatrix.setNumObjects(n);
        this.removeBodyEvent.body = body;
        this.dispatchEvent(this.removeBodyEvent);
    }
};

/**
 * Remove a rigid body from the simulation.
 * @method removeBody
 * @param {Body} body
 */
World.prototype.removeBody = World.prototype.remove;

/**
 * Adds a material to the World.
 * @method addMaterial
 * @param {Material} m
 * @todo Necessary?
 */
World.prototype.addMaterial = function(m){
    this.materials.push(m);
};

/**
 * Adds a contact material to the World
 * @method addContactMaterial
 * @param {ContactMaterial} cmat
 */
World.prototype.addContactMaterial = function(cmat) {

    // Add contact material
    this.contactmaterials.push(cmat);

    // Add current contact material to the material table
    this.contactMaterialTable.set(cmat.materials[0].id,cmat.materials[1].id,cmat);
};

// performance.now()
if(typeof performance === 'undefined'){
    performance = {};
}
if(!performance.now){
    var nowOffset = Date.now();
    if (performance.timing && performance.timing.navigationStart){
        nowOffset = performance.timing.navigationStart;
    }
    performance.now = function(){
        return Date.now() - nowOffset;
    };
}

var step_tmp1 = new Vec3();

/**
 * Step the physics world forward in time.
 *
 * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
 *
 * @method step
 * @param {Number} dt                       The fixed time step size to use.
 * @param {Number} [timeSinceLastCalled]    The time elapsed since the function was last called.
 * @param {Number} [maxSubSteps=10]         Maximum number of fixed steps to take per function call.
 *
 * @example
 *     // fixed timestepping without interpolation
 *     world.step(1/60);
 *
 * @see http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
 */
World.prototype.step = function(dt, timeSinceLastCalled, maxSubSteps){
    maxSubSteps = maxSubSteps || 10;
    timeSinceLastCalled = timeSinceLastCalled || 0;

    if(timeSinceLastCalled === 0){ // Fixed, simple stepping

        this.internalStep(dt);

        // Increment time
        this.time += dt;

    } else {

        // Compute the number of fixed steps we should have taken since the last step
        var internalSteps = Math.floor((this.time + timeSinceLastCalled) / dt) - Math.floor(this.time / dt);
        internalSteps = Math.min(internalSteps,maxSubSteps);

        // Do some fixed steps to catch up
        var t0 = performance.now();
        for(var i=0; i!==internalSteps; i++){
            this.internalStep(dt);
            if(performance.now() - t0 > dt * 1000){
                // We are slower than real-time. Better bail out.
                break;
            }
        }

        // Increment internal clock
        this.time += timeSinceLastCalled;

        // Compute "Left over" time step
        var h = this.time % dt;
        var h_div_dt = h / dt;
        var interpvelo = step_tmp1;
        var bodies = this.bodies;

        for(var j=0; j !== bodies.length; j++){
            var b = bodies[j];
            if(b.type !== Body.STATIC && b.sleepState !== Body.SLEEPING){

                // Interpolate
                b.position.vsub(b.previousPosition, interpvelo);
                interpvelo.scale(h_div_dt, interpvelo);
                b.position.vadd(interpvelo, b.interpolatedPosition);

                // TODO: interpolate quaternion
                // b.interpolatedAngle = b.angle + (b.angle - b.previousAngle) * h_div_dt;

            } else {

                // For static bodies, just copy. Who else will do it?
                b.interpolatedPosition.copy(b.position);
                b.interpolatedQuaternion.copy(b.quaternion);
            }
        }
    }
};

/**
 * Step the simulation
 * @method step
 * @param {Number} dt
 */
var World_step_postStepEvent = {type:"postStep"}, // Reusable event objects to save memory
    World_step_preStepEvent = {type:"preStep"},
    World_step_collideEvent = {type:"collide", body:null, contact:null },
    World_step_oldContacts = [], // Pools for unused objects
    World_step_frictionEquationPool = [],
    World_step_p1 = [], // Reusable arrays for collision pairs
    World_step_p2 = [],
    World_step_gvec = new Vec3(), // Temporary vectors and quats
    World_step_vi = new Vec3(),
    World_step_vj = new Vec3(),
    World_step_wi = new Vec3(),
    World_step_wj = new Vec3(),
    World_step_t1 = new Vec3(),
    World_step_t2 = new Vec3(),
    World_step_rixn = new Vec3(),
    World_step_rjxn = new Vec3(),
    World_step_step_q = new Quaternion(),
    World_step_step_w = new Quaternion(),
    World_step_step_wq = new Quaternion(),
    invI_tau_dt = new Vec3();
World.prototype.internalStep = function(dt){
    this.dt = dt;

    var world = this,
        that = this,
        contacts = this.contacts,
        p1 = World_step_p1,
        p2 = World_step_p2,
        N = this.numObjects(),
        bodies = this.bodies,
        solver = this.solver,
        gravity = this.gravity,
        doProfiling = this.doProfiling,
        profile = this.profile,
        DYNAMIC = Body.DYNAMIC,
        profilingStart,
        constraints = this.constraints,
        frictionEquationPool = World_step_frictionEquationPool,
        gnorm = gravity.norm(),
        gx = gravity.x,
        gy = gravity.y,
        gz = gravity.z,
        i=0;

    if(doProfiling){
        profilingStart = performance.now();
    }

    // Add gravity to all objects
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.type & DYNAMIC){ // Only for dynamic bodies
            var f = bi.force, m = bi.mass;
            f.x += m*gx;
            f.y += m*gy;
            f.z += m*gz;
        }
    }

    // Update subsystems
    for(var i=0, Nsubsystems=this.subsystems.length; i!==Nsubsystems; i++){
        this.subsystems[i].update();
    }

    // Collision detection
    if(doProfiling){ profilingStart = performance.now(); }
    p1.length = 0; // Clean up pair arrays from last step
    p2.length = 0;
    this.broadphase.collisionPairs(this,p1,p2);
    if(doProfiling){ profile.broadphase = performance.now() - profilingStart; }

    // Remove constrained pairs with collideConnected == false
    var Nconstraints = constraints.length;
    for(i=0; i!==Nconstraints; i++){
        var c = constraints[i];
        if(!c.collideConnected){
            for(var j = p1.length-1; j>=0; j-=1){
                if( (c.bodyA === p1[j] && c.bodyB === p2[j]) ||
                    (c.bodyB === p1[j] && c.bodyA === p2[j])){
                    p1.splice(j, 1);
                    p2.splice(j, 1);
                }
            }
        }
    }

    this.collisionMatrixTick();

    // Generate contacts
    if(doProfiling){ profilingStart = performance.now(); }
    var oldcontacts = World_step_oldContacts;
    var NoldContacts = contacts.length;

    for(i=0; i!==NoldContacts; i++){
        oldcontacts.push(contacts[i]);
    }
    contacts.length = 0;

    // Transfer FrictionEquation from current list to the pool for reuse
    var NoldFrictionEquations = this.frictionEquations.length;
    for(i=0; i!==NoldFrictionEquations; i++){
        frictionEquationPool.push(this.frictionEquations[i]);
    }
    this.frictionEquations.length = 0;

    this.narrowphase.getContacts(
        p1,
        p2,
        this,
        contacts,
        oldcontacts, // To be reused
        this.frictionEquations,
        frictionEquationPool
    );

    if(doProfiling){
        profile.narrowphase = performance.now() - profilingStart;
    }

    // Loop over all collisions
    if(doProfiling){
        profilingStart = performance.now();
    }

    // Add all friction eqs
    for (var i = 0; i < this.frictionEquations.length; i++) {
        solver.addEquation(this.frictionEquations[i]);
    }

    var ncontacts = contacts.length;
    for(var k=0; k!==ncontacts; k++){

        // Current contact
        var c = contacts[k];

        // Get current collision indeces
        var bi = c.bi,
            bj = c.bj,
            si = c.si,
            sj = c.sj;

        // Get collision properties
        var cm;
        if(bi.material && bj.material){
            cm = this.getContactMaterial(bi.material,bj.material) || this.defaultContactMaterial;
        } else {
            cm = this.defaultContactMaterial;
        }

        // c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;

        var mu = cm.friction;
        // c.restitution = cm.restitution;

        // If friction or restitution were specified in the material, use them
        if(bi.material && bj.material){
            if(bi.material.friction >= 0 && bj.material.friction >= 0){
                mu = bi.material.friction * bj.material.friction;
            }

            if(bi.material.restitution >= 0 && bj.material.restitution >= 0){
                c.restitution = bi.material.restitution * bj.material.restitution;
            }
        }

		// c.setSpookParams(
  //           cm.contactEquationStiffness,
  //           cm.contactEquationRelaxation,
  //           dt
  //       );

		solver.addEquation(c);

		// // Add friction constraint equation
		// if(mu > 0){

		// 	// Create 2 tangent equations
		// 	var mug = mu * gnorm;
		// 	var reducedMass = (bi.invMass + bj.invMass);
		// 	if(reducedMass > 0){
		// 		reducedMass = 1/reducedMass;
		// 	}
		// 	var pool = frictionEquationPool;
		// 	var c1 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
		// 	var c2 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
		// 	this.frictionEquations.push(c1, c2);

		// 	c1.bi = c2.bi = bi;
		// 	c1.bj = c2.bj = bj;
		// 	c1.minForce = c2.minForce = -mug*reducedMass;
		// 	c1.maxForce = c2.maxForce = mug*reducedMass;

		// 	// Copy over the relative vectors
		// 	c1.ri.copy(c.ri);
		// 	c1.rj.copy(c.rj);
		// 	c2.ri.copy(c.ri);
		// 	c2.rj.copy(c.rj);

		// 	// Construct tangents
		// 	c.ni.tangents(c1.t, c2.t);

  //           // Set spook params
  //           c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);
  //           c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);

  //           c1.enabled = c2.enabled = c.enabled;

		// 	// Add equations to solver
		// 	solver.addEquation(c1);
		// 	solver.addEquation(c2);
		// }

        if( bi.allowSleep &&
            bi.type === Body.DYNAMIC &&
            bi.sleepState  === Body.SLEEPING &&
            bj.sleepState  === Body.AWAKE &&
            bj.type !== Body.STATIC
        ){
            var speedSquaredB = bj.velocity.norm2() + bj.angularVelocity.norm2();
            var speedLimitSquaredB = Math.pow(bj.sleepSpeedLimit,2);
            if(speedSquaredB >= speedLimitSquaredB*2){
                bi._wakeUpAfterNarrowphase = true;
            }
        }

        if( bj.allowSleep &&
            bj.type === Body.DYNAMIC &&
            bj.sleepState  === Body.SLEEPING &&
            bi.sleepState  === Body.AWAKE &&
            bi.type !== Body.STATIC
        ){
            var speedSquaredA = bi.velocity.norm2() + bi.angularVelocity.norm2();
            var speedLimitSquaredA = Math.pow(bi.sleepSpeedLimit,2);
            if(speedSquaredA >= speedLimitSquaredA*2){
                bj._wakeUpAfterNarrowphase = true;
            }
        }

        // Now we know that i and j are in contact. Set collision matrix state
		this.collisionMatrix.set(bi, bj, true);

        if (!this.collisionMatrixPrevious.get(bi, bj)) {
            // First contact!
            // We reuse the collideEvent object, otherwise we will end up creating new objects for each new contact, even if there's no event listener attached.
            World_step_collideEvent.body = bj;
            World_step_collideEvent.contact = c;
            bi.dispatchEvent(World_step_collideEvent);

            World_step_collideEvent.body = bi;
            bj.dispatchEvent(World_step_collideEvent);
        }
    }
    if(doProfiling){
        profile.makeContactConstraints = performance.now() - profilingStart;
        profilingStart = performance.now();
    }

    // Wake up bodies
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi._wakeUpAfterNarrowphase){
            bi.wakeUp();
            bi._wakeUpAfterNarrowphase = false;
        }
    }

    // Add user-added constraints
    var Nconstraints = constraints.length;
    for(i=0; i!==Nconstraints; i++){
        var c = constraints[i];
        c.update();
        for(var j=0, Neq=c.equations.length; j!==Neq; j++){
            var eq = c.equations[j];
            solver.addEquation(eq);
        }
    }

    // Solve the constrained system
    solver.solve(dt,this);

    if(doProfiling){
        profile.solve = performance.now() - profilingStart;
    }

    // Remove all contacts from solver
    solver.removeAllEquations();

    // Apply damping, see http://code.google.com/p/bullet/issues/detail?id=74 for details
    var pow = Math.pow;
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.type & DYNAMIC){ // Only for dynamic bodies
            var ld = pow(1.0 - bi.linearDamping,dt);
            var v = bi.velocity;
            v.mult(ld,v);
            var av = bi.angularVelocity;
            if(av){
                var ad = pow(1.0 - bi.angularDamping,dt);
                av.mult(ad,av);
            }
        }
    }

    this.dispatchEvent(World_step_preStepEvent);

    // Invoke pre-step callbacks
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.preStep){
            bi.preStep.call(bi);
        }
    }

    // Leap frog
    // vnew = v + h*f/m
    // xnew = x + h*vnew
    if(doProfiling){
        profilingStart = performance.now();
    }
    var q = World_step_step_q;
    var w = World_step_step_w;
    var wq = World_step_step_wq;
    var stepnumber = this.stepnumber;
    var DYNAMIC_OR_KINEMATIC = Body.DYNAMIC | Body.KINEMATIC;
    var quatNormalize = stepnumber % (this.quatNormalizeSkip+1) === 0;
    var quatNormalizeFast = this.quatNormalizeFast;
    var half_dt = dt * 0.5;
    var PLANE = Shape.types.PLANE,
        CONVEX = Shape.types.CONVEXPOLYHEDRON;

    for(i=0; i!==N; i++){
        var b = bodies[i],
            force = b.force,
            tau = b.torque;
        if((b.type & DYNAMIC_OR_KINEMATIC) && b.sleepState !== Body.SLEEPING){ // Only for dynamic
            var velo = b.velocity,
                angularVelo = b.angularVelocity,
                pos = b.position,
                quat = b.quaternion,
                invMass = b.invMass,
                invInertia = b.invInertiaWorld;

            velo.x += force.x * invMass * dt;
            velo.y += force.y * invMass * dt;
            velo.z += force.z * invMass * dt;

            if(b.angularVelocity){
                invInertia.vmult(tau,invI_tau_dt);
                invI_tau_dt.mult(dt,invI_tau_dt);
                invI_tau_dt.vadd(angularVelo,angularVelo);
            }

            // Use new velocity  - leap frog
            pos.x += velo.x * dt;
            pos.y += velo.y * dt;
            pos.z += velo.z * dt;

            if(b.angularVelocity){
                w.set(angularVelo.x, angularVelo.y, angularVelo.z, 0);
                w.mult(quat,wq);
                quat.x += half_dt * wq.x;
                quat.y += half_dt * wq.y;
                quat.z += half_dt * wq.z;
                quat.w += half_dt * wq.w;
                if(quatNormalize){
                    if(quatNormalizeFast){
                        quat.normalizeFast();
                    } else {
                        quat.normalize();
                    }
                }
            }

            if(b.aabb){
                b.aabbNeedsUpdate = true;
            }

            // Update world inertia
            if(b.updateInertiaWorld){
                b.updateInertiaWorld();
            }
        }
    }
    this.clearForces();

    this.broadphase.dirty = true;

    if(doProfiling){
        profile.integrate = performance.now() - profilingStart;
    }

    // Update world time
    this.time += dt;
    this.stepnumber += 1;

    this.dispatchEvent(World_step_postStepEvent);

    // Invoke post-step callbacks
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        var postStep = bi.postStep;
        if(postStep){
            postStep.call(bi);
        }
    }

    // Sleeping update
    if(this.allowSleep){
        for(i=0; i!==N; i++){
            bodies[i].sleepTick(this.time);
        }
    }
};

/**
 * Sets all body forces in the world to zero.
 * @method clearForces
 */
World.prototype.clearForces = function(){
    var bodies = this.bodies;
    var N = bodies.length;
    for(var i=0; i !== N; i++){
        var b = bodies[i],
            force = b.force,
            tau = b.torque;

        b.force.set(0,0,0);
        b.torque.set(0,0,0);
    }
};

},{"../collision/AABB":3,"../collision/ArrayCollisionMatrix":4,"../collision/NaiveBroadphase":7,"../collision/Ray":9,"../collision/RaycastResult":10,"../equations/ContactEquation":19,"../equations/FrictionEquation":21,"../material/ContactMaterial":24,"../material/Material":25,"../math/Quaternion":28,"../math/Vec3":30,"../objects/Body":31,"../shapes/Shape":43,"../solver/GSSolver":46,"../utils/EventTarget":49,"../utils/TupleDictionary":52,"../utils/Vec3Pool":54,"./Narrowphase":55}]},{},[2])
(2)
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */


var _Group = function () {
	this._tweens = {};
	this._tweensAddedDuringUpdate = {};
};

_Group.prototype = {
	getAll: function () {

		return Object.keys(this._tweens).map(function (tweenId) {
			return this._tweens[tweenId];
		}.bind(this));

	},

	removeAll: function () {

		this._tweens = {};

	},

	add: function (tween) {

		this._tweens[tween.getId()] = tween;
		this._tweensAddedDuringUpdate[tween.getId()] = tween;

	},

	remove: function (tween) {

		delete this._tweens[tween.getId()];
		delete this._tweensAddedDuringUpdate[tween.getId()];

	},

	update: function (time, preserve) {

		var tweenIds = Object.keys(this._tweens);

		if (tweenIds.length === 0) {
			return false;
		}

		time = time !== undefined ? time : TWEEN.now();

		// Tweens are updated in "batches". If you add a new tween during an update, then the
		// new tween will be updated in the next batch.
		// If you remove a tween during an update, it may or may not be updated. However,
		// if the removed tween was added during the current batch, then it will not be updated.
		while (tweenIds.length > 0) {
			this._tweensAddedDuringUpdate = {};

			for (var i = 0; i < tweenIds.length; i++) {

				var tween = this._tweens[tweenIds[i]];

				if (tween && tween.update(time) === false) {
					tween._isPlaying = false;

					if (!preserve) {
						delete this._tweens[tweenIds[i]];
					}
				}
			}

			tweenIds = Object.keys(this._tweensAddedDuringUpdate);
		}

		return true;

	}
};

var TWEEN = new _Group();

TWEEN.Group = _Group;
TWEEN._nextId = 0;
TWEEN.nextId = function () {
	return TWEEN._nextId++;
};


// Include a performance.now polyfill.
// In node.js, use process.hrtime.
if (typeof (self) === 'undefined' && typeof (process) !== 'undefined' && process.hrtime) {
	TWEEN.now = function () {
		var time = process.hrtime();

		// Convert [seconds, nanoseconds] to milliseconds.
		return time[0] * 1000 + time[1] / 1000000;
	};
}
// In a browser, use self.performance.now if it is available.
else if (typeof (self) !== 'undefined' &&
         self.performance !== undefined &&
		 self.performance.now !== undefined) {
	// This must be bound, because directly assigning this function
	// leads to an invocation exception in Chrome.
	TWEEN.now = self.performance.now.bind(self.performance);
}
// Use Date.now if it is available.
else if (Date.now !== undefined) {
	TWEEN.now = Date.now;
}
// Otherwise, use 'new Date().getTime()'.
else {
	TWEEN.now = function () {
		return new Date().getTime();
	};
}


TWEEN.Tween = function (object, group) {
	this._object = object;
	this._valuesStart = {};
	this._valuesEnd = {};
	this._valuesStartRepeat = {};
	this._duration = 1000;
	this._repeat = 0;
	this._repeatDelayTime = undefined;
	this._yoyo = false;
	this._isPlaying = false;
	this._reversed = false;
	this._delayTime = 0;
	this._startTime = null;
	this._easingFunction = TWEEN.Easing.Linear.None;
	this._interpolationFunction = TWEEN.Interpolation.Linear;
	this._chainedTweens = [];
	this._onStartCallback = null;
	this._onStartCallbackFired = false;
	this._onUpdateCallback = null;
	this._onRepeatCallback = null;
	this._onCompleteCallback = null;
	this._onStopCallback = null;
	this._group = group || TWEEN;
	this._id = TWEEN.nextId();

};

TWEEN.Tween.prototype = {
	getId: function () {
		return this._id;
	},

	isPlaying: function () {
		return this._isPlaying;
	},

	to: function (properties, duration) {

		this._valuesEnd = properties;

		if (duration !== undefined) {
			this._duration = duration;
		}

		return this;

	},

	duration: function duration(d) {
		this._duration = d;
		return this;
	},

	start: function (time) {

		this._group.add(this);

		this._isPlaying = true;

		this._onStartCallbackFired = false;

		this._startTime = time !== undefined ? typeof time === 'string' ? TWEEN.now() + parseFloat(time) : time : TWEEN.now();
		this._startTime += this._delayTime;

		for (var property in this._valuesEnd) {

			// Check if an Array was provided as property value
			if (this._valuesEnd[property] instanceof Array) {

				if (this._valuesEnd[property].length === 0) {
					continue;
				}

				// Create a local copy of the Array with the start value at the front
				this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);

			}

			// If `to()` specifies a property that doesn't exist in the source object,
			// we should not set that property in the object
			if (this._object[property] === undefined) {
				continue;
			}

			// Save the starting value.
			this._valuesStart[property] = this._object[property];

			if ((this._valuesStart[property] instanceof Array) === false) {
				this._valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
			}

			this._valuesStartRepeat[property] = this._valuesStart[property] || 0;

		}

		return this;

	},

	stop: function () {

		if (!this._isPlaying) {
			return this;
		}

		this._group.remove(this);
		this._isPlaying = false;

		if (this._onStopCallback !== null) {
			this._onStopCallback(this._object);
		}

		this.stopChainedTweens();
		return this;

	},

	end: function () {

		this.update(Infinity);
		return this;

	},

	stopChainedTweens: function () {

		for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
			this._chainedTweens[i].stop();
		}

	},

	group: function (group) {
		this._group = group;
		return this;
	},

	delay: function (amount) {

		this._delayTime = amount;
		return this;

	},

	repeat: function (times) {

		this._repeat = times;
		return this;

	},

	repeatDelay: function (amount) {

		this._repeatDelayTime = amount;
		return this;

	},

	yoyo: function (yoyo) {

		this._yoyo = yoyo;
		return this;

	},

	easing: function (easingFunction) {

		this._easingFunction = easingFunction;
		return this;

	},

	interpolation: function (interpolationFunction) {

		this._interpolationFunction = interpolationFunction;
		return this;

	},

	chain: function () {

		this._chainedTweens = arguments;
		return this;

	},

	onStart: function (callback) {

		this._onStartCallback = callback;
		return this;

	},

	onUpdate: function (callback) {

		this._onUpdateCallback = callback;
		return this;

	},

	onRepeat: function onRepeat(callback) {

		this._onRepeatCallback = callback;
		return this;

	},

	onComplete: function (callback) {

		this._onCompleteCallback = callback;
		return this;

	},

	onStop: function (callback) {

		this._onStopCallback = callback;
		return this;

	},

	update: function (time) {

		var property;
		var elapsed;
		var value;

		if (time < this._startTime) {
			return true;
		}

		if (this._onStartCallbackFired === false) {

			if (this._onStartCallback !== null) {
				this._onStartCallback(this._object);
			}

			this._onStartCallbackFired = true;
		}

		elapsed = (time - this._startTime) / this._duration;
		elapsed = (this._duration === 0 || elapsed > 1) ? 1 : elapsed;

		value = this._easingFunction(elapsed);

		for (property in this._valuesEnd) {

			// Don't update properties that do not exist in the source object
			if (this._valuesStart[property] === undefined) {
				continue;
			}

			var start = this._valuesStart[property] || 0;
			var end = this._valuesEnd[property];

			if (end instanceof Array) {

				this._object[property] = this._interpolationFunction(end, value);

			} else {

				// Parses relative end values with start as base (e.g.: +10, -3)
				if (typeof (end) === 'string') {

					if (end.charAt(0) === '+' || end.charAt(0) === '-') {
						end = start + parseFloat(end);
					} else {
						end = parseFloat(end);
					}
				}

				// Protect against non numeric properties.
				if (typeof (end) === 'number') {
					this._object[property] = start + (end - start) * value;
				}

			}

		}

		if (this._onUpdateCallback !== null) {
			this._onUpdateCallback(this._object, elapsed);
		}

		if (elapsed === 1) {

			if (this._repeat > 0) {

				if (isFinite(this._repeat)) {
					this._repeat--;
				}

				// Reassign starting values, restart by making startTime = now
				for (property in this._valuesStartRepeat) {

					if (typeof (this._valuesEnd[property]) === 'string') {
						this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
					}

					if (this._yoyo) {
						var tmp = this._valuesStartRepeat[property];

						this._valuesStartRepeat[property] = this._valuesEnd[property];
						this._valuesEnd[property] = tmp;
					}

					this._valuesStart[property] = this._valuesStartRepeat[property];

				}

				if (this._yoyo) {
					this._reversed = !this._reversed;
				}

				if (this._repeatDelayTime !== undefined) {
					this._startTime = time + this._repeatDelayTime;
				} else {
					this._startTime = time + this._delayTime;
				}

				if (this._onRepeatCallback !== null) {
					this._onRepeatCallback(this._object);
				}

				return true;

			} else {

				if (this._onCompleteCallback !== null) {

					this._onCompleteCallback(this._object);
				}

				for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
					// Make the chained tweens start exactly at the time they should,
					// even if the `update()` method was called way past the duration of the tween
					this._chainedTweens[i].start(this._startTime + this._duration);
				}

				return false;

			}

		}

		return true;

	}
};


TWEEN.Easing = {

	Linear: {

		None: function (k) {

			return k;

		}

	},

	Quadratic: {

		In: function (k) {

			return k * k;

		},

		Out: function (k) {

			return k * (2 - k);

		},

		InOut: function (k) {

			if ((k *= 2) < 1) {
				return 0.5 * k * k;
			}

			return - 0.5 * (--k * (k - 2) - 1);

		}

	},

	Cubic: {

		In: function (k) {

			return k * k * k;

		},

		Out: function (k) {

			return --k * k * k + 1;

		},

		InOut: function (k) {

			if ((k *= 2) < 1) {
				return 0.5 * k * k * k;
			}

			return 0.5 * ((k -= 2) * k * k + 2);

		}

	},

	Quartic: {

		In: function (k) {

			return k * k * k * k;

		},

		Out: function (k) {

			return 1 - (--k * k * k * k);

		},

		InOut: function (k) {

			if ((k *= 2) < 1) {
				return 0.5 * k * k * k * k;
			}

			return - 0.5 * ((k -= 2) * k * k * k - 2);

		}

	},

	Quintic: {

		In: function (k) {

			return k * k * k * k * k;

		},

		Out: function (k) {

			return --k * k * k * k * k + 1;

		},

		InOut: function (k) {

			if ((k *= 2) < 1) {
				return 0.5 * k * k * k * k * k;
			}

			return 0.5 * ((k -= 2) * k * k * k * k + 2);

		}

	},

	Sinusoidal: {

		In: function (k) {

			return 1 - Math.cos(k * Math.PI / 2);

		},

		Out: function (k) {

			return Math.sin(k * Math.PI / 2);

		},

		InOut: function (k) {

			return 0.5 * (1 - Math.cos(Math.PI * k));

		}

	},

	Exponential: {

		In: function (k) {

			return k === 0 ? 0 : Math.pow(1024, k - 1);

		},

		Out: function (k) {

			return k === 1 ? 1 : 1 - Math.pow(2, - 10 * k);

		},

		InOut: function (k) {

			if (k === 0) {
				return 0;
			}

			if (k === 1) {
				return 1;
			}

			if ((k *= 2) < 1) {
				return 0.5 * Math.pow(1024, k - 1);
			}

			return 0.5 * (- Math.pow(2, - 10 * (k - 1)) + 2);

		}

	},

	Circular: {

		In: function (k) {

			return 1 - Math.sqrt(1 - k * k);

		},

		Out: function (k) {

			return Math.sqrt(1 - (--k * k));

		},

		InOut: function (k) {

			if ((k *= 2) < 1) {
				return - 0.5 * (Math.sqrt(1 - k * k) - 1);
			}

			return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);

		}

	},

	Elastic: {

		In: function (k) {

			if (k === 0) {
				return 0;
			}

			if (k === 1) {
				return 1;
			}

			return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);

		},

		Out: function (k) {

			if (k === 0) {
				return 0;
			}

			if (k === 1) {
				return 1;
			}

			return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;

		},

		InOut: function (k) {

			if (k === 0) {
				return 0;
			}

			if (k === 1) {
				return 1;
			}

			k *= 2;

			if (k < 1) {
				return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
			}

			return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;

		}

	},

	Back: {

		In: function (k) {

			var s = 1.70158;

			return k * k * ((s + 1) * k - s);

		},

		Out: function (k) {

			var s = 1.70158;

			return --k * k * ((s + 1) * k + s) + 1;

		},

		InOut: function (k) {

			var s = 1.70158 * 1.525;

			if ((k *= 2) < 1) {
				return 0.5 * (k * k * ((s + 1) * k - s));
			}

			return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);

		}

	},

	Bounce: {

		In: function (k) {

			return 1 - TWEEN.Easing.Bounce.Out(1 - k);

		},

		Out: function (k) {

			if (k < (1 / 2.75)) {
				return 7.5625 * k * k;
			} else if (k < (2 / 2.75)) {
				return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
			} else if (k < (2.5 / 2.75)) {
				return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
			} else {
				return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
			}

		},

		InOut: function (k) {

			if (k < 0.5) {
				return TWEEN.Easing.Bounce.In(k * 2) * 0.5;
			}

			return TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;

		}

	}

};

TWEEN.Interpolation = {

	Linear: function (v, k) {

		var m = v.length - 1;
		var f = m * k;
		var i = Math.floor(f);
		var fn = TWEEN.Interpolation.Utils.Linear;

		if (k < 0) {
			return fn(v[0], v[1], f);
		}

		if (k > 1) {
			return fn(v[m], v[m - 1], m - f);
		}

		return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);

	},

	Bezier: function (v, k) {

		var b = 0;
		var n = v.length - 1;
		var pw = Math.pow;
		var bn = TWEEN.Interpolation.Utils.Bernstein;

		for (var i = 0; i <= n; i++) {
			b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
		}

		return b;

	},

	CatmullRom: function (v, k) {

		var m = v.length - 1;
		var f = m * k;
		var i = Math.floor(f);
		var fn = TWEEN.Interpolation.Utils.CatmullRom;

		if (v[0] === v[m]) {

			if (k < 0) {
				i = Math.floor(f = m * (1 + k));
			}

			return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);

		} else {

			if (k < 0) {
				return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
			}

			if (k > 1) {
				return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
			}

			return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);

		}

	},

	Utils: {

		Linear: function (p0, p1, t) {

			return (p1 - p0) * t + p0;

		},

		Bernstein: function (n, i) {

			var fc = TWEEN.Interpolation.Utils.Factorial;

			return fc(n) / fc(i) / fc(n - i);

		},

		Factorial: (function () {

			var a = [1];

			return function (n) {

				var s = 1;

				if (a[n]) {
					return a[n];
				}

				for (var i = n; i > 1; i--) {
					s *= i;
				}

				a[n] = s;
				return s;

			};

		})(),

		CatmullRom: function (p0, p1, p2, p3, t) {

			var v0 = (p2 - p0) * 0.5;
			var v1 = (p3 - p1) * 0.5;
			var t2 = t * t;
			var t3 = t * t2;

			return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (- 3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;

		}

	}

};

// UMD (Universal Module Definition)
(function (root) {

	if (true) {

		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return TWEEN;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	} else if (typeof module !== 'undefined' && typeof exports === 'object') {

		// Node.js
		module.exports = TWEEN;

	} else if (root !== undefined) {

		// Global variable
		root.TWEEN = TWEEN;

	}

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-unused-variable */
// Subject imported before Observable to bypass circular dependency issue since
// Subject extends Observable and Observable references Subject in it's
// definition
var Subject_1 = __webpack_require__(6);
exports.Subject = Subject_1.Subject;
exports.AnonymousSubject = Subject_1.AnonymousSubject;
/* tslint:enable:no-unused-variable */
var Observable_1 = __webpack_require__(0);
exports.Observable = Observable_1.Observable;
// statics
/* tslint:disable:no-use-before-declare */
__webpack_require__(184);
__webpack_require__(187);
__webpack_require__(190);
__webpack_require__(193);
__webpack_require__(196);
__webpack_require__(199);
__webpack_require__(201);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(208);
__webpack_require__(211);
__webpack_require__(213);
__webpack_require__(216);
__webpack_require__(219);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(232);
__webpack_require__(235);
__webpack_require__(238);
__webpack_require__(241);
__webpack_require__(244);
__webpack_require__(246);
//dom
__webpack_require__(248);
__webpack_require__(250);
//operators
__webpack_require__(256);
__webpack_require__(258);
__webpack_require__(260);
__webpack_require__(262);
__webpack_require__(264);
__webpack_require__(266);
__webpack_require__(268);
__webpack_require__(270);
__webpack_require__(272);
__webpack_require__(274);
__webpack_require__(276);
__webpack_require__(278);
__webpack_require__(280);
__webpack_require__(282);
__webpack_require__(284);
__webpack_require__(286);
__webpack_require__(288);
__webpack_require__(290);
__webpack_require__(292);
__webpack_require__(294);
__webpack_require__(297);
__webpack_require__(299);
__webpack_require__(301);
__webpack_require__(303);
__webpack_require__(305);
__webpack_require__(307);
__webpack_require__(309);
__webpack_require__(311);
__webpack_require__(313);
__webpack_require__(315);
__webpack_require__(317);
__webpack_require__(319);
__webpack_require__(321);
__webpack_require__(326);
__webpack_require__(328);
__webpack_require__(330);
__webpack_require__(332);
__webpack_require__(334);
__webpack_require__(336);
__webpack_require__(338);
__webpack_require__(340);
__webpack_require__(342);
__webpack_require__(344);
__webpack_require__(346);
__webpack_require__(348);
__webpack_require__(350);
__webpack_require__(352);
__webpack_require__(354);
__webpack_require__(356);
__webpack_require__(358);
__webpack_require__(360);
__webpack_require__(362);
__webpack_require__(364);
__webpack_require__(366);
__webpack_require__(368);
__webpack_require__(371);
__webpack_require__(373);
__webpack_require__(375);
__webpack_require__(377);
__webpack_require__(379);
__webpack_require__(381);
__webpack_require__(383);
__webpack_require__(385);
__webpack_require__(387);
__webpack_require__(389);
__webpack_require__(391);
__webpack_require__(393);
__webpack_require__(395);
__webpack_require__(397);
__webpack_require__(399);
__webpack_require__(401);
__webpack_require__(403);
__webpack_require__(405);
__webpack_require__(407);
__webpack_require__(409);
__webpack_require__(411);
__webpack_require__(413);
__webpack_require__(415);
__webpack_require__(417);
__webpack_require__(425);
__webpack_require__(427);
__webpack_require__(429);
__webpack_require__(431);
__webpack_require__(433);
__webpack_require__(435);
__webpack_require__(437);
__webpack_require__(439);
__webpack_require__(441);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(446);
__webpack_require__(448);
__webpack_require__(450);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(455);
__webpack_require__(457);
__webpack_require__(459);
__webpack_require__(461);
__webpack_require__(463);
__webpack_require__(465);
__webpack_require__(467);
/* tslint:disable:no-unused-variable */
var Subscription_1 = __webpack_require__(5);
exports.Subscription = Subscription_1.Subscription;
var Subscriber_1 = __webpack_require__(1);
exports.Subscriber = Subscriber_1.Subscriber;
var AsyncSubject_1 = __webpack_require__(32);
exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
var ReplaySubject_1 = __webpack_require__(39);
exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
var BehaviorSubject_1 = __webpack_require__(121);
exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
var ConnectableObservable_1 = __webpack_require__(115);
exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
var Notification_1 = __webpack_require__(18);
exports.Notification = Notification_1.Notification;
var EmptyError_1 = __webpack_require__(40);
exports.EmptyError = EmptyError_1.EmptyError;
var ArgumentOutOfRangeError_1 = __webpack_require__(24);
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
var ObjectUnsubscribedError_1 = __webpack_require__(31);
exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
var TimeoutError_1 = __webpack_require__(151);
exports.TimeoutError = TimeoutError_1.TimeoutError;
var UnsubscriptionError_1 = __webpack_require__(64);
exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
var timeInterval_1 = __webpack_require__(148);
exports.TimeInterval = timeInterval_1.TimeInterval;
var timestamp_1 = __webpack_require__(58);
exports.Timestamp = timestamp_1.Timestamp;
var TestScheduler_1 = __webpack_require__(469);
exports.TestScheduler = TestScheduler_1.TestScheduler;
var VirtualTimeScheduler_1 = __webpack_require__(164);
exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
var AjaxObservable_1 = __webpack_require__(75);
exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
exports.AjaxError = AjaxObservable_1.AjaxError;
exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
var pipe_1 = __webpack_require__(42);
exports.pipe = pipe_1.pipe;
var asap_1 = __webpack_require__(140);
var async_1 = __webpack_require__(4);
var queue_1 = __webpack_require__(76);
var animationFrame_1 = __webpack_require__(472);
var rxSubscriber_1 = __webpack_require__(29);
var iterator_1 = __webpack_require__(16);
var observable_1 = __webpack_require__(30);
var _operators = __webpack_require__(476);
exports.operators = _operators;
/* tslint:enable:no-unused-variable */
/**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */
var Scheduler = {
    asap: asap_1.asap,
    queue: queue_1.queue,
    animationFrame: animationFrame_1.animationFrame,
    async: async_1.async
};
exports.Scheduler = Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */
var Symbol = {
    rxSubscriber: rxSubscriber_1.rxSubscriber,
    observable: observable_1.observable,
    iterator: iterator_1.iterator
};
exports.Symbol = Symbol;
//# sourceMappingURL=Rx.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(1);
var rxSubscriber_1 = __webpack_require__(29);
var Observer_1 = __webpack_require__(65);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bindCallback_1 = __webpack_require__(185);
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundCallbackObservable_1 = __webpack_require__(186);
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var AsyncSubject_1 = __webpack_require__(32);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundCallbackObservable = (function (_super) {
    __extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */
    BoundCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    BoundCallbackObservable.dispatch = function (state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new AsyncSubject_1.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    innerArgs[_i - 0] = arguments[_i];
                }
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === errorObject_1.errorObject) {
                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                    }
                    else {
                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                    }
                }
                else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === errorObject_1.errorObject) {
                subject.error(errorObject_1.errorObject.e);
            }
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}(Observable_1.Observable));
exports.BoundCallbackObservable = BoundCallbackObservable;
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bindNodeCallback_1 = __webpack_require__(188);
Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundNodeCallbackObservable_1 = __webpack_require__(189);
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var AsyncSubject_1 = __webpack_require__(32);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundNodeCallbackObservable = (function (_super) {
    __extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */
    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) {
                        subject.error(err);
                    }
                    else if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    return BoundNodeCallbackObservable;
}(Observable_1.Observable));
exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
function dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i - 0] = arguments[_i];
            }
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) {
                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else if (selector) {
                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === errorObject_1.errorObject) {
                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                }
                else {
                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                }
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === errorObject_1.errorObject) {
            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
        }
    }
    self.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineLatest_1 = __webpack_require__(191);
Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__(10);
var isArray_1 = __webpack_require__(11);
var ArrayObservable_1 = __webpack_require__(12);
var combineLatest_1 = __webpack_require__(33);
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    var scheduler = null;
    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(1);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concat_1 = __webpack_require__(17);
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(9);
var Observable_1 = __webpack_require__(0);
var iterator_1 = __webpack_require__(16);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var ScalarObservable_1 = __webpack_require__(44);
var EmptyObservable_1 = __webpack_require__(13);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var defer_1 = __webpack_require__(197);
Observable_1.Observable.defer = defer_1.defer;
//# sourceMappingURL=defer.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DeferObservable_1 = __webpack_require__(198);
exports.defer = DeferObservable_1.DeferObservable.create;
//# sourceMappingURL=defer.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var DeferObservable = (function (_super) {
    __extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */
    DeferObservable.create = function (observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function (subscriber) {
        return new DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}(Observable_1.Observable));
exports.DeferObservable = DeferObservable;
var DeferSubscriber = (function (_super) {
    __extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function () {
        try {
            this._callFactory();
        }
        catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function () {
        var result = this.factory();
        if (result) {
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return DeferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=DeferObservable.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var empty_1 = __webpack_require__(200);
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EmptyObservable_1 = __webpack_require__(13);
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var forkJoin_1 = __webpack_require__(202);
Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ForkJoinObservable_1 = __webpack_require__(203);
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var EmptyObservable_1 = __webpack_require__(13);
var isArray_1 = __webpack_require__(11);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ForkJoinObservable = (function (_super) {
    __extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */
    /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */
    ForkJoinObservable.create = function () {
        var sources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sources[_i - 0] = arguments[_i];
        }
        if (sources === null || arguments.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') {
            resultSelector = sources.pop();
        }
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
            sources = sources[0];
        }
        if (sources.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function (subscriber) {
        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}(Observable_1.Observable));
exports.ForkJoinObservable = ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ForkJoinSubscriber = (function (_super) {
    __extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) {
            return;
        }
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var from_1 = __webpack_require__(70);
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromEvent_1 = __webpack_require__(206);
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__(207);
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var tryCatch_1 = __webpack_require__(8);
var isFunction_1 = __webpack_require__(28);
var errorObject_1 = __webpack_require__(7);
var Subscription_1 = __webpack_require__(5);
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromEventPattern_1 = __webpack_require__(209);
Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventPatternObservable_1 = __webpack_require__(210);
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(28);
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(5);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventPatternObservable = (function (_super) {
    __extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */
    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            _this._callSelector(subscriber, args);
        } : function (e) { subscriber.next(e); };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!isFunction_1.isFunction(removeHandler)) {
            return;
        }
        subscriber.add(new Subscription_1.Subscription(function () {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        }
        catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        }
        catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}(Observable_1.Observable));
exports.FromEventPatternObservable = FromEventPatternObservable;
//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var fromPromise_1 = __webpack_require__(212);
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PromiseObservable_1 = __webpack_require__(72);
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var generate_1 = __webpack_require__(214);
Observable_1.Observable.generate = generate_1.generate;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var GenerateObservable_1 = __webpack_require__(215);
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var isScheduler_1 = __webpack_require__(10);
var selfSelector = function (value) { return value; };
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var GenerateObservable = (function (_super) {
    __extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) {
            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
        }
        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
        }
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function (subscriber) {
        var state = this.initialState;
        if (this.scheduler) {
            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
                subscriber: subscriber,
                iterate: this.iterate,
                condition: this.condition,
                resultSelector: this.resultSelector,
                state: state });
        }
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        } while (true);
    };
    GenerateObservable.dispatch = function (state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) {
            return;
        }
        if (state.needIterate) {
            try {
                state.state = state.iterate(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        }
        else {
            state.needIterate = true;
        }
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) {
                return;
            }
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) {
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        return this.schedule(state);
    };
    return GenerateObservable;
}(Observable_1.Observable));
exports.GenerateObservable = GenerateObservable;
//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var if_1 = __webpack_require__(217);
Observable_1.Observable.if = if_1._if;
//# sourceMappingURL=if.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IfObservable_1 = __webpack_require__(218);
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IfObservable = (function (_super) {
    __extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function (condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function (subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}(Observable_1.Observable));
exports.IfObservable = IfObservable;
var IfSubscriber = (function (_super) {
    __extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function () {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
            else {
                this._complete();
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var interval_1 = __webpack_require__(220);
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IntervalObservable_1 = __webpack_require__(221);
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(20);
var Observable_1 = __webpack_require__(0);
var async_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IntervalObservable = (function (_super) {
    __extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(period) || period < 0) {
            this.period = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = async_1.async;
        }
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */
    IntervalObservable.create = function (period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function (state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index, subscriber: subscriber, period: period
        }));
    };
    return IntervalObservable;
}(Observable_1.Observable));
exports.IntervalObservable = IntervalObservable;
//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var merge_1 = __webpack_require__(36);
Observable_1.Observable.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var race_1 = __webpack_require__(46);
Observable_1.Observable.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var never_1 = __webpack_require__(227);
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NeverObservable_1 = __webpack_require__(228);
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var noop_1 = __webpack_require__(43);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var NeverObservable = (function (_super) {
    __extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */
    NeverObservable.create = function () {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function (subscriber) {
        noop_1.noop();
    };
    return NeverObservable;
}(Observable_1.Observable));
exports.NeverObservable = NeverObservable;
//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var of_1 = __webpack_require__(69);
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var onErrorResumeNext_1 = __webpack_require__(231);
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var onErrorResumeNext_1 = __webpack_require__(47);
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pairs_1 = __webpack_require__(233);
Observable_1.Observable.pairs = pairs_1.pairs;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PairsObservable_1 = __webpack_require__(234);
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
function dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([key, obj[key]]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PairsObservable = (function (_super) {
    __extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */
    PairsObservable.create = function (obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function (subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
            });
        }
        else {
            for (var idx = 0; idx < length; idx++) {
                var key = keys[idx];
                subscriber.next([key, this.obj[key]]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}(Observable_1.Observable));
exports.PairsObservable = PairsObservable;
//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var range_1 = __webpack_require__(236);
Observable_1.Observable.range = range_1.range;
//# sourceMappingURL=range.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var RangeObservable_1 = __webpack_require__(237);
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var RangeObservable = (function (_super) {
    __extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */
    RangeObservable.create = function (start, count, scheduler) {
        if (start === void 0) { start = 0; }
        if (count === void 0) { count = 0; }
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function (state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(RangeObservable.dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(start++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
    };
    return RangeObservable;
}(Observable_1.Observable));
exports.RangeObservable = RangeObservable;
//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var using_1 = __webpack_require__(239);
Observable_1.Observable.using = using_1.using;
//# sourceMappingURL=using.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UsingObservable_1 = __webpack_require__(240);
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var subscribeToResult_1 = __webpack_require__(3);
var OuterSubscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var UsingObservable = (function (_super) {
    __extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function (resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function (subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new UsingSubscriber(subscriber, resource, observableFactory);
        }
        catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}(Observable_1.Observable));
exports.UsingObservable = UsingObservable;
var UsingSubscriber = (function (_super) {
    __extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function () {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var throw_1 = __webpack_require__(242);
Observable_1.Observable.throw = throw_1._throw;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ErrorObservable_1 = __webpack_require__(243);
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ErrorObservable = (function (_super) {
    __extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */
    ErrorObservable.create = function (error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function (arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function (subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) {
            return scheduler.schedule(ErrorObservable.dispatch, 0, {
                error: error, subscriber: subscriber
            });
        }
        else {
            subscriber.error(error);
        }
    };
    return ErrorObservable;
}(Observable_1.Observable));
exports.ErrorObservable = ErrorObservable;
//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timer_1 = __webpack_require__(74);
Observable_1.Observable.timer = timer_1.timer;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(20);
var Observable_1 = __webpack_require__(0);
var async_1 = __webpack_require__(4);
var isScheduler_1 = __webpack_require__(10);
var isDate_1 = __webpack_require__(37);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var TimerObservable = (function (_super) {
    __extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) { dueTime = 0; }
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if (isNumeric_1.isNumeric(period)) {
            this.period = Number(period) < 1 && 1 || Number(period);
        }
        else if (isScheduler_1.isScheduler(period)) {
            scheduler = period;
        }
        if (!isScheduler_1.isScheduler(scheduler)) {
            scheduler = async_1.async;
        }
        this.scheduler = scheduler;
        this.dueTime = isDate_1.isDate(dueTime) ?
            (+dueTime - this.scheduler.now()) :
            dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */
    TimerObservable.create = function (initialDelay, period, scheduler) {
        if (initialDelay === void 0) { initialDelay = 0; }
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function (state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        else if (period === -1) {
            return subscriber.complete();
        }
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index, period: period, subscriber: subscriber
        });
    };
    return TimerObservable;
}(Observable_1.Observable));
exports.TimerObservable = TimerObservable;
//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var zip_1 = __webpack_require__(247);
Observable_1.Observable.zip = zip_1.zip;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(38);
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var ajax_1 = __webpack_require__(249);
Observable_1.Observable.ajax = ajax_1.ajax;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AjaxObservable_1 = __webpack_require__(75);
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var webSocket_1 = __webpack_require__(251);
Observable_1.Observable.webSocket = webSocket_1.webSocket;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var WebSocketSubject_1 = __webpack_require__(252);
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var Subscriber_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(5);
var root_1 = __webpack_require__(9);
var ReplaySubject_1 = __webpack_require__(39);
var tryCatch_1 = __webpack_require__(8);
var errorObject_1 = __webpack_require__(7);
var assign_1 = __webpack_require__(255);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var WebSocketSubject = (function (_super) {
    __extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof Observable_1.Observable) {
            _super.call(this, destination, urlConfigOrSource);
        }
        else {
            _super.call(this);
            this.WebSocketCtor = root_1.root.WebSocket;
            this._output = new Subject_1.Subject();
            if (typeof urlConfigOrSource === 'string') {
                this.url = urlConfigOrSource;
            }
            else {
                // WARNING: config object could override important members here.
                assign_1.assign(this, urlConfigOrSource);
            }
            if (!this.WebSocketCtor) {
                throw new Error('no WebSocket constructor can be found');
            }
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function (e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */
    WebSocketSubject.create = function (urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function (operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
        this.socket = null;
        if (!this.source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
        this._output = new Subject_1.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new Observable_1.Observable(function (observer) {
            var result = tryCatch_1.tryCatch(subMsg)();
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                self.next(result);
            }
            var subscription = self.subscribe(function (x) {
                var result = tryCatch_1.tryCatch(messageFilter)(x);
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else if (result) {
                    observer.next(x);
                }
            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
            return function () {
                var result = tryCatch_1.tryCatch(unsubMsg)();
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else {
                    self.next(result);
                }
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function () {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ?
                new WebSocketCtor(this.url, this.protocol) :
                new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) {
                this.socket.binaryType = this.binaryType;
            }
        }
        catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new Subscription_1.Subscription(function () {
            _this.socket = null;
            if (socket && socket.readyState === 1) {
                socket.close();
            }
        });
        socket.onopen = function (e) {
            var openObserver = _this.openObserver;
            if (openObserver) {
                openObserver.next(e);
            }
            var queue = _this.destination;
            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                if (e && e.code) {
                    socket.close(e.code, e.reason);
                }
                else {
                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
                        'and an optional reason: { code: number, reason: string }'));
                }
                _this._resetState();
            }, function () {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
                subscription.add(queue.subscribe(_this.destination));
            }
        };
        socket.onerror = function (e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function (e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) {
                closeObserver.next(e);
            }
            if (e.wasClean) {
                observer.complete();
            }
            else {
                observer.error(e);
            }
        };
        socket.onmessage = function (e) {
            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                observer.next(result);
            }
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function (subscriber) {
        var _this = this;
        var source = this.source;
        if (source) {
            return source.subscribe(subscriber);
        }
        if (!this.socket) {
            this._connectSocket();
        }
        var subscription = new Subscription_1.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function () {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) {
                    socket.close();
                }
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    };
    return WebSocketSubject;
}(Subject_1.AnonymousSubject));
exports.WebSocketSubject = WebSocketSubject;
//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(21);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(22);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
function assignImpl(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var len = sources.length;
    for (var i = 0; i < len; i++) {
        var source = sources[i];
        for (var k in source) {
            if (source.hasOwnProperty(k)) {
                target[k] = source[k];
            }
        }
    }
    return target;
}
exports.assignImpl = assignImpl;
;
function getAssign(root) {
    return root.Object.assign || assignImpl;
}
exports.getAssign = getAssign;
exports.assign = getAssign(root_1.root);
//# sourceMappingURL=assign.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var buffer_1 = __webpack_require__(257);
Observable_1.Observable.prototype.buffer = buffer_1.buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var buffer_1 = __webpack_require__(77);
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return buffer_1.buffer(closingNotifier)(this);
}
exports.buffer = buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferCount_1 = __webpack_require__(259);
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferCount_1 = __webpack_require__(78);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
}
exports.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferTime_1 = __webpack_require__(261);
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var isScheduler_1 = __webpack_require__(10);
var bufferTime_1 = __webpack_require__(79);
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
exports.bufferTime = bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferToggle_1 = __webpack_require__(263);
Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferToggle_1 = __webpack_require__(80);
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
}
exports.bufferToggle = bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var bufferWhen_1 = __webpack_require__(265);
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferWhen_1 = __webpack_require__(81);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return bufferWhen_1.bufferWhen(closingSelector)(this);
}
exports.bufferWhen = bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var catch_1 = __webpack_require__(267);
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;
//# sourceMappingURL=catch.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var catchError_1 = __webpack_require__(82);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */
function _catch(selector) {
    return catchError_1.catchError(selector)(this);
}
exports._catch = _catch;
//# sourceMappingURL=catch.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineAll_1 = __webpack_require__(269);
Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineAll_1 = __webpack_require__(83);
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */
function combineAll(project) {
    return combineAll_1.combineAll(project)(this);
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var combineLatest_1 = __webpack_require__(271);
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__(33);
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return combineLatest_1.combineLatest.apply(void 0, observables)(this);
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concat_1 = __webpack_require__(273);
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__(84);
var concat_2 = __webpack_require__(17);
exports.concatStatic = concat_2.concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return concat_1.concat.apply(void 0, observables)(this);
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatAll_1 = __webpack_require__(275);
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatAll_1 = __webpack_require__(45);
/* tslint:enable:max-line-length */
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return concatAll_1.concatAll()(this);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatMap_1 = __webpack_require__(277);
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(48);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return concatMap_1.concatMap(project, resultSelector)(this);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var concatMapTo_1 = __webpack_require__(279);
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMapTo_1 = __webpack_require__(85);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var count_1 = __webpack_require__(281);
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var count_1 = __webpack_require__(86);
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return count_1.count(predicate)(this);
}
exports.count = count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var dematerialize_1 = __webpack_require__(283);
Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dematerialize_1 = __webpack_require__(87);
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return dematerialize_1.dematerialize()(this);
}
exports.dematerialize = dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var debounce_1 = __webpack_require__(285);
Observable_1.Observable.prototype.debounce = debounce_1.debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var debounce_1 = __webpack_require__(88);
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return debounce_1.debounce(durationSelector)(this);
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var debounceTime_1 = __webpack_require__(287);
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var debounceTime_1 = __webpack_require__(89);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
}
exports.debounceTime = debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var defaultIfEmpty_1 = __webpack_require__(289);
Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defaultIfEmpty_1 = __webpack_require__(49);
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
}
exports.defaultIfEmpty = defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var delay_1 = __webpack_require__(291);
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var delay_1 = __webpack_require__(90);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return delay_1.delay(delay, scheduler)(this);
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var delayWhen_1 = __webpack_require__(293);
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var delayWhen_1 = __webpack_require__(91);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
exports.delayWhen = delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinct_1 = __webpack_require__(295);
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinct_1 = __webpack_require__(92);
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return distinct_1.distinct(keySelector, flushes)(this);
}
exports.distinct = distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
function minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return (function () {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function (value) {
            if (!this.has(value)) {
                this._values.push(value);
            }
        };
        MinimalSet.prototype.has = function (value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function () {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function () {
            this._values.length = 0;
        };
        return MinimalSet;
    }());
}
exports.minimalSetImpl = minimalSetImpl;
exports.Set = root_1.root.Set || minimalSetImpl();
//# sourceMappingURL=Set.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinctUntilChanged_1 = __webpack_require__(298);
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__(50);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
}
exports.distinctUntilChanged = distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var distinctUntilKeyChanged_1 = __webpack_require__(300);
Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilKeyChanged_1 = __webpack_require__(93);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var do_1 = __webpack_require__(302);
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tap_1 = __webpack_require__(94);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return tap_1.tap(nextOrObserver, error, complete)(this);
}
exports._do = _do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var exhaust_1 = __webpack_require__(304);
Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exhaust_1 = __webpack_require__(95);
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return exhaust_1.exhaust()(this);
}
exports.exhaust = exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var exhaustMap_1 = __webpack_require__(306);
Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exhaustMap_1 = __webpack_require__(96);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
}
exports.exhaustMap = exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var expand_1 = __webpack_require__(308);
Observable_1.Observable.prototype.expand = expand_1.expand;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var expand_1 = __webpack_require__(97);
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return expand_1.expand(project, concurrent, scheduler)(this);
}
exports.expand = expand;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var elementAt_1 = __webpack_require__(310);
Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var elementAt_1 = __webpack_require__(98);
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return elementAt_1.elementAt(index, defaultValue)(this);
}
exports.elementAt = elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var filter_1 = __webpack_require__(312);
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var filter_1 = __webpack_require__(51);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return filter_1.filter(predicate, thisArg)(this);
}
exports.filter = filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var finally_1 = __webpack_require__(314);
Observable_1.Observable.prototype.finally = finally_1._finally;
Observable_1.Observable.prototype._finally = finally_1._finally;
//# sourceMappingURL=finally.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var finalize_1 = __webpack_require__(99);
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function _finally(callback) {
    return finalize_1.finalize(callback)(this);
}
exports._finally = _finally;
//# sourceMappingURL=finally.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var find_1 = __webpack_require__(316);
Observable_1.Observable.prototype.find = find_1.find;
//# sourceMappingURL=find.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__(52);
/* tslint:enable:max-line-length */
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    return find_1.find(predicate, thisArg)(this);
}
exports.find = find;
//# sourceMappingURL=find.js.map

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var findIndex_1 = __webpack_require__(318);
Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var findIndex_1 = __webpack_require__(100);
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return findIndex_1.findIndex(predicate, thisArg)(this);
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var first_1 = __webpack_require__(320);
Observable_1.Observable.prototype.first = first_1.first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var first_1 = __webpack_require__(101);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return first_1.first(predicate, resultSelector, defaultValue)(this);
}
exports.first = first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var groupBy_1 = __webpack_require__(322);
Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var groupBy_1 = __webpack_require__(102);
exports.GroupedObservable = groupBy_1.GroupedObservable;
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
exports.groupBy = groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
var MapPolyfill_1 = __webpack_require__(324);
exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
//# sourceMappingURL=Map.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var MapPolyfill = (function () {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function (key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function (key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        }
        else {
            this._values[i] = value;
        }
        return this;
    };
    MapPolyfill.prototype.delete = function (key) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            return false;
        }
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function () {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function (cb, thisArg) {
        for (var i = 0; i < this.size; i++) {
            cb.call(thisArg, this._values[i], this._keys[i]);
        }
    };
    return MapPolyfill;
}());
exports.MapPolyfill = MapPolyfill;
//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FastMap = (function () {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function (key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function (key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function (key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function (cb, thisArg) {
        var values = this.values;
        for (var key in values) {
            if (values.hasOwnProperty(key) && values[key] !== null) {
                cb.call(thisArg, values[key], key);
            }
        }
    };
    FastMap.prototype.clear = function () {
        this.values = {};
    };
    return FastMap;
}());
exports.FastMap = FastMap;
//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var ignoreElements_1 = __webpack_require__(327);
Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ignoreElements_1 = __webpack_require__(103);
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return ignoreElements_1.ignoreElements()(this);
}
exports.ignoreElements = ignoreElements;
;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var isEmpty_1 = __webpack_require__(329);
Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isEmpty_1 = __webpack_require__(104);
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */
function isEmpty() {
    return isEmpty_1.isEmpty()(this);
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var audit_1 = __webpack_require__(331);
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audit_1 = __webpack_require__(53);
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return audit_1.audit(durationSelector)(this);
}
exports.audit = audit;
//# sourceMappingURL=audit.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var auditTime_1 = __webpack_require__(333);
Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var auditTime_1 = __webpack_require__(105);
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return auditTime_1.auditTime(duration, scheduler)(this);
}
exports.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var last_1 = __webpack_require__(335);
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var last_1 = __webpack_require__(106);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return last_1.last(predicate, resultSelector, defaultValue)(this);
}
exports.last = last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var let_1 = __webpack_require__(337);
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var every_1 = __webpack_require__(339);
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var every_1 = __webpack_require__(107);
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return every_1.every(predicate, thisArg)(this);
}
exports.every = every;
//# sourceMappingURL=every.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var map_1 = __webpack_require__(341);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(23);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return map_1.map(project, thisArg)(this);
}
exports.map = map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mapTo_1 = __webpack_require__(343);
Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mapTo_1 = __webpack_require__(108);
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return mapTo_1.mapTo(value)(this);
}
exports.mapTo = mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var materialize_1 = __webpack_require__(345);
Observable_1.Observable.prototype.materialize = materialize_1.materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var materialize_1 = __webpack_require__(109);
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return materialize_1.materialize()(this);
}
exports.materialize = materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var max_1 = __webpack_require__(347);
Observable_1.Observable.prototype.max = max_1.max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var max_1 = __webpack_require__(110);
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    return max_1.max(comparer)(this);
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var merge_1 = __webpack_require__(349);
Observable_1.Observable.prototype.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__(111);
var merge_2 = __webpack_require__(36);
exports.mergeStatic = merge_2.merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return merge_1.merge.apply(void 0, observables)(this);
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeAll_1 = __webpack_require__(351);
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__(35);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeAll_1.mergeAll(concurrent)(this);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeMap_1 = __webpack_require__(353);
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(19);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
}
exports.mergeMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeMapTo_1 = __webpack_require__(355);
Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMapTo_1 = __webpack_require__(112);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
exports.mergeMapTo = mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var mergeScan_1 = __webpack_require__(357);
Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeScan_1 = __webpack_require__(113);
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
}
exports.mergeScan = mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var min_1 = __webpack_require__(359);
Observable_1.Observable.prototype.min = min_1.min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var min_1 = __webpack_require__(114);
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    return min_1.min(comparer)(this);
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var multicast_1 = __webpack_require__(361);
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__(14);
/* tslint:enable:max-line-length */
/**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
}
exports.multicast = multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var observeOn_1 = __webpack_require__(363);
Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var observeOn_1 = __webpack_require__(34);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return observeOn_1.observeOn(scheduler, delay)(this);
}
exports.observeOn = observeOn;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var onErrorResumeNext_1 = __webpack_require__(365);
Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var onErrorResumeNext_1 = __webpack_require__(47);
/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
}
exports.onErrorResumeNext = onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pairwise_1 = __webpack_require__(367);
Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var pairwise_1 = __webpack_require__(116);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return pairwise_1.pairwise()(this);
}
exports.pairwise = pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var partition_1 = __webpack_require__(369);
Observable_1.Observable.prototype.partition = partition_1.partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var partition_1 = __webpack_require__(117);
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return partition_1.partition(predicate, thisArg)(this);
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var pluck_1 = __webpack_require__(372);
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var pluck_1 = __webpack_require__(118);
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    return pluck_1.pluck.apply(void 0, properties)(this);
}
exports.pluck = pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publish_1 = __webpack_require__(374);
Observable_1.Observable.prototype.publish = publish_1.publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publish_1 = __webpack_require__(119);
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return publish_1.publish(selector)(this);
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishBehavior_1 = __webpack_require__(376);
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishBehavior_1 = __webpack_require__(120);
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return publishBehavior_1.publishBehavior(value)(this);
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishReplay_1 = __webpack_require__(378);
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishReplay_1 = __webpack_require__(122);
/* tslint:enable:max-line-length */
/**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var publishLast_1 = __webpack_require__(380);
Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishLast_1 = __webpack_require__(123);
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return publishLast_1.publishLast()(this);
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var race_1 = __webpack_require__(382);
Observable_1.Observable.prototype.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var race_1 = __webpack_require__(124);
// NOTE: to support backwards compatability with 5.4.* and lower
var race_2 = __webpack_require__(46);
exports.raceStatic = race_2.race;
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return race_1.race.apply(void 0, observables)(this);
}
exports.race = race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var reduce_1 = __webpack_require__(384);
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(25);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return reduce_1.reduce(accumulator, seed)(this);
    }
    return reduce_1.reduce(accumulator)(this);
}
exports.reduce = reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var repeat_1 = __webpack_require__(386);
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var repeat_1 = __webpack_require__(125);
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    return repeat_1.repeat(count)(this);
}
exports.repeat = repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var repeatWhen_1 = __webpack_require__(388);
Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var repeatWhen_1 = __webpack_require__(126);
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return repeatWhen_1.repeatWhen(notifier)(this);
}
exports.repeatWhen = repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var retry_1 = __webpack_require__(390);
Observable_1.Observable.prototype.retry = retry_1.retry;
//# sourceMappingURL=retry.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var retry_1 = __webpack_require__(127);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return retry_1.retry(count)(this);
}
exports.retry = retry;
//# sourceMappingURL=retry.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var retryWhen_1 = __webpack_require__(392);
Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var retryWhen_1 = __webpack_require__(128);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return retryWhen_1.retryWhen(notifier)(this);
}
exports.retryWhen = retryWhen;
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sample_1 = __webpack_require__(394);
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sample_1 = __webpack_require__(129);
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return sample_1.sample(notifier)(this);
}
exports.sample = sample;
//# sourceMappingURL=sample.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sampleTime_1 = __webpack_require__(396);
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var sampleTime_1 = __webpack_require__(130);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return sampleTime_1.sampleTime(period, scheduler)(this);
}
exports.sampleTime = sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var scan_1 = __webpack_require__(398);
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var scan_1 = __webpack_require__(54);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    if (arguments.length >= 2) {
        return scan_1.scan(accumulator, seed)(this);
    }
    return scan_1.scan(accumulator)(this);
}
exports.scan = scan;
//# sourceMappingURL=scan.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var sequenceEqual_1 = __webpack_require__(400);
Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sequenceEqual_1 = __webpack_require__(131);
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
}
exports.sequenceEqual = sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var share_1 = __webpack_require__(402);
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var share_1 = __webpack_require__(132);
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return share_1.share()(this);
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var shareReplay_1 = __webpack_require__(404);
Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shareReplay_1 = __webpack_require__(133);
/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
}
exports.shareReplay = shareReplay;
;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var single_1 = __webpack_require__(406);
Observable_1.Observable.prototype.single = single_1.single;
//# sourceMappingURL=single.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var single_1 = __webpack_require__(134);
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return single_1.single(predicate)(this);
}
exports.single = single;
//# sourceMappingURL=single.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skip_1 = __webpack_require__(408);
Observable_1.Observable.prototype.skip = skip_1.skip;
//# sourceMappingURL=skip.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skip_1 = __webpack_require__(135);
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return skip_1.skip(count)(this);
}
exports.skip = skip;
//# sourceMappingURL=skip.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipLast_1 = __webpack_require__(410);
Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipLast_1 = __webpack_require__(136);
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return skipLast_1.skipLast(count)(this);
}
exports.skipLast = skipLast;
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipUntil_1 = __webpack_require__(412);
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipUntil_1 = __webpack_require__(137);
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return skipUntil_1.skipUntil(notifier)(this);
}
exports.skipUntil = skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var skipWhile_1 = __webpack_require__(414);
Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipWhile_1 = __webpack_require__(138);
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return skipWhile_1.skipWhile(predicate)(this);
}
exports.skipWhile = skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var startWith_1 = __webpack_require__(416);
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var startWith_1 = __webpack_require__(139);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    return startWith_1.startWith.apply(void 0, array)(this);
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var subscribeOn_1 = __webpack_require__(418);
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var subscribeOn_1 = __webpack_require__(419);
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
}
exports.subscribeOn = subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscribeOnObservable_1 = __webpack_require__(420);
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
exports.subscribeOn = subscribeOn;
var SubscribeOnOperator = (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var asap_1 = __webpack_require__(140);
var isNumeric_1 = __webpack_require__(20);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var SubscribeOnObservable = (function (_super) {
    __extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) { delayTime = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
            this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = asap_1.asap;
        }
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) { delay = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(Observable_1.Observable));
exports.SubscribeOnObservable = SubscribeOnObservable;
//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Immediate_1 = __webpack_require__(422);
var AsyncAction_1 = __webpack_require__(21);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            Immediate_1.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}(AsyncAction_1.AsyncAction));
exports.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/

var root_1 = __webpack_require__(9);
var ImmediateDefinition = (function () {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        }
        else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) {
                // For Node.js before 0.9
                this.setImmediate = this.createProcessNextTickSetImmediate();
            }
            else if (this.canUsePostMessage()) {
                // For non-IE10 modern browsers
                this.setImmediate = this.createPostMessageSetImmediate();
            }
            else if (this.canUseMessageChannel()) {
                // For web workers, where supported
                this.setImmediate = this.createMessageChannelSetImmediate();
            }
            else if (this.canUseReadyStateChange()) {
                // For IE 6–8
                this.setImmediate = this.createReadyStateChangeSetImmediate();
            }
            else {
                // For older browsers
                this.setImmediate = this.createSetTimeoutSetImmediate();
            }
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function (o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function () {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function () {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function () {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') {
                handler.apply(undefined, args);
            }
            else {
                (new Function('' + handler))();
            }
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root &&
                typeof event.data === 'string' &&
                event.data.indexOf(messagePrefix) === 0) {
                instance.runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function (handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // 'too much recursion' error.
            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        }
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                }
                finally {
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}());
exports.ImmediateDefinition = ImmediateDefinition;
exports.Immediate = new ImmediateDefinition(root_1.root);
//# sourceMappingURL=Immediate.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(141).clearImmediate, __webpack_require__(141).setImmediate))

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(62)))

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(22);
var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var switch_1 = __webpack_require__(426);
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchAll_1 = __webpack_require__(142);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */
function _switch() {
    return switchAll_1.switchAll()(this);
}
exports._switch = _switch;
//# sourceMappingURL=switch.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var switchMap_1 = __webpack_require__(428);
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMap_1 = __webpack_require__(57);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return switchMap_1.switchMap(project, resultSelector)(this);
}
exports.switchMap = switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var switchMapTo_1 = __webpack_require__(430);
Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMapTo_1 = __webpack_require__(143);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
}
exports.switchMapTo = switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var take_1 = __webpack_require__(432);
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var take_1 = __webpack_require__(144);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return take_1.take(count)(this);
}
exports.take = take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeLast_1 = __webpack_require__(434);
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeLast_1 = __webpack_require__(55);
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return takeLast_1.takeLast(count)(this);
}
exports.takeLast = takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeUntil_1 = __webpack_require__(436);
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeUntil_1 = __webpack_require__(145);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return takeUntil_1.takeUntil(notifier)(this);
}
exports.takeUntil = takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var takeWhile_1 = __webpack_require__(438);
Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeWhile_1 = __webpack_require__(146);
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return takeWhile_1.takeWhile(predicate)(this);
}
exports.takeWhile = takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var throttle_1 = __webpack_require__(440);
Observable_1.Observable.prototype.throttle = throttle_1.throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var throttle_1 = __webpack_require__(41);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return throttle_1.throttle(durationSelector, config)(this);
}
exports.throttle = throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var throttleTime_1 = __webpack_require__(442);
Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var throttle_1 = __webpack_require__(41);
var throttleTime_1 = __webpack_require__(147);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
}
exports.throttleTime = throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeInterval_1 = __webpack_require__(148);
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeout_1 = __webpack_require__(445);
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var timeout_1 = __webpack_require__(150);
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeout_1.timeout(due, scheduler)(this);
}
exports.timeout = timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timeoutWith_1 = __webpack_require__(447);
Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var timeoutWith_1 = __webpack_require__(152);
/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
}
exports.timeoutWith = timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var timestamp_1 = __webpack_require__(449);
Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var timestamp_1 = __webpack_require__(58);
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timestamp_1.timestamp(scheduler)(this);
}
exports.timestamp = timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var toArray_1 = __webpack_require__(451);
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toArray_1 = __webpack_require__(153);
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
function toArray() {
    return toArray_1.toArray()(this);
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var window_1 = __webpack_require__(454);
Observable_1.Observable.prototype.window = window_1.window;
//# sourceMappingURL=window.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var window_1 = __webpack_require__(154);
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return window_1.window(windowBoundaries)(this);
}
exports.window = window;
//# sourceMappingURL=window.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowCount_1 = __webpack_require__(456);
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowCount_1 = __webpack_require__(155);
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
}
exports.windowCount = windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowTime_1 = __webpack_require__(458);
Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(4);
var isNumeric_1 = __webpack_require__(20);
var isScheduler_1 = __webpack_require__(10);
var windowTime_1 = __webpack_require__(156);
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
exports.windowTime = windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowToggle_1 = __webpack_require__(460);
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowToggle_1 = __webpack_require__(157);
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return windowToggle_1.windowToggle(openings, closingSelector)(this);
}
exports.windowToggle = windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var windowWhen_1 = __webpack_require__(462);
Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowWhen_1 = __webpack_require__(158);
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return windowWhen_1.windowWhen(closingSelector)(this);
}
exports.windowWhen = windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var withLatestFrom_1 = __webpack_require__(464);
Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var withLatestFrom_1 = __webpack_require__(159);
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
}
exports.withLatestFrom = withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var zip_1 = __webpack_require__(466);
Observable_1.Observable.prototype.zip = zip_1.zipProto;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(38);
/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zipProto() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return zip_1.zip.apply(void 0, observables)(this);
}
exports.zipProto = zipProto;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(0);
var zipAll_1 = __webpack_require__(468);
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zipAll_1 = __webpack_require__(160);
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return zipAll_1.zipAll(project)(this);
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var Notification_1 = __webpack_require__(18);
var ColdObservable_1 = __webpack_require__(470);
var HotObservable_1 = __webpack_require__(471);
var SubscriptionLog_1 = __webpack_require__(162);
var VirtualTimeScheduler_1 = __webpack_require__(164);
var defaultMaxFrame = 750;
var TestScheduler = (function (_super) {
    __extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function (marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) {
            throw new Error('marble diagram for time should have a completion marker "|"');
        }
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
        if (marbles.indexOf('^') !== -1) {
            throw new Error('cold observable cannot have subscription offset "^"');
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('cold observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new ColdObservable_1.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
        if (marbles.indexOf('!') !== -1) {
            throw new Error('hot observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new HotObservable_1.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function (value) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
        }, function (err) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
        }, function () {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
        var actual = [];
        var flushTest = { actual: actual, ready: false };
        var unsubscriptionFrame = TestScheduler
            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function () {
            subscription = observable.subscribe(function (x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof Observable_1.Observable) {
                    value = _this.materializeInnerObservable(value, _this.frame);
                }
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
            }, function (err) {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
            }, function () {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
        }
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
        var flushTest = { actual: actualSubscriptionLogs, ready: false };
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles) {
                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function (marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function () {
        var hotObservables = this.hotObservables;
        while (hotObservables.length > 0) {
            hotObservables.shift().setup();
        }
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
        while (readyFlushTests.length > 0) {
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
        if (typeof marbles !== 'string') {
            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
        }
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
                        'subscription marble diagram. Found instead \'' + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
        }
        else {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
        }
    };
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('conventional marble diagrams cannot have the ' +
                'unsubscription marker "!"');
        }
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
        var getValue = typeof values !== 'object' ?
            function (x) { return x; } :
            function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
        var groupStart = -1;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = Notification_1.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = Notification_1.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = Notification_1.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) {
                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
            }
        }
        return testMessages;
    };
    return TestScheduler;
}(VirtualTimeScheduler_1.VirtualTimeScheduler));
exports.TestScheduler = TestScheduler;
//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(0);
var Subscription_1 = __webpack_require__(5);
var SubscriptionLoggable_1 = __webpack_require__(161);
var applyMixins_1 = __webpack_require__(163);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ColdObservable = (function (_super) {
    __extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function (subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new Subscription_1.Subscription(function () {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
        var messagesLength = this.messages.length;
        for (var i = 0; i < messagesLength; i++) {
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function (_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, { message: message, subscriber: subscriber }));
        }
    };
    return ColdObservable;
}(Observable_1.Observable));
exports.ColdObservable = ColdObservable;
applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(6);
var Subscription_1 = __webpack_require__(5);
var SubscriptionLoggable_1 = __webpack_require__(161);
var applyMixins_1 = __webpack_require__(163);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var HotObservable = (function (_super) {
    __extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function (subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new Subscription_1.Subscription(function () {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function () {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */
        for (var i = 0; i < messagesLength; i++) {
            (function () {
                var message = subject.messages[i];
                /* tslint:enable */
                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
            })();
        }
    };
    return HotObservable;
}(Subject_1.Subject));
exports.HotObservable = HotObservable;
applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AnimationFrameAction_1 = __webpack_require__(473);
var AnimationFrameScheduler_1 = __webpack_require__(475);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(21);
var AnimationFrame_1 = __webpack_require__(474);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction_1.AsyncAction));
exports.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(9);
var RequestAnimationFrameDefinition = (function () {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        }
        else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        }
        else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        }
        else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        }
        else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        }
        else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
        }
    }
    return RequestAnimationFrameDefinition;
}());
exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(22);
var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audit_1 = __webpack_require__(53);
exports.audit = audit_1.audit;
var auditTime_1 = __webpack_require__(105);
exports.auditTime = auditTime_1.auditTime;
var buffer_1 = __webpack_require__(77);
exports.buffer = buffer_1.buffer;
var bufferCount_1 = __webpack_require__(78);
exports.bufferCount = bufferCount_1.bufferCount;
var bufferTime_1 = __webpack_require__(79);
exports.bufferTime = bufferTime_1.bufferTime;
var bufferToggle_1 = __webpack_require__(80);
exports.bufferToggle = bufferToggle_1.bufferToggle;
var bufferWhen_1 = __webpack_require__(81);
exports.bufferWhen = bufferWhen_1.bufferWhen;
var catchError_1 = __webpack_require__(82);
exports.catchError = catchError_1.catchError;
var combineAll_1 = __webpack_require__(83);
exports.combineAll = combineAll_1.combineAll;
var combineLatest_1 = __webpack_require__(33);
exports.combineLatest = combineLatest_1.combineLatest;
var concat_1 = __webpack_require__(84);
exports.concat = concat_1.concat;
var concatAll_1 = __webpack_require__(45);
exports.concatAll = concatAll_1.concatAll;
var concatMap_1 = __webpack_require__(48);
exports.concatMap = concatMap_1.concatMap;
var concatMapTo_1 = __webpack_require__(85);
exports.concatMapTo = concatMapTo_1.concatMapTo;
var count_1 = __webpack_require__(86);
exports.count = count_1.count;
var debounce_1 = __webpack_require__(88);
exports.debounce = debounce_1.debounce;
var debounceTime_1 = __webpack_require__(89);
exports.debounceTime = debounceTime_1.debounceTime;
var defaultIfEmpty_1 = __webpack_require__(49);
exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
var delay_1 = __webpack_require__(90);
exports.delay = delay_1.delay;
var delayWhen_1 = __webpack_require__(91);
exports.delayWhen = delayWhen_1.delayWhen;
var dematerialize_1 = __webpack_require__(87);
exports.dematerialize = dematerialize_1.dematerialize;
var distinct_1 = __webpack_require__(92);
exports.distinct = distinct_1.distinct;
var distinctUntilChanged_1 = __webpack_require__(50);
exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
var distinctUntilKeyChanged_1 = __webpack_require__(93);
exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
var elementAt_1 = __webpack_require__(98);
exports.elementAt = elementAt_1.elementAt;
var every_1 = __webpack_require__(107);
exports.every = every_1.every;
var exhaust_1 = __webpack_require__(95);
exports.exhaust = exhaust_1.exhaust;
var exhaustMap_1 = __webpack_require__(96);
exports.exhaustMap = exhaustMap_1.exhaustMap;
var expand_1 = __webpack_require__(97);
exports.expand = expand_1.expand;
var filter_1 = __webpack_require__(51);
exports.filter = filter_1.filter;
var finalize_1 = __webpack_require__(99);
exports.finalize = finalize_1.finalize;
var find_1 = __webpack_require__(52);
exports.find = find_1.find;
var findIndex_1 = __webpack_require__(100);
exports.findIndex = findIndex_1.findIndex;
var first_1 = __webpack_require__(101);
exports.first = first_1.first;
var groupBy_1 = __webpack_require__(102);
exports.groupBy = groupBy_1.groupBy;
var ignoreElements_1 = __webpack_require__(103);
exports.ignoreElements = ignoreElements_1.ignoreElements;
var isEmpty_1 = __webpack_require__(104);
exports.isEmpty = isEmpty_1.isEmpty;
var last_1 = __webpack_require__(106);
exports.last = last_1.last;
var map_1 = __webpack_require__(23);
exports.map = map_1.map;
var mapTo_1 = __webpack_require__(108);
exports.mapTo = mapTo_1.mapTo;
var materialize_1 = __webpack_require__(109);
exports.materialize = materialize_1.materialize;
var max_1 = __webpack_require__(110);
exports.max = max_1.max;
var merge_1 = __webpack_require__(111);
exports.merge = merge_1.merge;
var mergeAll_1 = __webpack_require__(35);
exports.mergeAll = mergeAll_1.mergeAll;
var mergeMap_1 = __webpack_require__(19);
exports.mergeMap = mergeMap_1.mergeMap;
var mergeMap_2 = __webpack_require__(19);
exports.flatMap = mergeMap_2.mergeMap;
var mergeMapTo_1 = __webpack_require__(112);
exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
var mergeScan_1 = __webpack_require__(113);
exports.mergeScan = mergeScan_1.mergeScan;
var min_1 = __webpack_require__(114);
exports.min = min_1.min;
var multicast_1 = __webpack_require__(14);
exports.multicast = multicast_1.multicast;
var observeOn_1 = __webpack_require__(34);
exports.observeOn = observeOn_1.observeOn;
var onErrorResumeNext_1 = __webpack_require__(47);
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
var pairwise_1 = __webpack_require__(116);
exports.pairwise = pairwise_1.pairwise;
var partition_1 = __webpack_require__(117);
exports.partition = partition_1.partition;
var pluck_1 = __webpack_require__(118);
exports.pluck = pluck_1.pluck;
var publish_1 = __webpack_require__(119);
exports.publish = publish_1.publish;
var publishBehavior_1 = __webpack_require__(120);
exports.publishBehavior = publishBehavior_1.publishBehavior;
var publishLast_1 = __webpack_require__(123);
exports.publishLast = publishLast_1.publishLast;
var publishReplay_1 = __webpack_require__(122);
exports.publishReplay = publishReplay_1.publishReplay;
var race_1 = __webpack_require__(124);
exports.race = race_1.race;
var reduce_1 = __webpack_require__(25);
exports.reduce = reduce_1.reduce;
var repeat_1 = __webpack_require__(125);
exports.repeat = repeat_1.repeat;
var repeatWhen_1 = __webpack_require__(126);
exports.repeatWhen = repeatWhen_1.repeatWhen;
var retry_1 = __webpack_require__(127);
exports.retry = retry_1.retry;
var retryWhen_1 = __webpack_require__(128);
exports.retryWhen = retryWhen_1.retryWhen;
var refCount_1 = __webpack_require__(56);
exports.refCount = refCount_1.refCount;
var sample_1 = __webpack_require__(129);
exports.sample = sample_1.sample;
var sampleTime_1 = __webpack_require__(130);
exports.sampleTime = sampleTime_1.sampleTime;
var scan_1 = __webpack_require__(54);
exports.scan = scan_1.scan;
var sequenceEqual_1 = __webpack_require__(131);
exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
var share_1 = __webpack_require__(132);
exports.share = share_1.share;
var shareReplay_1 = __webpack_require__(133);
exports.shareReplay = shareReplay_1.shareReplay;
var single_1 = __webpack_require__(134);
exports.single = single_1.single;
var skip_1 = __webpack_require__(135);
exports.skip = skip_1.skip;
var skipLast_1 = __webpack_require__(136);
exports.skipLast = skipLast_1.skipLast;
var skipUntil_1 = __webpack_require__(137);
exports.skipUntil = skipUntil_1.skipUntil;
var skipWhile_1 = __webpack_require__(138);
exports.skipWhile = skipWhile_1.skipWhile;
var startWith_1 = __webpack_require__(139);
exports.startWith = startWith_1.startWith;
/**
 * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
 * treeshaken. Currently if this export is added back, it
 * forces apps to bring in asap scheduler along with
 * Immediate, root, and other supporting code.
 */
// export { subscribeOn } from './operators/subscribeOn';
var switchAll_1 = __webpack_require__(142);
exports.switchAll = switchAll_1.switchAll;
var switchMap_1 = __webpack_require__(57);
exports.switchMap = switchMap_1.switchMap;
var switchMapTo_1 = __webpack_require__(143);
exports.switchMapTo = switchMapTo_1.switchMapTo;
var take_1 = __webpack_require__(144);
exports.take = take_1.take;
var takeLast_1 = __webpack_require__(55);
exports.takeLast = takeLast_1.takeLast;
var takeUntil_1 = __webpack_require__(145);
exports.takeUntil = takeUntil_1.takeUntil;
var takeWhile_1 = __webpack_require__(146);
exports.takeWhile = takeWhile_1.takeWhile;
var tap_1 = __webpack_require__(94);
exports.tap = tap_1.tap;
var throttle_1 = __webpack_require__(41);
exports.throttle = throttle_1.throttle;
var throttleTime_1 = __webpack_require__(147);
exports.throttleTime = throttleTime_1.throttleTime;
var timeInterval_1 = __webpack_require__(149);
exports.timeInterval = timeInterval_1.timeInterval;
var timeout_1 = __webpack_require__(150);
exports.timeout = timeout_1.timeout;
var timeoutWith_1 = __webpack_require__(152);
exports.timeoutWith = timeoutWith_1.timeoutWith;
var timestamp_1 = __webpack_require__(58);
exports.timestamp = timestamp_1.timestamp;
var toArray_1 = __webpack_require__(153);
exports.toArray = toArray_1.toArray;
var window_1 = __webpack_require__(154);
exports.window = window_1.window;
var windowCount_1 = __webpack_require__(155);
exports.windowCount = windowCount_1.windowCount;
var windowTime_1 = __webpack_require__(156);
exports.windowTime = windowTime_1.windowTime;
var windowToggle_1 = __webpack_require__(157);
exports.windowToggle = windowToggle_1.windowToggle;
var windowWhen_1 = __webpack_require__(158);
exports.windowWhen = windowWhen_1.windowWhen;
var withLatestFrom_1 = __webpack_require__(159);
exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
var zip_1 = __webpack_require__(38);
exports.zip = zip_1.zip;
var zipAll_1 = __webpack_require__(160);
exports.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=operators.js.map

/***/ }),
/* 477 */
/***/ (function(module, exports) {

/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/

/*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/

var MersenneTwister = function(seed) {
	if (seed == undefined) {
		seed = new Date().getTime();
	}

	/* Period parameters */
	this.N = 624;
	this.M = 397;
	this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	this.LOWER_MASK = 0x7fffffff; /* least significant r bits */

	this.mt = new Array(this.N); /* the array for the state vector */
	this.mti=this.N+1; /* mti==N+1 means mt[N] is not initialized */

	if (seed.constructor == Array) {
		this.init_by_array(seed, seed.length);
	}
	else {
		this.init_seed(seed);
	}
}

/* initializes mt[N] with a seed */
/* origin name init_genrand */
MersenneTwister.prototype.init_seed = function(s) {
	this.mt[0] = s >>> 0;
	for (this.mti=1; this.mti<this.N; this.mti++) {
		var s = this.mt[this.mti-1] ^ (this.mt[this.mti-1] >>> 30);
		this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253)
		+ this.mti;
		/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
		/* In the previous versions, MSBs of the seed affect   */
		/* only MSBs of the array mt[].                        */
		/* 2002/01/09 modified by Makoto Matsumoto             */
		this.mt[this.mti] >>>= 0;
		/* for >32 bit machines */
	}
}

/* initialize by an array with array-length */
/* init_key is the array for initializing keys */
/* key_length is its length */
/* slight change for C++, 2004/2/26 */
MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
	var i, j, k;
	this.init_seed(19650218);
	i=1; j=0;
	k = (this.N>key_length ? this.N : key_length);
	for (; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30)
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525)))
		+ init_key[j] + j; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++; j++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
		if (j>=key_length) j=0;
	}
	for (k=this.N-1; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941))
		- i; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
	}

	this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
}

/* generates a random number on [0,0xffffffff]-interval */
/* origin name genrand_int32 */
MersenneTwister.prototype.random_int = function() {
	var y;
	var mag01 = new Array(0x0, this.MATRIX_A);
	/* mag01[x] = x * MATRIX_A  for x=0,1 */

	if (this.mti >= this.N) { /* generate N words at one time */
		var kk;

		if (this.mti == this.N+1)  /* if init_seed() has not been called, */
			this.init_seed(5489);  /* a default initial seed is used */

		for (kk=0;kk<this.N-this.M;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		for (;kk<this.N-1;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+(this.M-this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		y = (this.mt[this.N-1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
		this.mt[this.N-1] = this.mt[this.M-1] ^ (y >>> 1) ^ mag01[y & 0x1];

		this.mti = 0;
	}

	y = this.mt[this.mti++];

	/* Tempering */
	y ^= (y >>> 11);
	y ^= (y << 7) & 0x9d2c5680;
	y ^= (y << 15) & 0xefc60000;
	y ^= (y >>> 18);

	return y >>> 0;
}

/* generates a random number on [0,0x7fffffff]-interval */
/* origin name genrand_int31 */
MersenneTwister.prototype.random_int31 = function() {
	return (this.random_int()>>>1);
}

/* generates a random number on [0,1]-real-interval */
/* origin name genrand_real1 */
MersenneTwister.prototype.random_incl = function() {
	return this.random_int()*(1.0/4294967295.0);
	/* divided by 2^32-1 */
}

/* generates a random number on [0,1)-real-interval */
MersenneTwister.prototype.random = function() {
	return this.random_int()*(1.0/4294967296.0);
	/* divided by 2^32 */
}

/* generates a random number on (0,1)-real-interval */
/* origin name genrand_real3 */
MersenneTwister.prototype.random_excl = function() {
	return (this.random_int() + 0.5)*(1.0/4294967296.0);
	/* divided by 2^32 */
}

/* generates a random number on [0,1) with 53-bit resolution*/
/* origin name genrand_res53 */
MersenneTwister.prototype.random_long = function() {
	var a=this.random_int()>>>5, b=this.random_int()>>>6;
	return(a*67108864.0+b)*(1.0/9007199254740992.0);
}

/* These real versions are due to Isaku Wada, 2002/01/09 added */

module.exports = MersenneTwister;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = {"glyphs":{"0":{"ha":833,"x_min":99,"x_max":735,"o":"m 417 -17 q 183 103 268 -17 q 99 446 99 224 q 183 786 99 669 q 417 903 268 903 q 650 786 565 903 q 735 446 735 669 q 650 103 735 224 q 417 -17 565 -17 m 417 75 q 569 165 510 75 q 628 446 628 256 q 613 610 628 542 q 569 724 597 679 q 501 790 540 769 q 417 811 463 811 q 332 790 371 811 q 265 724 293 769 q 221 610 236 679 q 206 446 206 542 q 265 165 206 256 q 417 75 324 75 m 417 363 q 356 387 382 363 q 331 456 331 411 q 356 523 331 499 q 417 547 382 547 q 477 523 451 547 q 503 456 503 499 q 477 387 503 411 q 417 363 451 363 z "},"1":{"ha":833,"x_min":135,"x_max":736,"o":"m 135 0 l 135 94 l 390 94 l 390 747 l 192 747 l 192 821 q 324 847 271 832 q 419 886 376 863 l 504 886 l 504 94 l 736 94 l 736 0 l 135 0 z "},"2":{"ha":833,"x_min":96,"x_max":725,"o":"m 101 0 l 101 68 q 301 249 214 168 q 447 397 388 329 q 536 522 506 464 q 567 636 567 581 q 519 761 567 713 q 374 810 472 810 q 258 778 311 810 q 161 703 204 747 l 96 768 q 224 866 156 829 q 388 903 293 903 q 508 884 454 903 q 599 831 561 865 q 656 749 636 797 q 676 642 676 700 q 647 516 676 579 q 563 385 617 453 q 433 245 508 318 q 268 90 358 172 q 351 96 310 93 q 433 99 393 99 l 725 99 l 725 0 l 101 0 z "},"3":{"ha":833,"x_min":79,"x_max":719,"o":"m 399 -17 q 206 22 283 -17 q 79 108 128 60 l 138 183 q 244 110 182 142 q 392 78 306 78 q 476 90 438 78 q 544 122 515 101 q 588 173 572 143 q 604 240 604 203 q 587 312 604 279 q 531 368 569 344 q 431 404 492 392 q 282 417 369 417 l 282 504 q 416 517 361 504 q 506 551 471 529 q 556 604 540 574 q 572 669 572 635 q 523 772 572 735 q 392 810 474 810 q 274 785 329 810 q 174 719 218 760 l 113 792 q 239 872 168 840 q 396 903 310 903 q 512 888 458 903 q 605 844 565 872 q 667 774 644 815 q 689 678 689 732 q 636 546 689 597 q 500 467 583 494 l 500 461 q 584 433 544 451 q 654 385 624 414 q 702 319 685 357 q 719 236 719 282 q 694 131 719 178 q 626 51 669 83 q 524 1 582 18 q 399 -17 465 -17 z "},"4":{"ha":833,"x_min":54,"x_max":757,"o":"m 511 0 l 511 244 l 54 244 l 54 321 l 497 886 l 619 886 l 619 336 l 757 336 l 757 244 l 619 244 l 619 0 l 511 0 m 181 336 l 511 336 l 511 611 q 514 690 513 647 q 518 768 515 732 l 511 768 q 467 703 490 736 q 421 639 443 671 l 181 336 z "},"5":{"ha":833,"x_min":78,"x_max":725,"o":"m 397 -17 q 290 -6 338 -17 q 203 21 242 4 q 134 59 165 38 q 78 104 103 81 l 135 179 q 182 141 157 160 q 237 108 207 122 q 303 86 267 94 q 385 78 340 78 q 473 92 432 78 q 544 133 514 107 q 592 197 575 160 q 610 281 610 235 q 551 424 610 372 q 392 475 492 475 q 297 461 336 475 q 211 421 258 447 l 150 460 l 179 886 l 681 886 l 681 788 l 281 788 l 257 525 q 333 551 296 542 q 421 561 369 561 q 540 544 485 561 q 637 494 596 528 q 701 408 678 460 q 725 283 725 356 q 698 156 725 211 q 625 62 671 100 q 520 3 579 24 q 397 -17 461 -17 z "},"6":{"ha":833,"x_min":107,"x_max":742,"o":"m 446 -17 q 312 10 374 -17 q 204 90 250 36 q 133 223 158 143 q 107 410 107 303 q 138 637 107 543 q 219 790 168 731 q 338 876 271 849 q 478 903 406 903 q 620 876 560 903 q 725 808 681 849 l 661 738 q 581 788 626 769 q 485 807 535 807 q 383 788 432 807 q 298 724 335 768 q 238 606 261 679 q 214 426 215 533 q 333 510 268 479 q 465 542 399 542 q 577 524 526 542 q 665 473 628 507 q 722 388 701 439 q 742 268 742 336 q 717 152 742 204 q 653 63 693 100 q 559 4 613 25 q 446 -17 506 -17 m 446 74 q 519 88 485 74 q 579 127 554 101 q 619 188 604 153 q 633 268 633 224 q 585 408 633 360 q 444 456 536 456 q 331 428 392 456 q 218 336 271 400 q 290 140 231 207 q 446 74 349 74 z "},"7":{"ha":833,"x_min":97,"x_max":739,"o":"m 314 0 q 338 230 319 126 q 390 426 356 333 q 478 607 425 519 q 608 788 532 694 l 97 788 l 97 886 l 739 886 l 739 815 q 594 624 651 715 q 503 437 538 532 q 453 236 468 342 q 433 0 438 131 l 314 0 z "},"8":{"ha":833,"x_min":94,"x_max":738,"o":"m 419 -17 q 284 1 344 -17 q 182 52 224 19 q 117 129 140 85 q 94 226 94 174 q 111 308 94 272 q 154 374 128 344 q 215 424 181 403 q 285 463 249 446 l 285 468 q 190 553 229 503 q 150 675 150 604 q 170 768 150 726 q 227 840 190 810 q 314 886 264 869 q 424 903 364 903 q 540 885 489 903 q 626 837 590 868 q 680 762 661 806 q 699 667 699 718 q 659 549 699 604 q 564 456 619 494 l 564 450 q 632 411 600 432 q 688 364 664 390 q 724 302 711 338 q 738 219 738 267 q 716 126 738 169 q 654 51 694 83 q 555 1 614 19 q 419 -17 496 -17 m 489 483 q 600 661 600 564 q 554 773 600 728 q 421 818 508 818 q 300 779 346 818 q 254 675 254 740 q 272 606 254 635 q 322 556 290 578 q 397 516 354 533 q 489 483 439 499 m 422 68 q 575 111 522 68 q 628 224 628 154 q 606 301 628 269 q 547 354 585 332 q 459 394 510 376 q 350 431 408 411 q 242 349 285 394 q 199 238 199 304 q 259 115 199 163 q 422 68 319 68 z "},"9":{"ha":833,"x_min":93,"x_max":728,"o":"m 390 431 q 503 458 443 431 q 617 549 563 486 q 545 746 603 679 q 389 813 488 813 q 315 799 349 813 q 256 759 281 785 q 216 697 231 733 q 201 618 201 661 q 249 478 201 526 q 390 431 297 431 m 357 -17 q 215 10 275 -17 q 110 76 154 36 l 174 149 q 253 97 207 117 q 350 78 299 78 q 451 97 403 78 q 535 162 499 117 q 594 279 572 207 q 619 458 617 351 q 501 375 565 406 q 368 344 436 344 q 256 362 307 344 q 169 413 206 379 q 113 499 133 447 q 93 618 93 550 q 117 734 93 682 q 181 824 140 786 q 276 882 222 861 q 388 903 329 903 q 522 876 460 903 q 631 797 585 850 q 702 663 676 743 q 728 476 728 583 q 697 249 728 343 q 614 97 665 156 q 496 10 563 38 q 357 -17 429 -17 z "}," ":{"ha":833,"x_min":0,"x_max":0,"o":""},"A":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 z "},"B":{"ha":833,"x_min":138,"x_max":760,"o":"m 138 0 l 138 911 l 396 911 q 523 899 465 911 q 622 860 581 886 q 685 791 663 833 q 708 689 708 749 q 669 566 708 621 q 549 490 631 511 l 549 485 q 704 415 649 469 q 760 267 760 361 q 735 150 760 200 q 665 67 710 100 q 556 17 619 33 q 417 0 493 0 l 138 0 m 253 528 l 376 528 q 544 565 493 528 q 594 679 594 603 q 541 784 594 754 q 382 814 488 814 l 253 814 l 253 528 m 253 97 l 400 97 q 582 138 518 97 q 646 272 646 179 q 583 394 646 357 q 400 431 521 431 l 253 431 l 253 97 z "},"C":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 z "},"D":{"ha":833,"x_min":121,"x_max":768,"o":"m 121 0 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 572 190 494 94 q 649 460 649 286 q 572 725 649 633 q 338 817 494 817 l 236 817 l 236 94 z "},"E":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 z "},"F":{"ha":833,"x_min":185,"x_max":744,"o":"m 185 0 l 185 911 l 744 911 l 744 814 l 301 814 l 301 506 l 676 506 l 676 408 l 301 408 l 301 0 l 185 0 z "},"G":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 z "},"H":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 z "},"I":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 z "},"J":{"ha":833,"x_min":113,"x_max":685,"o":"m 383 -17 q 233 19 307 -17 q 113 135 160 56 l 185 206 q 276 114 224 143 q 381 85 328 85 q 524 137 479 85 q 569 301 569 189 l 569 815 l 188 815 l 188 913 l 685 913 l 685 292 q 669 172 685 228 q 619 74 654 115 q 526 8 583 32 q 383 -17 468 -17 z "},"K":{"ha":833,"x_min":136,"x_max":806,"o":"m 136 0 l 136 911 l 253 911 l 253 454 l 257 454 l 640 911 l 772 911 l 483 565 l 806 0 l 675 0 l 410 478 l 253 290 l 253 0 l 136 0 z "},"L":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 z "},"M":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 z "},"N":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 z "},"O":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 z "},"P":{"ha":833,"x_min":142,"x_max":754,"o":"m 142 0 l 142 911 l 417 911 q 554 897 492 911 q 661 852 617 883 q 730 769 706 821 q 754 643 754 718 q 730 518 754 571 q 660 431 706 465 q 553 378 615 396 q 417 361 492 361 l 257 361 l 257 0 l 142 0 m 257 456 l 403 456 q 581 501 524 456 q 638 643 638 546 q 579 780 638 742 q 403 818 521 818 l 257 818 l 257 456 z "},"Q":{"ha":833,"x_min":69,"x_max":771,"o":"m 417 79 q 584 179 522 79 q 646 460 646 279 q 584 731 646 632 q 417 829 522 829 q 249 731 311 829 q 188 460 188 632 q 249 179 188 279 q 417 79 311 79 m 668 -226 q 471 -165 547 -226 q 361 -12 394 -104 q 241 36 294 -1 q 149 134 188 74 q 90 276 111 194 q 69 460 69 358 q 94 657 69 569 q 165 805 119 744 q 275 897 211 865 q 417 929 339 929 q 558 897 494 929 q 668 805 622 865 q 739 657 714 744 q 764 460 764 569 q 744 280 764 361 q 687 139 724 199 q 599 41 650 79 q 483 -10 547 3 q 558 -99 507 -69 q 681 -128 610 -128 q 719 -124 701 -128 q 749 -114 736 -119 l 771 -207 q 722 -221 747 -215 q 668 -226 697 -226 z "},"R":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 z "},"S":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 z "},"T":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 z "},"U":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 z "},"V":{"ha":833,"x_min":60,"x_max":774,"o":"m 350 0 l 60 911 l 182 911 l 329 419 q 372 268 353 338 q 417 118 392 199 l 422 118 q 446 195 435 158 q 467 268 457 232 q 488 342 478 304 q 510 419 499 379 l 656 911 l 774 911 l 485 0 l 350 0 z "},"W":{"ha":833,"x_min":14,"x_max":819,"o":"m 153 0 l 14 913 l 144 913 l 211 340 q 217 288 214 311 q 222 240 219 264 q 226 189 224 215 q 229 129 228 163 l 233 129 q 244 189 239 163 q 255 240 250 215 q 265 288 260 264 q 278 339 271 311 l 367 678 l 478 678 l 564 339 q 576 288 571 311 q 587 240 582 264 q 597 189 592 215 q 608 129 601 163 l 614 129 q 617 189 615 163 q 622 240 619 215 q 626 288 624 264 q 631 339 628 311 l 694 913 l 819 913 l 686 0 l 542 0 l 453 367 q 434 449 442 408 q 419 531 426 489 l 415 531 q 401 449 408 489 q 383 367 394 408 l 294 0 l 153 0 z "},"X":{"ha":833,"x_min":75,"x_max":758,"o":"m 75 0 l 347 471 l 93 911 l 221 911 l 349 678 q 383 616 367 646 q 422 546 400 586 l 428 546 q 462 616 447 586 q 493 678 476 646 l 618 911 l 740 911 l 486 465 l 758 0 l 631 0 l 493 246 q 455 315 474 279 q 413 392 436 350 l 407 392 q 369 315 388 350 q 333 246 351 279 l 197 0 l 75 0 z "},"Y":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 z "},"Z":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 z "},"a":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 z "},"b":{"ha":833,"x_min":129,"x_max":750,"o":"m 444 -17 q 340 8 396 -17 q 235 75 283 32 l 231 75 l 221 0 l 129 0 l 129 989 l 243 989 l 243 719 l 239 589 l 243 589 q 349 664 289 636 q 469 692 410 692 q 590 667 538 692 q 678 598 643 643 q 732 490 714 553 q 750 349 750 426 q 725 194 750 263 q 658 79 700 126 q 560 8 615 32 q 444 -17 504 -17 m 426 79 q 508 98 471 79 q 574 151 546 117 q 617 235 601 185 q 632 347 632 285 q 621 449 632 403 q 587 527 610 494 q 528 578 564 560 q 442 596 492 596 q 347 572 397 596 q 243 494 296 547 l 243 158 q 341 97 292 115 q 426 79 390 79 z "},"c":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 z "},"d":{"ha":833,"x_min":83,"x_max":704,"o":"m 376 -17 q 256 7 310 -17 q 164 76 203 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 275 667 219 642 q 390 692 331 692 q 499 669 451 692 q 592 604 547 646 l 596 604 l 590 729 l 590 989 l 704 989 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 554 46 q 376 -17 439 -17 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 z "},"e":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 z "},"f":{"ha":833,"x_min":143,"x_max":803,"o":"m 336 0 l 336 582 l 143 582 l 143 668 l 336 675 l 336 732 q 402 931 336 856 q 608 1006 468 1006 q 803 967 708 1006 l 776 881 q 699 906 735 900 q 619 913 664 913 q 488 866 528 913 q 449 736 449 819 l 449 675 l 732 675 l 732 582 l 449 582 l 449 0 l 336 0 z "},"g":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 z "},"h":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 z "},"i":{"ha":833,"x_min":125,"x_max":575,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"j":{"ha":833,"x_min":76,"x_max":575,"o":"m 269 -301 q 167 -288 217 -301 q 76 -256 117 -275 l 114 -171 q 190 -199 150 -189 q 268 -208 229 -208 q 351 -196 318 -208 q 404 -160 385 -183 q 431 -102 424 -136 q 439 -25 439 -68 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -17 q 539 -131 553 -79 q 492 -222 525 -183 q 406 -281 460 -260 q 269 -301 351 -301 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"k":{"ha":833,"x_min":147,"x_max":797,"o":"m 147 0 l 147 989 l 261 989 l 261 319 l 267 319 l 631 675 l 761 675 l 492 410 l 797 0 l 669 0 l 421 340 l 261 183 l 261 0 l 147 0 z "},"l":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 z "},"m":{"ha":833,"x_min":81,"x_max":775,"o":"m 81 0 l 81 675 l 172 675 l 182 586 l 185 586 q 246 663 211 633 q 339 692 281 692 q 467 575 438 692 q 531 660 496 629 q 625 692 567 692 q 735 638 696 692 q 775 483 775 585 l 775 0 l 661 0 l 661 475 q 589 593 661 593 q 531 567 553 593 q 481 489 508 542 l 481 0 l 375 0 l 375 475 q 359 563 375 533 q 306 593 343 593 q 244 567 269 593 q 194 489 219 542 l 194 0 l 81 0 z "},"n":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 z "},"o":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 z "},"p":{"ha":833,"x_min":129,"x_max":750,"o":"m 129 -285 l 129 675 l 224 675 l 233 589 l 238 589 q 347 663 285 633 q 471 692 408 692 q 591 667 539 692 q 678 598 643 643 q 732 490 714 553 q 750 347 750 426 q 725 194 750 261 q 658 79 700 126 q 560 8 615 32 q 443 -17 504 -17 q 341 6 396 -17 q 242 71 286 29 l 238 71 l 243 -57 l 243 -285 l 129 -285 m 424 79 q 574 150 515 79 q 632 347 632 221 q 621 449 632 403 q 587 527 610 494 q 528 578 564 560 q 442 596 492 596 q 347 572 397 596 q 243 494 296 547 l 243 158 q 340 97 292 115 q 424 79 389 79 z "},"q":{"ha":833,"x_min":83,"x_max":704,"o":"m 590 -285 l 590 -39 l 596 86 l 592 86 q 494 13 550 43 q 375 -17 438 -17 q 256 7 310 -17 q 163 76 201 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 275 667 219 642 q 390 692 331 692 q 501 668 453 692 q 599 600 550 644 l 603 600 l 613 675 l 704 675 l 704 -285 l 590 -285 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 z "},"r":{"ha":833,"x_min":203,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 z "},"s":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 z "},"t":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 z "},"u":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 z "},"v":{"ha":833,"x_min":71,"x_max":763,"o":"m 356 0 l 71 675 l 186 675 l 342 292 q 381 191 363 240 q 418 93 400 142 l 424 93 q 459 191 442 142 q 497 292 476 240 l 653 675 l 763 675 l 483 0 l 356 0 z "},"w":{"ha":833,"x_min":11,"x_max":822,"o":"m 158 0 l 11 675 l 125 675 l 206 283 q 222 190 215 235 q 236 97 229 146 l 242 97 q 259 191 249 146 q 281 283 269 236 l 364 633 l 478 633 l 558 283 q 581 190 569 235 q 600 97 593 146 l 606 97 q 620 190 614 146 q 636 283 626 235 l 717 675 l 822 675 l 678 0 l 531 0 l 453 322 q 419 522 436 393 l 414 522 q 381 322 397 393 l 306 0 l 158 0 z "},"x":{"ha":833,"x_min":89,"x_max":743,"o":"m 89 0 l 346 350 l 108 675 l 235 675 l 342 526 q 380 469 360 499 q 421 413 400 440 l 426 413 q 465 471 446 440 q 503 529 485 501 l 604 675 l 725 675 l 485 340 l 743 0 l 618 0 l 500 156 q 456 217 479 185 q 411 278 433 249 l 406 278 q 364 217 385 247 q 322 156 343 188 l 211 0 l 89 0 z "},"y":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 z "},"z":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 z "},"À":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Á":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Â":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ã":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ä":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ā":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 231 1021 l 231 1100 l 603 1100 l 603 1021 l 231 1021 z "},"Ă":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 283 1169 q 324 1087 292 1121 q 417 1053 357 1053 q 509 1087 476 1053 q 550 1169 542 1121 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 z "},"Å":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 971 q 320 1005 358 971 q 282 1096 282 1039 q 320 1188 282 1154 q 417 1222 358 1222 q 513 1188 475 1222 q 551 1096 551 1154 q 513 1005 551 1039 q 417 971 475 971 m 417 1021 q 466 1040 444 1021 q 488 1096 488 1060 q 466 1151 488 1132 q 417 1171 444 1171 q 365 1151 386 1171 q 344 1096 344 1132 q 365 1040 344 1060 q 417 1021 386 1021 z "},"Ǻ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 971 q 320 1005 358 971 q 282 1096 282 1039 q 296 1156 282 1129 q 333 1199 310 1182 l 517 1344 l 568 1275 l 458 1217 q 526 1174 500 1206 q 551 1096 551 1142 q 513 1005 551 1039 q 417 971 475 971 m 417 1021 q 466 1040 444 1021 q 488 1096 488 1060 q 466 1151 488 1132 q 417 1171 444 1171 q 365 1151 386 1171 q 344 1096 344 1132 q 365 1040 344 1060 q 417 1021 386 1021 z "},"Ǎ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Ą":{"ha":833,"x_min":44,"x_max":843,"o":"m 715 -312 q 613 -281 654 -312 q 572 -186 572 -250 q 583 -126 572 -154 q 612 -74 594 -97 q 651 -33 629 -51 q 693 0 672 -14 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 l 351 911 l 482 911 l 789 0 q 699 -67 736 -24 q 663 -161 663 -110 q 685 -215 663 -197 q 738 -232 707 -232 q 778 -223 761 -232 q 807 -203 794 -214 l 843 -262 q 788 -298 819 -283 q 715 -312 756 -312 m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 z "},"Ạ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ả":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ấ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 585 1060 l 543 1104 l 678 1233 l 726 1179 l 585 1060 z "},"Ầ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 249 1060 l 124 1182 l 172 1233 l 290 1101 l 249 1060 z "},"Ẩ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 576 1047 l 561 1096 q 606 1113 588 1103 q 624 1146 624 1124 q 601 1185 624 1174 q 525 1200 578 1197 l 538 1258 q 662 1231 619 1256 q 704 1157 704 1206 q 665 1080 704 1104 q 576 1047 626 1056 z "},"Ẫ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 285 971 l 238 1007 l 367 1128 l 467 1128 l 596 1007 l 549 971 l 419 1063 l 414 1063 l 285 971 m 508 1165 q 451 1176 475 1165 q 408 1200 428 1188 q 369 1224 388 1213 q 331 1235 351 1235 q 294 1218 306 1235 q 278 1171 282 1201 l 215 1178 q 243 1267 218 1231 q 325 1304 268 1304 q 382 1294 358 1304 q 426 1270 406 1283 q 464 1247 446 1257 q 503 1236 482 1236 q 540 1253 528 1236 q 556 1300 551 1269 l 618 1293 q 590 1202 615 1239 q 508 1165 565 1165 z "},"Ậ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ắ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 279 1169 q 321 1083 288 1118 q 417 1047 354 1047 q 513 1083 479 1047 q 554 1169 546 1118 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 m 421 1115 l 364 1156 l 496 1317 l 569 1267 l 421 1115 z "},"Ằ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 279 1169 q 321 1083 288 1118 q 417 1047 354 1047 q 513 1083 479 1047 q 554 1169 546 1118 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 m 413 1115 l 264 1267 l 338 1317 l 469 1156 l 413 1115 z "},"Ẳ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 279 1169 q 321 1083 288 1118 q 417 1047 354 1047 q 513 1083 479 1047 q 554 1169 546 1118 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 m 385 1111 l 371 1160 q 414 1177 396 1167 q 432 1210 432 1188 q 409 1249 432 1238 q 335 1264 386 1261 l 346 1322 q 471 1294 428 1319 q 514 1221 514 1269 q 503 1176 514 1194 q 474 1144 492 1157 q 433 1123 457 1131 q 385 1111 410 1115 z "},"Ẵ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 983 q 333 995 368 983 q 273 1028 297 1007 q 235 1075 249 1049 q 218 1131 222 1101 l 282 1142 q 321 1075 289 1104 q 417 1046 353 1046 q 513 1075 481 1046 q 551 1142 544 1104 l 615 1131 q 598 1075 611 1101 q 560 1028 585 1049 q 501 995 536 1007 q 417 983 465 983 m 508 1171 q 451 1182 475 1171 q 408 1206 428 1193 q 369 1229 388 1218 q 331 1240 351 1240 q 294 1224 306 1240 q 278 1175 282 1207 l 215 1182 q 243 1273 218 1236 q 325 1310 268 1310 q 382 1299 358 1310 q 426 1275 406 1288 q 464 1251 446 1263 q 503 1240 482 1240 q 540 1257 528 1240 q 556 1304 551 1274 l 618 1297 q 590 1208 615 1244 q 508 1171 565 1171 z "},"Ặ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 283 1169 q 324 1087 292 1121 q 417 1053 357 1053 q 509 1087 476 1053 q 550 1169 542 1121 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Æ":{"ha":833,"x_min":-1,"x_max":821,"o":"m 321 524 l 257 358 l 440 358 l 440 819 l 436 819 q 378 672 408 744 q 321 524 349 599 m -1 0 l 365 911 l 808 911 l 808 814 l 546 814 l 546 529 l 750 529 l 750 431 l 546 431 l 546 99 l 821 99 l 821 0 l 440 0 l 440 265 l 221 265 l 119 0 l -1 0 z "},"Ǽ":{"ha":833,"x_min":-1,"x_max":821,"o":"m 321 524 l 257 358 l 440 358 l 440 819 l 436 819 q 378 672 408 744 q 321 524 349 599 m -1 0 l 365 911 l 808 911 l 808 814 l 546 814 l 546 529 l 750 529 l 750 431 l 546 431 l 546 99 l 821 99 l 821 0 l 440 0 l 440 265 l 221 265 l 119 0 l -1 0 m 543 968 l 493 1026 l 689 1204 l 754 1128 l 543 968 z "},"Ǣ":{"ha":833,"x_min":-1,"x_max":821,"o":"m 321 524 l 257 358 l 440 358 l 440 819 l 436 819 q 378 672 408 744 q 321 524 349 599 m -1 0 l 365 911 l 808 911 l 808 814 l 546 814 l 546 529 l 750 529 l 750 431 l 546 431 l 546 99 l 821 99 l 821 0 l 440 0 l 440 265 l 221 265 l 119 0 l -1 0 m 397 1021 l 397 1100 l 769 1100 l 769 1021 l 397 1021 z "},"Ƀ":{"ha":833,"x_min":36,"x_max":768,"o":"m 146 0 l 146 225 l 36 225 l 36 303 l 146 311 l 146 911 l 404 911 q 531 899 474 911 q 630 860 589 886 q 694 791 671 833 q 717 689 717 749 q 678 566 717 621 q 557 490 639 511 l 557 485 q 713 415 657 469 q 768 267 768 361 q 743 150 768 200 q 673 67 718 100 q 565 17 628 33 q 425 0 501 0 l 146 0 m 261 97 l 408 97 q 590 138 526 97 q 654 272 654 179 q 592 394 654 357 q 408 431 529 431 l 261 431 l 261 311 l 458 311 l 458 225 l 261 225 l 261 97 m 261 528 l 385 528 q 552 565 501 528 q 603 679 603 603 q 549 784 603 754 q 390 814 496 814 l 261 814 l 261 528 z "},"Ḇ":{"ha":833,"x_min":138,"x_max":760,"o":"m 138 0 l 138 911 l 396 911 q 523 899 465 911 q 622 860 581 886 q 685 791 663 833 q 708 689 708 749 q 669 566 708 621 q 549 490 631 511 l 549 485 q 704 415 649 469 q 760 267 760 361 q 735 150 760 200 q 665 67 710 100 q 556 17 619 33 q 417 0 493 0 l 138 0 m 253 528 l 376 528 q 544 565 493 528 q 594 679 594 603 q 541 784 594 754 q 382 814 488 814 l 253 814 l 253 528 m 253 97 l 400 97 q 582 138 518 97 q 646 272 646 179 q 583 394 646 357 q 400 431 521 431 l 253 431 l 253 97 m 242 -235 l 242 -156 l 611 -156 l 611 -235 l 242 -235 z "},"Ç":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 m 365 -314 l 354 -258 q 474 -235 442 -251 q 506 -189 506 -219 q 482 -146 506 -161 q 399 -122 458 -131 l 454 11 l 529 11 l 493 -89 q 568 -122 542 -100 q 594 -187 594 -144 q 535 -278 594 -249 q 365 -314 476 -308 z "},"Ć":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 m 440 968 l 390 1026 l 586 1204 l 651 1128 l 440 968 z "},"Ĉ":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 m 325 971 l 275 1007 l 421 1164 l 540 1164 l 686 1007 l 636 971 l 483 1100 l 478 1100 l 325 971 z "},"Č":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 m 421 981 l 275 1138 l 325 1174 l 478 1046 l 483 1046 l 636 1174 l 686 1138 l 540 981 l 421 981 z "},"Ċ":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 m 481 992 q 422 1013 446 992 q 399 1071 399 1035 q 422 1127 399 1106 q 481 1149 446 1149 q 539 1127 515 1149 q 563 1071 563 1106 q 539 1013 563 1035 q 481 992 515 992 z "},"Ď":{"ha":833,"x_min":121,"x_max":768,"o":"m 121 0 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 572 190 494 94 q 649 460 649 286 q 572 725 649 633 q 338 817 494 817 l 236 817 l 236 94 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Ḍ":{"ha":833,"x_min":121,"x_max":768,"o":"m 121 0 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 572 190 494 94 q 649 460 649 286 q 572 725 649 633 q 338 817 494 817 l 236 817 l 236 94 m 410 -297 q 344 -273 371 -297 q 318 -208 318 -249 q 344 -144 318 -168 q 410 -119 371 -119 q 475 -144 449 -119 q 501 -208 501 -168 q 475 -273 501 -249 q 410 -297 449 -297 z "},"Ḏ":{"ha":833,"x_min":121,"x_max":768,"o":"m 121 0 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 572 190 494 94 q 649 460 649 286 q 572 725 649 633 q 338 817 494 817 l 236 817 l 236 94 m 225 -235 l 225 -156 l 594 -156 l 594 -235 l 225 -235 z "},"Ḑ":{"ha":833,"x_min":121,"x_max":768,"o":"m 121 0 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 572 190 494 94 q 649 460 649 286 q 572 725 649 633 q 338 817 494 817 l 236 817 l 236 94 m 278 -314 l 267 -258 q 386 -235 354 -251 q 418 -189 418 -219 q 394 -146 418 -161 q 311 -122 371 -131 l 367 11 l 442 11 l 406 -89 q 481 -122 454 -100 q 507 -187 507 -144 q 448 -278 507 -249 q 278 -314 389 -308 z "},"Đ":{"ha":833,"x_min":17,"x_max":768,"o":"m 121 0 l 121 436 l 17 436 l 17 514 l 121 522 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 570 190 493 94 q 647 460 647 286 q 570 725 647 633 q 338 817 493 817 l 236 817 l 236 522 l 436 522 l 436 436 l 236 436 l 236 94 z "},"Ɗ":{"ha":833,"x_min":28,"x_max":788,"o":"m 290 0 l 290 826 q 171 756 211 811 q 131 624 131 700 q 157 517 131 557 q 236 444 183 476 l 181 364 q 69 461 110 400 q 28 618 28 522 q 49 742 28 685 q 115 840 71 799 q 223 905 158 882 q 374 928 288 928 q 685 808 583 928 q 788 469 788 689 q 692 122 788 244 q 428 0 597 0 l 290 0 m 406 94 l 435 94 q 608 192 549 94 q 668 469 668 290 q 606 732 668 639 q 406 832 544 825 l 406 94 z "},"È":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 500 968 l 289 1128 l 354 1204 l 550 1026 l 500 968 z "},"É":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 419 968 l 369 1026 l 565 1204 l 631 1128 l 419 968 z "},"Ê":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 304 971 l 254 1007 l 400 1164 l 519 1164 l 665 1007 l 615 971 l 463 1100 l 457 1100 l 304 971 z "},"Ě":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 400 981 l 254 1138 l 304 1174 l 457 1046 l 463 1046 l 615 1174 l 665 1138 l 519 981 l 400 981 z "},"Ë":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 333 993 q 283 1013 303 993 q 263 1064 263 1032 q 283 1115 263 1096 q 333 1133 303 1133 q 383 1115 364 1133 q 403 1064 403 1096 q 383 1013 403 1032 q 333 993 364 993 m 586 993 q 536 1013 556 993 q 517 1064 517 1032 q 536 1115 517 1096 q 586 1133 556 1133 q 637 1115 617 1133 q 657 1064 657 1096 q 637 1013 657 1032 q 586 993 617 993 z "},"Ē":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 274 1021 l 274 1100 l 646 1100 l 646 1021 l 274 1021 z "},"Ĕ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 460 979 q 375 994 411 979 q 314 1033 339 1008 q 275 1090 289 1057 q 257 1158 261 1122 l 326 1169 q 367 1087 335 1121 q 460 1053 400 1053 q 552 1087 519 1053 q 593 1169 585 1121 l 663 1158 q 644 1090 658 1122 q 606 1033 631 1057 q 544 994 581 1008 q 460 979 508 979 z "},"Ė":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 460 992 q 401 1013 425 992 q 378 1071 378 1035 q 401 1127 378 1106 q 460 1149 425 1149 q 518 1127 494 1149 q 542 1071 542 1106 q 518 1013 542 1035 q 460 992 494 992 z "},"Ę":{"ha":833,"x_min":160,"x_max":768,"o":"m 642 -312 q 539 -281 579 -312 q 499 -186 499 -250 q 535 -76 499 -124 q 618 0 572 -28 l 160 0 l 160 911 l 722 911 l 722 814 l 276 814 l 276 528 l 653 528 l 653 429 l 276 429 l 276 99 l 736 99 l 736 0 l 731 0 q 678 -19 704 -4 q 633 -57 653 -35 q 600 -106 613 -79 q 588 -161 588 -133 q 611 -215 588 -197 q 664 -232 635 -232 q 703 -223 686 -232 q 733 -203 719 -214 l 768 -262 q 713 -298 744 -283 q 642 -312 682 -312 z "},"Ẹ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 463 -297 q 397 -273 424 -297 q 371 -208 371 -249 q 397 -144 371 -168 q 463 -119 424 -119 q 528 -144 501 -119 q 554 -208 554 -168 q 528 -273 554 -249 q 463 -297 501 -297 z "},"Ẻ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 415 969 l 403 1022 q 458 1046 436 1032 q 481 1086 481 1060 q 365 1144 481 1140 l 378 1211 q 519 1180 469 1208 q 569 1099 569 1151 q 557 1047 569 1068 q 523 1009 544 1025 q 474 984 501 993 q 415 969 446 975 z "},"Ẽ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 564 985 q 497 1000 525 985 q 447 1034 469 1015 q 403 1068 424 1053 q 358 1083 383 1083 q 314 1060 332 1083 q 292 992 296 1036 l 214 997 q 256 1122 218 1076 q 356 1168 293 1168 q 422 1153 394 1168 q 473 1119 450 1138 q 516 1085 496 1100 q 561 1069 536 1069 q 628 1161 617 1069 l 706 1156 q 664 1030 701 1075 q 564 985 626 985 z "},"Ế":{"ha":833,"x_min":158,"x_max":769,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 328 971 l 281 1007 l 410 1132 l 510 1132 l 639 1007 l 592 971 l 463 1067 l 457 1067 l 328 971 m 628 1060 l 586 1104 l 721 1233 l 769 1179 l 628 1060 z "},"Ề":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 328 971 l 281 1007 l 410 1132 l 510 1132 l 639 1007 l 592 971 l 463 1067 l 457 1067 l 328 971 m 292 1060 l 167 1182 l 215 1233 l 333 1101 l 292 1060 z "},"Ể":{"ha":833,"x_min":158,"x_max":747,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 328 971 l 281 1007 l 410 1132 l 510 1132 l 639 1007 l 592 971 l 463 1067 l 457 1067 l 328 971 m 619 1047 l 604 1096 q 649 1113 631 1103 q 667 1146 667 1124 q 644 1185 667 1174 q 568 1200 621 1197 l 581 1258 q 705 1231 663 1256 q 747 1157 747 1206 q 708 1080 747 1104 q 619 1047 669 1056 z "},"Ễ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 328 971 l 281 1007 l 410 1128 l 510 1128 l 639 1007 l 592 971 l 463 1063 l 457 1063 l 328 971 m 551 1165 q 494 1176 518 1165 q 451 1200 471 1188 q 413 1224 431 1213 q 374 1235 394 1235 q 337 1218 349 1235 q 321 1171 325 1201 l 258 1178 q 286 1267 261 1231 q 368 1304 311 1304 q 425 1294 401 1304 q 469 1270 449 1283 q 507 1247 489 1257 q 546 1236 525 1236 q 583 1253 571 1236 q 599 1300 594 1269 l 661 1293 q 633 1202 658 1239 q 551 1165 608 1165 z "},"Ệ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 304 971 l 254 1007 l 400 1164 l 519 1164 l 665 1007 l 615 971 l 463 1100 l 457 1100 l 304 971 m 463 -297 q 397 -273 424 -297 q 371 -208 371 -249 q 397 -144 371 -168 q 463 -119 424 -119 q 528 -144 501 -119 q 554 -208 554 -168 q 528 -273 554 -249 q 463 -297 501 -297 z "},"Ḗ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 274 1021 l 274 1100 l 646 1100 l 646 1021 l 274 1021 m 435 1149 l 392 1201 l 560 1344 l 614 1278 l 435 1149 z "},"Ǵ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 418 968 l 368 1026 l 564 1204 l 629 1128 l 418 968 z "},"Ĝ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 303 971 l 253 1007 l 399 1164 l 518 1164 l 664 1007 l 614 971 l 461 1100 l 456 1100 l 303 971 z "},"Ğ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 458 979 q 374 994 410 979 q 313 1033 338 1008 q 274 1090 288 1057 q 256 1158 260 1122 l 325 1169 q 366 1087 333 1121 q 458 1053 399 1053 q 551 1087 518 1053 q 592 1169 583 1121 l 661 1158 q 643 1090 657 1122 q 604 1033 629 1057 q 543 994 579 1008 q 458 979 507 979 z "},"Ġ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 458 992 q 400 1013 424 992 q 376 1071 376 1035 q 400 1127 376 1106 q 458 1149 424 1149 q 517 1127 493 1149 q 540 1071 540 1106 q 517 1013 540 1035 q 458 992 493 992 z "},"Ģ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 338 -314 l 326 -258 q 446 -235 414 -251 q 478 -192 478 -219 q 453 -151 478 -164 q 379 -133 428 -137 l 404 -81 q 531 -116 494 -92 q 567 -187 567 -140 q 508 -278 567 -249 q 338 -314 449 -308 z "},"Ǧ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 399 981 l 253 1138 l 303 1174 l 456 1046 l 461 1046 l 614 1174 l 664 1138 l 518 981 l 399 981 z "},"Ḡ":{"ha":833,"x_min":74,"x_max":740,"o":"m 468 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 561 918 524 928 q 630 892 599 908 q 685 857 661 876 q 729 817 710 838 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 m 272 1021 l 272 1100 l 644 1100 l 644 1021 l 272 1021 z "},"Ɠ":{"ha":833,"x_min":74,"x_max":818,"o":"m 729 817 l 664 743 q 588 803 631 779 q 478 826 544 826 q 362 801 414 826 q 272 727 310 775 q 215 611 235 679 q 194 458 194 543 q 213 303 194 372 q 267 186 232 235 q 356 111 303 138 q 475 85 408 85 q 565 99 524 85 q 633 139 607 114 l 633 376 l 451 376 l 451 472 l 740 472 l 740 89 q 627 14 697 44 q 468 -17 557 -17 q 310 15 382 -17 q 185 108 238 47 q 103 256 132 168 q 74 456 74 344 q 103 653 74 565 q 187 802 133 742 q 315 895 240 863 q 478 928 389 928 q 535 923 508 928 q 586 911 563 918 q 576 971 576 939 q 619 1076 576 1036 q 731 1117 661 1117 q 780 1111 758 1117 q 818 1099 801 1106 l 796 1011 q 774 1019 785 1015 q 749 1024 764 1024 q 693 1002 713 1024 q 674 949 674 981 q 688 884 674 911 q 729 817 701 857 z "},"Ĥ":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ḧ":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ḥ":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ḩ":{"ha":833,"x_min":39,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 m 50 -314 l 39 -258 q 158 -235 126 -251 q 190 -189 190 -219 q 167 -146 190 -161 q 83 -122 143 -131 l 139 11 l 214 11 l 178 -89 q 253 -122 226 -100 q 279 -187 279 -144 q 220 -278 279 -249 q 50 -314 161 -308 z "},"Ḫ":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 m 417 -319 q 321 -301 361 -319 q 255 -253 281 -283 q 216 -186 229 -224 q 200 -110 203 -149 l 271 -99 q 285 -151 275 -125 q 314 -197 296 -176 q 358 -231 332 -218 q 417 -243 383 -243 q 476 -231 450 -243 q 519 -197 501 -218 q 548 -151 538 -176 q 563 -99 558 -125 l 633 -110 q 617 -186 631 -149 q 578 -253 604 -224 q 512 -301 551 -283 q 417 -319 472 -319 z "},"Ħ":{"ha":833,"x_min":14,"x_max":819,"o":"m 14 672 l 14 750 l 110 758 l 110 911 l 226 911 l 226 758 l 607 758 l 607 911 l 724 911 l 724 758 l 819 758 l 819 672 l 724 672 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 l 110 672 l 14 672 m 226 529 l 607 529 l 607 672 l 226 672 l 226 529 z "},"Ì":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Í":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Î":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ĩ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ï":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ī":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 231 1021 l 231 1100 l 603 1100 l 603 1021 l 231 1021 z "},"İ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 417 992 q 358 1013 382 992 q 335 1071 335 1035 q 358 1127 335 1106 q 417 1149 382 1149 q 475 1127 451 1149 q 499 1071 499 1106 q 475 1013 499 1035 q 417 992 451 992 z "},"Ǐ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Į":{"ha":833,"x_min":132,"x_max":701,"o":"m 432 -312 q 330 -281 371 -312 q 289 -186 289 -250 q 321 -81 289 -128 q 388 0 353 -33 l 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 482 0 q 404 -81 429 -40 q 379 -161 379 -122 q 403 -215 379 -197 q 454 -232 426 -232 q 494 -223 478 -232 q 524 -203 511 -214 l 558 -262 q 503 -298 535 -283 q 432 -312 472 -312 z "},"Ỉ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ị":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ĭ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 283 1169 q 324 1087 292 1121 q 417 1053 357 1053 q 509 1087 476 1053 q 550 1169 542 1121 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 z "},"Ĵ":{"ha":833,"x_min":113,"x_max":685,"o":"m 383 -17 q 233 19 307 -17 q 113 135 160 56 l 185 206 q 276 114 224 143 q 381 85 328 85 q 524 137 479 85 q 569 301 569 189 l 569 815 l 188 815 l 188 913 l 685 913 l 685 292 q 669 172 685 228 q 619 74 654 115 q 526 8 583 32 q 383 -17 468 -17 m 294 971 l 244 1007 l 390 1164 l 510 1164 l 656 1007 l 606 971 l 453 1100 l 447 1100 l 294 971 z "},"Ķ":{"ha":833,"x_min":136,"x_max":806,"o":"m 136 0 l 136 911 l 253 911 l 253 454 l 257 454 l 640 911 l 772 911 l 483 565 l 806 0 l 675 0 l 410 478 l 253 290 l 253 0 l 136 0 m 349 -314 l 338 -258 q 457 -235 425 -251 q 489 -192 489 -219 q 464 -151 489 -164 q 390 -133 439 -137 l 415 -81 q 542 -116 506 -92 q 578 -187 578 -140 q 519 -278 578 -249 q 349 -314 460 -308 z "},"Ḳ":{"ha":833,"x_min":136,"x_max":806,"o":"m 136 0 l 136 911 l 253 911 l 253 454 l 257 454 l 640 911 l 772 911 l 483 565 l 806 0 l 675 0 l 410 478 l 253 290 l 253 0 l 136 0 m 469 -297 q 404 -273 431 -297 q 378 -208 378 -249 q 404 -144 378 -168 q 469 -119 431 -119 q 535 -144 508 -119 q 561 -208 561 -168 q 535 -273 561 -249 q 469 -297 508 -297 z "},"Ḵ":{"ha":833,"x_min":136,"x_max":806,"o":"m 136 0 l 136 911 l 253 911 l 253 454 l 257 454 l 640 911 l 772 911 l 483 565 l 806 0 l 675 0 l 410 478 l 253 290 l 253 0 l 136 0 m 285 -235 l 285 -156 l 654 -156 l 654 -235 l 285 -235 z "},"Ĺ":{"ha":833,"x_min":174,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 224 968 l 174 1026 l 369 1204 l 435 1128 l 224 968 z "},"Ľ":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 531 715 l 526 1088 l 629 1088 l 629 975 l 610 715 l 531 715 z "},"Ļ":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 364 -314 l 353 -258 q 472 -235 440 -251 q 504 -192 504 -219 q 479 -151 504 -164 q 406 -133 454 -137 l 431 -81 q 557 -116 521 -92 q 593 -187 593 -140 q 534 -278 593 -249 q 364 -314 475 -308 z "},"Ḷ":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 485 -297 q 419 -273 446 -297 q 393 -208 393 -249 q 419 -144 393 -168 q 485 -119 446 -119 q 550 -144 524 -119 q 576 -208 576 -168 q 550 -273 576 -249 q 485 -297 524 -297 z "},"Ḹ":{"ha":833,"x_min":78,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 78 1021 l 78 1100 l 450 1100 l 450 1021 l 78 1021 m 485 -297 q 419 -273 446 -297 q 393 -208 393 -249 q 419 -144 393 -168 q 485 -119 446 -119 q 550 -144 524 -119 q 576 -208 576 -168 q 550 -273 576 -249 q 485 -297 524 -297 z "},"Ḻ":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 300 -235 l 300 -156 l 669 -156 l 669 -235 l 300 -235 z "},"Ł":{"ha":833,"x_min":14,"x_max":751,"o":"m 54 251 l 14 325 l 186 417 l 186 911 l 300 911 l 300 468 l 593 625 l 633 551 l 300 374 l 300 99 l 751 99 l 751 0 l 186 0 l 186 324 l 54 251 z "},"Ŀ":{"ha":833,"x_min":186,"x_max":751,"o":"m 186 0 l 186 911 l 300 911 l 300 99 l 751 99 l 751 0 l 186 0 m 649 399 q 583 423 610 399 q 557 488 557 447 q 583 552 557 528 q 649 576 610 576 q 714 552 688 576 q 740 488 740 528 q 714 423 740 447 q 649 399 688 399 z "},"Ḿ":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ṁ":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 m 417 992 q 358 1013 382 992 q 335 1071 335 1035 q 358 1127 335 1106 q 417 1149 382 1149 q 475 1127 451 1149 q 499 1071 499 1106 q 475 1013 499 1035 q 417 992 451 992 z "},"Ṃ":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ń":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 390 968 l 340 1026 l 536 1204 l 601 1128 l 390 968 z "},"Ǹ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 471 968 l 260 1128 l 325 1204 l 521 1026 l 471 968 z "},"Ň":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 371 981 l 225 1138 l 275 1174 l 428 1046 l 433 1046 l 586 1174 l 636 1138 l 490 981 l 371 981 z "},"Ñ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 535 985 q 468 1000 496 985 q 417 1034 440 1015 q 374 1068 394 1053 q 329 1083 354 1083 q 285 1060 303 1083 q 263 992 267 1036 l 185 997 q 226 1122 189 1076 q 326 1168 264 1168 q 393 1153 365 1168 q 444 1119 421 1138 q 487 1085 467 1100 q 532 1069 507 1069 q 599 1161 588 1069 l 676 1156 q 635 1030 672 1075 q 535 985 597 985 z "},"Ņ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -192 436 -219 q 411 -151 436 -164 q 338 -133 386 -137 l 363 -81 q 489 -116 453 -92 q 525 -187 525 -140 q 466 -278 525 -249 q 296 -314 407 -308 z "},"Ṅ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 431 992 q 372 1013 396 992 q 349 1071 349 1035 q 372 1127 349 1106 q 431 1149 396 1149 q 489 1127 465 1149 q 513 1071 513 1106 q 489 1013 513 1035 q 431 992 465 992 z "},"Ṇ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ṉ":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 m 232 -235 l 232 -156 l 601 -156 l 601 -235 l 232 -235 z "},"Ò":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ó":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ô":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Õ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ö":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ō":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 231 1021 l 231 1100 l 603 1100 l 603 1021 l 231 1021 z "},"Ő":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 317 976 l 257 1006 l 385 1217 l 464 1172 l 317 976 m 539 976 l 479 1006 l 608 1217 l 686 1172 l 539 976 z "},"Ŏ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 283 1169 q 324 1087 292 1121 q 417 1053 357 1053 q 509 1087 476 1053 q 550 1169 542 1121 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 z "},"Ǒ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Ǫ":{"ha":833,"x_min":67,"x_max":767,"o":"m 442 -312 q 339 -281 379 -312 q 299 -186 299 -250 q 328 -89 299 -131 q 397 -15 358 -47 q 255 29 317 -10 q 151 131 193 68 q 88 277 110 193 q 67 460 67 361 q 92 656 67 569 q 165 803 118 743 q 275 896 211 864 q 417 928 339 928 q 558 895 493 928 q 669 802 622 863 q 741 655 715 742 q 767 460 767 568 q 702 163 767 276 q 515 -3 638 49 q 419 -74 451 -31 q 388 -161 388 -118 q 411 -215 388 -197 q 464 -232 435 -232 q 503 -223 486 -232 q 533 -203 519 -214 l 568 -262 q 513 -298 544 -283 q 442 -312 482 -312 m 417 83 q 584 182 521 83 q 647 460 647 281 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 249 182 186 281 q 417 83 313 83 z "},"Ọ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ỏ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ố":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 585 1060 l 543 1104 l 678 1233 l 726 1179 l 585 1060 z "},"Ồ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 249 1060 l 124 1182 l 172 1233 l 290 1101 l 249 1060 z "},"Ổ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 285 971 l 238 1007 l 367 1132 l 467 1132 l 596 1007 l 549 971 l 419 1067 l 414 1067 l 285 971 m 576 1047 l 561 1096 q 606 1113 588 1103 q 624 1146 624 1124 q 601 1185 624 1174 q 525 1200 578 1197 l 538 1258 q 662 1231 619 1256 q 704 1157 704 1206 q 665 1080 704 1104 q 576 1047 626 1056 z "},"Ỗ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 285 971 l 238 1007 l 367 1128 l 467 1128 l 596 1007 l 549 971 l 419 1063 l 414 1063 l 285 971 m 508 1165 q 451 1176 475 1165 q 408 1200 428 1188 q 369 1224 388 1213 q 331 1235 351 1235 q 294 1218 306 1235 q 278 1171 282 1201 l 215 1178 q 243 1267 218 1231 q 325 1304 268 1304 q 382 1294 358 1304 q 426 1270 406 1283 q 464 1247 446 1257 q 503 1236 482 1236 q 540 1253 528 1236 q 556 1300 551 1269 l 618 1293 q 590 1202 615 1239 q 508 1165 565 1165 z "},"Ộ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ơ":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 z "},"Ớ":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ờ":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ở":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ỡ":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 494 985 q 428 1000 456 985 q 377 1034 400 1015 q 334 1068 354 1053 q 289 1083 314 1083 q 244 1060 263 1083 q 222 992 226 1036 l 144 997 q 186 1122 149 1076 q 286 1168 224 1168 q 353 1153 325 1168 q 403 1119 381 1138 q 447 1085 426 1100 q 492 1069 467 1069 q 558 1161 547 1069 l 636 1156 q 594 1030 632 1075 q 494 985 557 985 z "},"Ợ":{"ha":833,"x_min":67,"x_max":781,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 571 889 503 928 q 679 1008 679 911 q 674 1051 679 1029 q 658 1089 668 1072 l 749 1129 q 772 1077 764 1106 q 781 1017 781 1049 q 742 902 781 946 q 636 842 703 858 q 733 686 699 782 q 767 460 767 590 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ṓ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 231 1021 l 231 1100 l 603 1100 l 603 1021 l 231 1021 m 392 1149 l 349 1201 l 517 1344 l 571 1278 l 392 1149 z "},"Ø":{"ha":833,"x_min":50,"x_max":778,"o":"m 417 -17 q 203 67 293 -17 l 128 -44 l 50 6 l 143 142 q 87 281 107 201 q 67 460 67 361 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 628 849 538 928 l 700 956 l 778 906 l 689 775 q 747 638 726 717 q 767 460 767 558 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 186 460 q 218 251 186 339 l 564 757 q 417 826 503 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 614 667 647 583 l 267 160 q 417 85 326 85 z "},"Ǿ":{"ha":833,"x_min":50,"x_max":778,"o":"m 417 -17 q 203 67 293 -17 l 128 -44 l 50 6 l 143 142 q 87 281 107 201 q 67 460 67 361 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 628 849 538 928 l 700 956 l 778 906 l 689 775 q 747 638 726 717 q 767 460 767 558 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 186 460 q 218 251 186 339 l 564 757 q 417 826 503 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 614 667 647 583 l 267 160 q 417 85 326 85 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Œ":{"ha":833,"x_min":46,"x_max":821,"o":"m 411 0 q 142 120 238 0 q 46 460 46 240 q 144 795 46 678 q 415 913 242 913 l 807 913 l 807 815 l 538 815 l 538 528 l 743 528 l 743 429 l 538 429 l 538 99 l 821 99 l 821 0 l 411 0 m 401 94 l 432 94 l 432 817 l 401 817 q 224 725 282 817 q 165 460 165 633 q 224 190 165 285 q 401 94 282 94 z "},"Ŕ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 382 968 l 332 1026 l 528 1204 l 593 1128 l 382 968 z "},"Ř":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 363 981 l 217 1138 l 267 1174 l 419 1046 l 425 1046 l 578 1174 l 628 1138 l 482 981 l 363 981 z "},"Ṙ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 422 992 q 364 1013 388 992 q 340 1071 340 1035 q 364 1127 340 1106 q 422 1149 388 1149 q 481 1127 457 1149 q 504 1071 504 1106 q 481 1013 504 1035 q 422 992 457 992 z "},"Ŗ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 324 -314 l 313 -258 q 432 -235 400 -251 q 464 -192 464 -219 q 439 -151 464 -164 q 365 -133 414 -137 l 390 -81 q 517 -116 481 -92 q 553 -187 553 -140 q 494 -278 553 -249 q 324 -314 435 -308 z "},"Ṛ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 444 -297 q 379 -273 406 -297 q 353 -208 353 -249 q 379 -144 353 -168 q 444 -119 406 -119 q 510 -144 483 -119 q 536 -208 536 -168 q 510 -273 536 -249 q 444 -297 483 -297 z "},"Ṝ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 236 1021 l 236 1100 l 608 1100 l 608 1021 l 236 1021 m 444 -297 q 379 -273 406 -297 q 353 -208 353 -249 q 379 -144 353 -168 q 444 -119 406 -119 q 510 -144 483 -119 q 536 -208 536 -168 q 510 -273 536 -249 q 444 -297 483 -297 z "},"Ṟ":{"ha":833,"x_min":139,"x_max":768,"o":"m 139 0 l 139 911 l 422 911 q 550 898 492 911 q 651 854 608 885 q 717 775 693 824 q 740 656 740 726 q 685 485 740 549 q 536 397 629 421 l 768 0 l 636 0 l 417 385 l 254 385 l 254 0 l 139 0 m 254 479 l 406 479 q 569 523 513 479 q 625 656 625 567 q 569 782 625 746 q 406 818 513 818 l 254 818 l 254 479 m 260 -235 l 260 -156 l 629 -156 l 629 -235 l 260 -235 z "},"Ś":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 399 968 l 349 1026 l 544 1204 l 610 1128 l 399 968 z "},"Ŝ":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 283 971 l 233 1007 l 379 1164 l 499 1164 l 644 1007 l 594 971 l 442 1100 l 436 1100 l 283 971 z "},"Š":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 379 981 l 233 1138 l 283 1174 l 436 1046 l 442 1046 l 594 1174 l 644 1138 l 499 981 l 379 981 z "},"Ş":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 322 -314 l 311 -258 q 431 -235 399 -251 q 463 -189 463 -219 q 439 -146 463 -161 q 356 -122 415 -131 l 411 11 l 486 11 l 450 -89 q 525 -122 499 -100 q 551 -187 551 -144 q 492 -278 551 -249 q 322 -314 433 -308 z "},"Ș":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 314 -314 l 303 -258 q 422 -235 390 -251 q 454 -192 454 -219 q 429 -151 454 -164 q 356 -133 404 -137 l 381 -81 q 507 -116 471 -92 q 543 -187 543 -140 q 484 -278 543 -249 q 314 -314 425 -308 z "},"Ṡ":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 439 992 q 381 1013 404 992 q 357 1071 357 1035 q 381 1127 357 1106 q 439 1149 404 1149 q 497 1127 474 1149 q 521 1071 521 1106 q 497 1013 521 1035 q 439 992 474 992 z "},"Ṣ":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 m 435 -297 q 369 -273 396 -297 q 343 -208 343 -249 q 369 -144 343 -168 q 435 -119 396 -119 q 500 -144 474 -119 q 526 -208 526 -168 q 500 -273 526 -249 q 435 -297 474 -297 z "},"ẞ":{"ha":833,"x_min":108,"x_max":790,"o":"m 542 -17 q 415 10 474 -17 q 318 85 357 36 l 374 158 q 446 99 408 118 q 532 81 483 81 q 633 123 596 81 q 669 232 669 165 q 659 295 669 265 q 622 351 649 325 q 548 397 594 376 q 431 431 501 417 l 422 506 l 594 719 q 527 805 571 778 q 424 832 483 832 q 279 769 333 832 q 225 574 225 707 l 225 0 l 108 0 l 108 594 q 131 733 108 671 q 193 838 153 794 q 292 904 233 881 q 424 928 350 928 q 611 869 540 928 q 715 714 682 811 l 547 504 q 663 456 615 483 q 738 395 710 429 q 778 320 765 361 q 790 232 790 279 q 774 133 790 179 q 724 54 757 88 q 646 2 692 21 q 542 -17 600 -17 z "},"Ť":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Ţ":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -189 436 -219 q 413 -146 436 -161 q 329 -122 389 -131 l 385 11 l 460 11 l 424 -89 q 499 -122 472 -100 q 525 -187 525 -144 q 466 -278 525 -249 q 296 -314 407 -308 z "},"Ț":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -192 436 -219 q 411 -151 436 -164 q 338 -133 386 -137 l 363 -81 q 489 -116 453 -92 q 525 -187 525 -140 q 466 -278 525 -249 q 296 -314 407 -308 z "},"Ṭ":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ṯ":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 m 232 -235 l 232 -156 l 601 -156 l 601 -235 l 232 -235 z "},"Ŧ":{"ha":833,"x_min":58,"x_max":775,"o":"m 161 425 l 161 506 l 286 511 l 358 511 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 511 l 672 511 l 672 425 l 475 425 l 475 0 l 358 0 l 358 425 l 161 425 z "},"Ù":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ú":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Û":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ũ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ü":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ū":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 231 1021 l 231 1100 l 603 1100 l 603 1021 l 231 1021 z "},"Ŭ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 417 979 q 332 994 368 979 q 271 1033 296 1008 q 232 1090 246 1057 q 214 1158 218 1122 l 283 1169 q 324 1087 292 1121 q 417 1053 357 1053 q 509 1087 476 1053 q 550 1169 542 1121 l 619 1158 q 601 1090 615 1122 q 563 1033 588 1057 q 501 994 538 1008 q 417 979 465 979 z "},"Ů":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 417 971 q 320 1005 358 971 q 282 1096 282 1039 q 320 1188 282 1154 q 417 1222 358 1222 q 513 1188 475 1222 q 551 1096 551 1154 q 513 1005 551 1039 q 417 971 475 971 m 417 1021 q 466 1040 444 1021 q 488 1096 488 1060 q 466 1151 488 1132 q 417 1171 444 1171 q 365 1151 386 1171 q 344 1096 344 1132 q 365 1040 344 1060 q 417 1021 386 1021 z "},"Ű":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 317 976 l 257 1006 l 385 1217 l 464 1172 l 317 976 m 539 976 l 479 1006 l 608 1217 l 686 1172 l 539 976 z "},"Ǔ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 357 981 l 211 1138 l 261 1174 l 414 1046 l 419 1046 l 572 1174 l 622 1138 l 476 981 l 357 981 z "},"Ų":{"ha":833,"x_min":110,"x_max":724,"o":"m 442 -312 q 339 -281 379 -312 q 299 -186 299 -250 q 308 -131 299 -157 q 331 -84 317 -106 q 361 -45 344 -62 q 392 -15 378 -28 q 186 79 263 -8 q 110 344 110 167 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 340 99 306 113 q 417 85 375 85 q 494 99 458 85 q 555 142 529 113 q 596 222 581 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 675 117 724 197 q 532 0 626 38 q 419 -76 450 -33 q 388 -161 388 -119 q 411 -215 388 -197 q 464 -232 435 -232 q 503 -223 486 -232 q 533 -203 519 -214 l 568 -262 q 513 -298 544 -283 q 442 -312 482 -312 z "},"Ǖ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 274 993 q 228 1011 246 993 q 211 1057 211 1029 q 228 1102 211 1085 q 274 1119 246 1119 q 319 1102 301 1119 q 338 1057 338 1085 q 319 1011 338 1029 q 274 993 301 993 m 560 993 q 514 1011 532 993 q 496 1057 496 1029 q 514 1102 496 1085 q 560 1119 532 1119 q 605 1102 588 1119 q 622 1057 622 1085 q 605 1011 622 1029 q 560 993 588 993 m 231 1196 l 231 1260 l 603 1260 l 603 1196 l 231 1196 z "},"Ǘ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 274 993 q 228 1011 246 993 q 211 1057 211 1029 q 228 1102 211 1085 q 274 1119 246 1119 q 319 1102 301 1119 q 338 1057 338 1085 q 319 1011 338 1029 q 274 993 301 993 m 560 993 q 514 1011 532 993 q 496 1057 496 1029 q 514 1102 496 1085 q 560 1119 532 1119 q 605 1102 588 1119 q 622 1057 622 1085 q 605 1011 622 1029 q 560 993 588 993 m 415 1143 l 364 1179 l 496 1344 l 569 1294 l 415 1143 z "},"Ǚ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 274 993 q 228 1011 246 993 q 211 1057 211 1029 q 228 1102 211 1085 q 274 1119 246 1119 q 319 1102 301 1119 q 338 1057 338 1085 q 319 1011 338 1029 q 274 993 301 993 m 560 993 q 514 1011 532 993 q 496 1057 496 1029 q 514 1102 496 1085 q 560 1119 532 1119 q 605 1102 588 1119 q 622 1057 622 1085 q 605 1011 622 1029 q 560 993 588 993 m 367 1165 l 229 1299 l 275 1336 l 414 1232 l 419 1232 l 558 1336 l 604 1299 l 467 1165 l 367 1165 z "},"Ǜ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 274 993 q 228 1011 246 993 q 211 1057 211 1029 q 228 1102 211 1085 q 274 1119 246 1119 q 319 1102 301 1119 q 338 1057 338 1085 q 319 1011 338 1029 q 274 993 301 993 m 560 993 q 514 1011 532 993 q 496 1057 496 1029 q 514 1102 496 1085 q 560 1119 532 1119 q 605 1102 588 1119 q 622 1057 622 1085 q 605 1011 622 1029 q 560 993 588 993 m 418 1143 l 264 1294 l 338 1344 l 469 1179 l 418 1143 z "},"Ụ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ủ":{"ha":833,"x_min":110,"x_max":724,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 724 911 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ư":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 z "},"Ứ":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ừ":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ử":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ữ":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ự":{"ha":833,"x_min":110,"x_max":875,"o":"m 418 -17 q 294 3 351 -17 q 197 66 238 22 q 133 178 156 110 q 110 344 110 246 l 110 911 l 226 911 l 226 342 q 241 222 226 271 q 281 142 256 172 q 342 99 307 113 q 418 85 376 85 q 494 99 460 85 q 556 142 529 113 q 597 222 582 172 q 611 342 611 271 l 611 911 l 657 911 q 744 943 714 918 q 774 1026 774 968 q 768 1069 774 1047 q 753 1107 763 1090 l 843 1146 q 867 1094 858 1122 q 875 1035 875 1067 q 831 915 875 954 q 724 861 788 876 l 724 344 q 701 178 724 246 q 638 66 678 110 q 541 3 597 22 q 418 -17 485 -17 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ṿ":{"ha":833,"x_min":60,"x_max":774,"o":"m 350 0 l 60 911 l 182 911 l 329 419 q 372 268 353 338 q 417 118 392 199 l 422 118 q 446 195 435 158 q 467 268 457 232 q 488 342 478 304 q 510 419 499 379 l 656 911 l 774 911 l 485 0 l 350 0 m 419 -297 q 354 -273 381 -297 q 328 -208 328 -249 q 354 -144 328 -168 q 419 -119 381 -119 q 485 -144 458 -119 q 511 -208 511 -168 q 485 -273 511 -249 q 419 -297 458 -297 z "},"Ẁ":{"ha":833,"x_min":14,"x_max":819,"o":"m 153 0 l 14 913 l 144 913 l 211 340 q 217 288 214 311 q 222 240 219 264 q 226 189 224 215 q 229 129 228 163 l 233 129 q 244 189 239 163 q 255 240 250 215 q 265 288 260 264 q 278 339 271 311 l 367 678 l 478 678 l 564 339 q 576 288 571 311 q 587 240 582 264 q 597 189 592 215 q 608 129 601 163 l 614 129 q 617 189 615 163 q 622 240 619 215 q 626 288 624 264 q 631 339 628 311 l 694 913 l 819 913 l 686 0 l 542 0 l 453 367 q 434 449 442 408 q 419 531 426 489 l 415 531 q 401 449 408 489 q 383 367 394 408 l 294 0 l 153 0 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ẃ":{"ha":833,"x_min":14,"x_max":819,"o":"m 153 0 l 14 913 l 144 913 l 211 340 q 217 288 214 311 q 222 240 219 264 q 226 189 224 215 q 229 129 228 163 l 233 129 q 244 189 239 163 q 255 240 250 215 q 265 288 260 264 q 278 339 271 311 l 367 678 l 478 678 l 564 339 q 576 288 571 311 q 587 240 582 264 q 597 189 592 215 q 608 129 601 163 l 614 129 q 617 189 615 163 q 622 240 619 215 q 626 288 624 264 q 631 339 628 311 l 694 913 l 819 913 l 686 0 l 542 0 l 453 367 q 434 449 442 408 q 419 531 426 489 l 415 531 q 401 449 408 489 q 383 367 394 408 l 294 0 l 153 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ŵ":{"ha":833,"x_min":14,"x_max":819,"o":"m 153 0 l 14 913 l 144 913 l 211 340 q 217 288 214 311 q 222 240 219 264 q 226 189 224 215 q 229 129 228 163 l 233 129 q 244 189 239 163 q 255 240 250 215 q 265 288 260 264 q 278 339 271 311 l 367 678 l 478 678 l 564 339 q 576 288 571 311 q 587 240 582 264 q 597 189 592 215 q 608 129 601 163 l 614 129 q 617 189 615 163 q 622 240 619 215 q 626 288 624 264 q 631 339 628 311 l 694 913 l 819 913 l 686 0 l 542 0 l 453 367 q 434 449 442 408 q 419 531 426 489 l 415 531 q 401 449 408 489 q 383 367 394 408 l 294 0 l 153 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ẅ":{"ha":833,"x_min":14,"x_max":819,"o":"m 153 0 l 14 913 l 144 913 l 211 340 q 217 288 214 311 q 222 240 219 264 q 226 189 224 215 q 229 129 228 163 l 233 129 q 244 189 239 163 q 255 240 250 215 q 265 288 260 264 q 278 339 271 311 l 367 678 l 478 678 l 564 339 q 576 288 571 311 q 587 240 582 264 q 597 189 592 215 q 608 129 601 163 l 614 129 q 617 189 615 163 q 622 240 619 215 q 626 288 624 264 q 631 339 628 311 l 694 913 l 819 913 l 686 0 l 542 0 l 453 367 q 434 449 442 408 q 419 531 426 489 l 415 531 q 401 449 408 489 q 383 367 394 408 l 294 0 l 153 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ỳ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 457 968 l 246 1128 l 311 1204 l 507 1026 l 457 968 z "},"Ý":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Ŷ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 261 971 l 211 1007 l 357 1164 l 476 1164 l 622 1007 l 572 971 l 419 1100 l 414 1100 l 261 971 z "},"Ÿ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ẏ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 417 992 q 358 1013 382 992 q 335 1071 335 1035 q 358 1127 335 1106 q 417 1149 382 1149 q 475 1127 451 1149 q 499 1071 499 1106 q 475 1013 499 1035 q 417 992 451 992 z "},"Ỵ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"Ỷ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 372 969 l 360 1022 q 415 1046 393 1032 q 438 1086 438 1060 q 322 1144 438 1140 l 335 1211 q 476 1180 426 1208 q 526 1099 526 1151 q 514 1047 526 1068 q 480 1009 501 1025 q 431 984 458 993 q 372 969 403 975 z "},"Ỹ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 521 985 q 454 1000 482 985 q 403 1034 426 1015 q 360 1068 381 1053 q 315 1083 340 1083 q 271 1060 289 1083 q 249 992 253 1036 l 171 997 q 213 1122 175 1076 q 313 1168 250 1168 q 379 1153 351 1168 q 430 1119 407 1138 q 473 1085 453 1100 q 518 1069 493 1069 q 585 1161 574 1069 l 663 1156 q 621 1030 658 1075 q 521 985 583 985 z "},"Ź":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 400 968 l 350 1026 l 546 1204 l 611 1128 l 400 968 z "},"Ž":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 381 981 l 235 1138 l 285 1174 l 438 1046 l 443 1046 l 596 1174 l 646 1138 l 500 981 l 381 981 z "},"Ż":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 440 992 q 382 1013 406 992 q 358 1071 358 1035 q 382 1127 358 1106 q 440 1149 406 1149 q 499 1127 475 1149 q 522 1071 522 1106 q 499 1013 522 1035 q 440 992 475 992 z "},"Ẑ":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 285 971 l 235 1007 l 381 1164 l 500 1164 l 646 1007 l 596 971 l 443 1100 l 438 1100 l 285 971 z "},"Ẓ":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 431 -297 q 365 -273 392 -297 q 339 -208 339 -249 q 365 -144 339 -168 q 431 -119 392 -119 q 496 -144 469 -119 q 522 -208 522 -168 q 496 -273 522 -249 q 431 -297 469 -297 z "},"Ẕ":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 m 246 -235 l 246 -156 l 615 -156 l 615 -235 l 246 -235 z "},"Ð":{"ha":833,"x_min":17,"x_max":768,"o":"m 121 0 l 121 436 l 17 436 l 17 514 l 121 522 l 121 911 l 346 911 q 660 794 553 911 q 768 460 768 678 q 660 121 768 242 q 351 0 553 0 l 121 0 m 236 94 l 338 94 q 570 190 493 94 q 647 460 647 286 q 570 725 647 633 q 338 817 493 817 l 236 817 l 236 522 l 436 522 l 436 436 l 236 436 l 236 94 z "},"Þ":{"ha":833,"x_min":140,"x_max":757,"o":"m 140 0 l 140 911 l 257 911 l 257 758 l 421 758 q 558 744 496 758 q 665 699 621 731 q 733 616 708 667 q 757 490 757 565 q 733 365 757 418 q 664 276 708 311 q 558 225 619 242 q 421 208 496 208 l 257 208 l 257 0 l 140 0 m 257 303 l 406 303 q 584 347 526 303 q 642 490 642 392 q 583 626 642 589 q 406 664 524 664 l 257 664 l 257 303 z "},"Ə":{"ha":833,"x_min":82,"x_max":764,"o":"m 417 -17 q 278 17 340 -17 q 173 113 217 51 q 106 260 129 174 q 82 454 82 347 q 82 470 82 463 q 83 486 82 478 l 649 486 q 583 739 643 650 q 413 828 524 828 q 310 806 356 828 q 229 747 264 783 l 174 826 q 277 899 217 871 q 418 928 338 928 q 563 895 499 928 q 672 802 626 863 q 740 655 717 742 q 764 458 764 568 q 738 261 764 349 q 667 112 713 174 q 557 17 621 50 q 417 -17 493 -17 m 417 83 q 574 163 513 83 q 647 397 636 242 l 196 397 q 264 161 207 239 q 417 83 321 83 z "},"Ŋ":{"ha":833,"x_min":118,"x_max":763,"o":"m 525 -17 q 469 -12 499 -17 q 421 3 440 -7 l 450 107 q 478 97 463 100 q 513 93 493 93 q 565 110 540 93 q 606 171 589 128 q 633 285 624 214 q 643 465 643 357 q 628 638 643 568 q 587 749 614 707 q 522 808 560 790 q 438 826 483 826 q 329 789 386 826 q 233 696 272 751 l 233 0 l 118 0 l 118 911 l 231 911 l 231 804 q 335 892 275 856 q 463 928 396 928 q 582 903 526 928 q 677 824 638 879 q 740 681 717 769 q 763 465 763 593 q 747 242 763 333 q 700 93 731 150 q 625 10 669 36 q 525 -17 581 -17 z "},"Ĳ":{"ha":833,"x_min":156,"x_max":678,"o":"m 156 0 l 156 911 l 271 911 l 271 0 l 156 0 m 488 -229 q 430 -224 456 -229 q 385 -211 404 -218 l 407 -119 q 440 -129 422 -125 q 475 -133 457 -133 q 545 -98 528 -133 q 563 0 563 -62 l 563 911 l 678 911 l 678 -4 q 634 -168 678 -107 q 488 -229 590 -229 z "},"à":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 474 789 l 256 1001 l 336 1079 l 533 846 l 474 789 z "},"á":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 415 789 l 356 846 l 553 1079 l 633 1001 l 415 789 z "},"â":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 278 789 l 229 833 l 388 1028 l 501 1028 l 660 833 l 611 789 l 447 946 l 442 946 l 278 789 z "},"ã":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 544 801 q 481 819 507 801 q 432 860 454 838 q 390 900 410 882 q 346 918 369 918 q 299 888 314 918 q 281 808 283 857 l 204 813 q 215 888 206 853 q 240 947 224 922 q 283 987 257 972 q 344 1001 308 1001 q 408 983 382 1001 q 457 943 435 965 q 499 903 479 921 q 544 885 519 885 q 590 915 575 885 q 608 994 606 946 l 685 989 q 674 915 683 949 q 649 856 665 881 q 606 816 632 831 q 544 801 581 801 z "},"ä":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 310 817 q 255 839 276 817 q 233 894 233 861 q 255 949 233 926 q 310 972 276 972 q 365 949 343 972 q 386 894 386 926 q 365 839 386 861 q 310 817 343 817 m 579 817 q 524 839 546 817 q 503 894 503 861 q 524 949 503 926 q 579 972 546 972 q 634 949 613 972 q 656 894 656 926 q 634 839 656 861 q 579 817 613 817 z "},"ā":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 260 835 l 260 914 l 629 914 l 629 835 l 260 835 z "},"ă":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 349 811 389 793 q 283 859 308 829 q 244 926 257 889 q 228 1003 231 964 l 299 1014 q 313 962 303 988 q 342 915 324 936 q 385 882 360 894 q 444 869 411 869 q 503 882 478 869 q 547 915 529 894 q 576 962 565 936 q 590 1014 586 988 l 661 1003 q 645 926 658 964 q 606 859 632 889 q 540 811 579 829 q 444 793 500 793 z "},"å":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 790 q 332 828 372 790 q 292 924 292 867 q 332 1019 292 981 q 444 1057 372 1057 q 557 1019 517 1057 q 597 924 597 981 q 557 828 597 867 q 444 790 517 790 m 444 842 q 501 865 478 842 q 524 924 524 889 q 501 983 524 960 q 444 1006 478 1006 q 388 983 411 1006 q 365 924 365 960 q 388 865 365 889 q 444 842 411 842 z "},"ǻ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 790 q 332 828 372 790 q 292 924 292 867 q 308 989 292 960 q 357 1036 325 1018 l 542 1171 l 590 1101 l 489 1053 q 569 1006 540 1042 q 597 924 597 971 q 557 828 597 867 q 444 790 517 790 m 444 842 q 501 865 478 842 q 524 924 524 889 q 501 983 524 960 q 444 1006 478 1006 q 388 983 411 1006 q 365 924 365 960 q 388 865 365 889 q 444 842 411 842 z "},"ǎ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 388 797 l 229 992 l 278 1036 l 442 879 l 447 879 l 611 1036 l 660 992 l 501 797 l 388 797 z "},"ą":{"ha":833,"x_min":113,"x_max":763,"o":"m 633 -312 q 531 -281 572 -312 q 490 -183 490 -250 q 529 -74 490 -121 q 622 7 568 -26 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 q 608 -76 640 -33 q 575 -161 575 -118 q 600 -219 575 -201 q 657 -237 625 -237 q 699 -229 681 -237 q 729 -208 717 -221 l 763 -262 q 706 -299 739 -286 q 633 -312 674 -312 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 z "},"ạ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ả":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 400 794 l 388 850 q 443 873 421 858 q 465 915 465 888 q 350 981 465 975 l 357 1056 q 504 1020 453 1053 q 556 925 556 988 q 542 873 556 894 q 508 835 529 851 q 458 810 486 819 q 400 794 431 800 z "},"ấ":{"ha":833,"x_min":113,"x_max":771,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 299 792 l 258 839 l 397 967 l 492 967 l 631 839 l 590 792 l 447 892 l 442 892 l 299 792 m 631 885 l 582 924 l 703 1090 l 771 1043 l 631 885 z "},"ầ":{"ha":833,"x_min":101,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 299 792 l 258 839 l 397 967 l 492 967 l 631 839 l 590 792 l 447 892 l 442 892 l 299 792 m 258 885 l 101 1040 l 168 1090 l 307 928 l 258 885 z "},"ẩ":{"ha":833,"x_min":113,"x_max":735,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 299 792 l 258 839 l 397 967 l 492 967 l 631 839 l 590 792 l 447 892 l 442 892 l 299 792 m 606 882 l 593 931 q 635 950 619 938 q 651 985 651 963 q 629 1026 651 1013 q 556 1042 607 1039 l 565 1099 q 691 1071 647 1096 q 735 997 735 1046 q 724 950 735 969 q 694 917 713 931 q 653 896 676 904 q 606 882 631 888 z "},"ẫ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 299 792 l 258 839 l 397 961 l 492 961 l 631 839 l 590 792 l 447 888 l 442 888 l 299 792 m 535 986 q 481 995 504 986 q 437 1015 457 1004 q 398 1035 417 1026 q 360 1044 379 1044 q 329 1031 339 1044 q 314 986 319 1017 l 254 992 q 283 1081 260 1046 q 354 1115 306 1115 q 408 1106 385 1115 q 452 1086 432 1097 q 491 1066 472 1075 q 529 1057 510 1057 q 560 1071 550 1057 q 575 1115 569 1085 l 635 1110 q 606 1022 629 1057 q 535 986 583 986 z "},"ậ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 278 789 l 229 833 l 388 1028 l 501 1028 l 660 833 l 611 789 l 447 946 l 442 946 l 278 789 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ắ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 349 811 389 793 q 283 859 308 829 q 244 926 257 889 q 228 1003 231 964 l 294 1014 q 309 959 299 986 q 338 911 319 932 q 383 877 357 890 q 444 864 410 864 q 506 877 479 864 q 551 911 532 890 q 580 959 569 932 q 594 1014 590 986 l 661 1003 q 645 926 658 964 q 606 859 632 889 q 540 811 579 829 q 444 793 500 793 m 438 943 l 383 983 l 506 1156 l 578 1100 l 438 943 z "},"ằ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 349 811 389 793 q 283 859 308 829 q 244 926 257 889 q 228 1003 231 964 l 294 1014 q 309 959 299 986 q 338 911 319 932 q 383 877 357 890 q 444 864 410 864 q 506 877 479 864 q 551 911 532 890 q 580 959 569 932 q 594 1014 590 986 l 661 1003 q 645 926 658 964 q 606 859 632 889 q 540 811 579 829 q 444 793 500 793 m 451 943 l 311 1100 l 383 1156 l 506 983 l 451 943 z "},"ẳ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 349 811 389 793 q 283 859 308 829 q 244 926 257 889 q 228 1003 231 964 l 294 1014 q 309 959 299 986 q 338 911 319 932 q 383 877 357 890 q 444 864 410 864 q 506 877 479 864 q 551 911 532 890 q 580 959 569 932 q 594 1014 590 986 l 661 1003 q 645 926 658 964 q 606 859 632 889 q 540 811 579 829 q 444 793 500 793 m 407 947 l 396 997 q 444 1017 425 1004 q 463 1051 463 1029 q 438 1092 463 1079 q 357 1108 414 1106 l 367 1178 q 499 1147 451 1175 q 546 1064 546 1119 q 534 1016 546 1036 q 503 982 522 996 q 458 960 483 968 q 407 947 433 951 z "},"ẵ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 357 806 393 793 q 297 841 321 819 q 260 889 272 863 q 244 942 247 915 l 310 953 q 347 888 315 918 q 444 858 379 858 q 542 888 510 858 q 579 953 574 918 l 644 942 q 629 889 642 915 q 592 841 617 863 q 532 806 568 819 q 444 793 496 793 m 535 986 q 481 995 504 986 q 437 1015 457 1004 q 398 1035 417 1026 q 360 1044 379 1044 q 329 1030 339 1044 q 314 985 319 1015 l 249 992 q 278 1079 254 1044 q 354 1114 303 1114 q 408 1105 385 1114 q 452 1085 432 1096 q 491 1065 472 1074 q 529 1056 510 1056 q 560 1070 550 1056 q 575 1114 569 1085 l 640 1108 q 610 1021 635 1056 q 535 986 586 986 z "},"ặ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 793 q 349 811 389 793 q 283 859 308 829 q 244 926 257 889 q 228 1003 231 964 l 299 1014 q 313 962 303 988 q 342 915 324 936 q 385 882 360 894 q 444 869 411 869 q 503 882 478 869 q 547 915 529 894 q 576 962 565 936 q 590 1014 586 988 l 661 1003 q 645 926 658 964 q 606 859 632 889 q 540 811 579 829 q 444 793 500 793 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"æ":{"ha":833,"x_min":24,"x_max":829,"o":"m 201 -17 q 74 32 124 -17 q 24 167 24 81 q 105 333 24 269 q 369 419 186 396 q 333 558 367 518 q 247 597 300 597 q 163 581 206 597 q 89 542 121 564 l 46 619 q 142 669 88 647 q 257 692 197 692 q 361 660 318 692 q 428 553 404 628 q 514 660 463 628 q 622 692 565 692 q 714 667 675 692 q 778 599 753 642 q 817 501 804 557 q 829 383 829 446 q 828 344 829 364 q 824 306 826 324 l 461 306 q 511 138 467 199 q 635 76 556 76 q 706 89 674 76 q 767 121 739 101 l 808 43 q 728 1 774 18 q 631 -17 683 -17 q 508 15 560 -17 q 422 104 456 46 q 319 15 374 46 q 201 -17 264 -17 m 232 75 q 314 99 271 75 q 393 171 357 124 q 369 336 369 246 l 369 346 q 253 319 299 335 q 179 282 207 303 q 140 235 151 261 q 129 178 129 208 q 158 102 129 129 q 232 75 186 75 m 615 601 q 518 554 563 601 q 463 394 474 507 l 736 394 q 615 601 731 601 z "},"ǽ":{"ha":833,"x_min":24,"x_max":829,"o":"m 201 -17 q 74 32 124 -17 q 24 167 24 81 q 105 333 24 269 q 369 419 186 396 q 333 558 367 518 q 247 597 300 597 q 163 581 206 597 q 89 542 121 564 l 46 619 q 142 669 88 647 q 257 692 197 692 q 361 660 318 692 q 428 553 404 628 q 514 660 463 628 q 622 692 565 692 q 714 667 675 692 q 778 599 753 642 q 817 501 804 557 q 829 383 829 446 q 828 344 829 364 q 824 306 826 324 l 461 306 q 511 138 467 199 q 635 76 556 76 q 706 89 674 76 q 767 121 739 101 l 808 43 q 728 1 774 18 q 631 -17 683 -17 q 508 15 560 -17 q 422 104 456 46 q 319 15 374 46 q 201 -17 264 -17 m 232 75 q 314 99 271 75 q 393 171 357 124 q 369 336 369 246 l 369 346 q 253 319 299 335 q 179 282 207 303 q 140 235 151 261 q 129 178 129 208 q 158 102 129 129 q 232 75 186 75 m 615 601 q 518 554 563 601 q 463 394 474 507 l 736 394 q 615 601 731 601 m 410 789 l 350 846 l 547 1079 l 628 1001 l 410 789 z "},"ǣ":{"ha":833,"x_min":24,"x_max":829,"o":"m 201 -17 q 74 32 124 -17 q 24 167 24 81 q 105 333 24 269 q 369 419 186 396 q 333 558 367 518 q 247 597 300 597 q 163 581 206 597 q 89 542 121 564 l 46 619 q 142 669 88 647 q 257 692 197 692 q 361 660 318 692 q 428 553 404 628 q 514 660 463 628 q 622 692 565 692 q 714 667 675 692 q 778 599 753 642 q 817 501 804 557 q 829 383 829 446 q 828 344 829 364 q 824 306 826 324 l 461 306 q 511 138 467 199 q 635 76 556 76 q 706 89 674 76 q 767 121 739 101 l 808 43 q 728 1 774 18 q 631 -17 683 -17 q 508 15 560 -17 q 422 104 456 46 q 319 15 374 46 q 201 -17 264 -17 m 232 75 q 314 99 271 75 q 393 171 357 124 q 369 336 369 246 l 369 346 q 253 319 299 335 q 179 282 207 303 q 140 235 151 261 q 129 178 129 208 q 158 102 129 129 q 232 75 186 75 m 615 601 q 518 554 563 601 q 463 394 474 507 l 736 394 q 615 601 731 601 m 254 835 l 254 914 l 624 914 l 624 835 l 254 835 z "},"ƀ":{"ha":833,"x_min":28,"x_max":750,"o":"m 444 -17 q 340 8 396 -17 q 235 75 283 32 l 231 75 l 221 0 l 129 0 l 129 781 l 28 781 l 28 863 l 129 869 l 129 989 l 243 989 l 243 869 l 539 869 l 539 781 l 243 781 l 243 688 l 239 561 l 243 561 q 349 636 289 608 q 469 664 410 664 q 590 640 538 664 q 678 574 643 617 q 732 471 714 532 q 750 335 750 410 q 725 186 750 251 q 658 76 700 121 q 560 7 615 31 q 444 -17 504 -17 m 426 79 q 574 147 515 79 q 632 333 632 214 q 588 503 632 439 q 442 568 543 568 q 347 544 397 568 q 243 467 296 519 l 243 158 q 341 97 292 115 q 426 79 390 79 z "},"ḇ":{"ha":833,"x_min":129,"x_max":750,"o":"m 444 -17 q 340 8 396 -17 q 235 75 283 32 l 231 75 l 221 0 l 129 0 l 129 989 l 243 989 l 243 719 l 239 589 l 243 589 q 349 664 289 636 q 469 692 410 692 q 590 667 538 692 q 678 598 643 643 q 732 490 714 553 q 750 349 750 426 q 725 194 750 263 q 658 79 700 126 q 560 8 615 32 q 444 -17 504 -17 m 426 79 q 508 98 471 79 q 574 151 546 117 q 617 235 601 185 q 632 347 632 285 q 621 449 632 403 q 587 527 610 494 q 528 578 564 560 q 442 596 492 596 q 347 572 397 596 q 243 494 296 547 l 243 158 q 341 97 292 115 q 426 79 390 79 m 246 -235 l 246 -156 l 615 -156 l 615 -235 l 246 -235 z "},"ç":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 m 360 -314 l 349 -258 q 468 -235 436 -251 q 500 -189 500 -219 q 476 -146 500 -161 q 393 -122 453 -131 l 449 11 l 524 11 l 488 -89 q 563 -122 536 -100 q 589 -187 589 -144 q 530 -278 589 -249 q 360 -314 471 -308 z "},"ć":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 m 451 789 l 392 846 l 589 1079 l 669 1001 l 451 789 z "},"ĉ":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 m 314 789 l 265 833 l 424 1028 l 538 1028 l 696 833 l 647 789 l 483 946 l 478 946 l 314 789 z "},"č":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 m 424 797 l 265 992 l 314 1036 l 478 879 l 483 879 l 647 1036 l 696 992 l 538 797 l 424 797 z "},"ċ":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 m 481 817 q 415 841 442 817 q 389 906 389 865 q 415 970 389 946 q 481 994 442 994 q 546 970 519 994 q 572 906 572 946 q 546 841 572 865 q 481 817 519 817 z "},"ď":{"ha":833,"x_min":75,"x_max":860,"o":"m 353 -17 q 239 7 290 -17 q 151 76 188 31 q 95 186 115 121 q 75 336 75 251 q 99 484 75 418 q 164 596 124 550 q 257 667 204 642 q 367 692 310 692 q 469 668 425 692 q 558 604 514 644 l 563 604 l 556 729 l 556 989 l 665 989 l 665 0 l 576 0 l 567 89 l 563 89 q 468 15 522 47 q 353 -17 414 -17 m 376 79 q 556 181 467 79 l 556 517 q 471 577 511 558 q 389 596 431 596 q 310 577 347 596 q 247 524 274 558 q 203 443 219 490 q 188 338 188 396 q 238 147 188 215 q 376 79 288 79 m 761 761 l 757 1133 l 860 1133 l 860 1021 l 840 761 l 761 761 z "},"ḍ":{"ha":833,"x_min":83,"x_max":704,"o":"m 376 -17 q 256 7 310 -17 q 164 76 203 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 275 667 219 642 q 390 692 331 692 q 499 669 451 692 q 592 604 547 646 l 596 604 l 590 729 l 590 989 l 704 989 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 554 46 q 376 -17 439 -17 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 m 422 -297 q 357 -273 383 -297 q 331 -208 331 -249 q 357 -144 331 -168 q 422 -119 383 -119 q 488 -144 461 -119 q 514 -208 514 -168 q 488 -273 514 -249 q 422 -297 461 -297 z "},"ḏ":{"ha":833,"x_min":83,"x_max":704,"o":"m 376 -17 q 256 7 310 -17 q 164 76 203 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 275 667 219 642 q 390 692 331 692 q 499 669 451 692 q 592 604 547 646 l 596 604 l 590 729 l 590 989 l 704 989 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 554 46 q 376 -17 439 -17 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 m 238 -235 l 238 -156 l 607 -156 l 607 -235 l 238 -235 z "},"ḑ":{"ha":833,"x_min":83,"x_max":704,"o":"m 376 -17 q 256 7 310 -17 q 164 76 203 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 275 667 219 642 q 390 692 331 692 q 499 669 451 692 q 592 604 547 646 l 596 604 l 590 729 l 590 989 l 704 989 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 554 46 q 376 -17 439 -17 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 m 290 -314 l 279 -258 q 399 -235 367 -251 q 431 -189 431 -219 q 407 -146 431 -161 q 324 -122 383 -131 l 379 11 l 454 11 l 418 -89 q 493 -122 467 -100 q 519 -187 519 -144 q 460 -278 519 -249 q 290 -314 401 -308 z "},"đ":{"ha":833,"x_min":83,"x_max":806,"o":"m 376 -17 q 256 6 310 -17 q 164 72 203 28 q 104 178 125 115 q 83 322 83 240 q 109 465 83 401 q 177 572 135 528 q 275 640 219 617 q 390 664 331 664 q 500 640 453 664 q 592 576 547 617 l 596 576 l 590 701 l 590 781 l 347 781 l 347 869 l 590 869 l 590 989 l 704 989 l 704 869 l 806 869 l 806 789 l 704 781 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 554 46 q 376 -17 439 -17 m 400 79 q 590 181 500 79 l 590 489 q 501 550 544 532 q 414 568 457 568 q 331 550 369 568 q 263 500 292 532 q 218 423 235 468 q 201 324 201 378 q 253 144 201 208 q 400 79 306 79 z "},"è":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 468 789 l 250 1001 l 331 1079 l 528 846 l 468 789 z "},"é":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 410 789 l 350 846 l 547 1079 l 628 1001 l 410 789 z "},"ê":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 272 789 l 224 833 l 382 1028 l 496 1028 l 654 833 l 606 789 l 442 946 l 436 946 l 272 789 z "},"ě":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 382 797 l 224 992 l 272 1036 l 436 879 l 442 879 l 606 1036 l 654 992 l 496 797 l 382 797 z "},"ë":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 304 817 q 249 839 271 817 q 228 894 228 861 q 249 949 228 926 q 304 972 271 972 q 359 949 338 972 q 381 894 381 926 q 359 839 381 861 q 304 817 338 817 m 574 817 q 519 839 540 817 q 497 894 497 861 q 519 949 497 926 q 574 972 540 972 q 628 949 607 972 q 650 894 650 926 q 628 839 650 861 q 574 817 607 817 z "},"ē":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 254 835 l 254 914 l 624 914 l 624 835 l 254 835 z "},"ĕ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 439 793 q 343 811 383 793 q 277 859 303 829 q 238 926 251 889 q 222 1003 225 964 l 293 1014 q 308 962 297 988 q 336 915 318 936 q 380 882 354 894 q 439 869 406 869 q 498 882 472 869 q 542 915 524 894 q 570 962 560 936 q 585 1014 581 988 l 656 1003 q 640 926 653 964 q 600 859 626 889 q 534 811 574 829 q 439 793 494 793 z "},"ę":{"ha":833,"x_min":94,"x_max":747,"o":"m 586 -312 q 483 -281 524 -312 q 443 -183 443 -250 q 473 -85 443 -128 q 549 -1 503 -42 q 491 -15 513 -14 q 458 -17 469 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 336 94 253 q 123 485 94 419 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 630 -3 667 26 q 570 -59 593 -33 q 538 -110 547 -85 q 528 -161 528 -135 q 553 -219 528 -200 q 610 -237 578 -237 q 651 -229 633 -237 q 683 -208 669 -221 l 717 -262 q 659 -299 692 -286 q 586 -312 626 -312 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 z "},"ė":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 439 817 q 374 841 400 817 q 347 906 347 865 q 374 970 347 946 q 439 994 400 994 q 504 970 478 994 q 531 906 531 946 q 504 841 531 865 q 439 817 478 817 z "},"ẹ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 439 -297 q 374 -273 400 -297 q 347 -208 347 -249 q 374 -144 347 -168 q 439 -119 400 -119 q 504 -144 478 -119 q 531 -208 531 -168 q 504 -273 531 -249 q 439 -297 478 -297 z "},"ẻ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 394 794 l 382 850 q 438 873 415 858 q 460 915 460 888 q 344 981 460 975 l 351 1056 q 499 1020 447 1053 q 550 925 550 988 q 537 873 550 894 q 502 835 524 851 q 453 810 481 819 q 394 794 425 800 z "},"ẽ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 539 801 q 475 819 501 801 q 426 860 449 838 q 384 900 404 882 q 340 918 364 918 q 293 888 308 918 q 275 808 278 857 l 199 813 q 209 888 200 853 q 235 947 218 922 q 277 987 251 972 q 339 1001 303 1001 q 403 983 376 1001 q 451 943 429 965 q 494 903 474 921 q 539 885 514 885 q 585 915 569 885 q 603 994 600 946 l 679 989 q 669 915 678 949 q 643 856 660 881 q 601 816 626 831 q 539 801 575 801 z "},"ế":{"ha":833,"x_min":94,"x_max":765,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 293 792 l 253 839 l 392 967 l 486 967 l 625 839 l 585 792 l 442 892 l 436 892 l 293 792 m 625 885 l 576 924 l 697 1090 l 765 1043 l 625 885 z "},"ề":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 293 792 l 253 839 l 392 967 l 486 967 l 625 839 l 585 792 l 442 892 l 436 892 l 293 792 m 253 885 l 96 1040 l 163 1090 l 301 928 l 253 885 z "},"ể":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 293 792 l 253 839 l 392 967 l 486 967 l 625 839 l 585 792 l 442 892 l 436 892 l 293 792 m 600 882 l 588 931 q 630 950 614 938 q 646 985 646 963 q 624 1026 646 1013 q 550 1042 601 1039 l 560 1099 q 685 1071 642 1096 q 729 997 729 1046 q 718 950 729 969 q 689 917 707 931 q 648 896 671 904 q 600 882 625 888 z "},"ễ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 293 792 l 253 839 l 392 961 l 486 961 l 625 839 l 585 792 l 442 888 l 436 888 l 293 792 m 529 986 q 475 995 499 986 q 431 1015 451 1004 q 392 1035 411 1026 q 354 1044 374 1044 q 324 1031 333 1044 q 308 986 314 1017 l 249 992 q 277 1081 254 1046 q 349 1115 300 1115 q 403 1106 379 1115 q 447 1086 426 1097 q 485 1066 467 1075 q 524 1057 504 1057 q 554 1071 544 1057 q 569 1115 564 1085 l 629 1110 q 601 1022 624 1057 q 529 986 578 986 z "},"ệ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 272 789 l 224 833 l 382 1028 l 496 1028 l 654 833 l 606 789 l 442 946 l 436 946 l 272 789 m 439 -297 q 374 -273 400 -297 q 347 -208 347 -249 q 374 -144 347 -168 q 439 -119 400 -119 q 504 -144 478 -119 q 531 -208 531 -168 q 504 -273 531 -249 q 439 -297 478 -297 z "},"ḗ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 254 835 l 254 914 l 624 914 l 624 835 l 254 835 m 392 979 l 347 1033 l 535 1171 l 588 1103 l 392 979 z "},"ǵ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 397 789 l 338 846 l 535 1079 l 615 1001 l 397 789 z "},"ĝ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 260 789 l 211 833 l 369 1028 l 483 1028 l 642 833 l 593 789 l 429 946 l 424 946 l 260 789 z "},"ğ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 426 793 q 331 811 371 793 q 265 859 290 829 q 226 926 239 889 q 210 1003 213 964 l 281 1014 q 295 962 285 988 q 324 915 306 936 q 367 882 342 894 q 426 869 393 869 q 485 882 460 869 q 529 915 511 894 q 558 962 547 936 q 572 1014 568 988 l 643 1003 q 627 926 640 964 q 588 859 614 889 q 522 811 561 829 q 426 793 482 793 z "},"ġ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 426 817 q 361 841 388 817 q 335 906 335 865 q 361 970 335 946 q 426 994 388 994 q 492 970 465 994 q 518 906 518 946 q 492 841 518 865 q 426 817 465 817 z "},"ģ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 481 799 q 354 833 390 808 q 318 906 318 858 q 377 997 318 967 q 547 1033 436 1026 l 558 976 q 439 955 471 971 q 407 910 407 939 q 432 869 407 882 q 506 851 457 856 l 481 799 z "},"ǧ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 369 797 l 211 992 l 260 1036 l 424 879 l 429 879 l 593 1036 l 642 992 l 483 797 l 369 797 z "},"ḡ":{"ha":833,"x_min":100,"x_max":786,"o":"m 411 -311 q 181 -262 263 -311 q 100 -124 100 -214 q 128 -44 100 -83 q 211 26 157 -6 l 211 32 q 163 74 183 47 q 142 143 142 100 q 163 209 142 175 q 222 269 183 243 l 222 275 q 163 345 188 301 q 139 450 139 389 q 160 550 139 506 q 218 626 182 594 q 302 674 254 657 q 404 692 350 692 q 504 675 460 692 l 783 675 l 783 582 l 608 582 q 649 522 632 558 q 665 446 665 486 q 645 349 665 392 q 590 276 625 306 q 506 230 554 246 q 404 214 458 214 q 348 220 378 214 q 290 239 318 226 q 238 161 238 206 q 274 102 238 121 q 378 83 311 83 l 529 83 q 723 47 660 83 q 786 -75 786 11 q 760 -165 786 -122 q 685 -240 733 -208 q 567 -292 636 -272 q 411 -311 497 -311 m 404 290 q 515 333 469 290 q 560 450 560 376 q 547 514 560 485 q 514 564 535 543 q 465 597 493 585 q 404 608 436 608 q 344 597 372 608 q 294 564 315 585 q 261 514 274 543 q 249 450 249 485 q 294 333 249 376 q 404 290 340 290 m 419 -228 q 525 -217 478 -228 q 606 -187 572 -206 q 656 -144 639 -168 q 674 -93 674 -119 q 635 -28 674 -44 q 519 -11 597 -11 l 388 -11 q 333 -9 358 -11 q 285 0 307 -7 q 217 -55 236 -26 q 199 -112 199 -83 q 255 -197 199 -165 q 419 -228 311 -228 m 242 835 l 242 914 l 611 914 l 611 835 l 242 835 z "},"ĥ":{"ha":833,"x_min":-22,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 28 1054 l -22 1090 l 124 1247 l 243 1247 l 389 1090 l 339 1054 l 186 1183 l 181 1183 l 28 1054 z "},"ḧ":{"ha":833,"x_min":-14,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 57 1076 q 6 1096 26 1076 q -14 1147 -14 1115 q 6 1198 -14 1179 q 57 1217 26 1217 q 107 1198 88 1217 q 126 1147 126 1179 q 107 1096 126 1115 q 57 1076 88 1076 m 310 1076 q 260 1096 279 1076 q 240 1147 240 1115 q 260 1198 240 1179 q 310 1217 279 1217 q 360 1198 340 1217 q 381 1147 381 1179 q 360 1096 381 1115 q 310 1076 340 1076 z "},"ḥ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 436 -297 q 371 -273 397 -297 q 344 -208 344 -249 q 371 -144 344 -168 q 436 -119 397 -119 q 501 -144 475 -119 q 528 -208 528 -168 q 501 -273 528 -249 q 436 -297 475 -297 z "},"ẖ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 251 -235 l 251 -156 l 621 -156 l 621 -235 l 251 -235 z "},"ḩ":{"ha":833,"x_min":56,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 67 -314 l 56 -258 q 175 -235 143 -251 q 207 -189 207 -219 q 183 -146 207 -161 q 100 -122 160 -131 l 156 11 l 231 11 l 194 -89 q 269 -122 243 -100 q 296 -187 296 -144 q 237 -278 296 -249 q 67 -314 178 -308 z "},"ḫ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 436 -319 q 340 -301 381 -319 q 274 -253 300 -283 q 235 -186 249 -224 q 219 -110 222 -149 l 290 -99 q 305 -151 294 -125 q 333 -197 315 -176 q 377 -231 351 -218 q 436 -243 403 -243 q 495 -231 469 -243 q 539 -197 521 -218 q 567 -151 557 -176 q 582 -99 578 -125 l 653 -110 q 637 -186 650 -149 q 597 -253 624 -224 q 531 -301 571 -283 q 436 -319 492 -319 z "},"ħ":{"ha":833,"x_min":28,"x_max":726,"o":"m 129 0 l 129 781 l 28 781 l 28 861 l 129 869 l 129 989 l 243 989 l 243 869 l 539 869 l 539 781 l 243 781 l 243 692 l 236 532 l 240 532 q 353 626 293 589 q 493 664 414 664 q 670 595 614 664 q 726 392 726 526 l 726 0 l 613 0 l 613 376 q 576 519 613 472 q 457 565 540 565 q 401 558 426 565 q 350 535 375 550 q 299 497 325 519 q 243 443 272 474 l 243 0 l 129 0 z "},"ì":{"ha":833,"x_min":125,"x_max":572,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 513 789 l 294 1001 l 375 1079 l 572 846 l 513 789 z "},"í":{"ha":833,"x_min":125,"x_max":672,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 454 789 l 394 846 l 592 1079 l 672 1001 l 454 789 z "},"î":{"ha":833,"x_min":125,"x_max":699,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 317 789 l 268 833 l 426 1028 l 540 1028 l 699 833 l 650 789 l 486 946 l 481 946 l 317 789 z "},"ĩ":{"ha":833,"x_min":125,"x_max":724,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 583 801 q 519 819 546 801 q 471 860 493 838 q 428 900 449 882 q 385 918 408 918 q 338 888 353 918 q 319 808 322 857 l 243 813 q 253 888 244 853 q 279 947 263 922 q 322 987 296 972 q 383 1001 347 1001 q 447 983 421 1001 q 496 943 474 965 q 538 903 518 921 q 583 885 558 885 q 629 915 614 885 q 647 994 644 946 l 724 989 q 713 915 722 949 q 688 856 704 881 q 645 816 671 831 q 583 801 619 801 z "},"ï":{"ha":833,"x_min":125,"x_max":694,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 349 817 q 294 839 315 817 q 272 894 272 861 q 294 949 272 926 q 349 972 315 972 q 403 949 382 972 q 425 894 425 926 q 403 839 425 861 q 349 817 382 817 m 618 817 q 563 839 585 817 q 542 894 542 861 q 563 949 542 926 q 618 972 585 972 q 673 949 651 972 q 694 894 694 926 q 673 839 694 861 q 618 817 651 817 z "},"ī":{"ha":833,"x_min":125,"x_max":668,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 299 835 l 299 914 l 668 914 l 668 835 l 299 835 z "},"ǐ":{"ha":833,"x_min":125,"x_max":699,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 426 797 l 268 992 l 317 1036 l 481 879 l 486 879 l 650 1036 l 699 992 l 540 797 l 426 797 z "},"į":{"ha":833,"x_min":125,"x_max":619,"o":"m 490 -312 q 387 -281 428 -312 q 346 -183 346 -250 q 381 -79 346 -125 q 465 0 417 -33 l 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -7 q 460 -78 490 -37 q 431 -161 431 -119 q 456 -219 431 -200 q 514 -237 481 -237 q 553 -229 536 -237 q 586 -208 571 -221 l 619 -262 q 562 -299 594 -286 q 490 -312 529 -312 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"ỉ":{"ha":833,"x_min":125,"x_max":594,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 439 794 l 426 850 q 482 873 460 858 q 504 915 504 888 q 389 981 504 975 l 396 1056 q 543 1020 492 1053 q 594 925 594 988 q 581 873 594 894 q 547 835 568 851 q 497 810 525 819 q 439 794 469 800 z "},"ị":{"ha":833,"x_min":125,"x_max":575,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 m 483 -297 q 418 -273 444 -297 q 392 -208 392 -249 q 418 -144 392 -168 q 483 -119 444 -119 q 549 -144 522 -119 q 575 -208 575 -168 q 549 -273 575 -249 q 483 -297 522 -297 z "},"ĭ":{"ha":833,"x_min":125,"x_max":700,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 483 793 q 388 811 428 793 q 322 859 347 829 q 283 926 296 889 q 267 1003 269 964 l 338 1014 q 352 962 342 988 q 381 915 363 936 q 424 882 399 894 q 483 869 450 869 q 542 882 517 869 q 586 915 568 894 q 615 962 604 936 q 629 1014 625 988 l 700 1003 q 684 926 697 964 q 644 859 671 889 q 578 811 618 829 q 483 793 539 793 z "},"ı":{"ha":833,"x_min":125,"x_max":553,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 z "},"ĵ":{"ha":833,"x_min":76,"x_max":699,"o":"m 269 -301 q 167 -288 217 -301 q 76 -256 117 -275 l 114 -171 q 190 -199 150 -189 q 268 -208 229 -208 q 351 -196 318 -208 q 404 -160 385 -183 q 431 -102 424 -136 q 439 -25 439 -68 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -17 q 539 -131 553 -79 q 492 -222 525 -183 q 406 -281 460 -260 q 269 -301 351 -301 m 317 789 l 268 833 l 426 1028 l 540 1028 l 699 833 l 650 789 l 486 946 l 481 946 l 317 789 z "},"ķ":{"ha":833,"x_min":147,"x_max":797,"o":"m 147 0 l 147 989 l 261 989 l 261 319 l 267 319 l 631 675 l 761 675 l 492 410 l 797 0 l 669 0 l 421 340 l 261 183 l 261 0 l 147 0 m 344 -314 l 333 -258 q 453 -235 421 -251 q 485 -192 485 -219 q 460 -151 485 -164 q 386 -133 435 -137 l 411 -81 q 538 -116 501 -92 q 574 -187 574 -140 q 515 -278 574 -249 q 344 -314 456 -308 z "},"ḳ":{"ha":833,"x_min":147,"x_max":797,"o":"m 147 0 l 147 989 l 261 989 l 261 319 l 267 319 l 631 675 l 761 675 l 492 410 l 797 0 l 669 0 l 421 340 l 261 183 l 261 0 l 147 0 m 465 -297 q 400 -273 426 -297 q 374 -208 374 -249 q 400 -144 374 -168 q 465 -119 426 -119 q 531 -144 504 -119 q 557 -208 557 -168 q 531 -273 557 -249 q 465 -297 504 -297 z "},"ḵ":{"ha":833,"x_min":147,"x_max":797,"o":"m 147 0 l 147 989 l 261 989 l 261 319 l 267 319 l 631 675 l 761 675 l 492 410 l 797 0 l 669 0 l 421 340 l 261 183 l 261 0 l 147 0 m 281 -235 l 281 -156 l 650 -156 l 650 -235 l 281 -235 z "},"ĸ":{"ha":833,"x_min":147,"x_max":797,"o":"m 147 0 l 147 675 l 261 675 l 261 319 l 265 321 l 631 675 l 761 675 l 492 407 l 797 0 l 669 0 l 421 333 l 261 181 l 261 0 l 147 0 z "},"ĺ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 357 1051 l 307 1110 l 503 1288 l 568 1211 l 357 1051 z "},"ľ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 561 761 l 557 1133 l 660 1133 l 660 1021 l 640 761 l 561 761 z "},"ļ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 414 -314 l 403 -258 q 522 -235 490 -251 q 554 -192 554 -219 q 529 -151 554 -164 q 456 -133 504 -137 l 481 -81 q 607 -116 571 -92 q 643 -187 643 -140 q 584 -278 643 -249 q 414 -314 525 -308 z "},"ḷ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 535 -297 q 469 -273 496 -297 q 443 -208 443 -249 q 469 -144 443 -168 q 535 -119 496 -119 q 600 -144 574 -119 q 626 -208 626 -168 q 600 -273 626 -249 q 535 -297 574 -297 z "},"ḹ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 211 1104 l 211 1183 l 583 1183 l 583 1104 l 211 1104 m 535 -297 q 469 -273 496 -297 q 443 -208 443 -249 q 469 -144 443 -168 q 535 -119 496 -119 q 600 -144 574 -119 q 626 -208 626 -168 q 600 -273 626 -249 q 535 -297 574 -297 z "},"ḻ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 350 -235 l 350 -156 l 719 -156 l 719 -235 l 350 -235 z "},"ł":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 465 l 193 376 l 153 451 l 343 563 l 343 896 l 103 896 l 103 989 l 457 989 l 457 615 l 663 732 l 701 657 l 457 518 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 z "},"ŀ":{"ha":833,"x_min":50,"x_max":882,"o":"m 513 -17 q 347 44 404 -17 q 290 226 290 106 l 290 896 l 50 896 l 50 989 l 404 989 l 404 218 q 440 110 404 143 q 538 78 476 78 q 664 108 597 78 l 693 24 q 607 -6 646 4 q 513 -17 568 -17 m 790 397 q 725 422 751 397 q 699 486 699 446 q 725 551 699 526 q 790 575 751 575 q 856 551 829 575 q 882 486 882 526 q 856 422 882 446 q 790 397 829 397 z "},"ḿ":{"ha":833,"x_min":81,"x_max":775,"o":"m 81 0 l 81 675 l 172 675 l 182 586 l 185 586 q 246 663 211 633 q 339 692 281 692 q 467 575 438 692 q 531 660 496 629 q 625 692 567 692 q 735 638 696 692 q 775 483 775 585 l 775 0 l 661 0 l 661 475 q 589 593 661 593 q 531 567 553 593 q 481 489 508 542 l 481 0 l 375 0 l 375 475 q 359 563 375 533 q 306 593 343 593 q 244 567 269 593 q 194 489 219 542 l 194 0 l 81 0 m 408 789 l 349 846 l 546 1079 l 626 1001 l 408 789 z "},"ṁ":{"ha":833,"x_min":81,"x_max":775,"o":"m 81 0 l 81 675 l 172 675 l 182 586 l 185 586 q 246 663 211 633 q 339 692 281 692 q 467 575 438 692 q 531 660 496 629 q 625 692 567 692 q 735 638 696 692 q 775 483 775 585 l 775 0 l 661 0 l 661 475 q 589 593 661 593 q 531 567 553 593 q 481 489 508 542 l 481 0 l 375 0 l 375 475 q 359 563 375 533 q 306 593 343 593 q 244 567 269 593 q 194 489 219 542 l 194 0 l 81 0 m 438 817 q 372 841 399 817 q 346 906 346 865 q 372 970 346 946 q 438 994 399 994 q 503 970 476 994 q 529 906 529 946 q 503 841 529 865 q 438 817 476 817 z "},"ṃ":{"ha":833,"x_min":81,"x_max":775,"o":"m 81 0 l 81 675 l 172 675 l 182 586 l 185 586 q 246 663 211 633 q 339 692 281 692 q 467 575 438 692 q 531 660 496 629 q 625 692 567 692 q 735 638 696 692 q 775 483 775 585 l 775 0 l 661 0 l 661 475 q 589 593 661 593 q 531 567 553 593 q 481 489 508 542 l 481 0 l 375 0 l 375 475 q 359 563 375 533 q 306 593 343 593 q 244 567 269 593 q 194 489 219 542 l 194 0 l 81 0 m 428 -297 q 363 -273 389 -297 q 336 -208 336 -249 q 363 -144 336 -168 q 428 -119 389 -119 q 493 -144 467 -119 q 519 -208 519 -168 q 493 -273 519 -249 q 428 -297 467 -297 z "},"ń":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 413 789 l 353 846 l 550 1079 l 631 1001 l 413 789 z "},"ǹ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 471 789 l 253 1001 l 333 1079 l 531 846 l 471 789 z "},"ň":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 385 797 l 226 992 l 275 1036 l 439 879 l 444 879 l 608 1036 l 657 992 l 499 797 l 385 797 z "},"ñ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 542 801 q 478 819 504 801 q 429 860 451 838 q 387 900 407 882 q 343 918 367 918 q 296 888 311 918 q 278 808 281 857 l 201 813 q 212 888 203 853 q 238 947 221 922 q 280 987 254 972 q 342 1001 306 1001 q 406 983 379 1001 q 454 943 432 965 q 497 903 476 921 q 542 885 517 885 q 588 915 572 885 q 606 994 603 946 l 682 989 q 672 915 681 949 q 646 856 663 881 q 603 816 629 831 q 542 801 578 801 z "},"ņ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 314 -314 l 303 -258 q 422 -235 390 -251 q 454 -192 454 -219 q 429 -151 454 -164 q 356 -133 404 -137 l 381 -81 q 507 -116 471 -92 q 543 -187 543 -140 q 484 -278 543 -249 q 314 -314 425 -308 z "},"ṅ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 442 817 q 376 841 403 817 q 350 906 350 865 q 376 970 350 946 q 442 994 403 994 q 507 970 481 994 q 533 906 533 946 q 507 841 533 865 q 442 817 481 817 z "},"ṇ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 435 -297 q 369 -273 396 -297 q 343 -208 343 -249 q 369 -144 343 -168 q 435 -119 396 -119 q 500 -144 474 -119 q 526 -208 526 -168 q 500 -273 526 -249 q 435 -297 474 -297 z "},"ṉ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 m 250 -235 l 250 -156 l 619 -156 l 619 -235 l 250 -235 z "},"ŉ":{"ha":833,"x_min":-31,"x_max":831,"o":"m 272 0 l 272 675 l 367 675 l 376 569 l 382 569 q 486 656 431 621 q 615 692 542 692 q 778 625 725 692 q 831 428 831 558 l 831 0 l 715 0 l 715 413 q 683 549 715 504 q 579 593 651 593 q 483 565 525 593 q 386 481 440 536 l 386 0 l 272 0 m 8 486 l -31 553 q 72 644 35 589 q 114 772 110 699 q 78 764 97 764 q 6 791 33 764 q -21 863 -21 818 q 8 941 -21 911 q 82 971 38 971 q 172 926 138 971 q 207 803 207 882 q 154 617 207 699 q 8 486 101 535 z "},"ò":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"ó":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"ô":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 250 789 l 201 833 l 360 1028 l 474 1028 l 632 833 l 583 789 l 419 946 l 414 946 l 250 789 z "},"õ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 517 801 q 453 819 479 801 q 404 860 426 838 q 362 900 382 882 q 318 918 342 918 q 271 888 286 918 q 253 808 256 857 l 176 813 q 187 888 178 853 q 213 947 196 922 q 255 987 229 972 q 317 1001 281 1001 q 381 983 354 1001 q 429 943 407 965 q 472 903 451 921 q 517 885 492 885 q 563 915 547 885 q 581 994 578 946 l 657 989 q 647 915 656 949 q 621 856 638 881 q 578 816 604 831 q 517 801 553 801 z "},"ö":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 282 817 q 227 839 249 817 q 206 894 206 861 q 227 949 206 926 q 282 972 249 972 q 337 949 315 972 q 358 894 358 926 q 337 839 358 861 q 282 817 315 817 m 551 817 q 497 839 518 817 q 475 894 475 861 q 497 949 475 926 q 551 972 518 972 q 606 949 585 972 q 628 894 628 926 q 606 839 628 861 q 551 817 585 817 z "},"ō":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 z "},"ő":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 338 789 l 274 818 l 394 1057 l 475 1018 l 338 789 m 547 789 l 483 818 l 604 1057 l 685 1018 l 547 789 z "},"ǒ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 360 797 l 201 992 l 250 1036 l 414 879 l 419 879 l 583 1036 l 632 992 l 474 797 l 360 797 z "},"ǫ":{"ha":833,"x_min":83,"x_max":750,"o":"m 450 -312 q 350 -281 390 -312 q 310 -183 310 -250 q 339 -87 310 -129 q 404 -15 368 -44 q 276 14 335 -12 q 174 85 217 40 q 108 194 132 131 q 83 336 83 258 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 733 213 750 265 q 685 119 717 160 q 610 49 654 79 q 513 -4 567 19 q 425 -74 456 -29 q 394 -161 394 -118 q 419 -219 394 -201 q 474 -237 444 -237 q 518 -228 500 -237 q 549 -208 536 -219 l 582 -262 q 526 -299 558 -285 q 450 -312 493 -312 m 417 76 q 505 95 465 76 q 573 148 544 114 q 617 230 601 182 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 230 201 278 q 260 148 232 182 q 328 95 289 114 q 417 76 368 76 z "},"ọ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ỏ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 372 794 l 360 850 q 415 873 393 858 q 438 915 438 888 q 322 981 438 975 l 329 1056 q 476 1020 425 1053 q 528 925 528 988 q 515 873 528 894 q 480 835 501 851 q 431 810 458 819 q 372 794 403 800 z "},"ố":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 271 792 l 231 839 l 369 967 l 464 967 l 603 839 l 563 792 l 419 892 l 414 892 l 271 792 m 603 885 l 554 924 l 675 1090 l 743 1043 l 603 885 z "},"ồ":{"ha":833,"x_min":74,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 271 792 l 231 839 l 369 967 l 464 967 l 603 839 l 563 792 l 419 892 l 414 892 l 271 792 m 231 885 l 74 1040 l 140 1090 l 279 928 l 231 885 z "},"ổ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 271 792 l 231 839 l 369 967 l 464 967 l 603 839 l 563 792 l 419 892 l 414 892 l 271 792 m 578 882 l 565 931 q 608 950 592 938 q 624 985 624 963 q 601 1026 624 1013 q 528 1042 579 1039 l 538 1099 q 663 1071 619 1096 q 707 997 707 1046 q 696 950 707 969 q 667 917 685 931 q 626 896 649 904 q 578 882 603 888 z "},"ỗ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 271 792 l 231 839 l 369 961 l 464 961 l 603 839 l 563 792 l 419 888 l 414 888 l 271 792 m 507 986 q 453 995 476 986 q 409 1015 429 1004 q 370 1035 389 1026 q 332 1044 351 1044 q 301 1031 311 1044 q 286 986 292 1017 l 226 992 q 255 1081 232 1046 q 326 1115 278 1115 q 381 1106 357 1115 q 424 1086 404 1097 q 463 1066 444 1075 q 501 1057 482 1057 q 532 1071 522 1057 q 547 1115 542 1085 l 607 1110 q 578 1022 601 1057 q 507 986 556 986 z "},"ộ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 250 789 l 201 833 l 360 1028 l 474 1028 l 632 833 l 583 789 l 419 946 l 414 946 l 250 789 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ŏ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 417 793 q 321 811 361 793 q 255 859 281 829 q 216 926 229 889 q 200 1003 203 964 l 271 1014 q 285 962 275 988 q 314 915 296 936 q 358 882 332 894 q 417 869 383 869 q 476 882 450 869 q 519 915 501 894 q 548 962 538 936 q 563 1014 558 988 l 633 1003 q 617 926 631 964 q 578 859 604 889 q 512 811 551 829 q 417 793 472 793 z "},"ṓ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 m 369 979 l 325 1033 l 513 1171 l 565 1103 l 369 979 z "},"ơ":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 z "},"ớ":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"ờ":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"ở":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 372 794 l 360 850 q 415 873 393 858 q 438 915 438 888 q 322 981 438 975 l 329 1056 q 476 1020 425 1053 q 528 925 528 988 q 515 873 528 894 q 480 835 501 851 q 431 810 458 819 q 372 794 403 800 z "},"ỡ":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 490 801 q 426 819 453 801 q 378 860 400 838 q 335 900 356 882 q 292 918 315 918 q 244 888 260 918 q 226 808 229 857 l 150 813 q 160 888 151 853 q 186 947 169 922 q 228 987 203 972 q 290 1001 254 1001 q 354 983 328 1001 q 403 943 381 965 q 445 903 425 921 q 490 885 465 885 q 536 915 521 885 q 554 994 551 946 l 631 989 q 620 915 629 949 q 594 856 611 881 q 552 816 578 831 q 490 801 526 801 z "},"ợ":{"ha":833,"x_min":83,"x_max":776,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 557 663 492 692 q 646 708 615 675 q 676 800 676 740 q 672 842 676 821 q 656 881 667 864 l 744 922 q 768 869 760 899 q 776 808 776 840 q 765 737 776 768 q 733 683 753 706 q 685 644 713 660 q 628 618 658 628 q 717 503 683 574 q 750 336 750 432 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ø":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 222 43 307 -17 l 150 -42 l 86 17 l 160 103 q 103 206 124 147 q 83 336 83 264 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 611 632 526 692 l 683 717 l 747 658 l 674 572 q 730 469 710 528 q 750 336 750 410 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 201 336 q 233 189 201 253 l 544 554 q 417 600 492 600 q 328 581 368 600 q 260 526 289 561 q 217 443 232 492 q 201 336 201 394 m 417 75 q 505 94 465 75 q 573 148 544 114 q 617 230 601 182 q 632 336 632 278 q 600 485 632 424 l 288 119 q 347 87 314 99 q 417 75 379 75 z "},"ǿ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 222 43 307 -17 l 150 -42 l 86 17 l 160 103 q 103 206 124 147 q 83 336 83 264 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 611 632 526 692 l 683 717 l 747 658 l 674 572 q 730 469 710 528 q 750 336 750 410 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 201 336 q 233 189 201 253 l 544 554 q 417 600 492 600 q 328 581 368 600 q 260 526 289 561 q 217 443 232 492 q 201 336 201 394 m 417 75 q 505 94 465 75 q 573 148 544 114 q 617 230 601 182 q 632 336 632 278 q 600 485 632 424 l 288 119 q 347 87 314 99 q 417 75 379 75 m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"œ":{"ha":833,"x_min":15,"x_max":829,"o":"m 261 78 q 316 97 292 78 q 358 150 340 115 q 385 232 375 185 q 394 338 394 279 q 385 443 394 396 q 358 525 375 490 q 316 578 340 560 q 261 597 292 597 q 158 526 193 597 q 122 336 122 454 q 158 149 122 219 q 261 78 193 78 m 254 -17 q 159 7 203 -17 q 83 76 115 31 q 33 187 51 121 q 15 336 15 253 q 33 487 15 421 q 84 599 51 553 q 160 668 117 644 q 256 692 204 692 q 365 651 319 692 q 438 525 410 611 q 515 651 465 611 q 629 692 564 692 q 717 667 679 692 q 779 600 754 642 q 817 502 804 558 q 829 383 829 446 q 828 344 829 364 q 824 306 826 324 l 482 306 q 534 133 489 189 q 647 76 579 76 q 711 89 683 76 q 767 121 739 101 l 808 43 q 734 1 776 18 q 643 -17 692 -17 q 521 22 575 -17 q 439 146 467 61 q 364 22 410 61 q 254 -17 318 -17 m 619 601 q 528 550 565 601 q 483 394 490 499 l 736 394 q 619 601 731 601 z "},"ŕ":{"ha":833,"x_min":203,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 451 789 l 392 846 l 589 1079 l 669 1001 l 451 789 z "},"ŗ":{"ha":833,"x_min":143,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 154 -314 l 143 -258 q 263 -235 231 -251 q 294 -192 294 -219 q 269 -151 294 -164 q 196 -133 244 -137 l 221 -81 q 347 -116 311 -92 q 383 -187 383 -140 q 324 -278 383 -249 q 154 -314 265 -308 z "},"ř":{"ha":833,"x_min":203,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 424 797 l 265 992 l 314 1036 l 478 879 l 483 879 l 647 1036 l 696 992 l 538 797 l 424 797 z "},"ṙ":{"ha":833,"x_min":203,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 481 817 q 415 841 442 817 q 389 906 389 865 q 415 970 389 946 q 481 994 442 994 q 546 970 519 994 q 572 906 572 946 q 546 841 572 865 q 481 817 519 817 z "},"ṛ":{"ha":833,"x_min":183,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 275 -297 q 210 -273 236 -297 q 183 -208 183 -249 q 210 -144 183 -168 q 275 -119 236 -119 q 340 -144 314 -119 q 367 -208 367 -168 q 340 -273 367 -249 q 275 -297 314 -297 z "},"ṝ":{"ha":833,"x_min":183,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 296 835 l 296 914 l 665 914 l 665 835 l 296 835 m 275 -297 q 210 -273 236 -297 q 183 -208 183 -249 q 210 -144 183 -168 q 275 -119 236 -119 q 340 -144 314 -119 q 367 -208 367 -168 q 340 -273 367 -249 q 275 -297 314 -297 z "},"ṟ":{"ha":833,"x_min":90,"x_max":746,"o":"m 203 0 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 0 l 203 0 m 90 -235 l 90 -156 l 460 -156 l 460 -235 l 90 -235 z "},"ś":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 392 789 l 332 846 l 529 1079 l 610 1001 l 392 789 z "},"ŝ":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 254 789 l 206 833 l 364 1028 l 478 1028 l 636 833 l 588 789 l 424 946 l 418 946 l 254 789 z "},"š":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 364 797 l 206 992 l 254 1036 l 418 879 l 424 879 l 588 1036 l 636 992 l 478 797 l 364 797 z "},"ş":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 315 -314 l 304 -258 q 424 -235 392 -251 q 456 -189 456 -219 q 432 -146 456 -161 q 349 -122 408 -131 l 404 11 l 479 11 l 443 -89 q 518 -122 492 -100 q 544 -187 544 -144 q 485 -278 544 -249 q 315 -314 426 -308 z "},"ș":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 308 -314 l 297 -258 q 417 -235 385 -251 q 449 -192 449 -219 q 424 -151 449 -164 q 350 -133 399 -137 l 375 -81 q 501 -116 465 -92 q 538 -187 538 -140 q 478 -278 538 -249 q 308 -314 419 -308 z "},"ṡ":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 421 817 q 356 841 382 817 q 329 906 329 865 q 356 970 329 946 q 421 994 382 994 q 486 970 460 994 q 513 906 513 946 q 486 841 513 865 q 421 817 460 817 z "},"ṣ":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 m 429 -297 q 364 -273 390 -297 q 338 -208 338 -249 q 364 -144 338 -168 q 429 -119 390 -119 q 494 -144 468 -119 q 521 -208 521 -168 q 494 -273 521 -249 q 429 -297 468 -297 z "},"ß":{"ha":833,"x_min":122,"x_max":783,"o":"m 557 -17 q 450 0 499 -17 q 357 46 401 17 l 403 126 q 478 85 442 99 q 554 72 514 72 q 644 105 613 72 q 675 181 675 138 q 654 247 675 221 q 602 294 633 274 q 535 331 571 314 q 467 372 499 349 q 415 426 436 394 q 394 506 394 457 q 414 587 394 553 q 457 652 433 621 q 500 716 481 683 q 519 793 519 749 q 489 878 519 844 q 400 913 458 913 q 280 860 324 913 q 236 704 236 808 l 236 0 l 122 0 l 122 721 q 142 838 122 785 q 197 928 161 890 q 285 985 233 965 q 401 1006 336 1006 q 499 989 457 1006 q 571 944 542 972 q 615 878 600 915 q 629 800 629 842 q 610 710 629 747 q 567 643 590 674 q 524 584 543 613 q 504 519 504 556 q 525 464 504 486 q 576 423 546 442 q 644 386 607 404 q 711 343 681 368 q 763 281 742 318 q 783 190 783 244 q 767 108 783 146 q 722 43 751 71 q 650 -1 692 15 q 557 -17 608 -17 z "},"ſ":{"ha":833,"x_min":143,"x_max":803,"o":"m 336 0 l 336 582 l 143 582 l 143 668 l 336 675 l 336 732 q 402 931 336 856 q 608 1006 468 1006 q 803 967 708 1006 l 776 881 q 699 906 735 900 q 619 913 664 913 q 488 866 528 913 q 449 736 449 819 l 449 0 l 336 0 z "},"ť":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 554 761 l 550 1133 l 653 1133 l 653 1021 l 633 761 l 554 761 z "},"ţ":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 419 -314 l 408 -258 q 528 -235 496 -251 q 560 -189 560 -219 q 536 -146 560 -161 q 453 -122 513 -131 l 508 11 l 583 11 l 547 -89 q 622 -122 596 -100 q 649 -187 649 -144 q 590 -278 649 -249 q 419 -314 531 -308 z "},"ț":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 406 -314 l 394 -258 q 514 -235 482 -251 q 546 -192 546 -219 q 521 -151 546 -164 q 447 -133 496 -137 l 472 -81 q 599 -116 563 -92 q 635 -187 635 -140 q 576 -278 635 -249 q 406 -314 517 -308 z "},"ṭ":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 526 -297 q 461 -273 488 -297 q 435 -208 435 -249 q 461 -144 435 -168 q 526 -119 488 -119 q 592 -144 565 -119 q 618 -208 618 -168 q 592 -273 618 -249 q 526 -297 565 -297 z "},"ṯ":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 342 -235 l 342 -156 l 711 -156 l 711 -235 l 342 -235 z "},"ẗ":{"ha":833,"x_min":96,"x_max":758,"o":"m 547 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 m 231 1004 q 176 1026 197 1004 q 154 1082 154 1049 q 176 1137 154 1114 q 231 1160 197 1160 q 285 1137 264 1160 q 307 1082 307 1114 q 285 1026 307 1049 q 231 1004 264 1004 m 500 1004 q 445 1026 467 1004 q 424 1082 424 1049 q 445 1137 424 1114 q 500 1160 467 1160 q 555 1137 533 1160 q 576 1082 576 1114 q 555 1026 576 1049 q 500 1004 533 1004 z "},"ŧ":{"ha":833,"x_min":96,"x_max":758,"o":"m 97 306 l 97 386 l 286 394 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 394 l 706 394 l 706 306 l 400 306 l 400 261 q 408 181 400 215 q 436 124 417 147 q 489 88 456 100 q 571 76 522 76 q 658 85 619 76 q 733 107 697 93 l 758 24 q 662 -5 713 7 q 547 -17 611 -17 q 424 3 474 -17 q 343 60 374 24 q 299 149 313 97 q 286 263 286 200 l 286 306 l 97 306 z "},"ù":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 440 789 l 222 1001 l 303 1079 l 500 846 l 440 789 z "},"ú":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 382 789 l 322 846 l 519 1079 l 600 1001 l 382 789 z "},"û":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 244 789 l 196 833 l 354 1028 l 468 1028 l 626 833 l 578 789 l 414 946 l 408 946 l 244 789 z "},"ũ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 511 801 q 447 819 474 801 q 399 860 421 838 q 356 900 376 882 q 313 918 336 918 q 265 888 281 918 q 247 808 250 857 l 171 813 q 181 888 172 853 q 207 947 190 922 q 249 987 224 972 q 311 1001 275 1001 q 375 983 349 1001 q 424 943 401 965 q 466 903 446 921 q 511 885 486 885 q 557 915 542 885 q 575 994 572 946 l 651 989 q 641 915 650 949 q 615 856 632 881 q 573 816 599 831 q 511 801 547 801 z "},"ü":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 276 817 q 222 839 243 817 q 200 894 200 861 q 222 949 200 926 q 276 972 243 972 q 331 949 310 972 q 353 894 353 926 q 331 839 353 861 q 276 817 310 817 m 546 817 q 491 839 513 817 q 469 894 469 861 q 491 949 469 926 q 546 972 513 972 q 601 949 579 972 q 622 894 622 926 q 601 839 622 861 q 546 817 579 817 z "},"ū":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 226 835 l 226 914 l 596 914 l 596 835 l 226 835 z "},"ŭ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 411 793 q 315 811 356 793 q 249 859 275 829 q 210 926 224 889 q 194 1003 197 964 l 265 1014 q 280 962 269 988 q 308 915 290 936 q 352 882 326 894 q 411 869 378 869 q 470 882 444 869 q 514 915 496 894 q 542 962 532 936 q 557 1014 553 988 l 628 1003 q 612 926 625 964 q 572 859 599 889 q 506 811 546 829 q 411 793 467 793 z "},"ů":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 411 790 q 299 828 339 790 q 258 924 258 867 q 299 1019 258 981 q 411 1057 339 1057 q 524 1019 483 1057 q 564 924 564 981 q 524 828 564 867 q 411 790 483 790 m 411 842 q 467 865 444 842 q 490 924 490 889 q 467 983 490 960 q 411 1006 444 1006 q 355 983 378 1006 q 332 924 332 960 q 355 865 332 889 q 411 842 378 842 z "},"ű":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 332 789 l 268 818 l 389 1057 l 469 1018 l 332 789 m 542 789 l 478 818 l 599 1057 l 679 1018 l 542 789 z "},"ǔ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 354 797 l 196 992 l 244 1036 l 408 879 l 414 879 l 578 1036 l 626 992 l 468 797 l 354 797 z "},"ų":{"ha":833,"x_min":107,"x_max":749,"o":"m 619 -312 q 517 -281 558 -312 q 476 -183 476 -250 q 515 -78 476 -124 q 608 0 554 -33 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 -7 q 594 -81 626 -40 q 561 -161 561 -121 q 586 -219 561 -200 q 643 -237 611 -237 q 685 -229 667 -237 q 715 -208 703 -221 l 749 -262 q 692 -299 725 -286 q 619 -312 660 -312 z "},"ǖ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 278 817 q 232 835 250 817 q 214 879 214 853 q 232 925 214 907 q 278 943 250 943 q 323 925 306 943 q 340 879 340 907 q 323 835 340 853 q 278 817 306 817 m 544 817 q 499 835 517 817 q 482 879 482 853 q 499 925 482 907 q 544 943 517 943 q 590 925 572 943 q 608 879 608 907 q 590 835 608 853 q 544 817 572 817 m 225 1042 l 225 1107 l 596 1107 l 596 1042 l 225 1042 z "},"ǘ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 278 817 q 232 835 250 817 q 214 879 214 853 q 232 925 214 907 q 278 943 250 943 q 323 925 306 943 q 340 879 340 907 q 323 835 340 853 q 278 817 306 817 m 544 817 q 499 835 517 817 q 482 879 482 853 q 499 925 482 907 q 544 943 517 943 q 590 925 572 943 q 608 879 608 907 q 590 835 608 853 q 544 817 572 817 m 401 979 l 353 1013 l 467 1172 l 535 1125 l 401 979 z "},"ǚ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 278 817 q 232 835 250 817 q 214 879 214 853 q 232 925 214 907 q 278 943 250 943 q 323 925 306 943 q 340 879 340 907 q 323 835 340 853 q 278 817 306 817 m 544 817 q 499 835 517 817 q 482 879 482 853 q 499 925 482 907 q 544 943 517 943 q 590 925 572 943 q 608 879 608 907 q 590 835 608 853 q 544 817 572 817 m 364 1000 l 233 1128 l 275 1167 l 408 1065 l 414 1065 l 547 1167 l 589 1128 l 458 1000 l 364 1000 z "},"ǜ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 278 817 q 232 835 250 817 q 214 879 214 853 q 232 925 214 907 q 278 943 250 943 q 323 925 306 943 q 340 879 340 907 q 323 835 340 853 q 278 817 306 817 m 544 817 q 499 835 517 817 q 482 879 482 853 q 499 925 482 907 q 544 943 517 943 q 590 925 572 943 q 608 879 608 907 q 590 835 608 853 q 544 817 572 817 m 421 979 l 288 1125 l 356 1172 l 469 1013 l 421 979 z "},"ụ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 426 -297 q 361 -273 388 -297 q 335 -208 335 -249 q 361 -144 335 -168 q 426 -119 388 -119 q 492 -144 465 -119 q 518 -208 518 -168 q 492 -273 518 -249 q 426 -297 465 -297 z "},"ủ":{"ha":833,"x_min":107,"x_max":701,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 701 675 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 367 794 l 354 850 q 410 873 388 858 q 432 915 432 888 q 317 981 432 975 l 324 1056 q 471 1020 419 1053 q 522 925 522 988 q 509 873 522 894 q 474 835 496 851 q 425 810 453 819 q 367 794 397 800 z "},"ư":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 z "},"ứ":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 382 789 l 322 846 l 519 1079 l 600 1001 l 382 789 z "},"ừ":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 440 789 l 222 1001 l 303 1079 l 500 846 l 440 789 z "},"ử":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 367 794 l 354 850 q 410 873 388 858 q 432 915 432 888 q 317 981 432 975 l 324 1056 q 471 1020 419 1053 q 522 925 522 988 q 509 873 522 894 q 474 835 496 851 q 425 810 453 819 q 367 794 397 800 z "},"ữ":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 500 801 q 436 819 463 801 q 388 860 410 838 q 345 900 365 882 q 301 918 325 918 q 254 888 269 918 q 236 808 239 857 l 160 813 q 170 888 161 853 q 196 947 179 922 q 238 987 213 972 q 300 1001 264 1001 q 364 983 338 1001 q 413 943 390 965 q 455 903 435 921 q 500 885 475 885 q 546 915 531 885 q 564 994 561 946 l 640 989 q 630 915 639 949 q 604 856 621 881 q 562 816 588 831 q 500 801 536 801 z "},"ự":{"ha":833,"x_min":107,"x_max":831,"o":"m 342 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 222 675 l 222 271 q 258 128 222 175 q 378 82 293 82 q 483 112 436 82 q 588 207 531 142 l 588 675 l 610 675 q 656 688 635 679 q 694 711 678 696 q 720 750 711 726 q 729 808 729 774 q 725 851 729 829 q 710 889 721 872 l 799 931 q 822 878 814 907 q 831 817 831 849 q 819 747 831 776 q 790 695 808 717 q 749 659 772 674 q 701 635 726 644 l 701 0 l 608 0 l 599 118 l 593 118 q 481 21 542 58 q 342 -17 421 -17 m 426 -297 q 361 -273 388 -297 q 335 -208 335 -249 q 361 -144 335 -168 q 426 -119 388 -119 q 492 -144 465 -119 q 518 -208 518 -168 q 492 -273 518 -249 q 426 -297 465 -297 z "},"ṿ":{"ha":833,"x_min":71,"x_max":763,"o":"m 356 0 l 71 675 l 186 675 l 342 292 q 381 191 363 240 q 418 93 400 142 l 424 93 q 459 191 442 142 q 497 292 476 240 l 653 675 l 763 675 l 483 0 l 356 0 m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"ẁ":{"ha":833,"x_min":11,"x_max":822,"o":"m 158 0 l 11 675 l 125 675 l 206 283 q 222 190 215 235 q 236 97 229 146 l 242 97 q 259 191 249 146 q 281 283 269 236 l 364 633 l 478 633 l 558 283 q 581 190 569 235 q 600 97 593 146 l 606 97 q 620 190 614 146 q 636 283 626 235 l 717 675 l 822 675 l 678 0 l 531 0 l 453 322 q 419 522 436 393 l 414 522 q 381 322 397 393 l 306 0 l 158 0 m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"ẃ":{"ha":833,"x_min":11,"x_max":822,"o":"m 158 0 l 11 675 l 125 675 l 206 283 q 222 190 215 235 q 236 97 229 146 l 242 97 q 259 191 249 146 q 281 283 269 236 l 364 633 l 478 633 l 558 283 q 581 190 569 235 q 600 97 593 146 l 606 97 q 620 190 614 146 q 636 283 626 235 l 717 675 l 822 675 l 678 0 l 531 0 l 453 322 q 419 522 436 393 l 414 522 q 381 322 397 393 l 306 0 l 158 0 m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"ŵ":{"ha":833,"x_min":11,"x_max":822,"o":"m 158 0 l 11 675 l 125 675 l 206 283 q 222 190 215 235 q 236 97 229 146 l 242 97 q 259 191 249 146 q 281 283 269 236 l 364 633 l 478 633 l 558 283 q 581 190 569 235 q 600 97 593 146 l 606 97 q 620 190 614 146 q 636 283 626 235 l 717 675 l 822 675 l 678 0 l 531 0 l 453 322 q 419 522 436 393 l 414 522 q 381 322 397 393 l 306 0 l 158 0 m 250 789 l 201 833 l 360 1028 l 474 1028 l 632 833 l 583 789 l 419 946 l 414 946 l 250 789 z "},"ẅ":{"ha":833,"x_min":11,"x_max":822,"o":"m 158 0 l 11 675 l 125 675 l 206 283 q 222 190 215 235 q 236 97 229 146 l 242 97 q 259 191 249 146 q 281 283 269 236 l 364 633 l 478 633 l 558 283 q 581 190 569 235 q 600 97 593 146 l 606 97 q 620 190 614 146 q 636 283 626 235 l 717 675 l 822 675 l 678 0 l 531 0 l 453 322 q 419 522 436 393 l 414 522 q 381 322 397 393 l 306 0 l 158 0 m 282 817 q 227 839 249 817 q 206 894 206 861 q 227 949 206 926 q 282 972 249 972 q 337 949 315 972 q 358 894 358 926 q 337 839 358 861 q 282 817 315 817 m 551 817 q 497 839 518 817 q 475 894 475 861 q 497 949 475 926 q 551 972 518 972 q 606 949 585 972 q 628 894 628 926 q 606 839 628 861 q 551 817 585 817 z "},"ỳ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 451 789 l 233 1001 l 314 1079 l 511 846 l 451 789 z "},"ý":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 393 789 l 333 846 l 531 1079 l 611 1001 l 393 789 z "},"ŷ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 256 789 l 207 833 l 365 1028 l 479 1028 l 638 833 l 589 789 l 425 946 l 419 946 l 256 789 z "},"ÿ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 288 817 q 233 839 254 817 q 211 894 211 861 q 233 949 211 926 q 288 972 254 972 q 342 949 321 972 q 364 894 364 926 q 342 839 364 861 q 288 817 321 817 m 557 817 q 502 839 524 817 q 481 894 481 861 q 502 949 481 926 q 557 972 524 972 q 612 949 590 972 q 633 894 633 926 q 612 839 633 861 q 557 817 590 817 z "},"ẏ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 422 817 q 357 841 383 817 q 331 906 331 865 q 357 970 331 946 q 422 994 383 994 q 488 970 461 994 q 514 906 514 946 q 488 841 514 865 q 422 817 461 817 z "},"ỵ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 636 -292 q 571 -267 597 -292 q 544 -203 544 -243 q 571 -138 544 -162 q 636 -114 597 -114 q 701 -138 675 -114 q 728 -203 728 -162 q 701 -267 728 -243 q 636 -292 675 -292 z "},"ỷ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 378 794 l 365 850 q 421 873 399 858 q 443 915 443 888 q 328 981 443 975 l 335 1056 q 482 1020 431 1053 q 533 925 533 988 q 520 873 533 894 q 485 835 507 851 q 436 810 464 819 q 378 794 408 800 z "},"ỹ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 522 801 q 458 819 485 801 q 410 860 432 838 q 367 900 388 882 q 324 918 347 918 q 276 888 292 918 q 258 808 261 857 l 182 813 q 192 888 183 853 q 218 947 201 922 q 260 987 235 972 q 322 1001 286 1001 q 386 983 360 1001 q 435 943 413 965 q 477 903 457 921 q 522 885 497 885 q 568 915 553 885 q 586 994 583 946 l 663 989 q 652 915 661 949 q 626 856 643 881 q 584 816 610 831 q 522 801 558 801 z "},"ź":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 418 789 l 358 846 l 556 1079 l 636 1001 l 418 789 z "},"ž":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 390 797 l 232 992 l 281 1036 l 444 879 l 450 879 l 614 1036 l 663 992 l 504 797 l 390 797 z "},"ż":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 447 817 q 382 841 408 817 q 356 906 356 865 q 382 970 356 946 q 447 994 408 994 q 513 970 486 994 q 539 906 539 946 q 513 841 539 865 q 447 817 486 817 z "},"ẑ":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 281 789 l 232 833 l 390 1028 l 504 1028 l 663 833 l 614 789 l 450 946 l 444 946 l 281 789 z "},"ẓ":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 436 -297 q 371 -273 397 -297 q 344 -208 344 -249 q 371 -144 344 -168 q 436 -119 397 -119 q 501 -144 475 -119 q 528 -208 528 -168 q 501 -273 528 -249 q 436 -297 475 -297 z "},"ẕ":{"ha":833,"x_min":99,"x_max":738,"o":"m 99 0 l 99 61 l 561 582 l 150 582 l 150 675 l 725 675 l 725 614 l 261 93 l 738 93 l 738 0 l 99 0 m 251 -235 l 251 -156 l 621 -156 l 621 -235 l 251 -235 z "},"ð":{"ha":833,"x_min":83,"x_max":744,"o":"m 414 -17 q 289 6 349 -17 q 183 70 229 28 q 110 173 138 113 q 83 308 83 233 q 107 437 83 379 q 173 535 131 494 q 273 599 215 576 q 400 621 331 621 q 524 592 465 621 q 621 510 582 563 q 562 671 601 601 q 461 794 522 740 l 250 686 l 208 758 l 389 850 q 313 897 353 875 q 229 942 274 919 l 282 1014 q 385 960 335 989 q 482 897 436 932 l 672 994 l 714 925 l 550 840 q 691 639 638 756 q 744 357 744 522 q 722 205 744 274 q 656 87 699 136 q 551 10 613 38 q 414 -17 490 -17 m 417 78 q 513 98 472 78 q 581 155 554 118 q 622 242 608 192 q 635 353 635 292 q 635 383 635 368 q 633 414 635 399 q 528 506 585 479 q 417 532 471 532 q 319 515 361 532 q 248 468 276 499 q 205 397 219 438 q 190 308 190 356 q 208 213 190 256 q 257 141 226 171 q 329 94 288 111 q 417 78 371 78 z "},"þ":{"ha":833,"x_min":129,"x_max":750,"o":"m 129 -285 l 129 989 l 243 989 l 243 710 l 239 589 l 243 589 q 349 664 290 636 q 468 692 408 692 q 589 667 536 692 q 677 598 642 643 q 731 490 713 553 q 750 347 750 426 q 724 194 750 261 q 656 79 699 126 q 558 8 614 32 q 443 -17 503 -17 q 340 7 393 -17 q 243 71 288 31 l 239 71 l 243 -57 l 243 -285 l 129 -285 m 424 79 q 506 98 468 79 q 572 151 544 117 q 616 235 600 185 q 632 347 632 285 q 587 527 632 458 q 440 596 542 596 q 346 572 396 596 q 243 494 296 547 l 243 158 q 340 97 292 115 q 424 79 388 79 z "},"ŋ":{"ha":833,"x_min":129,"x_max":726,"o":"m 538 -254 q 478 -248 506 -254 q 432 -235 451 -242 l 454 -147 q 488 -157 469 -153 q 525 -161 506 -161 q 595 -124 578 -161 q 613 -19 613 -86 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 353 654 292 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 -19 q 683 -191 726 -128 q 538 -254 639 -254 z "},"ȷ":{"ha":833,"x_min":76,"x_max":553,"o":"m 269 -301 q 167 -288 217 -301 q 76 -256 117 -275 l 114 -171 q 190 -199 150 -189 q 268 -208 229 -208 q 351 -196 318 -208 q 404 -160 385 -183 q 431 -102 424 -136 q 439 -25 439 -68 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -17 q 539 -131 553 -79 q 492 -222 525 -183 q 406 -281 460 -260 q 269 -301 351 -301 z "},"ĳ":{"ha":833,"x_min":129,"x_max":728,"o":"m 156 0 l 156 675 l 269 675 l 269 0 l 156 0 m 214 814 q 153 836 178 814 q 129 894 129 858 q 153 953 129 931 q 214 975 178 975 q 274 953 250 975 q 297 894 297 931 q 274 836 297 858 q 214 814 250 814 m 515 -301 q 459 -296 483 -301 q 417 -283 435 -290 l 439 -197 q 469 -205 453 -201 q 503 -208 485 -208 q 570 -174 554 -208 q 586 -76 586 -139 l 586 675 l 700 675 l 700 -76 q 658 -240 700 -179 q 515 -301 617 -301 m 644 814 q 584 836 608 814 q 560 894 560 858 q 584 953 560 931 q 644 975 608 975 q 704 953 681 975 q 728 894 728 931 q 704 836 728 858 q 644 814 681 814 z "},"ɐ":{"ha":833,"x_min":131,"x_max":735,"o":"m 406 -17 q 199 59 267 -17 q 131 261 131 135 l 131 675 l 225 675 l 235 583 l 239 583 q 364 660 294 628 q 504 692 433 692 q 594 679 551 692 q 667 642 636 667 q 717 581 699 617 q 735 500 735 546 q 707 401 735 443 q 620 328 679 358 q 469 278 561 297 q 246 249 376 258 q 257 183 247 214 q 288 128 267 151 q 342 92 308 106 q 424 78 375 78 q 552 103 490 78 q 661 158 614 129 l 706 81 q 647 47 681 64 q 574 15 613 29 q 493 -8 536 1 q 406 -17 450 -17 m 246 322 q 426 346 354 331 q 542 383 499 361 q 605 431 586 404 q 624 492 624 458 q 611 541 624 521 q 578 574 599 561 q 531 594 558 588 q 475 600 504 600 q 360 574 417 600 q 246 500 304 549 l 246 322 z "},"ɒ":{"ha":833,"x_min":129,"x_max":750,"o":"m 444 -17 q 339 8 394 -17 q 235 75 283 32 l 231 75 l 221 0 l 129 0 l 129 675 l 224 675 l 233 586 l 238 586 q 340 660 278 629 q 471 692 403 692 q 591 667 539 692 q 678 598 643 643 q 732 490 714 553 q 750 349 750 426 q 725 194 750 263 q 658 79 700 126 q 560 8 615 32 q 444 -17 504 -17 m 425 79 q 507 97 469 79 q 572 150 544 115 q 616 233 600 185 q 632 343 632 282 q 587 527 632 458 q 440 596 542 596 q 339 570 390 596 q 243 494 288 544 l 243 158 q 340 97 292 114 q 425 79 388 79 z "},"ɓ":{"ha":833,"x_min":129,"x_max":750,"o":"m 446 -17 q 340 7 396 -17 q 235 75 283 31 l 231 75 l 221 0 l 129 0 l 129 746 q 144 851 129 804 q 191 933 160 899 q 269 987 222 968 q 379 1006 317 1006 q 449 998 415 1006 q 508 979 482 990 l 482 892 q 435 908 458 903 q 390 913 411 913 q 281 869 315 913 q 243 749 246 826 l 238 579 l 243 579 q 349 654 289 626 q 469 682 410 682 q 590 658 538 682 q 678 590 643 633 q 732 483 714 546 q 750 343 750 419 q 725 190 750 257 q 658 78 700 124 q 560 8 615 32 q 446 -17 506 -17 m 426 79 q 508 97 469 79 q 573 149 546 115 q 616 232 600 183 q 632 342 632 281 q 587 519 632 451 q 442 586 542 586 q 346 562 397 586 q 243 485 294 538 l 243 158 q 341 97 292 114 q 426 79 390 79 z "},"ɔ":{"ha":833,"x_min":85,"x_max":722,"o":"m 357 -17 q 208 11 278 -17 q 85 89 139 39 l 136 163 q 230 102 176 126 q 346 78 283 78 q 451 97 404 78 q 533 149 499 115 q 585 231 567 183 q 604 336 604 278 q 586 442 604 394 q 535 525 568 490 q 458 578 503 560 q 358 597 413 597 q 249 576 297 597 q 157 519 200 556 l 99 593 q 208 663 142 633 q 365 692 274 692 q 502 668 438 692 q 616 599 567 644 q 694 487 665 553 q 722 336 722 421 q 694 187 722 253 q 617 76 665 121 q 501 7 568 31 q 357 -17 433 -17 z "},"ɕ":{"ha":833,"x_min":111,"x_max":746,"o":"m 501 75 q 617 97 578 75 q 656 154 656 119 q 636 195 656 179 q 572 211 617 211 q 482 181 532 211 q 385 96 432 150 q 501 75 436 75 m 257 -142 l 164 -103 q 201 -17 181 -58 q 244 60 221 24 q 147 174 182 104 q 111 336 111 244 q 141 487 111 421 q 222 599 171 553 q 339 668 272 644 q 479 692 406 692 q 628 664 567 692 q 733 593 689 636 l 678 522 q 590 581 638 560 q 483 601 542 601 q 381 582 428 601 q 299 528 333 563 q 244 444 264 493 q 224 336 224 396 q 245 225 224 274 q 306 143 267 176 q 442 254 371 215 q 579 293 513 293 q 703 256 660 293 q 746 156 746 218 q 684 33 746 83 q 499 -17 622 -17 q 325 15 406 -17 q 287 -60 304 -21 q 257 -142 269 -99 z "},"ɖ":{"ha":833,"x_min":83,"x_max":843,"o":"m 758 -244 q 631 -194 671 -244 q 590 -54 590 -143 l 593 85 l 589 85 q 492 13 549 43 q 374 -17 436 -17 q 255 7 308 -17 q 163 76 201 31 q 104 186 125 121 q 83 336 83 251 q 109 484 83 418 q 177 596 135 550 q 274 667 219 642 q 389 692 329 692 q 497 668 450 692 q 589 604 544 644 l 593 604 l 586 729 l 586 989 l 701 989 l 701 -29 q 716 -119 701 -87 q 771 -151 731 -151 q 797 -147 785 -151 q 821 -139 810 -143 l 843 -226 q 806 -239 828 -233 q 758 -244 785 -244 m 400 79 q 586 181 497 79 l 586 517 q 496 578 540 560 q 408 596 451 596 q 328 577 365 596 q 262 524 290 558 q 217 443 233 490 q 201 338 201 396 q 254 147 201 215 q 400 79 307 79 z "},"ɗ":{"ha":833,"x_min":83,"x_max":847,"o":"m 374 -17 q 163 75 242 -17 q 83 336 83 167 q 108 484 83 418 q 176 596 133 550 q 273 667 218 642 q 388 692 328 692 q 495 669 447 692 q 588 604 543 646 l 592 604 l 589 729 l 589 807 q 633 955 589 901 q 769 1008 678 1008 q 813 1005 793 1008 q 847 994 832 1001 l 825 907 q 805 913 815 910 q 782 915 794 915 q 718 881 736 915 q 700 788 700 846 l 700 0 l 606 0 l 596 89 l 592 89 q 494 15 551 46 q 374 -17 436 -17 m 399 79 q 586 181 496 79 l 586 517 q 496 578 540 560 q 407 596 451 596 q 328 577 365 596 q 262 524 290 558 q 217 443 233 490 q 201 338 201 396 q 253 147 201 215 q 399 79 306 79 z "},"ɘ":{"ha":833,"x_min":88,"x_max":738,"o":"m 403 601 q 257 550 315 601 q 190 394 199 499 l 621 394 q 546 548 606 494 q 403 601 486 601 m 375 -17 q 229 7 293 -17 q 115 63 165 31 l 156 138 q 252 92 203 108 q 363 75 301 75 q 460 90 414 75 q 540 133 506 104 q 597 206 575 163 q 624 306 618 249 l 92 306 q 88 338 89 318 q 88 375 88 357 q 110 504 88 446 q 176 604 133 563 q 278 669 218 646 q 410 692 338 692 q 536 667 476 692 q 640 597 596 643 q 711 485 685 551 q 738 336 738 419 q 709 188 738 253 q 631 77 681 122 q 516 8 582 32 q 375 -17 450 -17 z "},"ɑ":{"ha":833,"x_min":83,"x_max":704,"o":"m 375 -17 q 256 7 310 -17 q 164 76 203 31 q 104 186 125 121 q 83 336 83 251 q 108 484 83 418 q 176 596 133 550 q 275 667 219 642 q 392 692 331 692 q 501 668 451 692 q 599 600 551 644 l 603 600 l 613 675 l 704 675 l 704 0 l 610 0 l 600 89 l 596 89 q 497 15 556 46 q 375 -17 439 -17 m 400 79 q 590 181 500 79 l 590 517 q 501 578 544 560 q 413 596 457 596 q 330 577 368 596 q 263 524 292 558 q 218 443 235 490 q 201 338 201 396 q 253 147 201 215 q 400 79 306 79 z "},"ʙ":{"ha":833,"x_min":160,"x_max":764,"o":"m 160 0 l 160 675 l 472 675 q 579 665 531 675 q 662 635 628 656 q 715 583 696 615 q 735 504 735 550 q 703 412 735 447 q 617 360 671 376 l 617 356 q 673 336 646 349 q 720 303 700 324 q 752 256 740 283 q 764 193 764 229 q 743 107 764 143 q 685 47 722 71 q 596 11 647 22 q 483 0 544 0 l 160 0 m 272 394 l 453 394 q 584 420 544 394 q 624 493 624 446 q 585 562 624 540 q 461 583 547 583 l 272 583 l 272 394 m 272 92 l 471 92 q 606 117 563 92 q 650 200 650 143 q 464 306 650 306 l 272 306 l 272 92 z "},"ə":{"ha":833,"x_min":96,"x_max":746,"o":"m 413 -17 q 277 8 336 -17 q 178 75 218 32 q 117 178 138 118 q 96 311 96 239 q 97 349 96 329 q 101 381 99 368 l 631 381 q 556 546 619 490 q 388 601 492 601 q 276 584 326 601 q 181 538 226 567 l 139 613 q 254 668 190 644 q 400 692 318 692 q 540 667 476 692 q 650 598 604 643 q 721 488 696 553 q 746 339 746 422 q 720 188 746 254 q 649 76 694 122 q 543 7 604 31 q 413 -17 482 -17 m 410 75 q 560 129 501 75 q 631 292 619 183 l 199 292 q 260 129 206 183 q 410 75 315 75 z "},"ɚ":{"ha":833,"x_min":31,"x_max":863,"o":"m 301 -17 q 189 6 238 -17 q 107 68 140 29 q 55 160 74 107 q 31 274 36 213 l 454 456 q 384 567 431 533 q 278 601 338 601 q 186 585 225 601 q 111 544 147 569 l 71 622 q 167 673 115 654 q 288 692 219 692 q 451 643 382 692 q 556 499 521 594 l 657 543 l 717 519 q 725 455 719 479 q 739 417 731 431 q 758 398 747 403 q 785 393 769 393 q 811 400 799 393 q 832 414 824 407 l 863 354 q 826 331 847 342 q 776 319 804 319 q 699 347 736 319 q 649 450 663 375 l 575 419 q 580 374 578 397 q 582 328 582 351 q 562 190 582 253 q 505 81 542 126 q 417 9 468 35 q 301 -17 365 -17 m 300 74 q 372 90 339 74 q 426 138 404 107 q 461 211 449 168 q 474 306 474 254 q 473 342 474 325 q 471 375 472 358 l 131 231 q 194 110 150 147 q 300 74 238 74 z "},"ɛ":{"ha":833,"x_min":126,"x_max":743,"o":"m 442 -17 q 313 -3 371 -17 q 214 36 256 10 q 149 101 172 63 q 126 188 126 139 q 172 299 126 260 q 285 356 218 338 l 285 361 q 194 422 226 383 q 161 511 161 461 q 183 591 161 557 q 243 647 204 625 q 335 681 282 669 q 453 692 389 692 q 605 668 538 692 q 726 606 672 644 l 681 531 q 580 583 632 564 q 458 601 528 601 q 322 576 369 601 q 275 497 275 550 q 479 394 275 394 l 553 394 l 553 306 l 460 306 q 297 281 353 306 q 240 197 240 256 q 297 106 240 138 q 460 75 354 75 q 585 94 528 75 q 693 157 643 113 l 743 82 q 606 5 679 26 q 442 -17 533 -17 z "},"ɜ":{"ha":833,"x_min":86,"x_max":713,"o":"m 389 -17 q 232 5 306 -17 q 86 85 158 26 l 136 160 q 256 93 194 111 q 379 75 317 75 q 542 106 485 75 q 599 196 599 138 q 545 280 599 254 q 390 306 492 306 l 274 306 l 274 394 l 374 394 q 519 422 471 394 q 567 499 567 449 q 381 601 567 601 q 255 583 307 601 q 150 525 203 564 l 103 601 q 230 668 161 644 q 388 692 299 692 q 505 681 451 692 q 597 647 558 669 q 658 590 636 625 q 679 510 679 556 q 649 422 679 460 q 558 360 619 383 l 558 354 q 670 298 628 336 q 713 186 713 260 q 689 100 713 138 q 623 36 665 63 q 521 -3 581 10 q 389 -17 461 -17 z "},"ɞ":{"ha":833,"x_min":85,"x_max":746,"o":"m 454 -17 q 308 6 375 -17 q 190 72 240 28 q 113 183 140 117 q 85 335 85 249 q 115 490 85 422 q 194 601 144 557 q 310 669 244 646 q 446 692 375 692 q 550 681 501 692 q 635 647 599 669 q 691 590 671 625 q 711 510 711 556 q 682 419 711 460 q 594 360 653 379 l 594 354 q 653 333 625 347 q 701 299 681 319 q 734 250 722 278 q 746 186 746 222 q 667 36 746 89 q 454 -17 589 -17 m 456 75 q 586 106 540 75 q 632 196 632 138 q 583 278 632 251 q 458 306 533 306 l 410 306 l 410 394 l 447 394 q 560 422 519 394 q 600 497 600 450 q 559 576 600 550 q 450 601 518 601 q 351 583 397 601 q 272 531 306 565 q 219 447 239 497 q 200 335 200 397 q 269 140 200 206 q 456 75 338 75 z "},"ɟ":{"ha":833,"x_min":76,"x_max":783,"o":"m 269 -301 q 167 -288 217 -301 q 76 -256 117 -275 l 114 -171 q 190 -199 150 -189 q 268 -208 229 -208 q 351 -196 318 -208 q 404 -160 385 -183 q 431 -102 424 -136 q 439 -25 439 -68 l 439 286 l 169 286 l 169 369 l 439 378 l 439 582 l 125 582 l 125 675 l 553 675 l 553 378 l 783 378 l 783 286 l 553 286 l 553 -17 q 539 -131 553 -79 q 492 -222 525 -183 q 406 -281 460 -260 q 269 -301 351 -301 z "},"ɠ":{"ha":833,"x_min":83,"x_max":849,"o":"m 388 -300 q 255 -281 321 -300 q 132 -226 189 -262 l 175 -146 q 281 -194 226 -179 q 388 -208 336 -208 q 535 -160 485 -208 q 586 -31 585 -112 l 592 104 l 588 104 q 492 35 549 64 q 374 7 436 7 q 255 31 308 7 q 163 98 201 54 q 104 205 125 142 q 83 347 83 268 q 109 490 83 426 q 177 599 135 554 q 275 667 219 643 q 390 692 331 692 q 499 668 450 692 q 588 604 547 644 l 592 604 l 589 671 q 633 818 589 763 q 771 874 676 874 q 814 870 794 874 q 849 860 833 867 l 826 772 q 783 781 807 781 q 719 746 738 781 q 701 653 701 711 l 701 -33 q 618 -230 701 -160 q 388 -300 535 -300 m 400 101 q 586 203 496 101 l 586 517 q 496 578 540 561 q 408 596 451 596 q 328 578 365 596 q 262 526 290 560 q 217 448 233 493 q 201 349 201 403 q 254 168 201 235 q 400 101 307 101 z "},"ɡ":{"ha":833,"x_min":83,"x_max":704,"o":"m 389 -301 q 255 -283 322 -301 q 132 -229 188 -265 l 174 -147 q 282 -195 226 -181 q 389 -210 338 -210 q 538 -161 486 -210 q 593 -31 590 -112 l 596 104 l 592 104 q 494 35 551 64 q 375 7 438 7 q 256 31 310 7 q 164 98 203 54 q 104 205 125 142 q 83 347 83 268 q 108 490 83 426 q 176 599 133 554 q 274 667 218 643 q 392 692 331 692 q 503 667 451 692 q 599 600 554 643 l 603 600 l 613 675 l 704 675 l 704 -26 q 622 -228 704 -154 q 389 -301 540 -301 m 400 101 q 590 203 497 101 l 590 517 q 500 578 544 560 q 411 596 456 596 q 330 578 368 596 q 263 526 292 560 q 217 448 233 493 q 200 349 200 403 q 253 168 200 235 q 400 101 307 101 z "},"ɢ":{"ha":833,"x_min":108,"x_max":731,"o":"m 471 -17 q 330 6 396 -17 q 215 74 264 29 q 137 185 165 119 q 108 338 108 251 q 138 486 108 421 q 219 597 168 551 q 336 667 269 643 q 478 692 403 692 q 627 663 568 692 q 728 594 686 633 l 671 522 q 592 578 635 554 q 483 601 550 601 q 384 584 431 601 q 302 533 338 567 q 246 449 267 499 q 225 338 225 400 q 244 228 225 276 q 297 145 263 179 q 376 93 331 111 q 476 75 422 75 q 562 89 522 75 q 631 126 601 103 l 631 282 l 444 282 l 444 364 l 731 364 l 731 79 q 621 11 688 39 q 471 -17 554 -17 z "},"ɣ":{"ha":833,"x_min":71,"x_max":763,"o":"m 419 -311 q 300 -266 342 -311 q 258 -147 258 -221 q 265 -99 258 -122 q 283 -49 271 -75 q 310 6 294 -24 q 344 72 325 36 l 71 675 l 188 675 l 344 306 q 380 219 364 257 q 417 135 396 182 l 422 135 q 460 219 443 182 q 496 306 476 257 l 651 675 l 763 675 l 494 72 q 528 6 513 36 q 556 -49 544 -24 q 574 -99 568 -75 q 581 -147 581 -122 q 539 -266 581 -221 q 419 -311 497 -311 m 419 -232 q 467 -208 451 -232 q 482 -150 482 -185 q 465 -73 482 -114 q 422 15 449 -32 l 415 15 q 374 -74 390 -32 q 357 -150 357 -117 q 372 -208 357 -185 q 419 -232 388 -232 z "},"ɤ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 228 46 297 -17 q 158 218 158 108 q 208 367 158 296 q 338 504 258 438 q 260 574 294 551 q 186 597 225 597 q 119 578 147 597 l 83 661 q 137 684 106 676 q 200 692 168 692 q 309 660 257 692 q 417 571 361 629 q 524 660 471 629 q 633 692 576 692 q 697 684 665 692 q 750 661 728 676 l 714 578 q 647 597 686 597 q 573 574 607 597 q 496 504 539 551 q 625 367 575 438 q 675 218 675 296 q 606 46 675 108 q 417 -17 536 -17 m 417 78 q 526 118 486 78 q 565 221 565 158 q 524 338 565 282 q 417 450 482 394 q 310 338 351 394 q 268 221 268 282 q 308 118 268 158 q 417 78 347 78 z "},"ɥ":{"ha":833,"x_min":107,"x_max":704,"o":"m 590 -285 l 590 -43 l 596 115 q 481 22 542 60 q 340 -17 419 -17 q 163 52 219 -17 q 107 256 107 121 l 107 675 l 221 675 l 221 271 q 257 128 221 175 q 376 82 293 82 q 433 90 407 82 q 483 113 458 97 q 535 151 508 128 q 590 204 561 174 l 590 675 l 704 675 l 704 -285 l 590 -285 z "},"ɦ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 746 q 144 851 129 804 q 191 933 160 899 q 269 987 222 968 q 379 1006 317 1006 q 449 998 415 1006 q 508 979 482 990 l 482 892 q 435 908 458 903 q 390 913 411 913 q 281 869 315 913 q 243 749 246 826 l 235 550 l 240 550 q 353 644 293 606 q 493 682 414 682 q 670 613 614 682 q 726 408 726 543 l 726 0 l 613 0 l 613 394 q 576 536 613 490 q 457 582 540 582 q 401 574 426 582 q 350 551 375 567 q 299 514 325 536 q 243 461 272 492 l 243 0 l 129 0 z "},"ɧ":{"ha":833,"x_min":129,"x_max":726,"o":"m 533 -254 q 472 -248 500 -254 q 425 -235 444 -242 l 447 -147 q 481 -157 463 -153 q 521 -161 500 -161 q 594 -124 576 -161 q 613 -19 613 -86 l 613 394 q 576 536 613 490 q 457 582 540 582 q 401 574 426 582 q 350 551 375 567 q 299 514 325 536 q 243 461 272 492 l 243 0 l 129 0 l 129 746 q 144 851 129 804 q 191 933 160 899 q 269 987 222 968 q 379 1006 317 1006 q 448 998 415 1006 q 508 979 481 990 l 482 892 q 390 913 433 913 q 281 869 315 913 q 243 749 246 826 l 235 550 l 240 550 q 353 644 293 606 q 493 682 414 682 q 670 613 614 682 q 726 408 726 543 l 726 -19 q 683 -191 726 -128 q 533 -254 639 -254 z "},"ʜ":{"ha":833,"x_min":129,"x_max":704,"o":"m 129 0 l 129 675 l 243 675 l 243 401 l 590 401 l 590 675 l 704 675 l 704 0 l 590 0 l 590 300 l 243 300 l 243 0 l 129 0 z "},"ɨ":{"ha":833,"x_min":125,"x_max":783,"o":"m 183 292 l 183 369 l 439 378 l 439 582 l 125 582 l 125 675 l 553 675 l 553 378 l 783 378 l 783 292 l 553 292 l 553 0 l 439 0 l 439 292 l 183 292 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"ɪ":{"ha":833,"x_min":119,"x_max":714,"o":"m 119 0 l 119 93 l 358 93 l 358 582 l 119 582 l 119 675 l 714 675 l 714 582 l 472 582 l 472 93 l 714 93 l 714 0 l 119 0 z "},"ʝ":{"ha":833,"x_min":78,"x_max":669,"o":"m 581 -347 q 538 -275 560 -307 q 493 -215 517 -243 q 407 -278 460 -256 q 279 -301 354 -301 q 130 -256 182 -301 q 78 -147 78 -210 q 124 -47 78 -85 q 257 -8 169 -8 q 347 -19 301 -8 q 439 -54 393 -31 l 439 -51 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -28 q 539 -128 553 -85 q 608 -205 575 -161 q 669 -306 640 -249 l 581 -347 m 278 -211 q 367 -192 333 -211 q 417 -144 400 -174 q 336 -103 376 -115 q 256 -90 296 -90 q 190 -106 211 -90 q 169 -146 169 -122 q 197 -192 169 -174 q 278 -211 225 -211 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"ʞ":{"ha":833,"x_min":39,"x_max":686,"o":"m 572 -285 l 572 356 l 567 356 l 176 0 l 39 0 l 342 279 l 75 675 l 193 675 l 414 346 l 572 492 l 572 675 l 686 675 l 686 -285 l 572 -285 z "},"ɫ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 m 532 438 q 453 456 486 438 q 391 496 419 474 q 336 536 363 518 q 279 554 310 554 q 233 524 249 554 q 215 446 218 494 l 139 460 q 149 530 140 497 q 173 586 157 563 q 213 624 189 610 q 271 638 238 638 q 351 619 317 638 q 413 579 385 601 q 467 539 442 557 q 524 521 493 521 q 569 551 554 521 q 588 628 585 581 l 664 615 q 653 545 661 578 q 630 489 646 513 q 590 451 614 465 q 532 438 565 438 z "},"ɬ":{"ha":833,"x_min":103,"x_max":746,"o":"m 322 419 q 156 460 206 419 q 106 567 106 501 q 141 653 106 619 q 231 686 176 686 q 297 673 269 686 q 343 639 324 660 l 343 896 l 103 896 l 103 989 l 457 989 l 457 508 l 651 508 l 651 419 l 457 419 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 q 400 44 457 -17 q 343 226 343 106 l 343 419 l 322 419 m 297 508 l 343 508 l 343 517 q 319 577 343 549 q 242 606 294 606 q 210 594 222 606 q 197 561 197 582 q 297 508 197 508 z "},"ɭ":{"ha":833,"x_min":103,"x_max":746,"o":"m 564 -254 q 399 -193 456 -254 q 343 -11 343 -132 l 343 896 l 103 896 l 103 989 l 457 989 l 457 -19 q 492 -126 457 -94 q 589 -158 528 -158 q 649 -151 618 -158 q 717 -128 679 -144 l 746 -214 q 660 -242 700 -231 q 564 -254 619 -254 z "},"ɮ":{"ha":833,"x_min":110,"x_max":793,"o":"m 497 -301 q 326 -268 393 -301 q 215 -193 258 -235 l 272 -121 q 359 -181 308 -156 q 488 -207 410 -207 q 561 -192 526 -207 q 622 -151 596 -178 q 662 -85 647 -124 q 676 0 676 -47 q 628 135 676 86 q 493 183 579 183 q 438 178 457 183 q 396 163 419 174 l 349 224 l 619 582 l 224 582 l 224 0 l 110 0 l 110 989 l 224 989 l 224 675 l 763 675 l 763 614 l 497 264 q 624 251 569 269 q 717 196 679 232 q 774 110 754 160 q 793 3 793 60 q 768 -127 793 -71 q 702 -222 743 -183 q 608 -281 661 -261 q 497 -301 554 -301 z "},"ʟ":{"ha":833,"x_min":206,"x_max":739,"o":"m 206 0 l 206 675 l 319 675 l 319 93 l 739 93 l 739 0 l 206 0 z "},"ɯ":{"ha":833,"x_min":58,"x_max":753,"o":"m 753 675 l 753 0 l 661 0 l 651 89 l 649 89 q 588 13 622 42 q 494 -17 553 -17 q 367 100 396 -17 q 302 15 338 46 q 208 -17 267 -17 q 98 37 138 -17 q 58 192 58 90 l 58 675 l 172 675 l 172 200 q 244 82 172 82 q 303 108 281 82 q 353 186 325 133 l 353 675 l 458 675 l 458 200 q 474 112 458 142 q 528 82 490 82 q 589 108 564 82 q 639 186 614 133 l 639 675 l 753 675 z "},"ɰ":{"ha":833,"x_min":58,"x_max":753,"o":"m 644 -285 l 644 -46 l 653 93 l 647 93 q 586 13 619 42 q 494 -17 553 -17 q 367 100 396 -17 q 302 15 338 46 q 208 -17 267 -17 q 98 37 138 -17 q 58 192 58 90 l 58 675 l 172 675 l 172 200 q 244 82 172 82 q 303 108 281 82 q 353 186 325 133 l 353 675 l 458 675 l 458 200 q 474 112 458 142 q 528 82 490 82 q 589 108 564 82 q 639 186 614 133 l 639 675 l 753 675 l 753 -285 l 644 -285 z "},"ɱ":{"ha":833,"x_min":81,"x_max":775,"o":"m 604 -254 q 553 -249 576 -254 q 513 -237 529 -244 l 535 -150 q 561 -158 546 -154 q 592 -161 576 -161 q 649 -128 636 -161 q 661 -39 661 -94 l 661 475 q 589 593 661 593 q 531 567 553 593 q 481 489 508 542 l 481 0 l 375 0 l 375 475 q 359 563 375 533 q 306 593 343 593 q 244 567 269 593 q 194 489 219 542 l 194 0 l 81 0 l 81 675 l 172 675 l 182 586 l 185 586 q 246 663 211 633 q 339 692 281 692 q 467 575 438 692 q 531 660 496 629 q 625 692 567 692 q 735 638 696 692 q 775 483 775 585 l 775 -44 q 735 -199 775 -143 q 604 -254 696 -254 z "},"ɲ":{"ha":833,"x_min":-7,"x_max":726,"o":"m 78 -254 q 30 -249 51 -254 q -7 -236 8 -243 l 15 -149 q 39 -157 26 -153 q 65 -161 51 -161 q 120 -129 106 -161 q 135 -39 135 -97 l 135 675 l 229 675 l 239 560 l 244 560 q 357 654 297 617 q 494 692 417 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 549 613 504 q 461 593 540 593 q 405 585 431 593 q 354 563 379 578 q 304 524 329 547 q 250 471 279 501 l 250 -39 q 211 -197 250 -139 q 78 -254 172 -254 z "},"ɳ":{"ha":833,"x_min":129,"x_max":863,"o":"m 778 -254 q 645 -197 683 -254 q 607 -39 607 -139 l 607 404 q 571 549 607 504 q 454 593 535 593 q 349 563 394 593 q 243 471 303 532 l 243 0 l 129 0 l 129 675 l 224 675 l 233 560 l 239 560 q 351 654 292 617 q 488 692 410 692 q 665 623 608 692 q 721 419 721 554 l 721 -39 q 735 -129 721 -97 q 790 -161 750 -161 q 817 -157 804 -161 q 840 -149 829 -153 l 863 -236 q 826 -249 847 -243 q 778 -254 804 -254 z "},"ɴ":{"ha":833,"x_min":133,"x_max":700,"o":"m 133 0 l 133 675 l 243 675 l 504 293 q 550 221 525 261 q 597 149 575 181 l 603 149 q 595 278 599 215 q 592 394 592 340 l 592 675 l 700 675 l 700 0 l 590 0 l 329 382 q 283 454 308 414 q 236 526 257 494 l 231 526 q 238 397 235 460 q 242 281 242 335 l 242 0 l 133 0 z "},"ɵ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 6 350 -17 q 183 72 229 28 q 110 183 138 117 q 83 336 83 249 q 110 490 83 424 q 183 602 138 557 q 290 669 229 647 q 417 692 350 692 q 544 669 483 692 q 650 602 604 647 q 723 490 696 557 q 750 336 750 424 q 723 183 750 249 q 650 72 696 117 q 544 6 604 28 q 417 -17 483 -17 m 417 603 q 270 549 329 603 q 196 394 211 494 l 638 394 q 563 549 622 494 q 417 603 504 603 m 417 74 q 572 134 511 74 q 640 306 632 194 l 193 306 q 262 134 201 194 q 417 74 322 74 z "},"ɶ":{"ha":833,"x_min":46,"x_max":815,"o":"m 331 -17 q 220 6 272 -17 q 130 74 168 29 q 69 184 92 118 q 46 338 46 250 q 69 491 46 425 q 130 601 92 557 q 220 669 168 646 q 331 692 272 692 q 395 689 364 692 q 467 675 426 686 l 801 675 l 801 581 l 538 581 l 538 394 l 750 394 l 750 306 l 538 306 l 538 94 l 815 94 l 815 0 l 467 0 q 396 -13 428 -10 q 331 -17 364 -17 m 340 76 q 385 81 361 76 q 432 93 410 86 l 432 581 q 387 592 411 588 q 340 597 363 597 q 271 581 303 597 q 215 533 239 565 q 178 451 192 500 q 164 338 164 403 q 178 222 164 271 q 215 140 192 172 q 271 92 239 107 q 340 76 303 76 z "},"ɸ":{"ha":833,"x_min":61,"x_max":772,"o":"m 178 339 q 230 153 178 221 q 361 79 282 86 l 361 596 q 230 523 282 589 q 178 339 178 457 m 656 339 q 603 523 656 457 q 472 596 551 589 l 472 79 q 603 153 551 86 q 656 339 656 221 m 361 -285 l 361 -12 q 246 16 300 -8 q 151 85 192 40 q 85 193 110 129 q 61 339 61 257 q 85 483 61 419 q 151 591 110 547 q 246 659 192 635 q 361 688 300 683 l 361 989 l 472 989 l 472 688 q 587 659 532 683 q 683 591 642 635 q 748 483 724 547 q 772 339 772 419 q 748 193 772 257 q 683 85 724 129 q 587 16 642 40 q 472 -12 532 -8 l 472 -285 l 361 -285 z "},"ɹ":{"ha":833,"x_min":88,"x_max":631,"o":"m 631 675 l 631 0 l 536 0 l 526 160 l 522 160 q 392 31 469 78 q 221 -17 315 -17 q 151 -10 183 -17 q 88 11 119 -4 l 114 110 q 174 92 150 97 q 239 86 199 86 q 385 130 315 86 q 517 279 456 174 l 517 675 l 631 675 z "},"ɺ":{"ha":833,"x_min":88,"x_max":631,"o":"m 221 -17 q 151 -10 183 -17 q 88 11 119 -4 l 114 110 q 174 92 150 97 q 239 86 199 86 q 385 130 315 86 q 517 279 456 174 l 517 989 l 631 989 l 631 0 l 536 0 l 526 160 l 522 160 q 392 31 469 78 q 221 -17 315 -17 z "},"ɻ":{"ha":833,"x_min":88,"x_max":722,"o":"m 606 -254 q 461 -197 503 -254 q 419 -35 419 -139 l 419 128 l 415 128 q 328 22 381 61 q 208 -17 276 -17 q 149 -10 179 -17 q 88 11 119 -4 l 114 110 q 166 92 144 97 q 221 86 188 86 q 323 123 272 86 q 410 251 374 160 l 410 675 l 524 675 l 524 -21 q 544 -128 524 -96 q 618 -161 565 -161 q 659 -155 638 -161 q 697 -142 681 -149 l 722 -228 q 669 -247 701 -239 q 606 -254 638 -254 z "},"ɽ":{"ha":833,"x_min":203,"x_max":746,"o":"m 463 -254 q 339 -234 389 -254 q 259 -177 289 -214 q 216 -89 229 -140 q 203 25 203 -37 l 203 675 l 297 675 l 307 515 l 311 515 q 441 644 364 597 q 613 692 518 692 q 682 685 650 692 q 746 664 714 679 l 719 565 q 659 583 683 578 q 594 589 635 589 q 448 545 518 589 q 317 396 378 501 l 317 24 q 325 -56 317 -22 q 353 -114 333 -90 q 406 -149 372 -137 q 488 -161 439 -161 q 575 -153 536 -161 q 650 -131 614 -144 l 674 -214 q 578 -242 628 -231 q 463 -254 529 -254 z "},"ɾ":{"ha":833,"x_min":203,"x_max":746,"o":"m 203 0 l 203 346 q 228 494 203 429 q 299 602 253 558 q 410 669 344 646 q 557 692 475 692 q 746 664 669 692 l 719 565 q 643 585 676 581 q 569 590 610 590 q 474 575 519 590 q 393 527 428 560 q 338 444 358 494 q 317 322 317 393 l 317 0 l 203 0 z "},"ʀ":{"ha":833,"x_min":138,"x_max":757,"o":"m 138 0 l 138 675 l 471 675 q 572 665 525 675 q 653 631 619 654 q 707 569 688 607 q 726 475 726 531 q 676 338 726 388 q 556 272 626 289 l 757 0 l 628 0 l 438 264 l 253 264 l 253 0 l 138 0 m 253 353 l 451 353 q 570 383 528 353 q 613 472 613 413 q 570 558 613 533 q 451 583 528 583 l 253 583 l 253 353 z "},"ʁ":{"ha":833,"x_min":76,"x_max":696,"o":"m 696 675 l 696 0 l 363 0 q 261 10 308 0 q 180 44 214 21 q 126 106 146 68 q 107 200 107 144 q 157 337 107 288 q 278 403 207 386 l 76 675 l 206 675 l 396 411 l 581 411 l 581 675 l 696 675 m 581 322 l 382 322 q 263 292 306 322 q 221 203 221 263 q 263 117 221 142 q 382 92 306 92 l 581 92 l 581 322 z "},"ʂ":{"ha":833,"x_min":99,"x_max":731,"o":"m 274 -254 q 140 -197 181 -254 q 99 -29 99 -140 l 99 89 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 q 310 -3 368 -17 q 201 32 251 10 l 201 -42 q 219 -129 201 -96 q 286 -162 236 -162 q 321 -159 304 -162 q 350 -151 338 -156 l 372 -236 q 331 -249 356 -243 q 274 -254 306 -254 z "},"ʃ":{"ha":833,"x_min":78,"x_max":751,"o":"m 260 -301 q 161 -289 204 -301 q 78 -257 118 -276 l 114 -172 q 178 -198 146 -187 q 246 -208 210 -208 q 303 -197 281 -208 q 339 -162 326 -185 q 356 -109 351 -140 q 361 -40 361 -78 l 361 747 q 414 939 361 869 q 592 1008 467 1008 q 678 997 642 1008 q 751 965 714 985 l 719 881 q 663 906 689 896 q 604 915 636 915 q 540 903 565 915 q 501 869 515 892 q 481 816 486 847 q 475 747 475 785 l 475 -42 q 426 -233 475 -164 q 260 -301 378 -301 z "},"ʄ":{"ha":833,"x_min":78,"x_max":751,"o":"m 260 -301 q 161 -289 204 -301 q 78 -257 118 -276 l 114 -172 q 178 -198 146 -187 q 246 -208 210 -208 q 303 -197 281 -208 q 339 -162 326 -185 q 356 -109 351 -140 q 361 -40 361 -78 l 361 308 l 117 308 l 117 389 l 361 397 l 361 747 q 414 939 361 869 q 592 1008 467 1008 q 678 997 642 1008 q 751 965 714 985 l 719 881 q 663 906 689 896 q 604 915 636 915 q 540 903 565 915 q 501 869 515 892 q 481 816 486 847 q 475 747 475 785 l 475 397 l 717 397 l 717 308 l 475 308 l 475 -42 q 426 -233 475 -164 q 260 -301 378 -301 z "},"ʇ":{"ha":833,"x_min":75,"x_max":738,"o":"m 286 692 q 410 672 360 692 q 490 615 460 651 q 534 526 521 578 q 547 413 547 475 l 547 93 l 738 93 l 738 7 l 543 0 l 528 -217 l 433 -217 l 433 0 l 101 0 l 101 93 l 433 93 l 433 414 q 397 551 433 504 q 263 599 360 599 q 175 590 214 599 q 100 568 136 582 l 75 651 q 172 680 121 668 q 286 692 222 692 z "},"ʈ":{"ha":833,"x_min":96,"x_max":758,"o":"m 546 -254 q 422 -234 472 -254 q 342 -177 372 -214 q 299 -89 313 -140 q 286 25 286 -37 l 286 582 l 96 582 l 96 668 l 290 675 l 306 892 l 400 892 l 400 675 l 732 675 l 732 582 l 400 582 l 400 24 q 408 -56 400 -22 q 436 -114 417 -90 q 489 -149 456 -137 q 571 -161 522 -161 q 658 -153 619 -161 q 733 -131 697 -144 l 758 -214 q 657 -242 713 -231 q 546 -254 601 -254 z "},"ʉ":{"ha":833,"x_min":3,"x_max":814,"o":"m 378 83 q 470 110 431 83 q 558 197 510 136 l 558 353 l 250 353 l 250 261 q 281 125 250 167 q 378 83 311 83 m 342 -17 q 185 50 235 -17 q 136 247 136 117 l 136 353 l 3 353 l 3 433 l 136 442 l 136 675 l 250 675 l 250 442 l 558 442 l 558 675 l 672 675 l 672 442 l 814 442 l 814 353 l 672 353 l 672 0 l 578 0 l 569 106 l 567 106 q 465 16 518 49 q 342 -17 413 -17 z "},"ʊ":{"ha":833,"x_min":69,"x_max":764,"o":"m 417 -17 q 276 9 338 -17 q 173 78 215 35 q 108 176 131 121 q 86 290 86 232 q 98 385 86 342 q 128 465 110 429 q 170 528 147 500 q 217 579 193 557 l 217 582 l 69 582 l 69 675 l 340 675 l 340 601 q 242 483 281 551 q 203 314 203 415 q 216 224 203 267 q 256 149 229 181 q 324 97 283 117 q 417 78 364 78 q 510 97 469 78 q 577 149 550 117 q 617 224 604 181 q 631 314 631 267 q 592 483 631 415 q 493 601 553 551 l 493 675 l 764 675 l 764 582 l 617 582 l 617 579 q 663 528 639 557 q 705 465 686 500 q 735 385 724 429 q 747 290 747 342 q 725 176 747 232 q 660 78 703 121 q 557 9 618 35 q 417 -17 496 -17 z "},"ʋ":{"ha":833,"x_min":107,"x_max":750,"o":"m 413 -17 q 291 1 347 -17 q 194 58 235 19 q 130 155 153 96 q 107 294 107 214 l 107 675 l 222 675 l 222 304 q 238 200 222 243 q 279 130 253 157 q 341 90 306 103 q 417 78 376 78 q 508 101 468 78 q 576 167 549 125 q 618 267 604 210 q 632 390 632 324 q 602 547 632 493 q 510 600 572 600 q 483 598 490 600 q 461 592 475 596 l 443 681 q 481 689 463 686 q 533 692 500 692 q 691 622 632 692 q 750 407 750 553 q 728 238 750 315 q 665 103 707 160 q 559 15 622 47 q 413 -17 496 -17 z "},"ʌ":{"ha":833,"x_min":71,"x_max":763,"o":"m 478 675 l 763 0 l 647 0 l 492 383 q 452 484 471 435 q 415 582 433 533 l 410 582 q 374 484 392 533 q 336 383 357 435 l 181 0 l 71 0 l 350 675 l 478 675 z "},"ʍ":{"ha":833,"x_min":11,"x_max":822,"o":"m 675 675 l 822 0 l 708 0 l 628 392 q 611 485 618 440 q 597 578 604 529 l 592 578 q 574 484 585 529 q 553 392 564 439 l 469 42 l 356 42 l 275 392 q 252 485 264 440 q 233 578 240 529 l 228 578 q 213 485 219 529 q 197 392 207 440 l 117 0 l 11 0 l 156 675 l 303 675 l 381 353 q 414 153 397 282 l 419 153 q 453 353 436 282 l 528 675 l 675 675 z "},"ʎ":{"ha":833,"x_min":68,"x_max":765,"o":"m 68 0 l 382 769 q 425 863 400 819 q 483 938 450 906 q 560 988 517 969 q 657 1006 603 1006 q 703 1002 681 1006 q 746 992 726 999 l 721 901 q 694 908 708 906 q 663 911 679 911 q 553 869 596 911 q 488 764 511 828 l 450 676 l 765 0 l 650 0 l 485 374 q 444 469 465 418 q 401 569 422 521 l 396 569 q 359 470 378 521 q 324 374 340 419 l 176 0 l 68 0 z "},"ʏ":{"ha":833,"x_min":79,"x_max":757,"o":"m 361 0 l 361 228 l 79 675 l 203 675 l 321 483 q 369 399 344 439 q 417 314 393 360 l 422 314 q 468 399 446 360 q 518 483 490 439 l 635 675 l 757 675 l 475 228 l 475 0 l 361 0 z "},"ʐ":{"ha":833,"x_min":99,"x_max":861,"o":"m 776 -254 q 643 -198 682 -254 q 604 -50 604 -142 l 604 0 l 99 0 l 99 61 l 551 582 l 150 582 l 150 675 l 715 675 l 715 614 l 261 93 l 718 93 l 718 -39 q 733 -129 718 -97 q 789 -161 749 -161 q 815 -157 803 -161 q 839 -149 828 -153 l 861 -236 q 824 -249 846 -243 q 776 -254 803 -254 z "},"ʑ":{"ha":833,"x_min":99,"x_max":808,"o":"m 497 -161 l 411 -147 q 426 -70 418 -107 q 443 0 433 -33 l 99 0 l 99 61 l 549 582 l 150 582 l 150 675 l 699 675 l 699 614 l 250 93 q 366 91 313 92 q 471 90 419 90 q 683 300 550 300 q 773 266 738 300 q 808 175 808 232 q 754 50 808 100 q 592 0 700 0 l 529 0 q 513 -74 521 -35 q 497 -161 504 -114 m 618 89 q 696 113 669 89 q 722 169 722 138 q 709 205 722 193 q 675 217 696 217 q 616 188 646 217 q 558 89 586 158 l 618 89 z "},"ʒ":{"ha":833,"x_min":82,"x_max":732,"o":"m 400 -301 q 294 -290 342 -301 q 208 -260 247 -279 q 139 -219 169 -242 q 82 -171 108 -196 l 138 -97 q 185 -138 160 -118 q 242 -174 211 -158 q 309 -198 272 -189 q 390 -207 346 -207 q 478 -192 436 -207 q 550 -149 519 -176 q 599 -82 581 -121 q 617 6 617 -43 q 557 147 617 96 q 385 197 497 197 q 346 195 363 197 q 315 189 329 193 q 285 178 300 185 q 251 163 271 171 l 206 226 l 554 582 l 138 582 l 138 675 l 703 675 l 703 614 l 372 269 q 432 278 406 278 q 558 258 503 278 q 652 203 614 239 q 711 118 690 168 q 732 8 732 68 q 704 -124 732 -67 q 631 -222 676 -182 q 524 -281 585 -261 q 400 -301 464 -301 z "},"ʤ":{"ha":833,"x_min":0,"x_max":858,"o":"m 239 79 q 302 108 275 79 q 350 183 329 138 l 350 517 q 303 575 326 554 q 247 596 281 596 q 193 577 218 596 q 151 524 168 558 q 124 442 133 490 q 114 338 114 394 q 145 148 114 217 q 239 79 176 79 m 625 -301 q 510 -278 556 -301 q 428 -219 464 -256 l 482 -147 q 541 -191 510 -175 q 617 -207 572 -207 q 709 -156 674 -207 q 744 0 744 -104 q 713 135 744 88 q 621 183 682 183 q 585 178 599 183 q 551 163 571 174 l 506 235 l 708 582 l 456 582 l 456 0 l 374 0 l 364 81 l 360 81 q 301 13 338 43 q 215 -17 264 -17 q 128 7 168 -17 q 60 76 89 31 q 16 188 32 122 q 0 336 0 253 q 19 483 0 417 q 69 595 38 549 q 141 667 100 642 q 228 692 182 692 q 301 671 269 692 q 353 614 332 650 l 356 614 l 350 743 l 350 989 l 456 989 l 456 675 l 829 675 l 829 614 l 633 271 q 650 272 639 272 q 738 251 700 272 q 803 192 776 229 q 844 106 831 156 q 858 0 858 56 q 840 -128 858 -72 q 791 -223 822 -185 q 717 -281 760 -261 q 625 -301 674 -301 z "},"ʦ":{"ha":833,"x_min":35,"x_max":792,"o":"m 456 -17 q 304 1 365 -17 q 206 51 243 18 q 152 133 168 85 q 136 244 136 182 l 136 582 l 35 582 l 35 668 l 140 675 l 154 892 l 250 892 l 250 675 l 511 675 q 606 692 553 692 q 702 674 657 692 q 783 625 747 657 l 739 558 q 679 594 708 582 q 614 607 650 607 q 549 586 574 607 q 525 526 525 565 q 544 473 525 494 q 594 433 564 451 q 658 396 624 415 q 723 349 693 376 q 772 282 753 321 q 792 185 792 243 q 774 100 792 138 q 716 37 756 63 q 613 -3 676 11 q 456 -17 549 -17 m 461 72 q 638 103 589 72 q 688 186 688 133 q 667 258 688 229 q 617 309 647 288 q 552 350 588 331 q 487 393 517 369 q 437 449 457 417 q 417 529 417 481 q 424 582 417 557 l 250 582 l 250 243 q 260 165 250 197 q 296 113 271 133 q 361 82 321 92 q 461 72 401 72 z "},"ʧ":{"ha":833,"x_min":67,"x_max":838,"o":"m 490 -301 q 435 -296 460 -301 q 393 -283 411 -290 l 417 -197 q 446 -205 429 -201 q 481 -208 463 -208 q 543 -174 528 -208 q 558 -76 558 -139 l 558 582 l 282 582 l 282 207 q 303 110 282 144 q 378 76 324 76 q 418 82 397 76 q 458 94 439 88 l 479 8 q 420 -9 451 -1 q 357 -17 389 -17 q 267 0 304 -17 q 208 46 231 17 q 176 117 186 75 q 167 208 167 158 l 167 582 l 67 582 l 67 668 l 171 675 l 186 892 l 282 892 l 282 675 l 558 675 l 558 786 q 603 948 558 888 q 754 1008 649 1008 q 801 1003 781 1008 q 838 990 822 997 l 815 903 q 792 911 804 907 q 765 915 779 915 q 690 880 708 915 q 672 782 672 844 l 672 -76 q 630 -240 672 -179 q 490 -301 588 -301 z "},"ʔ":{"ha":833,"x_min":99,"x_max":708,"o":"m 332 0 l 332 432 q 449 504 400 471 q 530 572 499 538 q 576 644 561 607 q 592 726 592 681 q 538 861 592 811 q 385 911 485 911 q 251 877 306 911 q 160 799 196 843 l 99 872 q 150 922 121 897 q 215 965 179 946 q 296 994 251 983 q 393 1006 340 1006 q 516 988 458 1006 q 616 935 574 971 q 683 848 658 900 q 708 728 708 796 q 689 619 708 667 q 635 531 669 572 q 551 455 600 490 q 446 382 503 419 l 446 0 l 332 0 z "},"ʕ":{"ha":833,"x_min":124,"x_max":732,"o":"m 386 0 l 386 382 q 280 455 328 419 q 197 531 232 490 q 143 619 163 572 q 124 728 124 667 q 148 848 124 796 q 215 935 172 900 q 315 988 258 971 q 438 1006 372 1006 q 535 994 492 1006 q 616 965 579 983 q 681 922 653 946 q 732 872 710 897 l 672 799 q 580 877 635 843 q 446 911 525 911 q 293 861 347 911 q 239 726 239 811 q 254 644 239 681 q 301 572 269 607 q 383 504 333 538 q 500 432 432 471 l 500 0 l 386 0 z "},"ʡ":{"ha":833,"x_min":99,"x_max":719,"o":"m 332 0 l 332 349 l 103 349 l 103 429 l 208 436 l 350 436 q 528 573 465 503 q 592 726 592 643 q 540 861 592 811 q 390 911 488 911 q 254 876 310 911 q 160 799 199 842 l 99 872 q 151 921 121 897 q 217 963 181 944 q 299 994 254 982 q 399 1006 344 1006 q 519 988 463 1006 q 618 935 576 971 q 684 848 660 900 q 708 728 708 796 q 692 636 708 678 q 648 559 675 594 q 584 493 621 524 q 508 436 547 463 l 719 436 l 719 349 l 446 349 l 446 0 l 332 0 z "},"ʢ":{"ha":833,"x_min":114,"x_max":735,"o":"m 388 0 l 388 349 l 114 349 l 114 429 l 219 436 l 325 436 q 249 493 285 463 q 185 559 213 524 q 142 636 158 594 q 125 728 125 678 q 149 848 125 796 q 215 935 174 900 q 313 988 257 971 q 435 1006 369 1006 q 534 994 489 1006 q 616 963 579 982 q 682 921 653 944 q 735 872 711 897 l 674 799 q 579 876 635 842 q 443 911 524 911 q 293 861 346 911 q 240 726 240 811 q 304 573 240 643 q 482 436 368 503 l 731 436 l 731 349 l 501 349 l 501 0 l 388 0 z "},"ǂ":{"ha":833,"x_min":117,"x_max":717,"o":"m 361 -285 l 361 214 l 117 214 l 117 294 l 361 300 l 361 450 l 117 450 l 117 531 l 361 536 l 361 989 l 472 989 l 472 536 l 717 536 l 717 450 l 472 450 l 472 300 l 717 300 l 717 214 l 472 214 l 472 -285 l 361 -285 z "},"ʘ":{"ha":833,"x_min":83,"x_max":751,"o":"m 417 -17 q 279 14 340 -17 q 174 108 218 44 q 107 268 131 171 q 83 499 83 365 q 107 717 83 622 q 174 876 131 813 q 279 973 218 940 q 417 1006 340 1006 q 555 973 493 1006 q 660 876 617 940 q 728 717 704 813 q 751 499 751 622 q 728 268 751 365 q 660 108 704 171 q 555 14 617 44 q 417 -17 493 -17 m 417 78 q 506 100 464 78 q 577 172 547 122 q 624 302 607 222 q 642 499 642 382 q 624 682 642 604 q 577 811 607 760 q 506 887 547 863 q 417 911 464 911 q 327 887 368 911 q 256 811 286 863 q 209 682 226 760 q 192 499 192 604 q 209 302 192 382 q 256 172 226 222 q 327 100 286 122 q 417 78 368 78 m 417 411 q 356 436 382 411 q 331 499 331 461 q 356 563 331 539 q 417 588 382 588 q 477 563 451 588 q 503 499 503 539 q 477 436 503 461 q 417 411 451 411 z "},"Α":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 z "},"Β":{"ha":833,"x_min":138,"x_max":760,"o":"m 138 0 l 138 911 l 396 911 q 523 899 465 911 q 622 860 581 886 q 685 791 663 833 q 708 689 708 749 q 669 566 708 621 q 549 490 631 511 l 549 485 q 704 415 649 469 q 760 267 760 361 q 735 150 760 200 q 665 67 710 100 q 556 17 619 33 q 417 0 493 0 l 138 0 m 253 528 l 376 528 q 544 565 493 528 q 594 679 594 603 q 541 784 594 754 q 382 814 488 814 l 253 814 l 253 528 m 253 97 l 400 97 q 582 138 518 97 q 646 272 646 179 q 583 394 646 357 q 400 431 521 431 l 253 431 l 253 97 z "},"Γ":{"ha":833,"x_min":188,"x_max":743,"o":"m 188 0 l 188 911 l 743 911 l 743 814 l 303 814 l 303 0 l 188 0 z "},"Δ":{"ha":833,"x_min":60,"x_max":774,"o":"m 60 0 l 60 69 l 350 911 l 483 911 l 774 69 l 774 0 l 60 0 m 186 99 l 646 99 l 511 506 q 465 657 488 581 q 418 813 442 733 l 413 813 q 366 657 389 733 q 319 506 343 581 l 186 99 z "},"Ε":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 z "},"Ζ":{"ha":833,"x_min":90,"x_max":749,"o":"m 90 0 l 90 69 l 599 815 l 135 815 l 135 913 l 742 913 l 742 843 l 232 99 l 749 99 l 749 0 l 90 0 z "},"Η":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 z "},"Θ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 17 339 -17 q 165 112 211 50 q 92 262 118 174 q 67 460 67 350 q 92 656 67 569 q 165 803 118 743 q 275 896 211 864 q 417 928 339 928 q 558 895 493 928 q 669 802 622 863 q 741 655 715 742 q 767 460 767 568 q 741 262 767 350 q 669 112 715 174 q 558 17 622 50 q 417 -17 493 -17 m 417 85 q 511 111 468 85 q 584 187 554 138 q 631 305 614 236 q 647 460 647 374 q 631 613 647 544 q 584 728 614 681 q 511 801 554 775 q 417 826 468 826 q 322 801 364 826 q 249 728 279 775 q 203 613 219 681 q 186 460 186 544 q 203 305 186 374 q 249 187 219 236 q 322 111 279 138 q 417 85 364 85 m 279 429 l 279 529 l 554 529 l 554 429 l 279 429 z "},"Ι":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 z "},"Κ":{"ha":833,"x_min":136,"x_max":806,"o":"m 136 0 l 136 911 l 253 911 l 253 454 l 257 454 l 640 911 l 772 911 l 483 565 l 806 0 l 675 0 l 410 478 l 253 290 l 253 0 l 136 0 z "},"Λ":{"ha":833,"x_min":60,"x_max":774,"o":"m 60 0 l 349 911 l 483 911 l 774 0 l 651 0 l 504 493 q 461 644 481 574 q 417 794 442 714 l 411 794 q 367 644 386 714 q 324 493 347 574 l 178 0 l 60 0 z "},"Μ":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 z "},"Ν":{"ha":833,"x_min":114,"x_max":719,"o":"m 114 0 l 114 911 l 242 911 l 533 339 l 621 150 l 624 150 q 615 292 621 218 q 608 439 608 367 l 608 911 l 719 911 l 719 0 l 592 0 l 300 572 l 213 761 l 210 761 q 219 619 213 690 q 225 476 225 547 l 225 0 l 114 0 z "},"Ξ":{"ha":833,"x_min":97,"x_max":736,"o":"m 97 0 l 97 99 l 736 99 l 736 0 l 97 0 m 201 429 l 201 528 l 632 528 l 632 429 l 201 429 m 111 814 l 111 911 l 722 911 l 722 814 l 111 814 z "},"Ο":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 z "},"Π":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 724 911 l 724 0 l 607 0 l 607 814 l 226 814 l 226 0 l 110 0 z "},"Ρ":{"ha":833,"x_min":142,"x_max":754,"o":"m 142 0 l 142 911 l 417 911 q 554 897 492 911 q 661 852 617 883 q 730 769 706 821 q 754 643 754 718 q 730 518 754 571 q 660 431 706 465 q 553 378 615 396 q 417 361 492 361 l 257 361 l 257 0 l 142 0 m 257 456 l 403 456 q 581 501 524 456 q 638 643 638 546 q 579 780 638 742 q 403 818 521 818 l 257 818 l 257 456 z "},"Σ":{"ha":833,"x_min":104,"x_max":739,"o":"m 104 0 l 104 69 l 418 463 l 110 843 l 110 911 l 697 911 l 697 814 l 257 814 l 536 465 l 251 99 l 739 99 l 739 0 l 104 0 z "},"Τ":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 z "},"Υ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 z "},"Φ":{"ha":833,"x_min":36,"x_max":797,"o":"m 147 461 q 205 265 147 340 q 364 182 263 190 l 364 731 q 205 651 263 722 q 147 461 147 579 m 686 461 q 628 651 686 579 q 469 731 569 722 l 469 182 q 560 208 519 186 q 628 266 600 229 q 671 352 656 303 q 686 461 686 401 m 364 -31 l 364 92 q 228 124 289 96 q 126 199 168 151 q 60 312 83 246 q 36 461 36 378 q 60 607 36 542 q 126 718 83 672 q 228 790 168 764 q 364 821 289 817 l 364 942 l 469 942 l 469 821 q 605 790 544 817 q 708 718 665 764 q 774 607 750 672 q 797 461 797 542 q 774 312 797 378 q 708 199 750 246 q 605 124 665 151 q 469 92 544 96 l 469 -31 l 364 -31 z "},"Χ":{"ha":833,"x_min":75,"x_max":758,"o":"m 75 0 l 347 471 l 93 911 l 221 911 l 349 678 q 383 616 367 646 q 422 546 400 586 l 428 546 q 462 616 447 586 q 493 678 476 646 l 618 911 l 740 911 l 486 465 l 758 0 l 631 0 l 493 246 q 455 315 474 279 q 413 392 436 350 l 407 392 q 369 315 388 350 q 333 246 351 279 l 197 0 l 75 0 z "},"Ψ":{"ha":833,"x_min":61,"x_max":772,"o":"m 358 0 l 358 338 q 140 425 219 344 q 61 667 61 506 l 61 911 l 172 911 l 172 672 q 358 431 172 444 l 358 911 l 475 911 l 475 431 q 661 672 661 444 l 661 911 l 772 911 l 772 667 q 693 425 772 506 q 475 338 614 344 l 475 0 l 358 0 z "},"Ω":{"ha":833,"x_min":53,"x_max":781,"o":"m 53 0 l 53 94 l 221 94 l 221 100 q 165 166 192 128 q 115 253 138 204 q 80 360 93 301 q 67 488 67 418 q 91 664 67 583 q 161 803 115 744 q 272 895 207 863 q 417 928 336 928 q 562 895 497 928 q 672 803 626 863 q 742 664 718 744 q 767 488 767 583 q 753 360 767 418 q 718 253 740 301 q 669 166 696 204 q 613 100 642 128 l 613 94 l 781 94 l 781 0 l 489 0 l 489 85 q 551 157 522 118 q 602 244 581 196 q 635 350 624 292 q 647 481 647 408 q 632 617 647 554 q 588 727 617 681 q 515 800 558 774 q 417 826 472 826 q 318 800 361 826 q 246 727 275 774 q 201 617 217 681 q 186 481 186 554 q 198 350 186 408 q 231 244 210 292 q 282 157 253 196 q 344 85 311 118 l 344 0 l 53 0 z "},"Ά":{"ha":833,"x_min":50,"x_max":789,"o":"m 344 510 l 303 371 l 557 371 l 517 510 q 474 655 494 586 q 433 806 454 724 l 428 806 q 386 655 406 724 q 344 510 367 586 m 75 0 l 367 911 l 497 911 l 789 0 l 667 0 l 585 278 l 275 278 l 193 0 l 75 0 m 129 540 l 50 554 l 100 958 l 210 944 l 129 540 z "},"Έ":{"ha":833,"x_min":33,"x_max":736,"o":"m 278 0 l 278 911 l 722 911 l 722 814 l 383 814 l 383 528 l 653 528 l 653 429 l 383 429 l 383 99 l 736 99 l 736 0 l 278 0 m 113 540 l 33 554 l 83 958 l 193 944 l 113 540 z "},"Ή":{"ha":833,"x_min":33,"x_max":733,"o":"m 269 0 l 269 911 l 375 911 l 375 529 l 628 529 l 628 911 l 733 911 l 733 0 l 628 0 l 628 429 l 375 429 l 375 0 l 269 0 m 113 540 l 33 554 l 83 958 l 193 944 l 113 540 z "},"Ί":{"ha":833,"x_min":33,"x_max":701,"o":"m 257 0 l 257 99 l 421 99 l 421 814 l 257 814 l 257 911 l 701 911 l 701 814 l 536 814 l 536 99 l 701 99 l 701 0 l 257 0 m 113 540 l 33 554 l 83 958 l 193 944 l 113 540 z "},"Ϊ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ό":{"ha":833,"x_min":33,"x_max":767,"o":"m 483 -17 q 369 15 421 -17 q 281 108 318 47 q 222 258 243 169 q 201 460 201 347 q 222 661 201 574 q 281 808 243 749 q 369 898 318 868 q 483 928 421 928 q 598 898 546 928 q 688 808 650 868 q 746 661 725 749 q 767 460 767 574 q 746 256 767 344 q 688 106 725 167 q 598 15 650 46 q 483 -17 546 -17 m 483 85 q 608 177 561 85 q 654 460 654 269 q 607 737 654 647 q 483 826 560 826 q 360 738 407 826 q 314 460 314 649 q 360 177 314 269 q 483 85 407 85 m 113 540 l 33 554 l 83 958 l 193 944 l 113 540 z "},"Ύ":{"ha":833,"x_min":56,"x_max":836,"o":"m 496 0 l 496 325 l 261 911 l 368 911 l 469 640 q 509 531 490 582 q 547 428 528 481 l 553 428 q 591 533 572 481 q 629 640 610 586 l 733 911 l 836 911 l 601 325 l 601 0 l 496 0 m 135 540 l 56 554 l 106 958 l 215 944 l 135 540 z "},"Ϋ":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ώ":{"ha":833,"x_min":33,"x_max":778,"o":"m 186 0 l 186 94 l 324 94 l 324 100 q 233 280 265 183 q 201 507 201 376 q 222 676 201 599 q 278 809 242 753 q 366 897 314 865 q 482 928 418 928 q 598 897 546 928 q 687 809 650 865 q 743 676 724 753 q 763 507 763 599 q 731 280 763 376 q 640 100 699 183 l 640 94 l 778 94 l 778 0 l 539 0 l 539 85 q 622 262 593 167 q 650 489 650 357 q 639 627 650 565 q 606 733 628 689 q 553 802 585 778 q 482 826 522 826 q 410 802 442 826 q 358 733 379 778 q 325 627 336 689 q 314 489 314 565 q 342 262 314 357 q 425 85 371 167 l 425 0 l 186 0 m 113 540 l 33 554 l 83 958 l 193 944 l 113 540 z "},"α":{"ha":833,"x_min":79,"x_max":799,"o":"m 351 -17 q 240 6 290 -17 q 155 72 190 28 q 99 178 119 115 q 79 325 79 242 q 104 481 79 413 q 171 595 129 549 q 267 667 213 642 q 382 692 322 692 q 451 683 417 692 q 515 653 485 674 q 568 598 544 632 q 607 515 592 564 l 611 515 l 639 675 l 753 675 q 724 535 739 608 q 697 392 710 463 q 676 258 685 321 q 668 149 668 194 q 688 96 668 114 q 735 78 707 78 q 758 81 746 78 q 782 89 771 85 l 799 1 q 762 -11 783 -6 q 710 -17 740 -17 q 614 17 650 -17 q 578 121 578 50 l 574 121 q 475 17 529 50 q 351 -17 421 -17 m 375 79 q 444 96 410 79 q 505 141 478 113 q 549 208 532 169 q 571 289 567 246 l 581 415 q 546 506 567 471 q 500 561 525 542 q 449 588 475 581 q 400 596 422 596 q 325 578 361 596 q 260 528 289 561 q 215 444 232 494 q 197 326 197 393 q 244 144 197 208 q 375 79 292 79 z "},"β":{"ha":833,"x_min":129,"x_max":756,"o":"m 129 -249 l 129 688 q 147 814 129 756 q 199 915 164 872 q 286 981 233 957 q 410 1006 339 1006 q 508 991 461 1006 q 592 947 556 976 q 651 872 629 917 q 674 765 674 826 q 636 633 674 690 q 526 535 599 576 l 526 529 q 693 444 631 514 q 756 268 756 375 q 733 147 756 200 q 672 58 710 94 q 584 2 633 21 q 482 -17 535 -17 q 353 6 417 -17 q 236 86 289 28 q 241 -81 239 0 q 244 -249 243 -162 l 129 -249 m 454 79 q 527 92 493 79 q 587 131 561 106 q 627 192 613 156 q 642 275 642 229 q 593 410 642 356 q 446 464 544 464 q 376 456 410 464 l 358 543 q 452 576 414 554 q 515 628 490 599 q 550 690 539 657 q 561 757 561 724 q 549 825 561 796 q 517 874 538 854 q 469 903 496 893 q 411 913 442 913 q 287 851 332 913 q 240 667 242 790 q 238 426 239 544 q 238 185 238 307 q 344 100 286 121 q 454 79 401 79 z "},"γ":{"ha":833,"x_min":67,"x_max":747,"o":"m 354 -249 q 357 -208 356 -226 q 359 -170 358 -189 q 360 -130 360 -151 q 360 -81 360 -108 q 335 100 360 0 q 269 302 310 200 q 176 499 229 404 q 67 663 122 593 l 181 692 q 253 583 217 646 q 322 448 289 521 q 381 294 354 375 q 426 135 408 214 l 432 135 q 560 400 507 267 q 633 675 614 533 l 747 675 q 708 513 731 589 q 653 358 686 436 q 572 196 619 281 q 457 7 524 111 q 468 -122 465 -54 q 471 -249 471 -190 l 354 -249 z "},"δ":{"ha":833,"x_min":90,"x_max":743,"o":"m 417 -17 q 295 4 354 -17 q 190 65 236 25 q 117 161 144 104 q 90 290 90 218 q 112 402 90 351 q 170 493 133 453 q 256 563 207 533 q 363 611 306 592 q 284 664 321 638 q 220 719 247 690 q 178 782 193 749 q 163 854 163 815 q 176 912 163 885 q 219 960 190 939 q 290 993 247 981 q 393 1006 333 1006 q 548 992 467 1006 q 728 944 629 978 l 700 854 q 524 903 597 890 q 392 917 450 917 q 302 896 329 917 q 275 847 275 875 q 292 795 275 819 q 338 747 308 771 q 410 697 368 724 q 503 639 451 671 q 597 574 553 607 q 674 501 642 540 q 724 413 706 461 q 743 304 743 365 q 721 173 743 232 q 657 72 699 114 q 554 6 615 29 q 417 -17 493 -17 m 419 78 q 577 140 524 78 q 631 303 631 201 q 617 382 631 346 q 578 448 603 418 q 522 504 554 478 q 451 554 489 531 q 267 460 333 528 q 201 293 201 393 q 219 203 201 243 q 267 136 238 164 q 337 93 297 108 q 419 78 376 78 z "},"ε":{"ha":833,"x_min":126,"x_max":742,"o":"m 444 -17 q 211 37 296 -17 q 126 186 126 90 q 172 297 126 258 q 281 354 217 336 l 281 360 q 190 422 221 382 q 160 510 160 463 q 181 590 160 556 q 242 647 203 625 q 334 681 281 669 q 451 692 388 692 q 594 669 526 692 q 719 606 661 647 l 674 529 q 454 601 572 601 q 322 575 369 601 q 274 496 274 549 q 320 422 274 450 q 469 394 367 394 q 509 395 489 394 q 554 399 529 396 l 554 304 q 499 307 525 307 q 449 307 474 307 q 240 196 240 307 q 294 107 240 139 q 457 75 347 75 q 576 91 519 75 q 693 156 632 107 l 742 79 q 669 33 704 51 q 599 3 635 14 q 525 -12 563 -8 q 444 -17 488 -17 z "},"ζ":{"ha":833,"x_min":161,"x_max":728,"o":"m 649 -256 l 557 -218 q 609 -149 593 -174 q 625 -96 625 -124 q 617 -69 625 -81 q 588 -49 608 -58 q 531 -31 567 -39 q 442 -11 496 -22 q 335 20 386 0 q 246 76 285 40 q 184 169 207 113 q 161 308 161 225 q 199 476 161 392 q 298 638 236 560 q 437 783 360 715 q 593 903 514 851 q 508 903 558 903 q 403 901 457 903 q 295 899 349 900 q 203 896 242 897 l 203 989 l 726 989 l 726 896 l 719 896 q 558 778 638 847 q 417 632 479 710 q 317 472 356 554 q 279 314 279 389 q 295 214 279 254 q 341 147 311 174 q 413 106 371 121 q 510 81 456 90 q 606 58 565 69 q 674 29 647 46 q 715 -11 701 13 q 728 -69 728 -35 q 709 -149 728 -101 q 649 -256 690 -197 z "},"η":{"ha":833,"x_min":129,"x_max":714,"o":"m 599 -249 q 601 -79 600 -165 q 604 92 603 7 q 606 258 606 176 q 607 413 607 339 q 577 551 607 508 q 476 593 547 593 q 417 587 444 593 q 365 564 390 581 q 311 519 339 547 q 253 450 283 492 l 253 0 l 139 0 l 139 490 q 138 576 139 531 q 129 675 136 622 l 233 675 l 243 543 l 247 543 q 366 656 304 621 q 510 692 428 692 q 666 625 618 692 q 714 428 714 558 l 714 -249 l 599 -249 z "},"θ":{"ha":833,"x_min":100,"x_max":733,"o":"m 417 -17 q 285 14 343 -17 q 185 108 226 44 q 122 268 144 171 q 100 499 100 365 q 185 877 100 749 q 417 1006 269 1006 q 649 877 564 1006 q 733 499 733 749 q 711 268 733 365 q 648 108 689 171 q 549 14 607 44 q 417 -17 490 -17 m 417 911 q 339 890 375 911 q 276 825 303 869 q 232 710 249 781 q 213 542 215 640 l 621 542 q 601 710 618 640 q 558 825 585 781 q 494 890 531 869 q 417 911 458 911 m 417 78 q 494 97 458 78 q 558 162 531 117 q 601 280 585 207 q 621 460 618 353 l 213 460 q 231 280 215 353 q 274 162 247 207 q 338 97 301 117 q 417 78 375 78 z "},"ι":{"ha":833,"x_min":113,"x_max":729,"o":"m 556 -17 q 393 44 443 -17 q 343 226 343 106 l 343 582 l 113 582 l 113 675 l 458 675 q 456 558 457 618 q 453 440 454 499 q 451 324 451 381 q 450 218 450 268 q 483 111 450 144 q 581 78 515 78 q 638 84 607 78 q 700 106 668 90 l 729 21 q 652 -6 693 4 q 556 -17 611 -17 z "},"κ":{"ha":833,"x_min":139,"x_max":801,"o":"m 672 -11 q 606 67 642 24 q 535 157 571 110 q 466 254 500 204 q 406 354 432 304 q 311 239 357 301 q 260 35 260 164 l 260 0 l 153 0 l 153 490 q 151 581 153 531 q 139 675 149 631 l 253 675 q 263 605 260 647 q 265 518 265 563 l 265 307 l 271 307 q 367 442 313 379 q 483 556 421 506 q 610 640 544 606 q 740 692 675 675 l 753 583 q 618 526 686 564 q 482 429 550 488 q 548 319 510 376 q 628 207 586 263 q 715 99 671 151 q 801 0 760 46 l 672 -11 z "},"λ":{"ha":833,"x_min":78,"x_max":768,"o":"m 201 -11 l 78 0 l 389 690 l 378 722 q 305 865 344 821 q 203 908 265 908 q 155 901 175 908 q 117 886 135 894 l 88 981 q 141 999 111 992 q 215 1006 171 1006 q 308 989 268 1006 q 381 937 349 972 q 440 848 414 901 q 493 721 467 794 l 768 0 l 644 0 l 443 560 l 438 560 l 201 -11 z "},"μ":{"ha":833,"x_min":117,"x_max":765,"o":"m 117 -260 l 117 675 l 231 675 l 231 271 q 265 130 231 178 q 374 82 299 82 q 425 88 400 82 q 476 108 450 93 q 527 153 501 124 q 579 228 553 182 l 579 675 l 694 675 q 689 394 692 538 q 686 128 686 250 q 697 89 686 100 q 725 78 708 78 q 735 78 731 78 q 750 81 740 78 l 765 -6 q 700 -17 740 -17 q 620 15 647 -17 q 589 128 593 46 l 586 128 q 490 21 544 56 q 372 -14 435 -14 q 288 1 326 -14 q 222 60 250 15 q 223 -34 222 7 q 224 -111 224 -75 q 227 -183 225 -147 q 232 -260 229 -218 l 117 -260 z "},"ν":{"ha":833,"x_min":65,"x_max":750,"o":"m 357 0 q 308 192 338 100 q 239 367 278 283 q 156 524 200 450 q 65 663 111 597 l 179 692 q 257 569 218 638 q 329 425 296 500 q 389 272 363 350 q 429 118 415 193 l 435 118 q 503 253 469 183 q 564 393 536 322 q 610 535 592 464 q 635 675 629 607 l 750 675 q 711 505 736 588 q 651 340 686 422 q 570 174 615 257 q 469 0 525 90 l 357 0 z "},"ξ":{"ha":833,"x_min":128,"x_max":732,"o":"m 653 -256 l 561 -218 q 613 -149 597 -174 q 628 -96 628 -124 q 620 -69 628 -81 q 592 -49 613 -58 q 535 -31 571 -39 q 446 -11 500 -22 q 335 19 388 1 q 242 68 282 38 q 179 144 203 99 q 156 257 156 190 q 174 351 156 307 q 222 429 192 394 q 292 489 251 464 q 376 526 332 514 l 376 532 q 266 609 310 560 q 222 732 222 658 q 251 833 222 790 q 331 903 279 876 q 278 903 301 903 q 233 901 256 903 q 185 899 210 900 q 128 896 160 897 l 128 989 l 726 989 l 726 896 l 526 896 q 454 885 489 896 q 394 853 419 874 q 353 801 368 832 q 338 729 338 769 q 354 663 338 693 q 398 610 371 632 q 460 575 425 588 q 529 563 494 563 q 583 563 561 563 q 638 569 606 564 l 638 469 q 580 476 606 475 q 522 476 554 476 q 430 463 475 476 q 350 423 385 449 q 294 359 315 397 q 274 272 274 321 q 292 190 274 222 q 344 136 311 157 q 421 103 376 115 q 518 81 465 90 q 616 58 575 69 q 683 29 657 46 q 720 -11 708 13 q 732 -69 732 -35 q 714 -149 732 -101 q 653 -256 696 -197 z "},"ο":{"ha":833,"x_min":89,"x_max":744,"o":"m 417 -17 q 290 7 350 -17 q 186 76 231 31 q 115 187 142 121 q 89 336 89 253 q 115 487 89 421 q 186 599 142 553 q 290 668 231 644 q 417 692 350 692 q 543 668 483 692 q 647 599 603 644 q 718 487 692 553 q 744 336 744 421 q 718 187 744 253 q 647 76 692 121 q 543 7 603 31 q 417 -17 483 -17 m 417 78 q 504 97 465 78 q 570 149 543 115 q 612 231 597 183 q 626 336 626 278 q 612 442 626 394 q 570 525 597 490 q 504 578 543 560 q 417 597 465 597 q 329 578 368 597 q 263 525 290 560 q 222 442 236 490 q 207 336 207 394 q 222 231 207 278 q 263 149 236 183 q 329 97 290 115 q 417 78 368 78 z "},"π":{"ha":833,"x_min":38,"x_max":796,"o":"m 699 -17 q 585 26 618 -17 q 551 153 551 69 q 552 228 551 179 q 554 338 553 278 q 557 461 556 397 q 558 581 558 525 l 285 581 q 280 290 285 438 q 264 -7 275 142 l 150 0 q 172 297 167 150 q 178 581 178 443 l 38 581 l 38 668 l 133 675 l 796 675 l 796 581 l 668 581 q 663 458 665 524 q 660 330 661 392 q 658 219 658 268 q 658 144 658 169 q 674 93 658 108 q 721 78 689 78 q 736 80 728 78 q 758 86 744 82 l 775 -1 q 742 -12 760 -8 q 699 -17 724 -17 z "},"ρ":{"ha":833,"x_min":129,"x_max":750,"o":"m 129 -249 l 129 344 q 154 497 129 432 q 222 606 179 563 q 321 670 264 649 q 443 692 378 692 q 672 600 593 692 q 750 347 750 508 q 725 194 750 261 q 659 79 700 126 q 565 8 618 32 q 456 -17 511 -17 q 341 3 397 -17 q 236 79 285 22 q 239 -6 238 33 q 241 -85 240 -46 q 243 -164 242 -124 q 244 -249 244 -204 l 129 -249 m 436 79 q 513 98 476 79 q 575 151 549 117 q 617 235 601 185 q 632 347 632 285 q 621 449 632 403 q 586 527 610 494 q 526 578 563 560 q 439 596 490 596 q 363 580 399 596 q 299 533 326 564 q 255 454 271 501 q 239 343 239 407 l 239 171 q 288 124 264 142 q 338 96 313 106 q 388 83 363 86 q 436 79 413 79 z "},"σ":{"ha":833,"x_min":83,"x_max":794,"o":"m 403 -17 q 280 6 338 -17 q 178 73 222 29 q 109 182 135 117 q 83 331 83 247 q 110 484 83 419 q 183 591 138 549 q 286 654 228 633 q 408 675 344 675 l 794 675 l 794 578 q 684 585 735 582 q 575 589 633 588 l 575 583 q 678 479 642 547 q 714 315 714 411 q 690 175 714 236 q 624 71 665 114 q 525 6 582 28 q 403 -17 468 -17 m 403 78 q 483 95 446 78 q 546 144 519 113 q 587 222 572 176 q 601 325 601 268 q 589 422 601 375 q 551 503 576 468 q 490 560 526 539 q 406 581 453 581 q 260 519 318 581 q 201 331 201 457 q 217 226 201 272 q 259 146 232 179 q 323 95 286 113 q 403 78 360 78 z "},"τ":{"ha":833,"x_min":92,"x_max":742,"o":"m 522 -17 q 396 33 432 -17 q 360 176 360 82 l 360 582 l 92 582 l 92 668 l 189 675 l 742 675 l 742 582 l 472 582 q 468 369 469 474 q 467 168 467 264 q 487 99 467 119 q 547 78 507 78 q 588 82 568 78 q 632 93 608 86 l 647 4 q 591 -10 624 -4 q 522 -17 558 -17 z "},"υ":{"ha":833,"x_min":110,"x_max":732,"o":"m 408 -17 q 193 55 271 -17 q 115 274 115 126 q 118 382 115 328 q 121 490 121 436 q 119 576 121 531 q 110 675 117 622 l 221 675 q 229 601 228 639 q 231 518 231 563 q 229 460 231 492 q 226 394 228 428 q 224 328 225 361 q 222 267 222 296 q 238 179 222 215 q 278 121 253 143 q 338 88 304 99 q 410 78 372 78 q 492 94 454 78 q 557 145 529 111 q 600 232 585 179 q 615 357 615 285 q 603 503 615 428 q 560 665 590 578 l 671 692 q 715 526 699 608 q 732 360 732 444 q 708 198 732 268 q 642 80 685 128 q 539 8 599 32 q 408 -17 479 -17 z "},"φ":{"ha":833,"x_min":61,"x_max":772,"o":"m 178 339 q 230 153 178 221 q 361 79 282 86 l 361 596 q 230 523 282 589 q 178 339 178 457 m 656 339 q 603 523 656 457 q 472 596 551 589 l 472 79 q 603 153 551 86 q 656 339 656 221 m 361 -249 l 361 -12 q 246 16 300 -8 q 151 85 192 40 q 85 193 110 129 q 61 339 61 257 q 85 483 61 419 q 151 591 110 547 q 246 659 192 635 q 361 688 300 683 l 361 864 l 472 864 l 472 688 q 587 659 532 683 q 683 591 642 635 q 748 483 724 547 q 772 339 772 419 q 748 193 772 257 q 683 85 724 129 q 587 16 642 40 q 472 -12 532 -8 l 472 -249 l 361 -249 z "},"χ":{"ha":833,"x_min":78,"x_max":778,"o":"m 193 -265 l 78 -249 l 364 226 l 82 663 l 196 692 l 418 328 l 424 328 l 614 675 l 735 675 l 478 228 l 778 -236 l 667 -265 l 424 133 l 418 133 l 193 -265 z "},"ψ":{"ha":833,"x_min":74,"x_max":768,"o":"m 364 -249 l 364 -17 q 239 8 292 -15 q 151 74 186 32 q 100 172 117 115 q 83 299 83 229 l 83 490 q 82 576 83 531 q 74 675 81 622 l 185 675 q 192 601 190 639 q 193 518 193 563 q 192 456 193 489 q 192 393 192 424 q 191 336 192 363 q 190 293 190 310 q 232 135 190 193 q 364 76 274 76 l 364 864 l 475 864 l 475 78 q 610 153 563 85 q 658 356 658 221 q 656 431 658 394 q 647 503 653 467 q 630 580 640 540 q 603 665 619 619 l 708 692 q 754 527 740 604 q 768 358 768 450 q 691 88 768 185 q 475 -15 614 -8 l 475 -249 l 364 -249 z "},"ω":{"ha":833,"x_min":47,"x_max":786,"o":"m 264 -17 q 178 4 218 -17 q 110 67 139 25 q 64 172 81 108 q 47 318 47 235 q 84 519 47 426 q 174 692 121 613 l 274 646 q 223 564 244 604 q 187 482 201 524 q 165 395 172 440 q 158 297 158 350 q 190 135 158 192 q 271 78 222 78 q 338 115 310 78 q 367 247 367 153 q 364 331 367 289 q 356 428 361 374 l 474 428 q 466 331 468 374 q 464 247 464 289 q 472 166 464 199 q 492 114 479 133 q 522 86 504 94 q 558 78 539 78 q 639 135 608 78 q 669 315 669 193 q 663 409 669 367 q 644 490 657 451 q 612 567 632 529 q 564 649 592 606 l 665 692 q 714 611 692 651 q 752 526 736 571 q 777 431 768 481 q 786 322 786 381 q 727 67 786 151 q 572 -17 668 -17 q 483 10 524 -17 q 418 96 442 38 l 413 96 q 351 10 389 38 q 264 -17 313 -17 z "},"ς":{"ha":833,"x_min":125,"x_max":728,"o":"m 608 -250 l 517 -214 q 572 -137 553 -168 q 590 -76 590 -107 q 585 -47 590 -60 q 563 -22 579 -33 q 517 0 547 -10 q 439 19 488 10 q 322 55 379 32 q 222 116 265 78 q 151 212 178 154 q 125 353 125 269 q 154 497 125 433 q 233 603 183 560 q 347 669 282 647 q 482 692 411 692 q 625 665 567 692 q 728 597 683 638 l 669 524 q 586 579 628 561 q 488 597 544 597 q 390 580 435 597 q 313 531 346 563 q 262 453 281 499 q 243 353 243 408 q 262 252 243 293 q 314 184 281 211 q 392 140 347 157 q 490 113 438 124 q 590 86 550 100 q 652 53 629 72 q 684 9 675 35 q 693 -51 693 -17 q 672 -140 693 -87 q 608 -250 651 -192 z "},"ϐ":{"ha":833,"x_min":129,"x_max":756,"o":"m 457 -17 q 342 1 400 -17 q 237 56 285 18 q 159 157 189 94 q 129 311 129 219 l 129 688 q 147 814 129 756 q 199 915 164 872 q 288 982 235 958 q 414 1006 342 1006 q 509 991 463 1006 q 592 947 556 976 q 651 872 629 917 q 674 765 674 826 q 633 632 674 690 q 517 535 592 574 l 517 529 q 616 501 572 524 q 691 444 660 479 q 739 363 722 410 q 756 263 756 317 q 733 146 756 197 q 669 58 710 94 q 574 3 628 22 q 457 -17 519 -17 m 240 667 q 240 583 240 621 q 239 513 239 546 q 390 553 328 529 q 490 607 451 576 q 544 675 528 638 q 561 757 561 713 q 517 874 561 835 q 414 913 472 913 q 287 851 331 913 q 240 667 243 789 m 453 83 q 529 97 494 83 q 589 136 564 111 q 628 195 614 161 q 642 269 642 229 q 630 347 642 311 q 594 408 618 382 q 533 449 569 433 q 446 464 496 464 q 375 456 425 464 q 238 425 325 449 l 238 329 q 260 207 238 254 q 315 132 282 160 q 386 94 349 104 q 453 83 424 83 z "},"ϑ":{"ha":833,"x_min":110,"x_max":733,"o":"m 219 751 q 237 664 219 707 q 299 590 254 621 q 422 546 344 558 q 619 550 500 533 q 599 717 617 647 q 551 829 581 786 q 480 892 521 872 q 389 911 439 911 q 267 868 314 911 q 219 751 219 825 m 413 -17 q 212 51 283 -17 q 140 253 140 119 q 138 340 140 307 q 129 404 136 372 l 236 404 q 246 349 244 385 q 247 267 247 314 q 260 179 247 215 q 297 121 274 143 q 351 88 321 99 q 418 78 382 78 q 496 95 460 78 q 559 158 532 113 q 602 279 586 203 q 621 474 618 356 q 374 474 472 453 q 217 540 275 496 q 134 642 158 583 q 110 753 110 700 q 131 856 110 810 q 190 936 153 903 q 278 988 228 969 q 385 1006 328 1006 q 646 877 558 1006 q 733 503 733 749 q 710 260 733 360 q 645 100 688 161 q 544 11 603 39 q 413 -17 485 -17 z "},"ϕ":{"ha":833,"x_min":61,"x_max":772,"o":"m 178 339 q 230 153 178 221 q 361 79 282 86 l 361 596 q 230 523 282 589 q 178 339 178 457 m 656 339 q 603 523 656 457 q 472 596 551 589 l 472 79 q 603 153 551 86 q 656 339 656 221 m 361 -249 l 361 -12 q 246 16 300 -8 q 151 85 192 40 q 85 193 110 129 q 61 339 61 257 q 85 483 61 419 q 151 591 110 547 q 246 659 192 635 q 361 688 300 683 l 361 864 l 472 864 l 472 688 q 587 659 532 683 q 683 591 642 635 q 748 483 724 547 q 772 339 772 419 q 748 193 772 257 q 683 85 724 129 q 587 16 642 40 q 472 -12 532 -8 l 472 -249 l 361 -249 z "},"ά":{"ha":833,"x_min":79,"x_max":799,"o":"m 351 -17 q 240 6 290 -17 q 155 72 190 28 q 99 178 119 115 q 79 325 79 242 q 104 481 79 413 q 171 595 129 549 q 267 667 213 642 q 382 692 322 692 q 451 683 417 692 q 515 653 485 674 q 568 598 544 632 q 607 515 592 564 l 611 515 l 639 675 l 753 675 q 724 535 739 608 q 697 392 710 463 q 676 258 685 321 q 668 149 668 194 q 688 96 668 114 q 735 78 707 78 q 758 81 746 78 q 782 89 771 85 l 799 1 q 762 -11 783 -6 q 710 -17 740 -17 q 614 17 650 -17 q 578 121 578 50 l 574 121 q 475 17 529 50 q 351 -17 421 -17 m 375 79 q 444 96 410 79 q 505 141 478 113 q 549 208 532 169 q 571 289 567 246 l 581 415 q 546 506 567 471 q 500 561 525 542 q 449 588 475 581 q 400 596 422 596 q 325 578 361 596 q 260 528 289 561 q 215 444 232 494 q 197 326 197 393 q 244 144 197 208 q 375 79 292 79 m 481 776 l 401 790 l 467 1110 l 585 1089 l 481 776 z "},"έ":{"ha":833,"x_min":126,"x_max":742,"o":"m 444 -17 q 211 37 296 -17 q 126 186 126 90 q 172 297 126 258 q 281 354 217 336 l 281 360 q 190 422 221 382 q 160 510 160 463 q 181 590 160 556 q 242 647 203 625 q 334 681 281 669 q 451 692 388 692 q 594 669 526 692 q 719 606 661 647 l 674 529 q 454 601 572 601 q 322 575 369 601 q 274 496 274 549 q 320 422 274 450 q 469 394 367 394 q 509 395 489 394 q 554 399 529 396 l 554 304 q 499 307 525 307 q 449 307 474 307 q 240 196 240 307 q 294 107 240 139 q 457 75 347 75 q 576 91 519 75 q 693 156 632 107 l 742 79 q 669 33 704 51 q 599 3 635 14 q 525 -12 563 -8 q 444 -17 488 -17 m 497 776 l 418 790 l 483 1110 l 601 1089 l 497 776 z "},"ή":{"ha":833,"x_min":129,"x_max":714,"o":"m 599 -249 q 601 -79 600 -165 q 604 92 603 7 q 606 258 606 176 q 607 413 607 339 q 577 551 607 508 q 476 593 547 593 q 417 587 444 593 q 365 564 390 581 q 311 519 339 547 q 253 450 283 492 l 253 0 l 139 0 l 139 490 q 138 576 139 531 q 129 675 136 622 l 233 675 l 243 543 l 247 543 q 366 656 304 621 q 510 692 428 692 q 666 625 618 692 q 714 428 714 558 l 714 -249 l 599 -249 m 483 776 l 404 790 l 469 1110 l 588 1089 l 483 776 z "},"ί":{"ha":833,"x_min":113,"x_max":729,"o":"m 556 -17 q 393 44 443 -17 q 343 226 343 106 l 343 582 l 113 582 l 113 675 l 458 675 q 456 558 457 618 q 453 440 454 499 q 451 324 451 381 q 450 218 450 268 q 483 111 450 144 q 581 78 515 78 q 638 84 607 78 q 700 106 668 90 l 729 21 q 652 -6 693 4 q 556 -17 611 -17 m 424 776 l 344 790 l 410 1110 l 528 1089 l 424 776 z "},"ϊ":{"ha":833,"x_min":113,"x_max":729,"o":"m 556 -17 q 393 44 443 -17 q 343 226 343 106 l 343 582 l 113 582 l 113 675 l 458 675 q 456 558 457 618 q 453 440 454 499 q 451 324 451 381 q 450 218 450 268 q 483 111 450 144 q 581 78 515 78 q 638 84 607 78 q 700 106 668 90 l 729 21 q 652 -6 693 4 q 556 -17 611 -17 m 258 817 q 203 839 225 817 q 182 894 182 861 q 203 949 182 926 q 258 972 225 972 q 313 949 292 972 q 335 894 335 926 q 313 839 335 861 q 258 817 292 817 m 528 817 q 473 839 494 817 q 451 894 451 861 q 473 949 451 926 q 528 972 494 972 q 583 949 561 972 q 604 894 604 926 q 583 839 604 861 q 528 817 561 817 z "},"ό":{"ha":833,"x_min":89,"x_max":744,"o":"m 417 -17 q 290 7 350 -17 q 186 76 231 31 q 115 187 142 121 q 89 336 89 253 q 115 487 89 421 q 186 599 142 553 q 290 668 231 644 q 417 692 350 692 q 543 668 483 692 q 647 599 603 644 q 718 487 692 553 q 744 336 744 421 q 718 187 744 253 q 647 76 692 121 q 543 7 603 31 q 417 -17 483 -17 m 417 78 q 504 97 465 78 q 570 149 543 115 q 612 231 597 183 q 626 336 626 278 q 612 442 626 394 q 570 525 597 490 q 504 578 543 560 q 417 597 465 597 q 329 578 368 597 q 263 525 290 560 q 222 442 236 490 q 207 336 207 394 q 222 231 207 278 q 263 149 236 183 q 329 97 290 115 q 417 78 368 78 m 447 776 l 368 790 l 433 1110 l 551 1089 l 447 776 z "},"ύ":{"ha":833,"x_min":110,"x_max":732,"o":"m 408 -17 q 193 55 271 -17 q 115 274 115 126 q 118 382 115 328 q 121 490 121 436 q 119 576 121 531 q 110 675 117 622 l 221 675 q 229 601 228 639 q 231 518 231 563 q 229 460 231 492 q 226 394 228 428 q 224 328 225 361 q 222 267 222 296 q 238 179 222 215 q 278 121 253 143 q 338 88 304 99 q 410 78 372 78 q 492 94 454 78 q 557 145 529 111 q 600 232 585 179 q 615 357 615 285 q 603 503 615 428 q 560 665 590 578 l 671 692 q 715 526 699 608 q 732 360 732 444 q 708 198 732 268 q 642 80 685 128 q 539 8 599 32 q 408 -17 479 -17 m 443 776 l 364 790 l 429 1110 l 547 1089 l 443 776 z "},"ϋ":{"ha":833,"x_min":110,"x_max":732,"o":"m 408 -17 q 193 55 271 -17 q 115 274 115 126 q 118 382 115 328 q 121 490 121 436 q 119 576 121 531 q 110 675 117 622 l 221 675 q 229 601 228 639 q 231 518 231 563 q 229 460 231 492 q 226 394 228 428 q 224 328 225 361 q 222 267 222 296 q 238 179 222 215 q 278 121 253 143 q 338 88 304 99 q 410 78 372 78 q 492 94 454 78 q 557 145 529 111 q 600 232 585 179 q 615 357 615 285 q 603 503 615 428 q 560 665 590 578 l 671 692 q 715 526 699 608 q 732 360 732 444 q 708 198 732 268 q 642 80 685 128 q 539 8 599 32 q 408 -17 479 -17 m 278 817 q 223 839 244 817 q 201 894 201 861 q 223 949 201 926 q 278 972 244 972 q 333 949 311 972 q 354 894 354 926 q 333 839 354 861 q 278 817 311 817 m 547 817 q 492 839 514 817 q 471 894 471 861 q 492 949 471 926 q 547 972 514 972 q 602 949 581 972 q 624 894 624 926 q 602 839 624 861 q 547 817 581 817 z "},"ώ":{"ha":833,"x_min":47,"x_max":786,"o":"m 264 -17 q 178 4 218 -17 q 110 67 139 25 q 64 172 81 108 q 47 318 47 235 q 84 519 47 426 q 174 692 121 613 l 274 646 q 223 564 244 604 q 187 482 201 524 q 165 395 172 440 q 158 297 158 350 q 190 135 158 192 q 271 78 222 78 q 338 115 310 78 q 367 247 367 153 q 364 331 367 289 q 356 428 361 374 l 474 428 q 466 331 468 374 q 464 247 464 289 q 472 166 464 199 q 492 114 479 133 q 522 86 504 94 q 558 78 539 78 q 639 135 608 78 q 669 315 669 193 q 663 409 669 367 q 644 490 657 451 q 612 567 632 529 q 564 649 592 606 l 665 692 q 714 611 692 651 q 752 526 736 571 q 777 431 768 481 q 786 322 786 381 q 727 67 786 151 q 572 -17 668 -17 q 483 10 524 -17 q 418 96 442 38 l 413 96 q 351 10 389 38 q 264 -17 313 -17 m 447 776 l 368 790 l 433 1110 l 551 1089 l 447 776 z "},"ΐ":{"ha":833,"x_min":113,"x_max":729,"o":"m 556 -17 q 393 44 443 -17 q 343 226 343 106 l 343 582 l 113 582 l 113 675 l 458 675 q 456 558 457 618 q 453 440 454 499 q 451 324 451 381 q 450 218 450 268 q 483 111 450 144 q 581 78 515 78 q 638 84 607 78 q 700 106 668 90 l 729 21 q 652 -6 693 4 q 556 -17 611 -17 m 233 826 q 188 842 206 826 q 169 886 169 858 q 188 933 169 915 q 233 950 206 950 q 279 933 261 950 q 297 886 297 915 q 279 842 297 858 q 233 826 261 826 m 335 796 l 403 1110 l 497 1092 l 393 783 l 335 796 m 553 826 q 507 842 525 826 q 489 886 489 858 q 507 933 489 915 q 553 950 525 950 q 599 933 581 950 q 617 886 617 915 q 599 842 617 858 q 553 826 581 826 z "},"ΰ":{"ha":833,"x_min":110,"x_max":732,"o":"m 408 -17 q 193 55 271 -17 q 115 274 115 126 q 118 382 115 328 q 121 490 121 436 q 119 576 121 531 q 110 675 117 622 l 221 675 q 229 601 228 639 q 231 518 231 563 q 229 460 231 492 q 226 394 228 428 q 224 328 225 361 q 222 267 222 296 q 238 179 222 215 q 278 121 253 143 q 338 88 304 99 q 410 78 372 78 q 492 94 454 78 q 557 145 529 111 q 600 232 585 179 q 615 357 615 285 q 603 503 615 428 q 560 665 590 578 l 671 692 q 715 526 699 608 q 732 360 732 444 q 708 198 732 268 q 642 80 685 128 q 539 8 599 32 q 408 -17 479 -17 m 253 826 q 207 842 225 826 q 189 886 189 858 q 207 933 189 915 q 253 950 225 950 q 299 933 281 950 q 317 886 317 915 q 299 842 317 858 q 253 826 281 826 m 354 796 l 422 1110 l 517 1092 l 413 783 l 354 796 m 572 826 q 526 842 544 826 q 508 886 508 858 q 526 933 508 915 q 572 950 544 950 q 618 933 600 950 q 636 886 636 915 q 618 842 636 858 q 572 826 600 826 z "},"ϗ":{"ha":833,"x_min":139,"x_max":801,"o":"m 613 -260 l 481 -249 q 583 -131 535 -192 q 671 -10 632 -69 q 605 68 640 25 q 534 158 569 111 q 465 254 499 204 q 406 354 432 304 q 311 239 357 301 q 260 35 260 164 l 260 0 l 153 0 l 153 490 q 151 581 153 531 q 139 675 149 631 l 253 675 q 263 605 260 647 q 265 518 265 563 l 265 307 l 271 307 q 367 442 313 379 q 483 556 421 506 q 610 640 544 606 q 740 692 675 675 l 753 583 q 618 526 686 564 q 482 429 550 488 q 548 319 510 376 q 628 207 586 263 q 715 99 671 151 q 801 0 760 46 q 705 -142 756 -74 q 613 -260 654 -211 z "},"ϙ":{"ha":833,"x_min":86,"x_max":747,"o":"m 417 75 q 573 146 517 75 q 629 336 629 217 q 573 526 629 454 q 417 597 517 597 q 260 526 317 597 q 204 336 204 454 q 260 146 204 217 q 417 75 317 75 m 365 -249 l 365 -12 q 256 22 307 -4 q 167 93 204 49 q 108 199 129 138 q 86 336 86 260 q 113 488 86 421 q 184 599 139 554 q 289 668 229 644 q 417 692 349 692 q 544 668 485 692 q 649 599 604 644 q 721 488 694 554 q 747 336 747 421 q 726 201 747 261 q 669 96 706 140 q 582 24 632 51 q 474 -12 532 -3 q 476 -72 475 -44 q 477 -126 476 -99 q 478 -183 478 -153 q 481 -249 479 -212 l 365 -249 z "},"ϛ":{"ha":833,"x_min":126,"x_max":713,"o":"m 608 -250 l 518 -214 q 572 -137 554 -168 q 590 -79 590 -107 q 585 -49 590 -62 q 565 -24 581 -36 q 520 -2 550 -12 q 439 19 490 8 q 322 56 378 33 q 222 117 265 79 q 152 208 178 154 q 126 340 126 263 q 155 490 126 426 q 233 594 183 553 q 351 655 283 635 q 496 675 418 675 l 713 675 l 713 578 q 615 581 669 581 q 503 581 561 581 q 315 522 385 581 q 244 340 244 463 q 263 249 244 286 q 313 185 281 211 q 390 141 344 158 q 490 113 436 124 q 590 85 550 100 q 652 52 629 71 q 684 8 675 33 q 693 -51 693 -17 q 672 -140 693 -87 q 608 -250 651 -192 z "},"ϝ":{"ha":833,"x_min":203,"x_max":726,"o":"m 203 -249 l 203 675 l 726 675 l 726 582 l 308 582 l 311 281 l 681 281 l 681 199 l 313 199 q 314 -20 313 86 q 318 -249 315 -126 l 203 -249 z "},"ϡ":{"ha":833,"x_min":94,"x_max":729,"o":"m 704 -249 l 593 -235 q 613 -104 607 -168 q 618 24 618 -40 q 604 199 618 117 q 433 119 517 158 q 253 31 349 79 l 206 126 l 583 296 q 525 461 563 383 q 338 375 429 418 q 142 279 246 332 l 94 375 l 481 549 q 342 731 422 649 q 157 874 261 813 l 228 958 q 442 783 349 885 q 599 561 536 682 q 696 303 663 440 q 729 22 729 167 q 724 -115 729 -49 q 704 -249 718 -181 z "},";":{"ha":833,"x_min":274,"x_max":550,"o":"m 417 481 q 337 513 369 481 q 304 597 304 544 q 337 683 304 650 q 417 715 369 715 q 497 683 464 715 q 529 597 529 650 q 497 513 529 544 q 417 481 464 481 m 306 -296 l 274 -224 q 403 -130 360 -185 q 449 8 446 -75 q 435 6 442 6 q 422 6 429 6 q 346 31 378 6 q 314 110 314 57 q 347 188 314 161 q 425 215 381 215 q 519 167 488 215 q 550 38 550 119 q 485 -169 550 -85 q 306 -296 421 -253 z "},"·":{"ha":833,"x_min":304,"x_max":529,"o":"m 417 472 q 337 504 369 472 q 304 589 304 536 q 337 674 304 642 q 417 707 369 707 q 497 674 464 707 q 529 589 529 642 q 497 504 529 536 q 417 472 464 472 z "},"ʹ":{"ha":833,"x_min":357,"x_max":500,"o":"m 357 624 l 388 958 l 500 958 l 481 831 l 432 624 l 357 624 z "},"͵":{"ha":833,"x_min":333,"x_max":476,"o":"m 333 0 l 353 128 l 401 336 l 476 336 l 446 0 l 333 0 z "},"΄":{"ha":833,"x_min":368,"x_max":551,"o":"m 447 776 l 368 790 l 433 1110 l 551 1089 l 447 776 z "},"΅":{"ha":833,"x_min":193,"x_max":640,"o":"m 257 826 q 211 842 229 826 q 193 886 193 858 q 211 933 193 915 q 257 950 229 950 q 303 933 285 950 q 321 886 321 915 q 303 842 321 858 q 257 826 285 826 m 358 796 l 426 1110 l 521 1092 l 417 783 l 358 796 m 576 826 q 531 842 549 826 q 513 886 513 858 q 531 933 513 915 q 576 950 549 950 q 622 933 604 950 q 640 886 640 915 q 622 842 640 858 q 576 826 604 826 z "},"ͺ":{"ha":833,"x_min":371,"x_max":542,"o":"m 478 -279 q 371 -151 371 -279 l 371 -86 l 460 -86 q 457 -124 457 -104 q 457 -160 457 -144 q 469 -193 457 -183 q 499 -203 482 -203 q 510 -202 504 -203 q 529 -199 515 -201 l 542 -267 q 515 -276 528 -272 q 478 -279 501 -279 z "},"ι":{"ha":833,"x_min":349,"x_max":561,"o":"m 481 -17 q 379 24 410 -17 q 349 140 349 65 l 349 564 l 464 564 q 459 342 461 451 q 457 132 457 232 q 470 91 457 104 q 506 78 483 78 q 546 86 522 78 l 561 0 q 527 -12 546 -7 q 481 -17 508 -17 z "},"᾽":{"ha":833,"x_min":322,"x_max":528,"o":"m 372 794 l 360 850 q 415 873 393 858 q 438 915 438 888 q 322 981 438 975 l 329 1056 q 476 1020 425 1053 q 528 925 528 988 q 515 873 528 894 q 480 835 501 851 q 431 810 458 819 q 372 794 403 800 z "},"᾿":{"ha":833,"x_min":322,"x_max":528,"o":"m 372 794 l 360 850 q 415 873 393 858 q 438 915 438 888 q 322 981 438 975 l 329 1056 q 476 1020 425 1053 q 528 925 528 988 q 515 873 528 894 q 480 835 501 851 q 431 810 458 819 q 372 794 403 800 z "},"῾":{"ha":833,"x_min":306,"x_max":511,"o":"m 461 797 q 403 812 431 803 q 353 836 375 821 q 319 873 332 851 q 306 925 306 894 q 357 1020 306 988 q 504 1056 408 1053 l 511 981 q 396 915 396 975 q 418 873 396 888 q 474 850 440 858 l 461 797 z "},"`":{"ha":833,"x_min":290,"x_max":463,"o":"m 383 775 l 290 1049 l 408 1069 l 463 790 l 383 775 z "},"´":{"ha":833,"x_min":368,"x_max":551,"o":"m 447 776 l 368 790 l 433 1110 l 551 1089 l 447 776 z "},"῍":{"ha":833,"x_min":200,"x_max":576,"o":"m 250 801 l 236 854 q 283 876 264 861 q 301 919 301 892 q 200 979 301 974 l 206 1050 q 336 1018 288 1047 q 385 932 385 989 q 373 879 385 901 q 342 842 361 857 q 299 817 324 826 q 250 801 275 807 m 507 776 l 419 1050 l 522 1069 l 576 790 l 507 776 z "},"῝":{"ha":833,"x_min":192,"x_max":567,"o":"m 326 801 q 277 817 301 807 q 234 842 253 826 q 203 879 215 857 q 192 932 192 901 q 240 1018 192 989 q 371 1050 289 1047 l 376 979 q 275 919 275 974 q 293 876 275 892 q 339 854 311 861 l 326 801 m 499 776 l 410 1050 l 514 1069 l 567 790 l 499 776 z "},"῎":{"ha":833,"x_min":200,"x_max":594,"o":"m 250 801 l 236 854 q 283 876 264 861 q 301 919 301 892 q 200 979 301 974 l 206 1050 q 336 1018 288 1047 q 385 932 385 989 q 373 879 385 901 q 342 842 361 857 q 299 817 324 826 q 250 801 275 807 m 503 776 l 433 790 l 492 1069 l 594 1050 l 503 776 z "},"῞":{"ha":833,"x_min":206,"x_max":586,"o":"m 340 801 q 291 817 315 807 q 248 842 267 826 q 217 879 229 857 q 206 932 206 901 q 254 1018 206 989 q 385 1050 303 1047 l 390 979 q 289 919 289 974 q 307 876 289 892 q 353 854 325 861 l 340 801 m 424 790 l 483 1069 l 586 1050 l 493 776 l 424 790 z "},"῏":{"ha":833,"x_min":221,"x_max":613,"o":"m 507 993 q 453 1002 476 993 q 409 1022 429 1011 q 370 1042 389 1033 q 332 1051 351 1051 q 301 1037 311 1051 q 286 993 292 1022 l 221 999 q 251 1086 226 1051 q 326 1121 275 1121 q 381 1112 357 1121 q 424 1092 404 1103 q 463 1072 444 1081 q 501 1063 482 1063 q 532 1077 522 1063 q 547 1121 542 1092 l 613 1115 q 583 1028 607 1063 q 507 993 558 993 m 379 781 l 368 826 q 410 843 393 833 q 426 868 426 853 q 404 898 426 888 q 331 911 382 908 l 340 965 q 466 942 422 963 q 510 881 510 922 q 469 814 510 838 q 379 781 429 790 z "},"῟":{"ha":833,"x_min":221,"x_max":613,"o":"m 454 781 q 364 814 404 790 q 324 881 324 838 q 367 942 324 922 q 493 965 411 963 l 503 911 q 429 898 451 908 q 407 868 407 888 q 424 843 407 853 q 465 826 440 833 l 454 781 m 221 999 q 251 1086 226 1051 q 326 1121 275 1121 q 381 1112 357 1121 q 424 1092 404 1103 q 463 1072 444 1081 q 501 1063 482 1063 q 532 1077 522 1063 q 547 1121 542 1092 l 613 1115 q 583 1028 607 1063 q 507 993 558 993 q 453 1002 476 993 q 409 1022 429 1011 q 370 1042 389 1033 q 332 1051 351 1051 q 301 1037 311 1051 q 286 993 292 1022 l 221 999 z "},"῀":{"ha":833,"x_min":176,"x_max":657,"o":"m 517 801 q 453 819 479 801 q 404 860 426 838 q 362 900 382 882 q 318 918 342 918 q 271 888 286 918 q 253 808 256 857 l 176 813 q 187 888 178 853 q 213 947 196 922 q 255 987 229 972 q 317 1001 281 1001 q 381 983 354 1001 q 429 943 407 965 q 472 903 451 921 q 517 885 492 885 q 563 915 547 885 q 581 994 578 946 l 657 989 q 647 915 656 949 q 621 856 638 881 q 578 816 604 831 q 517 801 553 801 z "},"῭":{"ha":833,"x_min":201,"x_max":632,"o":"m 260 826 q 218 842 235 826 q 201 885 201 858 q 218 927 201 911 q 260 943 235 943 q 300 927 283 943 q 317 885 317 911 q 300 842 317 858 q 260 826 283 826 m 413 782 l 324 1056 l 415 1075 l 472 796 l 413 782 m 574 826 q 533 842 550 826 q 517 885 517 858 q 533 927 517 911 q 574 943 550 943 q 615 927 599 943 q 632 885 632 911 q 615 842 632 858 q 574 826 599 826 z "},"΅":{"ha":833,"x_min":193,"x_max":640,"o":"m 257 826 q 211 842 229 826 q 193 886 193 858 q 211 933 193 915 q 257 950 229 950 q 303 933 285 950 q 321 886 321 915 q 303 842 321 858 q 257 826 285 826 m 358 796 l 426 1110 l 521 1092 l 417 783 l 358 796 m 576 826 q 531 842 549 826 q 513 886 513 858 q 531 933 513 915 q 576 950 549 950 q 622 933 604 950 q 640 886 640 915 q 622 842 640 858 q 576 826 604 826 z "},"῁":{"ha":833,"x_min":204,"x_max":629,"o":"m 283 817 q 238 835 256 817 q 219 879 219 853 q 238 925 219 907 q 283 943 256 943 q 328 925 311 943 q 346 879 346 907 q 328 835 346 853 q 283 817 311 817 m 550 817 q 505 835 522 817 q 488 879 488 853 q 505 925 488 907 q 550 943 522 943 q 596 925 578 943 q 614 879 614 907 q 596 835 614 853 q 550 817 578 817 m 515 982 q 454 992 479 982 q 408 1016 429 1003 q 368 1040 388 1029 q 324 1050 349 1050 q 283 1034 300 1050 q 263 986 267 1018 l 204 992 q 236 1083 207 1046 q 318 1119 265 1119 q 379 1109 354 1119 q 425 1085 404 1099 q 465 1062 446 1072 q 510 1051 485 1051 q 550 1067 533 1051 q 571 1115 567 1083 l 629 1110 q 597 1019 626 1056 q 515 982 568 982 z "},"А":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 z "},"Б":{"ha":833,"x_min":138,"x_max":760,"o":"m 138 0 l 138 911 l 700 911 l 700 814 l 253 814 l 253 528 l 428 528 q 561 514 500 528 q 666 470 622 500 q 735 392 710 440 q 760 276 760 344 q 672 67 760 133 q 433 0 583 0 l 138 0 m 253 97 l 414 97 q 589 136 532 97 q 646 269 646 175 q 588 394 646 357 q 411 431 529 431 l 253 431 l 253 97 z "},"В":{"ha":833,"x_min":138,"x_max":760,"o":"m 138 0 l 138 911 l 396 911 q 523 899 465 911 q 622 860 581 886 q 685 791 663 833 q 708 689 708 749 q 669 566 708 621 q 549 490 631 511 l 549 485 q 704 415 649 469 q 760 267 760 361 q 735 150 760 200 q 665 67 710 100 q 556 17 619 33 q 417 0 493 0 l 138 0 m 253 528 l 376 528 q 544 565 493 528 q 594 679 594 603 q 541 784 594 754 q 382 814 488 814 l 253 814 l 253 528 m 253 97 l 400 97 q 582 138 518 97 q 646 272 646 179 q 583 394 646 357 q 400 431 521 431 l 253 431 l 253 97 z "},"Г":{"ha":833,"x_min":188,"x_max":743,"o":"m 188 0 l 188 911 l 743 911 l 743 814 l 303 814 l 303 0 l 188 0 z "},"Д":{"ha":833,"x_min":31,"x_max":803,"o":"m 43 -261 l 31 29 l 31 99 l 72 99 q 99 122 85 104 q 127 176 113 139 q 157 275 142 214 q 188 426 172 336 q 210 551 200 494 q 228 664 219 608 q 247 778 238 719 q 267 911 256 838 l 701 911 l 701 99 l 803 99 l 803 29 l 790 -261 l 689 -261 l 689 0 l 144 0 l 144 -261 l 43 -261 m 292 407 q 249 215 272 289 q 197 99 225 142 l 586 99 l 586 814 l 357 814 q 340 706 347 756 q 325 610 332 657 q 310 515 318 564 q 292 407 301 465 z "},"Е":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 z "},"Ж":{"ha":833,"x_min":1,"x_max":832,"o":"m 3 0 l 196 488 l 136 707 q 114 765 125 743 q 92 797 103 786 q 71 812 82 808 q 49 815 60 815 q 34 814 42 815 q 19 810 26 813 l 1 921 q 28 926 11 924 q 57 928 44 928 q 107 922 83 928 q 151 898 131 915 q 191 848 172 881 q 225 761 210 815 l 290 528 l 364 528 l 364 911 l 469 911 l 469 528 l 543 528 l 608 761 q 641 848 624 815 q 678 898 658 881 q 722 922 699 915 q 771 928 744 928 q 803 926 783 928 q 832 921 822 924 l 814 810 q 799 814 807 813 q 785 815 792 815 q 763 812 774 815 q 741 797 751 808 q 719 765 731 786 q 697 707 708 743 l 638 488 l 831 0 l 706 0 l 553 429 l 469 429 l 469 0 l 364 0 l 364 429 l 281 429 l 128 0 l 3 0 z "},"З":{"ha":833,"x_min":86,"x_max":750,"o":"m 418 -17 q 238 15 318 -17 q 86 118 157 47 l 151 197 q 274 110 213 136 q 417 85 336 85 q 502 97 463 85 q 572 131 542 108 q 619 188 601 154 q 636 264 636 221 q 571 393 636 351 q 386 435 506 435 l 283 435 l 283 524 l 358 524 q 535 563 481 524 q 589 681 589 603 q 538 790 589 753 q 407 826 486 826 q 287 803 342 826 q 189 739 232 779 l 126 817 q 251 897 176 865 q 410 928 325 928 q 529 912 475 928 q 622 866 583 896 q 681 792 660 836 q 703 694 703 749 q 668 567 703 622 q 567 489 633 513 l 567 483 q 698 410 646 468 q 750 258 750 353 q 724 142 750 193 q 653 55 699 90 q 548 1 608 19 q 418 -17 488 -17 z "},"И":{"ha":833,"x_min":108,"x_max":725,"o":"m 108 0 l 108 911 l 219 911 l 219 439 q 213 292 219 367 q 204 150 207 218 l 207 150 l 294 339 l 597 911 l 725 911 l 725 0 l 614 0 l 614 476 q 620 619 614 547 q 629 761 626 690 l 626 761 l 539 572 l 236 0 l 108 0 z "},"Й":{"ha":833,"x_min":108,"x_max":725,"o":"m 108 0 l 108 911 l 219 911 l 219 439 q 213 292 219 367 q 204 150 207 218 l 207 150 l 294 339 l 597 911 l 725 911 l 725 0 l 614 0 l 614 476 q 620 619 614 547 q 629 761 626 690 l 626 761 l 539 572 l 236 0 l 108 0 m 422 979 q 325 994 364 979 q 262 1033 286 1008 q 226 1090 238 1058 q 213 1157 214 1122 l 313 1163 q 339 1078 314 1114 q 422 1043 364 1043 q 472 1053 451 1043 q 505 1078 492 1063 q 524 1116 518 1094 q 532 1163 531 1138 l 632 1157 q 618 1090 629 1122 q 583 1033 607 1058 q 519 994 558 1008 q 422 979 481 979 z "},"К":{"ha":833,"x_min":142,"x_max":806,"o":"m 142 0 l 142 911 l 257 911 l 257 528 l 406 528 l 528 758 q 578 843 554 810 q 626 895 603 876 q 676 921 650 914 q 733 928 701 928 q 759 926 746 928 q 783 919 772 924 l 763 811 q 746 815 754 814 q 731 817 738 817 q 702 813 715 817 q 676 797 689 808 q 647 762 663 785 q 611 701 631 739 l 499 489 l 806 0 l 678 0 l 406 429 l 257 429 l 257 0 l 142 0 z "},"Л":{"ha":833,"x_min":3,"x_max":724,"o":"m 81 -17 q 40 -14 58 -17 q 3 -4 22 -11 l 26 103 q 65 94 47 94 q 97 102 82 94 q 126 135 113 110 q 154 209 140 161 q 185 339 168 257 q 212 482 199 413 q 238 622 225 551 q 262 763 250 692 q 288 911 274 835 l 724 911 l 724 0 l 607 0 l 607 814 l 378 814 q 337 570 356 688 q 294 326 318 453 q 253 156 274 222 q 207 51 232 89 q 151 -2 182 13 q 81 -17 119 -17 z "},"М":{"ha":833,"x_min":100,"x_max":733,"o":"m 100 0 l 100 911 l 242 911 l 369 522 l 414 375 l 419 375 l 463 522 l 592 911 l 733 911 l 733 0 l 622 0 l 622 456 q 624 533 622 489 q 630 621 626 576 q 636 707 633 665 q 642 778 639 749 l 638 778 l 586 600 l 456 242 l 372 242 l 244 600 l 192 778 l 189 778 q 195 707 192 749 q 201 621 199 665 q 206 533 204 576 q 208 456 208 489 l 208 0 l 100 0 z "},"Н":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 607 529 l 607 911 l 724 911 l 724 0 l 607 0 l 607 429 l 226 429 l 226 0 l 110 0 z "},"О":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 z "},"П":{"ha":833,"x_min":110,"x_max":724,"o":"m 110 0 l 110 911 l 724 911 l 724 0 l 607 0 l 607 814 l 226 814 l 226 0 l 110 0 z "},"Р":{"ha":833,"x_min":142,"x_max":754,"o":"m 142 0 l 142 911 l 417 911 q 554 897 492 911 q 661 852 617 883 q 730 769 706 821 q 754 643 754 718 q 730 518 754 571 q 660 431 706 465 q 553 378 615 396 q 417 361 492 361 l 257 361 l 257 0 l 142 0 m 257 456 l 403 456 q 581 501 524 456 q 638 643 638 546 q 579 780 638 742 q 403 818 521 818 l 257 818 l 257 456 z "},"С":{"ha":833,"x_min":90,"x_max":769,"o":"m 488 -17 q 331 15 403 -17 q 205 108 258 47 q 121 256 151 168 q 90 456 90 344 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 647 18 715 53 q 488 -17 579 -17 z "},"Т":{"ha":833,"x_min":58,"x_max":775,"o":"m 358 0 l 358 814 l 58 814 l 58 911 l 775 911 l 775 814 l 475 814 l 475 0 l 358 0 z "},"У":{"ha":833,"x_min":65,"x_max":772,"o":"m 247 -17 q 197 -13 217 -17 q 157 -3 176 -10 l 182 101 q 206 94 193 97 q 240 92 219 92 q 311 109 285 92 q 357 165 338 126 l 376 214 l 65 911 l 189 911 l 358 506 l 428 326 l 433 326 l 499 506 l 654 911 l 772 911 l 474 165 q 387 32 439 81 q 247 -17 335 -17 z "},"Ф":{"ha":833,"x_min":36,"x_max":797,"o":"m 147 461 q 201 281 147 347 q 364 204 254 214 l 364 710 q 201 638 254 701 q 147 461 147 574 m 686 461 q 633 638 686 574 q 469 710 579 701 l 469 204 q 633 281 579 214 q 686 461 686 347 m 364 -17 l 364 115 q 122 215 207 126 q 36 461 36 303 q 122 702 36 617 q 364 799 207 788 l 364 928 l 469 928 l 469 799 q 712 702 626 788 q 797 461 797 617 q 712 215 797 303 q 469 115 626 126 l 469 -17 l 364 -17 z "},"Х":{"ha":833,"x_min":75,"x_max":758,"o":"m 75 0 l 347 471 l 93 911 l 221 911 l 349 678 q 383 616 367 646 q 422 546 400 586 l 428 546 q 462 616 447 586 q 493 678 476 646 l 618 911 l 740 911 l 486 465 l 758 0 l 631 0 l 493 246 q 455 315 474 279 q 413 392 436 350 l 407 392 q 369 315 388 350 q 333 246 351 279 l 197 0 l 75 0 z "},"Ц":{"ha":833,"x_min":110,"x_max":818,"o":"m 110 0 l 110 911 l 225 911 l 225 99 l 604 99 l 604 911 l 719 911 l 719 99 l 818 99 l 818 29 l 806 -261 l 711 -261 l 711 0 l 110 0 z "},"Ч":{"ha":833,"x_min":90,"x_max":717,"o":"m 600 0 l 600 408 q 524 398 565 401 q 426 394 482 394 q 286 410 349 394 q 180 460 224 425 q 113 553 136 496 q 90 694 90 611 l 90 911 l 204 911 l 204 694 q 265 535 204 579 q 436 490 325 490 q 531 494 490 490 q 600 504 571 497 l 600 911 l 717 911 l 717 0 l 600 0 z "},"Ш":{"ha":833,"x_min":56,"x_max":778,"o":"m 56 0 l 56 911 l 161 911 l 161 99 l 364 99 l 364 911 l 469 911 l 469 99 l 672 99 l 672 911 l 778 911 l 778 0 l 56 0 z "},"Щ":{"ha":833,"x_min":53,"x_max":822,"o":"m 53 0 l 53 911 l 156 911 l 156 99 l 342 99 l 342 911 l 444 911 l 444 99 l 631 99 l 631 911 l 733 911 l 733 99 l 822 99 l 822 29 l 810 -261 l 718 -261 l 718 0 l 53 0 z "},"Ъ":{"ha":833,"x_min":26,"x_max":796,"o":"m 279 0 l 279 814 l 26 814 l 26 911 l 396 911 l 396 538 l 472 538 q 601 522 542 538 q 704 476 661 507 q 772 396 747 444 q 796 281 796 347 q 774 154 796 207 q 710 67 751 101 q 612 17 669 33 q 482 0 554 0 l 279 0 m 396 94 l 467 94 q 630 138 575 94 q 685 278 685 181 q 627 403 685 361 q 457 444 569 444 l 396 444 l 396 94 z "},"Ы":{"ha":833,"x_min":76,"x_max":757,"o":"m 76 0 l 76 911 l 182 911 l 182 538 l 232 538 q 356 523 300 538 q 452 477 413 508 q 514 397 492 446 q 536 281 536 349 q 454 67 536 135 q 233 0 372 0 l 76 0 m 182 94 l 224 94 q 381 138 328 94 q 435 278 435 181 q 381 405 435 365 q 221 444 328 444 l 182 444 l 182 94 m 651 0 l 651 911 l 757 911 l 757 0 l 651 0 z "},"Ь":{"ha":833,"x_min":136,"x_max":757,"o":"m 136 0 l 136 911 l 253 911 l 253 538 l 421 538 q 558 523 496 538 q 664 477 619 508 q 733 397 708 446 q 757 281 757 349 q 733 154 757 207 q 666 67 710 101 q 560 17 622 33 q 422 0 499 0 l 136 0 m 253 94 l 407 94 q 583 138 524 94 q 643 278 643 181 q 583 405 643 365 q 404 444 524 444 l 253 444 l 253 94 z "},"Э":{"ha":833,"x_min":64,"x_max":742,"o":"m 358 -17 q 194 18 265 -17 q 64 115 122 53 l 128 188 q 230 112 175 139 q 356 85 285 85 q 547 170 475 85 q 625 429 618 256 l 243 429 l 243 528 l 624 528 q 542 750 611 674 q 353 826 472 826 q 241 803 293 826 q 150 740 189 781 l 86 815 q 201 894 129 860 q 358 928 272 928 q 515 897 444 928 q 636 807 586 867 q 714 659 686 747 q 742 456 742 571 q 713 251 742 339 q 633 103 685 163 q 512 14 582 44 q 358 -17 442 -17 z "},"Ю":{"ha":833,"x_min":61,"x_max":783,"o":"m 528 -17 q 351 92 417 -17 q 281 429 286 201 l 178 429 l 178 0 l 61 0 l 61 911 l 178 911 l 178 529 l 282 529 q 356 832 292 736 q 528 928 421 928 q 714 815 644 928 q 783 461 783 703 q 714 100 783 217 q 528 -17 644 -17 m 528 85 q 586 106 561 85 q 628 172 611 126 q 655 288 646 217 q 664 461 664 360 q 655 631 664 561 q 628 744 646 700 q 586 807 611 788 q 528 826 561 826 q 471 807 496 826 q 428 744 446 788 q 401 631 411 700 q 392 461 392 561 q 401 288 392 360 q 428 172 411 217 q 471 106 446 126 q 528 85 496 85 z "},"Я":{"ha":833,"x_min":42,"x_max":696,"o":"m 579 0 l 579 385 l 411 385 l 175 0 l 42 0 l 297 397 q 148 483 206 419 q 90 656 90 546 q 114 775 90 726 q 180 854 138 824 q 281 898 222 885 q 410 911 340 911 l 696 911 l 696 0 l 579 0 m 426 479 l 579 479 l 579 818 l 426 818 q 263 782 319 818 q 207 656 207 746 q 263 523 207 567 q 426 479 319 479 z "},"Ѐ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 500 968 l 289 1128 l 354 1204 l 550 1026 l 500 968 z "},"Ё":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 333 993 q 283 1013 303 993 q 263 1064 263 1032 q 283 1115 263 1096 q 333 1133 303 1133 q 383 1115 364 1133 q 403 1064 403 1096 q 383 1013 403 1032 q 333 993 364 993 m 586 993 q 536 1013 556 993 q 517 1064 517 1032 q 536 1115 517 1096 q 586 1133 556 1133 q 637 1115 617 1133 q 657 1064 657 1096 q 637 1013 657 1032 q 586 993 617 993 z "},"Ђ":{"ha":833,"x_min":7,"x_max":800,"o":"m 571 -17 q 522 -12 547 -17 q 482 -3 497 -8 l 503 90 q 527 83 513 86 q 556 79 542 79 q 601 88 578 79 q 643 117 624 96 q 675 175 663 139 q 688 265 688 211 q 634 415 688 368 q 485 461 581 461 q 417 458 451 461 q 357 447 383 454 l 357 0 l 240 0 l 240 814 l 7 814 l 7 911 l 649 911 l 649 814 l 357 814 l 357 543 q 426 553 388 549 q 501 557 464 557 q 620 540 565 557 q 715 489 675 524 q 778 399 756 454 q 800 267 800 343 q 781 131 800 185 q 728 44 761 76 q 655 -3 696 11 q 571 -17 614 -17 z "},"Ѓ":{"ha":833,"x_min":188,"x_max":743,"o":"m 188 0 l 188 911 l 743 911 l 743 814 l 303 814 l 303 0 l 188 0 m 376 968 l 326 1026 l 522 1204 l 588 1128 l 376 968 z "},"Є":{"ha":833,"x_min":92,"x_max":769,"o":"m 489 -17 q 328 14 401 -17 q 203 103 256 44 q 121 251 150 163 q 92 456 92 339 q 122 659 92 571 q 205 807 151 747 q 333 897 258 867 q 494 928 407 928 q 642 894 578 928 q 747 815 707 860 l 683 740 q 601 803 647 779 q 497 826 556 826 q 300 750 375 826 q 210 528 225 674 l 590 528 l 590 429 l 208 429 q 290 170 215 256 q 494 85 364 85 q 610 112 560 85 q 706 188 661 139 l 769 115 q 647 18 715 53 q 489 -17 578 -17 z "},"Ѕ":{"ha":833,"x_min":93,"x_max":746,"o":"m 424 -17 q 240 19 324 -17 q 93 118 156 56 l 163 199 q 282 116 214 147 q 429 85 350 85 q 576 125 524 85 q 628 229 628 165 q 615 290 628 265 q 581 333 603 315 q 528 365 558 351 q 464 394 499 379 l 333 451 q 264 485 299 465 q 201 532 229 504 q 154 598 172 560 q 136 686 136 636 q 158 782 136 738 q 220 859 181 826 q 315 910 260 892 q 435 928 369 928 q 593 897 521 928 q 715 815 665 865 l 654 740 q 556 803 610 781 q 431 826 501 826 q 303 791 351 826 q 254 693 254 756 q 269 637 254 660 q 306 597 283 614 q 358 567 329 579 q 417 542 388 554 l 544 486 q 623 448 586 469 q 687 398 660 426 q 730 331 714 369 q 746 243 746 293 q 724 142 746 189 q 660 59 701 94 q 558 3 618 24 q 424 -17 499 -17 z "},"І":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 z "},"Ї":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ј":{"ha":833,"x_min":113,"x_max":685,"o":"m 383 -17 q 233 19 307 -17 q 113 135 160 56 l 185 206 q 276 114 224 143 q 381 85 328 85 q 524 137 479 85 q 569 301 569 189 l 569 815 l 188 815 l 188 913 l 685 913 l 685 292 q 669 172 685 228 q 619 74 654 115 q 526 8 583 32 q 383 -17 468 -17 z "},"Љ":{"ha":833,"x_min":-11,"x_max":797,"o":"m 49 -17 q 19 -15 33 -17 q -11 -7 6 -14 l 13 100 q 25 96 19 97 q 38 94 31 94 q 61 101 50 94 q 83 132 72 108 q 103 201 93 156 q 122 322 113 246 q 151 619 142 474 q 165 911 161 764 l 494 911 l 494 538 l 525 538 q 635 523 585 538 q 722 477 686 508 q 777 397 757 446 q 797 281 797 349 q 722 67 797 135 q 521 0 647 0 l 389 0 l 389 814 l 261 814 q 247 567 257 689 q 222 299 238 444 q 196 142 211 203 q 160 45 181 81 q 111 -3 139 10 q 49 -17 83 -17 m 494 94 l 517 94 q 651 138 607 94 q 694 278 694 181 q 650 405 694 365 q 513 444 606 444 l 494 444 l 494 94 z "},"Њ":{"ha":833,"x_min":54,"x_max":796,"o":"m 54 0 l 54 911 l 160 911 l 160 529 l 371 529 l 371 911 l 476 911 l 476 538 l 525 538 q 635 523 585 538 q 721 477 685 508 q 776 397 757 446 q 796 281 796 349 q 777 154 796 207 q 723 67 758 101 q 638 17 688 33 q 526 0 588 0 l 371 0 l 371 429 l 160 429 l 160 0 l 54 0 m 476 94 l 517 94 q 649 136 604 94 q 693 278 693 178 q 649 406 693 367 q 513 444 604 444 l 476 444 l 476 94 z "},"Ћ":{"ha":833,"x_min":7,"x_max":788,"o":"m 240 0 l 240 814 l 7 814 l 7 911 l 647 911 l 647 814 l 356 814 l 356 543 q 426 553 388 549 q 500 557 464 557 q 711 494 635 557 q 788 290 788 432 l 788 0 l 674 0 l 674 290 q 626 422 674 383 q 483 461 579 461 q 417 458 451 461 q 356 447 382 454 l 356 0 l 240 0 z "},"Ќ":{"ha":833,"x_min":142,"x_max":806,"o":"m 142 0 l 142 911 l 257 911 l 257 528 l 406 528 l 528 758 q 578 843 554 810 q 626 895 603 876 q 676 921 650 914 q 733 928 701 928 q 759 926 746 928 q 783 919 772 924 l 763 811 q 746 815 754 814 q 731 817 738 817 q 702 813 715 817 q 676 797 689 808 q 647 762 663 785 q 611 701 631 739 l 499 489 l 806 0 l 678 0 l 406 429 l 257 429 l 257 0 l 142 0 m 400 968 l 350 1026 l 546 1204 l 611 1128 l 400 968 z "},"Ѝ":{"ha":833,"x_min":108,"x_max":725,"o":"m 108 0 l 108 911 l 219 911 l 219 439 q 213 292 219 367 q 204 150 207 218 l 207 150 l 294 339 l 597 911 l 725 911 l 725 0 l 614 0 l 614 476 q 620 619 614 547 q 629 761 626 690 l 626 761 l 539 572 l 236 0 l 108 0 m 463 968 l 251 1128 l 317 1204 l 513 1026 l 463 968 z "},"Ў":{"ha":833,"x_min":65,"x_max":772,"o":"m 247 -17 q 197 -13 217 -17 q 157 -3 176 -10 l 182 101 q 206 94 193 97 q 240 92 219 92 q 311 109 285 92 q 357 165 338 126 l 376 214 l 65 911 l 189 911 l 358 506 l 428 326 l 433 326 l 499 506 l 654 911 l 772 911 l 474 165 q 387 32 439 81 q 247 -17 335 -17 m 422 979 q 325 994 364 979 q 262 1033 286 1008 q 226 1090 238 1058 q 213 1157 214 1122 l 313 1163 q 339 1078 314 1114 q 422 1043 364 1043 q 472 1053 451 1043 q 505 1078 492 1063 q 524 1116 518 1094 q 532 1163 531 1138 l 632 1157 q 618 1090 629 1122 q 583 1033 607 1058 q 519 994 558 1008 q 422 979 481 979 z "},"Џ":{"ha":833,"x_min":104,"x_max":729,"o":"m 104 0 l 104 911 l 221 911 l 221 99 l 613 99 l 613 911 l 729 911 l 729 0 l 476 0 l 465 -261 l 369 -261 l 369 0 l 104 0 z "},"Ѣ":{"ha":833,"x_min":33,"x_max":765,"o":"m 222 0 l 222 704 l 33 704 l 33 799 l 222 799 l 222 972 l 338 972 l 338 799 l 646 799 l 646 704 l 338 704 l 338 515 l 429 515 q 566 502 504 515 q 672 460 628 489 q 741 386 717 432 q 765 275 765 340 q 742 149 765 201 q 677 64 719 97 q 574 15 635 31 q 438 0 514 0 l 222 0 m 338 92 l 424 92 q 595 133 539 92 q 651 269 651 174 q 594 392 651 356 q 414 429 536 429 l 338 429 l 338 92 z "},"Ѳ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 274 15 339 -17 q 164 108 210 47 q 92 257 118 168 q 67 460 67 346 q 92 660 67 574 q 164 807 118 747 q 274 897 210 867 q 417 928 339 928 q 559 897 494 928 q 669 807 624 867 q 741 660 715 747 q 767 460 767 572 q 741 257 767 346 q 669 108 715 168 q 559 15 624 47 q 417 -17 494 -17 m 417 831 q 258 752 319 831 q 185 526 196 674 l 649 526 q 576 752 638 674 q 417 831 514 831 m 417 81 q 582 171 519 81 q 651 432 644 261 l 182 432 q 251 171 189 261 q 417 81 314 81 z "},"Ѵ":{"ha":833,"x_min":53,"x_max":832,"o":"m 344 0 l 53 911 l 176 911 l 324 419 q 365 268 346 338 q 411 118 385 199 l 417 118 q 437 195 428 158 q 456 268 446 232 q 475 342 465 304 q 496 419 485 379 l 585 735 q 652 882 613 836 q 765 928 692 928 q 801 925 786 928 q 832 915 815 922 l 808 808 q 792 814 801 811 q 772 817 783 817 q 724 791 742 817 q 692 714 707 765 l 486 0 l 344 0 z "},"Ґ":{"ha":833,"x_min":188,"x_max":742,"o":"m 188 0 l 188 911 l 622 911 l 644 1150 l 742 1150 l 729 814 l 303 814 l 303 0 l 188 0 z "},"Ғ":{"ha":833,"x_min":83,"x_max":731,"o":"m 194 0 l 194 417 l 83 417 l 83 497 l 194 503 l 194 911 l 731 911 l 731 814 l 311 814 l 311 503 l 544 503 l 544 417 l 311 417 l 311 0 l 194 0 z "},"Җ":{"ha":833,"x_min":1,"x_max":854,"o":"m 760 -261 l 760 0 l 706 0 l 553 429 l 469 429 l 469 0 l 364 0 l 364 429 l 281 429 l 128 0 l 3 0 l 196 488 l 136 707 q 114 765 125 743 q 92 797 103 786 q 71 812 82 808 q 49 815 60 815 q 34 814 42 815 q 19 810 26 813 l 1 921 q 28 926 11 924 q 57 928 44 928 q 107 922 83 928 q 151 898 131 915 q 191 848 172 881 q 225 761 210 815 l 290 528 l 364 528 l 364 911 l 469 911 l 469 528 l 543 528 l 608 761 q 641 848 624 815 q 678 898 658 881 q 722 922 699 915 q 771 928 744 928 q 803 926 783 928 q 832 921 822 924 l 814 810 q 799 814 807 813 q 785 815 792 815 q 763 812 774 815 q 741 797 751 808 q 719 765 731 786 q 697 707 708 743 l 638 488 l 792 99 l 854 99 l 854 29 l 842 -261 l 760 -261 z "},"Ҙ":{"ha":833,"x_min":86,"x_max":750,"o":"m 367 -261 l 367 -15 q 215 23 283 -8 q 86 117 147 54 l 151 196 q 274 109 213 135 q 417 83 336 83 q 502 95 463 83 q 572 130 542 107 q 619 186 601 153 q 636 263 636 219 q 571 392 636 350 q 386 433 506 433 l 283 433 l 283 522 l 358 522 q 535 562 481 522 q 589 679 589 601 q 538 788 589 751 q 407 825 486 825 q 287 801 342 825 q 189 738 232 778 l 126 815 q 251 895 176 864 q 410 926 325 926 q 529 910 475 926 q 622 865 583 894 q 681 791 660 835 q 703 693 703 747 q 668 566 703 621 q 567 488 633 511 l 567 482 q 698 409 646 467 q 750 257 750 351 q 730 151 750 199 q 673 70 710 104 q 587 15 636 36 q 479 -14 538 -7 l 468 -261 l 367 -261 z "},"Қ":{"ha":833,"x_min":142,"x_max":817,"o":"m 713 -261 l 713 0 l 678 0 l 406 429 l 257 429 l 257 0 l 142 0 l 142 911 l 257 911 l 257 528 l 406 528 l 528 758 q 578 843 554 810 q 626 895 603 876 q 676 921 650 914 q 733 928 701 928 q 759 926 746 928 q 783 919 772 924 l 763 811 q 746 815 754 814 q 731 817 738 817 q 702 813 715 817 q 676 797 689 808 q 647 762 663 785 q 611 701 631 739 l 499 489 l 743 99 l 817 99 l 817 29 l 804 -261 l 713 -261 z "},"Ҡ":{"ha":833,"x_min":26,"x_max":833,"o":"m 285 0 l 285 814 l 26 814 l 26 911 l 390 911 l 390 528 l 482 528 l 586 758 q 632 845 611 813 q 674 897 653 878 q 719 922 696 915 q 769 928 742 928 q 815 919 796 928 l 796 813 q 768 817 783 817 q 747 813 757 817 q 724 797 736 810 q 698 762 713 785 q 665 701 683 739 l 564 488 l 833 0 l 721 0 l 479 429 l 390 429 l 390 0 l 285 0 z "},"Ң":{"ha":833,"x_min":110,"x_max":818,"o":"m 110 0 l 110 911 l 226 911 l 226 529 l 604 529 l 604 911 l 719 911 l 719 99 l 818 99 l 818 29 l 806 -261 l 717 -261 l 717 0 l 604 0 l 604 429 l 226 429 l 226 0 l 110 0 z "},"Ҫ":{"ha":833,"x_min":90,"x_max":769,"o":"m 435 -261 l 435 -14 q 297 32 360 -4 q 188 128 233 68 q 116 270 142 188 q 90 456 90 353 q 121 653 90 565 q 206 801 151 740 q 335 895 260 863 q 499 928 410 928 q 644 894 581 928 q 747 817 707 861 l 682 743 q 601 803 646 781 q 499 826 557 826 q 380 801 433 826 q 289 727 326 775 q 231 611 251 679 q 210 458 210 543 q 231 303 210 372 q 289 186 251 235 q 380 111 326 138 q 499 85 433 85 q 610 111 561 85 q 704 186 660 138 l 769 115 q 671 31 725 63 q 547 -12 617 -1 l 536 -261 l 435 -261 z "},"Ү":{"ha":833,"x_min":53,"x_max":781,"o":"m 358 0 l 358 325 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 475 325 l 475 0 l 358 0 z "},"Ұ":{"ha":833,"x_min":53,"x_max":781,"o":"m 147 306 l 147 386 l 271 392 l 324 392 l 53 911 l 175 911 l 313 640 q 364 535 339 588 q 417 428 389 483 l 422 428 q 476 536 450 483 q 529 642 503 589 l 661 911 l 781 911 l 510 392 l 686 392 l 686 306 l 475 306 l 475 0 l 358 0 l 358 306 l 147 306 z "},"Ҳ":{"ha":833,"x_min":75,"x_max":783,"o":"m 682 -261 l 682 0 l 631 0 l 493 246 q 455 315 474 279 q 413 392 436 350 l 407 392 q 369 315 388 350 q 333 246 351 279 l 197 0 l 75 0 l 347 471 l 93 911 l 221 911 l 349 678 q 383 616 367 646 q 422 546 400 586 l 428 546 q 462 616 447 586 q 493 678 476 646 l 618 911 l 740 911 l 486 465 l 700 99 l 783 99 l 783 29 l 772 -261 l 682 -261 z "},"Ҷ":{"ha":833,"x_min":90,"x_max":808,"o":"m 593 0 l 593 408 q 519 398 560 401 q 422 394 478 394 q 283 410 344 394 q 178 460 221 425 q 113 553 136 496 q 90 694 90 611 l 90 911 l 204 911 l 204 694 q 263 535 204 579 q 433 490 322 490 q 525 494 486 490 q 593 504 564 497 l 593 911 l 710 911 l 710 99 l 808 99 l 808 29 l 796 -261 l 699 -261 l 699 0 l 593 0 z "},"Һ":{"ha":833,"x_min":126,"x_max":739,"o":"m 126 0 l 126 911 l 242 911 l 242 553 q 315 563 275 558 q 407 567 354 567 q 547 551 485 567 q 651 501 608 536 q 716 408 693 465 q 739 269 739 351 l 739 0 l 625 0 l 625 269 q 610 365 625 326 q 567 428 596 404 q 495 461 538 451 q 397 471 453 471 q 308 467 346 471 q 242 457 269 463 l 242 0 l 126 0 z "},"Ӏ":{"ha":833,"x_min":132,"x_max":701,"o":"m 132 0 l 132 99 l 358 99 l 358 814 l 132 814 l 132 911 l 701 911 l 701 814 l 475 814 l 475 99 l 701 99 l 701 0 l 132 0 z "},"Ӂ":{"ha":833,"x_min":1,"x_max":832,"o":"m 3 0 l 196 488 l 136 707 q 114 765 125 743 q 92 797 103 786 q 71 812 82 808 q 49 815 60 815 q 34 814 42 815 q 19 810 26 813 l 1 921 q 28 926 11 924 q 57 928 44 928 q 107 922 83 928 q 151 898 131 915 q 191 848 172 881 q 225 761 210 815 l 290 528 l 364 528 l 364 911 l 469 911 l 469 528 l 543 528 l 608 761 q 641 848 624 815 q 678 898 658 881 q 722 922 699 915 q 771 928 744 928 q 803 926 783 928 q 832 921 822 924 l 814 810 q 799 814 807 813 q 785 815 792 815 q 763 812 774 815 q 741 797 751 808 q 719 765 731 786 q 697 707 708 743 l 638 488 l 831 0 l 706 0 l 553 429 l 469 429 l 469 0 l 364 0 l 364 429 l 281 429 l 128 0 l 3 0 m 417 979 q 319 994 358 979 q 256 1033 281 1008 q 220 1090 232 1058 q 207 1157 208 1122 l 307 1163 q 333 1078 308 1114 q 417 1043 358 1043 q 466 1053 446 1043 q 499 1078 486 1063 q 519 1116 513 1094 q 526 1163 525 1138 l 626 1157 q 613 1090 624 1122 q 577 1033 601 1058 q 514 994 553 1008 q 417 979 475 979 z "},"Ӑ":{"ha":833,"x_min":44,"x_max":789,"o":"m 322 510 l 279 371 l 551 371 l 508 510 q 462 662 485 586 q 418 817 439 738 l 413 817 q 368 662 390 738 q 322 510 346 586 m 44 0 l 351 911 l 482 911 l 789 0 l 667 0 l 581 278 l 250 278 l 163 0 l 44 0 m 417 979 q 319 994 358 979 q 256 1033 281 1008 q 220 1090 232 1058 q 207 1157 208 1122 l 307 1163 q 333 1078 308 1114 q 417 1043 358 1043 q 466 1053 446 1043 q 499 1078 486 1063 q 519 1116 513 1094 q 526 1163 525 1138 l 626 1157 q 613 1090 624 1122 q 577 1033 601 1058 q 514 994 553 1008 q 417 979 475 979 z "},"Ӕ":{"ha":833,"x_min":-1,"x_max":821,"o":"m 321 524 l 257 358 l 440 358 l 440 819 l 436 819 q 378 672 408 744 q 321 524 349 599 m -1 0 l 365 911 l 808 911 l 808 814 l 546 814 l 546 529 l 750 529 l 750 431 l 546 431 l 546 99 l 821 99 l 821 0 l 440 0 l 440 265 l 221 265 l 119 0 l -1 0 z "},"Ӗ":{"ha":833,"x_min":158,"x_max":736,"o":"m 158 0 l 158 911 l 722 911 l 722 814 l 275 814 l 275 528 l 653 528 l 653 429 l 275 429 l 275 99 l 736 99 l 736 0 l 158 0 m 460 979 q 363 994 401 979 q 299 1033 324 1008 q 263 1090 275 1058 q 250 1157 251 1122 l 350 1163 q 376 1078 351 1114 q 460 1043 401 1043 q 509 1053 489 1043 q 542 1078 529 1063 q 562 1116 556 1094 q 569 1163 568 1138 l 669 1157 q 656 1090 667 1122 q 620 1033 644 1058 q 557 994 596 1008 q 460 979 518 979 z "},"Ә":{"ha":833,"x_min":82,"x_max":764,"o":"m 417 -17 q 278 17 340 -17 q 173 113 217 51 q 106 260 129 174 q 82 454 82 347 q 82 470 82 463 q 83 486 82 478 l 649 486 q 583 739 643 650 q 413 828 524 828 q 310 806 356 828 q 229 747 264 783 l 174 826 q 277 899 217 871 q 418 928 338 928 q 563 895 499 928 q 672 802 626 863 q 740 655 717 742 q 764 458 764 568 q 738 261 764 349 q 667 112 713 174 q 557 17 621 50 q 417 -17 493 -17 m 417 83 q 574 163 513 83 q 647 397 636 242 l 196 397 q 264 161 207 239 q 417 83 321 83 z "},"Ӣ":{"ha":833,"x_min":108,"x_max":725,"o":"m 108 0 l 108 911 l 219 911 l 219 439 q 213 292 219 367 q 204 150 207 218 l 207 150 l 294 339 l 597 911 l 725 911 l 725 0 l 614 0 l 614 476 q 620 619 614 547 q 629 761 626 690 l 626 761 l 539 572 l 236 0 l 108 0 m 236 1021 l 236 1100 l 608 1100 l 608 1021 l 236 1021 z "},"Ӧ":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 275 16 339 -17 q 165 110 211 49 q 92 259 118 171 q 67 460 67 347 q 92 657 67 569 q 165 804 118 744 q 275 896 211 864 q 417 928 339 928 q 558 896 493 928 q 669 804 622 864 q 741 657 715 744 q 767 460 767 569 q 741 259 767 347 q 669 110 715 171 q 558 16 622 49 q 417 -17 493 -17 m 417 85 q 511 110 468 85 q 584 185 554 136 q 631 303 614 233 q 647 460 647 372 q 631 614 647 546 q 584 729 614 682 q 511 801 554 776 q 417 826 468 826 q 322 801 364 826 q 249 729 279 776 q 203 614 219 682 q 186 460 186 546 q 203 303 186 372 q 249 185 219 233 q 322 110 279 136 q 417 85 364 85 m 290 993 q 240 1013 260 993 q 219 1064 219 1032 q 240 1115 219 1096 q 290 1133 260 1133 q 340 1115 321 1133 q 360 1064 360 1096 q 340 1013 360 1032 q 290 993 321 993 m 543 993 q 493 1013 513 993 q 474 1064 474 1032 q 493 1115 474 1096 q 543 1133 513 1133 q 594 1115 574 1133 q 614 1064 614 1096 q 594 1013 614 1032 q 543 993 574 993 z "},"Ө":{"ha":833,"x_min":67,"x_max":767,"o":"m 417 -17 q 274 15 339 -17 q 164 108 210 47 q 92 257 118 168 q 67 460 67 346 q 92 660 67 574 q 164 807 118 747 q 274 897 210 867 q 417 928 339 928 q 559 897 494 928 q 669 807 624 867 q 741 660 715 747 q 767 460 767 572 q 741 257 767 346 q 669 108 715 168 q 559 15 624 47 q 417 -17 494 -17 m 417 831 q 258 752 319 831 q 185 526 196 674 l 649 526 q 576 752 638 674 q 417 831 514 831 m 417 81 q 582 171 519 81 q 651 432 644 261 l 182 432 q 251 171 189 261 q 417 81 314 81 z "},"Ӯ":{"ha":833,"x_min":65,"x_max":772,"o":"m 247 -17 q 197 -13 217 -17 q 157 -3 176 -10 l 182 101 q 206 94 193 97 q 240 92 219 92 q 311 109 285 92 q 357 165 338 126 l 376 214 l 65 911 l 189 911 l 358 506 l 428 326 l 433 326 l 499 506 l 654 911 l 772 911 l 474 165 q 387 32 439 81 q 247 -17 335 -17 m 236 1021 l 236 1100 l 608 1100 l 608 1021 l 236 1021 z "},"Ӳ":{"ha":833,"x_min":65,"x_max":772,"o":"m 247 -17 q 197 -13 217 -17 q 157 -3 176 -10 l 182 101 q 206 94 193 97 q 240 92 219 92 q 311 109 285 92 q 357 165 338 126 l 376 214 l 65 911 l 189 911 l 358 506 l 428 326 l 433 326 l 499 506 l 654 911 l 772 911 l 474 165 q 387 32 439 81 q 247 -17 335 -17 m 322 976 l 263 1006 l 390 1217 l 469 1172 l 322 976 m 544 976 l 485 1006 l 614 1217 l 692 1172 l 544 976 z "},"а":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 z "},"б":{"ha":833,"x_min":104,"x_max":738,"o":"m 432 -17 q 293 13 354 -17 q 190 97 232 42 q 126 232 149 153 q 104 410 104 311 q 135 681 104 578 q 222 845 165 785 q 358 933 278 906 q 536 976 438 961 q 588 984 567 981 q 625 992 608 988 q 655 1001 642 996 q 685 1014 668 1006 l 708 910 q 643 883 681 892 q 560 867 606 874 q 417 840 478 854 q 316 792 357 825 q 252 699 275 758 q 221 538 229 639 q 328 622 267 593 q 457 650 390 650 q 571 628 519 650 q 659 566 622 607 q 717 467 696 525 q 738 335 738 408 q 715 189 738 254 q 651 78 692 124 q 553 8 610 32 q 432 -17 497 -17 m 431 78 q 570 149 521 78 q 619 335 619 219 q 570 501 619 439 q 429 563 521 563 q 322 537 376 563 q 215 440 267 511 l 215 388 q 228 260 215 318 q 269 163 242 203 q 336 100 296 122 q 431 78 376 78 z "},"в":{"ha":833,"x_min":144,"x_max":749,"o":"m 144 0 l 144 675 l 457 675 q 564 665 515 675 q 647 635 613 656 q 700 583 681 615 q 719 504 719 550 q 688 412 719 447 q 601 360 656 376 l 601 356 q 658 336 631 349 q 705 303 685 324 q 737 256 725 283 q 749 193 749 229 q 728 107 749 143 q 669 47 707 71 q 581 11 632 22 q 468 0 529 0 l 144 0 m 257 394 l 438 394 q 569 420 529 394 q 608 493 608 446 q 570 562 608 540 q 446 583 532 583 l 257 583 l 257 394 m 257 92 l 456 92 q 591 117 547 92 q 635 200 635 143 q 449 306 635 306 l 257 306 l 257 92 z "},"г":{"ha":833,"x_min":203,"x_max":726,"o":"m 203 0 l 203 675 l 726 675 l 726 582 l 317 582 l 317 0 l 203 0 z "},"д":{"ha":833,"x_min":58,"x_max":774,"o":"m 286 354 q 256 192 275 254 q 213 93 238 129 l 561 93 l 561 582 l 313 582 l 286 354 m 71 -239 l 58 21 l 58 93 l 92 93 q 119 116 106 101 q 143 161 132 131 q 165 243 154 192 q 186 376 176 294 l 222 675 l 675 675 l 675 93 l 774 93 l 774 21 l 761 -239 l 663 -239 l 663 0 l 168 0 l 168 -239 l 71 -239 z "},"е":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 z "},"ж":{"ha":833,"x_min":8,"x_max":825,"o":"m 8 0 l 192 364 l 144 493 q 101 565 124 549 q 57 581 79 581 q 45 581 50 581 q 33 578 40 581 l 17 685 q 35 690 24 689 q 58 692 46 692 q 153 663 113 692 q 226 550 194 633 l 285 394 l 361 394 l 361 675 l 472 675 l 472 394 l 549 394 l 607 550 q 680 663 639 633 q 775 692 721 692 q 817 685 800 692 l 800 578 q 788 581 793 581 q 776 581 783 581 q 731 565 753 581 q 689 493 710 549 l 642 364 l 825 0 l 706 0 l 560 306 l 472 306 l 472 0 l 361 0 l 361 306 l 274 306 l 128 0 l 8 0 z "},"з":{"ha":833,"x_min":86,"x_max":713,"o":"m 389 -17 q 232 5 306 -17 q 86 85 158 26 l 136 160 q 256 93 194 111 q 379 75 317 75 q 542 106 485 75 q 599 196 599 138 q 545 280 599 254 q 390 306 492 306 l 274 306 l 274 394 l 374 394 q 519 422 471 394 q 567 499 567 449 q 381 601 567 601 q 255 583 307 601 q 150 525 203 564 l 103 601 q 230 668 161 644 q 388 692 299 692 q 505 681 451 692 q 597 647 558 669 q 658 590 636 625 q 679 510 679 556 q 649 422 679 460 q 558 360 619 383 l 558 354 q 670 298 628 336 q 713 186 713 260 q 689 100 713 138 q 623 36 665 63 q 521 -3 581 10 q 389 -17 461 -17 z "},"и":{"ha":833,"x_min":139,"x_max":694,"o":"m 139 0 l 139 675 l 250 675 l 250 394 q 246 276 250 340 q 239 146 242 211 l 244 146 q 289 218 264 178 q 333 290 314 258 l 589 675 l 694 675 l 694 0 l 583 0 l 583 281 q 588 399 583 335 q 594 531 592 464 l 589 531 q 544 458 569 499 q 500 386 519 417 l 244 0 l 139 0 z "},"й":{"ha":833,"x_min":139,"x_max":694,"o":"m 139 0 l 139 675 l 250 675 l 250 394 q 246 276 250 340 q 239 146 242 211 l 244 146 q 289 218 264 178 q 333 290 314 258 l 589 675 l 694 675 l 694 0 l 583 0 l 583 281 q 588 399 583 335 q 594 531 592 464 l 589 531 q 544 458 569 499 q 500 386 519 417 l 244 0 l 139 0 m 432 794 q 333 812 374 794 q 267 858 293 829 q 228 924 240 886 q 214 1001 215 961 l 308 1007 q 316 951 310 978 q 337 904 322 924 q 374 873 351 885 q 432 861 397 861 q 490 873 467 861 q 527 904 513 885 q 548 951 542 924 q 556 1007 554 978 l 650 1001 q 635 924 647 961 q 597 858 624 886 q 531 812 571 829 q 432 794 490 794 z "},"к":{"ha":833,"x_min":153,"x_max":778,"o":"m 153 0 l 153 675 l 267 675 l 267 397 l 444 397 l 526 547 q 569 618 549 590 q 611 663 590 646 q 655 685 632 679 q 706 692 678 692 q 750 683 733 692 l 731 576 q 717 580 724 579 q 703 581 711 581 q 679 577 690 581 q 657 563 668 574 q 633 535 646 553 q 606 489 621 518 l 532 354 l 778 0 l 651 0 l 444 304 l 267 304 l 267 0 l 153 0 z "},"л":{"ha":833,"x_min":40,"x_max":689,"o":"m 103 -17 q 69 -14 83 -17 q 40 -6 56 -11 l 63 100 q 76 96 69 97 q 93 94 83 94 q 151 128 129 94 q 183 238 174 163 q 210 456 197 347 q 235 675 222 565 l 689 675 l 689 0 l 574 0 l 574 582 l 325 582 q 303 395 314 489 q 281 208 292 301 q 103 -17 251 -17 z "},"м":{"ha":833,"x_min":89,"x_max":744,"o":"m 89 0 l 89 675 l 228 675 l 356 358 q 386 276 371 317 q 415 194 401 236 l 421 194 q 451 276 436 236 q 481 358 467 317 l 606 675 l 744 675 l 744 0 l 636 0 l 636 303 q 638 355 636 325 q 641 416 639 385 q 645 478 643 447 q 650 536 647 510 l 644 536 q 614 454 629 496 q 583 375 599 413 l 461 64 l 375 64 l 247 375 q 218 454 232 413 q 189 536 204 496 l 183 536 q 188 478 185 510 q 192 416 190 447 q 196 355 194 385 q 197 303 197 325 l 197 0 l 89 0 z "},"н":{"ha":833,"x_min":129,"x_max":704,"o":"m 129 0 l 129 675 l 243 675 l 243 401 l 590 401 l 590 675 l 704 675 l 704 0 l 590 0 l 590 300 l 243 300 l 243 0 l 129 0 z "},"о":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 z "},"п":{"ha":833,"x_min":129,"x_max":704,"o":"m 129 0 l 129 675 l 704 675 l 704 0 l 590 0 l 590 582 l 243 582 l 243 0 l 129 0 z "},"р":{"ha":833,"x_min":129,"x_max":750,"o":"m 129 -285 l 129 675 l 224 675 l 233 589 l 238 589 q 347 663 285 633 q 471 692 408 692 q 591 667 539 692 q 678 598 643 643 q 732 490 714 553 q 750 347 750 426 q 725 194 750 261 q 658 79 700 126 q 560 8 615 32 q 443 -17 504 -17 q 341 6 396 -17 q 242 71 286 29 l 238 71 l 243 -57 l 243 -285 l 129 -285 m 424 79 q 574 150 515 79 q 632 347 632 221 q 621 449 632 403 q 587 527 610 494 q 528 578 564 560 q 442 596 492 596 q 347 572 397 596 q 243 494 296 547 l 243 158 q 340 97 292 115 q 424 79 389 79 z "},"с":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 334 7 401 -17 q 217 76 267 31 q 139 187 167 121 q 111 336 111 253 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 624 11 692 39 q 481 -17 556 -17 z "},"т":{"ha":833,"x_min":92,"x_max":742,"o":"m 360 0 l 360 582 l 92 582 l 92 675 l 742 675 l 742 582 l 474 582 l 474 0 l 360 0 z "},"у":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 z "},"ф":{"ha":833,"x_min":44,"x_max":789,"o":"m 361 -285 l 361 -69 l 364 33 q 314 -1 340 14 q 253 -17 288 -17 q 101 75 158 -17 q 44 336 44 167 q 62 484 44 418 q 108 596 79 550 q 174 667 136 642 q 253 692 211 692 q 314 677 288 692 q 364 642 340 663 l 361 744 l 361 989 l 472 989 l 472 744 l 469 639 q 526 677 494 663 q 592 692 558 692 q 676 667 639 692 q 738 598 713 643 q 776 490 763 553 q 789 347 789 426 q 772 194 789 261 q 726 79 754 126 q 659 8 697 32 q 579 -17 621 -17 q 523 -2 551 -17 q 469 33 494 13 l 472 -69 l 472 -285 l 361 -285 m 279 79 q 364 128 324 79 l 364 550 q 274 596 322 596 q 190 524 221 596 q 158 336 158 453 q 188 147 158 215 q 279 79 217 79 m 557 79 q 644 150 614 79 q 675 347 675 221 q 669 449 675 403 q 651 527 664 494 q 615 578 638 560 q 561 596 593 596 q 469 549 515 596 l 469 125 q 516 90 493 100 q 557 79 539 79 z "},"х":{"ha":833,"x_min":89,"x_max":743,"o":"m 89 0 l 346 350 l 108 675 l 235 675 l 342 526 q 380 469 360 499 q 421 413 400 440 l 426 413 q 465 471 446 440 q 503 529 485 501 l 604 675 l 725 675 l 485 340 l 743 0 l 618 0 l 500 156 q 456 217 479 185 q 411 278 433 249 l 406 278 q 364 217 385 247 q 322 156 343 188 l 211 0 l 89 0 z "},"ц":{"ha":833,"x_min":131,"x_max":789,"o":"m 131 0 l 131 675 l 244 675 l 244 93 l 576 93 l 576 675 l 690 675 l 690 93 l 789 93 l 789 21 l 778 -239 l 679 -239 l 679 0 l 131 0 z "},"ч":{"ha":833,"x_min":122,"x_max":681,"o":"m 567 0 l 567 272 q 528 265 546 268 q 494 259 511 261 q 458 256 478 257 q 413 256 439 256 q 289 269 343 256 q 198 313 235 283 q 142 390 161 343 q 122 506 122 438 l 122 675 l 236 675 l 236 506 q 284 385 236 421 q 436 349 332 349 q 501 353 472 349 q 567 365 531 357 l 567 675 l 681 675 l 681 0 l 567 0 z "},"ш":{"ha":833,"x_min":81,"x_max":753,"o":"m 81 0 l 81 675 l 194 675 l 194 93 l 364 93 l 364 675 l 469 675 l 469 93 l 639 93 l 639 675 l 753 675 l 753 0 l 81 0 z "},"щ":{"ha":833,"x_min":81,"x_max":825,"o":"m 81 0 l 81 675 l 194 675 l 194 93 l 358 93 l 358 675 l 464 675 l 464 93 l 628 93 l 628 675 l 742 675 l 742 93 l 825 93 l 825 21 l 814 -239 l 724 -239 l 724 0 l 81 0 z "},"ъ":{"ha":833,"x_min":49,"x_max":765,"o":"m 279 0 l 279 582 l 49 582 l 49 675 l 393 675 l 393 426 l 496 426 q 691 376 617 426 q 765 215 765 325 q 691 51 765 103 q 496 0 617 0 l 279 0 m 393 92 l 485 92 q 653 215 653 92 q 612 308 653 279 q 485 338 571 338 l 393 338 l 393 92 z "},"ы":{"ha":833,"x_min":97,"x_max":736,"o":"m 97 0 l 97 675 l 201 675 l 201 426 l 296 426 q 476 376 408 426 q 544 215 544 326 q 476 51 544 103 q 296 0 408 0 l 97 0 m 201 92 l 285 92 q 443 215 443 92 q 404 308 443 279 q 285 338 365 338 l 201 338 l 201 92 m 632 0 l 632 675 l 736 675 l 736 0 l 632 0 z "},"ь":{"ha":833,"x_min":174,"x_max":719,"o":"m 174 0 l 174 675 l 289 675 l 289 426 l 446 426 q 558 414 507 426 q 644 376 608 401 q 700 310 681 350 q 719 215 719 271 q 700 118 719 158 q 644 51 681 78 q 558 13 608 25 q 446 0 507 0 l 174 0 m 289 92 l 433 92 q 607 215 607 92 q 565 308 607 279 q 433 338 522 338 l 289 338 l 289 92 z "},"э":{"ha":833,"x_min":85,"x_max":722,"o":"m 356 -17 q 207 9 276 -17 q 85 83 138 35 l 133 154 q 226 97 172 118 q 344 75 281 75 q 532 132 461 75 q 611 306 603 189 l 263 306 l 263 394 l 608 394 q 524 550 593 499 q 356 601 456 601 q 240 581 289 601 q 153 526 192 560 l 99 596 q 207 664 143 636 q 363 692 271 692 q 501 670 436 692 q 616 605 567 649 q 694 494 665 561 q 722 336 722 426 q 694 181 722 247 q 618 72 667 115 q 502 6 569 28 q 356 -17 435 -17 z "},"ю":{"ha":833,"x_min":61,"x_max":783,"o":"m 533 -17 q 365 61 433 -17 q 288 296 296 139 l 175 296 l 175 0 l 61 0 l 61 675 l 175 675 l 175 397 l 289 397 q 369 619 301 546 q 533 692 436 692 q 633 670 588 692 q 713 604 679 649 q 765 493 746 560 q 783 336 783 426 q 765 181 783 247 q 713 70 746 114 q 633 5 679 26 q 533 -17 588 -17 m 531 78 q 630 141 593 78 q 667 336 667 204 q 630 533 667 469 q 531 597 593 597 q 427 533 465 597 q 389 336 389 469 q 427 141 389 204 q 531 78 465 78 z "},"я":{"ha":833,"x_min":76,"x_max":696,"o":"m 581 0 l 581 264 l 397 264 l 206 0 l 76 0 l 278 272 q 157 338 207 289 q 107 475 107 388 q 126 569 107 531 q 180 631 146 607 q 261 665 214 654 q 363 675 308 675 l 696 675 l 696 0 l 581 0 m 382 353 l 581 353 l 581 583 l 382 583 q 263 558 306 583 q 221 472 221 533 q 263 383 221 413 q 382 353 306 353 z "},"ѐ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 468 789 l 250 1001 l 331 1079 l 528 846 l 468 789 z "},"ё":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 304 817 q 249 839 271 817 q 228 894 228 861 q 249 949 228 926 q 304 972 271 972 q 359 949 338 972 q 381 894 381 926 q 359 839 381 861 q 304 817 338 817 m 574 817 q 519 839 540 817 q 497 894 497 861 q 519 949 497 926 q 574 972 540 972 q 628 949 607 972 q 650 894 650 926 q 628 839 650 861 q 574 817 607 817 z "},"ђ":{"ha":833,"x_min":28,"x_max":747,"o":"m 464 -301 q 416 -296 438 -301 q 379 -283 394 -290 l 401 -197 q 427 -205 413 -201 q 457 -208 442 -208 q 525 -189 493 -208 q 580 -121 557 -169 q 616 12 603 -72 q 629 225 629 96 q 582 487 629 408 q 442 565 535 565 q 345 535 389 565 q 243 443 301 506 l 243 0 l 129 0 l 129 783 l 28 783 l 28 863 l 129 869 l 129 989 l 243 989 l 243 869 l 539 869 l 539 783 l 243 783 l 243 692 l 236 533 l 240 533 q 347 626 290 589 q 478 664 404 664 q 678 558 608 664 q 747 238 747 451 q 728 -23 747 81 q 672 -188 708 -126 q 582 -276 635 -250 q 464 -301 529 -301 z "},"ѓ":{"ha":833,"x_min":203,"x_max":726,"o":"m 203 0 l 203 675 l 726 675 l 726 582 l 317 582 l 317 0 l 203 0 m 456 789 l 396 846 l 593 1079 l 674 1001 l 456 789 z "},"є":{"ha":833,"x_min":111,"x_max":749,"o":"m 481 -17 q 333 6 401 -17 q 216 72 265 28 q 139 181 167 115 q 111 336 111 247 q 141 492 111 425 q 222 603 171 560 q 342 669 274 647 q 488 692 411 692 q 631 665 571 692 q 735 599 690 639 l 681 526 q 593 581 640 561 q 488 601 546 601 q 313 549 383 601 q 225 394 242 497 l 590 394 l 590 306 l 222 306 q 301 133 231 190 q 490 75 372 75 q 608 98 554 75 q 701 156 661 121 l 749 83 q 624 9 693 35 q 481 -17 556 -17 z "},"ѕ":{"ha":833,"x_min":99,"x_max":731,"o":"m 431 -17 q 246 15 331 -17 q 99 89 161 46 l 151 164 q 280 97 210 122 q 444 72 350 72 q 573 103 531 72 q 615 178 615 135 q 608 214 615 197 q 578 246 601 231 q 514 275 556 261 q 404 303 472 289 q 206 377 272 331 q 140 500 140 424 q 158 576 140 540 q 212 637 176 611 q 299 677 247 663 q 421 692 351 692 q 571 666 499 692 q 693 606 643 640 l 638 532 q 533 583 590 564 q 411 603 476 603 q 290 574 325 603 q 256 506 256 544 q 301 438 256 461 q 451 393 347 415 q 590 355 536 375 q 676 310 644 335 q 719 254 707 285 q 731 185 731 224 q 711 107 731 143 q 653 43 692 71 q 559 -1 615 15 q 431 -17 503 -17 z "},"і":{"ha":833,"x_min":125,"x_max":575,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"ї":{"ha":833,"x_min":125,"x_max":694,"o":"m 439 0 l 439 582 l 125 582 l 125 675 l 553 675 l 553 0 l 439 0 m 349 817 q 294 839 315 817 q 272 894 272 861 q 294 949 272 926 q 349 972 315 972 q 403 949 382 972 q 425 894 425 926 q 403 839 425 861 q 349 817 382 817 m 618 817 q 563 839 585 817 q 542 894 542 861 q 563 949 542 926 q 618 972 585 972 q 673 949 651 972 q 694 894 694 926 q 673 839 694 861 q 618 817 651 817 z "},"ј":{"ha":833,"x_min":76,"x_max":575,"o":"m 269 -301 q 167 -288 217 -301 q 76 -256 117 -275 l 114 -171 q 190 -199 150 -189 q 268 -208 229 -208 q 351 -196 318 -208 q 404 -160 385 -183 q 431 -102 424 -136 q 439 -25 439 -68 l 439 582 l 125 582 l 125 675 l 553 675 l 553 -17 q 539 -131 553 -79 q 492 -222 525 -183 q 406 -281 460 -260 q 269 -301 351 -301 m 483 817 q 418 841 444 817 q 392 906 392 865 q 418 970 392 946 q 483 994 444 994 q 549 970 522 994 q 575 906 575 946 q 549 841 575 865 q 483 817 522 817 z "},"љ":{"ha":833,"x_min":-10,"x_max":772,"o":"m 51 -17 q 19 -14 32 -17 q -10 -6 6 -11 l 11 100 q 24 96 18 97 q 39 94 31 94 q 89 127 67 94 q 122 238 111 160 q 145 453 138 346 q 158 675 153 560 l 500 675 l 500 426 l 521 426 q 703 376 633 426 q 772 215 772 325 q 703 51 772 103 q 521 0 633 0 l 389 0 l 389 582 l 256 582 q 243 390 250 489 q 222 192 236 292 q 161 34 207 85 q 51 -17 115 -17 m 500 92 l 508 92 q 631 122 593 92 q 669 215 669 151 q 631 308 669 279 q 508 338 593 338 l 500 338 l 500 92 z "},"њ":{"ha":833,"x_min":81,"x_max":767,"o":"m 81 0 l 81 675 l 192 675 l 192 401 l 369 401 l 369 675 l 481 675 l 481 426 l 518 426 q 700 376 633 426 q 767 215 767 326 q 700 51 767 103 q 518 0 633 0 l 369 0 l 369 300 l 192 300 l 192 0 l 81 0 m 481 92 l 506 92 q 626 121 588 92 q 664 215 664 150 q 626 309 664 281 q 506 338 588 338 l 481 338 l 481 92 z "},"ћ":{"ha":833,"x_min":28,"x_max":726,"o":"m 129 0 l 129 781 l 28 781 l 28 861 l 129 869 l 129 989 l 243 989 l 243 869 l 539 869 l 539 781 l 243 781 l 243 692 l 236 532 l 240 532 q 353 626 293 589 q 493 664 414 664 q 670 595 614 664 q 726 392 726 526 l 726 0 l 613 0 l 613 376 q 576 519 613 472 q 457 565 540 565 q 401 558 426 565 q 350 535 375 550 q 299 497 325 519 q 243 443 272 474 l 243 0 l 129 0 z "},"ќ":{"ha":833,"x_min":153,"x_max":778,"o":"m 153 0 l 153 675 l 267 675 l 267 397 l 444 397 l 526 547 q 569 618 549 590 q 611 663 590 646 q 655 685 632 679 q 706 692 678 692 q 750 683 733 692 l 731 576 q 717 580 724 579 q 703 581 711 581 q 679 577 690 581 q 657 563 668 574 q 633 535 646 553 q 606 489 621 518 l 532 354 l 778 0 l 651 0 l 444 304 l 267 304 l 267 0 l 153 0 m 415 789 l 356 846 l 553 1079 l 633 1001 l 415 789 z "},"ѝ":{"ha":833,"x_min":139,"x_max":694,"o":"m 139 0 l 139 675 l 250 675 l 250 394 q 246 276 250 340 q 239 146 242 211 l 244 146 q 289 218 264 178 q 333 290 314 258 l 589 675 l 694 675 l 694 0 l 583 0 l 583 281 q 588 399 583 335 q 594 531 592 464 l 589 531 q 544 458 569 499 q 500 386 519 417 l 244 0 l 139 0 m 461 789 l 243 1001 l 324 1079 l 521 846 l 461 789 z "},"ў":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 422 794 q 324 812 364 794 q 257 858 283 829 q 218 924 231 886 q 204 1001 206 961 l 299 1007 q 306 951 300 978 q 327 904 313 924 q 365 873 342 885 q 422 861 388 861 q 480 873 457 861 q 517 904 503 885 q 538 951 532 924 q 546 1007 544 978 l 640 1001 q 626 924 638 961 q 588 858 614 886 q 521 812 561 829 q 422 794 481 794 z "},"џ":{"ha":833,"x_min":143,"x_max":690,"o":"m 143 0 l 143 675 l 257 675 l 257 93 l 576 93 l 576 675 l 690 675 l 690 0 l 476 0 l 464 -239 l 367 -239 l 363 0 l 143 0 z "},"ѣ":{"ha":833,"x_min":57,"x_max":757,"o":"m 269 0 l 269 610 l 57 610 l 57 703 l 269 703 l 269 864 l 383 864 l 383 703 l 638 703 l 638 610 l 383 610 l 383 426 l 489 426 q 598 414 549 426 q 683 376 647 401 q 738 310 718 350 q 757 215 757 271 q 738 118 757 158 q 683 51 718 78 q 598 13 647 25 q 489 0 549 0 l 269 0 m 383 92 l 476 92 q 646 215 646 92 q 604 308 646 279 q 476 338 563 338 l 383 338 l 383 92 z "},"ѳ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 6 350 -17 q 183 72 229 28 q 110 183 138 117 q 83 336 83 249 q 110 490 83 424 q 183 602 138 557 q 290 669 229 647 q 417 692 350 692 q 544 669 483 692 q 650 602 604 647 q 723 490 696 557 q 750 336 750 424 q 723 183 750 249 q 650 72 696 117 q 544 6 604 28 q 417 -17 483 -17 m 417 603 q 270 549 329 603 q 196 394 211 494 l 638 394 q 563 549 622 494 q 417 603 504 603 m 417 74 q 572 134 511 74 q 640 306 632 194 l 193 306 q 262 134 201 194 q 417 74 322 74 z "},"ѵ":{"ha":833,"x_min":97,"x_max":778,"o":"m 346 0 l 97 675 l 214 675 l 349 292 q 381 192 364 243 q 413 93 397 142 l 418 93 q 445 192 431 142 q 475 292 460 242 l 542 497 q 571 584 556 547 q 606 644 586 621 q 651 680 626 668 q 711 692 676 692 q 747 689 732 692 q 778 679 761 686 l 754 576 q 721 585 742 585 q 675 560 692 585 q 642 483 658 535 l 486 0 l 346 0 z "},"ґ":{"ha":833,"x_min":225,"x_max":699,"o":"m 225 0 l 225 675 l 585 675 l 607 914 l 699 914 l 688 582 l 339 582 l 339 0 l 225 0 z "},"ғ":{"ha":833,"x_min":100,"x_max":726,"o":"m 203 0 l 203 286 l 100 286 l 100 364 l 203 372 l 203 675 l 726 675 l 726 582 l 317 582 l 317 372 l 556 372 l 556 286 l 317 286 l 317 0 l 203 0 z "},"җ":{"ha":833,"x_min":8,"x_max":843,"o":"m 751 -239 l 751 0 l 706 0 l 560 306 l 472 306 l 472 0 l 361 0 l 361 306 l 274 306 l 128 0 l 8 0 l 192 364 l 144 493 q 101 565 124 549 q 57 581 79 581 q 45 581 50 581 q 33 578 40 581 l 17 685 q 35 690 24 689 q 58 692 46 692 q 153 663 113 692 q 226 550 194 633 l 285 394 l 361 394 l 361 675 l 472 675 l 472 394 l 549 394 l 607 550 q 680 663 639 633 q 775 692 721 692 q 817 685 800 692 l 800 578 q 788 581 793 581 q 776 581 783 581 q 731 565 753 581 q 689 493 710 549 l 642 364 l 778 93 l 843 93 l 843 21 l 832 -239 l 751 -239 z "},"ҙ":{"ha":833,"x_min":86,"x_max":713,"o":"m 347 -239 l 342 -15 q 211 13 274 -10 q 86 85 149 35 l 136 160 q 256 93 194 111 q 379 75 317 75 q 542 106 485 75 q 599 196 599 138 q 545 280 599 254 q 390 306 492 306 l 274 306 l 274 394 l 374 394 q 519 422 471 394 q 567 499 567 449 q 381 601 567 601 q 255 583 307 601 q 150 525 203 564 l 103 601 q 230 668 161 644 q 388 692 299 692 q 505 681 451 692 q 597 647 558 669 q 658 590 636 625 q 679 510 679 556 q 649 422 679 460 q 558 360 619 383 l 558 354 q 670 298 628 336 q 713 186 713 260 q 643 49 713 100 q 456 -14 574 -3 l 443 -239 l 347 -239 z "},"қ":{"ha":833,"x_min":153,"x_max":796,"o":"m 697 -239 l 697 0 l 651 0 l 444 304 l 267 304 l 267 0 l 153 0 l 153 675 l 267 675 l 267 397 l 444 397 l 526 547 q 569 618 549 590 q 611 663 590 646 q 655 685 632 679 q 706 692 678 692 q 750 683 733 692 l 731 576 q 717 580 724 579 q 703 581 711 581 q 679 577 690 581 q 657 563 668 574 q 633 535 646 553 q 606 489 621 518 l 532 354 l 713 93 l 796 93 l 796 21 l 785 -239 l 697 -239 z "},"ҡ":{"ha":833,"x_min":46,"x_max":808,"o":"m 281 0 l 281 582 l 46 582 l 46 675 l 385 675 l 385 397 l 517 397 l 575 547 q 610 620 592 592 q 650 665 629 649 q 694 686 671 681 q 742 692 717 692 q 782 685 764 692 l 761 578 q 750 581 754 581 q 739 581 746 581 q 695 565 715 581 q 651 489 675 549 l 597 349 l 808 0 l 699 0 l 517 304 l 385 304 l 385 0 l 281 0 z "},"ң":{"ha":833,"x_min":129,"x_max":789,"o":"m 129 0 l 129 675 l 243 675 l 243 401 l 576 401 l 576 675 l 690 675 l 690 93 l 789 93 l 789 21 l 778 -239 l 679 -239 l 679 0 l 576 0 l 576 300 l 243 300 l 243 0 l 129 0 z "},"ҫ":{"ha":833,"x_min":111,"x_max":749,"o":"m 421 -239 l 417 -12 q 294 24 350 -4 q 197 96 238 51 q 134 201 157 140 q 111 336 111 261 q 141 487 111 421 q 222 599 171 553 q 342 668 274 644 q 488 692 411 692 q 631 663 571 692 q 733 593 692 633 l 676 519 q 590 576 635 556 q 492 597 544 597 q 385 578 433 597 q 302 525 336 560 q 249 442 268 490 q 229 336 229 394 q 248 231 229 278 q 301 149 267 183 q 383 97 335 115 q 489 78 431 78 q 603 102 551 78 q 697 163 656 126 l 749 89 q 647 21 701 47 q 529 -14 592 -6 l 517 -239 l 421 -239 z "},"ү":{"ha":833,"x_min":71,"x_max":763,"o":"m 364 -285 l 364 -8 l 71 675 l 188 675 l 340 301 q 381 199 361 250 q 418 100 400 147 l 424 100 q 460 199 442 147 q 499 301 478 250 l 651 675 l 763 675 l 478 -8 l 478 -285 l 364 -285 z "},"ұ":{"ha":833,"x_min":71,"x_max":763,"o":"m 139 0 l 139 78 l 247 86 l 326 86 l 71 675 l 188 675 l 340 301 q 381 199 361 250 q 418 100 400 147 l 424 100 q 460 199 442 147 q 499 301 478 250 l 651 675 l 763 675 l 514 86 l 694 86 l 694 0 l 478 0 l 478 -285 l 364 -285 l 364 0 l 139 0 z "},"ҳ":{"ha":833,"x_min":89,"x_max":778,"o":"m 668 -239 l 668 0 l 618 0 l 500 156 q 456 217 479 185 q 411 278 433 249 l 406 278 q 364 217 385 247 q 322 156 343 188 l 211 0 l 89 0 l 346 350 l 108 675 l 235 675 l 342 526 q 380 469 360 499 q 421 413 400 440 l 426 413 q 465 471 446 440 q 503 529 485 501 l 604 675 l 725 675 l 485 340 l 672 93 l 778 93 l 778 21 l 767 -239 l 668 -239 z "},"ҷ":{"ha":833,"x_min":122,"x_max":771,"o":"m 558 0 l 558 272 q 522 265 538 268 q 489 259 506 261 q 453 256 472 257 q 408 256 435 256 q 197 312 272 256 q 122 500 122 368 l 122 675 l 236 675 l 236 500 q 283 384 236 419 q 432 349 329 349 q 495 353 467 349 q 558 365 524 357 l 558 675 l 672 675 l 672 93 l 771 93 l 771 21 l 760 -239 l 661 -239 l 661 0 l 558 0 z "},"һ":{"ha":833,"x_min":129,"x_max":726,"o":"m 129 0 l 129 989 l 243 989 l 243 719 l 236 560 l 240 560 q 353 654 293 617 q 493 692 414 692 q 670 623 614 692 q 726 419 726 554 l 726 0 l 613 0 l 613 404 q 576 547 613 500 q 457 593 540 593 q 401 585 426 593 q 350 563 375 578 q 299 524 325 547 q 243 471 272 501 l 243 0 l 129 0 z "},"ӂ":{"ha":833,"x_min":8,"x_max":825,"o":"m 8 0 l 192 364 l 144 493 q 101 565 124 549 q 57 581 79 581 q 45 581 50 581 q 33 578 40 581 l 17 685 q 35 690 24 689 q 58 692 46 692 q 153 663 113 692 q 226 550 194 633 l 285 394 l 361 394 l 361 675 l 472 675 l 472 394 l 549 394 l 607 550 q 680 663 639 633 q 775 692 721 692 q 817 685 800 692 l 800 578 q 788 581 793 581 q 776 581 783 581 q 731 565 753 581 q 689 493 710 549 l 642 364 l 825 0 l 706 0 l 560 306 l 472 306 l 472 0 l 361 0 l 361 306 l 274 306 l 128 0 l 8 0 m 417 794 q 318 812 358 794 q 251 858 278 829 q 213 924 225 886 q 199 1001 200 961 l 293 1007 q 301 951 294 978 q 322 904 307 924 q 359 873 336 885 q 417 861 382 861 q 474 873 451 861 q 512 904 497 885 q 533 951 526 924 q 540 1007 539 978 l 635 1001 q 620 924 632 961 q 582 858 608 886 q 515 812 556 829 q 417 794 475 794 z "},"ӏ":{"ha":833,"x_min":103,"x_max":746,"o":"m 565 -17 q 400 44 457 -17 q 343 226 343 106 l 343 896 l 103 896 l 103 989 l 457 989 l 457 218 q 493 110 457 143 q 590 78 529 78 q 717 108 650 78 l 746 24 q 660 -6 699 4 q 565 -17 621 -17 z "},"ӑ":{"ha":833,"x_min":113,"x_max":715,"o":"m 342 -17 q 253 -3 294 -17 q 180 34 211 10 q 131 94 149 58 q 113 175 113 129 q 140 274 113 232 q 226 347 167 317 q 378 397 285 378 q 601 428 471 417 q 590 493 600 463 q 560 547 581 524 q 505 583 539 569 q 422 597 471 597 q 294 572 356 597 q 186 517 233 546 l 142 594 q 201 628 167 611 q 273 660 235 646 q 354 683 311 674 q 442 692 397 692 q 648 616 581 692 q 715 414 715 540 l 715 0 l 622 0 l 613 92 l 608 92 q 483 15 551 47 q 342 -17 414 -17 m 372 75 q 487 101 431 75 q 601 175 543 126 l 601 353 q 420 329 493 344 q 303 292 347 314 q 242 244 260 271 q 224 183 224 217 q 236 134 224 154 q 269 101 249 114 q 316 81 289 88 q 372 75 343 75 m 444 794 q 346 812 386 794 q 279 858 306 829 q 240 924 253 886 q 226 1001 228 961 l 321 1007 q 328 951 322 978 q 349 904 335 924 q 387 873 364 885 q 444 861 410 861 q 502 873 479 861 q 540 904 525 885 q 560 951 554 924 q 568 1007 567 978 l 663 1001 q 648 924 660 961 q 610 858 636 886 q 543 812 583 829 q 444 794 503 794 z "},"ӕ":{"ha":833,"x_min":24,"x_max":829,"o":"m 201 -17 q 74 32 124 -17 q 24 167 24 81 q 105 333 24 269 q 369 419 186 396 q 333 558 367 518 q 247 597 300 597 q 163 581 206 597 q 89 542 121 564 l 46 619 q 142 669 88 647 q 257 692 197 692 q 361 660 318 692 q 428 553 404 628 q 514 660 463 628 q 622 692 565 692 q 714 667 675 692 q 778 599 753 642 q 817 501 804 557 q 829 383 829 446 q 828 344 829 364 q 824 306 826 324 l 461 306 q 511 138 467 199 q 635 76 556 76 q 706 89 674 76 q 767 121 739 101 l 808 43 q 728 1 774 18 q 631 -17 683 -17 q 508 15 560 -17 q 422 104 456 46 q 319 15 374 46 q 201 -17 264 -17 m 232 75 q 314 99 271 75 q 393 171 357 124 q 369 336 369 246 l 369 346 q 253 319 299 335 q 179 282 207 303 q 140 235 151 261 q 129 178 129 208 q 158 102 129 129 q 232 75 186 75 m 615 601 q 518 554 563 601 q 463 394 474 507 l 736 394 q 615 601 731 601 z "},"ӗ":{"ha":833,"x_min":94,"x_max":747,"o":"m 458 -17 q 316 7 382 -17 q 201 76 250 31 q 123 188 151 122 q 94 339 94 254 q 123 486 94 421 q 199 597 151 551 q 309 667 247 643 q 439 692 371 692 q 569 669 511 692 q 666 604 626 646 q 726 504 706 563 q 747 375 747 446 q 746 338 747 356 q 742 306 744 319 l 210 306 q 294 133 221 190 q 472 75 367 75 q 583 92 533 75 q 678 139 632 110 l 719 64 q 605 7 669 31 q 458 -17 540 -17 m 442 601 q 362 588 400 601 q 293 548 324 574 q 242 483 263 522 q 213 394 221 444 l 643 394 q 583 550 636 499 q 442 601 529 601 m 439 794 q 340 812 381 794 q 274 858 300 829 q 235 924 247 886 q 221 1001 222 961 l 315 1007 q 323 951 317 978 q 344 904 329 924 q 381 873 358 885 q 439 861 404 861 q 497 873 474 861 q 534 904 519 885 q 555 951 549 924 q 563 1007 561 978 l 657 1001 q 642 924 654 961 q 604 858 631 886 q 538 812 578 829 q 439 794 497 794 z "},"ә":{"ha":833,"x_min":96,"x_max":746,"o":"m 413 -17 q 277 8 336 -17 q 178 75 218 32 q 117 178 138 118 q 96 311 96 239 q 97 349 96 329 q 101 381 99 368 l 631 381 q 556 546 619 490 q 388 601 492 601 q 276 584 326 601 q 181 538 226 567 l 139 613 q 254 668 190 644 q 400 692 318 692 q 540 667 476 692 q 650 598 604 643 q 721 488 696 553 q 746 339 746 422 q 720 188 746 254 q 649 76 694 122 q 543 7 604 31 q 413 -17 482 -17 m 410 75 q 560 129 501 75 q 631 292 619 183 l 199 292 q 260 129 206 183 q 410 75 315 75 z "},"ӣ":{"ha":833,"x_min":139,"x_max":694,"o":"m 139 0 l 139 675 l 250 675 l 250 394 q 246 276 250 340 q 239 146 242 211 l 244 146 q 289 218 264 178 q 333 290 314 258 l 589 675 l 694 675 l 694 0 l 583 0 l 583 281 q 588 399 583 335 q 594 531 592 464 l 589 531 q 544 458 569 499 q 500 386 519 417 l 244 0 l 139 0 m 247 835 l 247 914 l 617 914 l 617 835 l 247 835 z "},"ӧ":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 7 350 -17 q 183 76 229 31 q 110 187 138 121 q 83 336 83 253 q 110 487 83 421 q 183 599 138 553 q 290 668 229 644 q 417 692 350 692 q 544 668 483 692 q 650 599 604 644 q 723 487 696 553 q 750 336 750 421 q 723 187 750 253 q 650 76 696 121 q 544 7 604 31 q 417 -17 483 -17 m 417 78 q 505 97 465 78 q 573 149 544 115 q 617 231 601 183 q 632 336 632 278 q 617 442 632 394 q 573 525 601 490 q 505 578 544 560 q 417 597 465 597 q 328 578 368 597 q 260 525 289 560 q 217 442 232 490 q 201 336 201 394 q 217 231 201 278 q 260 149 232 183 q 328 97 289 115 q 417 78 368 78 m 282 817 q 227 839 249 817 q 206 894 206 861 q 227 949 206 926 q 282 972 249 972 q 337 949 315 972 q 358 894 358 926 q 337 839 358 861 q 282 817 315 817 m 551 817 q 497 839 518 817 q 475 894 475 861 q 497 949 475 926 q 551 972 518 972 q 606 949 585 972 q 628 894 628 926 q 606 839 628 861 q 551 817 585 817 z "},"ө":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 -17 q 290 6 350 -17 q 183 72 229 28 q 110 183 138 117 q 83 336 83 249 q 110 490 83 424 q 183 602 138 557 q 290 669 229 647 q 417 692 350 692 q 544 669 483 692 q 650 602 604 647 q 723 490 696 557 q 750 336 750 424 q 723 183 750 249 q 650 72 696 117 q 544 6 604 28 q 417 -17 483 -17 m 417 603 q 270 549 329 603 q 196 394 211 494 l 638 394 q 563 549 622 494 q 417 603 504 603 m 417 74 q 572 134 511 74 q 640 306 632 194 l 193 306 q 262 134 201 194 q 417 74 322 74 z "},"ӯ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 238 835 l 238 914 l 607 914 l 607 835 l 238 835 z "},"ӳ":{"ha":833,"x_min":68,"x_max":765,"o":"m 182 -290 q 93 -276 132 -290 l 117 -186 q 147 -193 131 -190 q 178 -196 163 -196 q 293 -155 249 -196 q 363 -51 338 -114 l 383 -1 l 68 675 l 183 675 l 349 301 q 390 206 368 257 q 432 106 411 154 l 438 106 q 474 205 456 154 q 510 301 493 256 l 657 675 l 765 675 l 468 -56 q 424 -149 449 -106 q 364 -223 399 -192 q 284 -272 329 -254 q 182 -290 239 -290 m 343 789 l 279 818 l 400 1057 l 481 1018 l 343 789 m 553 789 l 489 818 l 610 1057 l 690 1018 l 553 789 z "},"№":{"ha":833,"x_min":3,"x_max":842,"o":"m 49 -17 q 31 -16 42 -17 q 11 -12 19 -15 l 3 78 q 34 90 24 78 q 44 136 44 101 l 44 886 l 164 886 q 181 828 168 871 q 212 728 194 785 q 248 608 229 671 q 283 488 267 544 q 312 388 300 431 q 328 328 324 344 q 354 232 340 288 q 379 136 368 176 l 385 136 q 376 256 381 201 q 367 360 371 311 q 360 456 363 410 q 358 553 358 503 l 358 765 q 453 903 358 903 q 471 902 460 903 q 492 899 482 901 l 499 808 q 469 797 479 808 q 458 750 458 785 l 458 0 l 336 0 q 319 58 332 15 q 290 158 307 101 q 255 279 274 215 q 219 400 236 343 q 190 500 203 457 q 174 560 178 543 q 161 604 168 579 q 147 656 154 629 q 134 706 140 682 q 122 750 128 731 l 117 750 q 127 630 122 685 q 136 526 132 575 q 142 430 140 476 q 144 333 144 383 l 144 119 q 49 -17 144 -17 m 686 383 q 626 397 654 383 q 575 438 597 410 q 540 508 553 465 q 528 608 528 550 q 540 708 528 665 q 575 777 553 750 q 626 817 597 804 q 686 831 654 831 q 796 776 750 831 q 842 608 842 722 q 796 438 842 493 q 686 383 750 383 m 686 460 q 756 608 756 460 q 686 756 756 756 q 614 608 614 756 q 686 460 614 460 m 567 233 l 567 308 l 806 308 l 806 233 l 567 233 z "},"&":{"ha":833,"x_min":58,"x_max":801,"o":"m 331 -17 q 219 2 269 -17 q 134 54 169 21 q 78 134 99 88 q 58 236 58 181 q 72 318 58 281 q 110 387 86 356 q 165 445 135 418 q 229 497 196 472 q 184 609 200 554 q 168 713 168 664 q 183 797 168 758 q 223 865 197 836 q 285 911 249 894 q 368 928 322 928 q 499 878 453 928 q 544 747 544 828 q 527 667 544 703 q 482 598 510 631 q 419 537 454 565 q 349 481 385 508 q 451 344 393 410 q 571 225 508 279 q 638 347 610 281 q 686 492 667 413 l 792 492 q 731 319 767 401 q 644 165 694 238 q 801 78 728 101 l 769 -17 q 579 88 679 11 q 469 11 529 39 q 331 -17 408 -17 m 267 714 q 278 636 267 676 q 308 554 289 596 q 363 597 338 575 q 409 641 389 618 q 440 690 429 664 q 451 746 451 715 q 433 816 451 786 q 368 846 414 846 q 293 808 319 846 q 267 714 267 771 m 344 75 q 428 94 388 75 q 504 147 468 114 q 378 275 438 206 q 272 419 319 344 q 199 338 228 381 q 169 243 169 296 q 183 174 169 206 q 221 121 197 143 q 276 87 244 99 q 344 75 308 75 z "},".":{"ha":833,"x_min":304,"x_max":529,"o":"m 417 -17 q 337 15 369 -17 q 304 100 304 47 q 337 185 304 153 q 417 218 369 218 q 497 185 464 218 q 529 100 529 153 q 497 15 529 47 q 417 -17 464 -17 z "},",":{"ha":833,"x_min":274,"x_max":550,"o":"m 306 -296 l 274 -224 q 403 -130 360 -185 q 449 8 446 -75 q 435 6 442 6 q 422 6 429 6 q 346 31 378 6 q 314 110 314 57 q 347 188 314 161 q 425 215 381 215 q 519 167 488 215 q 550 38 550 119 q 485 -169 550 -85 q 306 -296 421 -253 z "},":":{"ha":833,"x_min":304,"x_max":529,"o":"m 417 481 q 337 513 369 481 q 304 597 304 544 q 337 683 304 650 q 417 715 369 715 q 497 683 464 715 q 529 597 529 650 q 497 513 529 544 q 417 481 464 481 m 417 -17 q 337 15 369 -17 q 304 100 304 47 q 337 185 304 153 q 417 218 369 218 q 497 185 464 218 q 529 100 529 153 q 497 15 529 47 q 417 -17 464 -17 z "},";":{"ha":833,"x_min":274,"x_max":550,"o":"m 417 481 q 337 513 369 481 q 304 597 304 544 q 337 683 304 650 q 417 715 369 715 q 497 683 464 715 q 529 597 529 650 q 497 513 529 544 q 417 481 464 481 m 306 -296 l 274 -224 q 403 -130 360 -185 q 449 8 446 -75 q 435 6 442 6 q 422 6 429 6 q 346 31 378 6 q 314 110 314 57 q 347 188 314 161 q 425 215 381 215 q 519 167 488 215 q 550 38 550 119 q 485 -169 550 -85 q 306 -296 421 -253 z "},"…":{"ha":833,"x_min":44,"x_max":789,"o":"m 142 -17 q 73 13 101 -17 q 44 88 44 42 q 73 163 44 135 q 142 192 101 192 q 210 163 182 192 q 238 88 238 135 q 210 13 238 42 q 142 -17 182 -17 m 417 -17 q 348 13 376 -17 q 319 88 319 42 q 348 163 319 135 q 417 192 376 192 q 485 163 457 192 q 514 88 514 135 q 485 13 514 42 q 417 -17 457 -17 m 692 -17 q 624 13 651 -17 q 596 88 596 42 q 624 163 596 135 q 692 192 651 192 q 760 163 732 192 q 789 88 789 135 q 760 13 789 42 q 692 -17 732 -17 z "},"!":{"ha":833,"x_min":315,"x_max":518,"o":"m 378 322 l 364 800 l 361 931 l 472 931 l 469 800 l 456 322 l 378 322 m 417 -17 q 345 13 375 -17 q 315 92 315 42 q 345 169 315 140 q 417 197 375 197 q 488 169 458 197 q 518 92 518 140 q 488 13 518 42 q 417 -17 458 -17 z "},"¡":{"ha":833,"x_min":315,"x_max":518,"o":"m 361 -256 l 364 -125 l 378 353 l 456 353 l 469 -125 l 472 -256 l 361 -256 m 417 478 q 345 506 375 478 q 315 585 315 535 q 345 663 315 633 q 417 692 375 692 q 488 663 458 692 q 518 585 518 633 q 488 506 518 535 q 417 478 458 478 z "},"?":{"ha":833,"x_min":151,"x_max":665,"o":"m 336 322 q 340 411 328 372 q 377 482 353 450 q 432 542 401 514 q 490 597 463 569 q 535 653 517 624 q 553 718 553 682 q 515 815 553 776 q 400 853 476 853 q 302 831 347 853 q 219 772 257 810 l 151 835 q 263 915 199 883 q 407 947 326 947 q 513 932 465 947 q 594 888 560 917 q 647 820 628 860 q 665 731 665 781 q 647 647 665 683 q 601 581 628 611 q 542 523 574 550 q 485 466 511 496 q 445 401 460 436 q 438 322 431 367 l 336 322 m 397 -17 q 326 13 356 -17 q 296 92 296 42 q 326 169 296 140 q 397 197 356 197 q 469 169 439 197 q 499 92 499 140 q 469 13 499 42 q 397 -17 439 -17 z "},"¿":{"ha":833,"x_min":168,"x_max":682,"o":"m 426 -272 q 321 -257 368 -272 q 240 -213 274 -242 q 187 -145 206 -185 q 168 -56 168 -106 q 187 28 168 -8 q 233 94 206 64 q 291 152 260 125 q 348 209 322 179 q 388 273 374 239 q 396 353 401 307 l 497 353 q 493 264 506 303 q 456 193 481 225 q 401 133 432 161 q 344 78 371 106 q 299 22 317 51 q 281 -43 281 -8 q 319 -139 281 -101 q 433 -176 357 -176 q 531 -156 486 -176 q 614 -97 576 -135 l 682 -160 q 571 -240 635 -208 q 426 -272 507 -272 m 436 478 q 365 506 394 478 q 335 585 335 535 q 365 663 335 633 q 436 692 394 692 q 508 663 478 692 q 538 585 538 633 q 508 506 538 535 q 436 478 478 478 z "},"'":{"ha":833,"x_min":340,"x_max":493,"o":"m 378 489 l 343 801 l 340 954 l 493 954 l 490 801 l 456 489 l 378 489 z "},"\"":{"ha":833,"x_min":182,"x_max":653,"o":"m 219 489 l 185 801 l 182 954 l 335 954 l 332 801 l 297 489 l 219 489 m 538 489 l 503 801 l 500 954 l 653 954 l 650 801 l 615 489 l 538 489 z "},"‘":{"ha":833,"x_min":290,"x_max":528,"o":"m 415 486 q 326 530 361 486 q 290 653 290 574 q 343 840 290 757 q 490 971 396 922 l 528 904 q 426 812 464 867 q 385 685 389 757 q 421 693 401 693 q 491 665 464 693 q 518 593 518 638 q 489 515 518 544 q 415 486 460 486 z "},"’":{"ha":833,"x_min":301,"x_max":539,"o":"m 340 486 l 301 553 q 404 644 367 589 q 446 772 442 699 q 410 764 429 764 q 338 791 365 764 q 311 863 311 818 q 340 941 311 911 q 414 971 369 971 q 504 926 469 971 q 539 803 539 882 q 486 617 539 699 q 340 486 433 535 z "},"“":{"ha":833,"x_min":132,"x_max":688,"o":"m 257 486 q 167 530 203 486 q 132 653 132 574 q 185 840 132 757 q 332 971 238 922 l 369 904 q 268 812 306 867 q 226 685 231 757 q 263 693 243 693 q 333 665 306 693 q 360 593 360 638 q 331 515 360 544 q 257 486 301 486 m 575 486 q 485 530 521 486 q 450 653 450 574 q 503 840 450 757 q 650 971 556 922 l 688 904 q 586 812 624 867 q 544 685 549 757 q 581 693 561 693 q 651 665 624 693 q 678 593 678 638 q 649 515 678 544 q 575 486 619 486 z "},"”":{"ha":833,"x_min":143,"x_max":699,"o":"m 182 486 l 143 553 q 246 644 208 589 q 288 772 283 699 q 251 764 271 764 q 180 791 207 764 q 153 863 153 818 q 182 941 153 911 q 256 971 211 971 q 346 926 311 971 q 381 803 381 882 q 328 617 381 699 q 182 486 275 535 m 500 486 l 461 553 q 564 644 526 589 q 606 772 601 699 q 569 764 589 764 q 498 791 525 764 q 471 863 471 818 q 500 941 471 911 q 574 971 529 971 q 664 926 629 971 q 699 803 699 882 q 646 617 699 699 q 500 486 593 535 z "},"‚":{"ha":833,"x_min":301,"x_max":539,"o":"m 340 -312 l 301 -246 q 404 -155 367 -210 q 446 -26 442 -100 q 410 -35 429 -35 q 338 -8 365 -35 q 311 64 311 19 q 340 142 311 113 q 414 172 369 172 q 504 128 469 172 q 539 4 539 83 q 486 -182 539 -100 q 340 -312 433 -264 z "},"„":{"ha":833,"x_min":143,"x_max":699,"o":"m 182 -312 l 143 -246 q 246 -155 208 -210 q 288 -26 283 -100 q 251 -35 271 -35 q 180 -8 207 -35 q 153 64 153 19 q 182 142 153 113 q 256 172 211 172 q 346 128 311 172 q 381 4 381 83 q 328 -182 381 -100 q 182 -312 275 -264 m 500 -312 l 461 -246 q 564 -155 526 -210 q 606 -26 601 -100 q 569 -35 589 -35 q 498 -8 525 -35 q 471 64 471 19 q 500 142 471 113 q 574 172 529 172 q 664 128 629 172 q 699 4 699 83 q 646 -182 699 -100 q 500 -312 593 -264 z "},"‛":{"ha":833,"x_min":294,"x_max":532,"o":"m 493 486 q 347 617 400 535 q 294 803 294 699 q 329 926 294 882 q 419 971 364 971 q 493 941 464 971 q 522 863 522 911 q 495 791 522 818 q 424 764 468 764 q 388 772 404 764 q 429 644 392 699 q 532 553 467 589 l 493 486 z "},"‹":{"ha":833,"x_min":274,"x_max":540,"o":"m 486 72 l 274 294 l 274 406 l 486 628 l 540 579 l 364 350 l 540 119 l 486 72 z "},"›":{"ha":833,"x_min":293,"x_max":560,"o":"m 347 72 l 293 119 l 469 350 l 293 579 l 347 628 l 560 406 l 560 294 l 347 72 z "},"«":{"ha":833,"x_min":115,"x_max":700,"o":"m 328 72 l 115 294 l 115 406 l 328 628 l 382 579 l 206 350 l 382 119 l 328 72 m 646 72 l 433 294 l 433 406 l 646 628 l 700 579 l 524 350 l 700 119 l 646 72 z "},"»":{"ha":833,"x_min":135,"x_max":719,"o":"m 189 72 l 135 119 l 311 350 l 135 579 l 189 628 l 401 406 l 401 294 l 189 72 m 507 72 l 453 119 l 629 350 l 453 579 l 507 628 l 719 406 l 719 294 l 507 72 z "},"-":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 z "},"­":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 z "},"‐":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 z "},"–":{"ha":833,"x_min":111,"x_max":722,"o":"m 111 300 l 111 400 l 722 400 l 722 300 l 111 300 z "},"—":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 300 l 0 400 l 833 400 l 833 300 l 0 300 z "},"‒":{"ha":833,"x_min":111,"x_max":722,"o":"m 111 300 l 111 400 l 722 400 l 722 300 l 111 300 z "},"―":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 300 l 0 400 l 833 400 l 833 300 l 0 300 z "},"·":{"ha":833,"x_min":304,"x_max":529,"o":"m 417 365 q 337 397 369 365 q 304 482 304 429 q 337 567 304 535 q 417 600 369 600 q 497 567 464 600 q 529 482 529 535 q 497 397 529 429 q 417 365 464 365 z "},"•":{"ha":833,"x_min":210,"x_max":624,"o":"m 417 160 q 338 174 375 160 q 272 216 300 189 q 226 281 243 243 q 210 364 210 318 q 226 447 210 410 q 272 512 243 485 q 338 553 300 539 q 417 568 375 568 q 496 553 458 568 q 562 512 533 539 q 607 447 590 485 q 624 364 624 410 q 607 281 624 318 q 562 216 590 243 q 496 174 533 189 q 417 160 458 160 z "},"◦":{"ha":833,"x_min":193,"x_max":640,"o":"m 417 143 q 327 160 368 143 q 256 206 286 176 q 210 276 226 236 q 193 364 193 317 q 210 451 193 411 q 256 522 226 492 q 327 568 286 551 q 417 585 368 585 q 506 568 465 585 q 577 522 547 551 q 624 451 607 492 q 640 364 640 411 q 624 276 640 317 q 577 206 607 236 q 506 160 547 176 q 417 143 465 143 m 417 210 q 523 253 482 210 q 564 364 564 296 q 523 475 564 432 q 417 518 482 518 q 310 475 351 518 q 269 364 269 432 q 310 253 269 296 q 417 210 351 210 z "},"▪":{"ha":833,"x_min":231,"x_max":603,"o":"m 231 179 l 231 549 l 603 549 l 603 179 l 231 179 z "},"▫":{"ha":833,"x_min":214,"x_max":619,"o":"m 214 163 l 214 565 l 619 565 l 619 163 l 214 163 m 282 225 l 551 225 l 551 503 l 282 503 l 282 225 z "},"▴":{"ha":833,"x_min":193,"x_max":640,"o":"m 193 179 l 193 183 l 415 590 l 418 590 l 640 183 l 640 179 l 193 179 z "},"▵":{"ha":833,"x_min":163,"x_max":671,"o":"m 163 163 l 163 167 l 415 619 l 418 619 l 671 167 l 671 163 l 163 163 m 265 222 l 568 222 l 417 503 l 265 222 z "},"▸":{"ha":833,"x_min":231,"x_max":642,"o":"m 231 140 l 231 590 l 235 590 l 642 367 l 642 363 l 235 140 l 231 140 z "},"▹":{"ha":833,"x_min":214,"x_max":671,"o":"m 214 110 l 214 619 l 217 619 l 671 367 l 671 363 l 217 110 l 214 110 m 274 214 l 553 365 l 274 515 l 274 214 z "},"▾":{"ha":833,"x_min":193,"x_max":640,"o":"m 415 138 l 193 544 l 193 549 l 640 549 l 640 544 l 418 138 l 415 138 z "},"▿":{"ha":833,"x_min":163,"x_max":671,"o":"m 415 108 l 163 561 l 163 565 l 671 565 l 671 561 l 418 108 l 415 108 m 417 225 l 568 506 l 265 506 l 417 225 z "},"◂":{"ha":833,"x_min":192,"x_max":603,"o":"m 599 140 l 192 363 l 192 367 l 599 590 l 603 590 l 603 140 l 599 140 z "},"◃":{"ha":833,"x_min":163,"x_max":619,"o":"m 617 110 l 163 363 l 163 367 l 617 619 l 619 619 l 619 110 l 617 110 m 560 214 l 560 515 l 281 365 l 560 214 z "},"◘":{"ha":833,"x_min":211,"x_max":622,"o":"m 211 160 l 211 568 l 622 568 l 622 160 l 211 160 m 417 176 q 492 190 457 176 q 551 229 526 204 q 591 289 576 254 q 606 364 606 324 q 591 439 606 404 q 551 499 576 474 q 492 538 526 524 q 417 551 457 551 q 342 538 376 551 q 282 499 307 524 q 242 439 257 474 q 228 364 228 404 q 242 289 228 324 q 282 229 257 254 q 342 190 307 204 q 417 176 376 176 z "},"▬":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 272 l 0 428 l 833 428 l 833 272 l 0 272 z "},"_":{"ha":833,"x_min":83,"x_max":750,"o":"m 83 -194 l 83 -96 l 750 -96 l 750 -194 l 83 -194 z "},"‗":{"ha":833,"x_min":83,"x_max":750,"o":"m 83 -182 l 83 -96 l 750 -96 l 750 -182 l 83 -182 m 83 -351 l 83 -267 l 750 -267 l 750 -351 l 83 -351 z "},"‾":{"ha":833,"x_min":86,"x_max":747,"o":"m 86 801 l 86 876 l 747 876 l 747 801 l 86 801 z "},"‿":{"ha":833,"x_min":-214,"x_max":1047,"o":"m 417 -324 q 83 -278 239 -324 q -214 -146 -74 -233 l -181 -89 q 109 -206 -47 -169 q 417 -243 265 -243 q 724 -206 568 -243 q 1014 -89 881 -169 l 1047 -146 q 751 -278 907 -233 q 417 -324 594 -324 z "},"(":{"ha":833,"x_min":289,"x_max":664,"o":"m 601 -244 q 373 26 457 -132 q 289 386 289 185 q 373 746 289 588 q 601 1017 457 904 l 664 958 q 458 701 524 840 q 392 386 392 563 q 458 71 392 210 q 664 -186 524 -68 l 601 -244 z "},")":{"ha":833,"x_min":169,"x_max":544,"o":"m 232 -244 l 169 -186 q 376 71 310 -68 q 442 386 442 210 q 376 701 442 563 q 169 958 310 840 l 232 1017 q 460 746 376 904 q 544 386 544 588 q 460 26 544 185 q 232 -244 376 -132 z "},"[":{"ha":833,"x_min":313,"x_max":697,"o":"m 313 -211 l 313 983 l 697 983 l 697 918 l 404 918 l 404 -146 l 697 -146 l 697 -211 l 313 -211 z "},"]":{"ha":833,"x_min":136,"x_max":521,"o":"m 136 -211 l 136 -146 l 429 -146 l 429 918 l 136 918 l 136 983 l 521 983 l 521 -211 l 136 -211 z "},"{":{"ha":833,"x_min":167,"x_max":697,"o":"m 613 -211 q 499 -202 547 -211 q 418 -172 450 -193 q 371 -116 386 -151 q 356 -26 356 -81 q 358 45 356 11 q 362 111 360 79 q 366 175 364 143 q 368 242 368 207 q 360 281 368 263 q 329 315 351 300 q 267 340 307 331 q 167 350 228 350 l 167 422 q 267 432 228 422 q 329 457 307 442 q 360 491 351 472 q 368 531 368 510 q 362 662 368 597 q 356 799 356 726 q 371 888 356 853 q 418 944 386 924 q 499 974 450 965 q 613 983 547 983 l 697 983 l 697 918 l 625 918 q 538 911 572 918 q 485 889 504 904 q 460 849 467 874 q 453 792 453 825 q 457 669 453 732 q 461 540 461 606 q 434 437 461 472 q 335 389 407 401 l 335 383 q 434 335 407 371 q 461 232 461 300 q 457 103 461 161 q 453 -19 453 44 q 460 -77 453 -53 q 485 -117 467 -101 q 538 -139 504 -132 q 625 -146 572 -146 l 697 -146 l 697 -211 l 613 -211 z "},"}":{"ha":833,"x_min":138,"x_max":667,"o":"m 138 -211 l 138 -146 l 208 -146 q 295 -139 261 -146 q 349 -117 329 -132 q 375 -77 368 -101 q 382 -19 382 -53 q 378 103 382 44 q 374 232 374 161 q 400 335 374 300 q 499 383 426 371 l 499 389 q 400 437 426 401 q 374 540 374 472 q 378 669 374 606 q 382 792 382 732 q 375 849 382 825 q 349 889 368 874 q 295 911 329 904 q 208 918 261 918 l 138 918 l 138 983 l 222 983 q 335 974 288 983 q 415 944 383 965 q 463 888 447 924 q 478 799 478 853 q 472 662 478 726 q 465 531 465 597 q 474 491 465 510 q 504 457 482 472 q 566 432 526 442 q 667 422 606 422 l 667 350 q 566 340 606 350 q 504 315 526 331 q 474 281 482 300 q 465 242 465 263 q 467 175 465 207 q 472 111 469 143 q 476 45 474 79 q 478 -26 478 11 q 463 -116 478 -81 q 415 -172 447 -151 q 335 -202 383 -193 q 222 -211 288 -211 l 138 -211 z "},"/":{"ha":833,"x_min":138,"x_max":696,"o":"m 138 -222 l 593 986 l 696 986 l 240 -222 l 138 -222 z "},"|":{"ha":833,"x_min":365,"x_max":468,"o":"m 365 -347 l 365 1042 l 468 1042 l 468 -347 l 365 -347 z "},"\\":{"ha":833,"x_min":138,"x_max":696,"o":"m 593 -222 l 138 986 l 240 986 l 696 -222 l 593 -222 z "},"¦":{"ha":833,"x_min":365,"x_max":468,"o":"m 365 -347 l 365 264 l 468 264 l 468 -347 l 365 -347 m 365 431 l 365 1042 l 468 1042 l 468 431 l 365 431 z "},"*":{"ha":833,"x_min":117,"x_max":717,"o":"m 250 154 l 192 196 l 342 425 l 117 522 l 139 586 l 371 510 l 383 772 l 450 772 l 463 510 l 694 586 l 717 522 l 492 425 l 642 196 l 583 154 l 417 375 l 250 154 z "},"†":{"ha":833,"x_min":176,"x_max":657,"o":"m 368 -111 l 375 682 l 176 675 l 176 774 l 375 767 l 368 989 l 465 989 l 458 767 l 657 774 l 657 675 l 458 682 l 465 -111 l 368 -111 z "},"‡":{"ha":833,"x_min":176,"x_max":657,"o":"m 368 -111 l 375 111 l 176 104 l 176 203 l 375 193 l 368 439 l 375 685 l 176 675 l 176 774 l 375 767 l 368 989 l 465 989 l 458 767 l 657 774 l 657 675 l 458 685 l 465 439 l 458 193 l 657 203 l 657 104 l 458 111 l 465 -111 l 368 -111 z "},"§":{"ha":833,"x_min":126,"x_max":707,"o":"m 399 -89 q 258 -62 322 -89 q 150 10 194 -36 l 219 72 q 298 19 256 39 q 399 0 340 0 q 487 28 456 0 q 518 96 518 56 q 489 161 518 135 q 417 208 460 188 q 322 249 374 229 q 228 299 271 269 q 156 370 185 328 q 126 476 126 413 q 162 583 126 539 q 253 657 197 628 q 222 706 233 679 q 210 769 210 733 q 223 838 210 806 q 263 896 236 871 q 328 935 289 921 q 419 950 367 950 q 545 926 489 950 q 643 871 601 903 l 588 797 q 513 843 551 825 q 425 861 474 861 q 340 835 367 861 q 314 774 314 810 q 343 711 314 736 q 416 665 372 686 q 510 624 460 644 q 605 573 561 603 q 678 501 649 543 q 707 394 707 458 q 673 286 707 328 q 581 214 639 244 q 611 165 600 192 q 622 101 622 138 q 606 25 622 60 q 560 -35 589 -10 q 490 -74 531 -60 q 399 -89 449 -89 m 225 483 q 253 408 225 438 q 326 355 282 378 q 420 313 369 332 q 515 267 471 293 q 584 313 560 286 q 608 386 608 339 q 580 464 608 433 q 508 517 551 494 q 415 560 465 540 q 319 606 364 581 q 251 555 276 583 q 225 483 225 526 z "},"¶":{"ha":833,"x_min":100,"x_max":674,"o":"m 442 314 q 306 331 368 314 q 197 385 243 349 q 126 479 151 422 q 100 615 100 536 q 125 753 100 697 q 194 845 150 810 q 297 896 238 881 q 426 911 357 911 l 486 911 l 486 314 l 442 314 m 561 -111 l 561 911 l 674 911 l 674 -111 l 561 -111 z "},"‖":{"ha":833,"x_min":218,"x_max":617,"o":"m 218 -347 l 218 1042 l 321 1042 l 321 -347 l 218 -347 m 514 -347 l 514 1042 l 617 1042 l 617 -347 l 514 -347 z "},"‼":{"ha":833,"x_min":131,"x_max":686,"o":"m 193 322 l 179 800 l 176 931 l 288 931 l 285 800 l 271 322 l 193 322 m 232 -17 q 160 13 190 -17 q 131 92 131 42 q 160 169 131 140 q 232 197 190 197 q 303 169 274 197 q 333 92 333 140 q 303 13 333 42 q 232 -17 274 -17 m 546 322 l 532 800 l 529 931 l 640 931 l 638 800 l 624 322 l 546 322 m 585 -17 q 513 13 543 -17 q 483 92 483 42 q 513 169 483 140 q 585 197 543 197 q 656 169 626 197 q 686 92 686 140 q 656 13 686 42 q 585 -17 626 -17 z "},"⁇":{"ha":833,"x_min":19,"x_max":793,"o":"m 142 322 q 141 410 133 371 q 166 485 149 450 q 205 549 183 519 q 247 610 226 579 q 280 673 267 640 q 293 743 293 706 q 268 821 293 789 q 192 853 243 853 q 131 838 158 853 q 76 786 104 822 l 19 854 q 107 924 60 900 q 213 947 154 947 q 291 933 256 947 q 351 895 326 919 q 390 837 376 871 q 404 764 404 803 q 390 676 404 715 q 356 603 376 636 q 311 538 335 569 q 269 474 288 507 q 240 405 250 442 q 238 322 231 368 l 142 322 m 203 -17 q 131 13 161 -17 q 101 92 101 42 q 131 169 101 140 q 203 197 161 197 q 274 169 244 197 q 304 92 304 140 q 274 13 304 42 q 203 -17 244 -17 m 531 322 q 530 410 522 371 q 555 485 538 450 q 594 549 572 519 q 635 610 615 579 q 669 673 656 640 q 682 743 682 706 q 657 821 682 789 q 581 853 632 853 q 520 838 547 853 q 465 786 493 822 l 408 854 q 496 924 449 900 q 601 947 543 947 q 680 933 644 947 q 740 895 715 919 q 779 837 765 871 q 793 764 793 803 q 779 676 793 715 q 744 603 765 636 q 700 538 724 569 q 658 474 676 507 q 629 405 639 442 q 626 322 619 368 l 531 322 m 592 -17 q 520 13 550 -17 q 490 92 490 42 q 520 169 490 140 q 592 197 550 197 q 663 169 633 197 q 693 92 693 140 q 663 13 693 42 q 592 -17 633 -17 z "},"⁉":{"ha":833,"x_min":121,"x_max":793,"o":"m 531 322 q 530 410 522 371 q 555 485 538 450 q 594 549 572 519 q 635 610 615 579 q 669 673 656 640 q 682 743 682 706 q 657 821 682 789 q 581 853 632 853 q 520 838 547 853 q 465 786 493 822 l 408 854 q 496 924 449 900 q 601 947 543 947 q 680 933 644 947 q 740 895 715 919 q 779 837 765 871 q 793 764 793 803 q 779 676 793 715 q 744 603 765 636 q 700 538 724 569 q 658 474 676 507 q 629 405 639 442 q 626 322 619 368 l 531 322 m 592 -17 q 520 13 550 -17 q 490 92 490 42 q 520 169 490 140 q 592 197 550 197 q 663 169 633 197 q 693 92 693 140 q 663 13 693 42 q 592 -17 633 -17 m 183 322 l 169 800 l 167 931 l 278 931 l 275 800 l 261 322 l 183 322 m 222 -17 q 151 13 181 -17 q 121 92 121 42 q 151 169 121 140 q 222 197 181 197 q 294 169 264 197 q 324 92 324 140 q 294 13 324 42 q 222 -17 264 -17 z "},"⁈":{"ha":833,"x_min":19,"x_max":713,"o":"m 142 322 q 141 410 133 371 q 166 485 149 450 q 205 549 183 519 q 247 610 226 579 q 280 673 267 640 q 293 743 293 706 q 268 821 293 789 q 192 853 243 853 q 131 838 158 853 q 76 786 104 822 l 19 854 q 107 924 60 900 q 213 947 154 947 q 291 933 256 947 q 351 895 326 919 q 390 837 376 871 q 404 764 404 803 q 390 676 404 715 q 356 603 376 636 q 311 538 335 569 q 269 474 288 507 q 240 405 250 442 q 238 322 231 368 l 142 322 m 203 -17 q 131 13 161 -17 q 101 92 101 42 q 131 169 101 140 q 203 197 161 197 q 274 169 244 197 q 304 92 304 140 q 274 13 304 42 q 203 -17 244 -17 m 572 322 l 558 800 l 556 931 l 667 931 l 664 800 l 650 322 l 572 322 m 611 -17 q 540 13 569 -17 q 510 92 510 42 q 540 169 510 140 q 611 197 569 197 q 683 169 653 197 q 713 92 713 140 q 683 13 713 42 q 611 -17 653 -17 z "},"‽":{"ha":833,"x_min":131,"x_max":672,"o":"m 353 322 l 338 633 l 332 739 l 429 739 l 428 633 l 424 485 q 469 535 444 511 q 515 584 494 558 q 551 640 536 610 q 565 711 565 671 q 522 815 565 774 q 393 857 478 857 q 197 769 282 857 l 131 831 q 249 915 179 883 q 401 947 319 947 q 513 931 463 947 q 598 886 563 915 q 653 817 633 857 q 672 729 672 776 q 653 634 672 674 q 607 563 635 594 q 547 506 579 532 q 489 453 515 481 q 446 395 463 426 q 433 322 429 364 l 353 322 m 392 -17 q 324 12 353 -17 q 296 88 296 40 q 324 163 296 135 q 392 192 353 192 q 460 163 432 192 q 489 88 489 135 q 460 12 489 40 q 392 -17 432 -17 z "},"⸘":{"ha":833,"x_min":161,"x_max":703,"o":"m 481 353 l 496 42 l 501 -64 l 404 -64 l 406 42 l 410 190 q 364 140 389 164 q 318 91 339 117 q 283 35 297 65 q 268 -36 268 4 q 312 -140 268 -99 q 440 -182 356 -182 q 636 -94 551 -182 l 703 -156 q 584 -240 654 -208 q 432 -272 514 -272 q 321 -256 371 -272 q 235 -211 271 -240 q 181 -142 200 -182 q 161 -54 161 -101 q 180 40 161 0 q 226 112 199 81 q 286 169 254 143 q 344 222 318 194 q 388 280 371 249 q 400 353 404 311 l 481 353 m 442 692 q 509 663 481 692 q 538 588 538 635 q 509 512 538 540 q 442 483 481 483 q 373 512 401 483 q 344 588 344 540 q 373 663 344 635 q 442 692 401 692 z "},"⌜":{"ha":833,"x_min":313,"x_max":697,"o":"m 313 0 l 313 965 l 697 965 l 697 900 l 404 900 l 404 0 l 313 0 z "},"⌝":{"ha":833,"x_min":136,"x_max":521,"o":"m 429 0 l 429 900 l 136 900 l 136 965 l 521 965 l 521 0 l 429 0 z "},"⌞":{"ha":833,"x_min":313,"x_max":697,"o":"m 313 -119 l 313 886 l 404 886 l 404 -54 l 697 -54 l 697 -119 l 313 -119 z "},"⌟":{"ha":833,"x_min":136,"x_max":521,"o":"m 136 -119 l 136 -54 l 429 -54 l 429 886 l 521 886 l 521 -119 l 136 -119 z "},"⟦":{"ha":833,"x_min":258,"x_max":697,"o":"m 258 -211 l 258 983 l 697 983 l 697 918 l 458 918 l 458 -146 l 697 -146 l 697 -211 l 258 -211 m 331 -146 l 390 -146 l 390 918 l 331 918 l 331 -146 z "},"⟧":{"ha":833,"x_min":136,"x_max":575,"o":"m 136 -211 l 136 -146 l 375 -146 l 375 918 l 136 918 l 136 983 l 575 983 l 575 -211 l 136 -211 m 443 -146 l 503 -146 l 503 918 l 443 918 l 443 -146 z "},"⸢":{"ha":833,"x_min":314,"x_max":697,"o":"m 314 386 l 314 983 l 697 983 l 697 918 l 404 918 l 404 386 l 314 386 z "},"⸣":{"ha":833,"x_min":136,"x_max":521,"o":"m 429 386 l 429 900 l 136 900 l 136 965 l 521 965 l 521 386 l 429 386 z "},"⸤":{"ha":833,"x_min":313,"x_max":697,"o":"m 313 -211 l 313 386 l 404 386 l 404 -146 l 697 -146 l 697 -211 l 313 -211 z "},"⸥":{"ha":833,"x_min":136,"x_max":521,"o":"m 136 -211 l 136 -146 l 429 -146 l 429 386 l 521 386 l 521 -211 l 136 -211 z "},"©":{"ha":833,"x_min":42,"x_max":792,"o":"m 417 -15 q 269 17 338 -15 q 149 110 200 50 q 70 256 99 171 q 42 449 42 342 q 70 640 42 554 q 149 784 99 725 q 269 875 200 843 q 417 907 338 907 q 565 875 496 907 q 684 784 633 843 q 763 640 735 725 q 792 449 792 554 q 763 256 792 342 q 684 110 735 171 q 565 17 633 50 q 417 -15 496 -15 m 417 43 q 544 72 486 43 q 642 155 601 101 q 706 283 683 208 q 728 449 728 357 q 706 614 728 540 q 642 740 683 688 q 544 822 601 793 q 417 850 486 850 q 290 822 347 850 q 191 740 232 793 q 128 614 150 688 q 106 449 106 540 q 128 283 106 357 q 191 155 150 208 q 290 72 232 101 q 417 43 347 43 m 428 174 q 340 192 381 174 q 268 247 299 211 q 220 333 238 282 q 203 449 203 383 q 222 557 203 508 q 272 640 240 606 q 345 693 304 675 q 432 711 386 711 q 515 692 481 711 q 576 646 549 674 l 529 592 q 485 623 507 611 q 436 635 464 635 q 333 583 372 635 q 294 449 294 531 q 331 303 294 357 q 431 250 368 250 q 493 264 467 250 q 543 297 519 278 l 585 239 q 517 192 553 211 q 428 174 481 174 z "},"℗":{"ha":833,"x_min":42,"x_max":792,"o":"m 417 -15 q 269 17 338 -15 q 149 110 200 50 q 70 256 99 171 q 42 449 42 342 q 70 640 42 554 q 149 784 99 725 q 269 875 200 843 q 417 907 338 907 q 565 875 496 907 q 684 784 633 843 q 763 640 735 725 q 792 449 792 554 q 763 256 792 342 q 684 110 735 171 q 565 17 633 50 q 417 -15 496 -15 m 417 43 q 544 72 486 43 q 642 155 601 101 q 706 283 683 208 q 728 449 728 357 q 706 614 728 540 q 642 740 683 688 q 544 822 601 793 q 417 850 486 850 q 290 822 347 850 q 191 740 232 793 q 128 614 150 688 q 106 449 106 540 q 128 283 106 357 q 191 155 150 208 q 290 72 232 101 q 417 43 347 43 m 268 190 l 268 694 l 426 694 q 500 685 465 694 q 560 656 535 675 q 601 605 586 636 q 615 532 615 574 q 601 452 615 486 q 560 395 586 418 q 500 361 535 372 q 426 350 465 350 l 358 350 l 358 190 l 268 190 m 358 419 l 413 419 q 496 445 467 419 q 525 529 525 471 q 495 601 525 579 q 413 624 465 624 l 358 624 l 358 419 z "},"®":{"ha":833,"x_min":156,"x_max":678,"o":"m 417 443 q 315 463 363 443 q 231 519 267 483 q 176 606 196 556 q 156 717 156 656 q 176 828 156 778 q 231 914 196 878 q 315 970 267 950 q 417 990 363 990 q 518 970 471 990 q 601 914 565 950 q 657 828 636 878 q 678 717 678 778 q 657 606 678 656 q 601 519 636 556 q 518 463 565 483 q 417 443 471 443 m 417 494 q 498 510 460 494 q 563 556 536 526 q 606 626 590 585 q 622 717 622 667 q 606 806 622 765 q 563 877 590 847 q 498 924 536 907 q 417 940 460 940 q 335 924 372 940 q 269 877 297 907 q 226 806 242 847 q 210 717 210 765 q 226 626 210 667 q 269 556 242 585 q 335 510 297 526 q 417 494 372 494 m 315 579 l 315 861 l 421 861 q 498 841 465 861 q 531 771 531 821 q 516 724 531 746 q 478 694 501 703 l 542 579 l 478 579 l 429 676 l 372 676 l 372 579 l 315 579 m 372 721 l 408 721 q 453 733 436 721 q 469 768 469 744 q 456 801 469 789 q 411 814 443 814 l 372 814 l 372 721 z "},"™":{"ha":833,"x_min":-7,"x_max":806,"o":"m 126 508 l 126 864 l -7 864 l -7 939 l 343 939 l 343 864 l 210 864 l 210 508 l 126 508 m 406 508 l 406 939 l 504 939 l 567 781 l 604 669 l 610 669 l 646 781 l 707 939 l 806 939 l 806 508 l 729 508 l 729 699 l 739 844 l 733 844 l 635 585 l 576 585 l 476 844 l 471 844 l 481 699 l 481 508 l 406 508 z "},"℠":{"ha":833,"x_min":21,"x_max":806,"o":"m 174 492 q 90 509 128 492 q 21 558 53 526 l 67 610 q 119 572 93 586 q 179 557 144 557 q 229 572 211 557 q 247 611 247 586 q 234 649 247 639 q 189 675 221 660 l 125 708 q 69 751 94 724 q 43 826 43 778 q 82 915 43 881 q 188 949 121 949 q 261 933 226 949 q 319 896 296 918 l 278 842 q 233 871 257 858 q 185 883 208 883 q 136 867 153 883 q 119 831 119 851 q 134 797 119 810 q 176 771 149 783 l 240 739 q 303 693 281 719 q 325 618 325 667 q 315 571 325 593 q 285 531 304 549 q 237 502 265 513 q 174 492 208 492 m 406 508 l 406 939 l 504 939 l 567 781 l 604 669 l 610 669 l 646 781 l 707 939 l 806 939 l 806 508 l 729 508 l 729 699 l 739 844 l 733 844 l 635 585 l 576 585 l 476 844 l 471 844 l 481 699 l 481 508 l 406 508 z "},"@":{"ha":833,"x_min":68,"x_max":758,"o":"m 474 -200 q 318 -165 392 -200 q 189 -60 244 -129 q 101 111 133 8 q 68 347 68 214 q 99 581 68 481 q 186 747 131 681 q 316 848 242 814 q 476 882 390 882 q 601 857 549 882 q 689 788 654 832 q 741 683 724 743 q 758 551 758 622 l 758 139 l 689 139 l 679 219 l 674 219 q 594 151 643 181 q 490 122 544 122 q 420 135 453 122 q 363 171 388 147 q 325 228 339 194 q 311 304 311 263 q 406 465 311 411 q 678 542 500 519 l 678 561 q 666 656 678 611 q 629 733 654 700 q 565 786 604 767 q 471 806 525 806 q 351 776 408 806 q 251 690 294 747 q 181 545 207 632 q 156 343 156 458 q 181 145 156 232 q 249 -1 206 58 q 350 -92 292 -61 q 476 -124 408 -124 q 585 -108 539 -124 q 672 -61 632 -92 l 711 -124 q 600 -181 657 -161 q 474 -200 543 -200 m 514 203 q 669 292 592 203 l 669 467 q 464 409 525 447 q 403 307 403 371 q 433 231 403 258 q 514 203 463 203 z "},"#":{"ha":833,"x_min":121,"x_max":721,"o":"m 456 0 l 490 283 l 307 283 l 272 0 l 197 0 l 232 283 l 121 283 l 121 363 l 242 363 l 267 568 l 149 568 l 149 649 l 276 649 l 308 903 l 382 903 l 351 649 l 535 649 l 567 903 l 640 903 l 610 649 l 721 649 l 721 568 l 600 568 l 575 363 l 693 363 l 693 283 l 565 283 l 531 0 l 456 0 m 500 363 l 525 568 l 342 568 l 317 363 l 500 363 z "},"⁰":{"ha":833,"x_min":196,"x_max":638,"o":"m 417 532 q 256 607 317 532 q 196 821 196 682 q 256 1033 196 958 q 417 1107 317 1107 q 577 1033 517 1107 q 638 821 638 958 q 577 607 638 682 q 417 532 517 532 m 417 603 q 514 657 476 603 q 551 821 551 711 q 514 983 551 929 q 417 1036 476 1036 q 319 983 357 1036 q 282 821 282 929 q 319 657 282 711 q 417 603 357 603 z "},"¹":{"ha":833,"x_min":243,"x_max":661,"o":"m 243 549 l 243 624 l 414 624 l 414 976 l 268 976 l 268 1033 q 362 1054 325 1042 q 431 1090 399 1067 l 503 1090 l 503 624 l 661 624 l 661 549 l 243 549 z "},"²":{"ha":833,"x_min":203,"x_max":619,"o":"m 225 549 l 219 600 q 342 705 289 660 q 432 788 396 750 q 486 856 468 825 q 504 918 504 888 q 472 1001 504 971 q 386 1032 440 1032 q 313 1010 347 1032 q 256 953 279 988 l 203 1001 q 287 1078 235 1050 q 399 1107 339 1107 q 540 1063 486 1107 q 593 931 593 1018 q 576 856 593 892 q 528 785 558 821 q 456 710 497 749 q 364 624 414 671 l 619 624 l 619 549 l 225 549 z "},"³":{"ha":833,"x_min":197,"x_max":618,"o":"m 413 532 q 285 561 342 532 q 197 638 229 590 l 256 683 q 322 623 282 643 q 407 603 361 603 q 493 628 457 603 q 529 699 529 653 q 347 796 529 796 l 347 851 q 469 880 431 851 q 508 950 508 908 q 478 1013 508 989 q 397 1036 449 1036 q 329 1018 363 1036 q 272 969 296 1000 l 219 1017 q 302 1083 256 1060 q 410 1107 349 1107 q 481 1097 447 1107 q 541 1067 515 1086 q 582 1022 567 1049 q 597 961 597 994 q 570 881 597 913 q 488 828 543 849 q 583 782 547 817 q 618 694 618 747 q 602 627 618 657 q 558 576 586 597 q 492 543 529 554 q 413 532 454 532 z "},"⁴":{"ha":833,"x_min":206,"x_max":642,"o":"m 481 549 l 481 693 l 206 693 l 206 739 l 419 1107 l 485 1072 l 301 757 l 481 757 l 481 918 l 561 918 l 561 757 l 642 757 l 642 693 l 561 693 l 561 549 l 481 549 z "},"⁵":{"ha":833,"x_min":197,"x_max":624,"o":"m 415 532 q 285 561 339 532 q 197 638 231 590 l 256 683 q 410 603 311 603 q 499 636 464 603 q 535 722 535 669 q 497 810 535 778 q 401 842 460 842 q 341 829 367 842 q 292 797 315 817 l 247 828 l 274 1090 l 596 1090 l 596 1013 l 346 1013 l 332 879 q 380 895 354 890 q 432 900 406 900 q 506 888 471 900 q 567 853 542 876 q 608 797 593 831 q 624 718 624 763 q 608 642 624 676 q 564 583 592 608 q 498 545 536 558 q 415 532 460 532 z "},"⁶":{"ha":833,"x_min":210,"x_max":628,"o":"m 435 532 q 270 604 331 532 q 210 804 210 676 q 229 938 210 881 q 282 1032 249 994 q 361 1088 315 1069 q 460 1107 407 1107 q 546 1095 513 1107 q 607 1064 579 1083 l 569 1003 q 522 1027 547 1018 q 463 1036 496 1036 q 349 986 396 1036 q 294 832 301 936 q 444 889 356 889 q 581 841 533 889 q 628 715 628 793 q 613 643 628 676 q 572 585 599 610 q 511 546 546 560 q 435 532 476 532 m 433 603 q 514 633 482 603 q 546 714 546 664 q 516 793 546 763 q 428 824 486 824 q 360 811 393 824 q 294 763 328 799 q 338 643 301 683 q 433 603 375 603 z "},"⁷":{"ha":833,"x_min":217,"x_max":624,"o":"m 343 549 q 360 678 347 619 q 395 793 374 738 q 449 902 417 849 q 524 1014 481 956 l 217 1014 l 217 1090 l 624 1090 l 624 1040 q 538 917 572 975 q 483 800 504 858 q 452 681 463 742 q 438 549 442 619 l 343 549 z "},"⁸":{"ha":833,"x_min":210,"x_max":619,"o":"m 415 532 q 263 575 315 532 q 210 681 210 618 q 241 772 210 733 q 326 833 272 810 l 326 839 q 256 893 281 867 q 232 964 232 919 q 282 1067 232 1028 q 415 1107 332 1107 q 551 1069 501 1107 q 601 964 601 1031 q 574 885 601 915 q 506 833 546 854 l 506 828 q 592 768 564 801 q 619 683 619 735 q 565 575 619 618 q 415 532 511 532 m 447 857 q 505 908 490 885 q 519 960 519 932 q 491 1017 519 996 q 414 1039 463 1039 q 340 1017 367 1039 q 314 961 314 996 q 351 899 314 921 q 447 857 389 876 m 415 596 q 505 623 474 596 q 536 688 536 650 q 524 729 536 713 q 490 758 511 746 q 440 781 468 771 q 382 804 413 792 q 313 751 333 779 q 293 688 293 722 q 323 624 293 651 q 415 596 353 596 z "},"⁹":{"ha":833,"x_min":201,"x_max":621,"o":"m 403 814 q 469 826 438 814 q 535 874 501 839 q 491 995 528 954 q 397 1036 454 1036 q 317 1005 349 1036 q 285 925 285 974 q 315 845 285 876 q 403 814 344 814 m 371 532 q 283 544 318 532 q 224 574 249 556 l 260 636 q 308 612 282 621 q 368 603 335 603 q 481 652 435 603 q 535 806 528 701 q 385 750 474 750 q 249 798 297 750 q 201 922 201 846 q 216 995 201 961 q 257 1054 231 1029 q 319 1093 283 1079 q 396 1107 354 1107 q 560 1035 499 1107 q 621 833 621 963 q 601 700 621 757 q 549 606 582 643 q 469 550 515 568 q 371 532 424 532 z "},"⁽":{"ha":833,"x_min":328,"x_max":540,"o":"m 478 439 q 409 527 438 485 q 363 615 381 569 q 336 710 344 660 q 328 818 328 760 q 336 926 328 876 q 363 1020 344 975 q 409 1108 381 1065 q 478 1197 438 1151 l 540 1161 q 440 992 467 1075 q 414 818 414 910 q 440 644 414 726 q 540 475 467 563 l 478 439 z "},"⁾":{"ha":833,"x_min":293,"x_max":506,"o":"m 357 439 l 293 475 q 393 644 367 563 q 419 818 419 726 q 393 992 419 910 q 293 1161 367 1075 l 357 1197 q 424 1108 396 1151 q 471 1020 453 1065 q 497 926 489 975 q 506 818 506 876 q 497 710 506 760 q 471 615 489 660 q 424 527 453 569 q 357 439 396 485 z "},"₀":{"ha":833,"x_min":196,"x_max":638,"o":"m 417 -262 q 256 -187 317 -262 q 196 26 196 -112 q 256 238 196 164 q 417 313 317 313 q 577 238 517 313 q 638 26 638 164 q 577 -187 638 -112 q 417 -262 517 -262 m 417 -192 q 514 -137 476 -192 q 551 26 551 -83 q 514 188 551 135 q 417 242 476 242 q 319 188 357 242 q 282 26 282 135 q 319 -137 282 -83 q 417 -192 357 -192 z "},"₁":{"ha":833,"x_min":243,"x_max":661,"o":"m 243 -246 l 243 -171 l 414 -171 l 414 182 l 268 182 l 268 239 q 362 260 325 247 q 431 296 399 272 l 503 296 l 503 -171 l 661 -171 l 661 -246 l 243 -246 z "},"₂":{"ha":833,"x_min":203,"x_max":619,"o":"m 225 -246 l 219 -194 q 342 -90 289 -135 q 432 -7 396 -44 q 486 62 468 31 q 504 124 504 93 q 472 207 504 176 q 386 238 440 238 q 313 215 347 238 q 256 158 279 193 l 203 207 q 287 284 235 256 q 399 313 339 313 q 540 268 486 313 q 593 136 593 224 q 576 62 593 97 q 528 -10 558 26 q 456 -85 497 -46 q 364 -171 414 -124 l 619 -171 l 619 -246 l 225 -246 z "},"₃":{"ha":833,"x_min":197,"x_max":618,"o":"m 413 -262 q 285 -233 342 -262 q 197 -157 229 -204 l 256 -111 q 322 -172 282 -151 q 407 -192 361 -192 q 493 -167 457 -192 q 529 -96 529 -142 q 347 1 529 1 l 347 57 q 469 85 431 57 q 508 156 508 114 q 478 218 508 194 q 397 242 449 242 q 329 224 363 242 q 272 175 296 206 l 219 222 q 302 289 256 265 q 410 313 349 313 q 481 302 447 313 q 541 273 515 292 q 582 227 567 254 q 597 167 597 200 q 570 86 597 118 q 488 33 543 54 q 583 -12 547 22 q 618 -100 618 -47 q 602 -167 618 -137 q 558 -219 586 -197 q 492 -251 529 -240 q 413 -262 454 -262 z "},"₄":{"ha":833,"x_min":206,"x_max":642,"o":"m 481 -246 l 481 -101 l 206 -101 l 206 -56 l 419 313 l 485 278 l 301 -37 l 481 -37 l 481 124 l 561 124 l 561 -37 l 642 -37 l 642 -101 l 561 -101 l 561 -246 l 481 -246 z "},"₅":{"ha":833,"x_min":197,"x_max":624,"o":"m 415 -262 q 285 -233 339 -262 q 197 -157 231 -204 l 256 -111 q 410 -192 311 -192 q 499 -158 464 -192 q 535 -72 535 -125 q 497 15 535 -17 q 401 47 460 47 q 341 35 367 47 q 292 3 315 22 l 247 33 l 274 296 l 596 296 l 596 218 l 346 218 l 332 85 q 380 101 354 96 q 432 106 406 106 q 506 94 471 106 q 567 59 542 82 q 608 2 593 36 q 624 -76 624 -32 q 608 -152 624 -118 q 564 -211 592 -186 q 498 -249 536 -236 q 415 -262 460 -262 z "},"₆":{"ha":833,"x_min":210,"x_max":628,"o":"m 435 -262 q 270 -190 331 -262 q 210 10 210 -118 q 229 143 210 86 q 282 238 249 200 q 361 294 315 275 q 460 313 407 313 q 546 301 513 313 q 607 269 579 289 l 569 208 q 522 233 547 224 q 463 242 496 242 q 349 192 396 242 q 294 38 301 142 q 444 94 356 94 q 581 47 533 94 q 628 -79 628 -1 q 613 -151 628 -118 q 572 -210 599 -185 q 511 -249 546 -235 q 435 -262 476 -262 m 433 -192 q 514 -161 482 -192 q 546 -81 546 -131 q 516 -1 546 -32 q 428 29 486 29 q 360 17 393 29 q 294 -32 328 4 q 338 -151 301 -111 q 433 -192 375 -192 z "},"₇":{"ha":833,"x_min":217,"x_max":624,"o":"m 343 -246 q 360 -116 347 -175 q 395 -1 374 -57 q 449 108 417 54 q 524 219 481 161 l 217 219 l 217 296 l 624 296 l 624 246 q 538 122 572 181 q 483 6 504 64 q 452 -114 463 -53 q 438 -246 442 -175 l 343 -246 z "},"₈":{"ha":833,"x_min":210,"x_max":619,"o":"m 415 -262 q 263 -219 315 -262 q 210 -114 210 -176 q 241 -23 210 -61 q 326 39 272 15 l 326 44 q 256 99 281 72 q 232 169 232 125 q 282 273 232 233 q 415 313 332 313 q 551 274 501 313 q 601 169 601 236 q 574 90 601 121 q 506 39 546 60 l 506 33 q 592 -26 564 7 q 619 -111 619 -60 q 565 -219 619 -176 q 415 -262 511 -262 m 447 63 q 505 114 490 90 q 519 165 519 138 q 491 223 519 201 q 414 244 463 244 q 340 223 367 244 q 314 167 314 201 q 351 104 314 126 q 447 63 389 82 m 415 -199 q 505 -172 474 -199 q 536 -107 536 -144 q 524 -65 536 -82 q 490 -36 511 -49 q 440 -13 468 -24 q 382 10 413 -3 q 313 -44 333 -15 q 293 -107 293 -72 q 323 -171 293 -143 q 415 -199 353 -199 z "},"₉":{"ha":833,"x_min":201,"x_max":621,"o":"m 403 19 q 469 32 438 19 q 535 79 501 44 q 491 201 528 160 q 397 242 454 242 q 317 210 349 242 q 285 131 285 179 q 315 51 285 82 q 403 19 344 19 m 371 -262 q 283 -251 318 -262 q 224 -221 249 -239 l 260 -158 q 308 -183 282 -174 q 368 -192 335 -192 q 481 -142 435 -192 q 535 11 528 -93 q 385 -44 474 -44 q 249 3 297 -44 q 201 128 201 51 q 216 201 201 167 q 257 260 231 235 q 319 299 283 285 q 396 313 354 313 q 560 240 499 313 q 621 39 621 168 q 601 -94 621 -37 q 549 -189 582 -151 q 469 -244 515 -226 q 371 -262 424 -262 z "},"₍":{"ha":833,"x_min":328,"x_max":540,"o":"m 478 -356 q 409 -267 438 -310 q 363 -180 381 -225 q 336 -85 344 -135 q 328 24 328 -35 q 336 131 328 82 q 363 226 344 181 q 409 314 381 271 q 478 403 438 357 l 540 367 q 440 198 467 281 q 414 24 414 115 q 440 -150 414 -68 q 540 -319 467 -232 l 478 -356 z "},"₎":{"ha":833,"x_min":293,"x_max":506,"o":"m 357 -356 l 293 -319 q 393 -150 367 -232 q 419 24 419 -68 q 393 198 419 115 q 293 367 367 281 l 357 403 q 424 314 396 357 q 471 226 453 271 q 497 131 489 181 q 506 24 506 82 q 497 -85 506 -35 q 471 -180 489 -135 q 424 -267 453 -225 q 357 -356 396 -310 z "},"ª":{"ha":833,"x_min":226,"x_max":619,"o":"m 374 538 q 269 572 311 538 q 226 665 226 606 q 300 778 226 739 q 531 831 374 818 q 506 904 528 874 q 426 935 483 935 q 349 921 386 935 q 279 888 311 907 l 244 947 q 333 988 281 969 q 442 1006 385 1006 q 576 956 532 1006 q 619 819 619 907 l 619 549 l 546 549 l 540 601 l 538 601 q 461 556 503 574 q 374 538 419 538 m 396 606 q 465 620 432 606 q 531 661 497 635 l 531 776 q 362 740 411 765 q 313 674 313 714 q 338 622 313 638 q 396 606 363 606 z "},"º":{"ha":833,"x_min":197,"x_max":636,"o":"m 417 538 q 333 553 372 538 q 263 599 293 569 q 215 672 233 629 q 197 771 197 715 q 215 870 197 826 q 263 944 233 914 q 333 990 293 975 q 417 1006 372 1006 q 501 990 461 1006 q 571 944 540 975 q 619 870 601 914 q 636 771 636 826 q 619 672 636 715 q 571 599 601 629 q 501 553 540 569 q 417 538 461 538 m 417 610 q 510 654 476 610 q 544 771 544 699 q 510 889 544 844 q 417 933 476 933 q 323 889 357 933 q 289 771 289 844 q 323 654 289 699 q 417 610 357 610 z "},"ᵃ":{"ha":833,"x_min":226,"x_max":619,"o":"m 374 538 q 269 572 311 538 q 226 665 226 606 q 300 778 226 739 q 531 831 374 818 q 506 904 528 874 q 426 935 483 935 q 349 921 386 935 q 279 888 311 907 l 244 947 q 333 988 281 969 q 442 1006 385 1006 q 576 956 532 1006 q 619 819 619 907 l 619 549 l 546 549 l 540 601 l 538 601 q 461 556 503 574 q 374 538 419 538 m 396 606 q 465 620 432 606 q 531 661 497 635 l 531 776 q 362 740 411 765 q 313 674 313 714 q 338 622 313 638 q 396 606 363 606 z "},"ᵇ":{"ha":833,"x_min":239,"x_max":656,"o":"m 454 538 q 386 552 421 538 q 319 593 351 567 l 318 593 l 308 549 l 239 549 l 239 1203 l 328 1203 l 328 1024 l 325 946 q 394 989 357 972 q 469 1006 431 1006 q 608 944 561 1006 q 656 778 656 882 q 639 676 656 721 q 594 601 622 632 q 530 553 567 569 q 454 538 493 538 m 436 611 q 528 654 492 611 q 564 778 564 697 q 537 890 564 849 q 446 932 510 932 q 328 876 392 932 l 328 653 q 385 620 357 629 q 436 611 413 611 z "},"ᶜ":{"ha":833,"x_min":251,"x_max":640,"o":"m 481 538 q 390 553 432 538 q 317 599 347 569 q 269 672 286 629 q 251 771 251 715 q 271 870 251 826 q 323 944 290 914 q 398 990 356 975 q 488 1006 440 1006 q 571 990 536 1006 q 631 953 606 975 l 586 896 q 542 923 565 913 q 492 933 519 933 q 383 889 425 933 q 342 771 342 844 q 382 654 342 699 q 489 610 422 610 q 551 622 524 610 q 603 651 579 635 l 640 594 q 566 552 607 567 q 481 538 525 538 z "},"ᵈ":{"ha":833,"x_min":190,"x_max":608,"o":"m 383 538 q 243 598 296 538 q 190 771 190 658 q 207 869 190 825 q 251 943 224 913 q 316 990 279 974 q 393 1006 353 1006 q 463 992 433 1006 q 522 954 493 978 l 519 1031 l 519 1203 l 608 1203 l 608 549 l 535 549 l 528 599 l 525 599 q 460 556 497 574 q 383 538 424 538 m 404 611 q 519 667 465 611 l 519 889 q 464 922 490 913 q 410 932 438 932 q 319 890 356 932 q 282 772 282 847 q 314 653 282 694 q 404 611 346 611 z "},"ᵉ":{"ha":833,"x_min":201,"x_max":636,"o":"m 444 538 q 350 553 394 538 q 272 599 306 569 q 220 672 239 629 q 201 771 201 715 q 220 869 201 825 q 271 942 239 913 q 344 989 303 972 q 429 1006 385 1006 q 583 949 529 1006 q 636 796 636 892 q 635 769 636 781 q 632 747 633 757 l 285 747 q 341 641 293 676 q 454 606 389 606 q 524 615 492 606 q 586 640 557 624 l 617 585 q 444 538 542 538 m 433 936 q 341 906 383 936 q 288 814 299 876 l 560 814 q 519 908 553 881 q 433 936 485 936 z "},"ᶠ":{"ha":833,"x_min":275,"x_max":699,"o":"m 385 549 l 385 925 l 275 925 l 275 992 l 385 994 l 385 1032 q 430 1163 385 1114 q 571 1213 475 1213 q 699 1189 636 1213 l 679 1124 q 581 1142 633 1142 q 497 1113 522 1142 q 472 1035 472 1083 l 472 994 l 650 994 l 650 925 l 472 925 l 472 549 l 385 549 z "},"ᵍ":{"ha":833,"x_min":207,"x_max":669,"o":"m 414 346 q 262 376 317 346 q 207 467 207 407 q 281 564 207 522 l 281 567 q 249 596 263 578 q 235 642 235 614 q 249 686 235 664 q 289 725 264 708 l 289 729 q 249 776 265 747 q 232 844 232 804 q 247 912 232 882 q 285 963 261 942 q 342 994 310 983 q 413 1006 375 1006 q 449 1003 432 1006 q 481 994 465 1001 l 667 994 l 667 928 l 553 928 q 578 891 568 913 q 588 843 588 869 q 574 777 588 806 q 538 729 561 749 q 482 699 514 710 q 413 689 450 689 q 339 704 381 689 q 308 657 308 685 q 396 610 308 610 l 494 610 q 626 585 583 610 q 669 503 669 560 q 651 441 669 469 q 600 392 633 413 q 519 358 567 371 q 414 346 472 346 m 413 747 q 481 773 453 747 q 508 844 508 799 q 481 917 508 889 q 413 944 453 944 q 344 917 372 944 q 317 844 317 889 q 344 773 317 799 q 413 747 372 747 m 422 404 q 541 430 497 404 q 585 488 585 456 q 559 527 585 517 q 485 538 533 538 l 403 538 q 366 539 382 538 q 335 544 350 540 q 294 512 306 529 q 282 476 282 494 q 317 424 282 444 q 422 404 353 404 z "},"ʰ":{"ha":833,"x_min":243,"x_max":639,"o":"m 243 549 l 243 1203 l 332 1203 l 332 1024 l 326 928 q 399 983 360 960 q 488 1006 438 1006 q 603 960 567 1006 q 639 829 639 915 l 639 549 l 550 549 l 550 818 q 528 903 550 876 q 457 931 507 931 q 394 913 421 931 q 332 863 367 896 l 332 549 l 243 549 z "},"ⁱ":{"ha":833,"x_min":243,"x_max":544,"o":"m 439 549 l 439 925 l 243 925 l 243 994 l 528 994 l 528 549 l 439 549 m 476 1082 q 428 1099 447 1082 q 410 1144 410 1117 q 428 1192 410 1174 q 476 1210 447 1210 q 525 1192 506 1210 q 544 1144 544 1174 q 525 1099 544 1117 q 476 1082 506 1082 z "},"ʲ":{"ha":833,"x_min":194,"x_max":528,"o":"m 318 353 q 251 362 282 353 q 194 383 219 371 l 222 449 q 269 430 246 436 q 314 424 293 424 q 401 453 379 424 q 424 539 424 483 l 424 925 l 226 925 l 226 994 l 513 994 l 513 544 q 503 468 513 503 q 472 408 494 433 q 411 367 449 382 q 318 353 374 353 m 461 1082 q 413 1099 432 1082 q 393 1144 393 1117 q 413 1192 393 1174 q 461 1210 432 1210 q 509 1192 490 1210 q 528 1144 528 1174 q 509 1099 528 1117 q 461 1082 490 1082 z "},"ᵏ":{"ha":833,"x_min":263,"x_max":696,"o":"m 263 549 l 263 1203 l 351 1203 l 351 772 l 354 772 l 575 994 l 675 994 l 501 817 l 696 549 l 597 549 l 449 758 l 351 665 l 351 549 l 263 549 z "},"ˡ":{"ha":833,"x_min":272,"x_max":636,"o":"m 529 538 q 419 578 454 538 q 385 699 385 619 l 385 1132 l 272 1132 l 272 1203 l 474 1203 l 474 693 q 494 629 474 649 q 550 610 514 610 q 619 624 578 610 l 636 556 q 585 543 608 549 q 529 538 561 538 z "},"ᵐ":{"ha":833,"x_min":97,"x_max":735,"o":"m 97 549 l 97 994 l 167 994 l 175 932 l 179 932 q 241 984 207 963 q 319 1006 275 1006 q 444 922 415 1006 q 513 981 476 956 q 596 1006 550 1006 q 702 957 669 1006 q 735 831 735 908 l 735 549 l 649 549 l 649 818 q 632 901 649 871 q 567 932 615 932 q 517 917 543 932 q 460 867 492 901 l 460 549 l 374 549 l 374 818 q 357 901 374 871 q 292 932 340 932 q 241 917 267 932 q 183 867 215 901 l 183 549 l 97 549 z "},"ⁿ":{"ha":833,"x_min":243,"x_max":639,"o":"m 243 549 l 243 994 l 317 994 l 324 928 l 328 928 q 398 983 360 960 q 488 1006 436 1006 q 602 960 565 1006 q 639 829 639 915 l 639 549 l 550 549 l 550 818 q 528 903 550 876 q 457 931 507 931 q 394 913 421 931 q 332 863 367 896 l 332 549 l 243 549 z "},"ᵒ":{"ha":833,"x_min":197,"x_max":636,"o":"m 417 538 q 333 553 372 538 q 263 599 293 569 q 215 672 233 629 q 197 771 197 715 q 215 870 197 826 q 263 944 233 914 q 333 990 293 975 q 417 1006 372 1006 q 501 990 461 1006 q 571 944 540 975 q 619 870 601 914 q 636 771 636 826 q 619 672 636 715 q 571 599 601 629 q 501 553 540 569 q 417 538 461 538 m 417 610 q 510 654 476 610 q 544 771 544 699 q 510 889 544 844 q 417 933 476 933 q 323 889 357 933 q 289 771 289 844 q 323 654 289 699 q 417 610 357 610 z "},"ᵖ":{"ha":833,"x_min":239,"x_max":656,"o":"m 239 364 l 239 994 l 311 994 l 318 944 l 322 944 q 392 988 354 969 q 471 1006 429 1006 q 608 944 561 1006 q 656 778 656 882 q 639 676 656 721 q 594 601 622 632 q 530 553 567 569 q 454 538 493 538 q 325 588 390 538 l 328 511 l 328 364 l 239 364 m 436 611 q 528 654 492 611 q 564 778 564 697 q 537 890 564 849 q 446 932 510 932 q 389 918 418 932 q 328 876 360 904 l 328 653 q 385 620 357 629 q 436 611 413 611 z "},"ʳ":{"ha":833,"x_min":338,"x_max":689,"o":"m 338 549 l 338 994 l 413 994 l 419 890 l 422 890 q 500 975 454 944 q 600 1006 546 1006 q 689 988 649 1006 l 671 913 q 630 923 647 919 q 588 926 613 926 q 502 899 544 926 q 426 801 460 871 l 426 549 l 338 549 z "},"ˢ":{"ha":833,"x_min":225,"x_max":626,"o":"m 428 538 q 315 556 368 538 q 225 600 263 574 l 267 657 q 341 618 303 632 q 431 604 379 604 q 513 622 486 604 q 539 667 539 640 q 528 695 539 683 q 501 716 518 707 q 461 732 483 725 q 417 746 439 739 q 358 767 388 756 q 304 792 328 778 q 265 828 281 807 q 250 876 250 849 q 299 969 250 932 q 438 1006 349 1006 q 531 990 488 1006 q 607 954 575 975 l 565 899 q 506 928 538 917 q 438 939 475 939 q 362 922 385 939 q 339 881 339 904 q 349 856 339 867 q 375 838 358 846 q 413 822 392 829 q 456 808 433 815 q 517 788 486 799 q 572 763 547 778 q 611 726 596 747 q 626 672 626 704 q 576 577 626 617 q 428 538 525 538 z "},"ᵗ":{"ha":833,"x_min":228,"x_max":643,"o":"m 513 538 q 374 589 413 538 q 335 725 335 640 l 335 925 l 228 925 l 228 992 l 339 994 l 350 1133 l 424 1133 l 424 994 l 625 994 l 625 925 l 424 925 l 424 724 q 447 636 424 665 q 533 607 471 607 q 583 613 561 607 q 625 628 604 618 l 643 563 q 582 544 615 551 q 513 538 549 538 z "},"ᵘ":{"ha":833,"x_min":221,"x_max":615,"o":"m 369 538 q 257 583 293 538 q 221 713 221 628 l 221 994 l 310 994 l 310 724 q 331 640 310 667 q 400 614 351 614 q 465 630 436 614 q 526 683 493 646 l 526 994 l 615 994 l 615 549 l 543 549 l 535 618 l 532 618 q 460 560 500 582 q 369 538 421 538 z "},"ᵛ":{"ha":833,"x_min":193,"x_max":631,"o":"m 363 549 l 193 994 l 285 994 l 371 750 q 392 683 382 717 q 414 618 403 650 l 417 618 q 438 683 428 650 q 458 750 447 717 l 544 994 l 631 994 l 465 549 l 363 549 z "},"ʷ":{"ha":833,"x_min":72,"x_max":704,"o":"m 196 549 l 72 994 l 161 994 l 222 746 l 250 619 l 254 619 l 285 746 l 351 994 l 429 994 l 499 746 l 528 619 l 533 619 l 563 746 l 622 994 l 704 994 l 583 549 l 479 549 l 421 775 l 390 901 l 388 901 l 360 775 l 299 549 l 196 549 z "},"ˣ":{"ha":833,"x_min":221,"x_max":638,"o":"m 221 549 l 375 782 l 233 994 l 328 994 l 388 903 q 410 865 399 883 q 433 828 422 847 l 438 828 q 459 865 449 847 q 481 903 469 883 l 533 994 l 628 994 l 483 772 l 638 549 l 542 549 l 476 644 q 451 685 465 665 q 424 725 438 706 l 421 725 q 398 685 410 706 q 374 644 386 665 l 314 549 l 221 549 z "},"ʸ":{"ha":833,"x_min":194,"x_max":639,"o":"m 275 358 q 242 361 257 358 q 215 368 228 364 l 233 438 q 250 433 240 435 q 269 431 260 431 q 335 456 310 431 q 376 518 361 481 l 386 550 l 194 994 l 283 994 l 379 760 q 402 698 390 731 q 426 633 414 665 l 429 633 q 449 697 440 664 q 469 760 458 729 l 553 994 l 639 994 l 458 518 q 429 454 446 483 q 390 403 413 425 q 340 370 368 382 q 275 358 311 358 z "},"ᶻ":{"ha":833,"x_min":203,"x_max":633,"o":"m 203 549 l 203 594 l 499 925 l 236 925 l 236 994 l 624 994 l 624 949 l 329 618 l 633 618 l 633 549 l 203 549 z "},"ₔ":{"ha":833,"x_min":197,"x_max":632,"o":"m 414 538 q 324 553 364 538 q 255 599 283 569 q 212 667 226 628 q 197 754 197 707 q 199 782 197 769 q 201 803 200 794 l 549 803 q 497 905 540 871 q 390 939 453 939 q 260 904 321 939 l 229 960 q 308 996 265 983 q 401 1008 351 1008 q 492 992 450 1008 q 566 946 535 976 q 615 872 597 915 q 632 774 632 829 q 614 676 632 719 q 566 601 596 632 q 497 554 536 571 q 414 538 457 538 m 411 607 q 499 638 461 607 q 547 736 538 669 l 274 736 q 317 637 279 667 q 411 607 356 607 z "},"ˠ":{"ha":833,"x_min":203,"x_max":631,"o":"m 418 346 q 335 376 364 346 q 306 456 306 406 q 320 520 306 488 q 361 601 335 553 l 203 996 l 293 996 l 375 765 q 396 708 386 733 q 415 651 406 682 l 419 651 q 440 708 431 682 q 461 765 450 733 l 543 996 l 631 996 l 474 603 q 515 521 500 554 q 529 456 529 488 q 501 376 529 406 q 418 346 472 346 m 418 404 q 447 417 438 404 q 456 449 456 429 q 419 561 456 496 l 415 561 q 389 500 399 529 q 379 449 379 471 q 389 417 379 429 q 418 404 399 404 z "},"ˤ":{"ha":833,"x_min":222,"x_max":628,"o":"m 392 549 l 392 797 q 326 844 357 819 q 272 896 294 868 q 235 956 249 924 q 222 1029 222 989 q 240 1106 222 1072 q 287 1163 257 1140 q 356 1198 317 1186 q 438 1210 394 1210 q 551 1185 504 1210 q 628 1128 597 1160 l 581 1072 q 522 1117 554 1099 q 444 1136 489 1136 q 348 1107 385 1136 q 311 1026 311 1078 q 353 923 311 968 q 479 833 394 878 l 479 549 l 392 549 z "},"¤":{"ha":833,"x_min":81,"x_max":753,"o":"m 142 115 l 81 178 l 197 296 q 160 368 174 328 q 147 457 147 408 q 160 547 147 506 q 196 619 172 588 l 81 739 l 142 801 l 263 676 q 417 728 329 728 q 571 676 503 728 l 692 801 l 753 739 l 636 619 q 673 547 660 588 q 686 457 686 506 q 673 368 686 408 q 636 296 660 328 l 753 178 l 692 115 l 569 239 q 498 199 538 213 q 417 186 458 186 q 263 239 331 186 l 142 115 m 417 271 q 480 284 450 271 q 532 322 510 297 q 567 381 554 347 q 581 457 581 415 q 567 533 581 499 q 532 592 554 567 q 480 630 510 617 q 417 643 450 643 q 353 630 383 643 q 301 592 324 617 q 266 533 279 567 q 253 457 253 499 q 266 381 253 415 q 301 322 279 347 q 353 284 324 297 q 417 271 383 271 z "},"$":{"ha":833,"x_min":118,"x_max":711,"o":"m 118 157 l 172 236 q 288 170 225 199 q 431 142 351 142 q 556 176 514 142 q 599 263 599 210 q 566 334 599 306 q 485 385 533 363 q 378 428 436 407 q 272 477 321 449 q 191 545 224 506 q 158 646 158 585 q 220 789 158 733 q 383 856 282 844 l 383 1039 l 467 1039 l 467 857 q 594 821 543 850 q 688 751 646 792 l 626 685 q 581 717 603 703 q 536 742 560 732 q 485 758 513 753 q 422 764 457 764 q 310 733 351 764 q 269 649 269 701 q 302 585 269 610 q 384 539 335 560 q 490 497 433 518 q 597 447 547 476 q 678 376 646 418 q 711 271 711 335 q 694 188 711 226 q 644 122 676 150 q 566 74 611 93 q 467 50 521 56 l 467 -153 l 383 -153 l 383 49 q 236 86 306 56 q 118 157 167 117 z "},"£":{"ha":833,"x_min":107,"x_max":738,"o":"m 108 0 l 108 69 q 238 174 196 108 q 281 319 281 240 q 269 396 281 356 l 107 396 l 107 468 l 244 474 q 215 560 229 518 q 200 647 200 603 q 221 753 200 706 q 280 833 242 800 q 372 885 318 867 q 492 903 425 903 q 637 873 578 903 q 736 799 696 843 l 669 733 q 597 786 638 765 q 497 807 556 807 q 358 762 406 807 q 310 644 310 717 q 323 559 310 600 q 351 474 336 518 l 614 474 l 614 396 l 374 396 q 382 318 382 358 q 357 196 382 244 q 282 104 332 147 l 282 99 l 738 99 l 738 0 l 108 0 z "},"¥":{"ha":833,"x_min":74,"x_max":760,"o":"m 358 0 l 358 219 l 107 219 l 107 286 l 358 286 l 358 376 l 107 376 l 107 442 l 331 442 l 74 886 l 192 886 l 319 649 q 366 556 343 603 q 415 461 389 510 l 421 461 q 469 556 446 510 q 518 649 493 603 l 646 886 l 760 886 l 501 442 l 726 442 l 726 376 l 472 376 l 472 286 l 726 286 l 726 219 l 472 219 l 472 0 l 358 0 z "},"€":{"ha":833,"x_min":81,"x_max":786,"o":"m 519 -17 q 289 74 382 -17 q 169 328 196 164 l 81 328 l 81 389 l 163 394 q 161 418 161 406 q 161 442 161 431 q 161 465 161 453 q 163 488 161 476 l 81 488 l 81 549 l 169 556 q 294 811 196 719 q 539 903 392 903 q 671 872 610 903 q 774 794 732 840 l 706 729 q 628 788 669 765 q 535 811 588 811 q 370 744 433 811 q 288 556 307 676 l 696 556 l 696 488 l 281 488 q 279 467 279 476 q 279 446 279 457 q 279 421 279 433 q 281 396 279 408 l 640 396 l 640 328 l 289 328 q 369 142 308 208 q 526 75 431 75 q 631 100 586 75 q 718 174 676 125 l 786 113 q 669 17 733 51 q 519 -17 606 -17 z "},"¢":{"ha":833,"x_min":157,"x_max":703,"o":"m 269 431 q 313 276 269 338 q 436 197 357 215 l 436 663 q 314 583 358 644 q 269 431 269 522 m 436 -46 l 436 99 q 322 131 374 106 q 234 198 271 156 q 177 299 197 240 q 157 431 157 357 q 178 560 157 503 q 238 660 200 618 q 326 726 275 701 q 436 760 378 751 l 436 907 l 507 907 l 507 764 q 613 738 568 761 q 689 683 657 714 l 633 611 q 574 651 606 636 q 507 669 543 667 l 507 192 q 588 213 551 194 q 653 257 624 232 l 703 185 q 611 125 661 149 q 507 97 561 101 l 507 -46 l 436 -46 z "},"ƒ":{"ha":833,"x_min":68,"x_max":744,"o":"m 183 -135 q 118 -127 147 -135 q 68 -110 89 -119 l 90 -24 q 130 -36 110 -31 q 172 -42 150 -42 q 276 13 244 -42 q 321 175 307 68 l 354 479 l 210 479 l 210 561 l 307 567 l 364 567 l 372 644 q 446 856 390 783 q 618 928 501 928 q 688 919 654 928 q 744 900 721 911 l 717 814 q 676 829 697 824 q 624 835 654 835 q 565 819 589 835 q 524 779 540 804 q 497 722 507 754 q 483 654 488 689 l 474 567 l 671 567 l 671 479 l 464 479 l 426 150 q 402 34 418 86 q 358 -56 386 -18 q 288 -114 331 -93 q 183 -135 244 -135 z "},"₡":{"ha":833,"x_min":133,"x_max":758,"o":"m 507 811 q 493 811 500 811 q 479 810 486 811 l 396 100 q 478 76 435 78 l 564 803 q 507 811 536 811 m 251 446 q 335 150 251 250 l 410 792 q 292 667 332 756 q 251 446 251 578 m 300 -142 l 319 29 q 183 185 233 81 q 133 442 133 290 q 210 744 133 628 q 421 893 288 861 l 439 1042 l 506 1031 l 490 903 l 514 903 q 544 901 529 903 q 575 896 560 899 l 592 1042 l 658 1031 l 640 874 q 746 794 700 844 l 678 729 q 628 772 657 753 l 547 79 q 624 113 589 89 q 690 174 658 136 l 758 113 q 660 27 714 60 q 536 -14 606 -6 l 519 -153 l 453 -142 l 468 -15 q 385 0 426 -14 l 367 -153 l 300 -142 z "},"₤":{"ha":833,"x_min":108,"x_max":738,"o":"m 108 0 l 108 69 q 238 174 196 108 q 281 319 281 240 l 281 328 l 108 328 l 108 389 l 229 396 l 269 396 q 256 442 264 419 q 239 488 247 464 l 108 488 l 108 551 l 215 556 q 204 601 208 579 q 200 647 200 624 q 221 753 200 706 q 280 833 242 800 q 372 885 318 867 q 492 903 425 903 q 637 873 578 903 q 736 799 696 843 l 669 733 q 597 786 638 765 q 497 807 556 807 q 358 762 406 807 q 310 644 310 717 q 313 599 310 621 q 324 556 317 578 l 614 556 l 614 488 l 346 488 q 360 442 353 465 q 374 396 368 419 l 614 396 l 614 328 l 382 328 l 382 318 q 357 196 382 244 q 282 104 332 147 l 282 99 l 738 99 l 738 0 l 108 0 z "},"₦":{"ha":833,"x_min":64,"x_max":767,"o":"m 236 782 l 249 556 l 331 556 l 242 782 l 236 782 m 592 103 l 597 103 l 585 328 l 504 328 l 592 103 m 168 0 l 168 328 l 64 328 l 64 388 l 168 394 l 168 489 l 64 489 l 64 549 l 168 556 l 168 886 l 285 886 l 415 556 l 575 556 l 575 886 l 665 886 l 665 556 l 767 556 l 767 489 l 665 489 l 665 394 l 767 394 l 767 328 l 665 328 l 665 0 l 549 0 l 419 328 l 258 328 l 258 0 l 168 0 m 582 394 l 576 489 l 442 489 l 479 394 l 582 394 m 393 394 l 357 489 l 251 489 l 257 394 l 393 394 z "},"₧":{"ha":833,"x_min":58,"x_max":810,"o":"m 188 0 l 188 579 l 58 579 l 58 650 l 188 657 l 188 886 l 393 886 q 510 874 456 886 q 605 834 564 861 q 672 763 646 807 q 704 657 697 719 l 810 657 l 810 579 l 704 579 q 671 473 697 518 q 603 399 644 428 q 509 355 563 369 q 393 340 456 340 l 296 340 l 296 0 l 188 0 m 296 807 l 296 657 l 593 657 q 528 773 582 739 q 378 807 474 807 l 296 807 m 296 419 l 378 419 q 528 460 474 419 q 593 579 582 500 l 296 579 l 296 419 z "},"₩":{"ha":833,"x_min":39,"x_max":792,"o":"m 414 733 l 394 492 l 439 492 l 419 733 l 414 733 m 567 94 l 572 94 l 589 275 l 603 411 l 535 411 l 550 275 l 567 94 m 194 0 l 144 411 l 39 411 l 39 483 l 135 492 l 88 886 l 193 886 l 233 492 l 315 492 l 353 831 l 489 831 l 526 492 l 610 492 l 649 886 l 747 886 l 704 492 l 792 492 l 792 411 l 694 411 l 650 0 l 494 0 l 447 411 l 386 411 l 342 0 l 194 0 m 269 94 l 275 94 l 292 275 l 307 411 l 242 411 l 256 275 l 269 94 z "},"₫":{"ha":833,"x_min":151,"x_max":758,"o":"m 383 153 q 215 220 278 153 q 151 415 151 288 q 172 518 151 472 q 226 597 192 564 q 303 647 260 629 q 393 664 347 664 q 484 647 447 664 q 554 600 521 631 l 558 600 l 551 715 l 551 763 l 336 763 l 336 831 l 551 831 l 551 924 l 650 924 l 650 831 l 758 831 l 758 769 l 650 763 l 650 167 l 569 167 l 561 231 l 557 231 q 481 174 524 196 q 383 153 438 153 m 404 235 q 479 252 443 235 q 551 308 515 269 l 551 524 q 483 567 514 554 q 410 581 451 581 q 349 568 378 581 q 299 533 321 556 q 265 481 278 511 q 253 417 253 451 q 292 283 253 331 q 404 235 332 235 m 168 0 l 168 68 l 693 68 l 693 0 l 168 0 z "},"₱":{"ha":833,"x_min":58,"x_max":811,"o":"m 188 0 l 188 517 l 58 517 l 58 572 l 188 581 l 188 661 l 58 661 l 58 717 l 188 725 l 188 886 l 393 886 q 578 849 500 886 q 689 725 657 813 l 811 725 l 811 661 l 703 661 q 705 639 704 650 q 706 617 706 628 q 706 598 706 607 q 704 581 706 589 l 811 581 l 811 517 l 690 517 q 581 383 661 426 q 393 340 501 340 l 296 340 l 296 0 l 188 0 m 296 807 l 296 725 l 572 725 q 498 788 547 769 q 378 807 449 807 l 296 807 m 596 617 q 595 640 596 629 q 593 661 594 650 l 296 661 l 296 581 l 593 581 q 595 598 594 589 q 596 617 596 607 m 296 419 l 378 419 q 575 517 526 419 l 296 517 l 296 419 z "},"₲":{"ha":833,"x_min":117,"x_max":731,"o":"m 432 -153 l 432 -14 q 304 29 363 -6 q 204 122 246 64 q 140 261 163 181 q 117 442 117 342 q 139 619 117 539 q 202 758 161 699 q 301 852 243 817 q 432 899 360 888 l 432 1039 l 515 1039 l 515 901 q 634 865 579 896 q 726 792 689 835 l 658 728 q 581 788 622 765 q 488 811 540 811 q 380 785 426 811 q 301 713 333 760 q 251 597 268 665 q 235 446 235 529 q 251 292 235 360 q 299 176 268 224 q 376 103 331 129 q 479 78 421 78 q 564 93 524 78 q 626 129 604 108 l 626 364 l 465 364 l 465 460 l 731 460 l 731 85 q 515 -14 638 -1 l 515 -153 l 432 -153 z "},"₴":{"ha":833,"x_min":85,"x_max":746,"o":"m 449 -17 q 335 -1 386 -17 q 247 45 283 15 q 190 118 210 75 q 169 215 169 161 q 196 326 169 276 l 85 326 l 85 386 l 181 393 l 244 393 q 300 443 269 421 q 363 486 331 465 l 85 486 l 85 547 l 182 554 l 463 554 q 522 614 499 582 q 544 686 544 646 q 506 775 544 739 q 401 811 468 811 q 307 790 344 811 q 228 722 269 768 l 167 788 q 267 871 213 839 q 406 903 321 903 q 507 887 461 903 q 586 842 553 871 q 638 772 619 813 q 656 683 656 732 q 644 613 656 644 q 611 554 632 582 l 746 554 l 746 486 l 542 486 q 475 439 510 461 q 408 393 440 417 l 746 393 l 746 326 l 329 326 q 294 273 307 301 q 281 210 281 244 q 323 113 281 150 q 449 75 365 75 q 562 103 511 75 q 658 176 613 132 l 711 100 q 592 15 661 47 q 449 -17 524 -17 z "},"₵":{"ha":833,"x_min":133,"x_max":758,"o":"m 251 446 q 305 193 251 290 q 458 78 358 96 l 458 807 q 305 692 358 788 q 251 446 251 596 m 458 -153 l 458 -15 q 326 26 386 -8 q 224 118 267 60 q 157 258 181 176 q 133 442 133 340 q 156 621 133 540 q 222 760 179 701 q 324 854 264 818 q 458 900 385 890 l 458 1035 l 532 1035 l 532 901 q 652 867 597 897 q 746 794 707 838 l 678 729 q 611 783 646 761 q 532 810 576 804 l 532 78 q 617 109 579 85 q 690 174 654 133 l 758 113 q 658 26 713 60 q 532 -14 603 -7 l 532 -153 l 458 -153 z "},"₹":{"ha":833,"x_min":150,"x_max":729,"o":"m 150 350 l 150 443 l 260 443 q 442 483 375 443 q 515 607 508 524 l 150 607 l 150 668 l 256 675 l 511 675 q 430 765 494 739 q 260 792 365 792 l 150 792 l 150 886 l 729 886 l 729 818 l 511 818 q 587 760 557 797 q 626 675 617 724 l 729 675 l 729 607 l 629 607 q 558 440 622 500 q 392 360 494 379 l 681 0 l 551 0 l 274 350 l 150 350 z "},"₺":{"ha":833,"x_min":63,"x_max":744,"o":"m 222 -17 l 222 363 l 93 303 l 63 363 l 222 436 l 222 536 l 93 476 l 63 535 l 222 610 l 222 886 l 339 886 l 339 667 l 576 779 l 608 719 l 339 593 l 339 493 l 576 606 l 608 546 l 339 419 l 339 92 q 444 108 390 93 q 544 152 499 124 q 617 223 589 181 q 646 319 646 265 q 645 345 646 331 q 638 379 644 360 l 733 404 q 742 362 740 381 q 744 325 744 343 q 704 172 744 238 q 593 64 664 107 q 427 1 522 21 q 222 -17 332 -19 z "},"₮":{"ha":833,"x_min":76,"x_max":757,"o":"m 167 354 l 136 414 l 358 518 l 358 797 l 76 797 l 76 886 l 757 886 l 757 797 l 475 797 l 475 567 l 667 656 l 697 600 l 475 493 l 475 393 l 667 482 l 697 426 l 475 321 l 475 0 l 358 0 l 358 271 l 167 181 l 136 240 l 358 344 l 358 444 l 167 354 z "},"₸":{"ha":833,"x_min":76,"x_max":757,"o":"m 358 0 l 358 658 l 76 658 l 76 719 l 190 725 l 757 725 l 757 658 l 475 658 l 475 0 l 358 0 m 76 818 l 76 886 l 757 886 l 757 818 l 76 818 z "},"₽":{"ha":833,"x_min":58,"x_max":779,"o":"m 219 0 l 219 228 l 58 228 l 58 289 l 219 296 l 219 389 l 58 389 l 58 450 l 219 456 l 219 886 l 460 886 q 587 872 528 886 q 688 828 646 858 q 755 752 731 799 q 779 642 779 706 q 755 527 779 575 q 688 449 731 479 q 586 403 644 418 q 460 389 528 389 l 329 389 l 329 296 l 688 296 l 688 228 l 329 228 l 329 0 l 219 0 m 329 456 l 446 456 q 612 501 554 456 q 669 638 669 546 q 612 769 669 731 q 446 807 554 807 l 329 807 l 329 456 z "},"₣":{"ha":833,"x_min":96,"x_max":740,"o":"m 206 0 l 206 172 l 96 172 l 96 244 l 206 250 l 206 886 l 740 886 l 740 788 l 321 788 l 321 514 l 672 514 l 672 417 l 321 417 l 321 250 l 543 250 l 543 172 l 321 172 l 321 0 l 206 0 z "},"⁄":{"ha":833,"x_min":39,"x_max":794,"o":"m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 z "},"∕":{"ha":833,"x_min":39,"x_max":794,"o":"m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 z "},"%":{"ha":833,"x_min":39,"x_max":796,"o":"m 232 446 q 93 507 147 446 q 39 676 39 568 q 93 844 39 785 q 232 903 147 903 q 371 844 317 903 q 425 676 425 785 q 371 507 425 568 q 232 446 317 446 m 232 515 q 308 555 276 515 q 340 676 340 594 q 308 797 340 760 q 232 835 276 835 q 156 797 188 835 q 124 676 124 760 q 156 555 124 594 q 232 515 188 515 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 603 -17 q 464 44 518 -17 q 410 214 410 106 q 464 381 410 322 q 603 440 518 440 q 742 381 688 440 q 796 214 796 322 q 742 44 796 106 q 603 -17 688 -17 m 603 53 q 679 92 647 53 q 711 214 711 132 q 679 335 711 297 q 603 372 647 372 q 526 335 558 372 q 494 214 494 297 q 526 92 494 132 q 603 53 558 53 z "},"‰":{"ha":833,"x_min":67,"x_max":799,"o":"m 229 540 q 112 588 157 540 q 67 724 67 636 q 112 856 67 808 q 229 903 157 903 q 347 856 301 903 q 392 724 392 808 q 347 588 392 636 q 229 540 301 540 m 229 599 q 291 628 267 599 q 315 724 315 658 q 291 815 315 786 q 229 844 267 844 q 167 815 192 844 q 142 724 142 786 q 167 628 142 658 q 229 599 192 599 m 165 386 l 146 429 l 765 708 l 799 628 l 165 386 m 229 -17 q 112 31 157 -17 q 67 167 67 79 q 112 299 67 251 q 229 346 157 346 q 347 299 301 346 q 392 167 392 251 q 347 31 392 79 q 229 -17 301 -17 m 229 42 q 291 72 267 42 q 315 167 315 101 q 291 258 315 229 q 229 286 267 286 q 167 258 192 286 q 142 167 142 229 q 167 72 142 101 q 229 42 192 42 m 606 -17 q 488 31 533 -17 q 443 167 443 79 q 488 299 443 251 q 606 346 533 346 q 723 299 678 346 q 768 167 768 251 q 723 31 768 79 q 606 -17 678 -17 m 606 42 q 667 72 643 42 q 692 167 692 101 q 667 258 692 229 q 606 286 643 286 q 543 258 568 286 q 518 167 518 229 q 543 72 518 101 q 606 42 568 42 z "},"¼":{"ha":833,"x_min":39,"x_max":799,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 650 0 l 650 103 l 425 103 l 425 146 l 582 440 l 646 413 l 511 161 l 650 161 l 650 296 l 729 296 l 729 161 l 799 161 l 799 103 l 729 103 l 729 0 l 650 0 z "},"½":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 450 0 l 450 50 q 616 186 558 132 q 674 286 674 240 q 652 346 674 324 q 590 368 631 368 q 536 352 563 368 q 490 310 510 336 l 436 356 q 509 416 468 392 q 600 440 550 440 q 718 403 675 440 q 761 297 761 367 q 748 242 761 269 q 712 188 735 215 q 658 133 689 161 q 593 74 628 104 l 782 74 l 782 0 l 450 0 z "},"¾":{"ha":833,"x_min":44,"x_max":829,"o":"m 221 446 q 126 465 172 446 q 44 521 79 485 l 89 575 q 144 533 110 550 q 215 515 178 515 q 277 531 253 515 q 301 581 301 546 q 168 651 301 651 l 168 704 q 253 724 226 704 q 281 775 281 743 q 263 819 281 803 q 204 835 244 835 q 151 822 179 835 q 103 788 124 808 l 61 840 q 130 885 88 868 q 221 903 172 903 q 327 872 286 903 q 368 786 368 842 q 290 682 368 710 q 362 644 335 671 q 389 575 389 618 q 340 479 389 513 q 221 446 292 446 m 142 44 l 74 107 l 328 368 l 374 326 l 142 44 m 575 543 l 529 585 l 761 867 l 829 804 l 575 543 m 650 0 l 650 103 l 425 103 l 425 146 l 582 440 l 646 413 l 511 161 l 650 161 l 650 296 l 729 296 l 729 161 l 799 161 l 799 103 l 729 103 l 729 0 l 650 0 z "},"⅓":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 611 -17 q 516 3 563 -17 q 435 58 469 22 l 479 113 q 534 70 500 88 q 606 53 568 53 q 667 68 643 53 q 692 118 692 83 q 558 189 692 189 l 558 242 q 644 261 617 242 q 671 313 671 281 q 653 356 671 340 q 594 372 635 372 q 542 359 569 372 q 493 325 514 346 l 451 378 q 520 423 478 406 q 611 440 563 440 q 717 410 676 440 q 758 324 758 379 q 681 219 758 247 q 752 182 725 208 q 779 113 779 156 q 731 17 779 50 q 611 -17 682 -17 z "},"⅔":{"ha":833,"x_min":39,"x_max":794,"o":"m 60 463 l 60 513 q 226 649 168 594 q 283 749 283 703 q 262 808 283 786 q 200 831 240 831 q 146 815 172 831 q 100 772 119 799 l 46 818 q 119 878 78 854 q 210 903 160 903 q 328 866 285 903 q 371 760 371 829 q 358 705 371 732 q 322 651 344 678 q 268 595 299 624 q 203 536 238 567 l 392 536 l 392 463 l 60 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 611 -17 q 516 3 563 -17 q 435 58 469 22 l 479 113 q 534 70 500 88 q 606 53 568 53 q 667 68 643 53 q 692 118 692 83 q 558 189 692 189 l 558 242 q 644 261 617 242 q 671 313 671 281 q 653 356 671 340 q 594 372 635 372 q 542 359 569 372 q 493 325 514 346 l 451 378 q 520 423 478 406 q 611 440 563 440 q 717 410 676 440 q 758 324 758 379 q 681 219 758 247 q 752 182 725 208 q 779 113 779 156 q 731 17 779 50 q 611 -17 682 -17 z "},"⅕":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 614 -17 q 514 3 556 -17 q 435 58 472 22 l 479 113 q 534 70 503 88 q 607 53 565 53 q 673 74 647 53 q 699 132 699 94 q 674 192 699 172 q 606 213 649 213 q 558 204 578 213 q 517 181 538 196 l 474 208 l 497 424 l 760 424 l 760 349 l 567 349 l 553 251 q 631 268 586 268 q 743 233 700 268 q 786 131 786 197 q 738 24 786 64 q 614 -17 689 -17 z "},"⅖":{"ha":833,"x_min":39,"x_max":794,"o":"m 60 463 l 60 513 q 226 649 168 594 q 283 749 283 703 q 262 808 283 786 q 200 831 240 831 q 146 815 172 831 q 100 772 119 799 l 46 818 q 119 878 78 854 q 210 903 160 903 q 328 866 285 903 q 371 760 371 829 q 358 705 371 732 q 322 651 344 678 q 268 595 299 624 q 203 536 238 567 l 392 536 l 392 463 l 60 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 614 -17 q 514 3 556 -17 q 435 58 472 22 l 479 113 q 534 70 503 88 q 607 53 565 53 q 673 74 647 53 q 699 132 699 94 q 674 192 699 172 q 606 213 649 213 q 558 204 578 213 q 517 181 538 196 l 474 208 l 497 424 l 760 424 l 760 349 l 567 349 l 553 251 q 631 268 586 268 q 743 233 700 268 q 786 131 786 197 q 738 24 786 64 q 614 -17 689 -17 z "},"⅗":{"ha":833,"x_min":39,"x_max":794,"o":"m 221 446 q 126 465 172 446 q 44 521 79 485 l 89 575 q 144 533 110 550 q 215 515 178 515 q 277 531 253 515 q 301 581 301 546 q 168 651 301 651 l 168 704 q 253 724 226 704 q 281 775 281 743 q 263 819 281 803 q 204 835 244 835 q 151 822 179 835 q 103 788 124 808 l 61 840 q 130 885 88 868 q 221 903 172 903 q 327 872 286 903 q 368 786 368 842 q 290 682 368 710 q 362 644 335 671 q 389 575 389 618 q 340 479 389 513 q 221 446 292 446 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 614 -17 q 514 3 556 -17 q 435 58 472 22 l 479 113 q 534 70 503 88 q 607 53 565 53 q 673 74 647 53 q 699 132 699 94 q 674 192 699 172 q 606 213 649 213 q 558 204 578 213 q 517 181 538 196 l 474 208 l 497 424 l 760 424 l 760 349 l 567 349 l 553 251 q 631 268 586 268 q 743 233 700 268 q 786 131 786 197 q 738 24 786 64 q 614 -17 689 -17 z "},"⅘":{"ha":833,"x_min":39,"x_max":794,"o":"m 269 463 l 269 565 l 44 565 l 44 608 l 201 903 l 265 875 l 131 624 l 269 624 l 269 758 l 349 758 l 349 624 l 418 624 l 418 565 l 349 565 l 349 463 l 269 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 614 -17 q 514 3 556 -17 q 435 58 472 22 l 479 113 q 534 70 503 88 q 607 53 565 53 q 673 74 647 53 q 699 132 699 94 q 674 192 699 172 q 606 213 649 213 q 558 204 578 213 q 517 181 538 196 l 474 208 l 497 424 l 760 424 l 760 349 l 567 349 l 553 251 q 631 268 586 268 q 743 233 700 268 q 786 131 786 197 q 738 24 786 64 q 614 -17 689 -17 z "},"⅙":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 631 -17 q 494 40 549 -17 q 440 194 440 96 q 499 377 440 314 q 654 440 558 440 q 726 428 696 440 q 783 396 757 415 l 747 339 q 707 363 728 354 q 658 372 686 372 q 563 331 599 372 q 522 211 528 290 q 580 247 549 235 q 649 260 611 260 q 756 223 719 260 q 792 128 792 186 q 780 72 792 99 q 747 26 768 46 q 695 -6 725 6 q 631 -17 665 -17 m 629 53 q 689 73 668 53 q 710 128 710 93 q 690 181 710 160 q 628 201 671 201 q 524 153 572 201 q 563 76 532 100 q 629 53 593 53 z "},"⅚":{"ha":833,"x_min":39,"x_max":794,"o":"m 224 446 q 124 465 165 446 q 44 521 82 485 l 89 575 q 144 533 113 550 q 217 515 175 515 q 283 536 257 515 q 308 594 308 557 q 283 655 308 635 q 215 675 258 675 q 167 667 188 675 q 126 643 147 658 l 83 671 l 107 886 l 369 886 l 369 811 l 176 811 l 163 714 q 240 731 196 731 q 353 695 310 731 q 396 593 396 660 q 347 486 396 526 q 224 446 299 446 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 631 -17 q 494 40 549 -17 q 440 194 440 96 q 499 377 440 314 q 654 440 558 440 q 726 428 696 440 q 783 396 757 415 l 747 339 q 707 363 728 354 q 658 372 686 372 q 563 331 599 372 q 522 211 528 290 q 580 247 549 235 q 649 260 611 260 q 756 223 719 260 q 792 128 792 186 q 780 72 792 99 q 747 26 768 46 q 695 -6 725 6 q 631 -17 665 -17 m 629 53 q 689 73 668 53 q 710 128 710 93 q 690 181 710 160 q 628 201 671 201 q 524 153 572 201 q 563 76 532 100 q 629 53 593 53 z "},"⅐":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 547 0 q 559 99 550 54 q 585 185 568 144 q 626 267 601 226 q 685 350 651 307 l 450 350 l 450 424 l 788 424 l 788 374 q 715 281 743 325 q 671 194 688 238 q 647 103 654 150 q 638 0 640 56 l 547 0 z "},"⅛":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 613 -17 q 542 -7 574 -17 q 487 19 510 3 q 451 58 464 36 q 439 106 439 81 q 466 176 439 150 q 529 218 493 201 l 529 224 q 476 265 497 243 q 454 324 454 286 q 467 370 454 349 q 501 408 479 392 q 551 432 522 424 q 613 440 581 440 q 727 408 682 440 q 772 324 772 375 q 749 262 772 285 q 699 224 726 239 l 699 218 q 760 177 735 203 q 786 106 786 151 q 773 58 786 81 q 736 19 760 36 q 681 -7 713 3 q 613 -17 650 -17 m 640 246 q 679 281 668 263 q 690 319 690 299 q 670 361 690 344 q 613 378 650 378 q 557 362 578 378 q 536 322 536 346 q 567 275 536 292 q 640 246 597 258 m 613 46 q 677 63 649 46 q 706 108 706 81 q 695 141 706 128 q 668 163 685 154 q 630 179 651 172 q 585 193 608 186 q 519 111 519 163 q 547 65 519 83 q 613 46 574 46 z "},"⅜":{"ha":833,"x_min":39,"x_max":794,"o":"m 221 446 q 126 465 172 446 q 44 521 79 485 l 89 575 q 144 533 110 550 q 215 515 178 515 q 277 531 253 515 q 301 581 301 546 q 168 651 301 651 l 168 704 q 253 724 226 704 q 281 775 281 743 q 263 819 281 803 q 204 835 244 835 q 151 822 179 835 q 103 788 124 808 l 61 840 q 130 885 88 868 q 221 903 172 903 q 327 872 286 903 q 368 786 368 842 q 290 682 368 710 q 362 644 335 671 q 389 575 389 618 q 340 479 389 513 q 221 446 292 446 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 613 -17 q 542 -7 574 -17 q 487 19 510 3 q 451 58 464 36 q 439 106 439 81 q 466 176 439 150 q 529 218 493 201 l 529 224 q 476 265 497 243 q 454 324 454 286 q 467 370 454 349 q 501 408 479 392 q 551 432 522 424 q 613 440 581 440 q 727 408 682 440 q 772 324 772 375 q 749 262 772 285 q 699 224 726 239 l 699 218 q 760 177 735 203 q 786 106 786 151 q 773 58 786 81 q 736 19 760 36 q 681 -7 713 3 q 613 -17 650 -17 m 640 246 q 679 281 668 263 q 690 319 690 299 q 670 361 690 344 q 613 378 650 378 q 557 362 578 378 q 536 322 536 346 q 567 275 536 292 q 640 246 597 258 m 613 46 q 677 63 649 46 q 706 108 706 81 q 695 141 706 128 q 668 163 685 154 q 630 179 651 172 q 585 193 608 186 q 519 111 519 163 q 547 65 519 83 q 613 46 574 46 z "},"⅝":{"ha":833,"x_min":39,"x_max":794,"o":"m 224 446 q 124 465 165 446 q 44 521 82 485 l 89 575 q 144 533 113 550 q 217 515 175 515 q 283 536 257 515 q 308 594 308 557 q 283 655 308 635 q 215 675 258 675 q 167 667 188 675 q 126 643 147 658 l 83 671 l 107 886 l 369 886 l 369 811 l 176 811 l 163 714 q 240 731 196 731 q 353 695 310 731 q 396 593 396 660 q 347 486 396 526 q 224 446 299 446 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 613 -17 q 542 -7 574 -17 q 487 19 510 3 q 451 58 464 36 q 439 106 439 81 q 466 176 439 150 q 529 218 493 201 l 529 224 q 476 265 497 243 q 454 324 454 286 q 467 370 454 349 q 501 408 479 392 q 551 432 522 424 q 613 440 581 440 q 727 408 682 440 q 772 324 772 375 q 749 262 772 285 q 699 224 726 239 l 699 218 q 760 177 735 203 q 786 106 786 151 q 773 58 786 81 q 736 19 760 36 q 681 -7 713 3 q 613 -17 650 -17 m 640 246 q 679 281 668 263 q 690 319 690 299 q 670 361 690 344 q 613 378 650 378 q 557 362 578 378 q 536 322 536 346 q 567 275 536 292 q 640 246 597 258 m 613 46 q 677 63 649 46 q 706 108 706 81 q 695 141 706 128 q 668 163 685 154 q 630 179 651 172 q 585 193 608 186 q 519 111 519 163 q 547 65 519 83 q 613 46 574 46 z "},"⅞":{"ha":833,"x_min":39,"x_max":794,"o":"m 157 463 q 169 562 160 517 q 194 648 178 607 q 236 729 211 689 q 294 813 261 769 l 60 813 l 60 886 l 397 886 l 397 836 q 325 744 353 788 q 281 656 297 700 q 257 565 264 613 q 247 463 250 518 l 157 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 613 -17 q 542 -7 574 -17 q 487 19 510 3 q 451 58 464 36 q 439 106 439 81 q 466 176 439 150 q 529 218 493 201 l 529 224 q 476 265 497 243 q 454 324 454 286 q 467 370 454 349 q 501 408 479 392 q 551 432 522 424 q 613 440 581 440 q 727 408 682 440 q 772 324 772 375 q 749 262 772 285 q 699 224 726 239 l 699 218 q 760 177 735 203 q 786 106 786 151 q 773 58 786 81 q 736 19 760 36 q 681 -7 713 3 q 613 -17 650 -17 m 640 246 q 679 281 668 263 q 690 319 690 299 q 670 361 690 344 q 613 378 650 378 q 557 362 578 378 q 536 322 536 346 q 567 275 536 292 q 640 246 597 258 m 613 46 q 677 63 649 46 q 706 108 706 81 q 695 141 706 128 q 668 163 685 154 q 630 179 651 172 q 585 193 608 186 q 519 111 519 163 q 547 65 519 83 q 613 46 574 46 z "},"⅑":{"ha":833,"x_min":39,"x_max":794,"o":"m 208 463 l 208 782 l 94 782 l 94 840 q 169 858 140 847 q 226 886 197 869 l 296 886 l 296 463 l 208 463 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 599 224 q 651 234 626 224 q 701 269 675 244 q 664 348 694 324 q 597 372 633 372 q 538 351 560 372 q 517 296 517 331 q 536 244 517 264 q 599 224 556 224 m 572 -17 q 501 -3 532 -17 q 443 29 469 10 l 479 85 q 520 61 499 69 q 569 53 542 53 q 663 92 628 53 q 703 211 697 132 q 645 176 676 189 q 578 164 614 164 q 472 201 507 164 q 436 296 436 238 q 481 399 436 357 q 596 440 525 440 q 732 384 678 440 q 786 229 786 328 q 727 47 786 110 q 572 -17 668 -17 z "},"⅒":{"ha":833,"x_min":115,"x_max":799,"o":"m 229 557 l 229 782 l 115 782 l 115 840 q 190 858 161 847 q 247 886 218 868 l 317 886 l 317 557 l 229 557 m 165 386 l 146 429 l 765 708 l 799 628 l 165 386 m 229 0 l 229 225 l 115 225 l 115 283 q 190 301 161 290 q 247 329 218 311 l 317 329 l 317 0 l 229 0 m 606 -17 q 488 31 533 -17 q 443 167 443 79 q 488 299 443 251 q 606 346 533 346 q 723 299 678 346 q 768 167 768 251 q 723 31 768 79 q 606 -17 678 -17 m 606 42 q 667 72 643 42 q 692 167 692 101 q 667 258 692 229 q 606 286 643 286 q 543 258 568 286 q 518 167 518 229 q 543 72 518 101 q 606 42 568 42 z "},"↉":{"ha":833,"x_min":39,"x_max":794,"o":"m 232 446 q 93 507 147 446 q 39 676 39 568 q 93 844 39 785 q 232 903 147 903 q 371 844 317 903 q 425 676 425 785 q 371 507 425 568 q 232 446 317 446 m 232 515 q 308 555 276 515 q 340 676 340 594 q 308 797 340 760 q 232 835 276 835 q 156 797 188 835 q 124 676 124 760 q 156 555 124 594 q 232 515 188 515 m 107 44 l 39 107 l 293 368 l 339 326 l 107 44 m 540 543 l 494 585 l 726 867 l 794 804 l 540 543 m 611 -17 q 516 3 563 -17 q 435 58 469 22 l 479 113 q 534 70 500 88 q 606 53 568 53 q 667 68 643 53 q 692 118 692 83 q 558 189 692 189 l 558 242 q 644 261 617 242 q 671 313 671 281 q 653 356 671 340 q 594 372 635 372 q 542 359 569 372 q 493 325 514 346 l 451 378 q 520 423 478 406 q 611 440 563 440 q 717 410 676 440 q 758 324 758 379 q 681 219 758 247 q 752 182 725 208 q 779 113 779 156 q 731 17 779 50 q 611 -17 682 -17 z "},"+":{"ha":833,"x_min":118,"x_max":715,"o":"m 371 144 l 371 415 l 118 415 l 118 501 l 371 501 l 371 772 l 463 772 l 463 501 l 715 501 l 715 415 l 463 415 l 463 144 l 371 144 z "},"−":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 z "},"×":{"ha":833,"x_min":142,"x_max":692,"o":"m 203 175 l 142 238 l 356 458 l 142 678 l 203 740 l 417 519 l 631 740 l 692 678 l 478 458 l 692 238 l 631 175 l 417 397 l 203 175 z "},"÷":{"ha":833,"x_min":118,"x_max":715,"o":"m 417 633 q 363 654 385 633 q 342 708 342 675 q 363 761 342 740 q 417 782 385 782 q 470 761 449 782 q 492 708 492 740 q 470 654 492 675 q 417 633 449 633 m 417 133 q 363 154 385 133 q 342 208 342 175 q 363 261 342 240 q 417 282 385 282 q 470 261 449 282 q 492 208 492 240 q 470 154 492 175 q 417 133 449 133 m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 z "},"∙":{"ha":833,"x_min":300,"x_max":525,"o":"m 413 365 q 333 397 365 365 q 300 482 300 429 q 333 567 300 535 q 413 600 365 600 q 492 567 460 600 q 525 482 525 535 q 492 397 525 429 q 413 365 460 365 z "},"=":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 564 l 118 650 l 715 650 l 715 564 l 118 564 m 118 268 l 118 354 l 715 354 l 715 268 l 118 268 z "},"≡":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 714 l 118 800 l 715 800 l 715 714 l 118 714 m 118 415 l 118 501 l 715 501 l 715 415 l 118 415 m 118 118 l 118 204 l 715 204 l 715 118 l 118 118 z "},"<":{"ha":833,"x_min":167,"x_max":685,"o":"m 685 67 l 167 418 l 167 504 l 685 856 l 685 746 l 267 464 l 267 458 l 685 176 l 685 67 z "},">":{"ha":833,"x_min":149,"x_max":667,"o":"m 149 67 l 149 176 l 567 458 l 567 464 l 149 746 l 149 856 l 667 504 l 667 418 l 149 67 z "},"≤":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 0 l 118 86 l 715 86 l 715 0 l 118 0 m 715 213 l 118 425 l 118 528 l 715 740 l 715 642 l 424 540 l 236 479 l 236 474 l 424 413 l 715 311 l 715 213 z "},"≥":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 0 l 118 86 l 715 86 l 715 0 l 118 0 m 118 213 l 118 311 l 410 413 l 597 474 l 597 479 l 410 540 l 118 642 l 118 740 l 715 528 l 715 425 l 118 213 z "},"±":{"ha":833,"x_min":118,"x_max":715,"o":"m 371 176 l 371 422 l 118 422 l 118 508 l 371 508 l 371 772 l 463 772 l 463 508 l 715 508 l 715 422 l 463 422 l 463 176 l 371 176 m 118 0 l 118 86 l 715 86 l 715 0 l 118 0 z "},"^":{"ha":833,"x_min":154,"x_max":679,"o":"m 154 394 l 367 931 l 467 931 l 679 394 l 579 394 l 488 639 l 419 824 l 414 824 l 346 639 l 254 394 l 154 394 z "},"≠":{"ha":833,"x_min":118,"x_max":715,"o":"m 156 90 l 261 267 l 118 267 l 118 353 l 311 353 l 438 564 l 118 564 l 118 650 l 488 650 l 593 826 l 678 826 l 572 650 l 715 650 l 715 564 l 522 564 l 396 353 l 715 353 l 715 267 l 346 267 l 240 90 l 156 90 z "},"~":{"ha":833,"x_min":106,"x_max":728,"o":"m 539 357 q 465 375 497 357 q 403 415 432 393 q 348 456 375 438 q 292 474 321 474 q 231 450 260 474 q 179 354 203 426 l 106 386 q 192 522 142 483 q 294 560 242 560 q 369 542 336 560 q 430 501 401 524 q 485 461 458 479 q 542 443 513 443 q 573 448 558 443 q 602 466 588 453 q 629 503 617 479 q 654 563 642 526 l 728 529 q 642 394 692 432 q 539 357 592 357 z "},"≈":{"ha":833,"x_min":106,"x_max":728,"o":"m 539 506 q 465 524 497 506 q 403 564 432 542 q 348 604 375 586 q 292 622 321 622 q 231 599 260 622 q 179 503 203 575 l 106 535 q 192 670 142 632 q 294 708 242 708 q 369 690 336 708 q 430 650 401 672 q 485 610 458 628 q 542 592 513 592 q 573 597 558 592 q 602 615 588 601 q 629 651 617 628 q 654 711 642 675 l 728 678 q 642 543 692 581 q 539 506 592 506 m 539 210 q 465 228 497 210 q 403 268 432 246 q 348 308 375 290 q 292 326 321 326 q 231 303 260 326 q 179 207 203 279 l 106 239 q 192 374 142 336 q 294 413 242 413 q 369 394 336 413 q 430 354 401 376 q 485 314 458 332 q 542 296 513 296 q 573 301 558 296 q 602 319 588 306 q 629 356 617 332 q 654 415 642 379 l 728 382 q 642 247 692 285 q 539 210 592 210 z "},"¬":{"ha":833,"x_min":118,"x_max":715,"o":"m 624 144 l 624 415 l 118 415 l 118 501 l 715 501 l 715 144 l 624 144 z "},"⌐":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 144 l 118 501 l 715 501 l 715 415 l 210 415 l 210 144 l 118 144 z "},"∩":{"ha":833,"x_min":133,"x_max":700,"o":"m 133 144 l 133 493 q 155 616 133 561 q 214 710 176 671 q 303 770 251 749 q 417 792 356 792 q 530 770 478 792 q 619 710 582 749 q 678 616 657 671 q 700 493 700 561 l 700 144 l 610 144 l 610 476 q 557 642 610 585 q 417 700 504 700 q 276 642 329 700 q 224 476 224 585 l 224 144 l 133 144 z "},"∟":{"ha":833,"x_min":118,"x_max":715,"o":"m 118 144 l 118 772 l 210 772 l 210 231 l 715 231 l 715 144 l 118 144 z "},"∞":{"ha":833,"x_min":-6,"x_max":839,"o":"m 624 208 q 492 248 547 208 q 385 374 438 288 l 379 374 q 344 324 364 349 q 301 280 325 300 q 247 248 276 260 q 181 236 217 236 q 109 253 143 236 q 49 299 75 269 q 9 367 24 328 q -6 450 -6 406 q 10 547 -6 504 q 53 620 26 590 q 117 666 81 650 q 197 682 154 682 q 260 671 232 682 q 313 640 289 660 q 357 596 338 621 q 392 542 376 571 l 397 542 q 495 660 440 615 q 625 704 550 704 q 710 687 671 704 q 778 638 750 669 q 823 562 807 606 q 839 467 839 518 q 823 360 839 408 q 778 279 807 313 q 710 227 750 246 q 624 208 671 208 m 197 324 q 342 446 286 324 q 271 544 307 514 q 194 574 235 574 q 115 542 144 574 q 85 454 85 511 q 117 360 85 397 q 197 324 150 324 m 619 318 q 715 360 682 318 q 749 463 749 403 q 713 573 749 529 q 610 617 676 617 q 519 583 561 617 q 435 472 476 549 q 524 352 481 386 q 619 318 567 318 z "},"°":{"ha":833,"x_min":243,"x_max":592,"o":"m 417 596 q 351 608 382 596 q 295 644 319 621 q 257 699 271 667 q 243 772 243 732 q 257 847 243 814 q 295 903 271 879 q 351 939 319 926 q 417 951 382 951 q 483 939 451 951 q 539 903 515 926 q 577 847 563 879 q 592 772 592 814 q 577 699 592 732 q 539 644 563 667 q 483 608 515 621 q 417 596 451 596 m 417 660 q 493 692 464 660 q 522 772 522 724 q 493 856 522 824 q 417 888 464 888 q 342 856 371 888 q 313 772 313 824 q 342 692 313 724 q 417 660 371 660 z "},"′":{"ha":833,"x_min":357,"x_max":500,"o":"m 357 603 l 388 958 l 500 958 l 479 819 l 432 603 l 357 603 z "},"″":{"ha":833,"x_min":236,"x_max":622,"o":"m 236 603 l 267 958 l 379 958 l 358 819 l 311 603 l 236 603 m 479 603 l 510 958 l 622 958 l 601 819 l 554 603 l 479 603 z "},"‵":{"ha":833,"x_min":333,"x_max":476,"o":"m 401 603 l 354 819 l 333 958 l 446 958 l 476 603 l 401 603 z "},"µ":{"ha":833,"x_min":117,"x_max":765,"o":"m 117 -260 l 117 675 l 231 675 l 231 271 q 265 130 231 178 q 374 82 299 82 q 425 88 400 82 q 476 108 450 93 q 527 153 501 124 q 579 228 553 182 l 579 675 l 694 675 q 689 394 692 538 q 686 128 686 250 q 697 89 686 100 q 725 78 708 78 q 735 78 731 78 q 750 81 740 78 l 765 -6 q 700 -17 740 -17 q 620 15 647 -17 q 589 128 593 46 l 586 128 q 490 21 544 56 q 372 -14 435 -14 q 288 1 326 -14 q 222 60 250 15 q 223 -34 222 7 q 224 -111 224 -75 q 227 -183 225 -147 q 232 -260 229 -218 l 117 -260 z "},"∂":{"ha":833,"x_min":106,"x_max":726,"o":"m 358 -17 q 263 2 308 -17 q 182 55 217 21 q 126 138 147 89 q 106 250 106 188 q 126 376 106 318 q 186 475 147 433 q 281 540 225 517 q 407 564 336 564 q 519 538 464 564 q 614 464 574 511 q 615 487 615 475 q 615 510 615 499 q 563 761 615 683 q 421 839 510 839 q 338 820 376 839 q 265 768 299 801 l 213 840 q 312 909 257 885 q 432 933 367 933 q 647 828 567 933 q 726 507 726 722 q 700 294 726 390 q 625 128 674 197 q 508 22 576 60 q 358 -17 440 -17 m 369 78 q 522 153 460 78 q 606 367 583 228 q 511 449 560 425 q 417 472 463 472 q 327 456 365 472 q 264 410 289 439 q 226 342 239 382 q 214 257 214 303 q 226 183 214 215 q 260 126 239 150 q 310 90 282 103 q 369 78 338 78 z "},"∫":{"ha":833,"x_min":258,"x_max":613,"o":"m 324 -219 q 258 -210 281 -219 l 271 -124 q 319 -129 288 -129 q 395 -72 378 -129 q 413 93 413 -15 q 403 257 413 169 q 384 435 394 344 q 365 613 374 525 q 356 779 356 701 q 363 904 356 846 q 392 1005 371 963 q 450 1072 413 1047 q 547 1096 488 1096 q 586 1093 568 1096 q 613 1088 604 1090 l 599 1001 q 577 1006 589 1004 q 550 1007 565 1007 q 476 948 493 1007 q 458 782 458 889 q 467 619 458 707 q 488 442 476 532 q 508 263 499 351 q 517 99 517 175 q 509 -28 517 31 q 480 -128 501 -86 q 421 -195 458 -171 q 324 -219 383 -219 z "},"⌠":{"ha":833,"x_min":368,"x_max":625,"o":"m 472 -556 l 368 -556 l 368 779 q 376 904 368 846 q 405 1005 383 963 q 464 1072 426 1047 q 561 1096 501 1096 q 599 1093 581 1096 q 625 1088 617 1090 l 613 1001 q 591 1006 603 1004 q 564 1007 579 1007 q 490 948 507 1007 q 472 782 472 889 l 472 -556 z "},"⌡":{"ha":833,"x_min":213,"x_max":472,"o":"m 279 -219 q 213 -210 236 -219 l 226 -124 q 275 -129 243 -129 q 351 -72 333 -129 q 368 93 368 -15 l 368 1389 l 472 1389 l 472 99 q 465 -28 472 31 q 435 -128 457 -86 q 376 -195 414 -171 q 279 -219 339 -219 z "},"√":{"ha":833,"x_min":86,"x_max":810,"o":"m 421 -132 l 213 463 l 114 418 l 86 481 l 272 563 l 433 82 q 446 38 440 60 q 457 -7 451 15 l 463 -7 q 470 38 467 15 q 479 82 474 60 l 726 1139 l 810 1139 l 507 -132 l 421 -132 z "},"∆":{"ha":833,"x_min":60,"x_max":774,"o":"m 60 0 l 60 69 l 350 911 l 483 911 l 774 69 l 774 0 l 60 0 m 186 99 l 646 99 l 511 506 q 465 657 488 581 q 418 813 442 733 l 413 813 q 366 657 389 733 q 319 506 343 581 l 186 99 z "},"Ω":{"ha":833,"x_min":53,"x_max":781,"o":"m 53 0 l 53 94 l 221 94 l 221 100 q 165 166 192 128 q 115 253 138 204 q 80 360 93 301 q 67 488 67 418 q 91 664 67 583 q 161 803 115 744 q 272 895 207 863 q 417 928 336 928 q 562 895 497 928 q 672 803 626 863 q 742 664 718 744 q 767 488 767 583 q 753 360 767 418 q 718 253 740 301 q 669 166 696 204 q 613 100 642 128 l 613 94 l 781 94 l 781 0 l 489 0 l 489 85 q 551 157 522 118 q 602 244 581 196 q 635 350 624 292 q 647 481 647 408 q 632 617 647 554 q 588 727 617 681 q 515 800 558 774 q 417 826 472 826 q 318 800 361 826 q 246 727 275 774 q 201 617 217 681 q 186 481 186 554 q 198 350 186 408 q 231 244 210 292 q 282 157 253 196 q 344 85 311 118 l 344 0 l 53 0 z "},"∀":{"ha":833,"x_min":44,"x_max":789,"o":"m 789 911 l 482 0 l 351 0 l 44 911 l 167 911 l 253 633 l 583 633 l 671 911 l 789 911 m 415 94 l 421 94 q 465 249 443 174 q 511 401 488 325 l 554 540 l 282 540 l 325 401 q 372 249 349 325 q 415 94 394 174 z "},"∃":{"ha":833,"x_min":97,"x_max":675,"o":"m 97 0 l 97 99 l 558 99 l 558 429 l 181 429 l 181 528 l 558 528 l 558 814 l 111 814 l 111 911 l 675 911 l 675 0 l 97 0 z "},"∷":{"ha":833,"x_min":111,"x_max":724,"o":"m 224 590 q 144 622 176 590 q 111 707 111 654 q 144 792 111 760 q 224 825 176 825 q 303 792 271 825 q 336 707 336 760 q 303 622 336 654 q 224 590 271 590 m 224 93 q 144 125 176 93 q 111 210 111 157 q 144 295 111 263 q 224 328 176 328 q 303 295 271 328 q 336 210 336 263 q 303 125 336 157 q 224 93 271 93 m 611 590 q 531 622 564 590 q 499 707 499 654 q 531 792 499 760 q 611 825 564 825 q 691 792 658 825 q 724 707 724 760 q 691 622 724 654 q 611 590 658 590 m 611 93 q 531 125 564 93 q 499 210 499 157 q 531 295 499 263 q 611 328 564 328 q 691 295 658 328 q 724 210 724 263 q 691 125 724 157 q 611 93 658 93 z "},"∑":{"ha":833,"x_min":97,"x_max":763,"o":"m 97 -167 l 97 -93 l 428 360 l 113 813 l 113 886 l 724 886 l 724 788 l 256 788 l 256 782 l 550 361 l 242 -62 l 242 -68 l 763 -68 l 763 -167 l 97 -167 z "},"∏":{"ha":833,"x_min":72,"x_max":761,"o":"m 72 -167 l 72 886 l 761 886 l 761 -167 l 643 -167 l 643 785 l 188 785 l 188 -167 l 72 -167 z "},"℅":{"ha":833,"x_min":38,"x_max":796,"o":"m 231 446 q 154 461 189 446 q 93 506 119 476 q 52 577 67 535 q 38 674 38 619 q 54 770 38 728 q 99 842 71 813 q 163 888 126 872 q 238 903 199 903 q 314 886 282 903 q 369 849 346 869 l 325 794 q 286 822 306 811 q 242 833 267 833 q 158 789 192 833 q 124 674 124 744 q 156 559 124 603 q 239 515 188 515 q 296 528 271 515 q 340 558 321 542 l 379 504 q 310 461 347 476 q 231 446 272 446 m 108 44 l 40 107 l 294 368 l 340 326 l 108 44 m 542 543 l 496 585 l 728 867 l 796 804 l 542 543 m 603 -17 q 464 44 518 -17 q 410 214 410 106 q 464 381 410 322 q 603 440 518 440 q 742 381 688 440 q 796 214 796 322 q 742 44 796 106 q 603 -17 688 -17 m 603 53 q 679 92 647 53 q 711 214 711 132 q 679 335 711 297 q 603 372 647 372 q 526 335 558 372 q 494 214 494 297 q 526 92 494 132 q 603 53 558 53 z "},"ℓ":{"ha":833,"x_min":161,"x_max":690,"o":"m 501 -17 q 422 -3 460 -17 q 356 38 385 10 q 307 112 326 67 q 282 221 288 157 q 207 171 246 196 l 161 243 q 223 285 193 264 q 281 328 253 306 l 281 699 q 296 836 281 779 q 338 930 311 893 q 403 983 365 967 q 483 1000 440 1000 q 613 944 563 1000 q 664 785 664 889 q 592 534 664 654 q 392 306 519 414 l 392 271 q 401 181 392 217 q 428 122 411 144 q 469 90 446 100 q 517 81 492 81 q 590 99 560 81 q 644 142 619 118 l 690 71 q 608 11 654 39 q 501 -17 563 -17 m 392 718 l 392 425 q 520 597 474 508 q 567 785 567 686 q 544 883 567 854 q 486 913 521 913 q 420 866 449 913 q 392 718 392 819 z "},"℮":{"ha":833,"x_min":36,"x_max":797,"o":"m 417 -17 q 269 20 338 -17 q 148 120 200 57 q 66 268 96 183 q 36 450 36 353 q 66 632 36 547 q 148 780 96 717 q 269 880 200 843 q 417 917 338 917 q 565 880 496 917 q 685 780 633 843 q 767 632 738 717 q 797 450 797 547 l 797 439 l 222 439 q 217 433 217 439 l 217 122 q 220 108 217 114 q 228 94 224 101 q 313 33 264 54 q 419 11 363 11 q 558 53 493 11 q 672 167 624 96 l 725 167 q 590 33 668 83 q 417 -17 511 -17 m 222 464 l 611 464 q 619 472 619 464 l 619 783 q 606 814 619 800 q 521 869 569 850 q 419 889 472 889 q 313 867 363 889 q 228 808 264 846 q 220 793 224 801 q 217 778 217 785 l 217 472 q 222 464 217 464 z "},"←":{"ha":833,"x_min":24,"x_max":790,"o":"m 401 -21 l 24 347 l 24 353 l 401 721 l 461 657 l 182 397 l 790 397 l 790 303 l 182 303 l 461 43 l 401 -21 z "},"↑":{"ha":833,"x_min":46,"x_max":788,"o":"m 369 -35 l 369 575 l 110 296 l 46 354 l 414 732 l 419 732 l 788 354 l 724 296 l 464 575 l 464 -35 l 369 -35 z "},"→":{"ha":833,"x_min":40,"x_max":808,"o":"m 429 -21 l 371 43 l 650 303 l 40 303 l 40 397 l 650 397 l 371 657 l 429 721 l 808 353 l 808 347 l 429 -21 z "},"↓":{"ha":833,"x_min":46,"x_max":788,"o":"m 414 -35 l 46 344 l 110 403 l 369 124 l 369 732 l 464 732 l 464 124 l 724 403 l 788 344 l 419 -35 l 414 -35 z "},"↖":{"ha":833,"x_min":133,"x_max":711,"o":"m 646 46 l 214 476 l 228 96 l 140 92 l 133 619 l 138 624 l 665 617 l 663 529 l 281 543 l 711 113 l 646 46 z "},"↗":{"ha":833,"x_min":113,"x_max":690,"o":"m 179 44 l 113 111 l 543 542 l 163 529 l 158 615 l 686 622 l 690 618 l 683 90 l 596 94 l 610 475 l 179 44 z "},"↘":{"ha":833,"x_min":119,"x_max":697,"o":"m 693 76 l 165 83 l 169 171 l 550 157 l 119 588 l 186 654 l 617 224 l 604 604 l 690 608 l 697 81 l 693 76 z "},"↙":{"ha":833,"x_min":143,"x_max":721,"o":"m 147 76 l 143 81 l 150 608 l 238 604 l 224 222 l 654 653 l 721 588 l 290 156 l 671 169 l 675 82 l 147 76 z "},"⇐":{"ha":833,"x_min":24,"x_max":790,"o":"m 401 -21 l 24 347 l 24 353 l 401 721 l 461 657 l 306 514 l 790 514 l 790 439 l 224 439 l 131 353 l 131 347 l 224 261 l 790 261 l 790 186 l 306 186 l 461 43 l 401 -21 z "},"⇑":{"ha":833,"x_min":46,"x_max":788,"o":"m 110 296 l 46 354 l 414 732 l 419 732 l 788 354 l 724 296 l 581 450 l 581 -35 l 506 -35 l 506 532 l 419 625 l 414 625 l 328 532 l 328 -35 l 253 -35 l 253 450 l 110 296 z "},"⇒":{"ha":833,"x_min":40,"x_max":808,"o":"m 429 -21 l 371 43 l 525 186 l 40 186 l 40 261 l 607 261 l 700 347 l 700 353 l 607 439 l 40 439 l 40 514 l 525 514 l 371 657 l 429 721 l 808 353 l 808 347 l 429 -21 z "},"⇓":{"ha":833,"x_min":46,"x_max":788,"o":"m 414 -35 l 46 344 l 110 403 l 253 249 l 253 732 l 328 732 l 328 167 l 414 74 l 419 74 l 506 167 l 506 732 l 581 732 l 581 249 l 724 403 l 788 344 l 419 -35 l 414 -35 z "},"↔":{"ha":833,"x_min":-17,"x_max":850,"o":"m 850 353 l 850 347 l 601 51 l 539 104 l 714 303 l 119 303 l 294 104 l 232 51 l -17 347 l -17 353 l 232 649 l 294 596 l 119 397 l 714 397 l 539 596 l 601 649 l 850 353 z "},"↕":{"ha":833,"x_min":118,"x_max":715,"o":"m 419 -79 l 414 -79 l 118 168 l 171 232 l 369 57 l 369 642 l 171 467 l 118 529 l 414 778 l 419 778 l 715 529 l 663 467 l 464 642 l 464 57 l 663 232 l 715 168 l 419 -79 z "},"↨":{"ha":833,"x_min":83,"x_max":750,"o":"m 83 -192 l 83 -103 l 750 -103 l 750 -192 l 83 -192 m 419 -79 l 414 -79 l 118 168 l 171 232 l 369 57 l 369 642 l 171 467 l 118 529 l 414 778 l 419 778 l 715 529 l 663 467 l 464 642 l 464 57 l 663 232 l 715 168 l 419 -79 z "},"●":{"ha":833,"x_min":103,"x_max":731,"o":"m 417 146 q 291 169 349 146 q 192 235 233 193 q 126 334 150 276 q 103 458 103 392 q 126 583 103 525 q 192 682 150 640 q 291 747 233 724 q 417 771 349 771 q 542 747 485 771 q 642 682 600 724 q 707 583 683 640 q 731 458 731 525 q 707 334 731 392 q 642 235 683 276 q 542 169 600 193 q 417 146 485 146 z "},"○":{"ha":833,"x_min":86,"x_max":747,"o":"m 417 131 q 284 156 344 131 q 180 224 224 181 q 111 328 136 268 q 86 458 86 389 q 111 588 86 528 q 180 692 136 649 q 284 761 224 736 q 417 786 344 786 q 549 761 489 786 q 653 692 610 736 q 722 588 697 649 q 747 458 747 528 q 722 328 747 389 q 653 224 697 268 q 549 156 610 181 q 417 131 489 131 m 417 200 q 517 219 471 200 q 597 273 563 239 q 649 354 631 307 q 668 458 668 401 q 649 562 668 514 q 597 644 631 610 q 517 697 563 678 q 417 717 471 717 q 317 697 363 717 q 237 644 271 678 q 184 562 203 610 q 165 458 165 514 q 184 354 165 401 q 237 273 203 307 q 317 219 271 239 q 417 200 363 200 z "},"■":{"ha":833,"x_min":121,"x_max":713,"o":"m 121 163 l 121 754 l 713 754 l 713 163 l 121 163 z "},"□":{"ha":833,"x_min":101,"x_max":732,"o":"m 101 143 l 101 774 l 732 774 l 732 143 l 101 143 m 175 211 l 658 211 l 658 706 l 175 706 l 175 211 z "},"❒":{"ha":833,"x_min":101,"x_max":732,"o":"m 101 143 l 101 706 l 183 774 l 732 774 l 732 219 l 661 143 l 101 143 m 160 199 l 638 199 l 638 683 l 160 683 l 160 199 z "},"◆":{"ha":833,"x_min":46,"x_max":788,"o":"m 417 104 l 46 476 l 417 847 l 788 476 l 417 104 z "},"▲":{"ha":833,"x_min":86,"x_max":747,"o":"m 86 146 l 86 150 l 415 833 l 418 833 l 747 150 l 747 146 l 86 146 z "},"△":{"ha":833,"x_min":86,"x_max":747,"o":"m 86 146 l 86 150 l 415 833 l 418 833 l 747 150 l 747 146 l 86 146 m 190 207 l 643 207 l 417 689 l 190 207 z "},"▶":{"ha":833,"x_min":86,"x_max":775,"o":"m 86 151 l 86 811 l 90 811 l 775 483 l 775 479 l 90 151 l 86 151 z "},"▷":{"ha":833,"x_min":86,"x_max":775,"o":"m 86 151 l 86 811 l 90 811 l 775 483 l 775 479 l 90 151 l 86 151 m 151 258 l 631 481 l 151 704 l 151 258 z "},"▼":{"ha":833,"x_min":86,"x_max":747,"o":"m 415 118 l 86 801 l 86 806 l 747 806 l 747 801 l 418 118 l 415 118 z "},"▽":{"ha":833,"x_min":86,"x_max":747,"o":"m 415 118 l 86 801 l 86 806 l 747 806 l 747 801 l 418 118 l 415 118 m 417 263 l 643 744 l 190 744 l 417 263 z "},"◀":{"ha":833,"x_min":58,"x_max":747,"o":"m 743 151 l 58 479 l 58 483 l 743 811 l 747 811 l 747 151 l 743 151 z "},"◁":{"ha":833,"x_min":58,"x_max":747,"o":"m 743 151 l 58 479 l 58 483 l 743 811 l 747 811 l 747 151 l 743 151 m 682 258 l 682 704 l 204 481 l 682 258 z "},"►":{"ha":833,"x_min":29,"x_max":868,"o":"m 29 151 l 29 811 l 33 811 l 868 483 l 868 479 l 33 151 l 29 151 z "},"◄":{"ha":833,"x_min":-35,"x_max":804,"o":"m 800 151 l -35 479 l -35 483 l 800 811 l 804 811 l 804 151 l 800 151 z "},"◙":{"ha":833,"x_min":94,"x_max":739,"o":"m 94 139 l 94 778 l 739 778 l 739 139 l 94 139 m 417 144 q 544 168 486 144 q 644 234 603 192 q 710 334 686 276 q 733 458 733 392 q 710 583 733 525 q 644 683 686 640 q 544 749 603 725 q 417 772 486 772 q 289 749 347 772 q 189 683 231 725 q 124 583 147 640 q 100 458 100 525 q 124 334 100 392 q 189 234 147 276 q 289 168 231 192 q 417 144 347 144 m 417 213 q 322 231 365 213 q 247 281 278 249 q 197 359 215 314 q 179 458 179 404 q 197 558 179 513 q 247 635 215 603 q 322 686 278 668 q 417 704 365 704 q 512 686 468 704 q 587 635 556 668 q 636 558 618 603 q 654 458 654 513 q 636 359 654 404 q 587 281 618 314 q 512 231 556 249 q 417 213 468 213 z "},"◉":{"ha":833,"x_min":71,"x_max":763,"o":"m 417 126 q 283 151 346 126 q 173 220 219 175 q 99 330 126 265 q 71 476 71 394 q 99 622 71 557 q 173 731 126 686 q 283 801 219 776 q 417 825 346 825 q 551 801 488 825 q 660 731 614 776 q 735 622 707 686 q 763 476 763 557 q 735 330 763 394 q 660 220 707 265 q 551 151 614 175 q 417 126 488 126 m 417 196 q 520 215 471 196 q 607 269 569 233 q 667 358 644 306 q 690 476 690 410 q 667 595 690 543 q 607 683 644 647 q 520 738 569 719 q 417 757 471 757 q 313 738 363 757 q 226 683 264 719 q 166 595 189 647 q 143 476 143 543 q 166 358 143 410 q 226 269 189 306 q 313 215 264 233 q 417 196 363 196 m 417 276 q 343 290 378 276 q 281 331 308 304 q 238 394 254 357 q 222 476 222 431 q 238 558 222 521 q 281 620 254 594 q 343 660 308 646 q 417 675 378 675 q 490 660 456 675 q 552 620 525 646 q 595 558 579 594 q 611 476 611 521 q 595 394 611 431 q 552 331 579 357 q 490 290 525 304 q 417 276 456 276 z "},"☐":{"ha":833,"x_min":-35,"x_max":868,"o":"m -35 -14 l -35 861 l 50 932 l 868 932 l 868 71 l 796 -14 l -35 -14 m 25 46 l 764 46 l 764 829 l 25 829 l 25 46 z "},"☑":{"ha":833,"x_min":-35,"x_max":981,"o":"m 347 144 q 260 346 308 251 q 153 529 213 440 l 231 582 q 324 414 282 501 q 394 239 367 326 l 400 239 q 517 543 444 392 q 682 829 590 694 l 25 829 l 25 46 l 764 46 l 764 785 q 592 495 669 653 q 467 158 515 338 l 347 144 m -35 -14 l -35 861 l 50 932 l 756 932 q 906 1104 826 1025 l 981 1035 q 924 978 953 1007 q 868 918 896 950 l 868 71 l 796 -14 l -35 -14 z "},"✓":{"ha":833,"x_min":-8,"x_max":847,"o":"m 201 -28 q 109 187 160 88 q -8 382 58 286 l 69 435 q 174 253 128 347 q 253 67 221 160 l 258 67 q 350 314 296 190 q 471 552 404 438 q 614 768 538 667 q 772 950 690 869 l 847 881 q 688 708 765 804 q 542 497 610 611 q 417 255 474 383 q 321 -14 360 126 l 201 -28 z "},"♪":{"ha":833,"x_min":107,"x_max":735,"o":"m 247 -33 q 149 -7 190 -33 q 107 72 107 19 q 123 133 107 104 q 167 185 139 163 q 236 222 196 208 q 325 235 276 235 q 376 230 353 235 q 410 218 400 225 l 410 964 l 479 964 q 490 940 485 950 q 506 919 496 929 q 533 895 517 908 q 576 864 550 882 q 654 799 624 831 q 703 734 685 767 q 728 666 721 701 q 735 592 735 631 q 720 490 735 538 q 690 410 706 442 l 642 428 q 656 490 653 461 q 660 556 660 518 q 615 680 660 622 q 486 764 569 738 l 486 199 q 467 98 486 142 q 415 25 447 54 q 338 -19 382 -4 q 247 -33 294 -33 z "},"♫":{"ha":833,"x_min":6,"x_max":824,"o":"m 144 -33 q 47 -7 89 -33 q 6 72 6 19 q 21 133 6 104 q 63 185 36 163 q 129 222 90 208 q 214 235 168 235 q 265 230 242 235 q 299 218 289 225 l 299 936 l 824 1019 l 824 271 q 805 171 824 214 q 754 99 786 128 q 680 55 722 69 q 592 40 638 40 q 495 67 536 40 q 454 146 454 93 q 469 207 454 178 q 512 259 485 236 q 577 295 539 282 q 661 308 615 308 q 713 303 689 308 q 746 292 736 299 l 746 796 l 375 738 l 375 199 q 356 98 375 142 q 306 25 338 54 q 232 -19 274 -4 q 144 -33 190 -33 z "},"♥":{"ha":833,"x_min":13,"x_max":821,"o":"m 419 -17 l 414 -17 q 210 221 289 118 q 88 409 132 324 q 28 567 44 494 q 13 715 13 640 q 28 835 13 783 q 70 921 43 886 q 134 973 97 956 q 214 990 171 990 q 333 953 282 990 q 414 824 385 917 l 419 824 q 501 953 449 917 q 619 990 553 990 q 699 973 663 990 q 763 921 736 956 q 806 835 790 886 q 821 715 821 783 q 805 567 821 640 q 745 409 789 494 q 623 221 701 324 q 419 -17 544 118 z "},"♣":{"ha":833,"x_min":13,"x_max":821,"o":"m 146 0 l 146 56 q 231 79 192 63 q 300 128 269 96 q 352 214 331 161 q 386 344 374 267 l 376 344 q 298 249 347 275 q 197 224 249 224 q 63 282 114 224 q 13 435 13 340 q 28 520 13 483 q 69 581 43 557 q 132 618 96 606 q 208 631 168 631 q 256 624 232 631 q 311 603 279 618 l 317 608 q 261 669 282 639 q 230 726 240 699 q 216 776 219 753 q 213 817 213 799 q 228 886 213 854 q 272 941 244 918 q 337 977 300 964 q 417 990 374 990 q 497 977 460 990 q 561 941 533 964 q 605 886 589 918 q 621 817 621 854 q 617 776 621 799 q 603 726 614 753 q 572 669 593 699 q 517 608 551 639 l 522 603 q 578 624 554 618 q 625 631 601 631 q 701 618 665 631 q 764 581 738 606 q 806 520 790 557 q 821 435 821 483 q 808 349 821 388 q 770 282 794 310 q 712 239 746 254 q 636 224 678 224 q 584 230 610 224 q 535 250 558 236 q 491 287 511 264 q 457 344 471 310 l 447 344 q 481 214 460 267 q 533 128 503 161 q 603 79 564 96 q 688 56 642 63 l 688 0 l 146 0 z "},"♦":{"ha":833,"x_min":7,"x_max":826,"o":"m 419 -17 l 414 -17 l 7 493 l 7 499 l 414 1006 l 419 1006 l 826 499 l 826 493 l 419 -17 z "},"♠":{"ha":833,"x_min":13,"x_max":821,"o":"m 146 0 l 146 56 q 231 79 192 63 q 300 128 269 96 q 352 214 331 161 q 386 344 374 267 l 376 344 q 297 246 344 272 q 192 219 250 219 q 63 265 114 219 q 13 408 13 311 q 31 526 13 471 q 94 648 49 582 q 217 799 140 714 q 414 1006 294 883 l 419 1006 q 615 799 538 883 q 739 648 693 714 q 803 526 785 582 q 821 408 821 471 q 770 265 821 311 q 642 219 719 219 q 536 246 583 219 q 457 344 489 272 l 447 344 q 481 214 460 267 q 533 128 503 161 q 603 79 564 96 q 688 56 642 63 l 688 0 l 146 0 z "},"☺":{"ha":833,"x_min":13,"x_max":821,"o":"m 417 54 q 253 84 328 54 q 126 168 179 114 q 42 297 72 222 q 13 458 13 371 q 42 620 13 546 q 126 749 72 694 q 253 833 179 803 q 417 863 328 863 q 580 833 506 863 q 708 749 654 803 q 791 620 761 694 q 821 458 821 546 q 791 297 821 371 q 708 168 761 222 q 580 84 654 114 q 417 54 506 54 m 417 117 q 552 142 490 117 q 658 212 614 167 q 726 319 701 257 q 750 458 750 382 q 726 597 750 535 q 658 705 701 660 q 552 775 614 750 q 417 800 490 800 q 281 775 343 800 q 176 705 219 750 q 108 597 132 660 q 83 458 83 535 q 108 319 83 382 q 176 212 132 257 q 281 142 219 167 q 417 117 343 117 m 307 472 q 258 497 275 472 q 240 561 240 521 q 258 626 240 601 q 307 650 275 650 q 357 626 339 650 q 375 561 375 601 q 357 497 375 521 q 307 472 339 472 m 526 472 q 476 497 494 472 q 458 561 458 521 q 476 626 458 601 q 526 650 494 650 q 576 626 558 650 q 593 561 593 601 q 576 497 593 521 q 526 472 558 472 m 417 211 q 269 259 325 211 q 201 392 213 307 l 249 410 q 311 331 268 356 q 417 306 354 306 q 522 331 479 306 q 585 410 565 356 l 632 392 q 565 259 621 307 q 417 211 508 211 m 328 551 q 346 572 346 551 q 328 593 346 593 q 310 572 310 593 q 328 551 310 551 m 546 551 q 564 572 564 551 q 546 593 564 593 q 529 572 529 593 q 546 551 529 551 z "},"☻":{"ha":833,"x_min":40,"x_max":793,"o":"m 417 82 q 264 110 333 82 q 144 189 194 139 q 67 308 94 239 q 40 458 40 376 q 67 609 40 540 q 144 728 94 678 q 264 806 194 778 q 417 835 333 835 q 569 806 500 835 q 689 728 639 778 q 766 609 739 678 q 793 458 793 540 q 766 308 793 376 q 689 189 739 239 q 569 110 639 139 q 417 82 500 82 m 306 479 q 354 504 338 479 q 371 567 371 529 q 354 628 371 603 q 306 653 338 653 q 256 628 274 653 q 239 567 239 603 q 256 504 239 529 q 306 479 274 479 m 528 479 q 577 504 560 479 q 594 567 594 529 q 577 628 594 603 q 528 653 560 653 q 479 628 496 653 q 463 567 463 603 q 479 504 463 529 q 528 479 496 479 m 417 207 q 567 253 511 207 q 638 386 622 299 l 590 404 q 525 324 569 350 q 417 297 481 297 q 308 324 353 297 q 243 404 264 350 l 196 386 q 267 253 211 299 q 417 207 322 207 m 289 547 q 272 553 279 547 q 265 572 265 560 q 272 592 265 585 q 289 599 279 599 q 304 592 297 599 q 311 572 311 585 q 304 553 311 560 q 289 547 297 547 m 511 547 q 494 553 501 547 q 488 572 488 560 q 494 592 488 585 q 511 599 501 599 q 528 592 521 599 q 535 572 535 585 q 528 553 535 560 q 511 547 521 547 z "},"❤":{"ha":833,"x_min":-99,"x_max":932,"o":"m 419 13 l 414 13 q 330 122 381 78 q 222 201 279 165 q 108 272 165 238 q 5 354 51 307 q -70 468 -42 401 q -99 633 -99 535 q -78 753 -99 701 q -22 841 -58 806 q 65 894 15 876 q 175 913 115 913 q 327 872 267 913 q 414 728 388 831 l 419 728 q 506 872 446 831 q 658 913 567 913 q 768 894 718 913 q 855 841 818 876 q 912 753 892 806 q 932 633 932 701 q 903 468 932 535 q 828 354 875 401 q 725 272 782 307 q 611 201 668 238 q 503 122 554 165 q 419 13 453 78 z "},"☕":{"ha":833,"x_min":-44,"x_max":900,"o":"m 344 54 q 184 86 256 54 q 62 185 113 118 q -17 353 11 251 q -44 594 -44 456 q 58 794 -44 725 q 344 863 161 863 q 608 808 513 863 q 724 649 704 753 q 852 587 804 633 q 900 444 900 540 q 879 349 900 392 q 823 274 858 306 q 740 226 788 243 q 640 210 693 210 q 514 92 592 129 q 344 54 436 54 m 344 111 q 498 145 429 111 q 604 258 567 179 q 706 274 663 258 q 777 314 749 289 q 819 373 806 339 q 833 444 833 407 q 793 553 833 508 q 671 597 753 597 q 587 753 671 697 q 344 808 503 808 q 103 748 188 808 q 19 583 19 688 q 43 369 19 458 q 110 223 67 281 q 213 138 153 165 q 344 111 272 111 m 344 453 q 147 483 215 453 q 44 569 78 514 q 144 673 65 635 q 344 711 222 711 q 546 672 467 711 q 646 569 625 633 q 604 520 629 542 q 543 483 579 499 q 458 460 507 468 q 344 453 410 453 m 636 347 q 656 425 650 386 q 665 503 663 464 q 725 489 706 503 q 744 436 744 475 q 713 369 744 392 q 636 347 681 347 m 431 582 q 329 637 371 622 q 249 651 288 651 q 196 640 214 651 q 178 614 178 629 q 187 595 178 603 q 221 582 196 588 q 187 568 196 575 q 178 550 178 561 q 196 523 178 535 q 249 511 214 511 q 329 526 288 511 q 431 582 371 542 m 436 582 q 492 556 468 563 q 528 550 515 550 q 553 558 543 550 q 564 582 564 567 q 553 605 564 597 q 528 613 543 613 q 492 607 515 613 q 436 582 468 601 z "},"♀":{"ha":833,"x_min":83,"x_max":750,"o":"m 417 415 q 512 433 468 415 q 588 484 556 451 q 638 561 619 517 q 656 660 656 606 q 638 758 656 714 q 588 835 619 803 q 512 885 556 867 q 417 903 468 903 q 322 885 365 903 q 245 835 278 867 q 194 758 213 803 q 176 660 176 714 q 194 561 176 606 q 245 484 213 517 q 322 433 278 451 q 417 415 365 415 m 371 -64 l 371 114 l 174 114 l 174 200 l 371 200 l 371 340 q 256 376 308 349 q 165 445 203 403 q 105 542 126 488 q 83 660 83 597 q 108 787 83 728 q 178 890 133 846 q 283 958 222 933 q 417 982 344 982 q 550 958 489 982 q 656 890 611 933 q 725 787 700 846 q 750 660 750 728 q 728 542 750 597 q 669 445 707 488 q 578 376 631 403 q 463 340 525 349 l 463 200 l 660 200 l 660 114 l 463 114 l 463 -64 l 371 -64 z "},"♂":{"ha":833,"x_min":-17,"x_max":851,"o":"m 317 13 q 183 37 244 13 q 78 105 122 61 q 8 208 33 149 q -17 336 -17 267 q 8 463 -17 404 q 78 565 33 522 q 183 633 122 608 q 317 658 244 658 q 413 646 368 658 q 496 610 458 633 l 715 825 l 471 815 l 471 896 l 847 900 l 851 896 l 849 518 l 767 518 l 776 764 l 568 550 q 628 453 607 508 q 649 336 649 399 q 624 208 649 267 q 554 105 599 149 q 449 37 510 61 q 317 13 388 13 m 317 92 q 412 110 368 92 q 488 160 456 128 q 538 237 519 192 q 557 336 557 282 q 538 433 557 389 q 488 510 519 478 q 412 561 456 543 q 317 579 368 579 q 222 561 265 579 q 145 510 178 543 q 94 433 113 478 q 76 336 76 389 q 94 237 76 282 q 145 160 113 192 q 222 110 178 128 q 317 92 265 92 z "},"☼":{"ha":833,"x_min":-4,"x_max":838,"o":"m 417 267 q 493 281 458 267 q 553 320 528 294 q 592 381 578 346 q 606 458 606 417 q 592 535 606 500 q 553 597 578 571 q 493 636 528 622 q 417 650 458 650 q 340 636 375 650 q 281 597 306 622 q 242 535 256 571 q 228 458 228 500 q 242 381 228 417 q 281 320 256 346 q 340 281 306 294 q 417 267 375 267 m 700 115 l 578 240 q 461 193 526 201 l 461 32 l 372 32 l 372 193 q 312 209 340 197 q 258 238 283 221 l 133 115 l 74 176 l 196 297 q 146 415 156 350 l -4 415 l -4 501 l 146 501 q 163 562 150 533 q 193 615 175 590 l 74 738 l 133 799 l 254 676 q 309 707 279 694 q 372 724 339 719 l 372 885 l 461 885 l 461 724 q 576 678 524 715 l 700 799 l 760 738 l 638 618 q 688 501 676 568 l 838 501 l 838 415 l 688 415 q 639 300 678 351 l 760 176 l 700 115 z "},"◊":{"ha":833,"x_min":133,"x_max":700,"o":"m 364 -14 l 133 457 l 364 926 l 469 926 l 700 457 l 469 -14 l 364 -14 m 414 82 l 419 82 l 508 267 l 599 457 l 508 644 l 419 831 l 414 831 l 325 644 l 235 457 l 325 267 l 414 82 z "},"⌂":{"ha":833,"x_min":68,"x_max":765,"o":"m 68 0 l 68 500 l 367 926 l 467 926 l 765 500 l 765 0 l 68 0 m 165 83 l 668 83 l 668 469 l 533 668 l 419 842 l 414 842 l 300 668 l 165 469 l 165 83 z "},"ʹ":{"ha":833,"x_min":357,"x_max":500,"o":"m 357 603 l 388 958 l 500 958 l 479 819 l 432 603 l 357 603 z "},"ʻ":{"ha":833,"x_min":290,"x_max":528,"o":"m 415 486 q 326 530 361 486 q 290 653 290 574 q 343 840 290 757 q 490 971 396 922 l 528 904 q 426 812 464 867 q 385 685 389 757 q 421 693 401 693 q 491 665 464 693 q 518 593 518 638 q 489 515 518 544 q 415 486 460 486 z "},"ʼ":{"ha":833,"x_min":301,"x_max":539,"o":"m 340 486 l 301 553 q 404 644 367 589 q 446 772 442 699 q 410 764 429 764 q 338 791 365 764 q 311 863 311 818 q 340 941 311 911 q 414 971 369 971 q 504 926 469 971 q 539 803 539 882 q 486 617 539 699 q 340 486 433 535 z "},"ʾ":{"ha":833,"x_min":314,"x_max":569,"o":"m 314 747 l 314 817 q 436 851 394 817 q 478 947 478 885 q 436 1044 478 1010 q 314 1079 394 1079 l 314 1147 q 505 1097 440 1151 q 569 947 569 1043 q 505 797 569 851 q 314 747 440 743 z "},"ʿ":{"ha":833,"x_min":264,"x_max":519,"o":"m 519 747 q 328 797 393 743 q 264 947 264 851 q 328 1097 264 1043 q 519 1147 393 1151 l 519 1079 q 397 1044 439 1079 q 356 947 356 1010 q 397 851 356 885 q 519 817 439 817 l 519 747 z "},"ˁ":{"ha":833,"x_min":222,"x_max":628,"o":"m 392 608 l 392 735 q 326 781 357 757 q 272 833 294 806 q 235 894 249 861 q 222 967 222 926 q 240 1045 222 1011 q 287 1102 257 1079 q 356 1137 317 1125 q 438 1149 394 1149 q 551 1124 504 1149 q 628 1067 597 1099 l 581 1011 q 522 1056 554 1038 q 444 1075 489 1075 q 348 1046 385 1075 q 311 965 311 1017 q 353 862 311 907 q 479 772 394 817 l 479 608 l 392 608 z "},"ː":{"ha":833,"x_min":281,"x_max":553,"o":"m 281 0 l 410 225 l 424 225 l 553 0 l 281 0 m 410 476 l 281 699 l 553 699 l 424 476 l 410 476 z "},"ˑ":{"ha":833,"x_min":281,"x_max":553,"o":"m 410 476 l 281 699 l 553 699 l 424 476 l 410 476 z "},"˞":{"ha":833,"x_min":178,"x_max":549,"o":"m 457 319 q 378 349 413 319 q 324 453 343 378 l 178 393 l 178 481 l 381 564 q 397 477 388 511 q 416 424 406 443 q 439 399 426 406 q 465 392 451 392 q 494 398 482 392 q 518 413 507 404 l 549 353 q 510 330 532 340 q 457 319 488 319 z "},"`":{"ha":833,"x_min":228,"x_max":506,"o":"m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"´":{"ha":833,"x_min":328,"x_max":606,"o":"m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"ˆ":{"ha":833,"x_min":201,"x_max":632,"o":"m 250 789 l 201 833 l 360 1028 l 474 1028 l 632 833 l 583 789 l 419 946 l 414 946 l 250 789 z "},"ˇ":{"ha":833,"x_min":201,"x_max":632,"o":"m 360 797 l 201 992 l 250 1036 l 414 879 l 419 879 l 583 1036 l 632 992 l 474 797 l 360 797 z "},"ˈ":{"ha":833,"x_min":346,"x_max":488,"o":"m 378 551 l 346 994 l 488 994 l 456 551 l 378 551 z "},"ˉ":{"ha":833,"x_min":232,"x_max":601,"o":"m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 z "},"ˊ":{"ha":833,"x_min":328,"x_max":606,"o":"m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"ˋ":{"ha":833,"x_min":228,"x_max":506,"o":"m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"ˌ":{"ha":833,"x_min":346,"x_max":488,"o":"m 346 -353 l 378 92 l 456 92 l 488 -353 l 346 -353 z "},"˜":{"ha":833,"x_min":176,"x_max":657,"o":"m 517 801 q 453 819 479 801 q 404 860 426 838 q 362 900 382 882 q 318 918 342 918 q 271 888 286 918 q 253 808 256 857 l 176 813 q 187 888 178 853 q 213 947 196 922 q 255 987 229 972 q 317 1001 281 1001 q 381 983 354 1001 q 429 943 407 965 q 472 903 451 921 q 517 885 492 885 q 563 915 547 885 q 581 994 578 946 l 657 989 q 647 915 656 949 q 621 856 638 881 q 578 816 604 831 q 517 801 553 801 z "},"¨":{"ha":833,"x_min":206,"x_max":628,"o":"m 282 817 q 227 839 249 817 q 206 894 206 861 q 227 949 206 926 q 282 972 249 972 q 337 949 315 972 q 358 894 358 926 q 337 839 358 861 q 282 817 315 817 m 551 817 q 497 839 518 817 q 475 894 475 861 q 497 949 475 926 q 551 972 518 972 q 606 949 585 972 q 628 894 628 926 q 606 839 628 861 q 551 817 585 817 z "},"¯":{"ha":833,"x_min":232,"x_max":601,"o":"m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 z "},"˘":{"ha":833,"x_min":200,"x_max":633,"o":"m 417 793 q 321 811 361 793 q 255 859 281 829 q 216 926 229 889 q 200 1003 203 964 l 271 1014 q 285 962 275 988 q 314 915 296 936 q 358 882 332 894 q 417 869 383 869 q 476 882 450 869 q 519 915 501 894 q 548 962 538 936 q 563 1014 558 988 l 633 1003 q 617 926 631 964 q 578 859 604 889 q 512 811 551 829 q 417 793 472 793 z "},"˚":{"ha":833,"x_min":264,"x_max":569,"o":"m 417 790 q 304 828 344 790 q 264 924 264 867 q 304 1019 264 981 q 417 1057 344 1057 q 529 1019 489 1057 q 569 924 569 981 q 529 828 569 867 q 417 790 489 790 m 417 842 q 473 865 450 842 q 496 924 496 889 q 473 983 496 960 q 417 1006 450 1006 q 360 983 383 1006 q 338 924 338 960 q 360 865 338 889 q 417 842 383 842 z "},"˝":{"ha":833,"x_min":274,"x_max":685,"o":"m 338 789 l 274 818 l 394 1057 l 475 1018 l 338 789 m 547 789 l 483 818 l 604 1057 l 685 1018 l 547 789 z "},"˙":{"ha":833,"x_min":325,"x_max":508,"o":"m 417 817 q 351 841 378 817 q 325 906 325 865 q 351 970 325 946 q 417 994 378 994 q 482 970 456 994 q 508 906 508 946 q 482 841 508 865 q 417 817 456 817 z "},"¸":{"ha":833,"x_min":285,"x_max":525,"o":"m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -189 436 -219 q 413 -146 436 -161 q 329 -122 389 -131 l 385 11 l 460 11 l 424 -89 q 499 -122 472 -100 q 525 -187 525 -144 q 466 -278 525 -249 q 296 -314 407 -308 z "},"˛":{"ha":833,"x_min":292,"x_max":565,"o":"m 433 -312 q 332 -281 372 -312 q 292 -183 292 -250 q 303 -124 292 -151 q 331 -72 314 -96 q 369 -30 349 -49 q 410 4 390 -11 l 490 4 q 407 -74 438 -33 q 376 -161 376 -115 q 401 -219 376 -201 q 457 -237 426 -237 q 501 -228 482 -237 q 532 -208 519 -219 l 565 -262 q 508 -299 542 -285 q 433 -312 475 -312 z "},"◌":{"ha":833,"x_min":74,"x_max":760,"o":"m 415 -17 q 382 -3 396 -17 q 368 35 368 10 q 382 72 368 58 q 415 85 396 85 q 451 72 438 85 q 465 35 465 58 q 451 -3 465 10 q 415 -17 438 -17 m 268 21 q 234 34 249 21 q 219 74 219 47 q 234 110 219 97 q 268 122 249 122 q 303 110 289 122 q 318 74 318 97 q 304 34 318 47 q 268 21 290 21 m 563 21 q 529 34 543 21 q 515 74 515 47 q 529 110 515 97 q 563 122 543 122 q 598 110 583 122 q 613 74 613 97 q 599 34 613 47 q 563 21 586 21 m 160 135 q 126 148 140 135 q 113 185 113 161 q 126 224 113 210 q 160 238 140 238 q 196 224 182 238 q 210 185 210 210 q 197 148 210 161 q 160 135 183 135 m 672 135 q 638 148 653 135 q 624 185 624 161 q 638 224 624 210 q 672 238 653 238 q 707 224 693 238 q 721 185 721 210 q 708 148 721 161 q 672 135 696 135 m 121 286 q 88 300 101 286 q 74 338 74 314 q 88 375 74 363 q 121 388 101 388 q 158 375 143 388 q 172 338 172 363 q 158 300 172 314 q 121 286 144 286 m 710 286 q 675 300 689 286 q 661 338 661 314 q 675 375 661 363 q 710 388 689 388 q 744 375 729 388 q 760 338 760 363 q 746 300 760 314 q 710 286 732 286 m 160 439 q 126 453 140 439 q 113 492 113 467 q 126 529 113 517 q 160 542 140 542 q 196 529 182 542 q 210 492 210 517 q 197 453 210 467 q 160 439 183 439 m 672 439 q 638 452 653 439 q 624 490 624 465 q 638 527 624 514 q 672 540 653 540 q 707 527 693 540 q 721 490 721 514 q 672 439 721 439 m 268 553 q 234 566 249 553 q 219 603 219 579 q 234 642 219 629 q 268 654 249 654 q 303 642 289 654 q 318 603 318 629 q 304 566 318 579 q 268 553 290 553 m 563 551 q 529 565 543 551 q 515 603 515 579 q 529 641 515 628 q 563 654 543 654 q 598 641 583 654 q 613 603 613 628 q 599 565 613 579 q 563 551 586 551 m 415 589 q 382 603 396 589 q 368 642 368 617 q 382 678 368 665 q 415 692 396 692 q 451 678 438 692 q 465 642 465 665 q 451 603 465 617 q 415 589 438 589 z "},"̀":{"ha":833,"x_min":228,"x_max":506,"o":"m 446 789 l 228 1001 l 308 1079 l 506 846 l 446 789 z "},"́":{"ha":833,"x_min":328,"x_max":606,"o":"m 388 789 l 328 846 l 525 1079 l 606 1001 l 388 789 z "},"̂":{"ha":833,"x_min":201,"x_max":632,"o":"m 250 789 l 201 833 l 360 1028 l 474 1028 l 632 833 l 583 789 l 419 946 l 414 946 l 250 789 z "},"̃":{"ha":833,"x_min":176,"x_max":657,"o":"m 517 801 q 453 819 479 801 q 404 860 426 838 q 362 900 382 882 q 318 918 342 918 q 271 888 286 918 q 253 808 256 857 l 176 813 q 187 888 178 853 q 213 947 196 922 q 255 987 229 972 q 317 1001 281 1001 q 381 983 354 1001 q 429 943 407 965 q 472 903 451 921 q 517 885 492 885 q 563 915 547 885 q 581 994 578 946 l 657 989 q 647 915 656 949 q 621 856 638 881 q 578 816 604 831 q 517 801 553 801 z "},"̄":{"ha":833,"x_min":232,"x_max":601,"o":"m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 z "},"̅":{"ha":833,"x_min":232,"x_max":601,"o":"m 232 835 l 232 914 l 601 914 l 601 835 l 232 835 z "},"̆":{"ha":833,"x_min":200,"x_max":633,"o":"m 417 793 q 321 811 361 793 q 255 859 281 829 q 216 926 229 889 q 200 1003 203 964 l 271 1014 q 285 962 275 988 q 314 915 296 936 q 358 882 332 894 q 417 869 383 869 q 476 882 450 869 q 519 915 501 894 q 548 962 538 936 q 563 1014 558 988 l 633 1003 q 617 926 631 964 q 578 859 604 889 q 512 811 551 829 q 417 793 472 793 z "},"̇":{"ha":833,"x_min":325,"x_max":508,"o":"m 417 817 q 351 841 378 817 q 325 906 325 865 q 351 970 325 946 q 417 994 378 994 q 482 970 456 994 q 508 906 508 946 q 482 841 508 865 q 417 817 456 817 z "},"̈":{"ha":833,"x_min":206,"x_max":628,"o":"m 282 817 q 227 839 249 817 q 206 894 206 861 q 227 949 206 926 q 282 972 249 972 q 337 949 315 972 q 358 894 358 926 q 337 839 358 861 q 282 817 315 817 m 551 817 q 497 839 518 817 q 475 894 475 861 q 497 949 475 926 q 551 972 518 972 q 606 949 585 972 q 628 894 628 926 q 606 839 628 861 q 551 817 585 817 z "},"̉":{"ha":833,"x_min":322,"x_max":528,"o":"m 372 794 l 360 850 q 415 873 393 858 q 438 915 438 888 q 322 981 438 975 l 329 1056 q 476 1020 425 1053 q 528 925 528 988 q 515 873 528 894 q 480 835 501 851 q 431 810 458 819 q 372 794 403 800 z "},"̐":{"ha":833,"x_min":193,"x_max":640,"o":"m 417 793 q 319 811 360 793 q 251 859 278 829 q 210 926 224 889 q 193 1003 196 964 l 260 1014 q 275 959 264 986 q 306 911 286 932 q 353 877 325 890 q 417 864 381 864 q 479 877 451 864 q 527 911 507 890 q 558 959 547 932 q 574 1014 569 986 l 640 1003 q 624 926 638 964 q 583 859 610 889 q 515 811 556 829 q 417 793 474 793 m 417 974 q 361 994 383 974 q 339 1051 339 1015 q 361 1108 339 1088 q 417 1129 383 1129 q 472 1108 450 1129 q 494 1051 494 1088 q 472 994 494 1015 q 417 974 450 974 z "},"̊":{"ha":833,"x_min":264,"x_max":569,"o":"m 417 790 q 304 828 344 790 q 264 924 264 867 q 304 1019 264 981 q 417 1057 344 1057 q 529 1019 489 1057 q 569 924 569 981 q 529 828 569 867 q 417 790 489 790 m 417 842 q 473 865 450 842 q 496 924 496 889 q 473 983 496 960 q 417 1006 450 1006 q 360 983 383 1006 q 338 924 338 960 q 360 865 338 889 q 417 842 383 842 z "},"̋":{"ha":833,"x_min":274,"x_max":685,"o":"m 338 789 l 274 818 l 394 1057 l 475 1018 l 338 789 m 547 789 l 483 818 l 604 1057 l 685 1018 l 547 789 z "},"̌":{"ha":833,"x_min":201,"x_max":632,"o":"m 360 797 l 201 992 l 250 1036 l 414 879 l 419 879 l 583 1036 l 632 992 l 474 797 l 360 797 z "},"̏":{"ha":833,"x_min":149,"x_max":560,"o":"m 286 789 l 149 1018 l 229 1057 l 350 818 l 286 789 m 496 789 l 358 1018 l 439 1057 l 560 818 l 496 789 z "},"̑":{"ha":833,"x_min":200,"x_max":633,"o":"m 271 789 l 200 800 q 216 876 203 839 q 255 944 229 914 q 321 992 281 974 q 417 1010 361 1010 q 512 992 472 1010 q 578 944 551 974 q 617 876 604 914 q 633 800 631 839 l 563 789 q 548 841 558 815 q 519 888 538 867 q 476 921 501 908 q 417 933 450 933 q 358 921 383 933 q 314 888 332 908 q 285 841 296 867 q 271 789 275 815 z "},"̒":{"ha":833,"x_min":340,"x_max":490,"o":"m 421 768 q 363 795 385 768 q 340 872 340 822 q 369 967 340 924 q 465 1038 399 1011 l 490 990 q 425 946 446 971 q 404 893 404 921 q 422 896 415 896 q 465 881 446 896 q 485 835 485 867 q 467 785 485 803 q 421 768 449 768 z "},"̓":{"ha":833,"x_min":343,"x_max":493,"o":"m 368 768 l 343 815 q 408 860 388 835 q 429 913 429 885 q 411 910 418 910 q 368 924 388 910 q 349 971 349 939 q 367 1020 349 1003 q 413 1038 385 1038 q 471 1010 449 1038 q 493 933 493 983 q 464 838 493 882 q 368 768 435 794 z "},"̘":{"ha":833,"x_min":311,"x_max":544,"o":"m 471 -346 l 471 -246 l 311 -246 l 311 -181 l 471 -181 l 471 -81 l 544 -81 l 544 -346 l 471 -346 z "},"̙":{"ha":833,"x_min":289,"x_max":522,"o":"m 289 -346 l 289 -81 l 363 -81 l 363 -181 l 522 -181 l 522 -246 l 363 -246 l 363 -346 l 289 -346 z "},"̚":{"ha":833,"x_min":311,"x_max":535,"o":"m 465 796 l 465 926 l 311 926 l 311 992 l 535 992 l 535 796 l 465 796 z "},"̛":{"ha":833,"x_min":404,"x_max":622,"o":"m 415 603 l 404 660 q 521 785 521 678 q 515 824 521 806 q 501 861 510 842 l 590 903 q 613 851 604 878 q 622 793 622 825 q 606 716 622 749 q 561 660 589 683 q 496 622 533 636 q 415 603 458 608 z "},"̜":{"ha":833,"x_min":311,"x_max":503,"o":"m 503 -357 q 359 -324 407 -360 q 311 -225 311 -287 q 359 -125 311 -161 q 503 -92 407 -89 l 503 -142 q 423 -164 450 -142 q 396 -225 396 -186 q 423 -285 396 -262 q 503 -307 450 -307 l 503 -357 z "},"̝":{"ha":833,"x_min":256,"x_max":578,"o":"m 256 -293 l 256 -228 l 379 -228 l 379 -81 l 454 -81 l 454 -228 l 578 -228 l 578 -293 l 256 -293 z "},"̞":{"ha":833,"x_min":256,"x_max":578,"o":"m 379 -346 l 379 -199 l 256 -199 l 256 -133 l 578 -133 l 578 -199 l 454 -199 l 454 -346 l 379 -346 z "},"̟":{"ha":833,"x_min":256,"x_max":578,"o":"m 379 -346 l 379 -246 l 256 -246 l 256 -181 l 379 -181 l 379 -81 l 454 -81 l 454 -181 l 578 -181 l 578 -246 l 454 -246 l 454 -346 l 379 -346 z "},"̠":{"ha":833,"x_min":256,"x_max":578,"o":"m 256 -208 l 256 -143 l 578 -143 l 578 -208 l 256 -208 z "},"̣":{"ha":833,"x_min":325,"x_max":508,"o":"m 417 -297 q 351 -273 378 -297 q 325 -208 325 -249 q 351 -144 325 -168 q 417 -119 378 -119 q 482 -144 456 -119 q 508 -208 508 -168 q 482 -273 508 -249 q 417 -297 456 -297 z "},"̤":{"ha":833,"x_min":206,"x_max":628,"o":"m 282 -287 q 227 -265 249 -287 q 206 -210 206 -243 q 227 -155 206 -178 q 282 -132 249 -132 q 337 -155 315 -132 q 358 -210 358 -178 q 337 -265 358 -243 q 282 -287 315 -287 m 551 -287 q 497 -265 518 -287 q 475 -210 475 -243 q 497 -155 475 -178 q 551 -132 518 -132 q 606 -155 585 -132 q 628 -210 628 -178 q 606 -265 628 -243 q 551 -287 585 -287 z "},"̥":{"ha":833,"x_min":264,"x_max":569,"o":"m 417 -337 q 304 -299 344 -337 q 264 -204 264 -261 q 304 -109 264 -147 q 417 -71 344 -71 q 529 -109 489 -71 q 569 -204 569 -147 q 529 -299 569 -261 q 417 -337 489 -337 m 417 -286 q 473 -262 450 -286 q 496 -204 496 -239 q 473 -145 496 -168 q 417 -122 450 -122 q 360 -145 383 -122 q 338 -204 338 -168 q 360 -262 338 -239 q 417 -286 383 -286 z "},"̦":{"ha":833,"x_min":285,"x_max":525,"o":"m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -192 436 -219 q 411 -151 436 -164 q 338 -133 386 -137 l 363 -81 q 489 -116 453 -92 q 525 -187 525 -140 q 466 -278 525 -249 q 296 -314 407 -308 z "},"̧":{"ha":833,"x_min":285,"x_max":525,"o":"m 296 -314 l 285 -258 q 404 -235 372 -251 q 436 -189 436 -219 q 413 -146 436 -161 q 329 -122 389 -131 l 385 11 l 460 11 l 424 -89 q 499 -122 472 -100 q 525 -187 525 -144 q 466 -278 525 -249 q 296 -314 407 -308 z "},"̨":{"ha":833,"x_min":292,"x_max":565,"o":"m 433 -312 q 332 -281 372 -312 q 292 -183 292 -250 q 303 -124 292 -151 q 331 -72 314 -96 q 369 -30 349 -49 q 410 4 390 -11 l 490 4 q 407 -74 438 -33 q 376 -161 376 -115 q 401 -219 376 -201 q 457 -237 426 -237 q 501 -228 482 -237 q 532 -208 519 -219 l 565 -262 q 508 -299 542 -285 q 433 -312 475 -312 z "},"̩":{"ha":833,"x_min":368,"x_max":465,"o":"m 368 -369 l 376 -99 l 457 -99 l 465 -369 l 368 -369 z "},"̪":{"ha":833,"x_min":246,"x_max":588,"o":"m 246 -314 l 246 -114 l 588 -114 l 588 -314 l 521 -314 l 521 -179 l 313 -179 l 313 -314 l 246 -314 z "},"̬":{"ha":833,"x_min":201,"x_max":632,"o":"m 360 -310 l 201 -115 l 250 -71 l 414 -228 l 419 -228 l 583 -71 l 632 -115 l 474 -310 l 360 -310 z "},"̮":{"ha":833,"x_min":200,"x_max":633,"o":"m 417 -319 q 321 -301 361 -319 q 255 -253 281 -283 q 216 -186 229 -224 q 200 -110 203 -149 l 271 -99 q 285 -151 275 -125 q 314 -197 296 -176 q 358 -231 332 -218 q 417 -243 383 -243 q 476 -231 450 -243 q 519 -197 501 -218 q 548 -151 538 -176 q 563 -99 558 -125 l 633 -110 q 617 -186 631 -149 q 578 -253 604 -224 q 512 -301 551 -283 q 417 -319 472 -319 z "},"̯":{"ha":833,"x_min":200,"x_max":633,"o":"m 271 -328 l 200 -317 q 216 -240 203 -278 q 255 -173 229 -203 q 321 -125 281 -143 q 417 -107 361 -107 q 512 -125 472 -107 q 578 -173 551 -143 q 617 -240 604 -203 q 633 -317 631 -278 l 563 -328 q 548 -276 558 -301 q 519 -229 538 -250 q 476 -196 501 -208 q 417 -183 450 -183 q 358 -196 383 -183 q 314 -229 332 -208 q 285 -276 296 -250 q 271 -328 275 -301 z "},"̰":{"ha":833,"x_min":176,"x_max":657,"o":"m 517 -308 q 453 -290 479 -308 q 404 -250 426 -272 q 362 -210 382 -228 q 318 -192 342 -192 q 271 -222 286 -192 q 253 -301 256 -253 l 176 -297 q 187 -222 178 -257 q 213 -162 196 -187 q 255 -123 229 -137 q 317 -108 281 -108 q 381 -126 354 -108 q 429 -167 407 -144 q 472 -207 451 -189 q 517 -225 492 -225 q 563 -194 547 -225 q 581 -115 578 -164 l 657 -121 q 647 -195 656 -161 q 621 -254 638 -229 q 578 -294 604 -279 q 517 -308 553 -308 z "},"̱":{"ha":833,"x_min":232,"x_max":601,"o":"m 232 -235 l 232 -156 l 601 -156 l 601 -235 l 232 -235 z "},"̴":{"ha":833,"x_min":154,"x_max":679,"o":"m 547 240 q 468 258 501 240 q 406 299 435 276 q 351 339 378 321 q 294 357 325 357 q 249 327 264 357 q 231 249 233 297 l 154 263 q 164 333 156 300 q 188 389 172 365 q 228 426 204 413 q 286 440 253 440 q 366 422 332 440 q 428 382 400 404 q 483 342 457 360 q 539 324 508 324 q 585 353 569 324 q 603 431 600 383 l 679 418 q 669 348 676 381 q 645 292 661 315 q 605 254 629 268 q 547 240 581 240 z "},"̹":{"ha":833,"x_min":331,"x_max":522,"o":"m 331 -357 l 331 -307 q 410 -285 383 -307 q 438 -225 438 -262 q 410 -164 438 -186 q 331 -142 383 -142 l 331 -92 q 474 -125 426 -89 q 522 -225 522 -161 q 474 -324 522 -287 q 331 -357 426 -360 z "},"̺":{"ha":833,"x_min":246,"x_max":588,"o":"m 246 -312 l 246 -114 l 313 -114 l 313 -247 l 521 -247 l 521 -114 l 588 -114 l 588 -312 l 246 -312 z "},"̻":{"ha":833,"x_min":246,"x_max":588,"o":"m 246 -333 l 246 -107 l 588 -107 l 588 -333 l 246 -333 m 313 -278 l 521 -278 l 521 -161 l 313 -161 l 313 -278 z "},"̼":{"ha":833,"x_min":179,"x_max":654,"o":"m 253 -325 l 181 -317 q 214 -160 179 -208 q 315 -111 249 -111 q 378 -129 351 -111 q 415 -192 404 -147 l 418 -192 q 456 -129 429 -147 q 518 -111 483 -111 q 619 -160 585 -111 q 653 -317 654 -208 l 581 -325 q 563 -214 581 -242 q 513 -186 544 -186 q 465 -215 481 -186 q 450 -297 450 -244 l 450 -324 l 383 -324 l 383 -297 q 367 -215 383 -244 q 319 -186 351 -186 q 270 -214 288 -186 q 253 -325 253 -242 z "},"̽":{"ha":833,"x_min":286,"x_max":547,"o":"m 331 785 l 286 826 l 371 906 l 286 985 l 331 1026 l 417 946 l 503 1026 l 547 985 l 463 906 l 547 826 l 503 785 l 417 865 l 331 785 z "},"͂":{"ha":833,"x_min":176,"x_max":657,"o":"m 517 801 q 453 819 479 801 q 404 860 426 838 q 362 900 382 882 q 318 918 342 918 q 271 888 286 918 q 253 808 256 857 l 176 813 q 187 888 178 853 q 213 947 196 922 q 255 987 229 972 q 317 1001 281 1001 q 381 983 354 1001 q 429 943 407 965 q 472 903 451 921 q 517 885 492 885 q 563 915 547 885 q 581 994 578 946 l 657 989 q 647 915 656 949 q 621 856 638 881 q 578 816 604 831 q 517 801 553 801 z "},"ͅ":{"ha":833,"x_min":371,"x_max":542,"o":"m 478 -279 q 371 -151 371 -279 l 371 -86 l 460 -86 q 457 -124 457 -104 q 457 -160 457 -144 q 469 -193 457 -183 q 499 -203 482 -203 q 510 -202 504 -203 q 529 -199 515 -201 l 542 -267 q 515 -276 528 -272 q 478 -279 501 -279 z "},"͟":{"ha":833,"x_min":-268,"x_max":1101,"o":"m -268 -237 l -268 -157 l 1101 -157 l 1101 -237 l -268 -237 z "},"͡":{"ha":833,"x_min":-214,"x_max":1047,"o":"m -181 833 l -214 892 q 83 1023 -74 978 q 417 1068 239 1068 q 751 1023 594 1068 q 1047 892 907 978 l 1014 833 q 724 951 881 914 q 417 988 568 988 q 109 951 265 988 q -181 833 -47 914 z "}," ":{"ha":833,"x_min":0,"x_max":0,"o":""}," ":{"ha":833,"x_min":0,"x_max":0,"o":""},"─":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 363 l -54 471 l 888 471 l 888 363 l -54 363 z "},"━":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 308 l -54 525 l 888 525 l 888 308 l -54 308 z "},"│":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 -556 l 363 1389 l 471 1389 l 471 -556 l 363 -556 z "},"┃":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 -556 l 308 1389 l 525 1389 l 525 -556 l 308 -556 z "},"┄":{"ha":833,"x_min":46,"x_max":788,"o":"m 601 363 l 601 471 l 788 471 l 788 363 l 601 363 m 324 363 l 324 471 l 510 471 l 510 363 l 324 363 m 46 363 l 46 471 l 232 471 l 232 363 l 46 363 z "},"┅":{"ha":833,"x_min":46,"x_max":788,"o":"m 601 308 l 601 525 l 788 525 l 788 308 l 601 308 m 324 308 l 324 525 l 510 525 l 510 308 l 324 308 m 46 308 l 46 525 l 232 525 l 232 308 l 46 308 z "},"┆":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 788 l 363 1157 l 471 1157 l 471 788 l 363 788 m 363 232 l 363 601 l 471 601 l 471 232 l 363 232 m 363 -324 l 363 46 l 471 46 l 471 -324 l 363 -324 z "},"┇":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 788 l 308 1157 l 525 1157 l 525 788 l 308 788 m 308 232 l 308 601 l 525 601 l 525 232 l 308 232 m 308 -324 l 308 46 l 525 46 l 525 -324 l 308 -324 z "},"┈":{"ha":833,"x_min":26,"x_max":807,"o":"m 651 363 l 651 471 l 807 471 l 807 363 l 651 363 m 443 363 l 443 471 l 599 471 l 599 363 l 443 363 m 235 363 l 235 471 l 390 471 l 390 363 l 235 363 m 26 363 l 26 471 l 182 471 l 182 363 l 26 363 z "},"┉":{"ha":833,"x_min":26,"x_max":807,"o":"m 651 308 l 651 525 l 807 525 l 807 308 l 651 308 m 443 308 l 443 525 l 599 525 l 599 308 l 443 308 m 235 308 l 235 525 l 390 525 l 390 308 l 235 308 m 26 308 l 26 525 l 182 525 l 182 308 l 26 308 z "},"┊":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 886 l 363 1199 l 471 1199 l 471 886 l 363 886 m 363 469 l 363 782 l 471 782 l 471 469 l 363 469 m 363 53 l 363 365 l 471 365 l 471 53 l 363 53 m 363 -365 l 363 -53 l 471 -53 l 471 -365 l 363 -365 z "},"┋":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 886 l 308 1199 l 525 1199 l 525 886 l 308 886 m 308 469 l 308 782 l 525 782 l 525 469 l 308 469 m 308 53 l 308 365 l 525 365 l 525 53 l 308 53 m 308 -365 l 308 -53 l 525 -53 l 525 -365 l 308 -365 z "},"┌":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 471 l 888 471 l 888 363 z "},"┍":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 525 l 888 525 l 888 308 z "},"┎":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 471 l 888 471 l 888 363 z "},"┏":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 525 l 888 525 l 888 308 z "},"┐":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 471 471 l 471 -556 z "},"┑":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 471 525 l 471 -556 z "},"┒":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 525 471 l 525 -556 z "},"┓":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 525 525 l 525 -556 z "},"└":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 363 l 363 363 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┕":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 308 l 363 308 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┖":{"ha":833,"x_min":308,"x_max":888,"o":"m 308 363 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 l 308 363 z "},"┗":{"ha":833,"x_min":308,"x_max":888,"o":"m 308 308 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 l 308 308 z "},"┘":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 363 z "},"┙":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 308 z "},"┚":{"ha":833,"x_min":-54,"x_max":525,"o":"m -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 363 l -54 363 z "},"┛":{"ha":833,"x_min":-54,"x_max":525,"o":"m -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 308 l -54 308 z "},"├":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┝":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┞":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 363 l 308 363 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"┟":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┠":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"┡":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l 308 308 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"┢":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┣":{"ha":833,"x_min":308,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"┤":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 -556 z "},"┥":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 -556 z "},"┦":{"ha":833,"x_min":-54,"x_max":525,"o":"m 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 363 l 471 363 l 471 -556 z "},"┧":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 525 471 l 525 -556 z "},"┨":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 -556 z "},"┩":{"ha":833,"x_min":-54,"x_max":525,"o":"m 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 308 l 471 308 l 471 -556 z "},"┪":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 525 525 l 525 -556 z "},"┫":{"ha":833,"x_min":-54,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 -556 z "},"┬":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 888 471 l 888 363 z "},"┭":{"ha":833,"x_min":-54,"x_max":888,"o":"m 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 471 525 l 471 471 l 888 471 l 888 363 l 471 363 l 471 -556 z "},"┮":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 363 471 l 363 525 l 888 525 l 888 308 z "},"┯":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 888 525 l 888 308 z "},"┰":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 888 471 l 888 363 z "},"┱":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 525 525 l 525 471 l 888 471 l 888 363 z "},"┲":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 308 471 l 308 525 l 888 525 l 888 308 z "},"┳":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 888 525 l 888 308 z "},"┴":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┵":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┶":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 363 308 l 363 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┷":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┸":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"┹":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 l 525 363 l 525 308 l -54 308 z "},"┺":{"ha":833,"x_min":-54,"x_max":888,"o":"m 308 308 l 308 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 l 308 308 z "},"┻":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"┼":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┽":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"┾":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"┿":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"╀":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 -556 l 363 -556 l 363 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"╁":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 888 471 l 888 363 z "},"╂":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"╃":{"ha":833,"x_min":-54,"x_max":888,"o":"m 525 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 l 525 363 l 525 308 z "},"╄":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l 308 308 l 308 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"╅":{"ha":833,"x_min":-54,"x_max":888,"o":"m 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 525 525 l 525 471 l 888 471 l 888 363 l 525 363 l 525 -556 z "},"╆":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 308 471 l 308 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"╇":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 471 308 l 471 -556 l 363 -556 l 363 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"╈":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 363 525 l 363 1389 l 471 1389 l 471 525 l 888 525 l 888 308 z "},"╉":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 525 363 l 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 471 l 888 471 l 888 363 z "},"╊":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 363 l -54 363 l -54 471 l 308 471 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"╋":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 525 308 l 525 -556 l 308 -556 l 308 308 l -54 308 l -54 525 l 308 525 l 308 1389 l 525 1389 l 525 525 l 888 525 l 888 308 z "},"╌":{"ha":833,"x_min":104,"x_max":729,"o":"m 521 363 l 521 471 l 729 471 l 729 363 l 521 363 m 104 363 l 104 471 l 313 471 l 313 363 l 104 363 z "},"╍":{"ha":833,"x_min":104,"x_max":729,"o":"m 521 308 l 521 525 l 729 525 l 729 308 l 521 308 m 104 308 l 104 525 l 313 525 l 313 308 l 104 308 z "},"╎":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 625 l 363 1042 l 471 1042 l 471 625 l 363 625 m 363 -208 l 363 208 l 471 208 l 471 -208 l 363 -208 z "},"╏":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 625 l 308 1042 l 525 1042 l 525 625 l 308 625 m 308 -208 l 308 208 l 525 208 l 525 -208 l 308 -208 z "},"═":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 471 l -54 579 l 888 579 l 888 471 l -54 471 m -54 254 l -54 363 l 888 363 l 888 254 l -54 254 z "},"║":{"ha":833,"x_min":254,"x_max":579,"o":"m 471 -556 l 471 1389 l 579 1389 l 579 -556 l 471 -556 m 254 -556 l 254 1389 l 363 1389 l 363 -556 l 254 -556 z "},"╒":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 254 l 471 254 l 471 -556 l 363 -556 l 363 579 l 888 579 l 888 471 l 471 471 l 471 363 l 888 363 l 888 254 z "},"╓":{"ha":833,"x_min":254,"x_max":888,"o":"m 471 -556 l 471 363 l 363 363 l 363 -556 l 254 -556 l 254 471 l 888 471 l 888 363 l 579 363 l 579 -556 l 471 -556 z "},"╔":{"ha":833,"x_min":254,"x_max":888,"o":"m 888 471 l 363 471 l 363 -556 l 254 -556 l 254 579 l 888 579 l 888 471 m 888 254 l 579 254 l 579 -556 l 471 -556 l 471 363 l 888 363 l 888 254 z "},"╕":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 254 l -54 254 l -54 363 l 363 363 l 363 471 l -54 471 l -54 579 l 471 579 l 471 -556 z "},"╖":{"ha":833,"x_min":-54,"x_max":579,"o":"m 471 -556 l 471 363 l 363 363 l 363 -556 l 254 -556 l 254 363 l -54 363 l -54 471 l 579 471 l 579 -556 l 471 -556 z "},"╗":{"ha":833,"x_min":-54,"x_max":579,"o":"m 579 -556 l 471 -556 l 471 471 l -54 471 l -54 579 l 579 579 l 579 -556 m 363 -556 l 254 -556 l 254 254 l -54 254 l -54 363 l 363 363 l 363 -556 z "},"╘":{"ha":833,"x_min":363,"x_max":888,"o":"m 363 254 l 363 1389 l 471 1389 l 471 579 l 888 579 l 888 471 l 471 471 l 471 363 l 888 363 l 888 254 l 363 254 z "},"╙":{"ha":833,"x_min":254,"x_max":888,"o":"m 254 363 l 254 1389 l 363 1389 l 363 471 l 471 471 l 471 1389 l 579 1389 l 579 471 l 888 471 l 888 363 l 254 363 z "},"╚":{"ha":833,"x_min":254,"x_max":888,"o":"m 471 471 l 471 1389 l 579 1389 l 579 579 l 888 579 l 888 471 l 471 471 m 254 254 l 254 1389 l 363 1389 l 363 363 l 888 363 l 888 254 l 254 254 z "},"╛":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 254 l -54 254 l -54 363 l 363 363 l 363 471 l -54 471 l -54 579 l 363 579 l 363 1389 l 471 1389 l 471 254 z "},"╜":{"ha":833,"x_min":-54,"x_max":579,"o":"m 579 363 l -54 363 l -54 471 l 254 471 l 254 1389 l 363 1389 l 363 471 l 471 471 l 471 1389 l 579 1389 l 579 363 z "},"╝":{"ha":833,"x_min":-54,"x_max":579,"o":"m 363 471 l -54 471 l -54 579 l 254 579 l 254 1389 l 363 1389 l 363 471 m 579 254 l -54 254 l -54 363 l 471 363 l 471 1389 l 579 1389 l 579 254 z "},"╞":{"ha":833,"x_min":363,"x_max":888,"o":"m 888 254 l 471 254 l 471 -556 l 363 -556 l 363 1389 l 471 1389 l 471 579 l 888 579 l 888 471 l 471 471 l 471 363 l 888 363 l 888 254 z "},"╟":{"ha":833,"x_min":254,"x_max":888,"o":"m 254 -556 l 254 1389 l 363 1389 l 363 -556 l 254 -556 m 888 363 l 579 363 l 579 -556 l 471 -556 l 471 1389 l 579 1389 l 579 471 l 888 471 l 888 363 z "},"╠":{"ha":833,"x_min":254,"x_max":888,"o":"m 254 -556 l 254 1389 l 363 1389 l 363 -556 l 254 -556 m 471 471 l 471 1389 l 579 1389 l 579 579 l 888 579 l 888 471 l 471 471 m 888 254 l 579 254 l 579 -556 l 471 -556 l 471 363 l 888 363 l 888 254 z "},"╡":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 -556 l 363 -556 l 363 254 l -54 254 l -54 363 l 363 363 l 363 471 l -54 471 l -54 579 l 363 579 l 363 1389 l 471 1389 l 471 -556 z "},"╢":{"ha":833,"x_min":-54,"x_max":579,"o":"m 471 -556 l 471 1389 l 579 1389 l 579 -556 l 471 -556 m 363 -556 l 254 -556 l 254 363 l -54 363 l -54 471 l 254 471 l 254 1389 l 363 1389 l 363 -556 z "},"╣":{"ha":833,"x_min":-54,"x_max":579,"o":"m 471 -556 l 471 1389 l 579 1389 l 579 -556 l 471 -556 m 363 471 l -54 471 l -54 579 l 254 579 l 254 1389 l 363 1389 l 363 471 m 363 -556 l 254 -556 l 254 254 l -54 254 l -54 363 l 363 363 l 363 -556 z "},"╤":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 471 l -54 579 l 888 579 l 888 471 l -54 471 m 888 254 l 471 254 l 471 -556 l 363 -556 l 363 254 l -54 254 l -54 363 l 888 363 l 888 254 z "},"╥":{"ha":833,"x_min":-54,"x_max":888,"o":"m 471 -556 l 471 363 l 363 363 l 363 -556 l 254 -556 l 254 363 l -54 363 l -54 471 l 888 471 l 888 363 l 579 363 l 579 -556 l 471 -556 z "},"╦":{"ha":833,"x_min":-54,"x_max":888,"o":"m -54 471 l -54 579 l 888 579 l 888 471 l -54 471 m 888 254 l 579 254 l 579 -556 l 471 -556 l 471 363 l 888 363 l 888 254 m 363 -556 l 254 -556 l 254 254 l -54 254 l -54 363 l 363 363 l 363 -556 z "},"╧":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 471 l -54 471 l -54 579 l 363 579 l 363 1389 l 471 1389 l 471 579 l 888 579 l 888 471 m -54 254 l -54 363 l 888 363 l 888 254 l -54 254 z "},"╨":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l -54 363 l -54 471 l 254 471 l 254 1389 l 363 1389 l 363 471 l 471 471 l 471 1389 l 579 1389 l 579 471 l 888 471 l 888 363 z "},"╩":{"ha":833,"x_min":-54,"x_max":888,"o":"m 471 471 l 471 1389 l 579 1389 l 579 579 l 888 579 l 888 471 l 471 471 m 363 471 l -54 471 l -54 579 l 254 579 l 254 1389 l 363 1389 l 363 471 m -54 254 l -54 363 l 888 363 l 888 254 l -54 254 z "},"╪":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 254 l 471 254 l 471 -556 l 363 -556 l 363 254 l -54 254 l -54 363 l 363 363 l 363 471 l -54 471 l -54 579 l 363 579 l 363 1389 l 471 1389 l 471 579 l 888 579 l 888 471 l 471 471 l 471 363 l 888 363 l 888 254 z "},"╫":{"ha":833,"x_min":-54,"x_max":888,"o":"m 471 -556 l 471 363 l 363 363 l 363 -556 l 254 -556 l 254 363 l -54 363 l -54 471 l 254 471 l 254 1389 l 363 1389 l 363 471 l 471 471 l 471 1389 l 579 1389 l 579 471 l 888 471 l 888 363 l 579 363 l 579 -556 l 471 -556 z "},"╬":{"ha":833,"x_min":-54,"x_max":888,"o":"m 471 471 l 471 1389 l 579 1389 l 579 579 l 888 579 l 888 471 l 471 471 m 363 471 l -54 471 l -54 579 l 254 579 l 254 1389 l 363 1389 l 363 471 m 888 254 l 579 254 l 579 -556 l 471 -556 l 471 363 l 888 363 l 888 254 m 363 -556 l 254 -556 l 254 254 l -54 254 l -54 363 l 363 363 l 363 -556 z "},"╭":{"ha":833,"x_min":363,"x_max":888,"o":"m 363 -556 l 363 0 q 399 183 363 97 q 500 333 436 269 q 650 434 564 397 q 833 471 736 471 l 888 471 l 888 363 l 833 363 q 692 334 758 363 q 577 256 626 306 q 499 141 528 207 q 471 0 471 75 l 471 -556 l 363 -556 z "},"╮":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 0 l 471 -556 l 363 -556 l 363 0 q 334 141 363 75 q 256 256 306 207 q 141 334 207 306 q 0 363 75 363 l -54 363 l -54 471 l 0 471 q 183 434 97 471 q 333 333 269 397 q 434 183 397 269 q 471 0 471 97 z "},"╯":{"ha":833,"x_min":-54,"x_max":471,"o":"m 471 1389 l 471 833 q 434 650 471 736 q 333 500 397 564 q 183 399 269 436 q 0 363 97 363 l -54 363 l -54 471 l 0 471 q 141 499 75 471 q 256 577 207 528 q 334 692 306 626 q 363 833 363 758 l 363 1389 l 471 1389 z "},"╰":{"ha":833,"x_min":363,"x_max":888,"o":"m 363 833 l 363 1389 l 471 1389 l 471 833 q 499 692 471 758 q 577 577 528 626 q 692 499 626 528 q 833 471 758 471 l 888 471 l 888 363 l 833 363 q 650 399 736 363 q 500 500 564 436 q 399 650 436 564 q 363 833 363 736 z "},"╱":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -296 l 774 1250 l 833 1250 l 833 1129 l 60 -417 l 0 -417 l 0 -296 z "},"╲":{"ha":833,"x_min":0,"x_max":833,"o":"m 60 1250 l 833 -296 l 833 -417 l 774 -417 l 0 1129 l 0 1250 l 60 1250 z "},"╳":{"ha":833,"x_min":0,"x_max":833,"o":"m 774 -417 l 417 296 l 60 -417 l 0 -417 l 0 -296 l 357 417 l 0 1129 l 0 1250 l 60 1250 l 417 538 l 774 1250 l 833 1250 l 833 1129 l 476 417 l 833 -296 l 833 -417 l 774 -417 z "},"╴":{"ha":833,"x_min":-54,"x_max":471,"o":"m -54 363 l -54 471 l 471 471 l 471 363 l -54 363 z "},"╵":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 363 l 363 1389 l 471 1389 l 471 363 l 363 363 z "},"╶":{"ha":833,"x_min":363,"x_max":888,"o":"m 363 363 l 363 471 l 888 471 l 888 363 l 363 363 z "},"╷":{"ha":833,"x_min":363,"x_max":471,"o":"m 363 -556 l 363 471 l 471 471 l 471 -556 l 363 -556 z "},"╸":{"ha":833,"x_min":-54,"x_max":471,"o":"m -54 308 l -54 525 l 471 525 l 471 308 l -54 308 z "},"╹":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 363 l 308 1389 l 525 1389 l 525 363 l 308 363 z "},"╺":{"ha":833,"x_min":363,"x_max":888,"o":"m 363 308 l 363 525 l 888 525 l 888 308 l 363 308 z "},"╻":{"ha":833,"x_min":308,"x_max":525,"o":"m 308 -556 l 308 471 l 525 471 l 525 -556 l 308 -556 z "},"╼":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 308 l 363 308 l 363 363 l -54 363 l -54 471 l 363 471 l 363 525 l 888 525 l 888 308 z "},"╽":{"ha":833,"x_min":308,"x_max":525,"o":"m 525 -556 l 308 -556 l 308 471 l 363 471 l 363 1389 l 471 1389 l 471 471 l 525 471 l 525 -556 z "},"╾":{"ha":833,"x_min":-54,"x_max":888,"o":"m 888 363 l 471 363 l 471 308 l -54 308 l -54 525 l 471 525 l 471 471 l 888 471 l 888 363 z "},"╿":{"ha":833,"x_min":308,"x_max":525,"o":"m 525 363 l 471 363 l 471 -556 l 363 -556 l 363 363 l 308 363 l 308 1389 l 525 1389 l 525 363 z "},"▀":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 417 l 0 1389 l 833 1389 l 833 417 l 0 417 z "},"▁":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 -312 l 833 -312 l 833 -556 l 0 -556 z "},"▂":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 -69 l 833 -69 l 833 -556 l 0 -556 z "},"▃":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 174 l 833 174 l 833 -556 l 0 -556 z "},"▄":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 417 l 833 417 l 833 -556 l 0 -556 z "},"▅":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 660 l 833 660 l 833 -556 l 0 -556 z "},"▆":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 903 l 833 903 l 833 -556 l 0 -556 z "},"▇":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 1146 l 833 1146 l 833 -556 l 0 -556 z "},"█":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 1389 l 833 1389 l 833 -556 l 0 -556 z "},"▉":{"ha":833,"x_min":0,"x_max":729,"o":"m 0 -556 l 0 1389 l 729 1389 l 729 -556 l 0 -556 z "},"▊":{"ha":833,"x_min":0,"x_max":625,"o":"m 0 -556 l 0 1389 l 625 1389 l 625 -556 l 0 -556 z "},"▋":{"ha":833,"x_min":0,"x_max":521,"o":"m 0 -556 l 0 1389 l 521 1389 l 521 -556 l 0 -556 z "},"▌":{"ha":833,"x_min":0,"x_max":417,"o":"m 0 -556 l 0 1389 l 417 1389 l 417 -556 l 0 -556 z "},"▍":{"ha":833,"x_min":0,"x_max":313,"o":"m 0 -556 l 0 1389 l 313 1389 l 313 -556 l 0 -556 z "},"▎":{"ha":833,"x_min":0,"x_max":208,"o":"m 0 -556 l 0 1389 l 208 1389 l 208 -556 l 0 -556 z "},"▏":{"ha":833,"x_min":0,"x_max":104,"o":"m 0 -556 l 0 1389 l 104 1389 l 104 -556 l 0 -556 z "},"▐":{"ha":833,"x_min":417,"x_max":833,"o":"m 417 -556 l 417 1389 l 833 1389 l 833 -556 l 417 -556 z "},"░":{"ha":833,"x_min":-33,"x_max":744,"o":"m 644 1250 q 659 1285 644 1271 q 694 1300 674 1300 q 730 1285 715 1300 q 744 1250 744 1271 q 730 1215 744 1229 q 694 1200 715 1200 q 659 1215 674 1200 q 644 1250 644 1229 m 367 1250 q 381 1285 367 1271 q 417 1300 396 1300 q 452 1285 438 1300 q 467 1250 467 1271 q 452 1215 467 1229 q 417 1200 438 1200 q 381 1215 396 1200 q 367 1250 367 1229 m 89 1250 q 103 1285 89 1271 q 139 1300 118 1300 q 174 1285 160 1300 q 189 1250 189 1271 q 174 1215 189 1229 q 139 1200 160 1200 q 103 1215 118 1200 q 89 1250 89 1229 m 522 1111 q 532 1135 522 1125 q 556 1144 542 1144 q 579 1135 569 1144 q 589 1111 589 1125 q 579 1088 589 1097 q 556 1078 569 1078 q 532 1088 542 1078 q 522 1111 522 1097 m 244 1111 q 254 1135 244 1125 q 278 1144 264 1144 q 301 1135 292 1144 q 311 1111 311 1125 q 301 1088 311 1097 q 278 1078 292 1078 q 254 1088 264 1078 q 244 1111 244 1097 m -33 1111 q -24 1135 -33 1125 q 0 1144 -14 1144 q 24 1135 14 1144 q 33 1111 33 1125 q 24 1088 33 1097 q 0 1078 14 1078 q -24 1088 -14 1078 q -33 1111 -33 1097 m 644 972 q 659 1008 644 993 q 694 1022 674 1022 q 730 1008 715 1022 q 744 972 744 993 q 730 937 744 951 q 694 922 715 922 q 659 937 674 922 q 644 972 644 951 m 367 972 q 381 1008 367 993 q 417 1022 396 1022 q 452 1008 438 1022 q 467 972 467 993 q 452 937 467 951 q 417 922 438 922 q 381 937 396 922 q 367 972 367 951 m 89 972 q 103 1008 89 993 q 139 1022 118 1022 q 174 1008 160 1022 q 189 972 189 993 q 174 937 189 951 q 139 922 160 922 q 103 937 118 922 q 89 972 89 951 m 522 833 q 532 857 522 847 q 556 867 542 867 q 579 857 569 867 q 589 833 589 847 q 579 810 589 819 q 556 800 569 800 q 532 810 542 800 q 522 833 522 819 m 244 833 q 254 857 244 847 q 278 867 264 867 q 301 857 292 867 q 311 833 311 847 q 301 810 311 819 q 278 800 292 800 q 254 810 264 800 q 244 833 244 819 m -33 833 q -24 857 -33 847 q 0 867 -14 867 q 24 857 14 867 q 33 833 33 847 q 24 810 33 819 q 0 800 14 800 q -24 810 -14 800 q -33 833 -33 819 m 644 694 q 659 730 644 715 q 694 744 674 744 q 730 730 715 744 q 744 694 744 715 q 730 659 744 674 q 694 644 715 644 q 659 659 674 644 q 644 694 644 674 m 367 694 q 381 730 367 715 q 417 744 396 744 q 452 730 438 744 q 467 694 467 715 q 452 659 467 674 q 417 644 438 644 q 381 659 396 644 q 367 694 367 674 m 89 694 q 103 730 89 715 q 139 744 118 744 q 174 730 160 744 q 189 694 189 715 q 174 659 189 674 q 139 644 160 644 q 103 659 118 644 q 89 694 89 674 m 522 556 q 532 579 522 569 q 556 589 542 589 q 579 579 569 589 q 589 556 589 569 q 579 532 589 542 q 556 522 569 522 q 532 532 542 522 q 522 556 522 542 m 244 556 q 254 579 244 569 q 278 589 264 589 q 301 579 292 589 q 311 556 311 569 q 301 532 311 542 q 278 522 292 522 q 254 532 264 522 q 244 556 244 542 m -33 556 q -24 579 -33 569 q 0 589 -14 589 q 24 579 14 589 q 33 556 33 569 q 24 532 33 542 q 0 522 14 522 q -24 532 -14 522 q -33 556 -33 542 m 644 417 q 659 452 644 438 q 694 467 674 467 q 730 452 715 467 q 744 417 744 438 q 730 381 744 396 q 694 367 715 367 q 659 381 674 367 q 644 417 644 396 m 367 417 q 381 452 367 438 q 417 467 396 467 q 452 452 438 467 q 467 417 467 438 q 452 381 467 396 q 417 367 438 367 q 381 381 396 367 q 367 417 367 396 m 89 417 q 103 452 89 438 q 139 467 118 467 q 174 452 160 467 q 189 417 189 438 q 174 381 189 396 q 139 367 160 367 q 103 381 118 367 q 89 417 89 396 m 522 278 q 532 301 522 292 q 556 311 542 311 q 579 301 569 311 q 589 278 589 292 q 579 254 589 264 q 556 244 569 244 q 532 254 542 244 q 522 278 522 264 m 244 278 q 254 301 244 292 q 278 311 264 311 q 301 301 292 311 q 311 278 311 292 q 301 254 311 264 q 278 244 292 244 q 254 254 264 244 q 244 278 244 264 m -33 278 q -24 301 -33 292 q 0 311 -14 311 q 24 301 14 311 q 33 278 33 292 q 24 254 33 264 q 0 244 14 244 q -24 254 -14 244 q -33 278 -33 264 m 644 139 q 659 174 644 160 q 694 189 674 189 q 730 174 715 189 q 744 139 744 160 q 730 103 744 118 q 694 89 715 89 q 659 103 674 89 q 644 139 644 118 m 367 139 q 381 174 367 160 q 417 189 396 189 q 452 174 438 189 q 467 139 467 160 q 452 103 467 118 q 417 89 438 89 q 381 103 396 89 q 367 139 367 118 m 89 139 q 103 174 89 160 q 139 189 118 189 q 174 174 160 189 q 189 139 189 160 q 174 103 189 118 q 139 89 160 89 q 103 103 118 89 q 89 139 89 118 m 522 0 q 532 24 522 14 q 556 33 542 33 q 579 24 569 33 q 589 0 589 14 q 579 -24 589 -14 q 556 -33 569 -33 q 532 -24 542 -33 q 522 0 522 -14 m 244 0 q 254 24 244 14 q 278 33 264 33 q 301 24 292 33 q 311 0 311 14 q 301 -24 311 -14 q 278 -33 292 -33 q 254 -24 264 -33 q 244 0 244 -14 m -33 0 q -24 24 -33 14 q 0 33 -14 33 q 24 24 14 33 q 33 0 33 14 q 24 -24 33 -14 q 0 -33 14 -33 q -24 -24 -14 -33 q -33 0 -33 -14 m 644 -139 q 659 -103 644 -118 q 694 -89 674 -89 q 730 -103 715 -89 q 744 -139 744 -118 q 730 -174 744 -160 q 694 -189 715 -189 q 659 -174 674 -189 q 644 -139 644 -160 m 367 -139 q 381 -103 367 -118 q 417 -89 396 -89 q 452 -103 438 -89 q 467 -139 467 -118 q 452 -174 467 -160 q 417 -189 438 -189 q 381 -174 396 -189 q 367 -139 367 -160 m 89 -139 q 103 -103 89 -118 q 139 -89 118 -89 q 174 -103 160 -89 q 189 -139 189 -118 q 174 -174 189 -160 q 139 -189 160 -189 q 103 -174 118 -189 q 89 -139 89 -160 m 522 -278 q 532 -254 522 -264 q 556 -244 542 -244 q 579 -254 569 -244 q 589 -278 589 -264 q 579 -301 589 -292 q 556 -311 569 -311 q 532 -301 542 -311 q 522 -278 522 -292 m 244 -278 q 254 -254 244 -264 q 278 -244 264 -244 q 301 -254 292 -244 q 311 -278 311 -264 q 301 -301 311 -292 q 278 -311 292 -311 q 254 -301 264 -311 q 244 -278 244 -292 m -33 -278 q -24 -254 -33 -264 q 0 -244 -14 -244 q 24 -254 14 -244 q 33 -278 33 -264 q 24 -301 33 -292 q 0 -311 14 -311 q -24 -301 -14 -311 q -33 -278 -33 -292 m 644 -417 q 659 -381 644 -396 q 694 -367 674 -367 q 730 -381 715 -367 q 744 -417 744 -396 q 730 -452 744 -437 q 694 -467 715 -467 q 659 -452 674 -467 q 644 -417 644 -437 m 367 -417 q 381 -381 367 -396 q 417 -367 396 -367 q 452 -381 438 -367 q 467 -417 467 -396 q 452 -452 467 -437 q 417 -467 438 -467 q 381 -452 396 -467 q 367 -417 367 -437 m 89 -417 q 103 -381 89 -396 q 139 -367 118 -367 q 174 -381 160 -367 q 189 -417 189 -396 q 174 -452 189 -437 q 139 -467 160 -467 q 103 -452 118 -467 q 89 -417 89 -437 m 522 -556 q 532 -532 522 -542 q 556 -522 542 -522 q 579 -532 569 -522 q 589 -556 589 -542 q 579 -579 589 -569 q 556 -589 569 -589 q 532 -579 542 -589 q 522 -556 522 -569 m 244 -556 q 254 -532 244 -542 q 278 -522 264 -522 q 301 -532 292 -522 q 311 -556 311 -542 q 301 -579 311 -569 q 278 -589 292 -589 q 254 -579 264 -589 q 244 -556 244 -569 m -33 -556 q -24 -532 -33 -542 q 0 -522 -14 -522 q 24 -532 14 -522 q 33 -556 33 -542 q 24 -579 33 -569 q 0 -589 14 -589 q -24 -579 -14 -589 q -33 -556 -33 -569 z "},"▒":{"ha":833,"x_min":-50,"x_max":769,"o":"m 619 1250 q 641 1303 619 1282 q 694 1325 663 1325 q 748 1303 726 1325 q 769 1250 769 1282 q 748 1197 769 1218 q 694 1175 726 1175 q 641 1197 663 1175 q 619 1250 619 1218 m 342 1250 q 363 1303 342 1282 q 417 1325 385 1325 q 470 1303 449 1325 q 492 1250 492 1282 q 470 1197 492 1218 q 417 1175 449 1175 q 363 1197 385 1175 q 342 1250 342 1218 m 64 1250 q 85 1303 64 1282 q 139 1325 107 1325 q 192 1303 171 1325 q 214 1250 214 1282 q 192 1197 214 1218 q 139 1175 171 1175 q 85 1197 107 1175 q 64 1250 64 1218 m 506 1111 q 520 1147 506 1132 q 556 1161 535 1161 q 591 1147 576 1161 q 606 1111 606 1132 q 591 1076 606 1090 q 556 1061 576 1061 q 520 1076 535 1061 q 506 1111 506 1090 m 228 1111 q 242 1147 228 1132 q 278 1161 257 1161 q 313 1147 299 1161 q 328 1111 328 1132 q 313 1076 328 1090 q 278 1061 299 1061 q 242 1076 257 1061 q 228 1111 228 1090 m -50 1111 q -35 1147 -50 1132 q 0 1161 -21 1161 q 35 1147 21 1161 q 50 1111 50 1132 q 35 1076 50 1090 q 0 1061 21 1061 q -35 1076 -21 1061 q -50 1111 -50 1090 m 619 972 q 641 1026 619 1004 q 694 1047 663 1047 q 748 1026 726 1047 q 769 972 769 1004 q 748 919 769 940 q 694 897 726 897 q 641 919 663 897 q 619 972 619 940 m 342 972 q 363 1026 342 1004 q 417 1047 385 1047 q 470 1026 449 1047 q 492 972 492 1004 q 470 919 492 940 q 417 897 449 897 q 363 919 385 897 q 342 972 342 940 m 64 972 q 85 1026 64 1004 q 139 1047 107 1047 q 192 1026 171 1047 q 214 972 214 1004 q 192 919 214 940 q 139 897 171 897 q 85 919 107 897 q 64 972 64 940 m 506 833 q 520 869 506 854 q 556 883 535 883 q 591 869 576 883 q 606 833 606 854 q 591 798 606 813 q 556 783 576 783 q 520 798 535 783 q 506 833 506 813 m 228 833 q 242 869 228 854 q 278 883 257 883 q 313 869 299 883 q 328 833 328 854 q 313 798 328 813 q 278 783 299 783 q 242 798 257 783 q 228 833 228 813 m -50 833 q -35 869 -50 854 q 0 883 -21 883 q 35 869 21 883 q 50 833 50 854 q 35 798 50 813 q 0 783 21 783 q -35 798 -21 783 q -50 833 -50 813 m 619 694 q 641 748 619 726 q 694 769 663 769 q 748 748 726 769 q 769 694 769 726 q 748 641 769 663 q 694 619 726 619 q 641 641 663 619 q 619 694 619 663 m 342 694 q 363 748 342 726 q 417 769 385 769 q 470 748 449 769 q 492 694 492 726 q 470 641 492 663 q 417 619 449 619 q 363 641 385 619 q 342 694 342 663 m 64 694 q 85 748 64 726 q 139 769 107 769 q 192 748 171 769 q 214 694 214 726 q 192 641 214 663 q 139 619 171 619 q 85 641 107 619 q 64 694 64 663 m 506 556 q 520 591 506 576 q 556 606 535 606 q 591 591 576 606 q 606 556 606 576 q 591 520 606 535 q 556 506 576 506 q 520 520 535 506 q 506 556 506 535 m 228 556 q 242 591 228 576 q 278 606 257 606 q 313 591 299 606 q 328 556 328 576 q 313 520 328 535 q 278 506 299 506 q 242 520 257 506 q 228 556 228 535 m -50 556 q -35 591 -50 576 q 0 606 -21 606 q 35 591 21 606 q 50 556 50 576 q 35 520 50 535 q 0 506 21 506 q -35 520 -21 506 q -50 556 -50 535 m 619 417 q 641 470 619 449 q 694 492 663 492 q 748 470 726 492 q 769 417 769 449 q 748 363 769 385 q 694 342 726 342 q 641 363 663 342 q 619 417 619 385 m 342 417 q 363 470 342 449 q 417 492 385 492 q 470 470 449 492 q 492 417 492 449 q 470 363 492 385 q 417 342 449 342 q 363 363 385 342 q 342 417 342 385 m 64 417 q 85 470 64 449 q 139 492 107 492 q 192 470 171 492 q 214 417 214 449 q 192 363 214 385 q 139 342 171 342 q 85 363 107 342 q 64 417 64 385 m 506 278 q 520 313 506 299 q 556 328 535 328 q 591 313 576 328 q 606 278 606 299 q 591 242 606 257 q 556 228 576 228 q 520 242 535 228 q 506 278 506 257 m 228 278 q 242 313 228 299 q 278 328 257 328 q 313 313 299 328 q 328 278 328 299 q 313 242 328 257 q 278 228 299 228 q 242 242 257 228 q 228 278 228 257 m -50 278 q -35 313 -50 299 q 0 328 -21 328 q 35 313 21 328 q 50 278 50 299 q 35 242 50 257 q 0 228 21 228 q -35 242 -21 228 q -50 278 -50 257 m 619 139 q 641 192 619 171 q 694 214 663 214 q 748 192 726 214 q 769 139 769 171 q 748 85 769 107 q 694 64 726 64 q 641 85 663 64 q 619 139 619 107 m 342 139 q 363 192 342 171 q 417 214 385 214 q 470 192 449 214 q 492 139 492 171 q 470 85 492 107 q 417 64 449 64 q 363 85 385 64 q 342 139 342 107 m 64 139 q 85 192 64 171 q 139 214 107 214 q 192 192 171 214 q 214 139 214 171 q 192 85 214 107 q 139 64 171 64 q 85 85 107 64 q 64 139 64 107 m 506 0 q 520 35 506 21 q 556 50 535 50 q 591 35 576 50 q 606 0 606 21 q 591 -35 606 -21 q 556 -50 576 -50 q 520 -35 535 -50 q 506 0 506 -21 m 228 0 q 242 35 228 21 q 278 50 257 50 q 313 35 299 50 q 328 0 328 21 q 313 -35 328 -21 q 278 -50 299 -50 q 242 -35 257 -50 q 228 0 228 -21 m -50 0 q -35 35 -50 21 q 0 50 -21 50 q 35 35 21 50 q 50 0 50 21 q 35 -35 50 -21 q 0 -50 21 -50 q -35 -35 -21 -50 q -50 0 -50 -21 m 619 -139 q 641 -85 619 -107 q 694 -64 663 -64 q 748 -85 726 -64 q 769 -139 769 -107 q 748 -192 769 -171 q 694 -214 726 -214 q 641 -192 663 -214 q 619 -139 619 -171 m 342 -139 q 363 -85 342 -107 q 417 -64 385 -64 q 470 -85 449 -64 q 492 -139 492 -107 q 470 -192 492 -171 q 417 -214 449 -214 q 363 -192 385 -214 q 342 -139 342 -171 m 64 -139 q 85 -85 64 -107 q 139 -64 107 -64 q 192 -85 171 -64 q 214 -139 214 -107 q 192 -192 214 -171 q 139 -214 171 -214 q 85 -192 107 -214 q 64 -139 64 -171 m 506 -278 q 520 -242 506 -257 q 556 -228 535 -228 q 591 -242 576 -228 q 606 -278 606 -257 q 591 -313 606 -299 q 556 -328 576 -328 q 520 -313 535 -328 q 506 -278 506 -299 m 228 -278 q 242 -242 228 -257 q 278 -228 257 -228 q 313 -242 299 -228 q 328 -278 328 -257 q 313 -313 328 -299 q 278 -328 299 -328 q 242 -313 257 -328 q 228 -278 228 -299 m -50 -278 q -35 -242 -50 -257 q 0 -228 -21 -228 q 35 -242 21 -228 q 50 -278 50 -257 q 35 -313 50 -299 q 0 -328 21 -328 q -35 -313 -21 -328 q -50 -278 -50 -299 m 619 -417 q 641 -363 619 -385 q 694 -342 663 -342 q 748 -363 726 -342 q 769 -417 769 -385 q 748 -470 769 -449 q 694 -492 726 -492 q 641 -470 663 -492 q 619 -417 619 -449 m 342 -417 q 363 -363 342 -385 q 417 -342 385 -342 q 470 -363 449 -342 q 492 -417 492 -385 q 470 -470 492 -449 q 417 -492 449 -492 q 363 -470 385 -492 q 342 -417 342 -449 m 64 -417 q 85 -363 64 -385 q 139 -342 107 -342 q 192 -363 171 -342 q 214 -417 214 -385 q 192 -470 214 -449 q 139 -492 171 -492 q 85 -470 107 -492 q 64 -417 64 -449 m 506 -556 q 520 -520 506 -535 q 556 -506 535 -506 q 591 -520 576 -506 q 606 -556 606 -535 q 591 -591 606 -576 q 556 -606 576 -606 q 520 -591 535 -606 q 506 -556 506 -576 m 228 -556 q 242 -520 228 -535 q 278 -506 257 -506 q 313 -520 299 -506 q 328 -556 328 -535 q 313 -591 328 -576 q 278 -606 299 -606 q 242 -591 257 -606 q 228 -556 228 -576 m -50 -556 q -35 -520 -50 -535 q 0 -506 -21 -506 q 35 -520 21 -506 q 50 -556 50 -535 q 35 -591 50 -576 q 0 -606 21 -606 q -35 -591 -21 -606 q -50 -556 -50 -576 z "},"▓":{"ha":833,"x_min":-75,"x_max":807,"o":"m 582 1250 q 615 1330 582 1297 q 694 1363 647 1363 q 774 1330 742 1363 q 807 1250 807 1297 q 774 1170 807 1203 q 694 1138 742 1138 q 615 1170 647 1138 q 582 1250 582 1203 m 304 1250 q 337 1330 304 1297 q 417 1363 369 1363 q 497 1330 464 1363 q 529 1250 529 1297 q 497 1170 529 1203 q 417 1138 464 1138 q 337 1170 369 1138 q 304 1250 304 1203 m 26 1250 q 59 1330 26 1297 q 139 1363 92 1363 q 219 1330 186 1363 q 251 1250 251 1297 q 219 1170 251 1203 q 139 1138 186 1138 q 59 1170 92 1138 q 26 1250 26 1203 m 481 1111 q 502 1165 481 1143 q 556 1186 524 1186 q 609 1165 588 1186 q 631 1111 631 1143 q 609 1058 631 1079 q 556 1036 588 1036 q 502 1058 524 1036 q 481 1111 481 1079 m 203 1111 q 224 1165 203 1143 q 278 1186 246 1186 q 331 1165 310 1186 q 353 1111 353 1143 q 331 1058 353 1079 q 278 1036 310 1036 q 224 1058 246 1036 q 203 1111 203 1079 m -75 1111 q -53 1165 -75 1143 q 0 1186 -32 1186 q 53 1165 32 1186 q 75 1111 75 1143 q 53 1058 75 1079 q 0 1036 32 1036 q -53 1058 -32 1036 q -75 1111 -75 1079 m 582 972 q 615 1052 582 1019 q 694 1085 647 1085 q 774 1052 742 1085 q 807 972 807 1019 q 774 892 807 925 q 694 860 742 860 q 615 892 647 860 q 582 972 582 925 m 304 972 q 337 1052 304 1019 q 417 1085 369 1085 q 497 1052 464 1085 q 529 972 529 1019 q 497 892 529 925 q 417 860 464 860 q 337 892 369 860 q 304 972 304 925 m 26 972 q 59 1052 26 1019 q 139 1085 92 1085 q 219 1052 186 1085 q 251 972 251 1019 q 219 892 251 925 q 139 860 186 860 q 59 892 92 860 q 26 972 26 925 m 481 833 q 502 887 481 865 q 556 908 524 908 q 609 887 588 908 q 631 833 631 865 q 609 780 631 801 q 556 758 588 758 q 502 780 524 758 q 481 833 481 801 m 203 833 q 224 887 203 865 q 278 908 246 908 q 331 887 310 908 q 353 833 353 865 q 331 780 353 801 q 278 758 310 758 q 224 780 246 758 q 203 833 203 801 m -75 833 q -53 887 -75 865 q 0 908 -32 908 q 53 887 32 908 q 75 833 75 865 q 53 780 75 801 q 0 758 32 758 q -53 780 -32 758 q -75 833 -75 801 m 582 694 q 615 774 582 742 q 694 807 647 807 q 774 774 742 807 q 807 694 807 742 q 774 615 807 647 q 694 582 742 582 q 615 615 647 582 q 582 694 582 647 m 304 694 q 337 774 304 742 q 417 807 369 807 q 497 774 464 807 q 529 694 529 742 q 497 615 529 647 q 417 582 464 582 q 337 615 369 582 q 304 694 304 647 m 26 694 q 59 774 26 742 q 139 807 92 807 q 219 774 186 807 q 251 694 251 742 q 219 615 251 647 q 139 582 186 582 q 59 615 92 582 q 26 694 26 647 m 481 556 q 502 609 481 588 q 556 631 524 631 q 609 609 588 631 q 631 556 631 588 q 609 502 631 524 q 556 481 588 481 q 502 502 524 481 q 481 556 481 524 m 203 556 q 224 609 203 588 q 278 631 246 631 q 331 609 310 631 q 353 556 353 588 q 331 502 353 524 q 278 481 310 481 q 224 502 246 481 q 203 556 203 524 m -75 556 q -53 609 -75 588 q 0 631 -32 631 q 53 609 32 631 q 75 556 75 588 q 53 502 75 524 q 0 481 32 481 q -53 502 -32 481 q -75 556 -75 524 m 582 417 q 615 497 582 464 q 694 529 647 529 q 774 497 742 529 q 807 417 807 464 q 774 337 807 369 q 694 304 742 304 q 615 337 647 304 q 582 417 582 369 m 304 417 q 337 497 304 464 q 417 529 369 529 q 497 497 464 529 q 529 417 529 464 q 497 337 529 369 q 417 304 464 304 q 337 337 369 304 q 304 417 304 369 m 26 417 q 59 497 26 464 q 139 529 92 529 q 219 497 186 529 q 251 417 251 464 q 219 337 251 369 q 139 304 186 304 q 59 337 92 304 q 26 417 26 369 m 481 278 q 502 331 481 310 q 556 353 524 353 q 609 331 588 353 q 631 278 631 310 q 609 224 631 246 q 556 203 588 203 q 502 224 524 203 q 481 278 481 246 m 203 278 q 224 331 203 310 q 278 353 246 353 q 331 331 310 353 q 353 278 353 310 q 331 224 353 246 q 278 203 310 203 q 224 224 246 203 q 203 278 203 246 m -75 278 q -53 331 -75 310 q 0 353 -32 353 q 53 331 32 353 q 75 278 75 310 q 53 224 75 246 q 0 203 32 203 q -53 224 -32 203 q -75 278 -75 246 m 582 139 q 615 219 582 186 q 694 251 647 251 q 774 219 742 251 q 807 139 807 186 q 774 59 807 92 q 694 26 742 26 q 615 59 647 26 q 582 139 582 92 m 304 139 q 337 219 304 186 q 417 251 369 251 q 497 219 464 251 q 529 139 529 186 q 497 59 529 92 q 417 26 464 26 q 337 59 369 26 q 304 139 304 92 m 26 139 q 59 219 26 186 q 139 251 92 251 q 219 219 186 251 q 251 139 251 186 q 219 59 251 92 q 139 26 186 26 q 59 59 92 26 q 26 139 26 92 m 481 0 q 502 53 481 32 q 556 75 524 75 q 609 53 588 75 q 631 0 631 32 q 609 -53 631 -32 q 556 -75 588 -75 q 502 -53 524 -75 q 481 0 481 -32 m 203 0 q 224 53 203 32 q 278 75 246 75 q 331 53 310 75 q 353 0 353 32 q 331 -53 353 -32 q 278 -75 310 -75 q 224 -53 246 -75 q 203 0 203 -32 m -75 0 q -53 53 -75 32 q 0 75 -32 75 q 53 53 32 75 q 75 0 75 32 q 53 -53 75 -32 q 0 -75 32 -75 q -53 -53 -32 -75 q -75 0 -75 -32 m 582 -139 q 615 -59 582 -92 q 694 -26 647 -26 q 774 -59 742 -26 q 807 -139 807 -92 q 774 -219 807 -186 q 694 -251 742 -251 q 615 -219 647 -251 q 582 -139 582 -186 m 304 -139 q 337 -59 304 -92 q 417 -26 369 -26 q 497 -59 464 -26 q 529 -139 529 -92 q 497 -219 529 -186 q 417 -251 464 -251 q 337 -219 369 -251 q 304 -139 304 -186 m 26 -139 q 59 -59 26 -92 q 139 -26 92 -26 q 219 -59 186 -26 q 251 -139 251 -92 q 219 -219 251 -186 q 139 -251 186 -251 q 59 -219 92 -251 q 26 -139 26 -186 m 481 -278 q 502 -224 481 -246 q 556 -203 524 -203 q 609 -224 588 -203 q 631 -278 631 -246 q 609 -331 631 -310 q 556 -353 588 -353 q 502 -331 524 -353 q 481 -278 481 -310 m 203 -278 q 224 -224 203 -246 q 278 -203 246 -203 q 331 -224 310 -203 q 353 -278 353 -246 q 331 -331 353 -310 q 278 -353 310 -353 q 224 -331 246 -353 q 203 -278 203 -310 m -75 -278 q -53 -224 -75 -246 q 0 -203 -32 -203 q 53 -224 32 -203 q 75 -278 75 -246 q 53 -331 75 -310 q 0 -353 32 -353 q -53 -331 -32 -353 q -75 -278 -75 -310 m 582 -417 q 615 -337 582 -369 q 694 -304 647 -304 q 774 -337 742 -304 q 807 -417 807 -369 q 774 -497 807 -464 q 694 -529 742 -529 q 615 -497 647 -529 q 582 -417 582 -464 m 304 -417 q 337 -337 304 -369 q 417 -304 369 -304 q 497 -337 464 -304 q 529 -417 529 -369 q 497 -497 529 -464 q 417 -529 464 -529 q 337 -497 369 -529 q 304 -417 304 -464 m 26 -417 q 59 -337 26 -369 q 139 -304 92 -304 q 219 -337 186 -304 q 251 -417 251 -369 q 219 -497 251 -464 q 139 -529 186 -529 q 59 -497 92 -529 q 26 -417 26 -464 m 481 -556 q 502 -502 481 -524 q 556 -481 524 -481 q 609 -502 588 -481 q 631 -556 631 -524 q 609 -609 631 -587 q 556 -631 588 -631 q 502 -609 524 -631 q 481 -556 481 -587 m 203 -556 q 224 -502 203 -524 q 278 -481 246 -481 q 331 -502 310 -481 q 353 -556 353 -524 q 331 -609 353 -587 q 278 -631 310 -631 q 224 -609 246 -631 q 203 -556 203 -587 m -75 -556 q -53 -502 -75 -524 q 0 -481 -32 -481 q 53 -502 32 -481 q 75 -556 75 -524 q 53 -609 75 -587 q 0 -631 32 -631 q -53 -609 -32 -631 q -75 -556 -75 -587 z "},"▔":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 1146 l 0 1389 l 833 1389 l 833 1146 l 0 1146 z "},"▕":{"ha":833,"x_min":729,"x_max":833,"o":"m 729 -556 l 729 1389 l 833 1389 l 833 -556 l 729 -556 z "},"▖":{"ha":833,"x_min":0,"x_max":417,"o":"m 0 -556 l 0 417 l 417 417 l 417 -556 l 0 -556 z "},"▗":{"ha":833,"x_min":417,"x_max":833,"o":"m 417 -556 l 417 417 l 833 417 l 833 -556 l 417 -556 z "},"▘":{"ha":833,"x_min":0,"x_max":417,"o":"m 0 417 l 0 1389 l 417 1389 l 417 417 l 0 417 z "},"▙":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -556 l 0 1389 l 417 1389 l 417 417 l 833 417 l 833 -556 l 0 -556 z "},"▚":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 417 l 0 1389 l 417 1389 l 417 417 l 0 417 m 417 -556 l 417 417 l 833 417 l 833 -556 l 417 -556 z "},"▛":{"ha":833,"x_min":0,"x_max":833,"o":"m 833 417 l 417 417 l 417 -556 l 0 -556 l 0 1389 l 833 1389 l 833 417 z "},"▜":{"ha":833,"x_min":0,"x_max":833,"o":"m 833 -556 l 417 -556 l 417 417 l 0 417 l 0 1389 l 833 1389 l 833 -556 z "},"▝":{"ha":833,"x_min":417,"x_max":833,"o":"m 417 417 l 417 1389 l 833 1389 l 833 417 l 417 417 z "},"▞":{"ha":833,"x_min":0,"x_max":833,"o":"m 417 1389 l 833 1389 l 833 417 l 417 417 l 417 1389 m 0 417 l 417 417 l 417 -556 l 0 -556 l 0 417 z "},"▟":{"ha":833,"x_min":0,"x_max":833,"o":"m 833 -556 l 0 -556 l 0 417 l 417 417 l 417 1389 l 833 1389 l 833 -556 z "}," ":{"ha":833,"x_min":0,"x_max":0,"o":""},"﻿":{"ha":833,"x_min":0,"x_max":0,"o":""},"︎":{"ha":833,"x_min":42,"x_max":792,"o":"m 417 810 q 397 818 406 810 q 389 839 389 826 q 397 858 389 850 q 417 867 406 867 q 437 858 429 867 q 444 839 444 850 q 437 818 444 826 q 417 810 429 810 m 417 46 q 397 54 406 46 q 389 75 389 63 q 397 94 389 86 q 417 103 406 103 q 437 94 429 103 q 444 75 444 86 q 437 54 444 63 q 417 46 429 46 m 347 810 q 328 818 336 810 q 319 839 319 826 q 328 858 319 850 q 347 867 336 867 q 367 858 360 867 q 375 839 375 850 q 367 818 375 826 q 347 810 360 810 m 347 46 q 328 54 336 46 q 319 75 319 63 q 328 94 319 86 q 347 103 336 103 q 367 94 360 103 q 375 75 375 86 q 367 54 375 63 q 347 46 360 46 m 278 810 q 258 818 267 810 q 250 839 250 826 q 258 858 250 850 q 278 867 267 867 q 298 858 290 867 q 306 839 306 850 q 298 818 306 826 q 278 810 290 810 m 208 810 q 189 818 197 810 q 181 839 181 826 q 189 858 181 850 q 208 867 197 867 q 228 858 221 867 q 236 839 236 850 q 228 818 236 826 q 208 810 221 810 m 139 810 q 119 818 128 810 q 111 839 111 826 q 119 858 111 850 q 139 867 128 867 q 159 858 151 867 q 167 839 167 850 q 159 818 167 826 q 139 810 151 810 m 69 810 q 50 818 58 810 q 42 839 42 826 q 50 858 42 850 q 69 867 58 867 q 90 858 82 867 q 97 839 97 850 q 90 818 97 826 q 69 810 82 810 m 69 740 q 50 749 58 740 q 42 769 42 757 q 50 789 42 781 q 69 797 58 797 q 90 789 82 797 q 97 769 97 781 q 90 749 97 757 q 69 740 82 740 m 69 671 q 50 679 58 671 q 42 700 42 688 q 50 719 42 711 q 69 728 58 728 q 90 719 82 728 q 97 700 97 711 q 90 679 97 688 q 69 671 82 671 m 69 601 q 50 610 58 601 q 42 631 42 618 q 50 650 42 642 q 69 658 58 658 q 90 650 82 658 q 97 631 97 642 q 90 610 97 618 q 69 601 82 601 m 208 532 q 189 540 197 532 q 181 561 181 549 q 189 581 181 572 q 208 589 197 589 q 228 581 221 589 q 236 561 236 572 q 228 540 236 549 q 208 532 221 532 m 139 532 q 119 540 128 532 q 111 561 111 549 q 119 581 111 572 q 139 589 128 589 q 159 581 151 589 q 167 561 167 572 q 159 540 167 549 q 139 532 151 532 m 69 532 q 50 540 58 532 q 42 561 42 549 q 50 581 42 572 q 69 589 58 589 q 90 581 82 589 q 97 561 97 572 q 90 540 97 549 q 69 532 82 532 m 278 532 q 258 540 267 532 q 250 561 250 549 q 258 581 250 572 q 278 589 267 589 q 298 581 290 589 q 306 561 306 572 q 298 540 306 549 q 278 532 290 532 m 278 463 q 258 471 267 463 q 250 492 250 479 q 258 511 250 503 q 278 519 267 519 q 298 511 290 519 q 306 492 306 503 q 298 471 306 479 q 278 463 290 463 m 278 393 q 258 401 267 393 q 250 422 250 410 q 258 442 250 433 q 278 450 267 450 q 298 442 290 450 q 306 422 306 433 q 298 401 306 410 q 278 393 290 393 m 278 324 q 258 332 267 324 q 250 353 250 340 q 258 372 250 364 q 278 381 267 381 q 298 372 290 381 q 306 353 306 364 q 298 332 306 340 q 278 324 290 324 m 278 254 q 258 263 267 254 q 250 283 250 271 q 258 303 250 294 q 278 311 267 311 q 298 303 290 311 q 306 283 306 294 q 298 263 306 271 q 278 254 290 254 m 278 185 q 258 193 267 185 q 250 214 250 201 q 258 233 250 225 q 278 242 267 242 q 298 233 290 242 q 306 214 306 225 q 298 193 306 201 q 278 185 290 185 m 278 115 q 258 124 267 115 q 250 144 250 132 q 258 164 250 156 q 278 172 267 172 q 298 164 290 172 q 306 144 306 156 q 298 124 306 132 q 278 115 290 115 m 278 46 q 258 54 267 46 q 250 75 250 63 q 258 94 250 86 q 278 103 267 103 q 298 94 290 103 q 306 75 306 86 q 298 54 306 63 q 278 46 290 46 m 486 810 q 466 818 474 810 q 458 839 458 826 q 466 858 458 850 q 486 867 474 867 q 506 858 497 867 q 514 839 514 850 q 506 818 514 826 q 486 810 497 810 m 486 46 q 466 54 474 46 q 458 75 458 63 q 466 94 458 86 q 486 103 474 103 q 506 94 497 103 q 514 75 514 86 q 506 54 514 63 q 486 46 497 46 m 556 810 q 535 818 543 810 q 528 839 528 826 q 535 858 528 850 q 556 867 543 867 q 575 858 567 867 q 583 839 583 850 q 575 818 583 826 q 556 810 567 810 m 625 810 q 605 818 613 810 q 597 839 597 826 q 605 858 597 850 q 625 867 613 867 q 644 858 636 867 q 653 839 653 850 q 644 818 653 826 q 625 810 636 810 m 694 810 q 674 818 682 810 q 667 839 667 826 q 674 858 667 850 q 694 867 682 867 q 714 858 706 867 q 722 839 722 850 q 714 818 722 826 q 694 810 706 810 m 764 810 q 744 818 751 810 q 736 839 736 826 q 744 858 736 850 q 764 867 751 867 q 783 858 775 867 q 792 839 792 850 q 783 818 792 826 q 764 810 775 810 m 764 740 q 744 749 751 740 q 736 769 736 757 q 744 789 736 781 q 764 797 751 797 q 783 789 775 797 q 792 769 792 781 q 783 749 792 757 q 764 740 775 740 m 764 671 q 744 679 751 671 q 736 700 736 688 q 744 719 736 711 q 764 728 751 728 q 783 719 775 728 q 792 700 792 711 q 783 679 792 688 q 764 671 775 671 m 764 601 q 744 610 751 601 q 736 631 736 618 q 744 650 736 642 q 764 658 751 658 q 783 650 775 658 q 792 631 792 642 q 783 610 792 618 q 764 601 775 601 m 625 532 q 605 540 613 532 q 597 561 597 549 q 605 581 597 572 q 625 589 613 589 q 644 581 636 589 q 653 561 653 572 q 644 540 653 549 q 625 532 636 532 m 694 532 q 674 540 682 532 q 667 561 667 549 q 674 581 667 572 q 694 589 682 589 q 714 581 706 589 q 722 561 722 572 q 714 540 722 549 q 694 532 706 532 m 764 532 q 744 540 751 532 q 736 561 736 549 q 744 581 736 572 q 764 589 751 589 q 783 581 775 589 q 792 561 792 572 q 783 540 792 549 q 764 532 775 532 m 556 532 q 535 540 543 532 q 528 561 528 549 q 535 581 528 572 q 556 589 543 589 q 575 581 567 589 q 583 561 583 572 q 575 540 583 549 q 556 532 567 532 m 556 463 q 535 471 543 463 q 528 492 528 479 q 535 511 528 503 q 556 519 543 519 q 575 511 567 519 q 583 492 583 503 q 575 471 583 479 q 556 463 567 463 m 556 393 q 535 401 543 393 q 528 422 528 410 q 535 442 528 433 q 556 450 543 450 q 575 442 567 450 q 583 422 583 433 q 575 401 583 410 q 556 393 567 393 m 556 324 q 535 332 543 324 q 528 353 528 340 q 535 372 528 364 q 556 381 543 381 q 575 372 567 381 q 583 353 583 364 q 575 332 583 340 q 556 324 567 324 m 556 254 q 535 263 543 254 q 528 283 528 271 q 535 303 528 294 q 556 311 543 311 q 575 303 567 311 q 583 283 583 294 q 575 263 583 271 q 556 254 567 254 m 556 185 q 535 193 543 185 q 528 214 528 201 q 535 233 528 225 q 556 242 543 242 q 575 233 567 242 q 583 214 583 225 q 575 193 583 201 q 556 185 567 185 m 556 115 q 535 124 543 115 q 528 144 528 132 q 535 164 528 156 q 556 172 543 172 q 575 164 567 172 q 583 144 583 156 q 575 124 583 132 q 556 115 567 115 m 556 46 q 535 54 543 46 q 528 75 528 63 q 535 94 528 86 q 556 103 543 103 q 575 94 567 103 q 583 75 583 86 q 575 54 583 63 q 556 46 567 46 z "},"️":{"ha":833,"x_min":21,"x_max":813,"o":"m 417 804 q 389 832 389 804 q 417 860 389 860 q 444 832 444 860 q 417 804 444 804 m 57 517 q 29 544 29 517 q 57 572 29 572 q 85 544 85 572 q 57 517 85 517 m 81 599 q 53 626 53 599 q 81 654 53 654 q 108 626 108 654 q 81 599 108 599 m 126 668 q 107 677 115 668 q 99 699 99 686 q 107 718 99 710 q 126 726 115 726 q 147 718 139 726 q 154 699 154 710 q 147 677 154 686 q 126 668 139 668 m 186 728 q 167 737 175 728 q 158 758 158 746 q 167 778 158 771 q 186 786 175 786 q 214 758 214 786 q 207 737 214 746 q 186 728 200 728 m 258 769 q 238 778 246 769 q 231 800 231 788 q 258 828 231 828 q 286 800 286 828 q 278 778 286 788 q 258 769 271 769 m 336 794 q 317 803 325 794 q 308 825 308 813 q 317 845 308 838 q 336 853 325 853 q 364 825 364 853 q 357 803 364 813 q 336 794 350 794 m 785 428 q 765 437 772 428 q 757 458 757 446 q 785 486 757 486 q 813 458 813 486 q 805 437 813 446 q 785 428 797 428 m 776 517 q 749 544 749 517 q 776 572 749 572 q 804 544 804 572 q 776 517 804 517 m 753 599 q 725 626 725 599 q 753 654 725 654 q 781 626 781 654 q 753 599 781 599 m 707 668 q 687 677 694 668 q 679 699 679 686 q 687 718 679 710 q 707 726 694 726 q 726 718 718 726 q 735 699 735 710 q 726 677 735 686 q 707 668 718 668 m 647 728 q 626 737 633 728 q 619 758 619 746 q 647 786 619 786 q 667 778 658 786 q 675 758 675 771 q 667 737 675 746 q 647 728 658 728 m 575 769 q 555 778 563 769 q 547 800 547 788 q 575 828 547 828 q 603 800 603 828 q 595 778 603 788 q 575 769 588 769 m 497 794 q 476 803 483 794 q 469 825 469 813 q 497 853 469 853 q 517 845 508 853 q 525 825 525 838 q 517 803 525 813 q 497 794 508 794 m 417 113 q 437 103 429 113 q 444 82 444 94 q 437 63 444 71 q 417 54 429 54 q 397 63 404 54 q 389 82 389 71 q 397 103 389 94 q 417 113 404 113 m 49 486 q 76 456 76 486 q 69 436 76 444 q 49 428 61 428 q 28 436 36 428 q 21 456 21 444 q 49 486 21 486 m 57 400 q 77 391 69 400 q 85 369 85 382 q 77 350 85 358 q 57 342 69 342 q 37 350 44 342 q 29 369 29 358 q 37 391 29 382 q 57 400 44 400 m 81 318 q 101 309 93 318 q 108 288 108 300 q 101 268 108 276 q 81 260 93 260 q 60 268 68 260 q 53 288 53 276 q 60 309 53 300 q 81 318 68 318 m 126 246 q 154 218 154 246 q 126 190 154 190 q 107 198 115 190 q 99 218 99 206 q 107 238 99 231 q 126 246 115 246 m 186 186 q 214 156 214 186 q 207 136 214 144 q 186 128 200 128 q 167 136 175 128 q 158 156 158 144 q 167 178 158 171 q 186 186 175 186 m 258 144 q 286 114 286 144 q 278 94 286 103 q 258 86 271 86 q 238 94 246 86 q 231 114 231 103 q 258 144 231 144 m 336 119 q 364 89 364 119 q 357 69 364 78 q 336 61 350 61 q 317 69 325 61 q 308 89 308 78 q 317 112 308 104 q 336 119 325 119 m 776 400 q 797 391 789 400 q 804 369 804 382 q 797 350 804 358 q 776 342 789 342 q 756 350 764 342 q 749 369 749 358 q 756 391 749 382 q 776 400 764 400 m 753 318 q 773 309 765 318 q 781 288 781 300 q 773 268 781 276 q 753 260 765 260 q 733 268 740 260 q 725 288 725 276 q 733 309 725 300 q 753 318 740 318 m 707 246 q 726 238 718 246 q 735 218 735 231 q 726 198 735 206 q 707 190 718 190 q 679 218 679 190 q 707 246 679 246 m 647 186 q 667 178 658 186 q 675 156 675 171 q 667 136 675 144 q 647 128 658 128 q 626 136 633 128 q 619 156 619 144 q 647 186 619 186 m 575 144 q 603 114 603 144 q 595 94 603 103 q 575 86 588 86 q 555 94 563 86 q 547 114 547 103 q 575 144 547 144 m 497 119 q 517 112 508 119 q 525 89 525 104 q 517 69 525 78 q 497 61 508 61 q 476 69 483 61 q 469 89 469 78 q 497 119 469 119 m 417 288 q 437 278 429 288 q 444 257 444 269 q 437 238 444 246 q 417 229 429 229 q 397 238 404 229 q 389 257 389 246 q 397 278 389 269 q 417 288 404 288 m 617 400 q 637 391 629 400 q 644 369 644 382 q 637 350 644 358 q 617 342 629 342 q 597 350 604 342 q 589 369 589 358 q 597 391 589 382 q 617 400 604 400 m 568 333 q 588 324 581 333 q 596 303 596 315 q 588 283 596 292 q 568 275 581 275 q 548 283 556 275 q 540 303 540 292 q 548 324 540 315 q 568 333 556 333 m 497 296 q 517 288 508 296 q 525 268 525 281 q 517 248 525 256 q 497 240 508 240 q 469 268 469 240 q 497 296 469 296 m 217 400 q 237 391 229 400 q 244 369 244 382 q 237 350 244 358 q 217 342 229 342 q 197 350 204 342 q 189 369 189 358 q 197 391 189 382 q 217 400 204 400 m 265 333 q 285 324 278 333 q 293 303 293 315 q 285 283 293 292 q 265 275 278 275 q 245 283 253 275 q 238 303 238 292 q 245 324 238 315 q 265 333 253 333 m 336 296 q 364 268 364 296 q 336 240 364 240 q 317 248 325 240 q 308 268 308 256 q 317 288 308 281 q 336 296 325 296 m 308 508 q 336 481 336 508 q 308 453 336 453 q 281 481 281 453 q 308 508 281 508 m 364 550 q 384 541 376 550 q 392 519 392 532 q 384 500 392 508 q 364 492 376 492 q 344 500 351 492 q 336 519 336 508 q 344 541 336 532 q 364 550 351 550 m 308 604 q 281 632 281 604 q 308 660 281 660 q 336 632 336 660 q 308 604 336 604 m 364 561 q 344 570 351 561 q 336 592 336 579 q 344 611 336 603 q 364 619 351 619 q 384 611 376 619 q 392 592 392 603 q 384 570 392 579 q 364 561 376 561 m 253 550 q 273 541 265 550 q 281 519 281 532 q 273 500 281 508 q 253 492 265 492 q 233 500 240 492 q 225 519 225 508 q 233 541 225 532 q 253 550 240 550 m 253 561 q 233 570 240 561 q 225 592 225 579 q 233 611 225 603 q 253 619 240 619 q 273 611 265 619 q 281 592 281 603 q 273 570 281 579 q 253 561 265 561 m 525 508 q 553 481 553 508 q 525 453 553 453 q 497 481 497 453 q 525 508 497 508 m 469 550 q 490 541 482 550 q 497 519 497 532 q 490 500 497 508 q 469 492 482 492 q 449 500 457 492 q 442 519 442 508 q 449 541 442 532 q 469 550 457 550 m 525 604 q 497 632 497 604 q 525 660 497 660 q 553 632 553 660 q 525 604 553 604 m 469 561 q 449 570 457 561 q 442 592 442 579 q 449 611 442 603 q 469 619 457 619 q 490 611 482 619 q 497 592 497 603 q 490 570 497 579 q 469 561 482 561 m 581 550 q 601 541 593 550 q 608 519 608 532 q 601 500 608 508 q 581 492 593 492 q 560 500 568 492 q 553 519 553 508 q 560 541 553 532 q 581 550 568 550 m 581 561 q 560 570 568 561 q 553 592 553 579 q 560 611 553 603 q 581 619 568 619 q 601 611 593 619 q 608 592 608 603 q 601 570 608 579 q 581 561 593 561 z "},"ﬁ":{"ha":833,"x_min":72,"x_max":725,"o":"m 164 0 l 164 582 l 72 582 l 72 668 l 164 675 l 164 782 q 212 946 164 886 q 361 1006 260 1006 q 422 999 393 1006 q 474 983 450 993 l 450 896 q 374 913 410 913 q 278 782 278 913 l 278 675 l 421 675 l 421 582 l 278 582 l 278 0 l 164 0 m 575 0 l 575 675 l 689 675 l 689 0 l 575 0 m 633 817 q 568 841 594 817 q 542 906 542 865 q 568 970 542 946 q 633 994 594 994 q 699 970 672 994 q 725 906 725 946 q 699 841 725 865 q 633 817 672 817 z "},"ﬂ":{"ha":833,"x_min":79,"x_max":743,"o":"m 171 0 l 171 582 l 79 582 l 79 668 l 171 675 l 171 782 q 219 946 171 886 q 368 1006 267 1006 q 428 999 400 1006 q 481 983 457 993 l 456 896 q 379 913 418 913 q 285 782 285 913 l 285 675 l 428 675 l 428 582 l 285 582 l 285 0 l 171 0 m 678 -17 q 585 22 613 -17 q 557 136 557 61 l 557 989 l 671 989 l 671 128 q 681 89 671 100 q 703 78 690 78 q 713 78 708 78 q 728 81 718 78 l 743 -6 q 715 -14 731 -11 q 678 -17 700 -17 z "},"":{"ha":833,"x_min":138,"x_max":850,"o":"m 250 -389 l 138 -389 l 138 1 q 156 140 138 83 q 206 238 175 197 q 276 308 236 279 q 356 361 315 336 q 437 413 397 386 q 507 475 476 439 q 556 561 538 511 q 575 685 575 611 l 575 997 l 414 997 l 633 1271 l 850 997 l 688 997 l 688 660 q 669 519 688 576 q 619 420 650 461 q 549 351 589 379 q 469 297 510 322 q 388 246 428 272 q 318 184 349 219 q 269 99 288 149 q 250 -24 250 49 l 250 -389 m 250 533 l 138 463 l 138 1472 l 250 1472 l 250 533 z "},"":{"ha":833,"x_min":115,"x_max":718,"o":"m 115 611 l 115 1278 l 218 1278 l 218 697 l 529 697 l 529 611 l 115 611 m 271 -231 l 271 433 l 385 433 l 635 -110 l 640 -110 l 615 189 l 615 433 l 718 433 l 718 -231 l 601 -231 l 353 307 l 347 307 l 374 31 l 374 -231 l 271 -231 z "},"":{"ha":833,"x_min":63,"x_max":771,"o":"m 118 -97 l 63 -47 l 63 672 l 118 722 l 182 722 l 182 935 q 243 1123 182 1057 q 417 1189 304 1189 q 590 1123 529 1189 q 651 935 651 1057 l 651 722 l 715 722 l 771 672 l 771 -47 l 715 -97 l 118 -97 m 342 82 l 403 54 l 431 54 l 492 82 l 456 317 q 515 360 496 332 q 533 426 533 389 q 499 508 533 475 q 417 542 465 542 q 334 508 368 542 q 300 426 300 475 q 319 360 300 389 q 378 317 338 332 l 342 82 m 276 722 l 557 722 l 557 924 q 522 1053 557 1007 q 417 1099 488 1099 q 311 1053 346 1099 q 276 924 276 1007 l 276 722 z "},"":{"ha":833,"x_min":0,"x_max":833,"o":"m 0 -389 l 0 1444 l 833 528 l 0 -389 z "},"":{"ha":833,"x_min":-10,"x_max":849,"o":"m 58 -312 l -10 -246 l 725 528 l -10 1301 l 58 1368 l 849 528 l 58 -312 z "},"":{"ha":833,"x_min":0,"x_max":851,"o":"m 851 -389 l 0 528 l 851 1444 l 851 -389 z "},"":{"ha":833,"x_min":-15,"x_max":843,"o":"m 775 -312 l -15 528 l 775 1368 l 843 1301 l 108 528 l 843 -246 l 775 -312 z "}},"familyName":"Source Code Pro","ascender":1367,"descender":-379,"underlinePosition":-104,"underlineThickness":69,"boundingBox":{"yMin":-631,"xMin":-268,"yMax":1472,"xMax":1101},"resolution":1000,"original_font_information":{"format":0,"copyright":"Copyright 2010, 2012 Adobe Systems Incorporated (http://www.adobe.com/), with Reserved Font Name ‘Source’.","fontFamily":"Source Code Pro","fontSubfamily":"Regular","uniqueID":"2.030;ADBO;SourceCodePro-Regular;ADOBE","fullName":"Source Code Pro","version":"Version 2.030;PS 1.000;hotconv 16.6.51;makeotf.lib2.5.65220","postScriptName":"SourceCodePro-Regular","trademark":"Source is a trademark of Adobe Systems Incorporated in the United States and/or other countries.","manufacturer":"Adobe Systems Incorporated","designer":"Paul D. Hunt, Teo Tuominen","manufacturerURL":"http://www.adobe.com/type","licence":"This Font Software is licensed under the SIL Open Font License, Version 1.1. This license is available with a FAQ at: http://scripts.sil.org/OFL. This Font Software is distributed on an ‘AS IS’ BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the SIL Open Font License for the specific language, permissions and limitations governing your use of this Font Software.","licenceURL":"http://www.adobe.com/type/legal.html","unknown1":"simple a","unknown2":"simple g","unknown3":"serifed i & l","unknown4":"Sami Ŋ","unknown5":"cursive β","unknown6":"cursive θ","unknown7":"cursive φ","unknown8":"Serbian φ","unknown9":"Cyrillic breve [˘]","unknown10":"slashed zero [0]","unknown11":"typographic hyphen [-]","unknown12":"typographic asterisk [*]","unknown13":"slashed dollar sign [$]","unknown14":"alternate numeral one [1]","unknown15":"typographic alternates [-,*]","unknown16":"simple a, cursive β","unknown17":"simple g, cursive θ, Serbian б","unknown18":"serifed i & l","unknown19":"Sami Ŋ, cursive φ","unknown20":"slashed dollar sign [$]","unknown21":"alternate numeral one [1]"},"cssFontWeight":"normal","cssFontStyle":"normal"}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"1F3B959F-42A1-4CB1-94FE-4FE0104D24E0","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[45,-48,-50,10,-48,42,-10,-48,42,50,-43,50,50,-43,-50,50,50,-50,50,-43,50,50,50,-50,50,50,50,50,-43,50,45,-43,50,45,-43,-50,50,-43,50,45,-43,-50,50,-43,-50,45,-48,50,45,-48,-50,45,-43,-50,45,-48,50,45,-43,-50,45,-43,50,45,-48,50,10,-48,50,10,-48,42,45,-48,50,10,-48,42,45,-48,-50,-10,-48,50,10,-48,50,-50,50,50,50,50,50,-50,50,50,10,-48,50,-50,50,50,-50,50,-50,-50,-43,-50,-50,50,50,-50,-43,-50,-50,-43,50,-45,-43,-50,-50,-43,-50,-50,50,-50,45,-48,-50,-45,-48,-50,-45,-43,-50,-50,50,-50,50,50,-50,-45,-43,-50,50,50,-50,45,-43,-50,-45,-43,-50,-45,-43,50,-45,-43,-50,-45,-48,-50,-45,-43,50,-45,-48,-50,-45,-48,50,-10,-48,50,-45,-48,50,-10,-48,42,-45,-48,50,-45,-48,-50,-10,-48,42,45,-48,-50,-10,-48,42,-45,-48,-50,50,50,-50,-50,50,-50,-50,50,50,50,50,50,50,50,-50,-50,50,50,50,-43,-50,45,-43,-50,50,50,-50,45,-48,-50,-45,-43,-50,45,-43,-50,50,50,50,45,-43,50,50,-43,50,10,-48,50,45,-43,50,50,50,50,45,-48,50,45,-43,50,10,-48,50,-50,50,50,-50,-43,50,-45,-43,50,-45,-48,50,-10,-48,50,-45,-43,50,-50,50,50,-45,-43,50,-10,-48,50,-50,-43,50,-50,-43,-50,-45,-43,-50,-50,-43,50,-45,-43,-50,-45,-43,50],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0],"normalized":false}},"boundingSphere":{"center":[0,1,0],"radius":86.029065}}},{"uuid":"6640080A-A8B2-4D67-8DD0-7B657A7003C0","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[10,-50,42,-10,-50,42,-10,-48,42,10,-50,42,-10,-48,42,10,-48,42,-10,-50,50,-10,-50,42,10,-50,42,-10,-50,50,10,-50,42,10,-50,50,10,-48,50,-10,-48,50,-10,-50,50,10,-48,50,-10,-50,50,10,-50,50,10,-50,50,10,-50,42,10,-48,42,10,-50,50,10,-48,42,10,-48,50,-10,-50,42,-10,-50,50,-10,-48,50,-10,-50,42,-10,-48,50,-10,-48,42],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0],"normalized":false}},"boundingSphere":{"center":[0,-49,46],"radius":10.816654}}}],"materials":[{"uuid":"A5B7AEDC-2332-4924-B6B3-A53FA500664A","type":"MeshLambertMaterial","color":4866110,"emissive":855309,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"1E2761C3-76CF-42FB-8C74-63F8AE688DDB","type":"MeshLambertMaterial","color":16777215,"emissive":5066061,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"A0BD450A-B81E-4F91-BE93-A08A5B546F8A","type":"Group","name":"safe","castShadow":true,"receiveShadow":true,"matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"2EF002EA-830B-4BF5-9601-2898A82A2274","type":"Mesh","name":"body","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"1F3B959F-42A1-4CB1-94FE-4FE0104D24E0","material":"A5B7AEDC-2332-4924-B6B3-A53FA500664A"},{"uuid":"DFD98FA1-8245-4CEA-8FFE-B5301F02789C","type":"Mesh","name":"handle","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"6640080A-A8B2-4D67-8DD0-7B657A7003C0","material":"1E2761C3-76CF-42FB-8C74-63F8AE688DDB"}]}}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"178C017F-D9B1-4244-B591-77CB74A39143","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-42.938999,-50,-8.955,-44.044998,-50,-10.061,-41.544998,-50,-8.245,-44.044998,-50,-10.061,-44.755001,-50,-11.455,-41.544998,-50,-8.245,-44.755001,-50,-11.455,-45,-50,-13,-41.544998,-50,-8.245,-45,-50,-13,-44.755001,-50,-14.545,-41.544998,-50,-8.245,-44.755001,-50,-14.545,-44.044998,-50,-15.939,-41.544998,-50,-8.245,-44.044998,-50,-15.939,-42.938999,-50,-17.045,-41.544998,-50,-8.245,-42.938999,-50,-17.045,-41.544998,-50,-17.754999,-41.544998,-50,-8.245,-35.244999,-50,-14.545,-38.455002,-50,-8.245,-35.955002,-50,-15.939,-35,-50,-13,-38.455002,-50,-8.245,-35.244999,-50,-14.545,-35.244999,-50,-11.455,-38.455002,-50,-8.245,-35,-50,-13,-35.955002,-50,-10.061,-38.455002,-50,-8.245,-35.244999,-50,-11.455,-37.061001,-50,-8.955,-38.455002,-50,-8.245,-35.955002,-50,-10.061,-40,-50,-8,-38.455002,-50,-17.754999,-38.455002,-50,-8.245,-40,-50,-8,-41.544998,-50,-8.245,-41.544998,-50,-17.754999,-40,-50,-18,-40,-50,-8,-41.544998,-50,-17.754999,-38.455002,-50,-17.754999,-40,-50,-8,-40,-50,-18,-37.061001,-50,-17.045,-38.455002,-50,-8.245,-38.455002,-50,-17.754999,-35.955002,-50,-15.939,-38.455002,-50,-8.245,-37.061001,-50,-17.045,-37.528,-50,28.608,-35.298,-50,27.472,-35.298,-46,27.472,-37.528,-50,28.608,-35.298,-46,27.472,-37.528,-46,28.608,-40,-46,-8,-41.544998,-46,-8.245,-41.544998,-50,-8.245,-40,-46,-8,-41.544998,-50,-8.245,-40,-50,-8,-32,-50,21,-32.391998,-50,23.472,-32.391998,-50,18.528,-32.391998,-50,18.528,-32.391998,-50,23.472,-33.528,-50,25.702,-32.391998,-50,18.528,-33.528,-50,25.702,-35.298,-50,27.472,-32.391998,-50,18.528,-35.298,-50,27.472,-37.528,-50,28.608,-32.391998,-50,18.528,-37.528,-50,28.608,-40,-50,29,-32.391998,-50,18.528,-40,-50,29,-42.472,-50,28.608,-32.391998,-50,18.528,-42.472,-50,28.608,-44.702,-50,27.472,-32.391998,-50,18.528,-44.702,-50,27.472,-46.472,-50,25.702,-32.391998,-50,18.528,-46.472,-50,25.702,-47.608002,-50,23.472,-32.391998,-50,18.528,-47.608002,-50,23.472,-48,-50,21,-32.391998,-50,18.528,-48,-50,21,-47.608002,-50,18.528,-32.391998,-50,18.528,-47.608002,-50,18.528,-46.472,-50,16.298,-35.298,-50,27.472,-33.528,-50,25.702,-33.528,-46,25.702,-35.298,-50,27.472,-33.528,-46,25.702,-35.298,-46,27.472,-46.472,-50,16.298,-44.702,-50,14.528,-42.472,-50,13.392,-46.472,-50,16.298,-42.472,-50,13.392,-40,-50,13,-46.472,-50,16.298,-40,-50,13,-37.528,-50,13.392,-46.472,-50,16.298,-37.528,-50,13.392,-35.298,-50,14.528,-46.472,-50,16.298,-35.298,-50,14.528,-33.528,-50,16.298,-46.472,-50,16.298,-33.528,-50,16.298,-32.391998,-50,18.528,-33.528,-50,25.702,-32.391998,-50,23.472,-32.391998,-46,23.472,-33.528,-50,25.702,-32.391998,-46,23.472,-33.528,-46,25.702,-32.391998,-50,23.472,-32,-50,21,-32,-46,21,-32.391998,-50,23.472,-32,-46,21,-32.391998,-46,23.472,-37.061001,-46,-17.045,-36.400002,-46,-16.384001,-37.061001,-50,-17.045,-35.955002,-50,-15.939,-37.061001,-50,-17.045,-36.400002,-46,-16.384001,-32,-50,21,-32.391998,-50,18.528,-32.391998,-46,18.528,-32,-50,21,-32.391998,-46,18.528,-32,-46,21,-37.061001,-50,-17.045,-38.455002,-50,-17.754999,-38.455002,-46,-17.754999,-37.061001,-50,-17.045,-38.455002,-46,-17.754999,-37.061001,-46,-17.045,-32.391998,-50,18.528,-33.4842,-46,16.384001,-32.391998,-46,18.528,-47.608002,-50,18.528,-47.608002,-46,18.528,-46.5158,-46,16.384001,-47.608002,-50,18.528,-46.5158,-46,16.384001,-46.472,-50,16.298,-48,-50,21,-48,-46,21,-47.608002,-46,18.528,-48,-50,21,-47.608002,-46,18.528,-47.608002,-50,18.528,-47.608002,-50,23.472,-47.608002,-46,23.472,-48,-46,21,-47.608002,-50,23.472,-48,-46,21,-48,-50,21,-46.472,-50,25.702,-46.472,-46,25.702,-47.608002,-46,23.472,-46.472,-50,25.702,-47.608002,-46,23.472,-47.608002,-50,23.472,-44.702,-50,27.472,-44.702,-46,27.472,-46.472,-46,25.702,-44.702,-50,27.472,-46.472,-46,25.702,-46.472,-50,25.702,-42.472,-50,28.608,-42.472,-46,28.608,-44.702,-46,27.472,-42.472,-50,28.608,-44.702,-46,27.472,-44.702,-50,27.472,-40,-46,29,-42.472,-46,28.608,-42.472,-50,28.608,-40,-46,29,-42.472,-50,28.608,-40,-50,29,-33.528,-46,16.298,-33.4842,-46,16.384001,-33.528,-50,16.298,-32.391998,-50,18.528,-33.528,-50,16.298,-33.4842,-46,16.384001,-33.528,-50,16.298,-35.298,-50,14.528,-35.298,-46,14.528,-33.528,-50,16.298,-35.298,-46,14.528,-33.528,-46,16.298,-35.298,-50,14.528,-37.528,-50,13.392,-37.528,-46,13.392,-35.298,-50,14.528,-37.528,-46,13.392,-35.298,-46,14.528,-37.528,-50,13.392,-40,-50,13,-40,-46,13,-37.528,-50,13.392,-40,-46,13,-37.528,-46,13.392,-40,-50,13,-42.472,-50,13.392,-42.472,-46,13.392,-40,-50,13,-42.472,-46,13.392,-40,-46,13,-42.472,-50,13.392,-44.702,-50,14.528,-44.702,-46,14.528,-42.472,-50,13.392,-44.702,-46,14.528,-42.472,-46,13.392,-46.472,-50,16.298,-46.472,-46,16.298,-44.702,-46,14.528,-46.472,-50,16.298,-44.702,-46,14.528,-44.702,-50,14.528,-46.5158,-46,16.384001,-46.472,-46,16.298,-46.472,-50,16.298,-40,-46,-8,-40,-50,-8,-38.455002,-50,-8.245,-40,-46,-8,-38.455002,-50,-8.245,-38.455002,-46,-8.245,-38.455002,-50,-8.245,-37.061001,-50,-8.955,-37.061001,-46,-8.955,-38.455002,-50,-8.245,-37.061001,-46,-8.955,-38.455002,-46,-8.245,-37.061001,-50,-8.955,-35.955002,-50,-10.061,-35.955002,-46,-10.061,-37.061001,-50,-8.955,-35.955002,-46,-10.061,-37.061001,-46,-8.955,-35.955002,-50,-10.061,-35.244999,-50,-11.455,-35.244999,-46,-11.455,-35.955002,-50,-10.061,-35.244999,-46,-11.455,-35.955002,-46,-10.061,-40,-46,29,-40,-50,29,-37.528,-50,28.608,-40,-46,29,-37.528,-50,28.608,-37.528,-46,28.608,-35.244999,-50,-11.455,-35,-50,-13,-35,-46,-13,-35.244999,-50,-11.455,-35,-46,-13,-35.244999,-46,-11.455,-35,-50,-13,-35.244999,-50,-14.545,-35.244999,-46,-14.545,-35,-50,-13,-35.244999,-46,-14.545,-35,-46,-13,-35.244999,-50,-14.545,-35.955002,-50,-15.939,-35.955002,-46,-15.939,-35.244999,-50,-14.545,-35.955002,-46,-15.939,-35.244999,-46,-14.545,-35.955002,-50,-15.939,-36.400002,-46,-16.384001,-35.955002,-46,-15.939,-38.455002,-50,-17.754999,-40,-50,-18,-40,-46,-18,-38.455002,-50,-17.754999,-40,-46,-18,-38.455002,-46,-17.754999,-44.044998,-50,-15.939,-44.044998,-46,-15.939,-43.599998,-46,-16.384001,-40,-50,-18,-41.544998,-50,-17.754999,-41.544998,-46,-17.754999,-40,-50,-18,-41.544998,-46,-17.754999,-40,-46,-18,-44.755001,-50,-14.545,-44.755001,-46,-14.545,-44.044998,-46,-15.939,-44.755001,-50,-14.545,-44.044998,-46,-15.939,-44.044998,-50,-15.939,-45,-50,-13,-45,-46,-13,-44.755001,-46,-14.545,-45,-50,-13,-44.755001,-46,-14.545,-44.755001,-50,-14.545,-41.544998,-50,-17.754999,-42.938999,-50,-17.045,-42.938999,-46,-17.045,-41.544998,-50,-17.754999,-42.938999,-46,-17.045,-41.544998,-46,-17.754999,-44.755001,-50,-11.455,-44.755001,-46,-11.455,-45,-46,-13,-44.755001,-50,-11.455,-45,-46,-13,-45,-50,-13,-43.599998,-46,-16.384001,-42.938999,-46,-17.045,-42.938999,-50,-17.045,-43.599998,-46,-16.384001,-42.938999,-50,-17.045,-44.044998,-50,-15.939,-44.044998,-50,-10.061,-44.044998,-46,-10.061,-44.755001,-46,-11.455,-44.044998,-50,-10.061,-44.755001,-46,-11.455,-44.755001,-50,-11.455,-42.938999,-50,-8.955,-42.938999,-46,-8.955,-44.044998,-46,-10.061,-42.938999,-50,-8.955,-44.044998,-46,-10.061,-44.044998,-50,-10.061,-41.544998,-50,-8.245,-41.544998,-46,-8.245,-42.938999,-46,-8.955,-41.544998,-50,-8.245,-42.938999,-46,-8.955,-42.938999,-50,-8.955],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.453914,0,0.891046,0.453914,0,0.891046,0.453914,0,0.891046,0.453914,0,0.891046,0.453914,0,0.891046,0.453914,0,0.891046,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.891045,0,0.453914,0.891045,0,0.453914,0.891045,0,0.453914,0.891045,0,0.453914,0.891045,0,0.453914,0.891045,0,0.453914,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707106,0.707107,0,-0.707106,0.707107,0,-0.707106,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.453848,0,-0.891079,0.453848,0,-0.891079,0.453848,0,-0.891079,0.453848,0,-0.891079,0.453848,0,-0.891079,0.453848,0,-0.891079,0.891044,0,-0.453918,0.891044,0,-0.453918,0.891044,0,-0.453918,-0.891044,0,-0.453918,-0.891044,0,-0.453918,-0.891044,0,-0.453918,-0.891045,0.000002,-0.453914,-0.891045,0.000002,-0.453914,-0.891045,0.000002,-0.453914,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.891045,0,0.453914,-0.891045,0,0.453914,-0.891045,0,0.453914,-0.891045,0,0.453914,-0.891045,0,0.453914,-0.891045,0,0.453914,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.453914,0,0.891046,-0.453914,0,0.891046,-0.453914,0,0.891046,-0.453914,0,0.891046,-0.453914,0,0.891046,-0.453914,0,0.891046,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,0.891086,0,-0.453834,0.891086,0,-0.453834,0.891086,0,-0.453834,0.891045,0.000002,-0.453914,0.891045,0.000002,-0.453914,0.891045,0.000002,-0.453914,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.453914,0,-0.891046,0.453914,0,-0.891046,0.453914,0,-0.891046,0.453914,0,-0.891046,0.453914,0,-0.891046,0.453914,0,-0.891046,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.453914,0,-0.891046,-0.453914,0,-0.891046,-0.453914,0,-0.891046,-0.453914,0,-0.891046,-0.453914,0,-0.891046,-0.453914,0,-0.891046,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.891086,0,-0.453834,-0.891086,0,-0.453834,-0.891086,0,-0.453834,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.453849,0,0.891079,0.453849,0,0.891079,0.453849,0,0.891079,0.453849,0,0.891079,0.453849,0,0.891079,0.453849,0,0.891079,0.707107,0,0.707106,0.707107,0,0.707106,0.707107,0,0.707106,0.707107,0,0.707106,0.707107,0,0.707106,0.707107,0,0.707106,0.891078,0,0.453851,0.891078,0,0.453851,0.891078,0,0.453851,0.891078,0,0.453851,0.891078,0,0.453851,0.891078,0,0.453851,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.987659,0,-0.156618,0.891078,0,-0.453851,0.891078,0,-0.453851,0.891078,0,-0.453851,0.891078,0,-0.453851,0.891078,0,-0.453851,0.891078,0,-0.453851,0.707108,0,-0.707106,0.707108,0,-0.707106,0.707108,0,-0.707106,0.15662,0,-0.987659,0.15662,0,-0.987659,0.15662,0,-0.987659,0.15662,0,-0.987659,0.15662,0,-0.987659,0.15662,0,-0.987659,-0.707108,0,-0.707106,-0.707108,0,-0.707106,-0.707108,0,-0.707106,-0.15662,0,-0.987659,-0.15662,0,-0.987659,-0.15662,0,-0.987659,-0.15662,0,-0.987659,-0.15662,0,-0.987659,-0.15662,0,-0.987659,-0.891078,0,-0.453851,-0.891078,0,-0.453851,-0.891078,0,-0.453851,-0.891078,0,-0.453851,-0.891078,0,-0.453851,-0.891078,0,-0.453851,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.987659,0,-0.156618,-0.453848,0,-0.891079,-0.453848,0,-0.891079,-0.453848,0,-0.891079,-0.453848,0,-0.891079,-0.453848,0,-0.891079,-0.453848,0,-0.891079,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.987659,0,0.156618,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707106,-0.707107,0,-0.707106,-0.707107,0,-0.707106,-0.891078,0,0.453851,-0.891078,0,0.453851,-0.891078,0,0.453851,-0.891078,0,0.453851,-0.891078,0,0.453851,-0.891078,0,0.453851,-0.707107,0,0.707106,-0.707107,0,0.707106,-0.707107,0,0.707106,-0.707107,0,0.707106,-0.707107,0,0.707106,-0.707107,0,0.707106,-0.453849,0,0.891079,-0.453849,0,0.891079,-0.453849,0,0.891079,-0.453849,0,0.891079,-0.453849,0,0.891079,-0.453849,0,0.891079],"normalized":false}},"boundingSphere":{"center":[-40,-48,5.5],"radius":23.584953}}},{"uuid":"D73882FC-5B25-4276-BB49-CB7EFF2CDB8B","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-50,50,50,-50,50,-50,-50,-46,-50,-50,50,50,-50,-46,-50,-50,-46,50,-50,50,50,-50,-46,50,-48,-46,50,-12.634,13.271,-34,35,-11,-34,-4.271,17.532,-34,-19.271,6.634,-34,35,-11,-34,-12.634,13.271,-34,-4.271,17.532,-34,35,-11,-34,5,19,-34,5,19,-34,29.271,6.634,-34,22.634001,13.271,-34,5,19,-34,22.634001,13.271,-34,14.271,17.532,-34,50,-46,50,40.001999,-46,-40.002998,50,-46,-50,-50,-46,50,-50,-46,-50,-48,-46,16.384001,-50,-46,50,-48,-46,16.384001,-48,-46,21,-50,-46,50,-48,-46,21,-48,-46,50,-30.003,-46,-40.002998,-35,-46,-8,-35,-46,-13,-35,-46,-18,-30.003,-46,-40.002998,-35,-46,-13,29.271,6.634,-34,5,19,-34,33.532001,-1.729,-34,33.532001,-1.729,-34,5,19,-34,35,-11,-34,35,-11,-34,-19.271,6.634,-34,-23.532,-1.729,-34,35,-11,-34,-23.532,-1.729,-34,-25,-11,-34,35,-11,-34,-25,-11,-34,-23.532,-20.271,-34,35,-11,-34,-23.532,-20.271,-34,-19.271,-28.634001,-34,35,-11,-34,-19.271,-28.634001,-34,-12.634,-35.271,-34,35,-11,-34,-12.634,-35.271,-34,-4.271,-39.532001,-34,35,-11,-34,-4.271,-39.532001,-34,5,-41,-34,35,-11,-34,5,-41,-34,14.271,-39.532001,-34,35,-11,-34,14.271,-39.532001,-34,22.634001,-35.271,-34,35,-11,-34,22.634001,-35.271,-34,29.271,-28.634001,-34,35,-11,-34,29.271,-28.634001,-34,33.532001,-20.271,-34,29.271,6.634,-40,22.634001,13.271,-40,22.634001,13.271,-34,29.271,6.634,-40,22.634001,13.271,-34,29.271,6.634,-34,22.634001,13.271,-40,14.271,17.532,-40,14.271,17.532,-34,22.634001,13.271,-40,14.271,17.532,-34,22.634001,13.271,-34,-4.271,17.532,-40,5,19,-40,-12.634,13.271,-40,-19.271,6.634,-40,-12.634,13.271,-40,5,19,-40,14.271,17.532,-40,-25,-11,-40,5,19,-40,22.634001,13.271,-40,-25,-11,-40,14.271,17.532,-40,29.271,6.634,-40,-25,-11,-40,22.634001,13.271,-40,40.001999,34.002998,40.002998,40.001999,34.002998,-40.002998,40.001999,-46,-40.002998,14.271,17.532,-40,5,19,-40,5,19,-34,14.271,17.532,-40,5,19,-34,14.271,17.532,-34,-12.634,-35.271,-40,29.271,6.634,-40,-4.271,-39.532001,-40,-19.271,-28.634001,-40,29.271,6.634,-40,-12.634,-35.271,-40,-23.532,-20.271,-40,29.271,6.634,-40,-19.271,-28.634001,-40,-25,-11,-40,29.271,6.634,-40,-23.532,-20.271,-40,-23.532,-1.729,-40,5,19,-40,-25,-11,-40,-19.271,6.634,-40,5,19,-40,-23.532,-1.729,-40,5,-41,-40,-4.271,-39.532001,-40,29.271,6.634,-40,5,-41,-40,29.271,6.634,-40,33.532001,-1.729,-40,5,-41,-40,33.532001,-1.729,-40,35,-11,-40,5,-41,-40,35,-11,-40,33.532001,-20.271,-40,5,-41,-40,33.532001,-20.271,-40,29.271,-28.634001,-40,5,-41,-40,29.271,-28.634001,-40,22.634001,-35.271,-40,5,-41,-40,22.634001,-35.271,-40,14.271,-39.532001,-40,5,19,-40,-4.271,17.532,-40,-4.271,17.532,-34,5,19,-40,-4.271,17.532,-34,5,19,-34,50,-46,50,50,-46,-50,50,50,-50,-42.938999,-46,-8.955,-41.544998,-46,-8.245,-45,-46,13,-40,-46,-8,-38.455002,-46,-8.245,-40,-46,13,-37.528,-46,13.392,-40,-46,13,-35,-46,-8,-38.455002,-46,-8.245,-37.061001,-46,-8.955,-40,-46,13,-35,-46,-8,-40,-46,13,-37.061001,-46,-8.955,-50,-46,-50,-45,-46,-17.2071,-45,-46,-13,-45,-46,13,-48,-46,16.384001,-45,-46,-13,-50,-46,-50,-45,-46,-13,-48,-46,16.384001,-37.061001,-46,-8.955,-35.955002,-46,-10.061,-35,-46,-8,-46.472,-46,25.702,-44.702,-46,27.472,-48,-46,50,-42.472,-46,28.608,-40,-46,29,-48,-46,50,-4.271,17.532,-40,-12.634,13.271,-40,-12.634,13.271,-34,-4.271,17.532,-40,-12.634,13.271,-34,-4.271,17.532,-34,-40,-46,29,-37.528,-46,28.608,-32,-46,50,-37.528,-46,28.608,-35.298,-46,27.472,-32,-46,50,-50,50,-50,50,50,-50,50,-46,-50,-12.634,13.271,-40,-19.271,6.634,-40,-19.271,6.634,-34,-12.634,13.271,-40,-19.271,6.634,-34,-12.634,13.271,-34,-35.298,-46,27.472,-33.528,-46,25.702,-32,-46,50,-35.955002,-46,-10.061,-35.244999,-46,-11.455,-35,-46,-8,-50,50,-50,50,-46,-50,-50,-46,-50,-30.003,-46,-40.002998,50,-46,-50,40.001999,-46,-40.002998,-41.544998,-46,-8.245,-40,-46,-8,-45,-46,13,-33.528,-46,25.702,-32.391998,-46,23.472,-32,-46,50,-35,-46,-13,-35,-46,-8,-35.244999,-46,-11.455,-35,-46,-18,-40,-46,-18,-30.003,-46,-40.002998,-50,-46,-50,-30.003,-46,-40.002998,-40,-46,-18,-45,-46,-17.2071,-50,-46,-50,-40,-46,-18,50,-46,-50,-30.003,-46,-40.002998,-50,-46,-50,5,-41,-34,5,-41,-40,14.271,-39.532001,-40,5,-41,-34,14.271,-39.532001,-40,14.271,-39.532001,-34,-35,-46,-18,-35,-46,-13,-35.244999,-46,-14.545,14.271,-39.532001,-40,22.634001,-35.271,-40,22.634001,-35.271,-34,14.271,-39.532001,-40,22.634001,-35.271,-34,14.271,-39.532001,-34,-30.003,34.002998,40.002998,40.001999,34.002998,-40.002998,40.001999,34.002998,40.002998,-36.400002,-46,-16.384001,-35,-46,-18,-35.955002,-46,-15.939,22.634001,-35.271,-40,29.271,-28.634001,-40,29.271,-28.634001,-34,22.634001,-35.271,-40,29.271,-28.634001,-34,22.634001,-35.271,-34,40.001999,34.002998,-40.002998,-30.003,34.002998,40.002998,-30.003,34.002998,-40.002998,-43.599998,-46,-16.384001,-44.044998,-46,-15.939,-45,-46,-17.2071,-32,-46,21,-32,-46,50,-32.391998,-46,23.472,29.271,-28.634001,-40,33.532001,-20.271,-40,33.532001,-20.271,-34,29.271,-28.634001,-40,33.532001,-20.271,-34,29.271,-28.634001,-34,40.001999,34.002998,-40.002998,-30.003,34.002998,-40.002998,40.001999,-46,-40.002998,40.001999,-46,-40.002998,-30.003,34.002998,-40.002998,-30.003,-46,-40.002998,-35,-46,-8,-32,-46,21,-32.391998,-46,18.528,-44.044998,-46,-15.939,-44.755001,-46,-14.545,-45,-46,-17.2071,-30.003,34.002998,40.002998,-30.003,-46,-40.002998,-30.003,34.002998,-40.002998,33.532001,-20.271,-40,35,-11,-40,35,-11,-34,33.532001,-20.271,-40,35,-11,-34,33.532001,-20.271,-34,-45,-46,-13,-45,-46,-17.2071,-44.755001,-46,-14.545,-46.5158,-46,16.384001,-47.608002,-46,18.528,-48,-46,16.384001,-48,-46,21,-48,-46,16.384001,-47.608002,-46,18.528,33.532001,-1.729,-40,33.532001,-1.729,-34,35,-11,-34,33.532001,-1.729,-40,35,-11,-34,35,-11,-40,-45,-46,-13,-44.755001,-46,-11.455,-45,-46,13,-44.755001,-46,-11.455,-44.044998,-46,-10.061,-45,-46,13,-48,-46,21,-47.608002,-46,23.472,-48,-46,50,-47.608002,-46,23.472,-46.472,-46,25.702,-48,-46,50,-44.044998,-46,-10.061,-42.938999,-46,-8.955,-45,-46,13,29.271,6.634,-34,33.532001,-1.729,-34,33.532001,-1.729,-40,29.271,6.634,-34,33.532001,-1.729,-40,29.271,6.634,-40,-42.472,-46,28.608,-48,-46,50,-44.702,-46,27.472,-32,-46,50,-48,-46,50,-40,-46,29,-19.271,6.634,-40,-23.532,-1.729,-40,-23.532,-1.729,-34,-19.271,6.634,-40,-23.532,-1.729,-34,-19.271,6.634,-34,-42.472,-46,13.392,-45,-46,13,-40,-46,-8,-40,-46,13,-42.472,-46,13.392,-40,-46,-8,-32.391998,-46,18.528,-33.4842,-46,16.384001,-35,-46,-8,-33.528,-46,16.298,-35,-46,-8,-33.4842,-46,16.384001,-33.528,-46,16.298,-35.298,-46,14.528,-35,-46,-8,-23.532,-1.729,-40,-25,-11,-40,-25,-11,-34,-23.532,-1.729,-40,-25,-11,-34,-23.532,-1.729,-34,-35.244999,-46,-14.545,-35.955002,-46,-15.939,-35,-46,-18,-35,-46,-18,-36.400002,-46,-16.384001,-37.061001,-46,-17.045,-37.061001,-46,-17.045,-38.455002,-46,-17.754999,-35,-46,-18,-37.528,-46,13.392,-35,-46,-8,-35.298,-46,14.528,-40,-46,-18,-35,-46,-18,-38.455002,-46,-17.754999,-40,-46,-18,-41.544998,-46,-17.754999,-45,-46,-17.2071,-41.544998,-46,-17.754999,-42.938999,-46,-17.045,-45,-46,-17.2071,-25,-11,-34,-25,-11,-40,-23.532,-20.271,-40,-25,-11,-34,-23.532,-20.271,-40,-23.532,-20.271,-34,-42.938999,-46,-17.045,-43.599998,-46,-16.384001,-45,-46,-17.2071,-42.472,-46,13.392,-44.702,-46,14.528,-45,-46,13,-23.532,-20.271,-40,-19.271,-28.634001,-40,-19.271,-28.634001,-34,-23.532,-20.271,-40,-19.271,-28.634001,-34,-23.532,-20.271,-34,-44.702,-46,14.528,-46.472,-46,16.298,-45,-46,13,-48,-46,16.384001,-45,-46,13,-46.472,-46,16.298,-46.472,-46,16.298,-46.5158,-46,16.384001,-48,-46,16.384001,-19.271,-28.634001,-40,-12.634,-35.271,-40,-12.634,-35.271,-34,-19.271,-28.634001,-40,-12.634,-35.271,-34,-19.271,-28.634001,-34,-4.271,-39.532001,-40,-4.271,-39.532001,-34,-12.634,-35.271,-34,-4.271,-39.532001,-40,-12.634,-35.271,-34,-12.634,-35.271,-40,5,-41,-40,5,-41,-34,-4.271,-39.532001,-34,5,-41,-40,-4.271,-39.532001,-34,-4.271,-39.532001,-40,50,50,-50,50,50,50,50,-46,50,50,50,50,-50,50,50,-32,-46,50,50,50,50,-32,-46,50,50,-46,50,-32,-46,50,-30.003,-46,40.002998,40.001999,-46,40.002998,-32,-46,50,-32,-46,21,-30.003,-46,40.002998,-35,-46,-8,-30.003,-46,-40.002998,-32,-46,21,-30.003,-46,40.002998,-32,-46,21,-30.003,-46,-40.002998,40.001999,-46,40.002998,40.001999,-46,-40.002998,50,-46,50,-32,-46,50,40.001999,-46,40.002998,50,-46,50,50,50,-50,-50,50,-50,-50,50,50,50,50,50,50,50,-50,-50,50,50,-30.003,34.002998,40.002998,40.001999,34.002998,40.002998,40.001999,-46,40.002998,-30.003,34.002998,40.002998,40.001999,-46,40.002998,-30.003,-46,40.002998,-30.003,34.002998,40.002998,-30.003,-46,40.002998,-30.003,-46,-40.002998,40.001999,-46,40.002998,40.001999,34.002998,40.002998,40.001999,-46,-40.002998,-50,50,50,-48,-46,50,-32,-46,50],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.453977,0.891014,0,0.453977,0.891014,0,0.453977,0.891014,0,0.453977,0.891014,0,0.453977,0.891014,0,0.453977,0.891014,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,0.156395,0.987695,0,0.156395,0.987695,0,0.156395,0.987695,0,0.156395,0.987695,0,0.156395,0.987695,0,0.156395,0.987695,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-0.156395,0.987695,0,-0.156395,0.987695,0,-0.156395,0.987695,0,-0.156395,0.987695,0,-0.156395,0.987695,0,-0.156395,0.987695,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.453977,0.891014,0,-0.453977,0.891014,0,-0.453977,0.891014,0,-0.453977,0.891014,0,-0.453977,0.891014,0,-0.453977,0.891014,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.156395,-0.987695,0,0.156395,-0.987695,0,0.156395,-0.987695,0,0.156395,-0.987695,0,0.156395,-0.987695,0,0.156395,-0.987695,0,0,-1,0,0,-1,0,0,-1,0,0.453977,-0.891013,0,0.453977,-0.891013,0,0.453977,-0.891013,0,0.453977,-0.891013,0,0.453977,-0.891013,0,0.453977,-0.891013,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.891013,-0.453977,0,0.891013,-0.453977,0,0.891013,-0.453977,0,0.891013,-0.453977,0,0.891013,-0.453977,0,0.891013,-0.453977,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,0.987695,-0.156395,0,0.987695,-0.156395,0,0.987695,-0.156395,0,0.987695,-0.156395,0,0.987695,-0.156395,0,0.987695,-0.156395,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.987695,0.156395,0,0.987695,0.156395,0,0.987695,0.156395,0,0.987695,0.156395,0,0.987695,0.156395,0,0.987695,0.156395,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.891013,0.453977,0,0.891013,0.453977,0,0.891013,0.453977,0,0.891013,0.453977,0,0.891013,0.453977,0,0.891013,0.453977,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.891014,0.453977,0,-0.891014,0.453977,0,-0.891014,0.453977,0,-0.891014,0.453977,0,-0.891014,0.453977,0,-0.891014,0.453977,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.987695,0.156395,0,-0.987695,0.156395,0,-0.987695,0.156395,0,-0.987695,0.156395,0,-0.987695,0.156395,0,-0.987695,0.156395,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,-0.987695,-0.156395,0,-0.987695,-0.156395,0,-0.987695,-0.156395,0,-0.987695,-0.156395,0,-0.987695,-0.156395,0,-0.987695,-0.156395,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.891014,-0.453977,0,-0.891014,-0.453977,0,-0.891014,-0.453977,0,-0.891014,-0.453977,0,-0.891014,-0.453977,0,-0.891014,-0.453977,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.453977,-0.891013,0,-0.453977,-0.891013,0,-0.453977,-0.891013,0,-0.453977,-0.891013,0,-0.453977,-0.891013,0,-0.453977,-0.891013,0,-0.156395,-0.987695,0,-0.156395,-0.987695,0,-0.156395,-0.987695,0,-0.156395,-0.987695,0,-0.156395,-0.987695,0,-0.156395,-0.987695,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1],"normalized":false}},"boundingSphere":{"center":[0,2,0],"radius":85.463442}}}],"materials":[{"uuid":"766E3FC2-E78F-4114-9297-CD8662B8A847","type":"MeshLambertMaterial","color":2236962,"emissive":855309,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"98D7A93C-AB54-491B-ABF4-3EB41F4A7BA9","type":"MeshLambertMaterial","color":16777215,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"F278809A-6774-44A4-9A41-DD1763C03C48","type":"Group","name":"microwave_oven","matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"C728DF05-FAFB-453A-8B0A-632C465FCED2","type":"Mesh","name":"button","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"178C017F-D9B1-4244-B591-77CB74A39143","material":"766E3FC2-E78F-4114-9297-CD8662B8A847"},{"uuid":"56EB817C-C13B-49AE-ACFC-55559303FFE9","type":"Mesh","name":"body","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"D73882FC-5B25-4276-BB49-CB7EFF2CDB8B","material":"98D7A93C-AB54-491B-ABF4-3EB41F4A7BA9"}]}}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"8C9AC9CF-C2F5-437E-B950-113429E5DC96","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[50,40,40,50,40,-50,50,50,-50,-50,50,-50,-50,40,-50,-50,40,40,-40,40,40,-40,40,-50,-40,50,-50,-40,40,40,-40,50,-50,-40,50,40,50,-50,-50,50,-40,-50,50,-40,40,40,50,40,40,50,-50,40,40,-50,40,50,40,40,40,-50,40,40,40,40,-40,40,40,-40,-50,40,-50,-50,40,-40,40,40,-50,-50,40,-50,40,-50,-50,-50,-40,-50,-50,-40,-50,40,-50,40,40,-50,40,-50,-40,40,-50,-50,40,40,-40,40,-50,-40,40,40,40,-50,40,40,-50,-50,50,-50,-50,-50,-40,40,-50,-40,-50,-50,-50,-50,50,40,-50,40,40,-50,40,50,-50,50,40,-50,40,50,-50,50,50,-50,40,-50,40,-40,-50,40,-40,-40,40,-40,40,40,40,40,40,-40,-40,40,-40,50,40,40,50,40,-40,40,40,40,50,40,40,40,40,-40,40,40,40,40,40,40,-40,40,-40,-40,40,40,-50,40,-40,-40,40,40,-40,40,50,-50,50,50,-50,-50,50,-40,40,50,-50,50,50,-40,40,50,40,40,50,50,-50,50,50,50,50,40,40,50,-50,50,50,40,40,50,50,50,50,50,50,50,50,-50,40,50,40,50,50,50,40,50,40,-40,50,40,-50,50,-50,-50,50,50,-40,50,40,50,50,50,-40,50,40,-50,50,50,-40,-50,40,-40,-50,-50,-40,-40,-50,-40,-50,40,-40,-40,-50,-40,-40,40,-40,40,-50,-50,40,-50,-50,50,-50,-40,40,-50,-50,50,-50,-40,50,-50,50,-50,-50,40,-50,-50,40,-40,-50,50,-50,-50,40,-40,-50,50,-40,-50,-40,-50,-50,-50,-50,-50,-50,-40,-50,-40,-50,-50,-50,-40,-50,-40,-40,-50,40,40,40,40,40,-50,50,40,-50,40,40,40,50,40,-50,50,40,40,50,50,-50,40,50,-50,40,50,40,50,-40,40,50,-40,-50,40,-40,-50,50,-40,40,40,-40,-50,40,-40,40,-50,50,50,-50,50,-50,-50,40,40,-50,50,50,-50,40,40,-50,-40,40,-50,-50,-50,-50,-50,50,-50,-40,40,-50,50,50,-50,-40,40,-50,-50,50,50,50,50,-50,50,50,-50,-50,50,50,50,50,-50,-50,50,50,-50,50,-40,-40,40,-50,-40,40,-50,40,40,-40,-40,40,-50,40,40,-40,40,40,50,-40,40,40,-40,40,40,40,40,50,-40,40,40,40,40,50,40,40,-40,50,40,-40,50,-50,-50,50,-50,-40,-40,40,-40,-40,-50,-50,-40,-50,-40,-40,40,-50,-40,-50,-50,-40,40,-50,-50,50,-50,-50,-50,-40,-50,40,-50,-50,50,-40,-50,40,40,-50,40,50,-50,-50,50,-50,50,40,-50,40,-50,-50,50,40,-50,40,50,-50,50],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0],"normalized":false}},"boundingSphere":{"center":[0,0,0],"radius":86.60254}}}],"materials":[{"uuid":"D6E9B2EC-533F-4212-BA6D-8F48055E693D","type":"MeshLambertMaterial","color":13724989,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"69DCD231-9DD0-45B2-9ECE-01F150682CF0","type":"Group","name":"desk","matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"9A8FF8DD-472D-4EDC-A07B-26CECE563D8A","type":"Mesh","name":"body","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"8C9AC9CF-C2F5-437E-B950-113429E5DC96","material":"D6E9B2EC-533F-4212-BA6D-8F48055E693D"}]}}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"D6042B2F-9729-406A-A02A-8F11F4FDC0D5","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-50,-17.003,-17.003,-48,-17.003,-17.003,-48,-17.003,-48,-50,-17.003,-17.003,-48,-17.003,-48,-50,-17.003,-48,-50,-17.003,14.998,-48,-17.003,14.998,-48,-17.003,-14.998,-50,-17.003,14.998,-48,-17.003,-14.998,-50,-17.003,-14.998,-48,-17.003,48,-48,-17.003,17.003,-50,-17.003,17.003,-48,-17.003,48,-50,-17.003,17.003,-50,-17.003,48,-48,-48,14.998,-48,-17.003,14.998,-50,-17.003,14.998,-48,-48,14.998,-50,-17.003,14.998,-50,-48,14.998,-48,-48,-17.003,-48,-17.003,-17.003,-50,-17.003,-17.003,-48,-48,-17.003,-50,-17.003,-17.003,-50,-48,-17.003,-48,-17.003,-14.998,-48,-48,-14.998,-50,-48,-14.998,-48,-17.003,-14.998,-50,-48,-14.998,-50,-17.003,-14.998,-48,-17.003,17.003,-48,-48,17.003,-50,-48,17.003,-48,-17.003,17.003,-50,-48,17.003,-50,-17.003,17.003,-48,48,-48,-50,48,-48,-50,48,-17.003,-48,48,-48,-50,48,-17.003,-48,48,-17.003,-48,48,-14.998,-50,48,-14.998,-50,48,14.998,-48,48,-14.998,-50,48,14.998,-48,48,14.998,-48,48,17.003,-50,48,17.003,-50,48,48,-48,48,17.003,-50,48,48,-48,48,48,-48,-48,-17.003,-50,-48,-17.003,-50,-48,-48,-48,-48,-17.003,-50,-48,-48,-48,-48,-48,-48,-48,14.998,-50,-48,14.998,-50,-48,-14.998,-48,-48,14.998,-50,-48,-14.998,-48,-48,-14.998,-48,-48,48,-50,-48,48,-50,-48,17.003,-48,-48,48,-50,-48,17.003,-48,-48,17.003,-50,48,-48,-50,17.003,-48,-50,17.003,-17.003,-50,48,-48,-50,17.003,-17.003,-50,48,-17.003,-50,48,-14.998,-50,17.003,-14.998,-50,17.003,14.998,-50,48,-14.998,-50,17.003,14.998,-50,48,14.998,-50,48,17.003,-50,17.003,17.003,-50,17.003,48,-50,48,17.003,-50,17.003,48,-50,48,48,-50,-14.998,-17.003,-50,14.998,-17.003,-50,14.998,-48,-50,-14.998,-17.003,-50,14.998,-48,-50,-14.998,-48,-50,-14.998,14.998,-50,14.998,14.998,-50,14.998,-14.998,-50,-14.998,14.998,-50,14.998,-14.998,-50,-14.998,-14.998,-50,14.998,48,-50,14.998,17.003,-50,-14.998,17.003,-50,14.998,48,-50,-14.998,17.003,-50,-14.998,48,-50,-48,-17.003,-50,-17.003,-17.003,-50,-17.003,-48,-50,-48,-17.003,-50,-17.003,-48,-50,-48,-48,-50,-48,14.998,-50,-17.003,14.998,-50,-17.003,-14.998,-50,-48,14.998,-50,-17.003,-14.998,-50,-48,-14.998,-50,-17.003,48,-50,-17.003,17.003,-50,-48,17.003,-50,-17.003,48,-50,-48,17.003,-50,-48,48,-48,48,48,-50,48,48,-50,17.003,48,-48,48,48,-50,17.003,48,-48,17.003,48,-48,14.998,48,-50,14.998,48,-50,-14.998,48,-48,14.998,48,-50,-14.998,48,-48,-14.998,48,-48,-17.003,48,-50,-17.003,48,-50,-48,48,-48,-17.003,48,-50,-48,48,-48,-48,48,-48,17.003,-48,-50,17.003,-48,-50,48,-48,-48,17.003,-48,-50,48,-48,-48,48,-48,-48,-14.998,-48,-50,-14.998,-48,-50,14.998,-48,-48,-14.998,-48,-50,14.998,-48,-48,14.998,-48,-48,-48,-48,-50,-48,-48,-50,-17.003,-48,-48,-48,-48,-50,-17.003,-48,-48,-17.003,-48,-48,17.003,-48,-48,17.003,-17.003,-50,17.003,-17.003,-48,17.003,-48,-50,17.003,-17.003,-50,17.003,-48,-50,17.003,-14.998,-48,17.003,-14.998,-48,17.003,14.998,-50,17.003,-14.998,-48,17.003,14.998,-50,17.003,14.998,-50,17.003,17.003,-48,17.003,17.003,-48,17.003,48,-50,17.003,17.003,-48,17.003,48,-50,17.003,48,-48,17.003,14.998,-48,48,14.998,-50,48,14.998,-48,17.003,14.998,-50,48,14.998,-50,17.003,14.998,-48,17.003,-17.003,-48,48,-17.003,-50,48,-17.003,-48,17.003,-17.003,-50,48,-17.003,-50,17.003,-17.003,-48,48,-14.998,-48,17.003,-14.998,-50,17.003,-14.998,-48,48,-14.998,-50,17.003,-14.998,-50,48,-14.998,-48,48,17.003,-48,17.003,17.003,-50,17.003,17.003,-48,48,17.003,-50,17.003,17.003,-50,48,17.003,-50,14.998,-17.003,-48,14.998,-17.003,-48,14.998,-48,-50,14.998,-17.003,-48,14.998,-48,-50,14.998,-48,-50,14.998,14.998,-48,14.998,14.998,-48,14.998,-14.998,-50,14.998,14.998,-48,14.998,-14.998,-50,14.998,-14.998,-48,14.998,48,-48,14.998,17.003,-50,14.998,17.003,-48,14.998,48,-50,14.998,17.003,-50,14.998,48,-48,-14.998,-48,-48,-14.998,-17.003,-50,-14.998,-17.003,-48,-14.998,-48,-50,-14.998,-17.003,-50,-14.998,-48,-50,-14.998,-14.998,-48,-14.998,-14.998,-48,-14.998,14.998,-50,-14.998,-14.998,-48,-14.998,14.998,-50,-14.998,14.998,-50,-14.998,17.003,-48,-14.998,17.003,-48,-14.998,48,-50,-14.998,17.003,-48,-14.998,48,-50,-14.998,48,-48,-14.998,14.998,-48,14.998,14.998,-50,14.998,14.998,-48,-14.998,14.998,-50,14.998,14.998,-50,-14.998,14.998,-48,-14.998,-17.003,-48,14.998,-17.003,-50,14.998,-17.003,-48,-14.998,-17.003,-50,14.998,-17.003,-50,-14.998,-17.003,-48,14.998,-14.998,-48,-14.998,-14.998,-50,-14.998,-14.998,-48,14.998,-14.998,-50,-14.998,-14.998,-50,14.998,-14.998,-48,14.998,17.003,-48,-14.998,17.003,-50,-14.998,17.003,-48,14.998,17.003,-50,-14.998,17.003,-50,14.998,17.003],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[-49,0,0],"radius":67.889616}}},{"uuid":"39D018C8-165C-405B-A020-97E2556C3F6E","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[48,48,-14.998,48,17.003,-14.998,17.003,17.003,-14.998,48,48,-14.998,17.003,17.003,-14.998,17.003,48,-14.998,14.998,-14.998,14.998,-14.998,-14.998,14.998,-14.998,-14.998,-14.998,14.998,-14.998,14.998,-14.998,-14.998,-14.998,14.998,-14.998,-14.998,48,48,17.003,48,17.003,17.003,17.003,17.003,17.003,48,48,17.003,17.003,17.003,17.003,17.003,48,17.003,14.998,-14.998,48,-14.998,-14.998,48,-14.998,-14.998,17.003,14.998,-14.998,48,-14.998,-14.998,17.003,14.998,-14.998,17.003,17.003,14.998,-17.003,48,14.998,-17.003,48,14.998,-48,17.003,14.998,-17.003,48,14.998,-48,17.003,14.998,-48,-14.998,14.998,14.998,-14.998,-14.998,14.998,14.998,-14.998,14.998,-14.998,14.998,14.998,14.998,-14.998,14.998,14.998,14.998,14.998,17.003,14.998,14.998,48,14.998,14.998,48,14.998,-14.998,17.003,14.998,14.998,48,14.998,-14.998,17.003,14.998,-14.998,-14.998,14.998,-17.003,-14.998,-14.998,-17.003,14.998,-14.998,-17.003,-14.998,14.998,-17.003,14.998,-14.998,-17.003,14.998,14.998,-17.003,48,14.998,48,48,14.998,17.003,17.003,14.998,17.003,48,14.998,48,17.003,14.998,17.003,17.003,14.998,48,-14.998,-14.998,-14.998,-14.998,14.998,-14.998,14.998,14.998,-14.998,-14.998,-14.998,-14.998,14.998,14.998,-14.998,14.998,-14.998,-14.998,48,-14.998,-48,48,-14.998,-17.003,17.003,-14.998,-17.003,48,-14.998,-48,17.003,-14.998,-17.003,17.003,-14.998,-48,-14.998,-14.998,17.003,-14.998,14.998,17.003,14.998,14.998,17.003,-14.998,-14.998,17.003,14.998,14.998,17.003,14.998,-14.998,17.003,17.003,-14.998,-14.998,48,-14.998,-14.998,48,-14.998,14.998,17.003,-14.998,-14.998,48,-14.998,14.998,17.003,-14.998,14.998,14.998,-17.003,-48,-14.998,-17.003,-48,-14.998,-17.003,-17.003,14.998,-17.003,-48,-14.998,-17.003,-17.003,14.998,-17.003,-17.003,14.998,-17.003,-14.998,-14.998,-17.003,-14.998,-14.998,-17.003,14.998,14.998,-17.003,-14.998,-14.998,-17.003,14.998,14.998,-17.003,14.998,14.998,-17.003,17.003,-14.998,-17.003,17.003,-14.998,-17.003,48,14.998,-17.003,17.003,-14.998,-17.003,48,14.998,-17.003,48,-14.998,-17.003,14.998,-14.998,-48,14.998,14.998,-48,14.998,-14.998,-17.003,14.998,14.998,-48,14.998,14.998,-17.003,14.998,-14.998,-17.003,-17.003,-14.998,-48,-17.003,14.998,-48,-17.003,-14.998,-17.003,-17.003,14.998,-48,-17.003,14.998,-17.003,-17.003,14.998,-48,-14.998,-14.998,-48,-14.998,-14.998,-17.003,-14.998,14.998,-48,-14.998,-14.998,-17.003,-14.998,14.998,-17.003,-14.998,14.998,-48,17.003,-14.998,-48,17.003,-14.998,-17.003,17.003,14.998,-48,17.003,-14.998,-17.003,17.003,14.998,-17.003,17.003,-17.003,48,-17.003,-17.003,17.003,-17.003,-17.003,17.003,-48,-17.003,48,-17.003,-17.003,17.003,-48,-17.003,48,-48,-17.003,48,14.998,-17.003,17.003,14.998,-17.003,17.003,-14.998,-17.003,48,14.998,-17.003,17.003,-14.998,-17.003,48,-14.998,-17.003,48,48,-17.003,17.003,48,-17.003,17.003,17.003,-17.003,48,48,-17.003,17.003,17.003,-17.003,48,17.003,-17.003,14.998,-48,-17.003,14.998,-17.003,-17.003,-14.998,-17.003,-17.003,14.998,-48,-17.003,-14.998,-17.003,-17.003,-14.998,-48,17.003,48,-48,17.003,17.003,-48,17.003,17.003,-17.003,17.003,48,-48,17.003,17.003,-17.003,17.003,48,-17.003,-17.003,-14.998,-14.998,-17.003,14.998,-14.998,-17.003,14.998,14.998,-17.003,-14.998,-14.998,-17.003,14.998,14.998,-17.003,-14.998,14.998,17.003,48,-14.998,17.003,17.003,-14.998,17.003,17.003,14.998,17.003,48,-14.998,17.003,17.003,14.998,17.003,48,14.998,-17.003,-14.998,17.003,-17.003,14.998,17.003,-17.003,14.998,48,-17.003,-14.998,17.003,-17.003,14.998,48,-17.003,-14.998,48,17.003,48,17.003,17.003,17.003,17.003,17.003,17.003,48,17.003,48,17.003,17.003,17.003,48,17.003,48,48,-17.003,-17.003,-48,-17.003,-17.003,-17.003,-17.003,-48,-17.003,-17.003,-17.003,-48,-17.003,-48,-17.003,-17.003,-48,-48,17.003,-14.998,-17.003,17.003,14.998,-17.003,17.003,14.998,-48,17.003,-14.998,-17.003,17.003,14.998,-48,17.003,-14.998,-48,17.003,-14.998,17.003,48,-14.998,17.003,48,-14.998,48,17.003,-14.998,17.003,48,-14.998,48,17.003,-14.998,48,-17.003,-48,-14.998,-17.003,-17.003,-14.998,-17.003,-17.003,14.998,-17.003,-48,-14.998,-17.003,-17.003,14.998,-17.003,-48,14.998,17.003,-14.998,14.998,17.003,14.998,14.998,17.003,14.998,-14.998,17.003,-14.998,14.998,17.003,14.998,-14.998,17.003,-14.998,-14.998,48,-14.998,14.998,48,14.998,14.998,17.003,14.998,14.998,48,-14.998,14.998,17.003,14.998,14.998,17.003,-14.998,14.998,-17.003,-48,17.003,-17.003,-17.003,17.003,-17.003,-17.003,48,-17.003,-48,17.003,-17.003,-17.003,48,-17.003,-48,48,17.003,14.998,48,17.003,14.998,17.003,17.003,-14.998,17.003,17.003,14.998,48,17.003,-14.998,17.003,17.003,-14.998,48,48,-14.998,-17.003,48,14.998,-17.003,17.003,14.998,-17.003,48,-14.998,-17.003,17.003,14.998,-17.003,17.003,-14.998,-17.003,17.003,-48,-17.003,17.003,-17.003,-17.003,17.003,-17.003,-48,17.003,-48,-17.003,17.003,-17.003,-48,17.003,-48,-48,-17.003,17.003,-17.003,-48,17.003,-17.003,-48,17.003,-48,-17.003,17.003,-17.003,-48,17.003,-48,-17.003,17.003,-48,17.003,-48,14.998,17.003,-17.003,14.998,17.003,-17.003,-14.998,17.003,-48,14.998,17.003,-17.003,-14.998,17.003,-48,-14.998,17.003,-17.003,48,17.003,-17.003,17.003,17.003,-48,17.003,17.003,-17.003,48,17.003,-48,17.003,17.003,-48,48,48,14.998,-14.998,48,-14.998,-14.998,17.003,-14.998,-14.998,48,14.998,-14.998,17.003,-14.998,-14.998,17.003,14.998,-14.998,-17.003,17.003,14.998,-48,17.003,14.998,-48,17.003,-14.998,-17.003,17.003,14.998,-48,17.003,-14.998,-17.003,17.003,-14.998,48,17.003,-48,48,17.003,-17.003,17.003,17.003,-17.003,48,17.003,-48,17.003,17.003,-17.003,17.003,17.003,-48,48,14.998,17.003,48,-14.998,17.003,17.003,-14.998,17.003,48,14.998,17.003,17.003,-14.998,17.003,17.003,14.998,17.003,17.003,17.003,-14.998,48,17.003,-14.998,48,17.003,14.998,17.003,17.003,-14.998,48,17.003,14.998,17.003,17.003,14.998,-17.003,17.003,48,-48,17.003,48,-48,17.003,17.003,-17.003,17.003,48,-48,17.003,17.003,-17.003,17.003,17.003,17.003,17.003,17.003,48,17.003,17.003,48,17.003,48,17.003,17.003,17.003,48,17.003,48,17.003,17.003,48,48,17.003,14.998,48,48,14.998,17.003,48,14.998,48,17.003,14.998,17.003,48,14.998,17.003,17.003,14.998,17.003,-17.003,-17.003,48,-17.003,-17.003,48,-17.003,-48,17.003,-17.003,-17.003,48,-17.003,-48,17.003,-17.003,-48,-17.003,48,14.998,-48,48,14.998,-48,17.003,14.998,-17.003,48,14.998,-48,17.003,14.998,-17.003,17.003,14.998,48,17.003,-17.003,48,48,-17.003,17.003,48,-17.003,48,17.003,-17.003,17.003,48,-17.003,17.003,17.003,-17.003,17.003,-17.003,14.998,48,-17.003,14.998,48,-17.003,-14.998,17.003,-17.003,14.998,48,-17.003,-14.998,17.003,-17.003,-14.998,-17.003,48,-17.003,-48,48,-17.003,-48,17.003,-17.003,-17.003,48,-17.003,-48,17.003,-17.003,-17.003,17.003,-17.003,48,-17.003,48,48,-17.003,17.003,17.003,-17.003,17.003,48,-17.003,48,17.003,-17.003,17.003,17.003,-17.003,48,-48,17.003,-14.998,-48,48,-14.998,-17.003,48,-14.998,-48,17.003,-14.998,-17.003,48,-14.998,-17.003,17.003,-14.998,48,-48,14.998,48,-17.003,14.998,17.003,-17.003,14.998,48,-48,14.998,17.003,-17.003,14.998,17.003,-48,14.998,-48,17.003,17.003,-48,48,17.003,-17.003,48,17.003,-48,17.003,17.003,-17.003,48,17.003,-17.003,17.003,17.003,48,-48,-17.003,48,-17.003,-17.003,17.003,-17.003,-17.003,48,-48,-17.003,17.003,-17.003,-17.003,17.003,-48,-17.003,-17.003,14.998,-48,-48,14.998,-48,-48,14.998,-17.003,-17.003,14.998,-48,-48,14.998,-17.003,-17.003,14.998,-17.003,48,-17.003,-14.998,48,-48,-14.998,17.003,-48,-14.998,48,-17.003,-14.998,17.003,-48,-14.998,17.003,-17.003,-14.998,-17.003,14.998,-14.998,-48,14.998,-14.998,-48,14.998,14.998,-17.003,14.998,-14.998,-48,14.998,14.998,-17.003,14.998,14.998,48,-17.003,17.003,48,-48,17.003,17.003,-48,17.003,48,-17.003,17.003,17.003,-48,17.003,17.003,-17.003,17.003,-17.003,14.998,17.003,-48,14.998,17.003,-48,14.998,48,-17.003,14.998,17.003,-48,14.998,48,-17.003,14.998,48,14.998,48,-17.003,14.998,17.003,-17.003,14.998,17.003,-48,14.998,48,-17.003,14.998,17.003,-48,14.998,48,-48,14.998,48,14.998,14.998,17.003,14.998,14.998,17.003,-14.998,14.998,48,14.998,14.998,17.003,-14.998,14.998,48,-14.998,-17.003,-14.998,-17.003,-48,-14.998,-17.003,-48,-14.998,-48,-17.003,-14.998,-17.003,-48,-14.998,-48,-17.003,-14.998,-48,14.998,48,48,14.998,17.003,48,14.998,17.003,17.003,14.998,48,48,14.998,17.003,17.003,14.998,48,17.003,14.998,14.998,-48,14.998,14.998,-17.003,14.998,-14.998,-17.003,14.998,14.998,-48,14.998,-14.998,-17.003,14.998,-14.998,-48,-17.003,-14.998,14.998,-48,-14.998,14.998,-48,-14.998,-14.998,-17.003,-14.998,14.998,-48,-14.998,-14.998,-17.003,-14.998,-14.998,14.998,-14.998,-14.998,14.998,14.998,-14.998,14.998,14.998,14.998,14.998,-14.998,-14.998,14.998,14.998,14.998,14.998,-14.998,14.998,14.998,-14.998,17.003,14.998,14.998,17.003,14.998,14.998,48,14.998,-14.998,17.003,14.998,14.998,48,14.998,-14.998,48,-17.003,-14.998,48,-48,-14.998,48,-48,-14.998,17.003,-17.003,-14.998,48,-48,-14.998,17.003,-17.003,-14.998,17.003,14.998,-17.003,-48,14.998,-17.003,-17.003,14.998,-48,-17.003,14.998,-17.003,-48,14.998,-48,-17.003,14.998,-48,-48,14.998,-48,-14.998,14.998,-17.003,-14.998,14.998,-17.003,14.998,14.998,-48,-14.998,14.998,-17.003,14.998,14.998,-48,14.998,-48,14.998,14.998,-48,-14.998,14.998,-17.003,-14.998,14.998,-48,14.998,14.998,-17.003,-14.998,14.998,-17.003,14.998,14.998,14.998,-48,17.003,14.998,-17.003,17.003,14.998,-17.003,48,14.998,-48,17.003,14.998,-17.003,48,14.998,-48,48,-14.998,48,-48,-14.998,17.003,-48,-14.998,17.003,-17.003,-14.998,48,-48,-14.998,17.003,-17.003,-14.998,48,-17.003,-14.998,48,-14.998,-14.998,17.003,-14.998,-14.998,17.003,14.998,-14.998,48,-14.998,-14.998,17.003,14.998,-14.998,48,14.998,-48,14.998,-17.003,-48,-14.998,-17.003,-17.003,-14.998,-17.003,-48,14.998,-17.003,-17.003,-14.998,-17.003,-17.003,14.998,-17.003,-14.998,48,17.003,-14.998,17.003,17.003,-14.998,17.003,48,-14.998,48,17.003,-14.998,17.003,48,-14.998,48,48,-14.998,-14.998,-17.003,-14.998,14.998,-17.003,-14.998,14.998,-48,-14.998,-14.998,-17.003,-14.998,14.998,-48,-14.998,-14.998,-48,-48,-14.998,-14.998,-48,14.998,-14.998,-17.003,14.998,-14.998,-48,-14.998,-14.998,-17.003,14.998,-14.998,-17.003,-14.998,-14.998,-14.998,-14.998,14.998,-14.998,14.998,14.998,-14.998,14.998,-14.998,-14.998,-14.998,14.998,-14.998,14.998,-14.998,-14.998,-14.998,-14.998,-14.998,14.998,48,-14.998,14.998,17.003,-14.998,-14.998,17.003,-14.998,14.998,48,-14.998,-14.998,17.003,-14.998,-14.998,48,-48,-14.998,17.003,-48,14.998,17.003,-17.003,14.998,17.003,-48,-14.998,17.003,-17.003,14.998,17.003,-17.003,-14.998,17.003,-14.998,-48,-17.003,-14.998,-17.003,-17.003,-14.998,-17.003,-48,-14.998,-48,-17.003,-14.998,-17.003,-48,-14.998,-48,-48,-14.998,-48,14.998,-14.998,-17.003,14.998,-14.998,-17.003,-14.998,-14.998,-48,14.998,-14.998,-17.003,-14.998,-14.998,-48,-14.998,-17.003,-17.003,-48,-48,-17.003,-48,-48,-17.003,-17.003,-17.003,-17.003,-48,-48,-17.003,-17.003,-17.003,-17.003,-17.003,-14.998,-17.003,48,-14.998,-17.003,17.003,-14.998,-48,17.003,-14.998,-17.003,48,-14.998,-48,17.003,-14.998,-48,48,14.998,17.003,-17.003,-14.998,17.003,-17.003,-14.998,17.003,-48,14.998,17.003,-17.003,-14.998,17.003,-48,14.998,17.003,-48,14.998,17.003,14.998,-14.998,17.003,14.998,-14.998,17.003,-14.998,14.998,17.003,14.998,-14.998,17.003,-14.998,14.998,17.003,-14.998,-17.003,-17.003,-14.998,-48,-17.003,-14.998,-48,-17.003,14.998,-17.003,-17.003,-14.998,-48,-17.003,14.998,-17.003,-17.003,14.998,14.998,17.003,48,-14.998,17.003,48,-14.998,17.003,17.003,14.998,17.003,48,-14.998,17.003,17.003,14.998,17.003,17.003,14.998,48,14.998,-14.998,48,14.998,-14.998,17.003,14.998,14.998,48,14.998,-14.998,17.003,14.998,14.998,17.003,14.998,-17.003,-17.003,17.003,-48,-17.003,17.003,-48,-17.003,48,-17.003,-17.003,17.003,-48,-17.003,48,-17.003,-17.003,48,14.998,48,-17.003,-14.998,48,-17.003,-14.998,17.003,-17.003,14.998,48,-17.003,-14.998,17.003,-17.003,14.998,17.003,-17.003,-14.998,17.003,-14.998,-14.998,48,-14.998,14.998,48,-14.998,-14.998,17.003,-14.998,14.998,48,-14.998,14.998,17.003,-14.998,-48,-17.003,14.998,-48,-48,14.998,-17.003,-48,14.998,-48,-17.003,14.998,-17.003,-48,14.998,-17.003,-17.003,14.998,-14.998,17.003,17.003,-14.998,48,17.003,14.998,48,17.003,-14.998,17.003,17.003,14.998,48,17.003,14.998,17.003,17.003,14.998,14.998,-48,-14.998,14.998,-48,-14.998,14.998,-17.003,14.998,14.998,-48,-14.998,14.998,-17.003,14.998,14.998,-17.003,-48,-17.003,-17.003,-48,-48,-17.003,-17.003,-48,-17.003,-48,-17.003,-17.003,-17.003,-48,-17.003,-17.003,-17.003,-17.003,14.998,14.998,-14.998,-14.998,14.998,-14.998,-14.998,14.998,14.998,14.998,14.998,-14.998,-14.998,14.998,14.998,14.998,14.998,14.998,14.998,14.998,17.003,-14.998,14.998,17.003,-14.998,14.998,48,14.998,14.998,17.003,-14.998,14.998,48,14.998,14.998,48,14.998,-14.998,-17.003,-14.998,-14.998,-17.003,-14.998,-14.998,-48,14.998,-14.998,-17.003,-14.998,-14.998,-48,14.998,-14.998,-48,-17.003,-48,-14.998,-48,-48,-14.998,-48,-17.003,-14.998,-17.003,-48,-14.998,-48,-17.003,-14.998,-17.003,-17.003,-14.998,-17.003,-48,17.003,-48,-48,17.003,-48,-17.003,17.003,-17.003,-48,17.003,-48,-17.003,17.003,-17.003,-17.003,17.003],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[0,0,0],"radius":69.979297}}},{"uuid":"E3C0735F-408C-4D76-90DC-51003C002F6C","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[48,50,-48,48,50,-17.003,48,48,-17.003,48,50,-48,48,48,-17.003,48,48,-48,48,48,-14.998,48,50,-14.998,48,50,14.998,48,48,-14.998,48,50,14.998,48,48,14.998,48,48,17.003,48,50,17.003,48,50,48,48,48,17.003,48,50,48,48,48,48,48,50,-48,17.003,50,-48,17.003,50,-17.003,48,50,-48,17.003,50,-17.003,48,50,-17.003,48,50,-14.998,17.003,50,-14.998,17.003,50,14.998,48,50,-14.998,17.003,50,14.998,48,50,14.998,48,50,17.003,17.003,50,17.003,17.003,50,48,48,50,17.003,17.003,50,48,48,50,48,-14.998,50,-17.003,14.998,50,-17.003,14.998,50,-48,-14.998,50,-17.003,14.998,50,-48,-14.998,50,-48,-14.998,50,14.998,14.998,50,14.998,14.998,50,-14.998,-14.998,50,14.998,14.998,50,-14.998,-14.998,50,-14.998,14.998,50,48,14.998,50,17.003,-14.998,50,17.003,14.998,50,48,-14.998,50,17.003,-14.998,50,48,-48,50,-17.003,-17.003,50,-17.003,-17.003,50,-48,-48,50,-17.003,-17.003,50,-48,-48,50,-48,-48,50,14.998,-17.003,50,14.998,-17.003,50,-14.998,-48,50,14.998,-17.003,50,-14.998,-48,50,-14.998,-17.003,50,48,-17.003,50,17.003,-48,50,17.003,-17.003,50,48,-48,50,17.003,-48,50,48,17.003,50,-48,17.003,48,-48,17.003,48,-17.003,17.003,50,-48,17.003,48,-17.003,17.003,50,-17.003,-48,48,-17.003,-48,50,-17.003,-48,50,-48,-48,48,-17.003,-48,50,-48,-48,48,-48,17.003,50,-14.998,17.003,48,-14.998,17.003,48,14.998,17.003,50,-14.998,17.003,48,14.998,17.003,50,14.998,-48,48,14.998,-48,50,14.998,-48,50,-14.998,-48,48,14.998,-48,50,-14.998,-48,48,-14.998,48,50,48,17.003,50,48,17.003,48,48,48,50,48,17.003,48,48,48,48,48,17.003,50,17.003,17.003,48,17.003,17.003,48,48,17.003,50,17.003,17.003,48,48,17.003,50,48,-48,50,48,-48,50,17.003,-48,48,17.003,-48,50,48,-48,48,17.003,-48,48,48,14.998,48,48,14.998,50,48,-14.998,50,48,14.998,48,48,-14.998,50,48,-14.998,48,48,48,48,14.998,48,50,14.998,17.003,50,14.998,48,48,14.998,17.003,50,14.998,17.003,48,14.998,-17.003,48,48,-17.003,50,48,-48,50,48,-17.003,48,48,-48,50,48,-48,48,48,48,48,-17.003,48,50,-17.003,17.003,50,-17.003,48,48,-17.003,17.003,50,-17.003,17.003,48,-17.003,48,50,-48,48,48,-48,17.003,48,-48,48,50,-48,17.003,48,-48,17.003,50,-48,48,50,-14.998,48,48,-14.998,17.003,48,-14.998,48,50,-14.998,17.003,48,-14.998,17.003,50,-14.998,-14.998,48,-48,-14.998,50,-48,14.998,50,-48,-14.998,48,-48,14.998,50,-48,14.998,48,-48,48,50,17.003,48,48,17.003,17.003,48,17.003,48,50,17.003,17.003,48,17.003,17.003,50,17.003,-48,48,-48,-48,50,-48,-17.003,50,-48,-48,48,-48,-17.003,50,-48,-17.003,48,-48,14.998,50,-17.003,14.998,48,-17.003,14.998,48,-48,14.998,50,-17.003,14.998,48,-48,14.998,50,-48,14.998,50,14.998,14.998,48,14.998,14.998,48,-14.998,14.998,50,14.998,14.998,48,-14.998,14.998,50,-14.998,14.998,50,48,14.998,48,48,14.998,48,17.003,14.998,50,48,14.998,48,17.003,14.998,50,17.003,-14.998,50,-48,-14.998,48,-48,-14.998,48,-17.003,-14.998,50,-48,-14.998,48,-17.003,-14.998,50,-17.003,-14.998,50,-14.998,-14.998,48,-14.998,-14.998,48,14.998,-14.998,50,-14.998,-14.998,48,14.998,-14.998,50,14.998,-14.998,50,17.003,-14.998,48,17.003,-14.998,48,48,-14.998,50,17.003,-14.998,48,48,-14.998,50,48,14.998,50,14.998,-14.998,50,14.998,-14.998,48,14.998,14.998,50,14.998,-14.998,48,14.998,14.998,48,14.998,14.998,50,-17.003,-14.998,50,-17.003,-14.998,48,-17.003,14.998,50,-17.003,-14.998,48,-17.003,14.998,48,-17.003,14.998,48,-14.998,-14.998,48,-14.998,-14.998,50,-14.998,14.998,48,-14.998,-14.998,50,-14.998,14.998,50,-14.998,14.998,48,17.003,-14.998,48,17.003,-14.998,50,17.003,14.998,48,17.003,-14.998,50,17.003,14.998,50,17.003,-17.003,50,-17.003,-17.003,48,-17.003,-17.003,48,-48,-17.003,50,-17.003,-17.003,48,-48,-17.003,50,-48,-17.003,50,14.998,-17.003,48,14.998,-17.003,48,-14.998,-17.003,50,14.998,-17.003,48,-14.998,-17.003,50,-14.998,-17.003,50,48,-17.003,48,48,-17.003,48,17.003,-17.003,50,48,-17.003,48,17.003,-17.003,50,17.003,-17.003,50,14.998,-48,50,14.998,-48,48,14.998,-17.003,50,14.998,-48,48,14.998,-17.003,48,14.998,-17.003,50,-17.003,-48,50,-17.003,-48,48,-17.003,-17.003,50,-17.003,-48,48,-17.003,-17.003,48,-17.003,-17.003,48,-14.998,-48,48,-14.998,-48,50,-14.998,-17.003,48,-14.998,-48,50,-14.998,-17.003,50,-14.998,-17.003,48,17.003,-48,48,17.003,-48,50,17.003,-17.003,48,17.003,-48,50,17.003,-17.003,50,17.003],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[0,49,0],"radius":67.889616}}},{"uuid":"EC46E09E-F95C-417A-A03C-13913AFB027D","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[48,-17.003,48,48,-17.003,50,48,-48,50,48,-17.003,48,48,-48,50,48,-48,48,14.998,14.998,48,-14.998,14.998,48,-14.998,14.998,50,14.998,14.998,48,-14.998,14.998,50,14.998,14.998,50,14.998,-14.998,50,-14.998,-14.998,50,-14.998,-14.998,48,14.998,-14.998,50,-14.998,-14.998,48,14.998,-14.998,48,14.998,-17.003,48,-14.998,-17.003,48,-14.998,-17.003,50,14.998,-17.003,48,-14.998,-17.003,50,14.998,-17.003,50,-17.003,48,50,-17.003,17.003,50,-17.003,17.003,48,-17.003,48,50,-17.003,17.003,48,-17.003,48,48,-17.003,14.998,48,-17.003,14.998,50,-17.003,-14.998,50,-17.003,14.998,48,-17.003,-14.998,50,-17.003,-14.998,48,-17.003,-17.003,48,-17.003,-17.003,50,-17.003,-48,50,-17.003,-17.003,48,-17.003,-48,50,-17.003,-48,48,-17.003,17.003,50,-48,17.003,50,-48,17.003,48,-17.003,17.003,50,-48,17.003,48,-17.003,17.003,48,-48,48,50,-48,48,48,-48,17.003,48,-48,48,50,-48,17.003,48,-48,17.003,50,-17.003,14.998,48,-48,14.998,48,-48,14.998,50,-17.003,14.998,48,-48,14.998,50,-17.003,14.998,50,-48,14.998,50,-48,14.998,48,-48,-14.998,48,-48,14.998,50,-48,-14.998,48,-48,-14.998,50,-17.003,-14.998,50,-48,-14.998,50,-48,-14.998,48,-17.003,-14.998,50,-48,-14.998,48,-17.003,-14.998,48,-17.003,-17.003,48,-48,-17.003,48,-48,-17.003,50,-17.003,-17.003,48,-48,-17.003,50,-17.003,-17.003,50,-48,-17.003,50,-48,-17.003,48,-48,-48,48,-48,-17.003,50,-48,-48,48,-48,-48,50,48,48,50,17.003,48,50,17.003,17.003,50,48,48,50,17.003,17.003,50,48,17.003,50,48,14.998,50,17.003,14.998,50,17.003,-14.998,50,48,14.998,50,17.003,-14.998,50,48,-14.998,50,48,-17.003,50,17.003,-17.003,50,17.003,-48,50,48,-17.003,50,17.003,-48,50,48,-48,50,-14.998,17.003,50,14.998,17.003,50,14.998,48,50,-14.998,17.003,50,14.998,48,50,-14.998,48,50,-14.998,-14.998,50,14.998,-14.998,50,14.998,14.998,50,-14.998,-14.998,50,14.998,14.998,50,-14.998,14.998,50,14.998,-48,50,14.998,-17.003,50,-14.998,-17.003,50,14.998,-48,50,-14.998,-17.003,50,-14.998,-48,50,-48,17.003,50,-17.003,17.003,50,-17.003,48,50,-48,17.003,50,-17.003,48,50,-48,48,50,-48,-14.998,50,-17.003,-14.998,50,-17.003,14.998,50,-48,-14.998,50,-17.003,14.998,50,-48,14.998,50,-17.003,-48,50,-17.003,-17.003,50,-48,-17.003,50,-17.003,-48,50,-48,-17.003,50,-48,-48,50,17.003,-48,50,17.003,-48,48,48,-48,48,17.003,-48,50,48,-48,48,48,-48,50,-14.998,-48,50,-14.998,-48,48,14.998,-48,48,-14.998,-48,50,14.998,-48,48,14.998,-48,50,-48,-48,50,-48,-48,48,-17.003,-48,48,-48,-48,50,-17.003,-48,48,-17.003,-48,50,48,48,50,48,48,48,17.003,48,48,48,48,50,17.003,48,48,17.003,48,50,14.998,48,50,14.998,48,48,-14.998,48,48,14.998,48,50,-14.998,48,48,-14.998,48,50,-17.003,48,50,-17.003,48,48,-48,48,48,-17.003,48,50,-48,48,48,-48,48,50,17.003,48,48,17.003,17.003,48,17.003,17.003,50,17.003,48,48,17.003,17.003,50,17.003,48,50,17.003,14.998,50,17.003,14.998,48,17.003,-14.998,48,17.003,14.998,50,17.003,-14.998,48,17.003,-14.998,50,17.003,-17.003,50,17.003,-17.003,48,17.003,-48,48,17.003,-17.003,50,17.003,-48,48,17.003,-48,50,48,17.003,48,48,17.003,50,17.003,17.003,50,48,17.003,48,17.003,17.003,50,17.003,17.003,48,48,14.998,50,48,14.998,48,17.003,14.998,48,48,14.998,50,17.003,14.998,48,17.003,14.998,50,48,-14.998,48,48,-14.998,50,17.003,-14.998,50,48,-14.998,48,17.003,-14.998,50,17.003,-14.998,48,48,-17.003,50,48,-17.003,48,17.003,-17.003,48,48,-17.003,50,17.003,-17.003,48,17.003,-17.003,50,14.998,48,50,14.998,17.003,50,14.998,17.003,48,14.998,48,50,14.998,17.003,48,14.998,48,48,14.998,14.998,48,14.998,14.998,50,14.998,-14.998,50,14.998,14.998,48,14.998,-14.998,50,14.998,-14.998,48,48,48,48,48,48,50,48,17.003,50,48,48,48,48,17.003,50,48,17.003,48,14.998,-17.003,48,14.998,-17.003,50,14.998,-48,50,14.998,-17.003,48,14.998,-48,50,14.998,-48,48,48,14.998,48,48,14.998,50,48,-14.998,50,48,14.998,48,48,-14.998,50,48,-14.998,48,-14.998,48,48,-14.998,17.003,48,-14.998,17.003,50,-14.998,48,48,-14.998,17.003,50,-14.998,48,50,-14.998,14.998,50,-14.998,14.998,48,-14.998,-14.998,48,-14.998,14.998,50,-14.998,-14.998,48,-14.998,-14.998,50,-14.998,-17.003,50,-14.998,-17.003,48,-14.998,-48,48,-14.998,-17.003,50,-14.998,-48,48,-14.998,-48,50,14.998,17.003,50,-14.998,17.003,50,-14.998,17.003,48,14.998,17.003,50,-14.998,17.003,48,14.998,17.003,48],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0],"normalized":false}},"boundingSphere":{"center":[0,0,49],"radius":67.889616}}},{"uuid":"DDF30826-3212-414A-AE6F-D4A934F40A61","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[48,-48,-17.003,48,-50,-17.003,48,-50,-48,48,-48,-17.003,48,-50,-48,48,-48,-48,48,-48,14.998,48,-50,14.998,48,-50,-14.998,48,-48,14.998,48,-50,-14.998,48,-48,-14.998,48,-50,48,48,-50,17.003,48,-48,17.003,48,-50,48,48,-48,17.003,48,-48,48,-17.003,-50,17.003,-48,-50,17.003,-48,-48,17.003,-17.003,-50,17.003,-48,-48,17.003,-17.003,-48,17.003,48,-48,48,17.003,-48,48,17.003,-50,48,48,-48,48,17.003,-50,48,48,-50,48,-48,-50,-17.003,-48,-48,-17.003,-48,-48,-48,-48,-50,-17.003,-48,-48,-48,-48,-50,-48,-48,-50,14.998,-48,-48,14.998,-48,-48,-14.998,-48,-50,14.998,-48,-48,-14.998,-48,-50,-14.998,-48,-48,48,-48,-48,17.003,-48,-50,17.003,-48,-48,48,-48,-50,17.003,-48,-50,48,14.998,-50,48,14.998,-48,48,-14.998,-48,48,14.998,-50,48,-14.998,-48,48,-14.998,-50,48,-17.003,-50,48,-17.003,-48,48,-48,-48,48,-17.003,-50,48,-48,-48,48,-48,-50,48,48,-50,-17.003,17.003,-50,-17.003,17.003,-50,-48,48,-50,-17.003,17.003,-50,-48,48,-50,-48,-17.003,-50,-48,-48,-50,-48,-48,-48,-48,-17.003,-50,-48,-48,-48,-48,-17.003,-48,-48,48,-50,14.998,17.003,-50,14.998,17.003,-50,-14.998,48,-50,14.998,17.003,-50,-14.998,48,-50,-14.998,48,-50,48,17.003,-50,48,17.003,-50,17.003,48,-50,48,17.003,-50,17.003,48,-50,17.003,14.998,-50,-48,14.998,-50,-17.003,-14.998,-50,-17.003,14.998,-50,-48,-14.998,-50,-17.003,-14.998,-50,-48,-14.998,-50,-14.998,14.998,-50,-14.998,14.998,-50,14.998,-14.998,-50,-14.998,14.998,-50,14.998,-14.998,-50,14.998,-14.998,-50,17.003,14.998,-50,17.003,14.998,-50,48,-14.998,-50,17.003,14.998,-50,48,-14.998,-50,48,-17.003,-50,-48,-17.003,-50,-17.003,-48,-50,-17.003,-17.003,-50,-48,-48,-50,-17.003,-48,-50,-48,-48,-50,-14.998,-17.003,-50,-14.998,-17.003,-50,14.998,-48,-50,-14.998,-17.003,-50,14.998,-48,-50,14.998,-48,-50,17.003,-17.003,-50,17.003,-17.003,-50,48,-48,-50,17.003,-17.003,-50,48,-48,-50,48,17.003,-48,-48,17.003,-50,-48,17.003,-50,-17.003,17.003,-48,-48,17.003,-50,-17.003,17.003,-48,-17.003,17.003,-48,-14.998,17.003,-50,-14.998,17.003,-50,14.998,17.003,-48,-14.998,17.003,-50,14.998,17.003,-48,14.998,17.003,-48,17.003,17.003,-50,17.003,17.003,-50,48,17.003,-48,17.003,17.003,-50,48,17.003,-48,48,48,-50,14.998,48,-48,14.998,17.003,-48,14.998,48,-50,14.998,17.003,-48,14.998,17.003,-50,14.998,48,-50,-17.003,48,-48,-17.003,17.003,-48,-17.003,48,-50,-17.003,17.003,-48,-17.003,17.003,-50,-17.003,48,-48,-14.998,48,-50,-14.998,17.003,-50,-14.998,48,-48,-14.998,17.003,-50,-14.998,17.003,-48,-14.998,48,-48,17.003,48,-50,17.003,17.003,-50,17.003,48,-48,17.003,17.003,-50,17.003,17.003,-48,17.003,14.998,-48,-17.003,14.998,-50,-17.003,14.998,-50,-48,14.998,-48,-17.003,14.998,-50,-48,14.998,-48,-48,14.998,-48,14.998,14.998,-50,14.998,14.998,-50,-14.998,14.998,-48,14.998,14.998,-50,-14.998,14.998,-48,-14.998,14.998,-48,48,14.998,-50,48,14.998,-50,17.003,14.998,-48,48,14.998,-50,17.003,14.998,-48,17.003,-14.998,-48,-48,-14.998,-50,-48,-14.998,-50,-17.003,-14.998,-48,-48,-14.998,-50,-17.003,-14.998,-48,-17.003,-14.998,-48,-14.998,-14.998,-50,-14.998,-14.998,-50,14.998,-14.998,-48,-14.998,-14.998,-50,14.998,-14.998,-48,14.998,-14.998,-48,17.003,-14.998,-50,17.003,-14.998,-50,48,-14.998,-48,17.003,-14.998,-50,48,-14.998,-48,48,14.998,-48,14.998,-14.998,-48,14.998,-14.998,-50,14.998,14.998,-48,14.998,-14.998,-50,14.998,14.998,-50,14.998,14.998,-48,-17.003,-14.998,-48,-17.003,-14.998,-50,-17.003,14.998,-48,-17.003,-14.998,-50,-17.003,14.998,-50,-17.003,14.998,-50,-14.998,-14.998,-50,-14.998,-14.998,-48,-14.998,14.998,-50,-14.998,-14.998,-48,-14.998,14.998,-48,-14.998,14.998,-50,17.003,-14.998,-50,17.003,-14.998,-48,17.003,14.998,-50,17.003,-14.998,-48,17.003,14.998,-48,17.003,-17.003,-48,-17.003,-17.003,-50,-17.003,-17.003,-50,-48,-17.003,-48,-17.003,-17.003,-50,-48,-17.003,-48,-48,-17.003,-48,14.998,-17.003,-50,14.998,-17.003,-50,-14.998,-17.003,-48,14.998,-17.003,-50,-14.998,-17.003,-48,-14.998,-17.003,-48,48,-17.003,-50,48,-17.003,-50,17.003,-17.003,-48,48,-17.003,-50,17.003,-17.003,-48,17.003,-17.003,-48,14.998,-48,-48,14.998,-48,-50,14.998,-17.003,-48,14.998,-48,-50,14.998,-17.003,-50,14.998,-17.003,-48,-17.003,-48,-48,-17.003,-48,-50,-17.003,-17.003,-48,-17.003,-48,-50,-17.003,-17.003,-50,-17.003,-17.003,-50,-14.998,-48,-50,-14.998,-48,-48,-14.998,-17.003,-50,-14.998,-48,-48,-14.998,-17.003,-48,-14.998,48,-48,-48,48,-50,-48,17.003,-50,-48,48,-48,-48,17.003,-50,-48,17.003,-48,-48,14.998,-50,-48,-14.998,-50,-48,-14.998,-48,-48,14.998,-50,-48,-14.998,-48,-48,14.998,-48,-48],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[0,-49,0],"radius":67.889616}}},{"uuid":"EC9F6624-BE56-4E87-831F-9AAAF10F7119","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[48,48,-50,48,48,-48,48,17.003,-48,48,48,-50,48,17.003,-48,48,17.003,-50,48,14.998,-50,48,14.998,-48,48,-14.998,-48,48,14.998,-50,48,-14.998,-48,48,-14.998,-50,48,-17.003,-50,48,-17.003,-48,48,-48,-48,48,-17.003,-50,48,-48,-48,48,-48,-50,-48,48,-48,-48,48,-50,-48,17.003,-50,-48,48,-48,-48,17.003,-50,-48,17.003,-48,-48,14.998,-48,-48,14.998,-50,-48,-14.998,-50,-48,14.998,-48,-48,-14.998,-50,-48,-14.998,-48,-48,-17.003,-48,-48,-17.003,-50,-48,-48,-50,-48,-17.003,-48,-48,-48,-50,-48,-48,-48,48,17.003,-50,17.003,17.003,-50,17.003,48,-50,48,17.003,-50,17.003,48,-50,48,48,-50,48,-14.998,-50,17.003,-14.998,-50,17.003,14.998,-50,48,-14.998,-50,17.003,14.998,-50,48,14.998,-50,48,-48,-50,17.003,-48,-50,17.003,-17.003,-50,48,-48,-50,17.003,-17.003,-50,48,-17.003,-50,14.998,48,-50,14.998,17.003,-50,-14.998,17.003,-50,14.998,48,-50,-14.998,17.003,-50,-14.998,48,-50,-14.998,14.998,-50,14.998,14.998,-50,14.998,-14.998,-50,-14.998,14.998,-50,14.998,-14.998,-50,-14.998,-14.998,-50,-14.998,-17.003,-50,14.998,-17.003,-50,14.998,-48,-50,-14.998,-17.003,-50,14.998,-48,-50,-14.998,-48,-50,-17.003,48,-50,-17.003,17.003,-50,-48,17.003,-50,-17.003,48,-50,-48,17.003,-50,-48,48,-50,-48,14.998,-50,-17.003,14.998,-50,-17.003,-14.998,-50,-48,14.998,-50,-17.003,-14.998,-50,-48,-14.998,-50,-48,-17.003,-50,-17.003,-17.003,-50,-17.003,-48,-50,-48,-17.003,-50,-17.003,-48,-50,-48,-48,-50,17.003,-48,-48,17.003,-48,-50,48,-48,-50,17.003,-48,-48,48,-48,-50,48,-48,-48,-14.998,-48,-48,-14.998,-48,-50,14.998,-48,-50,-14.998,-48,-48,14.998,-48,-50,14.998,-48,-48,-48,-48,-48,-48,-48,-50,-17.003,-48,-50,-48,-48,-48,-17.003,-48,-50,-17.003,-48,-48,48,48,-48,48,48,-50,17.003,48,-50,48,48,-48,17.003,48,-50,17.003,48,-48,14.998,48,-48,14.998,48,-50,-14.998,48,-50,14.998,48,-48,-14.998,48,-50,-14.998,48,-48,-17.003,48,-48,-17.003,48,-50,-48,48,-50,-17.003,48,-48,-48,48,-50,-48,48,-48,17.003,48,-50,17.003,17.003,-50,17.003,17.003,-48,17.003,48,-50,17.003,17.003,-48,17.003,48,-48,17.003,14.998,-48,17.003,14.998,-50,17.003,-14.998,-50,17.003,14.998,-48,17.003,-14.998,-50,17.003,-14.998,-48,17.003,-17.003,-48,17.003,-17.003,-50,17.003,-48,-50,17.003,-17.003,-48,17.003,-48,-50,17.003,-48,-48,48,17.003,-50,48,17.003,-48,17.003,17.003,-48,48,17.003,-50,17.003,17.003,-48,17.003,17.003,-50,48,14.998,-48,48,14.998,-50,17.003,14.998,-50,48,14.998,-48,17.003,14.998,-50,17.003,14.998,-48,48,-14.998,-50,48,-14.998,-48,17.003,-14.998,-48,48,-14.998,-50,17.003,-14.998,-48,17.003,-14.998,-50,48,-17.003,-48,48,-17.003,-50,17.003,-17.003,-50,48,-17.003,-48,17.003,-17.003,-50,17.003,-17.003,-48,14.998,48,-48,14.998,17.003,-48,14.998,17.003,-50,14.998,48,-48,14.998,17.003,-50,14.998,48,-50,14.998,14.998,-50,14.998,14.998,-48,14.998,-14.998,-48,14.998,14.998,-50,14.998,-14.998,-48,14.998,-14.998,-50,14.998,-17.003,-50,14.998,-17.003,-48,14.998,-48,-48,14.998,-17.003,-50,14.998,-48,-48,14.998,-48,-50,-14.998,48,-50,-14.998,17.003,-50,-14.998,17.003,-48,-14.998,48,-50,-14.998,17.003,-48,-14.998,48,-48,-14.998,14.998,-48,-14.998,14.998,-50,-14.998,-14.998,-50,-14.998,14.998,-48,-14.998,-14.998,-50,-14.998,-14.998,-48,-14.998,-17.003,-48,-14.998,-17.003,-50,-14.998,-48,-50,-14.998,-17.003,-48,-14.998,-48,-50,-14.998,-48,-48,14.998,17.003,-48,-14.998,17.003,-48,-14.998,17.003,-50,14.998,17.003,-48,-14.998,17.003,-50,14.998,17.003,-50,14.998,14.998,-50,-14.998,14.998,-50,-14.998,14.998,-48,14.998,14.998,-50,-14.998,14.998,-48,14.998,14.998,-48,14.998,-14.998,-48,-14.998,-14.998,-48,-14.998,-14.998,-50,14.998,-14.998,-48,-14.998,-14.998,-50,14.998,-14.998,-50,14.998,-17.003,-50,-14.998,-17.003,-50,-14.998,-17.003,-48,14.998,-17.003,-50,-14.998,-17.003,-48,14.998,-17.003,-48,-17.003,48,-48,-17.003,17.003,-48,-17.003,17.003,-50,-17.003,48,-48,-17.003,17.003,-50,-17.003,48,-50,-17.003,14.998,-50,-17.003,14.998,-48,-17.003,-14.998,-48,-17.003,14.998,-50,-17.003,-14.998,-48,-17.003,-14.998,-50,-17.003,-17.003,-50,-17.003,-17.003,-48,-17.003,-48,-48,-17.003,-17.003,-50,-17.003,-48,-48,-17.003,-48,-50,-17.003,17.003,-48,-48,17.003,-48,-48,17.003,-50,-17.003,17.003,-48,-48,17.003,-50,-17.003,17.003,-50,-17.003,14.998,-50,-48,14.998,-50,-48,14.998,-48,-17.003,14.998,-50,-48,14.998,-48,-17.003,14.998,-48,-17.003,-14.998,-48,-48,-14.998,-48,-48,-14.998,-50,-17.003,-14.998,-48,-48,-14.998,-50,-17.003,-14.998,-50,-17.003,-17.003,-50,-48,-17.003,-50,-48,-17.003,-48,-17.003,-17.003,-50,-48,-17.003,-48,-17.003,-17.003,-48],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0],"normalized":false}},"boundingSphere":{"center":[0,0,-49],"radius":67.889616}}},{"uuid":"03190EC5-B85B-4C16-A8B4-2BDFAA696DBF","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[50,48,-48,48,48,-48,48,48,-17.003,50,48,-48,48,48,-17.003,50,48,-17.003,50,48,-14.998,48,48,-14.998,48,48,14.998,50,48,-14.998,48,48,14.998,50,48,14.998,50,48,17.003,48,48,17.003,48,48,48,50,48,17.003,48,48,48,50,48,48,50,-48,-17.003,48,-48,-17.003,48,-48,-48,50,-48,-17.003,48,-48,-48,50,-48,-48,50,-48,14.998,48,-48,14.998,48,-48,-14.998,50,-48,14.998,48,-48,-14.998,50,-48,-14.998,50,-48,48,48,-48,48,48,-48,17.003,50,-48,48,48,-48,17.003,50,-48,17.003,50,48,-17.003,50,17.003,-17.003,50,17.003,-48,50,48,-17.003,50,17.003,-48,50,48,-48,50,48,14.998,50,17.003,14.998,50,17.003,-14.998,50,48,14.998,50,17.003,-14.998,50,48,-14.998,50,48,48,50,17.003,48,50,17.003,17.003,50,48,48,50,17.003,17.003,50,48,17.003,50,14.998,-48,50,14.998,-17.003,50,-14.998,-17.003,50,14.998,-48,50,-14.998,-17.003,50,-14.998,-48,50,-14.998,-14.998,50,14.998,-14.998,50,14.998,14.998,50,-14.998,-14.998,50,14.998,14.998,50,-14.998,14.998,50,-14.998,17.003,50,14.998,17.003,50,14.998,48,50,-14.998,17.003,50,14.998,48,50,-14.998,48,50,-17.003,-48,50,-17.003,-17.003,50,-48,-17.003,50,-17.003,-48,50,-48,-17.003,50,-48,-48,50,-48,-14.998,50,-17.003,-14.998,50,-17.003,14.998,50,-48,-14.998,50,-17.003,14.998,50,-48,14.998,50,-48,17.003,50,-17.003,17.003,50,-17.003,48,50,-48,17.003,50,-17.003,48,50,-48,48,50,48,48,48,48,48,48,17.003,48,50,48,48,48,17.003,48,50,17.003,48,50,14.998,48,48,14.998,48,48,-14.998,48,50,14.998,48,48,-14.998,48,50,-14.998,48,50,-17.003,48,48,-17.003,48,48,-48,48,50,-17.003,48,48,-48,48,50,-48,48,50,17.003,-48,48,17.003,-48,48,48,-48,50,17.003,-48,48,48,-48,50,48,-48,50,-14.998,-48,48,-14.998,-48,48,14.998,-48,50,-14.998,-48,48,14.998,-48,50,14.998,-48,50,-48,-48,48,-48,-48,48,-17.003,-48,50,-48,-48,48,-17.003,-48,50,-17.003,-48,50,17.003,-48,50,17.003,-17.003,48,17.003,-17.003,50,17.003,-48,48,17.003,-17.003,48,17.003,-48,48,17.003,-14.998,50,17.003,-14.998,50,17.003,14.998,48,17.003,-14.998,50,17.003,14.998,48,17.003,14.998,48,17.003,17.003,50,17.003,17.003,50,17.003,48,48,17.003,17.003,50,17.003,48,48,17.003,48,50,48,14.998,48,48,14.998,48,17.003,14.998,50,48,14.998,48,17.003,14.998,50,17.003,14.998,50,48,-17.003,48,48,-17.003,48,17.003,-17.003,50,48,-17.003,48,17.003,-17.003,50,17.003,-17.003,48,17.003,-14.998,48,48,-14.998,50,48,-14.998,48,17.003,-14.998,50,48,-14.998,50,17.003,-14.998,48,17.003,17.003,48,48,17.003,50,48,17.003,48,17.003,17.003,50,48,17.003,50,17.003,17.003,48,14.998,-17.003,50,14.998,-17.003,50,14.998,-48,48,14.998,-17.003,50,14.998,-48,48,14.998,-48,48,14.998,14.998,50,14.998,14.998,50,14.998,-14.998,48,14.998,14.998,50,14.998,-14.998,48,14.998,-14.998,50,14.998,48,50,14.998,17.003,48,14.998,17.003,50,14.998,48,48,14.998,17.003,48,14.998,48,50,-14.998,-48,50,-14.998,-17.003,48,-14.998,-17.003,50,-14.998,-48,48,-14.998,-17.003,48,-14.998,-48,48,-14.998,-14.998,50,-14.998,-14.998,50,-14.998,14.998,48,-14.998,-14.998,50,-14.998,14.998,48,-14.998,14.998,48,-14.998,17.003,50,-14.998,17.003,50,-14.998,48,48,-14.998,17.003,50,-14.998,48,48,-14.998,48,48,14.998,14.998,48,-14.998,14.998,50,-14.998,14.998,48,14.998,14.998,50,-14.998,14.998,50,14.998,14.998,48,14.998,-17.003,48,-14.998,-17.003,50,-14.998,-17.003,48,14.998,-17.003,50,-14.998,-17.003,50,14.998,-17.003,48,-14.998,-14.998,48,14.998,-14.998,50,14.998,-14.998,48,-14.998,-14.998,50,14.998,-14.998,50,-14.998,-14.998,48,-14.998,17.003,48,14.998,17.003,50,14.998,17.003,48,-14.998,17.003,50,14.998,17.003,50,-14.998,17.003,48,-17.003,-17.003,50,-17.003,-17.003,50,-17.003,-48,48,-17.003,-17.003,50,-17.003,-48,48,-17.003,-48,48,-17.003,14.998,50,-17.003,14.998,50,-17.003,-14.998,48,-17.003,14.998,50,-17.003,-14.998,48,-17.003,-14.998,50,-17.003,48,50,-17.003,17.003,48,-17.003,17.003,50,-17.003,48,48,-17.003,17.003,48,-17.003,48,48,-17.003,14.998,48,-48,14.998,50,-48,14.998,48,-17.003,14.998,50,-48,14.998,50,-17.003,14.998,48,-17.003,-17.003,48,-48,-17.003,50,-48,-17.003,48,-17.003,-17.003,50,-48,-17.003,50,-17.003,-17.003,50,-48,-14.998,48,-48,-14.998,48,-17.003,-14.998,50,-48,-14.998,48,-17.003,-14.998,50,-17.003,-14.998,50,-48,17.003,48,-48,17.003,48,-17.003,17.003,50,-48,17.003,48,-17.003,17.003,50,-17.003,17.003],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[49,0,0],"radius":67.889616}}}],"materials":[{"uuid":"3194B1AB-D413-4BE2-8EC4-31CE6973D8B6","type":"MeshLambertMaterial","color":14628663,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"24556FD5-FDD0-4FA0-93DF-02853E367FC0","type":"MeshLambertMaterial","color":14211288,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"9074B003-7A20-4BCF-82BA-F0E7545A3541","type":"MeshLambertMaterial","color":16777215,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"7C22D87C-09A6-45B4-8455-BFC0C6A25F9F","type":"MeshLambertMaterial","color":2339107,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"B5CD65C8-1354-4734-A342-F1BAF67C73FE","type":"MeshLambertMaterial","color":16773632,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"4E9955C5-4C50-4A8F-9E83-67D4444155EB","type":"MeshLambertMaterial","color":3839213,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"FE12A3F5-B9CD-474C-873D-80384FF3F1B5","type":"MeshLambertMaterial","color":16743976,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"34E8693C-3BA7-4C92-AA5E-A61B0570A093","type":"Group","name":"magic","matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"E490C4FA-9C13-47C2-8B0D-7FB0DC74D35B","type":"Mesh","name":"group_0_40919","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"D6042B2F-9729-406A-A02A-8F11F4FDC0D5","material":"3194B1AB-D413-4BE2-8EC4-31CE6973D8B6"},{"uuid":"E54B22CE-2CB4-4682-84AD-4715EFC8E106","type":"Mesh","name":"group_0_2829873","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"39D018C8-165C-405B-A020-97E2556C3F6E","material":"24556FD5-FDD0-4FA0-93DF-02853E367FC0"},{"uuid":"FFCF4D88-D47D-450F-A3B1-A478A0493C9E","type":"Mesh","name":"group_0_4634441","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"E3C0735F-408C-4D76-90DC-51003C002F6C","material":"9074B003-7A20-4BCF-82BA-F0E7545A3541"},{"uuid":"0D1AF4CB-C96A-46F1-8763-A9B644C4FDEC","type":"Mesh","name":"group_0_15277357","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"EC46E09E-F95C-417A-A03C-13913AFB027D","material":"7C22D87C-09A6-45B4-8455-BFC0C6A25F9F"},{"uuid":"08A7D745-BEC6-467F-A052-BEEB3DEF4601","type":"Mesh","name":"group_0_16089887","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"DDF30826-3212-414A-AE6F-D4A934F40A61","material":"B5CD65C8-1354-4734-A342-F1BAF67C73FE"},{"uuid":"4F8580B6-968C-4517-9B97-9A93D0D99CD3","type":"Mesh","name":"group_0_16448250","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"EC9F6624-BE56-4E87-831F-9AAAF10F7119","material":"4E9955C5-4C50-4A8F-9E83-67D4444155EB"},{"uuid":"542E1F35-800B-4ACD-AEFB-2AB314CE3282","type":"Mesh","name":"group_0_16768282","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"03190EC5-B85B-4C16-A8B4-2BDFAA696DBF","material":"FE12A3F5-B9CD-474C-873D-80384FF3F1B5"}]}}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"AFC7ACE7-52E9-4079-B0BE-500CC3BC0D33","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[30.757,-54.957001,-22.347,28.871,-54.957001,-21.388,28.871,-55.056999,-21.388,30.757,-54.957001,-22.347,28.871,-55.056999,-21.388,30.757,-55.056999,-22.347,28.871,-54.957001,-21.388,26.780001,-54.957001,-21.056999,26.780001,-55.056999,-21.056999,28.871,-54.957001,-21.388,26.780001,-55.056999,-21.056999,28.871,-55.056999,-21.388,26.780001,-54.957001,-21.056999,24.688999,-54.957001,-21.388,24.688999,-55.056999,-21.388,26.780001,-54.957001,-21.056999,24.688999,-55.056999,-21.388,26.780001,-55.056999,-21.056999,24.688999,-54.957001,-21.388,22.802999,-54.957001,-22.347,22.802999,-55.056999,-22.347,24.688999,-54.957001,-21.388,22.802999,-55.056999,-22.347,24.688999,-55.056999,-21.388,21.306999,-55.056999,-23.84,22.802999,-55.056999,-22.347,21.306999,-54.957001,-23.84,22.802999,-54.957001,-22.347,21.306999,-54.957001,-23.84,22.802999,-55.056999,-22.347,21.306999,-54.957001,-23.84,20.346001,-54.957001,-25.722,20.346001,-55.056999,-25.722,21.306999,-54.957001,-23.84,20.346001,-55.056999,-25.722,21.306999,-55.056999,-23.84,20.346001,-54.957001,-25.722,20.014,-54.957001,-27.809,20.014,-55.056999,-27.809,20.346001,-54.957001,-25.722,20.014,-55.056999,-27.809,20.346001,-55.056999,-25.722,20.014,-55.056999,-27.809,20.014,-54.957001,-27.809,20.346001,-54.957001,-29.895,20.014,-55.056999,-27.809,20.346001,-54.957001,-29.895,20.346001,-55.056999,-29.895,20.346001,-54.957001,-29.895,21.306999,-54.957001,-31.777,21.306999,-55.056999,-31.777,20.346001,-54.957001,-29.895,21.306999,-55.056999,-31.777,20.346001,-55.056999,-29.895,28.871,-54.957001,-34.229,28.871,-55.056999,-34.229,26.780001,-55.056999,-34.560001,28.871,-54.957001,-34.229,26.780001,-55.056999,-34.560001,26.780001,-54.957001,-34.560001,30.757,-54.957001,-33.27,30.757,-55.056999,-33.27,28.871,-55.056999,-34.229,30.757,-54.957001,-33.27,28.871,-55.056999,-34.229,28.871,-54.957001,-34.229,30.757,-55.056999,-33.27,30.757,-54.957001,-33.27,31.2603,-54.957001,-32.768002,21.306999,-54.957001,-31.777,22.802999,-54.957001,-33.27,21.306999,-55.056999,-31.777,22.802999,-55.056999,-33.27,21.306999,-55.056999,-31.777,22.802999,-54.957001,-33.27,24.688999,-54.957001,-34.229,24.688999,-55.056999,-34.229,22.802999,-55.056999,-33.27,24.688999,-54.957001,-34.229,22.802999,-55.056999,-33.27,22.802999,-54.957001,-33.27,26.780001,-55.056999,-34.560001,24.688999,-55.056999,-34.229,24.688999,-54.957001,-34.229,26.780001,-55.056999,-34.560001,24.688999,-54.957001,-34.229,26.780001,-54.957001,-34.560001,20.346001,-55.056999,-29.895,23.108999,-55.056999,-26.764,20.014,-55.056999,-27.809,20.014,-55.056999,-27.809,22.426001,-55.056999,-25.827,20.346001,-55.056999,-25.722,21.306999,-55.056999,-31.777,23.632999,-55.056999,-27.031,20.346001,-55.056999,-29.895,22.334,-55.056999,-25.247,22.426001,-55.056999,-24.667999,20.346001,-55.056999,-25.722,21.306999,-55.056999,-23.84,20.346001,-55.056999,-25.722,22.426001,-55.056999,-24.667999,21.306999,-55.056999,-23.84,22.693001,-55.056999,-24.145,22.802999,-55.056999,-22.347,32.254002,-55.056999,-31.777,25.733999,-55.056999,-26.35,30.757,-55.056999,-33.27,33.546001,-55.056999,-27.809,26.000999,-55.056999,-25.827,33.215,-55.056999,-29.895,33.215,-55.056999,-29.895,25.733999,-55.056999,-26.35,32.254002,-55.056999,-31.777,24.794001,-55.056999,-27.031,24.576,-55.056999,-27.0655,24.688999,-55.056999,-34.229,22.802999,-55.056999,-33.27,24.688999,-55.056999,-34.229,24.212999,-55.056999,-27.122999,21.306999,-55.056999,-31.777,24.212999,-55.056999,-27.122999,23.632999,-55.056999,-27.031,23.108999,-55.056999,-26.764,20.346001,-55.056999,-29.895,23.632999,-55.056999,-27.031,22.693001,-55.056999,-26.35,20.014,-55.056999,-27.809,23.108999,-55.056999,-26.764,28.871,-55.056999,-21.388,26.000999,-55.056999,-24.667999,30.757,-55.056999,-22.347,26.000999,-55.056999,-24.667999,26.093,-55.056999,-25.247,30.757,-55.056999,-22.347,26.780001,-55.056999,-21.056999,25.733999,-55.056999,-24.145,28.871,-55.056999,-21.388,32.254002,-55.056999,-23.84,30.757,-55.056999,-22.347,26.093,-55.056999,-25.247,33.546001,-55.056999,-27.809,33.215,-55.056999,-25.722,26.000999,-55.056999,-25.827,25.733999,-55.056999,-26.35,33.215,-55.056999,-29.895,26.000999,-55.056999,-25.827,26.093,-55.056999,-25.247,26.000999,-55.056999,-25.827,33.215,-55.056999,-25.722,23.632999,-55.056999,-23.464001,22.802999,-55.056999,-22.347,23.108999,-55.056999,-23.73,22.802999,-55.056999,-22.347,23.632999,-55.056999,-23.464001,24.688999,-55.056999,-21.388,24.688999,-55.056999,-21.388,24.212999,-55.056999,-23.372,24.576,-55.056999,-23.429501,24.576,-55.056999,-23.429501,24.794001,-55.056999,-23.464001,24.688999,-55.056999,-21.388,25.733999,-55.056999,-24.145,26.780001,-55.056999,-21.056999,25.318001,-55.056999,-23.73,24.688999,-55.056999,-21.388,24.794001,-55.056999,-23.464001,26.780001,-55.056999,-21.056999,25.318001,-55.056999,-26.764,30.757,-55.056999,-33.27,25.733999,-55.056999,-26.35,24.576,-55.056999,-27.0655,24.212999,-55.056999,-27.122999,24.688999,-55.056999,-34.229,33.215,-55.056999,-25.722,32.254002,-55.056999,-23.84,26.093,-55.056999,-25.247,26.000999,-55.056999,-24.667999,28.871,-55.056999,-21.388,25.733999,-55.056999,-24.145,25.318001,-55.056999,-23.73,26.780001,-55.056999,-21.056999,24.794001,-55.056999,-23.464001,21.306999,-55.056999,-31.777,22.802999,-55.056999,-33.27,24.212999,-55.056999,-27.122999,24.212999,-55.056999,-23.372,24.688999,-55.056999,-21.388,23.632999,-55.056999,-23.464001,23.108999,-55.056999,-23.73,22.802999,-55.056999,-22.347,22.693001,-55.056999,-24.145,22.693001,-55.056999,-24.145,21.306999,-55.056999,-23.84,22.426001,-55.056999,-24.667999,22.334,-55.056999,-25.247,20.346001,-55.056999,-25.722,22.426001,-55.056999,-25.827,22.426001,-55.056999,-25.827,20.014,-55.056999,-27.809,22.693001,-55.056999,-26.35,25.318001,-55.056999,-26.764,24.794001,-55.056999,-27.031,28.871,-55.056999,-34.229,30.757,-55.056999,-33.27,25.318001,-55.056999,-26.764,28.871,-55.056999,-34.229,26.780001,-55.056999,-34.560001,28.871,-55.056999,-34.229,24.794001,-55.056999,-27.031,24.688999,-55.056999,-34.229,26.780001,-55.056999,-34.560001,24.794001,-55.056999,-27.031,33.215,-54.957001,-29.895,33.215,-55.056999,-29.895,32.768002,-54.957001,-30.770399,33.546001,-54.957001,-27.809,33.546001,-55.056999,-27.809,33.215,-55.056999,-29.895,33.546001,-54.957001,-27.809,33.215,-55.056999,-29.895,33.215,-54.957001,-29.895,33.546001,-55.056999,-27.809,33.546001,-54.957001,-27.809,33.215,-55.056999,-25.722,33.215,-54.957001,-25.722,33.215,-55.056999,-25.722,33.546001,-54.957001,-27.809,33.215,-54.957001,-25.722,32.768002,-54.957001,-24.8466,33.215,-55.056999,-25.722,32.254002,-55.056999,-23.84,33.215,-55.056999,-25.722,32.768002,-54.957001,-24.8466,30.757,-55.056999,-33.27,31.2603,-54.957001,-32.768002,32.254002,-55.056999,-31.777,32.254002,-54.957001,-31.777,32.254002,-55.056999,-31.777,31.2603,-54.957001,-32.768002,32.254002,-54.957001,-31.777,32.768002,-54.957001,-30.770399,32.254002,-55.056999,-31.777,33.215,-55.056999,-29.895,32.254002,-55.056999,-31.777,32.768002,-54.957001,-30.770399,32.254002,-54.957001,-23.84,32.254002,-55.056999,-23.84,32.768002,-54.957001,-24.8466,32.254002,-54.957001,-23.84,30.757,-54.957001,-22.347,30.757,-55.056999,-22.347,32.254002,-54.957001,-23.84,30.757,-55.056999,-22.347,32.254002,-55.056999,-23.84],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0.453253,0,0.891382,0.453253,0,0.891382,0.453253,0,0.891382,0.453253,0,0.891382,0.453253,0,0.891382,0.453253,0,0.891382,0.156351,0,0.987702,0.156351,0,0.987702,0.156351,0,0.987702,0.156351,0,0.987702,0.156351,0,0.987702,0.156351,0,0.987702,-0.156351,0,0.987702,-0.156351,0,0.987702,-0.156351,0,0.987702,-0.156351,0,0.987702,-0.156351,0,0.987702,-0.156351,0,0.987702,-0.453253,0,0.891382,-0.453253,0,0.891382,-0.453253,0,0.891382,-0.453253,0,0.891382,-0.453253,0,0.891382,-0.453253,0,0.891382,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.89061,0,0.454769,-0.89061,0,0.454769,-0.89061,0,0.454769,-0.89061,0,0.454769,-0.89061,0,0.454769,-0.89061,0,0.454769,-0.987582,0,0.157105,-0.987582,0,0.157105,-0.987582,0,0.157105,-0.987582,0,0.157105,-0.987582,0,0.157105,-0.987582,0,0.157105,-0.98757,0,-0.157178,-0.98757,0,-0.157178,-0.98757,0,-0.157178,-0.98757,0,-0.157178,-0.98757,0,-0.157178,-0.98757,0,-0.157178,-0.89061,0,-0.454769,-0.89061,0,-0.454769,-0.89061,0,-0.454769,-0.89061,0,-0.454769,-0.89061,0,-0.454769,-0.89061,0,-0.454769,0.156351,0,-0.987702,0.156351,0,-0.987702,0.156351,0,-0.987702,0.156351,0,-0.987702,0.156351,0,-0.987702,0.156351,0,-0.987702,0.453253,0,-0.891382,0.453253,0,-0.891382,0.453253,0,-0.891382,0.453253,0,-0.891382,0.453253,0,-0.891382,0.453253,0,-0.891382,0.706191,0,-0.708021,0.706191,0,-0.708021,0.706191,0,-0.708021,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.453253,0,-0.891382,-0.453253,0,-0.891382,-0.453253,0,-0.891382,-0.453253,0,-0.891382,-0.453253,0,-0.891382,-0.453253,0,-0.891382,-0.156351,0,-0.987702,-0.156351,0,-0.987702,-0.156351,0,-0.987702,-0.156351,0,-0.987702,-0.156351,0,-0.987702,-0.156351,0,-0.987702,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.890611,0,-0.454766,0.890611,0,-0.454766,0.890611,0,-0.454766,0.987644,0,-0.156717,0.987644,0,-0.156717,0.987644,0,-0.156717,0.987644,0,-0.156717,0.987644,0,-0.156717,0.987644,0,-0.156717,0.987655,0,0.156644,0.987655,0,0.156644,0.987655,0,0.156644,0.987655,0,0.156644,0.987655,0,0.156644,0.987655,0,0.156644,0.890611,0,0.454765,0.890611,0,0.454765,0.890611,0,0.454765,0.89061,-0.000035,0.454769,0.89061,-0.000035,0.454769,0.89061,-0.000035,0.454769,0.70616,0.000315,-0.708052,0.70616,0.000315,-0.708052,0.70616,0.000315,-0.708052,0.706144,0,-0.708068,0.706144,0,-0.708068,0.706144,0,-0.708068,0.890609,0,-0.454771,0.890609,0,-0.454771,0.890609,0,-0.454771,0.89061,-0.000026,-0.454769,0.89061,-0.000026,-0.454769,0.89061,-0.000026,-0.454769,0.890608,0,0.454771,0.890608,0,0.454771,0.890608,0,0.454771,0.70616,0,0.708053,0.70616,0,0.708053,0.70616,0,0.708053,0.70616,0,0.708053,0.70616,0,0.708053,0.70616,0,0.708053],"normalized":false}},"boundingSphere":{"center":[26.780001,-55.007,-27.8085],"radius":6.766186}}},{"uuid":"D683F0D3-E67C-4B74-ACCE-5EA75DF5BBE2","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[19.334999,-54.856998,-10.266,24.214001,-54.856998,-9.495,22.792,-54.848,-9.719,24.214001,-54.856998,-9.495,24.214001,-54.848,-9.495,22.792,-54.848,-9.719,19.334999,-50.856998,-10.266,22.858999,-50.882,-9.709,24.214001,-50.856998,-9.495,19.334999,-54.856998,-10.266,22.792,-54.848,-9.719,22.841,-51.952,-9.712,22.858999,-50.882,-9.709,24.214001,-50.882,-9.495,24.214001,-50.856998,-9.495,19.334999,-50.856998,-10.266,19.334999,-54.856998,-10.266,22.841,-51.952,-9.712,19.334999,-50.856998,-10.266,22.841,-51.952,-9.712,22.858999,-50.882,-9.709,15.152,-54.853001,-12.393,14.935,-54.856998,-12.503,19.334999,-54.856998,-10.266,19.334999,-50.856998,-10.266,15.152,-54.853001,-12.393,19.334999,-54.856998,-10.266,33.858799,-54.856998,-32.768002,36.985001,-54.856998,-34.507,33.926998,-54.856998,-32.700001,32.768002,-54.856998,-33.8564,36.985001,-54.856998,-34.507,33.858799,-54.856998,-32.768002,35.865002,-54.856998,-26.747999,40,-54.856998,-25.247,35.368999,-54.856998,-23.618,40,-54.856998,-25.247,39.228001,-54.856998,-20.379,35.368999,-54.856998,-23.618,33.926998,-54.856998,-20.795,36.985001,-54.856998,-15.988,32.768002,-54.856998,-19.638599,25.716999,-54.856998,-36.874001,22.580999,-54.856998,-36.379002,24.212999,-54.856998,-41,29.091999,-54.856998,-40.229,33.493,-54.856998,-37.992001,28.853001,-54.856998,-36.379002,31.681999,-54.856998,-34.939999,33.493,-54.856998,-37.992001,32.768002,-54.856998,-33.8564,32.768002,-54.856998,-19.638599,36.985001,-54.856998,-15.988,31.681999,-54.856998,-18.555,36.985001,-54.856998,-15.988,33.493,-54.856998,-12.503,31.681999,-54.856998,-18.555,19.752001,-54.856998,-18.555,14.935,-54.856998,-12.503,17.506001,-54.856998,-20.795,19.752001,-54.856998,-34.939999,19.334999,-54.856998,-40.229,22.580999,-54.856998,-36.379002,1.523,-54.856998,-5.095,2.305,-54.828999,-4.315,4.018,-54.856998,-2.606,3.236,-54.828999,-3.386,4.018,-54.856998,-2.606,2.305,-54.828999,-4.315,2.879,-50.873001,-25.962,8.626,-53.817001,-26.506001,-2.027,-51.790001,-25.555,8.629,-54.848,-26.523001,8.626,-53.817001,-26.506001,9.199,-54.856998,-30.115,8.427,-50.856998,-25.247999,8.427,-50.881001,-25.247999,8.66,-50.882,-23.775999,11.442,-50.856998,-15.989,11.442,-50.887001,-15.989,14.935,-50.887001,-12.503,11.442,-50.856998,-15.989,14.935,-50.887001,-12.503,14.935,-50.856998,-12.503,2.879,-50.873001,-25.962,8.618,-50.882,-26.455999,8.626,-53.817001,-26.506001,8.626,-53.817001,-26.506001,8.618,-50.882,-26.455999,9.199,-50.856998,-30.115,14.935,-50.887001,-12.503,15.049,-50.887001,-12.445,14.935,-50.856998,-12.503,15.049,-50.887001,-12.445,19.334999,-50.856998,-10.266,14.935,-50.856998,-12.503,8.626,-53.817001,-26.506001,9.199,-50.856998,-30.115,9.199,-54.856998,-30.115,8.618,-50.882,-26.455999,8.427,-50.856998,-25.247999,9.199,-50.856998,-30.115,8.618,-50.882,-26.455999,2.879,-50.873001,-25.962,8.427,-50.881001,-25.247999,8.427,-50.881001,-25.247999,8.427,-50.856998,-25.247999,8.618,-50.882,-26.455999,11.384,-50.887001,-16.101999,11.442,-50.887001,-15.989,11.442,-50.856998,-15.989,9.199,-50.856998,-30.115,11.442,-54.856998,-34.507,9.199,-54.856998,-30.115,11.442,-54.856998,-34.507,9.199,-50.856998,-30.115,11.442,-50.856998,-34.507,8.427,-54.848,-25.247999,8.427,-54.856998,-25.247999,8.671,-54.848,-23.709,8.427,-54.856998,-25.247999,9.199,-54.856998,-20.379,8.671,-54.848,-23.709,8.671,-54.848,-23.709,-1.958,-54.831001,-25.118,8.427,-54.848,-25.247999,8.427,-54.856998,-25.247999,8.629,-54.848,-26.523001,9.199,-54.856998,-30.115,8.427,-54.848,-25.247999,8.629,-54.848,-26.523001,8.427,-54.856998,-25.247999,19.334999,-50.856998,-40.229,14.934,-54.856998,-37.991001,14.934,-50.856998,-37.991001,14.934,-54.856998,-37.991001,11.442,-54.856998,-34.507,11.442,-50.856998,-34.507,14.934,-54.856998,-37.991001,11.442,-50.856998,-34.507,14.934,-50.856998,-37.991001,15.152,-54.853001,-12.393,15.049,-50.887001,-12.445,3.236,-54.828999,-3.386,15.152,-54.853001,-12.393,3.236,-54.828999,-3.386,14.935,-54.853001,-12.503,2.305,-54.828999,-4.315,14.935,-54.853001,-12.503,3.236,-54.828999,-3.386,18.910999,-50.856998,2.716,21.426001,-50.856998,1.437,18.910999,-54.856998,2.716,21.426001,-54.856998,1.437,18.910999,-54.856998,2.716,21.426001,-50.856998,1.437,11.442,-54.853001,-15.989,14.935,-54.853001,-12.503,2.305,-54.828999,-4.315,14.935,-54.856998,-12.503,11.442,-54.853001,-15.989,11.442,-54.856998,-15.989,14.935,-54.856998,-12.503,14.935,-54.853001,-12.503,11.442,-54.853001,-15.989,-8.191,-50.856998,-16.556999,-10.979,-50.856998,-16.115999,-10.979,-54.856998,-16.115999,11.331,-54.853001,-16.205,11.442,-54.853001,-15.989,2.305,-54.828999,-4.315,-8.589,-50.856998,-6.694,-8.589,-54.856998,-6.694,-11.733,-54.856998,-5.095,-8.589,-50.856998,-6.694,-11.733,-54.856998,-5.095,-11.733,-50.856998,-5.095,-5.105,-50.856998,-7.244,-5.105,-54.856998,-7.244,-8.589,-54.856998,-6.694,-5.105,-50.856998,-7.244,-8.589,-54.856998,-6.694,-8.589,-50.856998,-6.694,-11.733,-54.856998,-5.095,-14.228,-54.856998,-2.606,-14.228,-50.856998,-2.606,-11.733,-54.856998,-5.095,-14.228,-50.856998,-2.606,-11.733,-50.856998,-5.095,-1.62,-50.856998,-6.694,-1.62,-54.856998,-6.694,-5.105,-54.856998,-7.244,-1.62,-50.856998,-6.694,-5.105,-54.856998,-7.244,-5.105,-50.856998,-7.244,1.523,-54.856998,-5.095,-1.62,-54.856998,-6.694,-1.62,-50.856998,-6.694,-5.676,-54.856998,-17.836,-3.68,-54.856998,-19.827,-5.676,-50.856998,-17.836,-3.68,-50.856998,-19.827,-5.676,-50.856998,-17.836,-3.68,-54.856998,-19.827,11.442,-54.853001,-15.989,11.331,-54.853001,-16.205,11.442,-54.856998,-15.989,-13.766,-50.856998,-16.556999,-13.766,-54.856998,-16.556999,-10.979,-50.856998,-16.115999,-8.191,-54.856998,-16.556999,-8.191,-50.856998,-16.556999,-10.979,-54.856998,-16.115999,-8.191,-54.856998,-16.556999,-5.676,-54.856998,-17.836,-8.191,-50.856998,-16.556999,15.152,-54.853001,-12.393,14.935,-54.853001,-12.503,14.935,-54.856998,-12.503,-16.281,-54.856998,-17.836,-13.766,-54.856998,-16.556999,-16.281,-50.856998,-17.836,-13.766,-50.856998,-16.556999,-16.281,-50.856998,-17.836,-13.766,-54.856998,-16.556999,-10.979,-54.856998,-16.115999,-10.979,-50.856998,-16.115999,-13.766,-54.856998,-16.556999,-5.676,-50.856998,-17.836,-8.191,-50.856998,-16.556999,-5.676,-54.856998,-17.836,-3.68,-50.856998,-19.827,-3.68,-54.856998,-19.827,-2.399,-50.856998,-22.337,-2.399,-54.856998,-22.337,-2.399,-50.856998,-22.337,-3.68,-54.856998,-19.827,-3.68,-54.856998,-30.409,-3.68,-50.856998,-30.409,-2.399,-54.856998,-27.9,-2.399,-50.856998,-27.9,-2.399,-54.856998,-27.9,-3.68,-50.856998,-30.409,8.629,-54.848,-26.523001,-2.035,-54.831001,-25.605,8.626,-53.817001,-26.506001,-1.958,-50.856998,-25.118,-2.025,-50.865002,-25.540001,-2.399,-50.856998,-27.9,-1.958,-50.856998,-25.118,-2.025,-50.865002,-24.695,-1.958,-50.865002,-25.118,-1.958,-50.856998,-25.118,-2.399,-50.856998,-22.337,-2.025,-50.865002,-24.695,-1.958,-50.865002,-25.118,-2.025,-50.865002,-24.695,2.879,-50.873001,-25.962,24.214001,-54.856998,0.997,23.725,-54.831001,1.074,24.214001,-54.831001,0.997,23.740999,-53.834999,1.072,21.426001,-54.856998,1.437,21.426001,-50.856998,1.437,21.426001,-54.856998,1.437,23.740999,-53.834999,1.072,23.725,-54.831001,1.074,23.790001,-50.865002,1.064,23.740999,-53.834999,1.072,21.426001,-50.856998,1.437,15.634,-50.856998,12.78,15.192,-50.856998,9.999,15.634,-54.856998,12.78,33.493,-54.856998,-12.503,36.985001,-50.856998,-15.988,33.493,-50.856998,-12.503,22.580999,-50.856998,-36.379002,19.334999,-50.856998,-40.229,19.752001,-50.856998,-34.939999,29.091999,-50.856998,-40.229,24.212999,-50.856998,-41,25.716999,-50.856998,-36.874001,5.62,-54.856998,7.485,4.018,-54.856998,10.621,6.171,-54.856998,4.008,5.619,-54.856998,0.53,6.171,-54.856998,4.008,4.018,-54.856998,10.621,1.523,-54.856998,13.111,1.523,-54.856998,-5.095,4.018,-54.856998,10.621,15.634,-54.856998,7.217,16.916,-54.856998,4.707,16.916,-54.856998,15.289,-1.62,-54.856998,14.709,-5.105,-54.856998,15.259,-8.589,-54.856998,14.708,-1.62,-54.856998,14.709,-8.589,-54.856998,14.708,-11.733,-54.856998,13.111,-1.62,-54.856998,14.709,-11.733,-54.856998,13.111,-14.228,-54.856998,10.621,-1.62,-54.856998,14.709,-14.228,-54.856998,10.621,-15.829,-54.856998,7.485,-1.62,-54.856998,14.709,-15.829,-54.856998,7.485,-16.381001,-54.856998,4.008,-1.62,-54.856998,14.709,-16.381001,-54.856998,4.008,-15.829,-54.856998,0.53,-1.62,-54.856998,14.709,-15.829,-54.856998,0.53,-14.228,-54.856998,-2.606,-1.62,-54.856998,14.709,1.523,-54.856998,-5.095,1.523,-54.856998,13.111,5.619,-54.856998,0.53,4.018,-54.856998,10.621,4.018,-54.856998,-2.606,4.018,-54.856998,-2.606,4.018,-54.856998,10.621,1.523,-54.856998,-5.095,18.910999,-54.856998,17.280001,16.916,-54.856998,15.289,18.910999,-54.856998,2.716,21.426001,-54.856998,18.559,18.910999,-54.856998,17.280001,18.910999,-54.856998,2.716,32.792999,-54.856998,12.78,31.511,-54.856998,15.289,31.511,-54.856998,4.707,21.426001,-54.856998,1.437,24.214001,-54.856998,0.997,21.426001,-54.856998,18.559,24.212999,-54.856998,19,21.426001,-54.856998,18.559,24.214001,-54.856998,0.997,18.910999,-54.856998,2.716,21.426001,-54.856998,1.437,21.426001,-54.856998,18.559,15.192,-54.856998,9.999,15.634,-54.856998,7.217,15.634,-54.856998,12.78,9.199,-54.856998,-20.379,17.506001,-54.856998,-20.795,11.442,-54.856998,-15.989,32.792999,-54.856998,7.217,33.234001,-54.856998,9.998,31.511,-54.856998,4.707,33.234001,-54.856998,9.998,32.792999,-54.856998,12.78,31.511,-54.856998,4.707,29.516001,-54.856998,2.716,31.511,-54.856998,4.707,31.511,-54.856998,15.289,8.427,-54.848,-25.247999,-2.035,-54.831001,-25.605,8.629,-54.848,-26.523001,16.065001,-54.856998,-23.618,17.506001,-54.856998,-20.795,9.199,-54.856998,-20.379,31.511,-54.856998,15.289,29.516001,-54.856998,17.280001,29.516001,-54.856998,2.716,29.516001,-54.856998,17.280001,27.000999,-54.856998,18.559,29.516001,-54.856998,2.716,16.916,-54.856998,4.707,18.910999,-54.856998,2.716,16.916,-54.856998,15.289,27.000999,-54.856998,18.559,24.212999,-54.856998,19,24.214001,-54.856998,0.997,24.214001,-54.856998,0.997,27.000999,-54.856998,1.437,27.000999,-54.856998,18.559,27.000999,-54.856998,1.437,29.516001,-54.856998,2.716,27.000999,-54.856998,18.559,16.916,-54.856998,15.289,15.634,-54.856998,12.78,15.634,-54.856998,7.217,9.199,-54.856998,-30.115,15.568,-54.856998,-26.747999,8.427,-54.856998,-25.247999,8.626,-53.817001,-26.506001,-2.035,-54.831001,-25.605,-2.027,-51.790001,-25.555,15.568,-54.856998,-26.747999,16.065001,-54.856998,-23.618,8.427,-54.856998,-25.247999,9.199,-54.856998,-20.379,8.427,-54.856998,-25.247999,16.065001,-54.856998,-23.618,11.442,-54.856998,-34.507,16.065001,-54.856998,-29.877001,9.199,-54.856998,-30.115,14.934,-54.856998,-37.991001,17.506001,-54.856998,-32.700001,11.442,-54.856998,-34.507,15.568,-54.856998,-26.747999,9.199,-54.856998,-30.115,16.065001,-54.856998,-29.877001,25.716999,-54.856998,-16.621,28.853001,-54.856998,-17.117001,29.091999,-54.856998,-10.265,-2.399,-54.856998,-27.9,-2.027,-51.790001,-25.555,-2.035,-54.831001,-25.605,33.493,-54.856998,-12.503,29.091999,-54.856998,-10.265,28.853001,-54.856998,-17.117001,-5.105,-54.856998,-7.244,-1.62,-54.856998,14.709,-8.589,-54.856998,-6.694,-11.733,-54.856998,-5.095,-8.589,-54.856998,-6.694,-1.62,-54.856998,14.709,-1.62,-54.856998,-6.694,-1.62,-54.856998,14.709,-5.105,-54.856998,-7.244,1.523,-54.856998,-5.095,-1.62,-54.856998,14.709,-1.62,-54.856998,-6.694,-14.228,-54.856998,-2.606,-11.733,-54.856998,-5.095,-1.62,-54.856998,14.709,-2.025,-50.865002,-25.540001,-1.958,-50.865002,-25.118,2.879,-50.873001,-25.962,-2.399,-54.856998,-27.9,-2.399,-50.856998,-27.9,-2.027,-51.790001,-25.555,-16.281,-54.856998,-17.836,-8.191,-54.856998,-16.556999,-13.766,-54.856998,-16.556999,-2.399,-54.856998,-22.337,-3.68,-54.856998,-19.827,-16.281,-54.856998,-17.836,-3.68,-54.856998,-19.827,-5.676,-54.856998,-17.836,-16.281,-54.856998,-17.836,-8.191,-54.856998,-16.556999,-16.281,-54.856998,-17.836,-5.676,-54.856998,-17.836,-10.979,-54.856998,-16.115999,-13.766,-54.856998,-16.556999,-8.191,-54.856998,-16.556999,29.091999,-54.856998,-10.265,24.214001,-54.856998,-9.495,25.716999,-54.856998,-16.621,19.334999,-54.856998,-10.266,22.580999,-54.856998,-17.117001,24.214001,-54.856998,-9.495,22.580999,-54.856998,-17.117001,19.334999,-54.856998,-10.266,19.752001,-54.856998,-18.555,-3.68,-54.856998,-30.409,-2.399,-54.856998,-27.9,-16.281,-54.856998,-17.836,2.879,-50.873001,-25.962,-2.027,-51.790001,-25.555,-2.025,-50.865002,-25.540001,-13.766,-54.856998,-33.679001,-10.979,-54.856998,-34.118999,-16.281,-54.856998,-17.836,-2.399,-54.856998,-27.9,-1.958,-54.856998,-25.118,-16.281,-54.856998,-17.836,14.935,-54.856998,-12.503,19.752001,-54.856998,-18.555,19.334999,-54.856998,-10.266,8.427,-54.848,-25.247999,-1.958,-54.831001,-25.118,-2.035,-54.831001,-25.605,11.442,-54.856998,-15.989,17.506001,-54.856998,-20.795,14.935,-54.856998,-12.503,-2.399,-54.856998,-22.337,-16.281,-54.856998,-17.836,-1.958,-54.856998,-25.118,-1.958,-54.856998,-25.118,-2.035,-54.831001,-25.605,-1.958,-54.831001,-25.118,-2.399,-54.856998,-27.9,-2.035,-54.831001,-25.605,-1.958,-54.856998,-25.118,-3.68,-54.856998,-30.409,-16.281,-54.856998,-17.836,-5.676,-54.856998,-32.400002,-8.191,-54.856998,-33.679001,-5.676,-54.856998,-32.400002,-16.281,-54.856998,-17.836,28.853001,-54.856998,-17.117001,31.681999,-54.856998,-18.555,33.493,-54.856998,-12.503,25.716999,-54.856998,-16.621,24.214001,-54.856998,-9.495,22.580999,-54.856998,-17.117001,-18.277,-54.856998,-30.409,-16.281,-54.856998,-32.400002,-16.281,-54.856998,-17.836,33.234001,-50.856998,9.998,33.234001,-54.856998,9.998,32.792999,-54.856998,7.217,33.234001,-50.856998,9.998,32.792999,-54.856998,7.217,32.792999,-50.856998,7.217,32.792999,-50.856998,12.78,32.792999,-54.856998,12.78,33.234001,-54.856998,9.998,32.792999,-50.856998,12.78,33.234001,-54.856998,9.998,33.234001,-50.856998,9.998,-19.558001,-54.856998,-27.9,-16.281,-54.856998,-17.836,-20,-54.856998,-25.118,-18.277,-54.856998,-30.409,-16.281,-54.856998,-17.836,-19.558001,-54.856998,-27.9,-19.558001,-54.856998,-22.337,-20,-54.856998,-25.118,-16.281,-54.856998,-17.836,-13.766,-54.856998,-33.679001,-16.281,-54.856998,-17.836,-16.281,-54.856998,-32.400002,-18.277,-54.856998,-19.827,-19.558001,-54.856998,-22.337,-16.281,-54.856998,-17.836,-2.027,-51.790001,-25.555,-2.399,-50.856998,-27.9,-2.025,-50.865002,-25.540001,-8.191,-54.856998,-33.679001,-16.281,-54.856998,-17.836,-10.979,-54.856998,-34.118999,-14.228,-50.856998,-2.606,1.523,-50.856998,13.111,4.018,-50.856998,10.621,5.62,-50.856998,7.485,-14.228,-50.856998,-2.606,4.018,-50.856998,10.621,-16.381001,-50.856998,4.008,-15.829,-50.856998,7.485,-15.829,-50.856998,0.53,-15.829,-50.856998,7.485,-14.228,-50.856998,10.621,-15.829,-50.856998,0.53,-14.228,-50.856998,-2.606,-15.829,-50.856998,0.53,-14.228,-50.856998,10.621,-14.228,-50.856998,-2.606,-14.228,-50.856998,10.621,-11.733,-50.856998,13.111,-14.228,-50.856998,-2.606,-11.733,-50.856998,13.111,-8.589,-50.856998,14.708,-14.228,-50.856998,-2.606,-8.589,-50.856998,14.708,-5.105,-50.856998,15.259,-14.228,-50.856998,-2.606,-5.105,-50.856998,15.259,-1.62,-50.856998,14.709,-1.62,-50.856998,14.709,1.523,-50.856998,13.111,-14.228,-50.856998,-2.606,1.523,-50.856998,-5.095,-14.228,-50.856998,-2.606,4.018,-50.856998,-2.606,4.018,-50.856998,-2.606,-14.228,-50.856998,-2.606,5.619,-50.856998,0.53,6.171,-50.856998,4.008,-14.228,-50.856998,-2.606,5.62,-50.856998,7.485,6.171,-50.856998,4.008,5.619,-50.856998,0.53,-14.228,-50.856998,-2.606,11.442,-50.856998,-15.989,17.506001,-50.856998,-20.795,9.199,-50.856998,-20.379,8.427,-50.856998,-25.247999,9.199,-50.856998,-20.379,16.065001,-50.856998,-23.618,15.568,-50.856998,-26.747999,16.065001,-50.856998,-29.877001,9.199,-50.856998,-30.115,11.442,-50.856998,-34.507,9.199,-50.856998,-30.115,16.065001,-50.856998,-29.877001,-2.399,-50.856998,-22.337,-1.958,-50.856998,-25.118,-5.676,-50.856998,-17.836,-8.589,-50.856998,-6.694,-11.733,-50.856998,-5.095,-5.105,-50.856998,-7.244,-14.228,-50.856998,-2.606,-5.105,-50.856998,-7.244,-11.733,-50.856998,-5.095,-1.62,-50.856998,-6.694,-5.105,-50.856998,-7.244,-14.228,-50.856998,-2.606,-1.62,-50.856998,-6.694,-14.228,-50.856998,-2.606,1.523,-50.856998,-5.095,-5.676,-50.856998,-32.400002,-8.191,-50.856998,-33.679001,-5.676,-50.856998,-17.836,-2.399,-50.856998,-27.9,-3.68,-50.856998,-30.409,-5.676,-50.856998,-17.836,-1.958,-50.856998,-25.118,-2.399,-50.856998,-27.9,-5.676,-50.856998,-17.836,-3.68,-50.856998,-19.827,-2.399,-50.856998,-22.337,-5.676,-50.856998,-17.836,-10.979,-50.856998,-34.118999,-13.766,-50.856998,-33.679001,-13.766,-50.856998,-16.556999,-8.191,-50.856998,-16.556999,-5.676,-50.856998,-17.836,-8.191,-50.856998,-33.679001,-10.979,-50.856998,-16.115999,-8.191,-50.856998,-16.556999,-10.979,-50.856998,-34.118999,-8.191,-50.856998,-33.679001,-10.979,-50.856998,-34.118999,-8.191,-50.856998,-16.556999,-13.766,-50.856998,-16.556999,-10.979,-50.856998,-16.115999,-10.979,-50.856998,-34.118999,-16.281,-50.856998,-17.836,-13.766,-50.856998,-16.556999,-13.766,-50.856998,-33.679001,-18.277,-50.856998,-30.409,-19.558001,-50.856998,-27.9,-16.281,-50.856998,-32.400002,-3.68,-50.856998,-30.409,-5.676,-50.856998,-32.400002,-5.676,-50.856998,-17.836,-20,-50.856998,-25.118,-16.281,-50.856998,-32.400002,-19.558001,-50.856998,-27.9,-20,-50.856998,-25.118,-19.558001,-50.856998,-22.337,-16.281,-50.856998,-32.400002,-19.558001,-50.856998,-22.337,-18.277,-50.856998,-19.827,-16.281,-50.856998,-32.400002,-13.766,-50.856998,-33.679001,-16.281,-50.856998,-32.400002,-16.281,-50.856998,-17.836,-18.277,-50.856998,-19.827,-16.281,-50.856998,-17.836,-16.281,-50.856998,-32.400002,4.018,-54.856998,10.621,4.018,-50.856998,10.621,1.523,-50.856998,13.111,4.018,-54.856998,10.621,1.523,-50.856998,13.111,1.523,-54.856998,13.111,6.171,-50.856998,4.008,6.171,-54.856998,4.008,5.619,-54.856998,0.53,6.171,-50.856998,4.008,5.619,-54.856998,0.53,5.619,-50.856998,0.53,5.62,-50.856998,7.485,5.62,-54.856998,7.485,6.171,-54.856998,4.008,5.62,-50.856998,7.485,6.171,-54.856998,4.008,6.171,-50.856998,4.008,4.018,-54.856998,10.621,5.62,-54.856998,7.485,5.62,-50.856998,7.485,4.018,-54.856998,10.621,5.62,-50.856998,7.485,4.018,-50.856998,10.621,-1.62,-54.856998,14.709,1.523,-54.856998,13.111,-1.62,-50.856998,14.709,1.523,-50.856998,13.111,-1.62,-50.856998,14.709,1.523,-54.856998,13.111,15.634,-50.856998,7.217,15.634,-54.856998,7.217,15.192,-50.856998,9.999,15.192,-54.856998,9.999,15.192,-50.856998,9.999,15.634,-54.856998,7.217,15.634,-54.856998,12.78,15.192,-50.856998,9.999,15.192,-54.856998,9.999,-1.62,-54.856998,14.709,-1.62,-50.856998,14.709,-5.105,-50.856998,15.259,-1.62,-54.856998,14.709,-5.105,-50.856998,15.259,-5.105,-54.856998,15.259,-5.105,-50.856998,15.259,-8.589,-50.856998,14.708,-8.589,-54.856998,14.708,-5.105,-50.856998,15.259,-8.589,-54.856998,14.708,-5.105,-54.856998,15.259,-8.589,-50.856998,14.708,-11.733,-50.856998,13.111,-11.733,-54.856998,13.111,-8.589,-50.856998,14.708,-11.733,-54.856998,13.111,-8.589,-54.856998,14.708,-14.228,-54.856998,10.621,-14.228,-50.856998,10.621,-15.829,-50.856998,7.485,-14.228,-54.856998,10.621,-15.829,-50.856998,7.485,-15.829,-54.856998,7.485,-15.829,-50.856998,7.485,-16.381001,-50.856998,4.008,-16.381001,-54.856998,4.008,-15.829,-50.856998,7.485,-16.381001,-54.856998,4.008,-15.829,-54.856998,7.485,-16.381001,-50.856998,4.008,-15.829,-50.856998,0.53,-15.829,-54.856998,0.53,-16.381001,-50.856998,4.008,-15.829,-54.856998,0.53,-16.381001,-54.856998,4.008,-15.829,-50.856998,0.53,-14.228,-50.856998,-2.606,-14.228,-54.856998,-2.606,-15.829,-50.856998,0.53,-14.228,-54.856998,-2.606,-15.829,-54.856998,0.53,-11.733,-50.856998,13.111,-14.228,-50.856998,10.621,-14.228,-54.856998,10.621,-11.733,-50.856998,13.111,-14.228,-54.856998,10.621,-11.733,-54.856998,13.111,2.38,-50.862999,-4.241,4.018,-50.856998,-2.606,3.162,-50.862999,-3.46,2.38,-50.862999,-4.241,1.523,-50.856998,-5.095,4.018,-50.856998,-2.606,2.38,-50.862999,-4.241,2.305,-54.828999,-4.315,1.523,-50.856998,-5.095,1.523,-54.856998,-5.095,1.523,-50.856998,-5.095,2.305,-54.828999,-4.315,1.523,-54.856998,-5.095,-1.62,-50.856998,-6.694,1.523,-50.856998,-5.095,5.619,-54.856998,0.53,4.018,-54.856998,-2.606,5.619,-50.856998,0.53,2.38,-50.862999,-4.241,14.935,-50.887001,-12.503,11.442,-50.887001,-15.989,15.049,-50.887001,-12.445,14.935,-50.887001,-12.503,3.162,-50.862999,-3.46,2.38,-50.862999,-4.241,3.162,-50.862999,-3.46,14.935,-50.887001,-12.503,4.018,-50.856998,-2.606,5.619,-50.856998,0.53,4.018,-54.856998,-2.606,3.236,-54.828999,-3.386,15.049,-50.887001,-12.445,3.162,-50.862999,-3.46,11.442,-50.887001,-15.989,11.384,-50.887001,-16.101999,2.38,-50.862999,-4.241,3.236,-54.828999,-3.386,3.162,-50.862999,-3.46,4.018,-50.856998,-2.606,4.018,-50.856998,-2.606,4.018,-54.856998,-2.606,3.236,-54.828999,-3.386,36.985001,-54.856998,-34.507,32.768002,-54.856998,-33.8564,33.493,-54.856998,-37.992001,31.681999,-54.856998,-34.939999,28.853001,-54.856998,-36.379002,33.493,-54.856998,-37.992001,28.853001,-54.856998,-36.379002,25.716999,-54.856998,-36.874001,29.091999,-54.856998,-40.229,24.212999,-54.856998,-41,29.091999,-54.856998,-40.229,25.716999,-54.856998,-36.874001,19.334999,-54.856998,-40.229,24.212999,-54.856998,-41,22.580999,-54.856998,-36.379002,17.506001,-54.856998,-32.700001,14.934,-54.856998,-37.991001,19.752001,-54.856998,-34.939999,19.334999,-54.856998,-40.229,19.752001,-54.856998,-34.939999,14.934,-54.856998,-37.991001,16.065001,-54.856998,-29.877001,11.442,-54.856998,-34.507,17.506001,-54.856998,-32.700001,24.212999,-50.856998,-41,19.334999,-50.856998,-40.229,22.580999,-50.856998,-36.379002,14.934,-50.856998,-37.991001,19.752001,-50.856998,-34.939999,19.334999,-50.856998,-40.229,22.580999,-50.856998,-36.379002,25.716999,-50.856998,-36.874001,24.212999,-50.856998,-41,25.716999,-50.856998,-36.874001,28.853001,-50.856998,-36.379002,29.091999,-50.856998,-40.229,33.493,-50.856998,-37.992001,29.091999,-50.856998,-40.229,28.853001,-50.856998,-36.379002,29.091999,-50.856998,-40.229,29.091999,-54.856998,-40.229,24.212999,-54.856998,-41,29.091999,-50.856998,-40.229,24.212999,-54.856998,-41,24.212999,-50.856998,-41,33.493,-50.856998,-37.992001,36.985001,-54.856998,-34.507,33.493,-54.856998,-37.992001,33.493,-54.856998,-37.992001,29.091999,-54.856998,-40.229,29.091999,-50.856998,-40.229,33.493,-54.856998,-37.992001,29.091999,-50.856998,-40.229,33.493,-50.856998,-37.992001,19.334999,-50.856998,-40.229,19.334999,-54.856998,-40.229,14.934,-54.856998,-37.991001,24.212999,-54.856998,-41,19.334999,-54.856998,-40.229,19.334999,-50.856998,-40.229,24.212999,-54.856998,-41,19.334999,-50.856998,-40.229,24.212999,-50.856998,-41,36.985001,-54.856998,-15.988,33.926998,-54.856998,-20.795,39.228001,-54.856998,-20.379,33.926998,-54.856998,-20.795,35.368999,-54.856998,-23.618,39.228001,-54.856998,-20.379,35.368999,-54.856998,-29.877001,39.227001,-54.856998,-30.115,35.865002,-54.856998,-26.747999,33.926998,-54.856998,-32.700001,36.985001,-54.856998,-34.507,35.368999,-54.856998,-29.877001,40,-54.856998,-25.247,35.865002,-54.856998,-26.747999,39.227001,-54.856998,-30.115,39.227001,-54.856998,-30.115,35.368999,-54.856998,-29.877001,36.985001,-54.856998,-34.507,35.865002,-50.856998,-26.747999,35.368999,-50.856998,-23.618,40,-50.856998,-25.247,36.985001,-50.856998,-34.507,35.368999,-50.856998,-29.877001,39.227001,-50.856998,-30.115,39.227001,-50.856998,-30.115,35.865002,-50.856998,-26.747999,40,-50.856998,-25.247,39.228001,-50.856998,-20.379,40,-50.856998,-25.247,35.368999,-50.856998,-23.618,35.368999,-50.856998,-23.618,33.926998,-50.856998,-20.795,39.228001,-50.856998,-20.379,33.493,-50.856998,-37.992001,32.768002,-50.856998,-33.8564,36.985001,-50.856998,-34.507,39.227001,-50.856998,-30.115,39.227001,-54.856998,-30.115,36.985001,-50.856998,-34.507,40,-50.856998,-25.247,40,-54.856998,-25.247,39.227001,-54.856998,-30.115,40,-50.856998,-25.247,39.227001,-54.856998,-30.115,39.227001,-50.856998,-30.115,39.228001,-50.856998,-20.379,39.228001,-54.856998,-20.379,40,-54.856998,-25.247,39.228001,-50.856998,-20.379,40,-54.856998,-25.247,40,-50.856998,-25.247,36.985001,-50.856998,-15.988,36.985001,-54.856998,-15.988,39.228001,-54.856998,-20.379,36.985001,-50.856998,-15.988,39.228001,-54.856998,-20.379,39.228001,-50.856998,-20.379,36.985001,-50.856998,-15.988,33.493,-54.856998,-12.503,36.985001,-54.856998,-15.988,36.985001,-50.856998,-34.507,36.985001,-54.856998,-34.507,33.493,-50.856998,-37.992001,39.227001,-54.856998,-30.115,36.985001,-54.856998,-34.507,36.985001,-50.856998,-34.507,24.212999,-50.856998,19,27.000999,-50.856998,18.559,21.426001,-50.856998,18.559,18.910999,-50.856998,17.280001,21.426001,-50.856998,18.559,27.000999,-50.856998,18.559,29.516001,-50.856998,17.280001,29.516001,-50.856998,2.716,27.000999,-50.856998,18.559,18.910999,-50.856998,17.280001,27.000999,-50.856998,18.559,16.916,-50.856998,15.289,16.916,-50.856998,15.289,27.000999,-50.856998,18.559,15.634,-50.856998,12.78,31.511,-50.856998,15.289,29.516001,-50.856998,2.716,29.516001,-50.856998,17.280001,27.000999,-50.856998,1.437,27.000999,-50.856998,18.559,29.516001,-50.856998,2.716,32.792999,-50.856998,7.217,31.511,-50.856998,4.707,33.234001,-50.856998,9.998,18.910999,-50.856998,2.716,27.000999,-50.856998,18.559,21.426001,-50.856998,1.437,24.214001,-50.856998,0.997,27.000999,-50.856998,18.559,27.000999,-50.856998,1.437,21.426001,-50.856998,1.437,27.000999,-50.856998,18.559,24.214001,-50.856998,0.997,29.516001,-50.856998,2.716,31.511,-50.856998,15.289,31.511,-50.856998,4.707,15.634,-50.856998,7.217,27.000999,-50.856998,18.559,16.916,-50.856998,4.707,32.792999,-50.856998,12.78,31.511,-50.856998,4.707,31.511,-50.856998,15.289,33.234001,-50.856998,9.998,31.511,-50.856998,4.707,32.792999,-50.856998,12.78,15.634,-50.856998,12.78,27.000999,-50.856998,18.559,15.192,-50.856998,9.999,16.916,-50.856998,4.707,27.000999,-50.856998,18.559,18.910999,-50.856998,2.716,15.192,-50.856998,9.999,27.000999,-50.856998,18.559,15.634,-50.856998,7.217,33.493,-50.856998,-12.503,28.853001,-50.856998,-17.117001,29.091999,-50.856998,-10.265,29.091999,-50.856998,-10.265,25.716999,-50.856998,-16.621,24.214001,-50.856998,-9.495,24.214001,-50.856998,-9.495,22.580999,-50.856998,-17.117001,19.334999,-50.856998,-10.266,22.580999,-50.856998,-17.117001,19.752001,-50.856998,-18.555,19.334999,-50.856998,-10.266,36.985001,-50.856998,-15.988,31.681999,-50.856998,-18.555,33.493,-50.856998,-12.503,28.853001,-50.856998,-17.117001,25.716999,-50.856998,-16.621,29.091999,-50.856998,-10.265,22.580999,-50.856998,-17.117001,24.214001,-50.856998,-9.495,25.716999,-50.856998,-16.621,14.935,-50.856998,-12.503,19.334999,-50.856998,-10.266,19.752001,-50.856998,-18.555,19.752001,-50.856998,-18.555,17.506001,-50.856998,-20.795,14.935,-50.856998,-12.503,28.853001,-50.856998,-36.379002,31.681999,-50.856998,-34.939999,33.493,-50.856998,-37.992001,33.858799,-50.856998,-32.768002,36.985001,-50.856998,-34.507,32.768002,-50.856998,-33.8564,33.926998,-50.856998,-32.700001,36.985001,-50.856998,-34.507,33.858799,-50.856998,-32.768002,36.985001,-50.856998,-34.507,33.926998,-50.856998,-32.700001,35.368999,-50.856998,-29.877001,39.227001,-50.856998,-30.115,35.368999,-50.856998,-29.877001,35.865002,-50.856998,-26.747999,32.768002,-50.856998,-19.638599,36.985001,-50.856998,-15.988,33.926998,-50.856998,-20.795,36.985001,-50.856998,-15.988,39.228001,-50.856998,-20.379,33.926998,-50.856998,-20.795,32.768002,-50.856998,-33.8564,33.493,-50.856998,-37.992001,31.681999,-50.856998,-34.939999,36.985001,-50.856998,-15.988,32.768002,-50.856998,-19.638599,31.681999,-50.856998,-18.555,28.853001,-50.856998,-17.117001,33.493,-50.856998,-12.503,31.681999,-50.856998,-18.555,11.442,-50.856998,-15.989,14.935,-50.856998,-12.503,17.506001,-50.856998,-20.795,16.065001,-50.856998,-23.618,9.199,-50.856998,-20.379,17.506001,-50.856998,-20.795,9.199,-50.856998,-30.115,8.427,-50.856998,-25.247999,15.568,-50.856998,-26.747999,16.065001,-50.856998,-23.618,15.568,-50.856998,-26.747999,8.427,-50.856998,-25.247999,14.934,-50.856998,-37.991001,11.442,-50.856998,-34.507,17.506001,-50.856998,-32.700001,16.065001,-50.856998,-29.877001,17.506001,-50.856998,-32.700001,11.442,-50.856998,-34.507,17.506001,-50.856998,-32.700001,19.752001,-50.856998,-34.939999,14.934,-50.856998,-37.991001,-1.958,-50.865002,-25.118,-2.025,-50.865002,-25.540001,-1.958,-50.856998,-25.118,-2.035,-54.831001,-24.629999,-2.399,-50.856998,-22.337,-2.399,-54.856998,-22.337,-2.035,-54.831001,-24.629999,-2.025,-50.865002,-24.695,-2.399,-50.856998,-22.337,-2.035,-54.831001,-24.629999,-1.958,-54.856998,-25.118,-1.958,-54.831001,-25.118,-2.399,-54.856998,-22.337,-1.958,-54.856998,-25.118,-2.035,-54.831001,-24.629999,-8.191,-54.856998,-33.679001,-5.676,-50.856998,-32.400002,-5.676,-54.856998,-32.400002,-3.68,-54.856998,-30.409,-5.676,-54.856998,-32.400002,-5.676,-50.856998,-32.400002,-3.68,-54.856998,-30.409,-5.676,-50.856998,-32.400002,-3.68,-50.856998,-30.409,-16.281,-50.856998,-32.400002,-16.281,-54.856998,-32.400002,-18.277,-50.856998,-30.409,-13.766,-54.856998,-33.679001,-16.281,-54.856998,-32.400002,-16.281,-50.856998,-32.400002,-16.281,-54.856998,-32.400002,-18.277,-54.856998,-30.409,-18.277,-50.856998,-30.409,-16.281,-50.856998,-17.836,-18.277,-50.856998,-19.827,-18.277,-54.856998,-19.827,-16.281,-50.856998,-17.836,-18.277,-54.856998,-19.827,-16.281,-54.856998,-17.836,-19.558001,-54.856998,-27.9,-19.558001,-50.856998,-27.9,-18.277,-50.856998,-30.409,-19.558001,-54.856998,-27.9,-18.277,-50.856998,-30.409,-18.277,-54.856998,-30.409,-20,-54.856998,-25.118,-20,-50.856998,-25.118,-19.558001,-50.856998,-27.9,-20,-54.856998,-25.118,-19.558001,-50.856998,-27.9,-19.558001,-54.856998,-27.9,-19.558001,-54.856998,-22.337,-19.558001,-50.856998,-22.337,-20,-50.856998,-25.118,-19.558001,-54.856998,-22.337,-20,-50.856998,-25.118,-20,-54.856998,-25.118,-18.277,-50.856998,-19.827,-19.558001,-50.856998,-22.337,-19.558001,-54.856998,-22.337,-18.277,-50.856998,-19.827,-19.558001,-54.856998,-22.337,-18.277,-54.856998,-19.827,-8.191,-54.856998,-33.679001,-8.191,-50.856998,-33.679001,-5.676,-50.856998,-32.400002,-8.191,-54.856998,-33.679001,-10.979,-54.856998,-34.118999,-10.979,-50.856998,-34.118999,-8.191,-54.856998,-33.679001,-10.979,-50.856998,-34.118999,-8.191,-50.856998,-33.679001,-10.979,-54.856998,-34.118999,-13.766,-54.856998,-33.679001,-13.766,-50.856998,-33.679001,-10.979,-54.856998,-34.118999,-13.766,-50.856998,-33.679001,-10.979,-50.856998,-34.118999,-13.766,-54.856998,-33.679001,-16.281,-50.856998,-32.400002,-13.766,-50.856998,-33.679001,15.049,-50.887001,-12.445,15.152,-54.853001,-12.393,19.334999,-50.856998,-10.266,2.305,-54.828999,-4.315,2.38,-50.862999,-4.241,11.384,-50.887001,-16.101999,11.331,-54.853001,-16.205,2.305,-54.828999,-4.315,11.384,-50.887001,-16.101999,11.331,-54.853001,-16.205,11.384,-50.887001,-16.101999,9.199,-50.856998,-20.379,8.66,-50.882,-23.775999,-2.025,-50.865002,-24.695,-2.035,-54.831001,-24.629999,9.199,-54.856998,-20.379,11.442,-54.856998,-15.989,11.331,-54.853001,-16.205,2.879,-50.873001,-25.962,-2.025,-50.865002,-24.695,8.66,-50.882,-23.775999,9.199,-54.856998,-20.379,11.331,-54.853001,-16.205,9.199,-50.856998,-20.379,-2.035,-54.831001,-24.629999,-1.958,-54.831001,-25.118,8.671,-54.848,-23.709,9.199,-50.856998,-20.379,8.671,-54.848,-23.709,9.199,-54.856998,-20.379,8.66,-50.882,-23.775999,-2.035,-54.831001,-24.629999,8.671,-54.848,-23.709,2.879,-50.873001,-25.962,8.66,-50.882,-23.775999,8.427,-50.881001,-25.247999,9.199,-50.856998,-20.379,8.66,-50.882,-23.775999,8.671,-54.848,-23.709,11.442,-50.856998,-15.989,9.199,-50.856998,-20.379,11.384,-50.887001,-16.101999,9.199,-50.856998,-20.379,8.427,-50.856998,-25.247999,8.66,-50.882,-23.775999,29.516001,-54.856998,17.280001,29.516001,-50.856998,17.280001,27.000999,-50.856998,18.559,29.516001,-54.856998,17.280001,27.000999,-50.856998,18.559,27.000999,-54.856998,18.559,27.000999,-50.856998,18.559,24.212999,-50.856998,19,24.212999,-54.856998,19,27.000999,-50.856998,18.559,24.212999,-54.856998,19,27.000999,-54.856998,18.559,24.212999,-50.856998,19,21.426001,-50.856998,18.559,21.426001,-54.856998,18.559,24.212999,-50.856998,19,21.426001,-54.856998,18.559,24.212999,-54.856998,19,21.426001,-50.856998,18.559,18.910999,-50.856998,17.280001,18.910999,-54.856998,17.280001,21.426001,-50.856998,18.559,18.910999,-54.856998,17.280001,21.426001,-54.856998,18.559,32.792999,-54.856998,12.78,32.792999,-50.856998,12.78,31.511,-54.856998,15.289,31.511,-50.856998,15.289,31.511,-54.856998,15.289,32.792999,-50.856998,12.78,18.910999,-50.856998,17.280001,16.916,-50.856998,15.289,16.916,-54.856998,15.289,18.910999,-50.856998,17.280001,16.916,-54.856998,15.289,18.910999,-54.856998,17.280001,29.516001,-54.856998,17.280001,31.511,-54.856998,15.289,29.516001,-50.856998,17.280001,31.511,-50.856998,15.289,29.516001,-50.856998,17.280001,31.511,-54.856998,15.289,16.916,-50.856998,15.289,15.634,-50.856998,12.78,15.634,-54.856998,12.78,16.916,-50.856998,15.289,15.634,-54.856998,12.78,16.916,-54.856998,15.289,29.516001,-50.856998,2.716,29.516001,-54.856998,2.716,27.000999,-54.856998,1.437,27.000999,-50.856998,1.437,29.516001,-50.856998,2.716,27.000999,-54.856998,1.437,32.792999,-54.856998,7.217,31.511,-54.856998,4.707,32.792999,-50.856998,7.217,32.792999,-50.856998,7.217,31.511,-54.856998,4.707,31.511,-50.856998,4.707,29.516001,-50.856998,2.716,31.511,-50.856998,4.707,31.511,-54.856998,4.707,29.516001,-50.856998,2.716,31.511,-54.856998,4.707,29.516001,-54.856998,2.716,24.652,-51.790001,1.066,27.000999,-50.856998,1.437,27.000999,-54.856998,1.437,27.000999,-54.856998,1.437,24.701,-54.831001,1.074,24.652,-51.790001,1.066,24.652,-51.790001,1.066,24.636999,-50.865002,1.064,27.000999,-50.856998,1.437,27.000999,-50.856998,1.437,24.636999,-50.865002,1.064,24.214001,-50.856998,0.997,24.636999,-50.865002,1.064,24.214001,-50.865002,0.997,24.214001,-50.856998,0.997,15.634,-50.856998,7.217,16.916,-54.856998,4.707,15.634,-54.856998,7.217,23.725,-54.831001,1.074,24.214001,-54.856998,0.997,21.426001,-54.856998,1.437,24.701,-54.831001,1.074,27.000999,-54.856998,1.437,24.214001,-54.856998,0.997,24.701,-54.831001,1.074,24.214001,-54.856998,0.997,24.214001,-54.831001,0.997,15.634,-50.856998,7.217,16.916,-50.856998,4.707,16.916,-54.856998,4.707,23.790001,-50.865002,1.064,21.426001,-50.856998,1.437,24.214001,-50.856998,0.997,24.214001,-50.865002,0.997,23.790001,-50.865002,1.064,24.214001,-50.856998,0.997,16.916,-50.856998,4.707,18.910999,-50.856998,2.716,16.916,-54.856998,4.707,18.910999,-54.856998,2.716,16.916,-54.856998,4.707,18.910999,-50.856998,2.716,24.701,-54.831001,1.074,24.214001,-54.831001,0.997,23.473,-54.835999,-1.836,24.214001,-54.848,-9.495,23.473,-54.835999,-1.836,22.792,-54.848,-9.719,24.214001,-50.865002,0.997,23.406,-50.872002,-3.381,23.790001,-50.865002,1.064,25.568001,-50.882,-9.709,23.406,-50.872002,-3.381,24.636999,-50.865002,1.064,24.636999,-50.865002,1.064,24.652,-51.790001,1.066,25.568001,-50.882,-9.709,24.214001,-50.865002,0.997,24.636999,-50.865002,1.064,23.406,-50.872002,-3.381,22.858999,-50.882,-9.709,23.406,-50.872002,-3.381,24.214001,-50.882,-9.495,23.740999,-53.834999,1.072,23.790001,-50.865002,1.064,23.406,-50.872002,-3.381,23.473,-54.835999,-1.836,23.740999,-53.834999,1.072,22.841,-51.952,-9.712,23.473,-54.835999,-1.836,23.725,-54.831001,1.074,23.740999,-53.834999,1.072,23.406,-50.872002,-3.381,22.841,-51.952,-9.712,23.740999,-53.834999,1.072,22.841,-51.952,-9.712,22.792,-54.848,-9.719,23.473,-54.835999,-1.836,24.214001,-54.831001,0.997,23.725,-54.831001,1.074,23.473,-54.835999,-1.836,22.858999,-50.882,-9.709,22.841,-51.952,-9.712,23.406,-50.872002,-3.381,25.634001,-54.848,-9.719,29.091999,-54.856998,-10.265,25.618,-53.846001,-9.717,24.214001,-54.848,-9.495,24.214001,-54.856998,-9.495,25.634001,-54.848,-9.719,24.214001,-54.856998,-9.495,29.091999,-54.856998,-10.265,25.634001,-54.848,-9.719,23.473,-54.835999,-1.836,25.634001,-54.848,-9.719,24.701,-54.831001,1.074,25.634001,-54.848,-9.719,23.473,-54.835999,-1.836,24.214001,-54.848,-9.495,29.091999,-54.856998,-10.265,29.091999,-50.856998,-10.265,25.618,-53.846001,-9.717,29.091999,-50.856998,-10.265,25.568001,-50.882,-9.709,25.618,-53.846001,-9.717,25.568001,-50.882,-9.709,29.091999,-50.856998,-10.265,24.214001,-50.856998,-9.495,33.493,-50.856998,-12.503,29.091999,-50.856998,-10.265,29.091999,-54.856998,-10.265,29.091999,-54.856998,-10.265,33.493,-54.856998,-12.503,33.493,-50.856998,-12.503,24.652,-51.790001,1.066,24.701,-54.831001,1.074,25.618,-53.846001,-9.717,24.701,-54.831001,1.074,25.634001,-54.848,-9.719,25.618,-53.846001,-9.717,24.214001,-50.882,-9.495,23.406,-50.872002,-3.381,25.568001,-50.882,-9.709,25.568001,-50.882,-9.709,24.652,-51.790001,1.066,25.618,-53.846001,-9.717,24.214001,-50.882,-9.495,25.568001,-50.882,-9.709,24.214001,-50.856998,-9.495],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[-0.155615,-0.077745,0.984754,-0.155615,-0.077745,0.984754,-0.155615,-0.077745,0.984754,-0.155606,0,0.987819,-0.155606,0,0.987819,-0.155606,0,0.987819,-0.156085,0.004865,0.987732,-0.156085,0.004865,0.987732,-0.156085,0.004865,0.987732,-0.156286,0.000257,0.987712,-0.156286,0.000257,0.987712,-0.156286,0.000257,0.987712,-0.156,0,0.987757,-0.156,0,0.987757,-0.156,0,0.987757,-0.156078,0,0.987745,-0.156078,0,0.987745,-0.156078,0,0.987745,-0.156122,-0.000143,0.987738,-0.156122,-0.000143,0.987738,-0.156122,-0.000143,0.987738,-0.452021,0.072105,0.889088,-0.452021,0.072105,0.889088,-0.452021,0.072105,0.889088,-0.453255,0,0.891381,-0.453255,0,0.891381,-0.453255,0,0.891381,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.706252,-0.003026,-0.707954,0.706252,-0.003026,-0.707954,0.706252,-0.003026,-0.707954,0.706323,0.008097,-0.707843,0.706323,0.008097,-0.707843,0.706323,0.008097,-0.707843,-0.085758,0.016668,-0.996177,-0.085758,0.016668,-0.996177,-0.085758,0.016668,-0.996177,-0.987642,-0.000289,-0.156724,-0.987642,-0.000289,-0.156724,-0.987642,-0.000289,-0.156724,-0.987703,0,0.156341,-0.987703,0,0.156341,-0.987703,0,0.156341,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.085722,0.016737,-0.996178,-0.085722,0.016737,-0.996178,-0.085722,0.016737,-0.996178,-0.987627,-0.00002,-0.156822,-0.987627,-0.00002,-0.156822,-0.987627,-0.00002,-0.156822,-0.453463,0,0.891275,-0.453463,0,0.891275,-0.453463,0,0.891275,-0.4532,0.001254,0.891408,-0.4532,0.001254,0.891408,-0.4532,0.001254,0.891408,-0.987629,0,-0.156806,-0.987629,0,-0.156806,-0.987629,0,-0.156806,-0.987364,0.024176,-0.156615,-0.987364,0.024176,-0.156615,-0.987364,0.024176,-0.156615,0.001517,0.999999,-0.000587,0.001517,0.999999,-0.000587,0.001517,0.999999,-0.000587,-0.98773,0,-0.156172,-0.98773,0,-0.156172,-0.98773,0,-0.156172,-0.88965,0,0.456643,-0.88965,0,0.456643,-0.88965,0,0.456643,-0.890583,0,-0.454822,-0.890583,0,-0.454822,-0.890583,0,-0.454822,-0.890583,0,-0.454822,-0.890583,0,-0.454822,-0.890583,0,-0.454822,-0.987664,0,0.156588,-0.987664,0,0.156588,-0.987664,0,0.156588,-0.987661,-0.001686,0.156598,-0.987661,-0.001686,0.156598,-0.987661,-0.001686,0.156598,-0.001634,-0.999999,0.000259,-0.001634,-0.999999,0.000259,-0.001634,-0.999999,0.000259,-0.987309,-0.026354,-0.156606,-0.987309,-0.026354,-0.156606,-0.987309,-0.026354,-0.156606,-0.987681,0,-0.156479,-0.987681,0,-0.156479,-0.987681,0,-0.156479,-0.453279,0,-0.891369,-0.453279,0,-0.891369,-0.453279,0,-0.891369,-0.706296,0,-0.707917,-0.706296,0,-0.707917,-0.706296,0,-0.707917,-0.706296,0,-0.707917,-0.706296,0,-0.707917,-0.706296,0,-0.707917,0.602823,0.026112,0.797448,0.602823,0.026112,0.797448,0.602823,0.026112,0.797448,-0.000809,-0.999998,0.001595,-0.000809,-0.999998,0.001595,-0.000809,-0.999998,0.001595,-0.001152,-0.999999,0.001154,-0.001152,-0.999999,0.001154,-0.001152,-0.999999,0.001154,-0.453299,0,-0.891358,-0.453299,0,-0.891358,-0.453299,0,-0.891358,-0.453299,0,-0.891358,-0.453299,0,-0.891358,-0.453299,0,-0.891358,-0.001152,-0.999999,0.001154,-0.001152,-0.999999,0.001154,-0.001152,-0.999999,0.001154,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,-0.001586,-0.999998,0.000815,-0.001586,-0.999998,0.000815,-0.001586,-0.999998,0.000815,-0.453327,0,-0.891344,-0.453327,0,-0.891344,-0.453327,0,-0.891344,-0.453327,0,-0.891344,-0.453327,0,-0.891344,-0.453327,0,-0.891344,-0.155934,0,-0.987768,-0.155934,0,-0.987768,-0.155934,0,-0.987768,-0.155934,0,-0.987768,-0.155934,0,-0.987768,-0.155934,0,-0.987768,-0.706255,0,-0.707958,-0.706255,0,-0.707958,-0.706255,0,-0.707958,-0.706255,0,-0.707958,-0.706255,0,-0.707958,-0.706255,0,-0.707958,0.15589,0,-0.987774,0.15589,0,-0.987774,0.15589,0,-0.987774,0.15589,0,-0.987774,0.15589,0,-0.987774,0.15589,0,-0.987774,0.453441,0,-0.891286,0.453441,0,-0.891286,0.453441,0,-0.891286,0.706219,0,0.707993,0.706219,0,0.707993,0.706219,0,0.707993,0.706219,0,0.707993,0.706219,0,0.707993,0.706219,0,0.707993,-0.889431,0,0.45707,-0.889431,0,0.45707,-0.889431,0,0.45707,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,0.4533,0,0.891358,0.4533,0,0.891358,0.4533,0,0.891358,-0.452141,0,0.891946,-0.452141,0,0.891946,-0.452141,0,0.891946,-0.453299,0,0.891358,-0.453299,0,0.891358,-0.453299,0,0.891358,-0.453299,0,0.891358,-0.453299,0,0.891358,-0.453299,0,0.891358,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,0.4533,0,0.891358,0.4533,0,0.891358,0.4533,0,0.891358,0.890706,0,0.45458,0.890706,0,0.45458,0.890706,0,0.45458,0.890706,0,0.45458,0.890706,0,0.45458,0.890706,0,0.45458,0.890633,0,-0.454723,0.890633,0,-0.454723,0.890633,0,-0.454723,0.890633,0,-0.454723,0.890633,0,-0.454723,0.890633,0,-0.454723,-0.08573,0.016177,-0.996187,-0.08573,0.016177,-0.996187,-0.08573,0.016177,-0.996187,0.987585,-0.012952,-0.156551,0.987585,-0.012952,-0.156551,0.987585,-0.012952,-0.156551,0.987687,0,0.156442,0.987687,0,0.156442,0.987687,0,0.156442,0.987614,0.009572,0.156612,0.987614,0.009572,0.156612,0.987614,0.009572,0.156612,0.001701,0.999999,0.000269,0.001701,0.999999,0.000269,0.001701,0.999999,0.000269,-0.155548,0,-0.987828,-0.155548,0,-0.987828,-0.155548,0,-0.987828,-0.155744,0,-0.987797,-0.155744,0,-0.987797,-0.155744,0,-0.987797,-0.155968,0.000522,-0.987762,-0.155968,0.000522,-0.987762,-0.155968,0.000522,-0.987762,-0.155856,-0.000089,-0.98778,-0.155856,-0.000089,-0.98778,-0.155856,-0.000089,-0.98778,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.001616,-0.999999,-0.000256,-0.001616,-0.999999,-0.000256,-0.001616,-0.999999,-0.000256,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.08577,0.016604,-0.996177,-0.08577,0.016604,-0.996177,-0.08577,0.016604,-0.996177,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.987655,-0.000023,-0.156647,0.987655,-0.000023,-0.156647,0.987655,-0.000023,-0.156647,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.001609,0.999999,-0.000255,0.001609,0.999999,-0.000255,0.001609,0.999999,-0.000255,0.98765,0,-0.156676,0.98765,0,-0.156676,0.98765,0,-0.156676,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.085697,0.016339,-0.996187,-0.085697,0.016339,-0.996187,-0.085697,0.016339,-0.996187,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-0.001634,-0.999999,0.000258,-0.001634,-0.999999,0.000258,-0.001634,-0.999999,0.000258,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.98773,0,-0.156171,0.98773,0,-0.156171,0.98773,0,-0.156171,0.98764,-0.007544,-0.15656,0.98764,-0.007544,-0.15656,0.98764,-0.007544,-0.15656,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.987659,0,-0.15662,0.987659,0,-0.15662,0.987659,0,-0.15662,0.987659,0,-0.15662,0.987659,0,-0.15662,0.987659,0,-0.15662,0.987668,0,0.156565,0.987668,0,0.156565,0.987668,0,0.156565,0.987668,0,0.156565,0.987668,0,0.156565,0.987668,0,0.156565,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.987675,0.000403,-0.15652,0.987675,0.000403,-0.15652,0.987675,0.000403,-0.15652,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.987638,0,-0.15675,0.987638,0,-0.15675,0.987638,0,-0.15675,0.987638,0,-0.15675,0.987638,0,-0.15675,0.987638,0,-0.15675,0.987675,0,0.156517,0.987675,0,0.156517,0.987675,0,0.156517,0.987675,0,0.156517,0.987675,0,0.156517,0.987675,0,0.156517,0.890532,0,0.454921,0.890532,0,0.454921,0.890532,0,0.454921,0.890532,0,0.454921,0.890532,0,0.454921,0.890532,0,0.454921,0.453216,0,0.891401,0.453216,0,0.891401,0.453216,0,0.891401,0.453216,0,0.891401,0.453216,0,0.891401,0.453216,0,0.891401,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,0.15589,0,0.987774,0.15589,0,0.987774,0.15589,0,0.987774,0.15589,0,0.987774,0.15589,0,0.987774,0.15589,0,0.987774,-0.15621,0,0.987724,-0.15621,0,0.987724,-0.15621,0,0.987724,-0.15621,0,0.987724,-0.15621,0,0.987724,-0.15621,0,0.987724,-0.452876,0,0.891573,-0.452876,0,0.891573,-0.452876,0,0.891573,-0.452876,0,0.891573,-0.452876,0,0.891573,-0.452876,0,0.891573,-0.890647,0,0.454696,-0.890647,0,0.454696,-0.890647,0,0.454696,-0.890647,0,0.454696,-0.890647,0,0.454696,-0.890647,0,0.454696,-0.987631,0,0.156794,-0.987631,0,0.156794,-0.987631,0,0.156794,-0.987631,0,0.156794,-0.987631,0,0.156794,-0.987631,0,0.156794,-0.987638,0,-0.15675,-0.987638,0,-0.15675,-0.987638,0,-0.15675,-0.987638,0,-0.15675,-0.987638,0,-0.15675,-0.987638,0,-0.15675,-0.890647,0,-0.454696,-0.890647,0,-0.454696,-0.890647,0,-0.454696,-0.890647,0,-0.454696,-0.890647,0,-0.454696,-0.890647,0,-0.454696,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,0.702658,-0.106205,-0.703557,0.702658,-0.106205,-0.703557,0.702658,-0.106205,-0.703557,0.701956,0.110168,-0.703648,0.701956,0.110168,-0.703648,0.701956,0.110168,-0.703648,0.705865,-0.000132,-0.708346,0.705865,-0.000132,-0.708346,0.705865,-0.000132,-0.708346,0.706201,0,-0.708012,0.706201,0,-0.708012,0.706201,0,-0.708012,0.453441,0,-0.891286,0.453441,0,-0.891286,0.453441,0,-0.891286,0.890647,0,-0.454696,0.890647,0,-0.454696,0.890647,0,-0.454696,0.001152,0.999999,-0.001154,0.001152,0.999999,-0.001154,0.001152,0.999999,-0.001154,0.000812,0.999998,-0.001597,0.000812,0.999998,-0.001597,0.000812,0.999998,-0.001597,0.001152,0.999999,-0.001154,0.001152,0.999999,-0.001154,0.001152,0.999999,-0.001154,0.890647,0,-0.454696,0.890647,0,-0.454696,0.890647,0,-0.454696,0.602819,0.026127,0.79745,0.602819,0.026127,0.79745,0.602819,0.026127,0.79745,0.00159,0.999998,-0.000816,0.00159,0.999998,-0.000816,0.00159,0.999998,-0.000816,0.706279,-0.000031,-0.707933,0.706279,-0.000031,-0.707933,0.706279,-0.000031,-0.707933,0.706201,0,-0.708012,0.706201,0,-0.708012,0.706201,0,-0.708012,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0.156087,0,-0.987743,0.156087,0,-0.987743,0.156087,0,-0.987743,0.156087,0,-0.987743,0.156087,0,-0.987743,0.156087,0,-0.987743,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.453118,0,-0.89145,0.453118,0,-0.89145,0.453118,0,-0.89145,0.453118,0,-0.89145,0.453118,0,-0.89145,0.453118,0,-0.89145,-0.453279,0,-0.891369,-0.453279,0,-0.891369,-0.453279,0,-0.891369,-0.156119,0,-0.987738,-0.156119,0,-0.987738,-0.156119,0,-0.987738,-0.156119,0,-0.987738,-0.156119,0,-0.987738,-0.156119,0,-0.987738,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0.890665,0,-0.454661,0.890665,0,-0.454661,0.890665,0,-0.454661,0.987626,0,-0.156827,0.987626,0,-0.156827,0.987626,0,-0.156827,0.987626,0,-0.156827,0.987626,0,-0.156827,0.987626,0,-0.156827,0.987657,0,0.156629,0.987657,0,0.156629,0.987657,0,0.156629,0.987657,0,0.156629,0.987657,0,0.156629,0.987657,0,0.156629,0.890541,0,0.454904,0.890541,0,0.454904,0.890541,0,0.454904,0.890541,0,0.454904,0.890541,0,0.454904,0.890541,0,0.454904,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.890665,0,-0.454661,0.890665,0,-0.454661,0.890665,0,-0.454661,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0.98763,0,-0.156804,0.98763,0,-0.156804,0.98763,0,-0.156804,0.987633,0,0.156781,0.987633,0,0.156781,0.987633,0,0.156781,0.987654,0.000077,0.156651,0.987654,0.000077,0.156651,0.987654,0.000077,0.156651,0.987779,0,0.155859,0.987779,0,0.155859,0.987779,0,0.155859,0.987553,-0.014629,0.156602,0.987553,-0.014629,0.156602,0.987553,-0.014629,0.156602,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.70622,0,-0.707993,0.70622,0,-0.707993,0.70622,0,-0.707993,0.70622,0,-0.707993,0.70622,0,-0.707993,0.70622,0,-0.707993,-0.70622,0,-0.707993,-0.70622,0,-0.707993,-0.70622,0,-0.707993,-0.453299,0,-0.891359,-0.453299,0,-0.891359,-0.453299,0,-0.891359,-0.70622,0,-0.707993,-0.70622,0,-0.707993,-0.70622,0,-0.707993,-0.706219,0,0.707993,-0.706219,0,0.707993,-0.706219,0,0.707993,-0.706219,0,0.707993,-0.706219,0,0.707993,-0.706219,0,0.707993,-0.890633,0,-0.454723,-0.890633,0,-0.454723,-0.890633,0,-0.454723,-0.890633,0,-0.454723,-0.890633,0,-0.454723,-0.890633,0,-0.454723,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987613,0,-0.15691,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.987604,0,0.156965,-0.890706,0,0.45458,-0.890706,0,0.45458,-0.890706,0,0.45458,-0.890706,0,0.45458,-0.890706,0,0.45458,-0.890706,0,0.45458,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.155889,0,-0.987775,0.155889,0,-0.987775,0.155889,0,-0.987775,0.155889,0,-0.987775,0.155889,0,-0.987775,0.155889,0,-0.987775,-0.155944,0,-0.987766,-0.155944,0,-0.987766,-0.155944,0,-0.987766,-0.155944,0,-0.987766,-0.155944,0,-0.987766,-0.155944,0,-0.987766,-0.453299,0,-0.891359,-0.453299,0,-0.891359,-0.453299,0,-0.891359,-0.453193,-0.000082,0.891412,-0.453193,-0.000082,0.891412,-0.453193,-0.000082,0.891412,-0.796195,0.026335,-0.604466,-0.796195,0.026335,-0.604466,-0.796195,0.026335,-0.604466,-0.796196,0.026338,-0.604466,-0.796196,0.026338,-0.604466,-0.796196,0.026338,-0.604466,-0.890521,0.000085,0.454943,-0.890521,0.000085,0.454943,-0.890521,0.000085,0.454943,-0.085654,0.016543,0.996188,-0.085654,0.016543,0.996188,-0.085654,0.016543,0.996188,-0.881626,-0.14081,0.450453,-0.881626,-0.14081,0.450453,-0.881626,-0.14081,0.450453,0.001601,0.999999,-0.000117,0.001601,0.999999,-0.000117,0.001601,0.999999,-0.000117,-0.890554,0,0.454878,-0.890554,0,0.454878,-0.890554,0,0.454878,-0.001566,-0.999999,-0.000247,-0.001566,-0.999999,-0.000247,-0.001566,-0.999999,-0.000247,-0.987662,0,0.156602,-0.987662,0,0.156602,-0.987662,0,0.156602,-0.085672,0.016591,0.996185,-0.085672,0.016591,0.996185,-0.085672,0.016591,0.996185,0.001383,0.999999,0.00046,0.001383,0.999999,0.00046,0.001383,0.999999,0.00046,-0.987645,-0.000092,0.15671,-0.987645,-0.000092,0.15671,-0.987645,-0.000092,0.15671,-0.890471,0.007881,0.454972,-0.890471,0.007881,0.454972,-0.890471,0.007881,0.454972,-0.987544,0.015484,0.156579,-0.987544,0.015484,0.156579,-0.987544,0.015484,0.156579,0.453299,0,0.891359,0.453299,0,0.891359,0.453299,0,0.891359,0.453299,0,0.891359,0.453299,0,0.891359,0.453299,0,0.891359,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,0.156235,0,0.98772,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.15629,0,0.987711,-0.453299,0,0.891359,-0.453299,0,0.891359,-0.453299,0,0.891359,-0.453299,0,0.891359,-0.453299,0,0.891359,-0.453299,0,0.891359,0.890489,0,0.455005,0.890489,0,0.455005,0.890489,0,0.455005,0.890489,0,0.455005,0.890489,0,0.455005,0.890489,0,0.455005,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,-0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,0.706397,0,0.707816,-0.890489,0,0.455005,-0.890489,0,0.455005,-0.890489,0,0.455005,-0.890489,0,0.455005,-0.890489,0,0.455005,-0.890489,0,0.455005,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.453299,0,-0.891358,0.890563,0,-0.454861,0.890563,0,-0.454861,0.890563,0,-0.454861,0.890563,0,-0.454861,0.890563,0,-0.454861,0.890563,0,-0.454861,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.706397,0,-0.707816,0.156006,0,-0.987756,0.156006,0,-0.987756,0.156006,0,-0.987756,0.155896,-0.000087,-0.987774,0.155896,-0.000087,-0.987774,0.155896,-0.000087,-0.987774,0.155854,0.000392,-0.98778,0.155854,0.000392,-0.98778,0.155854,0.000392,-0.98778,0.155888,-0.026989,-0.987406,0.155888,-0.026989,-0.987406,0.155888,-0.026989,-0.987406,0.156443,0,-0.987687,0.156443,0,-0.987687,0.156443,0,-0.987687,-0.890562,0,-0.454861,-0.890562,0,-0.454861,-0.890562,0,-0.454861,-0.155886,-0.006597,-0.987753,-0.155886,-0.006597,-0.987753,-0.155886,-0.006597,-0.987753,0.155943,0.004351,-0.987756,0.155943,0.004351,-0.987756,0.155943,0.004351,-0.987756,0.156171,0,-0.98773,0.156171,0,-0.98773,0.156171,0,-0.98773,-0.890562,0,-0.454861,-0.890562,0,-0.454861,-0.890562,0,-0.454861,-0.155881,-0.010454,-0.98772,-0.155881,-0.010454,-0.98772,-0.155881,-0.010454,-0.98772,-0.156082,0,-0.987744,-0.156082,0,-0.987744,-0.156082,0,-0.987744,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.706397,0,-0.707816,-0.000291,-0.999998,0.00184,-0.000291,-0.999998,0.00184,-0.000291,-0.999998,0.00184,-0.000243,-0.999999,0.001543,-0.000243,-0.999999,0.001543,-0.000243,-0.999999,0.001543,-0.000245,0.999999,-0.001554,-0.000245,0.999999,-0.001554,-0.000245,0.999999,-0.001554,0.000008,0.999999,-0.001577,0.000008,0.999999,-0.001577,0.000008,0.999999,-0.001577,0.996156,0.016341,0.086062,0.996156,0.016341,0.086062,0.996156,0.016341,0.086062,0.000261,0.999999,-0.001647,0.000261,0.999999,-0.001647,0.000261,0.999999,-0.001647,0.000253,0.999999,-0.001602,0.000253,0.999999,-0.001602,0.000253,0.999999,-0.001602,-0.996153,0.016667,0.086031,-0.996153,0.016667,0.086031,-0.996153,0.016667,0.086031,-0.99615,0.016709,0.086053,-0.99615,0.016709,0.086053,-0.99615,0.016709,0.086053,-0.996143,0.016174,0.086236,-0.996143,0.016174,0.086236,-0.996143,0.016174,0.086236,-0.996151,0.016698,0.086051,-0.996151,0.016698,0.086051,-0.996151,0.016698,0.086051,-0.996153,0.016647,0.086031,-0.996153,0.016647,0.086031,-0.996153,0.016647,0.086031,0.000267,-0.999999,0.001694,0.000267,-0.999999,0.001694,0.000267,-0.999999,0.001694,-0.996151,0.016516,0.086083,-0.996151,0.016516,0.086083,-0.996151,0.016516,0.086083,0.155964,0.000519,0.987763,0.155964,0.000519,0.987763,0.155964,0.000519,0.987763,0.15582,0,0.987786,0.15582,0,0.987786,0.15582,0,0.987786,0.1559,-0.016406,0.987637,0.1559,-0.016406,0.987637,0.1559,-0.016406,0.987637,0.00028,-0.999999,0.001599,0.00028,-0.999999,0.001599,0.00028,-0.999999,0.001599,0.000251,-0.999999,0.001591,0.000251,-0.999999,0.001591,0.000251,-0.999999,0.001591,0.155817,0,0.987786,0.155817,0,0.987786,0.155817,0,0.987786,0.155848,-0.000037,0.987781,0.155848,-0.000037,0.987781,0.155848,-0.000037,0.987781,0.155912,-0.010607,0.987714,0.155912,-0.010607,0.987714,0.155912,-0.010607,0.987714,0.453279,0,0.891369,0.453279,0,0.891369,0.453279,0,0.891369,0.453279,0,0.891369,0.453279,0,0.891369,0.453279,0,0.891369,0.99615,0.016278,0.086137,0.99615,0.016278,0.086137,0.99615,0.016278,0.086137,0.996163,0.015736,0.086089,0.996163,0.015736,0.086089,0.996163,0.015736,0.086089,-0.000264,0.999999,-0.00167,-0.000264,0.999999,-0.00167,-0.000264,0.999999,-0.00167,0.99615,0.016572,0.086081,0.99615,0.016572,0.086081,0.99615,0.016572,0.086081,0.156112,0,0.987739,0.156112,0,0.987739,0.156112,0,0.987739],"normalized":false}},"boundingSphere":{"center":[10,-52.856998,-11],"radius":35.843679}}},{"uuid":"456D2BF6-DCA8-4DBC-BFF4-DE08D2EF1334","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-50,50,50,-50,50,-50,-50,-50,-50,-50,50,50,-50,-50,-50,-50,-50,50,50,-50,-50,-50,-50,-50,-50,50,-50,-50,50,-50,50,50,-50,50,-50,-50,50,50,-50,50,50,50,50,-50,50,50,50,-50,50,-50,50,50,-50,-50,-50,-50,-50,50,-50,-50,50,-50,50,50,50,50,-50,-50,50,50,-50,50,-50,50,-50,-50,50,50,50,50,-50,50,50,50,-50,50,50,-50,-50,50,50,-50,50,-50,-50,50,-50,-50,-50,50,50,50,50,50,-50,-50,50,50],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0],"normalized":false}},"boundingSphere":{"center":[0,0,0],"radius":86.60254}}},{"uuid":"10D872D0-8E82-4188-BE92-CE356A2843E6","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[31.681999,-54.957001,-34.939999,32.768002,-54.856998,-33.8564,33.926998,-54.957001,-32.700001,33.858799,-54.856998,-32.768002,33.926998,-54.957001,-32.700001,32.768002,-54.856998,-33.8564,33.926998,-54.856998,-32.700001,33.926998,-54.957001,-32.700001,33.858799,-54.856998,-32.768002,35.368999,-54.856998,-29.877001,35.368999,-54.957001,-29.877001,33.926998,-54.957001,-32.700001,35.368999,-54.856998,-29.877001,33.926998,-54.957001,-32.700001,33.926998,-54.856998,-32.700001,35.865002,-54.856998,-26.747999,35.865002,-54.957001,-26.747999,35.368999,-54.957001,-29.877001,35.865002,-54.856998,-26.747999,35.368999,-54.957001,-29.877001,35.368999,-54.856998,-29.877001,35.368999,-54.856998,-23.618,35.368999,-54.957001,-23.618,35.865002,-54.957001,-26.747999,35.368999,-54.856998,-23.618,35.865002,-54.957001,-26.747999,35.865002,-54.856998,-26.747999,33.926998,-54.856998,-20.795,33.926998,-54.957001,-20.795,35.368999,-54.957001,-23.618,33.926998,-54.856998,-20.795,35.368999,-54.957001,-23.618,35.368999,-54.856998,-23.618,31.681999,-54.957001,-18.555,33.926998,-54.957001,-20.795,32.768002,-54.856998,-19.638599,33.926998,-54.856998,-20.795,32.768002,-54.856998,-19.638599,33.926998,-54.957001,-20.795,28.853001,-54.856998,-36.379002,28.853001,-54.957001,-36.379002,25.716999,-54.957001,-36.874001,28.853001,-54.856998,-36.379002,25.716999,-54.957001,-36.874001,25.716999,-54.856998,-36.874001,31.681999,-54.856998,-34.939999,31.681999,-54.957001,-34.939999,28.853001,-54.957001,-36.379002,31.681999,-54.856998,-34.939999,28.853001,-54.957001,-36.379002,28.853001,-54.856998,-36.379002,31.681999,-54.957001,-34.939999,31.681999,-54.856998,-34.939999,32.768002,-54.856998,-33.8564,32.768002,-54.856998,-19.638599,31.681999,-54.856998,-18.555,31.681999,-54.957001,-18.555,31.681999,-54.856998,-18.555,28.853001,-54.856998,-17.117001,28.853001,-54.957001,-17.117001,31.681999,-54.856998,-18.555,28.853001,-54.957001,-17.117001,31.681999,-54.957001,-18.555,28.853001,-54.856998,-17.117001,25.716999,-54.856998,-16.621,25.716999,-54.957001,-16.621,28.853001,-54.856998,-17.117001,25.716999,-54.957001,-16.621,28.853001,-54.957001,-17.117001,25.716999,-54.856998,-16.621,22.580999,-54.856998,-17.117001,22.580999,-54.957001,-17.117001,25.716999,-54.856998,-16.621,22.580999,-54.957001,-17.117001,25.716999,-54.957001,-16.621,22.580999,-54.856998,-17.117001,19.752001,-54.856998,-18.555,19.752001,-54.957001,-18.555,22.580999,-54.856998,-17.117001,19.752001,-54.957001,-18.555,22.580999,-54.957001,-17.117001,19.752001,-54.856998,-18.555,17.506001,-54.856998,-20.795,17.506001,-54.957001,-20.795,19.752001,-54.856998,-18.555,17.506001,-54.957001,-20.795,19.752001,-54.957001,-18.555,17.506001,-54.856998,-20.795,16.065001,-54.856998,-23.618,16.065001,-54.957001,-23.618,17.506001,-54.856998,-20.795,16.065001,-54.957001,-23.618,17.506001,-54.957001,-20.795,16.065001,-54.856998,-23.618,15.568,-54.856998,-26.747999,15.568,-54.957001,-26.747999,16.065001,-54.856998,-23.618,15.568,-54.957001,-26.747999,16.065001,-54.957001,-23.618,15.568,-54.957001,-26.747999,15.568,-54.856998,-26.747999,16.065001,-54.856998,-29.877001,15.568,-54.957001,-26.747999,16.065001,-54.856998,-29.877001,16.065001,-54.957001,-29.877001,16.065001,-54.856998,-29.877001,17.506001,-54.856998,-32.700001,17.506001,-54.957001,-32.700001,16.065001,-54.856998,-29.877001,17.506001,-54.957001,-32.700001,16.065001,-54.957001,-29.877001,19.752001,-54.856998,-34.939999,19.752001,-54.957001,-34.939999,17.506001,-54.957001,-32.700001,19.752001,-54.856998,-34.939999,17.506001,-54.957001,-32.700001,17.506001,-54.856998,-32.700001,19.752001,-54.957001,-34.939999,19.752001,-54.856998,-34.939999,22.580999,-54.957001,-36.379002,22.580999,-54.856998,-36.379002,22.580999,-54.957001,-36.379002,19.752001,-54.856998,-34.939999,25.716999,-54.957001,-36.874001,22.580999,-54.957001,-36.379002,22.580999,-54.856998,-36.379002,25.716999,-54.957001,-36.874001,22.580999,-54.856998,-36.379002,25.716999,-54.856998,-36.874001,25.716999,-50.856998,-36.874001,22.580999,-50.856998,-36.379002,19.752001,-50.856998,-34.939999,25.716999,-50.856998,-36.874001,19.752001,-50.856998,-34.939999,17.506001,-50.856998,-32.700001,25.716999,-50.856998,-36.874001,17.506001,-50.856998,-32.700001,16.065001,-50.856998,-29.877001,25.716999,-50.856998,-36.874001,16.065001,-50.856998,-29.877001,15.568,-50.856998,-26.747999,25.716999,-50.856998,-36.874001,15.568,-50.856998,-26.747999,16.065001,-50.856998,-23.618,25.716999,-50.856998,-36.874001,16.065001,-50.856998,-23.618,17.506001,-50.856998,-20.795,25.716999,-50.856998,-36.874001,17.506001,-50.856998,-20.795,19.752001,-50.856998,-18.555,25.716999,-50.856998,-36.874001,19.752001,-50.856998,-18.555,22.580999,-50.856998,-17.117001,25.716999,-50.856998,-36.874001,22.580999,-50.856998,-17.117001,25.716999,-50.856998,-16.621,25.716999,-50.856998,-36.874001,25.716999,-50.856998,-16.621,28.853001,-50.856998,-17.117001,25.716999,-50.856998,-36.874001,28.853001,-50.856998,-17.117001,31.681999,-50.856998,-18.555,25.716999,-50.856998,-36.874001,31.681999,-50.856998,-18.555,32.768002,-50.856998,-19.638599,32.768002,-50.856998,-33.8564,31.681999,-50.856998,-34.939999,32.768002,-50.856998,-19.638599,31.681999,-50.856998,-34.939999,28.853001,-50.856998,-36.379002,32.768002,-50.856998,-19.638599,25.716999,-50.856998,-36.874001,32.768002,-50.856998,-19.638599,28.853001,-50.856998,-36.379002,33.926998,-54.957001,-20.795,32.254002,-54.957001,-23.84,35.368999,-54.957001,-23.618,31.681999,-54.957001,-18.555,30.757,-54.957001,-22.347,33.926998,-54.957001,-20.795,35.865002,-54.957001,-26.747999,35.368999,-54.957001,-23.618,33.215,-54.957001,-25.722,35.865002,-54.957001,-26.747999,33.546001,-54.957001,-27.809,35.368999,-54.957001,-29.877001,32.768002,-54.957001,-30.770399,35.368999,-54.957001,-29.877001,33.215,-54.957001,-29.895,33.215,-54.957001,-29.895,35.368999,-54.957001,-29.877001,33.546001,-54.957001,-27.809,33.215,-54.957001,-25.722,35.368999,-54.957001,-23.618,32.768002,-54.957001,-24.8466,33.546001,-54.957001,-27.809,35.865002,-54.957001,-26.747999,33.215,-54.957001,-25.722,16.065001,-54.957001,-23.618,15.568,-54.957001,-26.747999,20.346001,-54.957001,-25.722,20.014,-54.957001,-27.809,20.346001,-54.957001,-25.722,15.568,-54.957001,-26.747999,16.065001,-54.957001,-29.877001,20.014,-54.957001,-27.809,15.568,-54.957001,-26.747999,17.506001,-54.957001,-32.700001,20.346001,-54.957001,-29.895,16.065001,-54.957001,-29.877001,19.752001,-54.957001,-34.939999,21.306999,-54.957001,-31.777,17.506001,-54.957001,-32.700001,20.346001,-54.957001,-25.722,21.306999,-54.957001,-23.84,16.065001,-54.957001,-23.618,31.681999,-54.957001,-34.939999,28.871,-54.957001,-34.229,28.853001,-54.957001,-36.379002,25.716999,-54.957001,-36.874001,28.853001,-54.957001,-36.379002,26.780001,-54.957001,-34.560001,26.780001,-54.957001,-34.560001,24.688999,-54.957001,-34.229,25.716999,-54.957001,-36.874001,22.580999,-54.957001,-36.379002,25.716999,-54.957001,-36.874001,24.688999,-54.957001,-34.229,24.688999,-54.957001,-34.229,22.802999,-54.957001,-33.27,22.580999,-54.957001,-36.379002,28.853001,-54.957001,-17.117001,25.716999,-54.957001,-16.621,26.780001,-54.957001,-21.056999,24.688999,-54.957001,-21.388,26.780001,-54.957001,-21.056999,25.716999,-54.957001,-16.621,22.580999,-54.957001,-17.117001,24.688999,-54.957001,-21.388,25.716999,-54.957001,-16.621,19.752001,-54.957001,-18.555,22.802999,-54.957001,-22.347,22.580999,-54.957001,-17.117001,26.780001,-54.957001,-21.056999,28.871,-54.957001,-21.388,28.853001,-54.957001,-17.117001,31.681999,-54.957001,-18.555,28.853001,-54.957001,-17.117001,28.871,-54.957001,-21.388,31.681999,-54.957001,-18.555,28.871,-54.957001,-21.388,30.757,-54.957001,-22.347,32.254002,-54.957001,-31.777,33.926998,-54.957001,-32.700001,32.768002,-54.957001,-30.770399,31.2603,-54.957001,-32.768002,33.926998,-54.957001,-32.700001,32.254002,-54.957001,-31.777,35.368999,-54.957001,-29.877001,32.768002,-54.957001,-30.770399,33.926998,-54.957001,-32.700001,32.768002,-54.957001,-24.8466,35.368999,-54.957001,-23.618,32.254002,-54.957001,-23.84,32.254002,-54.957001,-23.84,33.926998,-54.957001,-20.795,30.757,-54.957001,-22.347,24.688999,-54.957001,-21.388,22.580999,-54.957001,-17.117001,22.802999,-54.957001,-22.347,22.802999,-54.957001,-22.347,19.752001,-54.957001,-18.555,21.306999,-54.957001,-23.84,19.752001,-54.957001,-18.555,17.506001,-54.957001,-20.795,21.306999,-54.957001,-23.84,17.506001,-54.957001,-20.795,16.065001,-54.957001,-23.618,21.306999,-54.957001,-23.84,20.014,-54.957001,-27.809,16.065001,-54.957001,-29.877001,20.346001,-54.957001,-29.895,20.346001,-54.957001,-29.895,17.506001,-54.957001,-32.700001,21.306999,-54.957001,-31.777,33.926998,-54.957001,-32.700001,31.2603,-54.957001,-32.768002,31.681999,-54.957001,-34.939999,26.780001,-54.957001,-34.560001,28.853001,-54.957001,-36.379002,28.871,-54.957001,-34.229,28.871,-54.957001,-34.229,31.681999,-54.957001,-34.939999,30.757,-54.957001,-33.27,30.757,-54.957001,-33.27,31.681999,-54.957001,-34.939999,31.2603,-54.957001,-32.768002,21.306999,-54.957001,-31.777,19.752001,-54.957001,-34.939999,22.802999,-54.957001,-33.27,19.752001,-54.957001,-34.939999,22.580999,-54.957001,-36.379002,22.802999,-54.957001,-33.27,35.368999,-50.856998,-23.618,35.865002,-50.856998,-26.747999,33.926998,-50.856998,-20.795,35.865002,-50.856998,-26.747999,35.368999,-50.856998,-29.877001,33.926998,-50.856998,-20.795,35.368999,-50.856998,-29.877001,33.926998,-50.856998,-32.700001,33.926998,-50.856998,-20.795,32.768002,-50.856998,-19.638599,33.926998,-50.856998,-20.795,33.926998,-50.856998,-32.700001,32.768002,-50.856998,-19.638599,33.926998,-50.856998,-32.700001,33.858799,-50.856998,-32.768002,32.768002,-50.856998,-19.638599,33.858799,-50.856998,-32.768002,32.768002,-50.856998,-33.8564,25.318001,-55.157001,-23.73,24.794001,-55.157001,-23.464001,25.318001,-55.157001,-26.764,25.733999,-55.157001,-24.145,25.318001,-55.157001,-23.73,25.318001,-55.157001,-26.764,24.794001,-55.157001,-27.031,25.318001,-55.157001,-26.764,24.794001,-55.157001,-23.464001,26.000999,-55.157001,-24.667999,25.733999,-55.157001,-24.145,25.318001,-55.157001,-26.764,26.093,-55.157001,-25.247,26.000999,-55.157001,-24.667999,25.318001,-55.157001,-26.764,25.733999,-55.157001,-26.35,26.000999,-55.157001,-25.827,25.318001,-55.157001,-26.764,26.093,-55.157001,-25.247,25.318001,-55.157001,-26.764,26.000999,-55.157001,-25.827,24.794001,-55.157001,-27.031,24.794001,-55.157001,-23.464001,24.212999,-55.157001,-27.122999,24.794001,-55.157001,-23.464001,24.212999,-55.157001,-23.372,24.212999,-55.157001,-27.122999,24.212999,-55.157001,-23.372,23.632999,-55.157001,-23.464001,24.212999,-55.157001,-27.122999,23.632999,-55.157001,-27.031,24.212999,-55.157001,-27.122999,23.632999,-55.157001,-23.464001,23.108999,-55.157001,-23.73,23.108999,-55.157001,-26.764,23.632999,-55.157001,-23.464001,22.693001,-55.157001,-24.145,23.108999,-55.157001,-26.764,23.108999,-55.157001,-23.73,22.426001,-55.157001,-24.667999,23.108999,-55.157001,-26.764,22.693001,-55.157001,-24.145,22.334,-55.157001,-25.247,23.108999,-55.157001,-26.764,22.426001,-55.157001,-24.667999,22.426001,-55.157001,-25.827,23.108999,-55.157001,-26.764,22.334,-55.157001,-25.247,22.693001,-55.157001,-26.35,23.108999,-55.157001,-26.764,22.426001,-55.157001,-25.827,23.632999,-55.157001,-27.031,23.632999,-55.157001,-23.464001,23.108999,-55.157001,-26.764,24.794001,-55.056999,-27.031,24.794001,-55.157001,-27.031,24.576,-55.056999,-27.0655,25.318001,-55.056999,-26.764,25.318001,-55.157001,-26.764,24.794001,-55.157001,-27.031,25.318001,-55.056999,-26.764,24.794001,-55.157001,-27.031,24.794001,-55.056999,-27.031,25.733999,-55.056999,-26.35,25.733999,-55.157001,-26.35,25.318001,-55.157001,-26.764,25.733999,-55.056999,-26.35,25.318001,-55.157001,-26.764,25.318001,-55.056999,-26.764,26.000999,-55.056999,-25.827,26.000999,-55.157001,-25.827,25.733999,-55.157001,-26.35,26.000999,-55.056999,-25.827,25.733999,-55.157001,-26.35,25.733999,-55.056999,-26.35,26.093,-55.056999,-25.247,26.093,-55.157001,-25.247,26.000999,-55.157001,-25.827,26.093,-55.056999,-25.247,26.000999,-55.157001,-25.827,26.000999,-55.056999,-25.827,26.000999,-55.056999,-24.667999,26.000999,-55.157001,-24.667999,26.093,-55.157001,-25.247,26.000999,-55.056999,-24.667999,26.093,-55.157001,-25.247,26.093,-55.056999,-25.247,25.733999,-55.056999,-24.145,25.733999,-55.157001,-24.145,26.000999,-55.157001,-24.667999,25.733999,-55.056999,-24.145,26.000999,-55.157001,-24.667999,26.000999,-55.056999,-24.667999,25.733999,-55.056999,-24.145,25.318001,-55.056999,-23.73,25.318001,-55.157001,-23.73,25.733999,-55.056999,-24.145,25.318001,-55.157001,-23.73,25.733999,-55.157001,-24.145,25.318001,-55.056999,-23.73,24.794001,-55.056999,-23.464001,24.794001,-55.157001,-23.464001,25.318001,-55.056999,-23.73,24.794001,-55.157001,-23.464001,25.318001,-55.157001,-23.73,24.794001,-55.056999,-23.464001,24.576,-55.056999,-23.429501,24.794001,-55.157001,-23.464001,24.212999,-55.056999,-27.122999,24.576,-55.056999,-27.0655,24.212999,-55.157001,-27.122999,24.794001,-55.157001,-27.031,24.212999,-55.157001,-27.122999,24.576,-55.056999,-27.0655,24.576,-55.056999,-23.429501,24.212999,-55.056999,-23.372,24.212999,-55.157001,-23.372,24.576,-55.056999,-23.429501,24.212999,-55.157001,-23.372,24.794001,-55.157001,-23.464001,24.212999,-55.056999,-23.372,23.632999,-55.056999,-23.464001,23.632999,-55.157001,-23.464001,24.212999,-55.056999,-23.372,23.632999,-55.157001,-23.464001,24.212999,-55.157001,-23.372,23.632999,-55.056999,-23.464001,23.108999,-55.056999,-23.73,23.108999,-55.157001,-23.73,23.632999,-55.056999,-23.464001,23.108999,-55.157001,-23.73,23.632999,-55.157001,-23.464001,23.108999,-55.056999,-23.73,22.693001,-55.056999,-24.145,22.693001,-55.157001,-24.145,23.108999,-55.056999,-23.73,22.693001,-55.157001,-24.145,23.108999,-55.157001,-23.73,22.693001,-55.056999,-24.145,22.426001,-55.056999,-24.667999,22.426001,-55.157001,-24.667999,22.693001,-55.056999,-24.145,22.426001,-55.157001,-24.667999,22.693001,-55.157001,-24.145,22.426001,-55.056999,-24.667999,22.334,-55.056999,-25.247,22.334,-55.157001,-25.247,22.426001,-55.056999,-24.667999,22.334,-55.157001,-25.247,22.426001,-55.157001,-24.667999,22.334,-55.157001,-25.247,22.334,-55.056999,-25.247,22.426001,-55.056999,-25.827,22.334,-55.157001,-25.247,22.426001,-55.056999,-25.827,22.426001,-55.157001,-25.827,22.426001,-55.056999,-25.827,22.693001,-55.056999,-26.35,22.693001,-55.157001,-26.35,22.426001,-55.056999,-25.827,22.693001,-55.157001,-26.35,22.426001,-55.157001,-25.827,23.108999,-55.056999,-26.764,23.108999,-55.157001,-26.764,22.693001,-55.157001,-26.35,23.108999,-55.056999,-26.764,22.693001,-55.157001,-26.35,22.693001,-55.056999,-26.35,23.632999,-55.056999,-27.031,23.632999,-55.157001,-27.031,23.108999,-55.157001,-26.764,23.632999,-55.056999,-27.031,23.108999,-55.157001,-26.764,23.108999,-55.056999,-26.764,24.212999,-55.157001,-27.122999,23.632999,-55.157001,-27.031,23.632999,-55.056999,-27.031,24.212999,-55.157001,-27.122999,23.632999,-55.056999,-27.031,24.212999,-55.056999,-27.122999],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0.706318,0.000113,-0.707895,0.706318,0.000113,-0.707895,0.706318,0.000113,-0.707895,0.706328,0.000342,-0.707885,0.706328,0.000342,-0.707885,0.706328,0.000342,-0.707885,0.706076,0,-0.708136,0.706076,0,-0.708136,0.706076,0,-0.708136,0.890545,0,-0.454895,0.890545,0,-0.454895,0.890545,0,-0.454895,0.890545,0,-0.454895,0.890545,0,-0.454895,0.890545,0,-0.454895,0.987668,0,-0.156563,0.987668,0,-0.156563,0.987668,0,-0.156563,0.987668,0,-0.156563,0.987668,0,-0.156563,0.987668,0,-0.156563,0.987676,0,0.156514,0.987676,0,0.156514,0.987676,0,0.156514,0.987676,0,0.156514,0.987676,0,0.156514,0.987676,0,0.156514,0.890545,0,0.454895,0.890545,0,0.454895,0.890545,0,0.454895,0.890545,0,0.454895,0.890545,0,0.454895,0.890545,0,0.454895,0.706318,0.000107,0.707895,0.706318,0.000107,0.707895,0.706318,0.000107,0.707895,0.706314,0,0.707899,0.706314,0,0.707899,0.706314,0,0.707899,0.155914,0,-0.987771,0.155914,0,-0.987771,0.155914,0,-0.987771,0.155914,0,-0.987771,0.155914,0,-0.987771,0.155914,0,-0.987771,0.453379,0,-0.891318,0.453379,0,-0.891318,0.453379,0,-0.891318,0.453379,0,-0.891318,0.453379,0,-0.891318,0.453379,0,-0.891318,0.706323,0,-0.70789,0.706323,0,-0.70789,0.706323,0,-0.70789,0.706323,0,0.70789,0.706323,0,0.70789,0.706323,0,0.70789,0.453128,0,0.891445,0.453128,0,0.891445,0.453128,0,0.891445,0.453128,0,0.891445,0.453128,0,0.891445,0.453128,0,0.891445,0.156221,0,0.987722,0.156221,0,0.987722,0.156221,0,0.987722,0.156221,0,0.987722,0.156221,0,0.987722,0.156221,0,0.987722,-0.156221,0,0.987722,-0.156221,0,0.987722,-0.156221,0,0.987722,-0.156221,0,0.987722,-0.156221,0,0.987722,-0.156221,0,0.987722,-0.453128,0,0.891445,-0.453128,0,0.891445,-0.453128,0,0.891445,-0.453128,0,0.891445,-0.453128,0,0.891445,-0.453128,0,0.891445,-0.70616,0,0.708052,-0.70616,0,0.708052,-0.70616,0,0.708052,-0.70616,0,0.708052,-0.70616,0,0.708052,-0.70616,0,0.708052,-0.890673,0,0.454644,-0.890673,0,0.454644,-0.890673,0,0.454644,-0.890673,0,0.454644,-0.890673,0,0.454644,-0.890673,0,0.454644,-0.987627,0,0.156822,-0.987627,0,0.156822,-0.987627,0,0.156822,-0.987627,0,0.156822,-0.987627,0,0.156822,-0.987627,0,0.156822,-0.987619,0,-0.15687,-0.987619,0,-0.15687,-0.987619,0,-0.15687,-0.987619,0,-0.15687,-0.987619,0,-0.15687,-0.987619,0,-0.15687,-0.890673,0,-0.454644,-0.890673,0,-0.454644,-0.890673,0,-0.454644,-0.890673,0,-0.454644,-0.890673,0,-0.454644,-0.890673,0,-0.454644,-0.70616,0,-0.708052,-0.70616,0,-0.708052,-0.70616,0,-0.708052,-0.70616,0,-0.708052,-0.70616,0,-0.708052,-0.70616,0,-0.708052,-0.453379,0,-0.891318,-0.453379,0,-0.891318,-0.453379,0,-0.891318,-0.453379,0,-0.891318,-0.453379,0,-0.891318,-0.453379,0,-0.891318,-0.155914,0,-0.987771,-0.155914,0,-0.987771,-0.155914,0,-0.987771,-0.155914,0,-0.987771,-0.155914,0,-0.987771,-0.155914,0,-0.987771,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0.156312,0,-0.987708,0.156312,0,-0.987708,0.156312,0,-0.987708,0.454002,0,-0.891001,0.454002,0,-0.891001,0.454002,0,-0.891001,0.454002,0,-0.891001,0.454002,0,-0.891001,0.454002,0,-0.891001,0.705402,0,-0.708808,0.705402,0,-0.708808,0.705402,0,-0.708808,0.705402,0,-0.708808,0.705402,0,-0.708808,0.705402,0,-0.708808,0.890649,0,-0.454691,0.890649,0,-0.454691,0.890649,0,-0.454691,0.890649,0,-0.454691,0.890649,0,-0.454691,0.890649,0,-0.454691,0.987652,0,-0.156664,0.987652,0,-0.156664,0.987652,0,-0.156664,0.987652,0,-0.156664,0.987652,0,-0.156664,0.987652,0,-0.156664,0.98761,0,0.156927,0.98761,0,0.156927,0.98761,0,0.156927,0.98761,0,0.156927,0.98761,0,0.156927,0.98761,0,0.156927,0.890649,0,0.454692,0.890649,0,0.454692,0.890649,0,0.454692,0.890649,0,0.454692,0.890649,0,0.454692,0.890649,0,0.454692,0.706257,0,0.707955,0.706257,0,0.707955,0.706257,0,0.707955,0.706257,0,0.707955,0.706257,0,0.707955,0.706257,0,0.707955,0.452649,0,0.891689,0.452649,0,0.891689,0.452649,0,0.891689,0.452649,0,0.891689,0.452649,0,0.891689,0.452649,0,0.891689,0.156312,0,0.987708,0.156312,0,0.987708,0.156312,0,0.987708,0.156448,0,-0.987686,0.156448,0,-0.987686,0.156448,0,-0.987686,0.156397,0.000191,-0.987694,0.156397,0.000191,-0.987694,0.156397,0.000191,-0.987694,0.156453,0,0.987685,0.156453,0,0.987685,0.156453,0,0.987685,0.1564,0.000198,0.987694,0.1564,0.000198,0.987694,0.1564,0.000198,0.987694,-0.156664,0,0.987652,-0.156664,0,0.987652,-0.156664,0,0.987652,-0.156664,0,0.987652,-0.156664,0,0.987652,-0.156664,0,0.987652,-0.452649,0,0.891689,-0.452649,0,0.891689,-0.452649,0,0.891689,-0.452649,0,0.891689,-0.452649,0,0.891689,-0.452649,0,0.891689,-0.706257,0,0.707955,-0.706257,0,0.707955,-0.706257,0,0.707955,-0.706257,0,0.707955,-0.706257,0,0.707955,-0.706257,0,0.707955,-0.890649,0,0.454692,-0.890649,0,0.454692,-0.890649,0,0.454692,-0.890649,0,0.454692,-0.890649,0,0.454692,-0.890649,0,0.454692,-0.98761,0,0.156927,-0.98761,0,0.156927,-0.98761,0,0.156927,-0.98761,0,0.156927,-0.98761,0,0.156927,-0.98761,0,0.156927,-0.987652,0,-0.156664,-0.987652,0,-0.156664,-0.987652,0,-0.156664,-0.987652,0,-0.156664,-0.987652,0,-0.156664,-0.987652,0,-0.156664,-0.890649,0,-0.454691,-0.890649,0,-0.454691,-0.890649,0,-0.454691,-0.890649,0,-0.454691,-0.890649,0,-0.454691,-0.890649,0,-0.454691,-0.705402,0,-0.708808,-0.705402,0,-0.708808,-0.705402,0,-0.708808,-0.705402,0,-0.708808,-0.705402,0,-0.708808,-0.705402,0,-0.708808,-0.454002,0,-0.891001,-0.454002,0,-0.891001,-0.454002,0,-0.891001,-0.454002,0,-0.891001,-0.454002,0,-0.891001,-0.454002,0,-0.891001,-0.156661,0,-0.987652,-0.156661,0,-0.987652,-0.156661,0,-0.987652,-0.156661,0,-0.987652,-0.156661,0,-0.987652,-0.156661,0,-0.987652],"normalized":false}},"boundingSphere":{"center":[25.716501,-53.007,-26.7475],"radius":10.373745}}}],"materials":[{"uuid":"766E3FC2-E78F-4114-9297-CD8662B8A847","type":"MeshLambertMaterial","color":2236962,"emissive":855309,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"B66CF6B1-4689-4738-82B0-50861D300E64","type":"MeshLambertMaterial","color":7981337,"emissive":1184274,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"38DEB71E-D052-4FCD-970B-BC4215AA2664","type":"MeshLambertMaterial","color":16777215,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"12536C28-8D65-43AD-83F3-020582A48119","type":"MeshLambertMaterial","color":16777215,"emissive":2236962,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"4F117387-2F74-41FD-A0DC-4E2595637AE4","type":"Group","name":"logo","matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"79A63A8E-2238-4718-BAFA-20E664F4B286","type":"Mesh","name":"group_0_2829873","receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"AFC7ACE7-52E9-4079-B0BE-500CC3BC0D33","material":"766E3FC2-E78F-4114-9297-CD8662B8A847"},{"uuid":"0484E032-6B8D-4F5B-B314-CF95603808ED","type":"Mesh","name":"group_0_4634441","receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"D683F0D3-E67C-4B74-ACCE-5EA75DF5BBE2","material":"B66CF6B1-4689-4738-82B0-50861D300E64"},{"uuid":"B9CF126F-BB6B-48EF-AB4C-12AD88DF8C83","type":"Mesh","name":"group_0_15277357","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"456D2BF6-DCA8-4DBC-BFF4-DE08D2EF1334","material":"38DEB71E-D052-4FCD-970B-BC4215AA2664"},{"uuid":"58F7DE33-E742-4DDA-AE4E-D924C8C6532D","type":"Mesh","name":"group_0_16448250","receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"10D872D0-8E82-4188-BE92-CE356A2843E6","material":"12536C28-8D65-43AD-83F3-020582A48119"}]}}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"1B9BCCE5-23C5-40D6-A4E8-DF658CFEA3D3","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-12.5,-50,0,-22.5,-50,0,-22.5,-50,-10,-12.5,-50,0,-22.5,-50,-10,-12.5,-50,-10,-12.5,-49.799999,-10,-12.5,-49.799999,0,-12.5,-50,0,-12.5,-49.799999,-10,-12.5,-50,0,-12.5,-50,-10,11.5,-50,0,11.5,-49.799999,0,11.5,-49.799999,-9.7,11.5,-50,0,11.5,-49.799999,-9.7,11.5,-50,-9.7,-12.5,-50,-10,-22.5,-50,-10,-22.5,-49.799999,-10,-12.5,-50,-10,-22.5,-49.799999,-10,-12.5,-49.799999,-10,21.5,-50,0,21.5,-49.799999,0,11.5,-49.799999,0,21.5,-50,0,11.5,-49.799999,0,11.5,-50,0,-22.5,-50,0,-22.5,-49.799999,0,-22.5,-49.799999,-10,-22.5,-50,0,-22.5,-49.799999,-10,-22.5,-50,-10,-12.5,-49.799999,0,-22.5,-49.799999,0,-22.5,-50,0,-12.5,-49.799999,0,-22.5,-50,0,-12.5,-50,0,21.5,-50,0,11.75,-50,-9.7,21.5,-50,-10,11.75,-50,-10,21.5,-50,-10,11.75,-50,-9.7,11.5,-50,-9.7,11.75,-50,-9.7,11.5,-50,0,21.5,-50,0,11.5,-50,0,11.75,-50,-9.7,11.75,-49.799999,-10,21.5,-49.799999,-10,21.5,-50,-10,11.75,-49.799999,-10,21.5,-50,-10,11.75,-50,-10,21.5,-49.799999,-10,21.5,-49.799999,0,21.5,-50,0,21.5,-49.799999,-10,21.5,-50,0,21.5,-50,-10],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0],"normalized":false}},"boundingSphere":{"center":[-0.5,-49.9,-5],"radius":22.56125}}},{"uuid":"B83FE8E1-BA4E-435E-A9C1-41AF200E9460","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[49.5,-50,50,37.5,-50,25,49.5,-50,13,49,13.627,-39,49,49.5,-39,49.5,13.627,-39,49.5,50,-39,49.5,13.627,-39,49,49.5,-39,49.5,50,50,49.5,-20.686001,1,49.5,13.627,-19,37.5,-50,13,49.5,-50,13,37.5,-50,25,49.5,13.627,-39,49.5,50,-39,49.5,13.627,-19,49.5,50,50,49.5,13.627,-19,49.5,50,-39,49.5,-50,13,49.5,-47.941002,13,49.5,-50,50,-50.5,13.627,-39,-50.5,13.627,-19,-50.5,50,-39,-50.5,-20.686001,-19,-50.5,-20.686001,1,-50.5,13.627,-19,-50.5,13.627,-19,-50.5,50,50,-50.5,50,-39,-49,-38.137001,1,-49,-38.137001,-9,-50.5,-38.137001,-9,-49,-38.137001,1,-50.5,-38.137001,-9,-50.5,-38.137001,1,-50.5,-47.941002,13,-50.5,-38.137001,1,-50.5,-47.941002,-9,-50.5,-38.137001,-9,-50.5,-47.941002,-9,-50.5,-38.137001,1,49.5,-50,50,49.5,-47.941002,13,49.5,-20.686001,1,-49,-38.137001,-9,-49,-47.941002,-9,-50.5,-47.941002,-9,-49,-38.137001,-9,-50.5,-47.941002,-9,-50.5,-38.137001,-9,-50.5,-20.686001,1,-50.5,-20.686001,-19,-49,-20.686001,-19,-50.5,-20.686001,1,-49,-20.686001,-19,-49,-20.686001,1,37.5,-48.5,13,49,-48.5,13,37.5,-50,13,-50.5,-38.137001,1,-50.5,-47.941002,13,-50.5,-20.686001,1,-50.5,-47.941002,13,-50.5,-50,50,-50.5,-20.686001,1,-50.5,50,50,-50.5,13.627,-19,-50.5,-20.686001,1,49.5,-47.941002,-9,49.5,-38.137001,-9,49.5,-38.137001,1,49.5,-38.137001,1,49.5,-20.686001,1,49.5,-47.941002,13,49.5,-47.941002,-9,49.5,-38.137001,1,49.5,-47.941002,13,-49,-38.137001,1,-50.5,-38.137001,1,-50.5,-20.686001,1,-49,-38.137001,1,-50.5,-20.686001,1,-49,-20.686001,1,-50.5,50,50,-50.5,-20.686001,1,-50.5,-50,50,-50.5,-50,50,-50.5,-47.941002,13,-50.5,-50,13,-50.5,-50,13,-38.5,-50,13,-38.5,-50,25,49.5,-50,50,49.5,-20.686001,1,49.5,50,50,49.5,-20.686001,-19,49.5,13.627,-19,49.5,-20.686001,1,-50.5,-47.941002,13,-49,-47.941002,13,-49,-48.5,13,-50.5,-47.941002,13,-49,-48.5,13,-50.5,-50,13,-38.5,-50,25,-50.5,-50,50,-50.5,-50,13,-50.5,50,-39,-49,49.5,-39,-50.5,13.627,-39,-50.5,50,-39,49.5,50,-39,-49,49.5,-39,-49,13.627,-39,-50.5,13.627,-39,-49,49.5,-39,-50.5,-50,13,-49,-48.5,13,-38.5,-50,13,-38.5,-48.5,13,-38.5,-50,13,-49,-48.5,13,-38.5,-48.5,13,-38.5,-48.5,25,-38.5,-50,25,-38.5,-48.5,13,-38.5,-50,25,-38.5,-50,13,49.5,-50,50,-50.5,-50,50,-38.5,-50,25,49.5,13.627,-19,49.5,-20.686001,-19,49,-20.686001,-19,49.5,13.627,-19,49,-20.686001,-19,49,13.627,-19,49.5,50,-39,-50.5,50,-39,49.5,50,50,-50.5,50,50,49.5,50,50,-50.5,50,-39,49.5,13.627,-19,49,13.627,-19,49,13.627,-39,49.5,13.627,-19,49,13.627,-39,49.5,13.627,-39,49.5,-50,13,37.5,-50,13,49,-48.5,13,49,-47.941002,13,49.5,-47.941002,13,49,-48.5,13,49.5,-50,13,49,-48.5,13,49.5,-47.941002,13,-50.5,50,50,49.5,-50,50,49.5,50,50,49.5,-47.941002,13,49,-47.941002,13,49,-47.941002,-9,49.5,-47.941002,13,49,-47.941002,-9,49.5,-47.941002,-9,49.5,-50,50,-50.5,50,50,-50.5,-50,50,49.5,-20.686001,1,49.5,-38.137001,1,49,-38.137001,1,49.5,-20.686001,1,49,-38.137001,1,49,-20.686001,1,-50.5,13.627,-19,-50.5,13.627,-39,-49,13.627,-39,-50.5,13.627,-19,-49,13.627,-39,-49,13.627,-19,49.5,-38.137001,-9,49,-38.137001,-9,49,-38.137001,1,49.5,-38.137001,-9,49,-38.137001,1,49.5,-38.137001,1,49.5,-38.137001,-9,49.5,-47.941002,-9,49,-47.941002,-9,49.5,-38.137001,-9,49,-47.941002,-9,49,-38.137001,-9,49.5,-20.686001,1,49,-20.686001,1,49,-20.686001,-19,49.5,-20.686001,1,49,-20.686001,-19,49.5,-20.686001,-19,49.5,50,-39,49,49.5,-39,-49,49.5,-39,37.5,-50,25,49.5,-50,50,-38.5,-50,25,-38.5,-50,25,37.5,-48.5,25,37.5,-50,25,37.5,-48.5,25,-38.5,-50,25,-38.5,-48.5,25,37.5,-50,25,37.5,-48.5,25,37.5,-48.5,13,37.5,-50,25,37.5,-48.5,13,37.5,-50,13,-50.5,13.627,-19,-49,13.627,-19,-49,-20.686001,-19,-50.5,13.627,-19,-49,-20.686001,-19,-50.5,-20.686001,-19,-49,-47.941002,13,-50.5,-47.941002,13,-50.5,-47.941002,-9,-49,-47.941002,13,-50.5,-47.941002,-9,-49,-47.941002,-9],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0],"normalized":false}},"boundingSphere":{"center":[-0.5,0,5.5],"radius":83.54789}}},{"uuid":"39C3BDBC-0F0D-45DE-AC12-5669F146F33F","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-25,-49.799999,-22,-12,-49.799999,-36,-12,-49.799999,-22,25,-49,-50,25,-49,-22,25,-49.799999,-50,25,-49.799999,-50,-12,-49.799999,-36,-25,-49.799999,-50,-25,-49.799999,-50,-25,-49.799999,-22,-25,-49,-22,-25,-49.799999,-50,-25,-49,-22,-25,-49,-50,-25,-49.799999,-22,-12,-49.799999,-22,-25,-49,-22,25,-49,-22,25,-49.799999,-22,25,-49.799999,-50,-25,-49.799999,-50,-12,-49.799999,-36,-25,-49.799999,-22,25,-49,-50,-25,-49,-50,-25,-49,-22,25,-49,-22,12,-49.799999,-22,25,-49.799999,-22,-25,-49,-50,25,-49,-50,25,-49.799999,-50,-25,-49,-50,25,-49.799999,-50,-25,-49.799999,-50,25,-49.799999,-50,25,-49.799999,-22,12,-49.799999,-36,12,-49.799999,-22,12,-49.799999,-36,25,-49.799999,-22,25,-49,-22,-25,-49,-22,12,-49.799999,-22,-12,-49.799999,-22,12,-49.799999,-22,-25,-49,-22,-12,-49.799999,-36,25,-49.799999,-50,12,-49.799999,-36,25,-49,-22,25,-49,-50,-25,-49,-22],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0],"normalized":false}},"boundingSphere":{"center":[0,-49.4,-36],"radius":28.655889}}},{"uuid":"51E1EAB7-C16E-49A1-9B5D-B87478904B8E","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-12.25,-49,-21.700001,11.75,-49,-21.700001,-12.25,-50,-21.700001,-12.25,-49,-9.7,11.5,-49,-9.7,-12.25,-49,-21.700001,11.5,-49,-9.7,11.75,-49,-10,-12.25,-49,-21.700001,11.75,-49,-21.700001,11.75,-49,-10,11.75,-49.799999,-10,11.75,-50,-10,11.75,-50,-21.700001,11.75,-49.799999,-10,11.75,-49,-21.700001,11.75,-49.799999,-10,11.75,-50,-21.700001,11.5,-49,-9.7,-12.25,-49,-9.7,11.5,-49.799999,-9.7,11.5,-50,-9.7,11.5,-49.799999,-9.7,-12.25,-50,-9.7,-12.25,-50,-21.700001,11.75,-50,-21.700001,11.75,-50,-10,11.75,-50,-9.7,11.5,-50,-9.7,11.75,-50,-10,-12.25,-50,-9.7,-12.25,-50,-21.700001,11.5,-50,-9.7,11.75,-50,-10,11.5,-50,-9.7,-12.25,-50,-21.700001,-12.25,-50,-9.7,-12.25,-49,-9.7,-12.25,-49,-21.700001,-12.25,-50,-9.7,-12.25,-49,-21.700001,-12.25,-50,-21.700001,-12.25,-50,-9.7,11.5,-49.799999,-9.7,-12.25,-49,-9.7,11.75,-50,-21.700001,-12.25,-50,-21.700001,11.75,-49,-21.700001,11.75,-49,-21.700001,-12.25,-49,-21.700001,11.75,-49,-10,11.75,-49,-9.7,11.75,-49,-10,11.5,-49,-9.7],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0],"normalized":false}},"boundingSphere":{"center":[-0.25,-49.5,-15.7],"radius":13.425722}}},{"uuid":"DB78FE5E-D8DF-4635-81C3-6CB5676C19B0","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[49,49.5,-50,49,49.5,-39,49,13.627,-39,49,13.627,-39,49,-20.686001,-19,49,-48.5,-50,49,49.5,-50,49,13.627,-39,49,-48.5,-50,49,13.627,-39,49,13.627,-19,49,-20.686001,-19,49,-47.941002,13,49,-48.5,13,49,-47.941002,-9,49,-48.5,13,49,-48.5,-50,49,-47.941002,-9,49,-38.137001,1,49,-38.137001,-9,49,-20.686001,1,49,-20.686001,-19,49,-20.686001,1,49,-38.137001,-9,49,-47.941002,-9,49,-48.5,-50,49,-38.137001,-9,49,-20.686001,-19,49,-38.137001,-9,49,-48.5,-50,-49,-48.5,-50,-49,13.627,-39,-49,49.5,-50,-49,49.5,-39,-49,49.5,-50,-49,13.627,-39,-49,13.627,-39,-49,-20.686001,-19,-49,13.627,-19,-49,-47.941002,13,-49,-47.941002,-9,-49,-48.5,13,-49,-48.5,-50,-49,-48.5,13,-49,-47.941002,-9,-49,-38.137001,1,-49,-20.686001,1,-49,-38.137001,-9,-49,-20.686001,1,-49,-20.686001,-19,-49,-38.137001,-9,-49,-48.5,-50,-49,-38.137001,-9,-49,-20.686001,-19,-49,-38.137001,-9,-49,-48.5,-50,-49,-47.941002,-9,-49,-48.5,-50,-49,-20.686001,-19,-49,13.627,-39,-38.5,-48.5,13,-49,-48.5,13,-49,-48.5,-50,49,-48.5,-50,37.5,-48.5,13,-49,-48.5,-50,37.5,-48.5,25,-38.5,-48.5,25,37.5,-48.5,13,-49,49.5,-50,49,49.5,-50,49,-48.5,-50,-49,-48.5,-50,-49,49.5,-50,49,-48.5,-50,49,-48.5,-50,49,-48.5,13,37.5,-48.5,13,-38.5,-48.5,13,-49,-48.5,-50,37.5,-48.5,13,-49,49.5,-39,49,49.5,-39,49,49.5,-50,-49,49.5,-39,49,49.5,-50,-49,49.5,-50,-38.5,-48.5,25,-38.5,-48.5,13,37.5,-48.5,13],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0],"normalized":false}},"boundingSphere":{"center":[0,0.5,-12.5],"radius":78.792449}}},{"uuid":"B50170BA-B861-4948-A186-6A1CAF4D87BA","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-12,-50,-22,-12,-49.799999,-22,-12,-49.799999,-36,-12,-50,-22,-12,-49.799999,-36,-12,-50,-36,12,-50,-36,12,-49.799999,-36,12,-49.799999,-22,12,-50,-36,12,-49.799999,-22,12,-50,-22,12,-50,-22,-12,-50,-22,12,-50,-36,-12,-50,-36,12,-50,-36,-12,-50,-22,12,-50,-22,12,-49.799999,-22,-12,-49.799999,-22,12,-50,-22,-12,-49.799999,-22,-12,-50,-22,-12,-49.799999,-36,12,-49.799999,-36,12,-50,-36,-12,-49.799999,-36,12,-50,-36,-12,-50,-36],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[0,-49.9,-29],"radius":13.892804}}},{"uuid":"62B8E234-7548-4E77-8F9B-D62A864CEC4A","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-12.5,-49.799999,2,-12.5,-49.799999,0,-12.5,-49,2,-12.5,-49,-10,-12.5,-49,2,-12.5,-49.799999,0,-12.5,-49,-10,-12.5,-49.799999,0,-12.5,-49.799999,-10,21.5,-49.799999,-10,35.5,-49.799999,-10,21.5,-49.799999,0,35.5,-49.799999,-10,35.5,-49.799999,2,21.5,-49.799999,0,-36.5,-49.799999,-10,-36.5,-49.799999,2,-36.5,-49,2,-36.5,-49.799999,-10,-36.5,-49,2,-36.5,-49,-10,11.5,-49.799999,2,21.5,-49.799999,0,35.5,-49.799999,2,-12.5,-49,2,-36.5,-49,2,-36.5,-49.799999,2,-12.5,-49,2,-36.5,-49.799999,2,-12.5,-49.799999,2,11.75,-49,-10,11.75,-49,-9.7,35.5,-49,-10,35.5,-49,2,35.5,-49,-10,11.75,-49,-9.7,35.5,-49,-10,35.5,-49,2,35.5,-49.799999,2,35.5,-49,-10,35.5,-49.799999,2,35.5,-49.799999,-10,35.5,-49,2,11.5,-49,2,35.5,-49.799999,2,11.5,-49.799999,2,11.5,-49,2,11.5,-49.799999,0,11.5,-49,2,11.5,-49,-9.7,11.5,-49.799999,0,11.5,-49.799999,-9.7,11.5,-49.799999,0,11.5,-49,-9.7,11.5,-49.799999,2,35.5,-49.799999,2,11.5,-49,2,-12.5,-49,-10,-22.5,-49.799999,-10,-36.5,-49,-10,-36.5,-49.799999,-10,-36.5,-49,-10,-22.5,-49.799999,-10,-12.5,-49.799999,-10,-22.5,-49.799999,-10,-12.5,-49,-10,21.5,-49.799999,0,11.5,-49.799999,2,11.5,-49.799999,0,11.5,-49,-9.7,11.5,-49,2,11.75,-49,-9.7,35.5,-49,2,11.75,-49,-9.7,11.5,-49,2,-22.5,-49.799999,-10,-22.5,-49.799999,0,-36.5,-49.799999,-10,-36.5,-49.799999,2,-36.5,-49.799999,-10,-22.5,-49.799999,0,-12.5,-49.799999,0,-12.5,-49.799999,2,-22.5,-49.799999,0,-36.5,-49.799999,2,-22.5,-49.799999,0,-12.5,-49.799999,2,-36.5,-49,-10,-36.5,-49,2,-12.5,-49,-10,-12.5,-49,2,-12.5,-49,-10,-36.5,-49,2,35.5,-49.799999,-10,21.5,-49.799999,-10,35.5,-49,-10,11.75,-49,-10,35.5,-49,-10,21.5,-49.799999,-10,11.75,-49,-10,21.5,-49.799999,-10,11.75,-49.799999,-10],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,-1,0,0,-1,0,0,-1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1],"normalized":false}},"boundingSphere":{"center":[-0.5,-49.4,-4],"radius":36.498767}}}],"materials":[{"uuid":"E7AAB6D8-7DB6-4E70-9B4F-90272EAB304F","type":"MeshLambertMaterial","color":5802912,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"A5B7AEDC-2332-4924-B6B3-A53FA500664A","type":"MeshLambertMaterial","color":4866110,"emissive":855309,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"32F40277-D4A6-410D-B01B-E2E3CD11E5A7","type":"MeshLambertMaterial","color":7101506,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"EAD436B3-F59E-46DC-9E96-4F5CE306C511","type":"MeshLambertMaterial","color":10317632,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"D14094C3-99CA-4798-AFD6-783CFC1F41AB","type":"MeshLambertMaterial","color":13210719,"emissive":0,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"6F0AD78D-1B47-4434-A5F5-C7F9486D171F","type":"MeshPhongMaterial","name":"color_15308428","color":15972573,"emissive":0,"specular":1118481,"shininess":30,"flatShading":true,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"12536C28-8D65-43AD-83F3-020582A48119","type":"MeshLambertMaterial","color":16777215,"emissive":2236962,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"5DCCC75E-B3B4-4627-907E-7D0F460BC885","type":"Group","name":"steve","matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"90CB7C43-44A7-4C3D-A550-E9E36FB5FCEB","type":"Mesh","name":"eyes_blue","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"1B9BCCE5-23C5-40D6-A4E8-DF658CFEA3D3","material":"E7AAB6D8-7DB6-4E70-9B4F-90272EAB304F"},{"uuid":"0CA76828-8B6F-469B-85AE-E0397ABDF057","type":"Mesh","name":"hair","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"B83FE8E1-BA4E-435E-A9C1-41AF200E9460","material":"A5B7AEDC-2332-4924-B6B3-A53FA500664A"},{"uuid":"5A2D3D9B-4FCB-4C53-B01D-0352808AAB3A","type":"Mesh","name":"beard","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"39C3BDBC-0F0D-45DE-AC12-5669F146F33F","material":"32F40277-D4A6-410D-B01B-E2E3CD11E5A7"},{"uuid":"D7B48537-E2F0-48C1-B357-542F1D1F09FE","type":"Mesh","name":"nose","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"51E1EAB7-C16E-49A1-9B5D-B87478904B8E","material":"EAD436B3-F59E-46DC-9E96-4F5CE306C511"},{"uuid":"01E5FF4D-0B46-4CA6-9EED-99CEBDA9C14D","type":"Mesh","name":"face","castShadow":true,"receiveShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"DB78FE5E-D8DF-4635-81C3-6CB5676C19B0","material":"D14094C3-99CA-4798-AFD6-783CFC1F41AB"},{"uuid":"53B2FC38-A3C3-4BC7-98CE-4A9DAE5B3FFE","type":"Mesh","name":"mouth","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"B50170BA-B861-4948-A186-6A1CAF4D87BA","material":"6F0AD78D-1B47-4434-A5F5-C7F9486D171F"},{"uuid":"B3C9F57E-BD70-4E37-BDDE-64FCF1D2C038","type":"Mesh","name":"eyes_white","matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"62B8E234-7548-4E77-8F9B-D62A864CEC4A","material":"12536C28-8D65-43AD-83F3-020582A48119"}]}}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"version":4.5,"type":"Object","generator":"Object3D.toJSON"},"geometries":[{"uuid":"D6C0640F-2E69-4326-A318-D56942A80BE1","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[5.706,1.854,20.537001,4.854,3.527,30,5.706,1.854,30,5.706,1.854,20.537001,4.854,3.527,20.537001,4.854,3.527,30,5.706,1.854,30,4.854,3.527,30,3.527,4.854,30,5.706,1.854,30,3.527,4.854,30,1.854,5.706,30,5.706,1.854,30,1.854,5.706,30,0,6,30,5.706,1.854,30,0,6,30,-1.854,5.706,30,5.706,1.854,30,-1.854,5.706,30,-3.527,4.854,30,5.706,1.854,30,-3.527,4.854,30,-4.854,3.527,30,5.706,1.854,30,-4.854,3.527,30,-5.706,1.854,30,5.706,1.854,30,-5.706,1.854,30,-6,0,30,5.706,1.854,30,-6,0,30,6,0,30,3.527,-4.854,30,4.854,-3.527,30,1.854,-5.706,30,4.854,-3.527,30,5.706,-1.854,30,1.854,-5.706,30,0,-6,30,1.854,-5.706,30,5.706,-1.854,30,6,0,30,-6,0,30,5.706,-1.854,30,-6,0,30,-5.706,-1.854,30,5.706,-1.854,30,-3.527,-4.854,30,5.706,-1.854,30,-4.854,-3.527,30,-1.854,-5.706,30,5.706,-1.854,30,-3.527,-4.854,30,-5.706,-1.854,30,-4.854,-3.527,30,5.706,-1.854,30,0,-6,30,5.706,-1.854,30,-1.854,-5.706,30,3.3902,4.6663,20.537001,3.527,4.854,20.537001,4.6663,3.3902,20.537001,3.3902,4.6663,20.537001,3.3413,4.6912,20.537001,3.527,4.854,20.537001,1.854,5.706,20.537001,3.527,4.854,20.537001,3.3413,4.6912,20.537001,3.3413,4.6912,20.537001,1.7825,5.4852,20.537001,1.854,5.706,20.537001,1.7825,5.4852,20.537001,1.7283,5.4938,20.537001,1.854,5.706,20.537001,0,5.7675,20.537001,0,6,20.537001,1.7283,5.4938,20.537001,6,0,20.537001,5.7675,0,20.537001,5.759,0.0542,20.537001,5.4852,1.7825,20.537001,5.706,1.854,20.537001,5.759,0.0542,20.537001,6,0,20.537001,5.759,0.0542,20.537001,5.706,1.854,20.537001,5.706,1.854,20.537001,5.4852,1.7825,20.537001,5.4603,1.8314,20.537001,4.6663,3.3902,20.537001,4.854,3.527,20.537001,5.4603,1.8314,20.537001,5.706,1.854,20.537001,5.4603,1.8314,20.537001,4.854,3.527,20.537001,4.854,3.527,20.537001,4.6663,3.3902,20.537001,3.527,4.854,20.537001,-1.854,5.706,20.537001,-1.8314,5.4603,20.537001,-3.527,4.854,20.537001,1.854,5.706,20.537001,1.7283,5.4938,20.537001,0,6,20.537001,-1.854,5.706,20.537001,0,6,20.537001,-0.0542,5.759,20.537001,-1.7825,5.4852,20.537001,-1.8314,5.4603,20.537001,-1.854,5.706,20.537001,-1.7825,5.4852,20.537001,-1.854,5.706,20.537001,-0.0542,5.759,20.537001,0,5.7675,20.537001,-0.0542,5.759,20.537001,0,6,20.537001,-3.3902,4.6663,20.537001,-3.527,4.854,20.537001,-1.8314,5.4603,20.537001,-3.3902,4.6663,20.537001,-4.6663,3.3902,20.537001,-3.527,4.854,20.537001,-3.527,4.854,20.537001,-4.6663,3.3902,20.537001,-4.854,3.527,20.537001,5.706,1.854,30,6,0,30,5.706,1.854,20.537001,-4.854,3.527,20.537001,-4.6912,3.3413,20.537001,-5.706,1.854,20.537001,6,0,30,6,0,20.537001,5.706,1.854,20.537001,-5.706,1.854,20.537001,-4.6912,3.3413,20.537001,-5.4852,1.7825,20.537001,-5.4852,1.7825,20.537001,-5.4938,1.7283,20.537001,-5.706,1.854,20.537001,-4.6663,3.3902,20.537001,-4.6912,3.3413,20.537001,-4.854,3.527,20.537001,-5.7675,0,20.537001,-6,0,20.537001,-5.4938,1.7283,20.537001,-5.706,1.854,20.537001,-5.4938,1.7283,20.537001,-6,0,20.537001,4.854,3.527,30,4.854,3.527,20.537001,3.527,4.854,30,3.527,4.854,20.537001,3.527,4.854,30,4.854,3.527,20.537001,-6,0,20.537001,-6,0,30,-5.706,1.854,30,-5.706,1.854,20.537001,-6,0,20.537001,-5.706,1.854,30,1.854,5.706,30,3.527,4.854,30,1.854,5.706,20.537001,3.527,4.854,20.537001,1.854,5.706,20.537001,3.527,4.854,30,0,6,30,1.854,5.706,30,0,6,20.537001,1.854,5.706,20.537001,0,6,20.537001,1.854,5.706,30,-1.854,5.706,30,0,6,30,-1.854,5.706,20.537001,0,6,20.537001,-1.854,5.706,20.537001,0,6,30,-3.527,4.854,20.537001,-3.527,4.854,30,-1.854,5.706,20.537001,-1.854,5.706,20.537001,-3.527,4.854,30,-1.854,5.706,30,-5.706,-1.854,20.537001,-5.4603,-1.8314,20.537001,-4.854,-3.527,20.537001,-5.706,-1.854,20.537001,-5.4852,-1.7825,20.537001,-5.4603,-1.8314,20.537001,-4.6663,-3.3902,20.537001,-4.854,-3.527,20.537001,-5.4603,-1.8314,20.537001,-6,0,20.537001,-5.759,-0.0542,20.537001,-5.706,-1.854,20.537001,-4.6663,-3.3902,20.537001,-3.3902,-4.6663,20.537001,-3.527,-4.854,20.537001,-4.854,-3.527,20.537001,-4.6663,-3.3902,20.537001,-3.527,-4.854,20.537001,-5.4852,-1.7825,20.537001,-5.706,-1.854,20.537001,-5.759,-0.0542,20.537001,-5.7675,0,20.537001,-5.759,-0.0542,20.537001,-6,0,20.537001,-8.817,12.135,5.563,-12.135,8.817,-11.282,-12.135,8.817,5.563,-12.135,8.817,-11.282,-14.266,4.635,-11.282,-12.135,8.817,5.563,-3.527,-4.854,20.537001,-3.3413,-4.6912,20.537001,-1.854,-5.706,20.537001,-1.854,-5.706,20.537001,-1.7825,-5.4852,20.537001,-1.7283,-5.4938,20.537001,0,-5.7675,20.537001,0,-6,20.537001,-1.7283,-5.4938,20.537001,-3.3413,-4.6912,20.537001,-3.527,-4.854,20.537001,-3.3902,-4.6663,20.537001,6,0,30,5.706,-1.854,30,5.706,-1.854,20.537001,6,0,20.537001,6,0,30,5.706,-1.854,20.537001,-1.7825,-5.4852,20.537001,-1.854,-5.706,20.537001,-3.3413,-4.6912,20.537001,-4.854,-3.527,20.537001,-4.854,-3.527,30,-5.706,-1.854,30,-4.854,-3.527,20.537001,-5.706,-1.854,30,-5.706,-1.854,20.537001,-3.527,-4.854,30,-4.854,-3.527,30,-3.527,-4.854,20.537001,-4.854,-3.527,20.537001,-3.527,-4.854,20.537001,-4.854,-3.527,30,-6,0,20.537001,-5.706,-1.854,20.537001,-6,0,30,-5.706,-1.854,30,-6,0,30,-5.706,-1.854,20.537001,-1.854,-5.706,20.537001,-1.854,-5.706,30,-3.527,-4.854,30,-1.854,-5.706,20.537001,-3.527,-4.854,30,-3.527,-4.854,20.537001,-1.854,-5.706,20.537001,0,-6,20.537001,-1.854,-5.706,30,0,-6,30,-1.854,-5.706,30,0,-6,20.537001,-4.854,3.527,30,-3.527,4.854,30,-3.527,4.854,20.537001,-4.854,3.527,20.537001,-4.854,3.527,30,-3.527,4.854,20.537001,12.135,-8.817,-11.282,14.266,-4.635,-11.282,12.135,-8.817,5.563,4.635,-14.266,-11.282,4.635,-14.266,5.563,4.6339,-14.2662,5.563,0,-15,5.563,0,-15,-11.282,4.6339,-14.2662,5.563,4.635,-14.266,-11.282,8.817,-12.135,-11.282,4.635,-14.266,5.563,8.817,-12.135,5.563,4.635,-14.266,5.563,8.817,-12.135,-11.282,5.706,-1.854,20.537001,5.4852,-1.7825,20.537001,5.4938,-1.7283,20.537001,5.7675,0,20.537001,6,0,20.537001,5.4938,-1.7283,20.537001,5.706,-1.854,20.537001,5.4938,-1.7283,20.537001,6,0,20.537001,4.6663,-3.3902,20.537001,4.6912,-3.3413,20.537001,4.854,-3.527,20.537001,3.527,-4.854,20.537001,3.3902,-4.6663,20.537001,4.854,-3.527,20.537001,4.854,-3.527,20.537001,4.6912,-3.3413,20.537001,5.706,-1.854,20.537001,5.4852,-1.7825,20.537001,5.706,-1.854,20.537001,4.6912,-3.3413,20.537001,8.817,-12.135,5.563,8.817,-12.135,-11.282,12.135,-8.817,5.563,12.135,-8.817,-11.282,12.135,-8.817,5.563,8.817,-12.135,-11.282,0,-6,20.537001,0.0542,-5.759,20.537001,1.854,-5.706,20.537001,1.7825,-5.4852,20.537001,1.854,-5.706,20.537001,0.0542,-5.759,20.537001,0,-5.7675,20.537001,0.0542,-5.759,20.537001,0,-6,20.537001,-1.854,-5.706,20.537001,-1.7283,-5.4938,20.537001,0,-6,20.537001,3.3902,-4.6663,20.537001,3.527,-4.854,20.537001,1.8314,-5.4603,20.537001,3.527,-4.854,20.537001,1.854,-5.706,20.537001,1.8314,-5.4603,20.537001,1.7825,-5.4852,20.537001,1.8314,-5.4603,20.537001,1.854,-5.706,20.537001,4.6663,-3.3902,20.537001,4.854,-3.527,20.537001,3.3902,-4.6663,20.537001,1.854,-5.706,20.537001,1.854,-5.706,30,0,-6,30,1.854,-5.706,20.537001,0,-6,30,0,-6,20.537001,3.527,-4.854,20.537001,3.527,-4.854,30,1.854,-5.706,30,3.527,-4.854,20.537001,1.854,-5.706,30,1.854,-5.706,20.537001,3.527,-4.854,20.537001,4.854,-3.527,20.537001,3.527,-4.854,30,4.854,-3.527,30,3.527,-4.854,30,4.854,-3.527,20.537001,5.706,-1.854,30,4.854,-3.527,30,4.854,-3.527,20.537001,5.706,-1.854,30,4.854,-3.527,20.537001,5.706,-1.854,20.537001,-4.854,3.527,20.537001,-5.706,1.854,30,-4.854,3.527,30,-4.854,3.527,20.537001,-5.706,1.854,20.537001,-5.706,1.854,30,-15,0,-11.282,-15,0,5.563,-14.266,4.635,-11.282,-14.266,4.635,5.563,-14.266,4.635,-11.282,-15,0,5.563,8.817,12.135,-11.282,8.817,12.135,5.563,12.135,8.817,-11.282,12.135,8.817,5.563,12.135,8.817,-11.282,8.817,12.135,5.563,-8.817,12.135,5.563,-4.635,14.266,5.563,-8.817,12.135,-11.282,-4.635,14.266,-11.282,-8.817,12.135,-11.282,-4.635,14.266,5.563,-8.817,12.135,-11.282,-12.135,8.817,-11.282,-8.817,12.135,5.563,4.635,14.266,5.563,8.817,12.135,5.563,4.635,14.266,-11.282,8.817,12.135,-11.282,4.635,14.266,-11.282,8.817,12.135,5.563,-14.266,4.635,5.563,-12.135,8.817,5.563,-14.266,4.635,-11.282,0,15,5.563,4.635,14.266,5.563,0,15,-11.282,4.635,14.266,-11.282,0,15,-11.282,4.635,14.266,5.563,-4.635,14.266,5.563,0,15,5.563,-4.635,14.266,-11.282,-4.635,14.266,-11.282,0,15,5.563,0,15,-11.282,15,0,5.563,15,0,-11.282,14.266,4.635,5.563,14.266,4.635,-11.282,14.266,4.635,5.563,15,0,-11.282,12.135,8.817,-11.282,14.266,4.635,5.563,14.266,4.635,-11.282,12.135,8.817,5.563,14.266,4.635,5.563,12.135,8.817,-11.282,4.635,-14.266,-11.282,4.6339,-14.2662,5.563,0,-15,-11.282,-4.635,-14.266,5.563,-8.817,-12.135,5.563,-8.817,-12.135,-11.282,-4.635,-14.266,-11.282,-4.635,-14.266,5.563,-8.817,-12.135,-11.282,-14.266,-4.635,-11.282,-15,0,5.563,-15,0,-11.282,-14.266,-4.635,5.563,-15,0,5.563,-14.266,-4.635,-11.282,-12.135,-8.817,5.563,-14.266,-4.635,5.563,-12.135,-8.817,-11.282,-14.266,-4.635,-11.282,-12.135,-8.817,-11.282,-14.266,-4.635,5.563,-8.817,-12.135,5.563,-12.135,-8.817,5.563,-8.817,-12.135,-11.282,-12.135,-8.817,-11.282,-8.817,-12.135,-11.282,-12.135,-8.817,5.563,0,-15,5.563,-4.635,-14.266,5.563,0,-15,-11.282,0,-15,-11.282,-4.635,-14.266,5.563,-4.635,-14.266,-11.282,14.266,-4.635,5.563,12.135,-8.817,5.563,14.266,-4.635,-11.282,15,0,5.563,14.266,-4.635,5.563,15,0,-11.282,14.266,-4.635,-11.282,15,0,-11.282,14.266,-4.635,5.563],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0.891101,0.453806,0,0.891101,0.453806,0,0.891101,0.453806,0,0.891101,0.453806,0,0.891101,0.453806,0,0.891101,0.453806,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0,0,-1,0,0,-1,0,0,-1,0.987659,0.156619,0,0.987659,0.156619,0,0.987659,0.156619,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,-0.987659,0.156619,0,0.453806,0.891101,0,0.453806,0.891101,0,0.453806,0.891101,0,0.453806,0.891101,0,0.453806,0.891101,0,0.453806,0.891101,0,0.156619,0.987659,0,0.156619,0.987659,0,0.156619,0.987659,0,0.156619,0.987659,0,0.156619,0.987659,0,0.156619,0.987659,0,-0.156619,0.987659,0,-0.156619,0.987659,0,-0.156619,0.987659,0,-0.156619,0.987659,0,-0.156619,0.987659,0,-0.156619,0.987659,0,-0.453806,0.891101,0,-0.453806,0.891101,0,-0.453806,0.891101,0,-0.453806,0.891101,0,-0.453806,0.891101,0,-0.453806,0.891101,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0.987659,-0.156619,0,0,0,-1,0,0,-1,0,0,-1,-0.891101,-0.453806,0,-0.891101,-0.453806,0,-0.891101,-0.453806,0,-0.891101,-0.453806,0,-0.891101,-0.453806,0,-0.891101,-0.453806,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.987659,-0.156619,0,-0.453806,-0.891101,0,-0.453806,-0.891101,0,-0.453806,-0.891101,0,-0.453806,-0.891101,0,-0.453806,-0.891101,0,-0.453806,-0.891101,0,-0.156619,-0.987659,0,-0.156619,-0.987659,0,-0.156619,-0.987659,0,-0.156619,-0.987659,0,-0.156619,-0.987659,0,-0.156619,-0.987659,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.179111,-0.983829,0,0.179111,-0.983829,0,0.179111,-0.983829,0,0.156406,-0.987693,0,0.156406,-0.987693,0,0.156406,-0.987693,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0.156619,-0.987659,0,0.156619,-0.987659,0,0.156619,-0.987659,0,0.156619,-0.987659,0,0.156619,-0.987659,0,0.156619,-0.987659,0,0.453806,-0.891101,0,0.453806,-0.891101,0,0.453806,-0.891101,0,0.453806,-0.891101,0,0.453806,-0.891101,0,0.453806,-0.891101,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.891101,-0.453806,0,0.891101,-0.453806,0,0.891101,-0.453806,0,0.891101,-0.453806,0,0.891101,-0.453806,0,0.891101,-0.453806,0,-0.891101,0.453806,0,-0.891101,0.453806,0,-0.891101,0.453806,0,-0.891101,0.453806,0,-0.891101,0.453806,0,-0.891101,0.453806,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.156411,-0.987692,-0.000002,0.156411,-0.987692,-0.000002,0.156411,-0.987692,-0.000002,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0],"normalized":false}},"boundingSphere":{"center":[0,0,9.359],"radius":25.515737}}},{"uuid":"B8C8F6C9-01D8-4664-97EC-868F326DAD83","type":"BufferGeometry","data":{"attributes":{"position":{"itemSize":3,"type":"Float32Array","array":[-15,0,-30,-14.266,4.635,-30,-12.135,8.817,-30,-15,0,-30,-12.135,8.817,-30,-8.817,12.135,-30,-15,0,-30,-8.817,12.135,-30,-4.635,14.266,-30,-15,0,-30,-4.635,14.266,-30,0,15,-30,-15,0,-30,0,15,-30,4.635,14.266,-30,-15,0,-30,4.635,14.266,-30,8.817,12.135,-30,-15,0,-30,8.817,12.135,-30,12.135,8.817,-30,-15,0,-30,12.135,8.817,-30,14.266,4.635,-30,-15,0,-30,14.266,4.635,-30,15,0,-30,-8.817,-12.135,-30,15,0,-30,-4.635,-14.266,-30,-12.135,-8.817,-30,15,0,-30,-8.817,-12.135,-30,-14.266,-4.635,-30,15,0,-30,-12.135,-8.817,-30,-15,0,-30,15,0,-30,-14.266,-4.635,-30,0,-15,-30,-4.635,-14.266,-30,15,0,-30,0,-15,-30,15,0,-30,14.266,-4.635,-30,0,-15,-30,14.266,-4.635,-30,12.135,-8.817,-30,0,-15,-30,12.135,-8.817,-30,8.817,-12.135,-30,0,-15,-30,8.817,-12.135,-30,4.635,-14.266,-30,-5.509,-4.003,19.514999,-4.6663,-3.3902,20.537001,-5.4603,-1.8314,20.537001,8.817,12.135,-11.282,4.635,14.266,-30,4.635,14.266,-11.282,4.635,14.266,-30,0,15,-11.282,4.635,14.266,-11.282,-5.509,-4.003,19.514999,-5.4603,-1.8314,20.537001,-6.477,-2.104,19.514999,-5.4852,-1.7825,20.537001,-6.477,-2.104,19.514999,-5.4603,-1.8314,20.537001,12.164,3.952,10.361,11.541,3.75,11.635,12.135,0,11.635,-5.4852,-1.7825,20.537001,-5.759,-0.0542,20.537001,-6.477,-2.104,19.514999,-4.635,14.266,-11.282,-8.817,12.135,-30,-8.817,12.135,-11.282,-8.817,12.135,-30,-12.135,8.817,-11.282,-8.817,12.135,-11.282,-6.477,-2.104,19.514999,-5.759,-0.0542,20.537001,-6.81,0,19.514999,-5.7675,0,20.537001,-6.81,0,19.514999,-5.759,-0.0542,20.537001,12.79,0,10.361,12.164,3.952,10.361,12.135,0,11.635,15,0,-11.282,15,0,-30,14.266,4.635,-11.282,12.79,0,10.361,12.711,4.13,9.185,12.164,3.952,10.361,-6.81,0,19.514999,-7.454,-2.422,18.339001,-6.477,-2.104,19.514999,-7.133,-9.818,11.635,-3.952,-12.164,10.361,-3.75,-11.541,11.635,4.635,-14.266,-11.282,8.817,-12.135,-30,8.817,-12.135,-11.282,13.568,-4.408,7.241,14.266,0,7.241,13.18,-4.282,8.137,8.817,-12.135,-30,12.135,-8.817,-11.282,8.817,-12.135,-11.282,-7.133,-9.818,11.635,-7.518,-10.347,10.361,-3.952,-12.164,10.361,12.135,-8.817,-11.282,14.266,-4.635,-30,14.266,-4.635,-11.282,15,0,-11.282,14.266,-4.635,-11.282,15,0,-30,14.266,-4.635,-30,15,0,-30,14.266,-4.635,-11.282,-6.81,0,19.514999,-7.837,0,18.339001,-7.454,-2.422,18.339001,-3.952,-12.164,10.361,0,-12.79,10.361,-3.75,-11.541,11.635,-4.635,-14.266,-30,-4.635,-14.266,-11.282,-8.817,-12.135,-11.282,0,-15,-11.282,-4.635,-14.266,-11.282,-4.635,-14.266,-30,12.135,8.817,-30,12.135,8.817,-11.282,14.266,4.635,-30,14.266,4.635,-11.282,14.266,4.635,-30,12.135,8.817,-11.282,13.568,-4.408,7.241,14.586,0,6.521,14.266,0,7.241,8.817,12.135,-11.282,12.135,8.817,-11.282,8.817,12.135,-30,12.135,8.817,-30,8.817,12.135,-30,12.135,8.817,-11.282,2.104,6.477,19.514999,1.7825,5.4852,20.537001,3.3413,4.6912,20.537001,8.817,12.135,-30,4.635,14.266,-30,8.817,12.135,-11.282,0,15,-11.282,4.635,14.266,-30,0,15,-30,2.104,6.477,19.514999,3.3413,4.6912,20.537001,4.003,5.509,19.514999,13.568,-4.408,7.241,13.872,-4.507,6.521,14.586,0,6.521,0,15,-30,-4.635,14.266,-30,-4.635,14.266,-11.282,0,15,-30,-4.635,14.266,-11.282,0,15,-11.282,14.815,0,5.994,14.586,0,6.521,13.872,-4.507,6.521,-4.635,14.266,-30,-8.817,12.135,-30,-4.635,14.266,-11.282,1.7283,5.4938,20.537001,0,6.81,19.514999,0,5.7675,20.537001,14.09,-4.578,5.994,14.815,0,5.994,13.872,-4.507,6.521,-12.135,8.817,-11.282,-8.817,12.135,-30,-12.135,8.817,-30,14.266,4.635,-11.282,15,0,-30,14.266,4.635,-30,14.09,-4.578,5.994,14.954,0,5.672,14.815,0,5.994,-12.135,8.817,-30,-14.266,4.635,-30,-14.266,4.635,-11.282,-12.135,8.817,-30,-14.266,4.635,-11.282,-12.135,8.817,-11.282,-13.568,4.408,7.241,-13.18,4.282,8.137,-11.212,8.146,8.137,14.09,-4.578,5.994,14.222,-4.621,5.672,14.954,0,5.672,-15,0,-11.282,-14.266,4.635,-11.282,-15,0,-30,-14.266,4.635,-30,-15,0,-30,-14.266,4.635,-11.282,4.635,-14.266,-30,4.635,-14.266,-11.282,0,-15,-30,0,-15,-11.282,0,-15,-30,4.635,-14.266,-11.282,4.635,-14.266,-30,8.817,-12.135,-30,4.635,-14.266,-11.282,2.104,6.477,19.514999,0,6.81,19.514999,1.7283,5.4938,20.537001,1.7283,5.4938,20.537001,1.7825,5.4852,20.537001,2.104,6.477,19.514999,12.135,-8.817,-11.282,8.817,-12.135,-30,12.135,-8.817,-30,2.422,7.454,18.339001,2.104,6.477,19.514999,4.003,5.509,19.514999,12.135,-8.817,-30,14.266,-4.635,-30,12.135,-8.817,-11.282,0,6.81,19.514999,2.104,6.477,19.514999,0,7.837,18.339001,2.422,7.454,18.339001,0,7.837,18.339001,2.104,6.477,19.514999,11.8,-8.573,6.521,11.541,-8.385,7.241,8.385,-11.541,7.241,11.8,-8.573,6.521,8.385,-11.541,7.241,8.573,-11.8,6.521,4.607,6.341,18.339001,2.422,7.454,18.339001,4.003,5.509,19.514999,-14.266,-4.635,-30,-14.266,-4.635,-11.282,-15,0,-30,-15,0,-11.282,-15,0,-30,-14.266,-4.635,-11.282,4.607,6.341,18.339001,2.725,8.385,17.065001,2.422,7.454,18.339001,-12.135,-8.817,-11.282,-14.266,-4.635,-11.282,-12.135,-8.817,-30,-14.266,-4.635,-30,-12.135,-8.817,-30,-14.266,-4.635,-11.282,-8.817,-12.135,-11.282,-12.135,-8.817,-11.282,-8.817,-12.135,-30,-12.135,-8.817,-30,-8.817,-12.135,-30,-12.135,-8.817,-11.282,-8.817,-12.135,-11.282,-8.817,-12.135,-30,-4.635,-14.266,-30,0,-15,-30,0,-15,-11.282,-4.635,-14.266,-30,-7.518,10.347,10.361,-7.133,9.818,11.635,-3.75,11.541,11.635,-3.75,11.541,11.635,-3.952,12.164,10.361,-7.518,10.347,10.361,5.7675,0,20.537001,6.81,0,19.514999,5.759,0.0542,20.537001,-3.952,12.164,10.361,-7.856,10.813,9.185,-7.518,10.347,10.361,4.6663,3.3902,20.537001,5.4603,1.8314,20.537001,5.509,4.003,19.514999,11.8,-8.573,6.521,8.573,-11.8,6.521,8.708,-11.986,5.994,-3.952,12.164,10.361,-4.13,12.711,9.185,-7.856,10.813,9.185,5.4852,1.7825,20.537001,6.477,2.104,19.514999,5.4603,1.8314,20.537001,13.568,-4.408,7.241,11.212,-8.146,8.137,11.541,-8.385,7.241,3.3902,4.6663,20.537001,4.6663,3.3902,20.537001,4.003,5.509,19.514999,13.872,-4.507,6.521,13.568,-4.408,7.241,11.541,-8.385,7.241,-10.813,-7.856,9.185,-11.212,-8.146,8.137,-7.856,-10.813,9.185,13.872,-4.507,6.521,11.541,-8.385,7.241,11.8,-8.573,6.521,-10.347,-7.518,10.361,-7.518,-10.347,10.361,-7.133,-9.818,11.635,-10.347,-7.518,10.361,-10.813,-7.856,9.185,-7.518,-10.347,10.361,-7.856,-10.813,9.185,-7.518,-10.347,10.361,-10.813,-7.856,9.185,10.347,7.518,10.361,9.818,7.133,11.635,11.541,3.75,11.635,0,12.135,11.635,0,12.79,10.361,-3.952,12.164,10.361,11.8,-8.573,6.521,14.09,-4.578,5.994,13.872,-4.507,6.521,0,12.135,11.635,-3.952,12.164,10.361,-3.75,11.541,11.635,-0.0542,5.759,20.537001,0,5.7675,20.537001,0,6.81,19.514999,-2.104,6.477,19.514999,-0.0542,5.759,20.537001,0,6.81,19.514999,11.986,-8.708,5.994,8.708,-11.986,5.994,8.79,-12.098,5.672,11.986,-8.708,5.994,8.79,-12.098,5.672,12.098,-8.79,5.672,0,12.79,10.361,-4.13,12.711,9.185,-3.952,12.164,10.361,-4.13,12.711,9.185,0,12.79,10.361,0,13.365,9.185,4.607,6.341,18.339001,4.003,5.509,19.514999,6.341,4.607,18.339001,-1.7825,5.4852,20.537001,-2.104,6.477,19.514999,-1.8314,5.4603,20.537001,8.79,-12.098,5.672,8.817,-12.135,5.563,12.135,-8.817,5.563,8.79,-12.098,5.672,12.135,-8.817,5.563,12.098,-8.79,5.672,6.341,4.607,18.339001,7.133,5.182,17.065001,5.182,7.133,17.065001,6.341,4.607,18.339001,5.182,7.133,17.065001,4.607,6.341,18.339001,8.385,2.725,17.065001,7.881,5.726,15.725,7.133,5.182,17.065001,0,-6.81,19.514999,0,-5.7675,20.537001,-1.7283,-5.4938,20.537001,-1.7283,-5.4938,20.537001,-2.104,-6.477,19.514999,0,-6.81,19.514999,11.986,-8.708,5.994,11.8,-8.573,6.521,8.708,-11.986,5.994,-1.7825,-5.4852,20.537001,-2.104,-6.477,19.514999,-1.7283,-5.4938,20.537001,-4.6663,3.3902,20.537001,-3.3902,4.6663,20.537001,-4.003,5.509,19.514999,-15,0,5.563,-14.954,0,5.672,-14.222,4.621,5.672,0,-7.837,18.339001,0,-6.81,19.514999,-2.104,-6.477,19.514999,-2.104,-6.477,19.514999,-2.422,-7.454,18.339001,0,-7.837,18.339001,-14.266,4.635,5.563,-15,0,5.563,-14.222,4.621,5.672,6.477,2.104,19.514999,7.454,2.422,18.339001,6.341,4.607,18.339001,7.454,2.422,18.339001,7.133,5.182,17.065001,6.341,4.607,18.339001,-4.6663,-3.3902,20.537001,-5.509,-4.003,19.514999,-3.3902,-4.6663,20.537001,11.8,-8.573,6.521,11.986,-8.708,5.994,14.09,-4.578,5.994,5.509,4.003,19.514999,4.003,5.509,19.514999,4.6663,3.3902,20.537001,-3.3413,-4.6912,20.537001,-2.104,-6.477,19.514999,-1.7825,-5.4852,20.537001,-13.568,4.408,7.241,-13.872,4.507,6.521,-14.586,0,6.521,-3.3413,-4.6912,20.537001,-3.3902,-4.6663,20.537001,-4.003,-5.509,19.514999,-3.3413,-4.6912,20.537001,-4.003,-5.509,19.514999,-2.104,-6.477,19.514999,-14.09,4.578,5.994,-14.222,4.621,5.672,-14.954,0,5.672,-2.422,-7.454,18.339001,-2.104,-6.477,19.514999,-4.003,-5.509,19.514999,6.477,2.104,19.514999,5.4852,1.7825,20.537001,5.759,0.0542,20.537001,8.817,-12.135,5.563,8.79,-12.098,5.672,4.621,-14.222,5.672,5.759,0.0542,20.537001,6.81,0,19.514999,6.477,2.104,19.514999,7.518,10.347,10.361,9.818,7.133,11.635,10.347,7.518,10.361,12.164,3.952,10.361,10.347,7.518,10.361,11.541,3.75,11.635,6.477,2.104,19.514999,5.509,4.003,19.514999,5.4603,1.8314,20.537001,12.164,3.952,10.361,10.813,7.856,9.185,10.347,7.518,10.361,6.477,2.104,19.514999,6.341,4.607,18.339001,5.509,4.003,19.514999,12.164,3.952,10.361,12.711,4.13,9.185,10.813,7.856,9.185,7.454,2.422,18.339001,6.477,2.104,19.514999,6.81,0,19.514999,6.81,0,19.514999,7.837,0,18.339001,7.454,2.422,18.339001,-5.509,-4.003,19.514999,-6.477,-2.104,19.514999,-6.341,-4.607,18.339001,7.518,10.347,10.361,10.347,7.518,10.361,10.813,7.856,9.185,-7.454,-2.422,18.339001,-6.341,-4.607,18.339001,-6.477,-2.104,19.514999,-13.18,4.282,8.137,-13.568,4.408,7.241,-14.266,0,7.241,7.837,0,18.339001,8.385,2.725,17.065001,7.454,2.422,18.339001,-8.385,-2.725,17.065001,-7.881,-5.726,15.725,-7.133,-5.182,17.065001,-14.815,0,5.994,-14.586,0,6.521,-13.872,4.507,6.521,8.385,2.725,17.065001,7.837,0,18.339001,8.817,0,17.065001,-14.09,4.578,5.994,-14.815,0,5.994,-13.872,4.507,6.521,8.385,2.725,17.065001,7.133,5.182,17.065001,7.454,2.422,18.339001,-4.003,-5.509,19.514999,-3.3902,-4.6663,20.537001,-5.509,-4.003,19.514999,0,-13.365,9.185,0,-13.858,8.137,4.282,-13.18,8.137,-4.607,-6.341,18.339001,-4.003,-5.509,19.514999,-6.341,-4.607,18.339001,-5.509,-4.003,19.514999,-6.341,-4.607,18.339001,-4.003,-5.509,19.514999,12.711,4.13,9.185,11.212,8.146,8.137,10.813,7.856,9.185,-4.607,-6.341,18.339001,-2.422,-7.454,18.339001,-4.003,-5.509,19.514999,-14.266,0,7.241,-13.858,0,8.137,-13.18,4.282,8.137,-7.454,-2.422,18.339001,-7.133,-5.182,17.065001,-6.341,-4.607,18.339001,12.79,0,10.361,13.365,0,9.185,12.711,4.13,9.185,-13.568,4.408,7.241,-14.586,0,6.521,-14.266,0,7.241,-7.133,-5.182,17.065001,-7.454,-2.422,18.339001,-8.385,-2.725,17.065001,-4.607,-6.341,18.339001,-6.341,-4.607,18.339001,-7.133,-5.182,17.065001,-5.182,-7.133,17.065001,-4.607,-6.341,18.339001,-7.133,-5.182,17.065001,0,7.837,18.339001,2.422,7.454,18.339001,0,8.817,17.065001,-14.09,4.578,5.994,-14.954,0,5.672,-14.815,0,5.994,-7.881,-5.726,15.725,-5.182,-7.133,17.065001,-7.133,-5.182,17.065001,-14.09,-4.578,5.994,-14.586,0,6.521,-14.815,0,5.994,-8.385,-2.725,17.065001,-7.454,-2.422,18.339001,-7.837,0,18.339001,-14.815,0,5.994,-14.954,0,5.672,-14.222,-4.621,5.672,4.282,-13.18,8.137,8.146,-11.212,8.137,4.13,-12.711,9.185,-14.954,0,5.672,-14.266,-4.635,5.563,-14.222,-4.621,5.672,-8.385,-2.725,17.065001,-7.837,0,18.339001,-8.817,0,17.065001,0,7.837,18.339001,0,8.817,17.065001,-2.725,8.385,17.065001,0,-13.858,8.137,0,-14.266,7.241,4.408,-13.568,7.241,-14.954,0,5.672,-15,0,5.563,-14.266,-4.635,5.563,-8.385,-2.725,17.065001,-9.265,-3.01,15.725,-7.881,-5.726,15.725,0,-13.858,8.137,4.408,-13.568,7.241,4.282,-13.18,8.137,8.146,-11.212,8.137,4.282,-13.18,8.137,8.385,-11.541,7.241,11.541,-8.385,7.241,11.212,-8.146,8.137,8.385,-11.541,7.241,-4.607,-6.341,18.339001,-2.725,-8.385,17.065001,-2.422,-7.454,18.339001,-5.182,-7.133,17.065001,-2.725,-8.385,17.065001,-4.607,-6.341,18.339001,4.408,-13.568,7.241,8.385,-11.541,7.241,4.282,-13.18,8.137,4.408,-13.568,7.241,8.573,-11.8,6.521,8.385,-11.541,7.241,6.81,0,19.514999,5.7675,0,20.537001,5.4938,-1.7283,20.537001,-2.422,-7.454,18.339001,0,-8.817,17.065001,0,-7.837,18.339001,4.408,-13.568,7.241,4.507,-13.872,6.521,8.573,-11.8,6.521,-2.422,-7.454,18.339001,-2.725,-8.385,17.065001,0,-8.817,17.065001,6.81,0,19.514999,5.4938,-1.7283,20.537001,6.477,-2.104,19.514999,-2.104,6.477,19.514999,-1.7825,5.4852,20.537001,-0.0542,5.759,20.537001,4.507,-13.872,6.521,8.708,-11.986,5.994,8.573,-11.8,6.521,-4.003,5.509,19.514999,-3.3902,4.6663,20.537001,-1.8314,5.4603,20.537001,0,-9.742,15.725,0,-8.817,17.065001,-2.725,-8.385,17.065001,-4.003,5.509,19.514999,-1.8314,5.4603,20.537001,-2.104,6.477,19.514999,4.507,-13.872,6.521,4.578,-14.09,5.994,8.708,-11.986,5.994,7.454,-2.422,18.339001,7.837,0,18.339001,6.477,-2.104,19.514999,4.578,-14.09,5.994,4.621,-14.222,5.672,8.79,-12.098,5.672,-2.104,6.477,19.514999,0,6.81,19.514999,-2.422,7.454,18.339001,7.837,0,18.339001,6.81,0,19.514999,6.477,-2.104,19.514999,0,6.81,19.514999,0,7.837,18.339001,-2.422,7.454,18.339001,6.477,-2.104,19.514999,5.509,-4.003,19.514999,7.454,-2.422,18.339001,4.578,-14.09,5.994,0,-14.815,5.994,4.621,-14.222,5.672,-2.422,7.454,18.339001,-4.607,6.341,18.339001,-2.104,6.477,19.514999,-13.872,-4.507,6.521,-13.568,-4.408,7.241,-14.266,0,7.241,8.385,-2.725,17.065001,7.454,-2.422,18.339001,6.341,-4.607,18.339001,4.578,-14.09,5.994,8.79,-12.098,5.672,8.708,-11.986,5.994,-2.725,8.385,17.065001,-2.422,7.454,18.339001,0,7.837,18.339001,7.454,-2.422,18.339001,8.817,0,17.065001,7.837,0,18.339001,8.817,-12.135,5.563,4.621,-14.222,5.672,4.635,-14.266,5.563,8.385,-2.725,17.065001,8.817,0,17.065001,7.454,-2.422,18.339001,4.621,-14.222,5.672,0,-14.954,5.672,4.635,-14.266,5.563,-14.586,0,6.521,-13.872,-4.507,6.521,-14.266,0,7.241,0,-14.954,5.672,4.6339,-14.2662,5.563,4.635,-14.266,5.563,-10.347,7.518,10.361,-9.818,7.133,11.635,-7.518,10.347,10.361,4.408,-13.568,7.241,0,-14.266,7.241,4.507,-13.872,6.521,-10.347,7.518,10.361,-7.518,10.347,10.361,-7.856,10.813,9.185,-4.607,6.341,18.339001,-6.341,4.607,18.339001,-4.003,5.509,19.514999,0,-14.586,6.521,4.507,-13.872,6.521,0,-14.266,7.241,-4.607,6.341,18.339001,-5.182,7.133,17.065001,-6.341,4.607,18.339001,-6.341,4.607,18.339001,-5.182,7.133,17.065001,-7.133,5.182,17.065001,-6.704,9.228,12.975,-7.133,9.818,11.635,-9.228,6.704,12.975,0,-14.586,6.521,4.578,-14.09,5.994,4.507,-13.872,6.521,0,-14.586,6.521,0,-14.815,5.994,4.578,-14.09,5.994,-2.422,7.454,18.339001,-5.182,7.133,17.065001,-4.607,6.341,18.339001,0,-14.815,5.994,0,-14.954,5.672,4.621,-14.222,5.672,-5.182,7.133,17.065001,-5.726,7.881,15.725,-7.133,5.182,17.065001,-7.881,5.726,15.725,-7.133,5.182,17.065001,-5.726,7.881,15.725,-2.725,8.385,17.065001,-5.182,7.133,17.065001,-2.422,7.454,18.339001,5.509,-4.003,19.514999,6.341,-4.607,18.339001,7.454,-2.422,18.339001,4.6339,-14.2662,5.563,0,-14.954,5.672,0,-15,5.563,-5.182,7.133,17.065001,-2.725,8.385,17.065001,-5.726,7.881,15.725,8.146,-11.212,8.137,8.385,-11.541,7.241,11.212,-8.146,8.137,8.385,-2.725,17.065001,6.341,-4.607,18.339001,7.133,-5.182,17.065001,7.133,-5.182,17.065001,9.265,-3.01,15.725,8.385,-2.725,17.065001,5.182,7.133,17.065001,7.133,5.182,17.065001,5.726,7.881,15.725,7.881,5.726,15.725,5.726,7.881,15.725,7.133,5.182,17.065001,-5.726,7.881,15.725,-8.581,6.234,14.35,-7.881,5.726,15.725,5.509,-4.003,19.514999,4.003,-5.509,19.514999,6.341,-4.607,18.339001,-13.858,0,8.137,-13.18,-4.282,8.137,-13.365,0,9.185,5.726,-7.881,15.725,7.881,-5.726,15.725,5.182,-7.133,17.065001,7.133,-5.182,17.065001,5.182,-7.133,17.065001,7.881,-5.726,15.725,-4.003,5.509,19.514999,-2.104,6.477,19.514999,-4.607,6.341,18.339001,7.881,-5.726,15.725,9.265,-3.01,15.725,7.133,-5.182,17.065001,-13.568,-4.408,7.241,-13.18,-4.282,8.137,-13.858,0,8.137,-4.003,5.509,19.514999,-5.509,4.003,19.514999,-4.6663,3.3902,20.537001,5.4852,-1.7825,20.537001,6.477,-2.104,19.514999,5.4938,-1.7283,20.537001,-4.003,5.509,19.514999,-6.341,4.607,18.339001,-5.509,4.003,19.514999,-13.568,-4.408,7.241,-13.858,0,8.137,-14.266,0,7.241,5.4852,-1.7825,20.537001,4.6912,-3.3413,20.537001,6.477,-2.104,19.514999,-11.541,-8.385,7.241,-11.212,-8.146,8.137,-13.18,-4.282,8.137,4.6912,-3.3413,20.537001,4.6663,-3.3902,20.537001,5.509,-4.003,19.514999,4.6912,-3.3413,20.537001,5.509,-4.003,19.514999,6.477,-2.104,19.514999,-4.6663,3.3902,20.537001,-5.509,4.003,19.514999,-4.6912,3.3413,20.537001,-13.18,-4.282,8.137,-13.568,-4.408,7.241,-11.541,-8.385,7.241,-11.406,0,12.975,-10.607,0,14.35,-10.087,3.278,14.35,-14.586,0,6.521,-14.09,-4.578,5.994,-13.872,-4.507,6.521,8.573,11.8,6.521,8.385,11.541,7.241,11.541,8.385,7.241,8.573,11.8,6.521,11.541,8.385,7.241,11.8,8.573,6.521,5.182,-7.133,17.065001,7.133,-5.182,17.065001,6.341,-4.607,18.339001,4.607,-6.341,18.339001,5.182,-7.133,17.065001,6.341,-4.607,18.339001,-10.848,3.525,12.975,-11.406,0,12.975,-10.087,3.278,14.35,5.509,-4.003,19.514999,4.6663,-3.3902,20.537001,4.003,-5.509,19.514999,-6.477,2.104,19.514999,-5.509,4.003,19.514999,-7.454,2.422,18.339001,6.341,-4.607,18.339001,4.003,-5.509,19.514999,4.607,-6.341,18.339001,-7.454,2.422,18.339001,-5.509,4.003,19.514999,-6.341,4.607,18.339001,-14.815,0,5.994,-14.222,-4.621,5.672,-14.09,-4.578,5.994,2.104,-6.477,19.514999,1.7825,-5.4852,20.537001,0.0542,-5.759,20.537001,0.0542,-5.759,20.537001,0,-5.7675,20.537001,0,-6.81,19.514999,0.0542,-5.759,20.537001,0,-6.81,19.514999,2.104,-6.477,19.514999,-6.341,4.607,18.339001,-8.385,2.725,17.065001,-7.454,2.422,18.339001,4.003,-5.509,19.514999,3.3902,-4.6663,20.537001,1.8314,-5.4603,20.537001,-7.133,5.182,17.065001,-8.385,2.725,17.065001,-6.341,4.607,18.339001,2.104,-6.477,19.514999,4.003,-5.509,19.514999,1.8314,-5.4603,20.537001,2.104,-6.477,19.514999,1.8314,-5.4603,20.537001,1.7825,-5.4852,20.537001,2.104,-6.477,19.514999,4.607,-6.341,18.339001,4.003,-5.509,19.514999,8.708,11.986,5.994,8.573,11.8,6.521,11.986,8.708,5.994,11.8,8.573,6.521,11.986,8.708,5.994,8.573,11.8,6.521,-10.087,3.278,14.35,-8.581,6.234,14.35,-10.848,3.525,12.975,-8.385,2.725,17.065001,-8.817,0,17.065001,-7.454,2.422,18.339001,-8.581,6.234,14.35,-9.228,6.704,12.975,-10.848,3.525,12.975,8.708,11.986,5.994,11.986,8.708,5.994,8.79,12.098,5.672,12.098,8.79,5.672,8.79,12.098,5.672,11.986,8.708,5.994,2.422,-7.454,18.339001,4.607,-6.341,18.339001,2.104,-6.477,19.514999,8.817,12.135,5.563,8.79,12.098,5.672,12.098,8.79,5.672,8.817,12.135,5.563,12.098,8.79,5.672,12.135,8.817,5.563,2.422,-7.454,18.339001,5.182,-7.133,17.065001,4.607,-6.341,18.339001,-11.541,3.75,11.635,-10.848,3.525,12.975,-9.228,6.704,12.975,2.725,-8.385,17.065001,5.182,-7.133,17.065001,2.422,-7.454,18.339001,0,-6.81,19.514999,2.422,-7.454,18.339001,2.104,-6.477,19.514999,-7.881,5.726,15.725,-9.265,3.01,15.725,-7.133,5.182,17.065001,-7.133,5.182,17.065001,-9.265,3.01,15.725,-8.385,2.725,17.065001,0,-6.81,19.514999,0,-7.837,18.339001,2.422,-7.454,18.339001,4.6663,-3.3902,20.537001,3.3902,-4.6663,20.537001,4.003,-5.509,19.514999,4.635,14.266,5.563,8.79,12.098,5.672,8.817,12.135,5.563,-9.742,0,15.725,-8.817,0,17.065001,-8.385,2.725,17.065001,-9.265,3.01,15.725,-9.742,0,15.725,-8.385,2.725,17.065001,-14.222,-4.621,5.672,-14.266,-4.635,5.563,-12.135,-8.817,5.563,-10.087,3.278,14.35,-9.265,3.01,15.725,-7.881,5.726,15.725,0,-14.586,6.521,0,-14.266,7.241,-4.408,-13.568,7.241,-4.6912,3.3413,20.537001,-6.477,2.104,19.514999,-5.4852,1.7825,20.537001,2.422,-7.454,18.339001,0,-7.837,18.339001,2.725,-8.385,17.065001,10.813,7.856,9.185,7.856,10.813,9.185,7.518,10.347,10.361,-6.477,2.104,19.514999,-4.6912,3.3413,20.537001,-5.509,4.003,19.514999,2.725,-8.385,17.065001,0,-7.837,18.339001,0,-8.817,17.065001,11.212,8.146,8.137,7.856,10.813,9.185,10.813,7.856,9.185,-6.81,0,19.514999,-5.7675,0,20.537001,-5.4938,1.7283,20.537001,-4.282,-13.18,8.137,0,-14.266,7.241,0,-13.858,8.137,0,-8.817,17.065001,0,-9.742,15.725,3.01,-9.265,15.725,9.228,6.704,12.975,6.704,9.228,12.975,6.234,8.581,14.35,-6.81,0,19.514999,-5.4938,1.7283,20.537001,-6.477,2.104,19.514999,-5.4852,1.7825,20.537001,-6.477,2.104,19.514999,-5.4938,1.7283,20.537001,-6.477,2.104,19.514999,-7.454,2.422,18.339001,-7.837,0,18.339001,3.278,10.087,14.35,3.01,9.265,15.725,5.726,7.881,15.725,-7.837,0,18.339001,-6.81,0,19.514999,-6.477,2.104,19.514999,6.234,8.581,14.35,3.278,10.087,14.35,5.726,7.881,15.725,-7.454,2.422,18.339001,-8.817,0,17.065001,-7.837,0,18.339001,6.704,9.228,12.975,3.525,10.848,12.975,6.234,8.581,14.35,0,-14.954,5.672,0,-14.815,5.994,-4.578,-14.09,5.994,-5.726,-7.881,15.725,-7.881,-5.726,15.725,-8.581,-6.234,14.35,9.742,0,15.725,9.265,-3.01,15.725,10.607,0,14.35,0,9.742,15.725,3.01,9.265,15.725,0,10.607,14.35,3.01,9.265,15.725,3.278,10.087,14.35,0,10.607,14.35,10.848,-3.525,12.975,11.406,0,12.975,10.087,-3.278,14.35,-5.182,-7.133,17.065001,-7.881,-5.726,15.725,-5.726,-7.881,15.725,3.01,9.265,15.725,5.182,7.133,17.065001,5.726,7.881,15.725,10.607,0,14.35,10.087,-3.278,14.35,11.406,0,12.975,-10.607,0,14.35,-10.087,-3.278,14.35,-9.742,0,15.725,10.607,0,14.35,9.265,-3.01,15.725,10.087,-3.278,14.35,-9.265,-3.01,15.725,-9.742,0,15.725,-10.087,-3.278,14.35,3.525,10.848,12.975,3.278,10.087,14.35,6.234,8.581,14.35,-10.087,3.278,14.35,-7.881,5.726,15.725,-8.581,6.234,14.35,-9.265,-3.01,15.725,-8.581,-6.234,14.35,-7.881,-5.726,15.725,0,11.406,12.975,0,10.607,14.35,3.278,10.087,14.35,3.525,10.848,12.975,0,11.406,12.975,3.278,10.087,14.35,-9.265,3.01,15.725,-10.607,0,14.35,-9.742,0,15.725,-10.087,-3.278,14.35,-8.581,-6.234,14.35,-9.265,-3.01,15.725,-10.087,3.278,14.35,-10.607,0,14.35,-9.265,3.01,15.725,6.704,9.228,12.975,3.75,11.541,11.635,3.525,10.848,12.975,10.087,-3.278,14.35,8.581,-6.234,14.35,10.848,-3.525,12.975,-9.228,-6.704,12.975,-8.581,-6.234,14.35,-10.087,-3.278,14.35,-10.087,-3.278,14.35,-10.848,-3.525,12.975,-9.228,-6.704,12.975,3.525,10.848,12.975,0,12.135,11.635,0,11.406,12.975,-10.347,7.518,10.361,-12.164,3.952,10.361,-9.818,7.133,11.635,8.581,-6.234,14.35,9.228,-6.704,12.975,10.848,-3.525,12.975,-10.813,7.856,9.185,-10.347,7.518,10.361,-7.856,10.813,9.185,9.818,7.133,11.635,6.704,9.228,12.975,9.228,6.704,12.975,7.133,9.818,11.635,6.704,9.228,12.975,9.818,7.133,11.635,-10.848,3.525,12.975,-12.135,0,11.635,-11.406,0,12.975,9.818,7.133,11.635,7.518,10.347,10.361,7.133,9.818,11.635,-8.146,-11.212,8.137,-4.282,-13.18,8.137,-7.856,-10.813,9.185,-12.135,0,11.635,-10.848,3.525,12.975,-11.541,3.75,11.635,-11.541,3.75,11.635,-9.818,7.133,11.635,-12.164,3.952,10.361,-8.817,0,17.065001,-9.265,-3.01,15.725,-8.385,-2.725,17.065001,-4.282,-13.18,8.137,-8.146,-11.212,8.137,-4.408,-13.568,7.241,-11.541,3.75,11.635,-12.79,0,10.361,-12.135,0,11.635,-9.265,-3.01,15.725,-8.817,0,17.065001,-9.742,0,15.725,-10.087,-3.278,14.35,-10.607,0,14.35,-10.848,-3.525,12.975,7.856,10.813,9.185,4.282,13.18,8.137,4.13,12.711,9.185,3.01,9.265,15.725,0,9.742,15.725,2.725,8.385,17.065001,-10.848,-3.525,12.975,-10.607,0,14.35,-11.406,0,12.975,0,8.817,17.065001,2.725,8.385,17.065001,0,9.742,15.725,-12.164,3.952,10.361,-12.79,0,10.361,-11.541,3.75,11.635,-4.408,-13.568,7.241,0,-14.266,7.241,-4.282,-13.18,8.137,-12.711,4.13,9.185,-12.164,3.952,10.361,-10.347,7.518,10.361,2.725,8.385,17.065001,5.182,7.133,17.065001,3.01,9.265,15.725,-11.541,-3.75,11.635,-11.406,0,12.975,-12.135,0,11.635,-10.813,7.856,9.185,-12.711,4.13,9.185,-10.347,7.518,10.361,0,-14.586,6.521,-4.408,-13.568,7.241,-4.507,-13.872,6.521,3.75,11.541,11.635,6.704,9.228,12.975,7.133,9.818,11.635,-13.365,0,9.185,-12.79,0,10.361,-12.164,3.952,10.361,2.422,7.454,18.339001,2.725,8.385,17.065001,0,8.817,17.065001,-12.711,4.13,9.185,-13.365,0,9.185,-12.164,3.952,10.361,-11.541,-3.75,11.635,-10.848,-3.525,12.975,-11.406,0,12.975,-11.212,8.146,8.137,-13.18,4.282,8.137,-10.813,7.856,9.185,5.509,4.003,19.514999,6.341,4.607,18.339001,4.003,5.509,19.514999,0,-14.815,5.994,0,-14.586,6.521,-4.507,-13.872,6.521,-10.848,-3.525,12.975,-9.818,-7.133,11.635,-9.228,-6.704,12.975,-12.711,4.13,9.185,-10.813,7.856,9.185,-13.18,4.282,8.137,-13.18,4.282,8.137,-13.858,0,8.137,-12.711,4.13,9.185,-4.507,-13.872,6.521,-4.578,-14.09,5.994,0,-14.815,5.994,3.75,11.541,11.635,0,12.135,11.635,3.525,10.848,12.975,-7.133,-9.818,11.635,-9.818,-7.133,11.635,-10.347,-7.518,10.361,-13.858,0,8.137,-13.365,0,9.185,-12.711,4.13,9.185,7.133,9.818,11.635,3.952,12.164,10.361,3.75,11.541,11.635,-4.621,-14.222,5.672,0,-14.954,5.672,-4.578,-14.09,5.994,3.952,12.164,10.361,7.133,9.818,11.635,7.518,10.347,10.361,-9.818,7.133,11.635,-11.541,3.75,11.635,-9.228,6.704,12.975,11.541,-3.75,11.635,10.848,-3.525,12.975,9.228,-6.704,12.975,3.75,11.541,11.635,0,12.79,10.361,0,12.135,11.635,0,-15,5.563,0,-14.954,5.672,-4.621,-14.222,5.672,9.818,-7.133,11.635,11.541,-3.75,11.635,9.228,-6.704,12.975,-4.635,-14.266,5.563,0,-15,5.563,-4.621,-14.222,5.672,-10.848,-3.525,12.975,-11.541,-3.75,11.635,-9.818,-7.133,11.635,-12.164,-3.952,10.361,-11.541,-3.75,11.635,-12.135,0,11.635,3.952,12.164,10.361,0,12.79,10.361,3.75,11.541,11.635,9.742,0,15.725,8.817,0,17.065001,8.385,-2.725,17.065001,7.518,10.347,10.361,4.13,12.711,9.185,3.952,12.164,10.361,9.742,0,15.725,8.385,-2.725,17.065001,9.265,-3.01,15.725,-12.164,-3.952,10.361,-12.135,0,11.635,-12.79,0,10.361,-10.347,-7.518,10.361,-9.818,-7.133,11.635,-11.541,-3.75,11.635,4.13,12.711,9.185,7.518,10.347,10.361,7.856,10.813,9.185,-4.578,-14.09,5.994,-4.507,-13.872,6.521,-8.573,-11.8,6.521,-12.164,-3.952,10.361,-10.347,-7.518,10.361,-11.541,-3.75,11.635,0,13.365,9.185,0,12.79,10.361,3.952,12.164,10.361,-12.164,-3.952,10.361,-10.813,-7.856,9.185,-10.347,-7.518,10.361,4.13,12.711,9.185,0,13.365,9.185,3.952,12.164,10.361,-12.79,0,10.361,-12.711,-4.13,9.185,-12.164,-3.952,10.361,11.541,-3.75,11.635,12.79,0,10.361,12.135,0,11.635,-8.708,-11.986,5.994,-4.621,-14.222,5.672,-4.578,-14.09,5.994,-12.79,0,10.361,-13.365,0,9.185,-12.711,-4.13,9.185,-4.507,13.872,6.521,-4.408,13.568,7.241,0,14.266,7.241,10.848,-3.525,12.975,12.135,0,11.635,11.406,0,12.975,-12.711,-4.13,9.185,-10.813,-7.856,9.185,-12.164,-3.952,10.361,-8.146,-11.212,8.137,-7.856,-10.813,9.185,-11.212,-8.146,8.137,-13.18,-4.282,8.137,-12.711,-4.13,9.185,-13.365,0,9.185,0,13.858,8.137,0,14.266,7.241,-4.408,13.568,7.241,-12.711,-4.13,9.185,-11.212,-8.146,8.137,-10.813,-7.856,9.185,4.607,6.341,18.339001,5.182,7.133,17.065001,2.725,8.385,17.065001,7.881,5.726,15.725,9.265,3.01,15.725,8.581,6.234,14.35,-13.18,-4.282,8.137,-11.212,-8.146,8.137,-12.711,-4.13,9.185,11.541,-3.75,11.635,12.135,0,11.635,10.848,-3.525,12.975,6.234,8.581,14.35,5.726,7.881,15.725,8.581,6.234,14.35,7.881,5.726,15.725,8.581,6.234,14.35,5.726,7.881,15.725,-8.146,-11.212,8.137,-11.212,-8.146,8.137,-8.385,-11.541,7.241,-11.541,-8.385,7.241,-8.385,-11.541,7.241,-11.212,-8.146,8.137,-7.133,-9.818,11.635,-9.228,-6.704,12.975,-9.818,-7.133,11.635,4.003,5.509,19.514999,3.3413,4.6912,20.537001,3.3902,4.6663,20.537001,6.234,8.581,14.35,8.581,6.234,14.35,9.228,6.704,12.975,9.818,-7.133,11.635,12.164,-3.952,10.361,11.541,-3.75,11.635,-8.385,-11.541,7.241,-4.408,-13.568,7.241,-8.146,-11.212,8.137,0,-9.742,15.725,-3.01,-9.265,15.725,0,-10.607,14.35,9.265,3.01,15.725,9.742,0,15.725,10.087,3.278,14.35,-11.541,-8.385,7.241,-11.8,-8.573,6.521,-8.573,-11.8,6.521,-11.541,-8.385,7.241,-8.573,-11.8,6.521,-8.385,-11.541,7.241,9.818,-7.133,11.635,10.347,-7.518,10.361,12.164,-3.952,10.361,-4.507,-13.872,6.521,-4.408,-13.568,7.241,-8.385,-11.541,7.241,-3.01,-9.265,15.725,-3.278,-10.087,14.35,0,-10.607,14.35,0,14.586,6.521,-4.507,13.872,6.521,0,14.266,7.241,-4.578,14.09,5.994,-4.507,13.872,6.521,0,14.586,6.521,-3.525,-10.848,12.975,-3.278,-10.087,14.35,-6.234,-8.581,14.35,-4.507,-13.872,6.521,-8.385,-11.541,7.241,-8.573,-11.8,6.521,10.607,0,14.35,10.087,3.278,14.35,9.742,0,15.725,-3.525,-10.848,12.975,0,-11.406,12.975,-3.278,-10.087,14.35,-11.8,-8.573,6.521,-11.986,-8.708,5.994,-8.573,-11.8,6.521,10.087,3.278,14.35,8.581,6.234,14.35,9.265,3.01,15.725,0,14.815,5.994,-4.578,14.09,5.994,0,14.586,6.521,12.164,-3.952,10.361,12.79,0,10.361,11.541,-3.75,11.635,10.607,0,14.35,10.848,3.525,12.975,10.087,3.278,14.35,12.711,-4.13,9.185,12.164,-3.952,10.361,10.347,-7.518,10.361,-3.278,-10.087,14.35,0,-11.406,12.975,0,-10.607,14.35,-6.234,-8.581,14.35,-5.726,-7.881,15.725,-8.581,-6.234,14.35,-11.541,-8.385,7.241,-13.568,-4.408,7.241,-11.8,-8.573,6.521,10.607,0,14.35,11.406,0,12.975,10.848,3.525,12.975,13.365,0,9.185,12.164,-3.952,10.361,12.711,-4.13,9.185,-13.568,-4.408,7.241,-13.872,-4.507,6.521,-11.8,-8.573,6.521,9.228,6.704,12.975,8.581,6.234,14.35,10.087,3.278,14.35,-6.704,-9.228,12.975,-6.234,-8.581,14.35,-9.228,-6.704,12.975,-8.581,-6.234,14.35,-9.228,-6.704,12.975,-6.234,-8.581,14.35,10.813,-7.856,9.185,12.711,-4.13,9.185,10.347,-7.518,10.361,-4.282,13.18,8.137,0,13.858,8.137,-4.408,13.568,7.241,9.228,6.704,12.975,10.087,3.278,14.35,10.848,3.525,12.975,12.164,-3.952,10.361,13.365,0,9.185,12.79,0,10.361,10.848,3.525,12.975,11.406,0,12.975,11.541,3.75,11.635,-14.09,-4.578,5.994,-11.986,-8.708,5.994,-13.872,-4.507,6.521,-3.278,-10.087,14.35,-3.01,-9.265,15.725,-5.726,-7.881,15.725,0,13.365,9.185,0,13.858,8.137,-4.282,13.18,8.137,-5.182,-7.133,17.065001,-5.726,-7.881,15.725,-3.01,-9.265,15.725,10.848,3.525,12.975,11.541,3.75,11.635,9.818,7.133,11.635,-6.234,-8.581,14.35,-3.278,-10.087,14.35,-5.726,-7.881,15.725,-8.708,-11.986,5.994,-8.573,-11.8,6.521,-11.986,-8.708,5.994,10.848,3.525,12.975,9.818,7.133,11.635,9.228,6.704,12.975,-4.578,-14.09,5.994,-8.573,-11.8,6.521,-8.708,-11.986,5.994,13.18,-4.282,8.137,12.711,-4.13,9.185,10.813,-7.856,9.185,-6.234,-8.581,14.35,-6.704,-9.228,12.975,-3.525,-10.848,12.975,-4.578,14.09,5.994,0,14.815,5.994,-4.621,14.222,5.672,8.385,2.725,17.065001,8.817,0,17.065001,9.265,3.01,15.725,0,-12.135,11.635,0,-11.406,12.975,-3.525,-10.848,12.975,-8.708,-11.986,5.994,-11.986,-8.708,5.994,-8.79,-12.098,5.672,-12.098,-8.79,5.672,-8.79,-12.098,5.672,-11.986,-8.708,5.994,0,14.954,5.672,-4.621,14.222,5.672,0,14.815,5.994,7.881,5.726,15.725,8.385,2.725,17.065001,9.265,3.01,15.725,-9.228,-6.704,12.975,-7.133,-9.818,11.635,-6.704,-9.228,12.975,-4.635,14.266,5.563,-4.621,14.222,5.672,0,14.954,5.672,8.817,0,17.065001,9.742,0,15.725,9.265,3.01,15.725,0,14.954,5.672,0,15,5.563,-4.635,14.266,5.563,12.711,-4.13,9.185,13.858,0,8.137,13.365,0,9.185,-3.75,-11.541,11.635,-3.525,-10.848,12.975,-6.704,-9.228,12.975,-8.708,-11.986,5.994,-8.79,-12.098,5.672,-4.621,-14.222,5.672,-7.133,-9.818,11.635,-3.75,-11.541,11.635,-6.704,-9.228,12.975,-12.098,-8.79,5.672,-12.135,-8.817,5.563,-8.79,-12.098,5.672,13.858,0,8.137,12.711,-4.13,9.185,13.18,-4.282,8.137,-8.79,-12.098,5.672,-12.135,-8.817,5.563,-8.817,-12.135,5.563,11.406,0,12.975,12.135,0,11.635,11.541,3.75,11.635,6.704,-9.228,12.975,9.228,-6.704,12.975,6.234,-8.581,14.35,8.581,-6.234,14.35,6.234,-8.581,14.35,9.228,-6.704,12.975,-2.725,-8.385,17.065001,-5.182,-7.133,17.065001,-3.01,-9.265,15.725,-11.8,-8.573,6.521,-13.872,-4.507,6.521,-11.986,-8.708,5.994,5.726,-7.881,15.725,6.234,-8.581,14.35,7.881,-5.726,15.725,8.581,-6.234,14.35,7.881,-5.726,15.725,6.234,-8.581,14.35,9.265,-3.01,15.725,7.881,-5.726,15.725,10.087,-3.278,14.35,-2.725,-8.385,17.065001,-3.01,-9.265,15.725,0,-9.742,15.725,-14.09,-4.578,5.994,-12.098,-8.79,5.672,-11.986,-8.708,5.994,10.087,-3.278,14.35,7.881,-5.726,15.725,8.581,-6.234,14.35,0,-12.135,11.635,-3.525,-10.848,12.975,-3.75,-11.541,11.635,5.182,-7.133,17.065001,2.725,-8.385,17.065001,5.726,-7.881,15.725,-3.75,-11.541,11.635,0,-12.79,10.361,0,-12.135,11.635,-4.13,12.711,9.185,0,13.365,9.185,-4.282,13.18,8.137,-4.13,-12.711,9.185,-3.952,-12.164,10.361,-7.518,-10.347,10.361,-14.09,-4.578,5.994,-14.222,-4.621,5.672,-12.098,-8.79,5.672,-8.146,11.212,8.137,-7.856,10.813,9.185,-4.13,12.711,9.185,-12.098,-8.79,5.672,-14.222,-4.621,5.672,-12.135,-8.817,5.563,-4.282,13.18,8.137,-8.146,11.212,8.137,-4.13,12.711,9.185,10.347,-7.518,10.361,7.518,-10.347,10.361,10.813,-7.856,9.185,-4.635,-14.266,5.563,-4.621,-14.222,5.672,-8.79,-12.098,5.672,-8.79,-12.098,5.672,-8.817,-12.135,5.563,-4.635,-14.266,5.563,-8.573,11.8,6.521,-4.408,13.568,7.241,-4.507,13.872,6.521,10.347,-7.518,10.361,9.818,-7.133,11.635,7.518,-10.347,10.361,4.408,13.568,7.241,0,14.266,7.241,4.282,13.18,8.137,3.278,-10.087,14.35,3.01,-9.265,15.725,0,-9.742,15.725,-4.282,13.18,8.137,-4.408,13.568,7.241,-8.385,11.541,7.241,0,14.586,6.521,4.408,13.568,7.241,4.507,13.872,6.521,-8.385,11.541,7.241,-4.408,13.568,7.241,-8.573,11.8,6.521,4.578,14.09,5.994,4.507,13.872,6.521,8.573,11.8,6.521,0,-10.607,14.35,3.278,-10.087,14.35,0,-9.742,15.725,0,-10.607,14.35,3.525,-10.848,12.975,3.278,-10.087,14.35,3.278,-10.087,14.35,6.234,-8.581,14.35,3.01,-9.265,15.725,-4.578,14.09,5.994,-4.621,14.222,5.672,-8.79,12.098,5.672,0,-10.607,14.35,0,-11.406,12.975,3.525,-10.848,12.975,-11.212,8.146,8.137,-10.813,7.856,9.185,-8.146,11.212,8.137,8.79,12.098,5.672,4.635,14.266,5.563,4.621,14.222,5.672,6.704,-9.228,12.975,6.234,-8.581,14.35,3.278,-10.087,14.35,-8.385,11.541,7.241,-8.146,11.212,8.137,-4.282,13.18,8.137,-8.385,11.541,7.241,-11.541,8.385,7.241,-8.146,11.212,8.137,0,-13.365,9.185,-3.952,-12.164,10.361,-4.13,-12.711,9.185,6.704,-9.228,12.975,3.278,-10.087,14.35,3.525,-10.848,12.975,-7.856,-10.813,9.185,-4.13,-12.711,9.185,-7.518,-10.347,10.361,-11.541,8.385,7.241,-11.212,8.146,8.137,-8.146,11.212,8.137,-4.282,-13.18,8.137,-4.13,-12.711,9.185,-7.856,-10.813,9.185,7.133,-9.818,11.635,6.704,-9.228,12.975,3.525,-10.848,12.975,-4.282,-13.18,8.137,0,-13.858,8.137,-4.13,-12.711,9.185,-8.573,11.8,6.521,-11.8,8.573,6.521,-11.541,8.385,7.241,-8.573,11.8,6.521,-11.541,8.385,7.241,-8.385,11.541,7.241,-4.13,-12.711,9.185,0,-13.858,8.137,0,-13.365,9.185,-8.573,11.8,6.521,-11.986,8.708,5.994,-11.8,8.573,6.521,0,-13.365,9.185,0,-12.79,10.361,-3.952,-12.164,10.361,3.01,-9.265,15.725,6.234,-8.581,14.35,5.726,-7.881,15.725,-11.541,8.385,7.241,-13.872,4.507,6.521,-13.568,4.408,7.241,9.818,-7.133,11.635,9.228,-6.704,12.975,7.133,-9.818,11.635,6.704,-9.228,12.975,7.133,-9.818,11.635,9.228,-6.704,12.975,4.635,14.266,5.563,0,15,5.563,4.621,14.222,5.672,-11.8,8.573,6.521,-13.872,4.507,6.521,-11.541,8.385,7.241,5.726,-7.881,15.725,2.725,-8.385,17.065001,3.01,-9.265,15.725,-13.568,4.408,7.241,-11.212,8.146,8.137,-11.541,8.385,7.241,2.725,-8.385,17.065001,0,-8.817,17.065001,3.01,-9.265,15.725,-14.09,4.578,5.994,-13.872,4.507,6.521,-11.8,8.573,6.521,8.146,11.212,8.137,7.856,10.813,9.185,11.212,8.146,8.137,-11.986,8.708,5.994,-14.09,4.578,5.994,-11.8,8.573,6.521,8.146,11.212,8.137,4.282,13.18,8.137,7.856,10.813,9.185,-4.578,14.09,5.994,-8.708,11.986,5.994,-4.507,13.872,6.521,10.813,-7.856,9.185,7.518,-10.347,10.361,7.856,-10.813,9.185,8.385,11.541,7.241,4.408,13.568,7.241,8.146,11.212,8.137,7.133,-9.818,11.635,3.525,-10.848,12.975,3.75,-11.541,11.635,-8.817,12.135,5.563,-8.79,12.098,5.672,-4.621,14.222,5.672,4.408,13.568,7.241,4.282,13.18,8.137,8.146,11.212,8.137,7.856,-10.813,9.185,4.13,-12.711,9.185,8.146,-11.212,8.137,10.813,-7.856,9.185,7.856,-10.813,9.185,11.212,-8.146,8.137,8.146,-11.212,8.137,11.212,-8.146,8.137,7.856,-10.813,9.185,4.507,13.872,6.521,4.408,13.568,7.241,8.385,11.541,7.241,3.525,-10.848,12.975,0,-11.406,12.975,3.75,-11.541,11.635,-8.817,12.135,5.563,-4.621,14.222,5.672,-4.635,14.266,5.563,0,-11.406,12.975,0,-12.135,11.635,3.75,-11.541,11.635,4.507,13.872,6.521,8.385,11.541,7.241,8.573,11.8,6.521,-8.708,11.986,5.994,-8.573,11.8,6.521,-4.507,13.872,6.521,3.952,-12.164,10.361,3.75,-11.541,11.635,0,-12.135,11.635,-8.708,11.986,5.994,-11.986,8.708,5.994,-8.573,11.8,6.521,0,-12.79,10.361,3.952,-12.164,10.361,0,-12.135,11.635,-8.708,11.986,5.994,-4.578,14.09,5.994,-8.79,12.098,5.672,7.518,-10.347,10.361,7.133,-9.818,11.635,3.75,-11.541,11.635,8.573,11.8,6.521,8.708,11.986,5.994,4.578,14.09,5.994,-12.098,8.79,5.672,-8.79,12.098,5.672,-12.135,8.817,5.563,-8.817,12.135,5.563,-12.135,8.817,5.563,-8.79,12.098,5.672,3.952,-12.164,10.361,7.518,-10.347,10.361,3.75,-11.541,11.635,3.952,-12.164,10.361,7.856,-10.813,9.185,7.518,-10.347,10.361,4.621,14.222,5.672,4.578,14.09,5.994,8.708,11.986,5.994,-8.708,11.986,5.994,-8.79,12.098,5.672,-11.986,8.708,5.994,-12.098,8.79,5.672,-11.986,8.708,5.994,-8.79,12.098,5.672,0,-12.79,10.361,4.13,-12.711,9.185,3.952,-12.164,10.361,8.708,11.986,5.994,8.79,12.098,5.672,4.621,14.222,5.672,0,-12.79,10.361,0,-13.365,9.185,4.13,-12.711,9.185,4.13,-12.711,9.185,7.856,-10.813,9.185,3.952,-12.164,10.361,0,14.586,6.521,0,14.266,7.241,4.408,13.568,7.241,4.282,-13.18,8.137,4.13,-12.711,9.185,0,-13.365,9.185,-11.986,8.708,5.994,-14.222,4.621,5.672,-14.09,4.578,5.994,4.578,14.09,5.994,0,14.815,5.994,4.507,13.872,6.521,-14.222,4.621,5.672,-11.986,8.708,5.994,-12.098,8.79,5.672,7.133,-9.818,11.635,7.518,-10.347,10.361,9.818,-7.133,11.635,12.098,-8.79,5.672,14.266,-4.635,5.563,14.222,-4.621,5.672,0,14.586,6.521,4.507,13.872,6.521,0,14.815,5.994,15,0,5.563,14.954,0,5.672,14.222,-4.621,5.672,0,14.266,7.241,0,13.858,8.137,4.282,13.18,8.137,14.266,-4.635,5.563,15,0,5.563,14.222,-4.621,5.672,-12.098,8.79,5.672,-14.266,4.635,5.563,-14.222,4.621,5.672,-12.098,8.79,5.672,-12.135,8.817,5.563,-14.266,4.635,5.563,4.578,14.09,5.994,0,14.954,5.672,0,14.815,5.994,14.222,-4.621,5.672,14.09,-4.578,5.994,11.986,-8.708,5.994,-7.856,10.813,9.185,-8.146,11.212,8.137,-10.813,7.856,9.185,0,14.954,5.672,4.578,14.09,5.994,4.621,14.222,5.672,11.986,-8.708,5.994,12.098,-8.79,5.672,14.222,-4.621,5.672,12.098,-8.79,5.672,12.135,-8.817,5.563,14.266,-4.635,5.563,0,14.954,5.672,4.621,14.222,5.672,0,15,5.563,11.212,-8.146,8.137,13.18,-4.282,8.137,10.813,-7.856,9.185,0,13.858,8.137,0,13.365,9.185,4.13,12.711,9.185,13.18,-4.282,8.137,14.266,0,7.241,13.858,0,8.137,0,13.858,8.137,4.13,12.711,9.185,4.282,13.18,8.137,13.568,-4.408,7.241,13.18,-4.282,8.137,11.212,-8.146,8.137,11.212,8.146,8.137,11.541,8.385,7.241,8.385,11.541,7.241,11.212,8.146,8.137,8.385,11.541,7.241,8.146,11.212,8.137,12.098,8.79,5.672,14.222,4.621,5.672,12.135,8.817,5.563,14.222,4.621,5.672,14.266,4.635,5.563,12.135,8.817,5.563,13.858,0,8.137,13.568,4.408,7.241,13.18,4.282,8.137,14.266,0,7.241,13.568,4.408,7.241,13.858,0,8.137,13.872,4.507,6.521,13.568,4.408,7.241,14.266,0,7.241,13.568,4.408,7.241,13.872,4.507,6.521,11.8,8.573,6.521,14.266,0,7.241,14.586,0,6.521,13.872,4.507,6.521,14.09,4.578,5.994,13.872,4.507,6.521,14.586,0,6.521,14.586,0,6.521,14.815,0,5.994,14.09,4.578,5.994,14.222,4.621,5.672,14.09,4.578,5.994,14.815,0,5.994,14.954,0,5.672,14.222,4.621,5.672,14.815,0,5.994,14.954,0,5.672,14.266,4.635,5.563,14.222,4.621,5.672,14.954,0,5.672,15,0,5.563,14.266,4.635,5.563,13.365,0,9.185,13.18,4.282,8.137,12.711,4.13,9.185,13.365,0,9.185,13.858,0,8.137,13.18,4.282,8.137,12.711,4.13,9.185,13.18,4.282,8.137,11.212,8.146,8.137,11.541,8.385,7.241,11.212,8.146,8.137,13.18,4.282,8.137,13.18,4.282,8.137,13.568,4.408,7.241,11.541,8.385,7.241,13.568,4.408,7.241,11.8,8.573,6.521,11.541,8.385,7.241,13.872,4.507,6.521,11.986,8.708,5.994,11.8,8.573,6.521,14.09,4.578,5.994,11.986,8.708,5.994,13.872,4.507,6.521,11.986,8.708,5.994,14.09,4.578,5.994,12.098,8.79,5.672,14.09,4.578,5.994,14.222,4.621,5.672,12.098,8.79,5.672,-6.704,9.228,12.975,-6.234,8.581,14.35,-3.278,10.087,14.35,-3.525,10.848,12.975,-6.704,9.228,12.975,-3.278,10.087,14.35,-6.704,9.228,12.975,-3.525,10.848,12.975,-7.133,9.818,11.635,-3.525,10.848,12.975,-3.75,11.541,11.635,-7.133,9.818,11.635,-2.725,8.385,17.065001,0,8.817,17.065001,-3.01,9.265,15.725,0,8.817,17.065001,0,9.742,15.725,-3.01,9.265,15.725,-3.01,9.265,15.725,-5.726,7.881,15.725,-2.725,8.385,17.065001,-3.278,10.087,14.35,-3.01,9.265,15.725,0,9.742,15.725,-3.278,10.087,14.35,-6.234,8.581,14.35,-3.01,9.265,15.725,-5.726,7.881,15.725,-3.01,9.265,15.725,-6.234,8.581,14.35,0,9.742,15.725,0,10.607,14.35,-3.278,10.087,14.35,0,10.607,14.35,-3.525,10.848,12.975,-3.278,10.087,14.35,0,10.607,14.35,0,11.406,12.975,-3.525,10.848,12.975,-3.75,11.541,11.635,-3.525,10.848,12.975,0,11.406,12.975,-3.75,11.541,11.635,0,11.406,12.975,0,12.135,11.635,-5.726,7.881,15.725,-6.234,8.581,14.35,-8.581,6.234,14.35,-8.581,6.234,14.35,-6.234,8.581,14.35,-9.228,6.704,12.975,-6.704,9.228,12.975,-9.228,6.704,12.975,-6.234,8.581,14.35,-9.818,7.133,11.635,-9.228,6.704,12.975,-7.133,9.818,11.635,-9.818,7.133,11.635,-7.133,9.818,11.635,-7.518,10.347,10.361],"normalized":false},"normal":{"itemSize":3,"type":"Float32Array","array":[0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,0,0,-1,-0.627913,-0.319838,0.709528,-0.627913,-0.319838,0.709528,-0.627913,-0.319838,0.709528,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,-0.627642,-0.319936,0.709723,-0.627642,-0.319936,0.709723,-0.627642,-0.319936,0.709723,-0.62775,-0.319651,0.709755,-0.62775,-0.319651,0.709755,-0.62775,-0.319651,0.709755,0.88065,0.139495,0.452765,0.88065,0.139495,0.452765,0.88065,0.139495,0.452765,-0.695707,-0.110215,0.70982,-0.695707,-0.110215,0.70982,-0.695707,-0.110215,0.70982,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.69582,-0.110127,0.709723,-0.69582,-0.110127,0.709723,-0.69582,-0.110127,0.709723,-0.69587,-0.109132,0.709827,-0.69587,-0.109132,0.709827,-0.69587,-0.109132,0.709827,0.880649,0.139496,0.452767,0.880649,0.139496,0.452767,0.880649,0.139496,0.452767,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.889347,0.140873,0.434991,0.889347,0.140873,0.434991,0.889347,0.140873,0.434991,-0.747813,-0.118356,0.653275,-0.747813,-0.118356,0.653275,-0.747813,-0.118356,0.653275,-0.404671,-0.794545,0.452703,-0.404671,-0.794545,0.452703,-0.404671,-0.794545,0.452703,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.9008,-0.14264,0.410137,0.9008,-0.14264,0.410137,0.9008,-0.14264,0.410137,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,-0.4049,-0.794647,0.452319,-0.4049,-0.794647,0.452319,-0.4049,-0.794647,0.452319,0.890992,-0.454018,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,0.987692,-0.156411,0,-0.747924,-0.118272,0.653162,-0.747924,-0.118272,0.653162,-0.747924,-0.118272,0.653162,-0.139496,-0.88065,0.452765,-0.139496,-0.88065,0.452765,-0.139496,-0.88065,0.452765,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.890992,0.454018,0,0.904392,-0.143209,0.401953,0.904392,-0.143209,0.401953,0.904392,-0.143209,0.401953,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.707107,0.707107,0,0.319737,0.627715,0.709748,0.319737,0.627715,0.709748,0.319737,0.627715,0.709748,0.454018,0.890992,0,0.454018,0.890992,0,0.454018,0.890992,0,0.156411,0.987692,0,0.156411,0.987692,0,0.156411,0.987692,0,0.320014,0.627795,0.709553,0.320014,0.627795,0.709553,0.320014,0.627795,0.709553,0.904528,-0.143296,0.401615,0.904528,-0.143296,0.401615,0.904528,-0.143296,0.401615,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,-0.156411,0.987692,0,0.907623,-0.143786,0.394393,0.907623,-0.143786,0.394393,0.907623,-0.143786,0.394393,-0.454018,0.890992,0,-0.454018,0.890992,0,-0.454018,0.890992,0,0.110188,0.695789,0.709744,0.110188,0.695789,0.709744,0.110188,0.695789,0.709744,0.907478,-0.143714,0.394752,0.907478,-0.143714,0.394752,0.907478,-0.143714,0.394752,-0.707107,0.707107,0,-0.707107,0.707107,0,-0.707107,0.707107,0,0.987692,0.156411,0,0.987692,0.156411,0,0.987692,0.156411,0,0.908555,-0.143884,0.392205,0.908555,-0.143884,0.392205,0.908555,-0.143884,0.392205,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.890992,0.454018,0,-0.81269,0.413917,0.410131,-0.81269,0.413917,0.410131,-0.81269,0.413917,0.410131,0.908741,-0.143951,0.39175,0.908741,-0.143951,0.39175,0.908741,-0.143951,0.39175,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,-0.987692,0.156411,0,0.156411,-0.987692,0,0.156411,-0.987692,0,0.156411,-0.987692,0,0.156411,-0.987692,0,0.156411,-0.987692,0,0.156411,-0.987692,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.454018,-0.890992,0,0.110114,0.695739,0.709804,0.110114,0.695739,0.709804,0.110114,0.695739,0.709804,0.110385,0.695666,0.709834,0.110385,0.695666,0.709834,0.110385,0.695666,0.709834,0.707107,-0.707107,0,0.707107,-0.707107,0,0.707107,-0.707107,0,0.343819,0.674497,0.653332,0.343819,0.674497,0.653332,0.343819,0.674497,0.653332,0.890992,-0.454018,0,0.890992,-0.454018,0,0.890992,-0.454018,0,0.118372,0.747915,0.653155,0.118372,0.747915,0.653155,0.118372,0.747915,0.653155,0.118258,0.747835,0.653267,0.118258,0.747835,0.653267,0.118258,0.747835,0.653267,0.647465,-0.647465,0.401967,0.647465,-0.647465,0.401967,0.647465,-0.647465,0.401967,0.647465,-0.647465,0.401967,0.647465,-0.647465,0.401967,0.647465,-0.647465,0.401967,0.343532,0.674409,0.653574,0.343532,0.674409,0.653574,0.343532,0.674409,0.653574,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,-0.987692,-0.156411,0,0.361525,0.709732,0.604633,0.361525,0.709732,0.604633,0.361525,0.709732,0.604633,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.890992,-0.454018,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.707107,-0.707107,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.454018,-0.890992,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.156411,-0.987692,0,-0.404761,0.794723,0.452309,-0.404761,0.794723,0.452309,-0.404761,0.794723,0.452309,-0.404814,0.794478,0.452693,-0.404814,0.794478,0.452693,-0.404814,0.794478,0.452693,0.69587,0.109132,0.709827,0.69587,0.109132,0.709827,0.69587,0.109132,0.709827,-0.40872,0.802145,0.435329,-0.40872,0.802145,0.435329,-0.40872,0.802145,0.435329,0.627913,0.319838,0.709528,0.627913,0.319838,0.709528,0.627913,0.319838,0.709528,0.649431,-0.649431,0.395574,0.649431,-0.649431,0.395574,0.649431,-0.649431,0.395574,-0.408693,0.802313,0.435045,-0.408693,0.802313,0.435045,-0.408693,0.802313,0.435045,0.62775,0.319651,0.709755,0.62775,0.319651,0.709755,0.62775,0.319651,0.709755,0.813001,-0.414371,0.409054,0.813001,-0.414371,0.409054,0.813001,-0.414371,0.409054,0.498244,0.498244,0.709582,0.498244,0.498244,0.709582,0.498244,0.498244,0.709582,0.815916,-0.415856,0.401678,0.815916,-0.415856,0.401678,0.815916,-0.415856,0.401678,-0.641206,-0.641206,0.421556,-0.641206,-0.641206,0.421556,-0.641206,-0.641206,0.421556,0.815812,-0.415731,0.402017,0.815812,-0.415731,0.402017,0.815812,-0.415731,0.402017,-0.630604,-0.630604,0.452412,-0.630604,-0.630604,0.452412,-0.630604,-0.630604,0.452412,-0.636619,-0.636619,0.435239,-0.636619,-0.636619,0.435239,-0.636619,-0.636619,0.435239,-0.636619,-0.636619,0.435239,-0.636619,-0.636619,0.435239,-0.636619,-0.636619,0.435239,0.794723,0.404761,0.452309,0.794723,0.404761,0.452309,0.794723,0.404761,0.452309,-0.139496,0.880649,0.452767,-0.139496,0.880649,0.452767,-0.139496,0.880649,0.452767,0.818596,-0.41715,0.394824,0.818596,-0.41715,0.394824,0.818596,-0.41715,0.394824,-0.139495,0.88065,0.452765,-0.139495,0.88065,0.452765,-0.139495,0.88065,0.452765,-0.109132,0.69587,0.709827,-0.109132,0.69587,0.709827,-0.109132,0.69587,0.709827,-0.110127,0.69582,0.709723,-0.110127,0.69582,0.709723,-0.110127,0.69582,0.709723,0.650533,-0.650533,0.391935,0.650533,-0.650533,0.391935,0.650533,-0.650533,0.391935,0.650533,-0.650533,0.391935,0.650533,-0.650533,0.391935,0.650533,-0.650533,0.391935,-0.140873,0.889347,0.434991,-0.140873,0.889347,0.434991,-0.140873,0.889347,0.434991,-0.140841,0.88941,0.434873,-0.140841,0.88941,0.434873,-0.140841,0.88941,0.434873,0.535206,0.535206,0.653535,0.535206,0.535206,0.653535,0.535206,0.535206,0.653535,-0.319651,0.62775,0.709755,-0.319651,0.62775,0.709755,-0.319651,0.62775,0.709755,0.653056,-0.653056,0.383453,0.653056,-0.653056,0.383453,0.653056,-0.653056,0.383453,0.653056,-0.653056,0.383453,0.653056,-0.653056,0.383453,0.653056,-0.653056,0.383453,0.563318,0.563318,0.604439,0.563318,0.563318,0.604439,0.563318,0.563318,0.604439,0.563318,0.563318,0.604439,0.563318,0.563318,0.604439,0.563318,0.563318,0.604439,0.73621,0.375147,0.563258,0.73621,0.375147,0.563258,0.73621,0.375147,0.563258,-0.110188,-0.695789,0.709744,-0.110188,-0.695789,0.709744,-0.110188,-0.695789,0.709744,-0.110114,-0.695739,0.709804,-0.110114,-0.695739,0.709804,-0.110114,-0.695739,0.709804,0.649431,-0.649431,0.395574,0.649431,-0.649431,0.395574,0.649431,-0.649431,0.395574,-0.110385,-0.695666,0.709834,-0.110385,-0.695666,0.709834,-0.110385,-0.695666,0.709834,-0.498244,0.498244,0.709582,-0.498244,0.498244,0.709582,-0.498244,0.498244,0.709582,-0.91166,0.144414,0.384734,-0.91166,0.144414,0.384734,-0.91166,0.144414,0.384734,-0.118372,-0.747915,0.653155,-0.118372,-0.747915,0.653155,-0.118372,-0.747915,0.653155,-0.118258,-0.747835,0.653267,-0.118258,-0.747835,0.653267,-0.118258,-0.747835,0.653267,-0.911028,0.144271,0.386283,-0.911028,0.144271,0.386283,-0.911028,0.144271,0.386283,0.674582,0.34362,0.653349,0.674582,0.34362,0.653349,0.674582,0.34362,0.653349,0.709839,0.361579,0.604474,0.709839,0.361579,0.604474,0.709839,0.361579,0.604474,-0.498244,-0.498244,0.709582,-0.498244,-0.498244,0.709582,-0.498244,-0.498244,0.709582,0.81834,-0.416898,0.395621,0.81834,-0.416898,0.395621,0.81834,-0.416898,0.395621,0.498244,0.498244,0.709582,0.498244,0.498244,0.709582,0.498244,0.498244,0.709582,-0.319737,-0.627715,0.709748,-0.319737,-0.627715,0.709748,-0.319737,-0.627715,0.709748,-0.904528,0.143296,0.401615,-0.904528,0.143296,0.401615,-0.904528,0.143296,0.401615,-0.319759,-0.627961,0.709521,-0.319759,-0.627961,0.709521,-0.319759,-0.627961,0.709521,-0.320014,-0.627795,0.709553,-0.320014,-0.627795,0.709553,-0.320014,-0.627795,0.709553,-0.908741,0.143951,0.39175,-0.908741,0.143951,0.39175,-0.908741,0.143951,0.39175,-0.343819,-0.674497,0.653332,-0.343819,-0.674497,0.653332,-0.343819,-0.674497,0.653332,0.695707,0.110215,0.70982,0.695707,0.110215,0.70982,0.695707,0.110215,0.70982,0.419296,-0.822996,0.383235,0.419296,-0.822996,0.383235,0.419296,-0.822996,0.383235,0.69582,0.110127,0.709723,0.69582,0.110127,0.709723,0.69582,0.110127,0.709723,0.630604,0.630604,0.452412,0.630604,0.630604,0.452412,0.630604,0.630604,0.452412,0.794478,0.404814,0.452693,0.794478,0.404814,0.452693,0.794478,0.404814,0.452693,0.627642,0.319936,0.709723,0.627642,0.319936,0.709723,0.627642,0.319936,0.709723,0.802145,0.40872,0.435329,0.802145,0.40872,0.435329,0.802145,0.40872,0.435329,0.674298,0.343718,0.653591,0.674298,0.343718,0.653591,0.674298,0.343718,0.653591,0.802313,0.408693,0.435045,0.802313,0.408693,0.435045,0.802313,0.408693,0.435045,0.747813,0.118356,0.653275,0.747813,0.118356,0.653275,0.747813,0.118356,0.653275,0.747924,0.118272,0.653162,0.747924,0.118272,0.653162,0.747924,0.118272,0.653162,-0.674298,-0.343718,0.653591,-0.674298,-0.343718,0.653591,-0.674298,-0.343718,0.653591,0.636619,0.636619,0.435239,0.636619,0.636619,0.435239,0.636619,0.636619,0.435239,-0.674582,-0.34362,0.653349,-0.674582,-0.34362,0.653349,-0.674582,-0.34362,0.653349,-0.9008,0.14264,0.410137,-0.9008,0.14264,0.410137,-0.9008,0.14264,0.410137,0.786789,0.124418,0.604552,0.786789,0.124418,0.604552,0.786789,0.124418,0.604552,-0.73621,-0.375147,0.563258,-0.73621,-0.375147,0.563258,-0.73621,-0.375147,0.563258,-0.907623,0.143786,0.394393,-0.907623,0.143786,0.394393,-0.907623,0.143786,0.394393,0.786439,0.124676,0.604954,0.786439,0.124676,0.604954,0.786439,0.124676,0.604954,-0.907478,0.143714,0.394752,-0.907478,0.143714,0.394752,-0.907478,0.143714,0.394752,0.709685,0.36163,0.604624,0.709685,0.36163,0.604624,0.709685,0.36163,0.604624,-0.498244,-0.498244,0.709582,-0.498244,-0.498244,0.709582,-0.498244,-0.498244,0.709582,0.141827,-0.89573,0.421369,0.141827,-0.89573,0.421369,0.141827,-0.89573,0.421369,-0.535206,-0.535206,0.653535,-0.535206,-0.535206,0.653535,-0.535206,-0.535206,0.653535,-0.535206,-0.535206,0.653535,-0.535206,-0.535206,0.653535,-0.535206,-0.535206,0.653535,0.80802,0.4116,0.421531,0.80802,0.4116,0.421531,0.80802,0.4116,0.421531,-0.343532,-0.674409,0.653574,-0.343532,-0.674409,0.653574,-0.343532,-0.674409,0.653574,-0.900784,0.142627,0.410178,-0.900784,0.142627,0.410178,-0.900784,0.142627,0.410178,-0.709839,-0.361579,0.604474,-0.709839,-0.361579,0.604474,-0.709839,-0.361579,0.604474,0.88941,0.140841,0.434873,0.88941,0.140841,0.434873,0.88941,0.140841,0.434873,-0.904392,0.143209,0.401953,-0.904392,0.143209,0.401953,-0.904392,0.143209,0.401953,-0.709685,-0.36163,0.604624,-0.709685,-0.36163,0.604624,-0.709685,-0.36163,0.604624,-0.563318,-0.563318,0.604439,-0.563318,-0.563318,0.604439,-0.563318,-0.563318,0.604439,-0.563318,-0.563318,0.604439,-0.563318,-0.563318,0.604439,-0.563318,-0.563318,0.604439,0.124367,0.78647,0.604977,0.124367,0.78647,0.604977,0.124367,0.78647,0.604977,-0.908555,0.143884,0.392205,-0.908555,0.143884,0.392205,-0.908555,0.143884,0.392205,-0.584242,-0.584242,0.563314,-0.584242,-0.584242,0.563314,-0.584242,-0.584242,0.563314,-0.90763,-0.143738,0.394396,-0.90763,-0.143738,0.394396,-0.90763,-0.143738,0.394396,-0.786789,-0.124418,0.604552,-0.786789,-0.124418,0.604552,-0.786789,-0.124418,0.604552,-0.90855,-0.143921,0.392203,-0.90855,-0.143921,0.392203,-0.90855,-0.143921,0.392203,0.41159,-0.808122,0.421346,0.41159,-0.808122,0.421346,0.41159,-0.808122,0.421346,-0.91102,-0.144312,0.386285,-0.91102,-0.144312,0.386285,-0.91102,-0.144312,0.386285,-0.786439,-0.124676,0.604954,-0.786439,-0.124676,0.604954,-0.786439,-0.124676,0.604954,-0.124676,0.786439,0.604954,-0.124676,0.786439,0.604954,-0.124676,0.786439,0.604954,0.142637,-0.900782,0.410178,0.142637,-0.900782,0.410178,0.142637,-0.900782,0.410178,-0.911666,-0.144372,0.384737,-0.911666,-0.144372,0.384737,-0.911666,-0.144372,0.384737,-0.736203,-0.375149,0.563266,-0.736203,-0.375149,0.563266,-0.736203,-0.375149,0.563266,0.14263,-0.900802,0.410136,0.14263,-0.900802,0.410136,0.14263,-0.900802,0.410136,0.414139,-0.813127,0.409039,0.414139,-0.813127,0.409039,0.414139,-0.813127,0.409039,0.645246,-0.645246,0.409041,0.645246,-0.645246,0.409041,0.645246,-0.645246,0.409041,-0.361525,-0.709732,0.604633,-0.361525,-0.709732,0.604633,-0.361525,-0.709732,0.604633,-0.361679,-0.709781,0.604483,-0.361679,-0.709781,0.604483,-0.361679,-0.709781,0.604483,0.414155,-0.812577,0.410115,0.414155,-0.812577,0.410115,0.414155,-0.812577,0.410115,0.415788,-0.815782,0.402021,0.415788,-0.815782,0.402021,0.415788,-0.815782,0.402021,0.695789,-0.110188,0.709744,0.695789,-0.110188,0.709744,0.695789,-0.110188,0.709744,-0.124367,-0.78647,0.604977,-0.124367,-0.78647,0.604977,-0.124367,-0.78647,0.604977,0.415798,-0.815944,0.401682,0.415798,-0.815944,0.401682,0.415798,-0.815944,0.401682,-0.124721,-0.786723,0.604576,-0.124721,-0.786723,0.604576,-0.124721,-0.786723,0.604576,0.695739,-0.110114,0.709804,0.695739,-0.110114,0.709804,0.695739,-0.110114,0.709804,-0.110215,0.695707,0.70982,-0.110215,0.695707,0.70982,-0.110215,0.695707,0.70982,0.416993,-0.818288,0.395627,0.416993,-0.818288,0.395627,0.416993,-0.818288,0.395627,-0.319838,0.627913,0.709528,-0.319838,0.627913,0.709528,-0.319838,0.627913,0.709528,-0.12937,-0.81605,0.563317,-0.12937,-0.81605,0.563317,-0.12937,-0.81605,0.563317,-0.319936,0.627642,0.709723,-0.319936,0.627642,0.709723,-0.319936,0.627642,0.709723,0.417052,-0.818643,0.39483,0.417052,-0.818643,0.39483,0.417052,-0.818643,0.39483,0.747835,-0.118258,0.653267,0.747835,-0.118258,0.653267,0.747835,-0.118258,0.653267,0.417655,-0.819776,0.391831,0.417655,-0.819776,0.391831,0.417655,-0.819776,0.391831,-0.118356,0.747813,0.653275,-0.118356,0.747813,0.653275,-0.118356,0.747813,0.653275,0.747915,-0.118372,0.653155,0.747915,-0.118372,0.653155,0.747915,-0.118372,0.653155,-0.118272,0.747924,0.653162,-0.118272,0.747924,0.653162,-0.118272,0.747924,0.653162,0.674497,-0.343819,0.653332,0.674497,-0.343819,0.653332,0.674497,-0.343819,0.653332,0.143915,-0.908747,0.391748,0.143915,-0.908747,0.391748,0.143915,-0.908747,0.391748,-0.34362,0.674582,0.653349,-0.34362,0.674582,0.653349,-0.34362,0.674582,0.653349,-0.90454,-0.143233,0.401611,-0.90454,-0.143233,0.401611,-0.90454,-0.143233,0.401611,0.709732,-0.361525,0.604633,0.709732,-0.361525,0.604633,0.709732,-0.361525,0.604633,0.417689,-0.819894,0.391547,0.417689,-0.819894,0.391547,0.417689,-0.819894,0.391547,-0.124418,0.786789,0.604552,-0.124418,0.786789,0.604552,-0.124418,0.786789,0.604552,0.78647,-0.124367,0.604977,0.78647,-0.124367,0.604977,0.78647,-0.124367,0.604977,0.418898,-0.82207,0.385648,0.418898,-0.82207,0.385648,0.418898,-0.82207,0.385648,0.786723,-0.124721,0.604576,0.786723,-0.124721,0.604576,0.786723,-0.124721,0.604576,0.144312,-0.91102,0.386285,0.144312,-0.91102,0.386285,0.144312,-0.91102,0.386285,-0.904384,-0.143273,0.401949,-0.904384,-0.143273,0.401949,-0.904384,-0.143273,0.401949,0.103789,-0.570098,0.814994,0.103789,-0.570098,0.814994,0.103789,-0.570098,0.814994,-0.630604,0.630604,0.452412,-0.630604,0.630604,0.452412,-0.630604,0.630604,0.452412,0.143233,-0.90454,0.401611,0.143233,-0.90454,0.401611,0.143233,-0.90454,0.401611,-0.636619,0.636619,0.435239,-0.636619,0.636619,0.435239,-0.636619,0.636619,0.435239,-0.535206,0.535206,0.653535,-0.535206,0.535206,0.653535,-0.535206,0.535206,0.653535,0.143273,-0.904384,0.401949,0.143273,-0.904384,0.401949,0.143273,-0.904384,0.401949,-0.563318,0.563318,0.604439,-0.563318,0.563318,0.604439,-0.563318,0.563318,0.604439,-0.563318,0.563318,0.604439,-0.563318,0.563318,0.604439,-0.563318,0.563318,0.604439,-0.62278,0.62278,0.473592,-0.62278,0.62278,0.473592,-0.62278,0.62278,0.473592,0.143762,-0.90747,0.394755,0.143762,-0.90747,0.394755,0.143762,-0.90747,0.394755,0.143738,-0.90763,0.394396,0.143738,-0.90763,0.394396,0.143738,-0.90763,0.394396,-0.361579,0.709839,0.604474,-0.361579,0.709839,0.604474,-0.361579,0.709839,0.604474,0.143921,-0.90855,0.392203,0.143921,-0.90855,0.392203,0.143921,-0.90855,0.392203,-0.584242,0.584242,0.563314,-0.584242,0.584242,0.563314,-0.584242,0.584242,0.563314,-0.584242,0.584242,0.563314,-0.584242,0.584242,0.563314,-0.584242,0.584242,0.563314,-0.36163,0.709685,0.604624,-0.36163,0.709685,0.604624,-0.36163,0.709685,0.604624,0.674409,-0.343532,0.653574,0.674409,-0.343532,0.653574,0.674409,-0.343532,0.653574,0.144367,-0.911666,0.384737,0.144367,-0.911666,0.384737,0.144367,-0.911666,0.384737,-0.375147,0.73621,0.563258,-0.375147,0.73621,0.563258,-0.375147,0.73621,0.563258,0.645246,-0.645246,0.409041,0.645246,-0.645246,0.409041,0.645246,-0.645246,0.409041,0.709781,-0.361679,0.604483,0.709781,-0.361679,0.604483,0.709781,-0.361679,0.604483,0.736205,-0.375144,0.563266,0.736205,-0.375144,0.563266,0.736205,-0.375144,0.563266,0.584242,0.584242,0.563314,0.584242,0.584242,0.563314,0.584242,0.584242,0.563314,0.584242,0.584242,0.563314,0.584242,0.584242,0.563314,0.584242,0.584242,0.563314,-0.600642,0.600642,0.527692,-0.600642,0.600642,0.527692,-0.600642,0.600642,0.527692,0.535206,-0.535206,0.653535,0.535206,-0.535206,0.653535,0.535206,-0.535206,0.653535,-0.89573,-0.141827,0.421369,-0.89573,-0.141827,0.421369,-0.89573,-0.141827,0.421369,0.584242,-0.584242,0.563314,0.584242,-0.584242,0.563314,0.584242,-0.584242,0.563314,0.584242,-0.584242,0.563314,0.584242,-0.584242,0.563314,0.584242,-0.584242,0.563314,-0.343718,0.674298,0.653591,-0.343718,0.674298,0.653591,-0.343718,0.674298,0.653591,0.736208,-0.375152,0.563258,0.736208,-0.375152,0.563258,0.736208,-0.375152,0.563258,-0.900802,-0.14263,0.410136,-0.900802,-0.14263,0.410136,-0.900802,-0.14263,0.410136,-0.498244,0.498244,0.709582,-0.498244,0.498244,0.709582,-0.498244,0.498244,0.709582,0.695666,-0.110385,0.709834,0.695666,-0.110385,0.709834,0.695666,-0.110385,0.709834,-0.535206,0.535206,0.653535,-0.535206,0.535206,0.653535,-0.535206,0.535206,0.653535,-0.900782,-0.142637,0.410178,-0.900782,-0.142637,0.410178,-0.900782,-0.142637,0.410178,0.627715,-0.319737,0.709748,0.627715,-0.319737,0.709748,0.627715,-0.319737,0.709748,-0.813127,-0.414139,0.409039,-0.813127,-0.414139,0.409039,-0.813127,-0.414139,0.409039,0.627961,-0.319759,0.709521,0.627961,-0.319759,0.709521,0.627961,-0.319759,0.709521,0.627795,-0.320014,0.709553,0.627795,-0.320014,0.709553,0.627795,-0.320014,0.709553,-0.627961,0.319759,0.709521,-0.627961,0.319759,0.709521,-0.627961,0.319759,0.709521,-0.812577,-0.414155,0.410115,-0.812577,-0.414155,0.410115,-0.812577,-0.414155,0.410115,-0.856602,0.135886,0.497763,-0.856602,0.135886,0.497763,-0.856602,0.135886,0.497763,-0.90747,-0.143762,0.394755,-0.90747,-0.143762,0.394755,-0.90747,-0.143762,0.394755,0.647465,0.647465,0.401967,0.647465,0.647465,0.401967,0.647465,0.647465,0.401967,0.647465,0.647465,0.401967,0.647465,0.647465,0.401967,0.647465,0.647465,0.401967,0.563318,-0.563318,0.604439,0.563318,-0.563318,0.604439,0.563318,-0.563318,0.604439,0.563318,-0.563318,0.604439,0.563318,-0.563318,0.604439,0.563318,-0.563318,0.604439,-0.856343,0.135557,0.498298,-0.856343,0.135557,0.498298,-0.856343,0.135557,0.498298,0.498244,-0.498244,0.709582,0.498244,-0.498244,0.709582,0.498244,-0.498244,0.709582,-0.674497,0.343819,0.653332,-0.674497,0.343819,0.653332,-0.674497,0.343819,0.653332,0.535206,-0.535206,0.653535,0.535206,-0.535206,0.653535,0.535206,-0.535206,0.653535,-0.674409,0.343532,0.653574,-0.674409,0.343532,0.653574,-0.674409,0.343532,0.653574,-0.908747,-0.143915,0.391748,-0.908747,-0.143915,0.391748,-0.908747,-0.143915,0.391748,0.110215,-0.695707,0.70982,0.110215,-0.695707,0.70982,0.110215,-0.695707,0.70982,0.109132,-0.69587,0.709827,0.109132,-0.69587,0.709827,0.109132,-0.69587,0.709827,0.110127,-0.69582,0.709723,0.110127,-0.69582,0.709723,0.110127,-0.69582,0.709723,-0.709732,0.361525,0.604633,-0.709732,0.361525,0.604633,-0.709732,0.361525,0.604633,0.319838,-0.627913,0.709528,0.319838,-0.627913,0.709528,0.319838,-0.627913,0.709528,-0.709781,0.361679,0.604483,-0.709781,0.361679,0.604483,-0.709781,0.361679,0.604483,0.319936,-0.627642,0.709723,0.319936,-0.627642,0.709723,0.319936,-0.627642,0.709723,0.319651,-0.62775,0.709755,0.319651,-0.62775,0.709755,0.319651,-0.62775,0.709755,0.343718,-0.674298,0.653591,0.343718,-0.674298,0.653591,0.343718,-0.674298,0.653591,0.649431,0.649431,0.395574,0.649431,0.649431,0.395574,0.649431,0.649431,0.395574,0.649431,0.649431,0.395574,0.649431,0.649431,0.395574,0.649431,0.649431,0.395574,-0.77254,0.393587,0.498268,-0.77254,0.393587,0.498268,-0.77254,0.393587,0.498268,-0.786723,0.124721,0.604576,-0.786723,0.124721,0.604576,-0.786723,0.124721,0.604576,-0.772583,0.393704,0.49811,-0.772583,0.393704,0.49811,-0.772583,0.393704,0.49811,0.650533,0.650533,0.391935,0.650533,0.650533,0.391935,0.650533,0.650533,0.391935,0.650533,0.650533,0.391935,0.650533,0.650533,0.391935,0.650533,0.650533,0.391935,0.34362,-0.674582,0.653349,0.34362,-0.674582,0.653349,0.34362,-0.674582,0.653349,0.653056,0.653056,0.383453,0.653056,0.653056,0.383453,0.653056,0.653056,0.383453,0.653056,0.653056,0.383453,0.653056,0.653056,0.383453,0.653056,0.653056,0.383453,0.361579,-0.709839,0.604474,0.361579,-0.709839,0.604474,0.361579,-0.709839,0.604474,-0.784955,0.400008,0.473116,-0.784955,0.400008,0.473116,-0.784955,0.400008,0.473116,0.36163,-0.709685,0.604624,0.36163,-0.709685,0.604624,0.36163,-0.709685,0.604624,0.118356,-0.747813,0.653275,0.118356,-0.747813,0.653275,0.118356,-0.747813,0.653275,-0.736208,0.375152,0.563258,-0.736208,0.375152,0.563258,-0.736208,0.375152,0.563258,-0.736205,0.375144,0.563266,-0.736205,0.375144,0.563266,-0.736205,0.375144,0.563266,0.118272,-0.747924,0.653162,0.118272,-0.747924,0.653162,0.118272,-0.747924,0.653162,0.498244,-0.498244,0.709582,0.498244,-0.498244,0.709582,0.498244,-0.498244,0.709582,0.419354,0.822964,0.383239,0.419354,0.822964,0.383239,0.419354,0.822964,0.383239,-0.81605,0.12937,0.563317,-0.81605,0.12937,0.563317,-0.81605,0.12937,0.563317,-0.816009,0.129314,0.56339,-0.816009,0.129314,0.56339,-0.816009,0.129314,0.56339,-0.82207,-0.418898,0.385648,-0.82207,-0.418898,0.385648,-0.82207,-0.418898,0.385648,-0.756867,0.385679,0.527641,-0.756867,0.385679,0.527641,-0.756867,0.385679,0.527641,-0.143209,-0.904392,0.401953,-0.143209,-0.904392,0.401953,-0.143209,-0.904392,0.401953,-0.627715,0.319737,0.709748,-0.627715,0.319737,0.709748,-0.627715,0.319737,0.709748,0.124418,-0.786789,0.604552,0.124418,-0.786789,0.604552,0.124418,-0.786789,0.604552,0.636619,0.636619,0.435239,0.636619,0.636619,0.435239,0.636619,0.636619,0.435239,-0.627795,0.320014,0.709553,-0.627795,0.320014,0.709553,-0.627795,0.320014,0.709553,0.124676,-0.786439,0.604954,0.124676,-0.786439,0.604954,0.124676,-0.786439,0.604954,0.641206,0.641206,0.421556,0.641206,0.641206,0.421556,0.641206,0.641206,0.421556,-0.695789,0.110188,0.709744,-0.695789,0.110188,0.709744,-0.695789,0.110188,0.709744,-0.142627,-0.900784,0.410178,-0.142627,-0.900784,0.410178,-0.142627,-0.900784,0.410178,0.129321,-0.816055,0.563321,0.129321,-0.816055,0.563321,0.129321,-0.816055,0.563321,0.613147,0.613147,0.498098,0.613147,0.613147,0.498098,0.613147,0.613147,0.498098,-0.695739,0.110114,0.709804,-0.695739,0.110114,0.709804,-0.695739,0.110114,0.709804,-0.695666,0.110385,0.709834,-0.695666,0.110385,0.709834,-0.695666,0.110385,0.709834,-0.747835,0.118258,0.653267,-0.747835,0.118258,0.653267,-0.747835,0.118258,0.653267,0.385679,0.756867,0.527641,0.385679,0.756867,0.527641,0.385679,0.756867,0.527641,-0.747915,0.118372,0.653155,-0.747915,0.118372,0.653155,-0.747915,0.118372,0.653155,0.385586,0.756835,0.527754,0.385586,0.756835,0.527754,0.385586,0.756835,0.527754,-0.78647,0.124367,0.604977,-0.78647,0.124367,0.604977,-0.78647,0.124367,0.604977,0.393704,0.772583,0.49811,0.393704,0.772583,0.49811,0.393704,0.772583,0.49811,-0.143884,-0.908555,0.392205,-0.143884,-0.908555,0.392205,-0.143884,-0.908555,0.392205,-0.600642,-0.600642,0.527692,-0.600642,-0.600642,0.527692,-0.600642,-0.600642,0.527692,0.838925,-0.132946,0.52776,0.838925,-0.132946,0.52776,0.838925,-0.132946,0.52776,0.132946,0.838925,0.52776,0.132946,0.838925,0.52776,0.132946,0.838925,0.52776,0.1331,0.839041,0.527536,0.1331,0.839041,0.527536,0.1331,0.839041,0.527536,0.856343,-0.135557,0.498298,0.856343,-0.135557,0.498298,0.856343,-0.135557,0.498298,-0.584242,-0.584242,0.563314,-0.584242,-0.584242,0.563314,-0.584242,-0.584242,0.563314,0.375152,0.736208,0.563258,0.375152,0.736208,0.563258,0.375152,0.736208,0.563258,0.856602,-0.135886,0.497763,0.856602,-0.135886,0.497763,0.856602,-0.135886,0.497763,-0.838909,-0.133079,0.527751,-0.838909,-0.133079,0.527751,-0.838909,-0.133079,0.527751,0.839041,-0.1331,0.527536,0.839041,-0.1331,0.527536,0.839041,-0.1331,0.527536,-0.839068,-0.132968,0.527527,-0.839068,-0.132968,0.527527,-0.839068,-0.132968,0.527527,0.393587,0.77254,0.498268,0.393587,0.77254,0.498268,0.393587,0.77254,0.498268,-0.756835,0.385586,0.527754,-0.756835,0.385586,0.527754,-0.756835,0.385586,0.527754,-0.756801,-0.385645,0.527759,-0.756801,-0.385645,0.527759,-0.756801,-0.385645,0.527759,0.135886,0.856602,0.497763,0.135886,0.856602,0.497763,0.135886,0.856602,0.497763,0.135557,0.856343,0.498298,0.135557,0.856343,0.498298,0.135557,0.856343,0.498298,-0.838925,0.132946,0.52776,-0.838925,0.132946,0.52776,-0.838925,0.132946,0.52776,-0.756895,-0.385617,0.527646,-0.756895,-0.385617,0.527646,-0.756895,-0.385617,0.527646,-0.839041,0.1331,0.527536,-0.839041,0.1331,0.527536,-0.839041,0.1331,0.527536,0.400008,0.784955,0.473116,0.400008,0.784955,0.473116,0.400008,0.784955,0.473116,0.77254,-0.393587,0.498268,0.77254,-0.393587,0.498268,0.77254,-0.393587,0.498268,-0.772624,-0.39363,0.498104,-0.772624,-0.39363,0.498104,-0.772624,-0.39363,0.498104,-0.772505,-0.393664,0.498262,-0.772505,-0.393664,0.498262,-0.772505,-0.393664,0.498262,0.137727,0.87005,0.473333,0.137727,0.87005,0.473333,0.137727,0.87005,0.473333,-0.794647,0.4049,0.452319,-0.794647,0.4049,0.452319,-0.794647,0.4049,0.452319,0.772583,-0.393704,0.49811,0.772583,-0.393704,0.49811,0.772583,-0.393704,0.49811,-0.636619,0.636619,0.435239,-0.636619,0.636619,0.435239,-0.636619,0.636619,0.435239,0.62278,0.62278,0.473592,0.62278,0.62278,0.473592,0.62278,0.62278,0.473592,0.62278,0.62278,0.473592,0.62278,0.62278,0.473592,0.62278,0.62278,0.473592,-0.87005,0.137727,0.473333,-0.87005,0.137727,0.473333,-0.87005,0.137727,0.473333,0.630604,0.630604,0.452412,0.630604,0.630604,0.452412,0.630604,0.630604,0.452412,-0.411552,-0.808047,0.421527,-0.411552,-0.808047,0.421527,-0.411552,-0.808047,0.421527,-0.870135,0.137829,0.473146,-0.870135,0.137829,0.473146,-0.870135,0.137829,0.473146,-0.794545,0.404671,0.452703,-0.794545,0.404671,0.452703,-0.794545,0.404671,0.452703,-0.815998,-0.129362,0.563393,-0.815998,-0.129362,0.563393,-0.815998,-0.129362,0.563393,-0.413917,-0.81269,0.410131,-0.413917,-0.81269,0.410131,-0.413917,-0.81269,0.410131,-0.880649,0.139495,0.452767,-0.880649,0.139495,0.452767,-0.880649,0.139495,0.452767,-0.816055,-0.129321,0.563321,-0.816055,-0.129321,0.563321,-0.816055,-0.129321,0.563321,-0.856288,-0.135836,0.498317,-0.856288,-0.135836,0.498317,-0.856288,-0.135836,0.498317,0.41164,0.808098,0.421343,0.41164,0.808098,0.421343,0.41164,0.808098,0.421343,0.129314,0.816009,0.56339,0.129314,0.816009,0.56339,0.129314,0.816009,0.56339,-0.856635,-0.135604,0.497783,-0.856635,-0.135604,0.497783,-0.856635,-0.135604,0.497783,0.12937,0.81605,0.563317,0.12937,0.81605,0.563317,0.12937,0.81605,0.563317,-0.88065,0.139496,0.452765,-0.88065,0.139496,0.452765,-0.88065,0.139496,0.452765,-0.14264,-0.9008,0.410137,-0.14264,-0.9008,0.410137,-0.14264,-0.9008,0.410137,-0.80227,0.408784,0.435039,-0.80227,0.408784,0.435039,-0.80227,0.408784,0.435039,0.375144,0.736205,0.563266,0.375144,0.736205,0.563266,0.375144,0.736205,0.563266,-0.870039,-0.137814,0.473327,-0.870039,-0.137814,0.473327,-0.870039,-0.137814,0.473327,-0.802193,0.408632,0.435323,-0.802193,0.408632,0.435323,-0.802193,0.408632,0.435323,-0.143296,-0.904528,0.401615,-0.143296,-0.904528,0.401615,-0.143296,-0.904528,0.401615,0.399729,0.784843,0.473538,0.399729,0.784843,0.473538,0.399729,0.784843,0.473538,-0.889404,0.140882,0.43487,-0.889404,0.140882,0.43487,-0.889404,0.140882,0.43487,0.124721,0.786723,0.604576,0.124721,0.786723,0.604576,0.124721,0.786723,0.604576,-0.889355,0.140832,0.434988,-0.889355,0.140832,0.434988,-0.889355,0.140832,0.434988,-0.870152,-0.137743,0.473141,-0.870152,-0.137743,0.473141,-0.870152,-0.137743,0.473141,-0.808047,0.411552,0.421527,-0.808047,0.411552,0.421527,-0.808047,0.411552,0.421527,0.535206,0.535206,0.653535,0.535206,0.535206,0.653535,0.535206,0.535206,0.653535,-0.143786,-0.907623,0.394393,-0.143786,-0.907623,0.394393,-0.143786,-0.907623,0.394393,-0.784747,-0.399902,0.473551,-0.784747,-0.399902,0.473551,-0.784747,-0.399902,0.473551,-0.808098,0.41164,0.421343,-0.808098,0.41164,0.421343,-0.808098,0.41164,0.421343,-0.895709,0.141824,0.421416,-0.895709,0.141824,0.421416,-0.895709,0.141824,0.421416,-0.143714,-0.907478,0.394752,-0.143714,-0.907478,0.394752,-0.143714,-0.907478,0.394752,0.137829,0.870135,0.473146,0.137829,0.870135,0.473146,0.137829,0.870135,0.473146,-0.630604,-0.630604,0.452412,-0.630604,-0.630604,0.452412,-0.630604,-0.630604,0.452412,-0.895729,0.141842,0.421368,-0.895729,0.141842,0.421368,-0.895729,0.141842,0.421368,0.404671,0.794545,0.452703,0.404671,0.794545,0.452703,0.404671,0.794545,0.452703,-0.143951,-0.908741,0.39175,-0.143951,-0.908741,0.39175,-0.143951,-0.908741,0.39175,0.4049,0.794647,0.452319,0.4049,0.794647,0.452319,0.4049,0.794647,0.452319,-0.784843,0.399729,0.473538,-0.784843,0.399729,0.473538,-0.784843,0.399729,0.473538,0.784955,-0.400008,0.473116,0.784955,-0.400008,0.473116,0.784955,-0.400008,0.473116,0.139495,0.880649,0.452767,0.139495,0.880649,0.452767,0.139495,0.880649,0.452767,-0.144414,-0.91166,0.384734,-0.144414,-0.91166,0.384734,-0.144414,-0.91166,0.384734,0.784843,-0.399729,0.473538,0.784843,-0.399729,0.473538,0.784843,-0.399729,0.473538,-0.144271,-0.911028,0.386283,-0.144271,-0.911028,0.386283,-0.144271,-0.911028,0.386283,-0.785038,-0.399829,0.47313,-0.785038,-0.399829,0.47313,-0.785038,-0.399829,0.47313,-0.88065,-0.139495,0.452765,-0.88065,-0.139495,0.452765,-0.88065,-0.139495,0.452765,0.139496,0.88065,0.452765,0.139496,0.88065,0.452765,0.139496,0.88065,0.452765,0.81605,-0.12937,0.563317,0.81605,-0.12937,0.563317,0.81605,-0.12937,0.563317,0.408784,0.80227,0.435039,0.408784,0.80227,0.435039,0.408784,0.80227,0.435039,0.816009,-0.129314,0.56339,0.816009,-0.129314,0.56339,0.816009,-0.129314,0.56339,-0.880649,-0.139496,0.452767,-0.880649,-0.139496,0.452767,-0.880649,-0.139496,0.452767,-0.794723,-0.404761,0.452309,-0.794723,-0.404761,0.452309,-0.794723,-0.404761,0.452309,0.408632,0.802193,0.435323,0.408632,0.802193,0.435323,0.408632,0.802193,0.435323,-0.41715,-0.818596,0.394824,-0.41715,-0.818596,0.394824,-0.41715,-0.818596,0.394824,-0.794478,-0.404814,0.452693,-0.794478,-0.404814,0.452693,-0.794478,-0.404814,0.452693,0.140882,0.889404,0.43487,0.140882,0.889404,0.43487,0.140882,0.889404,0.43487,-0.802145,-0.40872,0.435329,-0.802145,-0.40872,0.435329,-0.802145,-0.40872,0.435329,0.140832,0.889355,0.434988,0.140832,0.889355,0.434988,0.140832,0.889355,0.434988,-0.889347,-0.140873,0.434991,-0.889347,-0.140873,0.434991,-0.889347,-0.140873,0.434991,0.880649,-0.139495,0.452767,0.880649,-0.139495,0.452767,0.880649,-0.139495,0.452767,-0.417634,-0.819786,0.391832,-0.417634,-0.819786,0.391832,-0.417634,-0.819786,0.391832,-0.88941,-0.140841,0.434873,-0.88941,-0.140841,0.434873,-0.88941,-0.140841,0.434873,-0.143233,0.90454,0.401611,-0.143233,0.90454,0.401611,-0.143233,0.90454,0.401611,0.87005,-0.137727,0.473333,0.87005,-0.137727,0.473333,0.87005,-0.137727,0.473333,-0.802313,-0.408693,0.435045,-0.802313,-0.408693,0.435045,-0.802313,-0.408693,0.435045,-0.641206,-0.641206,0.421556,-0.641206,-0.641206,0.421556,-0.641206,-0.641206,0.421556,-0.895706,-0.141838,0.421417,-0.895706,-0.141838,0.421417,-0.895706,-0.141838,0.421417,-0.142637,0.900782,0.410178,-0.142637,0.900782,0.410178,-0.142637,0.900782,0.410178,-0.80802,-0.4116,0.421531,-0.80802,-0.4116,0.421531,-0.80802,-0.4116,0.421531,0.361679,0.709781,0.604483,0.361679,0.709781,0.604483,0.361679,0.709781,0.604483,0.756801,0.385645,0.527759,0.756801,0.385645,0.527759,0.756801,0.385645,0.527759,-0.808122,-0.41159,0.421346,-0.808122,-0.41159,0.421346,-0.808122,-0.41159,0.421346,0.870135,-0.137829,0.473146,0.870135,-0.137829,0.473146,0.870135,-0.137829,0.473146,0.600642,0.600642,0.527692,0.600642,0.600642,0.527692,0.600642,0.600642,0.527692,0.600642,0.600642,0.527692,0.600642,0.600642,0.527692,0.600642,0.600642,0.527692,-0.645246,-0.645246,0.409041,-0.645246,-0.645246,0.409041,-0.645246,-0.645246,0.409041,-0.645246,-0.645246,0.409041,-0.645246,-0.645246,0.409041,-0.645246,-0.645246,0.409041,-0.62278,-0.62278,0.473592,-0.62278,-0.62278,0.473592,-0.62278,-0.62278,0.473592,0.319759,0.627961,0.709521,0.319759,0.627961,0.709521,0.319759,0.627961,0.709521,0.613147,0.613147,0.498098,0.613147,0.613147,0.498098,0.613147,0.613147,0.498098,0.794545,-0.404671,0.452703,0.794545,-0.404671,0.452703,0.794545,-0.404671,0.452703,-0.414371,-0.813001,0.409054,-0.414371,-0.813001,0.409054,-0.414371,-0.813001,0.409054,-0.132946,-0.838925,0.52776,-0.132946,-0.838925,0.52776,-0.132946,-0.838925,0.52776,0.839068,0.132968,0.527527,0.839068,0.132968,0.527527,0.839068,0.132968,0.527527,-0.647465,-0.647465,0.401967,-0.647465,-0.647465,0.401967,-0.647465,-0.647465,0.401967,-0.647465,-0.647465,0.401967,-0.647465,-0.647465,0.401967,-0.647465,-0.647465,0.401967,0.794647,-0.4049,0.452319,0.794647,-0.4049,0.452319,0.794647,-0.4049,0.452319,-0.415856,-0.815916,0.401678,-0.415856,-0.815916,0.401678,-0.415856,-0.815916,0.401678,-0.1331,-0.839041,0.527536,-0.1331,-0.839041,0.527536,-0.1331,-0.839041,0.527536,-0.143273,0.904384,0.401949,-0.143273,0.904384,0.401949,-0.143273,0.904384,0.401949,-0.143762,0.90747,0.394755,-0.143762,0.90747,0.394755,-0.143762,0.90747,0.394755,-0.393587,-0.77254,0.498268,-0.393587,-0.77254,0.498268,-0.393587,-0.77254,0.498268,-0.415731,-0.815812,0.402017,-0.415731,-0.815812,0.402017,-0.415731,-0.815812,0.402017,0.838909,0.133079,0.527751,0.838909,0.133079,0.527751,0.838909,0.133079,0.527751,-0.135557,-0.856343,0.498298,-0.135557,-0.856343,0.498298,-0.135557,-0.856343,0.498298,-0.649431,-0.649431,0.395574,-0.649431,-0.649431,0.395574,-0.649431,-0.649431,0.395574,0.756895,0.385617,0.527646,0.756895,0.385617,0.527646,0.756895,0.385617,0.527646,-0.143738,0.90763,0.394396,-0.143738,0.90763,0.394396,-0.143738,0.90763,0.394396,0.88065,-0.139496,0.452765,0.88065,-0.139496,0.452765,0.88065,-0.139496,0.452765,0.856288,0.135836,0.498317,0.856288,0.135836,0.498317,0.856288,0.135836,0.498317,0.80227,-0.408784,0.435039,0.80227,-0.408784,0.435039,0.80227,-0.408784,0.435039,-0.135886,-0.856602,0.497763,-0.135886,-0.856602,0.497763,-0.135886,-0.856602,0.497763,-0.600642,-0.600642,0.527692,-0.600642,-0.600642,0.527692,-0.600642,-0.600642,0.527692,-0.815782,-0.415788,0.402021,-0.815782,-0.415788,0.402021,-0.815782,-0.415788,0.402021,0.856635,0.135604,0.497783,0.856635,0.135604,0.497783,0.856635,0.135604,0.497783,0.889355,-0.140832,0.434988,0.889355,-0.140832,0.434988,0.889355,-0.140832,0.434988,-0.815944,-0.415798,0.401682,-0.815944,-0.415798,0.401682,-0.815944,-0.415798,0.401682,0.772624,0.39363,0.498104,0.772624,0.39363,0.498104,0.772624,0.39363,0.498104,-0.613147,-0.613147,0.498098,-0.613147,-0.613147,0.498098,-0.613147,-0.613147,0.498098,-0.613147,-0.613147,0.498098,-0.613147,-0.613147,0.498098,-0.613147,-0.613147,0.498098,0.802193,-0.408632,0.435323,0.802193,-0.408632,0.435323,0.802193,-0.408632,0.435323,-0.14263,0.900802,0.410136,-0.14263,0.900802,0.410136,-0.14263,0.900802,0.410136,0.772505,0.393664,0.498262,0.772505,0.393664,0.498262,0.772505,0.393664,0.498262,0.889404,-0.140882,0.43487,0.889404,-0.140882,0.43487,0.889404,-0.140882,0.43487,0.870152,0.137743,0.473141,0.870152,0.137743,0.473141,0.870152,0.137743,0.473141,-0.818643,-0.417052,0.39483,-0.818643,-0.417052,0.39483,-0.818643,-0.417052,0.39483,-0.385679,-0.756867,0.527641,-0.385679,-0.756867,0.527641,-0.385679,-0.756867,0.527641,-0.141827,0.89573,0.421369,-0.141827,0.89573,0.421369,-0.141827,0.89573,0.421369,-0.375152,-0.736208,0.563258,-0.375152,-0.736208,0.563258,-0.375152,-0.736208,0.563258,0.785038,0.399829,0.47313,0.785038,0.399829,0.47313,0.785038,0.399829,0.47313,-0.385586,-0.756835,0.527754,-0.385586,-0.756835,0.527754,-0.385586,-0.756835,0.527754,-0.649431,-0.649431,0.395574,-0.649431,-0.649431,0.395574,-0.649431,-0.649431,0.395574,0.784747,0.399902,0.473551,0.784747,0.399902,0.473551,0.784747,0.399902,0.473551,-0.416898,-0.81834,0.395621,-0.416898,-0.81834,0.395621,-0.416898,-0.81834,0.395621,0.808098,-0.41164,0.421343,0.808098,-0.41164,0.421343,0.808098,-0.41164,0.421343,-0.393704,-0.772583,0.49811,-0.393704,-0.772583,0.49811,-0.393704,-0.772583,0.49811,-0.143915,0.908747,0.391748,-0.143915,0.908747,0.391748,-0.143915,0.908747,0.391748,0.815998,0.129362,0.563393,0.815998,0.129362,0.563393,0.815998,0.129362,0.563393,-0.137727,-0.87005,0.473333,-0.137727,-0.87005,0.473333,-0.137727,-0.87005,0.473333,-0.650533,-0.650533,0.391935,-0.650533,-0.650533,0.391935,-0.650533,-0.650533,0.391935,-0.650533,-0.650533,0.391935,-0.650533,-0.650533,0.391935,-0.650533,-0.650533,0.391935,-0.143921,0.90855,0.392203,-0.143921,0.90855,0.392203,-0.143921,0.90855,0.392203,0.736203,0.375149,0.563266,0.736203,0.375149,0.563266,0.736203,0.375149,0.563266,-0.62278,-0.62278,0.473592,-0.62278,-0.62278,0.473592,-0.62278,-0.62278,0.473592,-0.144312,0.91102,0.386285,-0.144312,0.91102,0.386285,-0.144312,0.91102,0.386285,0.816055,0.129321,0.563321,0.816055,0.129321,0.563321,0.816055,0.129321,0.563321,-0.144372,0.911666,0.384737,-0.144372,0.911666,0.384737,-0.144372,0.911666,0.384737,0.895729,-0.141842,0.421368,0.895729,-0.141842,0.421368,0.895729,-0.141842,0.421368,-0.400008,-0.784955,0.473116,-0.400008,-0.784955,0.473116,-0.400008,-0.784955,0.473116,-0.41771,-0.819883,0.391548,-0.41771,-0.819883,0.391548,-0.41771,-0.819883,0.391548,-0.399729,-0.784843,0.473538,-0.399729,-0.784843,0.473538,-0.399729,-0.784843,0.473538,-0.653056,-0.653056,0.383453,-0.653056,-0.653056,0.383453,-0.653056,-0.653056,0.383453,0.895709,-0.141824,0.421416,0.895709,-0.141824,0.421416,0.895709,-0.141824,0.421416,-0.653056,-0.653056,0.383453,-0.653056,-0.653056,0.383453,-0.653056,-0.653056,0.383453,0.870039,0.137814,0.473327,0.870039,0.137814,0.473327,0.870039,0.137814,0.473327,0.613147,-0.613147,0.498098,0.613147,-0.613147,0.498098,0.613147,-0.613147,0.498098,0.613147,-0.613147,0.498098,0.613147,-0.613147,0.498098,0.613147,-0.613147,0.498098,-0.375144,-0.736205,0.563266,-0.375144,-0.736205,0.563266,-0.375144,-0.736205,0.563266,-0.818288,-0.416993,0.395627,-0.818288,-0.416993,0.395627,-0.818288,-0.416993,0.395627,0.600642,-0.600642,0.527692,0.600642,-0.600642,0.527692,0.600642,-0.600642,0.527692,0.600642,-0.600642,0.527692,0.600642,-0.600642,0.527692,0.600642,-0.600642,0.527692,0.756867,-0.385679,0.527641,0.756867,-0.385679,0.527641,0.756867,-0.385679,0.527641,-0.129314,-0.816009,0.56339,-0.129314,-0.816009,0.56339,-0.129314,-0.816009,0.56339,-0.819894,-0.417689,0.391547,-0.819894,-0.417689,0.391547,-0.819894,-0.417689,0.391547,0.756835,-0.385586,0.527754,0.756835,-0.385586,0.527754,0.756835,-0.385586,0.527754,-0.137829,-0.870135,0.473146,-0.137829,-0.870135,0.473146,-0.137829,-0.870135,0.473146,0.375147,-0.73621,0.563258,0.375147,-0.73621,0.563258,0.375147,-0.73621,0.563258,-0.139495,-0.880649,0.452767,-0.139495,-0.880649,0.452767,-0.139495,-0.880649,0.452767,-0.141838,0.895706,0.421417,-0.141838,0.895706,0.421417,-0.141838,0.895706,0.421417,-0.408784,-0.80227,0.435039,-0.408784,-0.80227,0.435039,-0.408784,-0.80227,0.435039,-0.819776,-0.417655,0.391831,-0.819776,-0.417655,0.391831,-0.819776,-0.417655,0.391831,-0.4116,0.80802,0.421531,-0.4116,0.80802,0.421531,-0.4116,0.80802,0.421531,-0.822996,-0.419296,0.383235,-0.822996,-0.419296,0.383235,-0.822996,-0.419296,0.383235,-0.41159,0.808122,0.421346,-0.41159,0.808122,0.421346,-0.41159,0.808122,0.421346,0.636619,-0.636619,0.435239,0.636619,-0.636619,0.435239,0.636619,-0.636619,0.435239,-0.418839,-0.822099,0.385652,-0.418839,-0.822099,0.385652,-0.418839,-0.822099,0.385652,-0.419354,-0.822964,0.383239,-0.419354,-0.822964,0.383239,-0.419354,-0.822964,0.383239,-0.415798,0.815944,0.401682,-0.415798,0.815944,0.401682,-0.415798,0.815944,0.401682,0.630604,-0.630604,0.452412,0.630604,-0.630604,0.452412,0.630604,-0.630604,0.452412,0.14264,0.9008,0.410137,0.14264,0.9008,0.410137,0.14264,0.9008,0.410137,0.132968,-0.839068,0.527527,0.132968,-0.839068,0.527527,0.132968,-0.839068,0.527527,-0.414155,0.812577,0.410115,-0.414155,0.812577,0.410115,-0.414155,0.812577,0.410115,0.143296,0.904528,0.401615,0.143296,0.904528,0.401615,0.143296,0.904528,0.401615,-0.415788,0.815782,0.402021,-0.415788,0.815782,0.402021,-0.415788,0.815782,0.402021,0.41715,0.818596,0.394824,0.41715,0.818596,0.394824,0.41715,0.818596,0.394824,0.133079,-0.838909,0.527751,0.133079,-0.838909,0.527751,0.133079,-0.838909,0.527751,0.135836,-0.856288,0.498317,0.135836,-0.856288,0.498317,0.135836,-0.856288,0.498317,0.385617,-0.756895,0.527646,0.385617,-0.756895,0.527646,0.385617,-0.756895,0.527646,-0.417655,0.819776,0.391831,-0.417655,0.819776,0.391831,-0.417655,0.819776,0.391831,0.135604,-0.856635,0.497783,0.135604,-0.856635,0.497783,0.135604,-0.856635,0.497783,-0.641206,0.641206,0.421556,-0.641206,0.641206,0.421556,-0.641206,0.641206,0.421556,0.418839,0.822099,0.385652,0.418839,0.822099,0.385652,0.418839,0.822099,0.385652,0.39363,-0.772624,0.498104,0.39363,-0.772624,0.498104,0.39363,-0.772624,0.498104,-0.414139,0.813127,0.409039,-0.414139,0.813127,0.409039,-0.414139,0.813127,0.409039,-0.645246,0.645246,0.409041,-0.645246,0.645246,0.409041,-0.645246,0.645246,0.409041,-0.140832,-0.889355,0.434988,-0.140832,-0.889355,0.434988,-0.140832,-0.889355,0.434988,0.393664,-0.772505,0.498262,0.393664,-0.772505,0.498262,0.393664,-0.772505,0.498262,-0.408632,-0.802193,0.435323,-0.408632,-0.802193,0.435323,-0.408632,-0.802193,0.435323,-0.645246,0.645246,0.409041,-0.645246,0.645246,0.409041,-0.645246,0.645246,0.409041,-0.41164,-0.808098,0.421343,-0.41164,-0.808098,0.421343,-0.41164,-0.808098,0.421343,0.399902,-0.784747,0.473551,0.399902,-0.784747,0.473551,0.399902,-0.784747,0.473551,-0.141824,-0.895709,0.421416,-0.141824,-0.895709,0.421416,-0.141824,-0.895709,0.421416,-0.647465,0.647465,0.401967,-0.647465,0.647465,0.401967,-0.647465,0.647465,0.401967,-0.647465,0.647465,0.401967,-0.647465,0.647465,0.401967,-0.647465,0.647465,0.401967,-0.141842,-0.895729,0.421368,-0.141842,-0.895729,0.421368,-0.141842,-0.895729,0.421368,-0.649431,0.649431,0.395574,-0.649431,0.649431,0.395574,-0.649431,0.649431,0.395574,-0.140882,-0.889404,0.43487,-0.140882,-0.889404,0.43487,-0.140882,-0.889404,0.43487,0.385645,-0.756801,0.527759,0.385645,-0.756801,0.527759,0.385645,-0.756801,0.527759,-0.815916,0.415856,0.401678,-0.815916,0.415856,0.401678,-0.815916,0.415856,0.401678,0.62278,-0.62278,0.473592,0.62278,-0.62278,0.473592,0.62278,-0.62278,0.473592,0.62278,-0.62278,0.473592,0.62278,-0.62278,0.473592,0.62278,-0.62278,0.473592,0.144271,0.911028,0.386283,0.144271,0.911028,0.386283,0.144271,0.911028,0.386283,-0.815812,0.415731,0.402017,-0.815812,0.415731,0.402017,-0.815812,0.415731,0.402017,0.375149,-0.736203,0.563266,0.375149,-0.736203,0.563266,0.375149,-0.736203,0.563266,-0.813001,0.414371,0.409054,-0.813001,0.414371,0.409054,-0.813001,0.414371,0.409054,0.129362,-0.815998,0.563393,0.129362,-0.815998,0.563393,0.129362,-0.815998,0.563393,-0.818596,0.41715,0.394824,-0.818596,0.41715,0.394824,-0.818596,0.41715,0.394824,0.641206,0.641206,0.421556,0.641206,0.641206,0.421556,0.641206,0.641206,0.421556,-0.81834,0.416898,0.395621,-0.81834,0.416898,0.395621,-0.81834,0.416898,0.395621,0.411552,0.808047,0.421527,0.411552,0.808047,0.421527,0.411552,0.808047,0.421527,-0.417052,0.818643,0.39483,-0.417052,0.818643,0.39483,-0.417052,0.818643,0.39483,0.636619,-0.636619,0.435239,0.636619,-0.636619,0.435239,0.636619,-0.636619,0.435239,0.414371,0.813001,0.409054,0.414371,0.813001,0.409054,0.414371,0.813001,0.409054,0.399829,-0.785038,0.47313,0.399829,-0.785038,0.47313,0.399829,-0.785038,0.47313,-0.419296,0.822996,0.383235,-0.419296,0.822996,0.383235,-0.419296,0.822996,0.383235,0.413917,0.81269,0.410131,0.413917,0.81269,0.410131,0.413917,0.81269,0.410131,0.4116,-0.80802,0.421531,0.4116,-0.80802,0.421531,0.4116,-0.80802,0.421531,0.641206,-0.641206,0.421556,0.641206,-0.641206,0.421556,0.641206,-0.641206,0.421556,0.641206,-0.641206,0.421556,0.641206,-0.641206,0.421556,0.641206,-0.641206,0.421556,0.415856,0.815916,0.401678,0.415856,0.815916,0.401678,0.415856,0.815916,0.401678,0.137743,-0.870152,0.473141,0.137743,-0.870152,0.473141,0.137743,-0.870152,0.473141,-0.418898,0.82207,0.385648,-0.418898,0.82207,0.385648,-0.418898,0.82207,0.385648,0.137814,-0.870039,0.473327,0.137814,-0.870039,0.473327,0.137814,-0.870039,0.473327,0.415731,0.815812,0.402017,0.415731,0.815812,0.402017,0.415731,0.815812,0.402017,-0.416993,0.818288,0.395627,-0.416993,0.818288,0.395627,-0.416993,0.818288,0.395627,0.139495,-0.88065,0.452765,0.139495,-0.88065,0.452765,0.139495,-0.88065,0.452765,-0.649431,0.649431,0.395574,-0.649431,0.649431,0.395574,-0.649431,0.649431,0.395574,0.139496,-0.880649,0.452767,0.139496,-0.880649,0.452767,0.139496,-0.880649,0.452767,-0.417689,0.819894,0.391547,-0.417689,0.819894,0.391547,-0.417689,0.819894,0.391547,0.404761,-0.794723,0.452309,0.404761,-0.794723,0.452309,0.404761,-0.794723,0.452309,0.416898,0.81834,0.395621,0.416898,0.81834,0.395621,0.416898,0.81834,0.395621,-0.653056,0.653056,0.383453,-0.653056,0.653056,0.383453,-0.653056,0.653056,0.383453,-0.653056,0.653056,0.383453,-0.653056,0.653056,0.383453,-0.653056,0.653056,0.383453,0.404814,-0.794478,0.452693,0.404814,-0.794478,0.452693,0.404814,-0.794478,0.452693,0.40872,-0.802145,0.435329,0.40872,-0.802145,0.435329,0.40872,-0.802145,0.435329,0.417634,0.819786,0.391832,0.417634,0.819786,0.391832,0.417634,0.819786,0.391832,-0.650533,0.650533,0.391935,-0.650533,0.650533,0.391935,-0.650533,0.650533,0.391935,-0.650533,0.650533,0.391935,-0.650533,0.650533,0.391935,-0.650533,0.650533,0.391935,0.140873,-0.889347,0.434991,0.140873,-0.889347,0.434991,0.140873,-0.889347,0.434991,0.41771,0.819883,0.391548,0.41771,0.819883,0.391548,0.41771,0.819883,0.391548,0.140841,-0.88941,0.434873,0.140841,-0.88941,0.434873,0.140841,-0.88941,0.434873,0.408693,-0.802313,0.435045,0.408693,-0.802313,0.435045,0.408693,-0.802313,0.435045,0.143209,0.904392,0.401953,0.143209,0.904392,0.401953,0.143209,0.904392,0.401953,0.141838,-0.895706,0.421417,0.141838,-0.895706,0.421417,0.141838,-0.895706,0.421417,-0.819786,0.417634,0.391832,-0.819786,0.417634,0.391832,-0.819786,0.417634,0.391832,0.143714,0.907478,0.394752,0.143714,0.907478,0.394752,0.143714,0.907478,0.394752,-0.819883,0.41771,0.391548,-0.819883,0.41771,0.391548,-0.819883,0.41771,0.391548,0.630604,-0.630604,0.452412,0.630604,-0.630604,0.452412,0.630604,-0.630604,0.452412,0.822099,-0.418839,0.385652,0.822099,-0.418839,0.385652,0.822099,-0.418839,0.385652,0.143786,0.907623,0.394393,0.143786,0.907623,0.394393,0.143786,0.907623,0.394393,0.91166,-0.144414,0.384734,0.91166,-0.144414,0.384734,0.91166,-0.144414,0.384734,0.142627,0.900784,0.410178,0.142627,0.900784,0.410178,0.142627,0.900784,0.410178,0.911028,-0.144271,0.386283,0.911028,-0.144271,0.386283,0.911028,-0.144271,0.386283,-0.822099,0.418839,0.385652,-0.822099,0.418839,0.385652,-0.822099,0.418839,0.385652,-0.822964,0.419354,0.383239,-0.822964,0.419354,0.383239,-0.822964,0.419354,0.383239,0.143884,0.908555,0.392205,0.143884,0.908555,0.392205,0.143884,0.908555,0.392205,0.819786,-0.417634,0.391832,0.819786,-0.417634,0.391832,0.819786,-0.417634,0.391832,-0.641206,0.641206,0.421556,-0.641206,0.641206,0.421556,-0.641206,0.641206,0.421556,0.143951,0.908741,0.39175,0.143951,0.908741,0.39175,0.143951,0.908741,0.39175,0.819883,-0.41771,0.391548,0.819883,-0.41771,0.391548,0.819883,-0.41771,0.391548,0.822964,-0.419354,0.383239,0.822964,-0.419354,0.383239,0.822964,-0.419354,0.383239,0.144414,0.91166,0.384734,0.144414,0.91166,0.384734,0.144414,0.91166,0.384734,0.808047,-0.411552,0.421527,0.808047,-0.411552,0.421527,0.808047,-0.411552,0.421527,0.141842,0.895729,0.421368,0.141842,0.895729,0.421368,0.141842,0.895729,0.421368,0.900784,-0.142627,0.410178,0.900784,-0.142627,0.410178,0.900784,-0.142627,0.410178,0.141824,0.895709,0.421416,0.141824,0.895709,0.421416,0.141824,0.895709,0.421416,0.81269,-0.413917,0.410131,0.81269,-0.413917,0.410131,0.81269,-0.413917,0.410131,0.645246,0.645246,0.409041,0.645246,0.645246,0.409041,0.645246,0.645246,0.409041,0.645246,0.645246,0.409041,0.645246,0.645246,0.409041,0.645246,0.645246,0.409041,0.822996,0.419296,0.383235,0.822996,0.419296,0.383235,0.822996,0.419296,0.383235,0.82207,0.418898,0.385648,0.82207,0.418898,0.385648,0.82207,0.418898,0.385648,0.900802,0.14263,0.410136,0.900802,0.14263,0.410136,0.900802,0.14263,0.410136,0.900782,0.142637,0.410178,0.900782,0.142637,0.410178,0.900782,0.142637,0.410178,0.90454,0.143233,0.401611,0.90454,0.143233,0.401611,0.90454,0.143233,0.401611,0.815944,0.415798,0.401682,0.815944,0.415798,0.401682,0.815944,0.415798,0.401682,0.904384,0.143273,0.401949,0.904384,0.143273,0.401949,0.904384,0.143273,0.401949,0.90747,0.143762,0.394755,0.90747,0.143762,0.394755,0.90747,0.143762,0.394755,0.90763,0.143738,0.394396,0.90763,0.143738,0.394396,0.90763,0.143738,0.394396,0.908747,0.143915,0.391748,0.908747,0.143915,0.391748,0.908747,0.143915,0.391748,0.90855,0.143921,0.392203,0.90855,0.143921,0.392203,0.90855,0.143921,0.392203,0.91102,0.144312,0.386285,0.91102,0.144312,0.386285,0.91102,0.144312,0.386285,0.911666,0.144372,0.384737,0.911666,0.144372,0.384737,0.911666,0.144372,0.384737,0.895706,0.141838,0.421417,0.895706,0.141838,0.421417,0.895706,0.141838,0.421417,0.89573,0.141827,0.421369,0.89573,0.141827,0.421369,0.89573,0.141827,0.421369,0.808122,0.41159,0.421346,0.808122,0.41159,0.421346,0.808122,0.41159,0.421346,0.813127,0.414139,0.409039,0.813127,0.414139,0.409039,0.813127,0.414139,0.409039,0.812577,0.414155,0.410115,0.812577,0.414155,0.410115,0.812577,0.414155,0.410115,0.815782,0.415788,0.402021,0.815782,0.415788,0.402021,0.815782,0.415788,0.402021,0.818288,0.416993,0.395627,0.818288,0.416993,0.395627,0.818288,0.416993,0.395627,0.818643,0.417052,0.39483,0.818643,0.417052,0.39483,0.818643,0.417052,0.39483,0.819894,0.417689,0.391547,0.819894,0.417689,0.391547,0.819894,0.417689,0.391547,0.819776,0.417655,0.391831,0.819776,0.417655,0.391831,0.819776,0.417655,0.391831,-0.39363,0.772624,0.498104,-0.39363,0.772624,0.498104,-0.39363,0.772624,0.498104,-0.393664,0.772505,0.498262,-0.393664,0.772505,0.498262,-0.393664,0.772505,0.498262,-0.399902,0.784747,0.473551,-0.399902,0.784747,0.473551,-0.399902,0.784747,0.473551,-0.399829,0.785038,0.47313,-0.399829,0.785038,0.47313,-0.399829,0.785038,0.47313,-0.129362,0.815998,0.563393,-0.129362,0.815998,0.563393,-0.129362,0.815998,0.563393,-0.129321,0.816055,0.563321,-0.129321,0.816055,0.563321,-0.129321,0.816055,0.563321,-0.375149,0.736203,0.563266,-0.375149,0.736203,0.563266,-0.375149,0.736203,0.563266,-0.132968,0.839068,0.527527,-0.132968,0.839068,0.527527,-0.132968,0.839068,0.527527,-0.385617,0.756895,0.527646,-0.385617,0.756895,0.527646,-0.385617,0.756895,0.527646,-0.385645,0.756801,0.527759,-0.385645,0.756801,0.527759,-0.385645,0.756801,0.527759,-0.133079,0.838909,0.527751,-0.133079,0.838909,0.527751,-0.133079,0.838909,0.527751,-0.135836,0.856288,0.498317,-0.135836,0.856288,0.498317,-0.135836,0.856288,0.498317,-0.135604,0.856635,0.497783,-0.135604,0.856635,0.497783,-0.135604,0.856635,0.497783,-0.137743,0.870152,0.473141,-0.137743,0.870152,0.473141,-0.137743,0.870152,0.473141,-0.137814,0.870039,0.473327,-0.137814,0.870039,0.473327,-0.137814,0.870039,0.473327,-0.600642,0.600642,0.527692,-0.600642,0.600642,0.527692,-0.600642,0.600642,0.527692,-0.613147,0.613147,0.498098,-0.613147,0.613147,0.498098,-0.613147,0.613147,0.498098,-0.613147,0.613147,0.498098,-0.613147,0.613147,0.498098,-0.613147,0.613147,0.498098,-0.62278,0.62278,0.473592,-0.62278,0.62278,0.473592,-0.62278,0.62278,0.473592,-0.630604,0.630604,0.452412,-0.630604,0.630604,0.452412,-0.630604,0.630604,0.452412],"normalized":false}},"boundingSphere":{"center":[0,0,-4.7315],"radius":29.385355}}}],"materials":[{"uuid":"B66CF6B1-4689-4738-82B0-50861D300E64","type":"MeshLambertMaterial","color":7981337,"emissive":2236962,"depthFunc":3,"depthTest":true,"depthWrite":true},{"uuid":"12536C28-8D65-43AD-83F3-020582A48119","type":"MeshLambertMaterial","color":16777215,"emissive":2236962,"depthFunc":3,"depthTest":true,"depthWrite":true}],"object":{"uuid":"C03638B5-7B1C-4F2F-8D76-CBED1E10278D","type":"Group","name":"bottle","castShadow":true,"matrix":[0.01,0,0,0,0,0.01,0,0,0,0,0.01,0,0,0,0,1],"children":[{"uuid":"3AC5AD9E-8064-4421-9F3D-2634304BFF67","type":"Mesh","name":"group_0_4634441","castShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"D6C0640F-2E69-4326-A318-D56942A80BE1","material":"B66CF6B1-4689-4738-82B0-50861D300E64"},{"uuid":"7C2D24CC-451F-4457-BEC2-CF70DD312F08","type":"Mesh","name":"group_0_14541540","castShadow":true,"matrix":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"geometry":"B8C8F6C9-01D8-4664-97EC-868F326DAD83","material":"12536C28-8D65-43AD-83F3-020582A48119"}]}}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(15),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(488);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(59),n=__webpack_require__(15),r=__webpack_require__(489);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(490);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rem; });
/* unused harmony export px */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible__ = __webpack_require__(492);
var Rem=function Rem(option){var _option={remUnit:75,remPrecision:6};option=Object.assign({},_option,option);return function(x){return parseFloat((x/option.remUnit).toFixed(option.remPrecision)).toString()+'rem';};};var rem=Rem({remUnit:108});var px=function px(x){return''+(!__WEBPACK_IMPORTED_MODULE_0__flexible__["a" /* default */].hairlines&&x<1?1:x)+'px';};

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Flexible=(_temp=_class=function(){function Flexible(){var _this=this;var onUpdate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};_classCallCheck(this,Flexible);this.hairlines=false;this.width=0;this.height=0;this.docEl=document.documentElement;this.dpr=window.devicePixelRatio||1;this.setRemUnit=function(){_this.width=Math.min(_this.docEl.clientWidth,Flexible.MAX_WIDTH);_this.height=_this.docEl.clientHeight;var rem=_this.width/10;_this.docEl.style.fontSize=rem+'px';};this.onUpdate=onUpdate;this.setRemUnit();// reset rem unit on page resize
window.addEventListener('resize',function(){_this.setRemUnit();_this.onUpdate();});window.addEventListener('pageshow',function(e){if(e.persisted){this.setRemUnit();this.onUpdate();}});// detect 0.5px supports
if(this.dpr>=2){var fakeBody=document.createElement('body');var testElement=document.createElement('div');testElement.style.border='.5px solid transparent';fakeBody.appendChild(testElement);this.docEl.appendChild(fakeBody);if(testElement.offsetHeight===1){this.hairlines=true;}this.docEl.removeChild(fakeBody);}}// set 1rem = viewWidth / 10
_createClass(Flexible,[{key:'state',get:function get(){return{width:this.width,height:this.height,hairlines:this.hairlines,dpr:this.dpr};}}]);return Flexible;}(),_class.MAX_WIDTH=540,_temp);/* harmony default export */ __webpack_exports__["a"] = (new Flexible());

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export A */
/* unused harmony export Abbr */
/* unused harmony export Acronym */
/* unused harmony export Address */
/* unused harmony export Applet */
/* unused harmony export Area */
/* unused harmony export Article */
/* unused harmony export Aside */
/* unused harmony export Audio */
/* unused harmony export B */
/* unused harmony export Base */
/* unused harmony export Basefont */
/* unused harmony export Bdi */
/* unused harmony export Bdo */
/* unused harmony export Bgsound */
/* unused harmony export Big */
/* unused harmony export Blink */
/* unused harmony export Blockquote */
/* unused harmony export Body */
/* unused harmony export Br */
/* unused harmony export Button */
/* unused harmony export Canvas */
/* unused harmony export Caption */
/* unused harmony export Center */
/* unused harmony export Cite */
/* unused harmony export Code */
/* unused harmony export Col */
/* unused harmony export Colgroup */
/* unused harmony export Command */
/* unused harmony export Content */
/* unused harmony export Data */
/* unused harmony export Datalist */
/* unused harmony export Dd */
/* unused harmony export Del */
/* unused harmony export Details */
/* unused harmony export Dfn */
/* unused harmony export Dialog */
/* unused harmony export Dir */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Div; });
/* unused harmony export Dl */
/* unused harmony export Dt */
/* unused harmony export Element */
/* unused harmony export Em */
/* unused harmony export Embed */
/* unused harmony export Fieldset */
/* unused harmony export Figcaption */
/* unused harmony export Figure */
/* unused harmony export Font */
/* unused harmony export Footer */
/* unused harmony export Form */
/* unused harmony export Frame */
/* unused harmony export Frameset */
/* unused harmony export H1 */
/* unused harmony export H2 */
/* unused harmony export H3 */
/* unused harmony export H4 */
/* unused harmony export H5 */
/* unused harmony export H6 */
/* unused harmony export Head */
/* unused harmony export Header */
/* unused harmony export Hgroup */
/* unused harmony export Hr */
/* unused harmony export Html */
/* unused harmony export I */
/* unused harmony export Iframe */
/* unused harmony export Image */
/* unused harmony export Img */
/* unused harmony export Input */
/* unused harmony export Ins */
/* unused harmony export Isindex */
/* unused harmony export Kbd */
/* unused harmony export Keygen */
/* unused harmony export Label */
/* unused harmony export Legend */
/* unused harmony export Li */
/* unused harmony export Link */
/* unused harmony export Listing */
/* unused harmony export Main */
/* unused harmony export MapTag */
/* unused harmony export Mark */
/* unused harmony export Marquee */
/* unused harmony export MathTag */
/* unused harmony export Menu */
/* unused harmony export Menuitem */
/* unused harmony export Meta */
/* unused harmony export Meter */
/* unused harmony export Multicol */
/* unused harmony export Nav */
/* unused harmony export Nextid */
/* unused harmony export Nobr */
/* unused harmony export Noembed */
/* unused harmony export Noframes */
/* unused harmony export Noscript */
/* unused harmony export ObjectTag */
/* unused harmony export Ol */
/* unused harmony export Optgroup */
/* unused harmony export Option */
/* unused harmony export Output */
/* unused harmony export P */
/* unused harmony export Param */
/* unused harmony export Picture */
/* unused harmony export Plaintext */
/* unused harmony export Pre */
/* unused harmony export Progress */
/* unused harmony export Q */
/* unused harmony export Rb */
/* unused harmony export Rbc */
/* unused harmony export Rp */
/* unused harmony export Rt */
/* unused harmony export Rtc */
/* unused harmony export Ruby */
/* unused harmony export S */
/* unused harmony export Samp */
/* unused harmony export Script */
/* unused harmony export Section */
/* unused harmony export Select */
/* unused harmony export Shadow */
/* unused harmony export Slot */
/* unused harmony export Small */
/* unused harmony export Source */
/* unused harmony export Spacer */
/* unused harmony export Span */
/* unused harmony export Strike */
/* unused harmony export Strong */
/* unused harmony export Style */
/* unused harmony export Sub */
/* unused harmony export Summary */
/* unused harmony export Sup */
/* unused harmony export Svg */
/* unused harmony export Table */
/* unused harmony export Tbody */
/* unused harmony export Td */
/* unused harmony export Template */
/* unused harmony export Textarea */
/* unused harmony export Tfoot */
/* unused harmony export Th */
/* unused harmony export Thead */
/* unused harmony export Time */
/* unused harmony export Title */
/* unused harmony export Tr */
/* unused harmony export Track */
/* unused harmony export Tt */
/* unused harmony export U */
/* unused harmony export Ul */
/* unused harmony export Var */
/* unused harmony export Video */
/* unused harmony export Wbr */
/* unused harmony export Xmp */
/* unused harmony export AltGlyph */
/* unused harmony export AltGlyphDef */
/* unused harmony export AltGlyphItem */
/* unused harmony export Animate */
/* unused harmony export AnimateColor */
/* unused harmony export AnimateMotion */
/* unused harmony export AnimateTransform */
/* unused harmony export Animation */
/* unused harmony export Circle */
/* unused harmony export ClipPath */
/* unused harmony export ColorProfile */
/* unused harmony export Cursor */
/* unused harmony export Defs */
/* unused harmony export Desc */
/* unused harmony export Discard */
/* unused harmony export Ellipse */
/* unused harmony export FeBlend */
/* unused harmony export FeColorMatrix */
/* unused harmony export FeComponentTransfer */
/* unused harmony export FeComposite */
/* unused harmony export FeConvolveMatrix */
/* unused harmony export FeDiffuseLighting */
/* unused harmony export FeDisplacementMap */
/* unused harmony export FeDistantLight */
/* unused harmony export FeDropShadow */
/* unused harmony export FeFlood */
/* unused harmony export FeFuncA */
/* unused harmony export FeFuncB */
/* unused harmony export FeFuncG */
/* unused harmony export FeFuncR */
/* unused harmony export FeGaussianBlur */
/* unused harmony export FeImage */
/* unused harmony export FeMerge */
/* unused harmony export FeMergeNode */
/* unused harmony export FeMorphology */
/* unused harmony export FeOffset */
/* unused harmony export FePointLight */
/* unused harmony export FeSpecularLighting */
/* unused harmony export FeSpotLight */
/* unused harmony export FeTile */
/* unused harmony export FeTurbulence */
/* unused harmony export Filter */
/* unused harmony export FontFace */
/* unused harmony export FontFaceFormat */
/* unused harmony export FontFaceName */
/* unused harmony export FontFaceSrc */
/* unused harmony export FontFaceUri */
/* unused harmony export ForeignObject */
/* unused harmony export G */
/* unused harmony export Glyph */
/* unused harmony export GlyphRef */
/* unused harmony export Handler */
/* unused harmony export Hatch */
/* unused harmony export Hatchpath */
/* unused harmony export Hkern */
/* unused harmony export Line */
/* unused harmony export LinearGradient */
/* unused harmony export Listener */
/* unused harmony export Marker */
/* unused harmony export Mask */
/* unused harmony export Mesh */
/* unused harmony export Meshgradient */
/* unused harmony export Meshpatch */
/* unused harmony export Meshrow */
/* unused harmony export Metadata */
/* unused harmony export MissingGlyph */
/* unused harmony export Mpath */
/* unused harmony export Path */
/* unused harmony export Pattern */
/* unused harmony export Polygon */
/* unused harmony export Polyline */
/* unused harmony export Prefetch */
/* unused harmony export RadialGradient */
/* unused harmony export Rect */
/* unused harmony export SetTag */
/* unused harmony export SolidColor */
/* unused harmony export Solidcolor */
/* unused harmony export Stop */
/* unused harmony export Switch */
/* unused harmony export SymbolTag */
/* unused harmony export Tbreak */
/* unused harmony export Text */
/* unused harmony export TextArea */
/* unused harmony export TextPath */
/* unused harmony export Tref */
/* unused harmony export Tspan */
/* unused harmony export Unknown */
/* unused harmony export Use */
/* unused harmony export View */
/* unused harmony export Vkern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamor__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_glamor__);



var htmlTagNames = [
  "a",
  "abbr",
  "acronym",
  "address",
  "applet",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "basefont",
  "bdi",
  "bdo",
  "bgsound",
  "big",
  "blink",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "col",
  "colgroup",
  "command",
  "content",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "element",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "font",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "image",
  "img",
  "input",
  "ins",
  "isindex",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "listing",
  "main",
  "map",
  "mark",
  "marquee",
  "math",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "multicol",
  "nav",
  "nextid",
  "nobr",
  "noembed",
  "noframes",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "plaintext",
  "pre",
  "progress",
  "q",
  "rb",
  "rbc",
  "rp",
  "rt",
  "rtc",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "shadow",
  "slot",
  "small",
  "source",
  "spacer",
  "span",
  "strike",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "xmp"
]
;

var svgTagNames = [
  "a",
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "animation",
  "audio",
  "canvas",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "discard",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "handler",
  "hatch",
  "hatchpath",
  "hkern",
  "iframe",
  "image",
  "line",
  "linearGradient",
  "listener",
  "marker",
  "mask",
  "mesh",
  "meshgradient",
  "meshpatch",
  "meshrow",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "prefetch",
  "radialGradient",
  "rect",
  "script",
  "set",
  "solidColor",
  "solidcolor",
  "stop",
  "style",
  "svg",
  "switch",
  "symbol",
  "tbreak",
  "text",
  "textArea",
  "textPath",
  "title",
  "tref",
  "tspan",
  "unknown",
  "use",
  "video",
  "view",
  "vkern"
]
;

var domElements = htmlTagNames.concat(svgTagNames).filter(function (tag, index, array) {
  return array.indexOf(tag) === index;
});

var CHANNEL = '__glamorous__'; /* istanbul ignore next */

var isPreact = false;

var _PropTypes = void 0;

/* istanbul ignore next */
if (isPreact) {
  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes) {
    _PropTypes = function PropTypes() {
      return _PropTypes;
    };

    ['array', 'bool', 'func', 'number', 'object', 'string', 'symbol', 'any', 'arrayOf', 'element', 'instanceOf', 'node', 'objectOf', 'oneOf', 'oneOfType', 'shape', 'exact'].forEach(function (type) {
      _PropTypes[type] = _PropTypes;
    });
  }
  // copied from preact-compat
  /* eslint-disable no-eq-null, eqeqeq, consistent-return */
  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children) {
    var Children = {
      map: function map(children, fn, ctx) {
        if (children == null) {
          return null;
        }
        children = Children.toArray(children);
        if (ctx && ctx !== children) {
          fn = fn.bind(ctx);
        }
        return children.map(fn);
      },
      forEach: function forEach(children, fn, ctx) {
        if (children == null) {
          return null;
        }
        children = Children.toArray(children);
        if (ctx && ctx !== children) {
          fn = fn.bind(ctx);
        }
        children.forEach(fn);
      },
      count: function count(children) {
        return children && children.length || 0;
      },
      only: function only(children) {
        children = Children.toArray(children);
        if (children.length !== 1) {
          throw new Error('Children.only() expects only one child.');
        }
        return children[0];
      },
      toArray: function toArray(children) {
        if (children == null) {
          return [];
        }
        return [].concat(children);
      }
    };
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children = Children;
  }
  /* eslint-enable no-eq-null, eqeqeq, consistent-return */
} else if (parseFloat(__WEBPACK_IMPORTED_MODULE_0_react___default.a.version.slice(0, 4)) >= 15.5) {
  /* istanbul ignore next */
  try {
    _PropTypes = __webpack_require__(523);
    /* istanbul ignore next */
  } catch (error) {
    // ignore
  }
}
/* istanbul ignore next */
_PropTypes = _PropTypes || __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;

/*
eslint
  import/no-mutable-exports:0,
  import/prefer-default-export:0,
  react/no-deprecated:0
 */

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateWarningMessage(Comp) {
  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
  // eslint-disable-next-line max-len
  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
}

function withTheme(ComponentToTheme) {
  var _defaultContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$noWarn = _ref.noWarn,
      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
      _ref$createElement = _ref.createElement,
      createElement = _ref$createElement === undefined ? true : _ref$createElement;

  var ThemedComponent = function (_React$Component) {
    inherits(ThemedComponent, _React$Component);

    function ThemedComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, ThemedComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
        return _this.setState({ theme: theme });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    // eslint-disable-next-line complexity
    ThemedComponent.prototype.componentWillMount = function componentWillMount() {
      if (!this.context[CHANNEL]) {
        if (false) {
          this.warned = true;
          // eslint-disable-next-line no-console
          console.warn(generateWarningMessage(ComponentToTheme));
        }
      }
      var theme = this.props.theme;

      if (this.context[CHANNEL]) {
        // if a theme is provided via props,
        // it takes precedence over context
        this.setTheme(theme ? theme : this.context[CHANNEL].getState());
      } else {
        this.setTheme(theme || {});
      }
    };

    ThemedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.theme !== nextProps.theme) {
        this.setTheme(nextProps.theme);
      }
    };

    ThemedComponent.prototype.componentDidMount = function componentDidMount() {
      if (this.context[CHANNEL] && !this.props.theme) {
        // subscribe to future theme changes
        this.subscriptionId = this.context[CHANNEL].subscribe(this.setTheme);
      }
    };

    ThemedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      // cleanup subscription
      this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
    };

    ThemedComponent.prototype.render = function render() {
      if (createElement) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentToTheme, _extends({}, this.props, this.state));
      } else {
        // this allows us to effectively use the GlamorousComponent
        // as our `render` method without going through lifecycle hooks.
        // Also allows us to forward the context in the scenario where
        // a user wants to add more context.
        // eslint-disable-next-line babel/new-cap
        return ComponentToTheme.call(this, _extends({}, this.props, this.state), this.context);
      }
    };

    return ThemedComponent;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

   false ? ThemedComponent.propTypes = {
    theme: _PropTypes.object
  } : void 0;


  var defaultContextTypes = (_defaultContextTypes = {}, _defaultContextTypes[CHANNEL] = _PropTypes.object, _defaultContextTypes);

  var userDefinedContextTypes = null;

  // configure the contextTypes to be settable by the user,
  // however also retaining the glamorous channel.
  Object.defineProperty(ThemedComponent, 'contextTypes', {
    enumerable: true,
    configurable: true,
    set: function set$$1(value) {
      userDefinedContextTypes = value;
    },
    get: function get$$1() {
      // if the user has provided a contextTypes definition,
      // merge the default context types with the provided ones.
      if (userDefinedContextTypes) {
        return _extends({}, defaultContextTypes, userDefinedContextTypes);
      }
      return defaultContextTypes;
    }
  });

  return ThemedComponent;
}

var isFunction_1 = isFunction;

var toString = Object.prototype.toString;

function isFunction (fn) {
  var string = toString.call(fn);
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
}

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

function isObjectObject(o) {
  return isobject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

var isPlainObject = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

var _ThemeProvider$childC, _ThemeProvider$contex;

/**
 * This is a component which will provide a theme to the entire tree
 * via context and event listener
 * (because pure components block context updates)
 * inspired by the styled-components implementation
 * https://github.com/styled-components/styled-components
 * @param {Object} theme the theme object..
 */

var ThemeProvider = function (_React$Component) {
  inherits(ThemeProvider, _React$Component);

  function ThemeProvider() {
    var _temp, _this, _ret;

    classCallCheck(this, ThemeProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setOuterTheme = function (theme) {
      _this.outerTheme = theme;
      if (_this.broadcast !== undefined) {
        _this.publishTheme();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // create theme, by merging with outer theme, if present
  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction_1(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (!isPlainObject(mergedTheme)) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, ' + 'i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CHANNEL] = this.broadcast, _ref;
  };

  ThemeProvider.prototype.publishTheme = function publishTheme(theme) {
    this.broadcast.setState(this.getTheme(theme));
  };

  ThemeProvider.prototype.componentDidMount = function componentDidMount() {
    // create a new subscription for keeping track of outer theme, if present
    if (this.context[CHANNEL]) {
      this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
    }
  };

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    // set broadcast state by merging outer theme with own
    if (this.context[CHANNEL]) {
      this.setOuterTheme(this.context[CHANNEL].getState());
    }
    this.broadcast = createBroadcast(this.getTheme(this.props.theme));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publishTheme(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
  };

  ThemeProvider.prototype.render = function render() {
    return this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children) : null;
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _PropTypes.object.isRequired, _ThemeProvider$childC);

ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL] = _PropTypes.object, _ThemeProvider$contex);

 false ? ThemeProvider.propTypes = {
  theme: _PropTypes.oneOfType([_PropTypes.object, _PropTypes.func]).isRequired,
  children: _PropTypes.node
} : void 0;

/**
 * This function takes a className string and gets all the
 * associated glamor styles. It's used to merge glamor styles
 * from a className to make sure that specificity is not
 * a problem when passing a className to a component.
 * @param {String} [className=''] the className string
 * @return {Object} { glamorStyles, glamorlessClassName }
 *   - glamorStyles is an array of all the glamor styles objects
 *   - glamorlessClassName is the rest of the className string
 *     without the glamor classNames
 */
function extractGlamorStyles(className) {
  var glamorlessClassName = [];
  var glamorStyles = [];
  className.toString().split(' ').forEach(function (name) {
    if (__WEBPACK_IMPORTED_MODULE_1_glamor__["styleSheet"].registered[name.substring(4)] === undefined) {
      glamorlessClassName.push(name);
    } else {
      var style = buildGlamorSrcFromClassName(name);
      glamorStyles.push(style);
    }
  });

  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
}

/** Glamor's css function returns an object with the shape
 *
 * {
 *   [`data-css-${hash}`]: '',
 *   toString() { return `css-${hash}` }
 * }
 *
 * Whenever glamor's build function encounters an object with
 * this shape it just pulls the resulting styles from the cache.
 *
 * note: the toString method is not needed to qualify the shape
 **/
function buildGlamorSrcFromClassName(className) {
  var _ref;

  return _ref = {}, _ref['data-' + className] = '', _ref;
}

function getGlamorClassName(_ref2) {
  var styles = _ref2.styles,
      props = _ref2.props,
      cssOverrides = _ref2.cssOverrides,
      cssProp = _ref2.cssProp,
      context = _ref2.context,
      displayName = _ref2.displayName;

  var _handleStyles = handleStyles([].concat(styles, [props.className, cssOverrides, cssProp]), props, context),
      mappedArgs = _handleStyles.mappedArgs,
      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;
  // eslint-disable-next-line max-len


  var isDev = "production" === 'development' || !"production";
  var devRules = isDev ? { label: displayName } : null;
  var glamorClassName = __WEBPACK_IMPORTED_MODULE_1_glamor__["css"].apply(undefined, [devRules].concat(mappedArgs)).toString();
  var extras = nonGlamorClassNames.join(' ').trim();
  return (glamorClassName + ' ' + extras).trim();
}

// this next function is on a "hot" code-path
// so it's pretty complex to make sure it's fast.
// eslint-disable-next-line complexity
function handleStyles(styles, props, context) {
  var current = void 0;
  var mappedArgs = [];
  var nonGlamorClassNames = [];
  for (var i = 0; i < styles.length; i++) {
    current = styles[i];
    while (typeof current === 'function') {
      current = current(props, context);
    }
    if (typeof current === 'string') {
      var _extractGlamorStyles = extractGlamorStyles(current),
          glamorStyles = _extractGlamorStyles.glamorStyles,
          glamorlessClassName = _extractGlamorStyles.glamorlessClassName;

      mappedArgs.push.apply(mappedArgs, glamorStyles);
      nonGlamorClassNames.push.apply(nonGlamorClassNames, glamorlessClassName);
    } else if (Array.isArray(current)) {
      var recursed = handleStyles(current, props, context);
      mappedArgs.push.apply(mappedArgs, recursed.mappedArgs);
      nonGlamorClassNames.push.apply(nonGlamorClassNames, recursed.nonGlamorClassNames);
    } else {
      mappedArgs.push(current);
    }
  }
  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
}

/*
 * This is a relatively small abstraction that's ripe for open sourcing.
 * Documentation is in the README.md
 */

function createGlamorous(splitProps) {
  return glamorous;

  /**
   * This is the main export and the function that people
   * interact with most directly.
   *
   * It accepts a component which can be a string or
   * a React Component and returns
   * a "glamorousComponentFactory"
   * @param {String|ReactComponent} comp the component to render
   * @param {Object} options helpful info for the GlamorousComponents
   * @return {Function} the glamorousComponentFactory
   */
  function glamorous(comp) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var rootEl = config.rootEl,
        displayName = config.displayName,
        shouldClassNameUpdate = config.shouldClassNameUpdate,
        _config$filterProps = config.filterProps,
        filterProps = _config$filterProps === undefined ? [] : _config$filterProps,
        _config$forwardProps = config.forwardProps,
        forwardProps = _config$forwardProps === undefined ? [] : _config$forwardProps,
        _config$propsAreCssOv = config.propsAreCssOverrides,
        propsAreCssOverrides = _config$propsAreCssOv === undefined ? comp.propsAreCssOverrides : _config$propsAreCssOv,
        basePropsToApply = config.withProps;

    Object.assign(glamorousComponentFactory, { withConfig: withConfig });
    return glamorousComponentFactory;

    function withConfig(newConfig) {
      return glamorous(comp, _extends({}, config, newConfig));
    }

    /**
     * This returns a React Component that renders the comp (closure)
     * with a className based on the given glamor styles object(s)
     * @param {...Object|Function} styles the styles to create with glamor.
     *   If any of these are functions, they are invoked with the component
     *   props and the return value is used.
     * @return {ReactComponent} the ReactComponent function
     */
    function glamorousComponentFactory() {
      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
        styles[_key] = arguments[_key];
      }

      /**
       * This is a component which will render the comp (closure)
       * with the glamorous styles (closure). Forwards any valid
       * props to the underlying component.
       */
      var GlamorousComponent = withTheme(function (props, context) {
        props = getPropsToApply(GlamorousComponent.propsToApply, {}, props, context);
        var updateClassName = shouldUpdate(props, context, this.previous);

        if (shouldClassNameUpdate) {
          this.previous = { props: props, context: context };
        }

        var _splitProps = splitProps(props, GlamorousComponent),
            toForward = _splitProps.toForward,
            cssOverrides = _splitProps.cssOverrides,
            cssProp = _splitProps.cssProp;

        // create className to apply


        this.className = updateClassName ? getGlamorClassName({
          styles: GlamorousComponent.styles,
          props: props,
          cssOverrides: cssOverrides,
          cssProp: cssProp,
          context: context,
          displayName: GlamorousComponent.displayName
        }) : this.className;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GlamorousComponent.comp, _extends({
          // if innerRef is forwarded we don't want to apply it here
          ref: 'innerRef' in toForward ? undefined : props.innerRef
        }, toForward, {
          className: this.className
        }));
      }, { noWarn: true, createElement: false });

       false ? GlamorousComponent.propTypes = {
        // className accepts an object due to glamor's css function
        // returning an object with a toString method that gives the className
        className: _PropTypes.oneOfType([_PropTypes.string, _PropTypes.object]),
        cssOverrides: _PropTypes.object,
        innerRef: _PropTypes.oneOfType([_PropTypes.func, _PropTypes.object]),
        glam: _PropTypes.object
      } : void 0;

      function shouldUpdate(props, context, previous) {
        // exiting early so components which do not use this
        // optimization are not penalized by hanging onto
        // references to previous props and context
        if (!shouldClassNameUpdate) {
          return true;
        }
        var update = true;
        if (previous) {
          if (!shouldClassNameUpdate(previous.props, props, previous.context, context)) {
            update = false;
          }
        }

        return update;
      }

      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
        comp: comp,
        styles: styles,
        rootEl: rootEl,
        filterProps: filterProps,
        forwardProps: forwardProps,
        displayName: displayName,
        propsToApply: basePropsToApply
      }), {
        isGlamorousComponent: true,
        propsAreCssOverrides: propsAreCssOverrides,
        withComponent: function (newComp) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var fwp = GlamorousComponent.forwardProps,
              flp = GlamorousComponent.filterProps,
              componentProperties = objectWithoutProperties(GlamorousComponent, ['forwardProps', 'filterProps']);

          return glamorous(_extends({}, componentProperties, {
            comp: newComp,
            rootEl: getRootEl(newComp)
          }), _extends({
            // allows the forwardProps and filterProps to be overridden
            forwardProps: fwp,
            filterProps: flp
          }, options))();
        },
        withProps: function () {
          for (var _len2 = arguments.length, propsToApply = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            propsToApply[_key2] = arguments[_key2];
          }

          return glamorous(GlamorousComponent, { withProps: propsToApply })();
        },
        withConfig: withConfig
      });
      return GlamorousComponent;
    }
  }

  function getGlamorousComponentMetadata(_ref) {
    var comp = _ref.comp,
        styles = _ref.styles,
        rootEl = _ref.rootEl,
        filterProps = _ref.filterProps,
        forwardProps = _ref.forwardProps,
        displayName = _ref.displayName,
        basePropsToApply = _ref.propsToApply;

    var componentsComp = comp.comp ? comp.comp : comp;
    var propsToApply = comp.propsToApply ? [].concat(comp.propsToApply, arrayify(basePropsToApply)) : arrayify(basePropsToApply);
    return {
      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
      styles: when(comp.styles, styles),
      // keep track of the ultimate rootEl to render (we never
      // actually render anything but
      // the base component, even when people wrap a glamorous
      // component in glamorous
      comp: componentsComp,
      rootEl: rootEl || getRootEl(comp),
      // join forwardProps and filterProps
      // (for anyone doing: glamorous(glamorous.a({}), {}))
      forwardProps: when(comp.forwardProps, forwardProps),
      filterProps: when(comp.filterProps, filterProps),
      // set the displayName to something that's slightly more
      // helpful than `GlamorousComponent` :)
      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')',
      // these are props that should be applied to the component at render time
      propsToApply: propsToApply
    };
  }
}

/**
 * reduces the propsToApply given to a single props object
 * @param {Array} propsToApply an array of propsToApply objects:
 *   - object
 *   - array of propsToApply items
 *   - function that accepts the accumulated props and the context
 * @param {Object} accumulator an object to apply props onto
 * @param {Object} props the props that should ultimately take precedence
 * @param {*} context the context object
 * @return {Object} the reduced props
 */
function getPropsToApply(propsToApply, accumulator, props, context) {
  // using forEach rather than reduce here because the reduce solution
  // effectively did the same thing because we manipulate the `accumulator`
  propsToApply.forEach(function (propsToApplyItem) {
    if (typeof propsToApplyItem === 'function') {
      return Object.assign(accumulator, propsToApplyItem(Object.assign({}, accumulator, props), context));
    } else if (Array.isArray(propsToApplyItem)) {
      return Object.assign(accumulator, getPropsToApply(propsToApplyItem, accumulator, props, context));
    }
    return Object.assign(accumulator, propsToApplyItem);
  });
  // props wins
  return Object.assign(accumulator, props);
}

function arrayify() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return Array.isArray(x) ? x : [x];
}

function when(comp, prop) {
  return comp ? comp.concat(prop) : prop;
}

function getRootEl(comp) {
  return comp.rootEl ? comp.rootEl : comp.comp || comp;
}

function getDisplayName(comp) {
  return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
}

//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault;

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault;

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault;

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
};

//
// API
//

var src = memoize;
var strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};
src.strategies = strategies;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var a = ["coords","download","href","name","rel","shape","target","type"];
var abbr = ["title"];
var applet = ["alt","height","name","width"];
var area = ["alt","coords","download","href","rel","shape","target","type"];
var audio = ["controls","loop","muted","preload","src"];
var base = ["href","target"];
var basefont = ["size"];
var bdo = ["dir"];
var blockquote = ["cite"];
var button = ["disabled","form","name","type","value"];
var canvas = ["height","width"];
var col = ["span","width"];
var colgroup = ["span","width"];
var data = ["value"];
var del = ["cite"];
var details = ["open"];
var dfn = ["title"];
var dialog = ["open"];
var embed = ["height","src","type","width"];
var fieldset = ["disabled","form","name"];
var font = ["size"];
var form = ["accept","action","method","name","target"];
var frame = ["name","scrolling","src"];
var frameset = ["cols","rows"];
var head = ["profile"];
var hr = ["size","width"];
var html = ["manifest"];
var iframe = ["height","name","sandbox","scrolling","src","width"];
var img = ["alt","height","name","sizes","src","width"];
var input = ["accept","alt","autoCapitalize","autoCorrect","autoSave","checked","defaultChecked","defaultValue","disabled","form","height","list","max","min","multiple","name","onChange","pattern","placeholder","required","results","size","src","step","title","type","value","width"];
var ins = ["cite"];
var keygen = ["challenge","disabled","form","name"];
var label = ["form"];
var li = ["type","value"];
var link = ["color","href","integrity","media","nonce","rel","scope","sizes","target","title","type"];
var map = ["name"];
var meta = ["content","name"];
var meter = ["high","low","max","min","optimum","value"];
var object = ["data","form","height","name","type","width"];
var ol = ["reversed","start","type"];
var optgroup = ["disabled","label"];
var option = ["disabled","label","selected","value"];
var output = ["form","name"];
var param = ["name","type","value"];
var pre = ["width"];
var progress = ["max","value"];
var q = ["cite"];
var script = ["async","defer","integrity","nonce","src","type"];
var select = ["defaultValue","disabled","form","multiple","name","onChange","required","size","value"];
var slot = ["name"];
var source = ["media","sizes","src","type"];
var style = ["media","nonce","title","type"];
var table = ["summary","width"];
var td = ["headers","height","scope","width"];
var textarea = ["autoCapitalize","autoCorrect","cols","defaultValue","disabled","form","name","onChange","placeholder","required","rows","value","wrap"];
var th = ["headers","height","scope","width"];
var track = ["default","kind","label","src"];
var ul = ["type"];
var video = ["controls","height","loop","muted","playsInline","poster","preload","src","width"];
var svg = ["accentHeight","accumulate","additive","alignmentBaseline","allowReorder","alphabetic","amplitude","arabicForm","ascent","attributeName","attributeType","autoReverse","azimuth","baseFrequency","baseProfile","baselineShift","bbox","begin","bias","by","calcMode","capHeight","clip","clipPath","clipPathUnits","clipRule","color","colorInterpolation","colorInterpolationFilters","colorProfile","colorRendering","contentScriptType","contentStyleType","cursor","cx","cy","d","decelerate","descent","diffuseConstant","direction","display","divisor","dominantBaseline","dur","dx","dy","edgeMode","elevation","enableBackground","end","exponent","externalResourcesRequired","fill","fillOpacity","fillRule","filter","filterRes","filterUnits","floodColor","floodOpacity","focusable","fontFamily","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontWeight","format","from","fx","fy","g1","g2","glyphName","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","gradientTransform","gradientUnits","hanging","height","horizAdvX","horizOriginX","ideographic","imageRendering","in","in2","intercept","k","k1","k2","k3","k4","kernelMatrix","kernelUnitLength","kerning","keyPoints","keySplines","keyTimes","lengthAdjust","letterSpacing","lightingColor","limitingConeAngle","local","markerEnd","markerHeight","markerMid","markerStart","markerUnits","markerWidth","mask","maskContentUnits","maskUnits","mathematical","mode","numOctaves","offset","opacity","operator","order","orient","orientation","origin","overflow","overlinePosition","overlineThickness","paintOrder","panose1","pathLength","patternContentUnits","patternTransform","patternUnits","pointerEvents","points","pointsAtX","pointsAtY","pointsAtZ","preserveAlpha","preserveAspectRatio","primitiveUnits","r","radius","refX","refY","renderingIntent","repeatCount","repeatDur","requiredExtensions","requiredFeatures","restart","result","rotate","rx","ry","scale","seed","shapeRendering","slope","spacing","specularConstant","specularExponent","speed","spreadMethod","startOffset","stdDeviation","stemh","stemv","stitchTiles","stopColor","stopOpacity","strikethroughPosition","strikethroughThickness","string","stroke","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeWidth","surfaceScale","systemLanguage","tableValues","targetX","targetY","textAnchor","textDecoration","textLength","textRendering","to","transform","u1","u2","underlinePosition","underlineThickness","unicode","unicodeBidi","unicodeRange","unitsPerEm","vAlphabetic","vHanging","vIdeographic","vMathematical","values","vectorEffect","version","vertAdvY","vertOriginX","vertOriginY","viewBox","viewTarget","visibility","width","widths","wordSpacing","writingMode","x","x1","x2","xChannelSelector","xHeight","xlinkActuate","xlinkArcrole","xlinkHref","xlinkRole","xlinkShow","xlinkTitle","xlinkType","xmlBase","xmlLang","xmlSpace","xmlns","xmlnsXlink","y","y1","y2","yChannelSelector","z","zoomAndPan"];
var elements = {"html":["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],"svg":["a","altGlyph","altGlyphDef","altGlyphItem","animate","animateColor","animateMotion","animateTransform","circle","clipPath","color-profile","cursor","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","font","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignObject","g","glyph","glyphRef","hkern","image","line","linearGradient","marker","mask","metadata","missing-glyph","mpath","path","pattern","polygon","polyline","radialGradient","rect","script","set","stop","style","svg","switch","symbol","text","textPath","title","tref","tspan","use","view","vkern"]};
var reactHtmlAttributes = {
	a: a,
	abbr: abbr,
	applet: applet,
	area: area,
	audio: audio,
	base: base,
	basefont: basefont,
	bdo: bdo,
	blockquote: blockquote,
	button: button,
	canvas: canvas,
	col: col,
	colgroup: colgroup,
	data: data,
	del: del,
	details: details,
	dfn: dfn,
	dialog: dialog,
	embed: embed,
	fieldset: fieldset,
	font: font,
	form: form,
	frame: frame,
	frameset: frameset,
	head: head,
	hr: hr,
	html: html,
	iframe: iframe,
	img: img,
	input: input,
	ins: ins,
	keygen: keygen,
	label: label,
	li: li,
	link: link,
	map: map,
	meta: meta,
	meter: meter,
	object: object,
	ol: ol,
	optgroup: optgroup,
	option: option,
	output: output,
	param: param,
	pre: pre,
	progress: progress,
	q: q,
	script: script,
	select: select,
	slot: slot,
	source: source,
	style: style,
	table: table,
	td: td,
	textarea: textarea,
	th: th,
	track: track,
	ul: ul,
	video: video,
	svg: svg,
	elements: elements,
	"*": ["about","acceptCharset","accessKey","allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","capture","cellPadding","cellSpacing","charSet","classID","className","colSpan","contentEditable","contextMenu","crossOrigin","dangerouslySetInnerHTML","datatype","dateTime","dir","draggable","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hidden","hrefLang","htmlFor","httpEquiv","icon","id","inlist","inputMode","is","itemID","itemProp","itemRef","itemScope","itemType","keyParams","keyType","lang","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","prefix","property","radioGroup","readOnly","resource","role","rowSpan","scoped","seamless","security","spellCheck","srcDoc","srcLang","srcSet","style","suppressContentEditableWarning","tabIndex","title","typeof","unselectable","useMap","vocab","wmode"]
};

var reactHtmlAttributes$1 = Object.freeze({
	a: a,
	abbr: abbr,
	applet: applet,
	area: area,
	audio: audio,
	base: base,
	basefont: basefont,
	bdo: bdo,
	blockquote: blockquote,
	button: button,
	canvas: canvas,
	col: col,
	colgroup: colgroup,
	data: data,
	del: del,
	details: details,
	dfn: dfn,
	dialog: dialog,
	embed: embed,
	fieldset: fieldset,
	font: font,
	form: form,
	frame: frame,
	frameset: frameset,
	head: head,
	hr: hr,
	html: html,
	iframe: iframe,
	img: img,
	input: input,
	ins: ins,
	keygen: keygen,
	label: label,
	li: li,
	link: link,
	map: map,
	meta: meta,
	meter: meter,
	object: object,
	ol: ol,
	optgroup: optgroup,
	option: option,
	output: output,
	param: param,
	pre: pre,
	progress: progress,
	q: q,
	script: script,
	select: select,
	slot: slot,
	source: source,
	style: style,
	table: table,
	td: td,
	textarea: textarea,
	th: th,
	track: track,
	ul: ul,
	video: video,
	svg: svg,
	elements: elements,
	default: reactHtmlAttributes
});

var reactHtmlAttributes$2 = ( reactHtmlAttributes$1 && reactHtmlAttributes ) || reactHtmlAttributes$1;

var dist = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


exports.default = reactHtmlAttributes$2;

module.exports = reactHtmlAttributes$2; // for CommonJS compatibility
});

var reactHTMLAttributes = unwrapExports(dist);

/*
 * This is used to check if a property name is one of the React-specific
 * properties and determine if that property should be forwarded
 * to the React component
 */

/* Logic copied from ReactDOMUnknownPropertyHook */
var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'autoFocus', 'defaultValue', 'valueLink', 'defaultChecked', 'checkedLink', 'innerHTML', 'suppressContentEditableWarning', 'onFocusIn', 'onFocusOut', 'className',

/* List copied from https://facebook.github.io/react/docs/events.html */
'onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onInvalid', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'onCopyCapture', 'onCutCapture', 'onPasteCapture', 'onCompositionEndCapture', 'onCompositionStartCapture', 'onCompositionUpdateCapture', 'onKeyDownCapture', 'onKeyPressCapture', 'onKeyUpCapture', 'onFocusCapture', 'onBlurCapture', 'onChangeCapture', 'onInputCapture', 'onSubmitCapture', 'onClickCapture', 'onContextMenuCapture', 'onDoubleClickCapture', 'onDragCapture', 'onDragEndCapture', 'onDragEnterCapture', 'onDragExitCapture', 'onDragLeaveCapture', 'onDragOverCapture', 'onDragStartCapture', 'onDropCapture', 'onMouseDownCapture', 'onMouseEnterCapture', 'onMouseLeaveCapture', 'onMouseMoveCapture', 'onMouseOutCapture', 'onMouseOverCapture', 'onMouseUpCapture', 'onSelectCapture', 'onTouchCancelCapture', 'onTouchEndCapture', 'onTouchMoveCapture', 'onTouchStartCapture', 'onScrollCapture', 'onWheelCapture', 'onAbortCapture', 'onCanPlayCapture', 'onCanPlayThroughCapture', 'onDurationChangeCapture', 'onEmptiedCapture', 'onEncryptedCapture', 'onEndedCapture', 'onErrorCapture', 'onLoadedDataCapture', 'onLoadedMetadataCapture', 'onLoadStartCapture', 'onPauseCapture', 'onPlayCapture', 'onPlayingCapture', 'onProgressCapture', 'onRateChangeCapture', 'onSeekedCapture', 'onSeekingCapture', 'onStalledCapture', 'onSuspendCapture', 'onTimeUpdateCapture', 'onVolumeChangeCapture', 'onWaitingCapture', 'onLoadCapture', 'onAnimationStartCapture', 'onAnimationEndCapture', 'onAnimationIterationCapture', 'onTransitionEndCapture'];

if (isPreact) {
  reactProps.push('autocomplete', 'autofocus', 'class', 'for', 'onDblClick', 'onSearch', 'slot', 'srcset');
}

/* eslint max-lines:0, func-style:0 */

var globalReactHtmlProps = reactHTMLAttributes['*'];
var supportedSVGTagNames = reactHTMLAttributes.elements.svg;
var supportedHtmlTagNames = reactHTMLAttributes.elements.html;

// these are valid attributes that have the
// same name as CSS properties, and is used
// for css overrides API
var cssProps = ['color', 'height', 'width'];

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR =
// eslint-disable-next-line max-len
':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
// eslint-disable-next-line max-len
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var isSvgTag = function (tagName) {
  return (
    // in our context, we only say that SVG tags are SVG
    // if they are not also HTML.
    // See https://github.com/paypal/glamorous/issues/245
    // the svg tag will always be treated as svg for
    // er... obvious reasons
    tagName === 'svg' || supportedHtmlTagNames.indexOf(tagName) === -1 && supportedSVGTagNames.indexOf(tagName) !== -1
  );
};
var isHtmlProp = function (name, tagName) {
  var elementAttributes = void 0;

  if (isSvgTag(tagName)) {
    // all SVG attributes supported by React are grouped under 'svg'
    elementAttributes = reactHTMLAttributes.svg;
  } else {
    elementAttributes = reactHTMLAttributes[tagName] || [];
  }

  return globalReactHtmlProps.indexOf(name) !== -1 || elementAttributes.indexOf(name) !== -1;
};
var isCssProp = function (name) {
  return cssProps.indexOf(name) !== -1;
};
var isReactProp = function (name) {
  return reactProps.indexOf(name) !== -1;
};

// eslint-disable-next-line complexity
var shouldForwardProperty = function (tagName, name) {
  return typeof tagName !== 'string' || (isHtmlProp(name, tagName) || isReactProp(name) || isCustomAttribute(name.toLowerCase())) && (!isCssProp(name) || isSvgTag(tagName));
};

var shouldForwardProperty$1 = src(shouldForwardProperty);

// eslint-disable-next-line complexity
function splitProps(_ref, _ref2) {
  var propsAreCssOverrides = _ref2.propsAreCssOverrides,
      rootEl = _ref2.rootEl,
      filterProps = _ref2.filterProps,
      forwardProps = _ref2.forwardProps;
  var cssProp = _ref.css,
      innerRef = _ref.innerRef,
      theme = _ref.theme,
      className = _ref.className,
      glam = _ref.glam,
      rest = objectWithoutProperties(_ref, ['css', 'innerRef', 'theme', 'className', 'glam']);

  // forward innerRef if user wishes to do so
  if (innerRef !== undefined && forwardProps.indexOf('innerRef') !== -1) {
    rest.innerRef = innerRef;
  }
  var returnValue = { toForward: {}, cssProp: cssProp, cssOverrides: {} };
  if (!propsAreCssOverrides) {
    if (typeof rootEl !== 'string' && filterProps.length === 0) {
      // if it's not a string and filterProps is empty,
      // then we can forward everything (because it's a component)
      returnValue.toForward = rest;
      return returnValue;
    }
  }
  return Object.keys(rest).reduce(function (split, propName) {
    if (filterProps.indexOf(propName) !== -1) {
      return split;
    } else if (forwardProps.indexOf(propName) !== -1 || shouldForwardProperty$1(rootEl, propName)) {
      split.toForward[propName] = rest[propName];
    } else if (propsAreCssOverrides) {
      split.cssOverrides[propName] = rest[propName];
    }
    return split;
  }, returnValue);
}

var glamorous = createGlamorous(splitProps);

/*
 * This creates a glamorousComponentFactory for every DOM element so you can
 * simply do:
 * const GreenButton = glamorous.button({
 *   backgroundColor: 'green',
 *   padding: 20,
 * })
 * <GreenButton>Click Me!</GreenButton>
 */
Object.assign(glamorous, domElements.reduce(function (getters, tag) {
  // TODO: next breaking change, let's make
  // the `displayName` be: `glamorous.${tag}`
  getters[tag] = glamorous(tag);
  return getters;
}, {}));

/*
 * This creates a glamorous component for each DOM element so you can
 * simply do:
 * <glamorous.Div
 *   color="green"
 *   marginLeft={20}
 * >
 *   I'm green!
 * </glamorous.Div>
 */
Object.assign(glamorous, domElements.reduce(function (comps, tag) {
  var capitalTag = capitalize(tag);
  comps[capitalTag] = glamorous[tag]();
  comps[capitalTag].displayName = 'glamorous.' + capitalTag;
  comps[capitalTag].propsAreCssOverrides = true;
  return comps;
}, {}));

function capitalize(s) {
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}

/*
 * Fix importing in typescript after rollup compilation
 * https://github.com/rollup/rollup/issues/1156
 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
 */
glamorous.default = glamorous;

// these exports below are generated
// and will be tree-shaken if you're using Webpack 2 or Rollup
var A = glamorous['A'];
var Abbr = glamorous['Abbr'];
var Acronym = glamorous['Acronym'];
var Address = glamorous['Address'];
var Applet = glamorous['Applet'];
var Area = glamorous['Area'];
var Article = glamorous['Article'];
var Aside = glamorous['Aside'];
var Audio = glamorous['Audio'];
var B = glamorous['B'];
var Base = glamorous['Base'];
var Basefont = glamorous['Basefont'];
var Bdi = glamorous['Bdi'];
var Bdo = glamorous['Bdo'];
var Bgsound = glamorous['Bgsound'];
var Big = glamorous['Big'];
var Blink = glamorous['Blink'];
var Blockquote = glamorous['Blockquote'];
var Body = glamorous['Body'];
var Br = glamorous['Br'];
var Button = glamorous['Button'];
var Canvas = glamorous['Canvas'];
var Caption = glamorous['Caption'];
var Center = glamorous['Center'];
var Cite = glamorous['Cite'];
var Code = glamorous['Code'];
var Col = glamorous['Col'];
var Colgroup = glamorous['Colgroup'];
var Command = glamorous['Command'];
var Content = glamorous['Content'];
var Data = glamorous['Data'];
var Datalist = glamorous['Datalist'];
var Dd = glamorous['Dd'];
var Del = glamorous['Del'];
var Details = glamorous['Details'];
var Dfn = glamorous['Dfn'];
var Dialog = glamorous['Dialog'];
var Dir = glamorous['Dir'];
var Div = glamorous['Div'];
var Dl = glamorous['Dl'];
var Dt = glamorous['Dt'];
var Element = glamorous['Element'];
var Em = glamorous['Em'];
var Embed = glamorous['Embed'];
var Fieldset = glamorous['Fieldset'];
var Figcaption = glamorous['Figcaption'];
var Figure = glamorous['Figure'];
var Font = glamorous['Font'];
var Footer = glamorous['Footer'];
var Form = glamorous['Form'];
var Frame = glamorous['Frame'];
var Frameset = glamorous['Frameset'];
var H1 = glamorous['H1'];
var H2 = glamorous['H2'];
var H3 = glamorous['H3'];
var H4 = glamorous['H4'];
var H5 = glamorous['H5'];
var H6 = glamorous['H6'];
var Head = glamorous['Head'];
var Header = glamorous['Header'];
var Hgroup = glamorous['Hgroup'];
var Hr = glamorous['Hr'];
var Html = glamorous['Html'];
var I = glamorous['I'];
var Iframe = glamorous['Iframe'];
var Image = glamorous['Image'];
var Img = glamorous['Img'];
var Input = glamorous['Input'];
var Ins = glamorous['Ins'];
var Isindex = glamorous['Isindex'];
var Kbd = glamorous['Kbd'];
var Keygen = glamorous['Keygen'];
var Label = glamorous['Label'];
var Legend = glamorous['Legend'];
var Li = glamorous['Li'];
var Link = glamorous['Link'];
var Listing = glamorous['Listing'];
var Main = glamorous['Main'];
var MapTag = glamorous['Map'];
var Mark = glamorous['Mark'];
var Marquee = glamorous['Marquee'];
var MathTag = glamorous['Math'];
var Menu = glamorous['Menu'];
var Menuitem = glamorous['Menuitem'];
var Meta = glamorous['Meta'];
var Meter = glamorous['Meter'];
var Multicol = glamorous['Multicol'];
var Nav = glamorous['Nav'];
var Nextid = glamorous['Nextid'];
var Nobr = glamorous['Nobr'];
var Noembed = glamorous['Noembed'];
var Noframes = glamorous['Noframes'];
var Noscript = glamorous['Noscript'];
var ObjectTag = glamorous['Object'];
var Ol = glamorous['Ol'];
var Optgroup = glamorous['Optgroup'];
var Option = glamorous['Option'];
var Output = glamorous['Output'];
var P = glamorous['P'];
var Param = glamorous['Param'];
var Picture = glamorous['Picture'];
var Plaintext = glamorous['Plaintext'];
var Pre = glamorous['Pre'];
var Progress = glamorous['Progress'];
var Q = glamorous['Q'];
var Rb = glamorous['Rb'];
var Rbc = glamorous['Rbc'];
var Rp = glamorous['Rp'];
var Rt = glamorous['Rt'];
var Rtc = glamorous['Rtc'];
var Ruby = glamorous['Ruby'];
var S = glamorous['S'];
var Samp = glamorous['Samp'];
var Script = glamorous['Script'];
var Section = glamorous['Section'];
var Select = glamorous['Select'];
var Shadow = glamorous['Shadow'];
var Slot = glamorous['Slot'];
var Small = glamorous['Small'];
var Source = glamorous['Source'];
var Spacer = glamorous['Spacer'];
var Span = glamorous['Span'];
var Strike = glamorous['Strike'];
var Strong = glamorous['Strong'];
var Style = glamorous['Style'];
var Sub = glamorous['Sub'];
var Summary = glamorous['Summary'];
var Sup = glamorous['Sup'];
var Svg = glamorous['Svg'];
var Table = glamorous['Table'];
var Tbody = glamorous['Tbody'];
var Td = glamorous['Td'];
var Template = glamorous['Template'];
var Textarea = glamorous['Textarea'];
var Tfoot = glamorous['Tfoot'];
var Th = glamorous['Th'];
var Thead = glamorous['Thead'];
var Time = glamorous['Time'];
var Title = glamorous['Title'];
var Tr = glamorous['Tr'];
var Track = glamorous['Track'];
var Tt = glamorous['Tt'];
var U = glamorous['U'];
var Ul = glamorous['Ul'];
var Var = glamorous['Var'];
var Video = glamorous['Video'];
var Wbr = glamorous['Wbr'];
var Xmp = glamorous['Xmp'];
var AltGlyph = glamorous['AltGlyph'];
var AltGlyphDef = glamorous['AltGlyphDef'];
var AltGlyphItem = glamorous['AltGlyphItem'];
var Animate = glamorous['Animate'];
var AnimateColor = glamorous['AnimateColor'];
var AnimateMotion = glamorous['AnimateMotion'];
var AnimateTransform = glamorous['AnimateTransform'];
var Animation = glamorous['Animation'];
var Circle = glamorous['Circle'];
var ClipPath = glamorous['ClipPath'];
var ColorProfile = glamorous['Color-profile'];
var Cursor = glamorous['Cursor'];
var Defs = glamorous['Defs'];
var Desc = glamorous['Desc'];
var Discard = glamorous['Discard'];
var Ellipse = glamorous['Ellipse'];
var FeBlend = glamorous['FeBlend'];
var FeColorMatrix = glamorous['FeColorMatrix'];
var FeComponentTransfer = glamorous['FeComponentTransfer'];
var FeComposite = glamorous['FeComposite'];
var FeConvolveMatrix = glamorous['FeConvolveMatrix'];
var FeDiffuseLighting = glamorous['FeDiffuseLighting'];
var FeDisplacementMap = glamorous['FeDisplacementMap'];
var FeDistantLight = glamorous['FeDistantLight'];
var FeDropShadow = glamorous['FeDropShadow'];
var FeFlood = glamorous['FeFlood'];
var FeFuncA = glamorous['FeFuncA'];
var FeFuncB = glamorous['FeFuncB'];
var FeFuncG = glamorous['FeFuncG'];
var FeFuncR = glamorous['FeFuncR'];
var FeGaussianBlur = glamorous['FeGaussianBlur'];
var FeImage = glamorous['FeImage'];
var FeMerge = glamorous['FeMerge'];
var FeMergeNode = glamorous['FeMergeNode'];
var FeMorphology = glamorous['FeMorphology'];
var FeOffset = glamorous['FeOffset'];
var FePointLight = glamorous['FePointLight'];
var FeSpecularLighting = glamorous['FeSpecularLighting'];
var FeSpotLight = glamorous['FeSpotLight'];
var FeTile = glamorous['FeTile'];
var FeTurbulence = glamorous['FeTurbulence'];
var Filter = glamorous['Filter'];
var FontFace = glamorous['Font-face'];
var FontFaceFormat = glamorous['Font-face-format'];
var FontFaceName = glamorous['Font-face-name'];
var FontFaceSrc = glamorous['Font-face-src'];
var FontFaceUri = glamorous['Font-face-uri'];
var ForeignObject = glamorous['ForeignObject'];
var G = glamorous['G'];
var Glyph = glamorous['Glyph'];
var GlyphRef = glamorous['GlyphRef'];
var Handler = glamorous['Handler'];
var Hatch = glamorous['Hatch'];
var Hatchpath = glamorous['Hatchpath'];
var Hkern = glamorous['Hkern'];
var Line = glamorous['Line'];
var LinearGradient = glamorous['LinearGradient'];
var Listener = glamorous['Listener'];
var Marker = glamorous['Marker'];
var Mask = glamorous['Mask'];
var Mesh = glamorous['Mesh'];
var Meshgradient = glamorous['Meshgradient'];
var Meshpatch = glamorous['Meshpatch'];
var Meshrow = glamorous['Meshrow'];
var Metadata = glamorous['Metadata'];
var MissingGlyph = glamorous['Missing-glyph'];
var Mpath = glamorous['Mpath'];
var Path = glamorous['Path'];
var Pattern = glamorous['Pattern'];
var Polygon = glamorous['Polygon'];
var Polyline = glamorous['Polyline'];
var Prefetch = glamorous['Prefetch'];
var RadialGradient = glamorous['RadialGradient'];
var Rect = glamorous['Rect'];
var SetTag = glamorous['Set'];
var SolidColor = glamorous['SolidColor'];
var Solidcolor = glamorous['Solidcolor'];
var Stop = glamorous['Stop'];
var Switch = glamorous['Switch'];
var SymbolTag = glamorous['Symbol'];
var Tbreak = glamorous['Tbreak'];
var Text = glamorous['Text'];
var TextArea = glamorous['TextArea'];
var TextPath = glamorous['TextPath'];
var Tref = glamorous['Tref'];
var Tspan = glamorous['Tspan'];
var Unknown = glamorous['Unknown'];
var Use = glamorous['Use'];
var View = glamorous['View'];
var Vkern = glamorous['Vkern'];

/* harmony default export */ __webpack_exports__["b"] = (glamorous);



/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(15);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(495);

var _CSSPropertyOperations = __webpack_require__(165);

var _clean = __webpack_require__(504);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(505);

var _hash = __webpack_require__(522);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(15);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(497);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(499);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(166);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(502);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(15);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(165);

var _prefixer = __webpack_require__(506);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(507);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(508);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(509);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(510);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(511);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(512);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(513);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(514);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(515);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(516);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(517);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(518);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(519);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(167);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(26);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(26);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(26);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(26);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(520);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(26);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(167);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(521);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(524)();
}


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(525);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.f59045fc.js